
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire109f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire109f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("7He6T", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $f4HGZ = parcelRequire("f4HGZ");

var $5WnCa = parcelRequire("5WnCa");

var $gJrpv = parcelRequire("gJrpv");

var $hN833 = parcelRequire("hN833");
function $59a77e8886024a57$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $59a77e8886024a57$var$BigIntSupported = typeof BigInt !== "undefined";
var $59a77e8886024a57$var$SymbolSupported = typeof Symbol !== "undefined";
var $59a77e8886024a57$var$ObjectToString = $59a77e8886024a57$var$uncurryThis(Object.prototype.toString);
var $59a77e8886024a57$var$numberValue = $59a77e8886024a57$var$uncurryThis(Number.prototype.valueOf);
var $59a77e8886024a57$var$stringValue = $59a77e8886024a57$var$uncurryThis(String.prototype.valueOf);
var $59a77e8886024a57$var$booleanValue = $59a77e8886024a57$var$uncurryThis(Boolean.prototype.valueOf);
if ($59a77e8886024a57$var$BigIntSupported) var $59a77e8886024a57$var$bigIntValue = $59a77e8886024a57$var$uncurryThis(BigInt.prototype.valueOf);
if ($59a77e8886024a57$var$SymbolSupported) var $59a77e8886024a57$var$symbolValue = $59a77e8886024a57$var$uncurryThis(Symbol.prototype.valueOf);
function $59a77e8886024a57$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $f4HGZ;
module.exports.isGeneratorFunction = $5WnCa;
module.exports.isTypedArray = $hN833;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $59a77e8886024a57$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $59a77e8886024a57$var$isPromise;
function $59a77e8886024a57$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $hN833(value) || $59a77e8886024a57$var$isDataView(value);
}
module.exports.isArrayBufferView = $59a77e8886024a57$var$isArrayBufferView;
function $59a77e8886024a57$var$isUint8Array(value) {
    return $gJrpv(value) === "Uint8Array";
}
module.exports.isUint8Array = $59a77e8886024a57$var$isUint8Array;
function $59a77e8886024a57$var$isUint8ClampedArray(value) {
    return $gJrpv(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $59a77e8886024a57$var$isUint8ClampedArray;
function $59a77e8886024a57$var$isUint16Array(value) {
    return $gJrpv(value) === "Uint16Array";
}
module.exports.isUint16Array = $59a77e8886024a57$var$isUint16Array;
function $59a77e8886024a57$var$isUint32Array(value) {
    return $gJrpv(value) === "Uint32Array";
}
module.exports.isUint32Array = $59a77e8886024a57$var$isUint32Array;
function $59a77e8886024a57$var$isInt8Array(value) {
    return $gJrpv(value) === "Int8Array";
}
module.exports.isInt8Array = $59a77e8886024a57$var$isInt8Array;
function $59a77e8886024a57$var$isInt16Array(value) {
    return $gJrpv(value) === "Int16Array";
}
module.exports.isInt16Array = $59a77e8886024a57$var$isInt16Array;
function $59a77e8886024a57$var$isInt32Array(value) {
    return $gJrpv(value) === "Int32Array";
}
module.exports.isInt32Array = $59a77e8886024a57$var$isInt32Array;
function $59a77e8886024a57$var$isFloat32Array(value) {
    return $gJrpv(value) === "Float32Array";
}
module.exports.isFloat32Array = $59a77e8886024a57$var$isFloat32Array;
function $59a77e8886024a57$var$isFloat64Array(value) {
    return $gJrpv(value) === "Float64Array";
}
module.exports.isFloat64Array = $59a77e8886024a57$var$isFloat64Array;
function $59a77e8886024a57$var$isBigInt64Array(value) {
    return $gJrpv(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $59a77e8886024a57$var$isBigInt64Array;
function $59a77e8886024a57$var$isBigUint64Array(value) {
    return $gJrpv(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $59a77e8886024a57$var$isBigUint64Array;
function $59a77e8886024a57$var$isMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Map]";
}
$59a77e8886024a57$var$isMapToString.working = typeof Map !== "undefined" && $59a77e8886024a57$var$isMapToString(new Map());
function $59a77e8886024a57$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $59a77e8886024a57$var$isMapToString.working ? $59a77e8886024a57$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $59a77e8886024a57$var$isMap;
function $59a77e8886024a57$var$isSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Set]";
}
$59a77e8886024a57$var$isSetToString.working = typeof Set !== "undefined" && $59a77e8886024a57$var$isSetToString(new Set());
function $59a77e8886024a57$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $59a77e8886024a57$var$isSetToString.working ? $59a77e8886024a57$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $59a77e8886024a57$var$isSet;
function $59a77e8886024a57$var$isWeakMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WeakMap]";
}
$59a77e8886024a57$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $59a77e8886024a57$var$isWeakMapToString(new WeakMap());
function $59a77e8886024a57$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $59a77e8886024a57$var$isWeakMapToString.working ? $59a77e8886024a57$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $59a77e8886024a57$var$isWeakMap;
function $59a77e8886024a57$var$isWeakSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WeakSet]";
}
$59a77e8886024a57$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $59a77e8886024a57$var$isWeakSetToString(new WeakSet());
function $59a77e8886024a57$var$isWeakSet(value) {
    return $59a77e8886024a57$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $59a77e8886024a57$var$isWeakSet;
function $59a77e8886024a57$var$isArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$59a77e8886024a57$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $59a77e8886024a57$var$isArrayBufferToString(new ArrayBuffer());
function $59a77e8886024a57$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $59a77e8886024a57$var$isArrayBufferToString.working ? $59a77e8886024a57$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $59a77e8886024a57$var$isArrayBuffer;
function $59a77e8886024a57$var$isDataViewToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object DataView]";
}
$59a77e8886024a57$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $59a77e8886024a57$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $59a77e8886024a57$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $59a77e8886024a57$var$isDataViewToString.working ? $59a77e8886024a57$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $59a77e8886024a57$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $59a77e8886024a57$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $59a77e8886024a57$var$isSharedArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $59a77e8886024a57$var$isSharedArrayBuffer(value) {
    if (typeof $59a77e8886024a57$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $59a77e8886024a57$var$isSharedArrayBufferToString.working === "undefined") $59a77e8886024a57$var$isSharedArrayBufferToString.working = $59a77e8886024a57$var$isSharedArrayBufferToString(new $59a77e8886024a57$var$SharedArrayBufferCopy());
    return $59a77e8886024a57$var$isSharedArrayBufferToString.working ? $59a77e8886024a57$var$isSharedArrayBufferToString(value) : value instanceof $59a77e8886024a57$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $59a77e8886024a57$var$isSharedArrayBuffer;
function $59a77e8886024a57$var$isAsyncFunction(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $59a77e8886024a57$var$isAsyncFunction;
function $59a77e8886024a57$var$isMapIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $59a77e8886024a57$var$isMapIterator;
function $59a77e8886024a57$var$isSetIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $59a77e8886024a57$var$isSetIterator;
function $59a77e8886024a57$var$isGeneratorObject(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $59a77e8886024a57$var$isGeneratorObject;
function $59a77e8886024a57$var$isWebAssemblyCompiledModule(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $59a77e8886024a57$var$isWebAssemblyCompiledModule;
function $59a77e8886024a57$var$isNumberObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$numberValue);
}
module.exports.isNumberObject = $59a77e8886024a57$var$isNumberObject;
function $59a77e8886024a57$var$isStringObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$stringValue);
}
module.exports.isStringObject = $59a77e8886024a57$var$isStringObject;
function $59a77e8886024a57$var$isBooleanObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$booleanValue);
}
module.exports.isBooleanObject = $59a77e8886024a57$var$isBooleanObject;
function $59a77e8886024a57$var$isBigIntObject(value) {
    return $59a77e8886024a57$var$BigIntSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$bigIntValue);
}
module.exports.isBigIntObject = $59a77e8886024a57$var$isBigIntObject;
function $59a77e8886024a57$var$isSymbolObject(value) {
    return $59a77e8886024a57$var$SymbolSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$symbolValue);
}
module.exports.isSymbolObject = $59a77e8886024a57$var$isSymbolObject;
function $59a77e8886024a57$var$isBoxedPrimitive(value) {
    return $59a77e8886024a57$var$isNumberObject(value) || $59a77e8886024a57$var$isStringObject(value) || $59a77e8886024a57$var$isBooleanObject(value) || $59a77e8886024a57$var$isBigIntObject(value) || $59a77e8886024a57$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $59a77e8886024a57$var$isBoxedPrimitive;
function $59a77e8886024a57$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($59a77e8886024a57$var$isArrayBuffer(value) || $59a77e8886024a57$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $59a77e8886024a57$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});
parcelRegister("f4HGZ", function(module, exports) {
"use strict";

var $af991f1d6c80f097$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $hXu6F = parcelRequire("hXu6F");
var $af991f1d6c80f097$var$$toString = $hXu6F("Object.prototype.toString");
var $af991f1d6c80f097$var$isStandardArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $af991f1d6c80f097$var$$toString(value) === "[object Arguments]";
};
var $af991f1d6c80f097$var$isLegacyArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $af991f1d6c80f097$var$$toString(value) !== "[object Array]" && $af991f1d6c80f097$var$$toString(value.callee) === "[object Function]";
};
var $af991f1d6c80f097$var$supportsStandardArguments = function() {
    return $af991f1d6c80f097$var$isStandardArguments(arguments);
}();
$af991f1d6c80f097$var$isStandardArguments.isLegacyArguments = $af991f1d6c80f097$var$isLegacyArguments; // for tests
module.exports = $af991f1d6c80f097$var$supportsStandardArguments ? $af991f1d6c80f097$var$isStandardArguments : $af991f1d6c80f097$var$isLegacyArguments;

});
parcelRegister("3KyxH", function(module, exports) {
"use strict";

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $7YWkK() && !!Symbol.toStringTag;
};

});
parcelRegister("7YWkK", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("hXu6F", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $cOB0F = parcelRequire("cOB0F");
var $d12f4cdcd6b10506$var$$indexOf = $cOB0F($1zENl("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1zENl(name, !!allowMissing);
    if (typeof intrinsic === "function" && $d12f4cdcd6b10506$var$$indexOf(name, ".prototype.") > -1) return $cOB0F(intrinsic);
    return intrinsic;
};

});
parcelRegister("1zENl", function(module, exports) {
"use strict";
var $1258b452ecf218a1$var$undefined1;

var $5A49f = parcelRequire("5A49f");

var $hDtVy = parcelRequire("hDtVy");

var $9RC8m = parcelRequire("9RC8m");

var $2BaZq = parcelRequire("2BaZq");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $hFSMY = parcelRequire("hFSMY");
var $1258b452ecf218a1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $1258b452ecf218a1$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1258b452ecf218a1$var$$gOPD) try {
    $1258b452ecf218a1$var$$gOPD({}, "");
} catch (e) {
    $1258b452ecf218a1$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $eEkyn();
};
var $1258b452ecf218a1$var$ThrowTypeError = $1258b452ecf218a1$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1258b452ecf218a1$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $1258b452ecf218a1$var$hasProto = (parcelRequire("dSRh6"))();
var $1258b452ecf218a1$var$getProto = Object.getPrototypeOf || ($1258b452ecf218a1$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === "undefined" || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGenerator%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncIteratorPrototype%": $1258b452ecf218a1$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $5A49f,
    "%eval%": eval,
    "%EvalError%": $hDtVy,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $1258b452ecf218a1$var$$Function,
    "%GeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $9RC8m,
    "%ReferenceError%": $2BaZq,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $5Ox6r,
    "%ThrowTypeError%": $1258b452ecf218a1$var$ThrowTypeError,
    "%TypedArray%": $1258b452ecf218a1$var$TypedArray,
    "%TypeError%": $eEkyn,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $hFSMY,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($1258b452ecf218a1$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto(e));
    $1258b452ecf218a1$var$INTRINSICS["%Error.prototype%"] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $1258b452ecf218a1$var$getProto) value = $1258b452ecf218a1$var$getProto(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $gvair = parcelRequire("gvair");

var $4c4Ky = parcelRequire("4c4Ky");
var $1258b452ecf218a1$var$$concat = $gvair.call(Function.call, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call(Function.apply, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call(Function.call, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call(Function.call, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $5Ox6r("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $5Ox6r("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($4c4Ky($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $eEkyn("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $5Ox6r("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $eEkyn("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $eEkyn('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $5Ox6r("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $5Ox6r("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eEkyn("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($1258b452ecf218a1$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1258b452ecf218a1$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $4c4Ky(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("5A49f", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("hDtVy", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("9RC8m", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("2BaZq", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("5Ox6r", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("eEkyn", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("hFSMY", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("24qIq", function(module, exports) {
"use strict";
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $1820ada193f67aeb$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $7YWkK();
};

});

parcelRegister("dSRh6", function(module, exports) {
"use strict";
var $a1b9a4c94d7d9147$var$test = {
    __proto__: null,
    foo: {}
};
var $a1b9a4c94d7d9147$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $a1b9a4c94d7d9147$var$test
    }).foo === $a1b9a4c94d7d9147$var$test.foo && !($a1b9a4c94d7d9147$var$test instanceof $a1b9a4c94d7d9147$var$$Object);
};

});

parcelRegister("gvair", function(module, exports) {
"use strict";

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = "[object Function]";
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $efd80b1d7fbb2850$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("4c4Ky", function(module, exports) {
"use strict";
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gvair = parcelRequire("gvair");
/** @type {import('.')} */ module.exports = $gvair.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);

});


parcelRegister("cOB0F", function(module, exports) {
"use strict";

var $gvair = parcelRequire("gvair");

var $1zENl = parcelRequire("1zENl");

var $BPe9e = parcelRequire("BPe9e");

var $eEkyn = parcelRequire("eEkyn");
var $9546dce5bd4976bd$var$$apply = $1zENl("%Function.prototype.apply%");
var $9546dce5bd4976bd$var$$call = $1zENl("%Function.prototype.call%");
var $9546dce5bd4976bd$var$$reflectApply = $1zENl("%Reflect.apply%", true) || $gvair.call($9546dce5bd4976bd$var$$call, $9546dce5bd4976bd$var$$apply);

var $jAy3M = parcelRequire("jAy3M");
var $9546dce5bd4976bd$var$$max = $1zENl("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $eEkyn("a function is required");
    var func = $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$call, arguments);
    return $BPe9e(func, 1 + $9546dce5bd4976bd$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $9546dce5bd4976bd$var$applyBind = function applyBind() {
    return $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$apply, arguments);
};
if ($jAy3M) $jAy3M(module.exports, "apply", {
    value: $9546dce5bd4976bd$var$applyBind
});
else module.exports.apply = $9546dce5bd4976bd$var$applyBind;

});
parcelRegister("BPe9e", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $5FEEt = parcelRequire("5FEEt");

var $071b317808876eb5$var$hasDescriptors = (parcelRequire("i16wS"))();

var $dYOee = parcelRequire("dYOee");

var $eEkyn = parcelRequire("eEkyn");
var $071b317808876eb5$var$$floor = $1zENl("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $eEkyn("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $071b317808876eb5$var$$floor(length) !== length) throw new $eEkyn("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $dYOee) {
        var desc = $dYOee(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($071b317808876eb5$var$hasDescriptors) $5FEEt(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $5FEEt(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("5FEEt", function(module, exports) {
"use strict";

var $jAy3M = parcelRequire("jAy3M");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $eEkyn("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $eEkyn("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $eEkyn("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $eEkyn("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $eEkyn("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $eEkyn("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$dYOee && $dYOee(obj, property);
    if ($jAy3M) $jAy3M(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $5Ox6r("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("jAy3M", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
/** @type {import('.')} */ var $e42bccb64e3fb3fd$var$$defineProperty = $1zENl("%Object.defineProperty%", true) || false;
if ($e42bccb64e3fb3fd$var$$defineProperty) try {
    $e42bccb64e3fb3fd$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e42bccb64e3fb3fd$var$$defineProperty = false;
}
module.exports = $e42bccb64e3fb3fd$var$$defineProperty;

});

parcelRegister("dYOee", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
var $a2d7d74e83f6c3ed$var$$gOPD = $1zENl("%Object.getOwnPropertyDescriptor%", true);
if ($a2d7d74e83f6c3ed$var$$gOPD) try {
    $a2d7d74e83f6c3ed$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$var$$gOPD = null;
}
module.exports = $a2d7d74e83f6c3ed$var$$gOPD;

});


parcelRegister("i16wS", function(module, exports) {
"use strict";

var $jAy3M = parcelRequire("jAy3M");
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$jAy3M;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$jAy3M) return null;
    try {
        return $jAy3M([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});





parcelRegister("5WnCa", function(module, exports) {
"use strict";
var $4534afe844d627e4$var$toStr = Object.prototype.toString;
var $4534afe844d627e4$var$fnToStr = Function.prototype.toString;
var $4534afe844d627e4$var$isFnRegex = /^\s*(?:function)?\*/;

var $4534afe844d627e4$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $4534afe844d627e4$var$getProto = Object.getPrototypeOf;
var $4534afe844d627e4$var$getGeneratorFunc = function() {
    if (!$4534afe844d627e4$var$hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var $4534afe844d627e4$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if ($4534afe844d627e4$var$isFnRegex.test($4534afe844d627e4$var$fnToStr.call(fn))) return true;
    if (!$4534afe844d627e4$var$hasToStringTag) {
        var str = $4534afe844d627e4$var$toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!$4534afe844d627e4$var$getProto) return false;
    if (typeof $4534afe844d627e4$var$GeneratorFunction === "undefined") {
        var generatorFunc = $4534afe844d627e4$var$getGeneratorFunc();
        $4534afe844d627e4$var$GeneratorFunction = generatorFunc ? $4534afe844d627e4$var$getProto(generatorFunc) : false;
    }
    return $4534afe844d627e4$var$getProto(fn) === $4534afe844d627e4$var$GeneratorFunction;
};

});

parcelRegister("gJrpv", function(module, exports) {
"use strict";

var $gFhA7 = parcelRequire("gFhA7");

var $8yXCr = parcelRequire("8yXCr");

var $cOB0F = parcelRequire("cOB0F");

var $hXu6F = parcelRequire("hXu6F");

var $dYOee = parcelRequire("dYOee");
/** @type {(O: object) => string} */ var $c2e61c703a2c9ae0$var$$toString = $hXu6F("Object.prototype.toString");

var $c2e61c703a2c9ae0$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $c2e61c703a2c9ae0$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $c2e61c703a2c9ae0$var$typedArrays = $8yXCr();
var $c2e61c703a2c9ae0$var$$slice = $hXu6F("String.prototype.slice");
var $c2e61c703a2c9ae0$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $c2e61c703a2c9ae0$var$$indexOf = $hXu6F("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {(receiver: import('.').TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call} Getter */ /** @type {{ [k in `\$${import('.').TypedArrayName}`]?: Getter } & { __proto__: null }} */ var $c2e61c703a2c9ae0$var$cache = {
    __proto__: null
};
if ($c2e61c703a2c9ae0$var$hasToStringTag && $dYOee && $c2e61c703a2c9ae0$var$getPrototypeOf) $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $c2e61c703a2c9ae0$var$getPrototypeOf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $dYOee(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $c2e61c703a2c9ae0$var$getPrototypeOf(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $dYOee(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $c2e61c703a2c9ae0$var$cache["$" + typedArray] = $cOB0F(descriptor.get);
    }
});
else $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) // @ts-expect-error TODO: fix
    $c2e61c703a2c9ae0$var$cache["$" + typedArray] = $cOB0F(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c2e61c703a2c9ae0$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $gFhA7(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $c2e61c703a2c9ae0$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            if ("$" + getter(value) === typedArray) found = $c2e61c703a2c9ae0$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c2e61c703a2c9ae0$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $gFhA7(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $c2e61c703a2c9ae0$var$cache, /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            getter(value);
            found = $c2e61c703a2c9ae0$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$c2e61c703a2c9ae0$var$hasToStringTag) {
        /** @type {string} */ var tag = $c2e61c703a2c9ae0$var$$slice($c2e61c703a2c9ae0$var$$toString(value), 8, -1);
        if ($c2e61c703a2c9ae0$var$$indexOf($c2e61c703a2c9ae0$var$typedArrays, tag) > -1) return tag;
        if (tag !== "Object") return false;
        // node < 0.6 hits here on real Typed Arrays
        return $c2e61c703a2c9ae0$var$trySlices(value);
    }
    if (!$dYOee) return null;
     // unknown engine
    return $c2e61c703a2c9ae0$var$tryTypedArrays(value);
};

});
parcelRegister("gFhA7", function(module, exports) {
"use strict";

var $63RD0 = parcelRequire("63RD0");
var $c21e1d005400ef2a$var$toStr = Object.prototype.toString;
var $c21e1d005400ef2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $c21e1d005400ef2a$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($c21e1d005400ef2a$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $c21e1d005400ef2a$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $c21e1d005400ef2a$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($c21e1d005400ef2a$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $c21e1d005400ef2a$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$63RD0(iterator)) throw new TypeError("iterator must be a function");
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($c21e1d005400ef2a$var$toStr.call(list) === "[object Array]") $c21e1d005400ef2a$var$forEachArray(list, iterator, receiver);
    else if (typeof list === "string") $c21e1d005400ef2a$var$forEachString(list, iterator, receiver);
    else $c21e1d005400ef2a$var$forEachObject(list, iterator, receiver);
};
module.exports = $c21e1d005400ef2a$var$forEach;

});
parcelRegister("63RD0", function(module, exports) {
"use strict";
var $469c9f4bd3a650de$var$fnToStr = Function.prototype.toString;
var $469c9f4bd3a650de$var$reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var $469c9f4bd3a650de$var$badArrayLike;
var $469c9f4bd3a650de$var$isCallableMarker;
if (typeof $469c9f4bd3a650de$var$reflectApply === "function" && typeof Object.defineProperty === "function") try {
    $469c9f4bd3a650de$var$badArrayLike = Object.defineProperty({}, "length", {
        get: function() {
            throw $469c9f4bd3a650de$var$isCallableMarker;
        }
    });
    $469c9f4bd3a650de$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $469c9f4bd3a650de$var$reflectApply(function() {
        throw 42;
    }, null, $469c9f4bd3a650de$var$badArrayLike);
} catch (_) {
    if (_ !== $469c9f4bd3a650de$var$isCallableMarker) $469c9f4bd3a650de$var$reflectApply = null;
}
else $469c9f4bd3a650de$var$reflectApply = null;
var $469c9f4bd3a650de$var$constructorRegex = /^\s*class\b/;
var $469c9f4bd3a650de$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $469c9f4bd3a650de$var$fnToStr.call(value);
        return $469c9f4bd3a650de$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $469c9f4bd3a650de$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
        $469c9f4bd3a650de$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $469c9f4bd3a650de$var$toStr = Object.prototype.toString;
var $469c9f4bd3a650de$var$objectClass = "[object Object]";
var $469c9f4bd3a650de$var$fnClass = "[object Function]";
var $469c9f4bd3a650de$var$genClass = "[object GeneratorFunction]";
var $469c9f4bd3a650de$var$ddaClass = "[object HTMLAllCollection]"; // IE 11
var $469c9f4bd3a650de$var$ddaClass2 = "[object HTML document.all class]";
var $469c9f4bd3a650de$var$ddaClass3 = "[object HTMLCollection]"; // IE 9-10
var $469c9f4bd3a650de$var$hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $469c9f4bd3a650de$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === "object") {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $469c9f4bd3a650de$var$all = document.all;
    if ($469c9f4bd3a650de$var$toStr.call($469c9f4bd3a650de$var$all) === $469c9f4bd3a650de$var$toStr.call(document.all)) $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($469c9f4bd3a650de$var$isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
            var str = $469c9f4bd3a650de$var$toStr.call(value);
            return (str === $469c9f4bd3a650de$var$ddaClass || str === $469c9f4bd3a650de$var$ddaClass2 || str === $469c9f4bd3a650de$var$ddaClass3 // opera 12.16
             || str === $469c9f4bd3a650de$var$objectClass // IE 6-8
            ) && value("") == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $469c9f4bd3a650de$var$reflectApply ? function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    try {
        $469c9f4bd3a650de$var$reflectApply(value, null, $469c9f4bd3a650de$var$badArrayLike);
    } catch (e) {
        if (e !== $469c9f4bd3a650de$var$isCallableMarker) return false;
    }
    return !$469c9f4bd3a650de$var$isES6ClassFn(value) && $469c9f4bd3a650de$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    if ($469c9f4bd3a650de$var$hasToStringTag) return $469c9f4bd3a650de$var$tryFunctionObject(value);
    if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
    var strClass = $469c9f4bd3a650de$var$toStr.call(value);
    if (strClass !== $469c9f4bd3a650de$var$fnClass && strClass !== $469c9f4bd3a650de$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $469c9f4bd3a650de$var$tryFunctionObject(value);
};

});


parcelRegister("8yXCr", function(module, exports) {
"use strict";

var $epJrh = parcelRequire("epJrh");
var $63bfbecf41903c8f$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $epJrh.length; i++)if (typeof $63bfbecf41903c8f$var$g[$epJrh[i]] === "function") // @ts-expect-error
    out[out.length] = $epJrh[i];
    return out;
};

});
parcelRegister("epJrh", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = [
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
];

});



parcelRegister("hN833", function(module, exports) {
"use strict";

var $gJrpv = parcelRequire("gJrpv");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$gJrpv(value);
};

});


parcelRegister("kotBY", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});

parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("8HV7i", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $656ea513998a70a9$var$_typeof = $41YNz.default;
function $656ea513998a70a9$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $656ea513998a70a9$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $656ea513998a70a9$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($656ea513998a70a9$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $656ea513998a70a9$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("23fob", function(module, exports) {

$parcel$export(module.exports, "mediaTypeClass", () => mediaTypeClass, (v) => mediaTypeClass = v);
$parcel$export(module.exports, "callbackify", () => callbackify, (v) => callbackify = v);
$parcel$export(module.exports, "domToString", () => domToString, (v) => domToString = v);
$parcel$export(module.exports, "heavyCompareSPO", () => heavyCompareSPO, (v) => heavyCompareSPO = v);
$parcel$export(module.exports, "parseXML", () => parseXML, (v) => parseXML = v);
$parcel$export(module.exports, "RDFArrayRemove", () => RDFArrayRemove, (v) => RDFArrayRemove = v);
$parcel$export(module.exports, "string_startswith", () => string_startswith, (v) => string_startswith = v);
$parcel$export(module.exports, "stackString", () => stackString, (v) => stackString = v);
/**
 * Utility functions for $rdf
 * @module util
 */ 
var $4Q80K = parcelRequire("4Q80K");


var $99pVg = parcelRequire("99pVg");

var $6YUDA = parcelRequire("6YUDA");
var string = {
    template: stringTemplate
};
function mediaTypeClass(mediaType) {
    mediaType = mediaType.split(";")[0].trim(); // remove media type parameters
    return new (0, $99pVg.default)("http://www.w3.org/ns/iana/media-types/" + mediaType + "#Resource");
}
function linkRelationProperty(relation) {
    return new (0, $99pVg.default)("http://www.w3.org/ns/iana/link-relations/relation#" + relation.trim());
}
function callbackify(obj, callbacks) {
    obj.callbacks = {};
    for(var x = callbacks.length - 1; x >= 0; x--)obj.callbacks[callbacks[x]] = [];
    obj.addHook = function(hook) {
        if (!obj.callbacks[hook]) obj.callbacks[hook] = [];
    };
    obj.addCallback = function(hook, func) {
        obj.callbacks[hook].push(func);
    };
    obj.removeCallback = function(hook, funcName) {
        for(var i = 0; i < obj.callbacks[hook].length; i++)if (obj.callbacks[hook][i].name === funcName) {
            obj.callbacks[hook].splice(i, 1);
            return true;
        }
        return false;
    };
    obj.insertCallback = function(hook, func) {
        obj.callbacks[hook].unshift(func);
    };
    obj.fireCallbacks = function fireCallbacks(hook, args) {
        var newCallbacks = [];
        var replaceCallbacks = [];
        var len = obj.callbacks[hook].length;
        var x;
        var callback;
        // log.info('!@$ Firing '+hook+' call back with length'+len)
        for(x = len - 1; x >= 0; x--){
            // log.info('@@ Firing '+hook+' callback '+ obj.callbacks[hook][x])
            callback = obj.callbacks[hook][x];
            if (callback && callback.apply(obj, args)) newCallbacks.push(callback);
        }
        for(x = newCallbacks.length - 1; x >= 0; x--)replaceCallbacks.push(newCallbacks[x]);
        for(x = len; x < obj.callbacks[hook].length; x++)replaceCallbacks.push(obj.callbacks[hook][x]);
        obj.callbacks[hook] = replaceCallbacks;
    };
}
function DOMParserFactory() {
    if (window.DOMParser) return new (0, $6YUDA.DOMParser)();
    else if (window.ActiveXObject) return new ActiveXObject("Microsoft.XMLDOM");
    else return false;
}
function domToString(node, options) {
    options = options || {};
    var selfClosing = [];
    if (options && options.selfClosing) options.selfClosing.split(" ").forEach(function(n) {
        selfClosing[n] = true;
    });
    var skipAttributes = [];
    if (options && options.skipAttributes) options.skipAttributes.split(" ").forEach(function(n) {
        skipAttributes[n] = true;
    });
    return dumpNode(node, options, selfClosing, skipAttributes);
}
function dumpNode(node, options, selfClosing, skipAttributes) {
    var i;
    var out = "";
    var noEsc = [
        false
    ];
    if (typeof node.nodeType === "undefined") return out;
    if (node.nodeType === 1) {
        if (node.hasAttribute("class") && options && options.classWithChildText && node.matches(options.classWithChildText.class)) out += node.querySelector(options.classWithChildText.element).textContent;
        else if (!(options && options.skipNodeWithClass && node.matches("." + options.skipNodeWithClass))) {
            var ename = node.nodeName.toLowerCase();
            out += "<" + ename;
            var attrList = [];
            for(i = node.attributes.length - 1; i >= 0; i--){
                var atn = node.attributes[i];
                if (skipAttributes && skipAttributes.length > 0 && skipAttributes[atn.name]) continue;
                if (/^\d+$/.test(atn.name)) continue;
                if (atn.name === "class" && options && options.replaceClassItemWith && atn.value.split(" ").indexOf(options.replaceClassItemWith.source) > -1) {
                    var re = new RegExp(options.replaceClassItemWith.source, "g");
                    atn.value = atn.value.replace(re, options.replaceClassItemWith.target).trim();
                }
                if (!(atn.name === "class" && options && options.skipClassWithValue && options.skipClassWithValue === atn.value)) attrList.push(atn.name + "='" + atn.value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&quot;") + "'");
            }
            if (attrList.length > 0) {
                if (options && options.sortAttributes) attrList.sort(function(a, b) {
                    return a.toLowerCase().localeCompare(b.toLowerCase());
                });
                out += " " + attrList.join(" ");
            }
            if (selfClosing && selfClosing.ename) out += " />";
            else {
                out += ">";
                out += ename === "html" ? "\n  " : "";
                noEsc.push(ename === "style" || ename === "script");
                for(i = 0; i < node.childNodes.length; i++)out += dumpNode(node.childNodes[i]);
                noEsc.pop();
                out += ename === "body" ? "</" + ename + ">" + "\n" : "</" + ename + ">";
            }
        }
    } else if (node.nodeType === 8) // FIXME: If comments are not tabbed in source, a new line is not prepended
    out += "<!--" + node.nodeValue + "-->";
    else if (node.nodeType === 3 || node.nodeType === 4) {
        // XXX: Remove new lines which were added after DOM ready
        var nl = node.nodeValue.replace(/\n+$/, "");
        out += noEsc[noEsc.length - 1] ? nl : nl.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    } else {
        console.log("Warning; Cannot handle serialising nodes of type: " + node.nodeType);
        console.log(node);
    }
    return out;
}
function dtstamp() {
    var now = new Date();
    var year = now.getYear() + 1900;
    var month = now.getMonth() + 1;
    var day = now.getDate();
    var hour = now.getUTCHours();
    var minute = now.getUTCMinutes();
    var second = now.getSeconds();
    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;
    if (hour < 10) hour = "0" + hour;
    if (minute < 10) minute = "0" + minute;
    if (second < 10) second = "0" + second;
    return year + "-" + month + "-" + day + "T" + hour + ":" + minute + ":" + second + "Z";
}
function heavyCompare(x, y, g, uriMap) {
    var nonBlank = function nonBlank(x) {
        return x.termType === "BlankNode" ? null : x;
    };
    var signature = function signature(x) {
        var lis = g.statementsMatching(x).map(function(st) {
            return "" + nonBlank(st.subject) + " " + nonBlank(st.predicate) + " " + nonBlank(st.object);
        }).concat(g.statementsMatching(undefined, undefined, x).map(function(st) {
            return "" + nonBlank(st.subject) + " " + nonBlank(st.predicate) + " " + nonBlank(st.object);
        }));
        lis.sort();
        return lis.join("\n");
    };
    var comparison = Object.prototype.hasOwnProperty.call(g, "compareTerms") ? g.compareTerms(x, y) : x.compareTerm(y);
    if (x.termType === "BlankNode" && y.termType === "BlankNode") {
        if (comparison === 0) return 0; // Same
        if (signature(x) > signature(y)) return 1;
        if (signature(x) < signature(y)) return -1;
        return comparison; // Too bad -- this order not canonical.
    // throw "different bnodes indistinquishable for sorting"
    } else {
        if (uriMap && x.uri && y.uri) return (uriMap[x.uri] || x.uri).localeCompare(uriMap[y.uri] || y.uri);
        return comparison;
    }
}
function heavyCompareSPO(x, y, g, uriMap) {
    return heavyCompare(x.subject, y.subject, g, uriMap) || heavyCompare(x.predicate, y.predicate, g, uriMap) || heavyCompare(x.object, y.object, g, uriMap);
}
function output(o) {
    var k = document.createElement("div");
    k.textContent = o;
    document.body.appendChild(k);
}
function parseXML(str, options) {
    var dparser;
    options = options || {};
    if (module && module.exports) {
        // Node.js
        var dom = new (0, $6YUDA.DOMParser)().parseFromString(str, options.contentType || "application/xhtml+xml");
        return dom;
    } else if (typeof window !== "undefined" && window.DOMParser) dparser = new window.DOMParser(); // seems to actually work
    else dparser = new (0, $6YUDA.DOMParser)(); // Doc says this works
    return dparser.parseFromString(str, "application/xml");
}
function RDFArrayRemove(a, x) {
    for(var i = 0; i < a.length; i++)// TODO: This used to be the following, which didnt always work..why
    // if(a[i] === x)
    if (a[i].subject.equals(x.subject) && a[i].predicate.equals(x.predicate) && a[i].object.equals(x.object) && a[i].why.equals(x.why)) {
        a.splice(i, 1);
        return;
    }
    throw new Error("RDFArrayRemove: Array did not contain " + x + " " + x.why);
}
function string_startswith(str, pref) {
    // missing library routines
    return str.slice(0, pref.length) === pref;
}
/**
 * C++, python style %s -> subs
 */ function stringTemplate(base, subs) {
    var baseA = base.split("%s");
    var result = "";
    for(var i = 0; i < subs.length; i++){
        subs[i] += "";
        result += baseA[i] + subs[i];
    }
    return result + baseA.slice(subs.length).join();
}
function stackString(e) {
    var str = "" + e + "\n";
    if (!e.stack) return str + "No stack available.\n";
    var lines = e.stack.toString().split("\n");
    var toprint = [];
    for(var i = 0; i < lines.length; i++){
        var line = lines[i];
        if (line.indexOf("ecmaunit.js") > -1) break;
        if (line.charAt(0) == "(") line = "function" + line;
        var chunks = line.split("@");
        toprint.push(chunks);
    }
    // toprint.reverse();  No - I prefer the latest at the top by the error message -tbl
    for(var i = 0; i < toprint.length; i++)str += "  " + toprint[i][1] + "\n    " + toprint[i][0];
    return str;
}

});
parcelRegister("4Q80K", function(module, exports) {

$parcel$export(module.exports, "docpart", () => $38623b99b5ce9da3$export$80bf8edc91783541);
$parcel$export(module.exports, "document", () => $38623b99b5ce9da3$export$5a7bfc01df82fcd1);
$parcel$export(module.exports, "hostpart", () => $38623b99b5ce9da3$export$ca102a2135b45508);
$parcel$export(module.exports, "join", () => $38623b99b5ce9da3$export$f7e2c8231c57a8bd);
$parcel$export(module.exports, "protocol", () => $38623b99b5ce9da3$export$a51d6b395ff4c65a);
$parcel$export(module.exports, "refTo", () => $38623b99b5ce9da3$export$53a1c54169f784af);
/*
 * Implements URI-specific functions
 *
 * See RFC 2386
 *
 * See also:
 *   http://www.w3.org/2005/10/ajaw/uri.js
 *   http://www.w3.org/2000/10/swap/uripath.py
 *
 */ 
var $99pVg = parcelRequire("99pVg");
var $38623b99b5ce9da3$var$alert = $38623b99b5ce9da3$var$alert || console.log;
function $38623b99b5ce9da3$export$80bf8edc91783541(uri) {
    var i;
    i = uri.indexOf("#");
    if (i < 0) return uri;
    else return uri.slice(0, i);
}
function $38623b99b5ce9da3$export$5a7bfc01df82fcd1(x) {
    return new (0, $99pVg.default)($38623b99b5ce9da3$export$80bf8edc91783541(x));
}
function $38623b99b5ce9da3$export$ca102a2135b45508(u) {
    var m = /[^\/]*\/\/([^\/]*)\//.exec(u);
    if (m) return m[1];
    else return "";
}
function $38623b99b5ce9da3$export$f7e2c8231c57a8bd(given, base) {
    var baseColon, baseScheme, baseSingle;
    var colon, lastSlash, path;
    var baseHash = base.indexOf("#");
    if (baseHash > 0) base = base.slice(0, baseHash);
    if (given.length === 0) return base;
    if (given.indexOf("#") === 0) return base + given;
    colon = given.indexOf(":");
    if (colon >= 0) return given;
    baseColon = base.indexOf(":");
    if (base.length === 0) return given;
    if (baseColon < 0) {
        $38623b99b5ce9da3$var$alert("Invalid base: " + base + " in join with given: " + given);
        return given;
    }
    baseScheme = base.slice(0, +baseColon + 1 || 9e9);
    if (given.indexOf("//") === 0) return baseScheme + given;
    if (base.indexOf("//", baseColon) === baseColon + 1) {
        baseSingle = base.indexOf("/", baseColon + 3);
        if (baseSingle < 0) {
            if (base.length - baseColon - 3 > 0) return base + "/" + given;
            else return baseScheme + given;
        }
    } else {
        baseSingle = base.indexOf("/", baseColon + 1);
        if (baseSingle < 0) {
            if (base.length - baseColon - 1 > 0) return base + "/" + given;
            else return baseScheme + given;
        }
    }
    if (given.indexOf("/") === 0) return base.slice(0, baseSingle) + given;
    path = base.slice(baseSingle);
    lastSlash = path.lastIndexOf("/");
    if (lastSlash < 0) return baseScheme + given;
    if (lastSlash >= 0 && lastSlash < path.length - 1) path = path.slice(0, +lastSlash + 1 || 9e9);
    path += given;
    while(path.match(/[^\/]*\/\.\.\//))path = path.replace(/[^\/]*\/\.\.\//, "");
    path = path.replace(/\.\//g, "");
    path = path.replace(/\/\.$/, "/");
    return base.slice(0, baseSingle) + path;
}
function $38623b99b5ce9da3$export$a51d6b395ff4c65a(uri) {
    var i = uri.indexOf(":");
    if (i < 0) return null;
    else return uri.slice(0, i);
}
function $38623b99b5ce9da3$export$53a1c54169f784af(base, uri) {
    var c, i, k, l, len, len1, n, o, p, q, ref, ref1, s;
    var commonHost = new RegExp("^[-_a-zA-Z0-9.]+:(//[^/]*)?/[^/]*$");
    if (!base) return uri;
    if (base === uri) return "";
    for(i = o = 0, len = uri.length; o < len; i = ++o){
        var _c = uri[i];
        if (_c !== base[i]) break;
    }
    if (base.slice(0, i).match(commonHost)) {
        k = uri.indexOf("//");
        if (k < 0) k = -2;
        l = uri.indexOf("/", k + 2);
        if (uri[l + 1] !== "/" && base[l + 1] !== "/" && uri.slice(0, l) === base.slice(0, l)) return uri.slice(l);
    }
    if (uri[i] === "#" && base.length === i) return uri.slice(i);
    while(i > 0 && uri[i - 1] !== "/")i--;
    if (i < 3) return uri;
    if (base.indexOf("//", i - 2) > 0 || uri.indexOf("//", i - 2) > 0) return uri;
    if (base.indexOf(":", i) > 0) return uri;
    n = 0;
    ref = base.slice(i);
    for(p = 0, len1 = ref.length; p < len1; p++){
        c = ref[p];
        if (c === "/") n++;
    }
    if (n === 0 && i < uri.length && uri[i] === "#") return "./" + uri.slice(i);
    if (n === 0 && i === uri.length) return "./";
    s = "";
    if (n > 0) for(q = 1, ref1 = n; ref1 >= 1 ? q <= ref1 : q >= ref1; ref1 >= 1 ? ++q : --q)s += "../";
    return s + uri.slice(i);
}

});
parcelRegister("99pVg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a99100006cc9c4d$export$2e2bcd8739ae039);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $6zC7B = parcelRequire("6zC7B");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $g5Zhu = parcelRequire("g5Zhu");

var $aZYlt = parcelRequire("aZYlt");

var $cdU35 = parcelRequire("cdU35");

var $8RKL2 = parcelRequire("8RKL2");

var $avzMW = parcelRequire("avzMW");

var $gCJkd = parcelRequire("gCJkd");
function $6a99100006cc9c4d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6a99100006cc9c4d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $6a99100006cc9c4d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A named (IRI) RDF node
 */ var $6a99100006cc9c4d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Node) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(NamedNode, _Node);
    var _super = $6a99100006cc9c4d$var$_createSuper(NamedNode);
    /**
   * Create a named (IRI) RDF Node
   * @constructor
   * @param iri - The IRI for this node
   */ function NamedNode(iri) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, NamedNode);
        _this = _super.call(this, (0, $avzMW.termValue)(iri));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "termType", (0, $8RKL2.NamedNodeTermType));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "classOrder", (0, $aZYlt.default).NamedNode);
        if (!_this.value) throw new Error("Missing IRI for NamedNode");
        if (!_this.value.includes(":")) throw new Error('NamedNode IRI "' + iri + '" must be absolute.');
        if (_this.value.includes(" ")) {
            var message = 'Error: NamedNode IRI "' + iri + '" must not contain unencoded spaces.';
            throw new Error(message);
        }
        return _this;
    }
    /**
   * Returns an $rdf node for the containing directory, ending in slash.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(NamedNode, [
        {
            key: "dir",
            value: function dir() {
                var str = this.value.split("#")[0];
                var p = str.slice(0, -1).lastIndexOf("/");
                var q = str.indexOf("//");
                if (q >= 0 && p < q + 2 || p < 0) return null;
                return new NamedNode(str.slice(0, p + 1));
            }
        },
        {
            key: "site",
            value: function site() {
                var str = this.value.split("#")[0];
                var p = str.indexOf("//");
                if (p < 0) throw new Error("This URI does not have a web site part (origin)");
                var q = str.indexOf("/", p + 2);
                if (q < 0) return new NamedNode(str.slice(0) + "/"); // Add slash to a bare origin
                else return new NamedNode(str.slice(0, q + 1));
            }
        },
        {
            key: "doc",
            value: function doc() {
                if (this.value.indexOf("#") < 0) return this;
                else return new NamedNode(this.value.split("#")[0]);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "<" + this.value + ">";
            }
        },
        {
            key: "id",
            value: function id() {
                return this.value.split("#")[1];
            }
        },
        {
            key: "uri",
            get: function get() {
                return this.value;
            },
            set: function set(uri) {
                this.value = uri;
            }
        }
    ], [
        {
            key: "fromValue",
            value: function fromValue(value) {
                if (typeof value === "undefined" || value === null) return value;
                if ((0, $gCJkd.isTerm)(value)) return value;
                return new NamedNode(value);
            }
        }
    ]);
    return NamedNode;
}((0, $cdU35.default));

});
parcelRegister("fu0YK", function(module, exports) {
function $b45a6abf916bff88$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $b45a6abf916bff88$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lR7jo", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $fe9438347a673ba6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $5DKOa(descriptor.key), descriptor);
    }
}
function $fe9438347a673ba6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fe9438347a673ba6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fe9438347a673ba6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $fe9438347a673ba6$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5DKOa", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;

var $fKGZD = parcelRequire("fKGZD");
function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $fKGZD(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
module.exports = $010f4e0e13c82e16$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fKGZD", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b77c8068776c2a21$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("6zC7B", function(module, exports) {
function $4c93951af9bb8a88$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $4c93951af9bb8a88$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("f8wIT", function(module, exports) {

var $aAhot = parcelRequire("aAhot");
function $b050fc8434f4a0e1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $aAhot(subClass, superClass);
}
module.exports = $b050fc8434f4a0e1$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aAhot", function(module, exports) {
function $7b4ac2338b8e8f97$var$_setPrototypeOf(o, p) {
    module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $7b4ac2338b8e8f97$var$_setPrototypeOf(o, p);
}
module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("eN9hz", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $ac4cd79166dac6e4$var$_typeof = $41YNz.default;

var $6zC7B = parcelRequire("6zC7B");
function $ac4cd79166dac6e4$var$_possibleConstructorReturn(self, call) {
    if (call && ($ac4cd79166dac6e4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6zC7B(self);
}
module.exports = $ac4cd79166dac6e4$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cGTaw", function(module, exports) {
function $93d4339c80153a6a$var$_getPrototypeOf(o) {
    module.exports = $93d4339c80153a6a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $93d4339c80153a6a$var$_getPrototypeOf(o);
}
module.exports = $93d4339c80153a6a$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("g5Zhu", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $bb7ca61ce45563c4$var$_defineProperty(obj, key, value) {
    key = $5DKOa(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $bb7ca61ce45563c4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("aZYlt", function(module, exports) {

$parcel$export(module.exports, "default", () => $801e6932b6e9b45f$export$2e2bcd8739ae039);
/**
* Class orders
*/ var $801e6932b6e9b45f$var$ClassOrder = {
    "Literal": 1,
    "Collection": 3,
    "Graph": 4,
    "NamedNode": 5,
    "BlankNode": 6,
    "Variable": 7
};
var $801e6932b6e9b45f$export$2e2bcd8739ae039 = $801e6932b6e9b45f$var$ClassOrder;

});

parcelRegister("cdU35", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e622d13d12c0a4c$export$2e2bcd8739ae039);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
/**
 * The superclass of all RDF Statement objects, that is
 * NamedNode, Literal, BlankNode, etc.
 * Should not be instantiated directly.
 * Also called Term.
 * @link https://rdf.js.org/data-model-spec/#term-interface
 * @class Node
 */ var $8e622d13d12c0a4c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Node(value) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Node);
        /** The type of node */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "termType", void 0);
        /** The class order for this node */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "classOrder", void 0);
        /** The node's value */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "value", void 0);
        this.value = value;
    }
    /**
   * Creates the substituted node for this one, according to the specified bindings
   * @param bindings - Bindings of identifiers to nodes
   */ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Node, [
        {
            key: "substitute",
            value: function substitute(bindings) {
                return this;
            }
        },
        {
            key: "compareTerm",
            value: function compareTerm(other) {
                if (this.classOrder < other.classOrder) return -1;
                if (this.classOrder > other.classOrder) return 1;
                if (this.value < other.value) return -1;
                if (this.value > other.value) return 1;
                return 0;
            }
        },
        {
            key: "equals",
            value: function equals(other) {
                if (!other) return false;
                return this.termType === other.termType && this.value === other.value;
            }
        },
        {
            key: "hashString",
            value: function hashString() {
                return this.toCanonical();
            }
        },
        {
            key: "sameTerm",
            value: function sameTerm(other) {
                return this.equals(other);
            }
        },
        {
            key: "toCanonical",
            value: function toCanonical() {
                return this.toNT();
            }
        },
        {
            key: "toNT",
            value: function toNT() {
                return this.toString();
            }
        },
        {
            key: "toNQ",
            value: function toNQ() {
                return this.toNT();
            }
        },
        {
            key: "toString",
            value: function toString() {
                throw new Error("Node.toString() is abstract - see the subclasses instead");
            }
        }
    ]);
    return Node;
}();
// Specified in './node.ts' to prevent circular dependency
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($8e622d13d12c0a4c$export$2e2bcd8739ae039, "fromValue", void 0);
// Specified in './node.ts' to prevent circular dependency
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($8e622d13d12c0a4c$export$2e2bcd8739ae039, "toJS", void 0);

});

parcelRegister("8RKL2", function(module, exports) {

$parcel$export(module.exports, "NamedNodeTermType", () => $67478b0b307aeabd$export$ab86c9774e900759);
$parcel$export(module.exports, "BlankNodeTermType", () => $67478b0b307aeabd$export$f1b84dadeebce3ec);
$parcel$export(module.exports, "LiteralTermType", () => $67478b0b307aeabd$export$6ec19b5755c118bb);
$parcel$export(module.exports, "VariableTermType", () => $67478b0b307aeabd$export$76b848e67ab7df67);
$parcel$export(module.exports, "DefaultGraphTermType", () => $67478b0b307aeabd$export$66e3691befce521);
$parcel$export(module.exports, "CollectionTermType", () => $67478b0b307aeabd$export$1cc319ce4cc6c07);
$parcel$export(module.exports, "EmptyTermType", () => $67478b0b307aeabd$export$5e07dee03d88fd9b);
$parcel$export(module.exports, "GraphTermType", () => $67478b0b307aeabd$export$8b0a5b7a9bab7f5f);
$parcel$export(module.exports, "HTMLContentType", () => $67478b0b307aeabd$export$4e97c6324b0fc563);
$parcel$export(module.exports, "JSONLDContentType", () => $67478b0b307aeabd$export$c0caf88d9bfc4151);
$parcel$export(module.exports, "N3ContentType", () => $67478b0b307aeabd$export$7c2abebedede4666);
$parcel$export(module.exports, "N3LegacyContentType", () => $67478b0b307aeabd$export$71a86f1571e0f9e3);
$parcel$export(module.exports, "NQuadsAltContentType", () => $67478b0b307aeabd$export$e1378d8473a1b8b);
$parcel$export(module.exports, "NQuadsContentType", () => $67478b0b307aeabd$export$72c700663a6da118);
$parcel$export(module.exports, "NTriplesContentType", () => $67478b0b307aeabd$export$1c7d73fda2689091);
$parcel$export(module.exports, "RDFXMLContentType", () => $67478b0b307aeabd$export$ee6f8f5f19deb6c0);
$parcel$export(module.exports, "SPARQLUpdateContentType", () => $67478b0b307aeabd$export$fad3d759a39fa06b);
$parcel$export(module.exports, "SPARQLUpdateSingleMatchContentType", () => $67478b0b307aeabd$export$d7cdba5560258a1);
$parcel$export(module.exports, "TurtleContentType", () => $67478b0b307aeabd$export$9be2284ddc122481);
$parcel$export(module.exports, "TurtleLegacyContentType", () => $67478b0b307aeabd$export$55356beaf2f33538);
$parcel$export(module.exports, "XHTMLContentType", () => $67478b0b307aeabd$export$b5947d5930ff0842);
var $67478b0b307aeabd$export$ab86c9774e900759 = "NamedNode";
var $67478b0b307aeabd$export$f1b84dadeebce3ec = "BlankNode";
var $67478b0b307aeabd$export$6ec19b5755c118bb = "Literal";
var $67478b0b307aeabd$export$76b848e67ab7df67 = "Variable";
var $67478b0b307aeabd$export$66e3691befce521 = "DefaultGraph";
var $67478b0b307aeabd$export$1cc319ce4cc6c07 = "Collection";
var $67478b0b307aeabd$export$5e07dee03d88fd9b = "Empty";
var $67478b0b307aeabd$export$8b0a5b7a9bab7f5f = "Graph";
var $67478b0b307aeabd$export$4e97c6324b0fc563 = "text/html";
var $67478b0b307aeabd$export$c0caf88d9bfc4151 = "application/ld+json";
var $67478b0b307aeabd$export$7c2abebedede4666 = "text/n3";
var $67478b0b307aeabd$export$71a86f1571e0f9e3 = "application/n3";
var $67478b0b307aeabd$export$e1378d8473a1b8b = "application/nquads";
var $67478b0b307aeabd$export$72c700663a6da118 = "application/n-quads";
var $67478b0b307aeabd$export$1c7d73fda2689091 = "application/n-triples";
var $67478b0b307aeabd$export$ee6f8f5f19deb6c0 = "application/rdf+xml";
var $67478b0b307aeabd$export$fad3d759a39fa06b = "application/sparql-update";
var $67478b0b307aeabd$export$d7cdba5560258a1 = "application/sparql-update-single-match";
var $67478b0b307aeabd$export$9be2284ddc122481 = "text/turtle";
var $67478b0b307aeabd$export$55356beaf2f33538 = "application/x-turtle";
var $67478b0b307aeabd$export$b5947d5930ff0842 = "application/xhtml+xml"; /**
 * A valid mime type header
 */  /** A type for values that serves as inputs */  /**
 * In this project, there exist two types for the same kind of RDF concept.
 * We have RDF/JS spec types (standardized, generic), and RDFlib types (internal, specific).
 * When deciding which type to use in a function, it is preferable to accept generic inputs,
 * whenever possible, and provide strict outputs.
 * In some ways, the TF types in here are a bit more strict.
 * Variables are missing, and the statement requires specific types of terms (e.g. NamedNode instead of Term).
 */  /** An RDF/JS Subject */  /** An RDF/JS Predicate */  /** An RDF/JS Object */  /** An RDF/JS Graph */  // | Formula
 /** All the types that a .fromValue() method might return */ 

});

parcelRegister("avzMW", function(module, exports) {

$parcel$export(module.exports, "termValue", () => $7a688f78df8e5efd$export$deab0da43b28364e);
/** Retrieve the value of a term, or self if already a string. */ function $7a688f78df8e5efd$export$deab0da43b28364e(node) {
    if (typeof node === "string") return node;
    return node.value;
}

});

parcelRegister("gCJkd", function(module, exports) {

$parcel$export(module.exports, "isStatement", () => $c1a35a9520365540$export$78a28e85343c8674);
$parcel$export(module.exports, "isStore", () => $c1a35a9520365540$export$9abf972af34a1547);
$parcel$export(module.exports, "isCollection", () => $c1a35a9520365540$export$cea7aa84e978eba5);
$parcel$export(module.exports, "isTerm", () => $c1a35a9520365540$export$9d67e281257ee71);
$parcel$export(module.exports, "isRDFlibObject", () => $c1a35a9520365540$export$ee15a308c4424939);
$parcel$export(module.exports, "isRDFlibSubject", () => $c1a35a9520365540$export$aa61d0c644b154b4);
$parcel$export(module.exports, "isRDFlibPredicate", () => $c1a35a9520365540$export$1b8f3715c19ad752);
$parcel$export(module.exports, "isVariable", () => $c1a35a9520365540$export$670a0c046e2ed227);
$parcel$export(module.exports, "isLiteral", () => $c1a35a9520365540$export$899158ea22bb4609);
$parcel$export(module.exports, "isQuad", () => $c1a35a9520365540$export$631d618571b0cb5d);
$parcel$export(module.exports, "isNamedNode", () => $c1a35a9520365540$export$10490ce738f72284);
$parcel$export(module.exports, "isBlankNode", () => $c1a35a9520365540$export$7b5b4967656acaac);
$parcel$export(module.exports, "isGraph", () => $c1a35a9520365540$export$ac5b344562d20e4e);

var $41YNz = parcelRequire("41YNz");

var $8RKL2 = parcelRequire("8RKL2");
function $c1a35a9520365540$export$78a28e85343c8674(obj) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(obj) === "object" && obj !== null && "subject" in obj;
}
function $c1a35a9520365540$export$9abf972af34a1547(obj) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(obj) === "object" && obj !== null && "statements" in obj;
}
function $c1a35a9520365540$export$cea7aa84e978eba5(obj) {
    return $c1a35a9520365540$export$9d67e281257ee71(obj) && obj.termType === (0, $8RKL2.CollectionTermType);
}
function $c1a35a9520365540$export$ee15a308c4424939(obj) {
    return obj && Object.prototype.hasOwnProperty.call(obj, "termType") && (obj.termType === (0, $8RKL2.NamedNodeTermType) || obj.termType === (0, $8RKL2.VariableTermType) || obj.termType === (0, $8RKL2.BlankNodeTermType) || obj.termType === (0, $8RKL2.CollectionTermType) || obj.termType === (0, $8RKL2.LiteralTermType) || obj.termType === (0, $8RKL2.GraphTermType));
}
function $c1a35a9520365540$export$aa61d0c644b154b4(obj) {
    return obj && Object.prototype.hasOwnProperty.call(obj, "termType") && (obj.termType === (0, $8RKL2.NamedNodeTermType) || obj.termType === (0, $8RKL2.VariableTermType) || obj.termType === (0, $8RKL2.BlankNodeTermType) || obj.termType === (0, $8RKL2.CollectionTermType) || obj.termType === (0, $8RKL2.LiteralTermType) || obj.termType === (0, $8RKL2.GraphTermType));
}
function $c1a35a9520365540$export$1b8f3715c19ad752(obj) {
    return $c1a35a9520365540$export$9d67e281257ee71(obj) && (obj.termType === (0, $8RKL2.NamedNodeTermType) || obj.termType === (0, $8RKL2.BlankNodeTermType) || obj.termType === (0, $8RKL2.VariableTermType));
}
function $c1a35a9520365540$export$670a0c046e2ed227(obj) {
    return $c1a35a9520365540$export$9d67e281257ee71(obj) && obj.termType === (0, $8RKL2.VariableTermType);
}
function $c1a35a9520365540$export$9d67e281257ee71(obj) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(obj) === "object" && obj !== null && "termType" in obj;
}
function $c1a35a9520365540$export$899158ea22bb4609(value) {
    return value.termType === (0, $8RKL2.LiteralTermType);
}
function $c1a35a9520365540$export$631d618571b0cb5d(obj) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(obj) === "object" && obj !== null && "subject" in obj && "predicate" in obj && "object" in obj;
}
function $c1a35a9520365540$export$10490ce738f72284(obj) {
    return $c1a35a9520365540$export$9d67e281257ee71(obj) && obj.termType === "NamedNode";
}
function $c1a35a9520365540$export$7b5b4967656acaac(obj) {
    return $c1a35a9520365540$export$9d67e281257ee71(obj) && "termType" in obj && obj.termType === "BlankNode";
}
function $c1a35a9520365540$export$3abc00c648b4208e(obj) {
    return $c1a35a9520365540$export$9d67e281257ee71(obj) && (obj.termType === (0, $8RKL2.NamedNodeTermType) || obj.termType === (0, $8RKL2.VariableTermType) || obj.termType === (0, $8RKL2.BlankNodeTermType));
}
function $c1a35a9520365540$export$693d5ce24db4cd2a(obj) {
    return $c1a35a9520365540$export$9d67e281257ee71(obj) && (obj.termType === (0, $8RKL2.NamedNodeTermType) || obj.termType === (0, $8RKL2.VariableTermType));
}
function $c1a35a9520365540$export$597628373f7ff1c6(obj) {
    return $c1a35a9520365540$export$9d67e281257ee71(obj) && (obj.termType === (0, $8RKL2.NamedNodeTermType) || obj.termType === (0, $8RKL2.VariableTermType) || obj.termType === (0, $8RKL2.BlankNodeTermType) || obj.termType === (0, $8RKL2.LiteralTermType));
}
function $c1a35a9520365540$export$ac5b344562d20e4e(obj) {
    return $c1a35a9520365540$export$9d67e281257ee71(obj) && (obj.termType === (0, $8RKL2.NamedNodeTermType) || obj.termType === (0, $8RKL2.VariableTermType) || obj.termType === (0, $8RKL2.BlankNodeTermType) || obj.termType === (0, $8RKL2.DefaultGraphTermType));
}

});



parcelRegister("6YUDA", function(module, exports) {

$parcel$export(module.exports, "DOMParser", () => $515447b9158f86cb$export$1059c6e7d2ce5669, (v) => $515447b9158f86cb$export$1059c6e7d2ce5669 = v);
var $515447b9158f86cb$export$455426655eab1d48;
var $515447b9158f86cb$export$64f0bed4ae6f0f24;
var $515447b9158f86cb$export$1059c6e7d2ce5669;

var $2YubT = parcelRequire("2YubT");
$515447b9158f86cb$export$455426655eab1d48 = $2YubT.DOMImplementation;
$515447b9158f86cb$export$64f0bed4ae6f0f24 = $2YubT.XMLSerializer;

$515447b9158f86cb$export$1059c6e7d2ce5669 = (parcelRequire("c1Wy2")).DOMParser;

});
parcelRegister("2YubT", function(module, exports) {

$parcel$export(module.exports, "DOMImplementation", () => $22a89a9d1d5ce29e$export$455426655eab1d48, (v) => $22a89a9d1d5ce29e$export$455426655eab1d48 = v);
$parcel$export(module.exports, "XMLSerializer", () => $22a89a9d1d5ce29e$export$64f0bed4ae6f0f24, (v) => $22a89a9d1d5ce29e$export$64f0bed4ae6f0f24 = v);
//if(typeof require == 'function'){
var $22a89a9d1d5ce29e$export$d1d99cf900472499;
var $22a89a9d1d5ce29e$export$fe58bcf938607f6a;
var $22a89a9d1d5ce29e$export$455426655eab1d48;
var $22a89a9d1d5ce29e$export$db77ccec0bb4ccac;
var $22a89a9d1d5ce29e$export$85c928794f8d04d4;
var $22a89a9d1d5ce29e$export$79b41aa5d56abdff;
var $22a89a9d1d5ce29e$export$64f0bed4ae6f0f24;

var $hkG9E = parcelRequire("hkG9E");
var $22a89a9d1d5ce29e$var$find = $hkG9E.find;
var $22a89a9d1d5ce29e$var$NAMESPACE = $hkG9E.NAMESPACE;
/**
 * A prerequisite for `[].filter`, to drop elements that are empty
 * @param {string} input
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$notEmptyString(input) {
    return input !== "";
}
/**
 * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
 * @see https://infra.spec.whatwg.org/#ascii-whitespace
 *
 * @param {string} input
 * @returns {string[]} (can be empty)
 */ function $22a89a9d1d5ce29e$var$splitOnASCIIWhitespace(input) {
    // U+0009 TAB, U+000A LF, U+000C FF, U+000D CR, U+0020 SPACE
    return input ? input.split(/[\t\n\f\r ]+/).filter($22a89a9d1d5ce29e$var$notEmptyString) : [];
}
/**
 * Adds element as a key to current if it is not already present.
 *
 * @param {Record<string, boolean | undefined>} current
 * @param {string} element
 * @returns {Record<string, boolean | undefined>}
 */ function $22a89a9d1d5ce29e$var$orderedSetReducer(current, element) {
    if (!current.hasOwnProperty(element)) current[element] = true;
    return current;
}
/**
 * @see https://infra.spec.whatwg.org/#ordered-set
 * @param {string} input
 * @returns {string[]}
 */ function $22a89a9d1d5ce29e$var$toOrderedSet(input) {
    if (!input) return [];
    var list = $22a89a9d1d5ce29e$var$splitOnASCIIWhitespace(input);
    return Object.keys(list.reduce($22a89a9d1d5ce29e$var$orderedSetReducer, {}));
}
/**
 * Uses `list.indexOf` to implement something like `Array.prototype.includes`,
 * which we can not rely on being available.
 *
 * @param {any[]} list
 * @returns {function(any): boolean}
 */ function $22a89a9d1d5ce29e$var$arrayIncludes(list) {
    return function(element) {
        return list && list.indexOf(element) !== -1;
    };
}
function $22a89a9d1d5ce29e$var$copy(src, dest) {
    for(var p in src)if (Object.prototype.hasOwnProperty.call(src, p)) dest[p] = src[p];
}
/**
^\w+\.prototype\.([_\w]+)\s*=\s*((?:.*\{\s*?[\r\n][\s\S]*?^})|\S.*?(?=[;\r\n]));?
^\w+\.prototype\.([_\w]+)\s*=\s*(\S.*?(?=[;\r\n]));?
 */ function $22a89a9d1d5ce29e$var$_extends(Class, Super) {
    var pt = Class.prototype;
    if (!(pt instanceof Super)) {
        function t() {}
        t.prototype = Super.prototype;
        t = new t();
        $22a89a9d1d5ce29e$var$copy(pt, t);
        Class.prototype = pt = t;
    }
    if (pt.constructor != Class) {
        if (typeof Class != "function") console.error("unknown Class:" + Class);
        pt.constructor = Class;
    }
}
// Node Types
var $22a89a9d1d5ce29e$var$NodeType = {};
var $22a89a9d1d5ce29e$var$ELEMENT_NODE = $22a89a9d1d5ce29e$var$NodeType.ELEMENT_NODE = 1;
var $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE = $22a89a9d1d5ce29e$var$NodeType.ATTRIBUTE_NODE = 2;
var $22a89a9d1d5ce29e$var$TEXT_NODE = $22a89a9d1d5ce29e$var$NodeType.TEXT_NODE = 3;
var $22a89a9d1d5ce29e$var$CDATA_SECTION_NODE = $22a89a9d1d5ce29e$var$NodeType.CDATA_SECTION_NODE = 4;
var $22a89a9d1d5ce29e$var$ENTITY_REFERENCE_NODE = $22a89a9d1d5ce29e$var$NodeType.ENTITY_REFERENCE_NODE = 5;
var $22a89a9d1d5ce29e$var$ENTITY_NODE = $22a89a9d1d5ce29e$var$NodeType.ENTITY_NODE = 6;
var $22a89a9d1d5ce29e$var$PROCESSING_INSTRUCTION_NODE = $22a89a9d1d5ce29e$var$NodeType.PROCESSING_INSTRUCTION_NODE = 7;
var $22a89a9d1d5ce29e$var$COMMENT_NODE = $22a89a9d1d5ce29e$var$NodeType.COMMENT_NODE = 8;
var $22a89a9d1d5ce29e$var$DOCUMENT_NODE = $22a89a9d1d5ce29e$var$NodeType.DOCUMENT_NODE = 9;
var $22a89a9d1d5ce29e$var$DOCUMENT_TYPE_NODE = $22a89a9d1d5ce29e$var$NodeType.DOCUMENT_TYPE_NODE = 10;
var $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE = $22a89a9d1d5ce29e$var$NodeType.DOCUMENT_FRAGMENT_NODE = 11;
var $22a89a9d1d5ce29e$var$NOTATION_NODE = $22a89a9d1d5ce29e$var$NodeType.NOTATION_NODE = 12;
// ExceptionCode
var $22a89a9d1d5ce29e$var$ExceptionCode = {};
var $22a89a9d1d5ce29e$var$ExceptionMessage = {};
var $22a89a9d1d5ce29e$var$INDEX_SIZE_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INDEX_SIZE_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[1] = "Index size error", 1);
var $22a89a9d1d5ce29e$var$DOMSTRING_SIZE_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.DOMSTRING_SIZE_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[2] = "DOMString size error", 2);
var $22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.HIERARCHY_REQUEST_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[3] = "Hierarchy request error", 3);
var $22a89a9d1d5ce29e$var$WRONG_DOCUMENT_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.WRONG_DOCUMENT_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[4] = "Wrong document", 4);
var $22a89a9d1d5ce29e$var$INVALID_CHARACTER_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INVALID_CHARACTER_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[5] = "Invalid character", 5);
var $22a89a9d1d5ce29e$var$NO_DATA_ALLOWED_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.NO_DATA_ALLOWED_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[6] = "No data allowed", 6);
var $22a89a9d1d5ce29e$var$NO_MODIFICATION_ALLOWED_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[7] = "No modification allowed", 7);
var $22a89a9d1d5ce29e$var$NOT_FOUND_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.NOT_FOUND_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[8] = "Not found", 8);
var $22a89a9d1d5ce29e$var$NOT_SUPPORTED_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.NOT_SUPPORTED_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[9] = "Not supported", 9);
var $22a89a9d1d5ce29e$var$INUSE_ATTRIBUTE_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INUSE_ATTRIBUTE_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[10] = "Attribute in use", 10);
//level2
var $22a89a9d1d5ce29e$var$INVALID_STATE_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INVALID_STATE_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[11] = "Invalid state", 11);
var $22a89a9d1d5ce29e$var$SYNTAX_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.SYNTAX_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[12] = "Syntax error", 12);
var $22a89a9d1d5ce29e$var$INVALID_MODIFICATION_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INVALID_MODIFICATION_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[13] = "Invalid modification", 13);
var $22a89a9d1d5ce29e$var$NAMESPACE_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.NAMESPACE_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[14] = "Invalid namespace", 14);
var $22a89a9d1d5ce29e$var$INVALID_ACCESS_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INVALID_ACCESS_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[15] = "Invalid access", 15);
/**
 * DOM Level 2
 * Object DOMException
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/ecma-script-binding.html
 * @see http://www.w3.org/TR/REC-DOM-Level-1/ecma-script-language-binding.html
 */ function $22a89a9d1d5ce29e$var$DOMException(code, message) {
    if (message instanceof Error) var error = message;
    else {
        error = this;
        Error.call(this, $22a89a9d1d5ce29e$var$ExceptionMessage[code]);
        this.message = $22a89a9d1d5ce29e$var$ExceptionMessage[code];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $22a89a9d1d5ce29e$var$DOMException);
    }
    error.code = code;
    if (message) this.message = this.message + ": " + message;
    return error;
}
$22a89a9d1d5ce29e$var$DOMException.prototype = Error.prototype;
$22a89a9d1d5ce29e$var$copy($22a89a9d1d5ce29e$var$ExceptionCode, $22a89a9d1d5ce29e$var$DOMException);
/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
 * The NodeList interface provides the abstraction of an ordered collection of nodes, without defining or constraining how this collection is implemented. NodeList objects in the DOM are live.
 * The items in the NodeList are accessible via an integral index, starting from 0.
 */ function $22a89a9d1d5ce29e$var$NodeList() {}
$22a89a9d1d5ce29e$var$NodeList.prototype = {
    /**
	 * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
	 * @standard level1
	 */ length: 0,
    /**
	 * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
	 * @standard level1
	 * @param index  unsigned long
	 *   Index into the collection.
	 * @return Node
	 * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
	 */ item: function(index) {
        return index >= 0 && index < this.length ? this[index] : null;
    },
    toString: function(isHTML, nodeFilter) {
        for(var buf = [], i = 0; i < this.length; i++)$22a89a9d1d5ce29e$var$serializeToString(this[i], buf, isHTML, nodeFilter);
        return buf.join("");
    },
    /**
	 * @private
	 * @param {function (Node):boolean} predicate
	 * @returns {Node[]}
	 */ filter: function(predicate) {
        return Array.prototype.filter.call(this, predicate);
    },
    /**
	 * @private
	 * @param {Node} item
	 * @returns {number}
	 */ indexOf: function(item) {
        return Array.prototype.indexOf.call(this, item);
    }
};
function $22a89a9d1d5ce29e$var$LiveNodeList(node, refresh) {
    this._node = node;
    this._refresh = refresh;
    $22a89a9d1d5ce29e$var$_updateLiveList(this);
}
function $22a89a9d1d5ce29e$var$_updateLiveList(list) {
    var inc = list._node._inc || list._node.ownerDocument._inc;
    if (list._inc !== inc) {
        var ls = list._refresh(list._node);
        $22a89a9d1d5ce29e$var$__set__(list, "length", ls.length);
        if (!list.$$length || ls.length < list.$$length) {
            for(var i = ls.length; (i in list); i++)if (Object.prototype.hasOwnProperty.call(list, i)) delete list[i];
        }
        $22a89a9d1d5ce29e$var$copy(ls, list);
        list._inc = inc;
    }
}
$22a89a9d1d5ce29e$var$LiveNodeList.prototype.item = function(i) {
    $22a89a9d1d5ce29e$var$_updateLiveList(this);
    return this[i] || null;
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$LiveNodeList, $22a89a9d1d5ce29e$var$NodeList);
/**
 * Objects implementing the NamedNodeMap interface are used
 * to represent collections of nodes that can be accessed by name.
 * Note that NamedNodeMap does not inherit from NodeList;
 * NamedNodeMaps are not maintained in any particular order.
 * Objects contained in an object implementing NamedNodeMap may also be accessed by an ordinal index,
 * but this is simply to allow convenient enumeration of the contents of a NamedNodeMap,
 * and does not imply that the DOM specifies an order to these Nodes.
 * NamedNodeMap objects in the DOM are live.
 * used for attributes or DocumentType entities
 */ function $22a89a9d1d5ce29e$var$NamedNodeMap() {}
function $22a89a9d1d5ce29e$var$_findNodeIndex(list, node) {
    var i = list.length;
    while(i--){
        if (list[i] === node) return i;
    }
}
function $22a89a9d1d5ce29e$var$_addNamedNode(el, list, newAttr, oldAttr) {
    if (oldAttr) list[$22a89a9d1d5ce29e$var$_findNodeIndex(list, oldAttr)] = newAttr;
    else list[list.length++] = newAttr;
    if (el) {
        newAttr.ownerElement = el;
        var doc = el.ownerDocument;
        if (doc) {
            oldAttr && $22a89a9d1d5ce29e$var$_onRemoveAttribute(doc, el, oldAttr);
            $22a89a9d1d5ce29e$var$_onAddAttribute(doc, el, newAttr);
        }
    }
}
function $22a89a9d1d5ce29e$var$_removeNamedNode(el, list, attr) {
    //console.log('remove attr:'+attr)
    var i = $22a89a9d1d5ce29e$var$_findNodeIndex(list, attr);
    if (i >= 0) {
        var lastIndex = list.length - 1;
        while(i < lastIndex)list[i] = list[++i];
        list.length = lastIndex;
        if (el) {
            var doc = el.ownerDocument;
            if (doc) {
                $22a89a9d1d5ce29e$var$_onRemoveAttribute(doc, el, attr);
                attr.ownerElement = null;
            }
        }
    } else throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$NOT_FOUND_ERR, new Error(el.tagName + "@" + attr));
}
$22a89a9d1d5ce29e$var$NamedNodeMap.prototype = {
    length: 0,
    item: $22a89a9d1d5ce29e$var$NodeList.prototype.item,
    getNamedItem: function(key) {
        //		if(key.indexOf(':')>0 || key == 'xmlns'){
        //			return null;
        //		}
        //console.log()
        var i = this.length;
        while(i--){
            var attr = this[i];
            //console.log(attr.nodeName,key)
            if (attr.nodeName == key) return attr;
        }
    },
    setNamedItem: function(attr) {
        var el = attr.ownerElement;
        if (el && el != this._ownerElement) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$INUSE_ATTRIBUTE_ERR);
        var oldAttr = this.getNamedItem(attr.nodeName);
        $22a89a9d1d5ce29e$var$_addNamedNode(this._ownerElement, this, attr, oldAttr);
        return oldAttr;
    },
    /* returns Node */ setNamedItemNS: function(attr) {
        var el = attr.ownerElement, oldAttr;
        if (el && el != this._ownerElement) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$INUSE_ATTRIBUTE_ERR);
        oldAttr = this.getNamedItemNS(attr.namespaceURI, attr.localName);
        $22a89a9d1d5ce29e$var$_addNamedNode(this._ownerElement, this, attr, oldAttr);
        return oldAttr;
    },
    /* returns Node */ removeNamedItem: function(key) {
        var attr = this.getNamedItem(key);
        $22a89a9d1d5ce29e$var$_removeNamedNode(this._ownerElement, this, attr);
        return attr;
    },
    //for level2
    removeNamedItemNS: function(namespaceURI, localName) {
        var attr = this.getNamedItemNS(namespaceURI, localName);
        $22a89a9d1d5ce29e$var$_removeNamedNode(this._ownerElement, this, attr);
        return attr;
    },
    getNamedItemNS: function(namespaceURI, localName) {
        var i = this.length;
        while(i--){
            var node = this[i];
            if (node.localName == localName && node.namespaceURI == namespaceURI) return node;
        }
        return null;
    }
};
/**
 * The DOMImplementation interface represents an object providing methods
 * which are not dependent on any particular document.
 * Such an object is returned by the `Document.implementation` property.
 *
 * __The individual methods describe the differences compared to the specs.__
 *
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation MDN
 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-102161490 DOM Level 1 Core (Initial)
 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#ID-102161490 DOM Level 2 Core
 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-102161490 DOM Level 3 Core
 * @see https://dom.spec.whatwg.org/#domimplementation DOM Living Standard
 */ function $22a89a9d1d5ce29e$var$DOMImplementation() {}
$22a89a9d1d5ce29e$var$DOMImplementation.prototype = {
    /**
	 * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
	 * The different implementations fairly diverged in what kind of features were reported.
	 * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
	 *
	 * @deprecated It is deprecated and modern browsers return true in all cases.
	 *
	 * @param {string} feature
	 * @param {string} [version]
	 * @returns {boolean} always true
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
	 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
	 */ hasFeature: function(feature, version) {
        return true;
    },
    /**
	 * Creates an XML Document object of the specified type with its document element.
	 *
	 * __It behaves slightly different from the description in the living standard__:
	 * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
	 * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * @param {string|null} namespaceURI
	 * @param {string} qualifiedName
	 * @param {DocumentType=null} doctype
	 * @returns {Document}
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */ createDocument: function(namespaceURI, qualifiedName, doctype) {
        var doc = new $22a89a9d1d5ce29e$var$Document();
        doc.implementation = this;
        doc.childNodes = new $22a89a9d1d5ce29e$var$NodeList();
        doc.doctype = doctype || null;
        if (doctype) doc.appendChild(doctype);
        if (qualifiedName) {
            var root = doc.createElementNS(namespaceURI, qualifiedName);
            doc.appendChild(root);
        }
        return doc;
    },
    /**
	 * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
	 *
	 * __This behavior is slightly different from the in the specs__:
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * @param {string} qualifiedName
	 * @param {string} [publicId]
	 * @param {string} [systemId]
	 * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
	 * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */ createDocumentType: function(qualifiedName, publicId, systemId) {
        var node = new $22a89a9d1d5ce29e$var$DocumentType();
        node.name = qualifiedName;
        node.nodeName = qualifiedName;
        node.publicId = publicId || "";
        node.systemId = systemId || "";
        return node;
    }
};
/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-1950641247
 */ function $22a89a9d1d5ce29e$var$Node() {}
$22a89a9d1d5ce29e$var$Node.prototype = {
    firstChild: null,
    lastChild: null,
    previousSibling: null,
    nextSibling: null,
    attributes: null,
    parentNode: null,
    childNodes: null,
    ownerDocument: null,
    nodeValue: null,
    namespaceURI: null,
    prefix: null,
    localName: null,
    // Modified in DOM Level 2:
    insertBefore: function(newChild, refChild) {
        return $22a89a9d1d5ce29e$var$_insertBefore(this, newChild, refChild);
    },
    replaceChild: function(newChild, oldChild) {
        $22a89a9d1d5ce29e$var$_insertBefore(this, newChild, oldChild, $22a89a9d1d5ce29e$var$assertPreReplacementValidityInDocument);
        if (oldChild) this.removeChild(oldChild);
    },
    removeChild: function(oldChild) {
        return $22a89a9d1d5ce29e$var$_removeChild(this, oldChild);
    },
    appendChild: function(newChild) {
        return this.insertBefore(newChild, null);
    },
    hasChildNodes: function() {
        return this.firstChild != null;
    },
    cloneNode: function(deep) {
        return $22a89a9d1d5ce29e$var$cloneNode(this.ownerDocument || this, this, deep);
    },
    // Modified in DOM Level 2:
    normalize: function() {
        var child = this.firstChild;
        while(child){
            var next = child.nextSibling;
            if (next && next.nodeType == $22a89a9d1d5ce29e$var$TEXT_NODE && child.nodeType == $22a89a9d1d5ce29e$var$TEXT_NODE) {
                this.removeChild(next);
                child.appendData(next.data);
            } else {
                child.normalize();
                child = next;
            }
        }
    },
    // Introduced in DOM Level 2:
    isSupported: function(feature, version) {
        return this.ownerDocument.implementation.hasFeature(feature, version);
    },
    // Introduced in DOM Level 2:
    hasAttributes: function() {
        return this.attributes.length > 0;
    },
    /**
	 * Look up the prefix associated to the given namespace URI, starting from this node.
	 * **The default namespace declarations are ignored by this method.**
	 * See Namespace Prefix Lookup for details on the algorithm used by this method.
	 *
	 * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
	 *
	 * @param {string | null} namespaceURI
	 * @returns {string | null}
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
	 * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
	 * @see https://github.com/xmldom/xmldom/issues/322
	 */ lookupPrefix: function(namespaceURI) {
        var el = this;
        while(el){
            var map = el._nsMap;
            //console.dir(map)
            if (map) for(var n in map){
                if (Object.prototype.hasOwnProperty.call(map, n) && map[n] === namespaceURI) return n;
            }
            el = el.nodeType == $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
    },
    // Introduced in DOM Level 3:
    lookupNamespaceURI: function(prefix) {
        var el = this;
        while(el){
            var map = el._nsMap;
            //console.dir(map)
            if (map) {
                if (Object.prototype.hasOwnProperty.call(map, prefix)) return map[prefix];
            }
            el = el.nodeType == $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
    },
    // Introduced in DOM Level 3:
    isDefaultNamespace: function(namespaceURI) {
        var prefix = this.lookupPrefix(namespaceURI);
        return prefix == null;
    }
};
function $22a89a9d1d5ce29e$var$_xmlEncoder(c) {
    return c == "<" && "&lt;" || c == ">" && "&gt;" || c == "&" && "&amp;" || c == '"' && "&quot;" || "&#" + c.charCodeAt() + ";";
}
$22a89a9d1d5ce29e$var$copy($22a89a9d1d5ce29e$var$NodeType, $22a89a9d1d5ce29e$var$Node);
$22a89a9d1d5ce29e$var$copy($22a89a9d1d5ce29e$var$NodeType, $22a89a9d1d5ce29e$var$Node.prototype);
/**
 * @param callback return true for continue,false for break
 * @return boolean true: break visit;
 */ function $22a89a9d1d5ce29e$var$_visitNode(node, callback) {
    if (callback(node)) return true;
    if (node = node.firstChild) do {
        if ($22a89a9d1d5ce29e$var$_visitNode(node, callback)) return true;
    }while (node = node.nextSibling);
}
function $22a89a9d1d5ce29e$var$Document() {
    this.ownerDocument = this;
}
function $22a89a9d1d5ce29e$var$_onAddAttribute(doc, el, newAttr) {
    doc && doc._inc++;
    var ns = newAttr.namespaceURI;
    if (ns === $22a89a9d1d5ce29e$var$NAMESPACE.XMLNS) //update namespace
    el._nsMap[newAttr.prefix ? newAttr.localName : ""] = newAttr.value;
}
function $22a89a9d1d5ce29e$var$_onRemoveAttribute(doc, el, newAttr, remove) {
    doc && doc._inc++;
    var ns = newAttr.namespaceURI;
    if (ns === $22a89a9d1d5ce29e$var$NAMESPACE.XMLNS) //update namespace
    delete el._nsMap[newAttr.prefix ? newAttr.localName : ""];
}
/**
 * Updates `el.childNodes`, updating the indexed items and it's `length`.
 * Passing `newChild` means it will be appended.
 * Otherwise it's assumed that an item has been removed,
 * and `el.firstNode` and it's `.nextSibling` are used
 * to walk the current list of child nodes.
 *
 * @param {Document} doc
 * @param {Node} el
 * @param {Node} [newChild]
 * @private
 */ function $22a89a9d1d5ce29e$var$_onUpdateChild(doc, el, newChild) {
    if (doc && doc._inc) {
        doc._inc++;
        //update childNodes
        var cs = el.childNodes;
        if (newChild) cs[cs.length++] = newChild;
        else {
            var child = el.firstChild;
            var i = 0;
            while(child){
                cs[i++] = child;
                child = child.nextSibling;
            }
            cs.length = i;
            delete cs[cs.length];
        }
    }
}
/**
 * Removes the connections between `parentNode` and `child`
 * and any existing `child.previousSibling` or `child.nextSibling`.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 *
 * @param {Node} parentNode
 * @param {Node} child
 * @returns {Node} the child that was removed.
 * @private
 */ function $22a89a9d1d5ce29e$var$_removeChild(parentNode, child) {
    var previous = child.previousSibling;
    var next = child.nextSibling;
    if (previous) previous.nextSibling = next;
    else parentNode.firstChild = next;
    if (next) next.previousSibling = previous;
    else parentNode.lastChild = previous;
    child.parentNode = null;
    child.previousSibling = null;
    child.nextSibling = null;
    $22a89a9d1d5ce29e$var$_onUpdateChild(parentNode.ownerDocument, parentNode);
    return child;
}
/**
 * Returns `true` if `node` can be a parent for insertion.
 * @param {Node} node
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$hasValidParentNodeType(node) {
    return node && (node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_NODE || node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === $22a89a9d1d5ce29e$var$Node.ELEMENT_NODE);
}
/**
 * Returns `true` if `node` can be inserted according to it's `nodeType`.
 * @param {Node} node
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$hasInsertableNodeType(node) {
    return node && ($22a89a9d1d5ce29e$var$isElementNode(node) || $22a89a9d1d5ce29e$var$isTextNode(node) || $22a89a9d1d5ce29e$var$isDocTypeNode(node) || node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === $22a89a9d1d5ce29e$var$Node.COMMENT_NODE || node.nodeType === $22a89a9d1d5ce29e$var$Node.PROCESSING_INSTRUCTION_NODE);
}
/**
 * Returns true if `node` is a DOCTYPE node
 * @param {Node} node
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$isDocTypeNode(node) {
    return node && node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_TYPE_NODE;
}
/**
 * Returns true if the node is an element
 * @param {Node} node
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$isElementNode(node) {
    return node && node.nodeType === $22a89a9d1d5ce29e$var$Node.ELEMENT_NODE;
}
/**
 * Returns true if `node` is a text node
 * @param {Node} node
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$isTextNode(node) {
    return node && node.nodeType === $22a89a9d1d5ce29e$var$Node.TEXT_NODE;
}
/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Document} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $22a89a9d1d5ce29e$var$isElementInsertionPossible(doc, child) {
    var parentChildNodes = doc.childNodes || [];
    if ($22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isElementNode) || $22a89a9d1d5ce29e$var$isDocTypeNode(child)) return false;
    var docTypeNode = $22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isDocTypeNode);
    return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}
/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Node} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $22a89a9d1d5ce29e$var$isElementReplacementPossible(doc, child) {
    var parentChildNodes = doc.childNodes || [];
    function hasElementChildThatIsNotChild(node) {
        return $22a89a9d1d5ce29e$var$isElementNode(node) && node !== child;
    }
    if ($22a89a9d1d5ce29e$var$find(parentChildNodes, hasElementChildThatIsNotChild)) return false;
    var docTypeNode = $22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isDocTypeNode);
    return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}
/**
 * @private
 * Steps 1-5 of the checks before inserting and before replacing a child are the same.
 *
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $22a89a9d1d5ce29e$var$assertPreInsertionValidity1to5(parent, node, child) {
    // 1. If `parent` is not a Document, DocumentFragment, or Element node, then throw a "HierarchyRequestError" DOMException.
    if (!$22a89a9d1d5ce29e$var$hasValidParentNodeType(parent)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Unexpected parent node type " + parent.nodeType);
    // 2. If `node` is a host-including inclusive ancestor of `parent`, then throw a "HierarchyRequestError" DOMException.
    // not implemented!
    // 3. If `child` is non-null and its parent is not `parent`, then throw a "NotFoundError" DOMException.
    if (child && child.parentNode !== parent) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$NOT_FOUND_ERR, "child not in parent");
    if (// 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
    !$22a89a9d1d5ce29e$var$hasInsertableNodeType(node) || // 5. If either `node` is a Text node and `parent` is a document,
    // the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
    // || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
    // or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
    $22a89a9d1d5ce29e$var$isDocTypeNode(node) && parent.nodeType !== $22a89a9d1d5ce29e$var$Node.DOCUMENT_NODE) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Unexpected node type " + node.nodeType + " for parent node type " + parent.nodeType);
}
/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $22a89a9d1d5ce29e$var$assertPreInsertionValidityInDocument(parent, node, child) {
    var parentChildNodes = parent.childNodes || [];
    var nodeChildNodes = node.childNodes || [];
    // DocumentFragment
    if (node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter($22a89a9d1d5ce29e$var$isElementNode);
        // If node has more than one element child or has a Text node child.
        if (nodeChildElements.length > 1 || $22a89a9d1d5ce29e$var$find(nodeChildNodes, $22a89a9d1d5ce29e$var$isTextNode)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "More than one element or text in fragment");
        // Otherwise, if `node` has one element child and either `parent` has an element child,
        // `child` is a doctype, or `child` is non-null and a doctype is following `child`.
        if (nodeChildElements.length === 1 && !$22a89a9d1d5ce29e$var$isElementInsertionPossible(parent, child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Element in fragment can not be inserted before doctype");
    }
    // Element
    if ($22a89a9d1d5ce29e$var$isElementNode(node)) {
        // `parent` has an element child, `child` is a doctype,
        // or `child` is non-null and a doctype is following `child`.
        if (!$22a89a9d1d5ce29e$var$isElementInsertionPossible(parent, child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Only one element can be added and only after doctype");
    }
    // DocumentType
    if ($22a89a9d1d5ce29e$var$isDocTypeNode(node)) {
        // `parent` has a doctype child,
        if ($22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isDocTypeNode)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Only one doctype is allowed");
        var parentElementChild = $22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isElementNode);
        // `child` is non-null and an element is preceding `child`,
        if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Doctype can only be inserted before an element");
        // or `child` is null and `parent` has an element child.
        if (!child && parentElementChild) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Doctype can not be appended since element is present");
    }
}
/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $22a89a9d1d5ce29e$var$assertPreReplacementValidityInDocument(parent, node, child) {
    var parentChildNodes = parent.childNodes || [];
    var nodeChildNodes = node.childNodes || [];
    // DocumentFragment
    if (node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter($22a89a9d1d5ce29e$var$isElementNode);
        // If `node` has more than one element child or has a Text node child.
        if (nodeChildElements.length > 1 || $22a89a9d1d5ce29e$var$find(nodeChildNodes, $22a89a9d1d5ce29e$var$isTextNode)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "More than one element or text in fragment");
        // Otherwise, if `node` has one element child and either `parent` has an element child that is not `child` or a doctype is following `child`.
        if (nodeChildElements.length === 1 && !$22a89a9d1d5ce29e$var$isElementReplacementPossible(parent, child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Element in fragment can not be inserted before doctype");
    }
    // Element
    if ($22a89a9d1d5ce29e$var$isElementNode(node)) {
        // `parent` has an element child that is not `child` or a doctype is following `child`.
        if (!$22a89a9d1d5ce29e$var$isElementReplacementPossible(parent, child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Only one element can be added and only after doctype");
    }
    // DocumentType
    if ($22a89a9d1d5ce29e$var$isDocTypeNode(node)) {
        function hasDoctypeChildThatIsNotChild(node) {
            return $22a89a9d1d5ce29e$var$isDocTypeNode(node) && node !== child;
        }
        // `parent` has a doctype child that is not `child`,
        if ($22a89a9d1d5ce29e$var$find(parentChildNodes, hasDoctypeChildThatIsNotChild)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Only one doctype is allowed");
        var parentElementChild = $22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isElementNode);
        // or an element is preceding `child`.
        if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Doctype can only be inserted before an element");
    }
}
/**
 * @private
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $22a89a9d1d5ce29e$var$_insertBefore(parent, node, child, _inDocumentAssertion) {
    // To ensure pre-insertion validity of a node into a parent before a child, run these steps:
    $22a89a9d1d5ce29e$var$assertPreInsertionValidity1to5(parent, node, child);
    // If parent is a document, and any of the statements below, switched on the interface node implements,
    // are true, then throw a "HierarchyRequestError" DOMException.
    if (parent.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_NODE) (_inDocumentAssertion || $22a89a9d1d5ce29e$var$assertPreInsertionValidityInDocument)(parent, node, child);
    var cp = node.parentNode;
    if (cp) cp.removeChild(node); //remove and update
    if (node.nodeType === $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE) {
        var newFirst = node.firstChild;
        if (newFirst == null) return node;
        var newLast = node.lastChild;
    } else newFirst = newLast = node;
    var pre = child ? child.previousSibling : parent.lastChild;
    newFirst.previousSibling = pre;
    newLast.nextSibling = child;
    if (pre) pre.nextSibling = newFirst;
    else parent.firstChild = newFirst;
    if (child == null) parent.lastChild = newLast;
    else child.previousSibling = newLast;
    do newFirst.parentNode = parent;
    while (newFirst !== newLast && (newFirst = newFirst.nextSibling));
    $22a89a9d1d5ce29e$var$_onUpdateChild(parent.ownerDocument || parent, parent);
    //console.log(parent.lastChild.nextSibling == null)
    if (node.nodeType == $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE) node.firstChild = node.lastChild = null;
    return node;
}
/**
 * Appends `newChild` to `parentNode`.
 * If `newChild` is already connected to a `parentNode` it is first removed from it.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 * @param {Node} parentNode
 * @param {Node} newChild
 * @returns {Node}
 * @private
 */ function $22a89a9d1d5ce29e$var$_appendSingleChild(parentNode, newChild) {
    if (newChild.parentNode) newChild.parentNode.removeChild(newChild);
    newChild.parentNode = parentNode;
    newChild.previousSibling = parentNode.lastChild;
    newChild.nextSibling = null;
    if (newChild.previousSibling) newChild.previousSibling.nextSibling = newChild;
    else parentNode.firstChild = newChild;
    parentNode.lastChild = newChild;
    $22a89a9d1d5ce29e$var$_onUpdateChild(parentNode.ownerDocument, parentNode, newChild);
    return newChild;
}
$22a89a9d1d5ce29e$var$Document.prototype = {
    //implementation : null,
    nodeName: "#document",
    nodeType: $22a89a9d1d5ce29e$var$DOCUMENT_NODE,
    /**
	 * The DocumentType node of the document.
	 *
	 * @readonly
	 * @type DocumentType
	 */ doctype: null,
    documentElement: null,
    _inc: 1,
    insertBefore: function(newChild, refChild) {
        if (newChild.nodeType == $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE) {
            var child = newChild.firstChild;
            while(child){
                var next = child.nextSibling;
                this.insertBefore(child, refChild);
                child = next;
            }
            return newChild;
        }
        $22a89a9d1d5ce29e$var$_insertBefore(this, newChild, refChild);
        newChild.ownerDocument = this;
        if (this.documentElement === null && newChild.nodeType === $22a89a9d1d5ce29e$var$ELEMENT_NODE) this.documentElement = newChild;
        return newChild;
    },
    removeChild: function(oldChild) {
        if (this.documentElement == oldChild) this.documentElement = null;
        return $22a89a9d1d5ce29e$var$_removeChild(this, oldChild);
    },
    replaceChild: function(newChild, oldChild) {
        //raises
        $22a89a9d1d5ce29e$var$_insertBefore(this, newChild, oldChild, $22a89a9d1d5ce29e$var$assertPreReplacementValidityInDocument);
        newChild.ownerDocument = this;
        if (oldChild) this.removeChild(oldChild);
        if ($22a89a9d1d5ce29e$var$isElementNode(newChild)) this.documentElement = newChild;
    },
    // Introduced in DOM Level 2:
    importNode: function(importedNode, deep) {
        return $22a89a9d1d5ce29e$var$importNode(this, importedNode, deep);
    },
    // Introduced in DOM Level 2:
    getElementById: function(id) {
        var rtv = null;
        $22a89a9d1d5ce29e$var$_visitNode(this.documentElement, function(node) {
            if (node.nodeType == $22a89a9d1d5ce29e$var$ELEMENT_NODE) {
                if (node.getAttribute("id") == id) {
                    rtv = node;
                    return true;
                }
            }
        });
        return rtv;
    },
    /**
	 * The `getElementsByClassName` method of `Document` interface returns an array-like object
	 * of all child elements which have **all** of the given class name(s).
	 *
	 * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
	 *
	 *
	 * Warning: This is a live LiveNodeList.
	 * Changes in the DOM will reflect in the array as the changes occur.
	 * If an element selected by this array no longer qualifies for the selector,
	 * it will automatically be removed. Be aware of this for iteration purposes.
	 *
	 * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
	 * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
	 */ getElementsByClassName: function(classNames) {
        var classNamesSet = $22a89a9d1d5ce29e$var$toOrderedSet(classNames);
        return new $22a89a9d1d5ce29e$var$LiveNodeList(this, function(base) {
            var ls = [];
            if (classNamesSet.length > 0) $22a89a9d1d5ce29e$var$_visitNode(base.documentElement, function(node) {
                if (node !== base && node.nodeType === $22a89a9d1d5ce29e$var$ELEMENT_NODE) {
                    var nodeClassNames = node.getAttribute("class");
                    // can be null if the attribute does not exist
                    if (nodeClassNames) {
                        // before splitting and iterating just compare them for the most common case
                        var matches = classNames === nodeClassNames;
                        if (!matches) {
                            var nodeClassNamesSet = $22a89a9d1d5ce29e$var$toOrderedSet(nodeClassNames);
                            matches = classNamesSet.every($22a89a9d1d5ce29e$var$arrayIncludes(nodeClassNamesSet));
                        }
                        if (matches) ls.push(node);
                    }
                }
            });
            return ls;
        });
    },
    //document factory method:
    createElement: function(tagName) {
        var node = new $22a89a9d1d5ce29e$var$Element();
        node.ownerDocument = this;
        node.nodeName = tagName;
        node.tagName = tagName;
        node.localName = tagName;
        node.childNodes = new $22a89a9d1d5ce29e$var$NodeList();
        var attrs = node.attributes = new $22a89a9d1d5ce29e$var$NamedNodeMap();
        attrs._ownerElement = node;
        return node;
    },
    createDocumentFragment: function() {
        var node = new $22a89a9d1d5ce29e$var$DocumentFragment();
        node.ownerDocument = this;
        node.childNodes = new $22a89a9d1d5ce29e$var$NodeList();
        return node;
    },
    createTextNode: function(data) {
        var node = new $22a89a9d1d5ce29e$var$Text();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    createComment: function(data) {
        var node = new $22a89a9d1d5ce29e$var$Comment();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    createCDATASection: function(data) {
        var node = new $22a89a9d1d5ce29e$var$CDATASection();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    createProcessingInstruction: function(target, data) {
        var node = new $22a89a9d1d5ce29e$var$ProcessingInstruction();
        node.ownerDocument = this;
        node.tagName = node.nodeName = node.target = target;
        node.nodeValue = node.data = data;
        return node;
    },
    createAttribute: function(name) {
        var node = new $22a89a9d1d5ce29e$var$Attr();
        node.ownerDocument = this;
        node.name = name;
        node.nodeName = name;
        node.localName = name;
        node.specified = true;
        return node;
    },
    createEntityReference: function(name) {
        var node = new $22a89a9d1d5ce29e$var$EntityReference();
        node.ownerDocument = this;
        node.nodeName = name;
        return node;
    },
    // Introduced in DOM Level 2:
    createElementNS: function(namespaceURI, qualifiedName) {
        var node = new $22a89a9d1d5ce29e$var$Element();
        var pl = qualifiedName.split(":");
        var attrs = node.attributes = new $22a89a9d1d5ce29e$var$NamedNodeMap();
        node.childNodes = new $22a89a9d1d5ce29e$var$NodeList();
        node.ownerDocument = this;
        node.nodeName = qualifiedName;
        node.tagName = qualifiedName;
        node.namespaceURI = namespaceURI;
        if (pl.length == 2) {
            node.prefix = pl[0];
            node.localName = pl[1];
        } else //el.prefix = null;
        node.localName = qualifiedName;
        attrs._ownerElement = node;
        return node;
    },
    // Introduced in DOM Level 2:
    createAttributeNS: function(namespaceURI, qualifiedName) {
        var node = new $22a89a9d1d5ce29e$var$Attr();
        var pl = qualifiedName.split(":");
        node.ownerDocument = this;
        node.nodeName = qualifiedName;
        node.name = qualifiedName;
        node.namespaceURI = namespaceURI;
        node.specified = true;
        if (pl.length == 2) {
            node.prefix = pl[0];
            node.localName = pl[1];
        } else //el.prefix = null;
        node.localName = qualifiedName;
        return node;
    }
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Document, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$Element() {
    this._nsMap = {};
}
$22a89a9d1d5ce29e$var$Element.prototype = {
    nodeType: $22a89a9d1d5ce29e$var$ELEMENT_NODE,
    hasAttribute: function(name) {
        return this.getAttributeNode(name) != null;
    },
    getAttribute: function(name) {
        var attr = this.getAttributeNode(name);
        return attr && attr.value || "";
    },
    getAttributeNode: function(name) {
        return this.attributes.getNamedItem(name);
    },
    setAttribute: function(name, value) {
        var attr = this.ownerDocument.createAttribute(name);
        attr.value = attr.nodeValue = "" + value;
        this.setAttributeNode(attr);
    },
    removeAttribute: function(name) {
        var attr = this.getAttributeNode(name);
        attr && this.removeAttributeNode(attr);
    },
    //four real opeartion method
    appendChild: function(newChild) {
        if (newChild.nodeType === $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE) return this.insertBefore(newChild, null);
        else return $22a89a9d1d5ce29e$var$_appendSingleChild(this, newChild);
    },
    setAttributeNode: function(newAttr) {
        return this.attributes.setNamedItem(newAttr);
    },
    setAttributeNodeNS: function(newAttr) {
        return this.attributes.setNamedItemNS(newAttr);
    },
    removeAttributeNode: function(oldAttr) {
        //console.log(this == oldAttr.ownerElement)
        return this.attributes.removeNamedItem(oldAttr.nodeName);
    },
    //get real attribute name,and remove it by removeAttributeNode
    removeAttributeNS: function(namespaceURI, localName) {
        var old = this.getAttributeNodeNS(namespaceURI, localName);
        old && this.removeAttributeNode(old);
    },
    hasAttributeNS: function(namespaceURI, localName) {
        return this.getAttributeNodeNS(namespaceURI, localName) != null;
    },
    getAttributeNS: function(namespaceURI, localName) {
        var attr = this.getAttributeNodeNS(namespaceURI, localName);
        return attr && attr.value || "";
    },
    setAttributeNS: function(namespaceURI, qualifiedName, value) {
        var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
        attr.value = attr.nodeValue = "" + value;
        this.setAttributeNode(attr);
    },
    getAttributeNodeNS: function(namespaceURI, localName) {
        return this.attributes.getNamedItemNS(namespaceURI, localName);
    },
    getElementsByTagName: function(tagName) {
        return new $22a89a9d1d5ce29e$var$LiveNodeList(this, function(base) {
            var ls = [];
            $22a89a9d1d5ce29e$var$_visitNode(base, function(node) {
                if (node !== base && node.nodeType == $22a89a9d1d5ce29e$var$ELEMENT_NODE && (tagName === "*" || node.tagName == tagName)) ls.push(node);
            });
            return ls;
        });
    },
    getElementsByTagNameNS: function(namespaceURI, localName) {
        return new $22a89a9d1d5ce29e$var$LiveNodeList(this, function(base) {
            var ls = [];
            $22a89a9d1d5ce29e$var$_visitNode(base, function(node) {
                if (node !== base && node.nodeType === $22a89a9d1d5ce29e$var$ELEMENT_NODE && (namespaceURI === "*" || node.namespaceURI === namespaceURI) && (localName === "*" || node.localName == localName)) ls.push(node);
            });
            return ls;
        });
    }
};
$22a89a9d1d5ce29e$var$Document.prototype.getElementsByTagName = $22a89a9d1d5ce29e$var$Element.prototype.getElementsByTagName;
$22a89a9d1d5ce29e$var$Document.prototype.getElementsByTagNameNS = $22a89a9d1d5ce29e$var$Element.prototype.getElementsByTagNameNS;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Element, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$Attr() {}
$22a89a9d1d5ce29e$var$Attr.prototype.nodeType = $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Attr, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$CharacterData() {}
$22a89a9d1d5ce29e$var$CharacterData.prototype = {
    data: "",
    substringData: function(offset, count) {
        return this.data.substring(offset, offset + count);
    },
    appendData: function(text) {
        text = this.data + text;
        this.nodeValue = this.data = text;
        this.length = text.length;
    },
    insertData: function(offset, text) {
        this.replaceData(offset, 0, text);
    },
    appendChild: function(newChild) {
        throw new Error($22a89a9d1d5ce29e$var$ExceptionMessage[$22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR]);
    },
    deleteData: function(offset, count) {
        this.replaceData(offset, count, "");
    },
    replaceData: function(offset, count, text) {
        var start = this.data.substring(0, offset);
        var end = this.data.substring(offset + count);
        text = start + text + end;
        this.nodeValue = this.data = text;
        this.length = text.length;
    }
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$CharacterData, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$Text() {}
$22a89a9d1d5ce29e$var$Text.prototype = {
    nodeName: "#text",
    nodeType: $22a89a9d1d5ce29e$var$TEXT_NODE,
    splitText: function(offset) {
        var text = this.data;
        var newText = text.substring(offset);
        text = text.substring(0, offset);
        this.data = this.nodeValue = text;
        this.length = text.length;
        var newNode = this.ownerDocument.createTextNode(newText);
        if (this.parentNode) this.parentNode.insertBefore(newNode, this.nextSibling);
        return newNode;
    }
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Text, $22a89a9d1d5ce29e$var$CharacterData);
function $22a89a9d1d5ce29e$var$Comment() {}
$22a89a9d1d5ce29e$var$Comment.prototype = {
    nodeName: "#comment",
    nodeType: $22a89a9d1d5ce29e$var$COMMENT_NODE
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Comment, $22a89a9d1d5ce29e$var$CharacterData);
function $22a89a9d1d5ce29e$var$CDATASection() {}
$22a89a9d1d5ce29e$var$CDATASection.prototype = {
    nodeName: "#cdata-section",
    nodeType: $22a89a9d1d5ce29e$var$CDATA_SECTION_NODE
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$CDATASection, $22a89a9d1d5ce29e$var$CharacterData);
function $22a89a9d1d5ce29e$var$DocumentType() {}
$22a89a9d1d5ce29e$var$DocumentType.prototype.nodeType = $22a89a9d1d5ce29e$var$DOCUMENT_TYPE_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$DocumentType, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$Notation() {}
$22a89a9d1d5ce29e$var$Notation.prototype.nodeType = $22a89a9d1d5ce29e$var$NOTATION_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Notation, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$Entity() {}
$22a89a9d1d5ce29e$var$Entity.prototype.nodeType = $22a89a9d1d5ce29e$var$ENTITY_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Entity, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$EntityReference() {}
$22a89a9d1d5ce29e$var$EntityReference.prototype.nodeType = $22a89a9d1d5ce29e$var$ENTITY_REFERENCE_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$EntityReference, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$DocumentFragment() {}
$22a89a9d1d5ce29e$var$DocumentFragment.prototype.nodeName = "#document-fragment";
$22a89a9d1d5ce29e$var$DocumentFragment.prototype.nodeType = $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$DocumentFragment, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$ProcessingInstruction() {}
$22a89a9d1d5ce29e$var$ProcessingInstruction.prototype.nodeType = $22a89a9d1d5ce29e$var$PROCESSING_INSTRUCTION_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$ProcessingInstruction, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$XMLSerializer() {}
$22a89a9d1d5ce29e$var$XMLSerializer.prototype.serializeToString = function(node, isHtml, nodeFilter) {
    return $22a89a9d1d5ce29e$var$nodeSerializeToString.call(node, isHtml, nodeFilter);
};
$22a89a9d1d5ce29e$var$Node.prototype.toString = $22a89a9d1d5ce29e$var$nodeSerializeToString;
function $22a89a9d1d5ce29e$var$nodeSerializeToString(isHtml, nodeFilter) {
    var buf = [];
    var refNode = this.nodeType == 9 && this.documentElement || this;
    var prefix = refNode.prefix;
    var uri = refNode.namespaceURI;
    if (uri && prefix == null) {
        //console.log(prefix)
        var prefix = refNode.lookupPrefix(uri);
        if (prefix == null) //isHTML = true;
        var visibleNamespaces = [
            {
                namespace: uri,
                prefix: null
            }
        ];
    }
    $22a89a9d1d5ce29e$var$serializeToString(this, buf, isHtml, nodeFilter, visibleNamespaces);
    //console.log('###',this.nodeType,uri,prefix,buf.join(''))
    return buf.join("");
}
function $22a89a9d1d5ce29e$var$needNamespaceDefine(node, isHTML, visibleNamespaces) {
    var prefix = node.prefix || "";
    var uri = node.namespaceURI;
    // According to [Namespaces in XML 1.0](https://www.w3.org/TR/REC-xml-names/#ns-using) ,
    // and more specifically https://www.w3.org/TR/REC-xml-names/#nsc-NoPrefixUndecl :
    // > In a namespace declaration for a prefix [...], the attribute value MUST NOT be empty.
    // in a similar manner [Namespaces in XML 1.1](https://www.w3.org/TR/xml-names11/#ns-using)
    // and more specifically https://www.w3.org/TR/xml-names11/#nsc-NSDeclared :
    // > [...] Furthermore, the attribute value [...] must not be an empty string.
    // so serializing empty namespace value like xmlns:ds="" would produce an invalid XML document.
    if (!uri) return false;
    if (prefix === "xml" && uri === $22a89a9d1d5ce29e$var$NAMESPACE.XML || uri === $22a89a9d1d5ce29e$var$NAMESPACE.XMLNS) return false;
    var i = visibleNamespaces.length;
    while(i--){
        var ns = visibleNamespaces[i];
        // get namespace prefix
        if (ns.prefix === prefix) return ns.namespace !== uri;
    }
    return true;
}
/**
 * Well-formed constraint: No < in Attribute Values
 * > The replacement text of any entity referred to directly or indirectly
 * > in an attribute value must not contain a <.
 * @see https://www.w3.org/TR/xml11/#CleanAttrVals
 * @see https://www.w3.org/TR/xml11/#NT-AttValue
 *
 * Literal whitespace other than space that appear in attribute values
 * are serialized as their entity references, so they will be preserved.
 * (In contrast to whitespace literals in the input which are normalized to spaces)
 * @see https://www.w3.org/TR/xml11/#AVNormalize
 * @see https://w3c.github.io/DOM-Parsing/#serializing-an-element-s-attributes
 */ function $22a89a9d1d5ce29e$var$addSerializedAttribute(buf, qualifiedName, value) {
    buf.push(" ", qualifiedName, '="', value.replace(/[<>&"\t\n\r]/g, $22a89a9d1d5ce29e$var$_xmlEncoder), '"');
}
function $22a89a9d1d5ce29e$var$serializeToString(node, buf, isHTML, nodeFilter, visibleNamespaces) {
    if (!visibleNamespaces) visibleNamespaces = [];
    if (nodeFilter) {
        node = nodeFilter(node);
        if (node) {
            if (typeof node == "string") {
                buf.push(node);
                return;
            }
        } else return;
    //buf.sort.apply(attrs, attributeSorter);
    }
    switch(node.nodeType){
        case $22a89a9d1d5ce29e$var$ELEMENT_NODE:
            var attrs = node.attributes;
            var len = attrs.length;
            var child = node.firstChild;
            var nodeName = node.tagName;
            isHTML = $22a89a9d1d5ce29e$var$NAMESPACE.isHTML(node.namespaceURI) || isHTML;
            var prefixedNodeName = nodeName;
            if (!isHTML && !node.prefix && node.namespaceURI) {
                var defaultNS;
                // lookup current default ns from `xmlns` attribute
                for(var ai = 0; ai < attrs.length; ai++)if (attrs.item(ai).name === "xmlns") {
                    defaultNS = attrs.item(ai).value;
                    break;
                }
                if (!defaultNS) // lookup current default ns in visibleNamespaces
                for(var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--){
                    var namespace = visibleNamespaces[nsi];
                    if (namespace.prefix === "" && namespace.namespace === node.namespaceURI) {
                        defaultNS = namespace.namespace;
                        break;
                    }
                }
                if (defaultNS !== node.namespaceURI) for(var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--){
                    var namespace = visibleNamespaces[nsi];
                    if (namespace.namespace === node.namespaceURI) {
                        if (namespace.prefix) prefixedNodeName = namespace.prefix + ":" + nodeName;
                        break;
                    }
                }
            }
            buf.push("<", prefixedNodeName);
            for(var i = 0; i < len; i++){
                // add namespaces for attributes
                var attr = attrs.item(i);
                if (attr.prefix == "xmlns") visibleNamespaces.push({
                    prefix: attr.localName,
                    namespace: attr.value
                });
                else if (attr.nodeName == "xmlns") visibleNamespaces.push({
                    prefix: "",
                    namespace: attr.value
                });
            }
            for(var i = 0; i < len; i++){
                var attr = attrs.item(i);
                if ($22a89a9d1d5ce29e$var$needNamespaceDefine(attr, isHTML, visibleNamespaces)) {
                    var prefix = attr.prefix || "";
                    var uri = attr.namespaceURI;
                    $22a89a9d1d5ce29e$var$addSerializedAttribute(buf, prefix ? "xmlns:" + prefix : "xmlns", uri);
                    visibleNamespaces.push({
                        prefix: prefix,
                        namespace: uri
                    });
                }
                $22a89a9d1d5ce29e$var$serializeToString(attr, buf, isHTML, nodeFilter, visibleNamespaces);
            }
            // add namespace for current node
            if (nodeName === prefixedNodeName && $22a89a9d1d5ce29e$var$needNamespaceDefine(node, isHTML, visibleNamespaces)) {
                var prefix = node.prefix || "";
                var uri = node.namespaceURI;
                $22a89a9d1d5ce29e$var$addSerializedAttribute(buf, prefix ? "xmlns:" + prefix : "xmlns", uri);
                visibleNamespaces.push({
                    prefix: prefix,
                    namespace: uri
                });
            }
            if (child || isHTML && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)) {
                buf.push(">");
                //if is cdata child node
                if (isHTML && /^script$/i.test(nodeName)) while(child){
                    if (child.data) buf.push(child.data);
                    else $22a89a9d1d5ce29e$var$serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
                    child = child.nextSibling;
                }
                else while(child){
                    $22a89a9d1d5ce29e$var$serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
                    child = child.nextSibling;
                }
                buf.push("</", prefixedNodeName, ">");
            } else buf.push("/>");
            // remove added visible namespaces
            //visibleNamespaces.length = startVisibleNamespaces;
            return;
        case $22a89a9d1d5ce29e$var$DOCUMENT_NODE:
        case $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE:
            var child = node.firstChild;
            while(child){
                $22a89a9d1d5ce29e$var$serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
                child = child.nextSibling;
            }
            return;
        case $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE:
            return $22a89a9d1d5ce29e$var$addSerializedAttribute(buf, node.name, node.value);
        case $22a89a9d1d5ce29e$var$TEXT_NODE:
            /**
		 * The ampersand character (&) and the left angle bracket (<) must not appear in their literal form,
		 * except when used as markup delimiters, or within a comment, a processing instruction, or a CDATA section.
		 * If they are needed elsewhere, they must be escaped using either numeric character references or the strings
		 * `&amp;` and `&lt;` respectively.
		 * The right angle bracket (>) may be represented using the string " &gt; ", and must, for compatibility,
		 * be escaped using either `&gt;` or a character reference when it appears in the string `]]>` in content,
		 * when that string is not marking the end of a CDATA section.
		 *
		 * In the content of elements, character data is any string of characters
		 * which does not contain the start-delimiter of any markup
		 * and does not include the CDATA-section-close delimiter, `]]>`.
		 *
		 * @see https://www.w3.org/TR/xml/#NT-CharData
		 * @see https://w3c.github.io/DOM-Parsing/#xml-serializing-a-text-node
		 */ return buf.push(node.data.replace(/[<&>]/g, $22a89a9d1d5ce29e$var$_xmlEncoder));
        case $22a89a9d1d5ce29e$var$CDATA_SECTION_NODE:
            return buf.push("<![CDATA[", node.data, "]]>");
        case $22a89a9d1d5ce29e$var$COMMENT_NODE:
            return buf.push("<!--", node.data, "-->");
        case $22a89a9d1d5ce29e$var$DOCUMENT_TYPE_NODE:
            var pubid = node.publicId;
            var sysid = node.systemId;
            buf.push("<!DOCTYPE ", node.name);
            if (pubid) {
                buf.push(" PUBLIC ", pubid);
                if (sysid && sysid != ".") buf.push(" ", sysid);
                buf.push(">");
            } else if (sysid && sysid != ".") buf.push(" SYSTEM ", sysid, ">");
            else {
                var sub = node.internalSubset;
                if (sub) buf.push(" [", sub, "]");
                buf.push(">");
            }
            return;
        case $22a89a9d1d5ce29e$var$PROCESSING_INSTRUCTION_NODE:
            return buf.push("<?", node.target, " ", node.data, "?>");
        case $22a89a9d1d5ce29e$var$ENTITY_REFERENCE_NODE:
            return buf.push("&", node.nodeName, ";");
        //case ENTITY_NODE:
        //case NOTATION_NODE:
        default:
            buf.push("??", node.nodeName);
    }
}
function $22a89a9d1d5ce29e$var$importNode(doc, node, deep) {
    var node2;
    switch(node.nodeType){
        case $22a89a9d1d5ce29e$var$ELEMENT_NODE:
            node2 = node.cloneNode(false);
            node2.ownerDocument = doc;
        //var attrs = node2.attributes;
        //var len = attrs.length;
        //for(var i=0;i<len;i++){
        //node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
        //}
        case $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE:
            break;
        case $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE:
            deep = true;
            break;
    }
    if (!node2) node2 = node.cloneNode(false); //false
    node2.ownerDocument = doc;
    node2.parentNode = null;
    if (deep) {
        var child = node.firstChild;
        while(child){
            node2.appendChild($22a89a9d1d5ce29e$var$importNode(doc, child, deep));
            child = child.nextSibling;
        }
    }
    return node2;
}
//
//var _relationMap = {firstChild:1,lastChild:1,previousSibling:1,nextSibling:1,
//					attributes:1,childNodes:1,parentNode:1,documentElement:1,doctype,};
function $22a89a9d1d5ce29e$var$cloneNode(doc, node, deep) {
    var node2 = new node.constructor();
    for(var n in node)if (Object.prototype.hasOwnProperty.call(node, n)) {
        var v = node[n];
        if (typeof v != "object") {
            if (v != node2[n]) node2[n] = v;
        }
    }
    if (node.childNodes) node2.childNodes = new $22a89a9d1d5ce29e$var$NodeList();
    node2.ownerDocument = doc;
    switch(node2.nodeType){
        case $22a89a9d1d5ce29e$var$ELEMENT_NODE:
            var attrs = node.attributes;
            var attrs2 = node2.attributes = new $22a89a9d1d5ce29e$var$NamedNodeMap();
            var len = attrs.length;
            attrs2._ownerElement = node2;
            for(var i = 0; i < len; i++)node2.setAttributeNode($22a89a9d1d5ce29e$var$cloneNode(doc, attrs.item(i), true));
            break;
        case $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE:
            deep = true;
    }
    if (deep) {
        var child = node.firstChild;
        while(child){
            node2.appendChild($22a89a9d1d5ce29e$var$cloneNode(doc, child, deep));
            child = child.nextSibling;
        }
    }
    return node2;
}
function $22a89a9d1d5ce29e$var$__set__(object, key, value) {
    object[key] = value;
}
//do dynamic
try {
    if (Object.defineProperty) {
        Object.defineProperty($22a89a9d1d5ce29e$var$LiveNodeList.prototype, "length", {
            get: function() {
                $22a89a9d1d5ce29e$var$_updateLiveList(this);
                return this.$$length;
            }
        });
        Object.defineProperty($22a89a9d1d5ce29e$var$Node.prototype, "textContent", {
            get: function() {
                return getTextContent(this);
            },
            set: function(data) {
                switch(this.nodeType){
                    case $22a89a9d1d5ce29e$var$ELEMENT_NODE:
                    case $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE:
                        while(this.firstChild)this.removeChild(this.firstChild);
                        if (data || String(data)) this.appendChild(this.ownerDocument.createTextNode(data));
                        break;
                    default:
                        this.data = data;
                        this.value = data;
                        this.nodeValue = data;
                }
            }
        });
        function getTextContent(node) {
            switch(node.nodeType){
                case $22a89a9d1d5ce29e$var$ELEMENT_NODE:
                case $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE:
                    var buf = [];
                    node = node.firstChild;
                    while(node){
                        if (node.nodeType !== 7 && node.nodeType !== 8) buf.push(getTextContent(node));
                        node = node.nextSibling;
                    }
                    return buf.join("");
                default:
                    return node.nodeValue;
            }
        }
        $22a89a9d1d5ce29e$var$__set__ = function(object, key, value) {
            //console.log(value)
            object["$$" + key] = value;
        };
    }
} catch (e) {}
$22a89a9d1d5ce29e$export$d1d99cf900472499 = $22a89a9d1d5ce29e$var$DocumentType;
$22a89a9d1d5ce29e$export$fe58bcf938607f6a = $22a89a9d1d5ce29e$var$DOMException;
$22a89a9d1d5ce29e$export$455426655eab1d48 = $22a89a9d1d5ce29e$var$DOMImplementation;
$22a89a9d1d5ce29e$export$db77ccec0bb4ccac = $22a89a9d1d5ce29e$var$Element;
$22a89a9d1d5ce29e$export$85c928794f8d04d4 = $22a89a9d1d5ce29e$var$Node;
$22a89a9d1d5ce29e$export$79b41aa5d56abdff = $22a89a9d1d5ce29e$var$NodeList;
$22a89a9d1d5ce29e$export$64f0bed4ae6f0f24 = $22a89a9d1d5ce29e$var$XMLSerializer; //}

});
parcelRegister("hkG9E", function(module, exports) {

$parcel$export(module.exports, "find", () => $c9e500f3e8ddaab6$export$71aa6c912b956294, (v) => $c9e500f3e8ddaab6$export$71aa6c912b956294 = v);
$parcel$export(module.exports, "freeze", () => $c9e500f3e8ddaab6$export$792f3d81ea979f55, (v) => $c9e500f3e8ddaab6$export$792f3d81ea979f55 = v);
$parcel$export(module.exports, "NAMESPACE", () => $c9e500f3e8ddaab6$export$6aad947bda0f3f46, (v) => $c9e500f3e8ddaab6$export$6aad947bda0f3f46 = v);
var $c9e500f3e8ddaab6$export$e6e34fd1f2686227;
var $c9e500f3e8ddaab6$export$71aa6c912b956294;
var $c9e500f3e8ddaab6$export$792f3d81ea979f55;
var $c9e500f3e8ddaab6$export$c6cb9dd1e3ada1aa;
var $c9e500f3e8ddaab6$export$6aad947bda0f3f46;
"use strict";
/**
 * Ponyfill for `Array.prototype.find` which is only available in ES6 runtimes.
 *
 * Works with anything that has a `length` property and index access properties, including NodeList.
 *
 * @template {unknown} T
 * @param {Array<T> | ({length:number, [number]: T})} list
 * @param {function (item: T, index: number, list:Array<T> | ({length:number, [number]: T})):boolean} predicate
 * @param {Partial<Pick<ArrayConstructor['prototype'], 'find'>>?} ac `Array.prototype` by default,
 * 				allows injecting a custom implementation in tests
 * @returns {T | undefined}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
 * @see https://tc39.es/ecma262/multipage/indexed-collections.html#sec-array.prototype.find
 */ function $c9e500f3e8ddaab6$var$find(list, predicate, ac) {
    if (ac === undefined) ac = Array.prototype;
    if (list && typeof ac.find === "function") return ac.find.call(list, predicate);
    for(var i = 0; i < list.length; i++)if (Object.prototype.hasOwnProperty.call(list, i)) {
        var item = list[i];
        if (predicate.call(undefined, item, i, list)) return item;
    }
}
/**
 * "Shallow freezes" an object to render it immutable.
 * Uses `Object.freeze` if available,
 * otherwise the immutability is only in the type.
 *
 * Is used to create "enum like" objects.
 *
 * @template T
 * @param {T} object the object to freeze
 * @param {Pick<ObjectConstructor, 'freeze'> = Object} oc `Object` by default,
 * 				allows to inject custom object constructor for tests
 * @returns {Readonly<T>}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
 */ function $c9e500f3e8ddaab6$var$freeze(object, oc) {
    if (oc === undefined) oc = Object;
    return oc && typeof oc.freeze === "function" ? oc.freeze(object) : object;
}
/**
 * Since we can not rely on `Object.assign` we provide a simplified version
 * that is sufficient for our needs.
 *
 * @param {Object} target
 * @param {Object | null | undefined} source
 *
 * @returns {Object} target
 * @throws TypeError if target is not an object
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 * @see https://tc39.es/ecma262/multipage/fundamental-objects.html#sec-object.assign
 */ function $c9e500f3e8ddaab6$var$assign(target, source) {
    if (target === null || typeof target !== "object") throw new TypeError("target is not an object");
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    return target;
}
/**
 * All mime types that are allowed as input to `DOMParser.parseFromString`
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString#Argument02 MDN
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#domparsersupportedtype WHATWG HTML Spec
 * @see DOMParser.prototype.parseFromString
 */ var $c9e500f3e8ddaab6$var$MIME_TYPE = $c9e500f3e8ddaab6$var$freeze({
    /**
	 * `text/html`, the only mime type that triggers treating an XML document as HTML.
	 *
	 * @see DOMParser.SupportedType.isHTML
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
	 */ HTML: "text/html",
    /**
	 * Helper method to check a mime type if it indicates an HTML document
	 *
	 * @param {string} [value]
	 * @returns {boolean}
	 *
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */ isHTML: function(value) {
        return value === $c9e500f3e8ddaab6$var$MIME_TYPE.HTML;
    },
    /**
	 * `application/xml`, the standard mime type for XML documents.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
	 * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */ XML_APPLICATION: "application/xml",
    /**
	 * `text/html`, an alias for `application/xml`.
	 *
	 * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
	 * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */ XML_TEXT: "text/xml",
    /**
	 * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
	 * but is parsed as an XML document.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
	 * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
	 */ XML_XHTML_APPLICATION: "application/xhtml+xml",
    /**
	 * `image/svg+xml`,
	 *
	 * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
	 * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
	 * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
	 */ XML_SVG_IMAGE: "image/svg+xml"
});
/**
 * Namespaces that are used in this code base.
 *
 * @see http://www.w3.org/TR/REC-xml-names
 */ var $c9e500f3e8ddaab6$var$NAMESPACE = $c9e500f3e8ddaab6$var$freeze({
    /**
	 * The XHTML namespace.
	 *
	 * @see http://www.w3.org/1999/xhtml
	 */ HTML: "http://www.w3.org/1999/xhtml",
    /**
	 * Checks if `uri` equals `NAMESPACE.HTML`.
	 *
	 * @param {string} [uri]
	 *
	 * @see NAMESPACE.HTML
	 */ isHTML: function(uri) {
        return uri === $c9e500f3e8ddaab6$var$NAMESPACE.HTML;
    },
    /**
	 * The SVG namespace.
	 *
	 * @see http://www.w3.org/2000/svg
	 */ SVG: "http://www.w3.org/2000/svg",
    /**
	 * The `xml:` namespace.
	 *
	 * @see http://www.w3.org/XML/1998/namespace
	 */ XML: "http://www.w3.org/XML/1998/namespace",
    /**
	 * The `xmlns:` namespace
	 *
	 * @see https://www.w3.org/2000/xmlns/
	 */ XMLNS: "http://www.w3.org/2000/xmlns/"
});
$c9e500f3e8ddaab6$export$e6e34fd1f2686227 = $c9e500f3e8ddaab6$var$assign;
$c9e500f3e8ddaab6$export$71aa6c912b956294 = $c9e500f3e8ddaab6$var$find;
$c9e500f3e8ddaab6$export$792f3d81ea979f55 = $c9e500f3e8ddaab6$var$freeze;
$c9e500f3e8ddaab6$export$c6cb9dd1e3ada1aa = $c9e500f3e8ddaab6$var$MIME_TYPE;
$c9e500f3e8ddaab6$export$6aad947bda0f3f46 = $c9e500f3e8ddaab6$var$NAMESPACE;

});


parcelRegister("c1Wy2", function(module, exports) {

$parcel$export(module.exports, "DOMParser", () => $8c22fe72d8589809$export$1059c6e7d2ce5669, (v) => $8c22fe72d8589809$export$1059c6e7d2ce5669 = v);
var $8c22fe72d8589809$export$181392475aa39887;
var $8c22fe72d8589809$export$ba13e0e2f19e61a1;
var $8c22fe72d8589809$export$1059c6e7d2ce5669;

var $hkG9E = parcelRequire("hkG9E");

var $2YubT = parcelRequire("2YubT");

var $2NAtx = parcelRequire("2NAtx");

var $1fO4L = parcelRequire("1fO4L");
var $8c22fe72d8589809$var$DOMImplementation = $2YubT.DOMImplementation;
var $8c22fe72d8589809$var$NAMESPACE = $hkG9E.NAMESPACE;
var $8c22fe72d8589809$var$ParseError = $1fO4L.ParseError;
var $8c22fe72d8589809$var$XMLReader = $1fO4L.XMLReader;
/**
 * Normalizes line ending according to https://www.w3.org/TR/xml11/#sec-line-ends:
 *
 * > XML parsed entities are often stored in computer files which,
 * > for editing convenience, are organized into lines.
 * > These lines are typically separated by some combination
 * > of the characters CARRIAGE RETURN (#xD) and LINE FEED (#xA).
 * >
 * > To simplify the tasks of applications, the XML processor must behave
 * > as if it normalized all line breaks in external parsed entities (including the document entity)
 * > on input, before parsing, by translating all of the following to a single #xA character:
 * >
 * > 1. the two-character sequence #xD #xA
 * > 2. the two-character sequence #xD #x85
 * > 3. the single character #x85
 * > 4. the single character #x2028
 * > 5. any #xD character that is not immediately followed by #xA or #x85.
 *
 * @param {string} input
 * @returns {string}
 */ function $8c22fe72d8589809$var$normalizeLineEndings(input) {
    return input.replace(/\r[\n\u0085]/g, "\n").replace(/[\r\u0085\u2028]/g, "\n");
}
/**
 * @typedef Locator
 * @property {number} [columnNumber]
 * @property {number} [lineNumber]
 */ /**
 * @typedef DOMParserOptions
 * @property {DOMHandler} [domBuilder]
 * @property {Function} [errorHandler]
 * @property {(string) => string} [normalizeLineEndings] used to replace line endings before parsing
 * 						defaults to `normalizeLineEndings`
 * @property {Locator} [locator]
 * @property {Record<string, string>} [xmlns]
 *
 * @see normalizeLineEndings
 */ /**
 * The DOMParser interface provides the ability to parse XML or HTML source code
 * from a string into a DOM `Document`.
 *
 * _xmldom is different from the spec in that it allows an `options` parameter,
 * to override the default behavior._
 *
 * @param {DOMParserOptions} [options]
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-parsing-and-serialization
 */ function $8c22fe72d8589809$var$DOMParser(options) {
    this.options = options || {
        locator: {}
    };
}
$8c22fe72d8589809$var$DOMParser.prototype.parseFromString = function(source, mimeType) {
    var options = this.options;
    var sax = new $8c22fe72d8589809$var$XMLReader();
    var domBuilder = options.domBuilder || new $8c22fe72d8589809$var$DOMHandler(); //contentHandler and LexicalHandler
    var errorHandler = options.errorHandler;
    var locator = options.locator;
    var defaultNSMap = options.xmlns || {};
    var isHTML = /\/x?html?$/.test(mimeType); //mimeType.toLowerCase().indexOf('html') > -1;
    var entityMap = isHTML ? $2NAtx.HTML_ENTITIES : $2NAtx.XML_ENTITIES;
    if (locator) domBuilder.setDocumentLocator(locator);
    sax.errorHandler = $8c22fe72d8589809$var$buildErrorHandler(errorHandler, domBuilder, locator);
    sax.domBuilder = options.domBuilder || domBuilder;
    if (isHTML) defaultNSMap[""] = $8c22fe72d8589809$var$NAMESPACE.HTML;
    defaultNSMap.xml = defaultNSMap.xml || $8c22fe72d8589809$var$NAMESPACE.XML;
    var normalize = options.normalizeLineEndings || $8c22fe72d8589809$var$normalizeLineEndings;
    if (source && typeof source === "string") sax.parse(normalize(source), defaultNSMap, entityMap);
    else sax.errorHandler.error("invalid doc source");
    return domBuilder.doc;
};
function $8c22fe72d8589809$var$buildErrorHandler(errorImpl, domBuilder, locator) {
    if (!errorImpl) {
        if (domBuilder instanceof $8c22fe72d8589809$var$DOMHandler) return domBuilder;
        errorImpl = domBuilder;
    }
    var errorHandler = {};
    var isCallback = errorImpl instanceof Function;
    locator = locator || {};
    function build(key) {
        var fn = errorImpl[key];
        if (!fn && isCallback) fn = errorImpl.length == 2 ? function(msg) {
            errorImpl(key, msg);
        } : errorImpl;
        errorHandler[key] = fn && function(msg) {
            fn("[xmldom " + key + "]	" + msg + $8c22fe72d8589809$var$_locator(locator));
        } || function() {};
    }
    build("warning");
    build("error");
    build("fatalError");
    return errorHandler;
}
//console.log('#\n\n\n\n\n\n\n####')
/**
 * +ContentHandler+ErrorHandler
 * +LexicalHandler+EntityResolver2
 * -DeclHandler-DTDHandler
 *
 * DefaultHandler:EntityResolver, DTDHandler, ContentHandler, ErrorHandler
 * DefaultHandler2:DefaultHandler,LexicalHandler, DeclHandler, EntityResolver2
 * @link http://www.saxproject.org/apidoc/org/xml/sax/helpers/DefaultHandler.html
 */ function $8c22fe72d8589809$var$DOMHandler() {
    this.cdata = false;
}
function $8c22fe72d8589809$var$position(locator, node) {
    node.lineNumber = locator.lineNumber;
    node.columnNumber = locator.columnNumber;
}
/**
 * @see org.xml.sax.ContentHandler#startDocument
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
 */ $8c22fe72d8589809$var$DOMHandler.prototype = {
    startDocument: function() {
        this.doc = new $8c22fe72d8589809$var$DOMImplementation().createDocument(null, null, null);
        if (this.locator) this.doc.documentURI = this.locator.systemId;
    },
    startElement: function(namespaceURI, localName, qName, attrs) {
        var doc = this.doc;
        var el = doc.createElementNS(namespaceURI, qName || localName);
        var len = attrs.length;
        $8c22fe72d8589809$var$appendElement(this, el);
        this.currentElement = el;
        this.locator && $8c22fe72d8589809$var$position(this.locator, el);
        for(var i = 0; i < len; i++){
            var namespaceURI = attrs.getURI(i);
            var value = attrs.getValue(i);
            var qName = attrs.getQName(i);
            var attr = doc.createAttributeNS(namespaceURI, qName);
            this.locator && $8c22fe72d8589809$var$position(attrs.getLocator(i), attr);
            attr.value = attr.nodeValue = value;
            el.setAttributeNode(attr);
        }
    },
    endElement: function(namespaceURI, localName, qName) {
        var current = this.currentElement;
        var tagName = current.tagName;
        this.currentElement = current.parentNode;
    },
    startPrefixMapping: function(prefix, uri) {},
    endPrefixMapping: function(prefix) {},
    processingInstruction: function(target, data) {
        var ins = this.doc.createProcessingInstruction(target, data);
        this.locator && $8c22fe72d8589809$var$position(this.locator, ins);
        $8c22fe72d8589809$var$appendElement(this, ins);
    },
    ignorableWhitespace: function(ch, start, length) {},
    characters: function(chars, start, length) {
        chars = $8c22fe72d8589809$var$_toString.apply(this, arguments);
        //console.log(chars)
        if (chars) {
            if (this.cdata) var charNode = this.doc.createCDATASection(chars);
            else var charNode = this.doc.createTextNode(chars);
            if (this.currentElement) this.currentElement.appendChild(charNode);
            else if (/^\s*$/.test(chars)) this.doc.appendChild(charNode);
            this.locator && $8c22fe72d8589809$var$position(this.locator, charNode);
        }
    },
    skippedEntity: function(name) {},
    endDocument: function() {
        this.doc.normalize();
    },
    setDocumentLocator: function(locator) {
        if (this.locator = locator) locator.lineNumber = 0;
    },
    //LexicalHandler
    comment: function(chars, start, length) {
        chars = $8c22fe72d8589809$var$_toString.apply(this, arguments);
        var comm = this.doc.createComment(chars);
        this.locator && $8c22fe72d8589809$var$position(this.locator, comm);
        $8c22fe72d8589809$var$appendElement(this, comm);
    },
    startCDATA: function() {
        //used in characters() methods
        this.cdata = true;
    },
    endCDATA: function() {
        this.cdata = false;
    },
    startDTD: function(name, publicId, systemId) {
        var impl = this.doc.implementation;
        if (impl && impl.createDocumentType) {
            var dt = impl.createDocumentType(name, publicId, systemId);
            this.locator && $8c22fe72d8589809$var$position(this.locator, dt);
            $8c22fe72d8589809$var$appendElement(this, dt);
            this.doc.doctype = dt;
        }
    },
    /**
	 * @see org.xml.sax.ErrorHandler
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
	 */ warning: function(error) {
        console.warn("[xmldom warning]	" + error, $8c22fe72d8589809$var$_locator(this.locator));
    },
    error: function(error) {
        console.error("[xmldom error]	" + error, $8c22fe72d8589809$var$_locator(this.locator));
    },
    fatalError: function(error) {
        throw new $8c22fe72d8589809$var$ParseError(error, this.locator);
    }
};
function $8c22fe72d8589809$var$_locator(l) {
    if (l) return "\n@" + (l.systemId || "") + "#[line:" + l.lineNumber + ",col:" + l.columnNumber + "]";
}
function $8c22fe72d8589809$var$_toString(chars, start, length) {
    if (typeof chars == "string") return chars.substr(start, length);
    else {
        if (chars.length >= start + length || start) return new java.lang.String(chars, start, length) + "";
        return chars;
    }
}
/*
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/LexicalHandler.html
 * used method of org.xml.sax.ext.LexicalHandler:
 *  #comment(chars, start, length)
 *  #startCDATA()
 *  #endCDATA()
 *  #startDTD(name, publicId, systemId)
 *
 *
 * IGNORED method of org.xml.sax.ext.LexicalHandler:
 *  #endDTD()
 *  #startEntity(name)
 *  #endEntity(name)
 *
 *
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/DeclHandler.html
 * IGNORED method of org.xml.sax.ext.DeclHandler
 * 	#attributeDecl(eName, aName, type, mode, value)
 *  #elementDecl(name, model)
 *  #externalEntityDecl(name, publicId, systemId)
 *  #internalEntityDecl(name, value)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/EntityResolver2.html
 * IGNORED method of org.xml.sax.EntityResolver2
 *  #resolveEntity(String name,String publicId,String baseURI,String systemId)
 *  #resolveEntity(publicId, systemId)
 *  #getExternalSubset(name, baseURI)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/DTDHandler.html
 * IGNORED method of org.xml.sax.DTDHandler
 *  #notationDecl(name, publicId, systemId) {};
 *  #unparsedEntityDecl(name, publicId, systemId, notationName) {};
 */ "endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(key) {
    $8c22fe72d8589809$var$DOMHandler.prototype[key] = function() {
        return null;
    };
});
/* Private static helpers treated below as private instance methods, so don't need to add these to the public API; we might use a Relator to also get rid of non-standard public properties */ function $8c22fe72d8589809$var$appendElement(hander, node) {
    if (!hander.currentElement) hander.doc.appendChild(node);
    else hander.currentElement.appendChild(node);
} //appendChild and setAttributeNS are preformance key
$8c22fe72d8589809$export$181392475aa39887 = $8c22fe72d8589809$var$DOMHandler;
$8c22fe72d8589809$export$ba13e0e2f19e61a1 = $8c22fe72d8589809$var$normalizeLineEndings;
$8c22fe72d8589809$export$1059c6e7d2ce5669 = $8c22fe72d8589809$var$DOMParser;

});
parcelRegister("2NAtx", function(module, exports) {

$parcel$export(module.exports, "XML_ENTITIES", () => $209c739ee170ce7f$export$91f0e5ff03dc84f, (v) => $209c739ee170ce7f$export$91f0e5ff03dc84f = v);
$parcel$export(module.exports, "HTML_ENTITIES", () => $209c739ee170ce7f$export$b7e4d4631df36afa, (v) => $209c739ee170ce7f$export$b7e4d4631df36afa = v);
/**
 * The entities that are predefined in every XML document.
 *
 * @see https://www.w3.org/TR/2006/REC-xml11-20060816/#sec-predefined-ent W3C XML 1.1
 * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-predefined-ent W3C XML 1.0
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Predefined_entities_in_XML Wikipedia
 */ var $209c739ee170ce7f$export$91f0e5ff03dc84f;
/**
 * A map of all entities that are detected in an HTML document.
 * They contain all entries from `XML_ENTITIES`.
 *
 * @see XML_ENTITIES
 * @see DOMParser.parseFromString
 * @see DOMImplementation.prototype.createHTMLDocument
 * @see https://html.spec.whatwg.org/#named-character-references WHATWG HTML(5) Spec
 * @see https://html.spec.whatwg.org/entities.json JSON
 * @see https://www.w3.org/TR/xml-entity-names/ W3C XML Entity Names
 * @see https://www.w3.org/TR/html4/sgml/entities.html W3C HTML4/SGML
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Character_entity_references_in_HTML Wikipedia (HTML)
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Entities_representing_special_characters_in_XHTML Wikpedia (XHTML)
 */ var $209c739ee170ce7f$export$b7e4d4631df36afa;
/**
 * @deprecated use `HTML_ENTITIES` instead
 * @see HTML_ENTITIES
 */ var $209c739ee170ce7f$export$79451380caed3f98;
"use strict";

var $hkG9E = parcelRequire("hkG9E");
var $209c739ee170ce7f$require$freeze = $hkG9E.freeze;
$209c739ee170ce7f$export$91f0e5ff03dc84f = $209c739ee170ce7f$require$freeze({
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    quot: '"'
});
$209c739ee170ce7f$export$b7e4d4631df36afa = $209c739ee170ce7f$require$freeze({
    Aacute: "\xc1",
    aacute: "\xe1",
    Abreve: "\u0102",
    abreve: "\u0103",
    ac: "\u223E",
    acd: "\u223F",
    acE: "\u223E\u0333",
    Acirc: "\xc2",
    acirc: "\xe2",
    acute: "\xb4",
    Acy: "\u0410",
    acy: "\u0430",
    AElig: "\xc6",
    aelig: "\xe6",
    af: "\u2061",
    Afr: "\uD835\uDD04",
    afr: "\uD835\uDD1E",
    Agrave: "\xc0",
    agrave: "\xe0",
    alefsym: "\u2135",
    aleph: "\u2135",
    Alpha: "\u0391",
    alpha: "\u03B1",
    Amacr: "\u0100",
    amacr: "\u0101",
    amalg: "\u2A3F",
    AMP: "&",
    amp: "&",
    And: "\u2A53",
    and: "\u2227",
    andand: "\u2A55",
    andd: "\u2A5C",
    andslope: "\u2A58",
    andv: "\u2A5A",
    ang: "\u2220",
    ange: "\u29A4",
    angle: "\u2220",
    angmsd: "\u2221",
    angmsdaa: "\u29A8",
    angmsdab: "\u29A9",
    angmsdac: "\u29AA",
    angmsdad: "\u29AB",
    angmsdae: "\u29AC",
    angmsdaf: "\u29AD",
    angmsdag: "\u29AE",
    angmsdah: "\u29AF",
    angrt: "\u221F",
    angrtvb: "\u22BE",
    angrtvbd: "\u299D",
    angsph: "\u2222",
    angst: "\xc5",
    angzarr: "\u237C",
    Aogon: "\u0104",
    aogon: "\u0105",
    Aopf: "\uD835\uDD38",
    aopf: "\uD835\uDD52",
    ap: "\u2248",
    apacir: "\u2A6F",
    apE: "\u2A70",
    ape: "\u224A",
    apid: "\u224B",
    apos: "'",
    ApplyFunction: "\u2061",
    approx: "\u2248",
    approxeq: "\u224A",
    Aring: "\xc5",
    aring: "\xe5",
    Ascr: "\uD835\uDC9C",
    ascr: "\uD835\uDCB6",
    Assign: "\u2254",
    ast: "*",
    asymp: "\u2248",
    asympeq: "\u224D",
    Atilde: "\xc3",
    atilde: "\xe3",
    Auml: "\xc4",
    auml: "\xe4",
    awconint: "\u2233",
    awint: "\u2A11",
    backcong: "\u224C",
    backepsilon: "\u03F6",
    backprime: "\u2035",
    backsim: "\u223D",
    backsimeq: "\u22CD",
    Backslash: "\u2216",
    Barv: "\u2AE7",
    barvee: "\u22BD",
    Barwed: "\u2306",
    barwed: "\u2305",
    barwedge: "\u2305",
    bbrk: "\u23B5",
    bbrktbrk: "\u23B6",
    bcong: "\u224C",
    Bcy: "\u0411",
    bcy: "\u0431",
    bdquo: "\u201E",
    becaus: "\u2235",
    Because: "\u2235",
    because: "\u2235",
    bemptyv: "\u29B0",
    bepsi: "\u03F6",
    bernou: "\u212C",
    Bernoullis: "\u212C",
    Beta: "\u0392",
    beta: "\u03B2",
    beth: "\u2136",
    between: "\u226C",
    Bfr: "\uD835\uDD05",
    bfr: "\uD835\uDD1F",
    bigcap: "\u22C2",
    bigcirc: "\u25EF",
    bigcup: "\u22C3",
    bigodot: "\u2A00",
    bigoplus: "\u2A01",
    bigotimes: "\u2A02",
    bigsqcup: "\u2A06",
    bigstar: "\u2605",
    bigtriangledown: "\u25BD",
    bigtriangleup: "\u25B3",
    biguplus: "\u2A04",
    bigvee: "\u22C1",
    bigwedge: "\u22C0",
    bkarow: "\u290D",
    blacklozenge: "\u29EB",
    blacksquare: "\u25AA",
    blacktriangle: "\u25B4",
    blacktriangledown: "\u25BE",
    blacktriangleleft: "\u25C2",
    blacktriangleright: "\u25B8",
    blank: "\u2423",
    blk12: "\u2592",
    blk14: "\u2591",
    blk34: "\u2593",
    block: "\u2588",
    bne: "=\u20E5",
    bnequiv: "\u2261\u20E5",
    bNot: "\u2AED",
    bnot: "\u2310",
    Bopf: "\uD835\uDD39",
    bopf: "\uD835\uDD53",
    bot: "\u22A5",
    bottom: "\u22A5",
    bowtie: "\u22C8",
    boxbox: "\u29C9",
    boxDL: "\u2557",
    boxDl: "\u2556",
    boxdL: "\u2555",
    boxdl: "\u2510",
    boxDR: "\u2554",
    boxDr: "\u2553",
    boxdR: "\u2552",
    boxdr: "\u250C",
    boxH: "\u2550",
    boxh: "\u2500",
    boxHD: "\u2566",
    boxHd: "\u2564",
    boxhD: "\u2565",
    boxhd: "\u252C",
    boxHU: "\u2569",
    boxHu: "\u2567",
    boxhU: "\u2568",
    boxhu: "\u2534",
    boxminus: "\u229F",
    boxplus: "\u229E",
    boxtimes: "\u22A0",
    boxUL: "\u255D",
    boxUl: "\u255C",
    boxuL: "\u255B",
    boxul: "\u2518",
    boxUR: "\u255A",
    boxUr: "\u2559",
    boxuR: "\u2558",
    boxur: "\u2514",
    boxV: "\u2551",
    boxv: "\u2502",
    boxVH: "\u256C",
    boxVh: "\u256B",
    boxvH: "\u256A",
    boxvh: "\u253C",
    boxVL: "\u2563",
    boxVl: "\u2562",
    boxvL: "\u2561",
    boxvl: "\u2524",
    boxVR: "\u2560",
    boxVr: "\u255F",
    boxvR: "\u255E",
    boxvr: "\u251C",
    bprime: "\u2035",
    Breve: "\u02D8",
    breve: "\u02D8",
    brvbar: "\xa6",
    Bscr: "\u212C",
    bscr: "\uD835\uDCB7",
    bsemi: "\u204F",
    bsim: "\u223D",
    bsime: "\u22CD",
    bsol: "\\",
    bsolb: "\u29C5",
    bsolhsub: "\u27C8",
    bull: "\u2022",
    bullet: "\u2022",
    bump: "\u224E",
    bumpE: "\u2AAE",
    bumpe: "\u224F",
    Bumpeq: "\u224E",
    bumpeq: "\u224F",
    Cacute: "\u0106",
    cacute: "\u0107",
    Cap: "\u22D2",
    cap: "\u2229",
    capand: "\u2A44",
    capbrcup: "\u2A49",
    capcap: "\u2A4B",
    capcup: "\u2A47",
    capdot: "\u2A40",
    CapitalDifferentialD: "\u2145",
    caps: "\u2229\uFE00",
    caret: "\u2041",
    caron: "\u02C7",
    Cayleys: "\u212D",
    ccaps: "\u2A4D",
    Ccaron: "\u010C",
    ccaron: "\u010D",
    Ccedil: "\xc7",
    ccedil: "\xe7",
    Ccirc: "\u0108",
    ccirc: "\u0109",
    Cconint: "\u2230",
    ccups: "\u2A4C",
    ccupssm: "\u2A50",
    Cdot: "\u010A",
    cdot: "\u010B",
    cedil: "\xb8",
    Cedilla: "\xb8",
    cemptyv: "\u29B2",
    cent: "\xa2",
    CenterDot: "\xb7",
    centerdot: "\xb7",
    Cfr: "\u212D",
    cfr: "\uD835\uDD20",
    CHcy: "\u0427",
    chcy: "\u0447",
    check: "\u2713",
    checkmark: "\u2713",
    Chi: "\u03A7",
    chi: "\u03C7",
    cir: "\u25CB",
    circ: "\u02C6",
    circeq: "\u2257",
    circlearrowleft: "\u21BA",
    circlearrowright: "\u21BB",
    circledast: "\u229B",
    circledcirc: "\u229A",
    circleddash: "\u229D",
    CircleDot: "\u2299",
    circledR: "\xae",
    circledS: "\u24C8",
    CircleMinus: "\u2296",
    CirclePlus: "\u2295",
    CircleTimes: "\u2297",
    cirE: "\u29C3",
    cire: "\u2257",
    cirfnint: "\u2A10",
    cirmid: "\u2AEF",
    cirscir: "\u29C2",
    ClockwiseContourIntegral: "\u2232",
    CloseCurlyDoubleQuote: "\u201D",
    CloseCurlyQuote: "\u2019",
    clubs: "\u2663",
    clubsuit: "\u2663",
    Colon: "\u2237",
    colon: ":",
    Colone: "\u2A74",
    colone: "\u2254",
    coloneq: "\u2254",
    comma: ",",
    commat: "@",
    comp: "\u2201",
    compfn: "\u2218",
    complement: "\u2201",
    complexes: "\u2102",
    cong: "\u2245",
    congdot: "\u2A6D",
    Congruent: "\u2261",
    Conint: "\u222F",
    conint: "\u222E",
    ContourIntegral: "\u222E",
    Copf: "\u2102",
    copf: "\uD835\uDD54",
    coprod: "\u2210",
    Coproduct: "\u2210",
    COPY: "\xa9",
    copy: "\xa9",
    copysr: "\u2117",
    CounterClockwiseContourIntegral: "\u2233",
    crarr: "\u21B5",
    Cross: "\u2A2F",
    cross: "\u2717",
    Cscr: "\uD835\uDC9E",
    cscr: "\uD835\uDCB8",
    csub: "\u2ACF",
    csube: "\u2AD1",
    csup: "\u2AD0",
    csupe: "\u2AD2",
    ctdot: "\u22EF",
    cudarrl: "\u2938",
    cudarrr: "\u2935",
    cuepr: "\u22DE",
    cuesc: "\u22DF",
    cularr: "\u21B6",
    cularrp: "\u293D",
    Cup: "\u22D3",
    cup: "\u222A",
    cupbrcap: "\u2A48",
    CupCap: "\u224D",
    cupcap: "\u2A46",
    cupcup: "\u2A4A",
    cupdot: "\u228D",
    cupor: "\u2A45",
    cups: "\u222A\uFE00",
    curarr: "\u21B7",
    curarrm: "\u293C",
    curlyeqprec: "\u22DE",
    curlyeqsucc: "\u22DF",
    curlyvee: "\u22CE",
    curlywedge: "\u22CF",
    curren: "\xa4",
    curvearrowleft: "\u21B6",
    curvearrowright: "\u21B7",
    cuvee: "\u22CE",
    cuwed: "\u22CF",
    cwconint: "\u2232",
    cwint: "\u2231",
    cylcty: "\u232D",
    Dagger: "\u2021",
    dagger: "\u2020",
    daleth: "\u2138",
    Darr: "\u21A1",
    dArr: "\u21D3",
    darr: "\u2193",
    dash: "\u2010",
    Dashv: "\u2AE4",
    dashv: "\u22A3",
    dbkarow: "\u290F",
    dblac: "\u02DD",
    Dcaron: "\u010E",
    dcaron: "\u010F",
    Dcy: "\u0414",
    dcy: "\u0434",
    DD: "\u2145",
    dd: "\u2146",
    ddagger: "\u2021",
    ddarr: "\u21CA",
    DDotrahd: "\u2911",
    ddotseq: "\u2A77",
    deg: "\xb0",
    Del: "\u2207",
    Delta: "\u0394",
    delta: "\u03B4",
    demptyv: "\u29B1",
    dfisht: "\u297F",
    Dfr: "\uD835\uDD07",
    dfr: "\uD835\uDD21",
    dHar: "\u2965",
    dharl: "\u21C3",
    dharr: "\u21C2",
    DiacriticalAcute: "\xb4",
    DiacriticalDot: "\u02D9",
    DiacriticalDoubleAcute: "\u02DD",
    DiacriticalGrave: "`",
    DiacriticalTilde: "\u02DC",
    diam: "\u22C4",
    Diamond: "\u22C4",
    diamond: "\u22C4",
    diamondsuit: "\u2666",
    diams: "\u2666",
    die: "\xa8",
    DifferentialD: "\u2146",
    digamma: "\u03DD",
    disin: "\u22F2",
    div: "\xf7",
    divide: "\xf7",
    divideontimes: "\u22C7",
    divonx: "\u22C7",
    DJcy: "\u0402",
    djcy: "\u0452",
    dlcorn: "\u231E",
    dlcrop: "\u230D",
    dollar: "$",
    Dopf: "\uD835\uDD3B",
    dopf: "\uD835\uDD55",
    Dot: "\xa8",
    dot: "\u02D9",
    DotDot: "\u20DC",
    doteq: "\u2250",
    doteqdot: "\u2251",
    DotEqual: "\u2250",
    dotminus: "\u2238",
    dotplus: "\u2214",
    dotsquare: "\u22A1",
    doublebarwedge: "\u2306",
    DoubleContourIntegral: "\u222F",
    DoubleDot: "\xa8",
    DoubleDownArrow: "\u21D3",
    DoubleLeftArrow: "\u21D0",
    DoubleLeftRightArrow: "\u21D4",
    DoubleLeftTee: "\u2AE4",
    DoubleLongLeftArrow: "\u27F8",
    DoubleLongLeftRightArrow: "\u27FA",
    DoubleLongRightArrow: "\u27F9",
    DoubleRightArrow: "\u21D2",
    DoubleRightTee: "\u22A8",
    DoubleUpArrow: "\u21D1",
    DoubleUpDownArrow: "\u21D5",
    DoubleVerticalBar: "\u2225",
    DownArrow: "\u2193",
    Downarrow: "\u21D3",
    downarrow: "\u2193",
    DownArrowBar: "\u2913",
    DownArrowUpArrow: "\u21F5",
    DownBreve: "\u0311",
    downdownarrows: "\u21CA",
    downharpoonleft: "\u21C3",
    downharpoonright: "\u21C2",
    DownLeftRightVector: "\u2950",
    DownLeftTeeVector: "\u295E",
    DownLeftVector: "\u21BD",
    DownLeftVectorBar: "\u2956",
    DownRightTeeVector: "\u295F",
    DownRightVector: "\u21C1",
    DownRightVectorBar: "\u2957",
    DownTee: "\u22A4",
    DownTeeArrow: "\u21A7",
    drbkarow: "\u2910",
    drcorn: "\u231F",
    drcrop: "\u230C",
    Dscr: "\uD835\uDC9F",
    dscr: "\uD835\uDCB9",
    DScy: "\u0405",
    dscy: "\u0455",
    dsol: "\u29F6",
    Dstrok: "\u0110",
    dstrok: "\u0111",
    dtdot: "\u22F1",
    dtri: "\u25BF",
    dtrif: "\u25BE",
    duarr: "\u21F5",
    duhar: "\u296F",
    dwangle: "\u29A6",
    DZcy: "\u040F",
    dzcy: "\u045F",
    dzigrarr: "\u27FF",
    Eacute: "\xc9",
    eacute: "\xe9",
    easter: "\u2A6E",
    Ecaron: "\u011A",
    ecaron: "\u011B",
    ecir: "\u2256",
    Ecirc: "\xca",
    ecirc: "\xea",
    ecolon: "\u2255",
    Ecy: "\u042D",
    ecy: "\u044D",
    eDDot: "\u2A77",
    Edot: "\u0116",
    eDot: "\u2251",
    edot: "\u0117",
    ee: "\u2147",
    efDot: "\u2252",
    Efr: "\uD835\uDD08",
    efr: "\uD835\uDD22",
    eg: "\u2A9A",
    Egrave: "\xc8",
    egrave: "\xe8",
    egs: "\u2A96",
    egsdot: "\u2A98",
    el: "\u2A99",
    Element: "\u2208",
    elinters: "\u23E7",
    ell: "\u2113",
    els: "\u2A95",
    elsdot: "\u2A97",
    Emacr: "\u0112",
    emacr: "\u0113",
    empty: "\u2205",
    emptyset: "\u2205",
    EmptySmallSquare: "\u25FB",
    emptyv: "\u2205",
    EmptyVerySmallSquare: "\u25AB",
    emsp: "\u2003",
    emsp13: "\u2004",
    emsp14: "\u2005",
    ENG: "\u014A",
    eng: "\u014B",
    ensp: "\u2002",
    Eogon: "\u0118",
    eogon: "\u0119",
    Eopf: "\uD835\uDD3C",
    eopf: "\uD835\uDD56",
    epar: "\u22D5",
    eparsl: "\u29E3",
    eplus: "\u2A71",
    epsi: "\u03B5",
    Epsilon: "\u0395",
    epsilon: "\u03B5",
    epsiv: "\u03F5",
    eqcirc: "\u2256",
    eqcolon: "\u2255",
    eqsim: "\u2242",
    eqslantgtr: "\u2A96",
    eqslantless: "\u2A95",
    Equal: "\u2A75",
    equals: "=",
    EqualTilde: "\u2242",
    equest: "\u225F",
    Equilibrium: "\u21CC",
    equiv: "\u2261",
    equivDD: "\u2A78",
    eqvparsl: "\u29E5",
    erarr: "\u2971",
    erDot: "\u2253",
    Escr: "\u2130",
    escr: "\u212F",
    esdot: "\u2250",
    Esim: "\u2A73",
    esim: "\u2242",
    Eta: "\u0397",
    eta: "\u03B7",
    ETH: "\xd0",
    eth: "\xf0",
    Euml: "\xcb",
    euml: "\xeb",
    euro: "\u20AC",
    excl: "!",
    exist: "\u2203",
    Exists: "\u2203",
    expectation: "\u2130",
    ExponentialE: "\u2147",
    exponentiale: "\u2147",
    fallingdotseq: "\u2252",
    Fcy: "\u0424",
    fcy: "\u0444",
    female: "\u2640",
    ffilig: "\uFB03",
    fflig: "\uFB00",
    ffllig: "\uFB04",
    Ffr: "\uD835\uDD09",
    ffr: "\uD835\uDD23",
    filig: "\uFB01",
    FilledSmallSquare: "\u25FC",
    FilledVerySmallSquare: "\u25AA",
    fjlig: "fj",
    flat: "\u266D",
    fllig: "\uFB02",
    fltns: "\u25B1",
    fnof: "\u0192",
    Fopf: "\uD835\uDD3D",
    fopf: "\uD835\uDD57",
    ForAll: "\u2200",
    forall: "\u2200",
    fork: "\u22D4",
    forkv: "\u2AD9",
    Fouriertrf: "\u2131",
    fpartint: "\u2A0D",
    frac12: "\xbd",
    frac13: "\u2153",
    frac14: "\xbc",
    frac15: "\u2155",
    frac16: "\u2159",
    frac18: "\u215B",
    frac23: "\u2154",
    frac25: "\u2156",
    frac34: "\xbe",
    frac35: "\u2157",
    frac38: "\u215C",
    frac45: "\u2158",
    frac56: "\u215A",
    frac58: "\u215D",
    frac78: "\u215E",
    frasl: "\u2044",
    frown: "\u2322",
    Fscr: "\u2131",
    fscr: "\uD835\uDCBB",
    gacute: "\u01F5",
    Gamma: "\u0393",
    gamma: "\u03B3",
    Gammad: "\u03DC",
    gammad: "\u03DD",
    gap: "\u2A86",
    Gbreve: "\u011E",
    gbreve: "\u011F",
    Gcedil: "\u0122",
    Gcirc: "\u011C",
    gcirc: "\u011D",
    Gcy: "\u0413",
    gcy: "\u0433",
    Gdot: "\u0120",
    gdot: "\u0121",
    gE: "\u2267",
    ge: "\u2265",
    gEl: "\u2A8C",
    gel: "\u22DB",
    geq: "\u2265",
    geqq: "\u2267",
    geqslant: "\u2A7E",
    ges: "\u2A7E",
    gescc: "\u2AA9",
    gesdot: "\u2A80",
    gesdoto: "\u2A82",
    gesdotol: "\u2A84",
    gesl: "\u22DB\uFE00",
    gesles: "\u2A94",
    Gfr: "\uD835\uDD0A",
    gfr: "\uD835\uDD24",
    Gg: "\u22D9",
    gg: "\u226B",
    ggg: "\u22D9",
    gimel: "\u2137",
    GJcy: "\u0403",
    gjcy: "\u0453",
    gl: "\u2277",
    gla: "\u2AA5",
    glE: "\u2A92",
    glj: "\u2AA4",
    gnap: "\u2A8A",
    gnapprox: "\u2A8A",
    gnE: "\u2269",
    gne: "\u2A88",
    gneq: "\u2A88",
    gneqq: "\u2269",
    gnsim: "\u22E7",
    Gopf: "\uD835\uDD3E",
    gopf: "\uD835\uDD58",
    grave: "`",
    GreaterEqual: "\u2265",
    GreaterEqualLess: "\u22DB",
    GreaterFullEqual: "\u2267",
    GreaterGreater: "\u2AA2",
    GreaterLess: "\u2277",
    GreaterSlantEqual: "\u2A7E",
    GreaterTilde: "\u2273",
    Gscr: "\uD835\uDCA2",
    gscr: "\u210A",
    gsim: "\u2273",
    gsime: "\u2A8E",
    gsiml: "\u2A90",
    Gt: "\u226B",
    GT: ">",
    gt: ">",
    gtcc: "\u2AA7",
    gtcir: "\u2A7A",
    gtdot: "\u22D7",
    gtlPar: "\u2995",
    gtquest: "\u2A7C",
    gtrapprox: "\u2A86",
    gtrarr: "\u2978",
    gtrdot: "\u22D7",
    gtreqless: "\u22DB",
    gtreqqless: "\u2A8C",
    gtrless: "\u2277",
    gtrsim: "\u2273",
    gvertneqq: "\u2269\uFE00",
    gvnE: "\u2269\uFE00",
    Hacek: "\u02C7",
    hairsp: "\u200A",
    half: "\xbd",
    hamilt: "\u210B",
    HARDcy: "\u042A",
    hardcy: "\u044A",
    hArr: "\u21D4",
    harr: "\u2194",
    harrcir: "\u2948",
    harrw: "\u21AD",
    Hat: "^",
    hbar: "\u210F",
    Hcirc: "\u0124",
    hcirc: "\u0125",
    hearts: "\u2665",
    heartsuit: "\u2665",
    hellip: "\u2026",
    hercon: "\u22B9",
    Hfr: "\u210C",
    hfr: "\uD835\uDD25",
    HilbertSpace: "\u210B",
    hksearow: "\u2925",
    hkswarow: "\u2926",
    hoarr: "\u21FF",
    homtht: "\u223B",
    hookleftarrow: "\u21A9",
    hookrightarrow: "\u21AA",
    Hopf: "\u210D",
    hopf: "\uD835\uDD59",
    horbar: "\u2015",
    HorizontalLine: "\u2500",
    Hscr: "\u210B",
    hscr: "\uD835\uDCBD",
    hslash: "\u210F",
    Hstrok: "\u0126",
    hstrok: "\u0127",
    HumpDownHump: "\u224E",
    HumpEqual: "\u224F",
    hybull: "\u2043",
    hyphen: "\u2010",
    Iacute: "\xcd",
    iacute: "\xed",
    ic: "\u2063",
    Icirc: "\xce",
    icirc: "\xee",
    Icy: "\u0418",
    icy: "\u0438",
    Idot: "\u0130",
    IEcy: "\u0415",
    iecy: "\u0435",
    iexcl: "\xa1",
    iff: "\u21D4",
    Ifr: "\u2111",
    ifr: "\uD835\uDD26",
    Igrave: "\xcc",
    igrave: "\xec",
    ii: "\u2148",
    iiiint: "\u2A0C",
    iiint: "\u222D",
    iinfin: "\u29DC",
    iiota: "\u2129",
    IJlig: "\u0132",
    ijlig: "\u0133",
    Im: "\u2111",
    Imacr: "\u012A",
    imacr: "\u012B",
    image: "\u2111",
    ImaginaryI: "\u2148",
    imagline: "\u2110",
    imagpart: "\u2111",
    imath: "\u0131",
    imof: "\u22B7",
    imped: "\u01B5",
    Implies: "\u21D2",
    in: "\u2208",
    incare: "\u2105",
    infin: "\u221E",
    infintie: "\u29DD",
    inodot: "\u0131",
    Int: "\u222C",
    int: "\u222B",
    intcal: "\u22BA",
    integers: "\u2124",
    Integral: "\u222B",
    intercal: "\u22BA",
    Intersection: "\u22C2",
    intlarhk: "\u2A17",
    intprod: "\u2A3C",
    InvisibleComma: "\u2063",
    InvisibleTimes: "\u2062",
    IOcy: "\u0401",
    iocy: "\u0451",
    Iogon: "\u012E",
    iogon: "\u012F",
    Iopf: "\uD835\uDD40",
    iopf: "\uD835\uDD5A",
    Iota: "\u0399",
    iota: "\u03B9",
    iprod: "\u2A3C",
    iquest: "\xbf",
    Iscr: "\u2110",
    iscr: "\uD835\uDCBE",
    isin: "\u2208",
    isindot: "\u22F5",
    isinE: "\u22F9",
    isins: "\u22F4",
    isinsv: "\u22F3",
    isinv: "\u2208",
    it: "\u2062",
    Itilde: "\u0128",
    itilde: "\u0129",
    Iukcy: "\u0406",
    iukcy: "\u0456",
    Iuml: "\xcf",
    iuml: "\xef",
    Jcirc: "\u0134",
    jcirc: "\u0135",
    Jcy: "\u0419",
    jcy: "\u0439",
    Jfr: "\uD835\uDD0D",
    jfr: "\uD835\uDD27",
    jmath: "\u0237",
    Jopf: "\uD835\uDD41",
    jopf: "\uD835\uDD5B",
    Jscr: "\uD835\uDCA5",
    jscr: "\uD835\uDCBF",
    Jsercy: "\u0408",
    jsercy: "\u0458",
    Jukcy: "\u0404",
    jukcy: "\u0454",
    Kappa: "\u039A",
    kappa: "\u03BA",
    kappav: "\u03F0",
    Kcedil: "\u0136",
    kcedil: "\u0137",
    Kcy: "\u041A",
    kcy: "\u043A",
    Kfr: "\uD835\uDD0E",
    kfr: "\uD835\uDD28",
    kgreen: "\u0138",
    KHcy: "\u0425",
    khcy: "\u0445",
    KJcy: "\u040C",
    kjcy: "\u045C",
    Kopf: "\uD835\uDD42",
    kopf: "\uD835\uDD5C",
    Kscr: "\uD835\uDCA6",
    kscr: "\uD835\uDCC0",
    lAarr: "\u21DA",
    Lacute: "\u0139",
    lacute: "\u013A",
    laemptyv: "\u29B4",
    lagran: "\u2112",
    Lambda: "\u039B",
    lambda: "\u03BB",
    Lang: "\u27EA",
    lang: "\u27E8",
    langd: "\u2991",
    langle: "\u27E8",
    lap: "\u2A85",
    Laplacetrf: "\u2112",
    laquo: "\xab",
    Larr: "\u219E",
    lArr: "\u21D0",
    larr: "\u2190",
    larrb: "\u21E4",
    larrbfs: "\u291F",
    larrfs: "\u291D",
    larrhk: "\u21A9",
    larrlp: "\u21AB",
    larrpl: "\u2939",
    larrsim: "\u2973",
    larrtl: "\u21A2",
    lat: "\u2AAB",
    lAtail: "\u291B",
    latail: "\u2919",
    late: "\u2AAD",
    lates: "\u2AAD\uFE00",
    lBarr: "\u290E",
    lbarr: "\u290C",
    lbbrk: "\u2772",
    lbrace: "{",
    lbrack: "[",
    lbrke: "\u298B",
    lbrksld: "\u298F",
    lbrkslu: "\u298D",
    Lcaron: "\u013D",
    lcaron: "\u013E",
    Lcedil: "\u013B",
    lcedil: "\u013C",
    lceil: "\u2308",
    lcub: "{",
    Lcy: "\u041B",
    lcy: "\u043B",
    ldca: "\u2936",
    ldquo: "\u201C",
    ldquor: "\u201E",
    ldrdhar: "\u2967",
    ldrushar: "\u294B",
    ldsh: "\u21B2",
    lE: "\u2266",
    le: "\u2264",
    LeftAngleBracket: "\u27E8",
    LeftArrow: "\u2190",
    Leftarrow: "\u21D0",
    leftarrow: "\u2190",
    LeftArrowBar: "\u21E4",
    LeftArrowRightArrow: "\u21C6",
    leftarrowtail: "\u21A2",
    LeftCeiling: "\u2308",
    LeftDoubleBracket: "\u27E6",
    LeftDownTeeVector: "\u2961",
    LeftDownVector: "\u21C3",
    LeftDownVectorBar: "\u2959",
    LeftFloor: "\u230A",
    leftharpoondown: "\u21BD",
    leftharpoonup: "\u21BC",
    leftleftarrows: "\u21C7",
    LeftRightArrow: "\u2194",
    Leftrightarrow: "\u21D4",
    leftrightarrow: "\u2194",
    leftrightarrows: "\u21C6",
    leftrightharpoons: "\u21CB",
    leftrightsquigarrow: "\u21AD",
    LeftRightVector: "\u294E",
    LeftTee: "\u22A3",
    LeftTeeArrow: "\u21A4",
    LeftTeeVector: "\u295A",
    leftthreetimes: "\u22CB",
    LeftTriangle: "\u22B2",
    LeftTriangleBar: "\u29CF",
    LeftTriangleEqual: "\u22B4",
    LeftUpDownVector: "\u2951",
    LeftUpTeeVector: "\u2960",
    LeftUpVector: "\u21BF",
    LeftUpVectorBar: "\u2958",
    LeftVector: "\u21BC",
    LeftVectorBar: "\u2952",
    lEg: "\u2A8B",
    leg: "\u22DA",
    leq: "\u2264",
    leqq: "\u2266",
    leqslant: "\u2A7D",
    les: "\u2A7D",
    lescc: "\u2AA8",
    lesdot: "\u2A7F",
    lesdoto: "\u2A81",
    lesdotor: "\u2A83",
    lesg: "\u22DA\uFE00",
    lesges: "\u2A93",
    lessapprox: "\u2A85",
    lessdot: "\u22D6",
    lesseqgtr: "\u22DA",
    lesseqqgtr: "\u2A8B",
    LessEqualGreater: "\u22DA",
    LessFullEqual: "\u2266",
    LessGreater: "\u2276",
    lessgtr: "\u2276",
    LessLess: "\u2AA1",
    lesssim: "\u2272",
    LessSlantEqual: "\u2A7D",
    LessTilde: "\u2272",
    lfisht: "\u297C",
    lfloor: "\u230A",
    Lfr: "\uD835\uDD0F",
    lfr: "\uD835\uDD29",
    lg: "\u2276",
    lgE: "\u2A91",
    lHar: "\u2962",
    lhard: "\u21BD",
    lharu: "\u21BC",
    lharul: "\u296A",
    lhblk: "\u2584",
    LJcy: "\u0409",
    ljcy: "\u0459",
    Ll: "\u22D8",
    ll: "\u226A",
    llarr: "\u21C7",
    llcorner: "\u231E",
    Lleftarrow: "\u21DA",
    llhard: "\u296B",
    lltri: "\u25FA",
    Lmidot: "\u013F",
    lmidot: "\u0140",
    lmoust: "\u23B0",
    lmoustache: "\u23B0",
    lnap: "\u2A89",
    lnapprox: "\u2A89",
    lnE: "\u2268",
    lne: "\u2A87",
    lneq: "\u2A87",
    lneqq: "\u2268",
    lnsim: "\u22E6",
    loang: "\u27EC",
    loarr: "\u21FD",
    lobrk: "\u27E6",
    LongLeftArrow: "\u27F5",
    Longleftarrow: "\u27F8",
    longleftarrow: "\u27F5",
    LongLeftRightArrow: "\u27F7",
    Longleftrightarrow: "\u27FA",
    longleftrightarrow: "\u27F7",
    longmapsto: "\u27FC",
    LongRightArrow: "\u27F6",
    Longrightarrow: "\u27F9",
    longrightarrow: "\u27F6",
    looparrowleft: "\u21AB",
    looparrowright: "\u21AC",
    lopar: "\u2985",
    Lopf: "\uD835\uDD43",
    lopf: "\uD835\uDD5D",
    loplus: "\u2A2D",
    lotimes: "\u2A34",
    lowast: "\u2217",
    lowbar: "_",
    LowerLeftArrow: "\u2199",
    LowerRightArrow: "\u2198",
    loz: "\u25CA",
    lozenge: "\u25CA",
    lozf: "\u29EB",
    lpar: "(",
    lparlt: "\u2993",
    lrarr: "\u21C6",
    lrcorner: "\u231F",
    lrhar: "\u21CB",
    lrhard: "\u296D",
    lrm: "\u200E",
    lrtri: "\u22BF",
    lsaquo: "\u2039",
    Lscr: "\u2112",
    lscr: "\uD835\uDCC1",
    Lsh: "\u21B0",
    lsh: "\u21B0",
    lsim: "\u2272",
    lsime: "\u2A8D",
    lsimg: "\u2A8F",
    lsqb: "[",
    lsquo: "\u2018",
    lsquor: "\u201A",
    Lstrok: "\u0141",
    lstrok: "\u0142",
    Lt: "\u226A",
    LT: "<",
    lt: "<",
    ltcc: "\u2AA6",
    ltcir: "\u2A79",
    ltdot: "\u22D6",
    lthree: "\u22CB",
    ltimes: "\u22C9",
    ltlarr: "\u2976",
    ltquest: "\u2A7B",
    ltri: "\u25C3",
    ltrie: "\u22B4",
    ltrif: "\u25C2",
    ltrPar: "\u2996",
    lurdshar: "\u294A",
    luruhar: "\u2966",
    lvertneqq: "\u2268\uFE00",
    lvnE: "\u2268\uFE00",
    macr: "\xaf",
    male: "\u2642",
    malt: "\u2720",
    maltese: "\u2720",
    Map: "\u2905",
    map: "\u21A6",
    mapsto: "\u21A6",
    mapstodown: "\u21A7",
    mapstoleft: "\u21A4",
    mapstoup: "\u21A5",
    marker: "\u25AE",
    mcomma: "\u2A29",
    Mcy: "\u041C",
    mcy: "\u043C",
    mdash: "\u2014",
    mDDot: "\u223A",
    measuredangle: "\u2221",
    MediumSpace: "\u205F",
    Mellintrf: "\u2133",
    Mfr: "\uD835\uDD10",
    mfr: "\uD835\uDD2A",
    mho: "\u2127",
    micro: "\xb5",
    mid: "\u2223",
    midast: "*",
    midcir: "\u2AF0",
    middot: "\xb7",
    minus: "\u2212",
    minusb: "\u229F",
    minusd: "\u2238",
    minusdu: "\u2A2A",
    MinusPlus: "\u2213",
    mlcp: "\u2ADB",
    mldr: "\u2026",
    mnplus: "\u2213",
    models: "\u22A7",
    Mopf: "\uD835\uDD44",
    mopf: "\uD835\uDD5E",
    mp: "\u2213",
    Mscr: "\u2133",
    mscr: "\uD835\uDCC2",
    mstpos: "\u223E",
    Mu: "\u039C",
    mu: "\u03BC",
    multimap: "\u22B8",
    mumap: "\u22B8",
    nabla: "\u2207",
    Nacute: "\u0143",
    nacute: "\u0144",
    nang: "\u2220\u20D2",
    nap: "\u2249",
    napE: "\u2A70\u0338",
    napid: "\u224B\u0338",
    napos: "\u0149",
    napprox: "\u2249",
    natur: "\u266E",
    natural: "\u266E",
    naturals: "\u2115",
    nbsp: "\xa0",
    nbump: "\u224E\u0338",
    nbumpe: "\u224F\u0338",
    ncap: "\u2A43",
    Ncaron: "\u0147",
    ncaron: "\u0148",
    Ncedil: "\u0145",
    ncedil: "\u0146",
    ncong: "\u2247",
    ncongdot: "\u2A6D\u0338",
    ncup: "\u2A42",
    Ncy: "\u041D",
    ncy: "\u043D",
    ndash: "\u2013",
    ne: "\u2260",
    nearhk: "\u2924",
    neArr: "\u21D7",
    nearr: "\u2197",
    nearrow: "\u2197",
    nedot: "\u2250\u0338",
    NegativeMediumSpace: "\u200B",
    NegativeThickSpace: "\u200B",
    NegativeThinSpace: "\u200B",
    NegativeVeryThinSpace: "\u200B",
    nequiv: "\u2262",
    nesear: "\u2928",
    nesim: "\u2242\u0338",
    NestedGreaterGreater: "\u226B",
    NestedLessLess: "\u226A",
    NewLine: "\n",
    nexist: "\u2204",
    nexists: "\u2204",
    Nfr: "\uD835\uDD11",
    nfr: "\uD835\uDD2B",
    ngE: "\u2267\u0338",
    nge: "\u2271",
    ngeq: "\u2271",
    ngeqq: "\u2267\u0338",
    ngeqslant: "\u2A7E\u0338",
    nges: "\u2A7E\u0338",
    nGg: "\u22D9\u0338",
    ngsim: "\u2275",
    nGt: "\u226B\u20D2",
    ngt: "\u226F",
    ngtr: "\u226F",
    nGtv: "\u226B\u0338",
    nhArr: "\u21CE",
    nharr: "\u21AE",
    nhpar: "\u2AF2",
    ni: "\u220B",
    nis: "\u22FC",
    nisd: "\u22FA",
    niv: "\u220B",
    NJcy: "\u040A",
    njcy: "\u045A",
    nlArr: "\u21CD",
    nlarr: "\u219A",
    nldr: "\u2025",
    nlE: "\u2266\u0338",
    nle: "\u2270",
    nLeftarrow: "\u21CD",
    nleftarrow: "\u219A",
    nLeftrightarrow: "\u21CE",
    nleftrightarrow: "\u21AE",
    nleq: "\u2270",
    nleqq: "\u2266\u0338",
    nleqslant: "\u2A7D\u0338",
    nles: "\u2A7D\u0338",
    nless: "\u226E",
    nLl: "\u22D8\u0338",
    nlsim: "\u2274",
    nLt: "\u226A\u20D2",
    nlt: "\u226E",
    nltri: "\u22EA",
    nltrie: "\u22EC",
    nLtv: "\u226A\u0338",
    nmid: "\u2224",
    NoBreak: "\u2060",
    NonBreakingSpace: "\xa0",
    Nopf: "\u2115",
    nopf: "\uD835\uDD5F",
    Not: "\u2AEC",
    not: "\xac",
    NotCongruent: "\u2262",
    NotCupCap: "\u226D",
    NotDoubleVerticalBar: "\u2226",
    NotElement: "\u2209",
    NotEqual: "\u2260",
    NotEqualTilde: "\u2242\u0338",
    NotExists: "\u2204",
    NotGreater: "\u226F",
    NotGreaterEqual: "\u2271",
    NotGreaterFullEqual: "\u2267\u0338",
    NotGreaterGreater: "\u226B\u0338",
    NotGreaterLess: "\u2279",
    NotGreaterSlantEqual: "\u2A7E\u0338",
    NotGreaterTilde: "\u2275",
    NotHumpDownHump: "\u224E\u0338",
    NotHumpEqual: "\u224F\u0338",
    notin: "\u2209",
    notindot: "\u22F5\u0338",
    notinE: "\u22F9\u0338",
    notinva: "\u2209",
    notinvb: "\u22F7",
    notinvc: "\u22F6",
    NotLeftTriangle: "\u22EA",
    NotLeftTriangleBar: "\u29CF\u0338",
    NotLeftTriangleEqual: "\u22EC",
    NotLess: "\u226E",
    NotLessEqual: "\u2270",
    NotLessGreater: "\u2278",
    NotLessLess: "\u226A\u0338",
    NotLessSlantEqual: "\u2A7D\u0338",
    NotLessTilde: "\u2274",
    NotNestedGreaterGreater: "\u2AA2\u0338",
    NotNestedLessLess: "\u2AA1\u0338",
    notni: "\u220C",
    notniva: "\u220C",
    notnivb: "\u22FE",
    notnivc: "\u22FD",
    NotPrecedes: "\u2280",
    NotPrecedesEqual: "\u2AAF\u0338",
    NotPrecedesSlantEqual: "\u22E0",
    NotReverseElement: "\u220C",
    NotRightTriangle: "\u22EB",
    NotRightTriangleBar: "\u29D0\u0338",
    NotRightTriangleEqual: "\u22ED",
    NotSquareSubset: "\u228F\u0338",
    NotSquareSubsetEqual: "\u22E2",
    NotSquareSuperset: "\u2290\u0338",
    NotSquareSupersetEqual: "\u22E3",
    NotSubset: "\u2282\u20D2",
    NotSubsetEqual: "\u2288",
    NotSucceeds: "\u2281",
    NotSucceedsEqual: "\u2AB0\u0338",
    NotSucceedsSlantEqual: "\u22E1",
    NotSucceedsTilde: "\u227F\u0338",
    NotSuperset: "\u2283\u20D2",
    NotSupersetEqual: "\u2289",
    NotTilde: "\u2241",
    NotTildeEqual: "\u2244",
    NotTildeFullEqual: "\u2247",
    NotTildeTilde: "\u2249",
    NotVerticalBar: "\u2224",
    npar: "\u2226",
    nparallel: "\u2226",
    nparsl: "\u2AFD\u20E5",
    npart: "\u2202\u0338",
    npolint: "\u2A14",
    npr: "\u2280",
    nprcue: "\u22E0",
    npre: "\u2AAF\u0338",
    nprec: "\u2280",
    npreceq: "\u2AAF\u0338",
    nrArr: "\u21CF",
    nrarr: "\u219B",
    nrarrc: "\u2933\u0338",
    nrarrw: "\u219D\u0338",
    nRightarrow: "\u21CF",
    nrightarrow: "\u219B",
    nrtri: "\u22EB",
    nrtrie: "\u22ED",
    nsc: "\u2281",
    nsccue: "\u22E1",
    nsce: "\u2AB0\u0338",
    Nscr: "\uD835\uDCA9",
    nscr: "\uD835\uDCC3",
    nshortmid: "\u2224",
    nshortparallel: "\u2226",
    nsim: "\u2241",
    nsime: "\u2244",
    nsimeq: "\u2244",
    nsmid: "\u2224",
    nspar: "\u2226",
    nsqsube: "\u22E2",
    nsqsupe: "\u22E3",
    nsub: "\u2284",
    nsubE: "\u2AC5\u0338",
    nsube: "\u2288",
    nsubset: "\u2282\u20D2",
    nsubseteq: "\u2288",
    nsubseteqq: "\u2AC5\u0338",
    nsucc: "\u2281",
    nsucceq: "\u2AB0\u0338",
    nsup: "\u2285",
    nsupE: "\u2AC6\u0338",
    nsupe: "\u2289",
    nsupset: "\u2283\u20D2",
    nsupseteq: "\u2289",
    nsupseteqq: "\u2AC6\u0338",
    ntgl: "\u2279",
    Ntilde: "\xd1",
    ntilde: "\xf1",
    ntlg: "\u2278",
    ntriangleleft: "\u22EA",
    ntrianglelefteq: "\u22EC",
    ntriangleright: "\u22EB",
    ntrianglerighteq: "\u22ED",
    Nu: "\u039D",
    nu: "\u03BD",
    num: "#",
    numero: "\u2116",
    numsp: "\u2007",
    nvap: "\u224D\u20D2",
    nVDash: "\u22AF",
    nVdash: "\u22AE",
    nvDash: "\u22AD",
    nvdash: "\u22AC",
    nvge: "\u2265\u20D2",
    nvgt: ">\u20D2",
    nvHarr: "\u2904",
    nvinfin: "\u29DE",
    nvlArr: "\u2902",
    nvle: "\u2264\u20D2",
    nvlt: "<\u20D2",
    nvltrie: "\u22B4\u20D2",
    nvrArr: "\u2903",
    nvrtrie: "\u22B5\u20D2",
    nvsim: "\u223C\u20D2",
    nwarhk: "\u2923",
    nwArr: "\u21D6",
    nwarr: "\u2196",
    nwarrow: "\u2196",
    nwnear: "\u2927",
    Oacute: "\xd3",
    oacute: "\xf3",
    oast: "\u229B",
    ocir: "\u229A",
    Ocirc: "\xd4",
    ocirc: "\xf4",
    Ocy: "\u041E",
    ocy: "\u043E",
    odash: "\u229D",
    Odblac: "\u0150",
    odblac: "\u0151",
    odiv: "\u2A38",
    odot: "\u2299",
    odsold: "\u29BC",
    OElig: "\u0152",
    oelig: "\u0153",
    ofcir: "\u29BF",
    Ofr: "\uD835\uDD12",
    ofr: "\uD835\uDD2C",
    ogon: "\u02DB",
    Ograve: "\xd2",
    ograve: "\xf2",
    ogt: "\u29C1",
    ohbar: "\u29B5",
    ohm: "\u03A9",
    oint: "\u222E",
    olarr: "\u21BA",
    olcir: "\u29BE",
    olcross: "\u29BB",
    oline: "\u203E",
    olt: "\u29C0",
    Omacr: "\u014C",
    omacr: "\u014D",
    Omega: "\u03A9",
    omega: "\u03C9",
    Omicron: "\u039F",
    omicron: "\u03BF",
    omid: "\u29B6",
    ominus: "\u2296",
    Oopf: "\uD835\uDD46",
    oopf: "\uD835\uDD60",
    opar: "\u29B7",
    OpenCurlyDoubleQuote: "\u201C",
    OpenCurlyQuote: "\u2018",
    operp: "\u29B9",
    oplus: "\u2295",
    Or: "\u2A54",
    or: "\u2228",
    orarr: "\u21BB",
    ord: "\u2A5D",
    order: "\u2134",
    orderof: "\u2134",
    ordf: "\xaa",
    ordm: "\xba",
    origof: "\u22B6",
    oror: "\u2A56",
    orslope: "\u2A57",
    orv: "\u2A5B",
    oS: "\u24C8",
    Oscr: "\uD835\uDCAA",
    oscr: "\u2134",
    Oslash: "\xd8",
    oslash: "\xf8",
    osol: "\u2298",
    Otilde: "\xd5",
    otilde: "\xf5",
    Otimes: "\u2A37",
    otimes: "\u2297",
    otimesas: "\u2A36",
    Ouml: "\xd6",
    ouml: "\xf6",
    ovbar: "\u233D",
    OverBar: "\u203E",
    OverBrace: "\u23DE",
    OverBracket: "\u23B4",
    OverParenthesis: "\u23DC",
    par: "\u2225",
    para: "\xb6",
    parallel: "\u2225",
    parsim: "\u2AF3",
    parsl: "\u2AFD",
    part: "\u2202",
    PartialD: "\u2202",
    Pcy: "\u041F",
    pcy: "\u043F",
    percnt: "%",
    period: ".",
    permil: "\u2030",
    perp: "\u22A5",
    pertenk: "\u2031",
    Pfr: "\uD835\uDD13",
    pfr: "\uD835\uDD2D",
    Phi: "\u03A6",
    phi: "\u03C6",
    phiv: "\u03D5",
    phmmat: "\u2133",
    phone: "\u260E",
    Pi: "\u03A0",
    pi: "\u03C0",
    pitchfork: "\u22D4",
    piv: "\u03D6",
    planck: "\u210F",
    planckh: "\u210E",
    plankv: "\u210F",
    plus: "+",
    plusacir: "\u2A23",
    plusb: "\u229E",
    pluscir: "\u2A22",
    plusdo: "\u2214",
    plusdu: "\u2A25",
    pluse: "\u2A72",
    PlusMinus: "\xb1",
    plusmn: "\xb1",
    plussim: "\u2A26",
    plustwo: "\u2A27",
    pm: "\xb1",
    Poincareplane: "\u210C",
    pointint: "\u2A15",
    Popf: "\u2119",
    popf: "\uD835\uDD61",
    pound: "\xa3",
    Pr: "\u2ABB",
    pr: "\u227A",
    prap: "\u2AB7",
    prcue: "\u227C",
    prE: "\u2AB3",
    pre: "\u2AAF",
    prec: "\u227A",
    precapprox: "\u2AB7",
    preccurlyeq: "\u227C",
    Precedes: "\u227A",
    PrecedesEqual: "\u2AAF",
    PrecedesSlantEqual: "\u227C",
    PrecedesTilde: "\u227E",
    preceq: "\u2AAF",
    precnapprox: "\u2AB9",
    precneqq: "\u2AB5",
    precnsim: "\u22E8",
    precsim: "\u227E",
    Prime: "\u2033",
    prime: "\u2032",
    primes: "\u2119",
    prnap: "\u2AB9",
    prnE: "\u2AB5",
    prnsim: "\u22E8",
    prod: "\u220F",
    Product: "\u220F",
    profalar: "\u232E",
    profline: "\u2312",
    profsurf: "\u2313",
    prop: "\u221D",
    Proportion: "\u2237",
    Proportional: "\u221D",
    propto: "\u221D",
    prsim: "\u227E",
    prurel: "\u22B0",
    Pscr: "\uD835\uDCAB",
    pscr: "\uD835\uDCC5",
    Psi: "\u03A8",
    psi: "\u03C8",
    puncsp: "\u2008",
    Qfr: "\uD835\uDD14",
    qfr: "\uD835\uDD2E",
    qint: "\u2A0C",
    Qopf: "\u211A",
    qopf: "\uD835\uDD62",
    qprime: "\u2057",
    Qscr: "\uD835\uDCAC",
    qscr: "\uD835\uDCC6",
    quaternions: "\u210D",
    quatint: "\u2A16",
    quest: "?",
    questeq: "\u225F",
    QUOT: '"',
    quot: '"',
    rAarr: "\u21DB",
    race: "\u223D\u0331",
    Racute: "\u0154",
    racute: "\u0155",
    radic: "\u221A",
    raemptyv: "\u29B3",
    Rang: "\u27EB",
    rang: "\u27E9",
    rangd: "\u2992",
    range: "\u29A5",
    rangle: "\u27E9",
    raquo: "\xbb",
    Rarr: "\u21A0",
    rArr: "\u21D2",
    rarr: "\u2192",
    rarrap: "\u2975",
    rarrb: "\u21E5",
    rarrbfs: "\u2920",
    rarrc: "\u2933",
    rarrfs: "\u291E",
    rarrhk: "\u21AA",
    rarrlp: "\u21AC",
    rarrpl: "\u2945",
    rarrsim: "\u2974",
    Rarrtl: "\u2916",
    rarrtl: "\u21A3",
    rarrw: "\u219D",
    rAtail: "\u291C",
    ratail: "\u291A",
    ratio: "\u2236",
    rationals: "\u211A",
    RBarr: "\u2910",
    rBarr: "\u290F",
    rbarr: "\u290D",
    rbbrk: "\u2773",
    rbrace: "}",
    rbrack: "]",
    rbrke: "\u298C",
    rbrksld: "\u298E",
    rbrkslu: "\u2990",
    Rcaron: "\u0158",
    rcaron: "\u0159",
    Rcedil: "\u0156",
    rcedil: "\u0157",
    rceil: "\u2309",
    rcub: "}",
    Rcy: "\u0420",
    rcy: "\u0440",
    rdca: "\u2937",
    rdldhar: "\u2969",
    rdquo: "\u201D",
    rdquor: "\u201D",
    rdsh: "\u21B3",
    Re: "\u211C",
    real: "\u211C",
    realine: "\u211B",
    realpart: "\u211C",
    reals: "\u211D",
    rect: "\u25AD",
    REG: "\xae",
    reg: "\xae",
    ReverseElement: "\u220B",
    ReverseEquilibrium: "\u21CB",
    ReverseUpEquilibrium: "\u296F",
    rfisht: "\u297D",
    rfloor: "\u230B",
    Rfr: "\u211C",
    rfr: "\uD835\uDD2F",
    rHar: "\u2964",
    rhard: "\u21C1",
    rharu: "\u21C0",
    rharul: "\u296C",
    Rho: "\u03A1",
    rho: "\u03C1",
    rhov: "\u03F1",
    RightAngleBracket: "\u27E9",
    RightArrow: "\u2192",
    Rightarrow: "\u21D2",
    rightarrow: "\u2192",
    RightArrowBar: "\u21E5",
    RightArrowLeftArrow: "\u21C4",
    rightarrowtail: "\u21A3",
    RightCeiling: "\u2309",
    RightDoubleBracket: "\u27E7",
    RightDownTeeVector: "\u295D",
    RightDownVector: "\u21C2",
    RightDownVectorBar: "\u2955",
    RightFloor: "\u230B",
    rightharpoondown: "\u21C1",
    rightharpoonup: "\u21C0",
    rightleftarrows: "\u21C4",
    rightleftharpoons: "\u21CC",
    rightrightarrows: "\u21C9",
    rightsquigarrow: "\u219D",
    RightTee: "\u22A2",
    RightTeeArrow: "\u21A6",
    RightTeeVector: "\u295B",
    rightthreetimes: "\u22CC",
    RightTriangle: "\u22B3",
    RightTriangleBar: "\u29D0",
    RightTriangleEqual: "\u22B5",
    RightUpDownVector: "\u294F",
    RightUpTeeVector: "\u295C",
    RightUpVector: "\u21BE",
    RightUpVectorBar: "\u2954",
    RightVector: "\u21C0",
    RightVectorBar: "\u2953",
    ring: "\u02DA",
    risingdotseq: "\u2253",
    rlarr: "\u21C4",
    rlhar: "\u21CC",
    rlm: "\u200F",
    rmoust: "\u23B1",
    rmoustache: "\u23B1",
    rnmid: "\u2AEE",
    roang: "\u27ED",
    roarr: "\u21FE",
    robrk: "\u27E7",
    ropar: "\u2986",
    Ropf: "\u211D",
    ropf: "\uD835\uDD63",
    roplus: "\u2A2E",
    rotimes: "\u2A35",
    RoundImplies: "\u2970",
    rpar: ")",
    rpargt: "\u2994",
    rppolint: "\u2A12",
    rrarr: "\u21C9",
    Rrightarrow: "\u21DB",
    rsaquo: "\u203A",
    Rscr: "\u211B",
    rscr: "\uD835\uDCC7",
    Rsh: "\u21B1",
    rsh: "\u21B1",
    rsqb: "]",
    rsquo: "\u2019",
    rsquor: "\u2019",
    rthree: "\u22CC",
    rtimes: "\u22CA",
    rtri: "\u25B9",
    rtrie: "\u22B5",
    rtrif: "\u25B8",
    rtriltri: "\u29CE",
    RuleDelayed: "\u29F4",
    ruluhar: "\u2968",
    rx: "\u211E",
    Sacute: "\u015A",
    sacute: "\u015B",
    sbquo: "\u201A",
    Sc: "\u2ABC",
    sc: "\u227B",
    scap: "\u2AB8",
    Scaron: "\u0160",
    scaron: "\u0161",
    sccue: "\u227D",
    scE: "\u2AB4",
    sce: "\u2AB0",
    Scedil: "\u015E",
    scedil: "\u015F",
    Scirc: "\u015C",
    scirc: "\u015D",
    scnap: "\u2ABA",
    scnE: "\u2AB6",
    scnsim: "\u22E9",
    scpolint: "\u2A13",
    scsim: "\u227F",
    Scy: "\u0421",
    scy: "\u0441",
    sdot: "\u22C5",
    sdotb: "\u22A1",
    sdote: "\u2A66",
    searhk: "\u2925",
    seArr: "\u21D8",
    searr: "\u2198",
    searrow: "\u2198",
    sect: "\xa7",
    semi: ";",
    seswar: "\u2929",
    setminus: "\u2216",
    setmn: "\u2216",
    sext: "\u2736",
    Sfr: "\uD835\uDD16",
    sfr: "\uD835\uDD30",
    sfrown: "\u2322",
    sharp: "\u266F",
    SHCHcy: "\u0429",
    shchcy: "\u0449",
    SHcy: "\u0428",
    shcy: "\u0448",
    ShortDownArrow: "\u2193",
    ShortLeftArrow: "\u2190",
    shortmid: "\u2223",
    shortparallel: "\u2225",
    ShortRightArrow: "\u2192",
    ShortUpArrow: "\u2191",
    shy: "\xad",
    Sigma: "\u03A3",
    sigma: "\u03C3",
    sigmaf: "\u03C2",
    sigmav: "\u03C2",
    sim: "\u223C",
    simdot: "\u2A6A",
    sime: "\u2243",
    simeq: "\u2243",
    simg: "\u2A9E",
    simgE: "\u2AA0",
    siml: "\u2A9D",
    simlE: "\u2A9F",
    simne: "\u2246",
    simplus: "\u2A24",
    simrarr: "\u2972",
    slarr: "\u2190",
    SmallCircle: "\u2218",
    smallsetminus: "\u2216",
    smashp: "\u2A33",
    smeparsl: "\u29E4",
    smid: "\u2223",
    smile: "\u2323",
    smt: "\u2AAA",
    smte: "\u2AAC",
    smtes: "\u2AAC\uFE00",
    SOFTcy: "\u042C",
    softcy: "\u044C",
    sol: "/",
    solb: "\u29C4",
    solbar: "\u233F",
    Sopf: "\uD835\uDD4A",
    sopf: "\uD835\uDD64",
    spades: "\u2660",
    spadesuit: "\u2660",
    spar: "\u2225",
    sqcap: "\u2293",
    sqcaps: "\u2293\uFE00",
    sqcup: "\u2294",
    sqcups: "\u2294\uFE00",
    Sqrt: "\u221A",
    sqsub: "\u228F",
    sqsube: "\u2291",
    sqsubset: "\u228F",
    sqsubseteq: "\u2291",
    sqsup: "\u2290",
    sqsupe: "\u2292",
    sqsupset: "\u2290",
    sqsupseteq: "\u2292",
    squ: "\u25A1",
    Square: "\u25A1",
    square: "\u25A1",
    SquareIntersection: "\u2293",
    SquareSubset: "\u228F",
    SquareSubsetEqual: "\u2291",
    SquareSuperset: "\u2290",
    SquareSupersetEqual: "\u2292",
    SquareUnion: "\u2294",
    squarf: "\u25AA",
    squf: "\u25AA",
    srarr: "\u2192",
    Sscr: "\uD835\uDCAE",
    sscr: "\uD835\uDCC8",
    ssetmn: "\u2216",
    ssmile: "\u2323",
    sstarf: "\u22C6",
    Star: "\u22C6",
    star: "\u2606",
    starf: "\u2605",
    straightepsilon: "\u03F5",
    straightphi: "\u03D5",
    strns: "\xaf",
    Sub: "\u22D0",
    sub: "\u2282",
    subdot: "\u2ABD",
    subE: "\u2AC5",
    sube: "\u2286",
    subedot: "\u2AC3",
    submult: "\u2AC1",
    subnE: "\u2ACB",
    subne: "\u228A",
    subplus: "\u2ABF",
    subrarr: "\u2979",
    Subset: "\u22D0",
    subset: "\u2282",
    subseteq: "\u2286",
    subseteqq: "\u2AC5",
    SubsetEqual: "\u2286",
    subsetneq: "\u228A",
    subsetneqq: "\u2ACB",
    subsim: "\u2AC7",
    subsub: "\u2AD5",
    subsup: "\u2AD3",
    succ: "\u227B",
    succapprox: "\u2AB8",
    succcurlyeq: "\u227D",
    Succeeds: "\u227B",
    SucceedsEqual: "\u2AB0",
    SucceedsSlantEqual: "\u227D",
    SucceedsTilde: "\u227F",
    succeq: "\u2AB0",
    succnapprox: "\u2ABA",
    succneqq: "\u2AB6",
    succnsim: "\u22E9",
    succsim: "\u227F",
    SuchThat: "\u220B",
    Sum: "\u2211",
    sum: "\u2211",
    sung: "\u266A",
    Sup: "\u22D1",
    sup: "\u2283",
    sup1: "\xb9",
    sup2: "\xb2",
    sup3: "\xb3",
    supdot: "\u2ABE",
    supdsub: "\u2AD8",
    supE: "\u2AC6",
    supe: "\u2287",
    supedot: "\u2AC4",
    Superset: "\u2283",
    SupersetEqual: "\u2287",
    suphsol: "\u27C9",
    suphsub: "\u2AD7",
    suplarr: "\u297B",
    supmult: "\u2AC2",
    supnE: "\u2ACC",
    supne: "\u228B",
    supplus: "\u2AC0",
    Supset: "\u22D1",
    supset: "\u2283",
    supseteq: "\u2287",
    supseteqq: "\u2AC6",
    supsetneq: "\u228B",
    supsetneqq: "\u2ACC",
    supsim: "\u2AC8",
    supsub: "\u2AD4",
    supsup: "\u2AD6",
    swarhk: "\u2926",
    swArr: "\u21D9",
    swarr: "\u2199",
    swarrow: "\u2199",
    swnwar: "\u292A",
    szlig: "\xdf",
    Tab: "	",
    target: "\u2316",
    Tau: "\u03A4",
    tau: "\u03C4",
    tbrk: "\u23B4",
    Tcaron: "\u0164",
    tcaron: "\u0165",
    Tcedil: "\u0162",
    tcedil: "\u0163",
    Tcy: "\u0422",
    tcy: "\u0442",
    tdot: "\u20DB",
    telrec: "\u2315",
    Tfr: "\uD835\uDD17",
    tfr: "\uD835\uDD31",
    there4: "\u2234",
    Therefore: "\u2234",
    therefore: "\u2234",
    Theta: "\u0398",
    theta: "\u03B8",
    thetasym: "\u03D1",
    thetav: "\u03D1",
    thickapprox: "\u2248",
    thicksim: "\u223C",
    ThickSpace: "\u205F\u200A",
    thinsp: "\u2009",
    ThinSpace: "\u2009",
    thkap: "\u2248",
    thksim: "\u223C",
    THORN: "\xde",
    thorn: "\xfe",
    Tilde: "\u223C",
    tilde: "\u02DC",
    TildeEqual: "\u2243",
    TildeFullEqual: "\u2245",
    TildeTilde: "\u2248",
    times: "\xd7",
    timesb: "\u22A0",
    timesbar: "\u2A31",
    timesd: "\u2A30",
    tint: "\u222D",
    toea: "\u2928",
    top: "\u22A4",
    topbot: "\u2336",
    topcir: "\u2AF1",
    Topf: "\uD835\uDD4B",
    topf: "\uD835\uDD65",
    topfork: "\u2ADA",
    tosa: "\u2929",
    tprime: "\u2034",
    TRADE: "\u2122",
    trade: "\u2122",
    triangle: "\u25B5",
    triangledown: "\u25BF",
    triangleleft: "\u25C3",
    trianglelefteq: "\u22B4",
    triangleq: "\u225C",
    triangleright: "\u25B9",
    trianglerighteq: "\u22B5",
    tridot: "\u25EC",
    trie: "\u225C",
    triminus: "\u2A3A",
    TripleDot: "\u20DB",
    triplus: "\u2A39",
    trisb: "\u29CD",
    tritime: "\u2A3B",
    trpezium: "\u23E2",
    Tscr: "\uD835\uDCAF",
    tscr: "\uD835\uDCC9",
    TScy: "\u0426",
    tscy: "\u0446",
    TSHcy: "\u040B",
    tshcy: "\u045B",
    Tstrok: "\u0166",
    tstrok: "\u0167",
    twixt: "\u226C",
    twoheadleftarrow: "\u219E",
    twoheadrightarrow: "\u21A0",
    Uacute: "\xda",
    uacute: "\xfa",
    Uarr: "\u219F",
    uArr: "\u21D1",
    uarr: "\u2191",
    Uarrocir: "\u2949",
    Ubrcy: "\u040E",
    ubrcy: "\u045E",
    Ubreve: "\u016C",
    ubreve: "\u016D",
    Ucirc: "\xdb",
    ucirc: "\xfb",
    Ucy: "\u0423",
    ucy: "\u0443",
    udarr: "\u21C5",
    Udblac: "\u0170",
    udblac: "\u0171",
    udhar: "\u296E",
    ufisht: "\u297E",
    Ufr: "\uD835\uDD18",
    ufr: "\uD835\uDD32",
    Ugrave: "\xd9",
    ugrave: "\xf9",
    uHar: "\u2963",
    uharl: "\u21BF",
    uharr: "\u21BE",
    uhblk: "\u2580",
    ulcorn: "\u231C",
    ulcorner: "\u231C",
    ulcrop: "\u230F",
    ultri: "\u25F8",
    Umacr: "\u016A",
    umacr: "\u016B",
    uml: "\xa8",
    UnderBar: "_",
    UnderBrace: "\u23DF",
    UnderBracket: "\u23B5",
    UnderParenthesis: "\u23DD",
    Union: "\u22C3",
    UnionPlus: "\u228E",
    Uogon: "\u0172",
    uogon: "\u0173",
    Uopf: "\uD835\uDD4C",
    uopf: "\uD835\uDD66",
    UpArrow: "\u2191",
    Uparrow: "\u21D1",
    uparrow: "\u2191",
    UpArrowBar: "\u2912",
    UpArrowDownArrow: "\u21C5",
    UpDownArrow: "\u2195",
    Updownarrow: "\u21D5",
    updownarrow: "\u2195",
    UpEquilibrium: "\u296E",
    upharpoonleft: "\u21BF",
    upharpoonright: "\u21BE",
    uplus: "\u228E",
    UpperLeftArrow: "\u2196",
    UpperRightArrow: "\u2197",
    Upsi: "\u03D2",
    upsi: "\u03C5",
    upsih: "\u03D2",
    Upsilon: "\u03A5",
    upsilon: "\u03C5",
    UpTee: "\u22A5",
    UpTeeArrow: "\u21A5",
    upuparrows: "\u21C8",
    urcorn: "\u231D",
    urcorner: "\u231D",
    urcrop: "\u230E",
    Uring: "\u016E",
    uring: "\u016F",
    urtri: "\u25F9",
    Uscr: "\uD835\uDCB0",
    uscr: "\uD835\uDCCA",
    utdot: "\u22F0",
    Utilde: "\u0168",
    utilde: "\u0169",
    utri: "\u25B5",
    utrif: "\u25B4",
    uuarr: "\u21C8",
    Uuml: "\xdc",
    uuml: "\xfc",
    uwangle: "\u29A7",
    vangrt: "\u299C",
    varepsilon: "\u03F5",
    varkappa: "\u03F0",
    varnothing: "\u2205",
    varphi: "\u03D5",
    varpi: "\u03D6",
    varpropto: "\u221D",
    vArr: "\u21D5",
    varr: "\u2195",
    varrho: "\u03F1",
    varsigma: "\u03C2",
    varsubsetneq: "\u228A\uFE00",
    varsubsetneqq: "\u2ACB\uFE00",
    varsupsetneq: "\u228B\uFE00",
    varsupsetneqq: "\u2ACC\uFE00",
    vartheta: "\u03D1",
    vartriangleleft: "\u22B2",
    vartriangleright: "\u22B3",
    Vbar: "\u2AEB",
    vBar: "\u2AE8",
    vBarv: "\u2AE9",
    Vcy: "\u0412",
    vcy: "\u0432",
    VDash: "\u22AB",
    Vdash: "\u22A9",
    vDash: "\u22A8",
    vdash: "\u22A2",
    Vdashl: "\u2AE6",
    Vee: "\u22C1",
    vee: "\u2228",
    veebar: "\u22BB",
    veeeq: "\u225A",
    vellip: "\u22EE",
    Verbar: "\u2016",
    verbar: "|",
    Vert: "\u2016",
    vert: "|",
    VerticalBar: "\u2223",
    VerticalLine: "|",
    VerticalSeparator: "\u2758",
    VerticalTilde: "\u2240",
    VeryThinSpace: "\u200A",
    Vfr: "\uD835\uDD19",
    vfr: "\uD835\uDD33",
    vltri: "\u22B2",
    vnsub: "\u2282\u20D2",
    vnsup: "\u2283\u20D2",
    Vopf: "\uD835\uDD4D",
    vopf: "\uD835\uDD67",
    vprop: "\u221D",
    vrtri: "\u22B3",
    Vscr: "\uD835\uDCB1",
    vscr: "\uD835\uDCCB",
    vsubnE: "\u2ACB\uFE00",
    vsubne: "\u228A\uFE00",
    vsupnE: "\u2ACC\uFE00",
    vsupne: "\u228B\uFE00",
    Vvdash: "\u22AA",
    vzigzag: "\u299A",
    Wcirc: "\u0174",
    wcirc: "\u0175",
    wedbar: "\u2A5F",
    Wedge: "\u22C0",
    wedge: "\u2227",
    wedgeq: "\u2259",
    weierp: "\u2118",
    Wfr: "\uD835\uDD1A",
    wfr: "\uD835\uDD34",
    Wopf: "\uD835\uDD4E",
    wopf: "\uD835\uDD68",
    wp: "\u2118",
    wr: "\u2240",
    wreath: "\u2240",
    Wscr: "\uD835\uDCB2",
    wscr: "\uD835\uDCCC",
    xcap: "\u22C2",
    xcirc: "\u25EF",
    xcup: "\u22C3",
    xdtri: "\u25BD",
    Xfr: "\uD835\uDD1B",
    xfr: "\uD835\uDD35",
    xhArr: "\u27FA",
    xharr: "\u27F7",
    Xi: "\u039E",
    xi: "\u03BE",
    xlArr: "\u27F8",
    xlarr: "\u27F5",
    xmap: "\u27FC",
    xnis: "\u22FB",
    xodot: "\u2A00",
    Xopf: "\uD835\uDD4F",
    xopf: "\uD835\uDD69",
    xoplus: "\u2A01",
    xotime: "\u2A02",
    xrArr: "\u27F9",
    xrarr: "\u27F6",
    Xscr: "\uD835\uDCB3",
    xscr: "\uD835\uDCCD",
    xsqcup: "\u2A06",
    xuplus: "\u2A04",
    xutri: "\u25B3",
    xvee: "\u22C1",
    xwedge: "\u22C0",
    Yacute: "\xdd",
    yacute: "\xfd",
    YAcy: "\u042F",
    yacy: "\u044F",
    Ycirc: "\u0176",
    ycirc: "\u0177",
    Ycy: "\u042B",
    ycy: "\u044B",
    yen: "\xa5",
    Yfr: "\uD835\uDD1C",
    yfr: "\uD835\uDD36",
    YIcy: "\u0407",
    yicy: "\u0457",
    Yopf: "\uD835\uDD50",
    yopf: "\uD835\uDD6A",
    Yscr: "\uD835\uDCB4",
    yscr: "\uD835\uDCCE",
    YUcy: "\u042E",
    yucy: "\u044E",
    Yuml: "\u0178",
    yuml: "\xff",
    Zacute: "\u0179",
    zacute: "\u017A",
    Zcaron: "\u017D",
    zcaron: "\u017E",
    Zcy: "\u0417",
    zcy: "\u0437",
    Zdot: "\u017B",
    zdot: "\u017C",
    zeetrf: "\u2128",
    ZeroWidthSpace: "\u200B",
    Zeta: "\u0396",
    zeta: "\u03B6",
    Zfr: "\u2128",
    zfr: "\uD835\uDD37",
    ZHcy: "\u0416",
    zhcy: "\u0436",
    zigrarr: "\u21DD",
    Zopf: "\u2124",
    zopf: "\uD835\uDD6B",
    Zscr: "\uD835\uDCB5",
    zscr: "\uD835\uDCCF",
    zwj: "\u200D",
    zwnj: "\u200C"
});
$209c739ee170ce7f$export$79451380caed3f98 = $209c739ee170ce7f$export$b7e4d4631df36afa;

});

parcelRegister("1fO4L", function(module, exports) {

$parcel$export(module.exports, "XMLReader", () => $0e9e0929092947dd$export$ccbc9f9f018333e9, (v) => $0e9e0929092947dd$export$ccbc9f9f018333e9 = v);
$parcel$export(module.exports, "ParseError", () => $0e9e0929092947dd$export$f9c837a54db411d, (v) => $0e9e0929092947dd$export$f9c837a54db411d = v);
var $0e9e0929092947dd$export$ccbc9f9f018333e9;
var $0e9e0929092947dd$export$f9c837a54db411d;

var $hkG9E = parcelRequire("hkG9E");
var $0e9e0929092947dd$require$NAMESPACE = $hkG9E.NAMESPACE;
//[4]   	NameStartChar	   ::=   	":" | [A-Z] | "_" | [a-z] | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x2FF] | [#x370-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
//[4a]   	NameChar	   ::=   	NameStartChar | "-" | "." | [0-9] | #xB7 | [#x0300-#x036F] | [#x203F-#x2040]
//[5]   	Name	   ::=   	NameStartChar (NameChar)*
var $0e9e0929092947dd$var$nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/ //\u10000-\uEFFFF
;
var $0e9e0929092947dd$var$nameChar = new RegExp("[\\-\\.0-9" + $0e9e0929092947dd$var$nameStartChar.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
var $0e9e0929092947dd$var$tagNamePattern = new RegExp("^" + $0e9e0929092947dd$var$nameStartChar.source + $0e9e0929092947dd$var$nameChar.source + "*(?::" + $0e9e0929092947dd$var$nameStartChar.source + $0e9e0929092947dd$var$nameChar.source + "*)?$");
//var tagNamePattern = /^[a-zA-Z_][\w\-\.]*(?:\:[a-zA-Z_][\w\-\.]*)?$/
//var handlers = 'resolveEntity,getExternalSubset,characters,endDocument,endElement,endPrefixMapping,ignorableWhitespace,processingInstruction,setDocumentLocator,skippedEntity,startDocument,startElement,startPrefixMapping,notationDecl,unparsedEntityDecl,error,fatalError,warning,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,comment,endCDATA,endDTD,endEntity,startCDATA,startDTD,startEntity'.split(',')
//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
var $0e9e0929092947dd$var$S_TAG = 0; //tag name offerring
var $0e9e0929092947dd$var$S_ATTR = 1; //attr name offerring
var $0e9e0929092947dd$var$S_ATTR_SPACE = 2; //attr name end and space offer
var $0e9e0929092947dd$var$S_EQ = 3; //=space?
var $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE = 4; //attr value(no quot value only)
var $0e9e0929092947dd$var$S_ATTR_END = 5; //attr value end and no space(quot end)
var $0e9e0929092947dd$var$S_TAG_SPACE = 6; //(attr value end || tag end ) && (space offer)
var $0e9e0929092947dd$var$S_TAG_CLOSE = 7; //closed el<el />
/**
 * Creates an error that will not be caught by XMLReader aka the SAX parser.
 *
 * @param {string} message
 * @param {any?} locator Optional, can provide details about the location in the source
 * @constructor
 */ function $0e9e0929092947dd$var$ParseError(message, locator) {
    this.message = message;
    this.locator = locator;
    if (Error.captureStackTrace) Error.captureStackTrace(this, $0e9e0929092947dd$var$ParseError);
}
$0e9e0929092947dd$var$ParseError.prototype = new Error();
$0e9e0929092947dd$var$ParseError.prototype.name = $0e9e0929092947dd$var$ParseError.name;
function $0e9e0929092947dd$var$XMLReader() {}
$0e9e0929092947dd$var$XMLReader.prototype = {
    parse: function(source, defaultNSMap, entityMap) {
        var domBuilder = this.domBuilder;
        domBuilder.startDocument();
        $0e9e0929092947dd$var$_copy(defaultNSMap, defaultNSMap = {});
        $0e9e0929092947dd$var$parse(source, defaultNSMap, entityMap, domBuilder, this.errorHandler);
        domBuilder.endDocument();
    }
};
function $0e9e0929092947dd$var$parse(source, defaultNSMapCopy, entityMap, domBuilder, errorHandler) {
    function fixedFromCharCode(code) {
        // String.prototype.fromCharCode does not supports
        // > 2 bytes unicode chars directly
        if (code > 0xffff) {
            code -= 0x10000;
            var surrogate1 = 0xd800 + (code >> 10), surrogate2 = 0xdc00 + (code & 0x3ff);
            return String.fromCharCode(surrogate1, surrogate2);
        } else return String.fromCharCode(code);
    }
    function entityReplacer(a) {
        var k = a.slice(1, -1);
        if (Object.hasOwnProperty.call(entityMap, k)) return entityMap[k];
        else if (k.charAt(0) === "#") return fixedFromCharCode(parseInt(k.substr(1).replace("x", "0x")));
        else {
            errorHandler.error("entity not found:" + a);
            return a;
        }
    }
    function appendText(end) {
        if (end > start) {
            var xt = source.substring(start, end).replace(/&#?\w+;/g, entityReplacer);
            locator && position(start);
            domBuilder.characters(xt, 0, end - start);
            start = end;
        }
    }
    function position(p, m) {
        while(p >= lineEnd && (m = linePattern.exec(source))){
            lineStart = m.index;
            lineEnd = lineStart + m[0].length;
            locator.lineNumber++;
        //console.log('line++:',locator,startPos,endPos)
        }
        locator.columnNumber = p - lineStart + 1;
    }
    var lineStart = 0;
    var lineEnd = 0;
    var linePattern = /.*(?:\r\n?|\n)|.*$/g;
    var locator = domBuilder.locator;
    var parseStack = [
        {
            currentNSMap: defaultNSMapCopy
        }
    ];
    var closeMap = {};
    var start = 0;
    while(true){
        try {
            var tagStart = source.indexOf("<", start);
            if (tagStart < 0) {
                if (!source.substr(start).match(/^\s*$/)) {
                    var doc = domBuilder.doc;
                    var text = doc.createTextNode(source.substr(start));
                    doc.appendChild(text);
                    domBuilder.currentElement = text;
                }
                return;
            }
            if (tagStart > start) appendText(tagStart);
            switch(source.charAt(tagStart + 1)){
                case "/":
                    var end = source.indexOf(">", tagStart + 3);
                    var tagName = source.substring(tagStart + 2, end).replace(/[ \t\n\r]+$/g, "");
                    var config = parseStack.pop();
                    if (end < 0) {
                        tagName = source.substring(tagStart + 2).replace(/[\s<].*/, "");
                        errorHandler.error("end tag name: " + tagName + " is not complete:" + config.tagName);
                        end = tagStart + 1 + tagName.length;
                    } else if (tagName.match(/\s</)) {
                        tagName = tagName.replace(/[\s<].*/, "");
                        errorHandler.error("end tag name: " + tagName + " maybe not complete");
                        end = tagStart + 1 + tagName.length;
                    }
                    var localNSMap = config.localNSMap;
                    var endMatch = config.tagName == tagName;
                    var endIgnoreCaseMach = endMatch || config.tagName && config.tagName.toLowerCase() == tagName.toLowerCase();
                    if (endIgnoreCaseMach) {
                        domBuilder.endElement(config.uri, config.localName, tagName);
                        if (localNSMap) {
                            for(var prefix in localNSMap)if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) domBuilder.endPrefixMapping(prefix);
                        }
                        if (!endMatch) errorHandler.fatalError("end tag name: " + tagName + " is not match the current start tagName:" + config.tagName); // No known test case
                    } else parseStack.push(config);
                    end++;
                    break;
                // end elment
                case "?":
                    locator && position(tagStart);
                    end = $0e9e0929092947dd$var$parseInstruction(source, tagStart, domBuilder);
                    break;
                case "!":
                    locator && position(tagStart);
                    end = $0e9e0929092947dd$var$parseDCC(source, tagStart, domBuilder, errorHandler);
                    break;
                default:
                    locator && position(tagStart);
                    var el = new $0e9e0929092947dd$var$ElementAttributes();
                    var currentNSMap = parseStack[parseStack.length - 1].currentNSMap;
                    //elStartEnd
                    var end = $0e9e0929092947dd$var$parseElementStartPart(source, tagStart, el, currentNSMap, entityReplacer, errorHandler);
                    var len = el.length;
                    if (!el.closed && $0e9e0929092947dd$var$fixSelfClosed(source, end, el.tagName, closeMap)) {
                        el.closed = true;
                        if (!entityMap.nbsp) errorHandler.warning("unclosed xml attribute");
                    }
                    if (locator && len) {
                        var locator2 = $0e9e0929092947dd$var$copyLocator(locator, {});
                        //try{//attribute position fixed
                        for(var i = 0; i < len; i++){
                            var a = el[i];
                            position(a.offset);
                            a.locator = $0e9e0929092947dd$var$copyLocator(locator, {});
                        }
                        domBuilder.locator = locator2;
                        if ($0e9e0929092947dd$var$appendElement(el, domBuilder, currentNSMap)) parseStack.push(el);
                        domBuilder.locator = locator;
                    } else if ($0e9e0929092947dd$var$appendElement(el, domBuilder, currentNSMap)) parseStack.push(el);
                    if ($0e9e0929092947dd$require$NAMESPACE.isHTML(el.uri) && !el.closed) end = $0e9e0929092947dd$var$parseHtmlSpecialContent(source, end, el.tagName, entityReplacer, domBuilder);
                    else end++;
            }
        } catch (e) {
            if (e instanceof $0e9e0929092947dd$var$ParseError) throw e;
            errorHandler.error("element parse error: " + e);
            end = -1;
        }
        if (end > start) start = end;
        else //TODO: 这里有可能sax回退，有位置错误风险
        appendText(Math.max(tagStart, start) + 1);
    }
}
function $0e9e0929092947dd$var$copyLocator(f, t) {
    t.lineNumber = f.lineNumber;
    t.columnNumber = f.columnNumber;
    return t;
}
/**
 * @see #appendElement(source,elStartEnd,el,selfClosed,entityReplacer,domBuilder,parseStack);
 * @return end of the elementStartPart(end of elementEndPart for selfClosed el)
 */ function $0e9e0929092947dd$var$parseElementStartPart(source, start, el, currentNSMap, entityReplacer, errorHandler) {
    /**
	 * @param {string} qname
	 * @param {string} value
	 * @param {number} startIndex
	 */ function addAttribute(qname, value, startIndex) {
        if (el.attributeNames.hasOwnProperty(qname)) errorHandler.fatalError("Attribute " + qname + " redefined");
        el.addValue(qname, // @see https://www.w3.org/TR/xml/#AVNormalize
        // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
        // - recursive replacement of (DTD) entity references
        // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
        value.replace(/[\t\n\r]/g, " ").replace(/&#?\w+;/g, entityReplacer), startIndex);
    }
    var attrName;
    var value;
    var p = ++start;
    var s = $0e9e0929092947dd$var$S_TAG; //status
    while(true){
        var c = source.charAt(p);
        switch(c){
            case "=":
                if (s === $0e9e0929092947dd$var$S_ATTR) {
                    attrName = source.slice(start, p);
                    s = $0e9e0929092947dd$var$S_EQ;
                } else if (s === $0e9e0929092947dd$var$S_ATTR_SPACE) s = $0e9e0929092947dd$var$S_EQ;
                else //fatalError: equal must after attrName or space after attrName
                throw new Error("attribute equal must after attrName"); // No known test case
                break;
            case "'":
            case '"':
                if (s === $0e9e0929092947dd$var$S_EQ || s === $0e9e0929092947dd$var$S_ATTR //|| s == S_ATTR_SPACE
                ) {
                    if (s === $0e9e0929092947dd$var$S_ATTR) {
                        errorHandler.warning('attribute value must after "="');
                        attrName = source.slice(start, p);
                    }
                    start = p + 1;
                    p = source.indexOf(c, start);
                    if (p > 0) {
                        value = source.slice(start, p);
                        addAttribute(attrName, value, start - 1);
                        s = $0e9e0929092947dd$var$S_ATTR_END;
                    } else //fatalError: no end quot match
                    throw new Error("attribute value no end '" + c + "' match");
                } else if (s == $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE) {
                    value = source.slice(start, p);
                    addAttribute(attrName, value, start);
                    errorHandler.warning('attribute "' + attrName + '" missed start quot(' + c + ")!!");
                    start = p + 1;
                    s = $0e9e0929092947dd$var$S_ATTR_END;
                } else //fatalError: no equal before
                throw new Error('attribute value must after "="'); // No known test case
                break;
            case "/":
                switch(s){
                    case $0e9e0929092947dd$var$S_TAG:
                        el.setTagName(source.slice(start, p));
                    case $0e9e0929092947dd$var$S_ATTR_END:
                    case $0e9e0929092947dd$var$S_TAG_SPACE:
                    case $0e9e0929092947dd$var$S_TAG_CLOSE:
                        s = $0e9e0929092947dd$var$S_TAG_CLOSE;
                        el.closed = true;
                    case $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE:
                    case $0e9e0929092947dd$var$S_ATTR:
                        break;
                    case $0e9e0929092947dd$var$S_ATTR_SPACE:
                        el.closed = true;
                        break;
                    //case S_EQ:
                    default:
                        throw new Error("attribute invalid close char('/')") // No known test case
                        ;
                }
                break;
            case "":
                errorHandler.error("unexpected end of input");
                if (s == $0e9e0929092947dd$var$S_TAG) el.setTagName(source.slice(start, p));
                return p;
            case ">":
                switch(s){
                    case $0e9e0929092947dd$var$S_TAG:
                        el.setTagName(source.slice(start, p));
                    case $0e9e0929092947dd$var$S_ATTR_END:
                    case $0e9e0929092947dd$var$S_TAG_SPACE:
                    case $0e9e0929092947dd$var$S_TAG_CLOSE:
                        break; //normal
                    case $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE:
                    case $0e9e0929092947dd$var$S_ATTR:
                        value = source.slice(start, p);
                        if (value.slice(-1) === "/") {
                            el.closed = true;
                            value = value.slice(0, -1);
                        }
                    case $0e9e0929092947dd$var$S_ATTR_SPACE:
                        if (s === $0e9e0929092947dd$var$S_ATTR_SPACE) value = attrName;
                        if (s == $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE) {
                            errorHandler.warning('attribute "' + value + '" missed quot(")!');
                            addAttribute(attrName, value, start);
                        } else {
                            if (!$0e9e0929092947dd$require$NAMESPACE.isHTML(currentNSMap[""]) || !value.match(/^(?:disabled|checked|selected)$/i)) errorHandler.warning('attribute "' + value + '" missed value!! "' + value + '" instead!!');
                            addAttribute(value, value, start);
                        }
                        break;
                    case $0e9e0929092947dd$var$S_EQ:
                        throw new Error("attribute value missed!!");
                }
                //			console.log(tagName,tagNamePattern,tagNamePattern.test(tagName))
                return p;
            /*xml space '\x20' | #x9 | #xD | #xA; */ case "\x80":
                c = " ";
            default:
                if (c <= " ") switch(s){
                    case $0e9e0929092947dd$var$S_TAG:
                        el.setTagName(source.slice(start, p)); //tagName
                        s = $0e9e0929092947dd$var$S_TAG_SPACE;
                        break;
                    case $0e9e0929092947dd$var$S_ATTR:
                        attrName = source.slice(start, p);
                        s = $0e9e0929092947dd$var$S_ATTR_SPACE;
                        break;
                    case $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE:
                        var value = source.slice(start, p);
                        errorHandler.warning('attribute "' + value + '" missed quot(")!!');
                        addAttribute(attrName, value, start);
                    case $0e9e0929092947dd$var$S_ATTR_END:
                        s = $0e9e0929092947dd$var$S_TAG_SPACE;
                        break;
                }
                else //S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
                //S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
                switch(s){
                    //case S_TAG:void();break;
                    //case S_ATTR:void();break;
                    //case S_ATTR_NOQUOT_VALUE:void();break;
                    case $0e9e0929092947dd$var$S_ATTR_SPACE:
                        var tagName = el.tagName;
                        if (!$0e9e0929092947dd$require$NAMESPACE.isHTML(currentNSMap[""]) || !attrName.match(/^(?:disabled|checked|selected)$/i)) errorHandler.warning('attribute "' + attrName + '" missed value!! "' + attrName + '" instead2!!');
                        addAttribute(attrName, attrName, start);
                        start = p;
                        s = $0e9e0929092947dd$var$S_ATTR;
                        break;
                    case $0e9e0929092947dd$var$S_ATTR_END:
                        errorHandler.warning('attribute space is required"' + attrName + '"!!');
                    case $0e9e0929092947dd$var$S_TAG_SPACE:
                        s = $0e9e0929092947dd$var$S_ATTR;
                        start = p;
                        break;
                    case $0e9e0929092947dd$var$S_EQ:
                        s = $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE;
                        start = p;
                        break;
                    case $0e9e0929092947dd$var$S_TAG_CLOSE:
                        throw new Error("elements closed character '/' and '>' must be connected to");
                }
        } //end outer switch
        //console.log('p++',p)
        p++;
    }
}
/**
 * @return true if has new namespace define
 */ function $0e9e0929092947dd$var$appendElement(el, domBuilder, currentNSMap) {
    var tagName = el.tagName;
    var localNSMap = null;
    //var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
    var i = el.length;
    while(i--){
        var a = el[i];
        var qName = a.qName;
        var value = a.value;
        var nsp = qName.indexOf(":");
        if (nsp > 0) {
            var prefix = a.prefix = qName.slice(0, nsp);
            var localName = qName.slice(nsp + 1);
            var nsPrefix = prefix === "xmlns" && localName;
        } else {
            localName = qName;
            prefix = null;
            nsPrefix = qName === "xmlns" && "";
        }
        //can not set prefix,because prefix !== ''
        a.localName = localName;
        //prefix == null for no ns prefix attribute
        if (nsPrefix !== false) {
            if (localNSMap == null) {
                localNSMap = {};
                //console.log(currentNSMap,0)
                $0e9e0929092947dd$var$_copy(currentNSMap, currentNSMap = {});
            //console.log(currentNSMap,1)
            }
            currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
            a.uri = $0e9e0929092947dd$require$NAMESPACE.XMLNS;
            domBuilder.startPrefixMapping(nsPrefix, value);
        }
    }
    var i = el.length;
    while(i--){
        a = el[i];
        var prefix = a.prefix;
        if (prefix) {
            if (prefix === "xml") a.uri = $0e9e0929092947dd$require$NAMESPACE.XML;
            if (prefix !== "xmlns") a.uri = currentNSMap[prefix || ""];
        }
    }
    var nsp = tagName.indexOf(":");
    if (nsp > 0) {
        prefix = el.prefix = tagName.slice(0, nsp);
        localName = el.localName = tagName.slice(nsp + 1);
    } else {
        prefix = null; //important!!
        localName = el.localName = tagName;
    }
    //no prefix element has default namespace
    var ns = el.uri = currentNSMap[prefix || ""];
    domBuilder.startElement(ns, localName, tagName, el);
    //endPrefixMapping and startPrefixMapping have not any help for dom builder
    //localNSMap = null
    if (el.closed) {
        domBuilder.endElement(ns, localName, tagName);
        if (localNSMap) {
            for(prefix in localNSMap)if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) domBuilder.endPrefixMapping(prefix);
        }
    } else {
        el.currentNSMap = currentNSMap;
        el.localNSMap = localNSMap;
        //parseStack.push(el);
        return true;
    }
}
function $0e9e0929092947dd$var$parseHtmlSpecialContent(source, elStartEnd, tagName, entityReplacer, domBuilder) {
    if (/^(?:script|textarea)$/i.test(tagName)) {
        var elEndStart = source.indexOf("</" + tagName + ">", elStartEnd);
        var text = source.substring(elStartEnd + 1, elEndStart);
        if (/[&<]/.test(text)) {
            if (/^script$/i.test(tagName)) {
                //if(!/\]\]>/.test(text)){
                //lexHandler.startCDATA();
                domBuilder.characters(text, 0, text.length);
                //lexHandler.endCDATA();
                return elEndStart;
            //}
            } //}else{//text area
            text = text.replace(/&#?\w+;/g, entityReplacer);
            domBuilder.characters(text, 0, text.length);
            return elEndStart;
        //}
        }
    }
    return elStartEnd + 1;
}
function $0e9e0929092947dd$var$fixSelfClosed(source, elStartEnd, tagName, closeMap) {
    //if(tagName in closeMap){
    var pos = closeMap[tagName];
    if (pos == null) {
        //console.log(tagName)
        pos = source.lastIndexOf("</" + tagName + ">");
        if (pos < elStartEnd) pos = source.lastIndexOf("</" + tagName);
        closeMap[tagName] = pos;
    }
    return pos < elStartEnd;
//}
}
function $0e9e0929092947dd$var$_copy(source, target) {
    for(var n in source)if (Object.prototype.hasOwnProperty.call(source, n)) target[n] = source[n];
}
function $0e9e0929092947dd$var$parseDCC(source, start, domBuilder, errorHandler) {
    var next = source.charAt(start + 2);
    switch(next){
        case "-":
            if (source.charAt(start + 3) === "-") {
                var end = source.indexOf("-->", start + 4);
                //append comment source.substring(4,end)//<!--
                if (end > start) {
                    domBuilder.comment(source, start + 4, end - start - 4);
                    return end + 3;
                } else {
                    errorHandler.error("Unclosed comment");
                    return -1;
                }
            } else //error
            return -1;
        default:
            if (source.substr(start + 3, 6) == "CDATA[") {
                var end = source.indexOf("]]>", start + 9);
                domBuilder.startCDATA();
                domBuilder.characters(source, start + 9, end - start - 9);
                domBuilder.endCDATA();
                return end + 3;
            }
            //<!DOCTYPE
            //startDTD(java.lang.String name, java.lang.String publicId, java.lang.String systemId)
            var matchs = $0e9e0929092947dd$var$split(source, start);
            var len = matchs.length;
            if (len > 1 && /!doctype/i.test(matchs[0][0])) {
                var name = matchs[1][0];
                var pubid = false;
                var sysid = false;
                if (len > 3) {
                    if (/^public$/i.test(matchs[2][0])) {
                        pubid = matchs[3][0];
                        sysid = len > 4 && matchs[4][0];
                    } else if (/^system$/i.test(matchs[2][0])) sysid = matchs[3][0];
                }
                var lastMatch = matchs[len - 1];
                domBuilder.startDTD(name, pubid, sysid);
                domBuilder.endDTD();
                return lastMatch.index + lastMatch[0].length;
            }
    }
    return -1;
}
function $0e9e0929092947dd$var$parseInstruction(source, start, domBuilder) {
    var end = source.indexOf("?>", start);
    if (end) {
        var match = source.substring(start, end).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
        if (match) {
            var len = match[0].length;
            domBuilder.processingInstruction(match[1], match[2]);
            return end + 2;
        } else return -1;
    }
    return -1;
}
function $0e9e0929092947dd$var$ElementAttributes() {
    this.attributeNames = {};
}
$0e9e0929092947dd$var$ElementAttributes.prototype = {
    setTagName: function(tagName) {
        if (!$0e9e0929092947dd$var$tagNamePattern.test(tagName)) throw new Error("invalid tagName:" + tagName);
        this.tagName = tagName;
    },
    addValue: function(qName, value, offset) {
        if (!$0e9e0929092947dd$var$tagNamePattern.test(qName)) throw new Error("invalid attribute:" + qName);
        this.attributeNames[qName] = this.length;
        this[this.length++] = {
            qName: qName,
            value: value,
            offset: offset
        };
    },
    length: 0,
    getLocalName: function(i) {
        return this[i].localName;
    },
    getLocator: function(i) {
        return this[i].locator;
    },
    getQName: function(i) {
        return this[i].qName;
    },
    getURI: function(i) {
        return this[i].uri;
    },
    getValue: function(i) {
        return this[i].value;
    }
};
function $0e9e0929092947dd$var$split(source, start) {
    var match;
    var buf = [];
    var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
    reg.lastIndex = start;
    reg.exec(source); //skip <
    while(match = reg.exec(source)){
        buf.push(match);
        if (match[1]) return buf;
    }
}
$0e9e0929092947dd$export$ccbc9f9f018333e9 = $0e9e0929092947dd$var$XMLReader;
$0e9e0929092947dd$export$f9c837a54db411d = $0e9e0929092947dd$var$ParseError;

});




parcelRegister("biuEp", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ "use strict";

var $dBHwk = parcelRequire("dBHwk");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    "'"
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape), hostEndingChars = [
    "/",
    "?",
    "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};

var $2rasJ = parcelRequire("2rasJ");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === "object" && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== "string") throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $2rasJ.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf("@", hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || "";
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $dBHwk.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $2rasJ.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === "string") obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && typeof this.query === "object" && Object.keys(this.query).length) query = $2rasJ.stringify(this.query, {
        arrayFormat: "repeat",
        addQueryPrefix: false
    });
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === "string") {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = "/";
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (srcPath.length > 0) result.pathname = srcPath.join("/");
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("dBHwk", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.4.1",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("2rasJ", function(module, exports) {
"use strict";

var $jJyEy = parcelRequire("jJyEy");

var $cfYIz = parcelRequire("cfYIz");

var $i1Gbt = parcelRequire("i1Gbt");
module.exports = {
    formats: $i1Gbt,
    parse: $cfYIz,
    stringify: $jJyEy
};

});
parcelRegister("jJyEy", function(module, exports) {
"use strict";

var $LlIML = parcelRequire("LlIML");

var $iBfJ5 = parcelRequire("iBfJ5");

var $i1Gbt = parcelRequire("i1Gbt");
var $e5dd19a945a45bbb$var$has = Object.prototype.hasOwnProperty;
var $e5dd19a945a45bbb$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $e5dd19a945a45bbb$var$isArray = Array.isArray;
var $e5dd19a945a45bbb$var$push = Array.prototype.push;
var $e5dd19a945a45bbb$var$pushToArray = function(arr, valueOrArray) {
    $e5dd19a945a45bbb$var$push.apply(arr, $e5dd19a945a45bbb$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $e5dd19a945a45bbb$var$toISO = Date.prototype.toISOString;
var $e5dd19a945a45bbb$var$defaultFormat = $i1Gbt.default;
var $e5dd19a945a45bbb$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encodeDotInKeys: false,
    encoder: $iBfJ5.encode,
    encodeValuesOnly: false,
    format: $e5dd19a945a45bbb$var$defaultFormat,
    formatter: $i1Gbt.formatters[$e5dd19a945a45bbb$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $e5dd19a945a45bbb$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $e5dd19a945a45bbb$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $e5dd19a945a45bbb$var$sentinel = {};
var $e5dd19a945a45bbb$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($e5dd19a945a45bbb$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($e5dd19a945a45bbb$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $e5dd19a945a45bbb$var$isArray(obj)) obj = $iBfJ5.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($e5dd19a945a45bbb$var$isNonNullishPrimitive(obj) || $iBfJ5.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $e5dd19a945a45bbb$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $e5dd19a945a45bbb$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $iBfJ5.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($e5dd19a945a45bbb$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
    var adjustedPrefix = commaRoundTrip && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
    if (allowEmptyArrays && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 0) return adjustedPrefix + "[]";
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
        var keyPrefix = $e5dd19a945a45bbb$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $LlIML();
        valueSideChannel.set($e5dd19a945a45bbb$var$sentinel, sideChannel);
        $e5dd19a945a45bbb$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === "comma" && encodeValuesOnly && $e5dd19a945a45bbb$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $e5dd19a945a45bbb$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $e5dd19a945a45bbb$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $e5dd19a945a45bbb$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $i1Gbt.default;
    if (typeof opts.format !== "undefined") {
        if (!$e5dd19a945a45bbb$var$has.call($i1Gbt.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $i1Gbt.formatters[format];
    var filter = $e5dd19a945a45bbb$var$defaults.filter;
    if (typeof opts.filter === "function" || $e5dd19a945a45bbb$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $e5dd19a945a45bbb$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ("indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = $e5dd19a945a45bbb$var$defaults.arrayFormat;
    if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : $e5dd19a945a45bbb$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $e5dd19a945a45bbb$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $e5dd19a945a45bbb$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $e5dd19a945a45bbb$var$defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === "undefined" ? $e5dd19a945a45bbb$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $e5dd19a945a45bbb$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : $e5dd19a945a45bbb$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $e5dd19a945a45bbb$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $e5dd19a945a45bbb$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $e5dd19a945a45bbb$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $e5dd19a945a45bbb$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $e5dd19a945a45bbb$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $e5dd19a945a45bbb$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($e5dd19a945a45bbb$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var generateArrayPrefix = $e5dd19a945a45bbb$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $LlIML();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $e5dd19a945a45bbb$var$pushToArray(keys, $e5dd19a945a45bbb$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("LlIML", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $hXu6F = parcelRequire("hXu6F");

var $e7DLx = parcelRequire("e7DLx");

var $eEkyn = parcelRequire("eEkyn");
var $08e53d4ef2e1f8ef$var$$WeakMap = $1zENl("%WeakMap%", true);
var $08e53d4ef2e1f8ef$var$$Map = $1zENl("%Map%", true);
var $08e53d4ef2e1f8ef$var$$weakMapGet = $hXu6F("WeakMap.prototype.get", true);
var $08e53d4ef2e1f8ef$var$$weakMapSet = $hXu6F("WeakMap.prototype.set", true);
var $08e53d4ef2e1f8ef$var$$weakMapHas = $hXu6F("WeakMap.prototype.has", true);
var $08e53d4ef2e1f8ef$var$$mapGet = $hXu6F("Map.prototype.get", true);
var $08e53d4ef2e1f8ef$var$$mapSet = $hXu6F("Map.prototype.set", true);
var $08e53d4ef2e1f8ef$var$$mapHas = $hXu6F("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var $08e53d4ef2e1f8ef$var$listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var $08e53d4ef2e1f8ef$var$listGet = function(objects, key) {
    var node = $08e53d4ef2e1f8ef$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var $08e53d4ef2e1f8ef$var$listSet = function(objects, key, value) {
    var node = $08e53d4ef2e1f8ef$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var $08e53d4ef2e1f8ef$var$listHas = function(objects, key) {
    return !!$08e53d4ef2e1f8ef$var$listGetNode(objects, key);
};
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eEkyn("Side channel does not contain " + $e7DLx(key));
        },
        get: function(key) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $08e53d4ef2e1f8ef$var$$weakMapGet($wm, key);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if ($m) return $08e53d4ef2e1f8ef$var$$mapGet($m, key);
            } else {
                if ($o) return $08e53d4ef2e1f8ef$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $08e53d4ef2e1f8ef$var$$weakMapHas($wm, key);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if ($m) return $08e53d4ef2e1f8ef$var$$mapHas($m, key);
            } else {
                if ($o) return $08e53d4ef2e1f8ef$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $08e53d4ef2e1f8ef$var$$WeakMap();
                $08e53d4ef2e1f8ef$var$$weakMapSet($wm, key, value);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if (!$m) $m = new $08e53d4ef2e1f8ef$var$$Map();
                $08e53d4ef2e1f8ef$var$$mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                $08e53d4ef2e1f8ef$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("e7DLx", function(module, exports) {
var $a48090c7c3dfd2b6$var$hasMap = typeof Map === "function" && Map.prototype;
var $a48090c7c3dfd2b6$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $a48090c7c3dfd2b6$var$mapSize = $a48090c7c3dfd2b6$var$hasMap && $a48090c7c3dfd2b6$var$mapSizeDescriptor && typeof $a48090c7c3dfd2b6$var$mapSizeDescriptor.get === "function" ? $a48090c7c3dfd2b6$var$mapSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$mapForEach = $a48090c7c3dfd2b6$var$hasMap && Map.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasSet = typeof Set === "function" && Set.prototype;
var $a48090c7c3dfd2b6$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $a48090c7c3dfd2b6$var$setSize = $a48090c7c3dfd2b6$var$hasSet && $a48090c7c3dfd2b6$var$setSizeDescriptor && typeof $a48090c7c3dfd2b6$var$setSizeDescriptor.get === "function" ? $a48090c7c3dfd2b6$var$setSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$setForEach = $a48090c7c3dfd2b6$var$hasSet && Set.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $a48090c7c3dfd2b6$var$weakMapHas = $a48090c7c3dfd2b6$var$hasWeakMap ? WeakMap.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $a48090c7c3dfd2b6$var$weakSetHas = $a48090c7c3dfd2b6$var$hasWeakSet ? WeakSet.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $a48090c7c3dfd2b6$var$weakRefDeref = $a48090c7c3dfd2b6$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $a48090c7c3dfd2b6$var$booleanValueOf = Boolean.prototype.valueOf;
var $a48090c7c3dfd2b6$var$objectToString = Object.prototype.toString;
var $a48090c7c3dfd2b6$var$functionToString = Function.prototype.toString;
var $a48090c7c3dfd2b6$var$$match = String.prototype.match;
var $a48090c7c3dfd2b6$var$$slice = String.prototype.slice;
var $a48090c7c3dfd2b6$var$$replace = String.prototype.replace;
var $a48090c7c3dfd2b6$var$$toUpperCase = String.prototype.toUpperCase;
var $a48090c7c3dfd2b6$var$$toLowerCase = String.prototype.toLowerCase;
var $a48090c7c3dfd2b6$var$$test = RegExp.prototype.test;
var $a48090c7c3dfd2b6$var$$concat = Array.prototype.concat;
var $a48090c7c3dfd2b6$var$$join = Array.prototype.join;
var $a48090c7c3dfd2b6$var$$arrSlice = Array.prototype.slice;
var $a48090c7c3dfd2b6$var$$floor = Math.floor;
var $a48090c7c3dfd2b6$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $a48090c7c3dfd2b6$var$gOPS = Object.getOwnPropertySymbols;
var $a48090c7c3dfd2b6$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $a48090c7c3dfd2b6$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $a48090c7c3dfd2b6$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $a48090c7c3dfd2b6$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $a48090c7c3dfd2b6$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $a48090c7c3dfd2b6$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $a48090c7c3dfd2b6$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $a48090c7c3dfd2b6$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$a48090c7c3dfd2b6$var$$floor(-num) : $a48090c7c3dfd2b6$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $a48090c7c3dfd2b6$var$$slice.call(str, intStr.length + 1);
            return $a48090c7c3dfd2b6$var$$replace.call(intStr, sepRegex, "$&_") + "." + $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $a48090c7c3dfd2b6$var$$replace.call(str, sepRegex, "$&_");
}

var $kjyEk = parcelRequire("kjyEk");
var $a48090c7c3dfd2b6$var$inspectCustom = $kjyEk.custom;
var $a48090c7c3dfd2b6$var$inspectSymbol = $a48090c7c3dfd2b6$var$isSymbol($a48090c7c3dfd2b6$var$inspectCustom) ? $a48090c7c3dfd2b6$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($a48090c7c3dfd2b6$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($a48090c7c3dfd2b6$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $a48090c7c3dfd2b6$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($a48090c7c3dfd2b6$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($a48090c7c3dfd2b6$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $a48090c7c3dfd2b6$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $a48090c7c3dfd2b6$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $a48090c7c3dfd2b6$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($a48090c7c3dfd2b6$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $a48090c7c3dfd2b6$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($a48090c7c3dfd2b6$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var name = $a48090c7c3dfd2b6$var$nameOf(obj);
        var keys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $a48090c7c3dfd2b6$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($a48090c7c3dfd2b6$var$isSymbol(obj)) {
        var symString = $a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $a48090c7c3dfd2b6$var$symToString.call(obj);
        return typeof obj === "object" && !$a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$markBoxed(symString) : symString;
    }
    if ($a48090c7c3dfd2b6$var$isElement(obj)) {
        var s = "<" + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $a48090c7c3dfd2b6$var$wrapQuotes($a48090c7c3dfd2b6$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($a48090c7c3dfd2b6$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (indent && !$a48090c7c3dfd2b6$var$singleLineValues(xs)) return "[" + $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) + "]";
        return "[ " + $a48090c7c3dfd2b6$var$$join.call(xs, ", ") + " ]";
    }
    if ($a48090c7c3dfd2b6$var$isError(obj)) {
        var parts = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$a48090c7c3dfd2b6$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $a48090c7c3dfd2b6$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($a48090c7c3dfd2b6$var$inspectSymbol && typeof obj[$a48090c7c3dfd2b6$var$inspectSymbol] === "function" && $kjyEk) return $kjyEk(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($a48090c7c3dfd2b6$var$isMap(obj)) {
        var mapParts = [];
        if ($a48090c7c3dfd2b6$var$mapForEach) $a48090c7c3dfd2b6$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf("Map", $a48090c7c3dfd2b6$var$mapSize.call(obj), mapParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isSet(obj)) {
        var setParts = [];
        if ($a48090c7c3dfd2b6$var$setForEach) $a48090c7c3dfd2b6$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf("Set", $a48090c7c3dfd2b6$var$setSize.call(obj), setParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isWeakMap(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakMap");
    if ($a48090c7c3dfd2b6$var$isWeakSet(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakSet");
    if ($a48090c7c3dfd2b6$var$isWeakRef(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakRef");
    if ($a48090c7c3dfd2b6$var$isNumber(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(Number(obj)));
    if ($a48090c7c3dfd2b6$var$isBigInt(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect($a48090c7c3dfd2b6$var$bigIntValueOf.call(obj)));
    if ($a48090c7c3dfd2b6$var$isBoolean(obj)) return $a48090c7c3dfd2b6$var$markBoxed($a48090c7c3dfd2b6$var$booleanValueOf.call(obj));
    if ($a48090c7c3dfd2b6$var$isString(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (obj === $parcel$global) return "{ [object globalThis] }";
    if (!$a48090c7c3dfd2b6$var$isDate(obj) && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var ys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        var isPlainObject = $a48090c7c3dfd2b6$var$gPO ? $a48090c7c3dfd2b6$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $a48090c7c3dfd2b6$var$toStringTag && Object(obj) === obj && $a48090c7c3dfd2b6$var$toStringTag in obj ? $a48090c7c3dfd2b6$var$$slice.call($a48090c7c3dfd2b6$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $a48090c7c3dfd2b6$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $a48090c7c3dfd2b6$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $a48090c7c3dfd2b6$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $a48090c7c3dfd2b6$var$quote(s) {
    return $a48090c7c3dfd2b6$var$$replace.call(String(s), /"/g, "&quot;");
}
function $a48090c7c3dfd2b6$var$isArray(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Array]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isDate(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Date]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isRegExp(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object RegExp]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isError(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Error]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isString(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object String]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isNumber(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Number]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isBoolean(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Boolean]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $a48090c7c3dfd2b6$var$isSymbol(obj) {
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$a48090c7c3dfd2b6$var$symToString) return false;
    try {
        $a48090c7c3dfd2b6$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$a48090c7c3dfd2b6$var$bigIntValueOf) return false;
    try {
        $a48090c7c3dfd2b6$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $a48090c7c3dfd2b6$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $a48090c7c3dfd2b6$var$has(obj, key) {
    return $a48090c7c3dfd2b6$var$hasOwn.call(obj, key);
}
function $a48090c7c3dfd2b6$var$toStr(obj) {
    return $a48090c7c3dfd2b6$var$objectToString.call(obj);
}
function $a48090c7c3dfd2b6$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $a48090c7c3dfd2b6$var$$match.call($a48090c7c3dfd2b6$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $a48090c7c3dfd2b6$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $a48090c7c3dfd2b6$var$isMap(x) {
    if (!$a48090c7c3dfd2b6$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$mapSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakMap(x) {
    if (!$a48090c7c3dfd2b6$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        try {
            $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakRef(x) {
    if (!$a48090c7c3dfd2b6$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isSet(x) {
    if (!$a48090c7c3dfd2b6$var$setSize || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$setSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakSet(x) {
    if (!$a48090c7c3dfd2b6$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        try {
            $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $a48090c7c3dfd2b6$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $a48090c7c3dfd2b6$var$inspectString($a48090c7c3dfd2b6$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $a48090c7c3dfd2b6$var$lowbyte);
    return $a48090c7c3dfd2b6$var$wrapQuotes(s, "single", opts);
}
function $a48090c7c3dfd2b6$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $a48090c7c3dfd2b6$var$$toUpperCase.call(n.toString(16));
}
function $a48090c7c3dfd2b6$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $a48090c7c3dfd2b6$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $a48090c7c3dfd2b6$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $a48090c7c3dfd2b6$var$indentedJoin(entries, indent) : $a48090c7c3dfd2b6$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $a48090c7c3dfd2b6$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($a48090c7c3dfd2b6$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $a48090c7c3dfd2b6$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $a48090c7c3dfd2b6$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $a48090c7c3dfd2b6$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $a48090c7c3dfd2b6$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect) {
    var isArr = $a48090c7c3dfd2b6$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $a48090c7c3dfd2b6$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $a48090c7c3dfd2b6$var$gOPS === "function" ? $a48090c7c3dfd2b6$var$gOPS(obj) : [];
    var symMap;
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$a48090c7c3dfd2b6$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($a48090c7c3dfd2b6$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($a48090c7c3dfd2b6$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $a48090c7c3dfd2b6$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($a48090c7c3dfd2b6$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});



parcelRegister("iBfJ5", function(module, exports) {
"use strict";

var $i1Gbt = parcelRequire("i1Gbt");
var $d8a7e190fdc9c6e7$var$has = Object.prototype.hasOwnProperty;
var $d8a7e190fdc9c6e7$var$isArray = Array.isArray;
var $d8a7e190fdc9c6e7$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $d8a7e190fdc9c6e7$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($d8a7e190fdc9c6e7$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $d8a7e190fdc9c6e7$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $d8a7e190fdc9c6e7$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($d8a7e190fdc9c6e7$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$d8a7e190fdc9c6e7$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($d8a7e190fdc9c6e7$var$isArray(target) && !$d8a7e190fdc9c6e7$var$isArray(source)) mergeTarget = $d8a7e190fdc9c6e7$var$arrayToObject(target, options);
    if ($d8a7e190fdc9c6e7$var$isArray(target) && $d8a7e190fdc9c6e7$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($d8a7e190fdc9c6e7$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($d8a7e190fdc9c6e7$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $d8a7e190fdc9c6e7$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $d8a7e190fdc9c6e7$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $d8a7e190fdc9c6e7$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $i1Gbt.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $d8a7e190fdc9c6e7$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($d8a7e190fdc9c6e7$var$hexTable[0xC0 | c >> 6] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($d8a7e190fdc9c6e7$var$hexTable[0xE0 | c >> 12] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $d8a7e190fdc9c6e7$var$hexTable[0xF0 | c >> 18] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 12 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $d8a7e190fdc9c6e7$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $d8a7e190fdc9c6e7$var$compactQueue(queue);
    return value;
};
var $d8a7e190fdc9c6e7$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $d8a7e190fdc9c6e7$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $d8a7e190fdc9c6e7$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $d8a7e190fdc9c6e7$var$maybeMap = function maybeMap(val, fn) {
    if ($d8a7e190fdc9c6e7$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $d8a7e190fdc9c6e7$var$arrayToObject,
    assign: $d8a7e190fdc9c6e7$var$assign,
    combine: $d8a7e190fdc9c6e7$var$combine,
    compact: $d8a7e190fdc9c6e7$var$compact,
    decode: $d8a7e190fdc9c6e7$var$decode,
    encode: $d8a7e190fdc9c6e7$var$encode,
    isBuffer: $d8a7e190fdc9c6e7$var$isBuffer,
    isRegExp: $d8a7e190fdc9c6e7$var$isRegExp,
    maybeMap: $d8a7e190fdc9c6e7$var$maybeMap,
    merge: $d8a7e190fdc9c6e7$var$merge
};

});
parcelRegister("i1Gbt", function(module, exports) {
"use strict";
var $d1f90adf4e1eece6$var$replace = String.prototype.replace;
var $d1f90adf4e1eece6$var$percentTwenties = /%20/g;
var $d1f90adf4e1eece6$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $d1f90adf4e1eece6$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $d1f90adf4e1eece6$var$replace.call(value, $d1f90adf4e1eece6$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $d1f90adf4e1eece6$var$Format.RFC1738,
    RFC3986: $d1f90adf4e1eece6$var$Format.RFC3986
};

});



parcelRegister("cfYIz", function(module, exports) {
"use strict";

var $iBfJ5 = parcelRequire("iBfJ5");
var $8ec5fc0fdc198ba4$var$has = Object.prototype.hasOwnProperty;
var $8ec5fc0fdc198ba4$var$isArray = Array.isArray;
var $8ec5fc0fdc198ba4$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: true,
    decoder: $iBfJ5.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $8ec5fc0fdc198ba4$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $8ec5fc0fdc198ba4$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $8ec5fc0fdc198ba4$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $8ec5fc0fdc198ba4$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $8ec5fc0fdc198ba4$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $8ec5fc0fdc198ba4$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $8ec5fc0fdc198ba4$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "key");
            val = $iBfJ5.maybeMap($8ec5fc0fdc198ba4$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $8ec5fc0fdc198ba4$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $8ec5fc0fdc198ba4$var$isArray(val) ? [
            val
        ] : val;
        var existing = $8ec5fc0fdc198ba4$var$has.call(obj, key);
        if (existing && options.duplicates === "combine") obj[key] = $iBfJ5.combine(obj[key], val);
        else if (!existing || options.duplicates === "last") obj[key] = val;
    }
    return obj;
};
var $8ec5fc0fdc198ba4$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $8ec5fc0fdc198ba4$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = options.allowEmptyArrays && leaf === "" ? [] : [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== "__proto__") obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $8ec5fc0fdc198ba4$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $8ec5fc0fdc198ba4$var$parseObject(keys, val, options, valuesParsed);
};
var $8ec5fc0fdc198ba4$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $8ec5fc0fdc198ba4$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $8ec5fc0fdc198ba4$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === "undefined" ? $8ec5fc0fdc198ba4$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : $8ec5fc0fdc198ba4$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $8ec5fc0fdc198ba4$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $8ec5fc0fdc198ba4$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $8ec5fc0fdc198ba4$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $8ec5fc0fdc198ba4$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $8ec5fc0fdc198ba4$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $8ec5fc0fdc198ba4$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : $8ec5fc0fdc198ba4$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $8ec5fc0fdc198ba4$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $iBfJ5.isRegExp(opts.delimiter) ? opts.delimiter : $8ec5fc0fdc198ba4$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $8ec5fc0fdc198ba4$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $8ec5fc0fdc198ba4$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $8ec5fc0fdc198ba4$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $8ec5fc0fdc198ba4$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $8ec5fc0fdc198ba4$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $8ec5fc0fdc198ba4$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $8ec5fc0fdc198ba4$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $8ec5fc0fdc198ba4$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $iBfJ5.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $iBfJ5.compact(obj);
};

});



parcelRegister("v6ngW", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2brbW").then(()=>parcelRequire("5MOo6"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("6qlDJ", function(module, exports) {
"use strict";
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/master/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol("Symbol.dispose"),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol("Symbol.asyncDispose"),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("cSbri", function(module, exports) {
"use strict";

var $6ZWSX = parcelRequire("6ZWSX");

var $6qlDJ = parcelRequire("6qlDJ");
var $95f366cd9222c75c$require$kResistStopPropagation = $6qlDJ.kResistStopPropagation;
var $95f366cd9222c75c$require$SymbolDispose = $6qlDJ.SymbolDispose;

const $95f366cd9222c75c$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("bHKGd")).AbortSignal;

const $95f366cd9222c75c$var$AbortController = globalThis.AbortController || (parcelRequire("bHKGd")).AbortController;
const $95f366cd9222c75c$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $95f366cd9222c75c$var$Blob = globalThis.Blob || $6ZWSX.Blob;
/* eslint-disable indent */ const $95f366cd9222c75c$var$isBlob = typeof $95f366cd9222c75c$var$Blob !== "undefined" ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $95f366cd9222c75c$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $95f366cd9222c75c$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== "object" || !("aborted" in signal))) throw new ERR_INVALID_ARG_TYPE(name, "AbortSignal", signal);
};
const $95f366cd9222c75c$var$validateFunction = (value, name)=>{
    if (typeof value !== "function") throw new ERR_INVALID_ARG_TYPE(name, "Function", value);
};
// This is a simplified version of AggregateError
class $95f366cd9222c75c$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = "";
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = "AggregateError";
        this.errors = errors;
    }
}

module.exports = {
    AggregateError: $95f366cd9222c75c$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === "f") return replacement.toFixed(6);
            else if (type === "j") return JSON.stringify(replacement);
            else if (type === "s" && typeof replacement === "object") {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : "";
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case "string":
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes("`") && !value.includes("${")) return `\`${value}\``;
                }
                return `'${value}'`;
            case "number":
                if (isNaN(value)) return "NaN";
                else if (Object.is(value, -0)) return String(value);
                return value;
            case "bigint":
                return `${String(value)}n`;
            case "boolean":
            case "undefined":
                return String(value);
            case "object":
                return "{}";
        }
    },
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $95f366cd9222c75c$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $95f366cd9222c75c$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("7etJZ")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new ERR_INVALID_ARG_TYPE("signal", "AbortSignal", signal);
        $95f366cd9222c75c$var$validateAbortSignal(signal, "signal");
        $95f366cd9222c75c$var$validateFunction(listener, "listener");
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener("abort", listener, {
                __proto__: null,
                once: true,
                [$95f366cd9222c75c$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener("abort", listener);
            };
        }
        return {
            __proto__: null,
            [$95f366cd9222c75c$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $95f366cd9222c75c$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $95f366cd9222c75c$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $95f366cd9222c75c$var$validateAbortSignal(signal, "signals");
            signal.addEventListener("abort", abort, {
                once: true
            });
        });
        ac.signal.addEventListener("abort", ()=>{
            signals.forEach((signal)=>signal.removeEventListener("abort", abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for("nodejs.util.promisify.custom");

});
parcelRegister("bHKGd", function(module, exports) {
/*globals self, window */ "use strict";
/*eslint-disable @mysticatea/prettier */ const { AbortController: $8857eb8900fe3da6$var$AbortController, AbortSignal: $8857eb8900fe3da6$var$AbortSignal } = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : /* otherwise */ undefined;
/*eslint-enable @mysticatea/prettier */ module.exports = $8857eb8900fe3da6$var$AbortController;
module.exports.AbortSignal = $8857eb8900fe3da6$var$AbortSignal;
module.exports.default = $8857eb8900fe3da6$var$AbortController;

});

parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});


parcelRegister("3ujhf", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $28a3207d54bb93f3$require$ObjectDefineProperties = $6qlDJ.ObjectDefineProperties;
var $28a3207d54bb93f3$require$ObjectGetOwnPropertyDescriptor = $6qlDJ.ObjectGetOwnPropertyDescriptor;
var $28a3207d54bb93f3$require$ObjectKeys = $6qlDJ.ObjectKeys;
var $28a3207d54bb93f3$require$ObjectSetPrototypeOf = $6qlDJ.ObjectSetPrototypeOf;
module.exports = $28a3207d54bb93f3$var$Duplex;

var $6BZaW = parcelRequire("6BZaW");

var $4uosb = parcelRequire("4uosb");
$28a3207d54bb93f3$require$ObjectSetPrototypeOf($28a3207d54bb93f3$var$Duplex.prototype, $6BZaW.prototype);
$28a3207d54bb93f3$require$ObjectSetPrototypeOf($28a3207d54bb93f3$var$Duplex, $6BZaW);
{
    const keys = $28a3207d54bb93f3$require$ObjectKeys($4uosb.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$28a3207d54bb93f3$var$Duplex.prototype[method]) $28a3207d54bb93f3$var$Duplex.prototype[method] = $4uosb.prototype[method];
    }
}function $28a3207d54bb93f3$var$Duplex(options) {
    if (!(this instanceof $28a3207d54bb93f3$var$Duplex)) return new $28a3207d54bb93f3$var$Duplex(options);
    $6BZaW.call(this, options);
    $4uosb.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$28a3207d54bb93f3$require$ObjectDefineProperties($28a3207d54bb93f3$var$Duplex.prototype, {
    writable: {
        __proto__: null,
        ...$28a3207d54bb93f3$require$ObjectGetOwnPropertyDescriptor($4uosb.prototype, "writable")
    },
    writableHighWaterMark: {
        __proto__: null,
        ...$28a3207d54bb93f3$require$ObjectGetOwnPropertyDescriptor($4uosb.prototype, "writableHighWaterMark")
    },
    writableObjectMode: {
        __proto__: null,
        ...$28a3207d54bb93f3$require$ObjectGetOwnPropertyDescriptor($4uosb.prototype, "writableObjectMode")
    },
    writableBuffer: {
        __proto__: null,
        ...$28a3207d54bb93f3$require$ObjectGetOwnPropertyDescriptor($4uosb.prototype, "writableBuffer")
    },
    writableLength: {
        __proto__: null,
        ...$28a3207d54bb93f3$require$ObjectGetOwnPropertyDescriptor($4uosb.prototype, "writableLength")
    },
    writableFinished: {
        __proto__: null,
        ...$28a3207d54bb93f3$require$ObjectGetOwnPropertyDescriptor($4uosb.prototype, "writableFinished")
    },
    writableCorked: {
        __proto__: null,
        ...$28a3207d54bb93f3$require$ObjectGetOwnPropertyDescriptor($4uosb.prototype, "writableCorked")
    },
    writableEnded: {
        __proto__: null,
        ...$28a3207d54bb93f3$require$ObjectGetOwnPropertyDescriptor($4uosb.prototype, "writableEnded")
    },
    writableNeedDrain: {
        __proto__: null,
        ...$28a3207d54bb93f3$require$ObjectGetOwnPropertyDescriptor($4uosb.prototype, "writableNeedDrain")
    },
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $28a3207d54bb93f3$var$webStreamsAdapters;
// Lazy to avoid circular references
function $28a3207d54bb93f3$var$lazyWebStreams() {
    if ($28a3207d54bb93f3$var$webStreamsAdapters === undefined) $28a3207d54bb93f3$var$webStreamsAdapters = {};
    return $28a3207d54bb93f3$var$webStreamsAdapters;
}
$28a3207d54bb93f3$var$Duplex.fromWeb = function(pair, options) {
    return $28a3207d54bb93f3$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$28a3207d54bb93f3$var$Duplex.toWeb = function(duplex) {
    return $28a3207d54bb93f3$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $28a3207d54bb93f3$var$duplexify;

$28a3207d54bb93f3$var$Duplex.from = function(body) {
    if (!$28a3207d54bb93f3$var$duplexify) $28a3207d54bb93f3$var$duplexify = (parcelRequire("dq9MZ"));
    return $28a3207d54bb93f3$var$duplexify(body, "body");
};

});
parcelRegister("6BZaW", function(module, exports) {
/* replacement start */ 
var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $4d05a6f3c4a3c493$require$ArrayPrototypeIndexOf = $6qlDJ.ArrayPrototypeIndexOf;
var $4d05a6f3c4a3c493$require$NumberIsInteger = $6qlDJ.NumberIsInteger;
var $4d05a6f3c4a3c493$require$NumberIsNaN = $6qlDJ.NumberIsNaN;
var $4d05a6f3c4a3c493$require$NumberParseInt = $6qlDJ.NumberParseInt;
var $4d05a6f3c4a3c493$require$ObjectDefineProperties = $6qlDJ.ObjectDefineProperties;
var $4d05a6f3c4a3c493$require$ObjectKeys = $6qlDJ.ObjectKeys;
var $4d05a6f3c4a3c493$require$ObjectSetPrototypeOf = $6qlDJ.ObjectSetPrototypeOf;
var $4d05a6f3c4a3c493$require$Promise = $6qlDJ.Promise;
var $4d05a6f3c4a3c493$require$SafeSet = $6qlDJ.SafeSet;
var $4d05a6f3c4a3c493$require$SymbolAsyncDispose = $6qlDJ.SymbolAsyncDispose;
var $4d05a6f3c4a3c493$require$SymbolAsyncIterator = $6qlDJ.SymbolAsyncIterator;
var $4d05a6f3c4a3c493$require$Symbol = $6qlDJ.Symbol;
module.exports = $4d05a6f3c4a3c493$var$Readable;
$4d05a6f3c4a3c493$var$Readable.ReadableState = $4d05a6f3c4a3c493$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $4d05a6f3c4a3c493$require$EE = $7etJZ.EventEmitter;

var $8uq7s = parcelRequire("8uq7s");
var $4d05a6f3c4a3c493$require$Stream = $8uq7s.Stream;
var $4d05a6f3c4a3c493$require$prependListener = $8uq7s.prependListener;

var $6ZWSX = parcelRequire("6ZWSX");
var $4d05a6f3c4a3c493$require$Buffer = $6ZWSX.Buffer;

var $khx7T = parcelRequire("khx7T");
var $4d05a6f3c4a3c493$require$addAbortSignal = $khx7T.addAbortSignal;

var $52Cjj = parcelRequire("52Cjj");

let $4d05a6f3c4a3c493$var$debug = (parcelRequire("cSbri")).debuglog("stream", (fn)=>{
    $4d05a6f3c4a3c493$var$debug = fn;
});

var $insGM = parcelRequire("insGM");

var $8Pe5V = parcelRequire("8Pe5V");

var $5ZWSH = parcelRequire("5ZWSH");
var $4d05a6f3c4a3c493$require$getHighWaterMark = $5ZWSH.getHighWaterMark;
var $4d05a6f3c4a3c493$require$getDefaultHighWaterMark = $5ZWSH.getDefaultHighWaterMark;

var $PWkkZ = parcelRequire("PWkkZ");
const { aggregateTwoErrors: $4d05a6f3c4a3c493$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $4d05a6f3c4a3c493$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $4d05a6f3c4a3c493$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $4d05a6f3c4a3c493$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $4d05a6f3c4a3c493$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $4d05a6f3c4a3c493$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $4d05a6f3c4a3c493$var$AbortError } = $PWkkZ;

var $6q8Dc = parcelRequire("6q8Dc");
var $4d05a6f3c4a3c493$require$validateObject = $6q8Dc.validateObject;
const $4d05a6f3c4a3c493$var$kPaused = $4d05a6f3c4a3c493$require$Symbol("kPaused");

var $eNRCS = parcelRequire("eNRCS");
var $4d05a6f3c4a3c493$require$StringDecoder = $eNRCS.StringDecoder;

var $9gNIm = parcelRequire("9gNIm");
$4d05a6f3c4a3c493$require$ObjectSetPrototypeOf($4d05a6f3c4a3c493$var$Readable.prototype, $4d05a6f3c4a3c493$require$Stream.prototype);
$4d05a6f3c4a3c493$require$ObjectSetPrototypeOf($4d05a6f3c4a3c493$var$Readable, $4d05a6f3c4a3c493$require$Stream);
const $4d05a6f3c4a3c493$var$nop = ()=>{};
const { errorOrDestroy: $4d05a6f3c4a3c493$var$errorOrDestroy } = $8Pe5V;
const $4d05a6f3c4a3c493$var$kObjectMode = 1;
const $4d05a6f3c4a3c493$var$kEnded = 2;
const $4d05a6f3c4a3c493$var$kEndEmitted = 4;
const $4d05a6f3c4a3c493$var$kReading = 8;
const $4d05a6f3c4a3c493$var$kConstructed = 16;
const $4d05a6f3c4a3c493$var$kSync = 32;
const $4d05a6f3c4a3c493$var$kNeedReadable = 64;
const $4d05a6f3c4a3c493$var$kEmittedReadable = 128;
const $4d05a6f3c4a3c493$var$kReadableListening = 256;
const $4d05a6f3c4a3c493$var$kResumeScheduled = 512;
const $4d05a6f3c4a3c493$var$kErrorEmitted = 1024;
const $4d05a6f3c4a3c493$var$kEmitClose = 2048;
const $4d05a6f3c4a3c493$var$kAutoDestroy = 4096;
const $4d05a6f3c4a3c493$var$kDestroyed = 8192;
const $4d05a6f3c4a3c493$var$kClosed = 16384;
const $4d05a6f3c4a3c493$var$kCloseEmitted = 32768;
const $4d05a6f3c4a3c493$var$kMultiAwaitDrain = 65536;
const $4d05a6f3c4a3c493$var$kReadingMore = 131072;
const $4d05a6f3c4a3c493$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $4d05a6f3c4a3c493$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$4d05a6f3c4a3c493$require$ObjectDefineProperties($4d05a6f3c4a3c493$var$ReadableState.prototype, {
    objectMode: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kObjectMode),
    ended: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kEnded),
    endEmitted: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kEndEmitted),
    reading: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kNeedReadable),
    emittedReadable: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kEmittedReadable),
    readableListening: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kReadableListening),
    resumeScheduled: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kErrorEmitted),
    emitClose: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kEmitClose),
    autoDestroy: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kCloseEmitted),
    multiAwaitDrain: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kReadingMore),
    dataEmitted: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kDataEmitted)
});

function $4d05a6f3c4a3c493$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof (parcelRequire("3ujhf"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $4d05a6f3c4a3c493$var$kEmitClose | $4d05a6f3c4a3c493$var$kAutoDestroy | $4d05a6f3c4a3c493$var$kConstructed | $4d05a6f3c4a3c493$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $4d05a6f3c4a3c493$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $4d05a6f3c4a3c493$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $4d05a6f3c4a3c493$require$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex) : $4d05a6f3c4a3c493$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $insGM();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$4d05a6f3c4a3c493$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$4d05a6f3c4a3c493$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$4d05a6f3c4a3c493$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || "utf8";
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $4d05a6f3c4a3c493$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $4d05a6f3c4a3c493$var$Readable(options) {
    if (!(this instanceof $4d05a6f3c4a3c493$var$Readable)) return new $4d05a6f3c4a3c493$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("3ujhf"));
    this._readableState = new $4d05a6f3c4a3c493$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.construct === "function") this._construct = options.construct;
        if (options.signal && !isDuplex) $4d05a6f3c4a3c493$require$addAbortSignal(options.signal, this);
    }
    $4d05a6f3c4a3c493$require$Stream.call(this, options);
    $8Pe5V.construct(this, ()=>{
        if (this._readableState.needReadable) $4d05a6f3c4a3c493$var$maybeReadMore(this, this._readableState);
    });
}
$4d05a6f3c4a3c493$var$Readable.prototype.destroy = $8Pe5V.destroy;
$4d05a6f3c4a3c493$var$Readable.prototype._undestroy = $8Pe5V.undestroy;
$4d05a6f3c4a3c493$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$4d05a6f3c4a3c493$var$Readable.prototype[$4d05a6f3c4a3c493$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$4d05a6f3c4a3c493$var$Readable.prototype[$4d05a6f3c4a3c493$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $4d05a6f3c4a3c493$var$AbortError();
        this.destroy(error);
    }
    return new $4d05a6f3c4a3c493$require$Promise((resolve, reject)=>$52Cjj(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$4d05a6f3c4a3c493$var$Readable.prototype.push = function(chunk, encoding) {
    return $4d05a6f3c4a3c493$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$4d05a6f3c4a3c493$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $4d05a6f3c4a3c493$var$readableAddChunk(this, chunk, encoding, true);
};
function $4d05a6f3c4a3c493$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $4d05a6f3c4a3c493$var$debug("readableAddChunk", chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $4d05a6f3c4a3c493$var$kObjectMode) === 0) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $4d05a6f3c4a3c493$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $4d05a6f3c4a3c493$require$Buffer.from(chunk, encoding);
                    encoding = "";
                }
            }
        } else if (chunk instanceof $4d05a6f3c4a3c493$require$Buffer) encoding = "";
        else if ($4d05a6f3c4a3c493$require$Stream._isUint8Array(chunk)) {
            chunk = $4d05a6f3c4a3c493$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = "";
        } else if (chunk != null) err = new $4d05a6f3c4a3c493$var$ERR_INVALID_ARG_TYPE("chunk", [
            "string",
            "Buffer",
            "Uint8Array"
        ], chunk);
    }
    if (err) $4d05a6f3c4a3c493$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$4d05a6f3c4a3c493$var$kReading;
        $4d05a6f3c4a3c493$var$onEofChunk(stream, state);
    } else if ((state.state & $4d05a6f3c4a3c493$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $4d05a6f3c4a3c493$var$kEndEmitted) !== 0) $4d05a6f3c4a3c493$var$errorOrDestroy(stream, new $4d05a6f3c4a3c493$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $4d05a6f3c4a3c493$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $4d05a6f3c4a3c493$var$errorOrDestroy(stream, new $4d05a6f3c4a3c493$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$4d05a6f3c4a3c493$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $4d05a6f3c4a3c493$var$addChunk(stream, state, chunk, false);
                else $4d05a6f3c4a3c493$var$maybeReadMore(stream, state);
            } else $4d05a6f3c4a3c493$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$4d05a6f3c4a3c493$var$kReading;
        $4d05a6f3c4a3c493$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $4d05a6f3c4a3c493$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount("data") > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $4d05a6f3c4a3c493$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit("data", chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $4d05a6f3c4a3c493$var$kNeedReadable) !== 0) $4d05a6f3c4a3c493$var$emitReadable(stream);
    }
    $4d05a6f3c4a3c493$var$maybeReadMore(stream, state);
}
$4d05a6f3c4a3c493$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$4d05a6f3c4a3c493$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$4d05a6f3c4a3c493$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $4d05a6f3c4a3c493$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = "";
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== "") buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $4d05a6f3c4a3c493$var$MAX_HWM = 0x40000000;
function $4d05a6f3c4a3c493$var$computeNewHighWaterMark(n) {
    if (n > $4d05a6f3c4a3c493$var$MAX_HWM) throw new $4d05a6f3c4a3c493$var$ERR_OUT_OF_RANGE("size", "<= 1GiB", n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $4d05a6f3c4a3c493$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $4d05a6f3c4a3c493$var$kObjectMode) !== 0) return 1;
    if ($4d05a6f3c4a3c493$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$4d05a6f3c4a3c493$var$Readable.prototype.read = function(n) {
    $4d05a6f3c4a3c493$var$debug("read", n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$4d05a6f3c4a3c493$require$NumberIsInteger(n)) n = $4d05a6f3c4a3c493$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $4d05a6f3c4a3c493$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$4d05a6f3c4a3c493$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $4d05a6f3c4a3c493$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $4d05a6f3c4a3c493$var$endReadable(this);
        else $4d05a6f3c4a3c493$var$emitReadable(this);
        return null;
    }
    n = $4d05a6f3c4a3c493$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $4d05a6f3c4a3c493$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $4d05a6f3c4a3c493$var$kNeedReadable) !== 0;
    $4d05a6f3c4a3c493$var$debug("need readable", doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $4d05a6f3c4a3c493$var$debug("length less than watermark", doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $4d05a6f3c4a3c493$var$debug("reading, ended or constructing", doRead);
    } else if (doRead) {
        $4d05a6f3c4a3c493$var$debug("do read");
        state.state |= $4d05a6f3c4a3c493$var$kReading | $4d05a6f3c4a3c493$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $4d05a6f3c4a3c493$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $4d05a6f3c4a3c493$var$errorOrDestroy(this, err);
        }
        state.state &= ~$4d05a6f3c4a3c493$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $4d05a6f3c4a3c493$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $4d05a6f3c4a3c493$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $4d05a6f3c4a3c493$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit("data", ret);
    }
    return ret;
};
function $4d05a6f3c4a3c493$var$onEofChunk(stream, state) {
    $4d05a6f3c4a3c493$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $4d05a6f3c4a3c493$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $4d05a6f3c4a3c493$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $4d05a6f3c4a3c493$var$emitReadable(stream) {
    const state = stream._readableState;
    $4d05a6f3c4a3c493$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $4d05a6f3c4a3c493$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($4d05a6f3c4a3c493$var$emitReadable_, stream);
    }
}
function $4d05a6f3c4a3c493$var$emitReadable_(stream) {
    const state = stream._readableState;
    $4d05a6f3c4a3c493$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $4d05a6f3c4a3c493$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $4d05a6f3c4a3c493$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $hPtJY.nextTick($4d05a6f3c4a3c493$var$maybeReadMore_, stream, state);
    }
}
function $4d05a6f3c4a3c493$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $4d05a6f3c4a3c493$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$4d05a6f3c4a3c493$var$Readable.prototype._read = function(n) {
    throw new $4d05a6f3c4a3c493$var$ERR_METHOD_NOT_IMPLEMENTED("_read()");
};
$4d05a6f3c4a3c493$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $4d05a6f3c4a3c493$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $4d05a6f3c4a3c493$var$debug("pipe count=%d opts=%j", state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $4d05a6f3c4a3c493$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $4d05a6f3c4a3c493$var$debug("onend");
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $4d05a6f3c4a3c493$var$debug("cleanup");
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        if (ondrain) dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $4d05a6f3c4a3c493$var$debug("false write response, pause", 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $4d05a6f3c4a3c493$var$debug("false write response, pause", state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $4d05a6f3c4a3c493$var$pipeOnDrain(src, dest);
            dest.on("drain", ondrain);
        }
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $4d05a6f3c4a3c493$var$debug("ondata");
        const ret = dest.write(chunk);
        $4d05a6f3c4a3c493$var$debug("dest.write", ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $4d05a6f3c4a3c493$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if (dest.listenerCount("error") === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $4d05a6f3c4a3c493$var$errorOrDestroy(dest, er);
            else dest.emit("error", er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $4d05a6f3c4a3c493$require$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $4d05a6f3c4a3c493$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $4d05a6f3c4a3c493$var$debug("unpipe");
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit("pipe", src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $4d05a6f3c4a3c493$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $4d05a6f3c4a3c493$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $4d05a6f3c4a3c493$var$debug("pipeOnDrain", 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $4d05a6f3c4a3c493$var$debug("pipeOnDrain", state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount("data")) src.resume();
    };
}
$4d05a6f3c4a3c493$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $4d05a6f3c4a3c493$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$4d05a6f3c4a3c493$var$Readable.prototype.on = function(ev, fn) {
    const res = $4d05a6f3c4a3c493$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === "data") {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $4d05a6f3c4a3c493$var$debug("on readable", state.length, state.reading);
            if (state.length) $4d05a6f3c4a3c493$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($4d05a6f3c4a3c493$var$nReadingNextTick, this);
        }
    }
    return res;
};
$4d05a6f3c4a3c493$var$Readable.prototype.addListener = $4d05a6f3c4a3c493$var$Readable.prototype.on;
$4d05a6f3c4a3c493$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $4d05a6f3c4a3c493$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($4d05a6f3c4a3c493$var$updateReadableListening, this);
    return res;
};
$4d05a6f3c4a3c493$var$Readable.prototype.off = $4d05a6f3c4a3c493$var$Readable.prototype.removeListener;
$4d05a6f3c4a3c493$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $4d05a6f3c4a3c493$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($4d05a6f3c4a3c493$var$updateReadableListening, this);
    return res;
};
function $4d05a6f3c4a3c493$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount("readable") > 0;
    if (state.resumeScheduled && state[$4d05a6f3c4a3c493$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount("data") > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $4d05a6f3c4a3c493$var$nReadingNextTick(self) {
    $4d05a6f3c4a3c493$var$debug("readable nexttick read 0");
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$4d05a6f3c4a3c493$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $4d05a6f3c4a3c493$var$debug("resume");
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $4d05a6f3c4a3c493$var$resume(this, state);
    }
    state[$4d05a6f3c4a3c493$var$kPaused] = false;
    return this;
};
function $4d05a6f3c4a3c493$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($4d05a6f3c4a3c493$var$resume_, stream, state);
    }
}
function $4d05a6f3c4a3c493$var$resume_(stream, state) {
    $4d05a6f3c4a3c493$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $4d05a6f3c4a3c493$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$4d05a6f3c4a3c493$var$Readable.prototype.pause = function() {
    $4d05a6f3c4a3c493$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $4d05a6f3c4a3c493$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState[$4d05a6f3c4a3c493$var$kPaused] = true;
    return this;
};
function $4d05a6f3c4a3c493$var$flow(stream) {
    const state = stream._readableState;
    $4d05a6f3c4a3c493$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$4d05a6f3c4a3c493$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on("data", (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on("end", ()=>{
        this.push(null);
    });
    stream.on("error", (err)=>{
        $4d05a6f3c4a3c493$var$errorOrDestroy(this, err);
    });
    stream.on("close", ()=>{
        this.destroy();
    });
    stream.on("destroy", ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $4d05a6f3c4a3c493$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === "function") this[i] = stream[i].bind(stream);
    }
    return this;
};
$4d05a6f3c4a3c493$var$Readable.prototype[$4d05a6f3c4a3c493$require$SymbolAsyncIterator] = function() {
    return $4d05a6f3c4a3c493$var$streamToAsyncIterator(this);
};
$4d05a6f3c4a3c493$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $4d05a6f3c4a3c493$require$validateObject(options, "options");
    return $4d05a6f3c4a3c493$var$streamToAsyncIterator(this, options);
};
function $4d05a6f3c4a3c493$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== "function") stream = $4d05a6f3c4a3c493$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $4d05a6f3c4a3c493$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $4d05a6f3c4a3c493$var$createAsyncIterator(stream, options) {
    let callback = $4d05a6f3c4a3c493$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $4d05a6f3c4a3c493$var$nop;
        } else callback = resolve;
    }
    stream.on("readable", next);
    let error;
    const cleanup = $52Cjj(stream, {
        writable: false
    }, (err)=>{
        error = err ? $4d05a6f3c4a3c493$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $4d05a6f3c4a3c493$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $4d05a6f3c4a3c493$require$Promise(next);
        }
    } catch (err) {
        error = $4d05a6f3c4a3c493$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $8Pe5V.destroyer(stream, null);
        else {
            stream.off("readable", next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$4d05a6f3c4a3c493$require$ObjectDefineProperties($4d05a6f3c4a3c493$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$4d05a6f3c4a3c493$require$ObjectDefineProperties($4d05a6f3c4a3c493$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$4d05a6f3c4a3c493$var$kPaused] !== false;
        },
        set (value) {
            this[$4d05a6f3c4a3c493$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$4d05a6f3c4a3c493$var$Readable._fromList = $4d05a6f3c4a3c493$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $4d05a6f3c4a3c493$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $4d05a6f3c4a3c493$var$endReadable(stream) {
    const state = stream._readableState;
    $4d05a6f3c4a3c493$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($4d05a6f3c4a3c493$var$endReadableNT, state, stream);
    }
}
function $4d05a6f3c4a3c493$var$endReadableNT(state, stream) {
    $4d05a6f3c4a3c493$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit("end");
        if (stream.writable && stream.allowHalfOpen === false) $hPtJY.nextTick($4d05a6f3c4a3c493$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $4d05a6f3c4a3c493$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$4d05a6f3c4a3c493$var$Readable.from = function(iterable, opts) {
    return $9gNIm($4d05a6f3c4a3c493$var$Readable, iterable, opts);
};
let $4d05a6f3c4a3c493$var$webStreamsAdapters;
// Lazy to avoid circular references
function $4d05a6f3c4a3c493$var$lazyWebStreams() {
    if ($4d05a6f3c4a3c493$var$webStreamsAdapters === undefined) $4d05a6f3c4a3c493$var$webStreamsAdapters = {};
    return $4d05a6f3c4a3c493$var$webStreamsAdapters;
}
$4d05a6f3c4a3c493$var$Readable.fromWeb = function(readableStream, options) {
    return $4d05a6f3c4a3c493$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$4d05a6f3c4a3c493$var$Readable.toWeb = function(streamReadable, options) {
    return $4d05a6f3c4a3c493$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$4d05a6f3c4a3c493$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $4d05a6f3c4a3c493$var$Readable({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true,
        ...options,
        destroy (err, callback) {
            $8Pe5V.destroyer(src, err);
            callback(err);
        }
    }).wrap(src);
};

});
parcelRegister("8uq7s", function(module, exports) {
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $62e562ccc894494e$require$ArrayIsArray = $6qlDJ.ArrayIsArray;
var $62e562ccc894494e$require$ObjectSetPrototypeOf = $6qlDJ.ObjectSetPrototypeOf;

var $7etJZ = parcelRequire("7etJZ");
var $62e562ccc894494e$require$EE = $7etJZ.EventEmitter;
function $62e562ccc894494e$var$Stream(opts) {
    $62e562ccc894494e$require$EE.call(this, opts);
}
$62e562ccc894494e$require$ObjectSetPrototypeOf($62e562ccc894494e$var$Stream.prototype, $62e562ccc894494e$require$EE.prototype);
$62e562ccc894494e$require$ObjectSetPrototypeOf($62e562ccc894494e$var$Stream, $62e562ccc894494e$require$EE);
$62e562ccc894494e$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($62e562ccc894494e$require$EE.listenerCount(this, "error") === 0) this.emit("error", er);
    }
    $62e562ccc894494e$var$prependListener(source, "error", onerror);
    $62e562ccc894494e$var$prependListener(dest, "error", onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $62e562ccc894494e$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($62e562ccc894494e$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $62e562ccc894494e$var$Stream,
    prependListener: $62e562ccc894494e$var$prependListener
};

});

parcelRegister("khx7T", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", () => $03cf781e6c37f723$export$e2db56ee53255a0, (v) => $03cf781e6c37f723$export$e2db56ee53255a0 = v);
$parcel$export(module.exports, "addAbortSignalNoValidate", () => $03cf781e6c37f723$export$11956e9313f43de0, (v) => $03cf781e6c37f723$export$11956e9313f43de0 = v);
var $03cf781e6c37f723$export$e2db56ee53255a0;
var $03cf781e6c37f723$export$11956e9313f43de0;
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $03cf781e6c37f723$require$SymbolDispose = $6qlDJ.SymbolDispose;

var $PWkkZ = parcelRequire("PWkkZ");
var $03cf781e6c37f723$require$AbortError = $PWkkZ.AbortError;
var $03cf781e6c37f723$require$codes = $PWkkZ.codes;

var $dEd8A = parcelRequire("dEd8A");
var $03cf781e6c37f723$require$isNodeStream = $dEd8A.isNodeStream;
var $03cf781e6c37f723$require$isWebStream = $dEd8A.isWebStream;
var $03cf781e6c37f723$require$kControllerErrorFunction = $dEd8A.kControllerErrorFunction;

var $52Cjj = parcelRequire("52Cjj");
const { ERR_INVALID_ARG_TYPE: $03cf781e6c37f723$var$ERR_INVALID_ARG_TYPE } = $03cf781e6c37f723$require$codes;
let $03cf781e6c37f723$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $03cf781e6c37f723$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== "object" || !("aborted" in signal)) throw new $03cf781e6c37f723$var$ERR_INVALID_ARG_TYPE(name, "AbortSignal", signal);
};
$03cf781e6c37f723$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $03cf781e6c37f723$var$validateAbortSignal(signal, "signal");
    if (!$03cf781e6c37f723$require$isNodeStream(stream) && !$03cf781e6c37f723$require$isWebStream(stream)) throw new $03cf781e6c37f723$var$ERR_INVALID_ARG_TYPE("stream", [
        "ReadableStream",
        "WritableStream",
        "Stream"
    ], stream);
    return $03cf781e6c37f723$export$11956e9313f43de0(signal, stream);
};

$03cf781e6c37f723$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== "object" || !("aborted" in signal)) return stream;
    const onAbort = $03cf781e6c37f723$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $03cf781e6c37f723$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$03cf781e6c37f723$require$kControllerErrorFunction](new $03cf781e6c37f723$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $03cf781e6c37f723$var$addAbortListener = $03cf781e6c37f723$var$addAbortListener || (parcelRequire("cSbri")).addAbortListener;
        const disposable = $03cf781e6c37f723$var$addAbortListener(signal, onAbort);
        $52Cjj(stream, disposable[$03cf781e6c37f723$require$SymbolDispose]);
    }
    return stream;
};

});
parcelRegister("PWkkZ", function(module, exports) {
"use strict";

var $cSbri = parcelRequire("cSbri");
var $09c2021114adf118$require$format = $cSbri.format;
var $09c2021114adf118$require$inspect = $cSbri.inspect;
var $09c2021114adf118$require$CustomAggregateError = $cSbri.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/master/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $09c2021114adf118$var$AggregateError = globalThis.AggregateError || $09c2021114adf118$require$CustomAggregateError;
const $09c2021114adf118$var$kIsNodeError = Symbol("kIsNodeError");
const $09c2021114adf118$var$kTypes = [
    "string",
    "function",
    "number",
    "object",
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    "Function",
    "Object",
    "boolean",
    "bigint",
    "symbol"
];
const $09c2021114adf118$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $09c2021114adf118$var$nodeInternalPrefix = "__node_internal_";
const $09c2021114adf118$var$codes = {};
function $09c2021114adf118$var$assert(value, message) {
    if (!value) throw new $09c2021114adf118$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $09c2021114adf118$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $09c2021114adf118$var$getMessage(key, msg, args) {
    if (typeof msg === "function") {
        $09c2021114adf118$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $09c2021114adf118$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $09c2021114adf118$require$format(msg, ...args);
}
function $09c2021114adf118$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        constructor(...args){
            super($09c2021114adf118$var$getMessage(code, message, args));
        }
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$09c2021114adf118$var$kIsNodeError] = true;
    $09c2021114adf118$var$codes[code] = NodeError;
}
function $09c2021114adf118$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $09c2021114adf118$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, "name", {
        value: hidden
    });
    return fn;
}
function $09c2021114adf118$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $09c2021114adf118$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $09c2021114adf118$var$AbortError extends Error {
    constructor(message = "The operation was aborted", options){
        if (options !== undefined && typeof options !== "object") throw new $09c2021114adf118$var$codes.ERR_INVALID_ARG_TYPE("options", "Object", options);
        super(message, options);
        this.code = "ABORT_ERR";
        this.name = "AbortError";
    }
}
$09c2021114adf118$var$E("ERR_ASSERTION", "%s", Error);
$09c2021114adf118$var$E("ERR_INVALID_ARG_TYPE", (name, expected, actual)=>{
    $09c2021114adf118$var$assert(typeof name === "string", "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = "The ";
    if (name.endsWith(" argument")) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes(".") ? "property" : "argument"} `;
    msg += "must be ";
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $09c2021114adf118$var$assert(typeof value === "string", "All expected entries have to be of type string");
        if ($09c2021114adf118$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($09c2021114adf118$var$classRegExp.test(value)) instances.push(value);
        else {
            $09c2021114adf118$var$assert(value !== "object", 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf("object");
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push("Object");
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(", ")}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += " or ";
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(", ")}, or ${last}`;
                }
        }
        if (other.length > 0) msg += " or ";
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += "an ";
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(", ")}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === "function" && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === "object") {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $09c2021114adf118$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $09c2021114adf118$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$09c2021114adf118$var$E("ERR_INVALID_ARG_VALUE", (name, value, reason = "is invalid")=>{
    let inspected = $09c2021114adf118$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + "...";
    const type = name.includes(".") ? "property" : "argument";
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$09c2021114adf118$var$E("ERR_INVALID_RETURN_VALUE", (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$09c2021114adf118$var$E("ERR_MISSING_ARGS", (...args)=>{
    $09c2021114adf118$var$assert(args.length > 0, "At least one arg needs to be specified");
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(" or ");
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(", ")}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$09c2021114adf118$var$E("ERR_OUT_OF_RANGE", (str, range, input)=>{
    $09c2021114adf118$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $09c2021114adf118$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > 2n ** 32n || input < -(2n ** 32n)) received = $09c2021114adf118$var$addNumericalSeparator(received);
        received += "n";
    } else received = $09c2021114adf118$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$09c2021114adf118$var$E("ERR_MULTIPLE_CALLBACK", "Callback called multiple times", Error);
$09c2021114adf118$var$E("ERR_METHOD_NOT_IMPLEMENTED", "The %s method is not implemented", Error);
$09c2021114adf118$var$E("ERR_STREAM_ALREADY_FINISHED", "Cannot call %s after a stream was finished", Error);
$09c2021114adf118$var$E("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable", Error);
$09c2021114adf118$var$E("ERR_STREAM_DESTROYED", "Cannot call %s after a stream was destroyed", Error);
$09c2021114adf118$var$E("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$09c2021114adf118$var$E("ERR_STREAM_PREMATURE_CLOSE", "Premature close", Error);
$09c2021114adf118$var$E("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF", Error);
$09c2021114adf118$var$E("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event", Error);
$09c2021114adf118$var$E("ERR_STREAM_WRITE_AFTER_END", "write after end", Error);
$09c2021114adf118$var$E("ERR_UNKNOWN_ENCODING", "Unknown encoding: %s", TypeError);
module.exports = {
    AbortError: $09c2021114adf118$var$AbortError,
    aggregateTwoErrors: $09c2021114adf118$var$hideStackFrames($09c2021114adf118$var$aggregateTwoErrors),
    hideStackFrames: $09c2021114adf118$var$hideStackFrames,
    codes: $09c2021114adf118$var$codes
};

});

parcelRegister("dEd8A", function(module, exports) {
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $9ef933a2f63b7ec6$require$SymbolAsyncIterator = $6qlDJ.SymbolAsyncIterator;
var $9ef933a2f63b7ec6$require$SymbolIterator = $6qlDJ.SymbolIterator;
var $9ef933a2f63b7ec6$require$SymbolFor = $6qlDJ.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $9ef933a2f63b7ec6$var$kIsDestroyed = $9ef933a2f63b7ec6$require$SymbolFor("nodejs.stream.destroyed");
const $9ef933a2f63b7ec6$var$kIsErrored = $9ef933a2f63b7ec6$require$SymbolFor("nodejs.stream.errored");
const $9ef933a2f63b7ec6$var$kIsReadable = $9ef933a2f63b7ec6$require$SymbolFor("nodejs.stream.readable");
const $9ef933a2f63b7ec6$var$kIsWritable = $9ef933a2f63b7ec6$require$SymbolFor("nodejs.stream.writable");
const $9ef933a2f63b7ec6$var$kIsDisturbed = $9ef933a2f63b7ec6$require$SymbolFor("nodejs.stream.disturbed");
const $9ef933a2f63b7ec6$var$kIsClosedPromise = $9ef933a2f63b7ec6$require$SymbolFor("nodejs.webstream.isClosedPromise");
const $9ef933a2f63b7ec6$var$kControllerErrorFunction = $9ef933a2f63b7ec6$require$SymbolFor("nodejs.webstream.controllerErrorFunction");
function $9ef933a2f63b7ec6$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === "function" && typeof obj.on === "function" && (!strict || typeof obj.pause === "function" && typeof obj.resume === "function") && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $9ef933a2f63b7ec6$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === "function" && typeof obj.on === "function" && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $9ef933a2f63b7ec6$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === "function" && obj._readableState && typeof obj.on === "function" && typeof obj.write === "function");
}
function $9ef933a2f63b7ec6$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === "function" && typeof obj.on === "function" || typeof obj.pipe === "function" && typeof obj.on === "function");
}
function $9ef933a2f63b7ec6$var$isReadableStream(obj) {
    return !!(obj && !$9ef933a2f63b7ec6$var$isNodeStream(obj) && typeof obj.pipeThrough === "function" && typeof obj.getReader === "function" && typeof obj.cancel === "function");
}
function $9ef933a2f63b7ec6$var$isWritableStream(obj) {
    return !!(obj && !$9ef933a2f63b7ec6$var$isNodeStream(obj) && typeof obj.getWriter === "function" && typeof obj.abort === "function");
}
function $9ef933a2f63b7ec6$var$isTransformStream(obj) {
    return !!(obj && !$9ef933a2f63b7ec6$var$isNodeStream(obj) && typeof obj.readable === "object" && typeof obj.writable === "object");
}
function $9ef933a2f63b7ec6$var$isWebStream(obj) {
    return $9ef933a2f63b7ec6$var$isReadableStream(obj) || $9ef933a2f63b7ec6$var$isWritableStream(obj) || $9ef933a2f63b7ec6$var$isTransformStream(obj);
}
function $9ef933a2f63b7ec6$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$9ef933a2f63b7ec6$require$SymbolAsyncIterator] === "function";
    if (isAsync === false) return typeof obj[$9ef933a2f63b7ec6$require$SymbolIterator] === "function";
    return typeof obj[$9ef933a2f63b7ec6$require$SymbolAsyncIterator] === "function" || typeof obj[$9ef933a2f63b7ec6$require$SymbolIterator] === "function";
}
function $9ef933a2f63b7ec6$var$isDestroyed(stream) {
    if (!$9ef933a2f63b7ec6$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$9ef933a2f63b7ec6$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $9ef933a2f63b7ec6$var$isWritableEnded(stream) {
    if (!$9ef933a2f63b7ec6$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== "boolean") return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $9ef933a2f63b7ec6$var$isWritableFinished(stream, strict) {
    if (!$9ef933a2f63b7ec6$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== "boolean") return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $9ef933a2f63b7ec6$var$isReadableEnded(stream) {
    if (!$9ef933a2f63b7ec6$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== "boolean") return null;
    return rState.ended;
}
// Have emitted 'end'.
function $9ef933a2f63b7ec6$var$isReadableFinished(stream, strict) {
    if (!$9ef933a2f63b7ec6$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== "boolean") return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $9ef933a2f63b7ec6$var$isReadable(stream) {
    if (stream && stream[$9ef933a2f63b7ec6$var$kIsReadable] != null) return stream[$9ef933a2f63b7ec6$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== "boolean") return null;
    if ($9ef933a2f63b7ec6$var$isDestroyed(stream)) return false;
    return $9ef933a2f63b7ec6$var$isReadableNodeStream(stream) && stream.readable && !$9ef933a2f63b7ec6$var$isReadableFinished(stream);
}
function $9ef933a2f63b7ec6$var$isWritable(stream) {
    if (stream && stream[$9ef933a2f63b7ec6$var$kIsWritable] != null) return stream[$9ef933a2f63b7ec6$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== "boolean") return null;
    if ($9ef933a2f63b7ec6$var$isDestroyed(stream)) return false;
    return $9ef933a2f63b7ec6$var$isWritableNodeStream(stream) && stream.writable && !$9ef933a2f63b7ec6$var$isWritableEnded(stream);
}
function $9ef933a2f63b7ec6$var$isFinished(stream, opts) {
    if (!$9ef933a2f63b7ec6$var$isNodeStream(stream)) return null;
    if ($9ef933a2f63b7ec6$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $9ef933a2f63b7ec6$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $9ef933a2f63b7ec6$var$isWritable(stream)) return false;
    return true;
}
function $9ef933a2f63b7ec6$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$9ef933a2f63b7ec6$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $9ef933a2f63b7ec6$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$9ef933a2f63b7ec6$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $9ef933a2f63b7ec6$var$isClosed(stream) {
    if (!$9ef933a2f63b7ec6$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === "boolean") return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === "boolean" || typeof (rState === null || rState === undefined ? undefined : rState.closed) === "boolean") return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === "boolean" && $9ef933a2f63b7ec6$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $9ef933a2f63b7ec6$var$isOutgoingMessage(stream) {
    return typeof stream._closed === "boolean" && typeof stream._defaultKeepAlive === "boolean" && typeof stream._removedConnection === "boolean" && typeof stream._removedContLen === "boolean";
}
function $9ef933a2f63b7ec6$var$isServerResponse(stream) {
    return typeof stream._sent100 === "boolean" && $9ef933a2f63b7ec6$var$isOutgoingMessage(stream);
}
function $9ef933a2f63b7ec6$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === "boolean" && typeof stream._dumped === "boolean" && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $9ef933a2f63b7ec6$var$willEmitClose(stream) {
    if (!$9ef933a2f63b7ec6$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $9ef933a2f63b7ec6$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $9ef933a2f63b7ec6$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$9ef933a2f63b7ec6$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $9ef933a2f63b7ec6$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$9ef933a2f63b7ec6$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $9ef933a2f63b7ec6$var$isDestroyed,
    kIsDestroyed: $9ef933a2f63b7ec6$var$kIsDestroyed,
    isDisturbed: $9ef933a2f63b7ec6$var$isDisturbed,
    kIsDisturbed: $9ef933a2f63b7ec6$var$kIsDisturbed,
    isErrored: $9ef933a2f63b7ec6$var$isErrored,
    kIsErrored: $9ef933a2f63b7ec6$var$kIsErrored,
    isReadable: $9ef933a2f63b7ec6$var$isReadable,
    kIsReadable: $9ef933a2f63b7ec6$var$kIsReadable,
    kIsClosedPromise: $9ef933a2f63b7ec6$var$kIsClosedPromise,
    kControllerErrorFunction: $9ef933a2f63b7ec6$var$kControllerErrorFunction,
    kIsWritable: $9ef933a2f63b7ec6$var$kIsWritable,
    isClosed: $9ef933a2f63b7ec6$var$isClosed,
    isDuplexNodeStream: $9ef933a2f63b7ec6$var$isDuplexNodeStream,
    isFinished: $9ef933a2f63b7ec6$var$isFinished,
    isIterable: $9ef933a2f63b7ec6$var$isIterable,
    isReadableNodeStream: $9ef933a2f63b7ec6$var$isReadableNodeStream,
    isReadableStream: $9ef933a2f63b7ec6$var$isReadableStream,
    isReadableEnded: $9ef933a2f63b7ec6$var$isReadableEnded,
    isReadableFinished: $9ef933a2f63b7ec6$var$isReadableFinished,
    isReadableErrored: $9ef933a2f63b7ec6$var$isReadableErrored,
    isNodeStream: $9ef933a2f63b7ec6$var$isNodeStream,
    isWebStream: $9ef933a2f63b7ec6$var$isWebStream,
    isWritable: $9ef933a2f63b7ec6$var$isWritable,
    isWritableNodeStream: $9ef933a2f63b7ec6$var$isWritableNodeStream,
    isWritableStream: $9ef933a2f63b7ec6$var$isWritableStream,
    isWritableEnded: $9ef933a2f63b7ec6$var$isWritableEnded,
    isWritableFinished: $9ef933a2f63b7ec6$var$isWritableFinished,
    isWritableErrored: $9ef933a2f63b7ec6$var$isWritableErrored,
    isServerRequest: $9ef933a2f63b7ec6$var$isServerRequest,
    isServerResponse: $9ef933a2f63b7ec6$var$isServerResponse,
    willEmitClose: $9ef933a2f63b7ec6$var$willEmitClose,
    isTransformStream: $9ef933a2f63b7ec6$var$isTransformStream
};

});

parcelRegister("52Cjj", function(module, exports) {
/* replacement start */ 
var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $PWkkZ = parcelRequire("PWkkZ");
var $3abadb51ef1f2b7d$require$AbortError = $PWkkZ.AbortError;
var $3abadb51ef1f2b7d$require$codes = $PWkkZ.codes;
const { ERR_INVALID_ARG_TYPE: $3abadb51ef1f2b7d$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $3abadb51ef1f2b7d$var$ERR_STREAM_PREMATURE_CLOSE } = $3abadb51ef1f2b7d$require$codes;

var $3abadb51ef1f2b7d$require$kEmptyObject = (parcelRequire("cSbri")).kEmptyObject;
var $3abadb51ef1f2b7d$require$once = (parcelRequire("cSbri")).once;

var $6q8Dc = parcelRequire("6q8Dc");
var $3abadb51ef1f2b7d$require$validateAbortSignal = $6q8Dc.validateAbortSignal;
var $3abadb51ef1f2b7d$require$validateFunction = $6q8Dc.validateFunction;
var $3abadb51ef1f2b7d$require$validateObject = $6q8Dc.validateObject;
var $3abadb51ef1f2b7d$require$validateBoolean = $6q8Dc.validateBoolean;

var $6qlDJ = parcelRequire("6qlDJ");
var $3abadb51ef1f2b7d$require$Promise = $6qlDJ.Promise;
var $3abadb51ef1f2b7d$require$PromisePrototypeThen = $6qlDJ.PromisePrototypeThen;
var $3abadb51ef1f2b7d$require$SymbolDispose = $6qlDJ.SymbolDispose;

var $dEd8A = parcelRequire("dEd8A");
var $3abadb51ef1f2b7d$require$isClosed = $dEd8A.isClosed;
var $3abadb51ef1f2b7d$require$isReadable = $dEd8A.isReadable;
var $3abadb51ef1f2b7d$require$isReadableNodeStream = $dEd8A.isReadableNodeStream;
var $3abadb51ef1f2b7d$require$isReadableStream = $dEd8A.isReadableStream;
var $3abadb51ef1f2b7d$require$isReadableFinished = $dEd8A.isReadableFinished;
var $3abadb51ef1f2b7d$require$isReadableErrored = $dEd8A.isReadableErrored;
var $3abadb51ef1f2b7d$require$isWritable = $dEd8A.isWritable;
var $3abadb51ef1f2b7d$require$isWritableNodeStream = $dEd8A.isWritableNodeStream;
var $3abadb51ef1f2b7d$require$isWritableStream = $dEd8A.isWritableStream;
var $3abadb51ef1f2b7d$require$isWritableFinished = $dEd8A.isWritableFinished;
var $3abadb51ef1f2b7d$require$isWritableErrored = $dEd8A.isWritableErrored;
var $3abadb51ef1f2b7d$require$isNodeStream = $dEd8A.isNodeStream;
var $3abadb51ef1f2b7d$require$_willEmitClose = $dEd8A.willEmitClose;
var $3abadb51ef1f2b7d$require$kIsClosedPromise = $dEd8A.kIsClosedPromise;
let $3abadb51ef1f2b7d$var$addAbortListener;
function $3abadb51ef1f2b7d$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
const $3abadb51ef1f2b7d$var$nop = ()=>{};

function $3abadb51ef1f2b7d$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $3abadb51ef1f2b7d$require$kEmptyObject;
    } else if (options == null) options = $3abadb51ef1f2b7d$require$kEmptyObject;
    else $3abadb51ef1f2b7d$require$validateObject(options, "options");
    $3abadb51ef1f2b7d$require$validateFunction(callback, "callback");
    $3abadb51ef1f2b7d$require$validateAbortSignal(options.signal, "options.signal");
    callback = $3abadb51ef1f2b7d$require$once(callback);
    if ($3abadb51ef1f2b7d$require$isReadableStream(stream) || $3abadb51ef1f2b7d$require$isWritableStream(stream)) return $3abadb51ef1f2b7d$var$eosWeb(stream, options, callback);
    if (!$3abadb51ef1f2b7d$require$isNodeStream(stream)) throw new $3abadb51ef1f2b7d$var$ERR_INVALID_ARG_TYPE("stream", [
        "ReadableStream",
        "WritableStream",
        "Stream"
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $3abadb51ef1f2b7d$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $3abadb51ef1f2b7d$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $3abadb51ef1f2b7d$require$_willEmitClose(stream) && $3abadb51ef1f2b7d$require$isReadableNodeStream(stream) === readable && $3abadb51ef1f2b7d$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $3abadb51ef1f2b7d$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $3abadb51ef1f2b7d$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $3abadb51ef1f2b7d$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $3abadb51ef1f2b7d$require$isWritableErrored(stream) || $3abadb51ef1f2b7d$require$isReadableErrored(stream);
        if (errored && typeof errored !== "boolean") return callback.call(stream, errored);
        if (readable && !readableFinished && $3abadb51ef1f2b7d$require$isReadableNodeStream(stream, true)) {
            if (!$3abadb51ef1f2b7d$require$isReadableFinished(stream, false)) return callback.call(stream, new $3abadb51ef1f2b7d$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$3abadb51ef1f2b7d$require$isWritableFinished(stream, false)) return callback.call(stream, new $3abadb51ef1f2b7d$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $3abadb51ef1f2b7d$require$isWritableErrored(stream) || $3abadb51ef1f2b7d$require$isReadableErrored(stream);
        if (errored && typeof errored !== "boolean") return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on("finish", onfinish);
    };
    if ($3abadb51ef1f2b7d$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        if (!willEmitClose) stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === "boolean") stream.on("aborted", onclose);
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (options.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    if (closed) $hPtJY.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $hPtJY.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $3abadb51ef1f2b7d$require$isReadable(stream)) && (writableFinished || $3abadb51ef1f2b7d$require$isWritable(stream) === false)) $hPtJY.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $3abadb51ef1f2b7d$require$isWritable(stream)) && (readableFinished || $3abadb51ef1f2b7d$require$isReadable(stream) === false)) $hPtJY.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $hPtJY.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $3abadb51ef1f2b7d$var$nop;
        stream.removeListener("aborted", onclose);
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $3abadb51ef1f2b7d$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $hPtJY.nextTick(abort);
        else {
            $3abadb51ef1f2b7d$var$addAbortListener = $3abadb51ef1f2b7d$var$addAbortListener || (parcelRequire("cSbri")).addAbortListener;
            const disposable = $3abadb51ef1f2b7d$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $3abadb51ef1f2b7d$require$once((...args)=>{
                disposable[$3abadb51ef1f2b7d$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $3abadb51ef1f2b7d$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $3abadb51ef1f2b7d$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $3abadb51ef1f2b7d$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $hPtJY.nextTick(abort);
        else {
            $3abadb51ef1f2b7d$var$addAbortListener = $3abadb51ef1f2b7d$var$addAbortListener || (parcelRequire("cSbri")).addAbortListener;
            const disposable = $3abadb51ef1f2b7d$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $3abadb51ef1f2b7d$require$once((...args)=>{
                disposable[$3abadb51ef1f2b7d$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $hPtJY.nextTick(()=>callback.apply(stream, args));
    };
    $3abadb51ef1f2b7d$require$PromisePrototypeThen(stream[$3abadb51ef1f2b7d$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $3abadb51ef1f2b7d$var$nop;
}
function $3abadb51ef1f2b7d$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $3abadb51ef1f2b7d$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $3abadb51ef1f2b7d$require$validateBoolean(opts.cleanup, "cleanup");
        autoCleanup = opts.cleanup;
    }
    return new $3abadb51ef1f2b7d$require$Promise((resolve, reject)=>{
        const cleanup = $3abadb51ef1f2b7d$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $3abadb51ef1f2b7d$var$eos;
module.exports.finished = $3abadb51ef1f2b7d$var$finished;

});
parcelRegister("6q8Dc", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ "use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $4acbddc77dc5371b$require$ArrayIsArray = $6qlDJ.ArrayIsArray;
var $4acbddc77dc5371b$require$ArrayPrototypeIncludes = $6qlDJ.ArrayPrototypeIncludes;
var $4acbddc77dc5371b$require$ArrayPrototypeJoin = $6qlDJ.ArrayPrototypeJoin;
var $4acbddc77dc5371b$require$ArrayPrototypeMap = $6qlDJ.ArrayPrototypeMap;
var $4acbddc77dc5371b$require$NumberIsInteger = $6qlDJ.NumberIsInteger;
var $4acbddc77dc5371b$require$NumberIsNaN = $6qlDJ.NumberIsNaN;
var $4acbddc77dc5371b$require$NumberMAX_SAFE_INTEGER = $6qlDJ.NumberMAX_SAFE_INTEGER;
var $4acbddc77dc5371b$require$NumberMIN_SAFE_INTEGER = $6qlDJ.NumberMIN_SAFE_INTEGER;
var $4acbddc77dc5371b$require$NumberParseInt = $6qlDJ.NumberParseInt;
var $4acbddc77dc5371b$require$ObjectPrototypeHasOwnProperty = $6qlDJ.ObjectPrototypeHasOwnProperty;
var $4acbddc77dc5371b$require$RegExpPrototypeExec = $6qlDJ.RegExpPrototypeExec;
var $4acbddc77dc5371b$require$String = $6qlDJ.String;
var $4acbddc77dc5371b$require$StringPrototypeToUpperCase = $6qlDJ.StringPrototypeToUpperCase;
var $4acbddc77dc5371b$require$StringPrototypeTrim = $6qlDJ.StringPrototypeTrim;

var $PWkkZ = parcelRequire("PWkkZ");
const { hideStackFrames: $4acbddc77dc5371b$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $4acbddc77dc5371b$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $4acbddc77dc5371b$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $4acbddc77dc5371b$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $4acbddc77dc5371b$var$ERR_UNKNOWN_SIGNAL } } = $PWkkZ;

var $cSbri = parcelRequire("cSbri");
const { normalizeEncoding: $4acbddc77dc5371b$var$normalizeEncoding } = $cSbri;

var $cSbri = parcelRequire("cSbri");
const { isAsyncFunction: $4acbddc77dc5371b$var$isAsyncFunction, isArrayBufferView: $4acbddc77dc5371b$var$isArrayBufferView } = $cSbri.types;
const $4acbddc77dc5371b$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $4acbddc77dc5371b$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $4acbddc77dc5371b$var$isUint32(value) {
    return value === value >>> 0;
}
const $4acbddc77dc5371b$var$octalReg = /^[0-7]+$/;
const $4acbddc77dc5371b$var$modeDesc = "must be a 32-bit unsigned integer or an octal string";
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $4acbddc77dc5371b$var$parseFileMode(value, name, def) {
    if (typeof value === "undefined") value = def;
    if (typeof value === "string") {
        if ($4acbddc77dc5371b$require$RegExpPrototypeExec($4acbddc77dc5371b$var$octalReg, value) === null) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_VALUE(name, value, $4acbddc77dc5371b$var$modeDesc);
        value = $4acbddc77dc5371b$require$NumberParseInt(value, 8);
    }
    $4acbddc77dc5371b$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $4acbddc77dc5371b$var$validateInteger = $4acbddc77dc5371b$var$hideStackFrames((value, name, min = $4acbddc77dc5371b$require$NumberMIN_SAFE_INTEGER, max = $4acbddc77dc5371b$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== "number") throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "number", value);
    if (!$4acbddc77dc5371b$require$NumberIsInteger(value)) throw new $4acbddc77dc5371b$var$ERR_OUT_OF_RANGE(name, "an integer", value);
    if (value < min || value > max) throw new $4acbddc77dc5371b$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $4acbddc77dc5371b$var$validateInt32 = $4acbddc77dc5371b$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== "number") throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "number", value);
    if (!$4acbddc77dc5371b$require$NumberIsInteger(value)) throw new $4acbddc77dc5371b$var$ERR_OUT_OF_RANGE(name, "an integer", value);
    if (value < min || value > max) throw new $4acbddc77dc5371b$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $4acbddc77dc5371b$var$validateUint32 = $4acbddc77dc5371b$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== "number") throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "number", value);
    if (!$4acbddc77dc5371b$require$NumberIsInteger(value)) throw new $4acbddc77dc5371b$var$ERR_OUT_OF_RANGE(name, "an integer", value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $4acbddc77dc5371b$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $4acbddc77dc5371b$var$validateString(value, name) {
    if (typeof value !== "string") throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "string", value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $4acbddc77dc5371b$var$validateNumber(value, name, min, max) {
    if (typeof value !== "number") throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "number", value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $4acbddc77dc5371b$require$NumberIsNaN(value)) throw new $4acbddc77dc5371b$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ""}${min != null && max != null ? " && " : ""}${max != null ? `<= ${max}` : ""}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $4acbddc77dc5371b$var$validateOneOf = $4acbddc77dc5371b$var$hideStackFrames((value, name, oneOf)=>{
    if (!$4acbddc77dc5371b$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $4acbddc77dc5371b$require$ArrayPrototypeJoin($4acbddc77dc5371b$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === "string" ? `'${v}'` : $4acbddc77dc5371b$require$String(v)), ", ");
        const reason = "must be one of: " + allowed;
        throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $4acbddc77dc5371b$var$validateBoolean(value, name) {
    if (typeof value !== "boolean") throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "boolean", value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $4acbddc77dc5371b$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$4acbddc77dc5371b$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $4acbddc77dc5371b$var$validateObject = $4acbddc77dc5371b$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $4acbddc77dc5371b$var$getOwnPropertyValueOrDefault(options, "allowArray", false);
    const allowFunction = $4acbddc77dc5371b$var$getOwnPropertyValueOrDefault(options, "allowFunction", false);
    const nullable = $4acbddc77dc5371b$var$getOwnPropertyValueOrDefault(options, "nullable", false);
    if (!nullable && value === null || !allowArray && $4acbddc77dc5371b$require$ArrayIsArray(value) || typeof value !== "object" && (!allowFunction || typeof value !== "function")) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "Object", value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $4acbddc77dc5371b$var$validateDictionary = $4acbddc77dc5371b$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== "object" && typeof value !== "function") throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "a dictionary", value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $4acbddc77dc5371b$var$validateArray = $4acbddc77dc5371b$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$4acbddc77dc5371b$require$ArrayIsArray(value)) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "Array", value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $4acbddc77dc5371b$var$validateStringArray(value, name) {
    $4acbddc77dc5371b$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$4acbddc77dc5371b$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $4acbddc77dc5371b$var$validateBooleanArray(value, name) {
    $4acbddc77dc5371b$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$4acbddc77dc5371b$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $4acbddc77dc5371b$var$validateAbortSignalArray(value, name) {
    $4acbddc77dc5371b$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(indexedName, "AbortSignal", signal);
        $4acbddc77dc5371b$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $4acbddc77dc5371b$var$validateSignalName(signal, name = "signal") {
    $4acbddc77dc5371b$var$validateString(signal, name);
    if ($4acbddc77dc5371b$var$signals[signal] === undefined) {
        if ($4acbddc77dc5371b$var$signals[$4acbddc77dc5371b$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $4acbddc77dc5371b$var$ERR_UNKNOWN_SIGNAL(signal + " (signals must use all capital letters)");
        throw new $4acbddc77dc5371b$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $4acbddc77dc5371b$var$validateBuffer = $4acbddc77dc5371b$var$hideStackFrames((buffer, name = "buffer")=>{
    if (!$4acbddc77dc5371b$var$isArrayBufferView(buffer)) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, [
        "Buffer",
        "TypedArray",
        "DataView"
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $4acbddc77dc5371b$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $4acbddc77dc5371b$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === "hex" && length % 2 !== 0) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_VALUE("encoding", encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $4acbddc77dc5371b$var$validatePort(port, name = "Port", allowZero = true) {
    if (typeof port !== "number" && typeof port !== "string" || typeof port === "string" && $4acbddc77dc5371b$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $4acbddc77dc5371b$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $4acbddc77dc5371b$var$validateAbortSignal = $4acbddc77dc5371b$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== "object" || !("aborted" in signal))) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "AbortSignal", signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $4acbddc77dc5371b$var$validateFunction = $4acbddc77dc5371b$var$hideStackFrames((value, name)=>{
    if (typeof value !== "function") throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "Function", value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $4acbddc77dc5371b$var$validatePlainFunction = $4acbddc77dc5371b$var$hideStackFrames((value, name)=>{
    if (typeof value !== "function" || $4acbddc77dc5371b$var$isAsyncFunction(value)) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "Function", value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $4acbddc77dc5371b$var$validateUndefined = $4acbddc77dc5371b$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "undefined", value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $4acbddc77dc5371b$var$validateUnion(value, name, union) {
    if (!$4acbddc77dc5371b$require$ArrayPrototypeIncludes(union, value)) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, `('${$4acbddc77dc5371b$require$ArrayPrototypeJoin(union, "|")}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $4acbddc77dc5371b$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $4acbddc77dc5371b$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === "undefined" || !$4acbddc77dc5371b$require$RegExpPrototypeExec($4acbddc77dc5371b$var$linkValueRegExp, value)) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $4acbddc77dc5371b$var$validateLinkHeaderValue(hints) {
    if (typeof hints === "string") {
        $4acbddc77dc5371b$var$validateLinkHeaderFormat(hints, "hints");
        return hints;
    } else if ($4acbddc77dc5371b$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = "";
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $4acbddc77dc5371b$var$validateLinkHeaderFormat(link, "hints");
            result += link;
            if (i !== hintsLength - 1) result += ", ";
        }
        return result;
    }
    throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_VALUE("hints", hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $4acbddc77dc5371b$var$isInt32,
    isUint32: $4acbddc77dc5371b$var$isUint32,
    parseFileMode: $4acbddc77dc5371b$var$parseFileMode,
    validateArray: $4acbddc77dc5371b$var$validateArray,
    validateStringArray: $4acbddc77dc5371b$var$validateStringArray,
    validateBooleanArray: $4acbddc77dc5371b$var$validateBooleanArray,
    validateAbortSignalArray: $4acbddc77dc5371b$var$validateAbortSignalArray,
    validateBoolean: $4acbddc77dc5371b$var$validateBoolean,
    validateBuffer: $4acbddc77dc5371b$var$validateBuffer,
    validateDictionary: $4acbddc77dc5371b$var$validateDictionary,
    validateEncoding: $4acbddc77dc5371b$var$validateEncoding,
    validateFunction: $4acbddc77dc5371b$var$validateFunction,
    validateInt32: $4acbddc77dc5371b$var$validateInt32,
    validateInteger: $4acbddc77dc5371b$var$validateInteger,
    validateNumber: $4acbddc77dc5371b$var$validateNumber,
    validateObject: $4acbddc77dc5371b$var$validateObject,
    validateOneOf: $4acbddc77dc5371b$var$validateOneOf,
    validatePlainFunction: $4acbddc77dc5371b$var$validatePlainFunction,
    validatePort: $4acbddc77dc5371b$var$validatePort,
    validateSignalName: $4acbddc77dc5371b$var$validateSignalName,
    validateString: $4acbddc77dc5371b$var$validateString,
    validateUint32: $4acbddc77dc5371b$var$validateUint32,
    validateUndefined: $4acbddc77dc5371b$var$validateUndefined,
    validateUnion: $4acbddc77dc5371b$var$validateUnion,
    validateAbortSignal: $4acbddc77dc5371b$var$validateAbortSignal,
    validateLinkHeaderValue: $4acbddc77dc5371b$var$validateLinkHeaderValue
};

});



parcelRegister("insGM", function(module, exports) {
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $d610a10829238ace$require$StringPrototypeSlice = $6qlDJ.StringPrototypeSlice;
var $d610a10829238ace$require$SymbolIterator = $6qlDJ.SymbolIterator;
var $d610a10829238ace$require$TypedArrayPrototypeSet = $6qlDJ.TypedArrayPrototypeSet;
var $d610a10829238ace$require$Uint8Array = $6qlDJ.Uint8Array;

var $6ZWSX = parcelRequire("6ZWSX");
var $d610a10829238ace$require$Buffer = $6ZWSX.Buffer;

var $cSbri = parcelRequire("cSbri");
var $d610a10829238ace$require$inspect = $cSbri.inspect;
module.exports = class BufferList {
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return "";
        let p = this.head;
        let ret = "" + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $d610a10829238ace$require$Buffer.alloc(0);
        const ret = $d610a10829238ace$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $d610a10829238ace$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$d610a10829238ace$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = "";
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $d610a10829238ace$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $d610a10829238ace$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $d610a10829238ace$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $d610a10829238ace$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $d610a10829238ace$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $d610a10829238ace$require$TypedArrayPrototypeSet(ret, new $d610a10829238ace$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for("nodejs.util.inspect.custom")](_, options) {
        return $d610a10829238ace$require$inspect(this, {
            ...options,
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        });
    }
};

});

parcelRegister("8Pe5V", function(module, exports) {
"use strict";

var $hPtJY = parcelRequire("hPtJY");

var $PWkkZ = parcelRequire("PWkkZ");
/* replacement end */ const { aggregateTwoErrors: $66ce05103b2a1e15$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $66ce05103b2a1e15$var$ERR_MULTIPLE_CALLBACK }, AbortError: $66ce05103b2a1e15$var$AbortError } = $PWkkZ;

var $6qlDJ = parcelRequire("6qlDJ");
var $66ce05103b2a1e15$require$Symbol = $6qlDJ.Symbol;

var $dEd8A = parcelRequire("dEd8A");
var $66ce05103b2a1e15$require$kIsDestroyed = $dEd8A.kIsDestroyed;
var $66ce05103b2a1e15$require$isDestroyed = $dEd8A.isDestroyed;
var $66ce05103b2a1e15$require$isFinished = $dEd8A.isFinished;
var $66ce05103b2a1e15$require$isServerRequest = $dEd8A.isServerRequest;
const $66ce05103b2a1e15$var$kDestroy = $66ce05103b2a1e15$require$Symbol("kDestroy");
const $66ce05103b2a1e15$var$kConstruct = $66ce05103b2a1e15$require$Symbol("kConstruct");
function $66ce05103b2a1e15$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $66ce05103b2a1e15$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === "function") cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $66ce05103b2a1e15$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($66ce05103b2a1e15$var$kDestroy, function(er) {
        $66ce05103b2a1e15$var$_destroy(this, $66ce05103b2a1e15$var$aggregateTwoErrors(er, err), cb);
    });
    else $66ce05103b2a1e15$var$_destroy(this, err, cb);
    return this;
}
function $66ce05103b2a1e15$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $66ce05103b2a1e15$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === "function") cb(err);
        if (err) $hPtJY.nextTick($66ce05103b2a1e15$var$emitErrorCloseNT, self, err);
        else $hPtJY.nextTick($66ce05103b2a1e15$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $66ce05103b2a1e15$var$emitErrorCloseNT(self, err) {
    $66ce05103b2a1e15$var$emitErrorNT(self, err);
    $66ce05103b2a1e15$var$emitCloseNT(self);
}
function $66ce05103b2a1e15$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit("close");
}
function $66ce05103b2a1e15$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit("error", err);
}
function $66ce05103b2a1e15$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $66ce05103b2a1e15$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $hPtJY.nextTick($66ce05103b2a1e15$var$emitErrorNT, stream, err);
        else $66ce05103b2a1e15$var$emitErrorNT(stream, err);
    }
}
function $66ce05103b2a1e15$var$construct(stream, cb) {
    if (typeof stream._construct !== "function") return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($66ce05103b2a1e15$var$kConstruct, cb);
    if (stream.listenerCount($66ce05103b2a1e15$var$kConstruct) > 1) // Duplex
    return;
    $hPtJY.nextTick($66ce05103b2a1e15$var$constructNT, stream);
}
function $66ce05103b2a1e15$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $66ce05103b2a1e15$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $66ce05103b2a1e15$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($66ce05103b2a1e15$var$kDestroy, err);
        else if (err) $66ce05103b2a1e15$var$errorOrDestroy(stream, err, true);
        else $hPtJY.nextTick($66ce05103b2a1e15$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $hPtJY.nextTick(onConstruct, err);
        });
    } catch (err) {
        $hPtJY.nextTick(onConstruct, err);
    }
}
function $66ce05103b2a1e15$var$emitConstructNT(stream) {
    stream.emit($66ce05103b2a1e15$var$kConstruct);
}
function $66ce05103b2a1e15$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === "function";
}
function $66ce05103b2a1e15$var$emitCloseLegacy(stream) {
    stream.emit("close");
}
function $66ce05103b2a1e15$var$emitErrorCloseLegacy(stream, err) {
    stream.emit("error", err);
    $hPtJY.nextTick($66ce05103b2a1e15$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $66ce05103b2a1e15$var$destroyer(stream, err) {
    if (!stream || $66ce05103b2a1e15$require$isDestroyed(stream)) return;
    if (!err && !$66ce05103b2a1e15$require$isFinished(stream)) err = new $66ce05103b2a1e15$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($66ce05103b2a1e15$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($66ce05103b2a1e15$var$isRequest(stream)) stream.abort();
    else if ($66ce05103b2a1e15$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === "function") stream.destroy(err);
    else if (typeof stream.close === "function") // TODO: Don't lose err?
    stream.close();
    else if (err) $hPtJY.nextTick($66ce05103b2a1e15$var$emitErrorCloseLegacy, stream, err);
    else $hPtJY.nextTick($66ce05103b2a1e15$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$66ce05103b2a1e15$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $66ce05103b2a1e15$var$construct,
    destroyer: $66ce05103b2a1e15$var$destroyer,
    destroy: $66ce05103b2a1e15$var$destroy,
    undestroy: $66ce05103b2a1e15$var$undestroy,
    errorOrDestroy: $66ce05103b2a1e15$var$errorOrDestroy
};

});

parcelRegister("5ZWSH", function(module, exports) {
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $45e052d35abe52fb$require$MathFloor = $6qlDJ.MathFloor;
var $45e052d35abe52fb$require$NumberIsInteger = $6qlDJ.NumberIsInteger;

var $6q8Dc = parcelRequire("6q8Dc");
var $45e052d35abe52fb$require$validateInteger = $6q8Dc.validateInteger;

var $PWkkZ = parcelRequire("PWkkZ");
const { ERR_INVALID_ARG_VALUE: $45e052d35abe52fb$var$ERR_INVALID_ARG_VALUE } = $PWkkZ.codes;
let $45e052d35abe52fb$var$defaultHighWaterMarkBytes = 16384;
let $45e052d35abe52fb$var$defaultHighWaterMarkObjectMode = 16;
function $45e052d35abe52fb$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $45e052d35abe52fb$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $45e052d35abe52fb$var$defaultHighWaterMarkObjectMode : $45e052d35abe52fb$var$defaultHighWaterMarkBytes;
}
function $45e052d35abe52fb$var$setDefaultHighWaterMark(objectMode, value) {
    $45e052d35abe52fb$require$validateInteger(value, "value", 0);
    if (objectMode) $45e052d35abe52fb$var$defaultHighWaterMarkObjectMode = value;
    else $45e052d35abe52fb$var$defaultHighWaterMarkBytes = value;
}
function $45e052d35abe52fb$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $45e052d35abe52fb$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$45e052d35abe52fb$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : "options.highWaterMark";
            throw new $45e052d35abe52fb$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $45e052d35abe52fb$require$MathFloor(hwm);
    }
    // Default value
    return $45e052d35abe52fb$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $45e052d35abe52fb$var$getHighWaterMark,
    getDefaultHighWaterMark: $45e052d35abe52fb$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $45e052d35abe52fb$var$setDefaultHighWaterMark
};

});

parcelRegister("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});
parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});


parcelRegister("9gNIm", function(module, exports) {
"use strict";

var $hPtJY = parcelRequire("hPtJY");

var $6qlDJ = parcelRequire("6qlDJ");
var $6bfc2beb4df1a713$require$PromisePrototypeThen = $6qlDJ.PromisePrototypeThen;
var $6bfc2beb4df1a713$require$SymbolAsyncIterator = $6qlDJ.SymbolAsyncIterator;
var $6bfc2beb4df1a713$require$SymbolIterator = $6qlDJ.SymbolIterator;

var $6ZWSX = parcelRequire("6ZWSX");
var $6bfc2beb4df1a713$require$Buffer = $6ZWSX.Buffer;

var $PWkkZ = parcelRequire("PWkkZ");
const { ERR_INVALID_ARG_TYPE: $6bfc2beb4df1a713$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $6bfc2beb4df1a713$var$ERR_STREAM_NULL_VALUES } = $PWkkZ.codes;
function $6bfc2beb4df1a713$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === "string" || iterable instanceof $6bfc2beb4df1a713$require$Buffer) return new Readable({
        objectMode: true,
        ...opts,
        read () {
            this.push(iterable);
            this.push(null);
        }
    });
    let isAsync;
    if (iterable && iterable[$6bfc2beb4df1a713$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$6bfc2beb4df1a713$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$6bfc2beb4df1a713$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$6bfc2beb4df1a713$require$SymbolIterator]();
    } else throw new $6bfc2beb4df1a713$var$ERR_INVALID_ARG_TYPE("iterable", [
        "Iterable"
    ], iterable);
    const readable = new Readable({
        objectMode: true,
        highWaterMark: 1,
        // TODO(ronag): What options should be allowed?
        ...opts
    });
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $6bfc2beb4df1a713$require$PromisePrototypeThen(close(error), ()=>$hPtJY.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$hPtJY.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === "function";
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === "function") {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === "function" ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $6bfc2beb4df1a713$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $6bfc2beb4df1a713$var$from;

});


parcelRegister("4uosb", function(module, exports) {
/* replacement start */ 
var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $344ceeb902e9f356$require$ArrayPrototypeSlice = $6qlDJ.ArrayPrototypeSlice;
var $344ceeb902e9f356$require$Error = $6qlDJ.Error;
var $344ceeb902e9f356$require$FunctionPrototypeSymbolHasInstance = $6qlDJ.FunctionPrototypeSymbolHasInstance;
var $344ceeb902e9f356$require$ObjectDefineProperty = $6qlDJ.ObjectDefineProperty;
var $344ceeb902e9f356$require$ObjectDefineProperties = $6qlDJ.ObjectDefineProperties;
var $344ceeb902e9f356$require$ObjectSetPrototypeOf = $6qlDJ.ObjectSetPrototypeOf;
var $344ceeb902e9f356$require$StringPrototypeToLowerCase = $6qlDJ.StringPrototypeToLowerCase;
var $344ceeb902e9f356$require$Symbol = $6qlDJ.Symbol;
var $344ceeb902e9f356$require$SymbolHasInstance = $6qlDJ.SymbolHasInstance;
module.exports = $344ceeb902e9f356$var$Writable;
$344ceeb902e9f356$var$Writable.WritableState = $344ceeb902e9f356$var$WritableState;

var $7etJZ = parcelRequire("7etJZ");
var $344ceeb902e9f356$require$EE = $7etJZ.EventEmitter;

var $8uq7s = parcelRequire("8uq7s");
var $344ceeb902e9f356$require$Stream = $8uq7s.Stream;

var $6ZWSX = parcelRequire("6ZWSX");
var $344ceeb902e9f356$require$Buffer = $6ZWSX.Buffer;

var $8Pe5V = parcelRequire("8Pe5V");

var $khx7T = parcelRequire("khx7T");
var $344ceeb902e9f356$require$addAbortSignal = $khx7T.addAbortSignal;

var $5ZWSH = parcelRequire("5ZWSH");
var $344ceeb902e9f356$require$getHighWaterMark = $5ZWSH.getHighWaterMark;
var $344ceeb902e9f356$require$getDefaultHighWaterMark = $5ZWSH.getDefaultHighWaterMark;

var $PWkkZ = parcelRequire("PWkkZ");
const { ERR_INVALID_ARG_TYPE: $344ceeb902e9f356$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $344ceeb902e9f356$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $344ceeb902e9f356$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $344ceeb902e9f356$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $344ceeb902e9f356$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $344ceeb902e9f356$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $344ceeb902e9f356$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $344ceeb902e9f356$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $344ceeb902e9f356$var$ERR_UNKNOWN_ENCODING } = $PWkkZ.codes;
const { errorOrDestroy: $344ceeb902e9f356$var$errorOrDestroy } = $8Pe5V;
$344ceeb902e9f356$require$ObjectSetPrototypeOf($344ceeb902e9f356$var$Writable.prototype, $344ceeb902e9f356$require$Stream.prototype);
$344ceeb902e9f356$require$ObjectSetPrototypeOf($344ceeb902e9f356$var$Writable, $344ceeb902e9f356$require$Stream);
function $344ceeb902e9f356$var$nop() {}
const $344ceeb902e9f356$var$kOnFinished = $344ceeb902e9f356$require$Symbol("kOnFinished");

function $344ceeb902e9f356$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof (parcelRequire("3ujhf"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $344ceeb902e9f356$require$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex) : $344ceeb902e9f356$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || "utf8";
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $344ceeb902e9f356$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $344ceeb902e9f356$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$344ceeb902e9f356$var$kOnFinished] = [];
}
function $344ceeb902e9f356$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$344ceeb902e9f356$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $344ceeb902e9f356$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$344ceeb902e9f356$require$ObjectDefineProperty($344ceeb902e9f356$var$WritableState.prototype, "bufferedRequestCount", {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $344ceeb902e9f356$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("3ujhf"));
    if (!isDuplex && !$344ceeb902e9f356$require$FunctionPrototypeSymbolHasInstance($344ceeb902e9f356$var$Writable, this)) return new $344ceeb902e9f356$var$Writable(options);
    this._writableState = new $344ceeb902e9f356$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
        if (typeof options.construct === "function") this._construct = options.construct;
        if (options.signal) $344ceeb902e9f356$require$addAbortSignal(options.signal, this);
    }
    $344ceeb902e9f356$require$Stream.call(this, options);
    $8Pe5V.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $344ceeb902e9f356$var$clearBuffer(this, state);
        $344ceeb902e9f356$var$finishMaybe(this, state);
    });
}
$344ceeb902e9f356$require$ObjectDefineProperty($344ceeb902e9f356$var$Writable, $344ceeb902e9f356$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($344ceeb902e9f356$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $344ceeb902e9f356$var$Writable) return false;
        return object && object._writableState instanceof $344ceeb902e9f356$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$344ceeb902e9f356$var$Writable.prototype.pipe = function() {
    $344ceeb902e9f356$var$errorOrDestroy(this, new $344ceeb902e9f356$var$ERR_STREAM_CANNOT_PIPE());
};
function $344ceeb902e9f356$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== "buffer" && !$344ceeb902e9f356$require$Buffer.isEncoding(encoding)) throw new $344ceeb902e9f356$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== "function") cb = $344ceeb902e9f356$var$nop;
    }
    if (chunk === null) throw new $344ceeb902e9f356$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === "string") {
            if (state.decodeStrings !== false) {
                chunk = $344ceeb902e9f356$require$Buffer.from(chunk, encoding);
                encoding = "buffer";
            }
        } else if (chunk instanceof $344ceeb902e9f356$require$Buffer) encoding = "buffer";
        else if ($344ceeb902e9f356$require$Stream._isUint8Array(chunk)) {
            chunk = $344ceeb902e9f356$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = "buffer";
        } else throw new $344ceeb902e9f356$var$ERR_INVALID_ARG_TYPE("chunk", [
            "string",
            "Buffer",
            "Uint8Array"
        ], chunk);
    }
    let err;
    if (state.ending) err = new $344ceeb902e9f356$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $344ceeb902e9f356$var$ERR_STREAM_DESTROYED("write");
    if (err) {
        $hPtJY.nextTick(cb, err);
        $344ceeb902e9f356$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $344ceeb902e9f356$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$344ceeb902e9f356$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $344ceeb902e9f356$var$_write(this, chunk, encoding, cb) === true;
};
$344ceeb902e9f356$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$344ceeb902e9f356$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $344ceeb902e9f356$var$clearBuffer(this, state);
    }
};
$344ceeb902e9f356$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = $344ceeb902e9f356$require$StringPrototypeToLowerCase(encoding);
    if (!$344ceeb902e9f356$require$Buffer.isEncoding(encoding)) throw new $344ceeb902e9f356$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $344ceeb902e9f356$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== "buffer") state.allBuffers = false;
        if (state.allNoop && callback !== $344ceeb902e9f356$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $344ceeb902e9f356$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $344ceeb902e9f356$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $344ceeb902e9f356$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $344ceeb902e9f356$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $344ceeb902e9f356$var$errorOrDestroy(stream, er);
}
function $344ceeb902e9f356$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== "function") {
        $344ceeb902e9f356$var$errorOrDestroy(stream, new $344ceeb902e9f356$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $hPtJY.nextTick($344ceeb902e9f356$var$onwriteError, stream, state, er, cb);
        else $344ceeb902e9f356$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $344ceeb902e9f356$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $hPtJY.nextTick($344ceeb902e9f356$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $344ceeb902e9f356$var$afterWrite(stream, state, 1, cb);
    }
}
function $344ceeb902e9f356$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $344ceeb902e9f356$var$afterWrite(stream, state, count, cb);
}
function $344ceeb902e9f356$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $344ceeb902e9f356$var$errorBuffer(state);
    $344ceeb902e9f356$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $344ceeb902e9f356$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $344ceeb902e9f356$var$ERR_STREAM_DESTROYED("write"));
    }
    const onfinishCallbacks = state[$344ceeb902e9f356$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $344ceeb902e9f356$var$ERR_STREAM_DESTROYED("end"));
    }
    $344ceeb902e9f356$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $344ceeb902e9f356$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $344ceeb902e9f356$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $344ceeb902e9f356$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $344ceeb902e9f356$var$doWrite(stream, state, true, state.length, chunks, "", callback);
        $344ceeb902e9f356$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $344ceeb902e9f356$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $344ceeb902e9f356$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$344ceeb902e9f356$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $344ceeb902e9f356$var$ERR_METHOD_NOT_IMPLEMENTED("_write()");
};
$344ceeb902e9f356$var$Writable.prototype._writev = null;
$344ceeb902e9f356$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $344ceeb902e9f356$var$_write(this, chunk, encoding);
        if (ret instanceof $344ceeb902e9f356$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $344ceeb902e9f356$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $344ceeb902e9f356$var$ERR_STREAM_ALREADY_FINISHED("end");
    else if (state.destroyed) err = new $344ceeb902e9f356$var$ERR_STREAM_DESTROYED("end");
    if (typeof cb === "function") {
        if (err || state.finished) $hPtJY.nextTick(cb, err);
        else state[$344ceeb902e9f356$var$kOnFinished].push(cb);
    }
    return this;
};
function $344ceeb902e9f356$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $344ceeb902e9f356$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $344ceeb902e9f356$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $344ceeb902e9f356$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$344ceeb902e9f356$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $344ceeb902e9f356$var$errorOrDestroy(stream, err, state.sync);
        } else if ($344ceeb902e9f356$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit("prefinish");
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $hPtJY.nextTick($344ceeb902e9f356$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $344ceeb902e9f356$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.finalCalled = true;
            $344ceeb902e9f356$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $344ceeb902e9f356$var$finishMaybe(stream, state, sync) {
    if ($344ceeb902e9f356$var$needFinish(state)) {
        $344ceeb902e9f356$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $hPtJY.nextTick((stream, state)=>{
                    if ($344ceeb902e9f356$var$needFinish(state)) $344ceeb902e9f356$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($344ceeb902e9f356$var$needFinish(state)) {
                state.pendingcb++;
                $344ceeb902e9f356$var$finish(stream, state);
            }
        }
    }
}
function $344ceeb902e9f356$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$344ceeb902e9f356$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit("finish");
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$344ceeb902e9f356$require$ObjectDefineProperties($344ceeb902e9f356$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $344ceeb902e9f356$var$destroy = $8Pe5V.destroy;
$344ceeb902e9f356$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$344ceeb902e9f356$var$kOnFinished].length)) $hPtJY.nextTick($344ceeb902e9f356$var$errorBuffer, state);
    $344ceeb902e9f356$var$destroy.call(this, err, cb);
    return this;
};
$344ceeb902e9f356$var$Writable.prototype._undestroy = $8Pe5V.undestroy;
$344ceeb902e9f356$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$344ceeb902e9f356$var$Writable.prototype[$344ceeb902e9f356$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $344ceeb902e9f356$var$webStreamsAdapters;
// Lazy to avoid circular references
function $344ceeb902e9f356$var$lazyWebStreams() {
    if ($344ceeb902e9f356$var$webStreamsAdapters === undefined) $344ceeb902e9f356$var$webStreamsAdapters = {};
    return $344ceeb902e9f356$var$webStreamsAdapters;
}
$344ceeb902e9f356$var$Writable.fromWeb = function(writableStream, options) {
    return $344ceeb902e9f356$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$344ceeb902e9f356$var$Writable.toWeb = function(streamWritable) {
    return $344ceeb902e9f356$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("dq9MZ", function(module, exports) {
/* replacement start */ 
var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $6ZWSX = parcelRequire("6ZWSX");

var $dEd8A = parcelRequire("dEd8A");
var $9c554bfbf13c0cee$require$isReadable = $dEd8A.isReadable;
var $9c554bfbf13c0cee$require$isWritable = $dEd8A.isWritable;
var $9c554bfbf13c0cee$require$isIterable = $dEd8A.isIterable;
var $9c554bfbf13c0cee$require$isNodeStream = $dEd8A.isNodeStream;
var $9c554bfbf13c0cee$require$isReadableNodeStream = $dEd8A.isReadableNodeStream;
var $9c554bfbf13c0cee$require$isWritableNodeStream = $dEd8A.isWritableNodeStream;
var $9c554bfbf13c0cee$require$isDuplexNodeStream = $dEd8A.isDuplexNodeStream;
var $9c554bfbf13c0cee$require$isReadableStream = $dEd8A.isReadableStream;
var $9c554bfbf13c0cee$require$isWritableStream = $dEd8A.isWritableStream;

var $52Cjj = parcelRequire("52Cjj");

var $PWkkZ = parcelRequire("PWkkZ");
const { AbortError: $9c554bfbf13c0cee$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $9c554bfbf13c0cee$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $9c554bfbf13c0cee$var$ERR_INVALID_RETURN_VALUE } } = $PWkkZ;

var $8Pe5V = parcelRequire("8Pe5V");
var $9c554bfbf13c0cee$require$destroyer = $8Pe5V.destroyer;

var $3ujhf = parcelRequire("3ujhf");

var $6BZaW = parcelRequire("6BZaW");

var $4uosb = parcelRequire("4uosb");

var $cSbri = parcelRequire("cSbri");
var $9c554bfbf13c0cee$require$createDeferredPromise = $cSbri.createDeferredPromise;

var $9gNIm = parcelRequire("9gNIm");
const $9c554bfbf13c0cee$var$Blob = globalThis.Blob || $6ZWSX.Blob;
const $9c554bfbf13c0cee$var$isBlob = typeof $9c554bfbf13c0cee$var$Blob !== "undefined" ? function isBlob(b) {
    return b instanceof $9c554bfbf13c0cee$var$Blob;
} : function isBlob(b) {
    return false;
};

const $9c554bfbf13c0cee$var$AbortController = globalThis.AbortController || (parcelRequire("bHKGd")).AbortController;

var $6qlDJ = parcelRequire("6qlDJ");
var $9c554bfbf13c0cee$require$FunctionPrototypeCall = $6qlDJ.FunctionPrototypeCall;
// This is needed for pre node 17.
class $9c554bfbf13c0cee$var$Duplexify extends $3ujhf {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($9c554bfbf13c0cee$require$isDuplexNodeStream(body)) return body;
    if ($9c554bfbf13c0cee$require$isReadableNodeStream(body)) return $9c554bfbf13c0cee$var$_duplexify({
        readable: body
    });
    if ($9c554bfbf13c0cee$require$isWritableNodeStream(body)) return $9c554bfbf13c0cee$var$_duplexify({
        writable: body
    });
    if ($9c554bfbf13c0cee$require$isNodeStream(body)) return $9c554bfbf13c0cee$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($9c554bfbf13c0cee$require$isReadableStream(body)) return $9c554bfbf13c0cee$var$_duplexify({
        readable: $6BZaW.fromWeb(body)
    });
    if ($9c554bfbf13c0cee$require$isWritableStream(body)) return $9c554bfbf13c0cee$var$_duplexify({
        writable: $4uosb.fromWeb(body)
    });
    if (typeof body === "function") {
        const { value: value, write: write, final: final, destroy: destroy } = $9c554bfbf13c0cee$var$fromAsyncGen(body);
        if ($9c554bfbf13c0cee$require$isIterable(value)) return $9gNIm($9c554bfbf13c0cee$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === "function") {
            let d;
            const promise = $9c554bfbf13c0cee$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $9c554bfbf13c0cee$var$ERR_INVALID_RETURN_VALUE("nully", "body", val);
            }, (err)=>{
                $9c554bfbf13c0cee$require$destroyer(d, err);
            });
            return d = new $9c554bfbf13c0cee$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $hPtJY.nextTick(cb, null);
                        } catch (err) {
                            $hPtJY.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $9c554bfbf13c0cee$var$ERR_INVALID_RETURN_VALUE("Iterable, AsyncIterable or AsyncFunction", name, value);
    }
    if ($9c554bfbf13c0cee$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($9c554bfbf13c0cee$require$isIterable(body)) return $9gNIm($9c554bfbf13c0cee$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($9c554bfbf13c0cee$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $9c554bfbf13c0cee$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $9c554bfbf13c0cee$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === "object" || typeof (body === null || body === undefined ? undefined : body.readable) === "object") {
        const readable = body !== null && body !== undefined && body.readable ? $9c554bfbf13c0cee$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $9c554bfbf13c0cee$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $9c554bfbf13c0cee$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === "function") {
        let d;
        $9c554bfbf13c0cee$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $9c554bfbf13c0cee$require$destroyer(d, err);
        });
        return d = new $9c554bfbf13c0cee$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $9c554bfbf13c0cee$var$ERR_INVALID_ARG_TYPE(name, [
        "Blob",
        "ReadableStream",
        "WritableStream",
        "Stream",
        "Iterable",
        "AsyncIterable",
        "Function",
        "{ readable, writable } pair",
        "Promise"
    ], body);
};
function $9c554bfbf13c0cee$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $9c554bfbf13c0cee$require$createDeferredPromise();
    const ac = new $9c554bfbf13c0cee$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $hPtJY.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $9c554bfbf13c0cee$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $9c554bfbf13c0cee$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $9c554bfbf13c0cee$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== "function" ? $6BZaW.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$9c554bfbf13c0cee$require$isReadable(r);
    let writable = !!$9c554bfbf13c0cee$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $9c554bfbf13c0cee$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $52Cjj(w, (err)=>{
            writable = false;
            if (err) $9c554bfbf13c0cee$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on("drain", function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on("finish", function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $52Cjj(r, (err)=>{
            readable = false;
            if (err) $9c554bfbf13c0cee$require$destroyer(r, err);
            onfinished(err);
        });
        r.on("readable", function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on("end", function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $9c554bfbf13c0cee$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $9c554bfbf13c0cee$require$destroyer(w, err);
            $9c554bfbf13c0cee$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("iXAaU", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $dcd9cc4274c6eced$require$ObjectSetPrototypeOf = $6qlDJ.ObjectSetPrototypeOf;
module.exports = $dcd9cc4274c6eced$var$PassThrough;

var $3LvcR = parcelRequire("3LvcR");
$dcd9cc4274c6eced$require$ObjectSetPrototypeOf($dcd9cc4274c6eced$var$PassThrough.prototype, $3LvcR.prototype);
$dcd9cc4274c6eced$require$ObjectSetPrototypeOf($dcd9cc4274c6eced$var$PassThrough, $3LvcR);
function $dcd9cc4274c6eced$var$PassThrough(options) {
    if (!(this instanceof $dcd9cc4274c6eced$var$PassThrough)) return new $dcd9cc4274c6eced$var$PassThrough(options);
    $3LvcR.call(this, options);
}
$dcd9cc4274c6eced$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("3LvcR", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $2bddf7d853db3b47$require$ObjectSetPrototypeOf = $6qlDJ.ObjectSetPrototypeOf;
var $2bddf7d853db3b47$require$Symbol = $6qlDJ.Symbol;
module.exports = $2bddf7d853db3b47$var$Transform;

var $PWkkZ = parcelRequire("PWkkZ");
const { ERR_METHOD_NOT_IMPLEMENTED: $2bddf7d853db3b47$var$ERR_METHOD_NOT_IMPLEMENTED } = $PWkkZ.codes;

var $3ujhf = parcelRequire("3ujhf");

var $5ZWSH = parcelRequire("5ZWSH");
var $2bddf7d853db3b47$require$getHighWaterMark = $5ZWSH.getHighWaterMark;
$2bddf7d853db3b47$require$ObjectSetPrototypeOf($2bddf7d853db3b47$var$Transform.prototype, $3ujhf.prototype);
$2bddf7d853db3b47$require$ObjectSetPrototypeOf($2bddf7d853db3b47$var$Transform, $3ujhf);
const $2bddf7d853db3b47$var$kCallback = $2bddf7d853db3b47$require$Symbol("kCallback");
function $2bddf7d853db3b47$var$Transform(options) {
    if (!(this instanceof $2bddf7d853db3b47$var$Transform)) return new $2bddf7d853db3b47$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $2bddf7d853db3b47$require$getHighWaterMark(this, options, "readableHighWaterMark", true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = {
        ...options,
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    };
    $3ujhf.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$2bddf7d853db3b47$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on("prefinish", $2bddf7d853db3b47$var$prefinish);
}
function $2bddf7d853db3b47$var$final(cb) {
    if (typeof this._flush === "function" && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $2bddf7d853db3b47$var$prefinish() {
    if (this._final !== $2bddf7d853db3b47$var$final) $2bddf7d853db3b47$var$final.call(this);
}
$2bddf7d853db3b47$var$Transform.prototype._final = $2bddf7d853db3b47$var$final;
$2bddf7d853db3b47$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $2bddf7d853db3b47$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()");
};
$2bddf7d853db3b47$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$2bddf7d853db3b47$var$kCallback] = callback;
    });
};
$2bddf7d853db3b47$var$Transform.prototype._read = function() {
    if (this[$2bddf7d853db3b47$var$kCallback]) {
        const callback = this[$2bddf7d853db3b47$var$kCallback];
        this[$2bddf7d853db3b47$var$kCallback] = null;
        callback();
    }
};

});


parcelRegister("R5nvG", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("hGlpy", function(module, exports) {

exports = module.exports = (parcelRequire("ckMF8"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("bmKud"));

exports.Duplex = (parcelRequire("76uBF"));

exports.Transform = (parcelRequire("ac3yK"));

exports.PassThrough = (parcelRequire("ctboS"));

exports.finished = (parcelRequire("i2czs"));

exports.pipeline = (parcelRequire("lD2IR"));

});
parcelRegister("ckMF8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $8fad199f73b0aeea$var$Readable;
/*<replacement>*/ var $8fad199f73b0aeea$var$Duplex;
/*</replacement>*/ $8fad199f73b0aeea$var$Readable.ReadableState = $8fad199f73b0aeea$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $8fad199f73b0aeea$require$EE = $7etJZ.EventEmitter;
var $8fad199f73b0aeea$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $eRMOj = parcelRequire("eRMOj");

var $6ZWSX = parcelRequire("6ZWSX");
var $8fad199f73b0aeea$require$Buffer = $6ZWSX.Buffer;
var $8fad199f73b0aeea$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $8fad199f73b0aeea$var$_uint8ArrayToBuffer(chunk) {
    return $8fad199f73b0aeea$require$Buffer.from(chunk);
}
function $8fad199f73b0aeea$var$_isUint8Array(obj) {
    return $8fad199f73b0aeea$require$Buffer.isBuffer(obj) || obj instanceof $8fad199f73b0aeea$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $8fad199f73b0aeea$var$debug;
if ($kjyEk && $kjyEk.debuglog) $8fad199f73b0aeea$var$debug = $kjyEk.debuglog("stream");
else $8fad199f73b0aeea$var$debug = function debug() {};

var $5SYcZ = parcelRequire("5SYcZ");

var $bXXPL = parcelRequire("bXXPL");

var $i9Q8t = parcelRequire("i9Q8t");
var $8fad199f73b0aeea$var$getHighWaterMark = $i9Q8t.getHighWaterMark;

var $D4eFi = parcelRequire("D4eFi");
var $8fad199f73b0aeea$require$_require$codes = $D4eFi.codes;
var $8fad199f73b0aeea$var$ERR_INVALID_ARG_TYPE = $8fad199f73b0aeea$require$_require$codes.ERR_INVALID_ARG_TYPE, $8fad199f73b0aeea$var$ERR_STREAM_PUSH_AFTER_EOF = $8fad199f73b0aeea$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $8fad199f73b0aeea$var$ERR_METHOD_NOT_IMPLEMENTED = $8fad199f73b0aeea$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $8fad199f73b0aeea$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $8fad199f73b0aeea$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $8fad199f73b0aeea$var$StringDecoder;
var $8fad199f73b0aeea$var$createReadableStreamAsyncIterator;
var $8fad199f73b0aeea$var$from;

(parcelRequire("dlqwk"))($8fad199f73b0aeea$var$Readable, $eRMOj);
var $8fad199f73b0aeea$var$errorOrDestroy = $bXXPL.errorOrDestroy;
var $8fad199f73b0aeea$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $8fad199f73b0aeea$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $8fad199f73b0aeea$var$ReadableState(options, stream, isDuplex) {
    $8fad199f73b0aeea$var$Duplex = $8fad199f73b0aeea$var$Duplex || (parcelRequire("76uBF"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $8fad199f73b0aeea$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $8fad199f73b0aeea$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $5SYcZ();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$8fad199f73b0aeea$var$StringDecoder) $8fad199f73b0aeea$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $8fad199f73b0aeea$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $8fad199f73b0aeea$var$Readable(options) {
    $8fad199f73b0aeea$var$Duplex = $8fad199f73b0aeea$var$Duplex || (parcelRequire("76uBF"));
    if (!(this instanceof $8fad199f73b0aeea$var$Readable)) return new $8fad199f73b0aeea$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $8fad199f73b0aeea$var$Duplex;
    this._readableState = new $8fad199f73b0aeea$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $eRMOj.call(this);
}
Object.defineProperty($8fad199f73b0aeea$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$8fad199f73b0aeea$var$Readable.prototype.destroy = $bXXPL.destroy;
$8fad199f73b0aeea$var$Readable.prototype._undestroy = $bXXPL.undestroy;
$8fad199f73b0aeea$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$8fad199f73b0aeea$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $8fad199f73b0aeea$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $8fad199f73b0aeea$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$8fad199f73b0aeea$var$Readable.prototype.unshift = function(chunk) {
    return $8fad199f73b0aeea$var$readableAddChunk(this, chunk, null, true, false);
};
function $8fad199f73b0aeea$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $8fad199f73b0aeea$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $8fad199f73b0aeea$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $8fad199f73b0aeea$var$chunkInvalid(state, chunk);
        if (er) $8fad199f73b0aeea$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $8fad199f73b0aeea$require$Buffer.prototype) chunk = $8fad199f73b0aeea$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $8fad199f73b0aeea$var$errorOrDestroy(stream, new $8fad199f73b0aeea$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $8fad199f73b0aeea$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $8fad199f73b0aeea$var$errorOrDestroy(stream, new $8fad199f73b0aeea$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $8fad199f73b0aeea$var$addChunk(stream, state, chunk, false);
                    else $8fad199f73b0aeea$var$maybeReadMore(stream, state);
                } else $8fad199f73b0aeea$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $8fad199f73b0aeea$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $8fad199f73b0aeea$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $8fad199f73b0aeea$var$emitReadable(stream);
    }
    $8fad199f73b0aeea$var$maybeReadMore(stream, state);
}
function $8fad199f73b0aeea$var$chunkInvalid(state, chunk) {
    var er;
    if (!$8fad199f73b0aeea$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $8fad199f73b0aeea$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$8fad199f73b0aeea$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$8fad199f73b0aeea$var$Readable.prototype.setEncoding = function(enc) {
    if (!$8fad199f73b0aeea$var$StringDecoder) $8fad199f73b0aeea$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $8fad199f73b0aeea$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $8fad199f73b0aeea$var$MAX_HWM = 0x40000000;
function $8fad199f73b0aeea$var$computeNewHighWaterMark(n) {
    if (n >= $8fad199f73b0aeea$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $8fad199f73b0aeea$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $8fad199f73b0aeea$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $8fad199f73b0aeea$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$8fad199f73b0aeea$var$Readable.prototype.read = function(n) {
    $8fad199f73b0aeea$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $8fad199f73b0aeea$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $8fad199f73b0aeea$var$endReadable(this);
        else $8fad199f73b0aeea$var$emitReadable(this);
        return null;
    }
    n = $8fad199f73b0aeea$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $8fad199f73b0aeea$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $8fad199f73b0aeea$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $8fad199f73b0aeea$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $8fad199f73b0aeea$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $8fad199f73b0aeea$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $8fad199f73b0aeea$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $8fad199f73b0aeea$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $8fad199f73b0aeea$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $8fad199f73b0aeea$var$onEofChunk(stream, state) {
    $8fad199f73b0aeea$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $8fad199f73b0aeea$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $8fad199f73b0aeea$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $8fad199f73b0aeea$var$emitReadable(stream) {
    var state = stream._readableState;
    $8fad199f73b0aeea$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $8fad199f73b0aeea$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($8fad199f73b0aeea$var$emitReadable_, stream);
    }
}
function $8fad199f73b0aeea$var$emitReadable_(stream) {
    var state = stream._readableState;
    $8fad199f73b0aeea$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $8fad199f73b0aeea$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $8fad199f73b0aeea$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($8fad199f73b0aeea$var$maybeReadMore_, stream, state);
    }
}
function $8fad199f73b0aeea$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $8fad199f73b0aeea$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$8fad199f73b0aeea$var$Readable.prototype._read = function(n) {
    $8fad199f73b0aeea$var$errorOrDestroy(this, new $8fad199f73b0aeea$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$8fad199f73b0aeea$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $8fad199f73b0aeea$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $8fad199f73b0aeea$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $8fad199f73b0aeea$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $8fad199f73b0aeea$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $8fad199f73b0aeea$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $8fad199f73b0aeea$var$debug("ondata");
        var ret = dest.write(chunk);
        $8fad199f73b0aeea$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $8fad199f73b0aeea$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $8fad199f73b0aeea$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $8fad199f73b0aeea$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($8fad199f73b0aeea$var$EElistenerCount(dest, "error") === 0) $8fad199f73b0aeea$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $8fad199f73b0aeea$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $8fad199f73b0aeea$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $8fad199f73b0aeea$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $8fad199f73b0aeea$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $8fad199f73b0aeea$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $8fad199f73b0aeea$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $8fad199f73b0aeea$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $8fad199f73b0aeea$var$flow(src);
        }
    };
}
$8fad199f73b0aeea$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $8fad199f73b0aeea$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$8fad199f73b0aeea$var$Readable.prototype.on = function(ev, fn) {
    var res = $eRMOj.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $8fad199f73b0aeea$var$debug("on readable", state.length, state.reading);
            if (state.length) $8fad199f73b0aeea$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($8fad199f73b0aeea$var$nReadingNextTick, this);
        }
    }
    return res;
};
$8fad199f73b0aeea$var$Readable.prototype.addListener = $8fad199f73b0aeea$var$Readable.prototype.on;
$8fad199f73b0aeea$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $eRMOj.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($8fad199f73b0aeea$var$updateReadableListening, this);
    return res;
};
$8fad199f73b0aeea$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $eRMOj.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($8fad199f73b0aeea$var$updateReadableListening, this);
    return res;
};
function $8fad199f73b0aeea$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $8fad199f73b0aeea$var$nReadingNextTick(self1) {
    $8fad199f73b0aeea$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$8fad199f73b0aeea$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $8fad199f73b0aeea$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $8fad199f73b0aeea$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $8fad199f73b0aeea$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($8fad199f73b0aeea$var$resume_, stream, state);
    }
}
function $8fad199f73b0aeea$var$resume_(stream, state) {
    $8fad199f73b0aeea$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $8fad199f73b0aeea$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$8fad199f73b0aeea$var$Readable.prototype.pause = function() {
    $8fad199f73b0aeea$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $8fad199f73b0aeea$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $8fad199f73b0aeea$var$flow(stream) {
    var state = stream._readableState;
    $8fad199f73b0aeea$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$8fad199f73b0aeea$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $8fad199f73b0aeea$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $8fad199f73b0aeea$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $8fad199f73b0aeea$var$kProxyEvents.length; n++)stream.on($8fad199f73b0aeea$var$kProxyEvents[n], this.emit.bind(this, $8fad199f73b0aeea$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $8fad199f73b0aeea$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $8fad199f73b0aeea$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($8fad199f73b0aeea$var$createReadableStreamAsyncIterator === undefined) $8fad199f73b0aeea$var$createReadableStreamAsyncIterator = (parcelRequire("jwtCv"));
    return $8fad199f73b0aeea$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($8fad199f73b0aeea$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($8fad199f73b0aeea$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($8fad199f73b0aeea$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$8fad199f73b0aeea$var$Readable._fromList = $8fad199f73b0aeea$var$fromList;
Object.defineProperty($8fad199f73b0aeea$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $8fad199f73b0aeea$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $8fad199f73b0aeea$var$endReadable(stream) {
    var state = stream._readableState;
    $8fad199f73b0aeea$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($8fad199f73b0aeea$var$endReadableNT, state, stream);
    }
}
function $8fad199f73b0aeea$var$endReadableNT(state, stream) {
    $8fad199f73b0aeea$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $8fad199f73b0aeea$var$Readable.from = function(iterable, opts) {
    if ($8fad199f73b0aeea$var$from === undefined) $8fad199f73b0aeea$var$from = (parcelRequire("j6cxb"));
    return $8fad199f73b0aeea$var$from($8fad199f73b0aeea$var$Readable, iterable, opts);
};
function $8fad199f73b0aeea$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("eRMOj", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("5SYcZ", function(module, exports) {
"use strict";
function $4490b309386615cd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4490b309386615cd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4490b309386615cd$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4490b309386615cd$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4490b309386615cd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4490b309386615cd$var$_defineProperty(obj, key, value) {
    key = $4490b309386615cd$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4490b309386615cd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4490b309386615cd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4490b309386615cd$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4490b309386615cd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4490b309386615cd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4490b309386615cd$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4490b309386615cd$var$_toPropertyKey(arg) {
    var key = $4490b309386615cd$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $4490b309386615cd$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $4490b309386615cd$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $4490b309386615cd$var$inspect = $kjyEk.inspect;
var $4490b309386615cd$var$custom = $4490b309386615cd$var$inspect && $4490b309386615cd$var$inspect.custom || "inspect";
function $4490b309386615cd$var$copyBuffer(src, target, offset) {
    $4490b309386615cd$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $4490b309386615cd$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $4490b309386615cd$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $4490b309386615cd$var$Buffer.alloc(0);
                var ret = $4490b309386615cd$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $4490b309386615cd$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $4490b309386615cd$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $4490b309386615cd$var$custom,
            value: function value(_, options) {
                return $4490b309386615cd$var$inspect(this, $4490b309386615cd$var$_objectSpread($4490b309386615cd$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("bXXPL", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $8b639e23cbf7b1a8$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($8b639e23cbf7b1a8$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($8b639e23cbf7b1a8$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($8b639e23cbf7b1a8$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($8b639e23cbf7b1a8$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($8b639e23cbf7b1a8$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($8b639e23cbf7b1a8$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($8b639e23cbf7b1a8$var$emitCloseNT, _this);
    });
    return this;
}
function $8b639e23cbf7b1a8$var$emitErrorAndCloseNT(self, err) {
    $8b639e23cbf7b1a8$var$emitErrorNT(self, err);
    $8b639e23cbf7b1a8$var$emitCloseNT(self);
}
function $8b639e23cbf7b1a8$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $8b639e23cbf7b1a8$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $8b639e23cbf7b1a8$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $8b639e23cbf7b1a8$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $8b639e23cbf7b1a8$var$destroy,
    undestroy: $8b639e23cbf7b1a8$var$undestroy,
    errorOrDestroy: $8b639e23cbf7b1a8$var$errorOrDestroy
};

});

parcelRegister("i9Q8t", function(module, exports) {
"use strict";

var $d3818255098935fc$var$ERR_INVALID_OPT_VALUE = (parcelRequire("D4eFi")).codes.ERR_INVALID_OPT_VALUE;
function $d3818255098935fc$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $d3818255098935fc$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $d3818255098935fc$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $d3818255098935fc$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $d3818255098935fc$var$getHighWaterMark
};

});
parcelRegister("D4eFi", function(module, exports) {

$parcel$export(module.exports, "codes", () => $0756edb8c0a7f0bb$export$e45cb6485273080e, (v) => $0756edb8c0a7f0bb$export$e45cb6485273080e = v);
var $0756edb8c0a7f0bb$export$e45cb6485273080e;
"use strict";
function $0756edb8c0a7f0bb$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $0756edb8c0a7f0bb$var$codes = {};
function $0756edb8c0a7f0bb$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $0756edb8c0a7f0bb$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $0756edb8c0a7f0bb$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $0756edb8c0a7f0bb$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $0756edb8c0a7f0bb$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $0756edb8c0a7f0bb$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $0756edb8c0a7f0bb$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$0756edb8c0a7f0bb$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$0756edb8c0a7f0bb$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $0756edb8c0a7f0bb$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($0756edb8c0a7f0bb$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($0756edb8c0a7f0bb$var$oneOf(expected, "type"));
    else {
        var type = $0756edb8c0a7f0bb$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($0756edb8c0a7f0bb$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$0756edb8c0a7f0bb$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$0756edb8c0a7f0bb$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$0756edb8c0a7f0bb$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$0756edb8c0a7f0bb$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$0756edb8c0a7f0bb$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$0756edb8c0a7f0bb$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$0756edb8c0a7f0bb$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$0756edb8c0a7f0bb$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$0756edb8c0a7f0bb$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$0756edb8c0a7f0bb$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$0756edb8c0a7f0bb$export$e45cb6485273080e = $0756edb8c0a7f0bb$var$codes;

});


parcelRegister("76uBF", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $52c0d5c5894ea23a$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $52c0d5c5894ea23a$var$Duplex;

var $ckMF8 = parcelRequire("ckMF8");

var $bmKud = parcelRequire("bmKud");

(parcelRequire("dlqwk"))($52c0d5c5894ea23a$var$Duplex, $ckMF8);
// Allow the keys array to be GC'ed.
var $52c0d5c5894ea23a$var$keys = $52c0d5c5894ea23a$var$objectKeys($bmKud.prototype);
for(var $52c0d5c5894ea23a$var$v = 0; $52c0d5c5894ea23a$var$v < $52c0d5c5894ea23a$var$keys.length; $52c0d5c5894ea23a$var$v++){
    var $52c0d5c5894ea23a$var$method = $52c0d5c5894ea23a$var$keys[$52c0d5c5894ea23a$var$v];
    if (!$52c0d5c5894ea23a$var$Duplex.prototype[$52c0d5c5894ea23a$var$method]) $52c0d5c5894ea23a$var$Duplex.prototype[$52c0d5c5894ea23a$var$method] = $bmKud.prototype[$52c0d5c5894ea23a$var$method];
}
function $52c0d5c5894ea23a$var$Duplex(options) {
    if (!(this instanceof $52c0d5c5894ea23a$var$Duplex)) return new $52c0d5c5894ea23a$var$Duplex(options);
    $ckMF8.call(this, options);
    $bmKud.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $52c0d5c5894ea23a$var$onend);
        }
    }
}
Object.defineProperty($52c0d5c5894ea23a$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($52c0d5c5894ea23a$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($52c0d5c5894ea23a$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $52c0d5c5894ea23a$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($52c0d5c5894ea23a$var$onEndNT, this);
}
function $52c0d5c5894ea23a$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($52c0d5c5894ea23a$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("bmKud", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $8465cefe90e1fd93$var$Writable;
/* <replacement> */ function $8465cefe90e1fd93$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $8465cefe90e1fd93$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $8465cefe90e1fd93$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $8465cefe90e1fd93$var$Duplex;
/*</replacement>*/ $8465cefe90e1fd93$var$Writable.WritableState = $8465cefe90e1fd93$var$WritableState;

/*<replacement>*/ var $8465cefe90e1fd93$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $eRMOj = parcelRequire("eRMOj");

var $6ZWSX = parcelRequire("6ZWSX");
var $8465cefe90e1fd93$require$Buffer = $6ZWSX.Buffer;
var $8465cefe90e1fd93$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $8465cefe90e1fd93$var$_uint8ArrayToBuffer(chunk) {
    return $8465cefe90e1fd93$require$Buffer.from(chunk);
}
function $8465cefe90e1fd93$var$_isUint8Array(obj) {
    return $8465cefe90e1fd93$require$Buffer.isBuffer(obj) || obj instanceof $8465cefe90e1fd93$var$OurUint8Array;
}

var $bXXPL = parcelRequire("bXXPL");

var $i9Q8t = parcelRequire("i9Q8t");
var $8465cefe90e1fd93$var$getHighWaterMark = $i9Q8t.getHighWaterMark;

var $D4eFi = parcelRequire("D4eFi");
var $8465cefe90e1fd93$require$_require$codes = $D4eFi.codes;
var $8465cefe90e1fd93$var$ERR_INVALID_ARG_TYPE = $8465cefe90e1fd93$require$_require$codes.ERR_INVALID_ARG_TYPE, $8465cefe90e1fd93$var$ERR_METHOD_NOT_IMPLEMENTED = $8465cefe90e1fd93$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $8465cefe90e1fd93$var$ERR_MULTIPLE_CALLBACK = $8465cefe90e1fd93$require$_require$codes.ERR_MULTIPLE_CALLBACK, $8465cefe90e1fd93$var$ERR_STREAM_CANNOT_PIPE = $8465cefe90e1fd93$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $8465cefe90e1fd93$var$ERR_STREAM_DESTROYED = $8465cefe90e1fd93$require$_require$codes.ERR_STREAM_DESTROYED, $8465cefe90e1fd93$var$ERR_STREAM_NULL_VALUES = $8465cefe90e1fd93$require$_require$codes.ERR_STREAM_NULL_VALUES, $8465cefe90e1fd93$var$ERR_STREAM_WRITE_AFTER_END = $8465cefe90e1fd93$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $8465cefe90e1fd93$var$ERR_UNKNOWN_ENCODING = $8465cefe90e1fd93$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $8465cefe90e1fd93$var$errorOrDestroy = $bXXPL.errorOrDestroy;

(parcelRequire("dlqwk"))($8465cefe90e1fd93$var$Writable, $eRMOj);
function $8465cefe90e1fd93$var$nop() {}

function $8465cefe90e1fd93$var$WritableState(options, stream, isDuplex) {
    $8465cefe90e1fd93$var$Duplex = $8465cefe90e1fd93$var$Duplex || (parcelRequire("76uBF"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $8465cefe90e1fd93$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $8465cefe90e1fd93$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $8465cefe90e1fd93$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $8465cefe90e1fd93$var$CorkedRequest(this);
}
$8465cefe90e1fd93$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($8465cefe90e1fd93$var$WritableState.prototype, "buffer", {
            get: $8465cefe90e1fd93$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $8465cefe90e1fd93$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $8465cefe90e1fd93$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($8465cefe90e1fd93$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($8465cefe90e1fd93$var$realHasInstance.call(this, object)) return true;
            if (this !== $8465cefe90e1fd93$var$Writable) return false;
            return object && object._writableState instanceof $8465cefe90e1fd93$var$WritableState;
        }
    });
} else $8465cefe90e1fd93$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $8465cefe90e1fd93$var$Writable(options) {
    $8465cefe90e1fd93$var$Duplex = $8465cefe90e1fd93$var$Duplex || (parcelRequire("76uBF"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $8465cefe90e1fd93$var$Duplex;
    if (!isDuplex && !$8465cefe90e1fd93$var$realHasInstance.call($8465cefe90e1fd93$var$Writable, this)) return new $8465cefe90e1fd93$var$Writable(options);
    this._writableState = new $8465cefe90e1fd93$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $eRMOj.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$8465cefe90e1fd93$var$Writable.prototype.pipe = function() {
    $8465cefe90e1fd93$var$errorOrDestroy(this, new $8465cefe90e1fd93$var$ERR_STREAM_CANNOT_PIPE());
};
function $8465cefe90e1fd93$var$writeAfterEnd(stream, cb) {
    var er = new $8465cefe90e1fd93$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $8465cefe90e1fd93$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $8465cefe90e1fd93$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $8465cefe90e1fd93$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $8465cefe90e1fd93$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $8465cefe90e1fd93$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$8465cefe90e1fd93$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $8465cefe90e1fd93$var$_isUint8Array(chunk);
    if (isBuf && !$8465cefe90e1fd93$require$Buffer.isBuffer(chunk)) chunk = $8465cefe90e1fd93$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $8465cefe90e1fd93$var$nop;
    if (state.ending) $8465cefe90e1fd93$var$writeAfterEnd(this, cb);
    else if (isBuf || $8465cefe90e1fd93$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $8465cefe90e1fd93$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$8465cefe90e1fd93$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$8465cefe90e1fd93$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $8465cefe90e1fd93$var$clearBuffer(this, state);
    }
};
$8465cefe90e1fd93$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $8465cefe90e1fd93$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($8465cefe90e1fd93$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $8465cefe90e1fd93$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $8465cefe90e1fd93$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($8465cefe90e1fd93$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $8465cefe90e1fd93$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $8465cefe90e1fd93$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $8465cefe90e1fd93$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $8465cefe90e1fd93$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $8465cefe90e1fd93$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $8465cefe90e1fd93$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($8465cefe90e1fd93$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $8465cefe90e1fd93$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $8465cefe90e1fd93$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $8465cefe90e1fd93$var$finishMaybe(stream, state);
    }
}
function $8465cefe90e1fd93$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $8465cefe90e1fd93$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $8465cefe90e1fd93$var$ERR_MULTIPLE_CALLBACK();
    $8465cefe90e1fd93$var$onwriteStateUpdate(state);
    if (er) $8465cefe90e1fd93$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $8465cefe90e1fd93$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $8465cefe90e1fd93$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($8465cefe90e1fd93$var$afterWrite, stream, state, finished, cb);
        else $8465cefe90e1fd93$var$afterWrite(stream, state, finished, cb);
    }
}
function $8465cefe90e1fd93$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $8465cefe90e1fd93$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $8465cefe90e1fd93$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $8465cefe90e1fd93$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $8465cefe90e1fd93$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $8465cefe90e1fd93$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $8465cefe90e1fd93$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $8465cefe90e1fd93$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$8465cefe90e1fd93$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $8465cefe90e1fd93$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$8465cefe90e1fd93$var$Writable.prototype._writev = null;
$8465cefe90e1fd93$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $8465cefe90e1fd93$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($8465cefe90e1fd93$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $8465cefe90e1fd93$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $8465cefe90e1fd93$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $8465cefe90e1fd93$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $8465cefe90e1fd93$var$finishMaybe(stream, state);
    });
}
function $8465cefe90e1fd93$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($8465cefe90e1fd93$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $8465cefe90e1fd93$var$finishMaybe(stream, state) {
    var need = $8465cefe90e1fd93$var$needFinish(state);
    if (need) {
        $8465cefe90e1fd93$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $8465cefe90e1fd93$var$endWritable(stream, state, cb) {
    state.ending = true;
    $8465cefe90e1fd93$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $8465cefe90e1fd93$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($8465cefe90e1fd93$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$8465cefe90e1fd93$var$Writable.prototype.destroy = $bXXPL.destroy;
$8465cefe90e1fd93$var$Writable.prototype._undestroy = $bXXPL.undestroy;
$8465cefe90e1fd93$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config("throwDeprecation")) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("jwtCv", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $e367fb61d7befaea$var$_Object$setPrototypeO;
function $e367fb61d7befaea$var$_defineProperty(obj, key, value) {
    key = $e367fb61d7befaea$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e367fb61d7befaea$var$_toPropertyKey(arg) {
    var key = $e367fb61d7befaea$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $e367fb61d7befaea$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $i2czs = parcelRequire("i2czs");
var $e367fb61d7befaea$var$kLastResolve = Symbol("lastResolve");
var $e367fb61d7befaea$var$kLastReject = Symbol("lastReject");
var $e367fb61d7befaea$var$kError = Symbol("error");
var $e367fb61d7befaea$var$kEnded = Symbol("ended");
var $e367fb61d7befaea$var$kLastPromise = Symbol("lastPromise");
var $e367fb61d7befaea$var$kHandlePromise = Symbol("handlePromise");
var $e367fb61d7befaea$var$kStream = Symbol("stream");
function $e367fb61d7befaea$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $e367fb61d7befaea$var$readAndResolve(iter) {
    var resolve = iter[$e367fb61d7befaea$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$e367fb61d7befaea$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$e367fb61d7befaea$var$kLastPromise] = null;
            iter[$e367fb61d7befaea$var$kLastResolve] = null;
            iter[$e367fb61d7befaea$var$kLastReject] = null;
            resolve($e367fb61d7befaea$var$createIterResult(data, false));
        }
    }
}
function $e367fb61d7befaea$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($e367fb61d7befaea$var$readAndResolve, iter);
}
function $e367fb61d7befaea$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$e367fb61d7befaea$var$kEnded]) {
                resolve($e367fb61d7befaea$var$createIterResult(undefined, true));
                return;
            }
            iter[$e367fb61d7befaea$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $e367fb61d7befaea$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $e367fb61d7befaea$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($e367fb61d7befaea$var$_Object$setPrototypeO = {
    get stream () {
        return this[$e367fb61d7befaea$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$e367fb61d7befaea$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$e367fb61d7befaea$var$kEnded]) return Promise.resolve($e367fb61d7befaea$var$createIterResult(undefined, true));
        if (this[$e367fb61d7befaea$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$e367fb61d7befaea$var$kError]) reject(_this[$e367fb61d7befaea$var$kError]);
                else resolve($e367fb61d7befaea$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$e367fb61d7befaea$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($e367fb61d7befaea$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$e367fb61d7befaea$var$kStream].read();
            if (data !== null) return Promise.resolve($e367fb61d7befaea$var$createIterResult(data, false));
            promise = new Promise(this[$e367fb61d7befaea$var$kHandlePromise]);
        }
        this[$e367fb61d7befaea$var$kLastPromise] = promise;
        return promise;
    }
}, $e367fb61d7befaea$var$_defineProperty($e367fb61d7befaea$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $e367fb61d7befaea$var$_defineProperty($e367fb61d7befaea$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$e367fb61d7befaea$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($e367fb61d7befaea$var$createIterResult(undefined, true));
        });
    });
}), $e367fb61d7befaea$var$_Object$setPrototypeO), $e367fb61d7befaea$var$AsyncIteratorPrototype);
var $e367fb61d7befaea$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($e367fb61d7befaea$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $e367fb61d7befaea$var$_defineProperty(_Object$create, $e367fb61d7befaea$var$kStream, {
        value: stream,
        writable: true
    }), $e367fb61d7befaea$var$_defineProperty(_Object$create, $e367fb61d7befaea$var$kLastResolve, {
        value: null,
        writable: true
    }), $e367fb61d7befaea$var$_defineProperty(_Object$create, $e367fb61d7befaea$var$kLastReject, {
        value: null,
        writable: true
    }), $e367fb61d7befaea$var$_defineProperty(_Object$create, $e367fb61d7befaea$var$kError, {
        value: null,
        writable: true
    }), $e367fb61d7befaea$var$_defineProperty(_Object$create, $e367fb61d7befaea$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $e367fb61d7befaea$var$_defineProperty(_Object$create, $e367fb61d7befaea$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$e367fb61d7befaea$var$kStream].read();
            if (data) {
                iterator[$e367fb61d7befaea$var$kLastPromise] = null;
                iterator[$e367fb61d7befaea$var$kLastResolve] = null;
                iterator[$e367fb61d7befaea$var$kLastReject] = null;
                resolve($e367fb61d7befaea$var$createIterResult(data, false));
            } else {
                iterator[$e367fb61d7befaea$var$kLastResolve] = resolve;
                iterator[$e367fb61d7befaea$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$e367fb61d7befaea$var$kLastPromise] = null;
    $i2czs(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$e367fb61d7befaea$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$e367fb61d7befaea$var$kLastPromise] = null;
                iterator[$e367fb61d7befaea$var$kLastResolve] = null;
                iterator[$e367fb61d7befaea$var$kLastReject] = null;
                reject(err);
            }
            iterator[$e367fb61d7befaea$var$kError] = err;
            return;
        }
        var resolve = iterator[$e367fb61d7befaea$var$kLastResolve];
        if (resolve !== null) {
            iterator[$e367fb61d7befaea$var$kLastPromise] = null;
            iterator[$e367fb61d7befaea$var$kLastResolve] = null;
            iterator[$e367fb61d7befaea$var$kLastReject] = null;
            resolve($e367fb61d7befaea$var$createIterResult(undefined, true));
        }
        iterator[$e367fb61d7befaea$var$kEnded] = true;
    });
    stream.on("readable", $e367fb61d7befaea$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $e367fb61d7befaea$var$createReadableStreamAsyncIterator;

});
parcelRegister("i2czs", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $d2122a3122397796$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("D4eFi")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $d2122a3122397796$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $d2122a3122397796$var$noop() {}
function $d2122a3122397796$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $d2122a3122397796$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $d2122a3122397796$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $d2122a3122397796$var$once(callback || $d2122a3122397796$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $d2122a3122397796$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $d2122a3122397796$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($d2122a3122397796$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $d2122a3122397796$var$eos;

});


parcelRegister("j6cxb", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("ac3yK", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $76bdc937e9191f1e$var$Transform;

var $D4eFi = parcelRequire("D4eFi");
var $76bdc937e9191f1e$require$_require$codes = $D4eFi.codes;
var $76bdc937e9191f1e$var$ERR_METHOD_NOT_IMPLEMENTED = $76bdc937e9191f1e$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $76bdc937e9191f1e$var$ERR_MULTIPLE_CALLBACK = $76bdc937e9191f1e$require$_require$codes.ERR_MULTIPLE_CALLBACK, $76bdc937e9191f1e$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $76bdc937e9191f1e$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $76bdc937e9191f1e$var$ERR_TRANSFORM_WITH_LENGTH_0 = $76bdc937e9191f1e$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $76uBF = parcelRequire("76uBF");

(parcelRequire("dlqwk"))($76bdc937e9191f1e$var$Transform, $76uBF);
function $76bdc937e9191f1e$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $76bdc937e9191f1e$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $76bdc937e9191f1e$var$Transform(options) {
    if (!(this instanceof $76bdc937e9191f1e$var$Transform)) return new $76bdc937e9191f1e$var$Transform(options);
    $76uBF.call(this, options);
    this._transformState = {
        afterTransform: $76bdc937e9191f1e$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $76bdc937e9191f1e$var$prefinish);
}
function $76bdc937e9191f1e$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $76bdc937e9191f1e$var$done(_this, er, data);
    });
    else $76bdc937e9191f1e$var$done(this, null, null);
}
$76bdc937e9191f1e$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $76uBF.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$76bdc937e9191f1e$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $76bdc937e9191f1e$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$76bdc937e9191f1e$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$76bdc937e9191f1e$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$76bdc937e9191f1e$var$Transform.prototype._destroy = function(err, cb) {
    $76uBF.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $76bdc937e9191f1e$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $76bdc937e9191f1e$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $76bdc937e9191f1e$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("ctboS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $9141094facd8bc61$var$PassThrough;

var $ac3yK = parcelRequire("ac3yK");

(parcelRequire("dlqwk"))($9141094facd8bc61$var$PassThrough, $ac3yK);
function $9141094facd8bc61$var$PassThrough(options) {
    if (!(this instanceof $9141094facd8bc61$var$PassThrough)) return new $9141094facd8bc61$var$PassThrough(options);
    $ac3yK.call(this, options);
}
$9141094facd8bc61$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("lD2IR", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $fbef5a205e060350$var$eos;
function $fbef5a205e060350$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $D4eFi = parcelRequire("D4eFi");
var $fbef5a205e060350$require$_require$codes = $D4eFi.codes;
var $fbef5a205e060350$var$ERR_MISSING_ARGS = $fbef5a205e060350$require$_require$codes.ERR_MISSING_ARGS, $fbef5a205e060350$var$ERR_STREAM_DESTROYED = $fbef5a205e060350$require$_require$codes.ERR_STREAM_DESTROYED;
function $fbef5a205e060350$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $fbef5a205e060350$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $fbef5a205e060350$var$destroyer(stream, reading, writing, callback) {
    callback = $fbef5a205e060350$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($fbef5a205e060350$var$eos === undefined) $fbef5a205e060350$var$eos = (parcelRequire("i2czs"));
    $fbef5a205e060350$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($fbef5a205e060350$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $fbef5a205e060350$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $fbef5a205e060350$var$call(fn) {
    fn();
}
function $fbef5a205e060350$var$pipe(from, to) {
    return from.pipe(to);
}
function $fbef5a205e060350$var$popCallback(streams) {
    if (!streams.length) return $fbef5a205e060350$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $fbef5a205e060350$var$noop;
    return streams.pop();
}
function $fbef5a205e060350$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $fbef5a205e060350$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $fbef5a205e060350$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $fbef5a205e060350$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($fbef5a205e060350$var$call);
            if (reading) return;
            destroys.forEach($fbef5a205e060350$var$call);
            callback(error);
        });
    });
    return streams.reduce($fbef5a205e060350$var$pipe);
}
module.exports = $fbef5a205e060350$var$pipeline;

});


parcelRegister("hkN9y", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $c9ea6eb6e1b0be83$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $c9ea6eb6e1b0be83$var$MAX_UINT32 = 4294967295;
function $c9ea6eb6e1b0be83$var$oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}

var $1U9GM = parcelRequire("1U9GM");
var $c9ea6eb6e1b0be83$require$Buffer = $1U9GM.Buffer;
var $c9ea6eb6e1b0be83$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($c9ea6eb6e1b0be83$var$crypto && $c9ea6eb6e1b0be83$var$crypto.getRandomValues) module.exports = $c9ea6eb6e1b0be83$var$randomBytes;
else module.exports = $c9ea6eb6e1b0be83$var$oldBrowser;
function $c9ea6eb6e1b0be83$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $c9ea6eb6e1b0be83$var$MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = $c9ea6eb6e1b0be83$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $c9ea6eb6e1b0be83$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $c9ea6eb6e1b0be83$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes.slice(generated, generated + $c9ea6eb6e1b0be83$var$MAX_BYTES));
        else $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return $hPtJY.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});

parcelRegister("1R2J7", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $loYLU = parcelRequire("loYLU");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $26nOC = parcelRequire("26nOC");
function $159cdb2c74f453a8$var$Hash(hash) {
    $26nOC.call(this, "digest");
    this._hash = hash;
}
$dlqwk($159cdb2c74f453a8$var$Hash, $26nOC);
$159cdb2c74f453a8$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$159cdb2c74f453a8$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new $loYLU();
    if (alg === "rmd160" || alg === "ripemd160") return new $a8qBR();
    return new $159cdb2c74f453a8$var$Hash($5Z1sR(alg));
};

});
parcelRegister("loYLU", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");

var $1U9GM = parcelRequire("1U9GM");
var $f94afad95abc0930$require$Buffer = $1U9GM.Buffer;
var $f94afad95abc0930$var$ARRAY16 = new Array(16);
function $f94afad95abc0930$var$MD5() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$dlqwk($f94afad95abc0930$var$MD5, $eLdEM);
$f94afad95abc0930$var$MD5.prototype._update = function() {
    var M = $f94afad95abc0930$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$f94afad95abc0930$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $f94afad95abc0930$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $f94afad95abc0930$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $f94afad95abc0930$var$fnF(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnG(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnH(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnI(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $f94afad95abc0930$var$MD5;

});
parcelRegister("eLdEM", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $abf00c68ae11d39d$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $abf00c68ae11d39d$require$Transform = $ioRHp.Transform;

var $dlqwk = parcelRequire("dlqwk");
function $abf00c68ae11d39d$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$abf00c68ae11d39d$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $abf00c68ae11d39d$var$HashBase(blockSize) {
    $abf00c68ae11d39d$require$Transform.call(this);
    this._block = $abf00c68ae11d39d$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dlqwk($abf00c68ae11d39d$var$HashBase, $abf00c68ae11d39d$require$Transform);
$abf00c68ae11d39d$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype.update = function(data, encoding) {
    $abf00c68ae11d39d$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$abf00c68ae11d39d$require$Buffer.isBuffer(data)) data = $abf00c68ae11d39d$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$abf00c68ae11d39d$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$abf00c68ae11d39d$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$abf00c68ae11d39d$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $abf00c68ae11d39d$var$HashBase;

});
parcelRegister("ioRHp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $d6541f691ffb0af6$var$Stream;

var $7etJZ = parcelRequire("7etJZ");
var $d6541f691ffb0af6$require$EE = $7etJZ.EventEmitter;

var $dlqwk = parcelRequire("dlqwk");
$dlqwk($d6541f691ffb0af6$var$Stream, $d6541f691ffb0af6$require$EE);

$d6541f691ffb0af6$var$Stream.Readable = (parcelRequire("aBufs"));

$d6541f691ffb0af6$var$Stream.Writable = (parcelRequire("6XbcT"));

$d6541f691ffb0af6$var$Stream.Duplex = (parcelRequire("fFuzr"));

$d6541f691ffb0af6$var$Stream.Transform = (parcelRequire("k3Gr9"));

$d6541f691ffb0af6$var$Stream.PassThrough = (parcelRequire("6G2fH"));

$d6541f691ffb0af6$var$Stream.finished = (parcelRequire("hzqCm"));

$d6541f691ffb0af6$var$Stream.pipeline = (parcelRequire("coyuH"));
// Backwards-compat with node 0.4.x
$d6541f691ffb0af6$var$Stream.Stream = $d6541f691ffb0af6$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $d6541f691ffb0af6$var$Stream() {
    $d6541f691ffb0af6$require$EE.call(this);
}
$d6541f691ffb0af6$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d6541f691ffb0af6$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("aBufs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $7b84d2ca8f0d8afd$var$Readable;
/*<replacement>*/ var $7b84d2ca8f0d8afd$var$Duplex;
/*</replacement>*/ $7b84d2ca8f0d8afd$var$Readable.ReadableState = $7b84d2ca8f0d8afd$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $7b84d2ca8f0d8afd$require$EE = $7etJZ.EventEmitter;
var $7b84d2ca8f0d8afd$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jJj7p = parcelRequire("jJj7p");

var $6ZWSX = parcelRequire("6ZWSX");
var $7b84d2ca8f0d8afd$require$Buffer = $6ZWSX.Buffer;
var $7b84d2ca8f0d8afd$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $7b84d2ca8f0d8afd$var$_uint8ArrayToBuffer(chunk) {
    return $7b84d2ca8f0d8afd$require$Buffer.from(chunk);
}
function $7b84d2ca8f0d8afd$var$_isUint8Array(obj) {
    return $7b84d2ca8f0d8afd$require$Buffer.isBuffer(obj) || obj instanceof $7b84d2ca8f0d8afd$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $7b84d2ca8f0d8afd$var$debug;
if ($kjyEk && $kjyEk.debuglog) $7b84d2ca8f0d8afd$var$debug = $kjyEk.debuglog("stream");
else $7b84d2ca8f0d8afd$var$debug = function debug() {};

var $6aKSQ = parcelRequire("6aKSQ");

var $fnDgj = parcelRequire("fnDgj");

var $5yyyA = parcelRequire("5yyyA");
var $7b84d2ca8f0d8afd$var$getHighWaterMark = $5yyyA.getHighWaterMark;

var $967Aq = parcelRequire("967Aq");
var $7b84d2ca8f0d8afd$require$_require$codes = $967Aq.codes;
var $7b84d2ca8f0d8afd$var$ERR_INVALID_ARG_TYPE = $7b84d2ca8f0d8afd$require$_require$codes.ERR_INVALID_ARG_TYPE, $7b84d2ca8f0d8afd$var$ERR_STREAM_PUSH_AFTER_EOF = $7b84d2ca8f0d8afd$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $7b84d2ca8f0d8afd$var$ERR_METHOD_NOT_IMPLEMENTED = $7b84d2ca8f0d8afd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $7b84d2ca8f0d8afd$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $7b84d2ca8f0d8afd$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $7b84d2ca8f0d8afd$var$StringDecoder;
var $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator;
var $7b84d2ca8f0d8afd$var$from;

(parcelRequire("dlqwk"))($7b84d2ca8f0d8afd$var$Readable, $jJj7p);
var $7b84d2ca8f0d8afd$var$errorOrDestroy = $fnDgj.errorOrDestroy;
var $7b84d2ca8f0d8afd$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $7b84d2ca8f0d8afd$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $7b84d2ca8f0d8afd$var$ReadableState(options, stream, isDuplex) {
    $7b84d2ca8f0d8afd$var$Duplex = $7b84d2ca8f0d8afd$var$Duplex || (parcelRequire("fFuzr"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $7b84d2ca8f0d8afd$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $7b84d2ca8f0d8afd$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $6aKSQ();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$7b84d2ca8f0d8afd$var$StringDecoder) $7b84d2ca8f0d8afd$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $7b84d2ca8f0d8afd$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $7b84d2ca8f0d8afd$var$Readable(options) {
    $7b84d2ca8f0d8afd$var$Duplex = $7b84d2ca8f0d8afd$var$Duplex || (parcelRequire("fFuzr"));
    if (!(this instanceof $7b84d2ca8f0d8afd$var$Readable)) return new $7b84d2ca8f0d8afd$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $7b84d2ca8f0d8afd$var$Duplex;
    this._readableState = new $7b84d2ca8f0d8afd$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $jJj7p.call(this);
}
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$7b84d2ca8f0d8afd$var$Readable.prototype.destroy = $fnDgj.destroy;
$7b84d2ca8f0d8afd$var$Readable.prototype._undestroy = $fnDgj.undestroy;
$7b84d2ca8f0d8afd$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$7b84d2ca8f0d8afd$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $7b84d2ca8f0d8afd$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $7b84d2ca8f0d8afd$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$7b84d2ca8f0d8afd$var$Readable.prototype.unshift = function(chunk) {
    return $7b84d2ca8f0d8afd$var$readableAddChunk(this, chunk, null, true, false);
};
function $7b84d2ca8f0d8afd$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $7b84d2ca8f0d8afd$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $7b84d2ca8f0d8afd$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $7b84d2ca8f0d8afd$var$chunkInvalid(state, chunk);
        if (er) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $7b84d2ca8f0d8afd$require$Buffer.prototype) chunk = $7b84d2ca8f0d8afd$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, new $7b84d2ca8f0d8afd$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, new $7b84d2ca8f0d8afd$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, false);
                    else $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
                } else $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $7b84d2ca8f0d8afd$var$emitReadable(stream);
    }
    $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
}
function $7b84d2ca8f0d8afd$var$chunkInvalid(state, chunk) {
    var er;
    if (!$7b84d2ca8f0d8afd$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $7b84d2ca8f0d8afd$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$7b84d2ca8f0d8afd$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$7b84d2ca8f0d8afd$var$Readable.prototype.setEncoding = function(enc) {
    if (!$7b84d2ca8f0d8afd$var$StringDecoder) $7b84d2ca8f0d8afd$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $7b84d2ca8f0d8afd$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $7b84d2ca8f0d8afd$var$MAX_HWM = 0x40000000;
function $7b84d2ca8f0d8afd$var$computeNewHighWaterMark(n) {
    if (n >= $7b84d2ca8f0d8afd$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $7b84d2ca8f0d8afd$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7b84d2ca8f0d8afd$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $7b84d2ca8f0d8afd$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$7b84d2ca8f0d8afd$var$Readable.prototype.read = function(n) {
    $7b84d2ca8f0d8afd$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $7b84d2ca8f0d8afd$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $7b84d2ca8f0d8afd$var$endReadable(this);
        else $7b84d2ca8f0d8afd$var$emitReadable(this);
        return null;
    }
    n = $7b84d2ca8f0d8afd$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $7b84d2ca8f0d8afd$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $7b84d2ca8f0d8afd$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $7b84d2ca8f0d8afd$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $7b84d2ca8f0d8afd$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $7b84d2ca8f0d8afd$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $7b84d2ca8f0d8afd$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $7b84d2ca8f0d8afd$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $7b84d2ca8f0d8afd$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $7b84d2ca8f0d8afd$var$onEofChunk(stream, state) {
    $7b84d2ca8f0d8afd$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $7b84d2ca8f0d8afd$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $7b84d2ca8f0d8afd$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $7b84d2ca8f0d8afd$var$emitReadable(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $7b84d2ca8f0d8afd$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$emitReadable_, stream);
    }
}
function $7b84d2ca8f0d8afd$var$emitReadable_(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $7b84d2ca8f0d8afd$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$maybeReadMore_, stream, state);
    }
}
function $7b84d2ca8f0d8afd$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $7b84d2ca8f0d8afd$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$7b84d2ca8f0d8afd$var$Readable.prototype._read = function(n) {
    $7b84d2ca8f0d8afd$var$errorOrDestroy(this, new $7b84d2ca8f0d8afd$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$7b84d2ca8f0d8afd$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $7b84d2ca8f0d8afd$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $7b84d2ca8f0d8afd$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $7b84d2ca8f0d8afd$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $7b84d2ca8f0d8afd$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $7b84d2ca8f0d8afd$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $7b84d2ca8f0d8afd$var$debug("ondata");
        var ret = dest.write(chunk);
        $7b84d2ca8f0d8afd$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $7b84d2ca8f0d8afd$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $7b84d2ca8f0d8afd$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $7b84d2ca8f0d8afd$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($7b84d2ca8f0d8afd$var$EElistenerCount(dest, "error") === 0) $7b84d2ca8f0d8afd$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $7b84d2ca8f0d8afd$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $7b84d2ca8f0d8afd$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $7b84d2ca8f0d8afd$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $7b84d2ca8f0d8afd$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $7b84d2ca8f0d8afd$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $7b84d2ca8f0d8afd$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $7b84d2ca8f0d8afd$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $7b84d2ca8f0d8afd$var$flow(src);
        }
    };
}
$7b84d2ca8f0d8afd$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $7b84d2ca8f0d8afd$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$7b84d2ca8f0d8afd$var$Readable.prototype.on = function(ev, fn) {
    var res = $jJj7p.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $7b84d2ca8f0d8afd$var$debug("on readable", state.length, state.reading);
            if (state.length) $7b84d2ca8f0d8afd$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($7b84d2ca8f0d8afd$var$nReadingNextTick, this);
        }
    }
    return res;
};
$7b84d2ca8f0d8afd$var$Readable.prototype.addListener = $7b84d2ca8f0d8afd$var$Readable.prototype.on;
$7b84d2ca8f0d8afd$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jJj7p.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($7b84d2ca8f0d8afd$var$updateReadableListening, this);
    return res;
};
$7b84d2ca8f0d8afd$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jJj7p.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($7b84d2ca8f0d8afd$var$updateReadableListening, this);
    return res;
};
function $7b84d2ca8f0d8afd$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $7b84d2ca8f0d8afd$var$nReadingNextTick(self1) {
    $7b84d2ca8f0d8afd$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$7b84d2ca8f0d8afd$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $7b84d2ca8f0d8afd$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $7b84d2ca8f0d8afd$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $7b84d2ca8f0d8afd$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$resume_, stream, state);
    }
}
function $7b84d2ca8f0d8afd$var$resume_(stream, state) {
    $7b84d2ca8f0d8afd$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $7b84d2ca8f0d8afd$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$7b84d2ca8f0d8afd$var$Readable.prototype.pause = function() {
    $7b84d2ca8f0d8afd$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $7b84d2ca8f0d8afd$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $7b84d2ca8f0d8afd$var$flow(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$7b84d2ca8f0d8afd$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $7b84d2ca8f0d8afd$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $7b84d2ca8f0d8afd$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $7b84d2ca8f0d8afd$var$kProxyEvents.length; n++)stream.on($7b84d2ca8f0d8afd$var$kProxyEvents[n], this.emit.bind(this, $7b84d2ca8f0d8afd$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $7b84d2ca8f0d8afd$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $7b84d2ca8f0d8afd$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator === undefined) $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator = (parcelRequire("3etzH"));
    return $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$7b84d2ca8f0d8afd$var$Readable._fromList = $7b84d2ca8f0d8afd$var$fromList;
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7b84d2ca8f0d8afd$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $7b84d2ca8f0d8afd$var$endReadable(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$endReadableNT, state, stream);
    }
}
function $7b84d2ca8f0d8afd$var$endReadableNT(state, stream) {
    $7b84d2ca8f0d8afd$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $7b84d2ca8f0d8afd$var$Readable.from = function(iterable, opts) {
    if ($7b84d2ca8f0d8afd$var$from === undefined) $7b84d2ca8f0d8afd$var$from = (parcelRequire("gN4Jr"));
    return $7b84d2ca8f0d8afd$var$from($7b84d2ca8f0d8afd$var$Readable, iterable, opts);
};
function $7b84d2ca8f0d8afd$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("jJj7p", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("6aKSQ", function(module, exports) {
"use strict";
function $47e80b5d1f4ca857$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $47e80b5d1f4ca857$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $47e80b5d1f4ca857$var$ownKeys(Object(source), !0).forEach(function(key) {
            $47e80b5d1f4ca857$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $47e80b5d1f4ca857$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $47e80b5d1f4ca857$var$_defineProperty(obj, key, value) {
    key = $47e80b5d1f4ca857$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $47e80b5d1f4ca857$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $47e80b5d1f4ca857$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $47e80b5d1f4ca857$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $47e80b5d1f4ca857$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $47e80b5d1f4ca857$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $47e80b5d1f4ca857$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $47e80b5d1f4ca857$var$_toPropertyKey(arg) {
    var key = $47e80b5d1f4ca857$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $47e80b5d1f4ca857$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $47e80b5d1f4ca857$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $47e80b5d1f4ca857$var$inspect = $kjyEk.inspect;
var $47e80b5d1f4ca857$var$custom = $47e80b5d1f4ca857$var$inspect && $47e80b5d1f4ca857$var$inspect.custom || "inspect";
function $47e80b5d1f4ca857$var$copyBuffer(src, target, offset) {
    $47e80b5d1f4ca857$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $47e80b5d1f4ca857$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $47e80b5d1f4ca857$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $47e80b5d1f4ca857$var$Buffer.alloc(0);
                var ret = $47e80b5d1f4ca857$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $47e80b5d1f4ca857$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $47e80b5d1f4ca857$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $47e80b5d1f4ca857$var$custom,
            value: function value(_, options) {
                return $47e80b5d1f4ca857$var$inspect(this, $47e80b5d1f4ca857$var$_objectSpread($47e80b5d1f4ca857$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("fnDgj", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $b32775a19d7a76d1$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
    });
    return this;
}
function $b32775a19d7a76d1$var$emitErrorAndCloseNT(self, err) {
    $b32775a19d7a76d1$var$emitErrorNT(self, err);
    $b32775a19d7a76d1$var$emitCloseNT(self);
}
function $b32775a19d7a76d1$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $b32775a19d7a76d1$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b32775a19d7a76d1$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $b32775a19d7a76d1$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $b32775a19d7a76d1$var$destroy,
    undestroy: $b32775a19d7a76d1$var$undestroy,
    errorOrDestroy: $b32775a19d7a76d1$var$errorOrDestroy
};

});

parcelRegister("5yyyA", function(module, exports) {
"use strict";

var $40baeeffbb52bbd0$var$ERR_INVALID_OPT_VALUE = (parcelRequire("967Aq")).codes.ERR_INVALID_OPT_VALUE;
function $40baeeffbb52bbd0$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $40baeeffbb52bbd0$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $40baeeffbb52bbd0$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $40baeeffbb52bbd0$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $40baeeffbb52bbd0$var$getHighWaterMark
};

});
parcelRegister("967Aq", function(module, exports) {

$parcel$export(module.exports, "codes", () => $69fa8f23fe6fc7e7$export$e45cb6485273080e, (v) => $69fa8f23fe6fc7e7$export$e45cb6485273080e = v);
var $69fa8f23fe6fc7e7$export$e45cb6485273080e;
"use strict";
function $69fa8f23fe6fc7e7$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $69fa8f23fe6fc7e7$var$codes = {};
function $69fa8f23fe6fc7e7$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $69fa8f23fe6fc7e7$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $69fa8f23fe6fc7e7$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $69fa8f23fe6fc7e7$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $69fa8f23fe6fc7e7$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $69fa8f23fe6fc7e7$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $69fa8f23fe6fc7e7$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$69fa8f23fe6fc7e7$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $69fa8f23fe6fc7e7$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($69fa8f23fe6fc7e7$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($69fa8f23fe6fc7e7$var$oneOf(expected, "type"));
    else {
        var type = $69fa8f23fe6fc7e7$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($69fa8f23fe6fc7e7$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$69fa8f23fe6fc7e7$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$69fa8f23fe6fc7e7$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$69fa8f23fe6fc7e7$export$e45cb6485273080e = $69fa8f23fe6fc7e7$var$codes;

});


parcelRegister("fFuzr", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $b682660ac74fe757$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $b682660ac74fe757$var$Duplex;

var $aBufs = parcelRequire("aBufs");

var $6XbcT = parcelRequire("6XbcT");

(parcelRequire("dlqwk"))($b682660ac74fe757$var$Duplex, $aBufs);
// Allow the keys array to be GC'ed.
var $b682660ac74fe757$var$keys = $b682660ac74fe757$var$objectKeys($6XbcT.prototype);
for(var $b682660ac74fe757$var$v = 0; $b682660ac74fe757$var$v < $b682660ac74fe757$var$keys.length; $b682660ac74fe757$var$v++){
    var $b682660ac74fe757$var$method = $b682660ac74fe757$var$keys[$b682660ac74fe757$var$v];
    if (!$b682660ac74fe757$var$Duplex.prototype[$b682660ac74fe757$var$method]) $b682660ac74fe757$var$Duplex.prototype[$b682660ac74fe757$var$method] = $6XbcT.prototype[$b682660ac74fe757$var$method];
}
function $b682660ac74fe757$var$Duplex(options) {
    if (!(this instanceof $b682660ac74fe757$var$Duplex)) return new $b682660ac74fe757$var$Duplex(options);
    $aBufs.call(this, options);
    $6XbcT.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $b682660ac74fe757$var$onend);
        }
    }
}
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $b682660ac74fe757$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($b682660ac74fe757$var$onEndNT, this);
}
function $b682660ac74fe757$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("6XbcT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $5100f23d2ab8fadd$var$Writable;
/* <replacement> */ function $5100f23d2ab8fadd$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $5100f23d2ab8fadd$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $5100f23d2ab8fadd$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $5100f23d2ab8fadd$var$Duplex;
/*</replacement>*/ $5100f23d2ab8fadd$var$Writable.WritableState = $5100f23d2ab8fadd$var$WritableState;

/*<replacement>*/ var $5100f23d2ab8fadd$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jJj7p = parcelRequire("jJj7p");

var $6ZWSX = parcelRequire("6ZWSX");
var $5100f23d2ab8fadd$require$Buffer = $6ZWSX.Buffer;
var $5100f23d2ab8fadd$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $5100f23d2ab8fadd$var$_uint8ArrayToBuffer(chunk) {
    return $5100f23d2ab8fadd$require$Buffer.from(chunk);
}
function $5100f23d2ab8fadd$var$_isUint8Array(obj) {
    return $5100f23d2ab8fadd$require$Buffer.isBuffer(obj) || obj instanceof $5100f23d2ab8fadd$var$OurUint8Array;
}

var $fnDgj = parcelRequire("fnDgj");

var $5yyyA = parcelRequire("5yyyA");
var $5100f23d2ab8fadd$var$getHighWaterMark = $5yyyA.getHighWaterMark;

var $967Aq = parcelRequire("967Aq");
var $5100f23d2ab8fadd$require$_require$codes = $967Aq.codes;
var $5100f23d2ab8fadd$var$ERR_INVALID_ARG_TYPE = $5100f23d2ab8fadd$require$_require$codes.ERR_INVALID_ARG_TYPE, $5100f23d2ab8fadd$var$ERR_METHOD_NOT_IMPLEMENTED = $5100f23d2ab8fadd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $5100f23d2ab8fadd$var$ERR_MULTIPLE_CALLBACK = $5100f23d2ab8fadd$require$_require$codes.ERR_MULTIPLE_CALLBACK, $5100f23d2ab8fadd$var$ERR_STREAM_CANNOT_PIPE = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $5100f23d2ab8fadd$var$ERR_STREAM_DESTROYED = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_DESTROYED, $5100f23d2ab8fadd$var$ERR_STREAM_NULL_VALUES = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_NULL_VALUES, $5100f23d2ab8fadd$var$ERR_STREAM_WRITE_AFTER_END = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $5100f23d2ab8fadd$var$ERR_UNKNOWN_ENCODING = $5100f23d2ab8fadd$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $5100f23d2ab8fadd$var$errorOrDestroy = $fnDgj.errorOrDestroy;

(parcelRequire("dlqwk"))($5100f23d2ab8fadd$var$Writable, $jJj7p);
function $5100f23d2ab8fadd$var$nop() {}

function $5100f23d2ab8fadd$var$WritableState(options, stream, isDuplex) {
    $5100f23d2ab8fadd$var$Duplex = $5100f23d2ab8fadd$var$Duplex || (parcelRequire("fFuzr"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $5100f23d2ab8fadd$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $5100f23d2ab8fadd$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $5100f23d2ab8fadd$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $5100f23d2ab8fadd$var$CorkedRequest(this);
}
$5100f23d2ab8fadd$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($5100f23d2ab8fadd$var$WritableState.prototype, "buffer", {
            get: $5100f23d2ab8fadd$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $5100f23d2ab8fadd$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $5100f23d2ab8fadd$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($5100f23d2ab8fadd$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($5100f23d2ab8fadd$var$realHasInstance.call(this, object)) return true;
            if (this !== $5100f23d2ab8fadd$var$Writable) return false;
            return object && object._writableState instanceof $5100f23d2ab8fadd$var$WritableState;
        }
    });
} else $5100f23d2ab8fadd$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $5100f23d2ab8fadd$var$Writable(options) {
    $5100f23d2ab8fadd$var$Duplex = $5100f23d2ab8fadd$var$Duplex || (parcelRequire("fFuzr"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $5100f23d2ab8fadd$var$Duplex;
    if (!isDuplex && !$5100f23d2ab8fadd$var$realHasInstance.call($5100f23d2ab8fadd$var$Writable, this)) return new $5100f23d2ab8fadd$var$Writable(options);
    this._writableState = new $5100f23d2ab8fadd$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $jJj7p.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$5100f23d2ab8fadd$var$Writable.prototype.pipe = function() {
    $5100f23d2ab8fadd$var$errorOrDestroy(this, new $5100f23d2ab8fadd$var$ERR_STREAM_CANNOT_PIPE());
};
function $5100f23d2ab8fadd$var$writeAfterEnd(stream, cb) {
    var er = new $5100f23d2ab8fadd$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $5100f23d2ab8fadd$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $5100f23d2ab8fadd$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $5100f23d2ab8fadd$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$5100f23d2ab8fadd$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $5100f23d2ab8fadd$var$_isUint8Array(chunk);
    if (isBuf && !$5100f23d2ab8fadd$require$Buffer.isBuffer(chunk)) chunk = $5100f23d2ab8fadd$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $5100f23d2ab8fadd$var$nop;
    if (state.ending) $5100f23d2ab8fadd$var$writeAfterEnd(this, cb);
    else if (isBuf || $5100f23d2ab8fadd$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $5100f23d2ab8fadd$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$5100f23d2ab8fadd$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$5100f23d2ab8fadd$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5100f23d2ab8fadd$var$clearBuffer(this, state);
    }
};
$5100f23d2ab8fadd$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $5100f23d2ab8fadd$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $5100f23d2ab8fadd$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $5100f23d2ab8fadd$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $5100f23d2ab8fadd$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $5100f23d2ab8fadd$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $5100f23d2ab8fadd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $5100f23d2ab8fadd$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $5100f23d2ab8fadd$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $5100f23d2ab8fadd$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($5100f23d2ab8fadd$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    }
}
function $5100f23d2ab8fadd$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $5100f23d2ab8fadd$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $5100f23d2ab8fadd$var$ERR_MULTIPLE_CALLBACK();
    $5100f23d2ab8fadd$var$onwriteStateUpdate(state);
    if (er) $5100f23d2ab8fadd$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $5100f23d2ab8fadd$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5100f23d2ab8fadd$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($5100f23d2ab8fadd$var$afterWrite, stream, state, finished, cb);
        else $5100f23d2ab8fadd$var$afterWrite(stream, state, finished, cb);
    }
}
function $5100f23d2ab8fadd$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $5100f23d2ab8fadd$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $5100f23d2ab8fadd$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $5100f23d2ab8fadd$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $5100f23d2ab8fadd$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $5100f23d2ab8fadd$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $5100f23d2ab8fadd$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $5100f23d2ab8fadd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$5100f23d2ab8fadd$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $5100f23d2ab8fadd$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$5100f23d2ab8fadd$var$Writable.prototype._writev = null;
$5100f23d2ab8fadd$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $5100f23d2ab8fadd$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $5100f23d2ab8fadd$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $5100f23d2ab8fadd$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $5100f23d2ab8fadd$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    });
}
function $5100f23d2ab8fadd$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($5100f23d2ab8fadd$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $5100f23d2ab8fadd$var$finishMaybe(stream, state) {
    var need = $5100f23d2ab8fadd$var$needFinish(state);
    if (need) {
        $5100f23d2ab8fadd$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $5100f23d2ab8fadd$var$endWritable(stream, state, cb) {
    state.ending = true;
    $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $5100f23d2ab8fadd$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$5100f23d2ab8fadd$var$Writable.prototype.destroy = $fnDgj.destroy;
$5100f23d2ab8fadd$var$Writable.prototype._undestroy = $fnDgj.undestroy;
$5100f23d2ab8fadd$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});


parcelRegister("3etzH", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $25a99ede456543b7$var$_Object$setPrototypeO;
function $25a99ede456543b7$var$_defineProperty(obj, key, value) {
    key = $25a99ede456543b7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $25a99ede456543b7$var$_toPropertyKey(arg) {
    var key = $25a99ede456543b7$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $25a99ede456543b7$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $hzqCm = parcelRequire("hzqCm");
var $25a99ede456543b7$var$kLastResolve = Symbol("lastResolve");
var $25a99ede456543b7$var$kLastReject = Symbol("lastReject");
var $25a99ede456543b7$var$kError = Symbol("error");
var $25a99ede456543b7$var$kEnded = Symbol("ended");
var $25a99ede456543b7$var$kLastPromise = Symbol("lastPromise");
var $25a99ede456543b7$var$kHandlePromise = Symbol("handlePromise");
var $25a99ede456543b7$var$kStream = Symbol("stream");
function $25a99ede456543b7$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $25a99ede456543b7$var$readAndResolve(iter) {
    var resolve = iter[$25a99ede456543b7$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$25a99ede456543b7$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$25a99ede456543b7$var$kLastPromise] = null;
            iter[$25a99ede456543b7$var$kLastResolve] = null;
            iter[$25a99ede456543b7$var$kLastReject] = null;
            resolve($25a99ede456543b7$var$createIterResult(data, false));
        }
    }
}
function $25a99ede456543b7$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($25a99ede456543b7$var$readAndResolve, iter);
}
function $25a99ede456543b7$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$25a99ede456543b7$var$kEnded]) {
                resolve($25a99ede456543b7$var$createIterResult(undefined, true));
                return;
            }
            iter[$25a99ede456543b7$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $25a99ede456543b7$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $25a99ede456543b7$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($25a99ede456543b7$var$_Object$setPrototypeO = {
    get stream () {
        return this[$25a99ede456543b7$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$25a99ede456543b7$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$25a99ede456543b7$var$kEnded]) return Promise.resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        if (this[$25a99ede456543b7$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$25a99ede456543b7$var$kError]) reject(_this[$25a99ede456543b7$var$kError]);
                else resolve($25a99ede456543b7$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$25a99ede456543b7$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($25a99ede456543b7$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$25a99ede456543b7$var$kStream].read();
            if (data !== null) return Promise.resolve($25a99ede456543b7$var$createIterResult(data, false));
            promise = new Promise(this[$25a99ede456543b7$var$kHandlePromise]);
        }
        this[$25a99ede456543b7$var$kLastPromise] = promise;
        return promise;
    }
}, $25a99ede456543b7$var$_defineProperty($25a99ede456543b7$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $25a99ede456543b7$var$_defineProperty($25a99ede456543b7$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$25a99ede456543b7$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        });
    });
}), $25a99ede456543b7$var$_Object$setPrototypeO), $25a99ede456543b7$var$AsyncIteratorPrototype);
var $25a99ede456543b7$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($25a99ede456543b7$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kStream, {
        value: stream,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kLastResolve, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kLastReject, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kError, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$25a99ede456543b7$var$kStream].read();
            if (data) {
                iterator[$25a99ede456543b7$var$kLastPromise] = null;
                iterator[$25a99ede456543b7$var$kLastResolve] = null;
                iterator[$25a99ede456543b7$var$kLastReject] = null;
                resolve($25a99ede456543b7$var$createIterResult(data, false));
            } else {
                iterator[$25a99ede456543b7$var$kLastResolve] = resolve;
                iterator[$25a99ede456543b7$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$25a99ede456543b7$var$kLastPromise] = null;
    $hzqCm(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$25a99ede456543b7$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$25a99ede456543b7$var$kLastPromise] = null;
                iterator[$25a99ede456543b7$var$kLastResolve] = null;
                iterator[$25a99ede456543b7$var$kLastReject] = null;
                reject(err);
            }
            iterator[$25a99ede456543b7$var$kError] = err;
            return;
        }
        var resolve = iterator[$25a99ede456543b7$var$kLastResolve];
        if (resolve !== null) {
            iterator[$25a99ede456543b7$var$kLastPromise] = null;
            iterator[$25a99ede456543b7$var$kLastResolve] = null;
            iterator[$25a99ede456543b7$var$kLastReject] = null;
            resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        }
        iterator[$25a99ede456543b7$var$kEnded] = true;
    });
    stream.on("readable", $25a99ede456543b7$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $25a99ede456543b7$var$createReadableStreamAsyncIterator;

});
parcelRegister("hzqCm", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("967Aq")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $ccaa5a4968d6bb28$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $ccaa5a4968d6bb28$var$noop() {}
function $ccaa5a4968d6bb28$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $ccaa5a4968d6bb28$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $ccaa5a4968d6bb28$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $ccaa5a4968d6bb28$var$once(callback || $ccaa5a4968d6bb28$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($ccaa5a4968d6bb28$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $ccaa5a4968d6bb28$var$eos;

});


parcelRegister("gN4Jr", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("k3Gr9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $e9a50192eb9e2af9$var$Transform;

var $967Aq = parcelRequire("967Aq");
var $e9a50192eb9e2af9$require$_require$codes = $967Aq.codes;
var $e9a50192eb9e2af9$var$ERR_METHOD_NOT_IMPLEMENTED = $e9a50192eb9e2af9$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $e9a50192eb9e2af9$var$ERR_MULTIPLE_CALLBACK = $e9a50192eb9e2af9$require$_require$codes.ERR_MULTIPLE_CALLBACK, $e9a50192eb9e2af9$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $e9a50192eb9e2af9$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $e9a50192eb9e2af9$var$ERR_TRANSFORM_WITH_LENGTH_0 = $e9a50192eb9e2af9$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $fFuzr = parcelRequire("fFuzr");

(parcelRequire("dlqwk"))($e9a50192eb9e2af9$var$Transform, $fFuzr);
function $e9a50192eb9e2af9$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $e9a50192eb9e2af9$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $e9a50192eb9e2af9$var$Transform(options) {
    if (!(this instanceof $e9a50192eb9e2af9$var$Transform)) return new $e9a50192eb9e2af9$var$Transform(options);
    $fFuzr.call(this, options);
    this._transformState = {
        afterTransform: $e9a50192eb9e2af9$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $e9a50192eb9e2af9$var$prefinish);
}
function $e9a50192eb9e2af9$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $e9a50192eb9e2af9$var$done(_this, er, data);
    });
    else $e9a50192eb9e2af9$var$done(this, null, null);
}
$e9a50192eb9e2af9$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $fFuzr.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$e9a50192eb9e2af9$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $e9a50192eb9e2af9$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$e9a50192eb9e2af9$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$e9a50192eb9e2af9$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$e9a50192eb9e2af9$var$Transform.prototype._destroy = function(err, cb) {
    $fFuzr.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $e9a50192eb9e2af9$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $e9a50192eb9e2af9$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $e9a50192eb9e2af9$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("6G2fH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $4dc8698e5416b71e$var$PassThrough;

var $k3Gr9 = parcelRequire("k3Gr9");

(parcelRequire("dlqwk"))($4dc8698e5416b71e$var$PassThrough, $k3Gr9);
function $4dc8698e5416b71e$var$PassThrough(options) {
    if (!(this instanceof $4dc8698e5416b71e$var$PassThrough)) return new $4dc8698e5416b71e$var$PassThrough(options);
    $k3Gr9.call(this, options);
}
$4dc8698e5416b71e$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("coyuH", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $90627bba44315748$var$eos;
function $90627bba44315748$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $967Aq = parcelRequire("967Aq");
var $90627bba44315748$require$_require$codes = $967Aq.codes;
var $90627bba44315748$var$ERR_MISSING_ARGS = $90627bba44315748$require$_require$codes.ERR_MISSING_ARGS, $90627bba44315748$var$ERR_STREAM_DESTROYED = $90627bba44315748$require$_require$codes.ERR_STREAM_DESTROYED;
function $90627bba44315748$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $90627bba44315748$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $90627bba44315748$var$destroyer(stream, reading, writing, callback) {
    callback = $90627bba44315748$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($90627bba44315748$var$eos === undefined) $90627bba44315748$var$eos = (parcelRequire("hzqCm"));
    $90627bba44315748$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($90627bba44315748$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $90627bba44315748$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $90627bba44315748$var$call(fn) {
    fn();
}
function $90627bba44315748$var$pipe(from, to) {
    return from.pipe(to);
}
function $90627bba44315748$var$popCallback(streams) {
    if (!streams.length) return $90627bba44315748$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $90627bba44315748$var$noop;
    return streams.pop();
}
function $90627bba44315748$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $90627bba44315748$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $90627bba44315748$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $90627bba44315748$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($90627bba44315748$var$call);
            if (reading) return;
            destroys.forEach($90627bba44315748$var$call);
            callback(error);
        });
    });
    return streams.reduce($90627bba44315748$var$pipe);
}
module.exports = $90627bba44315748$var$pipeline;

});




parcelRegister("a8qBR", function(module, exports) {
"use strict";

var $6ZWSX = parcelRequire("6ZWSX");
var $760f4ae3157f7f0b$require$Buffer = $6ZWSX.Buffer;

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");
var $760f4ae3157f7f0b$var$ARRAY16 = new Array(16);
var $760f4ae3157f7f0b$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $760f4ae3157f7f0b$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $760f4ae3157f7f0b$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $760f4ae3157f7f0b$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $760f4ae3157f7f0b$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $760f4ae3157f7f0b$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $760f4ae3157f7f0b$var$RIPEMD160() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$dlqwk($760f4ae3157f7f0b$var$RIPEMD160, $eLdEM);
$760f4ae3157f7f0b$var$RIPEMD160.prototype._update = function() {
    var words = $760f4ae3157f7f0b$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $760f4ae3157f7f0b$var$fn1(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[0], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn5(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[0], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 32) {
            tl = $760f4ae3157f7f0b$var$fn2(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[1], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn4(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[1], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 48) {
            tl = $760f4ae3157f7f0b$var$fn3(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[2], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn3(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[2], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 64) {
            tl = $760f4ae3157f7f0b$var$fn4(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[3], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn2(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[3], $760f4ae3157f7f0b$var$sr[i]);
        } else {
            tl = $760f4ae3157f7f0b$var$fn5(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[4], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn1(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[4], $760f4ae3157f7f0b$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $760f4ae3157f7f0b$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $760f4ae3157f7f0b$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$760f4ae3157f7f0b$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $760f4ae3157f7f0b$require$Buffer.alloc ? $760f4ae3157f7f0b$require$Buffer.alloc(20) : new $760f4ae3157f7f0b$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $760f4ae3157f7f0b$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $760f4ae3157f7f0b$var$fn1(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn2(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn3(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn4(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn5(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $760f4ae3157f7f0b$var$RIPEMD160;

});

parcelRegister("5Z1sR", function(module, exports) {
var $45b3c90d57600982$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $45b3c90d57600982$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$45b3c90d57600982$var$exports.sha = (parcelRequire("dECyV"));

$45b3c90d57600982$var$exports.sha1 = (parcelRequire("dVcFO"));

$45b3c90d57600982$var$exports.sha224 = (parcelRequire("3wNjm"));

$45b3c90d57600982$var$exports.sha256 = (parcelRequire("3BFQx"));

$45b3c90d57600982$var$exports.sha384 = (parcelRequire("5qHaZ"));

$45b3c90d57600982$var$exports.sha512 = (parcelRequire("bZI17"));

});
parcelRegister("dECyV", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $9f0cec708e1f2103$require$Buffer = $1U9GM.Buffer;
var $9f0cec708e1f2103$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $9f0cec708e1f2103$var$W = new Array(80);
function $9f0cec708e1f2103$var$Sha() {
    this.init();
    this._w = $9f0cec708e1f2103$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($9f0cec708e1f2103$var$Sha, $O5ywn);
$9f0cec708e1f2103$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $9f0cec708e1f2103$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $9f0cec708e1f2103$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $9f0cec708e1f2103$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$9f0cec708e1f2103$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $9f0cec708e1f2103$var$rotl5(a) + $9f0cec708e1f2103$var$ft(s, b, c, d) + e + W[j] + $9f0cec708e1f2103$var$K[s] | 0;
        e = d;
        d = c;
        c = $9f0cec708e1f2103$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$9f0cec708e1f2103$var$Sha.prototype._hash = function() {
    var H = $9f0cec708e1f2103$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $9f0cec708e1f2103$var$Sha;

});
parcelRegister("O5ywn", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $0968fae43eb53960$require$Buffer = $1U9GM.Buffer;
// prototype class for hash functions
function $0968fae43eb53960$var$Hash(blockSize, finalSize) {
    this._block = $0968fae43eb53960$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$0968fae43eb53960$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $0968fae43eb53960$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$0968fae43eb53960$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$0968fae43eb53960$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $0968fae43eb53960$var$Hash;

});


parcelRegister("dVcFO", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $a22a6de6a357c37a$require$Buffer = $1U9GM.Buffer;
var $a22a6de6a357c37a$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $a22a6de6a357c37a$var$W = new Array(80);
function $a22a6de6a357c37a$var$Sha1() {
    this.init();
    this._w = $a22a6de6a357c37a$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($a22a6de6a357c37a$var$Sha1, $O5ywn);
$a22a6de6a357c37a$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $a22a6de6a357c37a$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $a22a6de6a357c37a$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $a22a6de6a357c37a$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $a22a6de6a357c37a$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$a22a6de6a357c37a$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $a22a6de6a357c37a$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $a22a6de6a357c37a$var$rotl5(a) + $a22a6de6a357c37a$var$ft(s, b, c, d) + e + W[j] + $a22a6de6a357c37a$var$K[s] | 0;
        e = d;
        d = c;
        c = $a22a6de6a357c37a$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$a22a6de6a357c37a$var$Sha1.prototype._hash = function() {
    var H = $a22a6de6a357c37a$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $a22a6de6a357c37a$var$Sha1;

});

parcelRegister("3wNjm", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $3BFQx = parcelRequire("3BFQx");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $291a9c6c5654a48d$require$Buffer = $1U9GM.Buffer;
var $291a9c6c5654a48d$var$W = new Array(64);
function $291a9c6c5654a48d$var$Sha224() {
    this.init();
    this._w = $291a9c6c5654a48d$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($291a9c6c5654a48d$var$Sha224, $3BFQx);
$291a9c6c5654a48d$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$291a9c6c5654a48d$var$Sha224.prototype._hash = function() {
    var H = $291a9c6c5654a48d$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $291a9c6c5654a48d$var$Sha224;

});
parcelRegister("3BFQx", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $2a05499bef58a0cf$require$Buffer = $1U9GM.Buffer;
var $2a05499bef58a0cf$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $2a05499bef58a0cf$var$W = new Array(64);
function $2a05499bef58a0cf$var$Sha256() {
    this.init();
    this._w = $2a05499bef58a0cf$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($2a05499bef58a0cf$var$Sha256, $O5ywn);
$2a05499bef58a0cf$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $2a05499bef58a0cf$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $2a05499bef58a0cf$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $2a05499bef58a0cf$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $2a05499bef58a0cf$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $2a05499bef58a0cf$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $2a05499bef58a0cf$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$2a05499bef58a0cf$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $2a05499bef58a0cf$var$gamma1(W[i - 2]) + W[i - 7] + $2a05499bef58a0cf$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $2a05499bef58a0cf$var$sigma1(e) + $2a05499bef58a0cf$var$ch(e, f, g) + $2a05499bef58a0cf$var$K[j] + W[j] | 0;
        var T2 = $2a05499bef58a0cf$var$sigma0(a) + $2a05499bef58a0cf$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$2a05499bef58a0cf$var$Sha256.prototype._hash = function() {
    var H = $2a05499bef58a0cf$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $2a05499bef58a0cf$var$Sha256;

});


parcelRegister("5qHaZ", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $bZI17 = parcelRequire("bZI17");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $01052ce47f94a5df$require$Buffer = $1U9GM.Buffer;
var $01052ce47f94a5df$var$W = new Array(160);
function $01052ce47f94a5df$var$Sha384() {
    this.init();
    this._w = $01052ce47f94a5df$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($01052ce47f94a5df$var$Sha384, $bZI17);
$01052ce47f94a5df$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$01052ce47f94a5df$var$Sha384.prototype._hash = function() {
    var H = $01052ce47f94a5df$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $01052ce47f94a5df$var$Sha384;

});
parcelRegister("bZI17", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $8bb7891960962038$require$Buffer = $1U9GM.Buffer;
var $8bb7891960962038$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8bb7891960962038$var$W = new Array(160);
function $8bb7891960962038$var$Sha512() {
    this.init();
    this._w = $8bb7891960962038$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($8bb7891960962038$var$Sha512, $O5ywn);
$8bb7891960962038$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8bb7891960962038$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8bb7891960962038$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8bb7891960962038$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8bb7891960962038$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8bb7891960962038$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8bb7891960962038$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8bb7891960962038$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8bb7891960962038$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8bb7891960962038$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8bb7891960962038$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $8bb7891960962038$var$Gamma0(xh, xl);
        var gamma0l = $8bb7891960962038$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $8bb7891960962038$var$Gamma1(xh, xl);
        var gamma1l = $8bb7891960962038$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8bb7891960962038$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8bb7891960962038$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8bb7891960962038$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $8bb7891960962038$var$maj(ah, bh, ch);
        var majl = $8bb7891960962038$var$maj(al, bl, cl);
        var sigma0h = $8bb7891960962038$var$sigma0(ah, al);
        var sigma0l = $8bb7891960962038$var$sigma0(al, ah);
        var sigma1h = $8bb7891960962038$var$sigma1(eh, el);
        var sigma1l = $8bb7891960962038$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $8bb7891960962038$var$K[j];
        var Kil = $8bb7891960962038$var$K[j + 1];
        var chh = $8bb7891960962038$var$Ch(eh, fh, gh);
        var chl = $8bb7891960962038$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8bb7891960962038$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8bb7891960962038$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8bb7891960962038$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8bb7891960962038$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8bb7891960962038$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8bb7891960962038$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8bb7891960962038$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8bb7891960962038$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8bb7891960962038$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8bb7891960962038$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8bb7891960962038$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8bb7891960962038$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8bb7891960962038$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8bb7891960962038$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8bb7891960962038$var$getCarry(this._hl, hl) | 0;
};
$8bb7891960962038$var$Sha512.prototype._hash = function() {
    var H = $8bb7891960962038$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8bb7891960962038$var$Sha512;

});



parcelRegister("26nOC", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $187e9d8dfda3dbba$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $187e9d8dfda3dbba$require$Transform = $ioRHp.Transform;

var $eNRCS = parcelRequire("eNRCS");
var $187e9d8dfda3dbba$require$StringDecoder = $eNRCS.StringDecoder;

var $dlqwk = parcelRequire("dlqwk");
function $187e9d8dfda3dbba$var$CipherBase(hashMode) {
    $187e9d8dfda3dbba$require$Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$dlqwk($187e9d8dfda3dbba$var$CipherBase, $187e9d8dfda3dbba$require$Transform);
$187e9d8dfda3dbba$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = $187e9d8dfda3dbba$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAutoPadding = function() {};
$187e9d8dfda3dbba$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$187e9d8dfda3dbba$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$187e9d8dfda3dbba$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $187e9d8dfda3dbba$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $187e9d8dfda3dbba$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $187e9d8dfda3dbba$var$CipherBase;

});


parcelRegister("1iL1D", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $77ZZs = parcelRequire("77ZZs");

var $26nOC = parcelRequire("26nOC");

var $1U9GM = parcelRequire("1U9GM");
var $0f2bf322914b61b2$require$Buffer = $1U9GM.Buffer;

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");
var $0f2bf322914b61b2$var$ZEROS = $0f2bf322914b61b2$require$Buffer.alloc(128);
function $0f2bf322914b61b2$var$Hmac(alg, key) {
    $26nOC.call(this, "digest");
    if (typeof key === "string") key = $0f2bf322914b61b2$require$Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new $a8qBR() : $5Z1sR(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $0f2bf322914b61b2$require$Buffer.concat([
        key,
        $0f2bf322914b61b2$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new $a8qBR() : $5Z1sR(alg);
    this._hash.update(ipad);
}
$dlqwk($0f2bf322914b61b2$var$Hmac, $26nOC);
$0f2bf322914b61b2$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$0f2bf322914b61b2$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new $a8qBR() : $5Z1sR(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new $0f2bf322914b61b2$var$Hmac("rmd160", key);
    if (alg === "md5") return new $77ZZs($8nM4g, key);
    return new $0f2bf322914b61b2$var$Hmac(alg, key);
};

});
parcelRegister("77ZZs", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $530945d1f5e7b9b5$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");
var $530945d1f5e7b9b5$var$ZEROS = $530945d1f5e7b9b5$require$Buffer.alloc(128);
var $530945d1f5e7b9b5$var$blocksize = 64;
function $530945d1f5e7b9b5$var$Hmac(alg, key) {
    $26nOC.call(this, "digest");
    if (typeof key === "string") key = $530945d1f5e7b9b5$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $530945d1f5e7b9b5$var$blocksize) key = alg(key);
    else if (key.length < $530945d1f5e7b9b5$var$blocksize) key = $530945d1f5e7b9b5$require$Buffer.concat([
        key,
        $530945d1f5e7b9b5$var$ZEROS
    ], $530945d1f5e7b9b5$var$blocksize);
    var ipad = this._ipad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    var opad = this._opad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    for(var i = 0; i < $530945d1f5e7b9b5$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$dlqwk($530945d1f5e7b9b5$var$Hmac, $26nOC);
$530945d1f5e7b9b5$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$530945d1f5e7b9b5$var$Hmac.prototype._final = function() {
    var h = this._alg($530945d1f5e7b9b5$require$Buffer.concat(this._hash));
    return this._alg($530945d1f5e7b9b5$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $530945d1f5e7b9b5$var$Hmac;

});

parcelRegister("8nM4g", function(module, exports) {

var $loYLU = parcelRequire("loYLU");
module.exports = function(buffer) {
    return new $loYLU().update(buffer).digest();
};

});


parcelRegister("6swAi", function(module, exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

});

parcelRegister("5dQ72", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $3cd697166017b735$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $1VtKc = parcelRequire("1VtKc");

var $kiaDM = parcelRequire("kiaDM");
var $3cd697166017b735$var$ZERO_BUF;
var $3cd697166017b735$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $3cd697166017b735$var$toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var $3cd697166017b735$var$checks = [];
function $3cd697166017b735$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$3cd697166017b735$var$subtle || !$3cd697166017b735$var$subtle.importKey || !$3cd697166017b735$var$subtle.deriveBits) return Promise.resolve(false);
    if ($3cd697166017b735$var$checks[algo] !== undefined) return $3cd697166017b735$var$checks[algo];
    $3cd697166017b735$var$ZERO_BUF = $3cd697166017b735$var$ZERO_BUF || $3cd697166017b735$require$Buffer.alloc(8);
    var prom = $3cd697166017b735$var$browserPbkdf2($3cd697166017b735$var$ZERO_BUF, $3cd697166017b735$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $3cd697166017b735$var$checks[algo] = prom;
    return prom;
}
var $3cd697166017b735$var$nextTick;
function $3cd697166017b735$var$getNextTick() {
    if ($3cd697166017b735$var$nextTick) return $3cd697166017b735$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $3cd697166017b735$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $3cd697166017b735$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $3cd697166017b735$var$nextTick = $parcel$global.setImmediate;
    else $3cd697166017b735$var$nextTick = $parcel$global.setTimeout;
    return $3cd697166017b735$var$nextTick;
}
function $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $3cd697166017b735$var$subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return $3cd697166017b735$var$subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $3cd697166017b735$require$Buffer.from(res);
    });
}
function $3cd697166017b735$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = $3cd697166017b735$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== "function") {
        $3cd697166017b735$var$getNextTick()(function() {
            var out;
            try {
                out = $1VtKc(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, "Password");
    salt = $kiaDM(salt, $6YaY3, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    $3cd697166017b735$var$resolvePromise($3cd697166017b735$var$checkNative(algo).then(function(resp) {
        if (resp) return $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $1VtKc(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("7dtUH", function(module, exports) {
var $5410f37dea3a95ee$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > $5410f37dea3a95ee$var$MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

});

parcelRegister("6YaY3", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
var $5130da986dd86f24$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $5130da986dd86f24$var$defaultEncoding = "utf-8";
else if ($parcel$global.process && $parcel$global.process.version) {
    var $5130da986dd86f24$var$pVersionMajor = parseInt($hPtJY.version.split(".")[0].slice(1), 10);
    $5130da986dd86f24$var$defaultEncoding = $5130da986dd86f24$var$pVersionMajor >= 6 ? "utf-8" : "binary";
} else $5130da986dd86f24$var$defaultEncoding = "utf-8";
module.exports = $5130da986dd86f24$var$defaultEncoding;

});

parcelRegister("1VtKc", function(module, exports) {

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $1U9GM = parcelRequire("1U9GM");
var $16722fe28cdbf3c2$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $kiaDM = parcelRequire("kiaDM");
var $16722fe28cdbf3c2$var$ZEROS = $16722fe28cdbf3c2$require$Buffer.alloc(128);
var $16722fe28cdbf3c2$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $16722fe28cdbf3c2$var$Hmac(alg, key, saltLen) {
    var hash = $16722fe28cdbf3c2$var$getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $16722fe28cdbf3c2$require$Buffer.concat([
        key,
        $16722fe28cdbf3c2$var$ZEROS
    ], blocksize);
    var ipad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    var opad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $16722fe28cdbf3c2$var$sizes[alg];
}
$16722fe28cdbf3c2$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $16722fe28cdbf3c2$var$getDigest(alg) {
    function shaFunc(data) {
        return $5Z1sR(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $a8qBR().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return $8nM4g;
    return shaFunc;
}
function $16722fe28cdbf3c2$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, "Password");
    salt = $kiaDM(salt, $6YaY3, "Salt");
    digest = digest || "sha1";
    var hmac = new $16722fe28cdbf3c2$var$Hmac(digest, password, salt.length);
    var DK = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(keylen);
    var block1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $16722fe28cdbf3c2$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $16722fe28cdbf3c2$var$pbkdf2;

});
parcelRegister("kiaDM", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $ec5dbe1d2de061b3$require$Buffer = $1U9GM.Buffer;
module.exports = function(thing, encoding, name) {
    if ($ec5dbe1d2de061b3$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return $ec5dbe1d2de061b3$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $ec5dbe1d2de061b3$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

});



parcelRegister("dyok1", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $9de15128f81796e0$export$cfaef8ed399428b0, (v) => $9de15128f81796e0$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $9de15128f81796e0$export$a80c7deaea7cbd80, (v) => $9de15128f81796e0$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $9de15128f81796e0$export$ed7577ae6e1cd0ef, (v) => $9de15128f81796e0$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $9de15128f81796e0$export$5dcbef3aa594f567, (v) => $9de15128f81796e0$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $9de15128f81796e0$export$5bc8001ca71ed9c5, (v) => $9de15128f81796e0$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $9de15128f81796e0$export$3e714e2c5d5d8cb2, (v) => $9de15128f81796e0$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $9de15128f81796e0$export$94c3e544fd062b7f, (v) => $9de15128f81796e0$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $9de15128f81796e0$export$9f77e0932fb78f72, (v) => $9de15128f81796e0$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $9de15128f81796e0$export$d865ce2836f5927f, (v) => $9de15128f81796e0$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $9de15128f81796e0$export$95e62ad65da8b7d2, (v) => $9de15128f81796e0$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $9de15128f81796e0$export$209139ff098c441a, (v) => $9de15128f81796e0$export$209139ff098c441a = v);
var $9de15128f81796e0$export$cfaef8ed399428b0;
var $9de15128f81796e0$export$a80c7deaea7cbd80;
var $9de15128f81796e0$export$ed7577ae6e1cd0ef;
var $9de15128f81796e0$export$5dcbef3aa594f567;
var $9de15128f81796e0$export$5bc8001ca71ed9c5;
var $9de15128f81796e0$export$3e714e2c5d5d8cb2;
var $9de15128f81796e0$export$94c3e544fd062b7f;
var $9de15128f81796e0$export$9f77e0932fb78f72;
var $9de15128f81796e0$export$d865ce2836f5927f;
var $9de15128f81796e0$export$95e62ad65da8b7d2;
var $9de15128f81796e0$export$209139ff098c441a;
"use strict";
$9de15128f81796e0$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$9de15128f81796e0$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$9de15128f81796e0$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $9de15128f81796e0$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$9de15128f81796e0$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $9de15128f81796e0$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $9de15128f81796e0$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $9de15128f81796e0$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$9de15128f81796e0$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $9de15128f81796e0$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$9de15128f81796e0$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $9de15128f81796e0$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $9de15128f81796e0$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$9de15128f81796e0$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

});

parcelRegister("enfpo", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");
function $a76f2a83ec677410$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $a76f2a83ec677410$var$Cipher;
$a76f2a83ec677410$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$a76f2a83ec677410$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$a76f2a83ec677410$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$a76f2a83ec677410$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$a76f2a83ec677410$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$a76f2a83ec677410$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$a76f2a83ec677410$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$a76f2a83ec677410$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $koC21.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("koC21", function(module, exports) {
module.exports = $ed938ccf59a32f03$var$assert;
function $ed938ccf59a32f03$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$ed938ccf59a32f03$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});


parcelRegister("dB8Kv", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $dyok1 = parcelRequire("dyok1");

var $enfpo = parcelRequire("enfpo");
function $9e6584766ef755d8$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $9e6584766ef755d8$var$DES(options) {
    $enfpo.call(this, options);
    var state = new $9e6584766ef755d8$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$dlqwk($9e6584766ef755d8$var$DES, $enfpo);
module.exports = $9e6584766ef755d8$var$DES;
$9e6584766ef755d8$var$DES.create = function create(options) {
    return new $9e6584766ef755d8$var$DES(options);
};
var $9e6584766ef755d8$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$9e6584766ef755d8$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $koC21.equal(key.length, this.blockSize, "Invalid key length");
    var kL = $dyok1.readUInt32BE(key, 0);
    var kR = $dyok1.readUInt32BE(key, 4);
    $dyok1.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $9e6584766ef755d8$var$shiftTable[i >>> 1];
        kL = $dyok1.r28shl(kL, shift);
        kR = $dyok1.r28shl(kR, shift);
        $dyok1.pc2(kL, kR, state.keys, i);
    }
};
$9e6584766ef755d8$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $dyok1.readUInt32BE(inp, inOff);
    var r = $dyok1.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $dyok1.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $dyok1.writeUInt32BE(out, l, outOff);
    $dyok1.writeUInt32BE(out, r, outOff + 4);
};
$9e6584766ef755d8$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$9e6584766ef755d8$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$koC21.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$9e6584766ef755d8$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(r, l, out, off);
};
$9e6584766ef755d8$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(l, r, out, off);
};

});

parcelRegister("eiYbc", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $a6a16d933acb8abd$export$f9bb8d20ccc7477a, (v) => $a6a16d933acb8abd$export$f9bb8d20ccc7477a = v);
var $a6a16d933acb8abd$export$f9bb8d20ccc7477a;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
var $a6a16d933acb8abd$var$proto = {};
function $a6a16d933acb8abd$var$CBCState(iv) {
    $koC21.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $a6a16d933acb8abd$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $dlqwk(CBC, Base);
    var keys = Object.keys($a6a16d933acb8abd$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $a6a16d933acb8abd$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$a6a16d933acb8abd$export$f9bb8d20ccc7477a = $a6a16d933acb8abd$var$instantiate;
$a6a16d933acb8abd$var$proto._cbcInit = function _cbcInit() {
    var state = new $a6a16d933acb8abd$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$a6a16d933acb8abd$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("5ye6K", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $enfpo = parcelRequire("enfpo");

var $dB8Kv = parcelRequire("dB8Kv");
function $40ab123e2a8964f5$var$EDEState(type, key) {
    $koC21.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        $dB8Kv.create({
            type: "encrypt",
            key: k1
        }),
        $dB8Kv.create({
            type: "decrypt",
            key: k2
        }),
        $dB8Kv.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        $dB8Kv.create({
            type: "decrypt",
            key: k3
        }),
        $dB8Kv.create({
            type: "encrypt",
            key: k2
        }),
        $dB8Kv.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function $40ab123e2a8964f5$var$EDE(options) {
    $enfpo.call(this, options);
    var state = new $40ab123e2a8964f5$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$dlqwk($40ab123e2a8964f5$var$EDE, $enfpo);
module.exports = $40ab123e2a8964f5$var$EDE;
$40ab123e2a8964f5$var$EDE.create = function create(options) {
    return new $40ab123e2a8964f5$var$EDE(options);
};
$40ab123e2a8964f5$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$40ab123e2a8964f5$var$EDE.prototype._pad = $dB8Kv.prototype._pad;
$40ab123e2a8964f5$var$EDE.prototype._unpad = $dB8Kv.prototype._unpad;

});

parcelRegister("f6p9h", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $afeaec8849bcc81c$export$5b0f6292f11d1d18, (v) => $afeaec8849bcc81c$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $afeaec8849bcc81c$export$e85a0c9a1067c5d3, (v) => $afeaec8849bcc81c$export$e85a0c9a1067c5d3 = v);
var $afeaec8849bcc81c$export$5b0f6292f11d1d18;
var $afeaec8849bcc81c$export$e85a0c9a1067c5d3;
$afeaec8849bcc81c$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$afeaec8849bcc81c$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("3QymJ", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18, (v) => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3, (v) => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = v);
var $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18;
var $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3;

var $dUX5c = parcelRequire("dUX5c");
$2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $dUX5c(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $dUX5c(out, pad);
};

});
parcelRegister("dUX5c", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $a21e55eeffd2595b$require$Buffer = $6ZWSX.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $a21e55eeffd2595b$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("2cuuO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $19a45ba19082fc97$export$5b0f6292f11d1d18, (v) => $19a45ba19082fc97$export$5b0f6292f11d1d18 = v);
var $19a45ba19082fc97$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $19a45ba19082fc97$require$Buffer = $1U9GM.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $19a45ba19082fc97$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $dUX5c(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $19a45ba19082fc97$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$19a45ba19082fc97$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("03mhO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $00a19188a96aa70f$export$5b0f6292f11d1d18, (v) => $00a19188a96aa70f$export$5b0f6292f11d1d18 = v);
var $00a19188a96aa70f$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $00a19188a96aa70f$require$Buffer = $1U9GM.Buffer;
function $00a19188a96aa70f$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $00a19188a96aa70f$require$Buffer.concat([
        self._prev.slice(1),
        $00a19188a96aa70f$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$00a19188a96aa70f$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $00a19188a96aa70f$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $00a19188a96aa70f$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fK9OU", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b762c4f45662bf18$export$5b0f6292f11d1d18, (v) => $b762c4f45662bf18$export$5b0f6292f11d1d18 = v);
var $b762c4f45662bf18$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $b762c4f45662bf18$require$Buffer = $1U9GM.Buffer;
function $b762c4f45662bf18$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $b762c4f45662bf18$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $b762c4f45662bf18$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(buffer.length);
    buffer = $b762c4f45662bf18$require$Buffer.concat([
        buffer,
        $b762c4f45662bf18$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$b762c4f45662bf18$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $b762c4f45662bf18$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fFe8N", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b675a769a603e0fc$export$5b0f6292f11d1d18, (v) => $b675a769a603e0fc$export$5b0f6292f11d1d18 = v);
var $b675a769a603e0fc$export$5b0f6292f11d1d18;

var $6ZWSX = parcelRequire("6ZWSX");
var $b675a769a603e0fc$require$Buffer = $6ZWSX.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $b675a769a603e0fc$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$b675a769a603e0fc$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $b675a769a603e0fc$require$Buffer.concat([
        self._cache,
        $b675a769a603e0fc$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});

parcelRegister("fJbMg", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b73431c24e9fa039$export$5b0f6292f11d1d18, (v) => $b73431c24e9fa039$export$5b0f6292f11d1d18 = v);
var $b73431c24e9fa039$export$5b0f6292f11d1d18;

var $dUX5c = parcelRequire("dUX5c");

var $1U9GM = parcelRequire("1U9GM");
var $b73431c24e9fa039$require$Buffer = $1U9GM.Buffer;

var $3VKgl = parcelRequire("3VKgl");
function $b73431c24e9fa039$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $3VKgl(self._prev);
    return out;
}
var $b73431c24e9fa039$var$blockSize = 16;
$b73431c24e9fa039$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $b73431c24e9fa039$var$blockSize);
    var start = self._cache.length;
    self._cache = $b73431c24e9fa039$require$Buffer.concat([
        self._cache,
        $b73431c24e9fa039$require$Buffer.allocUnsafe(chunkNum * $b73431c24e9fa039$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $b73431c24e9fa039$var$getBlock(self);
        var offset = start + i * $b73431c24e9fa039$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});
parcelRegister("3VKgl", function(module, exports) {
function $2dca94c326c7eb9a$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $2dca94c326c7eb9a$var$incr32;

});


parcelRegister("5vmVB", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7Zvov", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7JHF0", function(module, exports) {
var $5a1e9a6ed4e8de8a$var$r;
module.exports = function rand(len) {
    if (!$5a1e9a6ed4e8de8a$var$r) $5a1e9a6ed4e8de8a$var$r = new $5a1e9a6ed4e8de8a$var$Rand(null);
    return $5a1e9a6ed4e8de8a$var$r.generate(len);
};
function $5a1e9a6ed4e8de8a$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $5a1e9a6ed4e8de8a$var$Rand;
$5a1e9a6ed4e8de8a$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $5a1e9a6ed4e8de8a$var$crypto = (parcelRequire("kjyEk"));
    if (typeof $5a1e9a6ed4e8de8a$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        return $5a1e9a6ed4e8de8a$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRegister("b6RFW", function(module, exports) {

exports = module.exports = (parcelRequire("d4xg3"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("3LwY7"));

exports.Duplex = (parcelRequire("DwJuQ"));

exports.Transform = (parcelRequire("b7kl8"));

exports.PassThrough = (parcelRequire("4wWcs"));

});
parcelRegister("d4xg3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ module.exports = $9845726cca5dc7eb$var$Readable;

var $767Wy = parcelRequire("767Wy");
/*</replacement>*/ /*<replacement>*/ var $9845726cca5dc7eb$var$Duplex;
/*</replacement>*/ $9845726cca5dc7eb$var$Readable.ReadableState = $9845726cca5dc7eb$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $9845726cca5dc7eb$require$EE = $7etJZ.EventEmitter;
var $9845726cca5dc7eb$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $jfAlf = parcelRequire("jfAlf");

var $h3oXE = parcelRequire("h3oXE");
var $9845726cca5dc7eb$require$Buffer = $h3oXE.Buffer;
var $9845726cca5dc7eb$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk) {
    return $9845726cca5dc7eb$require$Buffer.from(chunk);
}
function $9845726cca5dc7eb$var$_isUint8Array(obj) {
    return $9845726cca5dc7eb$require$Buffer.isBuffer(obj) || obj instanceof $9845726cca5dc7eb$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $9845726cca5dc7eb$var$util = Object.create((parcelRequire("dH2Jp")));

$9845726cca5dc7eb$var$util.inherits = (parcelRequire("dlqwk"));

var $kjyEk = parcelRequire("kjyEk");
var $9845726cca5dc7eb$var$debug = void 0;
if ($kjyEk && $kjyEk.debuglog) $9845726cca5dc7eb$var$debug = $kjyEk.debuglog("stream");
else $9845726cca5dc7eb$var$debug = function() {};

var $185iR = parcelRequire("185iR");

var $fMCbt = parcelRequire("fMCbt");
var $9845726cca5dc7eb$var$StringDecoder;
$9845726cca5dc7eb$var$util.inherits($9845726cca5dc7eb$var$Readable, $jfAlf);
var $9845726cca5dc7eb$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $9845726cca5dc7eb$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($767Wy(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $9845726cca5dc7eb$var$ReadableState(options, stream) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $9845726cca5dc7eb$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $185iR();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("imDDS")).StringDecoder;
        this.decoder = new $9845726cca5dc7eb$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9845726cca5dc7eb$var$Readable(options) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    if (!(this instanceof $9845726cca5dc7eb$var$Readable)) return new $9845726cca5dc7eb$var$Readable(options);
    this._readableState = new $9845726cca5dc7eb$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $jfAlf.call(this);
}
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "destroyed", {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$9845726cca5dc7eb$var$Readable.prototype.destroy = $fMCbt.destroy;
$9845726cca5dc7eb$var$Readable.prototype._undestroy = $fMCbt.undestroy;
$9845726cca5dc7eb$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9845726cca5dc7eb$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $9845726cca5dc7eb$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$9845726cca5dc7eb$var$Readable.prototype.unshift = function(chunk) {
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, null, true, false);
};
function $9845726cca5dc7eb$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $9845726cca5dc7eb$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $9845726cca5dc7eb$var$chunkInvalid(state, chunk);
        if (er) stream.emit("error", er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $9845726cca5dc7eb$require$Buffer.prototype) chunk = $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit("error", new Error("stream.unshift() after end event"));
                else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit("error", new Error("stream.push() after EOF"));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
                    else $9845726cca5dc7eb$var$maybeReadMore(stream, state);
                } else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $9845726cca5dc7eb$var$needMoreData(state);
}
function $9845726cca5dc7eb$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit("data", chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $9845726cca5dc7eb$var$emitReadable(stream);
    }
    $9845726cca5dc7eb$var$maybeReadMore(stream, state);
}
function $9845726cca5dc7eb$var$chunkInvalid(state, chunk) {
    var er;
    if (!$9845726cca5dc7eb$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $9845726cca5dc7eb$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$9845726cca5dc7eb$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$9845726cca5dc7eb$var$Readable.prototype.setEncoding = function(enc) {
    if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("imDDS")).StringDecoder;
    this._readableState.decoder = new $9845726cca5dc7eb$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $9845726cca5dc7eb$var$MAX_HWM = 0x800000;
function $9845726cca5dc7eb$var$computeNewHighWaterMark(n) {
    if (n >= $9845726cca5dc7eb$var$MAX_HWM) n = $9845726cca5dc7eb$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9845726cca5dc7eb$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$9845726cca5dc7eb$var$Readable.prototype.read = function(n) {
    $9845726cca5dc7eb$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $9845726cca5dc7eb$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $9845726cca5dc7eb$var$endReadable(this);
        else $9845726cca5dc7eb$var$emitReadable(this);
        return null;
    }
    n = $9845726cca5dc7eb$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9845726cca5dc7eb$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $9845726cca5dc7eb$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9845726cca5dc7eb$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $9845726cca5dc7eb$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $9845726cca5dc7eb$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9845726cca5dc7eb$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $9845726cca5dc7eb$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9845726cca5dc7eb$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $9845726cca5dc7eb$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $9845726cca5dc7eb$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9845726cca5dc7eb$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9845726cca5dc7eb$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        if (state.sync) $bUlqC.nextTick($9845726cca5dc7eb$var$emitReadable_, stream);
        else $9845726cca5dc7eb$var$emitReadable_(stream);
    }
}
function $9845726cca5dc7eb$var$emitReadable_(stream) {
    $9845726cca5dc7eb$var$debug("emit readable");
    stream.emit("readable");
    $9845726cca5dc7eb$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9845726cca5dc7eb$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $bUlqC.nextTick($9845726cca5dc7eb$var$maybeReadMore_, stream, state);
    }
}
function $9845726cca5dc7eb$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $9845726cca5dc7eb$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9845726cca5dc7eb$var$Readable.prototype._read = function(n) {
    this.emit("error", new Error("_read() is not implemented"));
};
$9845726cca5dc7eb$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $9845726cca5dc7eb$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $bUlqC.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9845726cca5dc7eb$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9845726cca5dc7eb$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $9845726cca5dc7eb$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $9845726cca5dc7eb$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on("data", ondata);
    function ondata(chunk) {
        $9845726cca5dc7eb$var$debug("ondata");
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $9845726cca5dc7eb$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $9845726cca5dc7eb$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9845726cca5dc7eb$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($9845726cca5dc7eb$var$EElistenerCount(dest, "error") === 0) dest.emit("error", er);
    }
    // Make sure our error handler is attached before userland ones.
    $9845726cca5dc7eb$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $9845726cca5dc7eb$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $9845726cca5dc7eb$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $9845726cca5dc7eb$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $9845726cca5dc7eb$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $9845726cca5dc7eb$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $9845726cca5dc7eb$var$flow(src);
        }
    };
}
$9845726cca5dc7eb$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $9845726cca5dc7eb$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$9845726cca5dc7eb$var$Readable.prototype.on = function(ev, fn) {
    var res = $jfAlf.prototype.on.call(this, ev, fn);
    if (ev === "data") // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === "readable") {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $bUlqC.nextTick($9845726cca5dc7eb$var$nReadingNextTick, this);
            else if (state.length) $9845726cca5dc7eb$var$emitReadable(this);
        }
    }
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.addListener = $9845726cca5dc7eb$var$Readable.prototype.on;
function $9845726cca5dc7eb$var$nReadingNextTick(self1) {
    $9845726cca5dc7eb$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9845726cca5dc7eb$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("resume");
        state.flowing = true;
        $9845726cca5dc7eb$var$resume(this, state);
    }
    return this;
};
function $9845726cca5dc7eb$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $bUlqC.nextTick($9845726cca5dc7eb$var$resume_, stream, state);
    }
}
function $9845726cca5dc7eb$var$resume_(stream, state) {
    if (!state.reading) {
        $9845726cca5dc7eb$var$debug("resume read 0");
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit("resume");
    $9845726cca5dc7eb$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9845726cca5dc7eb$var$Readable.prototype.pause = function() {
    $9845726cca5dc7eb$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $9845726cca5dc7eb$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    return this;
};
function $9845726cca5dc7eb$var$flow(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9845726cca5dc7eb$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $9845726cca5dc7eb$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $9845726cca5dc7eb$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $9845726cca5dc7eb$var$kProxyEvents.length; n++)stream.on($9845726cca5dc7eb$var$kProxyEvents[n], this.emit.bind(this, $9845726cca5dc7eb$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $9845726cca5dc7eb$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$9845726cca5dc7eb$var$Readable._fromList = $9845726cca5dc7eb$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $9845726cca5dc7eb$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $9845726cca5dc7eb$var$copyFromBufferString(n, list) : $9845726cca5dc7eb$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$copyFromBuffer(n, list) {
    var ret = $9845726cca5dc7eb$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $9845726cca5dc7eb$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $bUlqC.nextTick($9845726cca5dc7eb$var$endReadableNT, state, stream);
    }
}
function $9845726cca5dc7eb$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
    }
}
function $9845726cca5dc7eb$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("bUlqC", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
if (typeof $hPtJY === "undefined" || !$hPtJY.version || $hPtJY.version.indexOf("v0.") === 0 || $hPtJY.version.indexOf("v1.") === 0 && $hPtJY.version.indexOf("v1.8.") !== 0) module.exports = {
    nextTick: $8ab58be9444f732a$var$nextTick
};
else module.exports = $hPtJY;
function $8ab58be9444f732a$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== "function") throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $hPtJY.nextTick(fn);
        case 2:
            return $hPtJY.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $hPtJY.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $hPtJY.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $hPtJY.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("767Wy", function(module, exports) {
var $52af415c3a3d4253$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $52af415c3a3d4253$var$toString.call(arr) == "[object Array]";
};

});

parcelRegister("jfAlf", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("h3oXE", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $c6a6143e40fe9703$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $c6a6143e40fe9703$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($c6a6143e40fe9703$var$Buffer.from && $c6a6143e40fe9703$var$Buffer.alloc && $c6a6143e40fe9703$var$Buffer.allocUnsafe && $c6a6143e40fe9703$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $c6a6143e40fe9703$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $c6a6143e40fe9703$var$SafeBuffer;
}
function $c6a6143e40fe9703$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $c6a6143e40fe9703$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$c6a6143e40fe9703$var$copyProps($c6a6143e40fe9703$var$Buffer, $c6a6143e40fe9703$var$SafeBuffer);
$c6a6143e40fe9703$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $c6a6143e40fe9703$var$Buffer(arg, encodingOrOffset, length);
};
$c6a6143e40fe9703$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $c6a6143e40fe9703$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$c6a6143e40fe9703$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $c6a6143e40fe9703$var$Buffer(size);
};
$c6a6143e40fe9703$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});

parcelRegister("dH2Jp", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $9f8168ed52eee242$export$43bee75e5e14138e, (v) => $9f8168ed52eee242$export$43bee75e5e14138e = v);
$parcel$export(module.exports, "isBoolean", () => $9f8168ed52eee242$export$f9ce7b637dfbe238, (v) => $9f8168ed52eee242$export$f9ce7b637dfbe238 = v);
$parcel$export(module.exports, "isNull", () => $9f8168ed52eee242$export$630801d484da15df, (v) => $9f8168ed52eee242$export$630801d484da15df = v);
$parcel$export(module.exports, "isNullOrUndefined", () => $9f8168ed52eee242$export$bedb7023a7733221, (v) => $9f8168ed52eee242$export$bedb7023a7733221 = v);
$parcel$export(module.exports, "isNumber", () => $9f8168ed52eee242$export$7e4aa119212bc614, (v) => $9f8168ed52eee242$export$7e4aa119212bc614 = v);
$parcel$export(module.exports, "isString", () => $9f8168ed52eee242$export$844ec244b1367d54, (v) => $9f8168ed52eee242$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "isSymbol", () => $9f8168ed52eee242$export$a244864fd9645c7f, (v) => $9f8168ed52eee242$export$a244864fd9645c7f = v);
$parcel$export(module.exports, "isUndefined", () => $9f8168ed52eee242$export$fce6876652108ab, (v) => $9f8168ed52eee242$export$fce6876652108ab = v);
$parcel$export(module.exports, "isRegExp", () => $9f8168ed52eee242$export$49841c62b9eff15, (v) => $9f8168ed52eee242$export$49841c62b9eff15 = v);
$parcel$export(module.exports, "isObject", () => $9f8168ed52eee242$export$a6cdc56e425d0d0a, (v) => $9f8168ed52eee242$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "isDate", () => $9f8168ed52eee242$export$871608497c498473, (v) => $9f8168ed52eee242$export$871608497c498473 = v);
$parcel$export(module.exports, "isError", () => $9f8168ed52eee242$export$e6127cc7fe7395c3, (v) => $9f8168ed52eee242$export$e6127cc7fe7395c3 = v);
$parcel$export(module.exports, "isFunction", () => $9f8168ed52eee242$export$f6e2535fb5126e54, (v) => $9f8168ed52eee242$export$f6e2535fb5126e54 = v);
$parcel$export(module.exports, "isPrimitive", () => $9f8168ed52eee242$export$c3825b437cbdea5c, (v) => $9f8168ed52eee242$export$c3825b437cbdea5c = v);
$parcel$export(module.exports, "isBuffer", () => $9f8168ed52eee242$export$a7884ebc965f8f54, (v) => $9f8168ed52eee242$export$a7884ebc965f8f54 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $9f8168ed52eee242$export$43bee75e5e14138e;
var $9f8168ed52eee242$export$f9ce7b637dfbe238;
var $9f8168ed52eee242$export$630801d484da15df;
var $9f8168ed52eee242$export$bedb7023a7733221;
var $9f8168ed52eee242$export$7e4aa119212bc614;
var $9f8168ed52eee242$export$844ec244b1367d54;
var $9f8168ed52eee242$export$a244864fd9645c7f;
var $9f8168ed52eee242$export$fce6876652108ab;
var $9f8168ed52eee242$export$49841c62b9eff15;
var $9f8168ed52eee242$export$a6cdc56e425d0d0a;
var $9f8168ed52eee242$export$871608497c498473;
var $9f8168ed52eee242$export$e6127cc7fe7395c3;
var $9f8168ed52eee242$export$f6e2535fb5126e54;
var $9f8168ed52eee242$export$c3825b437cbdea5c;
var $9f8168ed52eee242$export$a7884ebc965f8f54;
function $9f8168ed52eee242$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $9f8168ed52eee242$var$objectToString(arg) === "[object Array]";
}
$9f8168ed52eee242$export$43bee75e5e14138e = $9f8168ed52eee242$var$isArray;
function $9f8168ed52eee242$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
$9f8168ed52eee242$export$f9ce7b637dfbe238 = $9f8168ed52eee242$var$isBoolean;
function $9f8168ed52eee242$var$isNull(arg) {
    return arg === null;
}
$9f8168ed52eee242$export$630801d484da15df = $9f8168ed52eee242$var$isNull;
function $9f8168ed52eee242$var$isNullOrUndefined(arg) {
    return arg == null;
}
$9f8168ed52eee242$export$bedb7023a7733221 = $9f8168ed52eee242$var$isNullOrUndefined;
function $9f8168ed52eee242$var$isNumber(arg) {
    return typeof arg === "number";
}
$9f8168ed52eee242$export$7e4aa119212bc614 = $9f8168ed52eee242$var$isNumber;
function $9f8168ed52eee242$var$isString(arg) {
    return typeof arg === "string";
}
$9f8168ed52eee242$export$844ec244b1367d54 = $9f8168ed52eee242$var$isString;
function $9f8168ed52eee242$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
$9f8168ed52eee242$export$a244864fd9645c7f = $9f8168ed52eee242$var$isSymbol;
function $9f8168ed52eee242$var$isUndefined(arg) {
    return arg === void 0;
}
$9f8168ed52eee242$export$fce6876652108ab = $9f8168ed52eee242$var$isUndefined;
function $9f8168ed52eee242$var$isRegExp(re) {
    return $9f8168ed52eee242$var$objectToString(re) === "[object RegExp]";
}
$9f8168ed52eee242$export$49841c62b9eff15 = $9f8168ed52eee242$var$isRegExp;
function $9f8168ed52eee242$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
$9f8168ed52eee242$export$a6cdc56e425d0d0a = $9f8168ed52eee242$var$isObject;
function $9f8168ed52eee242$var$isDate(d) {
    return $9f8168ed52eee242$var$objectToString(d) === "[object Date]";
}
$9f8168ed52eee242$export$871608497c498473 = $9f8168ed52eee242$var$isDate;
function $9f8168ed52eee242$var$isError(e) {
    return $9f8168ed52eee242$var$objectToString(e) === "[object Error]" || e instanceof Error;
}
$9f8168ed52eee242$export$e6127cc7fe7395c3 = $9f8168ed52eee242$var$isError;
function $9f8168ed52eee242$var$isFunction(arg) {
    return typeof arg === "function";
}
$9f8168ed52eee242$export$f6e2535fb5126e54 = $9f8168ed52eee242$var$isFunction;
function $9f8168ed52eee242$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
$9f8168ed52eee242$export$c3825b437cbdea5c = $9f8168ed52eee242$var$isPrimitive;

$9f8168ed52eee242$export$a7884ebc965f8f54 = (parcelRequire("6ZWSX")).Buffer.isBuffer;
function $9f8168ed52eee242$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("185iR", function(module, exports) {
"use strict";
function $0d2aa6ea56b3e1e2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $h3oXE = parcelRequire("h3oXE");
var $0d2aa6ea56b3e1e2$require$Buffer = $h3oXE.Buffer;

var $kjyEk = parcelRequire("kjyEk");
function $0d2aa6ea56b3e1e2$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $0d2aa6ea56b3e1e2$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return "";
        var p = this.head;
        var ret = "" + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $0d2aa6ea56b3e1e2$require$Buffer.alloc(0);
        var ret = $0d2aa6ea56b3e1e2$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $0d2aa6ea56b3e1e2$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($kjyEk && $kjyEk.inspect && $kjyEk.inspect.custom) module.exports.prototype[$kjyEk.inspect.custom] = function() {
    var obj = $kjyEk.inspect({
        length: this.length
    });
    return this.constructor.name + " " + obj;
};

});

parcelRegister("fMCbt", function(module, exports) {
"use strict";

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $b7d8f541ca4a3ff5$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $b7d8f541ca4a3ff5$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b7d8f541ca4a3ff5$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
module.exports = {
    destroy: $b7d8f541ca4a3ff5$var$destroy,
    undestroy: $b7d8f541ca4a3ff5$var$undestroy
};

});

parcelRegister("DwJuQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
"use strict";

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ /*<replacement>*/ var $076d08b0309449dc$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $076d08b0309449dc$var$Duplex;

/*<replacement>*/ var $076d08b0309449dc$var$util = Object.create((parcelRequire("dH2Jp")));

$076d08b0309449dc$var$util.inherits = (parcelRequire("dlqwk"));

var $d4xg3 = parcelRequire("d4xg3");

var $3LwY7 = parcelRequire("3LwY7");
$076d08b0309449dc$var$util.inherits($076d08b0309449dc$var$Duplex, $d4xg3);
// avoid scope creep, the keys array can then be collected
var $076d08b0309449dc$var$keys = $076d08b0309449dc$var$objectKeys($3LwY7.prototype);
for(var $076d08b0309449dc$var$v = 0; $076d08b0309449dc$var$v < $076d08b0309449dc$var$keys.length; $076d08b0309449dc$var$v++){
    var $076d08b0309449dc$var$method = $076d08b0309449dc$var$keys[$076d08b0309449dc$var$v];
    if (!$076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method]) $076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method] = $3LwY7.prototype[$076d08b0309449dc$var$method];
}
function $076d08b0309449dc$var$Duplex(options) {
    if (!(this instanceof $076d08b0309449dc$var$Duplex)) return new $076d08b0309449dc$var$Duplex(options);
    $d4xg3.call(this, options);
    $3LwY7.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once("end", $076d08b0309449dc$var$onend);
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $076d08b0309449dc$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $bUlqC.nextTick($076d08b0309449dc$var$onEndNT, this);
}
function $076d08b0309449dc$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "destroyed", {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$076d08b0309449dc$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $bUlqC.nextTick(cb, err);
};

});
parcelRegister("3LwY7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
"use strict";

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ module.exports = $2bdf55c2c4f390d3$var$Writable;
/* <replacement> */ function $2bdf55c2c4f390d3$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $2bdf55c2c4f390d3$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $2bdf55c2c4f390d3$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $2bdf55c2c4f390d3$var$asyncWrite = (0, $bUlqC.nextTick);
/*</replacement>*/ /*<replacement>*/ var $2bdf55c2c4f390d3$var$Duplex;
/*</replacement>*/ $2bdf55c2c4f390d3$var$Writable.WritableState = $2bdf55c2c4f390d3$var$WritableState;

/*<replacement>*/ var $2bdf55c2c4f390d3$var$util = Object.create((parcelRequire("dH2Jp")));

$2bdf55c2c4f390d3$var$util.inherits = (parcelRequire("dlqwk"));

/*</replacement>*/ /*<replacement>*/ var $2bdf55c2c4f390d3$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jfAlf = parcelRequire("jfAlf");

var $h3oXE = parcelRequire("h3oXE");
var $2bdf55c2c4f390d3$require$Buffer = $h3oXE.Buffer;
var $2bdf55c2c4f390d3$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk) {
    return $2bdf55c2c4f390d3$require$Buffer.from(chunk);
}
function $2bdf55c2c4f390d3$var$_isUint8Array(obj) {
    return $2bdf55c2c4f390d3$require$Buffer.isBuffer(obj) || obj instanceof $2bdf55c2c4f390d3$var$OurUint8Array;
}

var $fMCbt = parcelRequire("fMCbt");
$2bdf55c2c4f390d3$var$util.inherits($2bdf55c2c4f390d3$var$Writable, $jfAlf);
function $2bdf55c2c4f390d3$var$nop() {}

function $2bdf55c2c4f390d3$var$WritableState(options, stream) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $2bdf55c2c4f390d3$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $2bdf55c2c4f390d3$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(this);
}
$2bdf55c2c4f390d3$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($2bdf55c2c4f390d3$var$WritableState.prototype, "buffer", {
            get: $2bdf55c2c4f390d3$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $2bdf55c2c4f390d3$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $2bdf55c2c4f390d3$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($2bdf55c2c4f390d3$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($2bdf55c2c4f390d3$var$realHasInstance.call(this, object)) return true;
            if (this !== $2bdf55c2c4f390d3$var$Writable) return false;
            return object && object._writableState instanceof $2bdf55c2c4f390d3$var$WritableState;
        }
    });
} else $2bdf55c2c4f390d3$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $2bdf55c2c4f390d3$var$Writable(options) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$2bdf55c2c4f390d3$var$realHasInstance.call($2bdf55c2c4f390d3$var$Writable, this) && !(this instanceof $2bdf55c2c4f390d3$var$Duplex)) return new $2bdf55c2c4f390d3$var$Writable(options);
    this._writableState = new $2bdf55c2c4f390d3$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $jfAlf.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$2bdf55c2c4f390d3$var$Writable.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
};
function $2bdf55c2c4f390d3$var$writeAfterEnd(stream, cb) {
    var er = new Error("write after end");
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit("error", er);
    $bUlqC.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $2bdf55c2c4f390d3$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError("May not write null values to stream");
    else if (typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    if (er) {
        stream.emit("error", er);
        $bUlqC.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$2bdf55c2c4f390d3$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $2bdf55c2c4f390d3$var$_isUint8Array(chunk);
    if (isBuf && !$2bdf55c2c4f390d3$require$Buffer.isBuffer(chunk)) chunk = $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $2bdf55c2c4f390d3$var$nop;
    if (state.ended) $2bdf55c2c4f390d3$var$writeAfterEnd(this, cb);
    else if (isBuf || $2bdf55c2c4f390d3$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $2bdf55c2c4f390d3$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$2bdf55c2c4f390d3$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$2bdf55c2c4f390d3$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(this, state);
    }
};
$2bdf55c2c4f390d3$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $2bdf55c2c4f390d3$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2bdf55c2c4f390d3$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $2bdf55c2c4f390d3$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $bUlqC.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $bUlqC.nextTick($2bdf55c2c4f390d3$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit("error", er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit("error", er);
        // this can emit finish, but finish must
        // always follow error
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    }
}
function $2bdf55c2c4f390d3$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $2bdf55c2c4f390d3$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $2bdf55c2c4f390d3$var$onwriteStateUpdate(state);
    if (er) $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $2bdf55c2c4f390d3$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $2bdf55c2c4f390d3$var$asyncWrite($2bdf55c2c4f390d3$var$afterWrite, stream, state, finished, cb);
        else $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb);
    }
}
function $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $2bdf55c2c4f390d3$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $2bdf55c2c4f390d3$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $2bdf55c2c4f390d3$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $2bdf55c2c4f390d3$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$2bdf55c2c4f390d3$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error("_write() is not implemented"));
};
$2bdf55c2c4f390d3$var$Writable.prototype._writev = null;
$2bdf55c2c4f390d3$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $2bdf55c2c4f390d3$var$endWritable(this, state, cb);
};
function $2bdf55c2c4f390d3$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $2bdf55c2c4f390d3$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit("error", err);
        state.prefinished = true;
        stream.emit("prefinish");
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    });
}
function $2bdf55c2c4f390d3$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function") {
            state.pendingcb++;
            state.finalCalled = true;
            $bUlqC.nextTick($2bdf55c2c4f390d3$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $2bdf55c2c4f390d3$var$finishMaybe(stream, state) {
    var need = $2bdf55c2c4f390d3$var$needFinish(state);
    if (need) {
        $2bdf55c2c4f390d3$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
        }
    }
    return need;
}
function $2bdf55c2c4f390d3$var$endWritable(stream, state, cb) {
    state.ending = true;
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $bUlqC.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $2bdf55c2c4f390d3$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "destroyed", {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$2bdf55c2c4f390d3$var$Writable.prototype.destroy = $fMCbt.destroy;
$2bdf55c2c4f390d3$var$Writable.prototype._undestroy = $fMCbt.undestroy;
$2bdf55c2c4f390d3$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("imDDS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $d5e9082788fdd47b$export$63a7aa211a91ed69, (v) => $d5e9082788fdd47b$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $d5e9082788fdd47b$export$63a7aa211a91ed69;
"use strict";

var $h3oXE = parcelRequire("h3oXE");
var $d5e9082788fdd47b$require$Buffer = $h3oXE.Buffer;
/*</replacement>*/ var $d5e9082788fdd47b$var$isEncoding = $d5e9082788fdd47b$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $d5e9082788fdd47b$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $d5e9082788fdd47b$var$normalizeEncoding(enc) {
    var nenc = $d5e9082788fdd47b$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($d5e9082788fdd47b$require$Buffer.isEncoding === $d5e9082788fdd47b$var$isEncoding || !$d5e9082788fdd47b$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$d5e9082788fdd47b$export$63a7aa211a91ed69 = $d5e9082788fdd47b$var$StringDecoder;
function $d5e9082788fdd47b$var$StringDecoder(encoding) {
    this.encoding = $d5e9082788fdd47b$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $d5e9082788fdd47b$var$utf16Text;
            this.end = $d5e9082788fdd47b$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $d5e9082788fdd47b$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $d5e9082788fdd47b$var$base64Text;
            this.end = $d5e9082788fdd47b$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $d5e9082788fdd47b$var$simpleWrite;
            this.end = $d5e9082788fdd47b$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $d5e9082788fdd47b$require$Buffer.allocUnsafe(nb);
}
$d5e9082788fdd47b$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$d5e9082788fdd47b$var$StringDecoder.prototype.end = $d5e9082788fdd47b$var$utf8End;
// Returns only complete characters in a Buffer
$d5e9082788fdd47b$var$StringDecoder.prototype.text = $d5e9082788fdd47b$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$d5e9082788fdd47b$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $d5e9082788fdd47b$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $d5e9082788fdd47b$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $d5e9082788fdd47b$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d5e9082788fdd47b$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d5e9082788fdd47b$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $d5e9082788fdd47b$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $d5e9082788fdd47b$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $d5e9082788fdd47b$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $d5e9082788fdd47b$var$utf8Text(buf, i) {
    var total = $d5e9082788fdd47b$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $d5e9082788fdd47b$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $d5e9082788fdd47b$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $d5e9082788fdd47b$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $d5e9082788fdd47b$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $d5e9082788fdd47b$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $d5e9082788fdd47b$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $d5e9082788fdd47b$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});


parcelRegister("b7kl8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $8180203f7f0d3074$var$Transform;

var $DwJuQ = parcelRequire("DwJuQ");

/*<replacement>*/ var $8180203f7f0d3074$var$util = Object.create((parcelRequire("dH2Jp")));

$8180203f7f0d3074$var$util.inherits = (parcelRequire("dlqwk"));
/*</replacement>*/ $8180203f7f0d3074$var$util.inherits($8180203f7f0d3074$var$Transform, $DwJuQ);
function $8180203f7f0d3074$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit("error", new Error("write callback called multiple times"));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $8180203f7f0d3074$var$Transform(options) {
    if (!(this instanceof $8180203f7f0d3074$var$Transform)) return new $8180203f7f0d3074$var$Transform(options);
    $DwJuQ.call(this, options);
    this._transformState = {
        afterTransform: $8180203f7f0d3074$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $8180203f7f0d3074$var$prefinish);
}
function $8180203f7f0d3074$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function") this._flush(function(er, data) {
        $8180203f7f0d3074$var$done(_this, er, data);
    });
    else $8180203f7f0d3074$var$done(this, null, null);
}
$8180203f7f0d3074$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $DwJuQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$8180203f7f0d3074$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error("_transform() is not implemented");
};
$8180203f7f0d3074$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$8180203f7f0d3074$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$8180203f7f0d3074$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $DwJuQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit("close");
    });
};
function $8180203f7f0d3074$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error("Calling transform done when ws.length != 0");
    if (stream._transformState.transforming) throw new Error("Calling transform done when still transforming");
    return stream.push(null);
}

});

parcelRegister("4wWcs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $34c74be520d619f2$var$PassThrough;

var $b7kl8 = parcelRequire("b7kl8");

/*<replacement>*/ var $34c74be520d619f2$var$util = Object.create((parcelRequire("dH2Jp")));

$34c74be520d619f2$var$util.inherits = (parcelRequire("dlqwk"));
/*</replacement>*/ $34c74be520d619f2$var$util.inherits($34c74be520d619f2$var$PassThrough, $b7kl8);
function $34c74be520d619f2$var$PassThrough(options) {
    if (!(this instanceof $34c74be520d619f2$var$PassThrough)) return new $34c74be520d619f2$var$PassThrough(options);
    $b7kl8.call(this, options);
}
$34c74be520d619f2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});


parcelRegister("dEXSZ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("fuV4H", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.5","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRegister("gEVtY", function(module, exports) {
"use strict";
var $c20cf89948514165$var$utils = module.exports;

var $jX0xT = parcelRequire("jX0xT");

var $koC21 = parcelRequire("koC21");

var $lC4vN = parcelRequire("lC4vN");
$c20cf89948514165$var$utils.assert = $koC21;
$c20cf89948514165$var$utils.toArray = $lC4vN.toArray;
$c20cf89948514165$var$utils.zero2 = $lC4vN.zero2;
$c20cf89948514165$var$utils.toHex = $lC4vN.toHex;
$c20cf89948514165$var$utils.encode = $lC4vN.encode;
// Represent num in a w-NAF form
function $c20cf89948514165$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$c20cf89948514165$var$utils.getNAF = $c20cf89948514165$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $c20cf89948514165$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$c20cf89948514165$var$utils.getJSF = $c20cf89948514165$var$getJSF;
function $c20cf89948514165$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$c20cf89948514165$var$utils.cachedProperty = $c20cf89948514165$var$cachedProperty;
function $c20cf89948514165$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $c20cf89948514165$var$utils.toArray(bytes, "hex") : bytes;
}
$c20cf89948514165$var$utils.parseBytes = $c20cf89948514165$var$parseBytes;
function $c20cf89948514165$var$intFromLE(bytes) {
    return new $jX0xT(bytes, "hex", "le");
}
$c20cf89948514165$var$utils.intFromLE = $c20cf89948514165$var$intFromLE;

});
parcelRegister("jX0xT", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("lC4vN", function(module, exports) {
"use strict";
var $fbc0a58a3f4350d8$var$utils = module.exports;
function $fbc0a58a3f4350d8$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$fbc0a58a3f4350d8$var$utils.toArray = $fbc0a58a3f4350d8$var$toArray;
function $fbc0a58a3f4350d8$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$fbc0a58a3f4350d8$var$utils.zero2 = $fbc0a58a3f4350d8$var$zero2;
function $fbc0a58a3f4350d8$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $fbc0a58a3f4350d8$var$zero2(msg[i].toString(16));
    return res;
}
$fbc0a58a3f4350d8$var$utils.toHex = $fbc0a58a3f4350d8$var$toHex;
$fbc0a58a3f4350d8$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $fbc0a58a3f4350d8$var$toHex(arr);
    else return arr;
};

});


parcelRegister("cP1GP", function(module, exports) {
"use strict";
var $955b8f041d2341cf$var$curve = module.exports;

$955b8f041d2341cf$var$curve.base = (parcelRequire("hSu7V"));

$955b8f041d2341cf$var$curve.short = (parcelRequire("eYNyQ"));

$955b8f041d2341cf$var$curve.mont = (parcelRequire("av2Yx"));

$955b8f041d2341cf$var$curve.edwards = (parcelRequire("dqmX9"));

});
parcelRegister("hSu7V", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d03ed95a59c9b218$var$getNAF = $gEVtY.getNAF;
var $d03ed95a59c9b218$var$getJSF = $gEVtY.getJSF;
var $d03ed95a59c9b218$var$assert = $gEVtY.assert;
function $d03ed95a59c9b218$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $jX0xT(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $jX0xT.red(conf.prime) : $jX0xT.mont(this.p);
    // Useful for many curves
    this.zero = new $jX0xT(0).toRed(this.red);
    this.one = new $jX0xT(1).toRed(this.red);
    this.two = new $jX0xT(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $jX0xT(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $d03ed95a59c9b218$var$BaseCurve;
$d03ed95a59c9b218$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $d03ed95a59c9b218$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $d03ed95a59c9b218$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $d03ed95a59c9b218$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $d03ed95a59c9b218$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $d03ed95a59c9b218$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $d03ed95a59c9b218$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $d03ed95a59c9b218$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $d03ed95a59c9b218$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$d03ed95a59c9b218$var$BaseCurve.BasePoint = $d03ed95a59c9b218$var$BasePoint;
$d03ed95a59c9b218$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$d03ed95a59c9b218$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $gEVtY.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$d03ed95a59c9b218$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$d03ed95a59c9b218$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$d03ed95a59c9b218$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $gEVtY.encode(this._encode(compact), enc);
};
$d03ed95a59c9b218$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$d03ed95a59c9b218$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$d03ed95a59c9b218$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$d03ed95a59c9b218$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("eYNyQ", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $ae7d1d0c45b43ec6$var$assert = $gEVtY.assert;
function $ae7d1d0c45b43ec6$var$ShortCurve(conf) {
    $hSu7V.call(this, "short", conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$dlqwk($ae7d1d0c45b43ec6$var$ShortCurve, $hSu7V);
module.exports = $ae7d1d0c45b43ec6$var$ShortCurve;
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $jX0xT(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $jX0xT(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $ae7d1d0c45b43ec6$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $jX0xT(vec.a, 16),
            b: new $jX0xT(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $jX0xT.mont(num);
    var tinv = new $jX0xT(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $jX0xT(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $jX0xT(1);
    var y1 = new $jX0xT(0);
    var x2 = new $jX0xT(0);
    var y2 = new $jX0xT(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $ae7d1d0c45b43ec6$var$Point(curve, x, y, isRed) {
    $hSu7V.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$dlqwk($ae7d1d0c45b43ec6$var$Point, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $ae7d1d0c45b43ec6$var$Point(this, x, y, isRed);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $ae7d1d0c45b43ec6$var$Point.fromJSON(this, obj, red);
};
$ae7d1d0c45b43ec6$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$ae7d1d0c45b43ec6$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$ae7d1d0c45b43ec6$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$ae7d1d0c45b43ec6$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.mul = function mul(k) {
    k = new $jX0xT(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$ae7d1d0c45b43ec6$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$ae7d1d0c45b43ec6$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$ae7d1d0c45b43ec6$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $ae7d1d0c45b43ec6$var$JPoint(curve, x, y, z) {
    $hSu7V.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $jX0xT(0);
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = new $jX0xT(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$dlqwk($ae7d1d0c45b43ec6$var$JPoint, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $ae7d1d0c45b43ec6$var$JPoint(this, x, y, z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $jX0xT(k, kbase);
    return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("av2Yx", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");

var $gEVtY = parcelRequire("gEVtY");
function $7a4f1b7c0dc1f992$var$MontCurve(conf) {
    $hSu7V.call(this, "mont", conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.i4 = new $jX0xT(4).toRed(this.red).redInvm();
    this.two = new $jX0xT(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$dlqwk($7a4f1b7c0dc1f992$var$MontCurve, $hSu7V);
module.exports = $7a4f1b7c0dc1f992$var$MontCurve;
$7a4f1b7c0dc1f992$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $7a4f1b7c0dc1f992$var$Point(curve, x, z) {
    $hSu7V.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $jX0xT(x, 16);
        this.z = new $jX0xT(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$dlqwk($7a4f1b7c0dc1f992$var$Point, $hSu7V.BasePoint);
$7a4f1b7c0dc1f992$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($gEVtY.toArray(bytes, enc), 1);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.point = function point(x, z) {
    return new $7a4f1b7c0dc1f992$var$Point(this, x, z);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $7a4f1b7c0dc1f992$var$Point.fromJSON(this, obj);
};
$7a4f1b7c0dc1f992$var$Point.prototype.precompute = function precompute() {
// No-op
};
$7a4f1b7c0dc1f992$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$7a4f1b7c0dc1f992$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $7a4f1b7c0dc1f992$var$Point(curve, obj[0], obj[1] || curve.one);
};
$7a4f1b7c0dc1f992$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$7a4f1b7c0dc1f992$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$7a4f1b7c0dc1f992$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$7a4f1b7c0dc1f992$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("dqmX9", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $9c5f8216d530af0e$var$assert = $gEVtY.assert;
function $9c5f8216d530af0e$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $hSu7V.call(this, "edwards", conf);
    this.a = new $jX0xT(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $jX0xT(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $jX0xT(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $9c5f8216d530af0e$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$dlqwk($9c5f8216d530af0e$var$EdwardsCurve, $hSu7V);
module.exports = $9c5f8216d530af0e$var$EdwardsCurve;
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$9c5f8216d530af0e$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $jX0xT(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $9c5f8216d530af0e$var$Point(curve, x, y, z, t) {
    $hSu7V.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = z ? new $jX0xT(z, 16) : this.curve.one;
        this.t = t && new $jX0xT(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$dlqwk($9c5f8216d530af0e$var$Point, $hSu7V.BasePoint);
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $9c5f8216d530af0e$var$Point.fromJSON(this, obj);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $9c5f8216d530af0e$var$Point(this, x, y, z, t);
};
$9c5f8216d530af0e$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $9c5f8216d530af0e$var$Point(curve, obj[0], obj[1], obj[2]);
};
$9c5f8216d530af0e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$9c5f8216d530af0e$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$9c5f8216d530af0e$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$9c5f8216d530af0e$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$9c5f8216d530af0e$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$9c5f8216d530af0e$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$9c5f8216d530af0e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$9c5f8216d530af0e$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$9c5f8216d530af0e$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$9c5f8216d530af0e$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$9c5f8216d530af0e$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$9c5f8216d530af0e$var$Point.prototype.toP = $9c5f8216d530af0e$var$Point.prototype.normalize;
$9c5f8216d530af0e$var$Point.prototype.mixedAdd = $9c5f8216d530af0e$var$Point.prototype.add;

});


parcelRegister("fbTbW", function(module, exports) {
"use strict";
var $b0f2b206068f1378$var$curves = module.exports;

var $kiSKt = parcelRequire("kiSKt");

var $cP1GP = parcelRequire("cP1GP");

var $gEVtY = parcelRequire("gEVtY");
var $b0f2b206068f1378$var$assert = $gEVtY.assert;
function $b0f2b206068f1378$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $cP1GP.short(options);
    else if (options.type === "edwards") this.curve = new $cP1GP.edwards(options);
    else this.curve = new $cP1GP.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $b0f2b206068f1378$var$assert(this.g.validate(), "Invalid curve");
    $b0f2b206068f1378$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$b0f2b206068f1378$var$curves.PresetCurve = $b0f2b206068f1378$var$PresetCurve;
function $b0f2b206068f1378$var$defineCurve(name, options) {
    Object.defineProperty($b0f2b206068f1378$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $b0f2b206068f1378$var$PresetCurve(options);
            Object.defineProperty($b0f2b206068f1378$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$b0f2b206068f1378$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$b0f2b206068f1378$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$b0f2b206068f1378$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$b0f2b206068f1378$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $kiSKt.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$b0f2b206068f1378$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $kiSKt.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$b0f2b206068f1378$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$b0f2b206068f1378$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $b0f2b206068f1378$var$pre;

try {
    $b0f2b206068f1378$var$pre = (parcelRequire("lNVWe"));
} catch (e) {
    $b0f2b206068f1378$var$pre = undefined;
}
$b0f2b206068f1378$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $kiSKt.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $b0f2b206068f1378$var$pre
    ]
});

});
parcelRegister("kiSKt", function(module, exports) {
var $ec7ff5071b027891$var$hash = module.exports;

$ec7ff5071b027891$var$hash.utils = (parcelRequire("btcbI"));

$ec7ff5071b027891$var$hash.common = (parcelRequire("aAb7n"));

$ec7ff5071b027891$var$hash.sha = (parcelRequire("2wnQk"));

$ec7ff5071b027891$var$hash.ripemd = (parcelRequire("05eZB"));

$ec7ff5071b027891$var$hash.hmac = (parcelRequire("ap2lu"));
// Proxy hash functions to the main object
$ec7ff5071b027891$var$hash.sha1 = $ec7ff5071b027891$var$hash.sha.sha1;
$ec7ff5071b027891$var$hash.sha256 = $ec7ff5071b027891$var$hash.sha.sha256;
$ec7ff5071b027891$var$hash.sha224 = $ec7ff5071b027891$var$hash.sha.sha224;
$ec7ff5071b027891$var$hash.sha384 = $ec7ff5071b027891$var$hash.sha.sha384;
$ec7ff5071b027891$var$hash.sha512 = $ec7ff5071b027891$var$hash.sha.sha512;
$ec7ff5071b027891$var$hash.ripemd160 = $ec7ff5071b027891$var$hash.ripemd.ripemd160;

});
parcelRegister("btcbI", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $859bdb699f0f4e15$export$69f1b2dcda23c5f8, (v) => $859bdb699f0f4e15$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $859bdb699f0f4e15$export$45b10814cc054894, (v) => $859bdb699f0f4e15$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $859bdb699f0f4e15$export$7ea66e3774a60b67, (v) => $859bdb699f0f4e15$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $859bdb699f0f4e15$export$34a52f00f601f6f1, (v) => $859bdb699f0f4e15$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $859bdb699f0f4e15$export$812b0cbd5e8a72ab, (v) => $859bdb699f0f4e15$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $859bdb699f0f4e15$export$f24f9e11d63bb314, (v) => $859bdb699f0f4e15$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $859bdb699f0f4e15$export$b71357c7e07ca1f1, (v) => $859bdb699f0f4e15$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $859bdb699f0f4e15$export$2e58a4b541fdcbe8, (v) => $859bdb699f0f4e15$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $859bdb699f0f4e15$export$183b950bde9faab8, (v) => $859bdb699f0f4e15$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $859bdb699f0f4e15$export$4785c77169fea59e, (v) => $859bdb699f0f4e15$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $859bdb699f0f4e15$export$242a185dfcffac5b, (v) => $859bdb699f0f4e15$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $859bdb699f0f4e15$export$58c04ae0ae31877d, (v) => $859bdb699f0f4e15$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $859bdb699f0f4e15$export$d058ca695f8c6f11, (v) => $859bdb699f0f4e15$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $859bdb699f0f4e15$export$a1efd7fc3e986367, (v) => $859bdb699f0f4e15$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $859bdb699f0f4e15$export$bbfea4a2b5abaab4, (v) => $859bdb699f0f4e15$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $859bdb699f0f4e15$export$97ad4afc7de86152, (v) => $859bdb699f0f4e15$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $859bdb699f0f4e15$export$ce4673d9a79f6a4b, (v) => $859bdb699f0f4e15$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $859bdb699f0f4e15$export$786cc99fc6eedc0b, (v) => $859bdb699f0f4e15$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $859bdb699f0f4e15$export$45c59b9a1848dd0, (v) => $859bdb699f0f4e15$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $859bdb699f0f4e15$export$50d8f613e76d3034, (v) => $859bdb699f0f4e15$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $859bdb699f0f4e15$export$b8e83683c60ee162, (v) => $859bdb699f0f4e15$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $859bdb699f0f4e15$export$aeeb51790d1bcc4a, (v) => $859bdb699f0f4e15$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $859bdb699f0f4e15$export$bb7c616f719ad9c, (v) => $859bdb699f0f4e15$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $859bdb699f0f4e15$export$4d63290824f9d7df, (v) => $859bdb699f0f4e15$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $859bdb699f0f4e15$export$2f64ceb90ef28ea1, (v) => $859bdb699f0f4e15$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $859bdb699f0f4e15$export$8d2089d465f6d10d, (v) => $859bdb699f0f4e15$export$8d2089d465f6d10d = v);
var $859bdb699f0f4e15$export$69f1b2dcda23c5f8;
var $859bdb699f0f4e15$export$45b10814cc054894;
var $859bdb699f0f4e15$export$7ea66e3774a60b67;
var $859bdb699f0f4e15$export$34a52f00f601f6f1;
var $859bdb699f0f4e15$export$812b0cbd5e8a72ab;
var $859bdb699f0f4e15$export$f24f9e11d63bb314;
var $859bdb699f0f4e15$export$b71357c7e07ca1f1;
var $859bdb699f0f4e15$export$2e58a4b541fdcbe8;
var $859bdb699f0f4e15$export$183b950bde9faab8;
var $859bdb699f0f4e15$export$4785c77169fea59e;
var $859bdb699f0f4e15$export$242a185dfcffac5b;
var $859bdb699f0f4e15$export$58c04ae0ae31877d;
var $859bdb699f0f4e15$export$d058ca695f8c6f11;
var $859bdb699f0f4e15$export$a1efd7fc3e986367;
var $859bdb699f0f4e15$export$bbfea4a2b5abaab4;
var $859bdb699f0f4e15$export$97ad4afc7de86152;
var $859bdb699f0f4e15$export$ce4673d9a79f6a4b;
var $859bdb699f0f4e15$export$786cc99fc6eedc0b;
var $859bdb699f0f4e15$export$45c59b9a1848dd0;
var $859bdb699f0f4e15$export$50d8f613e76d3034;
var $859bdb699f0f4e15$export$b8e83683c60ee162;
var $859bdb699f0f4e15$export$aeeb51790d1bcc4a;
var $859bdb699f0f4e15$export$bb7c616f719ad9c;
var $859bdb699f0f4e15$export$4d63290824f9d7df;
var $859bdb699f0f4e15$export$2f64ceb90ef28ea1;
var $859bdb699f0f4e15$export$8d2089d465f6d10d;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
$859bdb699f0f4e15$export$69f1b2dcda23c5f8 = $dlqwk;
function $859bdb699f0f4e15$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $859bdb699f0f4e15$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($859bdb699f0f4e15$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$859bdb699f0f4e15$export$45b10814cc054894 = $859bdb699f0f4e15$var$toArray;
function $859bdb699f0f4e15$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $859bdb699f0f4e15$var$zero2(msg[i].toString(16));
    return res;
}
$859bdb699f0f4e15$export$7ea66e3774a60b67 = $859bdb699f0f4e15$var$toHex;
function $859bdb699f0f4e15$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$859bdb699f0f4e15$export$34a52f00f601f6f1 = $859bdb699f0f4e15$var$htonl;
function $859bdb699f0f4e15$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $859bdb699f0f4e15$var$htonl(w);
        res += $859bdb699f0f4e15$var$zero8(w.toString(16));
    }
    return res;
}
$859bdb699f0f4e15$export$812b0cbd5e8a72ab = $859bdb699f0f4e15$var$toHex32;
function $859bdb699f0f4e15$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$859bdb699f0f4e15$export$f24f9e11d63bb314 = $859bdb699f0f4e15$var$zero2;
function $859bdb699f0f4e15$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$859bdb699f0f4e15$export$b71357c7e07ca1f1 = $859bdb699f0f4e15$var$zero8;
function $859bdb699f0f4e15$var$join32(msg, start, end, endian) {
    var len = end - start;
    $koC21(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$859bdb699f0f4e15$export$2e58a4b541fdcbe8 = $859bdb699f0f4e15$var$join32;
function $859bdb699f0f4e15$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$859bdb699f0f4e15$export$183b950bde9faab8 = $859bdb699f0f4e15$var$split32;
function $859bdb699f0f4e15$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$859bdb699f0f4e15$export$4785c77169fea59e = $859bdb699f0f4e15$var$rotr32;
function $859bdb699f0f4e15$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$859bdb699f0f4e15$export$242a185dfcffac5b = $859bdb699f0f4e15$var$rotl32;
function $859bdb699f0f4e15$var$sum32(a, b) {
    return a + b >>> 0;
}
$859bdb699f0f4e15$export$58c04ae0ae31877d = $859bdb699f0f4e15$var$sum32;
function $859bdb699f0f4e15$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$859bdb699f0f4e15$export$d058ca695f8c6f11 = $859bdb699f0f4e15$var$sum32_3;
function $859bdb699f0f4e15$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$859bdb699f0f4e15$export$a1efd7fc3e986367 = $859bdb699f0f4e15$var$sum32_4;
function $859bdb699f0f4e15$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$859bdb699f0f4e15$export$bbfea4a2b5abaab4 = $859bdb699f0f4e15$var$sum32_5;
function $859bdb699f0f4e15$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$859bdb699f0f4e15$export$97ad4afc7de86152 = $859bdb699f0f4e15$var$sum64;
function $859bdb699f0f4e15$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$ce4673d9a79f6a4b = $859bdb699f0f4e15$var$sum64_hi;
function $859bdb699f0f4e15$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$786cc99fc6eedc0b = $859bdb699f0f4e15$var$sum64_lo;
function $859bdb699f0f4e15$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$45c59b9a1848dd0 = $859bdb699f0f4e15$var$sum64_4_hi;
function $859bdb699f0f4e15$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$50d8f613e76d3034 = $859bdb699f0f4e15$var$sum64_4_lo;
function $859bdb699f0f4e15$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$b8e83683c60ee162 = $859bdb699f0f4e15$var$sum64_5_hi;
function $859bdb699f0f4e15$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$aeeb51790d1bcc4a = $859bdb699f0f4e15$var$sum64_5_lo;
function $859bdb699f0f4e15$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$bb7c616f719ad9c = $859bdb699f0f4e15$var$rotr64_hi;
function $859bdb699f0f4e15$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$4d63290824f9d7df = $859bdb699f0f4e15$var$rotr64_lo;
function $859bdb699f0f4e15$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$859bdb699f0f4e15$export$2f64ceb90ef28ea1 = $859bdb699f0f4e15$var$shr64_hi;
function $859bdb699f0f4e15$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$8d2089d465f6d10d = $859bdb699f0f4e15$var$shr64_lo;

});

parcelRegister("aAb7n", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $7b45e3fb23ceb2f4$export$8687658379b577e6, (v) => $7b45e3fb23ceb2f4$export$8687658379b577e6 = v);
var $7b45e3fb23ceb2f4$export$8687658379b577e6;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $7b45e3fb23ceb2f4$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$7b45e3fb23ceb2f4$export$8687658379b577e6 = $7b45e3fb23ceb2f4$var$BlockHash;
$7b45e3fb23ceb2f4$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $btcbI.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $btcbI.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $koC21(this.pending === null);
    return this._digest(enc);
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("2wnQk", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $1d6110a725745f5a$export$5091bdda49ba90f5, (v) => $1d6110a725745f5a$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $1d6110a725745f5a$export$97b70509d4e397ea, (v) => $1d6110a725745f5a$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $1d6110a725745f5a$export$bced8d2aada2d1c9, (v) => $1d6110a725745f5a$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $1d6110a725745f5a$export$612d47d55dedde45, (v) => $1d6110a725745f5a$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $1d6110a725745f5a$export$a888d2532e6dc7bb, (v) => $1d6110a725745f5a$export$a888d2532e6dc7bb = v);
var $1d6110a725745f5a$export$5091bdda49ba90f5;
var $1d6110a725745f5a$export$97b70509d4e397ea;
var $1d6110a725745f5a$export$bced8d2aada2d1c9;
var $1d6110a725745f5a$export$612d47d55dedde45;
var $1d6110a725745f5a$export$a888d2532e6dc7bb;
"use strict";

$1d6110a725745f5a$export$5091bdda49ba90f5 = (parcelRequire("IUW6G"));

$1d6110a725745f5a$export$97b70509d4e397ea = (parcelRequire("gBE2w"));

$1d6110a725745f5a$export$bced8d2aada2d1c9 = (parcelRequire("a9EzX"));

$1d6110a725745f5a$export$612d47d55dedde45 = (parcelRequire("7j4cV"));

$1d6110a725745f5a$export$a888d2532e6dc7bb = (parcelRequire("lMBCM"));

});
parcelRegister("IUW6G", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");
var $0870468534428d45$var$rotl32 = $btcbI.rotl32;
var $0870468534428d45$var$sum32 = $btcbI.sum32;
var $0870468534428d45$var$sum32_5 = $btcbI.sum32_5;
var $0870468534428d45$var$ft_1 = $dV8oa.ft_1;
var $0870468534428d45$var$BlockHash = $aAb7n.BlockHash;
var $0870468534428d45$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $0870468534428d45$var$SHA1() {
    if (!(this instanceof $0870468534428d45$var$SHA1)) return new $0870468534428d45$var$SHA1();
    $0870468534428d45$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$btcbI.inherits($0870468534428d45$var$SHA1, $0870468534428d45$var$BlockHash);
module.exports = $0870468534428d45$var$SHA1;
$0870468534428d45$var$SHA1.blockSize = 512;
$0870468534428d45$var$SHA1.outSize = 160;
$0870468534428d45$var$SHA1.hmacStrength = 80;
$0870468534428d45$var$SHA1.padLength = 64;
$0870468534428d45$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $0870468534428d45$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $0870468534428d45$var$sum32_5($0870468534428d45$var$rotl32(a, 5), $0870468534428d45$var$ft_1(s, b, c, d), e, W[i], $0870468534428d45$var$sha1_K[s]);
        e = d;
        d = c;
        c = $0870468534428d45$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $0870468534428d45$var$sum32(this.h[0], a);
    this.h[1] = $0870468534428d45$var$sum32(this.h[1], b);
    this.h[2] = $0870468534428d45$var$sum32(this.h[2], c);
    this.h[3] = $0870468534428d45$var$sum32(this.h[3], d);
    this.h[4] = $0870468534428d45$var$sum32(this.h[4], e);
};
$0870468534428d45$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});
parcelRegister("dV8oa", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $a2271b1744b4602b$export$5a92649d7ddb9f63, (v) => $a2271b1744b4602b$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $a2271b1744b4602b$export$c6d0d020c3a6269, (v) => $a2271b1744b4602b$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $a2271b1744b4602b$export$eb90c27fca05f956, (v) => $a2271b1744b4602b$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $a2271b1744b4602b$export$14a4a98e063b1999, (v) => $a2271b1744b4602b$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $a2271b1744b4602b$export$d20cecfa1564c686, (v) => $a2271b1744b4602b$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $a2271b1744b4602b$export$44fd472a12fc6db, (v) => $a2271b1744b4602b$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $a2271b1744b4602b$export$1ed238bb6ea1dd47, (v) => $a2271b1744b4602b$export$1ed238bb6ea1dd47 = v);
var $a2271b1744b4602b$export$5a92649d7ddb9f63;
var $a2271b1744b4602b$export$c6d0d020c3a6269;
var $a2271b1744b4602b$export$eb90c27fca05f956;
var $a2271b1744b4602b$export$cc992891a14496a1;
var $a2271b1744b4602b$export$14a4a98e063b1999;
var $a2271b1744b4602b$export$d20cecfa1564c686;
var $a2271b1744b4602b$export$44fd472a12fc6db;
var $a2271b1744b4602b$export$1ed238bb6ea1dd47;
"use strict";

var $btcbI = parcelRequire("btcbI");
var $a2271b1744b4602b$var$rotr32 = $btcbI.rotr32;
function $a2271b1744b4602b$var$ft_1(s, x, y, z) {
    if (s === 0) return $a2271b1744b4602b$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $a2271b1744b4602b$var$p32(x, y, z);
    if (s === 2) return $a2271b1744b4602b$var$maj32(x, y, z);
}
$a2271b1744b4602b$export$5a92649d7ddb9f63 = $a2271b1744b4602b$var$ft_1;
function $a2271b1744b4602b$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$a2271b1744b4602b$export$c6d0d020c3a6269 = $a2271b1744b4602b$var$ch32;
function $a2271b1744b4602b$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$a2271b1744b4602b$export$eb90c27fca05f956 = $a2271b1744b4602b$var$maj32;
function $a2271b1744b4602b$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$a2271b1744b4602b$export$cc992891a14496a1 = $a2271b1744b4602b$var$p32;
function $a2271b1744b4602b$var$s0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 2) ^ $a2271b1744b4602b$var$rotr32(x, 13) ^ $a2271b1744b4602b$var$rotr32(x, 22);
}
$a2271b1744b4602b$export$14a4a98e063b1999 = $a2271b1744b4602b$var$s0_256;
function $a2271b1744b4602b$var$s1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 6) ^ $a2271b1744b4602b$var$rotr32(x, 11) ^ $a2271b1744b4602b$var$rotr32(x, 25);
}
$a2271b1744b4602b$export$d20cecfa1564c686 = $a2271b1744b4602b$var$s1_256;
function $a2271b1744b4602b$var$g0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 7) ^ $a2271b1744b4602b$var$rotr32(x, 18) ^ x >>> 3;
}
$a2271b1744b4602b$export$44fd472a12fc6db = $a2271b1744b4602b$var$g0_256;
function $a2271b1744b4602b$var$g1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 17) ^ $a2271b1744b4602b$var$rotr32(x, 19) ^ x >>> 10;
}
$a2271b1744b4602b$export$1ed238bb6ea1dd47 = $a2271b1744b4602b$var$g1_256;

});


parcelRegister("gBE2w", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $a9EzX = parcelRequire("a9EzX");
function $c16f2915997a3b04$var$SHA224() {
    if (!(this instanceof $c16f2915997a3b04$var$SHA224)) return new $c16f2915997a3b04$var$SHA224();
    $a9EzX.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$btcbI.inherits($c16f2915997a3b04$var$SHA224, $a9EzX);
module.exports = $c16f2915997a3b04$var$SHA224;
$c16f2915997a3b04$var$SHA224.blockSize = 512;
$c16f2915997a3b04$var$SHA224.outSize = 224;
$c16f2915997a3b04$var$SHA224.hmacStrength = 192;
$c16f2915997a3b04$var$SHA224.padLength = 64;
$c16f2915997a3b04$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 7), "big");
    else return $btcbI.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("a9EzX", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");

var $koC21 = parcelRequire("koC21");
var $764a38c4cb12cffe$var$sum32 = $btcbI.sum32;
var $764a38c4cb12cffe$var$sum32_4 = $btcbI.sum32_4;
var $764a38c4cb12cffe$var$sum32_5 = $btcbI.sum32_5;
var $764a38c4cb12cffe$var$ch32 = $dV8oa.ch32;
var $764a38c4cb12cffe$var$maj32 = $dV8oa.maj32;
var $764a38c4cb12cffe$var$s0_256 = $dV8oa.s0_256;
var $764a38c4cb12cffe$var$s1_256 = $dV8oa.s1_256;
var $764a38c4cb12cffe$var$g0_256 = $dV8oa.g0_256;
var $764a38c4cb12cffe$var$g1_256 = $dV8oa.g1_256;
var $764a38c4cb12cffe$var$BlockHash = $aAb7n.BlockHash;
var $764a38c4cb12cffe$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $764a38c4cb12cffe$var$SHA256() {
    if (!(this instanceof $764a38c4cb12cffe$var$SHA256)) return new $764a38c4cb12cffe$var$SHA256();
    $764a38c4cb12cffe$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $764a38c4cb12cffe$var$sha256_K;
    this.W = new Array(64);
}
$btcbI.inherits($764a38c4cb12cffe$var$SHA256, $764a38c4cb12cffe$var$BlockHash);
module.exports = $764a38c4cb12cffe$var$SHA256;
$764a38c4cb12cffe$var$SHA256.blockSize = 512;
$764a38c4cb12cffe$var$SHA256.outSize = 256;
$764a38c4cb12cffe$var$SHA256.hmacStrength = 192;
$764a38c4cb12cffe$var$SHA256.padLength = 64;
$764a38c4cb12cffe$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $764a38c4cb12cffe$var$sum32_4($764a38c4cb12cffe$var$g1_256(W[i - 2]), W[i - 7], $764a38c4cb12cffe$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $koC21(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $764a38c4cb12cffe$var$sum32_5(h, $764a38c4cb12cffe$var$s1_256(e), $764a38c4cb12cffe$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $764a38c4cb12cffe$var$sum32($764a38c4cb12cffe$var$s0_256(a), $764a38c4cb12cffe$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $764a38c4cb12cffe$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $764a38c4cb12cffe$var$sum32(T1, T2);
    }
    this.h[0] = $764a38c4cb12cffe$var$sum32(this.h[0], a);
    this.h[1] = $764a38c4cb12cffe$var$sum32(this.h[1], b);
    this.h[2] = $764a38c4cb12cffe$var$sum32(this.h[2], c);
    this.h[3] = $764a38c4cb12cffe$var$sum32(this.h[3], d);
    this.h[4] = $764a38c4cb12cffe$var$sum32(this.h[4], e);
    this.h[5] = $764a38c4cb12cffe$var$sum32(this.h[5], f);
    this.h[6] = $764a38c4cb12cffe$var$sum32(this.h[6], g);
    this.h[7] = $764a38c4cb12cffe$var$sum32(this.h[7], h);
};
$764a38c4cb12cffe$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});


parcelRegister("7j4cV", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $lMBCM = parcelRequire("lMBCM");
function $551d923eb49b8fc5$var$SHA384() {
    if (!(this instanceof $551d923eb49b8fc5$var$SHA384)) return new $551d923eb49b8fc5$var$SHA384();
    $lMBCM.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$btcbI.inherits($551d923eb49b8fc5$var$SHA384, $lMBCM);
module.exports = $551d923eb49b8fc5$var$SHA384;
$551d923eb49b8fc5$var$SHA384.blockSize = 1024;
$551d923eb49b8fc5$var$SHA384.outSize = 384;
$551d923eb49b8fc5$var$SHA384.hmacStrength = 192;
$551d923eb49b8fc5$var$SHA384.padLength = 128;
$551d923eb49b8fc5$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 12), "big");
    else return $btcbI.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("lMBCM", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $koC21 = parcelRequire("koC21");
var $fdbb441c0566fb85$var$rotr64_hi = $btcbI.rotr64_hi;
var $fdbb441c0566fb85$var$rotr64_lo = $btcbI.rotr64_lo;
var $fdbb441c0566fb85$var$shr64_hi = $btcbI.shr64_hi;
var $fdbb441c0566fb85$var$shr64_lo = $btcbI.shr64_lo;
var $fdbb441c0566fb85$var$sum64 = $btcbI.sum64;
var $fdbb441c0566fb85$var$sum64_hi = $btcbI.sum64_hi;
var $fdbb441c0566fb85$var$sum64_lo = $btcbI.sum64_lo;
var $fdbb441c0566fb85$var$sum64_4_hi = $btcbI.sum64_4_hi;
var $fdbb441c0566fb85$var$sum64_4_lo = $btcbI.sum64_4_lo;
var $fdbb441c0566fb85$var$sum64_5_hi = $btcbI.sum64_5_hi;
var $fdbb441c0566fb85$var$sum64_5_lo = $btcbI.sum64_5_lo;
var $fdbb441c0566fb85$var$BlockHash = $aAb7n.BlockHash;
var $fdbb441c0566fb85$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $fdbb441c0566fb85$var$SHA512() {
    if (!(this instanceof $fdbb441c0566fb85$var$SHA512)) return new $fdbb441c0566fb85$var$SHA512();
    $fdbb441c0566fb85$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $fdbb441c0566fb85$var$sha512_K;
    this.W = new Array(160);
}
$btcbI.inherits($fdbb441c0566fb85$var$SHA512, $fdbb441c0566fb85$var$BlockHash);
module.exports = $fdbb441c0566fb85$var$SHA512;
$fdbb441c0566fb85$var$SHA512.blockSize = 1024;
$fdbb441c0566fb85$var$SHA512.outSize = 512;
$fdbb441c0566fb85$var$SHA512.hmacStrength = 192;
$fdbb441c0566fb85$var$SHA512.padLength = 128;
$fdbb441c0566fb85$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $fdbb441c0566fb85$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $fdbb441c0566fb85$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $fdbb441c0566fb85$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $fdbb441c0566fb85$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $fdbb441c0566fb85$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $fdbb441c0566fb85$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$fdbb441c0566fb85$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $koC21(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $fdbb441c0566fb85$var$s1_512_hi(eh, el);
        var c1_lo = $fdbb441c0566fb85$var$s1_512_lo(eh, el);
        var c2_hi = $fdbb441c0566fb85$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $fdbb441c0566fb85$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $fdbb441c0566fb85$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $fdbb441c0566fb85$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $fdbb441c0566fb85$var$s0_512_hi(ah, al);
        c0_lo = $fdbb441c0566fb85$var$s0_512_lo(ah, al);
        c1_hi = $fdbb441c0566fb85$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $fdbb441c0566fb85$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $fdbb441c0566fb85$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $fdbb441c0566fb85$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $fdbb441c0566fb85$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $fdbb441c0566fb85$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $fdbb441c0566fb85$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $fdbb441c0566fb85$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $fdbb441c0566fb85$var$sum64(this.h, 0, ah, al);
    $fdbb441c0566fb85$var$sum64(this.h, 2, bh, bl);
    $fdbb441c0566fb85$var$sum64(this.h, 4, ch, cl);
    $fdbb441c0566fb85$var$sum64(this.h, 6, dh, dl);
    $fdbb441c0566fb85$var$sum64(this.h, 8, eh, el);
    $fdbb441c0566fb85$var$sum64(this.h, 10, fh, fl);
    $fdbb441c0566fb85$var$sum64(this.h, 12, gh, gl);
    $fdbb441c0566fb85$var$sum64(this.h, 14, hh, hl);
};
$fdbb441c0566fb85$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};
function $fdbb441c0566fb85$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("05eZB", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e, (v) => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e = v);
var $00fc18f316764a3b$export$d1cea0ee4e3f0d3e;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");
var $00fc18f316764a3b$var$rotl32 = $btcbI.rotl32;
var $00fc18f316764a3b$var$sum32 = $btcbI.sum32;
var $00fc18f316764a3b$var$sum32_3 = $btcbI.sum32_3;
var $00fc18f316764a3b$var$sum32_4 = $btcbI.sum32_4;
var $00fc18f316764a3b$var$BlockHash = $aAb7n.BlockHash;
function $00fc18f316764a3b$var$RIPEMD160() {
    if (!(this instanceof $00fc18f316764a3b$var$RIPEMD160)) return new $00fc18f316764a3b$var$RIPEMD160();
    $00fc18f316764a3b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$btcbI.inherits($00fc18f316764a3b$var$RIPEMD160, $00fc18f316764a3b$var$BlockHash);
$00fc18f316764a3b$export$d1cea0ee4e3f0d3e = $00fc18f316764a3b$var$RIPEMD160;
$00fc18f316764a3b$var$RIPEMD160.blockSize = 512;
$00fc18f316764a3b$var$RIPEMD160.outSize = 160;
$00fc18f316764a3b$var$RIPEMD160.hmacStrength = 192;
$00fc18f316764a3b$var$RIPEMD160.padLength = 64;
$00fc18f316764a3b$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(A, $00fc18f316764a3b$var$f(j, B, C, D), msg[$00fc18f316764a3b$var$r[j] + start], $00fc18f316764a3b$var$K(j)), $00fc18f316764a3b$var$s[j]), E);
        A = E;
        E = D;
        D = $00fc18f316764a3b$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(Ah, $00fc18f316764a3b$var$f(79 - j, Bh, Ch, Dh), msg[$00fc18f316764a3b$var$rh[j] + start], $00fc18f316764a3b$var$Kh(j)), $00fc18f316764a3b$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $00fc18f316764a3b$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $00fc18f316764a3b$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $00fc18f316764a3b$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $00fc18f316764a3b$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $00fc18f316764a3b$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $00fc18f316764a3b$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$00fc18f316764a3b$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "little");
    else return $btcbI.split32(this.h, "little");
};
function $00fc18f316764a3b$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $00fc18f316764a3b$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $00fc18f316764a3b$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $00fc18f316764a3b$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $00fc18f316764a3b$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $00fc18f316764a3b$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $00fc18f316764a3b$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("ap2lu", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $792e0ef6fa035d02$var$Hmac(hash, key, enc) {
    if (!(this instanceof $792e0ef6fa035d02$var$Hmac)) return new $792e0ef6fa035d02$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($btcbI.toArray(key, enc));
}
module.exports = $792e0ef6fa035d02$var$Hmac;
$792e0ef6fa035d02$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $koC21(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$792e0ef6fa035d02$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$792e0ef6fa035d02$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("lNVWe", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRegister("220Zx", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $kKonu = parcelRequire("kKonu");

var $gEVtY = parcelRequire("gEVtY");

var $fbTbW = parcelRequire("fbTbW");

var $7JHF0 = parcelRequire("7JHF0");
var $17ac898fe5b06379$var$assert = $gEVtY.assert;

var $lPqzs = parcelRequire("lPqzs");

var $i46nc = parcelRequire("i46nc");
function $17ac898fe5b06379$var$EC(options) {
    if (!(this instanceof $17ac898fe5b06379$var$EC)) return new $17ac898fe5b06379$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $17ac898fe5b06379$var$assert(Object.prototype.hasOwnProperty.call($fbTbW, options), "Unknown curve " + options);
        options = $fbTbW[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $fbTbW.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $17ac898fe5b06379$var$EC;
$17ac898fe5b06379$var$EC.prototype.keyPair = function keyPair(options) {
    return new $lPqzs(this, options);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $lPqzs.fromPrivate(this, priv, enc);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $lPqzs.fromPublic(this, pub, enc);
};
$17ac898fe5b06379$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $7JHF0(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $jX0xT(2));
    for(;;){
        var priv = new $jX0xT(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$17ac898fe5b06379$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$17ac898fe5b06379$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $jX0xT(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $jX0xT(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $jX0xT(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $i46nc({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$17ac898fe5b06379$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $jX0xT(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $i46nc(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$17ac898fe5b06379$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $17ac898fe5b06379$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $i46nc(signature, enc);
    var n = this.n;
    var e = new $jX0xT(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$17ac898fe5b06379$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $i46nc(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRegister("kKonu", function(module, exports) {
"use strict";

var $kiSKt = parcelRequire("kiSKt");

var $lC4vN = parcelRequire("lC4vN");

var $koC21 = parcelRequire("koC21");
function $f1ab03780ebd0ab4$var$HmacDRBG(options) {
    if (!(this instanceof $f1ab03780ebd0ab4$var$HmacDRBG)) return new $f1ab03780ebd0ab4$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $lC4vN.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $lC4vN.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $lC4vN.toArray(options.pers, options.persEnc || "hex");
    $koC21(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $f1ab03780ebd0ab4$var$HmacDRBG;
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $kiSKt.hmac(this.hash, this.K);
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $lC4vN.toArray(entropy, entropyEnc);
    add = $lC4vN.toArray(add, addEnc);
    $koC21(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $lC4vN.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $lC4vN.encode(res, enc);
};

});

parcelRegister("lPqzs", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $fe42f8d68750188b$var$assert = $gEVtY.assert;
function $fe42f8d68750188b$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $fe42f8d68750188b$var$KeyPair;
$fe42f8d68750188b$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $fe42f8d68750188b$var$KeyPair) return pub;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $fe42f8d68750188b$var$KeyPair) return priv;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$fe42f8d68750188b$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$fe42f8d68750188b$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$fe42f8d68750188b$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $jX0xT(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$fe42f8d68750188b$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $fe42f8d68750188b$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $fe42f8d68750188b$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$fe42f8d68750188b$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $fe42f8d68750188b$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$fe42f8d68750188b$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$fe42f8d68750188b$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$fe42f8d68750188b$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRegister("i46nc", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d26d8b510bde7292$var$assert = $gEVtY.assert;
function $d26d8b510bde7292$var$Signature(options, enc) {
    if (options instanceof $d26d8b510bde7292$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $d26d8b510bde7292$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $jX0xT(options.r, 16);
    this.s = new $jX0xT(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $d26d8b510bde7292$var$Signature;
function $d26d8b510bde7292$var$Position() {
    this.place = 0;
}
function $d26d8b510bde7292$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $d26d8b510bde7292$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$d26d8b510bde7292$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $gEVtY.toArray(data, enc);
    var p = new $d26d8b510bde7292$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $d26d8b510bde7292$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $d26d8b510bde7292$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $d26d8b510bde7292$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $jX0xT(r);
    this.s = new $jX0xT(s);
    this.recoveryParam = null;
    return true;
};
function $d26d8b510bde7292$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$d26d8b510bde7292$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $d26d8b510bde7292$var$rmPadding(r);
    s = $d26d8b510bde7292$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $d26d8b510bde7292$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $d26d8b510bde7292$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $d26d8b510bde7292$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $gEVtY.encode(res, enc);
};

});


parcelRegister("esmmS", function(module, exports) {
"use strict";

var $kiSKt = parcelRequire("kiSKt");

var $fbTbW = parcelRequire("fbTbW");

var $gEVtY = parcelRequire("gEVtY");
var $a865080dcef76248$var$assert = $gEVtY.assert;
var $a865080dcef76248$var$parseBytes = $gEVtY.parseBytes;

var $1D85n = parcelRequire("1D85n");

var $7XcGE = parcelRequire("7XcGE");
function $a865080dcef76248$var$EDDSA(curve) {
    $a865080dcef76248$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $a865080dcef76248$var$EDDSA)) return new $a865080dcef76248$var$EDDSA(curve);
    curve = $fbTbW[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $kiSKt.sha512;
}
module.exports = $a865080dcef76248$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $a865080dcef76248$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $a865080dcef76248$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $a865080dcef76248$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $a865080dcef76248$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$a865080dcef76248$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $gEVtY.intFromLE(hash.digest()).umod(this.curve.n);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $1D85n.fromPublic(this, pub);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $1D85n.fromSecret(this, secret);
};
$a865080dcef76248$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $7XcGE) return sig;
    return new $7XcGE(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $a865080dcef76248$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$a865080dcef76248$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $gEVtY.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $gEVtY.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$a865080dcef76248$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$a865080dcef76248$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $gEVtY.intFromLE(bytes);
};
$a865080dcef76248$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("1D85n", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");
var $12ffb49ca423a34b$var$assert = $gEVtY.assert;
var $12ffb49ca423a34b$var$parseBytes = $gEVtY.parseBytes;
var $12ffb49ca423a34b$var$cachedProperty = $gEVtY.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $12ffb49ca423a34b$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $12ffb49ca423a34b$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $12ffb49ca423a34b$var$parseBytes(params.pub);
}
$12ffb49ca423a34b$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $12ffb49ca423a34b$var$KeyPair) return pub;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        pub: pub
    });
};
$12ffb49ca423a34b$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $12ffb49ca423a34b$var$KeyPair) return secret;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        secret: secret
    });
};
$12ffb49ca423a34b$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$12ffb49ca423a34b$var$KeyPair.prototype.sign = function sign(message) {
    $12ffb49ca423a34b$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $12ffb49ca423a34b$var$assert(this._secret, "KeyPair is public only");
    return $gEVtY.encode(this.secret(), enc);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $gEVtY.encode(this.pubBytes(), enc);
};
module.exports = $12ffb49ca423a34b$var$KeyPair;

});

parcelRegister("7XcGE", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $5ca7e26f93e1a560$var$assert = $gEVtY.assert;
var $5ca7e26f93e1a560$var$cachedProperty = $gEVtY.cachedProperty;
var $5ca7e26f93e1a560$var$parseBytes = $gEVtY.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $5ca7e26f93e1a560$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $5ca7e26f93e1a560$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $5ca7e26f93e1a560$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $jX0xT) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$5ca7e26f93e1a560$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$5ca7e26f93e1a560$var$Signature.prototype.toHex = function toHex() {
    return $gEVtY.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $5ca7e26f93e1a560$var$Signature;

});


parcelRegister("9qVGS", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("8fBln", function(module, exports) {

var $10gXo = parcelRequire("10gXo");

var $dlqwk = parcelRequire("dlqwk");
var $601cb1289d0f28d5$var$api = module.exports;
$601cb1289d0f28d5$var$api.define = function define(name, body) {
    return new $601cb1289d0f28d5$var$Entity(name, body);
};
function $601cb1289d0f28d5$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$601cb1289d0f28d5$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("aeJDW")).runInThisContext("(function " + this.name + "(entity) {\n" + "  this._initNamed(entity);\n" + "})");
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $dlqwk(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$601cb1289d0f28d5$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($10gXo.decoders[enc]);
    return this.decoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$601cb1289d0f28d5$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($10gXo.encoders[enc]);
    return this.encoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("10gXo", function(module, exports) {
var $0bb2f1d33a97833b$var$asn1 = module.exports;

$0bb2f1d33a97833b$var$asn1.bignum = (parcelRequire("9qVGS"));

$0bb2f1d33a97833b$var$asn1.define = (parcelRequire("8fBln")).define;

$0bb2f1d33a97833b$var$asn1.base = (parcelRequire("5JhaY"));

$0bb2f1d33a97833b$var$asn1.constants = (parcelRequire("3TcQc"));

$0bb2f1d33a97833b$var$asn1.decoders = (parcelRequire("89TTw"));

$0bb2f1d33a97833b$var$asn1.encoders = (parcelRequire("ljw8S"));

});
parcelRegister("5JhaY", function(module, exports) {
var $42be7a86790be210$var$base = module.exports;

$42be7a86790be210$var$base.Reporter = (parcelRequire("k2jVB")).Reporter;

$42be7a86790be210$var$base.DecoderBuffer = (parcelRequire("33sbF")).DecoderBuffer;

$42be7a86790be210$var$base.EncoderBuffer = (parcelRequire("33sbF")).EncoderBuffer;

$42be7a86790be210$var$base.Node = (parcelRequire("h4y6g"));

});
parcelRegister("k2jVB", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $e96373d85f7a5083$export$957313a2f485e5ed, (v) => $e96373d85f7a5083$export$957313a2f485e5ed = v);
var $e96373d85f7a5083$export$957313a2f485e5ed;

var $dlqwk = parcelRequire("dlqwk");
function $e96373d85f7a5083$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$e96373d85f7a5083$export$957313a2f485e5ed = $e96373d85f7a5083$var$Reporter;
$e96373d85f7a5083$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $e96373d85f7a5083$var$ReporterError;
};
$e96373d85f7a5083$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$e96373d85f7a5083$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$e96373d85f7a5083$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$e96373d85f7a5083$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$e96373d85f7a5083$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$e96373d85f7a5083$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
$e96373d85f7a5083$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$e96373d85f7a5083$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$e96373d85f7a5083$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $e96373d85f7a5083$var$ReporterError;
    if (inherited) err = msg;
    else err = new $e96373d85f7a5083$var$ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$e96373d85f7a5083$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $e96373d85f7a5083$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$dlqwk($e96373d85f7a5083$var$ReporterError, Error);
$e96373d85f7a5083$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, $e96373d85f7a5083$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("33sbF", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $2397844df508f52e$export$bf9f79cdc4a49163, (v) => $2397844df508f52e$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $2397844df508f52e$export$8ff24f7760c7a78e, (v) => $2397844df508f52e$export$8ff24f7760c7a78e = v);
var $2397844df508f52e$export$bf9f79cdc4a49163;
var $2397844df508f52e$export$8ff24f7760c7a78e;

var $dlqwk = parcelRequire("dlqwk");

var $5JhaY = parcelRequire("5JhaY");
var $2397844df508f52e$require$Reporter = $5JhaY.Reporter;

var $6ZWSX = parcelRequire("6ZWSX");
var $2397844df508f52e$require$Buffer = $6ZWSX.Buffer;
function $2397844df508f52e$var$DecoderBuffer(base, options) {
    $2397844df508f52e$require$Reporter.call(this, options);
    if (!$2397844df508f52e$require$Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$dlqwk($2397844df508f52e$var$DecoderBuffer, $2397844df508f52e$require$Reporter);
$2397844df508f52e$export$bf9f79cdc4a49163 = $2397844df508f52e$var$DecoderBuffer;
$2397844df508f52e$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $2397844df508f52e$require$Reporter.prototype.save.call(this)
    };
};
$2397844df508f52e$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $2397844df508f52e$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$2397844df508f52e$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
$2397844df508f52e$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    var res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $2397844df508f52e$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $2397844df508f52e$var$EncoderBuffer)) item = new $2397844df508f52e$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = $2397844df508f52e$require$Buffer.byteLength(value);
    } else if ($2397844df508f52e$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + typeof value);
}
$2397844df508f52e$export$8ff24f7760c7a78e = $2397844df508f52e$var$EncoderBuffer;
$2397844df508f52e$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $2397844df508f52e$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if ($2397844df508f52e$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("h4y6g", function(module, exports) {

var $5JhaY = parcelRequire("5JhaY");
var $c6dd42f3395d566f$require$Reporter = $5JhaY.Reporter;

var $5JhaY = parcelRequire("5JhaY");
var $c6dd42f3395d566f$require$EncoderBuffer = $5JhaY.EncoderBuffer;

var $5JhaY = parcelRequire("5JhaY");
var $c6dd42f3395d566f$require$DecoderBuffer = $5JhaY.DecoderBuffer;

var $koC21 = parcelRequire("koC21");
// Supported tags
var $c6dd42f3395d566f$var$tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
var $c6dd42f3395d566f$var$methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat($c6dd42f3395d566f$var$tags);
// Overrided methods list
var $c6dd42f3395d566f$var$overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function $c6dd42f3395d566f$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $c6dd42f3395d566f$var$Node;
var $c6dd42f3395d566f$var$stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
$c6dd42f3395d566f$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $c6dd42f3395d566f$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$c6dd42f3395d566f$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $c6dd42f3395d566f$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$c6dd42f3395d566f$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $koC21(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $koC21.equal(state.children.length, 1, "Root node can have only one child");
};
$c6dd42f3395d566f$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $koC21(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $koC21(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$c6dd42f3395d566f$var$overrided.forEach(function(method) {
    $c6dd42f3395d566f$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
$c6dd42f3395d566f$var$tags.forEach(function(tag) {
    $c6dd42f3395d566f$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $koC21(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$c6dd42f3395d566f$var$Node.prototype.use = function use(item) {
    $koC21(item);
    var state = this._baseState;
    $koC21(state.use === null);
    state.use = item;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $koC21(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $koC21(state.key === null);
    state.key = newKey;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $koC21(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $koC21(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$c6dd42f3395d566f$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state["default"];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            var data = new $c6dd42f3395d566f$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
$c6dd42f3395d566f$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $koC21(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$c6dd42f3395d566f$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
$c6dd42f3395d566f$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $c6dd42f3395d566f$require$EncoderBuffer(data, this.reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $c6dd42f3395d566f$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $koC21(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
$c6dd42f3395d566f$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$c6dd42f3395d566f$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("3TcQc", function(module, exports) {
var $2d507811e368678d$var$constants = module.exports;
// Helper
$2d507811e368678d$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$2d507811e368678d$var$constants.der = (parcelRequire("1G1m0"));

});
parcelRegister("1G1m0", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $138ac3909863432c$export$3584c46ed60baee8, (v) => $138ac3909863432c$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $138ac3909863432c$export$f18596ef8d632e49, (v) => $138ac3909863432c$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $138ac3909863432c$export$2b067c6666111485, (v) => $138ac3909863432c$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $138ac3909863432c$export$f17df38a421ab9e3, (v) => $138ac3909863432c$export$f17df38a421ab9e3 = v);
var $138ac3909863432c$export$3584c46ed60baee8;
var $138ac3909863432c$export$f18596ef8d632e49;
var $138ac3909863432c$export$2b067c6666111485;
var $138ac3909863432c$export$f17df38a421ab9e3;

var $3TcQc = parcelRequire("3TcQc");
$138ac3909863432c$export$3584c46ed60baee8 = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
$138ac3909863432c$export$f18596ef8d632e49 = $3TcQc._reverse($138ac3909863432c$export$3584c46ed60baee8);
$138ac3909863432c$export$2b067c6666111485 = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
$138ac3909863432c$export$f17df38a421ab9e3 = $3TcQc._reverse($138ac3909863432c$export$2b067c6666111485);

});


parcelRegister("89TTw", function(module, exports) {
var $5f0a857a78ce037a$var$decoders = module.exports;

$5f0a857a78ce037a$var$decoders.der = (parcelRequire("fkoHA"));

$5f0a857a78ce037a$var$decoders.pem = (parcelRequire("9wGrq"));

});
parcelRegister("fkoHA", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $10gXo = parcelRequire("10gXo");
var $b28be291c8d179e1$var$base = $10gXo.base;
var $b28be291c8d179e1$var$bignum = $10gXo.bignum;
// Import DER constants
var $b28be291c8d179e1$var$der = $10gXo.constants.der;
function $b28be291c8d179e1$var$DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $b28be291c8d179e1$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $b28be291c8d179e1$var$DERDecoder;
$b28be291c8d179e1$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $b28be291c8d179e1$var$base.DecoderBuffer)) data = new $b28be291c8d179e1$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $b28be291c8d179e1$var$DERNode(parent) {
    $b28be291c8d179e1$var$base.Node.call(this, "der", parent);
}
$dlqwk($b28be291c8d179e1$var$DERNode, $b28be291c8d179e1$var$base.Node);
$b28be291c8d179e1$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $b28be291c8d179e1$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$b28be291c8d179e1$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $b28be291c8d179e1$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $b28be291c8d179e1$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
$b28be291c8d179e1$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        var str = "";
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        var numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        var printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
$b28be291c8d179e1$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === "gentime") {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$b28be291c8d179e1$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $b28be291c8d179e1$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$b28be291c8d179e1$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function $b28be291c8d179e1$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $b28be291c8d179e1$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $b28be291c8d179e1$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $b28be291c8d179e1$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("9wGrq", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $6ZWSX = parcelRequire("6ZWSX");
var $6ef8062b6cdbe0f4$require$Buffer = $6ZWSX.Buffer;

var $fkoHA = parcelRequire("fkoHA");
function $6ef8062b6cdbe0f4$var$PEMDecoder(entity) {
    $fkoHA.call(this, entity);
    this.enc = "pem";
}
$dlqwk($6ef8062b6cdbe0f4$var$PEMDecoder, $fkoHA);
module.exports = $6ef8062b6cdbe0f4$var$PEMDecoder;
$6ef8062b6cdbe0f4$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    var base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, "");
    var input = new $6ef8062b6cdbe0f4$require$Buffer(base64, "base64");
    return $fkoHA.prototype.decode.call(this, input, options);
};

});


parcelRegister("ljw8S", function(module, exports) {
var $f8444e153c0591ac$var$encoders = module.exports;

$f8444e153c0591ac$var$encoders.der = (parcelRequire("2j6ve"));

$f8444e153c0591ac$var$encoders.pem = (parcelRequire("bPffB"));

});
parcelRegister("2j6ve", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $6ZWSX = parcelRequire("6ZWSX");
var $1ae2666fc718ae87$require$Buffer = $6ZWSX.Buffer;

var $10gXo = parcelRequire("10gXo");
var $1ae2666fc718ae87$var$base = $10gXo.base;
// Import DER constants
var $1ae2666fc718ae87$var$der = $10gXo.constants.der;
function $1ae2666fc718ae87$var$DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $1ae2666fc718ae87$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $1ae2666fc718ae87$var$DEREncoder;
$1ae2666fc718ae87$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $1ae2666fc718ae87$var$DERNode(parent) {
    $1ae2666fc718ae87$var$base.Node.call(this, "der", parent);
}
$dlqwk($1ae2666fc718ae87$var$DERNode, $1ae2666fc718ae87$var$base.Node);
$1ae2666fc718ae87$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $1ae2666fc718ae87$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $1ae2666fc718ae87$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        var buf = new $1ae2666fc718ae87$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $1ae2666fc718ae87$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $1ae2666fc718ae87$var$two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
$1ae2666fc718ae87$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === "gentime") str = [
        $1ae2666fc718ae87$var$two(date.getFullYear()),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        $1ae2666fc718ae87$var$two(date.getFullYear() % 100),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !$1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $1ae2666fc718ae87$require$Buffer(numArray);
    }
    if ($1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $1ae2666fc718ae87$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $1ae2666fc718ae87$require$Buffer(out));
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$1ae2666fc718ae87$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
$1ae2666fc718ae87$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state["default"] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if ($1ae2666fc718ae87$var$der.tagByName.hasOwnProperty(tag)) res = $1ae2666fc718ae87$var$der.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= $1ae2666fc718ae87$var$der.tagClassByName[cls || "universal"] << 6;
    return res;
}

});

parcelRegister("bPffB", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $2j6ve = parcelRequire("2j6ve");
function $89c04996afa84ca7$var$PEMEncoder(entity) {
    $2j6ve.call(this, entity);
    this.enc = "pem";
}
$dlqwk($89c04996afa84ca7$var$PEMEncoder, $2j6ve);
module.exports = $89c04996afa84ca7$var$PEMEncoder;
$89c04996afa84ca7$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $2j6ve.prototype.encode.call(this, data);
    var p = buf.toString("base64");
    var out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

});



parcelRegister("aeJDW", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, "_", {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    "Array",
    "Boolean",
    "Date",
    "Error",
    "EvalError",
    "Function",
    "Infinity",
    "JSON",
    "Math",
    "NaN",
    "Number",
    "Object",
    "RangeError",
    "ReferenceError",
    "RegExp",
    "String",
    "SyntaxError",
    "TypeError",
    "URIError",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "undefined",
    "unescape"
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement("iframe");
    if (!iframe.style) iframe.style = {};
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, "null");
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === "object") forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("bDaUv", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";

var $10gXo = parcelRequire("10gXo");
var $877bcccea3fc6be5$var$Time = $10gXo.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $877bcccea3fc6be5$var$AttributeTypeValue = $10gXo.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var $877bcccea3fc6be5$var$AlgorithmIdentifier = $10gXo.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var $877bcccea3fc6be5$var$SubjectPublicKeyInfo = $10gXo.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var $877bcccea3fc6be5$var$RelativeDistinguishedName = $10gXo.define("RelativeDistinguishedName", function() {
    this.setof($877bcccea3fc6be5$var$AttributeTypeValue);
});
var $877bcccea3fc6be5$var$RDNSequence = $10gXo.define("RDNSequence", function() {
    this.seqof($877bcccea3fc6be5$var$RelativeDistinguishedName);
});
var $877bcccea3fc6be5$var$Name = $10gXo.define("Name", function() {
    this.choice({
        rdnSequence: this.use($877bcccea3fc6be5$var$RDNSequence)
    });
});
var $877bcccea3fc6be5$var$Validity = $10gXo.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use($877bcccea3fc6be5$var$Time), this.key("notAfter").use($877bcccea3fc6be5$var$Time));
});
var $877bcccea3fc6be5$var$Extension = $10gXo.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var $877bcccea3fc6be5$var$TBSCertificate = $10gXo.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0)["int"]().optional(), this.key("serialNumber")["int"](), this.key("signature").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("issuer").use($877bcccea3fc6be5$var$Name), this.key("validity").use($877bcccea3fc6be5$var$Validity), this.key("subject").use($877bcccea3fc6be5$var$Name), this.key("subjectPublicKeyInfo").use($877bcccea3fc6be5$var$SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof($877bcccea3fc6be5$var$Extension).optional());
});
var $877bcccea3fc6be5$var$X509Certificate = $10gXo.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use($877bcccea3fc6be5$var$TBSCertificate), this.key("signatureAlgorithm").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = $877bcccea3fc6be5$var$X509Certificate;

});

parcelRegister("fd3gh", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b12a999e54d2bf45$require$Buffer = $6ZWSX.Buffer;

var $1zUcV = parcelRequire("1zUcV");

var $jqmf0 = parcelRequire("jqmf0");
module.exports = function createECDH(curve) {
    return new $b12a999e54d2bf45$var$ECDH(curve);
};
var $b12a999e54d2bf45$var$aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
$b12a999e54d2bf45$var$aliases.p224 = $b12a999e54d2bf45$var$aliases.secp224r1;
$b12a999e54d2bf45$var$aliases.p256 = $b12a999e54d2bf45$var$aliases.secp256r1 = $b12a999e54d2bf45$var$aliases.prime256v1;
$b12a999e54d2bf45$var$aliases.p192 = $b12a999e54d2bf45$var$aliases.secp192r1 = $b12a999e54d2bf45$var$aliases.prime192v1;
$b12a999e54d2bf45$var$aliases.p384 = $b12a999e54d2bf45$var$aliases.secp384r1;
$b12a999e54d2bf45$var$aliases.p521 = $b12a999e54d2bf45$var$aliases.secp521r1;
function $b12a999e54d2bf45$var$ECDH(curve) {
    this.curveType = $b12a999e54d2bf45$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $1zUcV.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$b12a999e54d2bf45$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$b12a999e54d2bf45$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(other)) other = new $b12a999e54d2bf45$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $b12a999e54d2bf45$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $b12a999e54d2bf45$var$formatReturnValue(key, enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $b12a999e54d2bf45$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(pub)) pub = new $b12a999e54d2bf45$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$b12a999e54d2bf45$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(priv)) priv = new $b12a999e54d2bf45$require$Buffer(priv, enc);
    var _priv = new $jqmf0(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $b12a999e54d2bf45$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $b12a999e54d2bf45$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $b12a999e54d2bf45$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $b12a999e54d2bf45$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("1zUcV", function(module, exports) {
"use strict";
var $1264a8f63e75be39$var$elliptic = module.exports;

$1264a8f63e75be39$var$elliptic.version = (parcelRequire("fuV4H")).version;

$1264a8f63e75be39$var$elliptic.utils = (parcelRequire("gEVtY"));

$1264a8f63e75be39$var$elliptic.rand = (parcelRequire("7JHF0"));

$1264a8f63e75be39$var$elliptic.curve = (parcelRequire("cP1GP"));

$1264a8f63e75be39$var$elliptic.curves = (parcelRequire("fbTbW"));

// Protocols
$1264a8f63e75be39$var$elliptic.ec = (parcelRequire("220Zx"));

$1264a8f63e75be39$var$elliptic.eddsa = (parcelRequire("esmmS"));

});

parcelRegister("jqmf0", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("98aLY", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $hkN9y = parcelRequire("hkN9y");

var $1R2J7 = parcelRequire("1R2J7");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3pDg3 = parcelRequire("3pDg3");

var $3Sg1O = parcelRequire("3Sg1O");

var $1U9GM = parcelRequire("1U9GM");
var $6a5d37a95541eeab$require$Buffer = $1U9GM.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $6a5d37a95541eeab$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $6a5d37a95541eeab$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $6rDPA(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return $3Sg1O(paddedMsg, key);
    else return $3pDg3(paddedMsg, key);
};
function $6a5d37a95541eeab$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $1R2J7("sha1").update($6a5d37a95541eeab$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $hkN9y(hLen);
    var maskedDb = $6nrMP($6a5d37a95541eeab$require$Buffer.concat([
        iHash,
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $5BMkJ(seed, dblen));
    var maskedSeed = $6nrMP(seed, $5BMkJ(maskedDb, hLen));
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $6a5d37a95541eeab$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $6a5d37a95541eeab$var$nonZero(k - mLen - 3);
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        msg
    ], k));
}
function $6a5d37a95541eeab$var$nonZero(len) {
    var out = $6a5d37a95541eeab$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $hkN9y(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $hkN9y(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("aNeDF", function(module, exports) {
"use strict";

var $fC6a8 = parcelRequire("fC6a8");

var $5v6nH = parcelRequire("5v6nH");

var $3ILSx = parcelRequire("3ILSx");

var $7Zu82 = parcelRequire("7Zu82");

var $lORrZ = parcelRequire("lORrZ");

var $1U9GM = parcelRequire("1U9GM");
var $7db9d5f82e4113aa$require$Buffer = $1U9GM.Buffer;
function $7db9d5f82e4113aa$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $5v6nH[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = $lORrZ.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = $7Zu82.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher["final"]());
    return $7db9d5f82e4113aa$require$Buffer.concat(out);
}
function $7db9d5f82e4113aa$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !$7db9d5f82e4113aa$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = $7db9d5f82e4113aa$require$Buffer.from(buffer);
    var stripped = $3ILSx(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = $fC6a8.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = $fC6a8.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fC6a8.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = $fC6a8.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = $fC6a8.EncryptedPrivateKey.decode(data, "der");
            data = $7db9d5f82e4113aa$var$decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = $fC6a8.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fC6a8.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $fC6a8.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = $fC6a8.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return $fC6a8.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return $fC6a8.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: $fC6a8.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = $fC6a8.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
$7db9d5f82e4113aa$var$parseKeys.signature = $fC6a8.signature;
module.exports = $7db9d5f82e4113aa$var$parseKeys;

});
parcelRegister("fC6a8", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $b5df2f5887fb7e8d$export$c98397a6eb8d0678, (v) => $b5df2f5887fb7e8d$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b, (v) => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $b5df2f5887fb7e8d$export$4471f5c65d097c11, (v) => $b5df2f5887fb7e8d$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de, (v) => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $b5df2f5887fb7e8d$export$8f54525b330fd87b, (v) => $b5df2f5887fb7e8d$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7, (v) => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce, (v) => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $b5df2f5887fb7e8d$export$8ad762e3e6399afe, (v) => $b5df2f5887fb7e8d$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0, (v) => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $b5df2f5887fb7e8d$export$c9cd164b539ebb63, (v) => $b5df2f5887fb7e8d$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $b5df2f5887fb7e8d$export$c98397a6eb8d0678;
var $b5df2f5887fb7e8d$export$f4aab6816f64fa6b;
var $b5df2f5887fb7e8d$export$4471f5c65d097c11;
var $b5df2f5887fb7e8d$export$ca8b6604d6ce14de;
var $b5df2f5887fb7e8d$export$8f54525b330fd87b;
var $b5df2f5887fb7e8d$export$23cd2842b44ca3e7;
var $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce;
var $b5df2f5887fb7e8d$export$8ad762e3e6399afe;
var $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0;
var $b5df2f5887fb7e8d$export$c9cd164b539ebb63;
"use strict";

var $10gXo = parcelRequire("10gXo");

$b5df2f5887fb7e8d$export$c98397a6eb8d0678 = (parcelRequire("bDaUv"));
var $b5df2f5887fb7e8d$var$RSAPrivateKey = $10gXo.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version")["int"](), this.key("modulus")["int"](), this.key("publicExponent")["int"](), this.key("privateExponent")["int"](), this.key("prime1")["int"](), this.key("prime2")["int"](), this.key("exponent1")["int"](), this.key("exponent2")["int"](), this.key("coefficient")["int"]());
});
$b5df2f5887fb7e8d$export$f4aab6816f64fa6b = $b5df2f5887fb7e8d$var$RSAPrivateKey;
var $b5df2f5887fb7e8d$var$RSAPublicKey = $10gXo.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus")["int"](), this.key("publicExponent")["int"]());
});
$b5df2f5887fb7e8d$export$4471f5c65d097c11 = $b5df2f5887fb7e8d$var$RSAPublicKey;
var $b5df2f5887fb7e8d$var$AlgorithmIdentifier = $10gXo.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p")["int"](), this.key("q")["int"](), this.key("g")["int"]()).optional());
});
var $b5df2f5887fb7e8d$var$PublicKey = $10gXo.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
$b5df2f5887fb7e8d$export$ca8b6604d6ce14de = $b5df2f5887fb7e8d$var$PublicKey;
var $b5df2f5887fb7e8d$var$PrivateKeyInfo = $10gXo.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version")["int"](), this.key("algorithm").use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
$b5df2f5887fb7e8d$export$8f54525b330fd87b = $b5df2f5887fb7e8d$var$PrivateKeyInfo;
var $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo = $10gXo.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters")["int"]())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
$b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo;
var $b5df2f5887fb7e8d$var$DSAPrivateKey = $10gXo.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version")["int"](), this.key("p")["int"](), this.key("q")["int"](), this.key("g")["int"](), this.key("pub_key")["int"](), this.key("priv_key")["int"]());
});
$b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = $b5df2f5887fb7e8d$var$DSAPrivateKey;
$b5df2f5887fb7e8d$export$8ad762e3e6399afe = $10gXo.define("DSAparam", function() {
    this["int"]();
});
var $b5df2f5887fb7e8d$var$ECParameters = $10gXo.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $b5df2f5887fb7e8d$var$ECPrivateKey = $10gXo.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version")["int"](), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use($b5df2f5887fb7e8d$var$ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
$b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = $b5df2f5887fb7e8d$var$ECPrivateKey;
$b5df2f5887fb7e8d$export$c9cd164b539ebb63 = $10gXo.define("signature", function() {
    this.seq().obj(this.key("r")["int"](), this.key("s")["int"]());
});

});

parcelRegister("5v6nH", function(module, exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

});

parcelRegister("3ILSx", function(module, exports) {
"use strict";
// adapted from https://github.com/apatil/pemstrip
var $2b5a9edea8bfc145$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $2b5a9edea8bfc145$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $2b5a9edea8bfc145$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $bSYjd = parcelRequire("bSYjd");

var $7Zu82 = parcelRequire("7Zu82");

var $1U9GM = parcelRequire("1U9GM");
var $2b5a9edea8bfc145$require$Buffer = $1U9GM.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($2b5a9edea8bfc145$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($2b5a9edea8bfc145$var$fullRegex);
        decrypted = $2b5a9edea8bfc145$require$Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = $2b5a9edea8bfc145$require$Buffer.from(match[2], "hex");
        var cipherText = $2b5a9edea8bfc145$require$Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = $bSYjd(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $7Zu82.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher["final"]());
        decrypted = $2b5a9edea8bfc145$require$Buffer.concat(out);
    }
    var tag = key.match($2b5a9edea8bfc145$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});
parcelRegister("bSYjd", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $8a7384f85993cf90$require$Buffer = $1U9GM.Buffer;

var $loYLU = parcelRequire("loYLU");
/* eslint-disable camelcase */ function $8a7384f85993cf90$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$8a7384f85993cf90$require$Buffer.isBuffer(password)) password = $8a7384f85993cf90$require$Buffer.from(password, "binary");
    if (salt) {
        if (!$8a7384f85993cf90$require$Buffer.isBuffer(salt)) salt = $8a7384f85993cf90$require$Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = $8a7384f85993cf90$require$Buffer.alloc(keyLen);
    var iv = $8a7384f85993cf90$require$Buffer.alloc(ivLen || 0);
    var tmp = $8a7384f85993cf90$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $loYLU();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $8a7384f85993cf90$var$EVP_BytesToKey;

});

parcelRegister("7Zu82", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $5d1599d560efe1c2$export$2f64596b8cbf08b4, (v) => $5d1599d560efe1c2$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $5d1599d560efe1c2$export$36b6d6ef312eab39, (v) => $5d1599d560efe1c2$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $5d1599d560efe1c2$export$58a258485f1e49f6, (v) => $5d1599d560efe1c2$export$58a258485f1e49f6 = v);
var $5d1599d560efe1c2$export$bdd223f16383713e;
var $5d1599d560efe1c2$export$26e5786e8ac8e530;
var $5d1599d560efe1c2$export$2f64596b8cbf08b4;
var $5d1599d560efe1c2$export$20533d26f07f1ee0;
var $5d1599d560efe1c2$export$12ada9414fbc594c;
var $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a;
var $5d1599d560efe1c2$export$36b6d6ef312eab39;
var $5d1599d560efe1c2$export$f5e7e39d57cd9700;
var $5d1599d560efe1c2$export$dedd8dc3dc62b370;
var $5d1599d560efe1c2$export$58a258485f1e49f6;

var $8Zgnw = parcelRequire("8Zgnw");

var $aSTOs = parcelRequire("aSTOs");

var $2lZ3i = parcelRequire("2lZ3i");
function $5d1599d560efe1c2$var$getCiphers() {
    return Object.keys($2lZ3i);
}
$5d1599d560efe1c2$export$bdd223f16383713e = $5d1599d560efe1c2$export$26e5786e8ac8e530 = $8Zgnw.createCipher;
$5d1599d560efe1c2$export$2f64596b8cbf08b4 = $5d1599d560efe1c2$export$20533d26f07f1ee0 = $8Zgnw.createCipheriv;
$5d1599d560efe1c2$export$12ada9414fbc594c = $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a = $aSTOs.createDecipher;
$5d1599d560efe1c2$export$36b6d6ef312eab39 = $5d1599d560efe1c2$export$f5e7e39d57cd9700 = $aSTOs.createDecipheriv;
$5d1599d560efe1c2$export$dedd8dc3dc62b370 = $5d1599d560efe1c2$export$58a258485f1e49f6 = $5d1599d560efe1c2$var$getCiphers;

});
parcelRegister("8Zgnw", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $68b0b9a01ec378ac$export$2f64596b8cbf08b4, (v) => $68b0b9a01ec378ac$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $68b0b9a01ec378ac$export$bdd223f16383713e, (v) => $68b0b9a01ec378ac$export$bdd223f16383713e = v);
var $68b0b9a01ec378ac$export$2f64596b8cbf08b4;
var $68b0b9a01ec378ac$export$bdd223f16383713e;

var $5Su5u = parcelRequire("5Su5u");

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $68b0b9a01ec378ac$require$Buffer = $1U9GM.Buffer;

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $68b0b9a01ec378ac$var$Cipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $68b0b9a01ec378ac$var$Splitter();
    this._cipher = new $j0hdX.AES(key);
    this._prev = $68b0b9a01ec378ac$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($68b0b9a01ec378ac$var$Cipher, $26nOC);
$68b0b9a01ec378ac$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $68b0b9a01ec378ac$require$Buffer.concat(out);
};
var $68b0b9a01ec378ac$var$PADDING = $68b0b9a01ec378ac$require$Buffer.alloc(16, 0x10);
$68b0b9a01ec378ac$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($68b0b9a01ec378ac$var$PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
$68b0b9a01ec378ac$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $68b0b9a01ec378ac$var$Splitter() {
    this.cache = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(0);
}
$68b0b9a01ec378ac$var$Splitter.prototype.add = function(data) {
    this.cache = $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$68b0b9a01ec378ac$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$68b0b9a01ec378ac$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $68b0b9a01ec378ac$var$createCipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = $68b0b9a01ec378ac$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = $68b0b9a01ec378ac$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new $hzsAp(config.module, password, iv);
    else if (config.type === "auth") return new $lyZ5N(config.module, password, iv);
    return new $68b0b9a01ec378ac$var$Cipher(config.module, password, iv);
}
function $68b0b9a01ec378ac$var$createCipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $68b0b9a01ec378ac$var$createCipheriv(suite, keys.key, keys.iv);
}
$68b0b9a01ec378ac$export$2f64596b8cbf08b4 = $68b0b9a01ec378ac$var$createCipheriv;
$68b0b9a01ec378ac$export$bdd223f16383713e = $68b0b9a01ec378ac$var$createCipher;

});
parcelRegister("5Su5u", function(module, exports) {








var $447955a9e06650da$var$modeModules = {
    ECB: (parcelRequire("f6p9h")),
    CBC: (parcelRequire("3QymJ")),
    CFB: (parcelRequire("2cuuO")),
    CFB8: (parcelRequire("03mhO")),
    CFB1: (parcelRequire("fK9OU")),
    OFB: (parcelRequire("fFe8N")),
    CTR: (parcelRequire("fJbMg")),
    GCM: (parcelRequire("fJbMg"))
};

var $2lZ3i = parcelRequire("2lZ3i");
for(var $447955a9e06650da$var$key in $2lZ3i)$2lZ3i[$447955a9e06650da$var$key].module = $447955a9e06650da$var$modeModules[$2lZ3i[$447955a9e06650da$var$key].mode];
module.exports = $2lZ3i;

});
parcelRegister("2lZ3i", function(module, exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

});


parcelRegister("lyZ5N", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $fb2c299f1eae7447$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");

var $5Z5i8 = parcelRequire("5Z5i8");

var $dUX5c = parcelRequire("dUX5c");

var $3VKgl = parcelRequire("3VKgl");
function $fb2c299f1eae7447$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $fb2c299f1eae7447$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $5Z5i8(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($fb2c299f1eae7447$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($fb2c299f1eae7447$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $fb2c299f1eae7447$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $fb2c299f1eae7447$require$Buffer.from(self._finID);
    $3VKgl(out);
    return out;
}
function $fb2c299f1eae7447$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    var h = $fb2c299f1eae7447$require$Buffer.alloc(4, 0);
    this._cipher = new $j0hdX.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $5Z5i8(ck);
    iv = $fb2c299f1eae7447$var$calcIv(this, iv, ck);
    this._prev = $fb2c299f1eae7447$require$Buffer.from(iv);
    this._cache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._secCache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$dlqwk($fb2c299f1eae7447$var$StreamCipher, $26nOC);
$fb2c299f1eae7447$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $fb2c299f1eae7447$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$fb2c299f1eae7447$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = $dUX5c(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $fb2c299f1eae7447$var$xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
$fb2c299f1eae7447$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$fb2c299f1eae7447$require$Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $fb2c299f1eae7447$var$StreamCipher;

});
parcelRegister("j0hdX", function(module, exports) {

$parcel$export(module.exports, "AES", () => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5, (v) => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5;

var $1U9GM = parcelRequire("1U9GM");
var $dd5b60bed61b3c64$require$Buffer = $1U9GM.Buffer;
function $dd5b60bed61b3c64$var$asUInt32Array(buf) {
    if (!$dd5b60bed61b3c64$require$Buffer.isBuffer(buf)) buf = $dd5b60bed61b3c64$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $dd5b60bed61b3c64$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $dd5b60bed61b3c64$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $dd5b60bed61b3c64$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $dd5b60bed61b3c64$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $dd5b60bed61b3c64$var$AES(key) {
    this._key = $dd5b60bed61b3c64$var$asUInt32Array(key);
    this._reset();
}
$dd5b60bed61b3c64$var$AES.blockSize = 16;
$dd5b60bed61b3c64$var$AES.keySize = 32;
$dd5b60bed61b3c64$var$AES.prototype.blockSize = $dd5b60bed61b3c64$var$AES.blockSize;
$dd5b60bed61b3c64$var$AES.prototype.keySize = $dd5b60bed61b3c64$var$AES.keySize;
$dd5b60bed61b3c64$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
            t ^= $dd5b60bed61b3c64$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $dd5b60bed61b3c64$var$G.INV_SUB_MIX[0][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 24]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[1][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 16 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[2][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 8 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[3][$dd5b60bed61b3c64$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    return $dd5b60bed61b3c64$var$cryptBlock(M, this._keySchedule, $dd5b60bed61b3c64$var$G.SUB_MIX, $dd5b60bed61b3c64$var$G.SBOX, this._nRounds);
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.decryptBlock = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $dd5b60bed61b3c64$var$cryptBlock(M, this._invKeySchedule, $dd5b60bed61b3c64$var$G.INV_SUB_MIX, $dd5b60bed61b3c64$var$G.INV_SBOX, this._nRounds);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.scrub = function() {
    $dd5b60bed61b3c64$var$scrubVec(this._keySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._invKeySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._key);
};
$dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = $dd5b60bed61b3c64$var$AES;

});

parcelRegister("5Z5i8", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $45b6c10c8dc18438$require$Buffer = $1U9GM.Buffer;
var $45b6c10c8dc18438$var$ZEROES = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
function $45b6c10c8dc18438$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $45b6c10c8dc18438$var$fromArray(out) {
    var buf = $45b6c10c8dc18438$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $45b6c10c8dc18438$var$GHASH(key) {
    this.h = key;
    this.state = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
    this.cache = $45b6c10c8dc18438$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$45b6c10c8dc18438$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$45b6c10c8dc18438$var$GHASH.prototype._multiply = function() {
    var Vi = $45b6c10c8dc18438$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $45b6c10c8dc18438$var$fromArray(Zi);
};
$45b6c10c8dc18438$var$GHASH.prototype.update = function(buf) {
    this.cache = $45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$45b6c10c8dc18438$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        $45b6c10c8dc18438$var$ZEROES
    ], 16));
    this.ghash($45b6c10c8dc18438$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $45b6c10c8dc18438$var$GHASH;

});


parcelRegister("hzsAp", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $ccabe1300e92c82b$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");
function $ccabe1300e92c82b$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    this._cipher = new $j0hdX.AES(key);
    this._prev = $ccabe1300e92c82b$require$Buffer.from(iv);
    this._cache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._secCache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$dlqwk($ccabe1300e92c82b$var$StreamCipher, $26nOC);
$ccabe1300e92c82b$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$ccabe1300e92c82b$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $ccabe1300e92c82b$var$StreamCipher;

});


parcelRegister("aSTOs", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $7eca3dd1d6757703$export$12ada9414fbc594c, (v) => $7eca3dd1d6757703$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $7eca3dd1d6757703$export$36b6d6ef312eab39, (v) => $7eca3dd1d6757703$export$36b6d6ef312eab39 = v);
var $7eca3dd1d6757703$export$12ada9414fbc594c;
var $7eca3dd1d6757703$export$36b6d6ef312eab39;

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $7eca3dd1d6757703$require$Buffer = $1U9GM.Buffer;

var $5Su5u = parcelRequire("5Su5u");

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $7eca3dd1d6757703$var$Decipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $7eca3dd1d6757703$var$Splitter();
    this._last = void 0;
    this._cipher = new $j0hdX.AES(key);
    this._prev = $7eca3dd1d6757703$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($7eca3dd1d6757703$var$Decipher, $26nOC);
$7eca3dd1d6757703$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $7eca3dd1d6757703$require$Buffer.concat(out);
};
$7eca3dd1d6757703$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $7eca3dd1d6757703$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
$7eca3dd1d6757703$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $7eca3dd1d6757703$var$Splitter() {
    this.cache = $7eca3dd1d6757703$require$Buffer.allocUnsafe(0);
}
$7eca3dd1d6757703$var$Splitter.prototype.add = function(data) {
    this.cache = $7eca3dd1d6757703$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$7eca3dd1d6757703$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$7eca3dd1d6757703$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $7eca3dd1d6757703$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $7eca3dd1d6757703$var$createDecipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = $7eca3dd1d6757703$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = $7eca3dd1d6757703$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new $hzsAp(config.module, password, iv, true);
    else if (config.type === "auth") return new $lyZ5N(config.module, password, iv, true);
    return new $7eca3dd1d6757703$var$Decipher(config.module, password, iv);
}
function $7eca3dd1d6757703$var$createDecipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $7eca3dd1d6757703$var$createDecipheriv(suite, keys.key, keys.iv);
}
$7eca3dd1d6757703$export$12ada9414fbc594c = $7eca3dd1d6757703$var$createDecipher;
$7eca3dd1d6757703$export$36b6d6ef312eab39 = $7eca3dd1d6757703$var$createDecipheriv;

});



parcelRegister("lORrZ", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $fe27baa2ca96071e$export$448fa22aedc9dbca, (v) => $fe27baa2ca96071e$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $fe27baa2ca96071e$export$b80c7ba289c8fa56, (v) => $fe27baa2ca96071e$export$b80c7ba289c8fa56 = v);
var $fe27baa2ca96071e$export$448fa22aedc9dbca;
var $fe27baa2ca96071e$export$b80c7ba289c8fa56;

$fe27baa2ca96071e$export$448fa22aedc9dbca = (parcelRequire("5dQ72"));

$fe27baa2ca96071e$export$b80c7ba289c8fa56 = (parcelRequire("1VtKc"));

});


parcelRegister("5BMkJ", function(module, exports) {

var $1R2J7 = parcelRequire("1R2J7");

var $1U9GM = parcelRequire("1U9GM");
var $4155e6705a7c8e0e$require$Buffer = $1U9GM.Buffer;
module.exports = function(seed, len) {
    var t = $4155e6705a7c8e0e$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $4155e6705a7c8e0e$var$i2ops(i++);
        t = $4155e6705a7c8e0e$require$Buffer.concat([
            t,
            $1R2J7("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $4155e6705a7c8e0e$var$i2ops(c) {
    var out = $4155e6705a7c8e0e$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("6nrMP", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("6rDPA", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("3pDg3", function(module, exports) {

var $6rDPA = parcelRequire("6rDPA");

var $1U9GM = parcelRequire("1U9GM");
var $27c228af35759e80$require$Buffer = $1U9GM.Buffer;
function $27c228af35759e80$var$withPublic(paddedMsg, key) {
    return $27c228af35759e80$require$Buffer.from(paddedMsg.toRed($6rDPA.mont(key.modulus)).redPow(new $6rDPA(key.publicExponent)).fromRed().toArray());
}
module.exports = $27c228af35759e80$var$withPublic;

});

parcelRegister("3Sg1O", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $2d22d91c93a13ae5$require$Buffer = $6ZWSX.Buffer;

var $dEXSZ = parcelRequire("dEXSZ");

var $hkN9y = parcelRequire("hkN9y");
function $2d22d91c93a13ae5$var$blind(priv) {
    var r = $2d22d91c93a13ae5$var$getr(priv);
    var blinder = r.toRed($dEXSZ.mont(priv.modulus)).redPow(new $dEXSZ(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $2d22d91c93a13ae5$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $dEXSZ($hkN9y(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $2d22d91c93a13ae5$var$crt(msg, priv) {
    var blinds = $2d22d91c93a13ae5$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $dEXSZ(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($dEXSZ.mont(priv.prime1));
    var c2 = blinded.toRed($dEXSZ.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($2d22d91c93a13ae5$require$Buffer, "be", len);
}
$2d22d91c93a13ae5$var$crt.getr = $2d22d91c93a13ae5$var$getr;
module.exports = $2d22d91c93a13ae5$var$crt;

});


parcelRegister("jU8t7", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3Sg1O = parcelRequire("3Sg1O");

var $1R2J7 = parcelRequire("1R2J7");

var $3pDg3 = parcelRequire("3pDg3");

var $1U9GM = parcelRequire("1U9GM");
var $e7d9d10092031842$require$Buffer = $1U9GM.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $6rDPA(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = $3pDg3(new $6rDPA(enc), key);
    else msg = $3Sg1O(enc, key);
    var zBuffer = $e7d9d10092031842$require$Buffer.alloc(k - msg.length);
    msg = $e7d9d10092031842$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $e7d9d10092031842$var$oaep(key, msg);
    else if (padding === 1) return $e7d9d10092031842$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function $e7d9d10092031842$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $1R2J7("sha1").update($e7d9d10092031842$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $6nrMP(maskedSeed, $5BMkJ(maskedDb, hLen));
    var db = $6nrMP(maskedDb, $5BMkJ(seed, k - hLen - 1));
    if ($e7d9d10092031842$var$compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function $e7d9d10092031842$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function $e7d9d10092031842$var$compare(a, b) {
    a = $e7d9d10092031842$require$Buffer.from(a);
    b = $e7d9d10092031842$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});

parcelRegister("jUw11", function(module, exports) {

$parcel$export(module.exports, "Wildcard", () => $e7ec14ea02a2a4bf$export$10fd9b2de72cfe8c, (v) => $e7ec14ea02a2a4bf$export$10fd9b2de72cfe8c = v);
// Wildcard constructor
var $e7ec14ea02a2a4bf$export$10fd9b2de72cfe8c;
class $e7ec14ea02a2a4bf$var$Wildcard {
    constructor(){
        return $e7ec14ea02a2a4bf$var$WILDCARD || this;
    }
    equals(other) {
        return other && this.termType === other.termType;
    }
}
Object.defineProperty($e7ec14ea02a2a4bf$var$Wildcard.prototype, "value", {
    enumerable: true,
    value: "*"
});
Object.defineProperty($e7ec14ea02a2a4bf$var$Wildcard.prototype, "termType", {
    enumerable: true,
    value: "Wildcard"
});
// Wildcard singleton
var $e7ec14ea02a2a4bf$var$WILDCARD = new $e7ec14ea02a2a4bf$var$Wildcard();
$e7ec14ea02a2a4bf$export$10fd9b2de72cfe8c = $e7ec14ea02a2a4bf$var$Wildcard;

});

parcelRegister("dUwlf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlankNode = void 0;
/**
 * A term that represents an RDF blank node with a label.
 */ class $a20997b43a187c27$var$BlankNode {
    constructor(value){
        this.termType = "BlankNode";
        this.value = value;
    }
    equals(other) {
        return !!other && other.termType === "BlankNode" && other.value === this.value;
    }
}
module.exports.BlankNode = $a20997b43a187c27$var$BlankNode;

});

parcelRegister("3wL3n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataFactory = void 0;

var $dUwlf = parcelRequire("dUwlf");

var $0UUif = parcelRequire("0UUif");

var $8RsDA = parcelRequire("8RsDA");

var $7KJsK = parcelRequire("7KJsK");

var $1k2AX = parcelRequire("1k2AX");

var $kNA9K = parcelRequire("kNA9K");
let $2918dc15ed9a49cb$var$dataFactoryCounter = 0;
/**
 * A factory for instantiating RDF terms and quads.
 */ class $2918dc15ed9a49cb$var$DataFactory {
    constructor(options){
        this.blankNodeCounter = 0;
        options = options || {};
        this.blankNodePrefix = options.blankNodePrefix || `df_${$2918dc15ed9a49cb$var$dataFactoryCounter++}_`;
    }
    /**
     * @param value The IRI for the named node.
     * @return A new instance of NamedNode.
     * @see NamedNode
     */ namedNode(value) {
        return new $7KJsK.NamedNode(value);
    }
    /**
     * @param value The optional blank node identifier.
     * @return A new instance of BlankNode.
     *         If the `value` parameter is undefined a new identifier
     *         for the blank node is generated for each call.
     * @see BlankNode
     */ blankNode(value) {
        return new $dUwlf.BlankNode(value || `${this.blankNodePrefix}${this.blankNodeCounter++}`);
    }
    /**
     * @param value              The literal value.
     * @param languageOrDatatype The optional language or datatype.
     *                           If `languageOrDatatype` is a NamedNode,
     *                           then it is used for the value of `NamedNode.datatype`.
     *                           Otherwise `languageOrDatatype` is used for the value
     *                           of `NamedNode.language`.
     * @return A new instance of Literal.
     * @see Literal
     */ literal(value, languageOrDatatype) {
        return new $8RsDA.Literal(value, languageOrDatatype);
    }
    /**
     * This method is optional.
     * @param value The variable name
     * @return A new instance of Variable.
     * @see Variable
     */ variable(value) {
        return new $kNA9K.Variable(value);
    }
    /**
     * @return An instance of DefaultGraph.
     */ defaultGraph() {
        return $0UUif.DefaultGraph.INSTANCE;
    }
    /**
     * @param subject   The quad subject term.
     * @param predicate The quad predicate term.
     * @param object    The quad object term.
     * @param graph     The quad graph term.
     * @return A new instance of Quad.
     * @see Quad
     */ quad(subject, predicate, object, graph) {
        return new $1k2AX.Quad(subject, predicate, object, graph || this.defaultGraph());
    }
    /**
     * Create a deep copy of the given term using this data factory.
     * @param original An RDF term.
     * @return A deep copy of the given term.
     */ fromTerm(original) {
        // TODO: remove nasty any casts when this TS bug has been fixed:
        //  https://github.com/microsoft/TypeScript/issues/26933
        switch(original.termType){
            case "NamedNode":
                return this.namedNode(original.value);
            case "BlankNode":
                return this.blankNode(original.value);
            case "Literal":
                if (original.language) return this.literal(original.value, original.language);
                if (!original.datatype.equals($8RsDA.Literal.XSD_STRING)) return this.literal(original.value, this.fromTerm(original.datatype));
                return this.literal(original.value);
            case "Variable":
                return this.variable(original.value);
            case "DefaultGraph":
                return this.defaultGraph();
            case "Quad":
                return this.quad(this.fromTerm(original.subject), this.fromTerm(original.predicate), this.fromTerm(original.object), this.fromTerm(original.graph));
        }
    }
    /**
     * Create a deep copy of the given quad using this data factory.
     * @param original An RDF quad.
     * @return A deep copy of the given quad.
     */ fromQuad(original) {
        return this.fromTerm(original);
    }
    /**
     * Reset the internal blank node counter.
     */ resetBlankNodeCounter() {
        this.blankNodeCounter = 0;
    }
}
module.exports.DataFactory = $2918dc15ed9a49cb$var$DataFactory;

});
parcelRegister("0UUif", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultGraph = void 0;
/**
 * A singleton term instance that represents the default graph.
 * It's only allowed to assign a DefaultGraph to the .graph property of a Quad.
 */ class $002c24bd07a7ffa2$var$DefaultGraph {
    constructor(){
        this.termType = "DefaultGraph";
        this.value = "";
    // Private constructor
    }
    equals(other) {
        return !!other && other.termType === "DefaultGraph";
    }
}
module.exports.DefaultGraph = $002c24bd07a7ffa2$var$DefaultGraph;
$002c24bd07a7ffa2$var$DefaultGraph.INSTANCE = new $002c24bd07a7ffa2$var$DefaultGraph();

});

parcelRegister("8RsDA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Literal = void 0;

var $7KJsK = parcelRequire("7KJsK");
/**
 * A term that represents an RDF literal, containing a string with an optional language tag or datatype.
 */ class $67397ccc34a6e6fe$var$Literal {
    constructor(value, languageOrDatatype){
        this.termType = "Literal";
        this.value = value;
        if (typeof languageOrDatatype === "string") {
            this.language = languageOrDatatype;
            this.datatype = $67397ccc34a6e6fe$var$Literal.RDF_LANGUAGE_STRING;
        } else if (languageOrDatatype) {
            this.language = "";
            this.datatype = languageOrDatatype;
        } else {
            this.language = "";
            this.datatype = $67397ccc34a6e6fe$var$Literal.XSD_STRING;
        }
    }
    equals(other) {
        return !!other && other.termType === "Literal" && other.value === this.value && other.language === this.language && this.datatype.equals(other.datatype);
    }
}
module.exports.Literal = $67397ccc34a6e6fe$var$Literal;
$67397ccc34a6e6fe$var$Literal.RDF_LANGUAGE_STRING = new $7KJsK.NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#langString");
$67397ccc34a6e6fe$var$Literal.XSD_STRING = new $7KJsK.NamedNode("http://www.w3.org/2001/XMLSchema#string");

});
parcelRegister("7KJsK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NamedNode = void 0;
/**
 * A term that contains an IRI.
 */ class $5a501833e31d245e$var$NamedNode {
    constructor(value){
        this.termType = "NamedNode";
        this.value = value;
    }
    equals(other) {
        return !!other && other.termType === "NamedNode" && other.value === this.value;
    }
}
module.exports.NamedNode = $5a501833e31d245e$var$NamedNode;

});


parcelRegister("1k2AX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Quad = void 0;
/**
 * An instance of DefaultGraph represents the default graph.
 * It's only allowed to assign a DefaultGraph to the .graph property of a Quad.
 */ class $0f69ac096a83e0ca$var$Quad {
    constructor(subject, predicate, object, graph){
        this.termType = "Quad";
        this.value = "";
        this.subject = subject;
        this.predicate = predicate;
        this.object = object;
        this.graph = graph;
    }
    equals(other) {
        // `|| !other.termType` is for backwards-compatibility with old factories without RDF* support.
        return !!other && (other.termType === "Quad" || !other.termType) && this.subject.equals(other.subject) && this.predicate.equals(other.predicate) && this.object.equals(other.object) && this.graph.equals(other.graph);
    }
}
module.exports.Quad = $0f69ac096a83e0ca$var$Quad;

});

parcelRegister("kNA9K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Variable = void 0;
/**
 * A term that represents a variable.
 */ class $f2446e1c920a3cc9$var$Variable {
    constructor(value){
        this.termType = "Variable";
        this.value = value;
    }
    equals(other) {
        return !!other && other.termType === "Variable" && other.value === this.value;
    }
}
module.exports.Variable = $f2446e1c920a3cc9$var$Variable;

});


parcelRegister("kAE07", function(module, exports) {

$parcel$export(module.exports, "default", () => $efd632c6048e8a66$export$2e2bcd8739ae039);
/**
 * A Dummy log
 * @module log
 */ var $efd632c6048e8a66$var$log = {
    debug: function debug(x) {},
    warn: function warn(x) {},
    info: function info(x) {},
    error: function error(x) {},
    success: function success(x) {},
    msg: function msg(x) {}
};
var $efd632c6048e8a66$export$2e2bcd8739ae039 = $efd632c6048e8a66$var$log;

});

var $4eae0a726ab50395$exports = {};
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof $4eae0a726ab50395$exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    $4eae0a726ab50395$exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : $4eae0a726ab50395$exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});


var $bebb5f3cb64a9781$exports = {};
!function(t, e) {
    $bebb5f3cb64a9781$exports = e();
}($bebb5f3cb64a9781$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


var $093a98c17cb6b6b8$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
var $093a98c17cb6b6b8$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $093a98c17cb6b6b8$var$formatRegExp = /%[sdj%]/g;
$093a98c17cb6b6b8$exports.format = function(f) {
    if (!$093a98c17cb6b6b8$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($093a98c17cb6b6b8$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($093a98c17cb6b6b8$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($093a98c17cb6b6b8$var$isNull(x) || !$093a98c17cb6b6b8$var$isObject(x)) str += " " + x;
    else str += " " + $093a98c17cb6b6b8$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
$093a98c17cb6b6b8$exports.deprecate = function(fn, msg) {
    if (typeof $hPtJY !== "undefined" && $hPtJY.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $hPtJY === "undefined") return function() {
        return $093a98c17cb6b6b8$exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($hPtJY.throwDeprecation) throw new Error(msg);
            else if ($hPtJY.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $093a98c17cb6b6b8$var$debugs = {};
var $093a98c17cb6b6b8$var$debugEnvRegex = /^$/;
var $093a98c17cb6b6b8$var$debugEnv;
$093a98c17cb6b6b8$exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$093a98c17cb6b6b8$var$debugs[set]) {
        if ($093a98c17cb6b6b8$var$debugEnvRegex.test(set)) {
            var pid = $hPtJY.pid;
            $093a98c17cb6b6b8$var$debugs[set] = function() {
                var msg = $093a98c17cb6b6b8$exports.format.apply($093a98c17cb6b6b8$exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $093a98c17cb6b6b8$var$debugs[set] = function() {};
    }
    return $093a98c17cb6b6b8$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $093a98c17cb6b6b8$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $093a98c17cb6b6b8$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($093a98c17cb6b6b8$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    $093a98c17cb6b6b8$exports._extend(ctx, opts);
    // set default options
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $093a98c17cb6b6b8$var$stylizeWithColor;
    return $093a98c17cb6b6b8$var$formatValue(ctx, obj, ctx.depth);
}
$093a98c17cb6b6b8$exports.inspect = $093a98c17cb6b6b8$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$093a98c17cb6b6b8$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$093a98c17cb6b6b8$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $093a98c17cb6b6b8$var$stylizeWithColor(str, styleType) {
    var style = $093a98c17cb6b6b8$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $093a98c17cb6b6b8$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $093a98c17cb6b6b8$var$inspect.colors[style][1] + "m";
    else return str;
}
function $093a98c17cb6b6b8$var$stylizeNoColor(str, styleType) {
    return str;
}
function $093a98c17cb6b6b8$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $093a98c17cb6b6b8$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $093a98c17cb6b6b8$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== $093a98c17cb6b6b8$exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$093a98c17cb6b6b8$var$isString(ret)) ret = $093a98c17cb6b6b8$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $093a98c17cb6b6b8$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $093a98c17cb6b6b8$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($093a98c17cb6b6b8$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $093a98c17cb6b6b8$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($093a98c17cb6b6b8$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($093a98c17cb6b6b8$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($093a98c17cb6b6b8$var$isError(value)) return $093a98c17cb6b6b8$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($093a98c17cb6b6b8$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($093a98c17cb6b6b8$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($093a98c17cb6b6b8$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($093a98c17cb6b6b8$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($093a98c17cb6b6b8$var$isError(value)) base = " " + $093a98c17cb6b6b8$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces);
}
function $093a98c17cb6b6b8$var$formatPrimitive(ctx, value) {
    if ($093a98c17cb6b6b8$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($093a98c17cb6b6b8$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($093a98c17cb6b6b8$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($093a98c17cb6b6b8$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($093a98c17cb6b6b8$var$isNull(value)) return ctx.stylize("null", "null");
}
function $093a98c17cb6b6b8$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($093a98c17cb6b6b8$var$hasOwnProperty(value, String(i))) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$093a98c17cb6b6b8$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($093a98c17cb6b6b8$var$isNull(recurseTimes)) str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, null);
            else str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($093a98c17cb6b6b8$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
$093a98c17cb6b6b8$exports.types = (parcelRequire("7He6T"));
function $093a98c17cb6b6b8$var$isArray(ar) {
    return Array.isArray(ar);
}
$093a98c17cb6b6b8$exports.isArray = $093a98c17cb6b6b8$var$isArray;
function $093a98c17cb6b6b8$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
$093a98c17cb6b6b8$exports.isBoolean = $093a98c17cb6b6b8$var$isBoolean;
function $093a98c17cb6b6b8$var$isNull(arg) {
    return arg === null;
}
$093a98c17cb6b6b8$exports.isNull = $093a98c17cb6b6b8$var$isNull;
function $093a98c17cb6b6b8$var$isNullOrUndefined(arg) {
    return arg == null;
}
$093a98c17cb6b6b8$exports.isNullOrUndefined = $093a98c17cb6b6b8$var$isNullOrUndefined;
function $093a98c17cb6b6b8$var$isNumber(arg) {
    return typeof arg === "number";
}
$093a98c17cb6b6b8$exports.isNumber = $093a98c17cb6b6b8$var$isNumber;
function $093a98c17cb6b6b8$var$isString(arg) {
    return typeof arg === "string";
}
$093a98c17cb6b6b8$exports.isString = $093a98c17cb6b6b8$var$isString;
function $093a98c17cb6b6b8$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
$093a98c17cb6b6b8$exports.isSymbol = $093a98c17cb6b6b8$var$isSymbol;
function $093a98c17cb6b6b8$var$isUndefined(arg) {
    return arg === void 0;
}
$093a98c17cb6b6b8$exports.isUndefined = $093a98c17cb6b6b8$var$isUndefined;
function $093a98c17cb6b6b8$var$isRegExp(re) {
    return $093a98c17cb6b6b8$var$isObject(re) && $093a98c17cb6b6b8$var$objectToString(re) === "[object RegExp]";
}
$093a98c17cb6b6b8$exports.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
$093a98c17cb6b6b8$exports.types.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
function $093a98c17cb6b6b8$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
$093a98c17cb6b6b8$exports.isObject = $093a98c17cb6b6b8$var$isObject;
function $093a98c17cb6b6b8$var$isDate(d) {
    return $093a98c17cb6b6b8$var$isObject(d) && $093a98c17cb6b6b8$var$objectToString(d) === "[object Date]";
}
$093a98c17cb6b6b8$exports.isDate = $093a98c17cb6b6b8$var$isDate;
$093a98c17cb6b6b8$exports.types.isDate = $093a98c17cb6b6b8$var$isDate;
function $093a98c17cb6b6b8$var$isError(e) {
    return $093a98c17cb6b6b8$var$isObject(e) && ($093a98c17cb6b6b8$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
$093a98c17cb6b6b8$exports.isError = $093a98c17cb6b6b8$var$isError;
$093a98c17cb6b6b8$exports.types.isNativeError = $093a98c17cb6b6b8$var$isError;
function $093a98c17cb6b6b8$var$isFunction(arg) {
    return typeof arg === "function";
}
$093a98c17cb6b6b8$exports.isFunction = $093a98c17cb6b6b8$var$isFunction;
function $093a98c17cb6b6b8$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
$093a98c17cb6b6b8$exports.isPrimitive = $093a98c17cb6b6b8$var$isPrimitive;

$093a98c17cb6b6b8$exports.isBuffer = (parcelRequire("kotBY"));
function $093a98c17cb6b6b8$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $093a98c17cb6b6b8$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $093a98c17cb6b6b8$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $093a98c17cb6b6b8$var$timestamp() {
    var d = new Date();
    var time = [
        $093a98c17cb6b6b8$var$pad(d.getHours()),
        $093a98c17cb6b6b8$var$pad(d.getMinutes()),
        $093a98c17cb6b6b8$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $093a98c17cb6b6b8$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
$093a98c17cb6b6b8$exports.log = function() {
    console.log("%s - %s", $093a98c17cb6b6b8$var$timestamp(), $093a98c17cb6b6b8$exports.format.apply($093a98c17cb6b6b8$exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ $093a98c17cb6b6b8$exports.inherits = (parcelRequire("dlqwk"));
$093a98c17cb6b6b8$exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$093a98c17cb6b6b8$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $093a98c17cb6b6b8$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
$093a98c17cb6b6b8$exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol && original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol]) {
        var fn = original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
};
$093a98c17cb6b6b8$exports.promisify.custom = $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol;
function $093a98c17cb6b6b8$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $093a98c17cb6b6b8$var$callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $hPtJY.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $hPtJY.nextTick($093a98c17cb6b6b8$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
$093a98c17cb6b6b8$exports.callbackify = $093a98c17cb6b6b8$var$callbackify;


let $5979e5393e457062$var$logFileName = "indegx.log";
function $5979e5393e457062$export$1a41b952b1d6d091(fileName) {
    if (fileName == null || fileName == undefined || fileName == "") $5979e5393e457062$var$logFileName = "indegx.log";
    else $5979e5393e457062$var$logFileName = fileName;
}
function $5979e5393e457062$export$bef1f36f5486a6a3(logObject, ...o) {
    $5979e5393e457062$var$logging("LOG", logObject, ...o);
}
function $5979e5393e457062$export$a3bc9b8ed74fc(logObject, ...o) {
    $5979e5393e457062$var$logging("ERROR", logObject, ...o);
}
function $5979e5393e457062$export$a80b3bd66acc52ff(logObject, ...o) {
    $5979e5393e457062$var$logging("INFO", logObject, ...o);
}
function $5979e5393e457062$var$logging(level, logObject, ...o) {
    const now = (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))();
    const message = $093a98c17cb6b6b8$exports.format("[%s][%s]: ", level, now.toISOString());
    console.error(message, logObject, ...o);
}



var $99pVg = parcelRequire("99pVg");
function $5b5611d501681341$export$2e2bcd8739ae039(nsuri, factory) {
    var dataFactory = factory || {
        namedNode: function namedNode(value) {
            return new (0, $99pVg.default)(value);
        }
    };
    return function(ln) {
        return dataFactory.namedNode(nsuri + (ln || ""));
    };
}


var $lR7jo = parcelRequire("lR7jo");

var $fu0YK = parcelRequire("fu0YK");

var $6zC7B = parcelRequire("6zC7B");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $g5Zhu = parcelRequire("g5Zhu");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $6zC7B = parcelRequire("6zC7B");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $g5Zhu = parcelRequire("g5Zhu");

var $aZYlt = parcelRequire("aZYlt");

var $cdU35 = parcelRequire("cdU35");

var $8RKL2 = parcelRequire("8RKL2");
function $d0a63e5194c4f691$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d0a63e5194c4f691$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $d0a63e5194c4f691$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * An RDF blank node is a Node without a URI
 * @link https://rdf.js.org/data-model-spec/#blanknode-interface
 */ var $d0a63e5194c4f691$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Node) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(BlankNode, _Node);
    var _super = $d0a63e5194c4f691$var$_createSuper(BlankNode);
    /**
   * Initializes this node
   * @param [id] The identifier for the blank node
   */ function BlankNode(id) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, BlankNode);
        _this = _super.call(this, BlankNode.getId(id));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "termType", (0, $8RKL2.BlankNodeTermType));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "classOrder", (0, $aZYlt.default).BlankNode);
        /** Whether this is a blank node */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "isBlank", 1);
        /**
     * This type of node is a variable.
     *
     * Note that the existence of this property already indicates that it is a variable.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "isVar", 1);
        return _this;
    }
    /**
   * The identifier for the blank node
   */ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(BlankNode, [
        {
            key: "id",
            get: function get() {
                return this.value;
            },
            set: function set(value) {
                this.value = value;
            }
        },
        {
            key: "compareTerm",
            value: function compareTerm(other) {
                if (this.classOrder < other.classOrder) return -1;
                if (this.classOrder > other.classOrder) return 1;
                if (this.id < other.id) return -1;
                if (this.id > other.id) return 1;
                return 0;
            }
        },
        {
            key: "copy",
            value: function copy(formula) {
                // depends on the formula
                var bnodeNew = new BlankNode();
                formula.copyTo(this, bnodeNew);
                return bnodeNew;
            }
        },
        {
            key: "toCanonical",
            value: function toCanonical() {
                return BlankNode.NTAnonymousNodePrefix + this.value;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return BlankNode.NTAnonymousNodePrefix + this.id;
            }
        }
    ], [
        {
            key: "getId",
            value: function getId(id) {
                if (id) {
                    if (typeof id !== "string") throw new Error("Bad id argument to new blank node: " + id);
                    if (id.includes("#")) {
                        // Is a URI with hash fragment
                        var fragments = id.split("#");
                        return fragments[fragments.length - 1];
                    }
                    return id;
                }
                return "n" + BlankNode.nextId++;
            }
        }
    ]);
    return BlankNode;
}((0, $cdU35.default));
/**
 * The next unique identifier for blank nodes
 */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($d0a63e5194c4f691$export$2e2bcd8739ae039, "nextId", 0);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($d0a63e5194c4f691$export$2e2bcd8739ae039, "NTAnonymousNodePrefix", "_:");




var $b8259e79f5c77a6f$exports = {};
function $b8259e79f5c77a6f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $b8259e79f5c77a6f$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $b8259e79f5c77a6f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $b8259e79f5c77a6f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
$b8259e79f5c77a6f$exports = $b8259e79f5c77a6f$var$_asyncToGenerator, $b8259e79f5c77a6f$exports.__esModule = true, $b8259e79f5c77a6f$exports["default"] = $b8259e79f5c77a6f$exports;



var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $lR7jo = parcelRequire("lR7jo");

var $fu0YK = parcelRequire("fu0YK");

var $g5Zhu = parcelRequire("g5Zhu");
var $c6598bdb60f83fe0$exports = {};
// TODO(Babel 8): Remove this file.

var $c6598bdb60f83fe0$var$runtime = (parcelRequire("8HV7i"))();
$c6598bdb60f83fe0$exports = $c6598bdb60f83fe0$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $c6598bdb60f83fe0$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $c6598bdb60f83fe0$var$runtime;
    else Function("r", "regeneratorRuntime = r")($c6598bdb60f83fe0$var$runtime);
}



var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $6zC7B = parcelRequire("6zC7B");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $g5Zhu = parcelRequire("g5Zhu");

var $aZYlt = parcelRequire("aZYlt");
// Prevents circular dependencies between data-factory-internal and statement

var $99pVg = parcelRequire("99pVg");
var $471ea8b4e912e4b1$export$fb7535ed90405da0 = "chrome:theSession";
var $471ea8b4e912e4b1$export$cbca1d642dcb0c4c = new (0, $99pVg.default)($471ea8b4e912e4b1$export$fb7535ed90405da0);



var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $6zC7B = parcelRequire("6zC7B");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $g5Zhu = parcelRequire("g5Zhu");

var $aZYlt = parcelRequire("aZYlt");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $6zC7B = parcelRequire("6zC7B");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $g5Zhu = parcelRequire("g5Zhu");


var $aZYlt = parcelRequire("aZYlt");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $6zC7B = parcelRequire("6zC7B");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $g5Zhu = parcelRequire("g5Zhu");

var $aZYlt = parcelRequire("aZYlt");

var $99pVg = parcelRequire("99pVg");

var $cdU35 = parcelRequire("cdU35");

var $8RKL2 = parcelRequire("8RKL2");

var $gCJkd = parcelRequire("gCJkd");

var $99pVg = parcelRequire("99pVg");
var $f42e02919a7ca0a9$export$2e2bcd8739ae039 = {
    boolean: new (0, $99pVg.default)("http://www.w3.org/2001/XMLSchema#boolean"),
    dateTime: new (0, $99pVg.default)("http://www.w3.org/2001/XMLSchema#dateTime"),
    decimal: new (0, $99pVg.default)("http://www.w3.org/2001/XMLSchema#decimal"),
    double: new (0, $99pVg.default)("http://www.w3.org/2001/XMLSchema#double"),
    integer: new (0, $99pVg.default)("http://www.w3.org/2001/XMLSchema#integer"),
    langString: new (0, $99pVg.default)("http://www.w3.org/1999/02/22-rdf-syntax-ns#langString"),
    string: new (0, $99pVg.default)("http://www.w3.org/2001/XMLSchema#string")
};


function $68c7b1d3a79e3436$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $68c7b1d3a79e3436$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $68c7b1d3a79e3436$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * An RDF literal, containing some value which isn't expressed as an IRI.
 * @link https://rdf.js.org/data-model-spec/#literal-interface
 */ var $68c7b1d3a79e3436$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Node) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Literal, _Node);
    var _super = $68c7b1d3a79e3436$var$_createSuper(Literal);
    /**
   * Initializes a literal
   * @param value - The literal's lexical value
   * @param language - The language for the literal. Defaults to ''.
   * @param datatype - The literal's datatype as a named node. Defaults to xsd:string.
   */ function Literal(value, language, datatype) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Literal);
        _this = _super.call(this, value);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "termType", (0, $8RKL2.LiteralTermType));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "classOrder", (0, $aZYlt.default).Literal);
        /**
     * The literal's datatype as a named node
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "datatype", (0, $f42e02919a7ca0a9$export$2e2bcd8739ae039).string);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "isVar", 0);
        /**
     * The language for the literal
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "language", "");
        if (language) {
            _this.language = language;
            _this.datatype = (0, $f42e02919a7ca0a9$export$2e2bcd8739ae039).langString;
        } else if (datatype) _this.datatype = (0, $99pVg.default).fromValue(datatype);
        else _this.datatype = (0, $f42e02919a7ca0a9$export$2e2bcd8739ae039).string;
        return _this;
    }
    /**
   * Gets a copy of this literal
   */ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Literal, [
        {
            key: "copy",
            value: function copy() {
                return new Literal(this.value, this.lang, this.datatype);
            }
        },
        {
            key: "equals",
            value: function equals(other) {
                if (!other) return false;
                return this.termType === other.termType && this.value === other.value && this.language === other.language && (!this.datatype && !other.datatype || this.datatype && this.datatype.equals(other.datatype));
            }
        },
        {
            key: "lang",
            get: function get() {
                return this.language;
            },
            set: function set(language) {
                this.language = language || "";
            }
        },
        {
            key: "toNT",
            value: function toNT() {
                return Literal.toNT(this);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "" + this.value;
            }
        }
    ], [
        {
            key: "toNT",
            value: function toNT(literal) {
                if (typeof literal.value === "number") return "" + literal.value;
                else if (typeof literal.value !== "string") throw new Error("Value of RDF literal is not string or number: " + literal.value);
                var str = literal.value;
                // #x22 ("), #x5C (\), #x0A (\n) and #xD (\r) are disallowed and need to be replaced
                // see https://www.w3.org/TR/n-triples/#grammar-production-STRING_LITERAL_QUOTE
                str = str.replace(/\\/g, "\\\\");
                str = str.replace(/\"/g, '\\"');
                str = str.replace(/\n/g, "\\n");
                str = str.replace(/\r/g, "\\r");
                str = '"' + str + '"';
                if (literal.language) str += "@" + literal.language;
                else if (!literal.datatype.equals((0, $f42e02919a7ca0a9$export$2e2bcd8739ae039).string)) // Only add datatype if it's not a string
                str += "^^" + literal.datatype.toCanonical();
                return str;
            }
        },
        {
            key: "fromBoolean",
            value: function fromBoolean(value) {
                var strValue = value ? "1" : "0";
                return new Literal(strValue, null, (0, $f42e02919a7ca0a9$export$2e2bcd8739ae039).boolean);
            }
        },
        {
            key: "fromDate",
            value: function fromDate(value) {
                if (!(value instanceof Date)) throw new TypeError("Invalid argument to Literal.fromDate()");
                var d2 = function d2(x) {
                    return ("" + (100 + x)).slice(1, 3);
                };
                var date = "" + value.getUTCFullYear() + "-" + d2(value.getUTCMonth() + 1) + "-" + d2(value.getUTCDate()) + "T" + d2(value.getUTCHours()) + ":" + d2(value.getUTCMinutes()) + ":" + d2(value.getUTCSeconds()) + "Z";
                return new Literal(date, null, (0, $f42e02919a7ca0a9$export$2e2bcd8739ae039).dateTime);
            }
        },
        {
            key: "fromNumber",
            value: function fromNumber(value) {
                if (typeof value !== "number") throw new TypeError("Invalid argument to Literal.fromNumber()");
                var datatype;
                var strValue = value.toString();
                if (strValue.indexOf("e") < 0 && Math.abs(value) <= Number.MAX_SAFE_INTEGER) datatype = Number.isInteger(value) ? (0, $f42e02919a7ca0a9$export$2e2bcd8739ae039).integer : (0, $f42e02919a7ca0a9$export$2e2bcd8739ae039).decimal;
                else datatype = (0, $f42e02919a7ca0a9$export$2e2bcd8739ae039).double;
                return new Literal(strValue, null, datatype);
            }
        },
        {
            key: "fromValue",
            value: function fromValue(value) {
                if ((0, $gCJkd.isLiteral)(value)) return value;
                switch((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value)){
                    case "object":
                        if (value instanceof Date) return Literal.fromDate(value);
                    case "boolean":
                        return Literal.fromBoolean(value);
                    case "number":
                        return Literal.fromNumber(value);
                    case "string":
                        return new Literal(value);
                }
                throw new Error("Can't make literal from " + value + " of type " + (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value));
            }
        }
    ]);
    return Literal;
}((0, $cdU35.default));



var $cdU35 = parcelRequire("cdU35");

var $8RKL2 = parcelRequire("8RKL2");

var $gCJkd = parcelRequire("gCJkd");
function $619d91631affbf30$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $619d91631affbf30$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $619d91631affbf30$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $619d91631affbf30$export$5f36b26c3833b3ba(value) {
    if (typeof value === "undefined" || value === null) return value;
    if ((0, $gCJkd.isTerm)(value)) // a Node subclass or a Collection
    return value;
    if (Array.isArray(value)) return new $619d91631affbf30$export$2e2bcd8739ae039(value);
    return (0, $68c7b1d3a79e3436$export$2e2bcd8739ae039).fromValue(value);
}
/**
 * A collection of other RDF nodes
 *
 * Use generic T to control the contents of the array.
 */ var $619d91631affbf30$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Node) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Collection, _Node);
    var _super = $619d91631affbf30$var$_createSuper(Collection);
    function Collection(initial) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Collection);
        _this = _super.call(this, ((0, $d0a63e5194c4f691$export$2e2bcd8739ae039).nextId++).toString());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "termType", (0, $8RKL2.CollectionTermType));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "classOrder", (0, $aZYlt.default).Collection);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "closed", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "compareTerm", (0, $d0a63e5194c4f691$export$2e2bcd8739ae039).prototype.compareTerm);
        /**
     * The nodes in this collection
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "elements", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "isVar", 0);
        if (initial && initial.length > 0) initial.forEach(function(element) {
            _this.elements.push($619d91631affbf30$export$5f36b26c3833b3ba(element));
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Collection, [
        {
            key: "id",
            get: function get() {
                return this.value;
            },
            set: function set(value) {
                this.value = value;
            }
        },
        {
            key: "append",
            value: function append(element) {
                return this.elements.push(element);
            }
        },
        {
            key: "close",
            value: function close() {
                this.closed = true;
                return this.closed;
            }
        },
        {
            key: "shift",
            value: function shift() {
                return this.elements.shift();
            }
        },
        {
            key: "substitute",
            value: function substitute(bindings) {
                var elementsCopy = this.elements.map(function(ea) {
                    return ea.substitute(bindings);
                });
                return new Collection(elementsCopy);
            }
        },
        {
            key: "toNT",
            value: function toNT() {
                return Collection.toNT(this);
            }
        },
        {
            key: "toString",
            value: /**
     * Serializes the collection to a string.
     * Surrounded by (parentheses) and separated by spaces.
     */ function toString() {
                return "(" + this.elements.join(" ") + ")";
            }
        },
        {
            key: "unshift",
            value: function unshift(element) {
                return this.elements.unshift(element);
            }
        }
    ], [
        {
            key: "toNT",
            value: function toNT(collection) {
                // return '(' + collection.elements.map(x => x.toNT()).join(' ') + ')'
                // As lists are not in NT and toNT() must be a reversible function, we kludge it for a list
                return (0, $d0a63e5194c4f691$export$2e2bcd8739ae039).NTAnonymousNodePrefix + collection.id;
            }
        }
    ]);
    return Collection;
}((0, $cdU35.default));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($619d91631affbf30$export$2e2bcd8739ae039, "termType", (0, $8RKL2.CollectionTermType));



var $g5Zhu = parcelRequire("g5Zhu");



var $99pVg = parcelRequire("99pVg");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $cdU35 = parcelRequire("cdU35");

var $8RKL2 = parcelRequire("8RKL2");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $6zC7B = parcelRequire("6zC7B");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $g5Zhu = parcelRequire("g5Zhu");

var $cdU35 = parcelRequire("cdU35");

var $8RKL2 = parcelRequire("8RKL2");

function $cdeb561dfecfaa8a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $cdeb561dfecfaa8a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $cdeb561dfecfaa8a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/** The RDF default graph */ var $cdeb561dfecfaa8a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Node) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(DefaultGraph, _Node);
    var _super = $cdeb561dfecfaa8a$var$_createSuper(DefaultGraph);
    function DefaultGraph() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, DefaultGraph);
        _this = _super.call(this, "");
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "value", "");
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "termType", (0, $8RKL2.DefaultGraphTermType));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "uri", (0, $471ea8b4e912e4b1$export$fb7535ed90405da0));
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(DefaultGraph, [
        {
            key: "toCanonical",
            value: function toCanonical() {
                return this.value;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "DefaultGraph";
            }
        }
    ]);
    return DefaultGraph;
}((0, $cdU35.default));
function $cdeb561dfecfaa8a$export$1a29e0fa6b36b0c8(object) {
    return !!object && object.termType === (0, $8RKL2.DefaultGraphTermType);
}


var $00d766c69dbb3a6e$var$defaultGraph = new (0, $cdeb561dfecfaa8a$export$2e2bcd8739ae039)();
/** A Statement represents an RDF Triple or Quad. */ var $00d766c69dbb3a6e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Construct a new statement
   *
   * @param subject - The subject of the triple.  What the fact is about
   * @param predicate - The relationship which is asserted between the subject and object
   * @param object - The thing or data value which is asserted to be related to the subject
   * @param {NamedNode} graph - The document where the triple is or was or will be stored on the web.
   *
   * The graph param is a named node of the document in which the triple when it is stored
   *  on the web. It exists because when you have read data from various places in the web,
   *  the “graph” tells you _why_ you have the triple. (At the moment, it is just the
   *  document, in future it could be an inference step)
   *
   * When you do UpdateManager.update() then the graph’s of all the statements must be the same,
   *  and give the document you are patching. In future, we may have a more
   *  powerful update() which can update more than one document.
   */ function Statement(subject, predicate, object, graph) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Statement);
        /** The subject of the triple.  What the Statement is about. */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "subject", void 0);
        /** The relationship which is asserted between the subject and object */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "predicate", void 0);
        /** The thing or data value which is asserted to be related to the subject */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "object", void 0);
        /**
     * The graph param is a named node of the document in which the triple when
     *  it is stored on the web.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "graph", void 0);
        this.subject = (0, $cdU35.default).fromValue(subject);
        this.predicate = (0, $cdU35.default).fromValue(predicate);
        this.object = (0, $cdU35.default).fromValue(object);
        this.graph = graph == undefined ? $00d766c69dbb3a6e$var$defaultGraph : (0, $cdU35.default).fromValue(graph); // property currently used by rdflib
    }
    /** Alias for graph, favored by Tim */ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Statement, [
        {
            key: "why",
            get: function get() {
                return this.graph;
            },
            set: function set(g) {
                this.graph = g;
            }
        },
        {
            key: "equals",
            value: function equals(other) {
                return other.subject.equals(this.subject) && other.predicate.equals(this.predicate) && other.object.equals(this.object) && other.graph.equals(this.graph);
            }
        },
        {
            key: "substitute",
            value: function substitute(bindings) {
                var y = new Statement(this.subject.substitute(bindings), this.predicate.substitute(bindings), this.object.substitute(bindings), (0, $cdeb561dfecfaa8a$export$1a29e0fa6b36b0c8)(this.graph) ? this.graph : this.graph.substitute(bindings)); // 2016
                // console.log('@@@ statement substitute:' + y)
                return y;
            }
        },
        {
            key: "toCanonical",
            value: function toCanonical() {
                var terms = [
                    this.subject.toCanonical(),
                    this.predicate.toCanonical(),
                    this.object.toCanonical()
                ];
                if (this.graph && this.graph.termType !== (0, $8RKL2.DefaultGraphTermType)) terms.push(this.graph.toCanonical());
                return terms.join(" ") + " .";
            }
        },
        {
            key: "toNT",
            value: function toNT() {
                return [
                    this.subject.toNT(),
                    this.predicate.toNT(),
                    this.object.toNT()
                ].join(" ") + " .";
            }
        },
        {
            key: "toNQ",
            value: function toNQ() {
                return [
                    this.subject.toNT(),
                    this.predicate.toNT(),
                    this.object.toNT(),
                    (0, $cdeb561dfecfaa8a$export$1a29e0fa6b36b0c8)(this.graph) ? "" : this.graph.toNT()
                ].join(" ") + " .";
            }
        },
        {
            key: "toString",
            value: function toString() {
                /*
      return [
        this.subject.toString(),
        this.predicate.toString(),
        this.object.toString(),
      ].join(' ') + ' .'
      */ return this.toNT();
            }
        }
    ]);
    return Statement;
}();



var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $6zC7B = parcelRequire("6zC7B");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $g5Zhu = parcelRequire("g5Zhu");

var $aZYlt = parcelRequire("aZYlt");

var $cdU35 = parcelRequire("cdU35");

var $8RKL2 = parcelRequire("8RKL2");

var $4Q80K = parcelRequire("4Q80K");
function $b7a48305c1700eec$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b7a48305c1700eec$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $b7a48305c1700eec$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
* Variables are placeholders used in patterns to be matched.
* In cwm they are symbols which are the formula's list of quantified variables.
* In sparql they are not visibly URIs.  Here we compromise, by having
* a common special base URI for variables. Their names are uris,
* but the ? notation has an implicit base uri of 'varid:'
*/ var $b7a48305c1700eec$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Node) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Variable, _Node);
    var _super = $b7a48305c1700eec$var$_createSuper(Variable);
    /**
   * Initializes this variable
   * @param name The variable's name
   */ function Variable() {
        var _this;
        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Variable);
        _this = _super.call(this, name);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "termType", (0, $8RKL2.VariableTermType));
        /** The base string for a variable's name */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "base", "varid:");
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "classOrder", (0, $aZYlt.default).Variable);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "isVar", 1);
        /** The unique identifier of this variable */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "uri", void 0);
        _this.base = "varid:";
        _this.uri = $4Q80K.join(name, _this.base);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Variable, [
        {
            key: "equals",
            value: function equals(other) {
                if (!other) return false;
                return this.termType === other.termType && this.value === other.value;
            }
        },
        {
            key: "hashString",
            value: function hashString() {
                return this.toString();
            }
        },
        {
            key: "substitute",
            value: function substitute(bindings) {
                var ref;
                return (ref = bindings[this.toNT()]) != null ? ref : this;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return Variable.toString(this);
            }
        }
    ], [
        {
            key: "toString",
            value: function toString(variable) {
                if (variable.uri.slice(0, variable.base.length) === variable.base) return "?".concat(variable.uri.slice(variable.base.length));
                return "?".concat(variable.uri);
            }
        }
    ]);
    return Variable;
}((0, $cdU35.default));



var $8RKL2 = parcelRequire("8RKL2");

/** A set of features that may be supported by a Data Factory */ var $03d9b46807fe65b2$export$6e91cf7616333d5 = /*#__PURE__*/ function(Feature) {
    Feature["collections"] = "COLLECTIONS";
    Feature["defaultGraphType"] = "DEFAULT_GRAPH_TYPE";
    Feature["equalsMethod"] = "EQUALS_METHOD";
    Feature["id"] = "ID";
    Feature["identity"] = "IDENTITY";
    Feature["reversibleId"] = "REVERSIBLE_ID";
    Feature["variableType"] = "VARIABLE_TYPE";
    return Feature;
}({}); /**
 * Defines a DataFactory as used in rdflib, based on the RDF/JS: Data model specification,
 * but with additional extensions
 *
 * bnIndex is optional but useful.
 */ 



var $gCJkd = parcelRequire("gCJkd");

var $158d84b4866fe33e$var$_supports;
/**
 * Gets the default graph
 */ var $158d84b4866fe33e$var$_defaultGraph = new (0, $cdeb561dfecfaa8a$export$2e2bcd8739ae039)();
/** A basic internal RDFlib datafactory, which does not support Collections  */ var $158d84b4866fe33e$var$CanonicalDataFactory = {
    supports: ($158d84b4866fe33e$var$_supports = {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($158d84b4866fe33e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).collections, false), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($158d84b4866fe33e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).defaultGraphType, false), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($158d84b4866fe33e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).equalsMethod, true), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($158d84b4866fe33e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).identity, false), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($158d84b4866fe33e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).id, true), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($158d84b4866fe33e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).reversibleId, false), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($158d84b4866fe33e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).variableType, true), $158d84b4866fe33e$var$_supports),
    /**
   * Creates a new blank node
   * @param value - The blank node's identifier
   */ blankNode: function blankNode(value) {
        return new (0, $d0a63e5194c4f691$export$2e2bcd8739ae039)(value);
    },
    defaultGraph: function defaultGraph() {
        return $158d84b4866fe33e$var$_defaultGraph;
    },
    /**
   * Compares to (rdf) objects for equality.
   */ equals: function equals(a, b) {
        if (a === b || !a || !b) return true;
        if ((0, $gCJkd.isQuad)(a) || (0, $gCJkd.isQuad)(b)) {
            if ((0, $gCJkd.isQuad)(a) && (0, $gCJkd.isQuad)(b)) return this.equals(a.subject, b.subject) && this.equals(a.predicate, b.predicate) && this.equals(a.object, b.object) && this.equals(a.graph, b.graph);
            return false;
        }
        if ((0, $gCJkd.isTerm)(a) && (0, $gCJkd.isTerm)(b)) return this.id(a) === this.id(b);
        return false;
    },
    /**
   * Generates a uniquely identifiably *idempotent* string for the given {term}.
   *
   * Equivalent to [[Term.hashString]]
   *
   * @example Use this to associate data with a term in an object
   *   { obj[id(term)] = "myData" }
   */ id: function id(term) {
        if (!term) return "undefined";
        if ((0, $gCJkd.isQuad)(term)) return this.quadToNQ(term);
        switch(term.termType){
            case 0, $8RKL2.DefaultGraphTermType:
                return "defaultGraph";
            case 0, $8RKL2.VariableTermType:
                return (0, $b7a48305c1700eec$export$2e2bcd8739ae039).toString(term);
            default:
                var nq = this.termToNQ(term);
                if (nq) return nq;
                throw new Error("Can't id term with type '".concat(term.termType, "'"));
        }
    },
    isQuad: function isQuad(obj) {
        return obj instanceof (0, $00d766c69dbb3a6e$export$2e2bcd8739ae039);
    },
    /**
   * Creates a new literal node. Does some JS literal parsing for ease of use.
   * @param value - The lexical value
   * @param languageOrDatatype - Either the language or the datatype
   */ literal: function literal(value, languageOrDatatype) {
        if (typeof value !== "string" && !languageOrDatatype) return (0, $68c7b1d3a79e3436$export$2e2bcd8739ae039).fromValue(value);
        var strValue = typeof value === "string" ? value : "" + value;
        if (typeof languageOrDatatype === "string") {
            if (languageOrDatatype.indexOf(":") === -1) return new (0, $68c7b1d3a79e3436$export$2e2bcd8739ae039)(strValue, languageOrDatatype);
            else return new (0, $68c7b1d3a79e3436$export$2e2bcd8739ae039)(strValue, null, this.namedNode(languageOrDatatype));
        } else return new (0, $68c7b1d3a79e3436$export$2e2bcd8739ae039)(strValue, null, languageOrDatatype);
    },
    /**
   * Creates a new named node
   * @param value - The new named node
   */ namedNode: function namedNode(value) {
        return new (0, $99pVg.default)(value);
    },
    /**
   * Creates a new statement
   * @param subject - The subject
   * @param predicate - The predicate
   * @param object - The object
   * @param graph - The containing graph
   */ quad: function quad(subject, predicate, object, graph) {
        return new (0, $00d766c69dbb3a6e$export$2e2bcd8739ae039)(subject, predicate, object, graph || $158d84b4866fe33e$var$_defaultGraph);
    },
    /**
   * Creates a new statement
   * @param subject - The subject
   * @param predicate - The predicate
   * @param object - The object
   * @param graph - The containing graph
   */ triple: function triple(subject, predicate, object, graph) {
        return this.quad(subject, predicate, object, graph);
    },
    quadToNQ: function quadToNQ(q) {
        return "".concat(this.termToNQ(q.subject), " ").concat(this.termToNQ(q.predicate), " ").concat(this.termToNQ(q.object), " ").concat(this.termToNQ(q.graph), " .");
    },
    /** Stringify a {term} to n-quads serialization. */ termToNQ: function termToNQ(term) {
        var _this = this;
        switch(term.termType){
            case 0, $8RKL2.BlankNodeTermType:
                return "_:" + term.value;
            case 0, $8RKL2.DefaultGraphTermType:
                return "";
            case 0, $8RKL2.EmptyTermType:
                return "<http://www.w3.org/1999/02/22-rdf-syntax-ns#nil>";
            case 0, $8RKL2.LiteralTermType:
                return (0, $68c7b1d3a79e3436$export$2e2bcd8739ae039).toNT(term);
            case 0, $8RKL2.GraphTermType:
            case 0, $8RKL2.NamedNodeTermType:
                return "<" + term.value + ">";
            case 0, $8RKL2.CollectionTermType:
                return "(" + term.elements.map(function(t) {
                    return _this.termToNQ(t);
                }).join(" ") + ")";
            default:
                throw new Error("Can't serialize nonstandard term type (was '".concat(term.termType, "')"));
        }
    },
    /** Convert an rdf object (term or quad) to n-quads serialization. */ toNQ: function toNQ(term) {
        if (this.isQuad(term)) return this.quadToNQ(term);
        return this.termToNQ(term);
    },
    /**
   * Creates a new variable
   * @param name - The name for the variable
   */ variable: function variable(name) {
        return new (0, $b7a48305c1700eec$export$2e2bcd8739ae039)(name);
    }
};
var /** Contains the factory methods as defined in the spec, plus id */ $158d84b4866fe33e$export$2e2bcd8739ae039 = $158d84b4866fe33e$var$CanonicalDataFactory;



var $kAE07 = parcelRequire("kAE07");


var $cdU35 = parcelRequire("cdU35");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");



var $4Q80K = parcelRequire("4Q80K");

var $23fob = parcelRequire("23fob");
var $4Q80K = parcelRequire("4Q80K");


function $c58a780548822e73$export$abafb17d1d8eb7fd() {
    var localFactory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $158d84b4866fe33e$export$2e2bcd8739ae039);
    return {
        boolean: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#boolean"),
        dateTime: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#dateTime"),
        decimal: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#decimal"),
        double: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#double"),
        integer: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#integer"),
        langString: localFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#langString"),
        string: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#string")
    };
}
var $c58a780548822e73$var$defaultXSD = $c58a780548822e73$export$abafb17d1d8eb7fd((0, $158d84b4866fe33e$export$2e2bcd8739ae039));
var $c58a780548822e73$export$2e2bcd8739ae039 = $c58a780548822e73$var$defaultXSD;


var $3f9355bcac0943b6$exports = {};
/**
 * Provides a way to access commonly used namespaces
 *
 * Usage:
 *
 *   ```
 *   const $rdf = require('rdflib'); //or any other RDF/JS-compatible library
 *   const ns = require('solid-namespace')($rdf);
 *   const store = $rdf.graph();
 *
 *   let me = ...;
 *   let name = store.any(me, ns.vcard(‘fn’)) || store.any(me, ns.foaf(‘name’));
 *   ```
 * @module vocab
 */ const $3f9355bcac0943b6$var$aliases = {
    acl: "http://www.w3.org/ns/auth/acl#",
    arg: "http://www.w3.org/ns/pim/arg#",
    as: "https://www.w3.org/ns/activitystreams#",
    cal: "http://www.w3.org/2002/12/cal/ical#",
    cert: "http://www.w3.org/ns/auth/cert#",
    contact: "http://www.w3.org/2000/10/swap/pim/contact#",
    dc: "http://purl.org/dc/elements/1.1/",
    dct: "http://purl.org/dc/terms/",
    doap: "http://usefulinc.com/ns/doap#",
    foaf: "http://xmlns.com/foaf/0.1/",
    geo: "http://www.w3.org/2003/01/geo/wgs84_pos#",
    gpx: "http://www.w3.org/ns/pim/gpx#",
    http: "http://www.w3.org/2007/ont/http#",
    httph: "http://www.w3.org/2007/ont/httph#",
    icalTZ: "http://www.w3.org/2002/12/cal/icaltzd#",
    ldp: "http://www.w3.org/ns/ldp#",
    link: "http://www.w3.org/2007/ont/link#",
    log: "http://www.w3.org/2000/10/swap/log#",
    meeting: "http://www.w3.org/ns/pim/meeting#",
    mo: "http://purl.org/ontology/mo/",
    org: "http://www.w3.org/ns/org#",
    owl: "http://www.w3.org/2002/07/owl#",
    pad: "http://www.w3.org/ns/pim/pad#",
    patch: "http://www.w3.org/ns/pim/patch#",
    prov: "http://www.w3.org/ns/prov#",
    qu: "http://www.w3.org/2000/10/swap/pim/qif#",
    trip: "http://www.w3.org/ns/pim/trip#",
    rdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    rdfs: "http://www.w3.org/2000/01/rdf-schema#",
    rss: "http://purl.org/rss/1.0/",
    sched: "http://www.w3.org/ns/pim/schedule#",
    schema: "http://schema.org/",
    sioc: "http://rdfs.org/sioc/ns#",
    solid: "http://www.w3.org/ns/solid/terms#",
    space: "http://www.w3.org/ns/pim/space#",
    stat: "http://www.w3.org/ns/posix/stat#",
    tab: "http://www.w3.org/2007/ont/link#",
    tabont: "http://www.w3.org/2007/ont/link#",
    ui: "http://www.w3.org/ns/ui#",
    vcard: "http://www.w3.org/2006/vcard/ns#",
    wf: "http://www.w3.org/2005/01/wf/flow#",
    xsd: "http://www.w3.org/2001/XMLSchema#",
    cco: "http://www.ontologyrepository.com/CommonCoreOntologies/",
    skos: "http://www.w3.org/2004/02/skos/core#",
    bookmark: "http://www.w3.org/2002/01/bookmark#",
    vann: "http://purl.org/vocab/vann/"
};
/**
 * @param [rdflib] {RDF} Optional RDF Library (such as rdflib.js or rdf-ext) to inject
 */ function $3f9355bcac0943b6$var$vocab(rdf = {
    namedNode: (u)=>u
}) {
    const namespaces = {};
    for(const alias in $3f9355bcac0943b6$var$aliases){
        const expansion = $3f9355bcac0943b6$var$aliases[alias];
        namespaces[alias] = function(localName = "") {
            return rdf.namedNode(expansion + localName);
        };
    }
    return namespaces;
}
$3f9355bcac0943b6$exports = $3f9355bcac0943b6$var$vocab;


var $4637181ac5e22c58$exports = {};

/*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */ (function(root, factory) {
    if (typeof define === "function" && define.amd) define([], factory);
    else if (0, $4637181ac5e22c58$exports) $4637181ac5e22c58$exports = factory();
    else root.ttl2jsonld = factory();
})($4637181ac5e22c58$exports, function() {
    "use strict";
    function peg$subclass(child, parent) {
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
    }
    function peg$SyntaxError(message, expected, found, location) {
        this.message = message;
        this.expected = expected;
        this.found = found;
        this.location = location;
        this.name = "SyntaxError";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, peg$SyntaxError);
    }
    peg$subclass(peg$SyntaxError, Error);
    peg$SyntaxError.buildMessage = function(expected, found) {
        var DESCRIBE_EXPECTATION_FNS = {
            literal: function(expectation) {
                return '"' + literalEscape(expectation.text) + '"';
            },
            "class": function(expectation) {
                var escapedParts = "", i;
                for(i = 0; i < expectation.parts.length; i++)escapedParts += expectation.parts[i] instanceof Array ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1]) : classEscape(expectation.parts[i]);
                return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
            },
            any: function(expectation) {
                return "any character";
            },
            end: function(expectation) {
                return "end of input";
            },
            other: function(expectation) {
                return expectation.description;
            }
        };
        function hex(ch) {
            return ch.charCodeAt(0).toString(16).toUpperCase();
        }
        function literalEscape(s) {
            return s.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
                return "\\x0" + hex(ch);
            }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
                return "\\x" + hex(ch);
            });
        }
        function classEscape(s) {
            return s.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
                return "\\x0" + hex(ch);
            }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
                return "\\x" + hex(ch);
            });
        }
        function describeExpectation(expectation) {
            return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
        }
        function describeExpected(expected) {
            var descriptions = new Array(expected.length), i, j;
            for(i = 0; i < expected.length; i++)descriptions[i] = describeExpectation(expected[i]);
            descriptions.sort();
            if (descriptions.length > 0) {
                for(i = 1, j = 1; i < descriptions.length; i++)if (descriptions[i - 1] !== descriptions[i]) {
                    descriptions[j] = descriptions[i];
                    j++;
                }
                descriptions.length = j;
            }
            switch(descriptions.length){
                case 1:
                    return descriptions[0];
                case 2:
                    return descriptions[0] + " or " + descriptions[1];
                default:
                    return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
            }
        }
        function describeFound(found) {
            return found ? '"' + literalEscape(found) + '"' : "end of input";
        }
        return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
    };
    function peg$parse(input, options) {
        options = options !== void 0 ? options : {};
        var peg$FAILED = {}, peg$startRuleFunctions = {
            turtleDoc: peg$parseturtleDoc
        }, peg$startRuleFunction = peg$parseturtleDoc, peg$c0 = function(statements) {
            var jsonld = context.toJSON();
            jsonld["@graph"] = [];
            statements.filter((a)=>Array.isArray(a)).forEach((a)=>{
                a.forEach((b)=>{
                    jsonld["@graph"].push(b);
                });
            });
            if (jsonld["@graph"].length === 1) {
                Object.assign(jsonld, jsonld["@graph"][0]);
                delete jsonld["@graph"];
            }
            return jsonld;
        }, peg$c1 = ".", peg$c2 = peg$literalExpectation(".", false), peg$c3 = function(a) {
            return a;
        }, peg$c4 = "#", peg$c5 = peg$literalExpectation("#", false), peg$c6 = /^[^\n]/, peg$c7 = peg$classExpectation([
            "\n"
        ], true, false), peg$c8 = "\n", peg$c9 = peg$literalExpectation("\n", false), peg$c10 = function(a) {
            return a.join("");
        }, peg$c11 = "@prefix", peg$c12 = peg$literalExpectation("@prefix", false), peg$c13 = function(a, b) {
            context.addPrefix(a === "" ? "0" : a, b);
            return {};
        }, peg$c14 = "@base", peg$c15 = peg$literalExpectation("@base", false), peg$c16 = function(a) {
            context.addBase(a);
            return {};
        }, peg$c17 = /^[Bb]/, peg$c18 = peg$classExpectation([
            "B",
            "b"
        ], false, false), peg$c19 = /^[Aa]/, peg$c20 = peg$classExpectation([
            "A",
            "a"
        ], false, false), peg$c21 = /^[Ss]/, peg$c22 = peg$classExpectation([
            "S",
            "s"
        ], false, false), peg$c23 = /^[Ee]/, peg$c24 = peg$classExpectation([
            "E",
            "e"
        ], false, false), peg$c25 = /^[Pp]/, peg$c26 = peg$classExpectation([
            "P",
            "p"
        ], false, false), peg$c27 = /^[Rr]/, peg$c28 = peg$classExpectation([
            "R",
            "r"
        ], false, false), peg$c29 = /^[Ff]/, peg$c30 = peg$classExpectation([
            "F",
            "f"
        ], false, false), peg$c31 = /^[Ii]/, peg$c32 = peg$classExpectation([
            "I",
            "i"
        ], false, false), peg$c33 = /^[Xx]/, peg$c34 = peg$classExpectation([
            "X",
            "x"
        ], false, false), peg$c35 = function(s, p) {
            var x = {};
            if (typeof s === "string" && s !== "[]") x["@id"] = s;
            else if (typeof s === "object") Object.assign(x, s);
            if (p) Object.assign(x, p);
            return [
                x
            ];
        }, peg$c36 = function(s, p) {
            var x = {};
            if (s) Object.assign(x, s);
            if (p) Object.assign(x, p);
            return [
                x
            ];
        }, peg$c37 = ";", peg$c38 = peg$literalExpectation(";", false), peg$c39 = function(a, b, e, f) {
            var x = {};
            x[e] = f;
            return x;
        }, peg$c40 = function(a, b, d) {
            return d;
        }, peg$c41 = function(a, b, c) {
            var x = {};
            c.unshift(createObject(a, b));
            c.forEach((t)=>{
                if (!t) return;
                Object.keys(t).forEach((key)=>{
                    t[key].forEach((val)=>{
                        if (key === "@type" && val["@id"] !== undefined) val = val["@id"];
                        if (x[key] === undefined) x[key] = val;
                        else if (Array.isArray(x[key])) x[key].push(val);
                        else x[key] = [
                            x[key],
                            val
                        ];
                    });
                });
            });
            return x;
        }, peg$c42 = ",", peg$c43 = peg$literalExpectation(",", false), peg$c44 = function(a, c) {
            return c;
        }, peg$c45 = function(a, b) {
            b.unshift(a);
            return b;
        }, peg$c46 = "a", peg$c47 = peg$literalExpectation("a", false), peg$c48 = function() {
            return "@type";
        }, peg$c49 = function(a) {
            return expandList(a, true);
        }, peg$c50 = function(a) {
            return expandList(a, false);
        }, peg$c51 = function(a) {
            return a === "[]" ? {} : {
                "@id": a
            };
        }, peg$c52 = function(a) {
            return {
                "@id": a
            };
        }, peg$c53 = "[", peg$c54 = peg$literalExpectation("[", false), peg$c55 = "]", peg$c56 = peg$literalExpectation("]", false), peg$c57 = "(", peg$c58 = peg$literalExpectation("(", false), peg$c59 = ")", peg$c60 = peg$literalExpectation(")", false), peg$c61 = function(a) {
            return {
                "@list": a
            };
        }, peg$c62 = function(a, b) {
            return {
                "@value": a,
                "@language": b
            };
        }, peg$c63 = "^^", peg$c64 = peg$literalExpectation("^^", false), peg$c65 = function(a, b) {
            if (b === "http://www.w3.org/2001/XMLSchema#boolean" && a === "true") return true;
            if (b === "http://www.w3.org/2001/XMLSchema#boolean" && a === "false") return false;
            if (b === "http://www.w3.org/2001/XMLSchema#integer") return parseInt(a);
            if (b === "http://www.w3.org/2001/XMLSchema#double") return parseFloat(a);
            const uri = context.resolve(b, true);
            if (uri) {
                const prefix = b.split(":")[0];
                if (uri === "http://www.w3.org/2001/XMLSchema#boolean" && a === "true") {
                    context.decrement(prefix);
                    return true;
                }
                if (uri === "http://www.w3.org/2001/XMLSchema#boolean" && a === "false") {
                    context.decrement(prefix);
                    return false;
                }
                if (uri === "http://www.w3.org/2001/XMLSchema#integer") {
                    context.decrement(prefix);
                    return parseInt(a);
                }
                if (uri === "http://www.w3.org/2001/XMLSchema#double") {
                    context.decrement(prefix);
                    return parseFloat(a);
                }
            }
            return {
                "@value": a,
                "@type": b
            };
        }, peg$c66 = "true", peg$c67 = peg$literalExpectation("true", false), peg$c68 = function() {
            return true;
        }, peg$c69 = "false", peg$c70 = peg$literalExpectation("false", false), peg$c71 = function() {
            return false;
        }, peg$c72 = function(a) {
            return a + ":";
        }, peg$c73 = "<", peg$c74 = peg$literalExpectation("<", false), peg$c75 = /^[^\0- <>"{}|\^`\\]/, peg$c76 = peg$classExpectation([
            [
                "\0",
                " "
            ],
            "<",
            ">",
            '"',
            "{",
            "}",
            "|",
            "^",
            "`",
            "\\"
        ], true, false), peg$c77 = ">", peg$c78 = peg$literalExpectation(">", false), peg$c79 = function(a) {
            const decoded = a.map((s)=>{
                if (0x10000 <= s.codePointAt(0) && s.codePointAt(0) <= 0xeffff) return "a";
                if (s.length === 1) return s;
                if (s.length === 6) return String.fromCharCode("0x" + s.substring(2));
                if (s.length === 10) return String.fromCodePoint("0x" + s.substring(2));
                return s;
            }).join("");
            if (decoded.match(/^[^\u0000-\u0020<>"{}|^`\\]*$/)) {
                var join = a.join("");
                try {
                    return context.resolve(join);
                } catch (e) {
                    error("Invalid IRIREF " + join);
                }
            } else error("Invalid IRIREF " + a.join("") + " / " + decoded);
        }, peg$c80 = ":", peg$c81 = peg$literalExpectation(":", false), peg$c82 = function(a) {
            a = a || "0";
            if (context.hasPrefix(a) === false) error("undefined prefix " + a);
            return a;
        }, peg$c83 = function(a) {
            return a || "";
        }, peg$c84 = function(a, b) {
            context.increment(a);
            return context.resolve(a + ":" + b);
        }, peg$c85 = "_:", peg$c86 = peg$literalExpectation("_:", false), peg$c87 = /^[0-9]/, peg$c88 = peg$classExpectation([
            [
                "0",
                "9"
            ]
        ], false, false), peg$c89 = "@", peg$c90 = peg$literalExpectation("@", false), peg$c91 = /^[a-zA-Z]/, peg$c92 = peg$classExpectation([
            [
                "a",
                "z"
            ],
            [
                "A",
                "Z"
            ]
        ], false, false), peg$c93 = "-", peg$c94 = peg$literalExpectation("-", false), peg$c95 = /^[a-zA-Z0-9]/, peg$c96 = peg$classExpectation([
            [
                "a",
                "z"
            ],
            [
                "A",
                "Z"
            ],
            [
                "0",
                "9"
            ]
        ], false, false), peg$c97 = function(a, s) {
            return "-" + s.join("");
        }, peg$c98 = function(a, b) {
            return a.join("") + b.join("");
        }, peg$c99 = /^[+\-]/, peg$c100 = peg$classExpectation([
            "+",
            "-"
        ], false, false), peg$c101 = function(a) {
            if (a.match(/^[0+][0-9]+$/)) return {
                "@value": a,
                "@type": "http://www.w3.org/2001/XMLSchema#integer"
            };
            return parseInt(a);
        }, peg$c102 = function(a) {
            return {
                "@value": a,
                "@type": "http://www.w3.org/2001/XMLSchema#decimal"
            };
        }, peg$c103 = function(a) {
            return {
                "@value": a,
                "@type": "http://www.w3.org/2001/XMLSchema#double"
            };
        }, peg$c104 = /^[eE]/, peg$c105 = peg$classExpectation([
            "e",
            "E"
        ], false, false), peg$c106 = '"', peg$c107 = peg$literalExpectation('"', false), peg$c108 = /^[^"\\\n\r]/, peg$c109 = peg$classExpectation([
            '"',
            "\\",
            "\n",
            "\r"
        ], true, false), peg$c110 = "'", peg$c111 = peg$literalExpectation("'", false), peg$c112 = /^[^'\\\n\r]/, peg$c113 = peg$classExpectation([
            "'",
            "\\",
            "\n",
            "\r"
        ], true, false), peg$c114 = "'''", peg$c115 = peg$literalExpectation("'''", false), peg$c116 = /^[^'\\]/, peg$c117 = peg$classExpectation([
            "'",
            "\\"
        ], true, false), peg$c118 = "''", peg$c119 = peg$literalExpectation("''", false), peg$c120 = function(head, a) {
            return "''" + a.join("");
        }, peg$c121 = function(head, a) {
            return "'" + a.join("");
        }, peg$c122 = function(head, body) {
            return head.join("") + body.join("");
        }, peg$c123 = '"""', peg$c124 = peg$literalExpectation('"""', false), peg$c125 = /^[^"\\]/, peg$c126 = peg$classExpectation([
            '"',
            "\\"
        ], true, false), peg$c127 = '""', peg$c128 = peg$literalExpectation('""', false), peg$c129 = function(head, a) {
            return '""' + a.join("");
        }, peg$c130 = function(head, a) {
            return '"' + a.join("");
        }, peg$c131 = "\\U", peg$c132 = peg$literalExpectation("\\U", false), peg$c133 = function(hex) {
            return String.fromCodePoint(parseInt(hex.join(""), 16));
        }, peg$c134 = "\\u", peg$c135 = peg$literalExpectation("\\u", false), peg$c136 = function(hex) {
            return String.fromCharCode(parseInt(hex.join(""), 16));
        }, peg$c137 = "\\t", peg$c138 = peg$literalExpectation("\\t", false), peg$c139 = function() {
            return "	";
        }, peg$c140 = "\\b", peg$c141 = peg$literalExpectation("\\b", false), peg$c142 = function() {
            return "\b";
        }, peg$c143 = "\\n", peg$c144 = peg$literalExpectation("\\n", false), peg$c145 = function() {
            return "\n";
        }, peg$c146 = "\\r", peg$c147 = peg$literalExpectation("\\r", false), peg$c148 = function() {
            return "\r";
        }, peg$c149 = "\\f", peg$c150 = peg$literalExpectation("\\f", false), peg$c151 = function() {
            return "\f";
        }, peg$c152 = '\\"', peg$c153 = peg$literalExpectation('\\"', false), peg$c154 = function() {
            return '"';
        }, peg$c155 = "\\'", peg$c156 = peg$literalExpectation("\\'", false), peg$c157 = function() {
            return "'";
        }, peg$c158 = "\\\\", peg$c159 = peg$literalExpectation("\\\\", false), peg$c160 = function() {
            return "\\";
        }, peg$c161 = /^[ \t\r\n]/, peg$c162 = peg$classExpectation([
            " ",
            "	",
            "\r",
            "\n"
        ], false, false), peg$c163 = function() {
            return "[]";
        }, peg$c164 = /^[\uD800-\uDBFF]/, peg$c165 = peg$classExpectation([
            [
                "\uD800",
                "\uDBFF"
            ]
        ], false, false), peg$c166 = /^[\uDC00-\uDFFF]/, peg$c167 = peg$classExpectation([
            [
                "\uDC00",
                "\uDFFF"
            ]
        ], false, false), peg$c168 = function(a, b) {
            return a + b;
        }, peg$c169 = /^[A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, peg$c170 = peg$classExpectation([
            [
                "A",
                "Z"
            ],
            [
                "a",
                "z"
            ],
            [
                "\xc0",
                "\xd6"
            ],
            [
                "\xd8",
                "\xf6"
            ],
            [
                "\xf8",
                "\u02FF"
            ],
            [
                "\u0370",
                "\u037D"
            ],
            [
                "\u037F",
                "\u1FFF"
            ],
            [
                "\u200C",
                "\u200D"
            ],
            [
                "\u2070",
                "\u218F"
            ],
            [
                "\u2C00",
                "\u2FEF"
            ],
            [
                "\u3001",
                "\uD7FF"
            ],
            [
                "\uF900",
                "\uFDCF"
            ],
            [
                "\uFDF0",
                "\uFFFD"
            ]
        ], false, false), peg$c171 = "_", peg$c172 = peg$literalExpectation("_", false), peg$c173 = "\xb7", peg$c174 = peg$literalExpectation("\xb7", false), peg$c175 = /^[\u0300-\u036F]/, peg$c176 = peg$classExpectation([
            [
                "\u0300",
                "\u036F"
            ]
        ], false, false), peg$c177 = /^[\u203F-\u2040]/, peg$c178 = peg$classExpectation([
            [
                "\u203F",
                "\u2040"
            ]
        ], false, false), peg$c179 = function(head, body, a, b) {
            return a.join("") + b.join("");
        }, peg$c180 = function(head, body, tail) {
            return head + body.join("") + tail.join("");
        }, peg$c181 = "%", peg$c182 = peg$literalExpectation("%", false), peg$c183 = /^[0-9A-Fa-f]/, peg$c184 = peg$classExpectation([
            [
                "0",
                "9"
            ],
            [
                "A",
                "F"
            ],
            [
                "a",
                "f"
            ]
        ], false, false), peg$c185 = "\\", peg$c186 = peg$literalExpectation("\\", false), peg$c187 = /^[_~.!$&'()*+,;=\/?#@%\-]/, peg$c188 = peg$classExpectation([
            "_",
            "~",
            ".",
            "!",
            "$",
            "&",
            "'",
            "(",
            ")",
            "*",
            "+",
            ",",
            ";",
            "=",
            "/",
            "?",
            "#",
            "@",
            "%",
            "-"
        ], false, false), peg$currPos = 0, peg$savedPos = 0, peg$posDetailsCache = [
            {
                line: 1,
                column: 1
            }
        ], peg$maxFailPos = 0, peg$maxFailExpected = [], peg$silentFails = 0, peg$result;
        if ("startRule" in options) {
            if (!(options.startRule in peg$startRuleFunctions)) throw new Error("Can't start parsing from rule \"" + options.startRule + '".');
            peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
        }
        function text() {
            return input.substring(peg$savedPos, peg$currPos);
        }
        function location() {
            return peg$computeLocation(peg$savedPos, peg$currPos);
        }
        function expected(description, location) {
            location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
            throw peg$buildStructuredError([
                peg$otherExpectation(description)
            ], input.substring(peg$savedPos, peg$currPos), location);
        }
        function error(message, location) {
            location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
            throw peg$buildSimpleError(message, location);
        }
        function peg$literalExpectation(text, ignoreCase) {
            return {
                type: "literal",
                text: text,
                ignoreCase: ignoreCase
            };
        }
        function peg$classExpectation(parts, inverted, ignoreCase) {
            return {
                type: "class",
                parts: parts,
                inverted: inverted,
                ignoreCase: ignoreCase
            };
        }
        function peg$anyExpectation() {
            return {
                type: "any"
            };
        }
        function peg$endExpectation() {
            return {
                type: "end"
            };
        }
        function peg$otherExpectation(description) {
            return {
                type: "other",
                description: description
            };
        }
        function peg$computePosDetails(pos) {
            var details = peg$posDetailsCache[pos], p;
            if (details) return details;
            else {
                p = pos - 1;
                while(!peg$posDetailsCache[p])p--;
                details = peg$posDetailsCache[p];
                details = {
                    line: details.line,
                    column: details.column
                };
                while(p < pos){
                    if (input.charCodeAt(p) === 10) {
                        details.line++;
                        details.column = 1;
                    } else details.column++;
                    p++;
                }
                peg$posDetailsCache[pos] = details;
                return details;
            }
        }
        function peg$computeLocation(startPos, endPos) {
            var startPosDetails = peg$computePosDetails(startPos), endPosDetails = peg$computePosDetails(endPos);
            return {
                start: {
                    offset: startPos,
                    line: startPosDetails.line,
                    column: startPosDetails.column
                },
                end: {
                    offset: endPos,
                    line: endPosDetails.line,
                    column: endPosDetails.column
                }
            };
        }
        function peg$fail(expected) {
            if (peg$currPos < peg$maxFailPos) return;
            if (peg$currPos > peg$maxFailPos) {
                peg$maxFailPos = peg$currPos;
                peg$maxFailExpected = [];
            }
            peg$maxFailExpected.push(expected);
        }
        function peg$buildSimpleError(message, location) {
            return new peg$SyntaxError(message, null, null, location);
        }
        function peg$buildStructuredError(expected, found, location) {
            return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
        }
        function peg$parseturtleDoc() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parsestatement();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parsestatement();
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parseIGNORE();
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    s3 = peg$parseIGNORE();
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c0(s1);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsestatement() {
            var s0, s1, s2, s3;
            s0 = peg$parsedirective();
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parsetriples();
                if (s1 !== peg$FAILED) {
                    s2 = [];
                    s3 = peg$parseIGNORE();
                    while(s3 !== peg$FAILED){
                        s2.push(s3);
                        s3 = peg$parseIGNORE();
                    }
                    if (s2 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 46) {
                            s3 = peg$c1;
                            peg$currPos++;
                        } else {
                            s3 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c2);
                        }
                        if (s3 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c3(s1);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            return s0;
        }
        function peg$parseCOMMENT() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 35) {
                s1 = peg$c4;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c5);
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                if (peg$c6.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c7);
                }
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    if (peg$c6.test(input.charAt(peg$currPos))) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c7);
                    }
                }
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 10) {
                        s3 = peg$c8;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c9);
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c10(s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseIGNORE() {
            var s0;
            s0 = peg$parseWS();
            if (s0 === peg$FAILED) s0 = peg$parseCOMMENT();
            return s0;
        }
        function peg$parsedirective() {
            var s0;
            s0 = peg$parseprefixID();
            if (s0 === peg$FAILED) {
                s0 = peg$parsebase();
                if (s0 === peg$FAILED) {
                    s0 = peg$parsesparqlPrefix();
                    if (s0 === peg$FAILED) s0 = peg$parsesparqlBase();
                }
            }
            return s0;
        }
        function peg$parseprefixID() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                if (input.substr(peg$currPos, 7) === peg$c11) {
                    s2 = peg$c11;
                    peg$currPos += 7;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c12);
                }
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$parseIGNORE();
                    while(s4 !== peg$FAILED){
                        s3.push(s4);
                        s4 = peg$parseIGNORE();
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parsePNAME_NS_NO_CHECK();
                        if (s4 !== peg$FAILED) {
                            s5 = [];
                            s6 = peg$parseIGNORE();
                            while(s6 !== peg$FAILED){
                                s5.push(s6);
                                s6 = peg$parseIGNORE();
                            }
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parseIRIREF();
                                if (s6 !== peg$FAILED) {
                                    s7 = [];
                                    s8 = peg$parseIGNORE();
                                    while(s8 !== peg$FAILED){
                                        s7.push(s8);
                                        s8 = peg$parseIGNORE();
                                    }
                                    if (s7 !== peg$FAILED) {
                                        if (input.charCodeAt(peg$currPos) === 46) {
                                            s8 = peg$c1;
                                            peg$currPos++;
                                        } else {
                                            s8 = peg$FAILED;
                                            if (peg$silentFails === 0) peg$fail(peg$c2);
                                        }
                                        if (s8 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s1 = peg$c13(s4, s6);
                                            s0 = s1;
                                        } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsebase() {
            var s0, s1, s2, s3, s4, s5, s6;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                if (input.substr(peg$currPos, 5) === peg$c14) {
                    s2 = peg$c14;
                    peg$currPos += 5;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c15);
                }
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$parseIGNORE();
                    while(s4 !== peg$FAILED){
                        s3.push(s4);
                        s4 = peg$parseIGNORE();
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parseIRIREF();
                        if (s4 !== peg$FAILED) {
                            s5 = [];
                            s6 = peg$parseIGNORE();
                            while(s6 !== peg$FAILED){
                                s5.push(s6);
                                s6 = peg$parseIGNORE();
                            }
                            if (s5 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 46) {
                                    s6 = peg$c1;
                                    peg$currPos++;
                                } else {
                                    s6 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c2);
                                }
                                if (s6 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c16(s4);
                                    s0 = s1;
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsesparqlBase() {
            var s0, s1, s2, s3, s4, s5, s6, s7;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                if (peg$c17.test(input.charAt(peg$currPos))) {
                    s2 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c18);
                }
                if (s2 !== peg$FAILED) {
                    if (peg$c19.test(input.charAt(peg$currPos))) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c20);
                    }
                    if (s3 !== peg$FAILED) {
                        if (peg$c21.test(input.charAt(peg$currPos))) {
                            s4 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s4 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c22);
                        }
                        if (s4 !== peg$FAILED) {
                            if (peg$c23.test(input.charAt(peg$currPos))) {
                                s5 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s5 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c24);
                            }
                            if (s5 !== peg$FAILED) {
                                s6 = [];
                                s7 = peg$parseIGNORE();
                                while(s7 !== peg$FAILED){
                                    s6.push(s7);
                                    s7 = peg$parseIGNORE();
                                }
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parseIRIREF();
                                    if (s7 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c16(s7);
                                        s0 = s1;
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsesparqlPrefix() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                if (peg$c25.test(input.charAt(peg$currPos))) {
                    s2 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c26);
                }
                if (s2 !== peg$FAILED) {
                    if (peg$c27.test(input.charAt(peg$currPos))) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c28);
                    }
                    if (s3 !== peg$FAILED) {
                        if (peg$c23.test(input.charAt(peg$currPos))) {
                            s4 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s4 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c24);
                        }
                        if (s4 !== peg$FAILED) {
                            if (peg$c29.test(input.charAt(peg$currPos))) {
                                s5 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s5 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c30);
                            }
                            if (s5 !== peg$FAILED) {
                                if (peg$c31.test(input.charAt(peg$currPos))) {
                                    s6 = input.charAt(peg$currPos);
                                    peg$currPos++;
                                } else {
                                    s6 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c32);
                                }
                                if (s6 !== peg$FAILED) {
                                    if (peg$c33.test(input.charAt(peg$currPos))) {
                                        s7 = input.charAt(peg$currPos);
                                        peg$currPos++;
                                    } else {
                                        s7 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c34);
                                    }
                                    if (s7 !== peg$FAILED) {
                                        s8 = [];
                                        s9 = peg$parseIGNORE();
                                        while(s9 !== peg$FAILED){
                                            s8.push(s9);
                                            s9 = peg$parseIGNORE();
                                        }
                                        if (s8 !== peg$FAILED) {
                                            s9 = peg$parsePNAME_NS_NO_CHECK();
                                            if (s9 !== peg$FAILED) {
                                                s10 = [];
                                                s11 = peg$parseIGNORE();
                                                while(s11 !== peg$FAILED){
                                                    s10.push(s11);
                                                    s11 = peg$parseIGNORE();
                                                }
                                                if (s10 !== peg$FAILED) {
                                                    s11 = peg$parseIRIREF();
                                                    if (s11 !== peg$FAILED) {
                                                        peg$savedPos = s0;
                                                        s1 = peg$c13(s9, s11);
                                                        s0 = s1;
                                                    } else {
                                                        peg$currPos = s0;
                                                        s0 = peg$FAILED;
                                                    }
                                                } else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                }
                                            } else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                            }
                                        } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsetriples() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = peg$parsesubject();
            if (s1 !== peg$FAILED) {
                s2 = peg$parsepredicateObjectList();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c35(s1, s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parseblankNodePropertyList();
                if (s1 !== peg$FAILED) {
                    s2 = peg$parsepredicateObjectList();
                    if (s2 === peg$FAILED) s2 = null;
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c36(s1, s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            return s0;
        }
        function peg$parsepredicateObjectList() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
            s0 = peg$currPos;
            s1 = peg$parseverb();
            if (s1 !== peg$FAILED) {
                s2 = peg$parseobjectList();
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$currPos;
                    s5 = [];
                    s6 = peg$parseIGNORE();
                    while(s6 !== peg$FAILED){
                        s5.push(s6);
                        s6 = peg$parseIGNORE();
                    }
                    if (s5 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 59) {
                            s6 = peg$c37;
                            peg$currPos++;
                        } else {
                            s6 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c38);
                        }
                        if (s6 !== peg$FAILED) {
                            s7 = peg$currPos;
                            s8 = peg$parseverb();
                            if (s8 !== peg$FAILED) {
                                s9 = peg$parseobjectList();
                                if (s9 !== peg$FAILED) {
                                    peg$savedPos = s7;
                                    s8 = peg$c39(s1, s2, s8, s9);
                                    s7 = s8;
                                } else {
                                    peg$currPos = s7;
                                    s7 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s7;
                                s7 = peg$FAILED;
                            }
                            if (s7 === peg$FAILED) s7 = null;
                            if (s7 !== peg$FAILED) {
                                peg$savedPos = s4;
                                s5 = peg$c40(s1, s2, s7);
                                s4 = s5;
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s4;
                        s4 = peg$FAILED;
                    }
                    while(s4 !== peg$FAILED){
                        s3.push(s4);
                        s4 = peg$currPos;
                        s5 = [];
                        s6 = peg$parseIGNORE();
                        while(s6 !== peg$FAILED){
                            s5.push(s6);
                            s6 = peg$parseIGNORE();
                        }
                        if (s5 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 59) {
                                s6 = peg$c37;
                                peg$currPos++;
                            } else {
                                s6 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c38);
                            }
                            if (s6 !== peg$FAILED) {
                                s7 = peg$currPos;
                                s8 = peg$parseverb();
                                if (s8 !== peg$FAILED) {
                                    s9 = peg$parseobjectList();
                                    if (s9 !== peg$FAILED) {
                                        peg$savedPos = s7;
                                        s8 = peg$c39(s1, s2, s8, s9);
                                        s7 = s8;
                                    } else {
                                        peg$currPos = s7;
                                        s7 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s7;
                                    s7 = peg$FAILED;
                                }
                                if (s7 === peg$FAILED) s7 = null;
                                if (s7 !== peg$FAILED) {
                                    peg$savedPos = s4;
                                    s5 = peg$c40(s1, s2, s7);
                                    s4 = s5;
                                } else {
                                    peg$currPos = s4;
                                    s4 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c41(s1, s2, s3);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseobjectList() {
            var s0, s1, s2, s3, s4, s5, s6;
            s0 = peg$currPos;
            s1 = peg$parseobject();
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$currPos;
                s4 = [];
                s5 = peg$parseIGNORE();
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    s5 = peg$parseIGNORE();
                }
                if (s4 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 44) {
                        s5 = peg$c42;
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c43);
                    }
                    if (s5 !== peg$FAILED) {
                        s6 = peg$parseobject();
                        if (s6 !== peg$FAILED) {
                            peg$savedPos = s3;
                            s4 = peg$c44(s1, s6);
                            s3 = s4;
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    s3 = peg$currPos;
                    s4 = [];
                    s5 = peg$parseIGNORE();
                    while(s5 !== peg$FAILED){
                        s4.push(s5);
                        s5 = peg$parseIGNORE();
                    }
                    if (s4 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 44) {
                            s5 = peg$c42;
                            peg$currPos++;
                        } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c43);
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parseobject();
                            if (s6 !== peg$FAILED) {
                                peg$savedPos = s3;
                                s4 = peg$c44(s1, s6);
                                s3 = s4;
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c45(s1, s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseverb() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = peg$parsepredicate();
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c3(s1);
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = [];
                s2 = peg$parseIGNORE();
                while(s2 !== peg$FAILED){
                    s1.push(s2);
                    s2 = peg$parseIGNORE();
                }
                if (s1 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 97) {
                        s2 = peg$c46;
                        peg$currPos++;
                    } else {
                        s2 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c47);
                    }
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c48();
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            return s0;
        }
        function peg$parsesubject() {
            var s0, s1;
            s0 = peg$currPos;
            s1 = peg$parsecollection();
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c49(s1);
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
                s0 = peg$parseBlankNode();
                if (s0 === peg$FAILED) s0 = peg$parseiri();
            }
            return s0;
        }
        function peg$parsepredicate() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parseiri();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c3(s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseobject() {
            var s0, s1;
            s0 = peg$parseliteral();
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parsecollection();
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c50(s1);
                }
                s0 = s1;
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    s1 = peg$parseBlankNode();
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c51(s1);
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        s1 = peg$parseblankNodePropertyList();
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c3(s1);
                        }
                        s0 = s1;
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            s1 = peg$parseiri();
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c52(s1);
                            }
                            s0 = s1;
                        }
                    }
                }
            }
            return s0;
        }
        function peg$parseliteral() {
            var s0;
            s0 = peg$parseRDFLiteral();
            if (s0 === peg$FAILED) {
                s0 = peg$parseNumericLiteral();
                if (s0 === peg$FAILED) s0 = peg$parseBooleanLiteral();
            }
            return s0;
        }
        function peg$parseblankNodePropertyList() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 91) {
                    s2 = peg$c53;
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c54);
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsepredicateObjectList();
                    if (s3 !== peg$FAILED) {
                        s4 = [];
                        s5 = peg$parseIGNORE();
                        while(s5 !== peg$FAILED){
                            s4.push(s5);
                            s5 = peg$parseIGNORE();
                        }
                        if (s4 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 93) {
                                s5 = peg$c55;
                                peg$currPos++;
                            } else {
                                s5 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c56);
                            }
                            if (s5 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c3(s3);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsecollection() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 40) {
                    s2 = peg$c57;
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c58);
                }
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$parseobject();
                    while(s4 !== peg$FAILED){
                        s3.push(s4);
                        s4 = peg$parseobject();
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = [];
                        s5 = peg$parseIGNORE();
                        while(s5 !== peg$FAILED){
                            s4.push(s5);
                            s5 = peg$parseIGNORE();
                        }
                        if (s4 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 41) {
                                s5 = peg$c59;
                                peg$currPos++;
                            } else {
                                s5 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c60);
                            }
                            if (s5 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c61(s3);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseNumericLiteral() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parseDOUBLE();
                if (s2 === peg$FAILED) {
                    s2 = peg$parseDECIMAL();
                    if (s2 === peg$FAILED) s2 = peg$parseINTEGER();
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c3(s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseRDFLiteral() {
            var s0, s1, s2, s3, s4, s5, s6;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parseString();
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$parseIGNORE();
                    while(s4 !== peg$FAILED){
                        s3.push(s4);
                        s4 = peg$parseIGNORE();
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parseLANGTAG();
                        if (s4 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c62(s2, s4);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = [];
                s2 = peg$parseIGNORE();
                while(s2 !== peg$FAILED){
                    s1.push(s2);
                    s2 = peg$parseIGNORE();
                }
                if (s1 !== peg$FAILED) {
                    s2 = peg$parseString();
                    if (s2 !== peg$FAILED) {
                        s3 = [];
                        s4 = peg$parseIGNORE();
                        while(s4 !== peg$FAILED){
                            s3.push(s4);
                            s4 = peg$parseIGNORE();
                        }
                        if (s3 !== peg$FAILED) {
                            if (input.substr(peg$currPos, 2) === peg$c63) {
                                s4 = peg$c63;
                                peg$currPos += 2;
                            } else {
                                s4 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c64);
                            }
                            if (s4 !== peg$FAILED) {
                                s5 = [];
                                s6 = peg$parseIGNORE();
                                while(s6 !== peg$FAILED){
                                    s5.push(s6);
                                    s6 = peg$parseIGNORE();
                                }
                                if (s5 !== peg$FAILED) {
                                    s6 = peg$parseiri();
                                    if (s6 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c65(s2, s6);
                                        s0 = s1;
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    s1 = [];
                    s2 = peg$parseIGNORE();
                    while(s2 !== peg$FAILED){
                        s1.push(s2);
                        s2 = peg$parseIGNORE();
                    }
                    if (s1 !== peg$FAILED) {
                        s2 = peg$parseString();
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c3(s2);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
            }
            return s0;
        }
        function peg$parseBooleanLiteral() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                if (input.substr(peg$currPos, 4) === peg$c66) {
                    s2 = peg$c66;
                    peg$currPos += 4;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c67);
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c68();
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = [];
                s2 = peg$parseIGNORE();
                while(s2 !== peg$FAILED){
                    s1.push(s2);
                    s2 = peg$parseIGNORE();
                }
                if (s1 !== peg$FAILED) {
                    if (input.substr(peg$currPos, 5) === peg$c69) {
                        s2 = peg$c69;
                        peg$currPos += 5;
                    } else {
                        s2 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c70);
                    }
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c71();
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            return s0;
        }
        function peg$parseString() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parseSTRING_LITERAL_LONG_SINGLE_QUOTE();
                if (s2 === peg$FAILED) {
                    s2 = peg$parseSTRING_LITERAL_LONG_QUOTE();
                    if (s2 === peg$FAILED) {
                        s2 = peg$parseSTRING_LITERAL_SINGLE_QUOTE();
                        if (s2 === peg$FAILED) s2 = peg$parseSTRING_LITERAL_QUOTE();
                    }
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c3(s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseiri() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parseIRIREF();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c3(s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = [];
                s2 = peg$parseIGNORE();
                while(s2 !== peg$FAILED){
                    s1.push(s2);
                    s2 = peg$parseIGNORE();
                }
                if (s1 !== peg$FAILED) {
                    s2 = peg$parsePrefixedName();
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c3(s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            return s0;
        }
        function peg$parsePrefixedName() {
            var s0, s1;
            s0 = peg$parsePNAME_LN();
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parsePNAME_NS();
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c72(s1);
                }
                s0 = s1;
            }
            return s0;
        }
        function peg$parseBlankNode() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parseBLANK_NODE_LABEL();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c3(s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = [];
                s2 = peg$parseIGNORE();
                while(s2 !== peg$FAILED){
                    s1.push(s2);
                    s2 = peg$parseIGNORE();
                }
                if (s1 !== peg$FAILED) {
                    s2 = peg$parseANON();
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c3(s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            return s0;
        }
        function peg$parseIRIREF() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 60) {
                s1 = peg$c73;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c74);
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                if (peg$c75.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c76);
                }
                if (s3 === peg$FAILED) s3 = peg$parseUCHAR();
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    if (peg$c75.test(input.charAt(peg$currPos))) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c76);
                    }
                    if (s3 === peg$FAILED) s3 = peg$parseUCHAR();
                }
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 62) {
                        s3 = peg$c77;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c78);
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c79(s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsePNAME_NS() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = peg$parsePN_PREFIX();
            if (s1 === peg$FAILED) s1 = null;
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 58) {
                    s2 = peg$c80;
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c81);
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c82(s1);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsePNAME_NS_NO_CHECK() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = peg$parsePN_PREFIX();
            if (s1 === peg$FAILED) s1 = null;
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 58) {
                    s2 = peg$c80;
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c81);
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c83(s1);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsePNAME_LN() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = peg$parsePNAME_NS();
            if (s1 !== peg$FAILED) {
                s2 = peg$parsePN_LOCAL();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c84(s1, s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseBLANK_NODE_LABEL() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
            s0 = peg$currPos;
            s1 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c85) {
                s2 = peg$c85;
                peg$currPos += 2;
            } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c86);
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parsePN_CHARS_U();
                if (s3 === peg$FAILED) {
                    if (peg$c87.test(input.charAt(peg$currPos))) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c88);
                    }
                }
                if (s3 !== peg$FAILED) {
                    s4 = [];
                    s5 = peg$parsePN_CHARS();
                    while(s5 !== peg$FAILED){
                        s4.push(s5);
                        s5 = peg$parsePN_CHARS();
                    }
                    if (s4 !== peg$FAILED) {
                        s5 = [];
                        s6 = peg$currPos;
                        s7 = [];
                        if (input.charCodeAt(peg$currPos) === 46) {
                            s8 = peg$c1;
                            peg$currPos++;
                        } else {
                            s8 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c2);
                        }
                        if (s8 !== peg$FAILED) while(s8 !== peg$FAILED){
                            s7.push(s8);
                            if (input.charCodeAt(peg$currPos) === 46) {
                                s8 = peg$c1;
                                peg$currPos++;
                            } else {
                                s8 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c2);
                            }
                        }
                        else s7 = peg$FAILED;
                        if (s7 !== peg$FAILED) {
                            s8 = [];
                            s9 = peg$parsePN_CHARS();
                            if (s9 !== peg$FAILED) while(s9 !== peg$FAILED){
                                s8.push(s9);
                                s9 = peg$parsePN_CHARS();
                            }
                            else s8 = peg$FAILED;
                            if (s8 !== peg$FAILED) {
                                s7 = [
                                    s7,
                                    s8
                                ];
                                s6 = s7;
                            } else {
                                peg$currPos = s6;
                                s6 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s6;
                            s6 = peg$FAILED;
                        }
                        while(s6 !== peg$FAILED){
                            s5.push(s6);
                            s6 = peg$currPos;
                            s7 = [];
                            if (input.charCodeAt(peg$currPos) === 46) {
                                s8 = peg$c1;
                                peg$currPos++;
                            } else {
                                s8 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c2);
                            }
                            if (s8 !== peg$FAILED) while(s8 !== peg$FAILED){
                                s7.push(s8);
                                if (input.charCodeAt(peg$currPos) === 46) {
                                    s8 = peg$c1;
                                    peg$currPos++;
                                } else {
                                    s8 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c2);
                                }
                            }
                            else s7 = peg$FAILED;
                            if (s7 !== peg$FAILED) {
                                s8 = [];
                                s9 = peg$parsePN_CHARS();
                                if (s9 !== peg$FAILED) while(s9 !== peg$FAILED){
                                    s8.push(s9);
                                    s9 = peg$parsePN_CHARS();
                                }
                                else s8 = peg$FAILED;
                                if (s8 !== peg$FAILED) {
                                    s7 = [
                                        s7,
                                        s8
                                    ];
                                    s6 = s7;
                                } else {
                                    peg$currPos = s6;
                                    s6 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s6;
                                s6 = peg$FAILED;
                            }
                        }
                        if (s5 !== peg$FAILED) {
                            s2 = [
                                s2,
                                s3,
                                s4,
                                s5
                            ];
                            s1 = s2;
                        } else {
                            peg$currPos = s1;
                            s1 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s1;
                        s1 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s1;
                    s1 = peg$FAILED;
                }
            } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
            else s0 = s1;
            return s0;
        }
        function peg$parseLANGTAG() {
            var s0, s1, s2, s3, s4, s5, s6, s7;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 64) {
                s1 = peg$c89;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c90);
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                if (peg$c91.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c92);
                }
                if (s3 !== peg$FAILED) while(s3 !== peg$FAILED){
                    s2.push(s3);
                    if (peg$c91.test(input.charAt(peg$currPos))) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c92);
                    }
                }
                else s2 = peg$FAILED;
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 45) {
                        s5 = peg$c93;
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c94);
                    }
                    if (s5 !== peg$FAILED) {
                        s6 = [];
                        if (peg$c95.test(input.charAt(peg$currPos))) {
                            s7 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s7 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c96);
                        }
                        if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                            s6.push(s7);
                            if (peg$c95.test(input.charAt(peg$currPos))) {
                                s7 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c96);
                            }
                        }
                        else s6 = peg$FAILED;
                        if (s6 !== peg$FAILED) {
                            peg$savedPos = s4;
                            s5 = peg$c97(s2, s6);
                            s4 = s5;
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s4;
                        s4 = peg$FAILED;
                    }
                    while(s4 !== peg$FAILED){
                        s3.push(s4);
                        s4 = peg$currPos;
                        if (input.charCodeAt(peg$currPos) === 45) {
                            s5 = peg$c93;
                            peg$currPos++;
                        } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c94);
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = [];
                            if (peg$c95.test(input.charAt(peg$currPos))) {
                                s7 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c96);
                            }
                            if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                                s6.push(s7);
                                if (peg$c95.test(input.charAt(peg$currPos))) {
                                    s7 = input.charAt(peg$currPos);
                                    peg$currPos++;
                                } else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c96);
                                }
                            }
                            else s6 = peg$FAILED;
                            if (s6 !== peg$FAILED) {
                                peg$savedPos = s4;
                                s5 = peg$c97(s2, s6);
                                s4 = s5;
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c98(s2, s3);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseINTEGER() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            s1 = peg$currPos;
            s2 = peg$currPos;
            if (peg$c99.test(input.charAt(peg$currPos))) {
                s3 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c100);
            }
            if (s3 === peg$FAILED) s3 = null;
            if (s3 !== peg$FAILED) {
                s4 = [];
                if (peg$c87.test(input.charAt(peg$currPos))) {
                    s5 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c88);
                }
                if (s5 !== peg$FAILED) while(s5 !== peg$FAILED){
                    s4.push(s5);
                    if (peg$c87.test(input.charAt(peg$currPos))) {
                        s5 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c88);
                    }
                }
                else s4 = peg$FAILED;
                if (s4 !== peg$FAILED) {
                    s3 = [
                        s3,
                        s4
                    ];
                    s2 = s3;
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) s1 = input.substring(s1, peg$currPos);
            else s1 = s2;
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c101(s1);
            }
            s0 = s1;
            return s0;
        }
        function peg$parseDECIMAL() {
            var s0, s1, s2, s3, s4, s5, s6, s7;
            s0 = peg$currPos;
            s1 = peg$currPos;
            s2 = peg$currPos;
            if (peg$c99.test(input.charAt(peg$currPos))) {
                s3 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c100);
            }
            if (s3 === peg$FAILED) s3 = null;
            if (s3 !== peg$FAILED) {
                s4 = [];
                if (peg$c87.test(input.charAt(peg$currPos))) {
                    s5 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c88);
                }
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    if (peg$c87.test(input.charAt(peg$currPos))) {
                        s5 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c88);
                    }
                }
                if (s4 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 46) {
                        s5 = peg$c1;
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c2);
                    }
                    if (s5 !== peg$FAILED) {
                        s6 = [];
                        if (peg$c87.test(input.charAt(peg$currPos))) {
                            s7 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s7 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c88);
                        }
                        if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                            s6.push(s7);
                            if (peg$c87.test(input.charAt(peg$currPos))) {
                                s7 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c88);
                            }
                        }
                        else s6 = peg$FAILED;
                        if (s6 !== peg$FAILED) {
                            s3 = [
                                s3,
                                s4,
                                s5,
                                s6
                            ];
                            s2 = s3;
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) s1 = input.substring(s1, peg$currPos);
            else s1 = s2;
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c102(s1);
            }
            s0 = s1;
            return s0;
        }
        function peg$parseDOUBLE() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8;
            s0 = peg$currPos;
            s1 = peg$currPos;
            s2 = peg$currPos;
            if (peg$c99.test(input.charAt(peg$currPos))) {
                s3 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c100);
            }
            if (s3 === peg$FAILED) s3 = null;
            if (s3 !== peg$FAILED) {
                s4 = peg$currPos;
                s5 = [];
                if (peg$c87.test(input.charAt(peg$currPos))) {
                    s6 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s6 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c88);
                }
                if (s6 !== peg$FAILED) while(s6 !== peg$FAILED){
                    s5.push(s6);
                    if (peg$c87.test(input.charAt(peg$currPos))) {
                        s6 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s6 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c88);
                    }
                }
                else s5 = peg$FAILED;
                if (s5 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 46) {
                        s6 = peg$c1;
                        peg$currPos++;
                    } else {
                        s6 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c2);
                    }
                    if (s6 !== peg$FAILED) {
                        s7 = [];
                        if (peg$c87.test(input.charAt(peg$currPos))) {
                            s8 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s8 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c88);
                        }
                        while(s8 !== peg$FAILED){
                            s7.push(s8);
                            if (peg$c87.test(input.charAt(peg$currPos))) {
                                s8 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s8 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c88);
                            }
                        }
                        if (s7 !== peg$FAILED) {
                            s8 = peg$parseEXPONENT();
                            if (s8 !== peg$FAILED) {
                                s5 = [
                                    s5,
                                    s6,
                                    s7,
                                    s8
                                ];
                                s4 = s5;
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s4;
                        s4 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                }
                if (s4 === peg$FAILED) {
                    s4 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 46) {
                        s5 = peg$c1;
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c2);
                    }
                    if (s5 !== peg$FAILED) {
                        s6 = [];
                        if (peg$c87.test(input.charAt(peg$currPos))) {
                            s7 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s7 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c88);
                        }
                        if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                            s6.push(s7);
                            if (peg$c87.test(input.charAt(peg$currPos))) {
                                s7 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c88);
                            }
                        }
                        else s6 = peg$FAILED;
                        if (s6 !== peg$FAILED) {
                            s7 = peg$parseEXPONENT();
                            if (s7 !== peg$FAILED) {
                                s5 = [
                                    s5,
                                    s6,
                                    s7
                                ];
                                s4 = s5;
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s4;
                        s4 = peg$FAILED;
                    }
                    if (s4 === peg$FAILED) {
                        s4 = peg$currPos;
                        s5 = [];
                        if (peg$c87.test(input.charAt(peg$currPos))) {
                            s6 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s6 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c88);
                        }
                        if (s6 !== peg$FAILED) while(s6 !== peg$FAILED){
                            s5.push(s6);
                            if (peg$c87.test(input.charAt(peg$currPos))) {
                                s6 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s6 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c88);
                            }
                        }
                        else s5 = peg$FAILED;
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parseEXPONENT();
                            if (s6 !== peg$FAILED) {
                                s5 = [
                                    s5,
                                    s6
                                ];
                                s4 = s5;
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    }
                }
                if (s4 !== peg$FAILED) {
                    s3 = [
                        s3,
                        s4
                    ];
                    s2 = s3;
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) s1 = input.substring(s1, peg$currPos);
            else s1 = s2;
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c103(s1);
            }
            s0 = s1;
            return s0;
        }
        function peg$parseEXPONENT() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            s1 = peg$currPos;
            if (peg$c104.test(input.charAt(peg$currPos))) {
                s2 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c105);
            }
            if (s2 !== peg$FAILED) {
                if (peg$c99.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c100);
                }
                if (s3 === peg$FAILED) s3 = null;
                if (s3 !== peg$FAILED) {
                    s4 = [];
                    if (peg$c87.test(input.charAt(peg$currPos))) {
                        s5 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c88);
                    }
                    if (s5 !== peg$FAILED) while(s5 !== peg$FAILED){
                        s4.push(s5);
                        if (peg$c87.test(input.charAt(peg$currPos))) {
                            s5 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c88);
                        }
                    }
                    else s4 = peg$FAILED;
                    if (s4 !== peg$FAILED) {
                        s2 = [
                            s2,
                            s3,
                            s4
                        ];
                        s1 = s2;
                    } else {
                        peg$currPos = s1;
                        s1 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s1;
                    s1 = peg$FAILED;
                }
            } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
            else s0 = s1;
            return s0;
        }
        function peg$parseSTRING_LITERAL_QUOTE() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 34) {
                s1 = peg$c106;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c107);
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                if (peg$c108.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c109);
                }
                if (s3 === peg$FAILED) {
                    s3 = peg$parseECHAR();
                    if (s3 === peg$FAILED) s3 = peg$parseUCHAR();
                }
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    if (peg$c108.test(input.charAt(peg$currPos))) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c109);
                    }
                    if (s3 === peg$FAILED) {
                        s3 = peg$parseECHAR();
                        if (s3 === peg$FAILED) s3 = peg$parseUCHAR();
                    }
                }
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 34) {
                        s3 = peg$c106;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c107);
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c10(s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseSTRING_LITERAL_SINGLE_QUOTE() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 39) {
                s1 = peg$c110;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c111);
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                if (peg$c112.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c113);
                }
                if (s3 === peg$FAILED) {
                    s3 = peg$parseECHAR();
                    if (s3 === peg$FAILED) s3 = peg$parseUCHAR();
                }
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    if (peg$c112.test(input.charAt(peg$currPos))) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c113);
                    }
                    if (s3 === peg$FAILED) {
                        s3 = peg$parseECHAR();
                        if (s3 === peg$FAILED) s3 = peg$parseUCHAR();
                    }
                }
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 39) {
                        s3 = peg$c110;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c111);
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c10(s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseSTRING_LITERAL_LONG_SINGLE_QUOTE() {
            var s0, s1, s2, s3, s4, s5, s6, s7;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 3) === peg$c114) {
                s1 = peg$c114;
                peg$currPos += 3;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c115);
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                if (peg$c116.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c117);
                }
                if (s3 === peg$FAILED) {
                    s3 = peg$parseECHAR();
                    if (s3 === peg$FAILED) s3 = peg$parseUCHAR();
                }
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    if (peg$c116.test(input.charAt(peg$currPos))) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c117);
                    }
                    if (s3 === peg$FAILED) {
                        s3 = peg$parseECHAR();
                        if (s3 === peg$FAILED) s3 = peg$parseUCHAR();
                    }
                }
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c118) {
                        s5 = peg$c118;
                        peg$currPos += 2;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c119);
                    }
                    if (s5 !== peg$FAILED) {
                        s6 = [];
                        if (peg$c116.test(input.charAt(peg$currPos))) {
                            s7 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s7 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c117);
                        }
                        if (s7 === peg$FAILED) {
                            s7 = peg$parseECHAR();
                            if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                        }
                        if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                            s6.push(s7);
                            if (peg$c116.test(input.charAt(peg$currPos))) {
                                s7 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c117);
                            }
                            if (s7 === peg$FAILED) {
                                s7 = peg$parseECHAR();
                                if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                            }
                        }
                        else s6 = peg$FAILED;
                        if (s6 !== peg$FAILED) {
                            peg$savedPos = s4;
                            s5 = peg$c120(s2, s6);
                            s4 = s5;
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s4;
                        s4 = peg$FAILED;
                    }
                    if (s4 === peg$FAILED) {
                        s4 = peg$currPos;
                        if (input.charCodeAt(peg$currPos) === 39) {
                            s5 = peg$c110;
                            peg$currPos++;
                        } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c111);
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = [];
                            if (peg$c116.test(input.charAt(peg$currPos))) {
                                s7 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c117);
                            }
                            if (s7 === peg$FAILED) {
                                s7 = peg$parseECHAR();
                                if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                            }
                            if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                                s6.push(s7);
                                if (peg$c116.test(input.charAt(peg$currPos))) {
                                    s7 = input.charAt(peg$currPos);
                                    peg$currPos++;
                                } else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c117);
                                }
                                if (s7 === peg$FAILED) {
                                    s7 = peg$parseECHAR();
                                    if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                                }
                            }
                            else s6 = peg$FAILED;
                            if (s6 !== peg$FAILED) {
                                peg$savedPos = s4;
                                s5 = peg$c121(s2, s6);
                                s4 = s5;
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    }
                    while(s4 !== peg$FAILED){
                        s3.push(s4);
                        s4 = peg$currPos;
                        if (input.substr(peg$currPos, 2) === peg$c118) {
                            s5 = peg$c118;
                            peg$currPos += 2;
                        } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c119);
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = [];
                            if (peg$c116.test(input.charAt(peg$currPos))) {
                                s7 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c117);
                            }
                            if (s7 === peg$FAILED) {
                                s7 = peg$parseECHAR();
                                if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                            }
                            if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                                s6.push(s7);
                                if (peg$c116.test(input.charAt(peg$currPos))) {
                                    s7 = input.charAt(peg$currPos);
                                    peg$currPos++;
                                } else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c117);
                                }
                                if (s7 === peg$FAILED) {
                                    s7 = peg$parseECHAR();
                                    if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                                }
                            }
                            else s6 = peg$FAILED;
                            if (s6 !== peg$FAILED) {
                                peg$savedPos = s4;
                                s5 = peg$c120(s2, s6);
                                s4 = s5;
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                        if (s4 === peg$FAILED) {
                            s4 = peg$currPos;
                            if (input.charCodeAt(peg$currPos) === 39) {
                                s5 = peg$c110;
                                peg$currPos++;
                            } else {
                                s5 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c111);
                            }
                            if (s5 !== peg$FAILED) {
                                s6 = [];
                                if (peg$c116.test(input.charAt(peg$currPos))) {
                                    s7 = input.charAt(peg$currPos);
                                    peg$currPos++;
                                } else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c117);
                                }
                                if (s7 === peg$FAILED) {
                                    s7 = peg$parseECHAR();
                                    if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                                }
                                if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                                    s6.push(s7);
                                    if (peg$c116.test(input.charAt(peg$currPos))) {
                                        s7 = input.charAt(peg$currPos);
                                        peg$currPos++;
                                    } else {
                                        s7 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c117);
                                    }
                                    if (s7 === peg$FAILED) {
                                        s7 = peg$parseECHAR();
                                        if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                                    }
                                }
                                else s6 = peg$FAILED;
                                if (s6 !== peg$FAILED) {
                                    peg$savedPos = s4;
                                    s5 = peg$c121(s2, s6);
                                    s4 = s5;
                                } else {
                                    peg$currPos = s4;
                                    s4 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        }
                    }
                    if (s3 !== peg$FAILED) {
                        if (input.substr(peg$currPos, 3) === peg$c114) {
                            s4 = peg$c114;
                            peg$currPos += 3;
                        } else {
                            s4 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c115);
                        }
                        if (s4 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c122(s2, s3);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseSTRING_LITERAL_LONG_QUOTE() {
            var s0, s1, s2, s3, s4, s5, s6, s7;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 3) === peg$c123) {
                s1 = peg$c123;
                peg$currPos += 3;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c124);
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                if (peg$c125.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c126);
                }
                if (s3 === peg$FAILED) {
                    s3 = peg$parseECHAR();
                    if (s3 === peg$FAILED) s3 = peg$parseUCHAR();
                }
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    if (peg$c125.test(input.charAt(peg$currPos))) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c126);
                    }
                    if (s3 === peg$FAILED) {
                        s3 = peg$parseECHAR();
                        if (s3 === peg$FAILED) s3 = peg$parseUCHAR();
                    }
                }
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c127) {
                        s5 = peg$c127;
                        peg$currPos += 2;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c128);
                    }
                    if (s5 !== peg$FAILED) {
                        s6 = [];
                        if (peg$c125.test(input.charAt(peg$currPos))) {
                            s7 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s7 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c126);
                        }
                        if (s7 === peg$FAILED) {
                            s7 = peg$parseECHAR();
                            if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                        }
                        if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                            s6.push(s7);
                            if (peg$c125.test(input.charAt(peg$currPos))) {
                                s7 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c126);
                            }
                            if (s7 === peg$FAILED) {
                                s7 = peg$parseECHAR();
                                if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                            }
                        }
                        else s6 = peg$FAILED;
                        if (s6 !== peg$FAILED) {
                            peg$savedPos = s4;
                            s5 = peg$c129(s2, s6);
                            s4 = s5;
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s4;
                        s4 = peg$FAILED;
                    }
                    if (s4 === peg$FAILED) {
                        s4 = peg$currPos;
                        if (input.charCodeAt(peg$currPos) === 34) {
                            s5 = peg$c106;
                            peg$currPos++;
                        } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c107);
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = [];
                            if (peg$c125.test(input.charAt(peg$currPos))) {
                                s7 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c126);
                            }
                            if (s7 === peg$FAILED) {
                                s7 = peg$parseECHAR();
                                if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                            }
                            if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                                s6.push(s7);
                                if (peg$c125.test(input.charAt(peg$currPos))) {
                                    s7 = input.charAt(peg$currPos);
                                    peg$currPos++;
                                } else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c126);
                                }
                                if (s7 === peg$FAILED) {
                                    s7 = peg$parseECHAR();
                                    if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                                }
                            }
                            else s6 = peg$FAILED;
                            if (s6 !== peg$FAILED) {
                                peg$savedPos = s4;
                                s5 = peg$c130(s2, s6);
                                s4 = s5;
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    }
                    while(s4 !== peg$FAILED){
                        s3.push(s4);
                        s4 = peg$currPos;
                        if (input.substr(peg$currPos, 2) === peg$c127) {
                            s5 = peg$c127;
                            peg$currPos += 2;
                        } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c128);
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = [];
                            if (peg$c125.test(input.charAt(peg$currPos))) {
                                s7 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c126);
                            }
                            if (s7 === peg$FAILED) {
                                s7 = peg$parseECHAR();
                                if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                            }
                            if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                                s6.push(s7);
                                if (peg$c125.test(input.charAt(peg$currPos))) {
                                    s7 = input.charAt(peg$currPos);
                                    peg$currPos++;
                                } else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c126);
                                }
                                if (s7 === peg$FAILED) {
                                    s7 = peg$parseECHAR();
                                    if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                                }
                            }
                            else s6 = peg$FAILED;
                            if (s6 !== peg$FAILED) {
                                peg$savedPos = s4;
                                s5 = peg$c129(s2, s6);
                                s4 = s5;
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                        if (s4 === peg$FAILED) {
                            s4 = peg$currPos;
                            if (input.charCodeAt(peg$currPos) === 34) {
                                s5 = peg$c106;
                                peg$currPos++;
                            } else {
                                s5 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c107);
                            }
                            if (s5 !== peg$FAILED) {
                                s6 = [];
                                if (peg$c125.test(input.charAt(peg$currPos))) {
                                    s7 = input.charAt(peg$currPos);
                                    peg$currPos++;
                                } else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c126);
                                }
                                if (s7 === peg$FAILED) {
                                    s7 = peg$parseECHAR();
                                    if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                                }
                                if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                                    s6.push(s7);
                                    if (peg$c125.test(input.charAt(peg$currPos))) {
                                        s7 = input.charAt(peg$currPos);
                                        peg$currPos++;
                                    } else {
                                        s7 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c126);
                                    }
                                    if (s7 === peg$FAILED) {
                                        s7 = peg$parseECHAR();
                                        if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                                    }
                                }
                                else s6 = peg$FAILED;
                                if (s6 !== peg$FAILED) {
                                    peg$savedPos = s4;
                                    s5 = peg$c130(s2, s6);
                                    s4 = s5;
                                } else {
                                    peg$currPos = s4;
                                    s4 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        }
                    }
                    if (s3 !== peg$FAILED) {
                        if (input.substr(peg$currPos, 3) === peg$c123) {
                            s4 = peg$c123;
                            peg$currPos += 3;
                        } else {
                            s4 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c124);
                        }
                        if (s4 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c122(s2, s3);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseUCHAR() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c131) {
                s1 = peg$c131;
                peg$currPos += 2;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c132);
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                s3 = peg$parseHEX();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parseHEX();
                    if (s4 !== peg$FAILED) {
                        s5 = peg$parseHEX();
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parseHEX();
                            if (s6 !== peg$FAILED) {
                                s7 = peg$parseHEX();
                                if (s7 !== peg$FAILED) {
                                    s8 = peg$parseHEX();
                                    if (s8 !== peg$FAILED) {
                                        s9 = peg$parseHEX();
                                        if (s9 !== peg$FAILED) {
                                            s10 = peg$parseHEX();
                                            if (s10 !== peg$FAILED) {
                                                s3 = [
                                                    s3,
                                                    s4,
                                                    s5,
                                                    s6,
                                                    s7,
                                                    s8,
                                                    s9,
                                                    s10
                                                ];
                                                s2 = s3;
                                            } else {
                                                peg$currPos = s2;
                                                s2 = peg$FAILED;
                                            }
                                        } else {
                                            peg$currPos = s2;
                                            s2 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s2;
                                        s2 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s2;
                                    s2 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s2;
                                s2 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c133(s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c134) {
                    s1 = peg$c134;
                    peg$currPos += 2;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c135);
                }
                if (s1 !== peg$FAILED) {
                    s2 = peg$currPos;
                    s3 = peg$parseHEX();
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parseHEX();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parseHEX();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parseHEX();
                                if (s6 !== peg$FAILED) {
                                    s3 = [
                                        s3,
                                        s4,
                                        s5,
                                        s6
                                    ];
                                    s2 = s3;
                                } else {
                                    peg$currPos = s2;
                                    s2 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s2;
                                s2 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c136(s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            return s0;
        }
        function peg$parseECHAR() {
            var s0, s1;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c137) {
                s1 = peg$c137;
                peg$currPos += 2;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c138);
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c139();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c140) {
                    s1 = peg$c140;
                    peg$currPos += 2;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c141);
                }
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c142();
                }
                s0 = s1;
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c143) {
                        s1 = peg$c143;
                        peg$currPos += 2;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c144);
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c145();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 2) === peg$c146) {
                            s1 = peg$c146;
                            peg$currPos += 2;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c147);
                        }
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c148();
                        }
                        s0 = s1;
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            if (input.substr(peg$currPos, 2) === peg$c149) {
                                s1 = peg$c149;
                                peg$currPos += 2;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c150);
                            }
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c151();
                            }
                            s0 = s1;
                            if (s0 === peg$FAILED) {
                                s0 = peg$currPos;
                                if (input.substr(peg$currPos, 2) === peg$c152) {
                                    s1 = peg$c152;
                                    peg$currPos += 2;
                                } else {
                                    s1 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c153);
                                }
                                if (s1 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c154();
                                }
                                s0 = s1;
                                if (s0 === peg$FAILED) {
                                    s0 = peg$currPos;
                                    if (input.substr(peg$currPos, 2) === peg$c155) {
                                        s1 = peg$c155;
                                        peg$currPos += 2;
                                    } else {
                                        s1 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c156);
                                    }
                                    if (s1 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c157();
                                    }
                                    s0 = s1;
                                    if (s0 === peg$FAILED) {
                                        s0 = peg$currPos;
                                        if (input.substr(peg$currPos, 2) === peg$c158) {
                                            s1 = peg$c158;
                                            peg$currPos += 2;
                                        } else {
                                            s1 = peg$FAILED;
                                            if (peg$silentFails === 0) peg$fail(peg$c159);
                                        }
                                        if (s1 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s1 = peg$c160();
                                        }
                                        s0 = s1;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return s0;
        }
        function peg$parseWS() {
            var s0;
            if (peg$c161.test(input.charAt(peg$currPos))) {
                s0 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c162);
            }
            return s0;
        }
        function peg$parseANON() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 91) {
                s1 = peg$c53;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c54);
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parseIGNORE();
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    s3 = peg$parseIGNORE();
                }
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 93) {
                        s3 = peg$c55;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c56);
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c163();
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsePN_CHARS_BASE() {
            var s0, s1, s2;
            s0 = peg$currPos;
            if (peg$c164.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c165);
            }
            if (s1 !== peg$FAILED) {
                if (peg$c166.test(input.charAt(peg$currPos))) {
                    s2 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c167);
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c168(s1, s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                if (peg$c169.test(input.charAt(peg$currPos))) {
                    s0 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c170);
                }
            }
            return s0;
        }
        function peg$parsePN_CHARS_U() {
            var s0;
            s0 = peg$parsePN_CHARS_BASE();
            if (s0 === peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 95) {
                    s0 = peg$c171;
                    peg$currPos++;
                } else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c172);
                }
            }
            return s0;
        }
        function peg$parsePN_CHARS() {
            var s0;
            s0 = peg$parsePN_CHARS_U();
            if (s0 === peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 45) {
                    s0 = peg$c93;
                    peg$currPos++;
                } else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c94);
                }
                if (s0 === peg$FAILED) {
                    if (peg$c87.test(input.charAt(peg$currPos))) {
                        s0 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s0 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c88);
                    }
                    if (s0 === peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 183) {
                            s0 = peg$c173;
                            peg$currPos++;
                        } else {
                            s0 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c174);
                        }
                        if (s0 === peg$FAILED) {
                            if (peg$c175.test(input.charAt(peg$currPos))) {
                                s0 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s0 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c176);
                            }
                            if (s0 === peg$FAILED) {
                                if (peg$c177.test(input.charAt(peg$currPos))) {
                                    s0 = input.charAt(peg$currPos);
                                    peg$currPos++;
                                } else {
                                    s0 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c178);
                                }
                            }
                        }
                    }
                }
            }
            return s0;
        }
        function peg$parsePN_PREFIX() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8;
            s0 = peg$currPos;
            s1 = peg$currPos;
            s2 = peg$parsePN_CHARS_BASE();
            if (s2 !== peg$FAILED) {
                s3 = [];
                s4 = peg$parsePN_CHARS();
                while(s4 !== peg$FAILED){
                    s3.push(s4);
                    s4 = peg$parsePN_CHARS();
                }
                if (s3 !== peg$FAILED) {
                    s4 = [];
                    s5 = peg$currPos;
                    s6 = [];
                    if (input.charCodeAt(peg$currPos) === 46) {
                        s7 = peg$c1;
                        peg$currPos++;
                    } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c2);
                    }
                    if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                        s6.push(s7);
                        if (input.charCodeAt(peg$currPos) === 46) {
                            s7 = peg$c1;
                            peg$currPos++;
                        } else {
                            s7 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c2);
                        }
                    }
                    else s6 = peg$FAILED;
                    if (s6 !== peg$FAILED) {
                        s7 = [];
                        s8 = peg$parsePN_CHARS();
                        if (s8 !== peg$FAILED) while(s8 !== peg$FAILED){
                            s7.push(s8);
                            s8 = peg$parsePN_CHARS();
                        }
                        else s7 = peg$FAILED;
                        if (s7 !== peg$FAILED) {
                            s6 = [
                                s6,
                                s7
                            ];
                            s5 = s6;
                        } else {
                            peg$currPos = s5;
                            s5 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s5;
                        s5 = peg$FAILED;
                    }
                    while(s5 !== peg$FAILED){
                        s4.push(s5);
                        s5 = peg$currPos;
                        s6 = [];
                        if (input.charCodeAt(peg$currPos) === 46) {
                            s7 = peg$c1;
                            peg$currPos++;
                        } else {
                            s7 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c2);
                        }
                        if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                            s6.push(s7);
                            if (input.charCodeAt(peg$currPos) === 46) {
                                s7 = peg$c1;
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c2);
                            }
                        }
                        else s6 = peg$FAILED;
                        if (s6 !== peg$FAILED) {
                            s7 = [];
                            s8 = peg$parsePN_CHARS();
                            if (s8 !== peg$FAILED) while(s8 !== peg$FAILED){
                                s7.push(s8);
                                s8 = peg$parsePN_CHARS();
                            }
                            else s7 = peg$FAILED;
                            if (s7 !== peg$FAILED) {
                                s6 = [
                                    s6,
                                    s7
                                ];
                                s5 = s6;
                            } else {
                                peg$currPos = s5;
                                s5 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s5;
                            s5 = peg$FAILED;
                        }
                    }
                    if (s4 !== peg$FAILED) {
                        s2 = [
                            s2,
                            s3,
                            s4
                        ];
                        s1 = s2;
                    } else {
                        peg$currPos = s1;
                        s1 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s1;
                    s1 = peg$FAILED;
                }
            } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
            else s0 = s1;
            return s0;
        }
        function peg$parsePN_LOCAL() {
            var s0, s1, s2, s3, s4, s5, s6, s7;
            s0 = peg$currPos;
            s1 = peg$parsePN_CHARS_U();
            if (s1 === peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 58) {
                    s1 = peg$c80;
                    peg$currPos++;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c81);
                }
                if (s1 === peg$FAILED) {
                    if (peg$c87.test(input.charAt(peg$currPos))) {
                        s1 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c88);
                    }
                    if (s1 === peg$FAILED) s1 = peg$parsePLX();
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parsePN_CHARS();
                if (s3 === peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 58) {
                        s3 = peg$c80;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c81);
                    }
                    if (s3 === peg$FAILED) s3 = peg$parsePLX();
                }
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    s3 = peg$parsePN_CHARS();
                    if (s3 === peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 58) {
                            s3 = peg$c80;
                            peg$currPos++;
                        } else {
                            s3 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c81);
                        }
                        if (s3 === peg$FAILED) s3 = peg$parsePLX();
                    }
                }
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$currPos;
                    s5 = [];
                    if (input.charCodeAt(peg$currPos) === 46) {
                        s6 = peg$c1;
                        peg$currPos++;
                    } else {
                        s6 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c2);
                    }
                    if (s6 !== peg$FAILED) while(s6 !== peg$FAILED){
                        s5.push(s6);
                        if (input.charCodeAt(peg$currPos) === 46) {
                            s6 = peg$c1;
                            peg$currPos++;
                        } else {
                            s6 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c2);
                        }
                    }
                    else s5 = peg$FAILED;
                    if (s5 !== peg$FAILED) {
                        s6 = [];
                        s7 = peg$parsePN_CHARS();
                        if (s7 === peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 58) {
                                s7 = peg$c80;
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c81);
                            }
                            if (s7 === peg$FAILED) s7 = peg$parsePLX();
                        }
                        if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                            s6.push(s7);
                            s7 = peg$parsePN_CHARS();
                            if (s7 === peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 58) {
                                    s7 = peg$c80;
                                    peg$currPos++;
                                } else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c81);
                                }
                                if (s7 === peg$FAILED) s7 = peg$parsePLX();
                            }
                        }
                        else s6 = peg$FAILED;
                        if (s6 !== peg$FAILED) {
                            peg$savedPos = s4;
                            s5 = peg$c179(s1, s2, s5, s6);
                            s4 = s5;
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s4;
                        s4 = peg$FAILED;
                    }
                    while(s4 !== peg$FAILED){
                        s3.push(s4);
                        s4 = peg$currPos;
                        s5 = [];
                        if (input.charCodeAt(peg$currPos) === 46) {
                            s6 = peg$c1;
                            peg$currPos++;
                        } else {
                            s6 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c2);
                        }
                        if (s6 !== peg$FAILED) while(s6 !== peg$FAILED){
                            s5.push(s6);
                            if (input.charCodeAt(peg$currPos) === 46) {
                                s6 = peg$c1;
                                peg$currPos++;
                            } else {
                                s6 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c2);
                            }
                        }
                        else s5 = peg$FAILED;
                        if (s5 !== peg$FAILED) {
                            s6 = [];
                            s7 = peg$parsePN_CHARS();
                            if (s7 === peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 58) {
                                    s7 = peg$c80;
                                    peg$currPos++;
                                } else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c81);
                                }
                                if (s7 === peg$FAILED) s7 = peg$parsePLX();
                            }
                            if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                                s6.push(s7);
                                s7 = peg$parsePN_CHARS();
                                if (s7 === peg$FAILED) {
                                    if (input.charCodeAt(peg$currPos) === 58) {
                                        s7 = peg$c80;
                                        peg$currPos++;
                                    } else {
                                        s7 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c81);
                                    }
                                    if (s7 === peg$FAILED) s7 = peg$parsePLX();
                                }
                            }
                            else s6 = peg$FAILED;
                            if (s6 !== peg$FAILED) {
                                peg$savedPos = s4;
                                s5 = peg$c179(s1, s2, s5, s6);
                                s4 = s5;
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c180(s1, s2, s3);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsePLX() {
            var s0;
            s0 = peg$parsePERCENT();
            if (s0 === peg$FAILED) s0 = peg$parsePN_LOCAL_ESC();
            return s0;
        }
        function peg$parsePERCENT() {
            var s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 37) {
                s2 = peg$c181;
                peg$currPos++;
            } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c182);
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parseHEX();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parseHEX();
                    if (s4 !== peg$FAILED) {
                        s2 = [
                            s2,
                            s3,
                            s4
                        ];
                        s1 = s2;
                    } else {
                        peg$currPos = s1;
                        s1 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s1;
                    s1 = peg$FAILED;
                }
            } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
            else s0 = s1;
            return s0;
        }
        function peg$parseHEX() {
            var s0;
            if (peg$c183.test(input.charAt(peg$currPos))) {
                s0 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c184);
            }
            return s0;
        }
        function peg$parsePN_LOCAL_ESC() {
            var s0, s1, s2;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 92) {
                s1 = peg$c185;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c186);
            }
            if (s1 !== peg$FAILED) {
                if (peg$c187.test(input.charAt(peg$currPos))) {
                    s2 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c188);
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c3(s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        var isBrowser = new Function("try {return this===window;}catch(e){ return false;}");
        var URL = isBrowser() ? window.URL : (parcelRequire("biuEp")).URL;
        var isIRI = function(a) {
            return a.match(/^[a-z](.*?):(.+?)/g);
        };
        function createObject(property, value) {
            var a = {};
            a[property] = value;
            return a;
        }
        var context = {
            base: [],
            data: {},
            addBase: function(uri) {
                if (context.base.length === 0) {
                    context.base.push(uri);
                    return;
                }
                const last = context.base[context.base.length - 1];
                if (last !== uri) context.base.push(new URL(uri, last).toString());
            },
            addPrefix: function(prefix, uri) {
                const list = context.data[prefix];
                if (list === undefined) context.data[prefix] = [
                    {
                        uri: uri,
                        count: 0
                    }
                ];
                else if (list[list.length - 1].uri !== uri) list.push({
                    uri: uri,
                    count: 0
                });
            },
            hasPrefix: function(prefix) {
                return this.data[prefix] !== undefined;
            },
            resolve: function(pname, force) {
                const prefix = Object.keys(context.data).find((key)=>pname.indexOf(key + ":") === 0);
                if (prefix !== undefined) {
                    const list = context.data[prefix];
                    if (list.length === 1 && force !== true && isIRI(list[0].uri)) return pname;
                    const uri = list[list.length - 1].uri;
                    return pname.replace(prefix + ":", uri);
                } else {
                    var base = context.base.length === 0 ? options.baseIRI : context.base[context.base.length - 1];
                    if (!base || pname.match(/^(http:|https:|urn:|file:)/)) return pname;
                    if (pname.indexOf("//") === 0 && base) return base.split("//")[0] + pname;
                    return new URL(pname, base).toString();
                }
            },
            increment: function(prefix) {
                const list = context.data[prefix];
                if (list !== undefined) list[list.length - 1].count++;
            },
            decrement: function(prefix) {
                const list = context.data[prefix];
                if (list !== undefined) list[list.length - 1].count--;
            },
            toJSON: function() {
                const root = {};
                if (context.base.length > 0) {
                    if (root["@context"] === undefined) root["@context"] = {};
                    root["@context"]["@base"] = context.base[0];
                }
                Object.keys(context.data).forEach((key)=>{
                    const head = context.data[key][0];
                    if (head.uri === "http://www.w3.org/2001/XMLSchema#" && head.count < 1) return;
                    if (!isIRI(head.uri)) return;
                    if (root["@context"] === undefined) root["@context"] = {};
                    root["@context"][key] = head.uri;
                });
                return root;
            }
        };
        function expandList(container, force) {
            if (container["@list"] === undefined) return container;
            if (!force && !container["@list"].find((x)=>x["@list"] !== undefined)) return container;
            if (container["@list"].length === 0) return {
                "@id": "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"
            };
            var root = {};
            var focus = null;
            container["@list"].forEach((b)=>{
                if (focus === null) focus = root;
                else {
                    focus["http://www.w3.org/1999/02/22-rdf-syntax-ns#rest"] = {};
                    focus = focus["http://www.w3.org/1999/02/22-rdf-syntax-ns#rest"];
                }
                focus["http://www.w3.org/1999/02/22-rdf-syntax-ns#first"] = expandList(b, true);
                focus["http://www.w3.org/1999/02/22-rdf-syntax-ns#rest"] = {
                    "@id": "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"
                };
            });
            return root;
        }
        peg$result = peg$startRuleFunction();
        if (peg$result !== peg$FAILED && peg$currPos === input.length) return peg$result;
        else {
            if (peg$result !== peg$FAILED && peg$currPos < input.length) peg$fail(peg$endExpectation());
            throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
        }
    }
    return {
        SyntaxError: peg$SyntaxError,
        parse: peg$parse
    };
});


function $f832e5387e149401$export$2e2bcd8739ae039(store) {
    return new $f832e5387e149401$export$ef852775387a0be7(store);
}
var $f832e5387e149401$export$ef852775387a0be7 = /*#__PURE__*/ function() {
    function Serializer(store) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Serializer);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_notQNameChars", "	\r\n !\"#$%&'()*.,+/;<=>?@[\\]^`{|}~");
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_notNameChars", this._notQNameChars + ":");
        //  stringToN3:  String escaping for N3
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "validPrefix", new RegExp(/^[a-zA-Z][a-zA-Z0-9]*$/));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "forbidden1", new RegExp(/[\\"\b\f\r\v\t\n\u0080-\uffff]/gm));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "forbidden3", new RegExp(/[\\"\b\f\r\v\u0080-\uffff]/gm));
        this.flags = "";
        this.base = null;
        this.prefixes = []; // suggested prefixes
        this.namespaces = []; // complementary
        var nsKeys = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($3f9355bcac0943b6$exports)))());
        for(var i in nsKeys){
            var uri = (0, (/*@__PURE__*/$parcel$interopDefault($3f9355bcac0943b6$exports)))()[nsKeys[i]]("");
            var prefix = nsKeys[i];
            this.prefixes[uri] = prefix;
            this.namespaces[prefix] = uri;
        }
        this.suggestPrefix("rdf", "http://www.w3.org/1999/02/22-rdf-syntax-ns#"); // XML code assumes this!
        this.suggestPrefix("xml", "reserved:reservedForFutureUse"); // XML reserves xml: in the spec.
        this.namespacesUsed = []; // Count actually used and so needed in @prefixes
        this.keywords = [
            "a"
        ]; // The only one we generate at the moment
        this.prefixchars = "abcdefghijklmnopqustuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        this.incoming = null; // Array not calculated yet
        this.formulas = []; // remembering original formulae from hashes
        this.store = store;
        this.rdfFactory = store.rdfFactory || (0, $158d84b4866fe33e$export$2e2bcd8739ae039);
        this.xsd = (0, $c58a780548822e73$export$abafb17d1d8eb7fd)(this.rdfFactory);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Serializer, [
        {
            key: "setBase",
            value: function setBase(base) {
                this.base = base;
                return this;
            }
        },
        {
            key: "setFlags",
            value: function setFlags(flags) {
                this.flags = flags || "";
                return this;
            }
        },
        {
            key: "toStr",
            value: function toStr(x) {
                var s = x.toNT();
                if (x.termType === "Graph") this.formulas[s] = x; // remember as reverse does not work
                return s;
            }
        },
        {
            key: "fromStr",
            value: function fromStr(s) {
                if (s[0] === "{") {
                    var x = this.formulas[s];
                    if (!x) console.log("No formula object for " + s);
                    return x;
                }
                return this.store.fromNT(s);
            }
        },
        {
            key: "setNamespaces",
            value: function setNamespaces(namespaces) {
                for(var px in namespaces)this.setPrefix(px, namespaces[px]);
                return this;
            }
        },
        {
            key: "setPrefix",
            value: function setPrefix(prefix, uri) {
                if (prefix.slice(0, 7) === "default") return; // Try to weed these out
                if (prefix.slice(0, 2) === "ns") return; //  From others inferior algos
                if (!prefix || !uri) return; // empty strings not suitable
                // remove any existing prefix targeting this uri
                // for (let existingPrefix in this.namespaces) {
                //   if (this.namespaces[existingPrefix] == uri)
                //     delete this.namespaces[existingPrefix];
                // }
                // remove any existing mapping for this prefix
                for(var existingNs in this.prefixes)if (this.prefixes[existingNs] == prefix) delete this.prefixes[existingNs];
                this.prefixes[uri] = prefix;
                this.namespaces[prefix] = uri;
            }
        },
        {
            key: "suggestPrefix",
            value: function suggestPrefix(prefix, uri) {
                if (prefix.slice(0, 7) === "default") return; // Try to weed these out
                if (prefix.slice(0, 2) === "ns") return; //  From others inferior algos
                if (!prefix || !uri) return; // empty strings not suitable
                if (prefix in this.namespaces || uri in this.prefixes) return; // already used
                this.prefixes[uri] = prefix;
                this.namespaces[prefix] = uri;
            }
        },
        {
            key: "suggestNamespaces",
            value: function suggestNamespaces(namespaces) {
                for(var px in namespaces)this.suggestPrefix(px, namespaces[px]);
                return this;
            }
        },
        {
            key: "checkIntegrity",
            value: function checkIntegrity() {
                var p, ns;
                for(p in this.namespaces){
                    if (this.prefixes[this.namespaces[p]] !== p) throw new Error("Serializer integity error 1: " + p + ", " + this.namespaces[p] + ", " + this.prefixes[this.namespaces[p]] + "!");
                }
                for(ns in this.prefixes){
                    if (this.namespaces[this.prefixes[ns]] !== ns) throw new Error("Serializer integity error 2: " + ns + ", " + this.prefixs[ns] + ", " + this.namespaces[this.prefixes[ns]] + "!");
                }
            }
        },
        {
            key: "makeUpPrefix",
            value: function makeUpPrefix(uri) {
                var p = uri;
                function canUseMethod(pp) {
                    if (!this.validPrefix.test(pp)) return false; // bad format
                    if (pp === "ns") return false; // boring
                    if (pp in this.namespaces) return false; // already used
                    this.prefixes[uri] = pp;
                    this.namespaces[pp] = uri;
                    return pp;
                }
                var canUse = canUseMethod.bind(this);
                if ("#/".indexOf(p[p.length - 1]) >= 0) p = p.slice(0, -1);
                var slash = p.lastIndexOf("/");
                if (slash >= 0) p = p.slice(slash + 1);
                var i = 0;
                while(i < p.length){
                    if (this.prefixchars.indexOf(p[i])) i++;
                    else break;
                }
                p = p.slice(0, i);
                if (p.length < 6 && canUse(p)) return p; // exact is best
                if (canUse(p.slice(0, 3))) return p.slice(0, 3);
                if (canUse(p.slice(0, 2))) return p.slice(0, 2);
                if (canUse(p.slice(0, 4))) return p.slice(0, 4);
                if (canUse(p.slice(0, 1))) return p.slice(0, 1);
                if (canUse(p.slice(0, 5))) return p.slice(0, 5);
                if (!this.validPrefix.test(p)) p = "n"; // Otherwise the loop below may never termimnate
                for(var j = 0;; j++)if (canUse(p.slice(0, 3) + j)) return p.slice(0, 3) + j;
            }
        },
        {
            key: "rootSubjects",
            value: function rootSubjects(sts) {
                var incoming = {};
                var subjects = {};
                var allBnodes = {};
                /* This scan is to find out which nodes will have to be the roots of trees
      ** in the serialized form. This will be any symbols, and any bnodes
      ** which hve more or less than one incoming arc, and any bnodes which have
      ** one incoming arc but it is an uninterrupted loop of such nodes back to itself.
      ** This should be kept linear time with repect to the number of statements.
      ** Note it does not use any indexing of the store.
      */ for(var i = 0; i < sts.length; i++){
                    var st = sts[i];
                    var checkMentions = function checkMentions(x) {
                        if (!incoming.hasOwnProperty(x)) incoming[x] = [];
                        incoming[x].push(st.subject); // List of things which will cause this to be printed
                    };
                    var st2 = [
                        st.subject,
                        st.predicate,
                        st.object
                    ];
                    st2.map(function(y) {
                        if (y.termType === "BlankNode") allBnodes[y.toNT()] = true;
                        else if (y.termType === "Collection") y.elements.forEach(function(z) {
                            checkMentions(z); // bnodes in collections important
                        });
                    });
                    checkMentions(sts[i].object);
                    var ss = subjects[this.toStr(st.subject)]; // Statements with this as subject
                    if (!ss) ss = [];
                    ss.push(st);
                    subjects[this.toStr(st.subject)] = ss; // Make hash. @@ too slow for formula?
                }
                var roots = [];
                for(var xNT in subjects){
                    if (!subjects.hasOwnProperty(xNT)) continue;
                    var y = this.fromStr(xNT);
                    if (y.termType !== "BlankNode" || !incoming[y] || incoming[y].length !== 1) {
                        roots.push(y);
                        continue;
                    }
                }
                this.incoming = incoming; // Keep for serializing @@ Bug for nested formulas
                // Now do the scan using existing roots
                var rootsHash = {};
                for(var k = 0; k < roots.length; k++)rootsHash[roots[k].toNT()] = true;
                return {
                    "roots": roots,
                    "subjects": subjects,
                    "rootsHash": rootsHash,
                    "incoming": incoming
                };
            }
        },
        {
            key: "toN3",
            value: function toN3(f) {
                return this.statementsToN3(f.statements);
            }
        },
        {
            key: "explicitURI",
            value: function explicitURI(uri) {
                if (this.flags.indexOf("r") < 0 && this.base) uri = $4Q80K.refTo(this.base, uri);
                else if (this.flags.indexOf("u") >= 0) // Unicode encoding NTriples style
                uri = $f832e5387e149401$var$backslashUify(uri);
                else uri = $f832e5387e149401$var$hexify(decodeURI(uri));
                return "<" + uri + ">";
            }
        },
        {
            key: "statementsToNTriples",
            value: function statementsToNTriples(sts) {
                var sorted = sts.slice();
                sorted.sort();
                var str = "";
                var rdfns = "http://www.w3.org/1999/02/22-rdf-syntax-ns#";
                var self = this;
                var kb = this.store;
                var factory = this.rdfFactory;
                var termToNT = function termToNT(x) {
                    if (x.termType !== "Collection") return self.atomicTermToN3(x);
                    var list = x.elements;
                    var rest = kb.sym(rdfns + "nill");
                    for(var i = list.length - 1; i >= 0; i--){
                        var bnode = factory.blankNode();
                        str += termToNT(bnode) + " " + termToNT(kb.sym(rdfns + "first")) + " " + termToNT(list[i]) + ".\n";
                        str += termToNT(bnode) + " " + termToNT(kb.sym(rdfns + "rest")) + " " + termToNT(rest) + ".\n";
                        rest = bnode;
                    }
                    return self.atomicTermToN3(rest);
                };
                for(var i = 0; i < sorted.length; i++){
                    var st = sorted[i];
                    var s = "";
                    s += termToNT(st.subject) + " ";
                    s += termToNT(st.predicate) + " ";
                    s += termToNT(st.object) + " ";
                    if (this.flags.indexOf("q") >= 0) // Do quads not nrtiples
                    s += termToNT(st.why) + " ";
                    s += ".\n";
                    str += s;
                }
                return str;
            }
        },
        {
            key: "statementsToN3",
            value: function statementsToN3(sts) {
                var indent = 4;
                var width = 80;
                var kb = this.store;
                // A URI Map alows us to put the type statemnts at the top.
                var uriMap = {
                    "http://www.w3.org/1999/02/22-rdf-syntax-ns#type": "aaa:00"
                };
                var SPO = function SPO(x, y) {
                    // Do limited canonicalization of bnodes
                    return $23fob.heavyCompareSPO(x, y, kb, uriMap);
                };
                sts.sort(SPO);
                if (this.base && !this.defaultNamespace) this.defaultNamespace = this.base + "#";
                var predMap = {};
                if (this.flags.indexOf("s") < 0) predMap["http://www.w3.org/2002/07/owl#sameAs"] = "=";
                if (this.flags.indexOf("t") < 0) predMap["http://www.w3.org/1999/02/22-rdf-syntax-ns#type"] = "a";
                if (this.flags.indexOf("i") < 0) predMap["http://www.w3.org/2000/10/swap/log#implies"] = "=>";
                // //////////////////////// Arrange the bits of text
                var spaces = function spaces(n) {
                    var s = "";
                    for(var i = 0; i < n; i++)s += " ";
                    return s;
                };
                var treeToLine = function treeToLine(tree) {
                    var str = "";
                    for(var i = 0; i < tree.length; i++){
                        var branch = tree[i];
                        var s2 = typeof branch === "string" ? branch : treeToLine(branch);
                        // Note the space before the dot in case statement ends with 123 or colon. which is in fact allowed but be conservative.
                        if (i !== 0) {
                            var ch = str.slice(-1) || " ";
                            if (s2 === "," || s2 === ";") ;
                            else if (s2 === "." && !"0123456789.:".includes(ch)) ;
                            else str += " "; // separate from previous token
                        }
                        str += s2;
                    }
                    return str;
                };
                // Convert a nested tree of lists and strings to a string
                var treeToString = function treeToString(tree, level) {
                    var str = "";
                    var lastLength = 100000;
                    if (level === undefined) level = -1;
                    for(var i = 0; i < tree.length; i++){
                        var branch = tree[i];
                        if (typeof branch !== "string") {
                            var substr = treeToString(branch, level + 1);
                            if (substr.length < 10 * (width - indent * level) && substr.indexOf('"""') < 0) {
                                // Don't mess up multiline strings
                                var line = treeToLine(branch);
                                if (line.length < width - indent * level) {
                                    branch = line; //   Note! treat as string below
                                    substr = "";
                                }
                            }
                            if (substr) lastLength = 10000;
                            str += substr;
                        }
                        if (typeof branch === "string") {
                            if (branch.length === 1 && str.slice(-1) === "\n") {
                                if (",.;".indexOf(branch) >= 0) {
                                    str = str.slice(0, -1);
                                    // be conservative and ensure a whitespace between some chars and a final dot, as in treeToLine above
                                    if (branch == "." && "0123456789.:".includes(str.charAt(str.length - 1))) {
                                        str += " ";
                                        lastLength += 1;
                                    }
                                    str += branch + "\n"; //  slip punct'n on end
                                    lastLength += 1;
                                    continue;
                                }
                            }
                            if (lastLength < indent * level + 4 || // if new line not necessary
                            lastLength + branch.length + 1 < width && ";.".indexOf(str[str.length - 2]) < 0) {
                                // or the string fits on last line
                                str = str.slice(0, -1) + " " + branch + "\n"; // then continue on this line
                                lastLength += branch.length + 1;
                            } else {
                                var _line = spaces(indent * level) + branch;
                                str += _line + "\n";
                                lastLength = _line.length;
                                if (level < 0) {
                                    str += "\n"; // extra blank line
                                    lastLength = 100000; // don't touch
                                }
                            }
                        }
                    }
                    return str;
                };
                // //////////////////////////////////////////// Structure for N3
                // Convert a set of statements into a nested tree of lists and strings
                function statementListToTreeMethod(statements) {
                    var stats = this.rootSubjects(statements);
                    var roots = stats.roots;
                    var results = [];
                    for(var i = 0; i < roots.length; i++){
                        var root = roots[i];
                        results.push(subjectTree(root, stats));
                    }
                    return results;
                }
                var statementListToTree = statementListToTreeMethod.bind(this);
                // The tree for a subject
                function subjectTree(subject, stats) {
                    if (subject.termType === "BlankNode" && !stats.incoming[subject]) return objectTree(subject, stats, true).concat([
                        "."
                    ]); // Anonymous bnode subject
                    return [
                        termToN3(subject, stats)
                    ].concat([
                        propertyTree(subject, stats)
                    ]).concat([
                        "."
                    ]);
                }
                // The property tree for a single subject or anonymous node
                function propertyTreeMethod(subject, stats) {
                    var results = [];
                    var lastPred = null;
                    var sts = stats.subjects[this.toStr(subject)] || []; // relevant statements
                    if (typeof sts === "undefined") throw new Error("Cant find statements for " + subject);
                    var objects = [];
                    for(var i = 0; i < sts.length; i++){
                        var st = sts[i];
                        if (st.predicate.uri === lastPred) objects.push(",");
                        else {
                            if (lastPred) {
                                results = results.concat([
                                    objects
                                ]).concat([
                                    ";"
                                ]);
                                objects = [];
                            }
                            results.push(predMap[st.predicate.uri] ? predMap[st.predicate.uri] : termToN3(st.predicate, stats));
                        }
                        lastPred = st.predicate.uri;
                        objects.push(objectTree(st.object, stats));
                    }
                    results = results.concat([
                        objects
                    ]);
                    return results;
                }
                var propertyTree = propertyTreeMethod.bind(this);
                function objectTreeMethod(obj, stats, force) {
                    if (obj.termType === "BlankNode" && (force || stats.rootsHash[obj.toNT()] === undefined)) {
                        // if not a root
                        if (stats.subjects[this.toStr(obj)]) return [
                            "[",
                            propertyTree(obj, stats),
                            "]"
                        ];
                        else return "[]";
                    }
                    return termToN3(obj, stats);
                }
                var objectTree = objectTreeMethod.bind(this);
                function termToN3Method(expr, stats) {
                    //
                    var i, res;
                    switch(expr.termType){
                        case "Graph":
                            res = [
                                "{"
                            ];
                            res = res.concat(statementListToTree(expr.statements));
                            return res.concat([
                                "}"
                            ]);
                        case "Collection":
                            res = [
                                "("
                            ];
                            for(i = 0; i < expr.elements.length; i++)res.push([
                                objectTree(expr.elements[i], stats)
                            ]);
                            res.push(")");
                            return res;
                        default:
                            return this.atomicTermToN3(expr);
                    }
                }
                Serializer.prototype.termToN3 = termToN3;
                var termToN3 = termToN3Method.bind(this);
                function prefixDirectivesMethod() {
                    var str = "";
                    if (this.flags.indexOf("d") < 0 && this.defaultNamespace) str += "@prefix : " + this.explicitURI(this.defaultNamespace) + ".\n";
                    for(var ns in this.prefixes){
                        if (!this.prefixes.hasOwnProperty(ns)) continue;
                        if (!this.namespacesUsed[ns]) continue;
                        str += "@prefix " + this.prefixes[ns] + ": " + this.explicitURI(ns) + ".\n";
                    }
                    return str + "\n";
                }
                var prefixDirectives = prefixDirectivesMethod.bind(this);
                // Body of statementsToN3:
                var tree = statementListToTree(sts);
                return prefixDirectives() + treeToString(tree);
            }
        },
        {
            key: "atomicTermToN3",
            value: function atomicTermToN3(expr, stats) {
                switch(expr.termType){
                    case "BlankNode":
                    case "Variable":
                        return expr.toNT();
                    case "Literal":
                        var val = expr.value;
                        if (typeof val !== "string") throw new TypeError("Value of RDF literal node must be a string");
                        // var val = expr.value.toString() // should be a string already
                        if (expr.datatype && this.flags.indexOf("x") < 0) // Supress native numbers
                        switch(expr.datatype.uri){
                            case "http://www.w3.org/2001/XMLSchema#integer":
                                return val;
                            case "http://www.w3.org/2001/XMLSchema#decimal":
                                // In Turtle, must have dot
                                if (val.indexOf(".") < 0) val += ".0";
                                return val;
                            case "http://www.w3.org/2001/XMLSchema#double":
                                // Must force use of 'e'
                                var eNotation = val.toLowerCase().indexOf("e") > 0;
                                if (val.indexOf(".") < 0 && !eNotation) val += ".0";
                                if (!eNotation) val += "e0";
                                return val;
                            case "http://www.w3.org/2001/XMLSchema#boolean":
                                return expr.value === "1" ? "true" : "false";
                        }
                        var str = this.stringToN3(expr.value);
                        if (expr.language) str += "@" + expr.language;
                        else if (!expr.datatype.equals(this.xsd.string)) str += "^^" + this.atomicTermToN3(expr.datatype, stats);
                        return str;
                    case "NamedNode":
                        return this.symbolToN3(expr);
                    case "DefaultGraph":
                        return "";
                    default:
                        throw new Error("Internal: atomicTermToN3 cannot handle " + expr + " of termType: " + expr.termType);
                }
            }
        },
        {
            key: "stringToN3",
            value: function stringToN3(str, flags) {
                if (!flags) flags = "e";
                var res = "";
                var i, j, k;
                var delim;
                var forbidden;
                if (str.length > 20 && // Long enough to make sense
                str.slice(-1) !== '"' && // corner case'
                flags.indexOf("n") < 0 && // Force single line
                (str.indexOf("\n") > 0 || str.indexOf('"') > 0)) {
                    delim = '"""';
                    forbidden = this.forbidden3;
                } else {
                    delim = '"';
                    forbidden = this.forbidden1;
                }
                for(i = 0; i < str.length;){
                    forbidden.lastIndex = 0;
                    var m = forbidden.exec(str.slice(i));
                    if (m == null) break;
                    j = i + forbidden.lastIndex - 1;
                    res += str.slice(i, j);
                    var ch = str[j];
                    if (ch === '"' && delim === '"""' && str.slice(j, j + 3) !== '"""') res += ch;
                    else {
                        k = '\b\f\r	\v\n\\"'.indexOf(ch); // No escaping of bell (7)?
                        if (k >= 0) res += "\\" + 'bfrtvn\\"'[k];
                        else if (flags.indexOf("e") >= 0) // Unicode escaping in strings not unix style
                        res += "\\u" + ("000" + ch.charCodeAt(0).toString(16).toLowerCase()).slice(-4);
                        else // no 'e' flag
                        res += ch;
                    }
                    i = j + 1;
                }
                return delim + res + str.slice(i) + delim;
            }
        },
        {
            key: "symbolToN3",
            value: function symbolToN3(x) {
                // c.f. symbolString() in notation3.py
                var uri = x.uri;
                var j = uri.indexOf("#");
                if (j < 0 && this.flags.indexOf("/") < 0) j = uri.lastIndexOf("/");
                if (j >= 0 && this.flags.indexOf("p") < 0 && // Can split at namespace but only if http[s]: URI or file: or ws[s] (why not others?)
                (uri.indexOf("http") === 0 || uri.indexOf("ws") === 0 || uri.indexOf("file") === 0)) {
                    var canSplit = true;
                    for(var k = j + 1; k < uri.length; k++)if (this._notNameChars.indexOf(uri[k]) >= 0) {
                        canSplit = false;
                        break;
                    }
                    /*
              if (uri.slice(0, j + 1) === this.base + '#') { // base-relative
                if (canSplit) {
                  return ':' + uri.slice(j + 1) // assume deafult ns is local
                } else {
                  return '<#' + uri.slice(j + 1) + '>'
                }
              }
        */ if (canSplit) {
                        var localid = uri.slice(j + 1);
                        var namesp = uri.slice(0, j + 1);
                        if (this.defaultNamespace && this.defaultNamespace === namesp && this.flags.indexOf("d") < 0) {
                            // d -> suppress default
                            if (this.flags.indexOf("k") >= 0 && this.keyords.indexOf(localid) < 0) return localid;
                            return ":" + localid;
                        }
                        // this.checkIntegrity() //  @@@ Remove when not testing
                        var prefix = this.prefixes[namesp];
                        if (!prefix) prefix = this.makeUpPrefix(namesp);
                        if (prefix) {
                            this.namespacesUsed[namesp] = true;
                            return prefix + ":" + localid;
                        }
                    // Fall though if can't do qname
                    }
                }
                return this.explicitURI(uri);
            }
        },
        {
            key: "writeStore",
            value: function writeStore(write) {
                var kb = this.store;
                var fetcher = kb.fetcher;
                var session = fetcher && fetcher.appNode;
                // The core data
                var sources = this.store.index[3];
                for(var s in sources){
                    // -> assume we can use -> as short for log:semantics
                    var source = kb.fromNT(s);
                    if (session && source.equals(session)) continue;
                    write("\n" + this.atomicTermToN3(source) + " " + this.atomicTermToN3(kb.sym("http://www.w3.org/2000/10/swap/log#semantics")) + " { " + this.statementsToN3(kb.statementsMatching(undefined, undefined, undefined, source)) + " }.\n");
                }
                // The metadata from HTTP interactions:
                kb.statementsMatching(undefined, kb.sym("http://www.w3.org/2007/ont/link#requestedURI")).map(function(st) {
                    write("\n<" + st.object.value + "> log:metadata {\n");
                    var sts = kb.statementsMatching(undefined, undefined, undefined, st.subject);
                    write(this.statementsToN3(this.statementsToN3(sts)));
                    write("}.\n");
                });
                // Inferences we have made ourselves not attributable to anyone else
                var metaSources = [];
                if (session) metaSources.push(session);
                var metadata = [];
                metaSources.map(function(source) {
                    metadata = metadata.concat(kb.statementsMatching(undefined, undefined, undefined, source));
                });
                write(this.statementsToN3(metadata));
            }
        },
        {
            key: "statementsToXML",
            value: function statementsToXML(sts) {
                var indent = 4;
                var width = 80;
                var namespaceCounts = []; // which have been used
                namespaceCounts["http://www.w3.org/1999/02/22-rdf-syntax-ns#"] = true;
                var liPrefix = "http://www.w3.org/1999/02/22-rdf-syntax-ns#_"; // prefix for ordered list items
                // //////////////////////// Arrange the bits of XML text
                var spaces = function spaces(n) {
                    var s = "";
                    for(var i = 0; i < n; i++)s += " ";
                    return s;
                };
                var XMLtreeToLine = function XMLtreeToLine(tree) {
                    var str = "";
                    for(var i = 0; i < tree.length; i++){
                        var branch = tree[i];
                        var s2 = typeof branch === "string" ? branch : XMLtreeToLine(branch);
                        str += s2;
                    }
                    return str;
                };
                // Convert a nested tree of lists and strings to a string
                var XMLtreeToString = function XMLtreeToString(tree, level) {
                    var str = "";
                    var line;
                    var lastLength = 100000;
                    if (!level) level = 0;
                    for(var i = 0; i < tree.length; i++){
                        var branch = tree[i];
                        if (typeof branch !== "string") {
                            var substr = XMLtreeToString(branch, level + 1);
                            if (substr.length < 10 * (width - indent * level) && substr.indexOf('"""') < 0) {
                                // Don't mess up multiline strings
                                line = XMLtreeToLine(branch);
                                if (line.length < width - indent * level) {
                                    branch = "   " + line; //   @@ Hack: treat as string below
                                    substr = "";
                                }
                            }
                            if (substr) lastLength = 10000;
                            str += substr;
                        }
                        if (typeof branch === "string") {
                            if (lastLength < indent * level + 4) {
                                // continue
                                str = str.slice(0, -1) + " " + branch + "\n";
                                lastLength += branch.length + 1;
                            } else {
                                line = spaces(indent * level) + branch;
                                str += line + "\n";
                                lastLength = line.length;
                            }
                        } else ;
                    }
                    return str;
                };
                function statementListToXMLTreeMethod(statements) {
                    this.suggestPrefix("rdf", "http://www.w3.org/1999/02/22-rdf-syntax-ns#");
                    var stats = this.rootSubjects(statements);
                    var roots = stats.roots;
                    var results = [];
                    for(var i = 0; i < roots.length; i++){
                        var root = roots[i];
                        results.push(subjectXMLTree(root, stats));
                    }
                    return results;
                }
                var statementListToXMLTree = statementListToXMLTreeMethod.bind(this);
                function escapeForXML(str) {
                    if (typeof str === "undefined") return "@@@undefined@@@@";
                    return str.replace(/[&<"]/g, function(m) {
                        switch(m[0]){
                            case "&":
                                return "&amp;";
                            case "<":
                                return "&lt;";
                            case '"':
                                return "&quot;";
                        }
                    });
                }
                function relURIMethod(term) {
                    return escapeForXML(this.base ? $4Q80K.refTo(this.base, term.uri) : term.uri);
                }
                var relURI = relURIMethod.bind(this);
                // The tree for a subject
                function subjectXMLTreeMethod(subject, stats) {
                    var results = [];
                    var type, t, st, pred;
                    var sts = stats.subjects[this.toStr(subject)]; // relevant statements
                    if (typeof sts === "undefined") // empty bnode
                    return propertyXMLTree(subject, stats);
                    // Sort only on the predicate, leave the order at object
                    // level undisturbed.  This leaves multilingual content in
                    // the order of entry (for partner literals), which helps
                    // readability.
                    //
                    // For the predicate sort, we attempt to split the uri
                    // as a hint to the sequence
                    sts.sort(function(a, b) {
                        var ap = a.predicate.uri;
                        var bp = b.predicate.uri;
                        if (ap.substring(0, liPrefix.length) === liPrefix || bp.substring(0, liPrefix.length) === liPrefix) // we're only interested in sorting list items
                        return ap.localeCompare(bp);
                        var as = ap.substring(liPrefix.length);
                        var bs = bp.substring(liPrefix.length);
                        var an = parseInt(as, 10);
                        var bn = parseInt(bs, 10);
                        if (isNaN(an) || isNaN(bn) || an !== as || bn !== bs) // we only care about integers
                        return ap.localeCompare(bp);
                        return an - bn;
                    });
                    for(var i = 0; i < sts.length; i++){
                        st = sts[i];
                        // look for a type
                        if (st.predicate.uri === "http://www.w3.org/1999/02/22-rdf-syntax-ns#type" && !type && st.object.termType === "NamedNode") {
                            type = st.object;
                            continue; // don't include it as a child element
                        }
                        // see whether predicate can be replaced with "li"
                        pred = st.predicate;
                        if (pred.uri.substr(0, liPrefix.length) === liPrefix) {
                            var number = pred.uri.substr(liPrefix.length);
                            // make sure these are actually numeric list items
                            var intNumber = parseInt(number, 10);
                            if (number === intNumber.toString()) // was numeric; don't need to worry about ordering since we've already
                            // sorted the statements
                            pred = this.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#li");
                        }
                        t = qname(pred);
                        switch(st.object.termType){
                            case "BlankNode":
                                if (stats.incoming[st.object].length === 1) // there should always be something in the incoming array for a bnode
                                results = results.concat([
                                    "<" + t + ' rdf:parseType="Resource">',
                                    subjectXMLTree(st.object, stats),
                                    "</" + t + ">"
                                ]);
                                else results = results.concat([
                                    "<" + t + ' rdf:nodeID="' + st.object.toNT().slice(2) + '"/>'
                                ]);
                                break;
                            case "NamedNode":
                                results = results.concat([
                                    "<" + t + ' rdf:resource="' + relURI(st.object) + '"/>'
                                ]);
                                break;
                            case "Literal":
                                results = results.concat([
                                    "<" + t + (st.object.datatype.equals(this.xsd.string) ? "" : ' rdf:datatype="' + escapeForXML(st.object.datatype.uri) + '"') + (st.object.language ? ' xml:lang="' + st.object.language + '"' : "") + ">" + escapeForXML(st.object.value) + "</" + t + ">"
                                ]);
                                break;
                            case "Collection":
                                results = results.concat([
                                    "<" + t + ' rdf:parseType="Collection">',
                                    collectionXMLTree(st.object, stats),
                                    "</" + t + ">"
                                ]);
                                break;
                            default:
                                throw new Error("Can't serialize object of type " + st.object.termType + " into XML");
                        } // switch
                    }
                    var tag = type ? qname(type) : "rdf:Description";
                    var attrs = "";
                    if (subject.termType === "BlankNode") {
                        if (!stats.incoming[subject] || stats.incoming[subject].length !== 1) // not an anonymous bnode
                        attrs = ' rdf:nodeID="' + subject.toNT().slice(2) + '"';
                    } else attrs = ' rdf:about="' + relURI(subject) + '"';
                    return [
                        "<" + tag + attrs + ">"
                    ].concat([
                        results
                    ]).concat([
                        "</" + tag + ">"
                    ]);
                }
                var subjectXMLTree = subjectXMLTreeMethod.bind(this);
                function collectionXMLTree(subject, stats) {
                    var res = [];
                    for(var i = 0; i < subject.elements.length; i++)res.push(subjectXMLTree(subject.elements[i], stats));
                    return res;
                }
                // The property tree for a single subject or anonymos node
                function propertyXMLTreeMethod(subject, stats) {
                    var results = [];
                    var sts = stats.subjects[this.toStr(subject)]; // relevant statements
                    if (!sts) return results; // No relevant statements
                    sts.sort();
                    for(var i = 0; i < sts.length; i++){
                        var st = sts[i];
                        switch(st.object.termType){
                            case "BlankNode":
                                if (stats.rootsHash[st.object.toNT()]) // This bnode has been done as a root -- no content here @@ what bout first time
                                results = results.concat([
                                    "<" + qname(st.predicate) + ' rdf:nodeID="' + st.object.toNT().slice(2) + '">',
                                    "</" + qname(st.predicate) + ">"
                                ]);
                                else results = results.concat([
                                    "<" + qname(st.predicate) + ' rdf:parseType="Resource">',
                                    propertyXMLTree(st.object, stats),
                                    "</" + qname(st.predicate) + ">"
                                ]);
                                break;
                            case "NamedNode":
                                results = results.concat([
                                    "<" + qname(st.predicate) + ' rdf:resource="' + relURI(st.object) + '"/>'
                                ]);
                                break;
                            case "Literal":
                                results = results.concat([
                                    "<" + qname(st.predicate) + (st.object.datatype.equals(this.xsd.string) ? "" : ' rdf:datatype="' + escapeForXML(st.object.datatype.value) + '"') + (st.object.language ? ' xml:lang="' + st.object.language + '"' : "") + ">" + escapeForXML(st.object.value) + "</" + qname(st.predicate) + ">"
                                ]);
                                break;
                            case "Collection":
                                results = results.concat([
                                    "<" + qname(st.predicate) + ' rdf:parseType="Collection">',
                                    collectionXMLTree(st.object, stats),
                                    "</" + qname(st.predicate) + ">"
                                ]);
                                break;
                            default:
                                throw new Error("Can't serialize object of type " + st.object.termType + " into XML");
                        } // switch
                    }
                    return results;
                }
                var propertyXMLTree = propertyXMLTreeMethod.bind(this);
                function qnameMethod(term) {
                    var uri = term.uri;
                    var j = uri.indexOf("#");
                    if (j < 0 && this.flags.indexOf("/") < 0) j = uri.lastIndexOf("/");
                    if (j < 0) throw new Error("Cannot make qname out of <" + uri + ">");
                    for(var k = j + 1; k < uri.length; k++){
                        if (this._notNameChars.indexOf(uri[k]) >= 0) throw new Error('Invalid character "' + uri[k] + '" cannot be in XML qname for URI: ' + uri);
                    }
                    var localid = uri.slice(j + 1);
                    var namesp = uri.slice(0, j + 1);
                    if (this.defaultNamespace && this.defaultNamespace === namesp && this.flags.indexOf("d") < 0) // d -> suppress default
                    return localid;
                    var prefix = this.prefixes[namesp];
                    if (!prefix) prefix = this.makeUpPrefix(namesp);
                    namespaceCounts[namesp] = true;
                    return prefix + ":" + localid;
                }
                var qname = qnameMethod.bind(this);
                // Body of toXML:
                var tree = statementListToXMLTree(sts);
                var str = "<rdf:RDF";
                if (this.defaultNamespace) str += ' xmlns="' + escapeForXML(this.defaultNamespace) + '"';
                for(var ns in namespaceCounts){
                    if (!namespaceCounts.hasOwnProperty(ns)) continue;
                    // Rel uris in xml ns is not strictly allowed in the XMLNS spec but needed in practice often
                    var ns2 = this.base && this.flags.includes("z") ? $4Q80K.refTo(this.base, ns) : ns;
                    str += "\n xmlns:" + this.prefixes[ns] + '="' + escapeForXML(ns2) + '"';
                }
                str += ">";
                var tree2 = [
                    str,
                    tree,
                    "</rdf:RDF>"
                ]; // @@ namespace declrations
                return XMLtreeToString(tree2, -1);
            } // End @@ body
        },
        {
            key: "statementsToJsonld",
            value: function statementsToJsonld(sts) {
                // ttl2jsonld creates context keys for all ttl prefix
                // context keys must be absolute IRI ttl2jsonld@0.0.8
                /* function findId (itemObj) {
        if (itemObj['@id']) {
          const item = itemObj['@id'].split(':')
          if (keys[item[0]]) itemObj['@id'] = jsonldObj['@context'][item[0]] + item[1]
        }
        const itemValues = Object.values(itemObj)
        for (const i in itemValues) {
          if (typeof itemValues[i] !== 'string') { // @list contains array
            findId(itemValues[i])
          }
        }
      } */ var turtleDoc = this.statementsToN3(sts);
                var jsonldObj = $4637181ac5e22c58$exports.parse(turtleDoc);
                return JSON.stringify(jsonldObj, null, 2);
            }
        }
    ]);
    return Serializer;
}();
// String escaping utilities
function $f832e5387e149401$var$hexify(str) {
    // also used in parser
    return encodeURI(str);
}
function $f832e5387e149401$var$backslashUify(str) {
    var res = "";
    var k;
    for(var i = 0; i < str.length; i++){
        k = str.charCodeAt(i);
        if (k > 65535) res += "\\U" + ("00000000" + k.toString(16)).slice(-8); // convert to upper?
        else if (k > 126) res += "\\u" + ("0000" + k.toString(16)).slice(-4);
        else res += str[i];
    }
    return res;
}



var $8RKL2 = parcelRequire("8RKL2");
function $957a454a8ab6ebde$export$2e2bcd8739ae039(/** The graph or nodes that should be serialized */ target, /** The store */ kb, base, /**
 * The mime type.
 * Defaults to Turtle.
 */ contentType, callback, options) {
    base = base || (target === null || target === void 0 ? void 0 : target.value);
    var opts = options || {};
    contentType = contentType || (0, $8RKL2.TurtleContentType); // text/n3 if complex?
    var documentString = undefined;
    try {
        var sz = (0, $f832e5387e149401$export$2e2bcd8739ae039)(kb);
        if (opts.flags) sz.setFlags(opts.flags);
        var newSts = kb.statementsMatching(undefined, undefined, undefined, target);
        // If an IndexedFormula, use the namespaces from the given graph as suggestions
        if ("namespaces" in kb) sz.suggestNamespaces(kb.namespaces);
        // use the provided options.namespaces are mandatory prefixes
        if (opts.namespaces) sz.setNamespaces(opts.namespaces);
        sz.setBase(base);
        switch(contentType){
            case 0, $8RKL2.RDFXMLContentType:
                documentString = sz.statementsToXML(newSts);
                return executeCallback(null, documentString);
            case 0, $8RKL2.N3ContentType:
            case 0, $8RKL2.N3LegacyContentType:
                documentString = sz.statementsToN3(newSts);
                return executeCallback(null, documentString);
            case 0, $8RKL2.TurtleContentType:
            case 0, $8RKL2.TurtleLegacyContentType:
                sz.setFlags("si"); // Suppress = for sameAs and => for implies
                documentString = sz.statementsToN3(newSts);
                return executeCallback(null, documentString);
            case 0, $8RKL2.NTriplesContentType:
                sz.setFlags("deinprstux"); // Suppress nice parts of N3 to make ntriples
                documentString = sz.statementsToNTriples(newSts);
                return executeCallback(null, documentString);
            case 0, $8RKL2.JSONLDContentType:
                sz.setFlags("si dr"); // turtle + dr (means no default, no relative prefix)
                documentString = sz.statementsToJsonld(newSts); // convert via turtle
                return executeCallback(null, documentString);
            case 0, $8RKL2.NQuadsContentType:
            case 0, $8RKL2.NQuadsAltContentType:
                // @@@ just outpout the quads? Does not work for collections
                sz.setFlags("deinprstux q"); // Suppress nice parts of N3 to make ntriples
                documentString = sz.statementsToNTriples(newSts); // q in flag means actually quads
                return executeCallback(null, documentString);
            default:
                throw new Error("Serialize: Content-type " + contentType + " not supported for data write.");
        }
    } catch (err) {
        if (callback) // @ts-ignore
        return callback(err, undefined);
        throw err; // Don't hide problems from caller in sync mode
    }
    function executeCallback(err, result) {
        if (callback) {
            callback(err, result);
            return;
        } else return result;
    }
}



var $8RKL2 = parcelRequire("8RKL2");

var $gCJkd = parcelRequire("gCJkd");


var $kAE07 = parcelRequire("kAE07");

var $4Q80K = parcelRequire("4Q80K");

var $23fob = parcelRequire("23fob");
function $c584fbcedb5512e3$export$cc2475d73d6ab0ad(kb, p, requestedBy) {
    var sf = null;
    if (typeof kb.fetcher !== "undefined") sf = kb.fetcher;
    else return;
    if (p.termType !== "NamedNode") return;
    var docuri = (0, $4Q80K.docpart)(p.uri);
    var fixuri;
    if (p.uri.indexOf("#") < 0) {
        // No hash
        // @@ major hack for dbpedia Categories, which spread indefinitely
        if ((0, $23fob.string_startswith)(p.uri, "http://dbpedia.org/resource/Category:")) return;
        /*
      if (string_startswith(p.uri, 'http://xmlns.com/foaf/0.1/')) {
      fixuri = "http://dig.csail.mit.edu/2005/ajar/ajaw/test/foaf"
      // should give HTTP 303 to ontology -- now is :-)
      } else
    */ if ((0, $23fob.string_startswith)(p.uri, "http://purl.org/dc/elements/1.1/") || (0, $23fob.string_startswith)(p.uri, "http://purl.org/dc/terms/")) fixuri = "http://dublincore.org/2005/06/13/dcq";
        else if ((0, $23fob.string_startswith)(p.uri, "http://xmlns.com/wot/0.1/")) fixuri = "http://xmlns.com/wot/0.1/index.rdf";
        else if ((0, $23fob.string_startswith)(p.uri, "http://web.resource.org/cc/")) //            log.warn("creative commons links to html instead of rdf. doesn't seem to content-negotiate.")
        fixuri = "http://web.resource.org/cc/schema.rdf";
    }
    if (fixuri) docuri = fixuri;
    if (sf && sf.getState(docuri) !== "unrequested") return;
    if (fixuri) // only give warning once: else happens too often
    (0, $kAE07.default).warn("Assuming server still broken, faking redirect of <" + p.uri + "> to <" + docuri + ">");
    return sf.fetch(docuri, {
        referringTerm: requestedBy
    });
}
var $c584fbcedb5512e3$export$d04247d66bc672f = [
    "blankNode",
    "defaultGraph",
    "literal",
    "namedNode",
    "quad",
    "variable",
    "supports"
];
var $c584fbcedb5512e3$var$rdf = {
    first: "http://www.w3.org/1999/02/22-rdf-syntax-ns#first",
    rest: "http://www.w3.org/1999/02/22-rdf-syntax-ns#rest",
    nil: "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"
};
function $c584fbcedb5512e3$export$b0f02731210f3037(rdfFactory, subject, data) {
    var statements = [];
    data.reduce(function(id, _listObj, i, listData) {
        statements.push(rdfFactory.quad(id, rdfFactory.namedNode($c584fbcedb5512e3$var$rdf.first), listData[i]));
        var nextNode;
        if (i < listData.length - 1) {
            nextNode = rdfFactory.blankNode();
            statements.push(rdfFactory.quad(id, rdfFactory.namedNode($c584fbcedb5512e3$var$rdf.rest), nextNode));
        } else statements.push(rdfFactory.quad(id, rdfFactory.namedNode($c584fbcedb5512e3$var$rdf.rest), rdfFactory.namedNode($c584fbcedb5512e3$var$rdf.nil)));
        return nextNode;
    }, subject);
    return statements;
}
function $c584fbcedb5512e3$export$37abcb37ee31055e(arr, item) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var length = arr.length;
    if (i < 0) i = length + i;
    for(; i < length; i++){
        if (arr[i] === item) return i;
    }
    return -1;
}



var $99pVg = parcelRequire("99pVg");
function $31157af6e1e82257$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $31157af6e1e82257$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $31157af6e1e82257$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $31157af6e1e82257$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $31157af6e1e82257$var$_arrayLikeToArray(o, minLen);
}
function $31157af6e1e82257$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $31157af6e1e82257$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $31157af6e1e82257$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $31157af6e1e82257$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A formula, or store of RDF statements
 */ var $31157af6e1e82257$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Node) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Formula, _Node);
    var _super = $31157af6e1e82257$var$_createSuper(Formula);
    /**
   * Initializes this formula
   * @constructor
   * @param statements - Initial array of statements
   * @param constraints - initial array of constraints
   * @param initBindings - initial bindings used in Query
   * @param optional - optional
   * @param opts
   * @param opts.rdfFactory - The rdf factory that should be used by the store
  */ function Formula() {
        var _this;
        var statements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var constraints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var initBindings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var optional = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
        var opts = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Formula);
        _this = _super.call(this, "");
        _this.statements = statements;
        _this.constraints = constraints;
        _this.initBindings = initBindings;
        _this.optional = optional;
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "termType", (0, $8RKL2.GraphTermType));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "classOrder", (0, $aZYlt.default).Graph);
        /**
     * The accompanying fetcher instance.
     *
     * Is set by the fetcher when initialized.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "fetcher", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "isVar", 0);
        /**
     * A namespace for the specified namespace's URI
     * @param nsuri The URI for the namespace
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "ns", (0, $5b5611d501681341$export$2e2bcd8739ae039));
        /** The factory used to generate statements and terms */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "rdfFactory", void 0);
        _this.rdfFactory = opts && opts.rdfFactory || (0, $158d84b4866fe33e$export$2e2bcd8739ae039);
        // Enable default factory methods on this while preserving factory context.
        var _iterator = $31157af6e1e82257$var$_createForOfIteratorHelper((0, $c584fbcedb5512e3$export$d04247d66bc672f)), _step;
        try {
            var _loop = function _loop() {
                var factoryMethod = _step.value;
                _this[factoryMethod] = function() {
                    var _this$rdfFactory;
                    return (_this$rdfFactory = _this.rdfFactory)[factoryMethod].apply(_this$rdfFactory, arguments);
                };
            };
            for(_iterator.s(); !(_step = _iterator.n()).done;)_loop();
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return _this;
    }
    /** Add a statement from its parts
   * @param subject - the first part of the statement
   * @param predicate - the second part of the statement
   * @param object - the third part of the statement
   * @param graph - the last part of the statement
   */ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Formula, [
        {
            key: "add",
            value: function add(subject, predicate, object, graph) {
                var _this2 = this;
                if (arguments.length === 1) subject.forEach(function(st) {
                    return _this2.add(st.subject, st.predicate, st.object, st.graph);
                });
                return this.statements.push(this.rdfFactory.quad(subject, predicate, object, graph));
            }
        },
        {
            key: "addStatement",
            value: function addStatement(statement) {
                return this.add(statement);
            }
        },
        {
            key: "bnode",
            value: function bnode(id) {
                return this.rdfFactory.blankNode(id);
            }
        },
        {
            key: "addAll",
            value: function addAll(statements) {
                var _this3 = this;
                statements.forEach(function(quad) {
                    _this3.add(quad.subject, quad.predicate, quad.object, quad.graph);
                });
            }
        },
        {
            key: "any",
            value: function any(s, p, o, g) {
                var st = this.anyStatementMatching(s, p, o, g);
                if (st == null) return null;
                else if (s == null) return st.subject;
                else if (p == null) return st.predicate;
                else if (o == null) return st.object;
                return null;
            }
        },
        {
            key: "anyValue",
            value: function anyValue(s, p, o, g) {
                var y = this.any(s, p, o, g);
                return y ? y.value : void 0;
            }
        },
        {
            key: "anyJS",
            value: function anyJS(s, p, o, g) {
                var y = this.any(s, p, o, g);
                return y ? (0, $cdU35.default).toJS(y) : void 0;
            }
        },
        {
            key: "anyStatementMatching",
            value: function anyStatementMatching(s, p, o, g) {
                var x = this.statementsMatching(s, p, o, g, true);
                if (!x || x.length === 0) return undefined;
                return x[0];
            }
        },
        {
            key: "id",
            value: function id(term) {
                return this.rdfFactory.id(term);
            }
        },
        {
            key: "statementsMatching",
            value: function statementsMatching(s, p, o, g, justOne) {
                var sts = this.statements.filter(function(st) {
                    return (!s || s.equals(st.subject)) && (!p || p.equals(st.predicate)) && (!o || o.equals(st.object)) && (!g || g.equals(st.graph));
                });
                if (justOne) return sts.length === 0 ? [] : [
                    sts[0]
                ];
                return sts;
            }
        },
        {
            key: "bottomTypeURIs",
            value: function bottomTypeURIs(types) {
                var bots;
                var bottom;
                var elt;
                var i;
                var len;
                var ref;
                var subs;
                var v;
                bots = [];
                for(var _k in types){
                    if (!types.hasOwnProperty(_k)) continue;
                    v = types[_k];
                    subs = this.each(void 0, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"), this.rdfFactory.namedNode(_k));
                    bottom = true;
                    i = 0;
                    for(len = subs.length; i < len; i++){
                        elt = subs[i];
                        ref = elt.uri;
                        if (ref in types) {
                            // the subclass is one we know
                            bottom = false;
                            break;
                        }
                    }
                    if (bottom) bots[_k] = v;
                }
                return bots;
            }
        },
        {
            key: "collection",
            value: function collection() {
                return new (0, $619d91631affbf30$export$2e2bcd8739ae039)();
            }
        },
        {
            key: "each",
            value: function each(s, p, o, g) {
                var results = [];
                var sts = this.statementsMatching(s, p, o, g, false);
                if (s == null) for(var i = 0, len = sts.length; i < len; i++)results.push(sts[i].subject);
                else if (p == null) for(var l = 0, len1 = sts.length; l < len1; l++)results.push(sts[l].predicate);
                else if (o == null) for(var m = 0, len2 = sts.length; m < len2; m++)results.push(sts[m].object);
                else if (g == null) for(var _q = 0, len3 = sts.length; _q < len3; _q++)results.push(new (0, $99pVg.default)(sts[_q].graph.value));
                return results;
            }
        },
        {
            key: "equals",
            value: function equals(other) {
                if (!other) return false;
                return this.hashString() === other.hashString();
            }
        },
        {
            key: "findMembersNT",
            value: function findMembersNT(thisClass) {
                var len2;
                var len4;
                var m;
                var members;
                var pred;
                var ref;
                var ref1;
                var ref2;
                var ref3;
                var ref4;
                var ref5;
                var seeds;
                var st;
                var u;
                seeds = {};
                seeds[thisClass.toNT()] = true;
                members = {};
                ref = this.transitiveClosure(seeds, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"), true);
                for(var t in ref){
                    if (!ref.hasOwnProperty(t)) continue;
                    ref1 = this.statementsMatching(void 0, this.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"), this.fromNT(t));
                    for(var i = 0, len = ref1.length; i < len; i++){
                        st = ref1[i];
                        members[st.subject.toNT()] = st;
                    }
                    ref2 = this.each(void 0, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#domain"), this.fromNT(t));
                    for(var l = 0, len1 = ref2.length; l < len1; l++){
                        pred = ref2[l];
                        ref3 = this.statementsMatching(void 0, pred);
                        for(m = 0, len2 = ref3.length; m < len2; m++){
                            st = ref3[m];
                            members[st.subject.toNT()] = st;
                        }
                    }
                    ref4 = this.each(void 0, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#range"), this.fromNT(t));
                    for(var _q2 = 0, len3 = ref4.length; _q2 < len3; _q2++){
                        pred = ref4[_q2];
                        ref5 = this.statementsMatching(void 0, pred);
                        for(u = 0, len4 = ref5.length; u < len4; u++){
                            st = ref5[u];
                            members[st.object.toNT()] = st;
                        }
                    }
                }
                return members;
            }
        },
        {
            key: "findMemberURIs",
            value: function findMemberURIs(subject) {
                return this.NTtoURI(this.findMembersNT(subject));
            }
        },
        {
            key: "findSubClassesNT",
            value: function findSubClassesNT(subject) {
                var types = {};
                types[subject.toNT()] = true;
                return this.transitiveClosure(types, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"), true);
            }
        },
        {
            key: "findSuperClassesNT",
            value: function findSuperClassesNT(subject) {
                var types = {};
                types[subject.toNT()] = true;
                return this.transitiveClosure(types, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"), false);
            }
        },
        {
            key: "findTypesNT",
            value: function findTypesNT(subject) {
                var domain;
                var range;
                var rdftype;
                var ref;
                var ref1;
                var ref2;
                var ref3;
                var st;
                var types;
                rdftype = "http://www.w3.org/1999/02/22-rdf-syntax-ns#type";
                types = [];
                ref = this.statementsMatching(subject, void 0, void 0);
                for(var i = 0, len = ref.length; i < len; i++){
                    st = ref[i];
                    if (st.predicate.uri === rdftype) types[st.object.toNT()] = st;
                    else {
                        ref1 = this.each(st.predicate, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#domain"));
                        for(var l = 0, len1 = ref1.length; l < len1; l++){
                            range = ref1[l];
                            types[range.toNT()] = st;
                        }
                    }
                }
                ref2 = this.statementsMatching(void 0, void 0, subject);
                for(var m = 0, len2 = ref2.length; m < len2; m++){
                    st = ref2[m];
                    ref3 = this.each(st.predicate, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#range"));
                    for(var _q3 = 0, len3 = ref3.length; _q3 < len3; _q3++){
                        domain = ref3[_q3];
                        types[domain.toNT()] = st;
                    }
                }
                return this.transitiveClosure(types, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"), false);
            }
        },
        {
            key: "findTypeURIs",
            value: function findTypeURIs(subject) {
                return this.NTtoURI(this.findTypesNT(subject));
            }
        },
        {
            key: "connectedStatements",
            value: function connectedStatements(subject, doc, excludePredicateURIs) {
                excludePredicateURIs = excludePredicateURIs || [];
                var todo = [
                    subject
                ];
                var done = {};
                var doneArcs = {};
                var result = [];
                var self = this;
                var follow = function follow(x) {
                    var queue = function queue(x) {
                        if (x.termType === "BlankNode" && !done[x.value]) {
                            done[x.value] = true;
                            todo.push(x);
                        }
                    };
                    var sts = self.statementsMatching(null, null, x, doc).concat(self.statementsMatching(x, null, null, doc));
                    sts = sts.filter(function(st) {
                        if (excludePredicateURIs[st.predicate.value]) return false;
                        var hash = st.toNT();
                        if (doneArcs[hash]) return false;
                        doneArcs[hash] = true;
                        return true;
                    });
                    sts.forEach(function(st) {
                        queue(st.subject);
                        queue(st.object);
                    });
                    result = result.concat(sts);
                };
                while(todo.length)follow(todo.shift());
                return result;
            }
        },
        {
            key: "formula",
            value: function formula(_features) {
                return new Formula();
            }
        },
        {
            key: "fromNT",
            value: function fromNT(str) {
                var dt, k, lang;
                switch(str[0]){
                    case "<":
                        return this.sym(str.slice(1, -1));
                    case '"':
                        lang = void 0;
                        dt = void 0;
                        k = str.lastIndexOf('"');
                        if (k < str.length - 1) {
                            if (str[k + 1] === "@") lang = str.slice(k + 2);
                            else if (str.slice(k + 1, k + 3) === "^^") dt = this.fromNT(str.slice(k + 3));
                            else throw new Error("Can't convert string from NT: " + str);
                        }
                        str = str.slice(1, k);
                        str = str.replace(/\\"/g, '"');
                        str = str.replace(/\\n/g, "\n");
                        str = str.replace(/\\\\/g, "\\");
                        return this.rdfFactory.literal(str, lang || dt);
                    case "_":
                        return this.rdfFactory.blankNode(str.slice(2));
                    case "?":
                        return new (0, $b7a48305c1700eec$export$2e2bcd8739ae039)(str.slice(1));
                }
                throw new Error("Can't convert from NT: " + str);
            }
        },
        {
            key: "holds",
            value: function holds(s, p, o, g) {
                var i;
                if (arguments.length === 1) {
                    if (!s) return true;
                    if (s instanceof Array) {
                        for(i = 0; i < s.length; i++){
                            if (!this.holds(s[i])) return false;
                        }
                        return true;
                    } else if ((0, $gCJkd.isStatement)(s)) return this.holds(s.subject, s.predicate, s.object, s.graph);
                    else if (s.statements) return this.holds(s.statements);
                }
                var st = this.anyStatementMatching(s, p, o, g);
                return st != null;
            }
        },
        {
            key: "holdsStatement",
            value: function holdsStatement(statement) {
                return this.holds(statement.subject, statement.predicate, statement.object, statement.graph);
            }
        },
        {
            key: "list",
            value: function list(values, context) {
                if (context.rdfFactory.supports["COLLECTIONS"]) {
                    var collection = context.rdfFactory.collection();
                    values.forEach(function(val) {
                        collection.append(val);
                    });
                    return collection;
                } else {
                    var node = context.rdfFactory.blankNode();
                    var statements = (0, $c584fbcedb5512e3$export$b0f02731210f3037)(context.rdfFactory, node, values);
                    context.addAll(statements);
                    return node;
                }
            }
        },
        {
            key: "NTtoURI",
            value: function NTtoURI(t) {
                var k, v;
                var uris = {};
                for(k in t){
                    if (!t.hasOwnProperty(k)) continue;
                    v = t[k];
                    if (k[0] === "<") uris[k.slice(1, -1)] = v;
                }
                return uris;
            }
        },
        {
            key: "serialize",
            value: function serialize(base, contentType, provenance, options) {
                // delegate the graph serialization to the implementation in ./serialize
                return (0, $957a454a8ab6ebde$export$2e2bcd8739ae039)(provenance, this, base, contentType, undefined, options);
            }
        },
        {
            key: "substitute",
            value: function substitute(bindings) {
                var statementsCopy = this.statements.map(function(ea) {
                    return ea.substitute(bindings);
                });
                // console.log('Formula subs statmnts:' + statementsCopy)
                var y = new Formula();
                y.addAll(statementsCopy);
                // console.log('indexed-form subs formula:' + y)
                return y;
            }
        },
        {
            key: "sym",
            value: function sym(uri, name) {
                if (name) throw new Error("This feature (kb.sym with 2 args) is removed. Do not assume prefix mappings.");
                return this.rdfFactory.namedNode(uri);
            }
        },
        {
            key: "the",
            value: function the(s, p, o, g) {
                var x = this.any(s, p, o, g);
                if (x == null) (0, $kAE07.default).error("No value found for the() {" + s + " " + p + " " + o + "}.");
                return x;
            }
        },
        {
            key: "transitiveClosure",
            value: function transitiveClosure(seeds, predicate, inverse) {
                var elt, i, len, s, sups, t;
                var agenda = {};
                Object.assign(agenda, seeds); // make a copy
                var done = {}; // classes we have looked up
                while(true){
                    t = function() {
                        for(var p in agenda){
                            if (!agenda.hasOwnProperty(p)) continue;
                            return p;
                        }
                    }();
                    if (t == null) return done;
                    sups = inverse ? this.each(void 0, predicate, this.fromNT(t)) : this.each(this.fromNT(t), predicate);
                    for(i = 0, len = sups.length; i < len; i++){
                        elt = sups[i];
                        s = elt.toNT();
                        if (s in done) continue;
                        if (s in agenda) continue;
                        agenda[s] = agenda[t];
                    }
                    done[t] = agenda[t];
                    delete agenda[t];
                }
            }
        },
        {
            key: "topTypeURIs",
            value: function topTypeURIs(types) {
                var i;
                var j;
                var k;
                var len;
                var n;
                var ref;
                var tops;
                var v;
                tops = [];
                for(k in types){
                    if (!types.hasOwnProperty(k)) continue;
                    v = types[k];
                    n = 0;
                    ref = this.each(this.rdfFactory.namedNode(k), this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"));
                    for(i = 0, len = ref.length; i < len; i++){
                        j = ref[i];
                        if (j.uri !== "http://www.w3.org/2000/01/rdf-schema#Resource") {
                            n++;
                            break;
                        }
                    }
                    if (!n) tops[k] = v;
                }
                if (tops["http://www.w3.org/2000/01/rdf-schema#Resource"]) delete tops["http://www.w3.org/2000/01/rdf-schema#Resource"];
                if (tops["http://www.w3.org/2002/07/owl#Thing"]) delete tops["http://www.w3.org/2002/07/owl#Thing"];
                return tops;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "{" + this.statements.join("\n") + "}";
            }
        },
        {
            key: "variable",
            value: function variable(name) {
                return new (0, $b7a48305c1700eec$export$2e2bcd8739ae039)(name);
            }
        },
        {
            key: "whether",
            value: function whether(s, p, o, g) {
                return this.statementsMatching(s, p, o, g, false).length;
            }
        }
    ]);
    return Formula;
}((0, $cdU35.default));




var $23fob = parcelRequire("23fob");

var $gCJkd = parcelRequire("gCJkd");
// This file attaches all functionality to Node
// that would otherwise require circular dependencies.


var $cdU35 = parcelRequire("cdU35");


var $gCJkd = parcelRequire("gCJkd");
/**
 * Creates an RDF Node from a native javascript value.
 * RDF Nodes are returned unchanged, undefined returned as itself.
 * @method fromValue
 * @static
 * @param value {Node|Date|String|Number|Boolean|Undefined}
 * @return {Node|Collection}
 */ (0, $cdU35.default).fromValue = (0, $619d91631affbf30$export$5f36b26c3833b3ba);
var $e01338ed2499626a$export$2e2bcd8739ae039 = (0, $cdU35.default);
var $e01338ed2499626a$var$ns = {
    xsd: (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/2001/XMLSchema#")
};
/**
 * Gets the javascript object equivalent to a node
 * @param term The RDF node
 */ (0, $cdU35.default).toJS = function(term) {
    if ((0, $gCJkd.isCollection)(term)) return term.elements.map((0, $cdU35.default).toJS); // Array node (not standard RDFJS)
    if (!(0, $gCJkd.isLiteral)(term)) return term;
    if (term.datatype.equals($e01338ed2499626a$var$ns.xsd("boolean"))) return term.value === "1" || term.value === "true";
    if (term.datatype.equals($e01338ed2499626a$var$ns.xsd("dateTime")) || term.datatype.equals($e01338ed2499626a$var$ns.xsd("date"))) return new Date(term.value);
    if (term.datatype.equals($e01338ed2499626a$var$ns.xsd("integer")) || term.datatype.equals($e01338ed2499626a$var$ns.xsd("float")) || term.datatype.equals($e01338ed2499626a$var$ns.xsd("decimal"))) return Number(term.value);
    return term.value;
};




var $lR7jo = parcelRequire("lR7jo");

var $fu0YK = parcelRequire("fu0YK");



var $kAE07 = parcelRequire("kAE07");

var $4Q80K = parcelRequire("4Q80K");
var $06f9ff3d33460d2e$export$62297b13309008b2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(function Query(name, id) {
    (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Query);
    this.pat = new (0, $6f5c135260474402$export$2e2bcd8739ae039)(); // The pattern to search for
    this.vars = []; // Used by UI code but not in query.js
    //    this.orderBy = [] // Not used yet
    this.name = name;
    this.id = id;
});
function $06f9ff3d33460d2e$export$b935ec197a103b45(myQuery, callback, fetcher, onDone) {
    /** Debug strings
  */ function bindingDebug(b) {
        var str = "";
        var v;
        for(v in b)if (b.hasOwnProperty(v)) str += "    " + v + " -> " + b[v];
        return str;
    }
    function bindingsDebug(nbs) {
        var str = "Bindings: ";
        var i;
        var n = nbs.length;
        for(i = 0; i < n; i++)str += bindingDebug(nbs[i][0]) + ";\n	";
        return str;
    } // bindingsDebug
    /** Unification
   *
   * Unification finds all bindings such that when the binding is applied
   * to one term it is equal to the other.
   * @returns {Arrray}-  a list of bindings, where a binding is an associative array
   *  mapping variuable to value.
   */ function unifyTerm(self, other, bindings, formula) {
        var actual = bindings[self];
        if (actual === undefined) {
            // Not mapped
            if (self.isVar) {
                var b = [];
                b[self] = other;
                return [
                    [
                        b,
                        null
                    ]
                ]; // Match
            }
            actual = self;
        }
        if (!actual.complexType) {
            if (formula.redirections[actual]) actual = formula.redirections[actual];
            if (formula.redirections[other]) other = formula.redirections[other];
            if (actual.equals(other) || actual.uri && actual.uri === (0, $471ea8b4e912e4b1$export$fb7535ed90405da0)) // Used to mean 'any graph' in a query
            return [
                [
                    [],
                    null
                ]
            ];
            return [];
        }
        if (self instanceof Array) {
            if (!(other instanceof Array)) return [];
            return unifyContents(self, other, bindings);
        }
        throw new Error("query.js: oops - code not written yet");
    // return undefined;  // for lint - no jslint objects to unreachables
    //    return actual.unifyContents(other, bindings)
    } // unifyTerm
    function unifyContents(self, other, bindings, formula) {
        var nbs2;
        if (self.length !== other.length) return []; // no way
        if (!self.length) return [
            [
                [],
                null
            ]
        ]; // Success
        var nbs = unifyTerm(self[0], other[0], bindings, formula);
        if (nbs.length === 0) return nbs;
        var res = [];
        var i;
        var n = nbs.length;
        var nb;
        var j;
        var m;
        var v;
        var nb2;
        var bindings2;
        for(i = 0; i < n; i++){
            // for each possibility from the first term
            nb = nbs[i][0]; // new bindings
            bindings2 = [];
            for(v in nb)if (nb.hasOwnProperty(v)) bindings2[v] = nb[v]; // copy
            for(v in bindings)if (bindings.hasOwnProperty(v)) bindings2[v] = bindings[v]; // copy
            nbs2 = unifyContents(self.slice(1), other.slice(1), bindings2, formula);
            m = nbs2.length;
            for(j = 0; j < m; j++){
                nb2 = nbs2[j][0]; // @@@@ no idea whether this is used or right
                for(v in nb)if (nb.hasOwnProperty(v)) nb2[v] = nb[v];
                res.push([
                    nb2,
                    null
                ]);
            }
        }
        return res;
    } // unifyContents
    //  Matching
    //
    // Matching finds all bindings such that when the binding is applied
    // to one term it is equal to the other term.  We only match formulae.
    /** if x is not in the bindings array, return the var; otherwise, return the bindings **/ function bind(x, binding) {
        var y = binding[x];
        if (y === undefined) return x;
        return y;
    }
    // When there are OPTIONAL clauses, we must return bindings without them if none of them
    // succeed. However, if any of them do succeed, we should not.  (This is what branchCount()
    // tracked. The problem currently is (2011/7) that when several optionals exist, and they
    // all match, multiple sets of bindings are returned, each with one optional filled in.)
    function union(a, b) {
        var c = {};
        var x;
        for(x in a)if (a.hasOwnProperty(x)) c[x] = a[x];
        for(x in b)if (b.hasOwnProperty(x)) c[x] = b[x];
        return c;
    }
    function OptionalBranchJunction(originalCallback, trunkBindings) {
        this.trunkBindings = trunkBindings;
        this.originalCallback = originalCallback;
        this.branches = [];
        // this.results = []; // result[i] is an array of bindings for branch i
        // this.done = {};  // done[i] means all/any results are in for branch i
        // this.count = {}
        return this;
    }
    OptionalBranchJunction.prototype.checkAllDone = function() {
        var i;
        for(i = 0; i < this.branches.length; i++){
            if (!this.branches[i].done) return;
        }
        (0, $kAE07.default).debug("OPTIONAL BIDNINGS ALL DONE:");
        this.doCallBacks(this.branches.length - 1, this.trunkBindings);
    };
    // Recrursively generate the cross product of the bindings
    OptionalBranchJunction.prototype.doCallBacks = function(b, bindings) {
        var j;
        if (b < 0) return this.originalCallback(bindings);
        for(j = 0; j < this.branches[b].results.length; j++)this.doCallBacks(b - 1, union(bindings, this.branches[b].results[j]));
    };
    // A mandatory branch is the normal one, where callbacks
    // are made immediately and no junction is needed.
    // Might be useful for onFinsihed callback for query API.
    function MandatoryBranch(callback, onDone) {
        this.count = 0;
        this.success = false;
        this.done = false;
        // this.results = []
        this.callback = callback;
        this.onDone = onDone;
        // this.junction = junction
        // junction.branches.push(this)
        return this;
    }
    MandatoryBranch.prototype.reportMatch = function(bindings) {
        // log.error("@@@@ query.js 1"); // @@
        this.callback(bindings);
        this.success = true;
    };
    MandatoryBranch.prototype.reportDone = function() {
        this.done = true;
        (0, $kAE07.default).info("Mandatory query branch finished.***");
        if (this.onDone !== undefined) this.onDone();
    };
    // An optional branch hoards its results.
    var OptionalBranch = function OptionalBranch(junction) {
        this.count = 0;
        this.done = false;
        this.results = [];
        this.junction = junction;
        junction.branches.push(this);
        return this;
    };
    OptionalBranch.prototype.reportMatch = function(bindings) {
        this.results.push(bindings);
    };
    OptionalBranch.prototype.reportDone = function() {
        (0, $kAE07.default).debug("Optional branch finished - results.length = " + this.results.length);
        if (this.results.length === 0) {
            // This is what optional means: if no hits,
            this.results.push({}); // mimic success, but with no bindings
            (0, $kAE07.default).debug("Optional branch FAILED - that's OK.");
        }
        this.done = true;
        this.junction.checkAllDone();
    };
    /** prepare -- sets the index of the item to the possible matches
   * @param f - formula
   * @param item - an Statement, possibly w/ vars in it
   * @param bindings - Bindings so far
   * @returns false if the query fails -- there are no items that match
  */ function prepare(f, item, bindings) {
        var terms, termIndex, i, ind;
        item.nvars = 0;
        item.index = null;
        // if (!f.statements) log.warn("@@@ prepare: f is "+f)
        //    log.debug("Prepare: f has "+ f.statements.length)
        // log.debug("Prepare: Kb size "+f.statements.length+" Preparing "+item)
        terms = [
            item.subject,
            item.predicate,
            item.object,
            item.why
        ];
        ind = [
            f.subjectIndex,
            f.predicateIndex,
            f.objectIndex,
            f.whyIndex
        ];
        for(i = 0; i < 4; i++){
            var t = terms[i];
            // console.log("  Prepare (" + t + ") "+(t in bindings))
            if (t.uri && t.uri === (0, $471ea8b4e912e4b1$export$fb7535ed90405da0)) ;
            else if (t.isVar && !(bindings[t] !== undefined)) item.nvars++;
            else {
                t = bind(terms[i], bindings); // returns the RDF binding if bound, otherwise itself
                // if (terms[i]!=bind(terms[i],bindings) alert("Term: "+terms[i]+"Binding: "+bind(terms[i], bindings))
                if (f.redirections[f.id(t)]) t = f.redirections[f.id(t)]; // redirect
                termIndex = ind[i][f.id(t)];
                if (!termIndex) {
                    item.index = [];
                    return false; // Query line cannot match
                }
                if (item.index === null || item.index.length > termIndex.length) // Find smallest index
                item.index = termIndex;
            }
        }
        if (item.index === null) // All 4 are variables?
        item.index = f.statements;
        return true;
    } // prepare
    /** sorting function -- negative if self is easier **/ // We always prefer to start with a URI to be able to browse a graph
    // this is why we put off items with more variables till later.
    function easiestQuery(self, other) {
        if (self.nvars !== other.nvars) return self.nvars - other.nvars;
        return self.index.length - other.index.length;
    }
    var matchIndex = 0; // index
    /** matches a pattern formula against the knowledge base, e.g. to find matches for table-view
  *
  * @param f - knowledge base formula
  * @param g - pattern formula (may have vars)
  * @param bindingsSoFar  - bindings accumulated in matching to date
  * @param level - spaces to indent stuff also lets you know what level of recursion you're at
  * @param fetcher - function (term, requestedBy) If you want link following
  * @param localCallback - function(bindings, pattern, branch) called on sucess
  * @returns nothing
  *
  * Will fetch linked data from the web iff the knowledge base an associated source fetcher (f.fetcher)
  ***/ var match = function match(f, g, bindingsSoFar, level, fetcher, localCallback, branch) {
        (0, $kAE07.default).debug("Match begins, Branch count now: " + branch.count + " for " + branch.pattern_debug);
        // log.debug("match: f has "+f.statements.length+", g has "+g.statements.length)
        var pattern = g.statements;
        if (pattern.length === 0) {
            // when it's satisfied all the pattern triples
            (0, $kAE07.default).debug("FOUND MATCH WITH BINDINGS:" + bindingDebug(bindingsSoFar));
            if (g.optional.length === 0) branch.reportMatch(bindingsSoFar);
            else {
                (0, $kAE07.default).debug("OPTIONAL: " + g.optional);
                var junction = new OptionalBranchJunction(callback, bindingsSoFar); // @@ won't work with nested optionals? nest callbacks
                var br = [];
                var b;
                for(b = 0; b < g.optional.length; b++){
                    br[b] = new OptionalBranch(junction); // Allocate branches to prevent premature ending
                    br[b].pattern_debug = g.optional[b]; // for diagnotics only
                }
                for(b = 0; b < g.optional.length; b++){
                    br[b].count = br[b].count + 1; // Count how many matches we have yet to complete
                    match(f, g.optional[b], bindingsSoFar, "", fetcher, callback, br[b]);
                }
            }
            branch.count--;
            (0, $kAE07.default).debug("Match ends -- success , Branch count now: " + branch.count + " for " + branch.pattern_debug);
            return; // Success
        }
        var item;
        var i;
        var n = pattern.length;
        // log.debug(level + "Match "+n+" left, bs so far:"+bindingDebug(bindingsSoFar))
        // Follow links from variables in query
        if (fetcher) {
            // Fetcher is used to fetch URIs, function first term is a URI term, second is the requester
            var id = "match" + matchIndex++;
            var fetchResource = function fetchResource(requestedTerm, id) {
                var docuri = requestedTerm.uri.split("#")[0];
                fetcher.nowOrWhenFetched(docuri, undefined, function(ok, body, xhr) {
                    if (!ok) console.log("Error following link to <" + requestedTerm.uri + "> in query: " + body);
                    match(f, g, bindingsSoFar, level, fetcher, // match not match2 to look up any others necessary.
                    localCallback, branch);
                });
            };
            for(i = 0; i < n; i++){
                item = pattern[i]; // for each of the triples in the query
                if (bindingsSoFar[item.subject] !== undefined && bindingsSoFar[item.subject].uri && fetcher && fetcher.getState((0, $4Q80K.docpart)(bindingsSoFar[item.subject].uri)) === "unrequested") {
                    // fetch the subject info and return to id
                    fetchResource(bindingsSoFar[item.subject], id);
                    return; // only look up one per line this time, but we will come back again though match
                }
                if (bindingsSoFar[item.object] !== undefined && bindingsSoFar[item.object].uri && fetcher && fetcher.getState((0, $4Q80K.docpart)(bindingsSoFar[item.object].uri)) === "unrequested") {
                    fetchResource(bindingsSoFar[item.object], id);
                    return;
                }
            }
        } // if fetcher
        match2(f, g, bindingsSoFar, level, fetcher, localCallback, branch);
    }; // match
    var constraintsSatisfied = function constraintsSatisfied(bindings, constraints) {
        var res = true;
        var x;
        var test;
        for(x in bindings){
            if (bindings.hasOwnProperty(x)) {
                if (constraints[x]) {
                    test = constraints[x].test;
                    if (test && !test(bindings[x])) res = false;
                }
            }
        }
        return res;
    };
    /** match2 -- stuff after the fetch **/ var match2 = function match2(f, g, bindingsSoFar, level, fetcher, callback, branch) {
        // post fetch
        var pattern = g.statements;
        var n = pattern.length;
        var i;
        var k;
        var nk;
        var v;
        var bindings2;
        var newBindings1;
        var item;
        for(i = 0; i < n; i++){
            // For each statement left in the query, run prepare
            item = pattern[i];
            // log.info('match2: item=' + item + ', bindingsSoFar=' + bindingDebug(bindingsSoFar))
            prepare(f, item, bindingsSoFar);
        // if (item.index) console.log('     item.index.length ' + item.index.length)
        }
        pattern.sort(easiestQuery);
        item = pattern[0];
        // log.debug("Sorted pattern:\n"+pattern)
        var rest = f.formula();
        rest.optional = g.optional;
        rest.constraints = g.constraints;
        rest.statements = pattern.slice(1); // No indexes: we will not query g.
        (0, $kAE07.default).debug(level + "match2 searching " + item.index.length + " for " + item + "; bindings so far=" + bindingDebug(bindingsSoFar));
        // var results = []
        var c;
        var nc = item.index.length;
        var nbs1;
        var st;
        var onward = 0;
        // var x
        for(c = 0; c < nc; c++){
            // For each candidate statement
            st = item.index[c]; // for each statement in the item's index, spawn a new match with that binding
            nbs1 = unifyContents([
                item.subject,
                item.predicate,
                item.object,
                item.why
            ], [
                st.subject,
                st.predicate,
                st.object,
                st.why
            ], bindingsSoFar, f);
            (0, $kAE07.default).info(level + " From first: " + nbs1.length + ": " + bindingsDebug(nbs1));
            nk = nbs1.length;
            // branch.count += nk
            // log.debug("Branch count bumped "+nk+" to: "+branch.count)
            for(k = 0; k < nk; k++){
                // For each way that statement binds
                bindings2 = [];
                newBindings1 = nbs1[k][0];
                if (!constraintsSatisfied(newBindings1, g.constraints)) // branch.count--
                (0, $kAE07.default).debug("Branch count CS: " + branch.count);
                else {
                    for(v in newBindings1)if (newBindings1.hasOwnProperty(v)) bindings2[v] = newBindings1[v]; // copy
                    for(v in bindingsSoFar)if (bindingsSoFar.hasOwnProperty(v)) bindings2[v] = bindingsSoFar[v]; // copy
                    branch.count++; // Count how many matches we have yet to complete
                    onward++;
                    match(f, rest, bindings2, level + "  ", fetcher, callback, branch); // call match
                }
            }
        }
        branch.count--;
        if (onward === 0) (0, $kAE07.default).debug("Match2 fails completely on " + item);
        (0, $kAE07.default).debug("Match2 ends, Branch count: " + branch.count + " for " + branch.pattern_debug);
        if (branch.count === 0) {
            (0, $kAE07.default).debug("Branch finished.");
            branch.reportDone();
        }
    }; // match2
    // ////////////////////////// Body of query()  ///////////////////////
    var f = this;
    (0, $kAE07.default).debug("Query on " + this.statements.length);
    var trunck = new MandatoryBranch(callback, onDone);
    trunck.count++; // count one branch to complete at the moment
    if (myQuery.sync) match(f, myQuery.pat, myQuery.pat.initBindings, "", fetcher, callback, trunck);
    else // Give up thread: Allow other activities to run
    setTimeout(function() {
        match(f, myQuery.pat, myQuery.pat.initBindings, "", fetcher, callback, trunck);
    }, 0);
// returns nothing; callback does the work
} // query



var $8RKL2 = parcelRequire("8RKL2");

var $99pVg = parcelRequire("99pVg");





function $6f5c135260474402$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6f5c135260474402$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6f5c135260474402$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6f5c135260474402$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6f5c135260474402$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $6f5c135260474402$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $6f5c135260474402$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6f5c135260474402$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6f5c135260474402$var$_arrayLikeToArray(o, minLen);
}
function $6f5c135260474402$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6f5c135260474402$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6f5c135260474402$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $6f5c135260474402$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $6f5c135260474402$var$owlNamespaceURI = "http://www.w3.org/2002/07/owl#";
// var link_ns = 'http://www.w3.org/2007/ont/link#'
// Handle Functional Property
function $6f5c135260474402$var$handleFP(formula, subj, pred, obj) {
    var o1 = formula.any(subj, pred, undefined);
    if (!o1) return false; // First time with this value
    // log.warn("Equating "+o1.uri+" and "+obj.uri + " because FP "+pred.uri);  //@@
    formula.equate(o1, obj);
    return true;
} // handleFP
// Handle Inverse Functional Property
function $6f5c135260474402$var$handleIFP(formula, subj, pred, obj) {
    var s1 = formula.any(undefined, pred, obj);
    if (!s1) return false; // First time with this value
    // log.warn("Equating "+s1.uri+" and "+subj.uri + " because IFP "+pred.uri);  //@@
    formula.equate(s1, subj);
    return true;
} // handleIFP
function $6f5c135260474402$var$handleRDFType(formula, subj, pred, obj, why) {
    //@ts-ignore this method does not seem to exist in this library
    if (formula.typeCallback) formula.typeCallback(formula, obj, why);
    var x = formula.classActions[formula.id(obj)];
    var done = false;
    if (x) for(var i = 0; i < x.length; i++)done = done || x[i](formula, subj, pred, obj, why);
    return done; // statement given is not needed if true
}
/**
 * Indexed Formula aka Store
 */ var $6f5c135260474402$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Formula) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(IndexedFormula, _Formula);
    var _super = $6f5c135260474402$var$_createSuper(IndexedFormula);
    /**
   * Creates a new formula
   * @param features - What sort of automatic processing to do? Array of string
   * @param features.sameAs - Smush together A and B nodes whenever { A sameAs B }
   * @param opts
   * @param [opts.rdfFactory] - The data factory that should be used by the store
   * @param [opts.rdfArrayRemove] - Function which removes statements from the store
   * @param [opts.dataCallback] - Callback when a statement is added to the store, will not trigger when adding duplicates
   */ function IndexedFormula(features) {
        var _this;
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, IndexedFormula);
        _this = _super.call(this, undefined, undefined, undefined, undefined, opts);
        // IN future - allow pass array of statements to constructor
        /**
     * An UpdateManager initialised to this store
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "updater", void 0);
        /**
     * Dictionary of namespace prefixes
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "namespaces", void 0);
        /** Map of iri predicates to functions to call when adding { s type X } */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "classActions", void 0);
        /** Map of iri predicates to functions to call when getting statement with {s X o} */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "propertyActions", void 0);
        /** Redirect to lexically smaller equivalent symbol */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "redirections", void 0);
        /** Reverse mapping to redirection: aliases for this */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "aliases", void 0);
        /** Redirections we got from HTTP */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "HTTPRedirects", void 0);
        /** Array of statements with this X as subject */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "subjectIndex", void 0);
        /** Array of statements with this X as predicate */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "predicateIndex", void 0);
        /** Array of statements with this X as object */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "objectIndex", void 0);
        /** Array of statements with X as provenance */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "whyIndex", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "index", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "features", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_universalVariables", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_existentialVariables", void 0);
        /** Function to remove quads from the store arrays with */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "rdfArrayRemove", void 0);
        /** Callbacks which are triggered after a statement has been added to the store */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "dataCallbacks", void 0);
        _this.propertyActions = {};
        _this.classActions = {};
        _this.redirections = [];
        _this.aliases = [];
        _this.HTTPRedirects = [];
        _this.subjectIndex = [];
        _this.predicateIndex = [];
        _this.objectIndex = [];
        _this.whyIndex = [];
        _this.index = [
            _this.subjectIndex,
            _this.predicateIndex,
            _this.objectIndex,
            _this.whyIndex
        ];
        _this.namespaces = {}; // Dictionary of namespace prefixes
        _this.features = features || [];
        _this.rdfArrayRemove = opts.rdfArrayRemove || (0, $23fob.RDFArrayRemove);
        if (opts.dataCallback) _this.dataCallbacks = [
            opts.dataCallback
        ];
        _this.initPropertyActions(_this.features);
        return _this;
    }
    /**
   * Gets the URI of the default graph
   */ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(IndexedFormula, [
        {
            key: "substitute",
            value: /**
     * Gets this graph with the bindings substituted
     * @param bindings The bindings
     */ function substitute(bindings) {
                var statementsCopy = this.statements.map(function(ea) {
                    return ea.substitute(bindings);
                });
                var y = new IndexedFormula();
                y.add(statementsCopy);
                return y;
            }
        },
        {
            key: "addDataCallback",
            value: function addDataCallback(cb) {
                if (!this.dataCallbacks) this.dataCallbacks = [];
                this.dataCallbacks.push(cb);
            }
        },
        {
            key: "applyPatch",
            value: function applyPatch(patch, target, patchCallback) {
                var targetKB = this;
                var ds;
                var binding = null;
                function doPatch(onDonePatch) {
                    if (patch["delete"]) {
                        ds = patch["delete"];
                        // console.log(bindingDebug(binding))
                        // console.log('ds before substitute: ' + ds)
                        if (binding) ds = ds.substitute(binding);
                        // console.log('applyPatch: delete: ' + ds)
                        ds = ds.statements;
                        var bad = [];
                        var ds2 = ds.map(function(st) {
                            // Find the actual statements in the store
                            var sts = targetKB.statementsMatching(st.subject, st.predicate, st.object, target);
                            if (sts.length === 0) {
                                // log.info("NOT FOUND deletable " + st)
                                bad.push(st);
                                return null;
                            } else // log.info("Found deletable " + st)
                            return sts[0];
                        });
                        if (bad.length) // console.log('Could not find to delete ' + bad.length + 'statements')
                        // console.log('despite ' + targetKB.statementsMatching(bad[0].subject, bad[0].predicate)[0])
                        return patchCallback("Could not find to delete: " + bad.join("\n or "));
                        ds2.map(function(st) {
                            targetKB.remove(st);
                        });
                    }
                    if (patch["insert"]) {
                        // log.info("doPatch insert "+patch['insert'])
                        ds = patch["insert"];
                        if (binding) ds = ds.substitute(binding);
                        ds = ds.statements;
                        ds.map(function(st) {
                            st.graph = target;
                            targetKB.add(st.subject, st.predicate, st.object, st.graph);
                        });
                    }
                    onDonePatch();
                }
                if (patch.where) {
                    // log.info("Processing WHERE: " + patch.where + '\n')
                    var query = new (0, $06f9ff3d33460d2e$export$62297b13309008b2)("patch");
                    query.pat = patch.where;
                    query.pat.statements.map(function(st) {
                        st.graph = (0, $6f0137736d5eb798$export$fe4bf738d66b6b12)(target.value);
                    });
                    //@ts-ignore TODO: add sync property to Query when converting Query to typescript
                    query.sync = true;
                    var bindingsFound = [];
                    targetKB.query(query, function onBinding(binding) {
                        bindingsFound.push(binding);
                    // console.log('   got a binding: ' + bindingDebug(binding))
                    }, targetKB.fetcher, function onDone() {
                        if (bindingsFound.length === 0) return patchCallback("No match found to be patched:" + patch.where);
                        if (bindingsFound.length > 1) return patchCallback("Patch ambiguous. No patch done.");
                        binding = bindingsFound[0];
                        doPatch(patchCallback);
                    });
                } else doPatch(patchCallback);
            }
        },
        {
            key: "declareExistential",
            value: function declareExistential(x) {
                if (!this._existentialVariables) this._existentialVariables = [];
                this._existentialVariables.push(x);
                return x;
            }
        },
        {
            key: "initPropertyActions",
            value: function initPropertyActions(features) {
                // If the predicate is #type, use handleRDFType to create a typeCallback on the object
                this.propertyActions[this.rdfFactory.id(this.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"))] = [
                    $6f5c135260474402$var$handleRDFType
                ];
                // Assumption: these terms are not redirected @@fixme
                if ((0, $c584fbcedb5512e3$export$37abcb37ee31055e)(features, "sameAs") >= 0) this.propertyActions[this.rdfFactory.id(this.rdfFactory.namedNode("".concat($6f5c135260474402$var$owlNamespaceURI, "sameAs")))] = [
                    function(formula, subj, pred, obj, why) {
                        // log.warn("Equating "+subj.uri+" sameAs "+obj.uri);  //@@
                        formula.equate(subj, obj);
                        return true; // true if statement given is NOT needed in the store
                    }
                ]; // sameAs -> equate & don't add to index
                if ((0, $c584fbcedb5512e3$export$37abcb37ee31055e)(features, "InverseFunctionalProperty") >= 0) this.classActions[this.rdfFactory.id(this.rdfFactory.namedNode("".concat($6f5c135260474402$var$owlNamespaceURI, "InverseFunctionalProperty")))] = [
                    function(formula, subj, pred, obj, addFn) {
                        // yes subj not pred!
                        return formula.newPropertyAction(subj, $6f5c135260474402$var$handleIFP);
                    }
                ]; // IFP -> handleIFP, do add to index
                if ((0, $c584fbcedb5512e3$export$37abcb37ee31055e)(features, "FunctionalProperty") >= 0) this.classActions[this.rdfFactory.id(this.rdfFactory.namedNode("".concat($6f5c135260474402$var$owlNamespaceURI, "FunctionalProperty")))] = [
                    function(formula, subj, proj, obj, addFn) {
                        return formula.newPropertyAction(subj, $6f5c135260474402$var$handleFP);
                    }
                ]; // FP => handleFP, do add to index
            }
        },
        {
            key: "addStatement",
            value: function addStatement(st) {
                this.add(st.subject, st.predicate, st.object, st.graph);
                return this.statements.length;
            }
        },
        {
            key: "add",
            value: function add(subj, pred, obj, why) {
                var i;
                if (arguments.length === 1) {
                    if (subj instanceof Array) for(i = 0; i < subj.length; i++)this.add(subj[i]);
                    else if ((0, $gCJkd.isQuad)(subj)) this.add(subj.subject, subj.predicate, subj.object, subj.graph);
                    else if ((0, $gCJkd.isStore)(subj)) this.add(subj.statements);
                    return this;
                }
                var actions;
                var st;
                if (!why) // system generated
                why = this.fetcher ? this.fetcher.appNode : this.rdfFactory.defaultGraph();
                if (typeof subj == "string") subj = this.rdfFactory.namedNode(subj);
                pred = (0, $e01338ed2499626a$export$2e2bcd8739ae039).fromValue(pred);
                var objNode = (0, $e01338ed2499626a$export$2e2bcd8739ae039).fromValue(obj);
                why = (0, $e01338ed2499626a$export$2e2bcd8739ae039).fromValue(why);
                if (!(0, $gCJkd.isRDFlibSubject)(subj)) throw new Error("Subject is not a subject type");
                if (!(0, $gCJkd.isRDFlibPredicate)(pred)) throw new Error("Predicate ".concat(pred, " is not a predicate type"));
                if (!(0, $gCJkd.isRDFlibObject)(objNode)) throw new Error("Object ".concat(objNode, " is not an object type"));
                if (!(0, $gCJkd.isGraph)(why)) throw new Error("Why is not a graph type");
                //@ts-ignore This is not used internally
                if (this.predicateCallback) //@ts-ignore This is not used internally
                this.predicateCallback(this, pred, why);
                // Action return true if the statement does not need to be added
                var predHash = this.id(this.canon(pred));
                actions = this.propertyActions[predHash]; // Predicate hash
                var done = false;
                if (actions) // alert('type: '+typeof actions +' @@ actions='+actions)
                for(i = 0; i < actions.length; i++)done = done || actions[i](this, subj, pred, objNode, why);
                if (this.holds(subj, pred, objNode, why)) // Takes time but saves duplicates
                // console.log('rdflib: Ignoring dup! {' + subj + ' ' + pred + ' ' + obj + ' ' + why + '}')
                return null; // @@better to return self in all cases?
                // If we are tracking provenance, every thing should be loaded into the store
                // if (done) return this.rdfFactory.quad(subj, pred, obj, why)
                // Don't put it in the store
                // still return this statement for owl:sameAs input
                var hash = [
                    this.id(this.canon(subj)),
                    predHash,
                    this.id(this.canon(objNode)),
                    this.id(this.canon(why))
                ];
                // @ts-ignore this will fail if you pass a collection and the factory does not allow Collections
                st = this.rdfFactory.quad(subj, pred, objNode, why);
                for(i = 0; i < 4; i++){
                    var ix = this.index[i];
                    var h = hash[i];
                    if (!ix[h]) ix[h] = [];
                    ix[h].push(st); // Set of things with this as subject, etc
                }
                // log.debug("ADDING    {"+subj+" "+pred+" "+objNode+"} "+why)
                this.statements.push(st);
                if (this.dataCallbacks) {
                    var _iterator = $6f5c135260474402$var$_createForOfIteratorHelper(this.dataCallbacks), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var callback = _step.value;
                            callback(st);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                return st;
            }
        },
        {
            key: "canon",
            value: function canon(term) {
                if (!term) // @@ TODO Should improve this to return proper value - doing this to keep it backward compatible
                return term;
                var y = this.redirections[this.id(term)];
                if (y) return y;
                switch(term.termType){
                    case 0, $8RKL2.BlankNodeTermType:
                        return new (0, $d0a63e5194c4f691$export$2e2bcd8739ae039)(term.value);
                    case 0, $8RKL2.CollectionTermType:
                        return term;
                    // non-RDF/JS type, should just need to cast
                    case 0, $8RKL2.DefaultGraphTermType:
                        return new (0, $cdeb561dfecfaa8a$export$2e2bcd8739ae039)();
                    case 0, $8RKL2.EmptyTermType:
                        // non-RDF/JS type, should just need to cast
                        return term;
                    case 0, $8RKL2.GraphTermType:
                        // non-RDF/JS type, should just need to cast
                        return term;
                    case 0, $8RKL2.LiteralTermType:
                        return new (0, $68c7b1d3a79e3436$export$2e2bcd8739ae039)(term.value, term.language, term.datatype);
                    case 0, $8RKL2.NamedNodeTermType:
                        return new (0, $99pVg.default)(term.value);
                    case 0, $8RKL2.VariableTermType:
                        return new (0, $b7a48305c1700eec$export$2e2bcd8739ae039)(term.value);
                    default:
                        throw new Error("Term Type not recognized for canonization: ".concat(term.termType));
                }
            }
        },
        {
            key: "check",
            value: function check() {
                this.checkStatementList(this.statements);
                for(var p = 0; p < 4; p++){
                    var ix = this.index[p];
                    for(var key in ix)if (ix.hasOwnProperty(key)) // @ts-ignore should this pass an array or a single statement? checkStateMentsList expects an array.
                    this.checkStatementList(ix[key], p);
                }
            }
        },
        {
            key: "checkStatementList",
            value: function checkStatementList(sts, from) {
                if (from === undefined) from = 0;
                var names = [
                    "subject",
                    "predicate",
                    "object",
                    "why"
                ];
                var origin = " found in " + names[from] + " index.";
                var st;
                for(var j = 0; j < sts.length; j++){
                    st = sts[j];
                    var term = [
                        st.subject,
                        st.predicate,
                        st.object,
                        st.graph
                    ];
                    var arrayContains = function arrayContains(a, x) {
                        for(var i = 0; i < a.length; i++){
                            if (a[i].subject.equals(x.subject) && a[i].predicate.equals(x.predicate) && a[i].object.equals(x.object) && a[i].why.equals(x.graph)) return true;
                        }
                    };
                    for(var p = 0; p < 4; p++){
                        var c = this.canon(term[p]);
                        var h = this.id(c);
                        if (!this.index[p][h]) ;
                        else arrayContains(this.index[p][h], st);
                    }
                    if (!arrayContains(this.statements, st)) throw new Error("Statement list does not statement " + st + "@" + st.graph + origin);
                }
            }
        },
        {
            key: "close",
            value: function close() {
                return this;
            }
        },
        {
            key: "compareTerms",
            value: function compareTerms(u1, u2) {
                // Keep compatibility with downstream classOrder changes
                if (Object.prototype.hasOwnProperty.call(u1, "compareTerm")) return u1.compareTerm(u2);
                if ((0, $aZYlt.default)[u1.termType] < (0, $aZYlt.default)[u2.termType]) return -1;
                if ((0, $aZYlt.default)[u1.termType] > (0, $aZYlt.default)[u2.termType]) return 1;
                if (u1.value < u2.value) return -1;
                if (u1.value > u2.value) return 1;
                return 0;
            }
        },
        {
            key: "copyTo",
            value: function copyTo(template, target, flags) {
                if (!flags) flags = [];
                var statList = this.statementsMatching(template);
                if ((0, $c584fbcedb5512e3$export$37abcb37ee31055e)(flags, "two-direction") !== -1) statList.concat(this.statementsMatching(undefined, undefined, template));
                for(var i = 0; i < statList.length; i++){
                    var st = statList[i];
                    switch(st.object.termType){
                        case "NamedNode":
                            this.add(target, st.predicate, st.object);
                            break;
                        case "Literal":
                        case "BlankNode":
                        // @ts-ignore Collections can appear here
                        case "Collection":
                            // @ts-ignore Possible bug: copy is not available on Collections
                            this.add(target, st.predicate, st.object.copy(this));
                    }
                    if ((0, $c584fbcedb5512e3$export$37abcb37ee31055e)(flags, "delete") !== -1) this.remove(st);
                }
            }
        },
        {
            key: "equate",
            value: function equate(u1in, u2in) {
                // log.warn("Equating "+u1+" and "+u2); // @@
                // @@JAMBO Must canonicalize the uris to prevent errors from a=b=c
                // 03-21-2010
                var u1 = this.canon(u1in);
                var u2 = this.canon(u2in);
                var d = this.compareTerms(u1, u2);
                if (!d) return true; // No information in {a = a}
                // var big
                // var small
                if (d < 0) // u1 less than u2
                return this.replaceWith(u2, u1);
                else return this.replaceWith(u1, u2);
            }
        },
        {
            key: "formula",
            value: function formula(features) {
                return new IndexedFormula(features);
            }
        },
        {
            key: "length",
            get: function get() {
                return this.statements.length;
            }
        },
        {
            key: "match",
            value: function match(subject, predicate, object, graph) {
                return this.statementsMatching((0, $e01338ed2499626a$export$2e2bcd8739ae039).fromValue(subject), (0, $e01338ed2499626a$export$2e2bcd8739ae039).fromValue(predicate), (0, $e01338ed2499626a$export$2e2bcd8739ae039).fromValue(object), (0, $e01338ed2499626a$export$2e2bcd8739ae039).fromValue(graph));
            }
        },
        {
            key: "mentionsURI",
            value: function mentionsURI(uri) {
                var hash = "<" + uri + ">";
                return !!this.subjectIndex[hash] || !!this.objectIndex[hash] || !!this.predicateIndex[hash];
            }
        },
        {
            key: "newExistential",
            value: function newExistential(uri) {
                if (!uri) return this.bnode();
                var x = this.sym(uri);
                // @ts-ignore x should be blanknode, but is namedNode.
                return this.declareExistential(x);
            }
        },
        {
            key: "newPropertyAction",
            value: function newPropertyAction(pred, action) {
                // log.debug("newPropertyAction:  "+pred)
                var hash = this.id(pred);
                if (!this.propertyActions[hash]) this.propertyActions[hash] = [];
                this.propertyActions[hash].push(action);
                // Now apply the function to to statements already in the store
                var toBeFixed = this.statementsMatching(undefined, pred, undefined);
                var done = false;
                for(var i = 0; i < toBeFixed.length; i++)// NOT optimized - sort toBeFixed etc
                done = done || action(this, toBeFixed[i].subject, pred, toBeFixed[i].object);
                return done;
            }
        },
        {
            key: "newUniversal",
            value: function newUniversal(uri) {
                var x = this.sym(uri);
                if (!this._universalVariables) this._universalVariables = [];
                this._universalVariables.push(x);
                return x;
            }
        },
        {
            key: "variable",
            value: function variable(name) {
                return new (0, $b7a48305c1700eec$export$2e2bcd8739ae039)(name);
            }
        },
        {
            key: "nextSymbol",
            value: function nextSymbol(doc) {
                for(var i = 0;; i++){
                    var uri = doc.value + "#n" + i;
                    if (!this.mentionsURI(uri)) return this.sym(uri);
                }
            }
        },
        {
            key: "query",
            value: function query(myQuery, callback, fetcher, onDone) {
                return (0, $06f9ff3d33460d2e$export$b935ec197a103b45).call(this, myQuery, callback, fetcher, onDone);
            }
        },
        {
            key: "querySync",
            value: function querySync(myQuery) {
                var results = [];
                function saveBinginds(bindings) {
                    results.push(bindings);
                }
                function onDone() {
                    done = true;
                }
                var done = false;
                // @ts-ignore TODO: Add .sync to Query
                myQuery.sync = true;
                (0, $06f9ff3d33460d2e$export$b935ec197a103b45).call(this, myQuery, saveBinginds, null, onDone);
                if (!done) throw new Error("Sync query should have called done function");
                return results;
            }
        },
        {
            key: "remove",
            value: function remove(st) {
                if (st instanceof Array) {
                    for(var i = 0; i < st.length; i++)this.remove(st[i]);
                    return this;
                }
                if ((0, $gCJkd.isStore)(st)) return this.remove(st.statements);
                var sts = this.statementsMatching(st.subject, st.predicate, st.object, st.graph);
                if (!sts.length) throw new Error("Statement to be removed is not on store: " + st);
                this.removeStatement(sts[0]);
                return this;
            }
        },
        {
            key: "removeDocument",
            value: function removeDocument(doc) {
                this.removeMetadata(doc);
                // remove document
                var sts = this.statementsMatching(undefined, undefined, undefined, doc).slice(); // Take a copy as this is the actual index
                for(var i = 0; i < sts.length; i++)this.removeStatement(sts[i]);
                this.removeMatches(doc, null, null);
                return this;
            }
        },
        {
            key: "removeMetadata",
            value: function removeMetadata(doc) {
                var meta = this.sym("chrome://TheCurrentSession"); // or this.rdfFactory.namedNode('chrome://TheCurrentSession')
                var linkNamespaceURI = "http://www.w3.org/2007/ont/link#";
                // remove status/response/request metadata
                var requests = this.statementsMatching(undefined, this.sym("".concat(linkNamespaceURI, "requestedURI")), this.rdfFactory.literal(doc.value), meta).map(function(st) {
                    return st.subject;
                });
                for(var r = 0; r < requests.length; r++){
                    var request = requests[r];
                    if (request != undefined) {
                        // removeMatches unresolved issue with collection https://github.com/linkeddata/rdflib.js/issues/631
                        var sts = void 0;
                        // status collection
                        var status = this.any(request, this.sym("".concat(linkNamespaceURI, "status")), null, meta);
                        if (status != undefined) {
                            sts = this.statementsMatching(status, this.sym("".concat(linkNamespaceURI, "status")), null, meta).slice();
                            for(var i = 0; i < sts.length; i++)this.removeStatement(sts[i]);
                        }
                        // response items list
                        var response = this.any(request, this.sym("".concat(linkNamespaceURI, "response")), null, meta);
                        if (response != undefined) {
                            sts = this.statementsMatching(response, null, null, meta).slice();
                            for(var i = 0; i < sts.length; i++)this.removeStatement(sts[i]);
                        }
                        // request triples
                        sts = this.statementsMatching(request, null, null, meta).slice();
                        for(var i = 0; i < sts.length; i++)this.removeStatement(sts[i]);
                    }
                }
                this.removeMatches(this.sym(doc.value), null, null, meta); // content-type
                return this;
            }
        },
        {
            key: "removeMany",
            value: function removeMany(subj, pred, obj, why, limit) {
                // log.debug("entering removeMany w/ subj,pred,obj,why,limit = " + subj +", "+ pred+", " + obj+", " + why+", " + limit)
                var sts = this.statementsMatching(subj, pred, obj, why, false);
                // This is a subtle bug that occurred in updateCenter.js too.
                // The fact is, this.statementsMatching returns this.whyIndex instead of a copy of it
                // but for perfromance consideration, it's better to just do that
                // so make a copy here.
                var statements = [];
                for(var i = 0; i < sts.length; i++)statements.push(sts[i]);
                if (limit) statements = statements.slice(0, limit);
                for(i = 0; i < statements.length; i++)this.remove(statements[i]);
            }
        },
        {
            key: "removeMatches",
            value: function removeMatches(subject, predicate, object, graph) {
                this.removeMany(subject, predicate, object, graph);
                return this;
            }
        },
        {
            key: "removeStatement",
            value: function removeStatement(st) {
                // log.debug("entering remove w/ st=" + st)
                var term = [
                    st.subject,
                    st.predicate,
                    st.object,
                    st.graph
                ];
                for(var p = 0; p < 4; p++){
                    var c = this.canon(term[p]);
                    var h = this.id(c);
                    if (!this.index[p][h]) ;
                    else this.rdfArrayRemove(this.index[p][h], st);
                }
                this.rdfArrayRemove(this.statements, st);
                return this;
            }
        },
        {
            key: "removeStatements",
            value: function removeStatements(sts) {
                for(var i = 0; i < sts.length; i++)this.remove(sts[i]);
                return this;
            }
        },
        {
            key: "replaceWith",
            value: function replaceWith(big, small) {
                // log.debug("Replacing "+big+" with "+small) // this.id(@@
                var oldhash = this.id(big);
                var newhash = this.id(small);
                var moveIndex = function moveIndex(ix) {
                    var oldlist = ix[oldhash];
                    if (!oldlist) return; // none to move
                    var newlist = ix[newhash];
                    if (!newlist) ix[newhash] = oldlist;
                    else ix[newhash] = oldlist.concat(newlist);
                    delete ix[oldhash];
                };
                // the canonical one carries all the indexes
                for(var i = 0; i < 4; i++)moveIndex(this.index[i]);
                this.redirections[oldhash] = small;
                if (big.value) {
                    // @@JAMBO: must update redirections,aliases from sub-items, too.
                    if (!this.aliases[newhash]) this.aliases[newhash] = [];
                    this.aliases[newhash].push(big); // Back link
                    if (this.aliases[oldhash]) for(i = 0; i < this.aliases[oldhash].length; i++){
                        this.redirections[this.id(this.aliases[oldhash][i])] = small;
                        this.aliases[newhash].push(this.aliases[oldhash][i]);
                    }
                    this.add(small, this.sym("http://www.w3.org/2007/ont/link#uri"), big);
                    // If two things are equal, and one is requested, we should request the other.
                    if (this.fetcher) this.fetcher.nowKnownAs(big, small);
                }
                moveIndex(this.classActions);
                moveIndex(this.propertyActions);
                // log.debug("Equate done. "+big+" to be known as "+small)
                return true; // true means the statement does not need to be put in
            }
        },
        {
            key: "allAliases",
            value: function allAliases(x) {
                var a = this.aliases[this.id(this.canon(x))] || [];
                a.push(this.canon(x));
                return a;
            }
        },
        {
            key: "sameThings",
            value: function sameThings(x, y) {
                if (x.equals(y)) return true;
                var x1 = this.canon(x);
                //    alert('x1='+x1)
                if (!x1) return false;
                var y1 = this.canon(y);
                //    alert('y1='+y1); //@@
                if (!y1) return false;
                return x1.value === y1.value;
            }
        },
        {
            key: "setPrefixForURI",
            value: function setPrefixForURI(prefix, nsuri) {
                // TODO: This is a hack for our own issues, which ought to be fixed
                // post-release
                // See http://dig.csail.mit.edu/cgi-bin/roundup.cgi/$rdf/issue227
                if (prefix === "tab" && this.namespaces["tab"]) return;
                 // There are files around with long badly generated prefixes like this
                if (prefix.slice(0, 2) === "ns" || prefix.slice(0, 7) === "default") return;
                // remove any prefix that currently targets nsuri
                for(var existingPrefix in this.namespaces)if (this.namespaces[existingPrefix] == nsuri) delete this.namespaces[existingPrefix];
                this.namespaces[prefix] = nsuri;
            }
        },
        {
            key: "statementsMatching",
            value: function statementsMatching(subj, pred, obj, why, justOne) {
                // log.debug("Matching {"+subj+" "+pred+" "+obj+"}")
                var pat = [
                    subj,
                    pred,
                    obj,
                    why
                ];
                var pattern = [];
                var hash = [];
                var wild = []; // wildcards
                var given = []; // Not wild
                var p;
                var list;
                for(p = 0; p < 4; p++){
                    pattern[p] = this.canon((0, $e01338ed2499626a$export$2e2bcd8739ae039).fromValue(pat[p]));
                    if (!pattern[p]) wild.push(p);
                    else {
                        given.push(p);
                        hash[p] = this.id(pattern[p]);
                    }
                }
                if (given.length === 0) return this.statements;
                if (given.length === 1) {
                    // Easy too, we have an index for that
                    p = given[0];
                    list = this.index[p][hash[p]];
                    if (list && justOne) {
                        if (list.length > 1) list = list.slice(0, 1);
                    }
                    list = list || [];
                    return list;
                }
                // Now given.length is 2, 3 or 4.
                // We hope that the scale-free nature of the data will mean we tend to get
                // a short index in there somewhere!
                var best = 1e10; // really bad
                var iBest;
                var i;
                for(i = 0; i < given.length; i++){
                    p = given[i]; // Which part we are dealing with
                    list = this.index[p][hash[p]];
                    if (!list) return []; // No occurrences
                    if (list.length < best) {
                        best = list.length;
                        iBest = i; // (not p!)
                    }
                }
                // Ok, we have picked the shortest index but now we have to filter it
                var pBest = given[iBest];
                var possibles = this.index[pBest][hash[pBest]];
                var check = given.slice(0, iBest).concat(given.slice(iBest + 1)); // remove iBest
                var results = [];
                var parts = [
                    "subject",
                    "predicate",
                    "object",
                    "why"
                ];
                for(var j = 0; j < possibles.length; j++){
                    var st = possibles[j];
                    for(i = 0; i < check.length; i++){
                        // for each position to be checked
                        p = check[i];
                        if (!this.canon(st[parts[p]]).equals(pattern[p])) {
                            st = null;
                            break;
                        }
                    }
                    if (st != null) {
                        results.push(st);
                        if (justOne) break;
                    }
                }
                return results;
            }
        },
        {
            key: "uris",
            value: function uris(term) {
                var cterm = this.canon(term);
                var terms = this.aliases[this.id(cterm)];
                if (!cterm.value) return [];
                var res = [
                    cterm.value
                ];
                if (terms) for(var i = 0; i < terms.length; i++)res.push(terms[i].uri);
                return res;
            }
        },
        {
            key: "serialize",
            value: function serialize(base, contentType, provenance, options) {
                var _options;
                // override Formula.serialize to force the serializer namespace prefixes
                // to those of this IndexedFormula
                // if namespaces are explicitly passed in options, let them override the existing namespaces in this formula
                var namespaces = (_options = options) !== null && _options !== void 0 && _options.namespaces ? $6f5c135260474402$var$_objectSpread($6f5c135260474402$var$_objectSpread({}, this.namespaces), options.namespaces) : $6f5c135260474402$var$_objectSpread({}, this.namespaces);
                options = $6f5c135260474402$var$_objectSpread($6f5c135260474402$var$_objectSpread({}, options || {}), {}, {
                    namespaces: namespaces
                });
                return (0, $957a454a8ab6ebde$export$2e2bcd8739ae039)(provenance, this, base, contentType, undefined, options);
            }
        }
    ], [
        {
            key: "defaultGraphURI",
            get: function get() {
                return 0, $471ea8b4e912e4b1$export$fb7535ed90405da0;
            }
        }
    ]);
    return IndexedFormula;
}((0, $31157af6e1e82257$export$2e2bcd8739ae039));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($6f5c135260474402$export$2e2bcd8739ae039, "handleRDFType", void 0);
$6f5c135260474402$export$2e2bcd8739ae039.handleRDFType = $6f5c135260474402$var$handleRDFType;



var $kAE07 = parcelRequire("kAE07");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $41YNz = parcelRequire("41YNz");

var $4Q80K = parcelRequire("4Q80K");




function $d44594c351a1dfa1$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $d44594c351a1dfa1$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $d44594c351a1dfa1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d44594c351a1dfa1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d44594c351a1dfa1$var$_arrayLikeToArray(o, minLen);
}
function $d44594c351a1dfa1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $d44594c351a1dfa1$var$RDF = (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/1999/02/22-rdf-syntax-ns#");
function $d44594c351a1dfa1$export$6468f4bab59ad3f(store, x, y, doc) {
    // console.log(`substituteInDoc put ${x} for ${y} in ${doc}}`)
    var _iterator = $d44594c351a1dfa1$var$_createForOfIteratorHelper(store.statementsMatching(y, null, null, doc)), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var quad = _step.value;
            var newStatement = new (0, $00d766c69dbb3a6e$export$2e2bcd8739ae039)(x, quad.predicate, quad.object, doc);
            store.remove(quad);
            store.add(newStatement);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var _iterator2 = $d44594c351a1dfa1$var$_createForOfIteratorHelper(store.statementsMatching(null, y, null, doc)), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _quad = _step2.value;
            store.remove(_quad);
            // console.log(`  substituteInDoc predicate ${x} in ${quad}}`)
            store.add(new (0, $00d766c69dbb3a6e$export$2e2bcd8739ae039)(_quad.subject, x, _quad.object, doc));
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    var _iterator3 = $d44594c351a1dfa1$var$_createForOfIteratorHelper(store.statementsMatching(null, null, y, doc)), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var _quad2 = _step3.value;
            store.remove(_quad2);
            store.add(new (0, $00d766c69dbb3a6e$export$2e2bcd8739ae039)(_quad2.subject, _quad2.predicate, x, doc));
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $d44594c351a1dfa1$export$db0e3a58b44fdcbc(store, doc) {
    var x = $d44594c351a1dfa1$var$RDF("nil");
    var _iterator4 = $d44594c351a1dfa1$var$_createForOfIteratorHelper(store.statementsMatching(x, null, null, doc)), _step4;
    try {
        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
            var quad = _step4.value;
            store.remove(quad);
            var y = new (0, $619d91631affbf30$export$2e2bcd8739ae039)();
            store.add(new (0, $00d766c69dbb3a6e$export$2e2bcd8739ae039)(y, quad.predicate, quad.object, doc));
        }
    } catch (err) {
        _iterator4.e(err);
    } finally{
        _iterator4.f();
    }
    var _iterator5 = $d44594c351a1dfa1$var$_createForOfIteratorHelper(store.statementsMatching(null, null, x, doc)), _step5;
    try {
        for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
            var _quad3 = _step5.value;
            if (!_quad3.predicate.sameTerm($d44594c351a1dfa1$var$RDF("rest"))) {
                // If not a tail
                store.remove(_quad3);
                var _y = new (0, $619d91631affbf30$export$2e2bcd8739ae039)();
                store.add(new (0, $00d766c69dbb3a6e$export$2e2bcd8739ae039)(_quad3.subject, _quad3.predicate, _y, doc));
            }
        }
    } catch (err) {
        _iterator5.e(err);
    } finally{
        _iterator5.f();
    }
}
function $d44594c351a1dfa1$export$c264eb27c0279bcd(store, doc // Do whole store?
) {
    function preceding(ele, listSoFar, trash) {
        var rests = store.statementsMatching(ele, $d44594c351a1dfa1$var$RDF("rest"), null, doc);
        if (rests.length !== 1) throw new Error("Bad list structure: no rest at ".concat(ele));
        var firsts = store.statementsMatching(ele, $d44594c351a1dfa1$var$RDF("first"), null, doc);
        if (firsts.length !== 1) throw new Error("Bad list structure: rest but ".concat(firsts.length, " firsts at ").concat(ele));
        var value = firsts[0].object;
        var total = [
            value
        ].concat(listSoFar);
        // console.log('  List now is: ', total)
        var totalTrash = trash.concat(rests).concat(firsts);
        var pres = store.statementsMatching(null, $d44594c351a1dfa1$var$RDF("rest"), ele, doc);
        if (pres.length === 0) {
            // Head of the list
            var newList = new (0, $619d91631affbf30$export$2e2bcd8739ae039)(total);
            store.remove(totalTrash);
            // Replace old list with new list:
            $d44594c351a1dfa1$export$6468f4bab59ad3f(store, newList, ele, doc);
            return;
        }
        if (pres.length !== 1) throw new Error("Bad list structure: ".concat(pres.length, " pres at ").concat(ele));
        var pre = pres[0].subject;
        if (pre.termType !== "BlankNode") throw new Error("Bad list element node ".concat(pre, " type: ").concat(pre.termType, " "));
        preceding(pre, total, totalTrash);
        return;
    }
    $d44594c351a1dfa1$export$db0e3a58b44fdcbc(store, doc); // lone ones only
    var tails = store.statementsMatching(null, $d44594c351a1dfa1$var$RDF("rest"), $d44594c351a1dfa1$var$RDF("nil"), doc);
    tails.forEach(function(tail) {
        if (tail.subject.termType !== "BlankNode") throw new Error("Bad list element node ".concat(tail.subject, " type: ").concat(tail.subject.termType, " "));
        preceding(tail.subject, [], []);
    });
}


function $220f89846e1c7272$var$hexify(str) {
    // also used in parser
    return encodeURI(str);
}
var $220f89846e1c7272$var$Utf8 = {
    // public method for url encoding
    encode: function encode(string) {
        string = string.replace(/\r\n/g, "\n");
        var utftext = "";
        for(var n = 0; n < string.length; n++){
            var c = string.charCodeAt(n);
            if (c < 128) utftext += String.fromCharCode(c);
            else if (c > 127 && c < 2048) {
                utftext += String.fromCharCode(c >> 6 | 192);
                utftext += String.fromCharCode(c & 63 | 128);
            } else {
                utftext += String.fromCharCode(c >> 12 | 224);
                utftext += String.fromCharCode(c >> 6 & 63 | 128);
                utftext += String.fromCharCode(c & 63 | 128);
            }
        }
        return utftext;
    },
    // public method for url decoding
    decode: function decode(utftext) {
        var string = "";
        var i = 0;
        while(i < utftext.length){
            var c = utftext.charCodeAt(i);
            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            } else if (c > 191 && c < 224) {
                string += String.fromCharCode((c & 31) << 6 | utftext.charCodeAt(i + 1) & 63);
                i += 2;
            } else {
                string += String.fromCharCode((c & 15) << 12 | (utftext.charCodeAt(i + 1) & 63) << 6 | utftext.charCodeAt(i + 2) & 63);
                i += 3;
            }
        }
        return string;
    }
}; // Things we need to define to make converted pythn code work in js
// environment of $rdf
var $220f89846e1c7272$var$RDFSink_forSomeSym = "http://www.w3.org/2000/10/swap/log#forSome";
var $220f89846e1c7272$var$RDFSink_forAllSym = "http://www.w3.org/2000/10/swap/log#forAll";
var $220f89846e1c7272$var$Logic_NS = "http://www.w3.org/2000/10/swap/log#";
//  pyjs seems to reference runtime library which I didn't find
var $220f89846e1c7272$var$pyjslib_Tuple = function pyjslib_Tuple(theList) {
    return theList;
};
var $220f89846e1c7272$var$pyjslib_List = function pyjslib_List(theList) {
    return theList;
};
var $220f89846e1c7272$var$pyjslib_Dict = function pyjslib_Dict(listOfPairs) {
    if (listOfPairs.length > 0) throw "missing.js: oops nnonempty dict not imp";
    return [];
};
var $220f89846e1c7272$var$pyjslib_len = function pyjslib_len(s) {
    return s.length;
};
var $220f89846e1c7272$var$pyjslib_slice = function pyjslib_slice(str, i, j) {
    if (typeof str.slice == "undefined") throw "@@ mising.js: No .slice function for " + str + " of type " + (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(str);
    if (typeof j == "undefined" || j == null) return str.slice(i);
    return str.slice(i, j); // @ exactly the same spec?
};
var $220f89846e1c7272$var$StopIteration = Error("dummy error stop iteration");
var $220f89846e1c7272$var$pyjslib_Iterator = function pyjslib_Iterator(theList) {
    this.last = 0;
    this.li = theList;
    this.next = function() {
        if (this.last == this.li.length) throw $220f89846e1c7272$var$StopIteration;
        return this.li[this.last++];
    };
    return this;
};
var $220f89846e1c7272$var$ord = function ord(str) {
    return str.charCodeAt(0);
};
var $220f89846e1c7272$var$string_find = function string_find(str, s) {
    return str.indexOf(s);
};
var $220f89846e1c7272$var$assertFudge = function assertFudge(condition, desc) {
    if (condition) return;
    if (desc) throw "python Assertion failed: " + desc;
    throw "(python) Assertion failed.";
};
var $220f89846e1c7272$var$stringFromCharCode = function stringFromCharCode(uesc) {
    return String.fromCharCode(uesc);
};
String.prototype.encode = function(encoding) {
    if (encoding != "utf-8") throw "UTF8_converter: can only do utf-8";
    return $220f89846e1c7272$var$Utf8.encode(this);
};
String.prototype.decode = function(encoding) {
    if (encoding != "utf-8") throw "UTF8_converter: can only do utf-8";
    //return Utf8.decode(this);
    return this;
};
var $220f89846e1c7272$var$uripath_join = function uripath_join(base, given) {
    return $4Q80K.join(given, base); // sad but true
};
var $220f89846e1c7272$var$becauseSubexpression = null; // No reason needed
var $220f89846e1c7272$var$diag_tracking = 0;
var $220f89846e1c7272$var$diag_chatty_flag = 0;
var $220f89846e1c7272$var$diag_progress = function diag_progress(str) {};
// why_BecauseOfData = function(doc, reason) { return doc };
var $220f89846e1c7272$var$RDF_type_URI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#type";
var $220f89846e1c7272$var$RDF_nil_URI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil";
var $220f89846e1c7272$var$DAML_sameAs_URI = "http://www.w3.org/2002/07/owl#sameAs";
/*
function SyntaxError(details) {
    return new __SyntaxError(details);
}
*/ function $220f89846e1c7272$var$__SyntaxError(details) {
    this.details = details;
}
/*

$Id: n3parser.js 14561 2008-02-23 06:37:26Z kennyluck $

HAND EDITED FOR CONVERSION TO JAVASCRIPT

This module implements a Nptation3 parser, and the final
part of a notation3 serializer.

See also:

Notation 3
http://www.w3.org/DesignIssues/Notation3

Closed World Machine - and RDF Processor
http://www.w3.org/2000/10/swap/cwm

To DO: See also "@@" in comments

- Clean up interfaces
______________________________________________

Module originally by Dan Connolly, includeing notation3
parser and RDF generator. TimBL added RDF stream model
and N3 generation, replaced stream model with use
of common store/formula API.  Yosi Scharf developped
the module, including tests and test harness.

*/ var $220f89846e1c7272$var$ADDED_HASH = "#";
var $220f89846e1c7272$var$LOG_implies_URI = "http://www.w3.org/2000/10/swap/log#implies";
var $220f89846e1c7272$var$INTEGER_DATATYPE = "http://www.w3.org/2001/XMLSchema#integer";
var $220f89846e1c7272$var$FLOAT_DATATYPE = "http://www.w3.org/2001/XMLSchema#double";
var $220f89846e1c7272$var$DECIMAL_DATATYPE = "http://www.w3.org/2001/XMLSchema#decimal";
var $220f89846e1c7272$var$DATE_DATATYPE = "http://www.w3.org/2001/XMLSchema#date";
var $220f89846e1c7272$var$DATETIME_DATATYPE = "http://www.w3.org/2001/XMLSchema#dateTime";
var $220f89846e1c7272$var$BOOLEAN_DATATYPE = "http://www.w3.org/2001/XMLSchema#boolean";
var $220f89846e1c7272$var$option_noregen = 0;
var $220f89846e1c7272$var$_notQNameChars = "	\r\n !\"#$%&'()*.,+/;<=>?@[\\]^`{|}~";
var $220f89846e1c7272$var$_notNameChars = $220f89846e1c7272$var$_notQNameChars + ":";
var $220f89846e1c7272$var$_rdfns = "http://www.w3.org/1999/02/22-rdf-syntax-ns#";
var $220f89846e1c7272$var$N3CommentCharacter = "#";
var $220f89846e1c7272$var$eol = new RegExp("^[ \\t]*(#[^\\n]*)?\\r?\\n", "g");
var $220f89846e1c7272$var$eof = new RegExp("^[ \\t]*(#[^\\n]*)?$", "g");
var $220f89846e1c7272$var$ws = new RegExp("^[ \\t]*", "g");
var $220f89846e1c7272$var$signed_integer = new RegExp("^[-+]?[0-9]+", "g");
var $220f89846e1c7272$var$number_syntax = new RegExp("^([-+]?[0-9]+)(\\.[0-9]+)?(e[-+]?[0-9]+)?", "g");
var $220f89846e1c7272$var$datetime_syntax = new RegExp("^[0-9][0-9][0-9][0-9]-[0-9][0-9]-[0-9][0-9](T[0-9][0-9]:[0-9][0-9](:[0-9][0-9](\\.[0-9]*)?)?)?Z?");
var $220f89846e1c7272$var$digitstring = new RegExp("^[0-9]+", "g");
var $220f89846e1c7272$var$interesting = new RegExp('[\\\\\\r\\n\\"]', "g");
var $220f89846e1c7272$var$langcode = new RegExp("^[a-zA-Z0-9]+(-[a-zA-Z0-9]+)*", "g");
function $220f89846e1c7272$var$createSinkParser(store, openFormula, thisDoc, baseURI, genPrefix, metaURI, flags, why) {
    return new $220f89846e1c7272$export$17576c3d9720d783(store, openFormula, thisDoc, baseURI, genPrefix, metaURI, flags, why);
}
var $220f89846e1c7272$export$2e2bcd8739ae039 = $220f89846e1c7272$var$createSinkParser;
var $220f89846e1c7272$export$17576c3d9720d783 = /*#__PURE__*/ function() {
    function SinkParser(store, openFormula, thisDoc, baseURI, genPrefix, metaURI, flags, why) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, SinkParser);
        if (typeof openFormula == "undefined") openFormula = null;
        if (typeof thisDoc == "undefined") thisDoc = "";
        if (typeof baseURI == "undefined") baseURI = null;
        if (typeof genPrefix == "undefined") genPrefix = "";
        if (typeof metaURI == "undefined") metaURI = null;
        if (typeof flags == "undefined") flags = "";
        if (typeof why == "undefined") why = null;
        /*
    note: namespace names should *not* end in #;
    the # will get added during qname processing */ this._bindings = new $220f89846e1c7272$var$pyjslib_Dict([]);
        this._flags = flags;
        if (thisDoc != "") {
            $220f89846e1c7272$var$assertFudge(thisDoc.indexOf(":") >= 0, "Document URI not absolute: " + thisDoc);
            this._bindings[""] = thisDoc + "#";
        }
        this._store = store;
        if (genPrefix) store.setGenPrefix(genPrefix);
        this._thisDoc = thisDoc;
        this.source = store.sym(thisDoc);
        this.lines = 0;
        this.statementCount = 0;
        this.hasNil = false;
        this.startOfLine = 0;
        this.previousLine = 0;
        this._genPrefix = genPrefix;
        this.keywords = new $220f89846e1c7272$var$pyjslib_List([
            "a",
            "this",
            "bind",
            "has",
            "is",
            "of",
            "true",
            "false"
        ]);
        this.keywordsSet = 0;
        this._anonymousNodes = new $220f89846e1c7272$var$pyjslib_Dict([]);
        this._variables = new $220f89846e1c7272$var$pyjslib_Dict([]);
        this._parentVariables = new $220f89846e1c7272$var$pyjslib_Dict([]);
        this._reason = why;
        this._reason2 = null;
        if ($220f89846e1c7272$var$diag_tracking) this._reason2 = why_BecauseOfData(store.sym(thisDoc), this._reason);
        if (baseURI) this._baseURI = baseURI;
        else if (thisDoc) this._baseURI = thisDoc;
        else this._baseURI = null;
        $220f89846e1c7272$var$assertFudge(!this._baseURI || this._baseURI.indexOf(":") >= 0);
        if (!this._genPrefix) {
            if (this._thisDoc) this._genPrefix = this._thisDoc + "#_g";
            else this._genPrefix = RDFSink_uniqueURI();
        }
        if (openFormula == null) {
            if (this._thisDoc) this._formula = store.formula(thisDoc + "#_formula");
            else this._formula = store.formula();
        } else this._formula = openFormula;
        this._context = this._formula;
        this._parentContext = null;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(SinkParser, [
        {
            key: "here",
            value: function here(i) {
                return this._genPrefix + "_L" + this.lines + "C" + (i - this.startOfLine + 1);
            }
        },
        {
            key: "formula",
            value: function formula() {
                return this._formula;
            }
        },
        {
            key: "loadStream",
            value: function loadStream(stream) {
                return this.loadBuf(stream.read());
            }
        },
        {
            key: "loadBuf",
            value: function loadBuf(buf) {
                /*
      Parses a buffer and returns its top level formula*/ this.startDoc();
                this.feed(buf);
                return this.endDoc();
            }
        },
        {
            key: "feed",
            value: function feed(octets) {
                /*
      Feed an octet stream tothe parser
       if BadSyntax is raised, the string
      passed in the exception object is the
      remainder after any statements have been parsed.
      So if there is more data to feed to the
      parser, it should be straightforward to recover.*/ var str = octets.decode("utf-8");
                var i = 0;
                while(i >= 0){
                    var j = this.skipSpace(str, i);
                    if (j < 0) return;
                    var i = this.directiveOrStatement(str, j);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "expected directive or statement");
                }
            }
        },
        {
            key: "directiveOrStatement",
            value: function directiveOrStatement(str, h) {
                var i = this.skipSpace(str, h);
                if (i < 0) return i;
                var j = this.directive(str, i);
                if (j >= 0) return this.checkDot(str, j);
                var j = this.statement(str, i);
                if (j >= 0) return this.checkDot(str, j);
                return j;
            }
        },
        {
            key: "tok",
            value: function tok(_tok, str, i) {
                /*
      Check for keyword.  Space must have been stripped on entry and
      we must not be at end of file.*/ var whitespace = "	\n\v\f\r ";
                if (str.slice(i, i + 1) == "@") var i = i + 1;
                else {
                    if ((0, $c584fbcedb5512e3$export$37abcb37ee31055e)(this.keywords, _tok) < 0) return -1;
                }
                var k = i + $220f89846e1c7272$var$pyjslib_len(_tok);
                if (str.slice(i, k) == _tok && $220f89846e1c7272$var$_notQNameChars.indexOf(str.charAt(k)) >= 0) return k;
                else return -1;
            }
        },
        {
            key: "directive",
            value: function directive(str, i) {
                var j = this.skipSpace(str, i);
                if (j < 0) return j;
                var res = new $220f89846e1c7272$var$pyjslib_List([]);
                var j = this.tok("bind", str, i);
                if (j > 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "keyword bind is obsolete: use @prefix");
                var j = this.tok("keywords", str, i);
                if (j > 0) {
                    var i = this.commaSeparatedList(str, j, res, false);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "'@keywords' needs comma separated list of words");
                    this.setKeywords($220f89846e1c7272$var$pyjslib_slice(res, null, null));
                    if ($220f89846e1c7272$var$diag_chatty_flag > 80) $220f89846e1c7272$var$diag_progress("Keywords ", this.keywords);
                    return i;
                }
                var j = this.tok("forAll", str, i);
                if (j > 0) {
                    var i = this.commaSeparatedList(str, j, res, true);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "Bad variable list after @forAll");
                    var __x = new $220f89846e1c7272$var$pyjslib_Iterator(res);
                    try {
                        while(true){
                            var x = __x.next();
                            if ((0, $c584fbcedb5512e3$export$37abcb37ee31055e)(this._variables, x) < 0 || (0, $c584fbcedb5512e3$export$37abcb37ee31055e)(this._parentVariables, x) >= 0) this._variables[x] = this._context.newUniversal(x);
                        }
                    } catch (e) {
                        if (e != $220f89846e1c7272$var$StopIteration) throw e;
                    }
                    return i;
                }
                var j = this.tok("forSome", str, i);
                if (j > 0) {
                    var i = this.commaSeparatedList(str, j, res, this.uri_ref2);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "Bad variable list after @forSome");
                    var __x = new $220f89846e1c7272$var$pyjslib_Iterator(res);
                    try {
                        while(true){
                            var x = __x.next();
                            this._context.declareExistential(x);
                        }
                    } catch (e) {
                        if (e != $220f89846e1c7272$var$StopIteration) throw e;
                    }
                    return i;
                }
                var j = this.tok("prefix", str, i);
                if (j >= 0) {
                    var t = new $220f89846e1c7272$var$pyjslib_List([]);
                    var i = this.qname(str, j, t);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "expected qname after @prefix");
                    var j = this.uri_ref2(str, i, t);
                    if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "expected <uriref> after @prefix _qname_");
                    var ns = t[1].uri;
                    if (this._baseURI) var ns = $220f89846e1c7272$var$uripath_join(this._baseURI, ns);
                    else $220f89846e1c7272$var$assertFudge(ns.indexOf(":") >= 0, "With no base URI, cannot handle relative URI for NS");
                    $220f89846e1c7272$var$assertFudge(ns.indexOf(":") >= 0);
                    this._bindings[t[0][0]] = ns;
                    this.bind(t[0][0], $220f89846e1c7272$var$hexify(ns));
                    return j;
                }
                var j = this.tok("base", str, i);
                if (j >= 0) {
                    var t = new $220f89846e1c7272$var$pyjslib_List([]);
                    var i = this.uri_ref2(str, j, t);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "expected <uri> after @base ");
                    var ns = t[0].uri;
                    if (this._baseURI) var ns = $220f89846e1c7272$var$uripath_join(this._baseURI, ns);
                    else throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "With no previous base URI, cannot use relative URI in @base  <" + ns + ">");
                    $220f89846e1c7272$var$assertFudge(ns.indexOf(":") >= 0);
                    this._baseURI = ns;
                    return i;
                }
                return -1;
            }
        },
        {
            key: "bind",
            value: function bind(qn, uri) {
                if (qn == "") ;
                else this._store.setPrefixForURI(qn, uri);
            }
        },
        {
            key: "setKeywords",
            value: function setKeywords(k) {
                /*
      Takes a list of strings*/ if (k == null) this.keywordsSet = 0;
                else {
                    this.keywords = k;
                    this.keywordsSet = 1;
                }
            }
        },
        {
            key: "startDoc",
            value: function startDoc() {}
        },
        {
            key: "endDoc",
            value: /* Signal end of document and stop parsing. returns formula */ function endDoc() {
                if (this.hasNil && this._store.rdfFactory.supports["COLLECTIONS"]) (0, $d44594c351a1dfa1$export$c264eb27c0279bcd)(this._store, this.source);
                return this._formula;
            }
        },
        {
            key: "makeStatement",
            value: function makeStatement(quad) {
                quad[0].add(quad[2], quad[1], quad[3], this.source);
                if (quad[2].uri && quad[2].uri === $220f89846e1c7272$var$RDF_nil_URI || quad[3].uri && quad[3].uri === $220f89846e1c7272$var$RDF_nil_URI) this.hasNil = true;
                this.statementCount += 1;
            }
        },
        {
            key: "statement",
            value: function statement(str, i) {
                var r = new $220f89846e1c7272$var$pyjslib_List([]);
                var i = this.object(str, i, r);
                if (i < 0) return i;
                var j = this.property_list(str, i, r[0]);
                if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "expected propertylist");
                return j;
            }
        },
        {
            key: "subject",
            value: function subject(str, i, res) {
                return this.item(str, i, res);
            }
        },
        {
            key: "verb",
            value: function verb(str, i, res) {
                /*
      has _prop_
      is _prop_ of
      a
      =
      _prop_
      >- prop ->
      <- prop -<
      _operator_*/ var j = this.skipSpace(str, i);
                if (j < 0) return j;
                var r = new $220f89846e1c7272$var$pyjslib_List([]);
                var j = this.tok("has", str, i);
                if (j >= 0) {
                    var i = this.prop(str, j, r);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "expected property after 'has'");
                    res.push(new $220f89846e1c7272$var$pyjslib_Tuple([
                        "->",
                        r[0]
                    ]));
                    return i;
                }
                var j = this.tok("is", str, i);
                if (j >= 0) {
                    var i = this.prop(str, j, r);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "expected <property> after 'is'");
                    var j = this.skipSpace(str, i);
                    if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "End of file found, expected property after 'is'");
                    var i = j;
                    var j = this.tok("of", str, i);
                    if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "expected 'of' after 'is' <prop>");
                    res.push(new $220f89846e1c7272$var$pyjslib_Tuple([
                        "<-",
                        r[0]
                    ]));
                    return j;
                }
                var j = this.tok("a", str, i);
                if (j >= 0) {
                    res.push(new $220f89846e1c7272$var$pyjslib_Tuple([
                        "->",
                        this._store.sym($220f89846e1c7272$var$RDF_type_URI)
                    ]));
                    return j;
                }
                if (str.slice(i, i + 2) == "<=") {
                    res.push(new $220f89846e1c7272$var$pyjslib_Tuple([
                        "<-",
                        this._store.sym($220f89846e1c7272$var$Logic_NS + "implies")
                    ]));
                    return i + 2;
                }
                if (str.slice(i, i + 1) == "=") {
                    if (str.slice(i + 1, i + 2) == ">") {
                        res.push(new $220f89846e1c7272$var$pyjslib_Tuple([
                            "->",
                            this._store.sym($220f89846e1c7272$var$Logic_NS + "implies")
                        ]));
                        return i + 2;
                    }
                    res.push(new $220f89846e1c7272$var$pyjslib_Tuple([
                        "->",
                        this._store.sym($220f89846e1c7272$var$DAML_sameAs_URI)
                    ]));
                    return i + 1;
                }
                if (str.slice(i, i + 2) == ":=") {
                    res.push(new $220f89846e1c7272$var$pyjslib_Tuple([
                        "->",
                        $220f89846e1c7272$var$Logic_NS + "becomes"
                    ]));
                    return i + 2;
                }
                var j = this.prop(str, i, r);
                if (j >= 0) {
                    res.push(new $220f89846e1c7272$var$pyjslib_Tuple([
                        "->",
                        r[0]
                    ]));
                    return j;
                }
                if (str.slice(i, i + 2) == ">-" || str.slice(i, i + 2) == "<-") throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, ">- ... -> syntax is obsolete.");
                return -1;
            }
        },
        {
            key: "prop",
            value: function prop(str, i, res) {
                return this.item(str, i, res);
            }
        },
        {
            key: "item",
            value: function item(str, i, res) {
                return this.path(str, i, res);
            }
        },
        {
            key: "blankNode",
            value: function blankNode(uri) {
                return this._context.bnode(uri, this._reason2);
            }
        },
        {
            key: "path",
            value: function path(str, i, res) {
                /*
      Parse the path production.
      */ var j = this.nodeOrLiteral(str, i, res);
                if (j < 0) return j;
                while("!^.".indexOf(str.slice(j, j + 1)) >= 0){
                    var ch = str.slice(j, j + 1);
                    if (ch == ".") {
                        var ahead = str.slice(j + 1, j + 2);
                        if (!ahead || $220f89846e1c7272$var$_notNameChars.indexOf(ahead) >= 0 && ":?<[{(".indexOf(ahead) < 0) break;
                    }
                    var subj = res.pop();
                    var obj = this.blankNode(this.here(j));
                    var j = this.node(str, j + 1, res);
                    if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "EOF found in middle of path syntax");
                    var pred = res.pop();
                    if (ch == "^") this.makeStatement(new $220f89846e1c7272$var$pyjslib_Tuple([
                        this._context,
                        pred,
                        obj,
                        subj
                    ]));
                    else this.makeStatement(new $220f89846e1c7272$var$pyjslib_Tuple([
                        this._context,
                        pred,
                        subj,
                        obj
                    ]));
                    res.push(obj);
                }
                return j;
            }
        },
        {
            key: "anonymousNode",
            value: function anonymousNode(ln) {
                /*
      Remember or generate a term for one of these _: anonymous nodes*/ var term = this._anonymousNodes[ln];
                if (term) return term;
                var term = this._store.bnode(ln);
                // var term = this._store.bnode(this._context, this._reason2); eh?
                this._anonymousNodes[ln] = term;
                return term;
            }
        },
        {
            key: "node",
            value: function node(str, i, res, subjectAlready) {
                if (typeof subjectAlready == "undefined") subjectAlready = null;
                /*
      Parse the <node> production.
      Space is now skipped once at the beginning
      instead of in multipe calls to self.skipSpace().
      */ var subj = subjectAlready;
                var j = this.skipSpace(str, i);
                if (j < 0) return j;
                var i = j;
                var ch = str.slice(i, i + 1);
                if (ch == "[") {
                    var bnodeID = this.here(i);
                    var j = this.skipSpace(str, i + 1);
                    if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "EOF after '['");
                    if (str.slice(j, j + 1) == "=") {
                        var i = j + 1;
                        var objs = new $220f89846e1c7272$var$pyjslib_List([]);
                        var j = this.objectList(str, i, objs);
                        if (j >= 0) {
                            var subj = objs[0];
                            if ($220f89846e1c7272$var$pyjslib_len(objs) > 1) {
                                var __obj = new $220f89846e1c7272$var$pyjslib_Iterator(objs);
                                try {
                                    while(true){
                                        var obj = __obj.next();
                                        this.makeStatement(new $220f89846e1c7272$var$pyjslib_Tuple([
                                            this._context,
                                            this._store.sym($220f89846e1c7272$var$DAML_sameAs_URI),
                                            subj,
                                            obj
                                        ]));
                                    }
                                } catch (e) {
                                    if (e != $220f89846e1c7272$var$StopIteration) throw e;
                                }
                            }
                            var j = this.skipSpace(str, j);
                            if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "EOF when objectList expected after [ = ");
                            if (str.slice(j, j + 1) == ";") var j = j + 1;
                        } else throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "objectList expected after [= ");
                    }
                    if (subj == null) var subj = this.blankNode(bnodeID);
                    var i = this.property_list(str, j, subj);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "property_list expected");
                    var j = this.skipSpace(str, i);
                    if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "EOF when ']' expected after [ <propertyList>");
                    if (str.slice(j, j + 1) != "]") throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "']' expected");
                    res.push(subj);
                    return j + 1;
                }
                if (ch == "{") {
                    var ch2 = str.slice(i + 1, i + 2);
                    if (ch2 == "$") {
                        i += 1;
                        var j = i + 1;
                        var mylist = new $220f89846e1c7272$var$pyjslib_List([]);
                        var first_run = true;
                        while(true){
                            var i = this.skipSpace(str, j);
                            if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "needed '$}', found end.");
                            if (str.slice(i, i + 2) == "$}") {
                                var j = i + 2;
                                break;
                            }
                            if (!first_run) {
                                if (str.slice(i, i + 1) == ",") i += 1;
                                else throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "expected: ','");
                            } else var first_run = false;
                            var item = new $220f89846e1c7272$var$pyjslib_List([]);
                            var j = this.item(str, i, item);
                            if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "expected item in set or '$}'");
                            mylist.push(item[0]);
                        }
                        res.push(this._store.newSet(mylist, this._context));
                        return j;
                    } else {
                        var j = i + 1;
                        var oldParentContext = this._parentContext;
                        this._parentContext = this._context;
                        var parentAnonymousNodes = this._anonymousNodes;
                        var grandParentVariables = this._parentVariables;
                        this._parentVariables = this._variables;
                        this._anonymousNodes = new $220f89846e1c7272$var$pyjslib_Dict([]);
                        this._variables = this._variables.slice();
                        var reason2 = this._reason2;
                        this._reason2 = $220f89846e1c7272$var$becauseSubexpression;
                        if (subj == null) var subj = this._store.formula();
                        this._context = subj;
                        while(true){
                            var i = this.skipSpace(str, j);
                            if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "needed '}', found end.");
                            if (str.slice(i, i + 1) == "}") {
                                var j = i + 1;
                                break;
                            }
                            var j = this.directiveOrStatement(str, i);
                            if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "expected statement or '}'");
                        }
                        this._anonymousNodes = parentAnonymousNodes;
                        this._variables = this._parentVariables;
                        this._parentVariables = grandParentVariables;
                        this._context = this._parentContext;
                        this._reason2 = reason2;
                        this._parentContext = oldParentContext;
                        res.push(subj.close());
                        return j;
                    }
                }
                if (ch == "(") {
                    var thing_type = this._store.list;
                    var ch2 = str.slice(i + 1, i + 2);
                    if (ch2 == "$") {
                        var thing_type = this._store.newSet;
                        i += 1;
                    }
                    var j = i + 1;
                    var mylist = new $220f89846e1c7272$var$pyjslib_List([]);
                    while(true){
                        var i = this.skipSpace(str, j);
                        if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "needed ')', found end.");
                        if (str.slice(i, i + 1) == ")") {
                            var j = i + 1;
                            break;
                        }
                        var item = new $220f89846e1c7272$var$pyjslib_List([]);
                        var j = this.item(str, i, item);
                        if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "expected item in list or ')'");
                        mylist.push(item[0]);
                    }
                    res.push(thing_type(mylist, this._context));
                    return j;
                }
                var j = this.tok("this", str, i);
                if (j >= 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "Keyword 'this' was ancient N3. Now use @forSome and @forAll keywords.");
                var j = this.tok("true", str, i);
                if (j >= 0) {
                    res.push(true);
                    return j;
                }
                var j = this.tok("false", str, i);
                if (j >= 0) {
                    res.push(false);
                    return j;
                }
                if (subj == null) {
                    var j = this.uri_ref2(str, i, res);
                    if (j >= 0) return j;
                }
                return -1;
            }
        },
        {
            key: "property_list",
            value: function property_list(str, i, subj) {
                /*
      Parse property list
      Leaves the terminating punctuation in the buffer
      */ while(true){
                    var j = this.skipSpace(str, i);
                    if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "EOF found when expected verb in property list");
                    if (str.slice(j, j + 2) == ":-") {
                        var i = j + 2;
                        var res = new $220f89846e1c7272$var$pyjslib_List([]);
                        var j = this.node(str, i, res, subj);
                        if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "bad {} or () or [] node after :- ");
                        var i = j;
                        continue;
                    }
                    var i = j;
                    var v = new $220f89846e1c7272$var$pyjslib_List([]);
                    var j = this.verb(str, i, v);
                    if (j <= 0) return i;
                    var objs = new $220f89846e1c7272$var$pyjslib_List([]);
                    var i = this.objectList(str, j, objs);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "objectList expected");
                    var __obj = new $220f89846e1c7272$var$pyjslib_Iterator(objs);
                    try {
                        while(true){
                            var obj = __obj.next();
                            var pairFudge = v[0];
                            var dir = pairFudge[0];
                            var sym = pairFudge[1];
                            if (dir == "->") this.makeStatement(new $220f89846e1c7272$var$pyjslib_Tuple([
                                this._context,
                                sym,
                                subj,
                                obj
                            ]));
                            else this.makeStatement(new $220f89846e1c7272$var$pyjslib_Tuple([
                                this._context,
                                sym,
                                obj,
                                subj
                            ]));
                        }
                    } catch (e) {
                        if (e != $220f89846e1c7272$var$StopIteration) throw e;
                    }
                    var j = this.skipSpace(str, i);
                    if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "EOF found in list of objects");
                    if (str.slice(i, i + 1) != ";") return i;
                    var i = i + 1;
                }
            }
        },
        {
            key: "commaSeparatedList",
            value: function commaSeparatedList(str, j, res, ofUris) {
                /*
      return value: -1 bad syntax; >1 new position in str
      res has things found appended
       Used to use a final value of the function to be called, e.g. this.bareWord
      but passing the function didn't work fo js converion pyjs
      */ var i = this.skipSpace(str, j);
                if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "EOF found expecting comma sep list");
                if (str.charAt(i) == ".") return j;
                if (ofUris) var i = this.uri_ref2(str, i, res);
                else var i = this.bareWord(str, i, res);
                if (i < 0) return -1;
                while(true){
                    var j = this.skipSpace(str, i);
                    if (j < 0) return j;
                    var ch = str.slice(j, j + 1);
                    if (ch != ",") {
                        if (ch != ".") return -1;
                        return j;
                    }
                    if (ofUris) var i = this.uri_ref2(str, j + 1, res);
                    else var i = this.bareWord(str, j + 1, res);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "bad list content");
                }
            }
        },
        {
            key: "objectList",
            value: function objectList(str, i, res) {
                var i = this.object(str, i, res);
                if (i < 0) return -1;
                while(true){
                    var j = this.skipSpace(str, i);
                    if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "EOF found after object");
                    if (str.slice(j, j + 1) != ",") return j;
                    var i = this.object(str, j + 1, res);
                    if (i < 0) return i;
                }
            }
        },
        {
            key: "checkDot",
            value: function checkDot(str, i) {
                var j = this.skipSpace(str, i);
                if (j < 0) return j;
                if (str.slice(j, j + 1) == ".") return j + 1;
                if (str.slice(j, j + 1) == "}") return j;
                if (str.slice(j, j + 1) == "]") return j;
                throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "expected '.' or '}' or ']' at end of statement");
            }
        },
        {
            key: "uri_ref2",
            value: function uri_ref2(str, i, res) {
                /*
      Generate uri from n3 representation.
       Note that the RDF convention of directly concatenating
      NS and local name is now used though I prefer inserting a '#'
      to make the namesapces look more like what XML folks expect.
      */ var qn = new $220f89846e1c7272$var$pyjslib_List([]);
                var j = this.qname(str, i, qn);
                if (j >= 0) {
                    var pairFudge = qn[0];
                    var pfx = pairFudge[0];
                    var ln = pairFudge[1];
                    if (pfx == null) {
                        $220f89846e1c7272$var$assertFudge(0, "not used?");
                        var ns = this._baseURI + $220f89846e1c7272$var$ADDED_HASH;
                    } else {
                        var ns = this._bindings[pfx];
                        if (!ns) {
                            if (pfx == "_") {
                                res.push(this.anonymousNode(ln));
                                return j;
                            }
                            throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "Prefix " + pfx + " not bound.");
                        }
                    }
                    var symb = this._store.sym(ns + ln);
                    if ((0, $c584fbcedb5512e3$export$37abcb37ee31055e)(this._variables, symb) >= 0) res.push(this._variables[symb]);
                    else res.push(symb);
                    return j;
                }
                var i = this.skipSpace(str, i);
                if (i < 0) return -1;
                if (str.charAt(i) == "?") {
                    var v = new $220f89846e1c7272$var$pyjslib_List([]);
                    var j = this.variable(str, i, v);
                    if (j > 0) {
                        res.push(v[0]);
                        return j;
                    }
                    return -1;
                } else if (str.charAt(i) == "<") {
                    var i = i + 1;
                    var st = i;
                    while(i < $220f89846e1c7272$var$pyjslib_len(str)){
                        if (str.charAt(i) == ">") {
                            var uref = str.slice(st, i);
                            if (this._baseURI) var uref = $220f89846e1c7272$var$uripath_join(this._baseURI, uref);
                            else $220f89846e1c7272$var$assertFudge(uref.indexOf(":") >= 0, "With no base URI, cannot deal with relative URIs");
                            if (str.slice(i - 1, i) == "#" && !($220f89846e1c7272$var$pyjslib_slice(uref, -1, null) == "#")) var uref = uref + "#";
                            var symb = this._store.sym(uref);
                            if ((0, $c584fbcedb5512e3$export$37abcb37ee31055e)(this._variables, symb) >= 0) res.push(this._variables[symb]);
                            else res.push(symb);
                            return i + 1;
                        }
                        var i = i + 1;
                    }
                    throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "unterminated URI reference");
                } else if (this.keywordsSet) {
                    var v = new $220f89846e1c7272$var$pyjslib_List([]);
                    var j = this.bareWord(str, i, v);
                    if (j < 0) return -1;
                    if ((0, $c584fbcedb5512e3$export$37abcb37ee31055e)(this.keywords, v[0]) >= 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, 'Keyword "' + v[0] + '" not allowed here.');
                    res.push(this._store.sym(this._bindings[""] + v[0]));
                    return j;
                } else return -1;
            }
        },
        {
            key: "skipSpace",
            value: function skipSpace(str, i) {
                /*
      Skip white space, newlines and comments.
      return -1 if EOF, else position of first non-ws character*/ var whitespace = " \n\r	\f\v\xa0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u200B\u2028\u2029\u3000";
                for(var j = i ? i : 0; j < str.length; j++){
                    var ch = str.charAt(j);
                    // console.log("    skipspace j= "+j + " i= " + i + " n= " + str.length);
                    // console.log(" skipspace ch <" + ch + ">");
                    if (whitespace.indexOf(ch) < 0) {
                        //not ws
                        // console.log(" skipspace 2 ch <" + ch + ">");
                        if (str.charAt(j) === "#") for(;; j++){
                            // console.log("    skipspace2 j= "+j + " i= " + i + " n= " + str.length);
                            if (j === str.length) return -1; // EOF
                            if (str.charAt(j) === "\n") {
                                this.lines = this.lines + 1;
                                break;
                            }
                        }
                        else // Not hash - something interesting
                        // console.log(" skipspace 3 ch <" + ch + ">");
                        return j;
                    } else // Whitespace
                    // console.log(" skipspace 5 ch <" + ch + ">");
                    if (str.charAt(j) === "\n") this.lines = this.lines + 1;
                } // next j
                return -1; // EOF
            }
        },
        {
            key: "variable",
            value: function variable(str, i, res) {
                /*
      ?abc -> variable(:abc)
      */ var j = this.skipSpace(str, i);
                if (j < 0) return -1;
                if (str.slice(j, j + 1) != "?") return -1;
                var j = j + 1;
                var i = j;
                if ("0123456789-".indexOf(str.charAt(j)) >= 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "Varible name can't start with '" + str.charAt(j) + "s'");
                while(i < $220f89846e1c7272$var$pyjslib_len(str) && $220f89846e1c7272$var$_notNameChars.indexOf(str.charAt(i)) < 0)var i = i + 1;
                if (this._parentContext == null) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "Can't use ?xxx syntax for variable in outermost level: " + str.slice(j - 1, i));
                res.push(this._store.variable(str.slice(j, i)));
                return i;
            }
        },
        {
            key: "bareWord",
            value: function bareWord(str, i, res) {
                /*
      abc -> :abc
      */ var j = this.skipSpace(str, i);
                if (j < 0) return -1;
                var ch = str.charAt(j);
                if ("0123456789-".indexOf(ch) >= 0) return -1;
                if ($220f89846e1c7272$var$_notNameChars.indexOf(ch) >= 0) return -1;
                var i = j;
                while(i < $220f89846e1c7272$var$pyjslib_len(str) && $220f89846e1c7272$var$_notNameChars.indexOf(str.charAt(i)) < 0)var i = i + 1;
                res.push(str.slice(j, i));
                return i;
            }
        },
        {
            key: "qname",
            value: function qname(str, i, res) {
                /*
       xyz:def -> ('xyz', 'def')
      If not in keywords and keywordsSet: def -> ('', 'def')
      :def -> ('', 'def')
      */ var i = this.skipSpace(str, i);
                if (i < 0) return -1;
                var c = str.charAt(i);
                if ("0123456789-+".indexOf(c) >= 0) return -1;
                if ($220f89846e1c7272$var$_notNameChars.indexOf(c) < 0) {
                    var ln = c;
                    var i = i + 1;
                    while(i < $220f89846e1c7272$var$pyjslib_len(str)){
                        var c = str.charAt(i);
                        if ($220f89846e1c7272$var$_notNameChars.indexOf(c) < 0) {
                            var ln = ln + c;
                            var i = i + 1;
                        } else break;
                    }
                } else var ln = "";
                if (i < $220f89846e1c7272$var$pyjslib_len(str) && str.charAt(i) == ":") {
                    var pfx = ln;
                    var i = i + 1;
                    var ln = "";
                    while(i < $220f89846e1c7272$var$pyjslib_len(str)){
                        var c = str.charAt(i);
                        if ($220f89846e1c7272$var$_notNameChars.indexOf(c) < 0) {
                            var ln = ln + c;
                            var i = i + 1;
                        } else break;
                    }
                    res.push(new $220f89846e1c7272$var$pyjslib_Tuple([
                        pfx,
                        ln
                    ]));
                    return i;
                } else {
                    if (ln && this.keywordsSet && (0, $c584fbcedb5512e3$export$37abcb37ee31055e)(this.keywords, ln) < 0) {
                        res.push(new $220f89846e1c7272$var$pyjslib_Tuple([
                            "",
                            ln
                        ]));
                        return i;
                    }
                    return -1;
                }
            }
        },
        {
            key: "object",
            value: function object(str, i, res) {
                var j = this.subject(str, i, res);
                if (j >= 0) return j;
                else {
                    var j = this.skipSpace(str, i);
                    if (j < 0) return -1;
                    else var i = j;
                    var delim = null;
                    var ch = str.charAt(i);
                    if (ch == '"' || ch == "'") {
                        if (str.slice(i, i + 3 == ch + ch)) delim = ch + ch + ch;
                        else delim = ch;
                        var i = i + $220f89846e1c7272$var$pyjslib_len(delim);
                        var pairFudge = this.strconst(str, i, delim);
                        var j = pairFudge[0];
                        var s = pairFudge[1];
                        res.push(this._store.literal(s));
                        $220f89846e1c7272$var$diag_progress("New string const ", s, j);
                        return j;
                    } else return -1;
                }
            }
        },
        {
            key: "nodeOrLiteral",
            value: function nodeOrLiteral(str, i, res) {
                var j = this.node(str, i, res);
                if (j >= 0) return j;
                else {
                    var j = this.skipSpace(str, i);
                    if (j < 0) return -1;
                    else var i = j;
                    var ch = str.charAt(i);
                    if ("-+0987654321".indexOf(ch) >= 0) {
                        $220f89846e1c7272$var$datetime_syntax.lastIndex = 0;
                        var m = $220f89846e1c7272$var$datetime_syntax.exec(str.slice(i));
                        if (m != null) {
                            // j =  ( i + datetime_syntax.lastIndex ) ;
                            var val = m[0];
                            j = i + val.length;
                            if (val.indexOf("T") >= 0) res.push(this._store.literal(val, this._store.sym($220f89846e1c7272$var$DATETIME_DATATYPE)));
                            else res.push(this._store.literal(val, this._store.sym($220f89846e1c7272$var$DATE_DATATYPE)));
                        } else {
                            $220f89846e1c7272$var$number_syntax.lastIndex = 0;
                            var m = $220f89846e1c7272$var$number_syntax.exec(str.slice(i));
                            if (m == null) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "Bad number or date syntax");
                            j = i + $220f89846e1c7272$var$number_syntax.lastIndex;
                            var val = str.slice(i, j);
                            if (val.indexOf("e") >= 0) res.push(this._store.literal(parseFloat(val), this._store.sym($220f89846e1c7272$var$FLOAT_DATATYPE)));
                            else if (str.slice(i, j).indexOf(".") >= 0) res.push(this._store.literal(parseFloat(val), this._store.sym($220f89846e1c7272$var$DECIMAL_DATATYPE)));
                            else res.push(this._store.literal(parseInt(val), this._store.sym($220f89846e1c7272$var$INTEGER_DATATYPE)));
                        }
                        return j; // Where we have got up to
                    }
                    if (str.charAt(i) == '"') {
                        if (str.slice(i, i + 3) == '"""') var delim = '"""';
                        else var delim = '"';
                        var i = i + $220f89846e1c7272$var$pyjslib_len(delim);
                        var dt = null;
                        var pairFudge = this.strconst(str, i, delim);
                        var j = pairFudge[0];
                        var s = pairFudge[1];
                        var lang = null;
                        if (str.slice(j, j + 1) == "@") {
                            $220f89846e1c7272$var$langcode.lastIndex = 0;
                            var m = $220f89846e1c7272$var$langcode.exec(str.slice(j + 1));
                            if (m == null) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, startline, str, i, "Bad language code syntax on string literal, after @");
                            var i = $220f89846e1c7272$var$langcode.lastIndex + j + 1;
                            var lang = str.slice(j + 1, i);
                            var j = i;
                        }
                        if (str.slice(j, j + 2) == "^^") {
                            var res2 = new $220f89846e1c7272$var$pyjslib_List([]);
                            var j = this.uri_ref2(str, j + 2, res2);
                            var dt = res2[0];
                        }
                        res.push(this._store.literal(s, lang || dt));
                        return j;
                    } else return -1;
                }
            }
        },
        {
            key: "strconst",
            value: function strconst(str, i, delim) {
                /*
      parse an N3 string constant delimited by delim.
      return index, val
      */ var j = i;
                var ustr = "";
                var startline1 = this.lines;
                while(j < $220f89846e1c7272$var$pyjslib_len(str)){
                    var i = j + $220f89846e1c7272$var$pyjslib_len(delim);
                    if (str.slice(j, i) == delim) return new $220f89846e1c7272$var$pyjslib_Tuple([
                        i,
                        ustr
                    ]);
                    if (str.charAt(j) == '"') {
                        var ustr = ustr + '"';
                        var j = j + 1;
                        continue;
                    }
                    $220f89846e1c7272$var$interesting.lastIndex = 0;
                    var m = $220f89846e1c7272$var$interesting.exec(str.slice(j));
                    if (!m) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, startline1, str, j, "Closing quote missing in string at ^ in " + str.slice(j - 20, j) + "^" + str.slice(j, j + 20));
                    var i = j + $220f89846e1c7272$var$interesting.lastIndex - 1;
                    var ustr = ustr + str.slice(j, i);
                    var ch = str.charAt(i);
                    if (ch == '"') {
                        var j = i;
                        continue;
                    } else if (ch == "\r") {
                        var j = i + 1;
                        continue;
                    } else if (ch == "\n") {
                        if (delim == '"') throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, startline1, str, i, "newline found in string literal");
                        this.lines = this.lines + 1;
                        var ustr = ustr + ch;
                        var j = i + 1;
                        this.previousLine = this.startOfLine;
                        this.startOfLine = j;
                    } else if (ch == "\\") {
                        var j = i + 1;
                        var ch = str.slice(j, j + 1);
                        if (!ch) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, startline1, str, i, "unterminated string literal (2)");
                        var k = $220f89846e1c7272$var$string_find('abfrtvn\\"', ch);
                        if (k >= 0) {
                            var uch = 'a\b\f\r	\v\n\\"'.charAt(k);
                            var ustr = ustr + uch;
                            var j = j + 1;
                        } else if (ch == "u") {
                            var pairFudge = this.uEscape(str, j + 1, startline1);
                            var j = pairFudge[0];
                            var ch = pairFudge[1];
                            var ustr = ustr + ch;
                        } else if (ch == "U") {
                            var pairFudge = this.UEscape(str, j + 1, startline1);
                            var j = pairFudge[0];
                            var ch = pairFudge[1];
                            var ustr = ustr + ch;
                        } else throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "bad escape");
                    }
                }
                throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "unterminated string literal");
            }
        },
        {
            key: "uEscape",
            value: function uEscape(str, i, startline1) {
                var j = i;
                var count = 0;
                var value = 0;
                while(count < 4){
                    var chFudge = str.slice(j, j + 1);
                    var ch = chFudge.toLowerCase();
                    var j = j + 1;
                    if (ch == "") throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, startline1, str, i, "unterminated string literal(3)");
                    var k = $220f89846e1c7272$var$string_find("0123456789abcdef", ch);
                    if (k < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, startline1, str, i, "bad string literal hex escape");
                    var value = value * 16 + k;
                    var count = count + 1;
                }
                var uch = String.fromCharCode(value);
                return new $220f89846e1c7272$var$pyjslib_Tuple([
                    j,
                    uch
                ]);
            }
        },
        {
            key: "UEscape",
            value: function UEscape(str, i, startline1) {
                var j = i;
                var count = 0;
                var value = "\\U";
                while(count < 8){
                    var chFudge = str.slice(j, j + 1);
                    var ch = chFudge.toLowerCase();
                    var j = j + 1;
                    if (ch == "") throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, startline1, str, i, "unterminated string literal(3)");
                    var k = $220f89846e1c7272$var$string_find("0123456789abcdef", ch);
                    if (k < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, startline1, str, i, "bad string literal hex escape");
                    var value = value + ch;
                    var count = count + 1;
                }
                var uch = $220f89846e1c7272$var$stringFromCharCode("0x" + $220f89846e1c7272$var$pyjslib_slice(value, 2, 10) - 0);
                return new $220f89846e1c7272$var$pyjslib_Tuple([
                    j,
                    uch
                ]);
            }
        }
    ]);
    return SinkParser;
}();
function $220f89846e1c7272$var$OLD_BadSyntax(uri, lines, str, i, why) {
    return new $220f89846e1c7272$var$__OLD_BadSyntax(uri, lines, str, i, why);
}
function $220f89846e1c7272$var$__OLD_BadSyntax(uri, lines, str, i, why) {
    this._str = str.encode("utf-8");
    this._str = str;
    this._i = i;
    this._why = why;
    this.lines = lines;
    this._uri = uri;
}
$220f89846e1c7272$var$__OLD_BadSyntax.prototype.toString = function() {
    var str = this._str;
    var i = this._i;
    var st = 0;
    if (i > 60) {
        var pre = "...";
        var st = i - 60;
    } else var pre = "";
    if ($220f89846e1c7272$var$pyjslib_len(str) - i > 60) var post = "...";
    else var post = "";
    return 'Line %i of <%s>: Bad syntax (%s) at ^ in:\n"%s%s^%s%s"' % new $220f89846e1c7272$var$pyjslib_Tuple([
        this.lines + 1,
        this._uri,
        this._why,
        pre,
        str.slice(st, i),
        str.slice(i, i + 60),
        post
    ]);
};
function $220f89846e1c7272$var$BadSyntax(uri, lines, str, i, why) {
    var lineNo = lines + 1;
    var msg = "Line " + lineNo + " of <" + uri + ">: Bad syntax: " + why + '\nat: "' + str.slice(i, i + 30) + '"';
    var e = new SyntaxError(msg, uri, lineNo);
    e.lineNo = lineNo;
    e.characterInFile = i;
    e.syntaxProblem = why;
    return e;
}
function $220f89846e1c7272$var$stripCR(str) {
    var res = "";
    var __ch = new $220f89846e1c7272$var$pyjslib_Iterator(str);
    try {
        while(true){
            var ch = __ch.next();
            if (ch != "\r") var res = res + ch;
        }
    } catch (e) {
        if (e != $220f89846e1c7272$var$StopIteration) throw e;
    }
    return res;
}
function $220f89846e1c7272$var$dummyWrite(x) {}



var $99pVg = parcelRequire("99pVg");


var $g5Zhu = parcelRequire("g5Zhu");



var $8RKL2 = parcelRequire("8RKL2");


var $gCJkd = parcelRequire("gCJkd");

var $2b3711697846728e$var$_supports;
function $2b3711697846728e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2b3711697846728e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $2b3711697846728e$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $2b3711697846728e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Data factory which also supports Collections
 *
 * Necessary for preventing circular dependencies.
 */ var $2b3711697846728e$var$ExtendedTermFactory = $2b3711697846728e$var$_objectSpread($2b3711697846728e$var$_objectSpread({}, (0, $158d84b4866fe33e$export$2e2bcd8739ae039)), {}, {
    supports: ($2b3711697846728e$var$_supports = {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($2b3711697846728e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).collections, true), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($2b3711697846728e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).defaultGraphType, false), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($2b3711697846728e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).equalsMethod, true), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($2b3711697846728e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).identity, false), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($2b3711697846728e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).id, true), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($2b3711697846728e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).reversibleId, false), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($2b3711697846728e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).variableType, true), $2b3711697846728e$var$_supports),
    /**
   * Creates a new collection
   * @param elements - The initial element
   */ collection: function collection(elements) {
        return new (0, $619d91631affbf30$export$2e2bcd8739ae039)(elements);
    },
    id: function id(term) {
        var _this = this;
        if ((0, $gCJkd.isCollection)(term)) return "( ".concat(term.elements.map(function(e) {
            return _this.id(e);
        }).join(", "), " )");
        if ((0, $gCJkd.isVariable)(term)) return (0, $b7a48305c1700eec$export$2e2bcd8739ae039).toString(term);
        return (0, $158d84b4866fe33e$export$2e2bcd8739ae039).id(term);
    },
    termToNQ: function termToNQ(term) {
        if (term.termType === (0, $8RKL2.CollectionTermType)) return (0, $619d91631affbf30$export$2e2bcd8739ae039).toNT(term);
        return (0, $158d84b4866fe33e$export$2e2bcd8739ae039).termToNQ(term);
    }
});
var $2b3711697846728e$export$2e2bcd8739ae039 = $2b3711697846728e$var$ExtendedTermFactory;



function $93c26633f06ced7c$export$a8378f59d30ae4c0(kb, obj) {
    if (typeof obj === "string") return kb.rdfFactory.literal(obj);
    if (Object.prototype.hasOwnProperty.call(obj, "@list")) {
        if (kb.rdfFactory.supports["COLLECTIONS"] === true) return $93c26633f06ced7c$var$listToCollection(kb, obj["@list"]);
        return $93c26633f06ced7c$var$listToStatements(kb, obj);
    }
    if (Object.prototype.hasOwnProperty.call(obj, "@id")) return $93c26633f06ced7c$var$nodeType(kb, obj);
    if (Object.prototype.hasOwnProperty.call(obj, "@language")) return kb.rdfFactory.literal(obj["@value"], obj["@language"]);
    if (Object.prototype.hasOwnProperty.call(obj, "@type")) return kb.rdfFactory.literal(obj["@value"], kb.rdfFactory.namedNode(obj["@type"]));
    if (Object.prototype.hasOwnProperty.call(obj, "@value")) return kb.rdfFactory.literal(obj["@value"]);
    return kb.rdfFactory.literal(obj);
}
/**
 * Adds the statements in a json-ld list object to {kb}.
 */ function $93c26633f06ced7c$var$listToStatements(kb, obj) {
    var listId = obj["@id"] ? $93c26633f06ced7c$var$nodeType(kb, obj) : kb.rdfFactory.blankNode();
    var items = obj["@list"].map(function(listItem) {
        return $93c26633f06ced7c$export$a8378f59d30ae4c0(kb, listItem);
    });
    var statements = (0, $c584fbcedb5512e3$export$b0f02731210f3037)(kb.rdfFactory, listId, items);
    kb.addAll(statements);
    return listId;
}
function $93c26633f06ced7c$var$listToCollection(kb, obj) {
    if (!Array.isArray(obj)) throw new TypeError("Object must be an array");
    return kb.rdfFactory.collection(obj.map(function(o) {
        return $93c26633f06ced7c$export$a8378f59d30ae4c0(kb, o);
    }));
}

function $93c26633f06ced7c$export$2e2bcd8739ae039(str, kb, base, callback) {
    var baseString = base && Object.prototype.hasOwnProperty.call(base, "termType") ? base.value : base;
    return (parcelRequire("v6ngW")).then(function(jsonld) {
        return jsonld.flatten(JSON.parse(str), null, {
            base: baseString
        });
    }).then(function(flattened) {
        return flattened.reduce(function(store, flatResource) {
            kb = $93c26633f06ced7c$var$processResource(kb, base, flatResource);
            return kb;
        }, kb);
    }).then(callback).catch(callback);
}
function $93c26633f06ced7c$var$nodeType(kb, obj) {
    if (obj["@id"].startsWith("_:")) // This object is a Blank Node. Pass the id without the `_:` prefix
    return kb.rdfFactory.blankNode(obj["@id"].substring(2));
    else // This object is a Named Node
    return kb.rdfFactory.namedNode(obj["@id"]);
}
function $93c26633f06ced7c$var$processResource(kb, base, flatResource) {
    var id = flatResource["@id"] ? $93c26633f06ced7c$var$nodeType(kb, flatResource) : kb.rdfFactory.blankNode();
    for(var _i = 0, _Object$keys = Object.keys(flatResource); _i < _Object$keys.length; _i++){
        var property = _Object$keys[_i];
        if (property === "@id") continue;
        else if (property == "@graph") {
            // the JSON-LD flattened structure may contain nested graphs
            // the id value for this object is the new base (named graph id) for all nested flat resources
            var graphId = id;
            // this is an array of resources
            var nestedFlatResources = flatResource[property];
            // recursively process all flat resources in the array, but with the graphId as base.
            for(var i = 0; i < nestedFlatResources.length; i++)kb = $93c26633f06ced7c$var$processResource(kb, graphId, nestedFlatResources[i]);
        }
        var value = flatResource[property];
        if (Array.isArray(value)) for(var _i2 = 0; _i2 < value.length; _i2++)kb.addStatement($93c26633f06ced7c$var$createStatement(kb, id, property, value[_i2], base));
        else kb.addStatement($93c26633f06ced7c$var$createStatement(kb, id, property, value, base));
    }
    return kb;
}
/**
 * Create statement quad depending on @type being a type node
 * @param kb
 * @param subject id
 * @param property
 * @param value
 * @return quad statement
 */ function $93c26633f06ced7c$var$createStatement(kb, id, property, value, base) {
    var predicate, object;
    if (property === "@type") {
        predicate = kb.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type");
        object = kb.rdfFactory.namedNode(value);
    } else {
        predicate = kb.rdfFactory.namedNode(property);
        object = $93c26633f06ced7c$export$a8378f59d30ae4c0(kb, value);
    }
    return kb.rdfFactory.quad(id, predicate, object, kb.rdfFactory.namedNode(base));
}


// **N3Lexer** tokenizes N3 documents.
var $6210dce35be42a6b$exports = {};
/*! queue-microtask. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ let $6210dce35be42a6b$var$promise;
$6210dce35be42a6b$exports = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : $parcel$global) : (cb)=>($6210dce35be42a6b$var$promise || ($6210dce35be42a6b$var$promise = Promise.resolve())).then(cb).catch((err)=>setTimeout(()=>{
            throw err;
        }, 0));


const $b50e49a75dcd9196$var$RDF = "http://www.w3.org/1999/02/22-rdf-syntax-ns#", $b50e49a75dcd9196$var$XSD = "http://www.w3.org/2001/XMLSchema#", $b50e49a75dcd9196$var$SWAP = "http://www.w3.org/2000/10/swap/";
var $b50e49a75dcd9196$export$2e2bcd8739ae039 = {
    xsd: {
        decimal: `${$b50e49a75dcd9196$var$XSD}decimal`,
        boolean: `${$b50e49a75dcd9196$var$XSD}boolean`,
        double: `${$b50e49a75dcd9196$var$XSD}double`,
        integer: `${$b50e49a75dcd9196$var$XSD}integer`,
        string: `${$b50e49a75dcd9196$var$XSD}string`
    },
    rdf: {
        type: `${$b50e49a75dcd9196$var$RDF}type`,
        nil: `${$b50e49a75dcd9196$var$RDF}nil`,
        first: `${$b50e49a75dcd9196$var$RDF}first`,
        rest: `${$b50e49a75dcd9196$var$RDF}rest`,
        langString: `${$b50e49a75dcd9196$var$RDF}langString`
    },
    owl: {
        sameAs: "http://www.w3.org/2002/07/owl#sameAs"
    },
    r: {
        forSome: `${$b50e49a75dcd9196$var$SWAP}reify#forSome`,
        forAll: `${$b50e49a75dcd9196$var$SWAP}reify#forAll`
    },
    log: {
        implies: `${$b50e49a75dcd9196$var$SWAP}log#implies`
    }
};



var $6ZWSX = parcelRequire("6ZWSX");
var $c66a9a29d2de1131$require$Buffer = $6ZWSX.Buffer;
const { xsd: $c66a9a29d2de1131$var$xsd } = (0, $b50e49a75dcd9196$export$2e2bcd8739ae039);
// Regular expression and replacement string to escape N3 strings
const $c66a9a29d2de1131$var$escapeSequence = /\\u([a-fA-F0-9]{4})|\\U([a-fA-F0-9]{8})|\\([^])/g;
const $c66a9a29d2de1131$var$escapeReplacements = {
    "\\": "\\",
    "'": "'",
    '"': '"',
    "n": "\n",
    "r": "\r",
    "t": "	",
    "f": "\f",
    "b": "\b",
    "_": "_",
    "~": "~",
    ".": ".",
    "-": "-",
    "!": "!",
    "$": "$",
    "&": "&",
    "(": "(",
    ")": ")",
    "*": "*",
    "+": "+",
    ",": ",",
    ";": ";",
    "=": "=",
    "/": "/",
    "?": "?",
    "#": "#",
    "@": "@",
    "%": "%"
};
const $c66a9a29d2de1131$var$illegalIriChars = /[\x00-\x20<>\\"\{\}\|\^\`]/;
const $c66a9a29d2de1131$var$lineModeRegExps = {
    _iri: true,
    _unescapedIri: true,
    _simpleQuotedString: true,
    _langcode: true,
    _blank: true,
    _newline: true,
    _comment: true,
    _whitespace: true,
    _endOfFile: true
};
const $c66a9a29d2de1131$var$invalidRegExp = /$0^/;
class $c66a9a29d2de1131$export$2e2bcd8739ae039 {
    constructor(options){
        // ## Regular expressions
        // It's slightly faster to have these as properties than as in-scope variables
        this._iri = /^<((?:[^ <>{}\\]|\\[uU])+)>[ \t]*/; // IRI with escape sequences; needs sanity check after unescaping
        this._unescapedIri = /^<([^\x00-\x20<>\\"\{\}\|\^\`]*)>[ \t]*/; // IRI without escape sequences; no unescaping
        this._simpleQuotedString = /^"([^"\\\r\n]*)"(?=[^"])/; // string without escape sequences
        this._simpleApostropheString = /^'([^'\\\r\n]*)'(?=[^'])/;
        this._langcode = /^@([a-z]+(?:-[a-z0-9]+)*)(?=[^a-z0-9\-])/i;
        this._prefix = /^((?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)?:(?=[#\s<])/;
        this._prefixed = /^((?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)?:((?:(?:[0-:A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~])(?:(?:[\.\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~])*(?:[\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~]))?)?)(?:[ \t]+|(?=\.?[,;!\^\s#()\[\]\{\}"'<>]))/;
        this._variable = /^\?(?:(?:[A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:[\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)(?=[.,;!\^\s#()\[\]\{\}"'<>])/;
        this._blank = /^_:((?:[0-9A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)(?:[ \t]+|(?=\.?[,;:\s#()\[\]\{\}"'<>]))/;
        this._number = /^[\-+]?(?:(\d+\.\d*|\.?\d+)[eE][\-+]?|\d*(\.)?)\d+(?=\.?[,;:\s#()\[\]\{\}"'<>])/;
        this._boolean = /^(?:true|false)(?=[.,;\s#()\[\]\{\}"'<>])/;
        this._keyword = /^@[a-z]+(?=[\s#<:])/i;
        this._sparqlKeyword = /^(?:PREFIX|BASE|GRAPH)(?=[\s#<])/i;
        this._shortPredicates = /^a(?=[\s#()\[\]\{\}"'<>])/;
        this._newline = /^[ \t]*(?:#[^\n\r]*)?(?:\r\n|\n|\r)[ \t]*/;
        this._comment = /#([^\n\r]*)/;
        this._whitespace = /^[ \t]+/;
        this._endOfFile = /^(?:#[^\n\r]*)?$/;
        options = options || {};
        // In line mode (N-Triples or N-Quads), only simple features may be parsed
        if (this._lineMode = !!options.lineMode) {
            this._n3Mode = false;
            // Don't tokenize special literals
            for(const key in this)if (!(key in $c66a9a29d2de1131$var$lineModeRegExps) && this[key] instanceof RegExp) this[key] = $c66a9a29d2de1131$var$invalidRegExp;
        } else this._n3Mode = options.n3 !== false;
        // Don't output comment tokens by default
        this._comments = !!options.comments;
        // Cache the last tested closing position of long literals
        this._literalClosingPos = 0;
    }
    // ## Private methods
    // ### `_tokenizeToEnd` tokenizes as for as possible, emitting tokens through the callback
    _tokenizeToEnd(callback, inputFinished) {
        // Continue parsing as far as possible; the loop will return eventually
        let input = this._input;
        let currentLineLength = input.length;
        while(true){
            // Count and skip whitespace lines
            let whiteSpaceMatch, comment;
            while(whiteSpaceMatch = this._newline.exec(input)){
                // Try to find a comment
                if (this._comments && (comment = this._comment.exec(whiteSpaceMatch[0]))) emitToken("comment", comment[1], "", this._line, whiteSpaceMatch[0].length);
                // Advance the input
                input = input.substr(whiteSpaceMatch[0].length, input.length);
                currentLineLength = input.length;
                this._line++;
            }
            // Skip whitespace on current line
            if (!whiteSpaceMatch && (whiteSpaceMatch = this._whitespace.exec(input))) input = input.substr(whiteSpaceMatch[0].length, input.length);
            // Stop for now if we're at the end
            if (this._endOfFile.test(input)) {
                // If the input is finished, emit EOF
                if (inputFinished) {
                    // Try to find a final comment
                    if (this._comments && (comment = this._comment.exec(input))) emitToken("comment", comment[1], "", this._line, input.length);
                    input = null;
                    emitToken("eof", "", "", this._line, 0);
                }
                return this._input = input;
            }
            // Look for specific token types based on the first character
            const line = this._line, firstChar = input[0];
            let type = "", value = "", prefix = "", match = null, matchLength = 0, inconclusive = false;
            switch(firstChar){
                case "^":
                    // We need at least 3 tokens lookahead to distinguish ^^<IRI> and ^^pre:fixed
                    if (input.length < 3) break;
                    else if (input[1] === "^") {
                        this._previousMarker = "^^";
                        // Move to type IRI or prefixed name
                        input = input.substr(2);
                        if (input[0] !== "<") {
                            inconclusive = true;
                            break;
                        }
                    } else {
                        if (this._n3Mode) {
                            matchLength = 1;
                            type = "^";
                        }
                        break;
                    }
                // Fall through in case the type is an IRI
                case "<":
                    // Try to find a full IRI without escape sequences
                    if (match = this._unescapedIri.exec(input)) type = "IRI", value = match[1];
                    else if (match = this._iri.exec(input)) {
                        value = this._unescape(match[1]);
                        if (value === null || $c66a9a29d2de1131$var$illegalIriChars.test(value)) return reportSyntaxError(this);
                        type = "IRI";
                    } else if (input.length > 1 && input[1] === "<") type = "<<", matchLength = 2;
                    else if (this._n3Mode && input.length > 1 && input[1] === "=") type = "inverse", matchLength = 2, value = ">";
                    break;
                case ">":
                    if (input.length > 1 && input[1] === ">") type = ">>", matchLength = 2;
                    break;
                case "_":
                    // Try to find a blank node. Since it can contain (but not end with) a dot,
                    // we always need a non-dot character before deciding it is a blank node.
                    // Therefore, try inserting a space if we're at the end of the input.
                    if ((match = this._blank.exec(input)) || inputFinished && (match = this._blank.exec(`${input} `))) type = "blank", prefix = "_", value = match[1];
                    break;
                case '"':
                    // Try to find a literal without escape sequences
                    if (match = this._simpleQuotedString.exec(input)) value = match[1];
                    else {
                        ({ value: value, matchLength: matchLength } = this._parseLiteral(input));
                        if (value === null) return reportSyntaxError(this);
                    }
                    if (match !== null || matchLength !== 0) {
                        type = "literal";
                        this._literalClosingPos = 0;
                    }
                    break;
                case "'":
                    if (!this._lineMode) {
                        // Try to find a literal without escape sequences
                        if (match = this._simpleApostropheString.exec(input)) value = match[1];
                        else {
                            ({ value: value, matchLength: matchLength } = this._parseLiteral(input));
                            if (value === null) return reportSyntaxError(this);
                        }
                        if (match !== null || matchLength !== 0) {
                            type = "literal";
                            this._literalClosingPos = 0;
                        }
                    }
                    break;
                case "?":
                    // Try to find a variable
                    if (this._n3Mode && (match = this._variable.exec(input))) type = "var", value = match[0];
                    break;
                case "@":
                    // Try to find a language code
                    if (this._previousMarker === "literal" && (match = this._langcode.exec(input))) type = "langcode", value = match[1];
                    else if (match = this._keyword.exec(input)) type = match[0];
                    break;
                case ".":
                    // Try to find a dot as punctuation
                    if (input.length === 1 ? inputFinished : input[1] < "0" || input[1] > "9") {
                        type = ".";
                        matchLength = 1;
                        break;
                    }
                // Fall through to numerical case (could be a decimal dot)
                case "0":
                case "1":
                case "2":
                case "3":
                case "4":
                case "5":
                case "6":
                case "7":
                case "8":
                case "9":
                case "+":
                case "-":
                    // Try to find a number. Since it can contain (but not end with) a dot,
                    // we always need a non-dot character before deciding it is a number.
                    // Therefore, try inserting a space if we're at the end of the input.
                    if (match = this._number.exec(input) || inputFinished && (match = this._number.exec(`${input} `))) {
                        type = "literal", value = match[0];
                        prefix = typeof match[1] === "string" ? $c66a9a29d2de1131$var$xsd.double : typeof match[2] === "string" ? $c66a9a29d2de1131$var$xsd.decimal : $c66a9a29d2de1131$var$xsd.integer;
                    }
                    break;
                case "B":
                case "b":
                case "p":
                case "P":
                case "G":
                case "g":
                    // Try to find a SPARQL-style keyword
                    if (match = this._sparqlKeyword.exec(input)) type = match[0].toUpperCase();
                    else inconclusive = true;
                    break;
                case "f":
                case "t":
                    // Try to match a boolean
                    if (match = this._boolean.exec(input)) type = "literal", value = match[0], prefix = $c66a9a29d2de1131$var$xsd.boolean;
                    else inconclusive = true;
                    break;
                case "a":
                    // Try to find an abbreviated predicate
                    if (match = this._shortPredicates.exec(input)) type = "abbreviation", value = "a";
                    else inconclusive = true;
                    break;
                case "=":
                    // Try to find an implication arrow or equals sign
                    if (this._n3Mode && input.length > 1) {
                        type = "abbreviation";
                        if (input[1] !== ">") matchLength = 1, value = "=";
                        else matchLength = 2, value = ">";
                    }
                    break;
                case "!":
                    if (!this._n3Mode) break;
                case ",":
                case ";":
                case "[":
                case "]":
                case "(":
                case ")":
                case "}":
                    if (!this._lineMode) {
                        matchLength = 1;
                        type = firstChar;
                    }
                    break;
                case "{":
                    // We need at least 2 tokens lookahead to distinguish "{|" and "{ "
                    if (!this._lineMode && input.length >= 2) {
                        // Try to find a quoted triple annotation start
                        if (input[1] === "|") type = "{|", matchLength = 2;
                        else type = firstChar, matchLength = 1;
                    }
                    break;
                case "|":
                    // We need 2 tokens lookahead to parse "|}"
                    // Try to find a quoted triple annotation end
                    if (input.length >= 2 && input[1] === "}") type = "|}", matchLength = 2;
                    break;
                default:
                    inconclusive = true;
            }
            // Some first characters do not allow an immediate decision, so inspect more
            if (inconclusive) {
                // Try to find a prefix
                if ((this._previousMarker === "@prefix" || this._previousMarker === "PREFIX") && (match = this._prefix.exec(input))) type = "prefix", value = match[1] || "";
                else if ((match = this._prefixed.exec(input)) || inputFinished && (match = this._prefixed.exec(`${input} `))) type = "prefixed", prefix = match[1] || "", value = this._unescape(match[2]);
            }
            // A type token is special: it can only be emitted after an IRI or prefixed name is read
            if (this._previousMarker === "^^") switch(type){
                case "prefixed":
                    type = "type";
                    break;
                case "IRI":
                    type = "typeIRI";
                    break;
                default:
                    type = "";
            }
            // What if nothing of the above was found?
            if (!type) {
                // We could be in streaming mode, and then we just wait for more input to arrive.
                // Otherwise, a syntax error has occurred in the input.
                // One exception: error on an unaccounted linebreak (= not inside a triple-quoted literal).
                if (inputFinished || !/^'''|^"""/.test(input) && /\n|\r/.test(input)) return reportSyntaxError(this);
                else return this._input = input;
            }
            // Emit the parsed token
            const length = matchLength || match[0].length;
            const token = emitToken(type, value, prefix, line, length);
            this.previousToken = token;
            this._previousMarker = type;
            // Advance to next part to tokenize
            input = input.substr(length, input.length);
        }
        // Emits the token through the callback
        function emitToken(type, value, prefix, line, length) {
            const start = input ? currentLineLength - input.length : currentLineLength;
            const end = start + length;
            const token = {
                type: type,
                value: value,
                prefix: prefix,
                line: line,
                start: start,
                end: end
            };
            callback(null, token);
            return token;
        }
        // Signals the syntax error through the callback
        function reportSyntaxError(self) {
            callback(self._syntaxError(/^\S*/.exec(input)[0]));
        }
    }
    // ### `_unescape` replaces N3 escape codes by their corresponding characters
    _unescape(item) {
        let invalid = false;
        const replaced = item.replace($c66a9a29d2de1131$var$escapeSequence, (sequence, unicode4, unicode8, escapedChar)=>{
            // 4-digit unicode character
            if (typeof unicode4 === "string") return String.fromCharCode(Number.parseInt(unicode4, 16));
            // 8-digit unicode character
            if (typeof unicode8 === "string") {
                let charCode = Number.parseInt(unicode8, 16);
                return charCode <= 0xFFFF ? String.fromCharCode(Number.parseInt(unicode8, 16)) : String.fromCharCode(0xD800 + ((charCode -= 0x10000) >> 10), 0xDC00 + (charCode & 0x3FF));
            }
            // fixed escape sequence
            if (escapedChar in $c66a9a29d2de1131$var$escapeReplacements) return $c66a9a29d2de1131$var$escapeReplacements[escapedChar];
            // invalid escape sequence
            invalid = true;
            return "";
        });
        return invalid ? null : replaced;
    }
    // ### `_parseLiteral` parses a literal into an unescaped value
    _parseLiteral(input) {
        // Ensure we have enough lookahead to identify triple-quoted strings
        if (input.length >= 3) {
            // Identify the opening quote(s)
            const opening = input.match(/^(?:"""|"|'''|'|)/)[0];
            const openingLength = opening.length;
            // Find the next candidate closing quotes
            let closingPos = Math.max(this._literalClosingPos, openingLength);
            while((closingPos = input.indexOf(opening, closingPos)) > 0){
                // Count backslashes right before the closing quotes
                let backslashCount = 0;
                while(input[closingPos - backslashCount - 1] === "\\")backslashCount++;
                // An even number of backslashes (in particular 0)
                // means these are actual, non-escaped closing quotes
                if (backslashCount % 2 === 0) {
                    // Extract and unescape the value
                    const raw = input.substring(openingLength, closingPos);
                    const lines = raw.split(/\r\n|\r|\n/).length - 1;
                    const matchLength = closingPos + openingLength;
                    // Only triple-quoted strings can be multi-line
                    if (openingLength === 1 && lines !== 0 || openingLength === 3 && this._lineMode) break;
                    this._line += lines;
                    return {
                        value: this._unescape(raw),
                        matchLength: matchLength
                    };
                }
                closingPos++;
            }
            this._literalClosingPos = input.length - openingLength + 1;
        }
        return {
            value: "",
            matchLength: 0
        };
    }
    // ### `_syntaxError` creates a syntax error for the given issue
    _syntaxError(issue) {
        this._input = null;
        const err = new Error(`Unexpected "${issue}" on line ${this._line}.`);
        err.context = {
            token: undefined,
            line: this._line,
            previousToken: this.previousToken
        };
        return err;
    }
    // ### Strips off any starting UTF BOM mark.
    _readStartingBom(input) {
        return input.startsWith("\uFEFF") ? input.substr(1) : input;
    }
    // ## Public methods
    // ### `tokenize` starts the transformation of an N3 document into an array of tokens.
    // The input can be a string or a stream.
    tokenize(input, callback) {
        this._line = 1;
        // If the input is a string, continuously emit tokens through the callback until the end
        if (typeof input === "string") {
            this._input = this._readStartingBom(input);
            // If a callback was passed, asynchronously call it
            if (typeof callback === "function") (0, (/*@__PURE__*/$parcel$interopDefault($6210dce35be42a6b$exports)))(()=>this._tokenizeToEnd(callback, true));
            else {
                const tokens = [];
                let error;
                this._tokenizeToEnd((e, t)=>e ? error = e : tokens.push(t), true);
                if (error) throw error;
                return tokens;
            }
        } else {
            this._pendingBuffer = null;
            if (typeof input.setEncoding === "function") input.setEncoding("utf8");
            // Adds the data chunk to the buffer and parses as far as possible
            input.on("data", (data)=>{
                if (this._input !== null && data.length !== 0) {
                    // Prepend any previous pending writes
                    if (this._pendingBuffer) {
                        data = $c66a9a29d2de1131$require$Buffer.concat([
                            this._pendingBuffer,
                            data
                        ]);
                        this._pendingBuffer = null;
                    }
                    // Hold if the buffer ends in an incomplete unicode sequence
                    if (data[data.length - 1] & 0x80) this._pendingBuffer = data;
                    else {
                        // Only read a BOM at the start
                        if (typeof this._input === "undefined") this._input = this._readStartingBom(typeof data === "string" ? data : data.toString());
                        else this._input += data;
                        this._tokenizeToEnd(callback, false);
                    }
                }
            });
            // Parses until the end
            input.on("end", ()=>{
                if (typeof this._input === "string") this._tokenizeToEnd(callback, true);
            });
            input.on("error", callback);
        }
    }
}


// **N3Parser** parses N3 documents.

// N3.js implementations of the RDF/JS core data types
// See https://github.com/rdfjs/representation-task-force/blob/master/interface-spec.md

const { rdf: $712f170b9f5279d6$var$rdf, xsd: $712f170b9f5279d6$var$xsd } = (0, $b50e49a75dcd9196$export$2e2bcd8739ae039);
// eslint-disable-next-line prefer-const
let $712f170b9f5279d6$var$DEFAULTGRAPH;
let $712f170b9f5279d6$var$_blankNodeCounter = 0;
const $712f170b9f5279d6$var$escapedLiteral = /^"(.*".*)(?="[^"]*$)/;
// ## DataFactory singleton
const $712f170b9f5279d6$var$DataFactory = {
    namedNode: $712f170b9f5279d6$var$namedNode,
    blankNode: $712f170b9f5279d6$var$blankNode,
    variable: $712f170b9f5279d6$var$variable,
    literal: $712f170b9f5279d6$var$literal,
    defaultGraph: $712f170b9f5279d6$var$defaultGraph,
    quad: $712f170b9f5279d6$var$quad,
    triple: $712f170b9f5279d6$var$quad
};
var $712f170b9f5279d6$export$2e2bcd8739ae039 = $712f170b9f5279d6$var$DataFactory;
class $712f170b9f5279d6$export$656c1e606ad06131 {
    constructor(id){
        this.id = id;
    }
    // ### The value of this term
    get value() {
        return this.id;
    }
    // ### Returns whether this object represents the same term as the other
    equals(other) {
        // If both terms were created by this library,
        // equality can be computed through ids
        if (other instanceof $712f170b9f5279d6$export$656c1e606ad06131) return this.id === other.id;
        // Otherwise, compare term type and value
        return !!other && this.termType === other.termType && this.value === other.value;
    }
    // ### Implement hashCode for Immutable.js, since we implement `equals`
    // https://immutable-js.com/docs/v4.0.0/ValueObject/#hashCode()
    hashCode() {
        return 0;
    }
    // ### Returns a plain object representation of this term
    toJSON() {
        return {
            termType: this.termType,
            value: this.value
        };
    }
}
class $712f170b9f5279d6$export$e55689a56c4c92c2 extends $712f170b9f5279d6$export$656c1e606ad06131 {
    // ### The term type of this term
    get termType() {
        return "NamedNode";
    }
}
class $712f170b9f5279d6$export$e175ae9e414693bc extends $712f170b9f5279d6$export$656c1e606ad06131 {
    // ### The term type of this term
    get termType() {
        return "Literal";
    }
    // ### The text value of this literal
    get value() {
        return this.id.substring(1, this.id.lastIndexOf('"'));
    }
    // ### The language of this literal
    get language() {
        // Find the last quotation mark (e.g., '"abc"@en-us')
        const id = this.id;
        let atPos = id.lastIndexOf('"') + 1;
        // If "@" it follows, return the remaining substring; empty otherwise
        return atPos < id.length && id[atPos++] === "@" ? id.substr(atPos).toLowerCase() : "";
    }
    // ### The datatype IRI of this literal
    get datatype() {
        return new $712f170b9f5279d6$export$e55689a56c4c92c2(this.datatypeString);
    }
    // ### The datatype string of this literal
    get datatypeString() {
        // Find the last quotation mark (e.g., '"abc"^^http://ex.org/types#t')
        const id = this.id, dtPos = id.lastIndexOf('"') + 1;
        const char = dtPos < id.length ? id[dtPos] : "";
        // If "^" it follows, return the remaining substring
        return char === "^" ? id.substr(dtPos + 2) : // If "@" follows, return rdf:langString; xsd:string otherwise
        char !== "@" ? $712f170b9f5279d6$var$xsd.string : $712f170b9f5279d6$var$rdf.langString;
    }
    // ### Returns whether this object represents the same term as the other
    equals(other) {
        // If both literals were created by this library,
        // equality can be computed through ids
        if (other instanceof $712f170b9f5279d6$export$e175ae9e414693bc) return this.id === other.id;
        // Otherwise, compare term type, value, language, and datatype
        return !!other && !!other.datatype && this.termType === other.termType && this.value === other.value && this.language === other.language && this.datatype.value === other.datatype.value;
    }
    toJSON() {
        return {
            termType: this.termType,
            value: this.value,
            language: this.language,
            datatype: {
                termType: "NamedNode",
                value: this.datatypeString
            }
        };
    }
}
class $712f170b9f5279d6$export$1a8019c085269883 extends $712f170b9f5279d6$export$656c1e606ad06131 {
    constructor(name){
        super(`_:${name}`);
    }
    // ### The term type of this term
    get termType() {
        return "BlankNode";
    }
    // ### The name of this blank node
    get value() {
        return this.id.substr(2);
    }
}
class $712f170b9f5279d6$export$c867a5c9595a1350 extends $712f170b9f5279d6$export$656c1e606ad06131 {
    constructor(name){
        super(`?${name}`);
    }
    // ### The term type of this term
    get termType() {
        return "Variable";
    }
    // ### The name of this variable
    get value() {
        return this.id.substr(1);
    }
}
class $712f170b9f5279d6$export$4383f89a7161b240 extends $712f170b9f5279d6$export$656c1e606ad06131 {
    constructor(){
        super("");
        return $712f170b9f5279d6$var$DEFAULTGRAPH || this;
    }
    // ### The term type of this term
    get termType() {
        return "DefaultGraph";
    }
    // ### Returns whether this object represents the same term as the other
    equals(other) {
        // If both terms were created by this library,
        // equality can be computed through strict equality;
        // otherwise, compare term types.
        return this === other || !!other && this.termType === other.termType;
    }
}
// ## DefaultGraph singleton
$712f170b9f5279d6$var$DEFAULTGRAPH = new $712f170b9f5279d6$export$4383f89a7161b240();
function $712f170b9f5279d6$export$85285e91bbd99cf(id, factory, nested) {
    factory = factory || $712f170b9f5279d6$var$DataFactory;
    // Falsy value or empty string indicate the default graph
    if (!id) return factory.defaultGraph();
    // Identify the term type based on the first character
    switch(id[0]){
        case "?":
            return factory.variable(id.substr(1));
        case "_":
            return factory.blankNode(id.substr(2));
        case '"':
            // Shortcut for internal literals
            if (factory === $712f170b9f5279d6$var$DataFactory) return new $712f170b9f5279d6$export$e175ae9e414693bc(id);
            // Literal without datatype or language
            if (id[id.length - 1] === '"') return factory.literal(id.substr(1, id.length - 2));
            // Literal with datatype or language
            const endPos = id.lastIndexOf('"', id.length - 1);
            return factory.literal(id.substr(1, endPos - 1), id[endPos + 1] === "@" ? id.substr(endPos + 2) : factory.namedNode(id.substr(endPos + 3)));
        case "[":
            id = JSON.parse(id);
            break;
        default:
            if (!nested || !Array.isArray(id)) return factory.namedNode(id);
    }
    return factory.quad($712f170b9f5279d6$export$85285e91bbd99cf(id[0], factory, true), $712f170b9f5279d6$export$85285e91bbd99cf(id[1], factory, true), $712f170b9f5279d6$export$85285e91bbd99cf(id[2], factory, true), id[3] && $712f170b9f5279d6$export$85285e91bbd99cf(id[3], factory, true));
}
function $712f170b9f5279d6$export$fbf03d1179c9227e(term, nested) {
    if (typeof term === "string") return term;
    if (term instanceof $712f170b9f5279d6$export$656c1e606ad06131 && term.termType !== "Quad") return term.id;
    if (!term) return $712f170b9f5279d6$var$DEFAULTGRAPH.id;
    // Term instantiated with another library
    switch(term.termType){
        case "NamedNode":
            return term.value;
        case "BlankNode":
            return `_:${term.value}`;
        case "Variable":
            return `?${term.value}`;
        case "DefaultGraph":
            return "";
        case "Literal":
            return `"${term.value}"${term.language ? `@${term.language}` : term.datatype && term.datatype.value !== $712f170b9f5279d6$var$xsd.string ? `^^${term.datatype.value}` : ""}`;
        case "Quad":
            const res = [
                $712f170b9f5279d6$export$fbf03d1179c9227e(term.subject, true),
                $712f170b9f5279d6$export$fbf03d1179c9227e(term.predicate, true),
                $712f170b9f5279d6$export$fbf03d1179c9227e(term.object, true)
            ];
            if (term.graph && term.graph.termType !== "DefaultGraph") res.push($712f170b9f5279d6$export$fbf03d1179c9227e(term.graph, true));
            return nested ? res : JSON.stringify(res);
        default:
            throw new Error(`Unexpected termType: ${term.termType}`);
    }
}
class $712f170b9f5279d6$export$7005c9eb6671414d extends $712f170b9f5279d6$export$656c1e606ad06131 {
    constructor(subject, predicate, object, graph){
        super("");
        this._subject = subject;
        this._predicate = predicate;
        this._object = object;
        this._graph = graph || $712f170b9f5279d6$var$DEFAULTGRAPH;
    }
    // ### The term type of this term
    get termType() {
        return "Quad";
    }
    get subject() {
        return this._subject;
    }
    get predicate() {
        return this._predicate;
    }
    get object() {
        return this._object;
    }
    get graph() {
        return this._graph;
    }
    // ### Returns a plain object representation of this quad
    toJSON() {
        return {
            termType: this.termType,
            subject: this._subject.toJSON(),
            predicate: this._predicate.toJSON(),
            object: this._object.toJSON(),
            graph: this._graph.toJSON()
        };
    }
    // ### Returns whether this object represents the same quad as the other
    equals(other) {
        return !!other && this._subject.equals(other.subject) && this._predicate.equals(other.predicate) && this._object.equals(other.object) && this._graph.equals(other.graph);
    }
}
function $712f170b9f5279d6$export$3ff8cecf0aa87c28(id) {
    return id.replace($712f170b9f5279d6$var$escapedLiteral, (_, quoted)=>`"${quoted.replace(/"/g, '""')}`);
}
function $712f170b9f5279d6$export$7cedbcd33d1bf915(id) {
    return id.replace($712f170b9f5279d6$var$escapedLiteral, (_, quoted)=>`"${quoted.replace(/""/g, '"')}`);
}
// ### Creates an IRI
function $712f170b9f5279d6$var$namedNode(iri) {
    return new $712f170b9f5279d6$export$e55689a56c4c92c2(iri);
}
// ### Creates a blank node
function $712f170b9f5279d6$var$blankNode(name) {
    return new $712f170b9f5279d6$export$1a8019c085269883(name || `n3-${$712f170b9f5279d6$var$_blankNodeCounter++}`);
}
// ### Creates a literal
function $712f170b9f5279d6$var$literal(value, languageOrDataType) {
    // Create a language-tagged string
    if (typeof languageOrDataType === "string") return new $712f170b9f5279d6$export$e175ae9e414693bc(`"${value}"@${languageOrDataType.toLowerCase()}`);
    // Automatically determine datatype for booleans and numbers
    let datatype = languageOrDataType ? languageOrDataType.value : "";
    if (datatype === "") {
        // Convert a boolean
        if (typeof value === "boolean") datatype = $712f170b9f5279d6$var$xsd.boolean;
        else if (typeof value === "number") {
            if (Number.isFinite(value)) datatype = Number.isInteger(value) ? $712f170b9f5279d6$var$xsd.integer : $712f170b9f5279d6$var$xsd.double;
            else {
                datatype = $712f170b9f5279d6$var$xsd.double;
                if (!Number.isNaN(value)) value = value > 0 ? "INF" : "-INF";
            }
        }
    }
    // Create a datatyped literal
    return datatype === "" || datatype === $712f170b9f5279d6$var$xsd.string ? new $712f170b9f5279d6$export$e175ae9e414693bc(`"${value}"`) : new $712f170b9f5279d6$export$e175ae9e414693bc(`"${value}"^^${datatype}`);
}
// ### Creates a variable
function $712f170b9f5279d6$var$variable(name) {
    return new $712f170b9f5279d6$export$c867a5c9595a1350(name);
}
// ### Returns the default graph
function $712f170b9f5279d6$var$defaultGraph() {
    return $712f170b9f5279d6$var$DEFAULTGRAPH;
}
// ### Creates a quad
function $712f170b9f5279d6$var$quad(subject, predicate, object, graph) {
    return new $712f170b9f5279d6$export$7005c9eb6671414d(subject, predicate, object, graph);
}



let $c0715e6442e25456$var$blankNodePrefix = 0;
class $c0715e6442e25456$export$2e2bcd8739ae039 {
    constructor(options){
        this._contextStack = [];
        this._graph = null;
        // Set the document IRI
        options = options || {};
        this._setBase(options.baseIRI);
        options.factory && $c0715e6442e25456$var$initDataFactory(this, options.factory);
        // Set supported features depending on the format
        const format = typeof options.format === "string" ? options.format.match(/\w*$/)[0].toLowerCase() : "", isTurtle = /turtle/.test(format), isTriG = /trig/.test(format), isNTriples = /triple/.test(format), isNQuads = /quad/.test(format), isN3 = this._n3Mode = /n3/.test(format), isLineMode = isNTriples || isNQuads;
        if (!(this._supportsNamedGraphs = !(isTurtle || isN3))) this._readPredicateOrNamedGraph = this._readPredicate;
        // Support triples in other graphs
        this._supportsQuads = !(isTurtle || isTriG || isNTriples || isN3);
        // Support nesting of triples
        this._supportsRDFStar = format === "" || /star|\*$/.test(format);
        // Disable relative IRIs in N-Triples or N-Quads mode
        if (isLineMode) this._resolveRelativeIRI = (iri)=>{
            return null;
        };
        this._blankNodePrefix = typeof options.blankNodePrefix !== "string" ? "" : options.blankNodePrefix.replace(/^(?!_:)/, "_:");
        this._lexer = options.lexer || new (0, $c66a9a29d2de1131$export$2e2bcd8739ae039)({
            lineMode: isLineMode,
            n3: isN3
        });
        // Disable explicit quantifiers by default
        this._explicitQuantifiers = !!options.explicitQuantifiers;
    }
    // ## Static class methods
    // ### `_resetBlankNodePrefix` restarts blank node prefix identification
    static _resetBlankNodePrefix() {
        $c0715e6442e25456$var$blankNodePrefix = 0;
    }
    // ## Private methods
    // ### `_setBase` sets the base IRI to resolve relative IRIs
    _setBase(baseIRI) {
        if (!baseIRI) {
            this._base = "";
            this._basePath = "";
        } else {
            // Remove fragment if present
            const fragmentPos = baseIRI.indexOf("#");
            if (fragmentPos >= 0) baseIRI = baseIRI.substr(0, fragmentPos);
            // Set base IRI and its components
            this._base = baseIRI;
            this._basePath = baseIRI.indexOf("/") < 0 ? baseIRI : baseIRI.replace(/[^\/?]*(?:\?.*)?$/, "");
            baseIRI = baseIRI.match(/^(?:([a-z][a-z0-9+.-]*:))?(?:\/\/[^\/]*)?/i);
            this._baseRoot = baseIRI[0];
            this._baseScheme = baseIRI[1];
        }
    }
    // ### `_saveContext` stores the current parsing context
    // when entering a new scope (list, blank node, formula)
    _saveContext(type, graph, subject, predicate, object) {
        const n3Mode = this._n3Mode;
        this._contextStack.push({
            type: type,
            subject: subject,
            predicate: predicate,
            object: object,
            graph: graph,
            inverse: n3Mode ? this._inversePredicate : false,
            blankPrefix: n3Mode ? this._prefixes._ : "",
            quantified: n3Mode ? this._quantified : null
        });
        // The settings below only apply to N3 streams
        if (n3Mode) {
            // Every new scope resets the predicate direction
            this._inversePredicate = false;
            // In N3, blank nodes are scoped to a formula
            // (using a dot as separator, as a blank node label cannot start with it)
            this._prefixes._ = this._graph ? `${this._graph.value}.` : ".";
            // Quantifiers are scoped to a formula
            this._quantified = Object.create(this._quantified);
        }
    }
    // ### `_restoreContext` restores the parent context
    // when leaving a scope (list, blank node, formula)
    _restoreContext(type, token) {
        // Obtain the previous context
        const context = this._contextStack.pop();
        if (!context || context.type !== type) return this._error(`Unexpected ${token.type}`, token);
        // Restore the quad of the previous context
        this._subject = context.subject;
        this._predicate = context.predicate;
        this._object = context.object;
        this._graph = context.graph;
        // Restore N3 context settings
        if (this._n3Mode) {
            this._inversePredicate = context.inverse;
            this._prefixes._ = context.blankPrefix;
            this._quantified = context.quantified;
        }
    }
    // ### `_readInTopContext` reads a token when in the top context
    _readInTopContext(token) {
        switch(token.type){
            // If an EOF token arrives in the top context, signal that we're done
            case "eof":
                if (this._graph !== null) return this._error("Unclosed graph", token);
                delete this._prefixes._;
                return this._callback(null, null, this._prefixes);
            // It could be a prefix declaration
            case "PREFIX":
                this._sparqlStyle = true;
            case "@prefix":
                return this._readPrefix;
            // It could be a base declaration
            case "BASE":
                this._sparqlStyle = true;
            case "@base":
                return this._readBaseIRI;
            // It could be a graph
            case "{":
                if (this._supportsNamedGraphs) {
                    this._graph = "";
                    this._subject = null;
                    return this._readSubject;
                }
            case "GRAPH":
                if (this._supportsNamedGraphs) return this._readNamedGraphLabel;
            // Otherwise, the next token must be a subject
            default:
                return this._readSubject(token);
        }
    }
    // ### `_readEntity` reads an IRI, prefixed name, blank node, or variable
    _readEntity(token, quantifier) {
        let value;
        switch(token.type){
            // Read a relative or absolute IRI
            case "IRI":
            case "typeIRI":
                const iri = this._resolveIRI(token.value);
                if (iri === null) return this._error("Invalid IRI", token);
                value = this._namedNode(iri);
                break;
            // Read a prefixed name
            case "type":
            case "prefixed":
                const prefix = this._prefixes[token.prefix];
                if (prefix === undefined) return this._error(`Undefined prefix "${token.prefix}:"`, token);
                value = this._namedNode(prefix + token.value);
                break;
            // Read a blank node
            case "blank":
                value = this._blankNode(this._prefixes[token.prefix] + token.value);
                break;
            // Read a variable
            case "var":
                value = this._variable(token.value.substr(1));
                break;
            // Everything else is not an entity
            default:
                return this._error(`Expected entity but got ${token.type}`, token);
        }
        // In N3 mode, replace the entity if it is quantified
        if (!quantifier && this._n3Mode && value.id in this._quantified) value = this._quantified[value.id];
        return value;
    }
    // ### `_readSubject` reads a quad's subject
    _readSubject(token) {
        this._predicate = null;
        switch(token.type){
            case "[":
                // Start a new quad with a new blank node as subject
                this._saveContext("blank", this._graph, this._subject = this._blankNode(), null, null);
                return this._readBlankNodeHead;
            case "(":
                // Start a new list
                this._saveContext("list", this._graph, this.RDF_NIL, null, null);
                this._subject = null;
                return this._readListItem;
            case "{":
                // Start a new formula
                if (!this._n3Mode) return this._error("Unexpected graph", token);
                this._saveContext("formula", this._graph, this._graph = this._blankNode(), null, null);
                return this._readSubject;
            case "}":
                // No subject; the graph in which we are reading is closed instead
                return this._readPunctuation(token);
            case "@forSome":
                if (!this._n3Mode) return this._error('Unexpected "@forSome"', token);
                this._subject = null;
                this._predicate = this.N3_FORSOME;
                this._quantifier = this._blankNode;
                return this._readQuantifierList;
            case "@forAll":
                if (!this._n3Mode) return this._error('Unexpected "@forAll"', token);
                this._subject = null;
                this._predicate = this.N3_FORALL;
                this._quantifier = this._variable;
                return this._readQuantifierList;
            case "literal":
                if (!this._n3Mode) return this._error("Unexpected literal", token);
                if (token.prefix.length === 0) {
                    this._literalValue = token.value;
                    return this._completeSubjectLiteral;
                } else this._subject = this._literal(token.value, this._namedNode(token.prefix));
                break;
            case "<<":
                if (!this._supportsRDFStar) return this._error("Unexpected RDF* syntax", token);
                this._saveContext("<<", this._graph, null, null, null);
                this._graph = null;
                return this._readSubject;
            default:
                // Read the subject entity
                if ((this._subject = this._readEntity(token)) === undefined) return;
                // In N3 mode, the subject might be a path
                if (this._n3Mode) return this._getPathReader(this._readPredicateOrNamedGraph);
        }
        // The next token must be a predicate,
        // or, if the subject was actually a graph IRI, a named graph
        return this._readPredicateOrNamedGraph;
    }
    // ### `_readPredicate` reads a quad's predicate
    _readPredicate(token) {
        const type = token.type;
        switch(type){
            case "inverse":
                this._inversePredicate = true;
            case "abbreviation":
                this._predicate = this.ABBREVIATIONS[token.value];
                break;
            case ".":
            case "]":
            case "}":
                // Expected predicate didn't come, must have been trailing semicolon
                if (this._predicate === null) return this._error(`Unexpected ${type}`, token);
                this._subject = null;
                return type === "]" ? this._readBlankNodeTail(token) : this._readPunctuation(token);
            case ";":
                // Additional semicolons can be safely ignored
                return this._predicate !== null ? this._readPredicate : this._error("Expected predicate but got ;", token);
            case "[":
                if (this._n3Mode) {
                    // Start a new quad with a new blank node as subject
                    this._saveContext("blank", this._graph, this._subject, this._subject = this._blankNode(), null);
                    return this._readBlankNodeHead;
                }
            case "blank":
                if (!this._n3Mode) return this._error("Disallowed blank node as predicate", token);
            default:
                if ((this._predicate = this._readEntity(token)) === undefined) return;
        }
        // The next token must be an object
        return this._readObject;
    }
    // ### `_readObject` reads a quad's object
    _readObject(token) {
        switch(token.type){
            case "literal":
                // Regular literal, can still get a datatype or language
                if (token.prefix.length === 0) {
                    this._literalValue = token.value;
                    return this._readDataTypeOrLang;
                } else this._object = this._literal(token.value, this._namedNode(token.prefix));
                break;
            case "[":
                // Start a new quad with a new blank node as subject
                this._saveContext("blank", this._graph, this._subject, this._predicate, this._subject = this._blankNode());
                return this._readBlankNodeHead;
            case "(":
                // Start a new list
                this._saveContext("list", this._graph, this._subject, this._predicate, this.RDF_NIL);
                this._subject = null;
                return this._readListItem;
            case "{":
                // Start a new formula
                if (!this._n3Mode) return this._error("Unexpected graph", token);
                this._saveContext("formula", this._graph, this._subject, this._predicate, this._graph = this._blankNode());
                return this._readSubject;
            case "<<":
                if (!this._supportsRDFStar) return this._error("Unexpected RDF* syntax", token);
                this._saveContext("<<", this._graph, this._subject, this._predicate, null);
                this._graph = null;
                return this._readSubject;
            default:
                // Read the object entity
                if ((this._object = this._readEntity(token)) === undefined) return;
                // In N3 mode, the object might be a path
                if (this._n3Mode) return this._getPathReader(this._getContextEndReader());
        }
        return this._getContextEndReader();
    }
    // ### `_readPredicateOrNamedGraph` reads a quad's predicate, or a named graph
    _readPredicateOrNamedGraph(token) {
        return token.type === "{" ? this._readGraph(token) : this._readPredicate(token);
    }
    // ### `_readGraph` reads a graph
    _readGraph(token) {
        if (token.type !== "{") return this._error(`Expected graph but got ${token.type}`, token);
        // The "subject" we read is actually the GRAPH's label
        this._graph = this._subject, this._subject = null;
        return this._readSubject;
    }
    // ### `_readBlankNodeHead` reads the head of a blank node
    _readBlankNodeHead(token) {
        if (token.type === "]") {
            this._subject = null;
            return this._readBlankNodeTail(token);
        } else {
            this._predicate = null;
            return this._readPredicate(token);
        }
    }
    // ### `_readBlankNodeTail` reads the end of a blank node
    _readBlankNodeTail(token) {
        if (token.type !== "]") return this._readBlankNodePunctuation(token);
        // Store blank node quad
        if (this._subject !== null) this._emit(this._subject, this._predicate, this._object, this._graph);
        // Restore the parent context containing this blank node
        const empty = this._predicate === null;
        this._restoreContext("blank", token);
        // If the blank node was the object, restore previous context and read punctuation
        if (this._object !== null) return this._getContextEndReader();
        else if (this._predicate !== null) return this._readObject;
        else // If the blank node was empty, it could be a named graph label
        return empty ? this._readPredicateOrNamedGraph : this._readPredicateAfterBlank;
    }
    // ### `_readPredicateAfterBlank` reads a predicate after an anonymous blank node
    _readPredicateAfterBlank(token) {
        switch(token.type){
            case ".":
            case "}":
                // No predicate is coming if the triple is terminated here
                this._subject = null;
                return this._readPunctuation(token);
            default:
                return this._readPredicate(token);
        }
    }
    // ### `_readListItem` reads items from a list
    _readListItem(token) {
        let item = null, list = null, next = this._readListItem; // The next function to execute
        const previousList = this._subject, stack = this._contextStack, parent = stack[stack.length - 1]; // The parent containing the current list
        switch(token.type){
            case "[":
                // Stack the current list quad and start a new quad with a blank node as subject
                this._saveContext("blank", this._graph, list = this._blankNode(), this.RDF_FIRST, this._subject = item = this._blankNode());
                next = this._readBlankNodeHead;
                break;
            case "(":
                // Stack the current list quad and start a new list
                this._saveContext("list", this._graph, list = this._blankNode(), this.RDF_FIRST, this.RDF_NIL);
                this._subject = null;
                break;
            case ")":
                // Closing the list; restore the parent context
                this._restoreContext("list", token);
                // If this list is contained within a parent list, return the membership quad here.
                // This will be `<parent list element> rdf:first <this list>.`.
                if (stack.length !== 0 && stack[stack.length - 1].type === "list") this._emit(this._subject, this._predicate, this._object, this._graph);
                // Was this list the parent's subject?
                if (this._predicate === null) {
                    // The next token is the predicate
                    next = this._readPredicate;
                    // No list tail if this was an empty list
                    if (this._subject === this.RDF_NIL) return next;
                } else {
                    next = this._getContextEndReader();
                    // No list tail if this was an empty list
                    if (this._object === this.RDF_NIL) return next;
                }
                // Close the list by making the head nil
                list = this.RDF_NIL;
                break;
            case "literal":
                // Regular literal, can still get a datatype or language
                if (token.prefix.length === 0) {
                    this._literalValue = token.value;
                    next = this._readListItemDataTypeOrLang;
                } else {
                    item = this._literal(token.value, this._namedNode(token.prefix));
                    next = this._getContextEndReader();
                }
                break;
            case "{":
                // Start a new formula
                if (!this._n3Mode) return this._error("Unexpected graph", token);
                this._saveContext("formula", this._graph, this._subject, this._predicate, this._graph = this._blankNode());
                return this._readSubject;
            default:
                if ((item = this._readEntity(token)) === undefined) return;
        }
        // Create a new blank node if no item head was assigned yet
        if (list === null) this._subject = list = this._blankNode();
        // Is this the first element of the list?
        if (previousList === null) {
            // This list is either the subject or the object of its parent
            if (parent.predicate === null) parent.subject = list;
            else parent.object = list;
        } else // Continue the previous list with the current list
        this._emit(previousList, this.RDF_REST, list, this._graph);
        // If an item was read, add it to the list
        if (item !== null) {
            // In N3 mode, the item might be a path
            if (this._n3Mode && (token.type === "IRI" || token.type === "prefixed")) {
                // Create a new context to add the item's path
                this._saveContext("item", this._graph, list, this.RDF_FIRST, item);
                this._subject = item, this._predicate = null;
                // _readPath will restore the context and output the item
                return this._getPathReader(this._readListItem);
            }
            // Output the item
            this._emit(list, this.RDF_FIRST, item, this._graph);
        }
        return next;
    }
    // ### `_readDataTypeOrLang` reads an _optional_ datatype or language
    _readDataTypeOrLang(token) {
        return this._completeObjectLiteral(token, false);
    }
    // ### `_readListItemDataTypeOrLang` reads an _optional_ datatype or language in a list
    _readListItemDataTypeOrLang(token) {
        return this._completeObjectLiteral(token, true);
    }
    // ### `_completeLiteral` completes a literal with an optional datatype or language
    _completeLiteral(token) {
        // Create a simple string literal by default
        let literal = this._literal(this._literalValue);
        switch(token.type){
            // Create a datatyped literal
            case "type":
            case "typeIRI":
                const datatype = this._readEntity(token);
                if (datatype === undefined) return; // No datatype means an error occurred
                literal = this._literal(this._literalValue, datatype);
                token = null;
                break;
            // Create a language-tagged string
            case "langcode":
                literal = this._literal(this._literalValue, token.value);
                token = null;
                break;
        }
        return {
            token: token,
            literal: literal
        };
    }
    // Completes a literal in subject position
    _completeSubjectLiteral(token) {
        this._subject = this._completeLiteral(token).literal;
        return this._readPredicateOrNamedGraph;
    }
    // Completes a literal in object position
    _completeObjectLiteral(token, listItem) {
        const completed = this._completeLiteral(token);
        if (!completed) return;
        this._object = completed.literal;
        // If this literal was part of a list, write the item
        // (we could also check the context stack, but passing in a flag is faster)
        if (listItem) this._emit(this._subject, this.RDF_FIRST, this._object, this._graph);
        // If the token was consumed, continue with the rest of the input
        if (completed.token === null) return this._getContextEndReader();
        else {
            this._readCallback = this._getContextEndReader();
            return this._readCallback(completed.token);
        }
    }
    // ### `_readFormulaTail` reads the end of a formula
    _readFormulaTail(token) {
        if (token.type !== "}") return this._readPunctuation(token);
        // Store the last quad of the formula
        if (this._subject !== null) this._emit(this._subject, this._predicate, this._object, this._graph);
        // Restore the parent context containing this formula
        this._restoreContext("formula", token);
        // If the formula was the subject, continue reading the predicate.
        // If the formula was the object, read punctuation.
        return this._object === null ? this._readPredicate : this._getContextEndReader();
    }
    // ### `_readPunctuation` reads punctuation between quads or quad parts
    _readPunctuation(token) {
        let next, graph = this._graph;
        const subject = this._subject, inversePredicate = this._inversePredicate;
        switch(token.type){
            // A closing brace ends a graph
            case "}":
                if (this._graph === null) return this._error("Unexpected graph closing", token);
                if (this._n3Mode) return this._readFormulaTail(token);
                this._graph = null;
            // A dot just ends the statement, without sharing anything with the next
            case ".":
                this._subject = null;
                next = this._contextStack.length ? this._readSubject : this._readInTopContext;
                if (inversePredicate) this._inversePredicate = false;
                break;
            // Semicolon means the subject is shared; predicate and object are different
            case ";":
                next = this._readPredicate;
                break;
            // Comma means both the subject and predicate are shared; the object is different
            case ",":
                next = this._readObject;
                break;
            // {| means that the current triple is annotated with predicate-object pairs.
            case "{|":
                if (!this._supportsRDFStar) return this._error("Unexpected RDF* syntax", token);
                // Continue using the last triple as quoted triple subject for the predicate-object pairs.
                const predicate = this._predicate, object = this._object;
                this._subject = this._quad(subject, predicate, object, this.DEFAULTGRAPH);
                next = this._readPredicate;
                break;
            // |} means that the current quoted triple in annotation syntax is finalized.
            case "|}":
                if (this._subject.termType !== "Quad") return this._error("Unexpected asserted triple closing", token);
                this._subject = null;
                next = this._readPunctuation;
                break;
            default:
                // An entity means this is a quad (only allowed if not already inside a graph)
                if (this._supportsQuads && this._graph === null && (graph = this._readEntity(token)) !== undefined) {
                    next = this._readQuadPunctuation;
                    break;
                }
                return this._error(`Expected punctuation to follow "${this._object.id}"`, token);
        }
        // A quad has been completed now, so return it
        if (subject !== null) {
            const predicate = this._predicate, object = this._object;
            if (!inversePredicate) this._emit(subject, predicate, object, graph);
            else this._emit(object, predicate, subject, graph);
        }
        return next;
    }
    // ### `_readBlankNodePunctuation` reads punctuation in a blank node
    _readBlankNodePunctuation(token) {
        let next;
        switch(token.type){
            // Semicolon means the subject is shared; predicate and object are different
            case ";":
                next = this._readPredicate;
                break;
            // Comma means both the subject and predicate are shared; the object is different
            case ",":
                next = this._readObject;
                break;
            default:
                return this._error(`Expected punctuation to follow "${this._object.id}"`, token);
        }
        // A quad has been completed now, so return it
        this._emit(this._subject, this._predicate, this._object, this._graph);
        return next;
    }
    // ### `_readQuadPunctuation` reads punctuation after a quad
    _readQuadPunctuation(token) {
        if (token.type !== ".") return this._error("Expected dot to follow quad", token);
        return this._readInTopContext;
    }
    // ### `_readPrefix` reads the prefix of a prefix declaration
    _readPrefix(token) {
        if (token.type !== "prefix") return this._error("Expected prefix to follow @prefix", token);
        this._prefix = token.value;
        return this._readPrefixIRI;
    }
    // ### `_readPrefixIRI` reads the IRI of a prefix declaration
    _readPrefixIRI(token) {
        if (token.type !== "IRI") return this._error(`Expected IRI to follow prefix "${this._prefix}:"`, token);
        const prefixNode = this._readEntity(token);
        this._prefixes[this._prefix] = prefixNode.value;
        this._prefixCallback(this._prefix, prefixNode);
        return this._readDeclarationPunctuation;
    }
    // ### `_readBaseIRI` reads the IRI of a base declaration
    _readBaseIRI(token) {
        const iri = token.type === "IRI" && this._resolveIRI(token.value);
        if (!iri) return this._error("Expected valid IRI to follow base declaration", token);
        this._setBase(iri);
        return this._readDeclarationPunctuation;
    }
    // ### `_readNamedGraphLabel` reads the label of a named graph
    _readNamedGraphLabel(token) {
        switch(token.type){
            case "IRI":
            case "blank":
            case "prefixed":
                return this._readSubject(token), this._readGraph;
            case "[":
                return this._readNamedGraphBlankLabel;
            default:
                return this._error("Invalid graph label", token);
        }
    }
    // ### `_readNamedGraphLabel` reads a blank node label of a named graph
    _readNamedGraphBlankLabel(token) {
        if (token.type !== "]") return this._error("Invalid graph label", token);
        this._subject = this._blankNode();
        return this._readGraph;
    }
    // ### `_readDeclarationPunctuation` reads the punctuation of a declaration
    _readDeclarationPunctuation(token) {
        // SPARQL-style declarations don't have punctuation
        if (this._sparqlStyle) {
            this._sparqlStyle = false;
            return this._readInTopContext(token);
        }
        if (token.type !== ".") return this._error("Expected declaration to end with a dot", token);
        return this._readInTopContext;
    }
    // Reads a list of quantified symbols from a @forSome or @forAll statement
    _readQuantifierList(token) {
        let entity;
        switch(token.type){
            case "IRI":
            case "prefixed":
                if ((entity = this._readEntity(token, true)) !== undefined) break;
            default:
                return this._error(`Unexpected ${token.type}`, token);
        }
        // Without explicit quantifiers, map entities to a quantified entity
        if (!this._explicitQuantifiers) this._quantified[entity.id] = this._quantifier(this._blankNode().value);
        else {
            // If this is the first item, start a new quantifier list
            if (this._subject === null) this._emit(this._graph || this.DEFAULTGRAPH, this._predicate, this._subject = this._blankNode(), this.QUANTIFIERS_GRAPH);
            else this._emit(this._subject, this.RDF_REST, this._subject = this._blankNode(), this.QUANTIFIERS_GRAPH);
            // Output the list item
            this._emit(this._subject, this.RDF_FIRST, entity, this.QUANTIFIERS_GRAPH);
        }
        return this._readQuantifierPunctuation;
    }
    // Reads punctuation from a @forSome or @forAll statement
    _readQuantifierPunctuation(token) {
        // Read more quantifiers
        if (token.type === ",") return this._readQuantifierList;
        else {
            // With explicit quantifiers, close the quantifier list
            if (this._explicitQuantifiers) {
                this._emit(this._subject, this.RDF_REST, this.RDF_NIL, this.QUANTIFIERS_GRAPH);
                this._subject = null;
            }
            // Read a dot
            this._readCallback = this._getContextEndReader();
            return this._readCallback(token);
        }
    }
    // ### `_getPathReader` reads a potential path and then resumes with the given function
    _getPathReader(afterPath) {
        this._afterPath = afterPath;
        return this._readPath;
    }
    // ### `_readPath` reads a potential path
    _readPath(token) {
        switch(token.type){
            // Forward path
            case "!":
                return this._readForwardPath;
            // Backward path
            case "^":
                return this._readBackwardPath;
            // Not a path; resume reading where we left off
            default:
                const stack = this._contextStack, parent = stack.length && stack[stack.length - 1];
                // If we were reading a list item, we still need to output it
                if (parent && parent.type === "item") {
                    // The list item is the remaining subejct after reading the path
                    const item = this._subject;
                    // Switch back to the context of the list
                    this._restoreContext("item", token);
                    // Output the list item
                    this._emit(this._subject, this.RDF_FIRST, item, this._graph);
                }
                return this._afterPath(token);
        }
    }
    // ### `_readForwardPath` reads a '!' path
    _readForwardPath(token) {
        let subject, predicate;
        const object = this._blankNode();
        // The next token is the predicate
        if ((predicate = this._readEntity(token)) === undefined) return;
        // If we were reading a subject, replace the subject by the path's object
        if (this._predicate === null) subject = this._subject, this._subject = object;
        else subject = this._object, this._object = object;
        // Emit the path's current quad and read its next section
        this._emit(subject, predicate, object, this._graph);
        return this._readPath;
    }
    // ### `_readBackwardPath` reads a '^' path
    _readBackwardPath(token) {
        const subject = this._blankNode();
        let predicate, object;
        // The next token is the predicate
        if ((predicate = this._readEntity(token)) === undefined) return;
        // If we were reading a subject, replace the subject by the path's subject
        if (this._predicate === null) object = this._subject, this._subject = subject;
        else object = this._object, this._object = subject;
        // Emit the path's current quad and read its next section
        this._emit(subject, predicate, object, this._graph);
        return this._readPath;
    }
    // ### `_readRDFStarTailOrGraph` reads the graph of a nested RDF* quad or the end of a nested RDF* triple
    _readRDFStarTailOrGraph(token) {
        if (token.type !== ">>") {
            // An entity means this is a quad (only allowed if not already inside a graph)
            if (this._supportsQuads && this._graph === null && (this._graph = this._readEntity(token)) !== undefined) return this._readRDFStarTail;
            return this._error(`Expected >> to follow "${this._object.id}"`, token);
        }
        return this._readRDFStarTail(token);
    }
    // ### `_readRDFStarTail` reads the end of a nested RDF* triple
    _readRDFStarTail(token) {
        if (token.type !== ">>") return this._error(`Expected >> but got ${token.type}`, token);
        // Read the quad and restore the previous context
        const quad = this._quad(this._subject, this._predicate, this._object, this._graph || this.DEFAULTGRAPH);
        this._restoreContext("<<", token);
        // If the triple was the subject, continue by reading the predicate.
        if (this._subject === null) {
            this._subject = quad;
            return this._readPredicate;
        } else {
            this._object = quad;
            return this._getContextEndReader();
        }
    }
    // ### `_getContextEndReader` gets the next reader function at the end of a context
    _getContextEndReader() {
        const contextStack = this._contextStack;
        if (!contextStack.length) return this._readPunctuation;
        switch(contextStack[contextStack.length - 1].type){
            case "blank":
                return this._readBlankNodeTail;
            case "list":
                return this._readListItem;
            case "formula":
                return this._readFormulaTail;
            case "<<":
                return this._readRDFStarTailOrGraph;
        }
    }
    // ### `_emit` sends a quad through the callback
    _emit(subject, predicate, object, graph) {
        this._callback(null, this._quad(subject, predicate, object, graph || this.DEFAULTGRAPH));
    }
    // ### `_error` emits an error message through the callback
    _error(message, token) {
        const err = new Error(`${message} on line ${token.line}.`);
        err.context = {
            token: token,
            line: token.line,
            previousToken: this._lexer.previousToken
        };
        this._callback(err);
        this._callback = $c0715e6442e25456$var$noop;
    }
    // ### `_resolveIRI` resolves an IRI against the base path
    _resolveIRI(iri) {
        return /^[a-z][a-z0-9+.-]*:/i.test(iri) ? iri : this._resolveRelativeIRI(iri);
    }
    // ### `_resolveRelativeIRI` resolves an IRI against the base path,
    // assuming that a base path has been set and that the IRI is indeed relative
    _resolveRelativeIRI(iri) {
        // An empty relative IRI indicates the base IRI
        if (!iri.length) return this._base;
        // Decide resolving strategy based in the first character
        switch(iri[0]){
            // Resolve relative fragment IRIs against the base IRI
            case "#":
                return this._base + iri;
            // Resolve relative query string IRIs by replacing the query string
            case "?":
                return this._base.replace(/(?:\?.*)?$/, iri);
            // Resolve root-relative IRIs at the root of the base IRI
            case "/":
                // Resolve scheme-relative IRIs to the scheme
                return (iri[1] === "/" ? this._baseScheme : this._baseRoot) + this._removeDotSegments(iri);
            // Resolve all other IRIs at the base IRI's path
            default:
                // Relative IRIs cannot contain a colon in the first path segment
                return /^[^/:]*:/.test(iri) ? null : this._removeDotSegments(this._basePath + iri);
        }
    }
    // ### `_removeDotSegments` resolves './' and '../' path segments in an IRI as per RFC3986
    _removeDotSegments(iri) {
        // Don't modify the IRI if it does not contain any dot segments
        if (!/(^|\/)\.\.?($|[/#?])/.test(iri)) return iri;
        // Start with an imaginary slash before the IRI in order to resolve trailing './' and '../'
        const length = iri.length;
        let result = "", i = -1, pathStart = -1, segmentStart = 0, next = "/";
        while(i < length){
            switch(next){
                // The path starts with the first slash after the authority
                case ":":
                    if (pathStart < 0) {
                        // Skip two slashes before the authority
                        if (iri[++i] === "/" && iri[++i] === "/") // Skip to slash after the authority
                        while((pathStart = i + 1) < length && iri[pathStart] !== "/")i = pathStart;
                    }
                    break;
                // Don't modify a query string or fragment
                case "?":
                case "#":
                    i = length;
                    break;
                // Handle '/.' or '/..' path segments
                case "/":
                    if (iri[i + 1] === ".") {
                        next = iri[++i + 1];
                        switch(next){
                            // Remove a '/.' segment
                            case "/":
                                result += iri.substring(segmentStart, i - 1);
                                segmentStart = i + 1;
                                break;
                            // Remove a trailing '/.' segment
                            case undefined:
                            case "?":
                            case "#":
                                return result + iri.substring(segmentStart, i) + iri.substr(i + 1);
                            // Remove a '/..' segment
                            case ".":
                                next = iri[++i + 1];
                                if (next === undefined || next === "/" || next === "?" || next === "#") {
                                    result += iri.substring(segmentStart, i - 2);
                                    // Try to remove the parent path from result
                                    if ((segmentStart = result.lastIndexOf("/")) >= pathStart) result = result.substr(0, segmentStart);
                                    // Remove a trailing '/..' segment
                                    if (next !== "/") return `${result}/${iri.substr(i + 1)}`;
                                    segmentStart = i + 1;
                                }
                        }
                    }
            }
            next = iri[++i];
        }
        return result + iri.substring(segmentStart);
    }
    // ## Public methods
    // ### `parse` parses the N3 input and emits each parsed quad through the callback
    parse(input, quadCallback, prefixCallback) {
        // The read callback is the next function to be executed when a token arrives.
        // We start reading in the top context.
        this._readCallback = this._readInTopContext;
        this._sparqlStyle = false;
        this._prefixes = Object.create(null);
        this._prefixes._ = this._blankNodePrefix ? this._blankNodePrefix.substr(2) : `b${$c0715e6442e25456$var$blankNodePrefix++}_`;
        this._prefixCallback = prefixCallback || $c0715e6442e25456$var$noop;
        this._inversePredicate = false;
        this._quantified = Object.create(null);
        // Parse synchronously if no quad callback is given
        if (!quadCallback) {
            const quads = [];
            let error;
            this._callback = (e, t)=>{
                e ? error = e : t && quads.push(t);
            };
            this._lexer.tokenize(input).every((token)=>{
                return this._readCallback = this._readCallback(token);
            });
            if (error) throw error;
            return quads;
        }
        // Parse asynchronously otherwise, executing the read callback when a token arrives
        this._callback = quadCallback;
        this._lexer.tokenize(input, (error, token)=>{
            if (error !== null) this._callback(error), this._callback = $c0715e6442e25456$var$noop;
            else if (this._readCallback) this._readCallback = this._readCallback(token);
        });
    }
}
// The empty function
function $c0715e6442e25456$var$noop() {}
// Initializes the parser with the given data factory
function $c0715e6442e25456$var$initDataFactory(parser, factory) {
    // Set factory methods
    const namedNode = factory.namedNode;
    parser._namedNode = namedNode;
    parser._blankNode = factory.blankNode;
    parser._literal = factory.literal;
    parser._variable = factory.variable;
    parser._quad = factory.quad;
    parser.DEFAULTGRAPH = factory.defaultGraph();
    // Set common named nodes
    parser.RDF_FIRST = namedNode((0, $b50e49a75dcd9196$export$2e2bcd8739ae039).rdf.first);
    parser.RDF_REST = namedNode((0, $b50e49a75dcd9196$export$2e2bcd8739ae039).rdf.rest);
    parser.RDF_NIL = namedNode((0, $b50e49a75dcd9196$export$2e2bcd8739ae039).rdf.nil);
    parser.N3_FORALL = namedNode((0, $b50e49a75dcd9196$export$2e2bcd8739ae039).r.forAll);
    parser.N3_FORSOME = namedNode((0, $b50e49a75dcd9196$export$2e2bcd8739ae039).r.forSome);
    parser.ABBREVIATIONS = {
        "a": namedNode((0, $b50e49a75dcd9196$export$2e2bcd8739ae039).rdf.type),
        "=": namedNode((0, $b50e49a75dcd9196$export$2e2bcd8739ae039).owl.sameAs),
        ">": namedNode((0, $b50e49a75dcd9196$export$2e2bcd8739ae039).log.implies)
    };
    parser.QUANTIFIERS_GRAPH = namedNode("urn:n3:quantifiers");
}
$c0715e6442e25456$var$initDataFactory($c0715e6442e25456$export$2e2bcd8739ae039.prototype, (0, $712f170b9f5279d6$export$2e2bcd8739ae039));


// **N3Writer** writes N3 documents.


var $d33ba30d5e9a7819$exports = {};

$parcel$export($d33ba30d5e9a7819$exports, "isNamedNode", () => $d33ba30d5e9a7819$export$10490ce738f72284);
$parcel$export($d33ba30d5e9a7819$exports, "isBlankNode", () => $d33ba30d5e9a7819$export$7b5b4967656acaac);
$parcel$export($d33ba30d5e9a7819$exports, "isLiteral", () => $d33ba30d5e9a7819$export$899158ea22bb4609);
$parcel$export($d33ba30d5e9a7819$exports, "isVariable", () => $d33ba30d5e9a7819$export$670a0c046e2ed227);
$parcel$export($d33ba30d5e9a7819$exports, "isDefaultGraph", () => $d33ba30d5e9a7819$export$1a29e0fa6b36b0c8);
$parcel$export($d33ba30d5e9a7819$exports, "inDefaultGraph", () => $d33ba30d5e9a7819$export$be8c4434e9c7c90b);
$parcel$export($d33ba30d5e9a7819$exports, "prefix", () => $d33ba30d5e9a7819$export$82e9f45cca5ba907);
$parcel$export($d33ba30d5e9a7819$exports, "prefixes", () => $d33ba30d5e9a7819$export$5d3c3f85c29a375);
// **N3Util** provides N3 utility functions.

function $d33ba30d5e9a7819$export$10490ce738f72284(term) {
    return !!term && term.termType === "NamedNode";
}
function $d33ba30d5e9a7819$export$7b5b4967656acaac(term) {
    return !!term && term.termType === "BlankNode";
}
function $d33ba30d5e9a7819$export$899158ea22bb4609(term) {
    return !!term && term.termType === "Literal";
}
function $d33ba30d5e9a7819$export$670a0c046e2ed227(term) {
    return !!term && term.termType === "Variable";
}
function $d33ba30d5e9a7819$export$1a29e0fa6b36b0c8(term) {
    return !!term && term.termType === "DefaultGraph";
}
function $d33ba30d5e9a7819$export$be8c4434e9c7c90b(quad) {
    return $d33ba30d5e9a7819$export$1a29e0fa6b36b0c8(quad.graph);
}
function $d33ba30d5e9a7819$export$82e9f45cca5ba907(iri, factory) {
    return $d33ba30d5e9a7819$export$5d3c3f85c29a375({
        "": iri.value || iri
    }, factory)("");
}
function $d33ba30d5e9a7819$export$5d3c3f85c29a375(defaultPrefixes, factory) {
    // Add all of the default prefixes
    const prefixes = Object.create(null);
    for(const prefix in defaultPrefixes)processPrefix(prefix, defaultPrefixes[prefix]);
    // Set the default factory if none was specified
    factory = factory || (0, $712f170b9f5279d6$export$2e2bcd8739ae039);
    // Registers a new prefix (if an IRI was specified)
    // or retrieves a function that expands an existing prefix (if no IRI was specified)
    function processPrefix(prefix, iri) {
        // Create a new prefix if an IRI is specified or the prefix doesn't exist
        if (typeof iri === "string") {
            // Create a function that expands the prefix
            const cache = Object.create(null);
            prefixes[prefix] = (local)=>{
                return cache[local] || (cache[local] = factory.namedNode(iri + local));
            };
        } else if (!(prefix in prefixes)) throw new Error(`Unknown prefix: ${prefix}`);
        return prefixes[prefix];
    }
    return processPrefix;
}


const $bab8cb0a961d0e7d$var$DEFAULTGRAPH = (0, $712f170b9f5279d6$export$2e2bcd8739ae039).defaultGraph();
const { rdf: $bab8cb0a961d0e7d$var$rdf, xsd: $bab8cb0a961d0e7d$var$xsd } = (0, $b50e49a75dcd9196$export$2e2bcd8739ae039);
// Characters in literals that require escaping
const $bab8cb0a961d0e7d$var$escape = /["\\\t\n\r\b\f\u0000-\u0019\ud800-\udbff]/, $bab8cb0a961d0e7d$var$escapeAll = /["\\\t\n\r\b\f\u0000-\u0019]|[\ud800-\udbff][\udc00-\udfff]/g, $bab8cb0a961d0e7d$var$escapedCharacters = {
    "\\": "\\\\",
    '"': '\\"',
    "	": "\\t",
    "\n": "\\n",
    "\r": "\\r",
    "\b": "\\b",
    "\f": "\\f"
};
// ## Placeholder class to represent already pretty-printed terms
class $bab8cb0a961d0e7d$var$SerializedTerm extends (0, $712f170b9f5279d6$export$656c1e606ad06131) {
    // Pretty-printed nodes are not equal to any other node
    // (e.g., [] does not equal [])
    equals(other) {
        return other === this;
    }
}
class $bab8cb0a961d0e7d$export$2e2bcd8739ae039 {
    constructor(outputStream, options){
        // ### `_prefixRegex` matches a prefixed name or IRI that begins with one of the added prefixes
        this._prefixRegex = /$0^/;
        // Shift arguments if the first argument is not a stream
        if (outputStream && typeof outputStream.write !== "function") options = outputStream, outputStream = null;
        options = options || {};
        this._lists = options.lists;
        // If no output stream given, send the output as string through the end callback
        if (!outputStream) {
            let output = "";
            this._outputStream = {
                write (chunk, encoding, done) {
                    output += chunk;
                    done && done();
                },
                end: (done)=>{
                    done && done(null, output);
                }
            };
            this._endStream = true;
        } else {
            this._outputStream = outputStream;
            this._endStream = options.end === undefined ? true : !!options.end;
        }
        // Initialize writer, depending on the format
        this._subject = null;
        if (!/triple|quad/i.test(options.format)) {
            this._lineMode = false;
            this._graph = $bab8cb0a961d0e7d$var$DEFAULTGRAPH;
            this._prefixIRIs = Object.create(null);
            options.prefixes && this.addPrefixes(options.prefixes);
            if (options.baseIRI) {
                this._baseMatcher = new RegExp(`^${$bab8cb0a961d0e7d$var$escapeRegex(options.baseIRI)}${options.baseIRI.endsWith("/") ? "" : "[#?]"}`);
                this._baseLength = options.baseIRI.length;
            }
        } else {
            this._lineMode = true;
            this._writeQuad = this._writeQuadLine;
        }
    }
    // ## Private methods
    // ### Whether the current graph is the default graph
    get _inDefaultGraph() {
        return $bab8cb0a961d0e7d$var$DEFAULTGRAPH.equals(this._graph);
    }
    // ### `_write` writes the argument to the output stream
    _write(string, callback) {
        this._outputStream.write(string, "utf8", callback);
    }
    // ### `_writeQuad` writes the quad to the output stream
    _writeQuad(subject, predicate, object, graph, done) {
        try {
            // Write the graph's label if it has changed
            if (!graph.equals(this._graph)) {
                // Close the previous graph and start the new one
                this._write((this._subject === null ? "" : this._inDefaultGraph ? ".\n" : "\n}\n") + ($bab8cb0a961d0e7d$var$DEFAULTGRAPH.equals(graph) ? "" : `${this._encodeIriOrBlank(graph)} {\n`));
                this._graph = graph;
                this._subject = null;
            }
            // Don't repeat the subject if it's the same
            if (subject.equals(this._subject)) {
                // Don't repeat the predicate if it's the same
                if (predicate.equals(this._predicate)) this._write(`, ${this._encodeObject(object)}`, done);
                else this._write(`;\n    ${this._encodePredicate(this._predicate = predicate)} ${this._encodeObject(object)}`, done);
            } else this._write(`${(this._subject === null ? "" : ".\n") + this._encodeSubject(this._subject = subject)} ${this._encodePredicate(this._predicate = predicate)} ${this._encodeObject(object)}`, done);
        } catch (error) {
            done && done(error);
        }
    }
    // ### `_writeQuadLine` writes the quad to the output stream as a single line
    _writeQuadLine(subject, predicate, object, graph, done) {
        // Write the quad without prefixes
        delete this._prefixMatch;
        this._write(this.quadToString(subject, predicate, object, graph), done);
    }
    // ### `quadToString` serializes a quad as a string
    quadToString(subject, predicate, object, graph) {
        return `${this._encodeSubject(subject)} ${this._encodeIriOrBlank(predicate)} ${this._encodeObject(object)}${graph && graph.value ? ` ${this._encodeIriOrBlank(graph)} .\n` : " .\n"}`;
    }
    // ### `quadsToString` serializes an array of quads as a string
    quadsToString(quads) {
        return quads.map((t)=>{
            return this.quadToString(t.subject, t.predicate, t.object, t.graph);
        }).join("");
    }
    // ### `_encodeSubject` represents a subject
    _encodeSubject(entity) {
        return entity.termType === "Quad" ? this._encodeQuad(entity) : this._encodeIriOrBlank(entity);
    }
    // ### `_encodeIriOrBlank` represents an IRI or blank node
    _encodeIriOrBlank(entity) {
        // A blank node or list is represented as-is
        if (entity.termType !== "NamedNode") {
            // If it is a list head, pretty-print it
            if (this._lists && entity.value in this._lists) entity = this.list(this._lists[entity.value]);
            return "id" in entity ? entity.id : `_:${entity.value}`;
        }
        let iri = entity.value;
        // Use relative IRIs if requested and possible
        if (this._baseMatcher && this._baseMatcher.test(iri)) iri = iri.substr(this._baseLength);
        // Escape special characters
        if ($bab8cb0a961d0e7d$var$escape.test(iri)) iri = iri.replace($bab8cb0a961d0e7d$var$escapeAll, $bab8cb0a961d0e7d$var$characterReplacer);
        // Try to represent the IRI as prefixed name
        const prefixMatch = this._prefixRegex.exec(iri);
        return !prefixMatch ? `<${iri}>` : !prefixMatch[1] ? iri : this._prefixIRIs[prefixMatch[1]] + prefixMatch[2];
    }
    // ### `_encodeLiteral` represents a literal
    _encodeLiteral(literal) {
        // Escape special characters
        let value = literal.value;
        if ($bab8cb0a961d0e7d$var$escape.test(value)) value = value.replace($bab8cb0a961d0e7d$var$escapeAll, $bab8cb0a961d0e7d$var$characterReplacer);
        // Write a language-tagged literal
        if (literal.language) return `"${value}"@${literal.language}`;
        // Write dedicated literals per data type
        if (this._lineMode) {
            // Only abbreviate strings in N-Triples or N-Quads
            if (literal.datatype.value === $bab8cb0a961d0e7d$var$xsd.string) return `"${value}"`;
        } else // Use common datatype abbreviations in Turtle or TriG
        switch(literal.datatype.value){
            case $bab8cb0a961d0e7d$var$xsd.string:
                return `"${value}"`;
            case $bab8cb0a961d0e7d$var$xsd.boolean:
                if (value === "true" || value === "false") return value;
                break;
            case $bab8cb0a961d0e7d$var$xsd.integer:
                if (/^[+-]?\d+$/.test(value)) return value;
                break;
            case $bab8cb0a961d0e7d$var$xsd.decimal:
                if (/^[+-]?\d*\.\d+$/.test(value)) return value;
                break;
            case $bab8cb0a961d0e7d$var$xsd.double:
                if (/^[+-]?(?:\d+\.\d*|\.?\d+)[eE][+-]?\d+$/.test(value)) return value;
                break;
        }
        // Write a regular datatyped literal
        return `"${value}"^^${this._encodeIriOrBlank(literal.datatype)}`;
    }
    // ### `_encodePredicate` represents a predicate
    _encodePredicate(predicate) {
        return predicate.value === $bab8cb0a961d0e7d$var$rdf.type ? "a" : this._encodeIriOrBlank(predicate);
    }
    // ### `_encodeObject` represents an object
    _encodeObject(object) {
        switch(object.termType){
            case "Quad":
                return this._encodeQuad(object);
            case "Literal":
                return this._encodeLiteral(object);
            default:
                return this._encodeIriOrBlank(object);
        }
    }
    // ### `_encodeQuad` encodes an RDF* quad
    _encodeQuad({ subject: subject, predicate: predicate, object: object, graph: graph }) {
        return `<<${this._encodeSubject(subject)} ${this._encodePredicate(predicate)} ${this._encodeObject(object)}${(0, $d33ba30d5e9a7819$export$1a29e0fa6b36b0c8)(graph) ? "" : ` ${this._encodeIriOrBlank(graph)}`}>>`;
    }
    // ### `_blockedWrite` replaces `_write` after the writer has been closed
    _blockedWrite() {
        throw new Error("Cannot write because the writer has been closed.");
    }
    // ### `addQuad` adds the quad to the output stream
    addQuad(subject, predicate, object, graph, done) {
        // The quad was given as an object, so shift parameters
        if (object === undefined) this._writeQuad(subject.subject, subject.predicate, subject.object, subject.graph, predicate);
        else if (typeof graph === "function") this._writeQuad(subject, predicate, object, $bab8cb0a961d0e7d$var$DEFAULTGRAPH, graph);
        else this._writeQuad(subject, predicate, object, graph || $bab8cb0a961d0e7d$var$DEFAULTGRAPH, done);
    }
    // ### `addQuads` adds the quads to the output stream
    addQuads(quads) {
        for(let i = 0; i < quads.length; i++)this.addQuad(quads[i]);
    }
    // ### `addPrefix` adds the prefix to the output stream
    addPrefix(prefix, iri, done) {
        const prefixes = {};
        prefixes[prefix] = iri;
        this.addPrefixes(prefixes, done);
    }
    // ### `addPrefixes` adds the prefixes to the output stream
    addPrefixes(prefixes, done) {
        // Ignore prefixes if not supported by the serialization
        if (!this._prefixIRIs) return done && done();
        // Write all new prefixes
        let hasPrefixes = false;
        for(let prefix in prefixes){
            let iri = prefixes[prefix];
            if (typeof iri !== "string") iri = iri.value;
            hasPrefixes = true;
            // Finish a possible pending quad
            if (this._subject !== null) {
                this._write(this._inDefaultGraph ? ".\n" : "\n}\n");
                this._subject = null, this._graph = "";
            }
            // Store and write the prefix
            this._prefixIRIs[iri] = prefix += ":";
            this._write(`@prefix ${prefix} <${iri}>.\n`);
        }
        // Recreate the prefix matcher
        if (hasPrefixes) {
            let IRIlist = "", prefixList = "";
            for(const prefixIRI in this._prefixIRIs){
                IRIlist += IRIlist ? `|${prefixIRI}` : prefixIRI;
                prefixList += (prefixList ? "|" : "") + this._prefixIRIs[prefixIRI];
            }
            IRIlist = $bab8cb0a961d0e7d$var$escapeRegex(IRIlist, /[\]\/\(\)\*\+\?\.\\\$]/g, "\\$&");
            this._prefixRegex = new RegExp(`^(?:${prefixList})[^\/]*$|` + `^(${IRIlist})([_a-zA-Z][\\-_a-zA-Z0-9]*)$`);
        }
        // End a prefix block with a newline
        this._write(hasPrefixes ? "\n" : "", done);
    }
    // ### `blank` creates a blank node with the given content
    blank(predicate, object) {
        let children = predicate, child, length;
        // Empty blank node
        if (predicate === undefined) children = [];
        else if (predicate.termType) children = [
            {
                predicate: predicate,
                object: object
            }
        ];
        else if (!("length" in predicate)) children = [
            predicate
        ];
        switch(length = children.length){
            // Generate an empty blank node
            case 0:
                return new $bab8cb0a961d0e7d$var$SerializedTerm("[]");
            // Generate a non-nested one-triple blank node
            case 1:
                child = children[0];
                if (!(child.object instanceof $bab8cb0a961d0e7d$var$SerializedTerm)) return new $bab8cb0a961d0e7d$var$SerializedTerm(`[ ${this._encodePredicate(child.predicate)} ${this._encodeObject(child.object)} ]`);
            // Generate a multi-triple or nested blank node
            default:
                let contents = "[";
                // Write all triples in order
                for(let i = 0; i < length; i++){
                    child = children[i];
                    // Write only the object is the predicate is the same as the previous
                    if (child.predicate.equals(predicate)) contents += `, ${this._encodeObject(child.object)}`;
                    else {
                        contents += `${(i ? ";\n  " : "\n  ") + this._encodePredicate(child.predicate)} ${this._encodeObject(child.object)}`;
                        predicate = child.predicate;
                    }
                }
                return new $bab8cb0a961d0e7d$var$SerializedTerm(`${contents}\n]`);
        }
    }
    // ### `list` creates a list node with the given content
    list(elements) {
        const length = elements && elements.length || 0, contents = new Array(length);
        for(let i = 0; i < length; i++)contents[i] = this._encodeObject(elements[i]);
        return new $bab8cb0a961d0e7d$var$SerializedTerm(`(${contents.join(" ")})`);
    }
    // ### `end` signals the end of the output stream
    end(done) {
        // Finish a possible pending quad
        if (this._subject !== null) {
            this._write(this._inDefaultGraph ? ".\n" : "\n}\n");
            this._subject = null;
        }
        // Disallow further writing
        this._write = this._blockedWrite;
        // Try to end the underlying stream, ensuring done is called exactly one time
        let singleDone = done && ((error, result)=>{
            singleDone = null, done(error, result);
        });
        if (this._endStream) try {
            return this._outputStream.end(singleDone);
        } catch (error) {}
        singleDone && singleDone();
    }
}
// Replaces a character by its escaped version
function $bab8cb0a961d0e7d$var$characterReplacer(character) {
    // Replace a single character by its escaped version
    let result = $bab8cb0a961d0e7d$var$escapedCharacters[character];
    if (result === undefined) {
        // Replace a single character with its 4-bit unicode escape sequence
        if (character.length === 1) {
            result = character.charCodeAt(0).toString(16);
            result = "\\u0000".substr(0, 6 - result.length) + result;
        } else {
            result = ((character.charCodeAt(0) - 0xD800) * 0x400 + character.charCodeAt(1) + 0x2400).toString(16);
            result = "\\U00000000".substr(0, 10 - result.length) + result;
        }
    }
    return result;
}
function $bab8cb0a961d0e7d$var$escapeRegex(regex) {
    return regex.replace(/[\]\/\(\)\*\+\?\.\\\$]/g, "\\$&");
}


// **N3Store** objects store N3 quads by graph in memory.
var $28176da182b29f80$exports = {};
"use strict";
var $511554dafd610175$exports = {};
/* replacement start */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $511554dafd610175$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $511554dafd610175$require$ObjectDefineProperty = $6qlDJ.ObjectDefineProperty;
var $511554dafd610175$require$ObjectKeys = $6qlDJ.ObjectKeys;
var $511554dafd610175$require$ReflectApply = $6qlDJ.ReflectApply;

var $cSbri = parcelRequire("cSbri");
const { promisify: { custom: $511554dafd610175$var$customPromisify } } = $cSbri;
var $b0731249a151e5da$export$42af8c323be37587;
var $b0731249a151e5da$export$f405f72c701dad87;
"use strict";

const $b0731249a151e5da$var$AbortController = globalThis.AbortController || (parcelRequire("bHKGd")).AbortController;

var $PWkkZ = parcelRequire("PWkkZ");
const { codes: { ERR_INVALID_ARG_VALUE: $b0731249a151e5da$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $b0731249a151e5da$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $b0731249a151e5da$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $b0731249a151e5da$var$ERR_OUT_OF_RANGE }, AbortError: $b0731249a151e5da$var$AbortError } = $PWkkZ;

var $6q8Dc = parcelRequire("6q8Dc");
var $b0731249a151e5da$require$validateAbortSignal = $6q8Dc.validateAbortSignal;
var $b0731249a151e5da$require$validateInteger = $6q8Dc.validateInteger;
var $b0731249a151e5da$require$validateObject = $6q8Dc.validateObject;

const $b0731249a151e5da$var$kWeakHandler = (parcelRequire("6qlDJ")).Symbol("kWeak");

const $b0731249a151e5da$var$kResistStopPropagation = (parcelRequire("6qlDJ")).Symbol("kResistStopPropagation");

var $52Cjj = parcelRequire("52Cjj");
var $b0731249a151e5da$require$finished = $52Cjj.finished;
var $45fc09d411d5afbf$exports = {};
"use strict";
var $e0a640136e444712$exports = {};
/* replacement start */ 
var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $e0a640136e444712$require$ArrayIsArray = $6qlDJ.ArrayIsArray;
var $e0a640136e444712$require$Promise = $6qlDJ.Promise;
var $e0a640136e444712$require$SymbolAsyncIterator = $6qlDJ.SymbolAsyncIterator;
var $e0a640136e444712$require$SymbolDispose = $6qlDJ.SymbolDispose;

var $52Cjj = parcelRequire("52Cjj");

var $e0a640136e444712$require$once = (parcelRequire("cSbri")).once;

var $8Pe5V = parcelRequire("8Pe5V");

var $3ujhf = parcelRequire("3ujhf");

var $PWkkZ = parcelRequire("PWkkZ");
const { aggregateTwoErrors: $e0a640136e444712$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $e0a640136e444712$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $e0a640136e444712$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $e0a640136e444712$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $e0a640136e444712$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $e0a640136e444712$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $e0a640136e444712$var$AbortError } = $PWkkZ;

var $6q8Dc = parcelRequire("6q8Dc");
var $e0a640136e444712$require$validateFunction = $6q8Dc.validateFunction;
var $e0a640136e444712$require$validateAbortSignal = $6q8Dc.validateAbortSignal;

var $dEd8A = parcelRequire("dEd8A");
var $e0a640136e444712$require$isIterable = $dEd8A.isIterable;
var $e0a640136e444712$require$isReadable = $dEd8A.isReadable;
var $e0a640136e444712$require$isReadableNodeStream = $dEd8A.isReadableNodeStream;
var $e0a640136e444712$require$isNodeStream = $dEd8A.isNodeStream;
var $e0a640136e444712$require$isTransformStream = $dEd8A.isTransformStream;
var $e0a640136e444712$require$isWebStream = $dEd8A.isWebStream;
var $e0a640136e444712$require$isReadableStream = $dEd8A.isReadableStream;
var $e0a640136e444712$require$isReadableFinished = $dEd8A.isReadableFinished;

const $e0a640136e444712$var$AbortController = globalThis.AbortController || (parcelRequire("bHKGd")).AbortController;
let $e0a640136e444712$var$PassThrough;
let $e0a640136e444712$var$Readable;
let $e0a640136e444712$var$addAbortListener;
function $e0a640136e444712$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on("close", ()=>{
        finished = true;
    });
    const cleanup = $52Cjj(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $8Pe5V.destroyer(stream, err || new $e0a640136e444712$var$ERR_STREAM_DESTROYED("pipe"));
        },
        cleanup: cleanup
    };
}
function $e0a640136e444712$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $e0a640136e444712$require$validateFunction(streams[streams.length - 1], "streams[stream.length - 1]");
    return streams.pop();
}
function $e0a640136e444712$var$makeAsyncIterable(val) {
    if ($e0a640136e444712$require$isIterable(val)) return val;
    else if ($e0a640136e444712$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $e0a640136e444712$var$fromReadable(val);
    throw new $e0a640136e444712$var$ERR_INVALID_ARG_TYPE("val", [
        "Readable",
        "Iterable",
        "AsyncIterable"
    ], val);
}

async function* $e0a640136e444712$var$fromReadable(val) {
    if (!$e0a640136e444712$var$Readable) $e0a640136e444712$var$Readable = (parcelRequire("6BZaW"));
    yield* $e0a640136e444712$var$Readable.prototype[$e0a640136e444712$require$SymbolAsyncIterator].call(val);
}
async function $e0a640136e444712$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $e0a640136e444712$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on("drain", resume);
    const cleanup = $52Cjj(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $e0a640136e444712$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off("drain", resume);
    }
}
async function $e0a640136e444712$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($e0a640136e444712$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $e0a640136e444712$var$pipeline(...streams) {
    return $e0a640136e444712$var$pipelineImpl(streams, $e0a640136e444712$require$once($e0a640136e444712$var$popCallback(streams)));
}


function $e0a640136e444712$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $e0a640136e444712$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $e0a640136e444712$var$ERR_MISSING_ARGS("streams");
    const ac = new $e0a640136e444712$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $e0a640136e444712$require$validateAbortSignal(outerSignal, "options.signal");
    function abort() {
        finishImpl(new $e0a640136e444712$var$AbortError());
    }
    $e0a640136e444712$var$addAbortListener = $e0a640136e444712$var$addAbortListener || (parcelRequire("cSbri")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $e0a640136e444712$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === "ERR_STREAM_PREMATURE_CLOSE")) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$e0a640136e444712$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $hPtJY.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($e0a640136e444712$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $e0a640136e444712$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($e0a640136e444712$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== "AbortError" && err.code !== "ERR_STREAM_PREMATURE_CLOSE") finish(err);
            }
            stream.on("error", onError);
            if ($e0a640136e444712$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener("error", onError);
            });
        }
        if (i === 0) {
            if (typeof stream === "function") {
                ret = stream({
                    signal: signal
                });
                if (!$e0a640136e444712$require$isIterable(ret)) throw new $e0a640136e444712$var$ERR_INVALID_RETURN_VALUE("Iterable, AsyncIterable or Stream", "source", ret);
            } else if ($e0a640136e444712$require$isIterable(stream) || $e0a640136e444712$require$isReadableNodeStream(stream) || $e0a640136e444712$require$isTransformStream(stream)) ret = stream;
            else ret = $3ujhf.from(stream);
        } else if (typeof stream === "function") {
            if ($e0a640136e444712$require$isTransformStream(ret)) {
                var _ret;
                ret = $e0a640136e444712$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $e0a640136e444712$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$e0a640136e444712$require$isIterable(ret, true)) throw new $e0a640136e444712$var$ERR_INVALID_RETURN_VALUE("AsyncIterable", `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$e0a640136e444712$var$PassThrough) $e0a640136e444712$var$PassThrough = (parcelRequire("iXAaU"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $e0a640136e444712$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === "function") {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $hPtJY.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $hPtJY.nextTick(finish, err);
                    });
                } else if ($e0a640136e444712$require$isIterable(ret, true)) {
                    finishCount++;
                    $e0a640136e444712$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($e0a640136e444712$require$isReadableStream(ret) || $e0a640136e444712$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $e0a640136e444712$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $e0a640136e444712$var$ERR_INVALID_RETURN_VALUE("AsyncIterable or Promise", "destination", ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $e0a640136e444712$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($e0a640136e444712$require$isNodeStream(stream)) {
            if ($e0a640136e444712$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $e0a640136e444712$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($e0a640136e444712$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($e0a640136e444712$require$isTransformStream(ret) || $e0a640136e444712$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $e0a640136e444712$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($e0a640136e444712$require$isIterable(ret)) {
                finishCount++;
                $e0a640136e444712$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $e0a640136e444712$var$ERR_INVALID_ARG_TYPE("val", [
                "Readable",
                "Iterable",
                "AsyncIterable",
                "ReadableStream",
                "TransformStream"
            ], ret);
            ret = stream;
        } else if ($e0a640136e444712$require$isWebStream(stream)) {
            if ($e0a640136e444712$require$isReadableNodeStream(ret)) {
                finishCount++;
                $e0a640136e444712$var$pumpToWeb($e0a640136e444712$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($e0a640136e444712$require$isReadableStream(ret) || $e0a640136e444712$require$isIterable(ret)) {
                finishCount++;
                $e0a640136e444712$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($e0a640136e444712$require$isTransformStream(ret)) {
                finishCount++;
                $e0a640136e444712$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $e0a640136e444712$var$ERR_INVALID_ARG_TYPE("val", [
                "Readable",
                "Iterable",
                "AsyncIterable",
                "ReadableStream",
                "TransformStream"
            ], ret);
            ret = stream;
        } else ret = $3ujhf.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $hPtJY.nextTick(abort);
    return ret;
}
function $e0a640136e444712$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on("close", ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $e0a640136e444712$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($e0a640136e444712$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $hPtJY.nextTick(endFn);
        else src.once("end", endFn);
    } else finish();
    $52Cjj(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === "ERR_STREAM_PREMATURE_CLOSE" && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once("end", finish).once("error", finish);
        else finish(err);
    });
    return $52Cjj(dst, {
        readable: false,
        writable: true
    }, finish);
}
$e0a640136e444712$exports = {
    pipelineImpl: $e0a640136e444712$var$pipelineImpl,
    pipeline: $e0a640136e444712$var$pipeline
};


var $45fc09d411d5afbf$require$pipeline = $e0a640136e444712$exports.pipeline;

var $3ujhf = parcelRequire("3ujhf");

var $8Pe5V = parcelRequire("8Pe5V");
var $45fc09d411d5afbf$require$destroyer = $8Pe5V.destroyer;

var $dEd8A = parcelRequire("dEd8A");
var $45fc09d411d5afbf$require$isNodeStream = $dEd8A.isNodeStream;
var $45fc09d411d5afbf$require$isReadable = $dEd8A.isReadable;
var $45fc09d411d5afbf$require$isWritable = $dEd8A.isWritable;
var $45fc09d411d5afbf$require$isWebStream = $dEd8A.isWebStream;
var $45fc09d411d5afbf$require$isTransformStream = $dEd8A.isTransformStream;
var $45fc09d411d5afbf$require$isWritableStream = $dEd8A.isWritableStream;
var $45fc09d411d5afbf$require$isReadableStream = $dEd8A.isReadableStream;

var $PWkkZ = parcelRequire("PWkkZ");
const { AbortError: $45fc09d411d5afbf$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $45fc09d411d5afbf$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $45fc09d411d5afbf$var$ERR_MISSING_ARGS } } = $PWkkZ;

var $52Cjj = parcelRequire("52Cjj");
$45fc09d411d5afbf$exports = function compose(...streams) {
    if (streams.length === 0) throw new $45fc09d411d5afbf$var$ERR_MISSING_ARGS("streams");
    if (streams.length === 1) return $3ujhf.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === "function") streams[0] = $3ujhf.from(streams[0]);
    if (typeof streams[streams.length - 1] === "function") {
        const idx = streams.length - 1;
        streams[idx] = $3ujhf.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$45fc09d411d5afbf$require$isNodeStream(streams[n]) && !$45fc09d411d5afbf$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($45fc09d411d5afbf$require$isReadable(streams[n]) || $45fc09d411d5afbf$require$isReadableStream(streams[n]) || $45fc09d411d5afbf$require$isTransformStream(streams[n]))) throw new $45fc09d411d5afbf$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], "must be readable");
        if (n > 0 && !($45fc09d411d5afbf$require$isWritable(streams[n]) || $45fc09d411d5afbf$require$isWritableStream(streams[n]) || $45fc09d411d5afbf$require$isTransformStream(streams[n]))) throw new $45fc09d411d5afbf$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], "must be writable");
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $45fc09d411d5afbf$require$pipeline(streams, onfinished);
    const writable = !!($45fc09d411d5afbf$require$isWritable(head) || $45fc09d411d5afbf$require$isWritableStream(head) || $45fc09d411d5afbf$require$isTransformStream(head));
    const readable = !!($45fc09d411d5afbf$require$isReadable(tail) || $45fc09d411d5afbf$require$isReadableStream(tail) || $45fc09d411d5afbf$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $3ujhf({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($45fc09d411d5afbf$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on("drain", function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($45fc09d411d5afbf$require$isWebStream(head)) {
            const writable = $45fc09d411d5afbf$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $45fc09d411d5afbf$require$isTransformStream(tail) ? tail.readable : tail;
        $52Cjj(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($45fc09d411d5afbf$require$isNodeStream(tail)) {
            tail.on("readable", function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on("end", function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($45fc09d411d5afbf$require$isWebStream(tail)) {
            const readable = $45fc09d411d5afbf$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch  {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $45fc09d411d5afbf$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($45fc09d411d5afbf$require$isNodeStream(tail)) $45fc09d411d5afbf$require$destroyer(tail, err);
        }
    };
    return d;
};



var $khx7T = parcelRequire("khx7T");
var $b0731249a151e5da$require$addAbortSignalNoValidate = $khx7T.addAbortSignalNoValidate;

var $dEd8A = parcelRequire("dEd8A");
var $b0731249a151e5da$require$isWritable = $dEd8A.isWritable;
var $b0731249a151e5da$require$isNodeStream = $dEd8A.isNodeStream;

var $b0731249a151e5da$require$deprecate = (parcelRequire("cSbri")).deprecate;

var $b0731249a151e5da$require$ArrayPrototypePush = (parcelRequire("6qlDJ")).ArrayPrototypePush;
var $b0731249a151e5da$require$Boolean = (parcelRequire("6qlDJ")).Boolean;
var $b0731249a151e5da$require$MathFloor = (parcelRequire("6qlDJ")).MathFloor;
var $b0731249a151e5da$require$Number = (parcelRequire("6qlDJ")).Number;
var $b0731249a151e5da$require$NumberIsNaN = (parcelRequire("6qlDJ")).NumberIsNaN;
var $b0731249a151e5da$require$Promise = (parcelRequire("6qlDJ")).Promise;
var $b0731249a151e5da$require$PromiseReject = (parcelRequire("6qlDJ")).PromiseReject;
var $b0731249a151e5da$require$PromiseResolve = (parcelRequire("6qlDJ")).PromiseResolve;
var $b0731249a151e5da$require$PromisePrototypeThen = (parcelRequire("6qlDJ")).PromisePrototypeThen;
var $b0731249a151e5da$require$Symbol = (parcelRequire("6qlDJ")).Symbol;
const $b0731249a151e5da$var$kEmpty = $b0731249a151e5da$require$Symbol("kEmpty");
const $b0731249a151e5da$var$kEof = $b0731249a151e5da$require$Symbol("kEof");
function $b0731249a151e5da$var$compose(stream, options) {
    if (options != null) $b0731249a151e5da$require$validateObject(options, "options");
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b0731249a151e5da$require$validateAbortSignal(options.signal, "options.signal");
    if ($b0731249a151e5da$require$isNodeStream(stream) && !$b0731249a151e5da$require$isWritable(stream)) throw new $b0731249a151e5da$var$ERR_INVALID_ARG_VALUE("stream", stream, "must be writable");
    const composedStream = $45fc09d411d5afbf$exports(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $b0731249a151e5da$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $b0731249a151e5da$var$map(fn, options) {
    if (typeof fn !== "function") throw new $b0731249a151e5da$var$ERR_INVALID_ARG_TYPE("fn", [
        "Function",
        "AsyncFunction"
    ], fn);
    if (options != null) $b0731249a151e5da$require$validateObject(options, "options");
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b0731249a151e5da$require$validateAbortSignal(options.signal, "options.signal");
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $b0731249a151e5da$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $b0731249a151e5da$require$MathFloor(options.highWaterMark);
    $b0731249a151e5da$require$validateInteger(concurrency, "options.concurrency", 1);
    $b0731249a151e5da$require$validateInteger(highWaterMark, "options.highWaterMark", 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("cSbri")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($b0731249a151e5da$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $b0731249a151e5da$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $b0731249a151e5da$var$kEmpty) continue;
                        val = $b0731249a151e5da$require$PromiseResolve(val);
                    } catch (err) {
                        val = $b0731249a151e5da$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $b0731249a151e5da$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $b0731249a151e5da$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($b0731249a151e5da$var$kEof);
            } catch (err) {
                const val = $b0731249a151e5da$require$PromiseReject(err);
                $b0731249a151e5da$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $b0731249a151e5da$var$kEof) return;
                    if (signal.aborted) throw new $b0731249a151e5da$var$AbortError();
                    if (val !== $b0731249a151e5da$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $b0731249a151e5da$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $b0731249a151e5da$var$asIndexedPairs(options) {
    if (options != null) $b0731249a151e5da$require$validateObject(options, "options");
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b0731249a151e5da$require$validateAbortSignal(options.signal, "options.signal");
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $b0731249a151e5da$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $b0731249a151e5da$var$some(fn, options) {
    for await (const unused of $b0731249a151e5da$var$filter.call(this, fn, options))return true;
    return false;
}
async function $b0731249a151e5da$var$every(fn, options) {
    if (typeof fn !== "function") throw new $b0731249a151e5da$var$ERR_INVALID_ARG_TYPE("fn", [
        "Function",
        "AsyncFunction"
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $b0731249a151e5da$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $b0731249a151e5da$var$find(fn, options) {
    for await (const result of $b0731249a151e5da$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $b0731249a151e5da$var$forEach(fn, options) {
    if (typeof fn !== "function") throw new $b0731249a151e5da$var$ERR_INVALID_ARG_TYPE("fn", [
        "Function",
        "AsyncFunction"
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $b0731249a151e5da$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $b0731249a151e5da$var$map.call(this, forEachFn, options));
}
function $b0731249a151e5da$var$filter(fn, options) {
    if (typeof fn !== "function") throw new $b0731249a151e5da$var$ERR_INVALID_ARG_TYPE("fn", [
        "Function",
        "AsyncFunction"
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $b0731249a151e5da$var$kEmpty;
    }
    return $b0731249a151e5da$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $b0731249a151e5da$var$ReduceAwareErrMissingArgs extends $b0731249a151e5da$var$ERR_MISSING_ARGS {
    constructor(){
        super("reduce");
        this.message = "Reduce of an empty stream requires an initial value";
    }
}
async function $b0731249a151e5da$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== "function") throw new $b0731249a151e5da$var$ERR_INVALID_ARG_TYPE("reducer", [
        "Function",
        "AsyncFunction"
    ], reducer);
    if (options != null) $b0731249a151e5da$require$validateObject(options, "options");
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b0731249a151e5da$require$validateAbortSignal(options.signal, "options.signal");
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $b0731249a151e5da$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once("error", ()=>{}) // The error is already propagated
        ;
        await $b0731249a151e5da$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $b0731249a151e5da$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$b0731249a151e5da$var$kWeakHandler]: this,
            [$b0731249a151e5da$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener("abort", ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $b0731249a151e5da$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $b0731249a151e5da$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $b0731249a151e5da$var$toArray(options) {
    if (options != null) $b0731249a151e5da$require$validateObject(options, "options");
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b0731249a151e5da$require$validateAbortSignal(options.signal, "options.signal");
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $b0731249a151e5da$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $b0731249a151e5da$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $b0731249a151e5da$var$flatMap(fn, options) {
    const values = $b0731249a151e5da$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $b0731249a151e5da$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $b0731249a151e5da$require$Number(number);
    if ($b0731249a151e5da$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $b0731249a151e5da$var$ERR_OUT_OF_RANGE("number", ">= 0", number);
    return number;
}
function $b0731249a151e5da$var$drop(number, options) {
    if (options != null) $b0731249a151e5da$require$validateObject(options, "options");
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b0731249a151e5da$require$validateAbortSignal(options.signal, "options.signal");
    number = $b0731249a151e5da$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $b0731249a151e5da$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $b0731249a151e5da$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $b0731249a151e5da$var$take(number, options) {
    if (options != null) $b0731249a151e5da$require$validateObject(options, "options");
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b0731249a151e5da$require$validateAbortSignal(options.signal, "options.signal");
    number = $b0731249a151e5da$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $b0731249a151e5da$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $b0731249a151e5da$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$b0731249a151e5da$export$42af8c323be37587 = {
    asIndexedPairs: $b0731249a151e5da$require$deprecate($b0731249a151e5da$var$asIndexedPairs, "readable.asIndexedPairs will be removed in a future version."),
    drop: $b0731249a151e5da$var$drop,
    filter: $b0731249a151e5da$var$filter,
    flatMap: $b0731249a151e5da$var$flatMap,
    map: $b0731249a151e5da$var$map,
    take: $b0731249a151e5da$var$take,
    compose: $b0731249a151e5da$var$compose
};
$b0731249a151e5da$export$f405f72c701dad87 = {
    every: $b0731249a151e5da$var$every,
    forEach: $b0731249a151e5da$var$forEach,
    reduce: $b0731249a151e5da$var$reduce,
    toArray: $b0731249a151e5da$var$toArray,
    some: $b0731249a151e5da$var$some,
    find: $b0731249a151e5da$var$find
};


var $511554dafd610175$require$streamReturningOperators = $b0731249a151e5da$export$42af8c323be37587;
var $511554dafd610175$require$promiseReturningOperators = $b0731249a151e5da$export$f405f72c701dad87;

var $PWkkZ = parcelRequire("PWkkZ");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $511554dafd610175$var$ERR_ILLEGAL_CONSTRUCTOR } } = $PWkkZ;


var $5ZWSH = parcelRequire("5ZWSH");
var $511554dafd610175$require$setDefaultHighWaterMark = $5ZWSH.setDefaultHighWaterMark;
var $511554dafd610175$require$getDefaultHighWaterMark = $5ZWSH.getDefaultHighWaterMark;

var $511554dafd610175$require$pipeline = $e0a640136e444712$exports.pipeline;

var $8Pe5V = parcelRequire("8Pe5V");
var $511554dafd610175$require$destroyer = $8Pe5V.destroyer;

var $52Cjj = parcelRequire("52Cjj");
const $511554dafd610175$var$internalBuffer = {};
var $eada4a54cfd36b5a$exports = {};
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $eada4a54cfd36b5a$require$ArrayPrototypePop = $6qlDJ.ArrayPrototypePop;
var $eada4a54cfd36b5a$require$Promise = $6qlDJ.Promise;

var $dEd8A = parcelRequire("dEd8A");
var $eada4a54cfd36b5a$require$isIterable = $dEd8A.isIterable;
var $eada4a54cfd36b5a$require$isNodeStream = $dEd8A.isNodeStream;
var $eada4a54cfd36b5a$require$isWebStream = $dEd8A.isWebStream;

var $eada4a54cfd36b5a$require$pl = $e0a640136e444712$exports.pipelineImpl;

var $52Cjj = parcelRequire("52Cjj");
var $eada4a54cfd36b5a$require$finished = $52Cjj.finished;

function $eada4a54cfd36b5a$var$pipeline(...streams) {
    return new $eada4a54cfd36b5a$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === "object" && !$eada4a54cfd36b5a$require$isNodeStream(lastArg) && !$eada4a54cfd36b5a$require$isIterable(lastArg) && !$eada4a54cfd36b5a$require$isWebStream(lastArg)) {
            const options = $eada4a54cfd36b5a$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $eada4a54cfd36b5a$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
$eada4a54cfd36b5a$exports = {
    finished: $eada4a54cfd36b5a$require$finished,
    pipeline: $eada4a54cfd36b5a$var$pipeline
};



var $dEd8A = parcelRequire("dEd8A");

const $511554dafd610175$var$Stream = $511554dafd610175$exports = (parcelRequire("8uq7s")).Stream;
$511554dafd610175$var$Stream.isDestroyed = $dEd8A.isDestroyed;
$511554dafd610175$var$Stream.isDisturbed = $dEd8A.isDisturbed;
$511554dafd610175$var$Stream.isErrored = $dEd8A.isErrored;
$511554dafd610175$var$Stream.isReadable = $dEd8A.isReadable;
$511554dafd610175$var$Stream.isWritable = $dEd8A.isWritable;

$511554dafd610175$var$Stream.Readable = (parcelRequire("6BZaW"));
for (const key of $511554dafd610175$require$ObjectKeys($511554dafd610175$require$streamReturningOperators)){
    const op = $511554dafd610175$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $511554dafd610175$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $511554dafd610175$var$Stream.Readable.from($511554dafd610175$require$ReflectApply(op, this, args));
    }
    $511554dafd610175$require$ObjectDefineProperty(fn, "name", {
        __proto__: null,
        value: op.name
    });
    $511554dafd610175$require$ObjectDefineProperty(fn, "length", {
        __proto__: null,
        value: op.length
    });
    $511554dafd610175$require$ObjectDefineProperty($511554dafd610175$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $511554dafd610175$require$ObjectKeys($511554dafd610175$require$promiseReturningOperators)){
    const op = $511554dafd610175$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $511554dafd610175$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $511554dafd610175$require$ReflectApply(op, this, args);
    }
    $511554dafd610175$require$ObjectDefineProperty(fn1, "name", {
        __proto__: null,
        value: op.name
    });
    $511554dafd610175$require$ObjectDefineProperty(fn1, "length", {
        __proto__: null,
        value: op.length
    });
    $511554dafd610175$require$ObjectDefineProperty($511554dafd610175$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$511554dafd610175$var$Stream.Writable = (parcelRequire("4uosb"));

$511554dafd610175$var$Stream.Duplex = (parcelRequire("3ujhf"));

$511554dafd610175$var$Stream.Transform = (parcelRequire("3LvcR"));

$511554dafd610175$var$Stream.PassThrough = (parcelRequire("iXAaU"));
$511554dafd610175$var$Stream.pipeline = $511554dafd610175$require$pipeline;

var $khx7T = parcelRequire("khx7T");
var $511554dafd610175$require$addAbortSignal = $khx7T.addAbortSignal;
$511554dafd610175$var$Stream.addAbortSignal = $511554dafd610175$require$addAbortSignal;
$511554dafd610175$var$Stream.finished = $52Cjj;
$511554dafd610175$var$Stream.destroy = $511554dafd610175$require$destroyer;
$511554dafd610175$var$Stream.compose = $45fc09d411d5afbf$exports;
$511554dafd610175$var$Stream.setDefaultHighWaterMark = $511554dafd610175$require$setDefaultHighWaterMark;
$511554dafd610175$var$Stream.getDefaultHighWaterMark = $511554dafd610175$require$getDefaultHighWaterMark;
$511554dafd610175$require$ObjectDefineProperty($511554dafd610175$var$Stream, "promises", {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $eada4a54cfd36b5a$exports;
    }
});
$511554dafd610175$require$ObjectDefineProperty($511554dafd610175$require$pipeline, $511554dafd610175$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $eada4a54cfd36b5a$exports.pipeline;
    }
});
$511554dafd610175$require$ObjectDefineProperty($52Cjj, $511554dafd610175$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $eada4a54cfd36b5a$exports.finished;
    }
});
// Backwards-compat with node 0.4.x
$511554dafd610175$var$Stream.Stream = $511554dafd610175$var$Stream;
$511554dafd610175$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$511554dafd610175$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $511554dafd610175$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};



const $28176da182b29f80$var$originalDestroy = $511554dafd610175$exports.Readable.destroy;
$28176da182b29f80$exports = $511554dafd610175$exports.Readable;
// Explicit export naming is needed for ESM
$28176da182b29f80$exports._uint8ArrayToBuffer = $511554dafd610175$exports._uint8ArrayToBuffer;
$28176da182b29f80$exports._isUint8Array = $511554dafd610175$exports._isUint8Array;
$28176da182b29f80$exports.isDisturbed = $511554dafd610175$exports.isDisturbed;
$28176da182b29f80$exports.isErrored = $511554dafd610175$exports.isErrored;
$28176da182b29f80$exports.isReadable = $511554dafd610175$exports.isReadable;
$28176da182b29f80$exports.Readable = $511554dafd610175$exports.Readable;
$28176da182b29f80$exports.Writable = $511554dafd610175$exports.Writable;
$28176da182b29f80$exports.Duplex = $511554dafd610175$exports.Duplex;
$28176da182b29f80$exports.Transform = $511554dafd610175$exports.Transform;
$28176da182b29f80$exports.PassThrough = $511554dafd610175$exports.PassThrough;
$28176da182b29f80$exports.addAbortSignal = $511554dafd610175$exports.addAbortSignal;
$28176da182b29f80$exports.finished = $511554dafd610175$exports.finished;
$28176da182b29f80$exports.destroy = $511554dafd610175$exports.destroy;
$28176da182b29f80$exports.destroy = $28176da182b29f80$var$originalDestroy;
$28176da182b29f80$exports.pipeline = $511554dafd610175$exports.pipeline;
$28176da182b29f80$exports.compose = $511554dafd610175$exports.compose;
Object.defineProperty($511554dafd610175$exports, "promises", {
    configurable: true,
    enumerable: true,
    get () {
        return $eada4a54cfd36b5a$exports;
    }
});
$28176da182b29f80$exports.Stream = $511554dafd610175$exports.Stream;
// Allow default importing
$28176da182b29f80$exports.default = $28176da182b29f80$exports;





class $b0dfd6227adaa9e6$export$2e2bcd8739ae039 {
    constructor(quads, options){
        // The number of quads is initially zero
        this._size = 0;
        // `_graphs` contains subject, predicate, and object indexes per graph
        this._graphs = Object.create(null);
        // `_ids` maps entities such as `http://xmlns.com/foaf/0.1/name` to numbers,
        // saving memory by using only numbers as keys in `_graphs`
        this._id = 0;
        this._ids = Object.create(null);
        this._entities = Object.create(null); // inverse of `_ids`
        // `_blankNodeIndex` is the index of the last automatically named blank node
        this._blankNodeIndex = 0;
        // Shift parameters if `quads` is not given
        if (!options && quads && !quads[0]) options = quads, quads = null;
        options = options || {};
        this._factory = options.factory || (0, $712f170b9f5279d6$export$2e2bcd8739ae039);
        // Add quads if passed
        if (quads) this.addQuads(quads);
    }
    _termFromId(id, factory) {
        if (id[0] === ".") {
            const entities = this._entities;
            const terms = id.split(".");
            const q = this._factory.quad(this._termFromId(entities[terms[1]]), this._termFromId(entities[terms[2]]), this._termFromId(entities[terms[3]]), terms[4] && this._termFromId(entities[terms[4]]));
            return q;
        }
        return (0, $712f170b9f5279d6$export$85285e91bbd99cf)(id, factory);
    }
    _termToNumericId(term) {
        if (term.termType === "Quad") {
            const s = this._termToNumericId(term.subject), p = this._termToNumericId(term.predicate), o = this._termToNumericId(term.object);
            let g;
            return s && p && o && ((0, $d33ba30d5e9a7819$export$1a29e0fa6b36b0c8)(term.graph) || (g = this._termToNumericId(term.graph))) && this._ids[g ? `.${s}.${p}.${o}.${g}` : `.${s}.${p}.${o}`];
        }
        return this._ids[(0, $712f170b9f5279d6$export$fbf03d1179c9227e)(term)];
    }
    _termToNewNumericId(term) {
        // This assumes that no graph term is present - we may wish to error if there is one
        const str = term && term.termType === "Quad" ? `.${this._termToNewNumericId(term.subject)}.${this._termToNewNumericId(term.predicate)}.${this._termToNewNumericId(term.object)}${(0, $d33ba30d5e9a7819$export$1a29e0fa6b36b0c8)(term.graph) ? "" : `.${this._termToNewNumericId(term.graph)}`}` : (0, $712f170b9f5279d6$export$fbf03d1179c9227e)(term);
        return this._ids[str] || (this._ids[this._entities[++this._id] = str] = this._id);
    }
    // ## Public properties
    // ### `size` returns the number of quads in the store
    get size() {
        // Return the quad count if if was cached
        let size = this._size;
        if (size !== null) return size;
        // Calculate the number of quads by counting to the deepest level
        size = 0;
        const graphs = this._graphs;
        let subjects, subject;
        for(const graphKey in graphs)for(const subjectKey in subjects = graphs[graphKey].subjects)for(const predicateKey in subject = subjects[subjectKey])size += Object.keys(subject[predicateKey]).length;
        return this._size = size;
    }
    // ## Private methods
    // ### `_addToIndex` adds a quad to a three-layered index.
    // Returns if the index has changed, if the entry did not already exist.
    _addToIndex(index0, key0, key1, key2) {
        // Create layers as necessary
        const index1 = index0[key0] || (index0[key0] = {});
        const index2 = index1[key1] || (index1[key1] = {});
        // Setting the key to _any_ value signals the presence of the quad
        const existed = key2 in index2;
        if (!existed) index2[key2] = null;
        return !existed;
    }
    // ### `_removeFromIndex` removes a quad from a three-layered index
    _removeFromIndex(index0, key0, key1, key2) {
        // Remove the quad from the index
        const index1 = index0[key0], index2 = index1[key1];
        delete index2[key2];
        // Remove intermediary index layers if they are empty
        for(const key in index2)return;
        delete index1[key1];
        for(const key in index1)return;
        delete index0[key0];
    }
    // ### `_findInIndex` finds a set of quads in a three-layered index.
    // The index base is `index0` and the keys at each level are `key0`, `key1`, and `key2`.
    // Any of these keys can be undefined, which is interpreted as a wildcard.
    // `name0`, `name1`, and `name2` are the names of the keys at each level,
    // used when reconstructing the resulting quad
    // (for instance: _subject_, _predicate_, and _object_).
    // Finally, `graphId` will be the graph of the created quads.
    *_findInIndex(index0, key0, key1, key2, name0, name1, name2, graphId) {
        let tmp, index1, index2;
        const entityKeys = this._entities;
        const graph = this._termFromId(graphId, this._factory);
        const parts = {
            subject: null,
            predicate: null,
            object: null
        };
        // If a key is specified, use only that part of index 0.
        if (key0) (tmp = index0, index0 = {})[key0] = tmp[key0];
        for(const value0 in index0)if (index1 = index0[value0]) {
            parts[name0] = this._termFromId(entityKeys[value0], this._factory);
            // If a key is specified, use only that part of index 1.
            if (key1) (tmp = index1, index1 = {})[key1] = tmp[key1];
            for(const value1 in index1)if (index2 = index1[value1]) {
                parts[name1] = this._termFromId(entityKeys[value1], this._factory);
                // If a key is specified, use only that part of index 2, if it exists.
                const values = key2 ? key2 in index2 ? [
                    key2
                ] : [] : Object.keys(index2);
                // Create quads for all items found in index 2.
                for(let l = 0; l < values.length; l++){
                    parts[name2] = this._termFromId(entityKeys[values[l]], this._factory);
                    yield this._factory.quad(parts.subject, parts.predicate, parts.object, graph);
                }
            }
        }
    }
    // ### `_loop` executes the callback on all keys of index 0
    _loop(index0, callback) {
        for(const key0 in index0)callback(key0);
    }
    // ### `_loopByKey0` executes the callback on all keys of a certain entry in index 0
    _loopByKey0(index0, key0, callback) {
        let index1, key1;
        if (index1 = index0[key0]) for(key1 in index1)callback(key1);
    }
    // ### `_loopByKey1` executes the callback on given keys of all entries in index 0
    _loopByKey1(index0, key1, callback) {
        let key0, index1;
        for(key0 in index0){
            index1 = index0[key0];
            if (index1[key1]) callback(key0);
        }
    }
    // ### `_loopBy2Keys` executes the callback on given keys of certain entries in index 2
    _loopBy2Keys(index0, key0, key1, callback) {
        let index1, index2, key2;
        if ((index1 = index0[key0]) && (index2 = index1[key1])) for(key2 in index2)callback(key2);
    }
    // ### `_countInIndex` counts matching quads in a three-layered index.
    // The index base is `index0` and the keys at each level are `key0`, `key1`, and `key2`.
    // Any of these keys can be undefined, which is interpreted as a wildcard.
    _countInIndex(index0, key0, key1, key2) {
        let count = 0, tmp, index1, index2;
        // If a key is specified, count only that part of index 0
        if (key0) (tmp = index0, index0 = {})[key0] = tmp[key0];
        for(const value0 in index0)if (index1 = index0[value0]) {
            // If a key is specified, count only that part of index 1
            if (key1) (tmp = index1, index1 = {})[key1] = tmp[key1];
            for(const value1 in index1)if (index2 = index1[value1]) {
                // If a key is specified, count the quad if it exists
                if (key2) key2 in index2 && count++;
                else count += Object.keys(index2).length;
            }
        }
        return count;
    }
    // ### `_getGraphs` returns an array with the given graph,
    // or all graphs if the argument is null or undefined.
    _getGraphs(graph) {
        if (!$b0dfd6227adaa9e6$var$isString(graph)) return this._graphs;
        const graphs = {};
        graphs[graph] = this._graphs[graph];
        return graphs;
    }
    // ### `_uniqueEntities` returns a function that accepts an entity ID
    // and passes the corresponding entity to callback if it hasn't occurred before.
    _uniqueEntities(callback) {
        const uniqueIds = Object.create(null);
        return (id)=>{
            if (!(id in uniqueIds)) {
                uniqueIds[id] = true;
                callback(this._termFromId(this._entities[id], this._factory));
            }
        };
    }
    // ## Public methods
    // ### `add` adds the specified quad to the dataset.
    // Returns the dataset instance it was called on.
    // Existing quads, as defined in Quad.equals, will be ignored.
    add(quad) {
        this.addQuad(quad);
        return this;
    }
    // ### `addQuad` adds a new quad to the store.
    // Returns if the quad index has changed, if the quad did not already exist.
    addQuad(subject, predicate, object, graph) {
        // Shift arguments if a quad object is given instead of components
        if (!predicate) graph = subject.graph, object = subject.object, predicate = subject.predicate, subject = subject.subject;
        // Convert terms to internal string representation
        graph = (0, $712f170b9f5279d6$export$fbf03d1179c9227e)(graph);
        // Find the graph that will contain the triple
        let graphItem = this._graphs[graph];
        // Create the graph if it doesn't exist yet
        if (!graphItem) {
            graphItem = this._graphs[graph] = {
                subjects: {},
                predicates: {},
                objects: {}
            };
            // Freezing a graph helps subsequent `add` performance,
            // and properties will never be modified anyway
            Object.freeze(graphItem);
        }
        // Since entities can often be long IRIs, we avoid storing them in every index.
        // Instead, we have a separate index that maps entities to numbers,
        // which are then used as keys in the other indexes.
        subject = this._termToNewNumericId(subject);
        predicate = this._termToNewNumericId(predicate);
        object = this._termToNewNumericId(object);
        const changed = this._addToIndex(graphItem.subjects, subject, predicate, object);
        this._addToIndex(graphItem.predicates, predicate, object, subject);
        this._addToIndex(graphItem.objects, object, subject, predicate);
        // The cached quad count is now invalid
        this._size = null;
        return changed;
    }
    // ### `addQuads` adds multiple quads to the store
    addQuads(quads) {
        for(let i = 0; i < quads.length; i++)this.addQuad(quads[i]);
    }
    // ### `delete` removes the specified quad from the dataset.
    // Returns the dataset instance it was called on.
    delete(quad) {
        this.removeQuad(quad);
        return this;
    }
    // ### `has` determines whether a dataset includes a certain quad or quad pattern.
    has(subjectOrQuad, predicate, object, graph) {
        if (subjectOrQuad && subjectOrQuad.subject) ({ subject: subjectOrQuad, predicate: predicate, object: object, graph: graph } = subjectOrQuad);
        return !this.readQuads(subjectOrQuad, predicate, object, graph).next().done;
    }
    // ### `import` adds a stream of quads to the store
    import(stream) {
        stream.on("data", (quad)=>{
            this.addQuad(quad);
        });
        return stream;
    }
    // ### `removeQuad` removes a quad from the store if it exists
    removeQuad(subject, predicate, object, graph) {
        // Shift arguments if a quad object is given instead of components
        if (!predicate) graph = subject.graph, object = subject.object, predicate = subject.predicate, subject = subject.subject;
        // Convert terms to internal string representation
        graph = (0, $712f170b9f5279d6$export$fbf03d1179c9227e)(graph);
        // Find internal identifiers for all components
        // and verify the quad exists.
        const graphs = this._graphs;
        let graphItem, subjects, predicates;
        if (!(subject = subject && this._termToNumericId(subject)) || !(predicate = predicate && this._termToNumericId(predicate)) || !(object = object && this._termToNumericId(object)) || !(graphItem = graphs[graph]) || !(subjects = graphItem.subjects[subject]) || !(predicates = subjects[predicate]) || !(object in predicates)) return false;
        // Remove it from all indexes
        this._removeFromIndex(graphItem.subjects, subject, predicate, object);
        this._removeFromIndex(graphItem.predicates, predicate, object, subject);
        this._removeFromIndex(graphItem.objects, object, subject, predicate);
        if (this._size !== null) this._size--;
        // Remove the graph if it is empty
        for(subject in graphItem.subjects)return true;
        delete graphs[graph];
        return true;
    }
    // ### `removeQuads` removes multiple quads from the store
    removeQuads(quads) {
        for(let i = 0; i < quads.length; i++)this.removeQuad(quads[i]);
    }
    // ### `remove` removes a stream of quads from the store
    remove(stream) {
        stream.on("data", (quad)=>{
            this.removeQuad(quad);
        });
        return stream;
    }
    // ### `removeMatches` removes all matching quads from the store
    // Setting any field to `undefined` or `null` indicates a wildcard.
    removeMatches(subject, predicate, object, graph) {
        const stream = new (0, $28176da182b29f80$exports.Readable)({
            objectMode: true
        });
        stream._read = ()=>{
            for (const quad of this.readQuads(subject, predicate, object, graph))stream.push(quad);
            stream.push(null);
        };
        return this.remove(stream);
    }
    // ### `deleteGraph` removes all triples with the given graph from the store
    deleteGraph(graph) {
        return this.removeMatches(null, null, null, graph);
    }
    // ### `getQuads` returns an array of quads matching a pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    getQuads(subject, predicate, object, graph) {
        return [
            ...this.readQuads(subject, predicate, object, graph)
        ];
    }
    // ### `readQuads` returns an generator of quads matching a pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    *readQuads(subject, predicate, object, graph) {
        // Convert terms to internal string representation
        graph = graph && (0, $712f170b9f5279d6$export$fbf03d1179c9227e)(graph);
        const graphs = this._getGraphs(graph);
        let content, subjectId, predicateId, objectId;
        // Translate IRIs to internal index keys.
        if (subject && !(subjectId = this._termToNumericId(subject)) || predicate && !(predicateId = this._termToNumericId(predicate)) || object && !(objectId = this._termToNumericId(object))) return;
        for(const graphId in graphs)// Only if the specified graph contains triples, there can be results
        if (content = graphs[graphId]) {
            // Choose the optimal index, based on what fields are present
            if (subjectId) {
                if (objectId) // If subject and object are given, the object index will be the fastest
                yield* this._findInIndex(content.objects, objectId, subjectId, predicateId, "object", "subject", "predicate", graphId);
                else // If only subject and possibly predicate are given, the subject index will be the fastest
                yield* this._findInIndex(content.subjects, subjectId, predicateId, null, "subject", "predicate", "object", graphId);
            } else if (predicateId) // If only predicate and possibly object are given, the predicate index will be the fastest
            yield* this._findInIndex(content.predicates, predicateId, objectId, null, "predicate", "object", "subject", graphId);
            else if (objectId) // If only object is given, the object index will be the fastest
            yield* this._findInIndex(content.objects, objectId, null, null, "object", "subject", "predicate", graphId);
            else // If nothing is given, iterate subjects and predicates first
            yield* this._findInIndex(content.subjects, null, null, null, "subject", "predicate", "object", graphId);
        }
    }
    // ### `match` returns a new dataset that is comprised of all quads in the current instance matching the given arguments.
    // The logic described in Quad Matching is applied for each quad in this dataset to check if it should be included in the output dataset.
    // Note: This method always returns a new DatasetCore, even if that dataset contains no quads.
    // Note: Since a DatasetCore is an unordered set, the order of the quads within the returned sequence is arbitrary.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    // For backwards compatibility, the object return also implements the Readable stream interface.
    match(subject, predicate, object, graph) {
        return new $b0dfd6227adaa9e6$var$DatasetCoreAndReadableStream(this, subject, predicate, object, graph);
    }
    // ### `countQuads` returns the number of quads matching a pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    countQuads(subject, predicate, object, graph) {
        // Convert terms to internal string representation
        graph = graph && (0, $712f170b9f5279d6$export$fbf03d1179c9227e)(graph);
        const graphs = this._getGraphs(graph);
        let count = 0, content, subjectId, predicateId, objectId;
        // Translate IRIs to internal index keys.
        if (subject && !(subjectId = this._termToNumericId(subject)) || predicate && !(predicateId = this._termToNumericId(predicate)) || object && !(objectId = this._termToNumericId(object))) return 0;
        for(const graphId in graphs)// Only if the specified graph contains triples, there can be results
        if (content = graphs[graphId]) {
            // Choose the optimal index, based on what fields are present
            if (subject) {
                if (object) // If subject and object are given, the object index will be the fastest
                count += this._countInIndex(content.objects, objectId, subjectId, predicateId);
                else // If only subject and possibly predicate are given, the subject index will be the fastest
                count += this._countInIndex(content.subjects, subjectId, predicateId, objectId);
            } else if (predicate) // If only predicate and possibly object are given, the predicate index will be the fastest
            count += this._countInIndex(content.predicates, predicateId, objectId, subjectId);
            else // If only object is possibly given, the object index will be the fastest
            count += this._countInIndex(content.objects, objectId, subjectId, predicateId);
        }
        return count;
    }
    // ### `forEach` executes the callback on all quads.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    forEach(callback, subject, predicate, object, graph) {
        this.some((quad)=>{
            callback(quad);
            return false;
        }, subject, predicate, object, graph);
    }
    // ### `every` executes the callback on all quads,
    // and returns `true` if it returns truthy for all them.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    every(callback, subject, predicate, object, graph) {
        let some = false;
        const every = !this.some((quad)=>{
            some = true;
            return !callback(quad);
        }, subject, predicate, object, graph);
        return some && every;
    }
    // ### `some` executes the callback on all quads,
    // and returns `true` if it returns truthy for any of them.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    some(callback, subject, predicate, object, graph) {
        for (const quad of this.readQuads(subject, predicate, object, graph))if (callback(quad)) return true;
        return false;
    }
    // ### `getSubjects` returns all subjects that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    getSubjects(predicate, object, graph) {
        const results = [];
        this.forSubjects((s)=>{
            results.push(s);
        }, predicate, object, graph);
        return results;
    }
    // ### `forSubjects` executes the callback on all subjects that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    forSubjects(callback, predicate, object, graph) {
        // Convert terms to internal string representation
        graph = graph && (0, $712f170b9f5279d6$export$fbf03d1179c9227e)(graph);
        const graphs = this._getGraphs(graph);
        let content, predicateId, objectId;
        callback = this._uniqueEntities(callback);
        // Translate IRIs to internal index keys.
        if (predicate && !(predicateId = this._termToNumericId(predicate)) || object && !(objectId = this._termToNumericId(object))) return;
        for(graph in graphs)// Only if the specified graph contains triples, there can be results
        if (content = graphs[graph]) {
            // Choose optimal index based on which fields are wildcards
            if (predicateId) {
                if (objectId) // If predicate and object are given, the POS index is best.
                this._loopBy2Keys(content.predicates, predicateId, objectId, callback);
                else // If only predicate is given, the SPO index is best.
                this._loopByKey1(content.subjects, predicateId, callback);
            } else if (objectId) // If only object is given, the OSP index is best.
            this._loopByKey0(content.objects, objectId, callback);
            else // If no params given, iterate all the subjects
            this._loop(content.subjects, callback);
        }
    }
    // ### `getPredicates` returns all predicates that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    getPredicates(subject, object, graph) {
        const results = [];
        this.forPredicates((p)=>{
            results.push(p);
        }, subject, object, graph);
        return results;
    }
    // ### `forPredicates` executes the callback on all predicates that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    forPredicates(callback, subject, object, graph) {
        // Convert terms to internal string representation
        graph = graph && (0, $712f170b9f5279d6$export$fbf03d1179c9227e)(graph);
        const graphs = this._getGraphs(graph);
        let content, subjectId, objectId;
        callback = this._uniqueEntities(callback);
        // Translate IRIs to internal index keys.
        if (subject && !(subjectId = this._termToNumericId(subject)) || object && !(objectId = this._termToNumericId(object))) return;
        for(graph in graphs)// Only if the specified graph contains triples, there can be results
        if (content = graphs[graph]) {
            // Choose optimal index based on which fields are wildcards
            if (subjectId) {
                if (objectId) // If subject and object are given, the OSP index is best.
                this._loopBy2Keys(content.objects, objectId, subjectId, callback);
                else // If only subject is given, the SPO index is best.
                this._loopByKey0(content.subjects, subjectId, callback);
            } else if (objectId) // If only object is given, the POS index is best.
            this._loopByKey1(content.predicates, objectId, callback);
            else // If no params given, iterate all the predicates.
            this._loop(content.predicates, callback);
        }
    }
    // ### `getObjects` returns all objects that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    getObjects(subject, predicate, graph) {
        const results = [];
        this.forObjects((o)=>{
            results.push(o);
        }, subject, predicate, graph);
        return results;
    }
    // ### `forObjects` executes the callback on all objects that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    forObjects(callback, subject, predicate, graph) {
        // Convert terms to internal string representation
        graph = graph && (0, $712f170b9f5279d6$export$fbf03d1179c9227e)(graph);
        const graphs = this._getGraphs(graph);
        let content, subjectId, predicateId;
        callback = this._uniqueEntities(callback);
        // Translate IRIs to internal index keys.
        if (subject && !(subjectId = this._termToNumericId(subject)) || predicate && !(predicateId = this._termToNumericId(predicate))) return;
        for(graph in graphs)// Only if the specified graph contains triples, there can be results
        if (content = graphs[graph]) {
            // Choose optimal index based on which fields are wildcards
            if (subjectId) {
                if (predicateId) // If subject and predicate are given, the SPO index is best.
                this._loopBy2Keys(content.subjects, subjectId, predicateId, callback);
                else // If only subject is given, the OSP index is best.
                this._loopByKey1(content.objects, subjectId, callback);
            } else if (predicateId) // If only predicate is given, the POS index is best.
            this._loopByKey0(content.predicates, predicateId, callback);
            else // If no params given, iterate all the objects.
            this._loop(content.objects, callback);
        }
    }
    // ### `getGraphs` returns all graphs that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    getGraphs(subject, predicate, object) {
        const results = [];
        this.forGraphs((g)=>{
            results.push(g);
        }, subject, predicate, object);
        return results;
    }
    // ### `forGraphs` executes the callback on all graphs that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    forGraphs(callback, subject, predicate, object) {
        for(const graph in this._graphs)this.some((quad)=>{
            callback(quad.graph);
            return true; // Halt iteration of some()
        }, subject, predicate, object, graph);
    }
    // ### `createBlankNode` creates a new blank node, returning its name
    createBlankNode(suggestedName) {
        let name, index;
        // Generate a name based on the suggested name
        if (suggestedName) {
            name = suggestedName = `_:${suggestedName}`, index = 1;
            while(this._ids[name])name = suggestedName + index++;
        } else do name = `_:b${this._blankNodeIndex++}`;
        while (this._ids[name]);
        // Add the blank node to the entities, avoiding the generation of duplicates
        this._ids[name] = ++this._id;
        this._entities[this._id] = name;
        return this._factory.blankNode(name.substr(2));
    }
    // ### `extractLists` finds and removes all list triples
    // and returns the items per list.
    extractLists({ remove: remove = false, ignoreErrors: ignoreErrors = false } = {}) {
        const lists = {}; // has scalar keys so could be a simple Object
        const onError = ignoreErrors ? ()=>true : (node, message)=>{
            throw new Error(`${node.value} ${message}`);
        };
        // Traverse each list from its tail
        const tails = this.getQuads(null, (0, $b50e49a75dcd9196$export$2e2bcd8739ae039).rdf.rest, (0, $b50e49a75dcd9196$export$2e2bcd8739ae039).rdf.nil, null);
        const toRemove = remove ? [
            ...tails
        ] : [];
        tails.forEach((tailQuad)=>{
            const items = []; // the members found as objects of rdf:first quads
            let malformed = false; // signals whether the current list is malformed
            let head; // the head of the list (_:b1 in above example)
            let headPos; // set to subject or object when head is set
            const graph = tailQuad.graph; // make sure list is in exactly one graph
            // Traverse the list from tail to end
            let current = tailQuad.subject;
            while(current && !malformed){
                const objectQuads = this.getQuads(null, null, current, null);
                const subjectQuads = this.getQuads(current, null, null, null);
                let quad, first = null, rest = null, parent = null;
                // Find the first and rest of this list node
                for(let i = 0; i < subjectQuads.length && !malformed; i++){
                    quad = subjectQuads[i];
                    if (!quad.graph.equals(graph)) malformed = onError(current, "not confined to single graph");
                    else if (head) malformed = onError(current, "has non-list arcs out");
                    else if (quad.predicate.value === (0, $b50e49a75dcd9196$export$2e2bcd8739ae039).rdf.first) {
                        if (first) malformed = onError(current, "has multiple rdf:first arcs");
                        else toRemove.push(first = quad);
                    } else if (quad.predicate.value === (0, $b50e49a75dcd9196$export$2e2bcd8739ae039).rdf.rest) {
                        if (rest) malformed = onError(current, "has multiple rdf:rest arcs");
                        else toRemove.push(rest = quad);
                    } else if (objectQuads.length) malformed = onError(current, "can't be subject and object");
                    else {
                        head = quad; // e.g. { (1 2 3) :p :o }
                        headPos = "subject";
                    }
                }
                // { :s :p (1 2) } arrives here with no head
                // { (1 2) :p :o } arrives here with head set to the list.
                for(let i = 0; i < objectQuads.length && !malformed; ++i){
                    quad = objectQuads[i];
                    if (head) malformed = onError(current, "can't have coreferences");
                    else if (quad.predicate.value === (0, $b50e49a75dcd9196$export$2e2bcd8739ae039).rdf.rest) {
                        if (parent) malformed = onError(current, "has incoming rdf:rest arcs");
                        else parent = quad;
                    } else {
                        head = quad; // e.g. { :s :p (1 2) }
                        headPos = "object";
                    }
                }
                // Store the list item and continue with parent
                if (!first) malformed = onError(current, "has no list head");
                else items.unshift(first.object);
                current = parent && parent.subject;
            }
            // Don't remove any quads if the list is malformed
            if (malformed) remove = false;
            else if (head) lists[head[headPos].value] = items;
        });
        // Remove list quads if requested
        if (remove) this.removeQuads(toRemove);
        return lists;
    }
    // ### Store is an iterable.
    // Can be used where iterables are expected: for...of loops, array spread operator,
    // `yield*`, and destructuring assignment (order is not guaranteed).
    *[Symbol.iterator]() {
        yield* this.readQuads();
    }
}
// Determines whether the argument is a string
function $b0dfd6227adaa9e6$var$isString(s) {
    return typeof s === "string" || s instanceof String;
}
/**
 * A class that implements both DatasetCore and Readable.
 */ class $b0dfd6227adaa9e6$var$DatasetCoreAndReadableStream extends (0, $28176da182b29f80$exports.Readable) {
    constructor(n3Store, subject, predicate, object, graph){
        super({
            objectMode: true
        });
        Object.assign(this, {
            n3Store: n3Store,
            subject: subject,
            predicate: predicate,
            object: object,
            graph: graph
        });
    }
    get filtered() {
        if (!this._filtered) {
            const { n3Store: n3Store, graph: graph, object: object, predicate: predicate, subject: subject } = this;
            const newStore = this._filtered = new $b0dfd6227adaa9e6$export$2e2bcd8739ae039({
                factory: n3Store._factory
            });
            for (const quad of n3Store.readQuads(subject, predicate, object, graph))newStore.addQuad(quad);
        }
        return this._filtered;
    }
    get size() {
        return this.filtered.size;
    }
    _read() {
        for (const quad of this)this.push(quad);
        this.push(null);
    }
    add(quad) {
        return this.filtered.add(quad);
    }
    delete(quad) {
        return this.filtered.delete(quad);
    }
    has(quad) {
        return this.filtered.has(quad);
    }
    match(subject, predicate, object, graph) {
        return new $b0dfd6227adaa9e6$var$DatasetCoreAndReadableStream(this.filtered, subject, predicate, object, graph);
    }
    *[Symbol.iterator]() {
        yield* this._filtered || this.n3Store.readQuads(this.subject, this.predicate, this.object, this.graph);
    }
}


// **N3StreamParser** parses a text stream into a quad stream.


class $6bcaa36986f53a11$export$2e2bcd8739ae039 extends (0, $28176da182b29f80$exports.Transform) {
    constructor(options){
        super({
            decodeStrings: true
        });
        this._readableState.objectMode = true;
        // Set up parser with dummy stream to obtain `data` and `end` callbacks
        const parser = new (0, $c0715e6442e25456$export$2e2bcd8739ae039)(options);
        let onData, onEnd;
        parser.parse({
            on: (event, callback)=>{
                switch(event){
                    case "data":
                        onData = callback;
                        break;
                    case "end":
                        onEnd = callback;
                        break;
                }
            }
        }, // Handle quads by pushing them down the pipeline
        (error, quad)=>{
            error && this.emit("error", error) || quad && this.push(quad);
        }, // Emit prefixes through the `prefix` event
        (prefix, uri)=>{
            this.emit("prefix", prefix, uri);
        });
        // Implement Transform methods through parser callbacks
        this._transform = (chunk, encoding, done)=>{
            onData(chunk);
            done();
        };
        this._flush = (done)=>{
            onEnd();
            done();
        };
    }
    // ### Parses a stream of strings
    import(stream) {
        stream.on("data", (chunk)=>{
            this.write(chunk);
        });
        stream.on("end", ()=>{
            this.end();
        });
        stream.on("error", (error)=>{
            this.emit("error", error);
        });
        return this;
    }
}


// **N3StreamWriter** serializes a quad stream into a text stream.


class $5cb440355f51fa91$export$2e2bcd8739ae039 extends (0, $28176da182b29f80$exports.Transform) {
    constructor(options){
        super({
            encoding: "utf8",
            writableObjectMode: true
        });
        // Set up writer with a dummy stream object
        const writer = this._writer = new (0, $bab8cb0a961d0e7d$export$2e2bcd8739ae039)({
            write: (quad, encoding, callback)=>{
                this.push(quad);
                callback && callback();
            },
            end: (callback)=>{
                this.push(null);
                callback && callback();
            }
        }, options);
        // Implement Transform methods on top of writer
        this._transform = (quad, encoding, done)=>{
            writer.addQuad(quad, done);
        };
        this._flush = (done)=>{
            writer.end(done);
        };
    }
    // ### Serializes a stream of quads
    import(stream) {
        stream.on("data", (quad)=>{
            this.write(quad);
        });
        stream.on("end", ()=>{
            this.end();
        });
        stream.on("error", (error)=>{
            this.emit("error", error);
        });
        stream.on("prefix", (prefix, iri)=>{
            this._writer.addPrefix(prefix, iri);
        });
        return this;
    }
}




var // Export all named exports as a default object for backward compatibility
$4c2b561ec056addb$export$2e2bcd8739ae039 = {
    Lexer: $c66a9a29d2de1131$export$2e2bcd8739ae039,
    Parser: $c0715e6442e25456$export$2e2bcd8739ae039,
    Writer: $bab8cb0a961d0e7d$export$2e2bcd8739ae039,
    Store: $b0dfd6227adaa9e6$export$2e2bcd8739ae039,
    StreamParser: $6bcaa36986f53a11$export$2e2bcd8739ae039,
    StreamWriter: $5cb440355f51fa91$export$2e2bcd8739ae039,
    Util: $d33ba30d5e9a7819$exports,
    DataFactory: $712f170b9f5279d6$export$2e2bcd8739ae039,
    Term: $712f170b9f5279d6$export$656c1e606ad06131,
    NamedNode: $712f170b9f5279d6$export$e55689a56c4c92c2,
    Literal: $712f170b9f5279d6$export$e175ae9e414693bc,
    BlankNode: $712f170b9f5279d6$export$1a8019c085269883,
    Variable: $712f170b9f5279d6$export$c867a5c9595a1350,
    DefaultGraph: $712f170b9f5279d6$export$4383f89a7161b240,
    Quad: $712f170b9f5279d6$export$7005c9eb6671414d,
    Triple: $712f170b9f5279d6$export$7005c9eb6671414d,
    termFromId: $712f170b9f5279d6$export$85285e91bbd99cf,
    termToId: $712f170b9f5279d6$export$fbf03d1179c9227e
};




var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");



var $99pVg = parcelRequire("99pVg");

var $4Q80K = parcelRequire("4Q80K");

var $23fob = parcelRequire("23fob");

if (typeof $fec45f84912c236b$var$Node === "undefined") //  @@@@@@ Global. Interface to xmldom.
var $fec45f84912c236b$var$Node = {
    ELEMENT_NODE: 1,
    ATTRIBUTE_NODE: 2,
    TEXT_NODE: 3,
    CDATA_SECTION_NODE: 4,
    ENTITY_REFERENCE_NODE: 5,
    ENTITY_NODE: 6,
    PROCESSING_INSTRUCTION_NODE: 7,
    COMMENT_NODE: 8,
    DOCUMENT_NODE: 9,
    DOCUMENT_TYPE_NODE: 10,
    DOCUMENT_FRAGMENT_NODE: 11,
    NOTATION_NODE: 12
};
var $fec45f84912c236b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function RDFaProcessor(kb, options) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, RDFaProcessor);
        this.options = options || {};
        this.kb = kb;
        this.target = options.target || {
            graph: {
                subjects: {},
                prefixes: {},
                terms: {}
            }
        };
        // XXX: Added to track bnodes
        this.blankNodes = [];
        // XXX: Added for normalisation
        this.htmlOptions = {
            "selfClosing": "br img input area base basefont col colgroup source wbr isindex link meta param hr"
        };
        this.theOne = "_:" + new Date().getTime();
        this.language = null;
        this.vocabulary = null;
        this.blankCounter = 0;
        this.langAttributes = [
            {
                namespaceURI: "http://www.w3.org/XML/1998/namespace",
                localName: "lang"
            }
        ];
        this.inXHTMLMode = false;
        this.absURIRE = /[\w\_\-]+:\S+/;
        this.finishedHandlers = [];
        this.init();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(RDFaProcessor, [
        {
            key: "addTriple",
            value: function addTriple(origin, subject, predicate, object) {
                var su, ob, pr, or;
                if (typeof subject === "undefined") su = (0, $158d84b4866fe33e$export$2e2bcd8739ae039).namedNode(this.options.base);
                else su = this.toRDFNodeObject(subject);
                pr = this.toRDFNodeObject(predicate);
                ob = this.toRDFNodeObject(object);
                or = (0, $158d84b4866fe33e$export$2e2bcd8739ae039).namedNode(this.options.base);
                // console.log('Adding { ' + su + ' ' + pr + ' ' + ob + ' ' + or + ' }')
                this.kb.add(su, pr, ob, or);
            }
        },
        {
            key: "ancestorPath",
            value: function ancestorPath(node) {
                var path = "";
                while(node && node.nodeType !== $fec45f84912c236b$var$Node.DOCUMENT_NODE){
                    path = "/" + node.localName + path;
                    node = node.parentNode;
                }
                return path;
            }
        },
        {
            key: "copyMappings",
            value: function copyMappings(mappings) {
                var newMappings = {};
                for(var k in mappings)newMappings[k] = mappings[k];
                return newMappings;
            }
        },
        {
            key: "copyProperties",
            value: function copyProperties() {}
        },
        {
            key: "deriveDateTimeType",
            value: function deriveDateTimeType(value) {
                for(var i = 0; i < RDFaProcessor.dateTimeTypes.length; i++){
                    // console.log("Checking "+value+" against "+RDFaProcessor.dateTimeTypes[i].type)
                    var matched = RDFaProcessor.dateTimeTypes[i].pattern.exec(value);
                    if (matched && matched[0].length === value.length) // console.log("Matched!")
                    return RDFaProcessor.dateTimeTypes[i].type;
                }
                return null;
            }
        },
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "newBlankNode",
            value: function newBlankNode() {
                this.blankCounter++;
                return "_:" + this.blankCounter;
            }
        },
        {
            key: "newSubjectOrigin",
            value: function newSubjectOrigin(origin, subject) {}
        },
        {
            key: "parseCURIE",
            value: function parseCURIE(value, prefixes, base) {
                var colon = value.indexOf(":");
                var uri;
                if (colon >= 0) {
                    var prefix = value.substring(0, colon);
                    if (prefix === "") {
                        // default prefix
                        uri = prefixes[""];
                        return uri ? uri + value.substring(colon + 1) : null;
                    } else if (prefix === "_") // blank node
                    return "_:" + value.substring(colon + 1);
                    else if (RDFaProcessor.NCNAME.test(prefix)) {
                        uri = prefixes[prefix];
                        if (uri) return uri + value.substring(colon + 1);
                    }
                }
                return null;
            }
        },
        {
            key: "parseCURIEOrURI",
            value: function parseCURIEOrURI(value, prefixes, base) {
                var curie = this.parseCURIE(value, prefixes, base);
                if (curie) return curie;
                return this.resolveAndNormalize(base, value);
            }
        },
        {
            key: "parsePredicate",
            value: function parsePredicate(value, defaultVocabulary, terms, prefixes, base, ignoreTerms) {
                if (value === "") return null;
                var predicate = this.parseTermOrCURIEOrAbsURI(value, defaultVocabulary, ignoreTerms ? null : terms, prefixes, base);
                if (predicate && predicate.indexOf("_:") === 0) return null;
                return predicate;
            }
        },
        {
            key: "parsePrefixMappings",
            value: function parsePrefixMappings(str, target) {
                var values = this.tokenize(str);
                var prefix = null;
                // var uri = null
                for(var i = 0; i < values.length; i++){
                    if (values[i][values[i].length - 1] === ":") prefix = values[i].substring(0, values[i].length - 1);
                    else if (prefix) {
                        target[prefix] = this.options.base ? $4Q80K.join(values[i], this.options.base) : values[i];
                        prefix = null;
                    }
                }
            }
        },
        {
            key: "parseSafeCURIEOrCURIEOrURI",
            value: function parseSafeCURIEOrCURIEOrURI(value, prefixes, base) {
                value = this.trim(value);
                if (value.charAt(0) === "[" && value.charAt(value.length - 1) === "]") {
                    value = value.substring(1, value.length - 1);
                    value = value.trim(value);
                    if (value.length === 0) return null;
                    if (value === "_:") // the one node
                    return this.theOne;
                    return this.parseCURIE(value, prefixes, base);
                } else return this.parseCURIEOrURI(value, prefixes, base);
            }
        },
        {
            key: "parseTermOrCURIEOrAbsURI",
            value: function parseTermOrCURIEOrAbsURI(value, defaultVocabulary, terms, prefixes, base) {
                // alert("Parsing "+value+" with default vocab "+defaultVocabulary)
                value = this.trim(value);
                var curie = this.parseCURIE(value, prefixes, base);
                if (curie) return curie;
                else if (terms) {
                    if (defaultVocabulary && !this.absURIRE.exec(value)) return defaultVocabulary + value;
                    var term = terms[value];
                    if (term) return term;
                    var lcvalue = value.toLowerCase();
                    term = terms[lcvalue];
                    if (term) return term;
                }
                if (this.absURIRE.exec(value)) return this.resolveAndNormalize(base, value);
                return null;
            }
        },
        {
            key: "parseTermOrCURIEOrURI",
            value: function parseTermOrCURIEOrURI(value, defaultVocabulary, terms, prefixes, base) {
                // alert("Parsing "+value+" with default vocab "+defaultVocabulary)
                value = this.trim(value);
                var curie = this.parseCURIE(value, prefixes, base);
                if (curie) return curie;
                else {
                    var term = terms[value];
                    if (term) return term;
                    var lcvalue = value.toLowerCase();
                    term = terms[lcvalue];
                    if (term) return term;
                    if (defaultVocabulary && !this.absURIRE.exec(value)) return defaultVocabulary + value;
                }
                return this.resolveAndNormalize(base, value);
            }
        },
        {
            key: "parseURI",
            value: function parseURI(uri) {
                return uri; // We just use strings as URIs, not objects now.
            }
        },
        {
            key: "process",
            value: function process(node, options) {
                /*
      if (!window.console) {
         window.console = { log: function() {} }
      } */ options = options || {};
                var base;
                if (node.nodeType === $fec45f84912c236b$var$Node.DOCUMENT_NODE) {
                    if (node.baseURI && !options.baseURI) options.baseURI = node.baseURI; // be defensive as DOM implementations vary
                    base = node.baseURI;
                    node = node.documentElement;
                    if (!node.baseURI) node.baseURI = base;
                    this.setContext(node);
                } else if (node.parentNode.nodeType === $fec45f84912c236b$var$Node.DOCUMENT_NODE) this.setContext(node);
                var queue = [];
                // Fix for Firefox that includes the hash in the base URI
                var removeHash = function removeHash(baseURI) {
                    // Fix for undefined baseURI property
                    if (!baseURI && options && options.baseURI) return options.baseURI;
                    var hash = baseURI.indexOf("#");
                    if (hash >= 0) baseURI = baseURI.substring(0, hash);
                    if (options && options.baseURIMap) baseURI = options.baseURIMap(baseURI);
                    return baseURI;
                };
                queue.push({
                    current: node,
                    context: this.push(null, removeHash(node.baseURI))
                });
                while(queue.length > 0){
                    var item = queue.shift();
                    if (item.parent) {
                        // Sequence Step 14: list triple generation
                        if (item.context.parent && item.context.parent.listMapping === item.listMapping) continue;
                        // console.log("Generating lists for "+item.subject+", tag "+item.parent.localName)
                        for(var _predicate in item.listMapping){
                            var list = item.listMapping[_predicate];
                            if (list.length === 0) {
                                this.addTriple(item.parent, item.subject, _predicate, {
                                    type: RDFaProcessor.objectURI,
                                    value: "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"
                                });
                                continue;
                            }
                            var bnodes = [];
                            for(var _i = 0; _i < list.length; _i++)bnodes.push(this.newBlankNode());
                            for(var _i2 = 0; _i2 < bnodes.length; _i2++){
                                this.addTriple(item.parent, bnodes[_i2], "http://www.w3.org/1999/02/22-rdf-syntax-ns#first", list[_i2]);
                                this.addTriple(item.parent, bnodes[_i2], "http://www.w3.org/1999/02/22-rdf-syntax-ns#rest", {
                                    type: RDFaProcessor.objectURI,
                                    value: _i2 + 1 < bnodes.length ? bnodes[_i2 + 1] : "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"
                                });
                            }
                            this.addTriple(item.parent, item.subject, _predicate, {
                                type: RDFaProcessor.objectURI,
                                value: bnodes[0]
                            });
                        }
                        continue;
                    }
                    var current = item.current;
                    var context = item.context;
                    // console.log("Tag: "+current.localName+", listMapping="+JSON.stringify(context.listMapping))
                    // Sequence Step 1
                    var skip = false;
                    var newSubject = null;
                    var currentObjectResource = null;
                    var typedResource = null;
                    var prefixes = context.prefixes;
                    var prefixesCopied = false;
                    var incomplete = [];
                    var listMapping = context.listMapping;
                    var listMappingDifferent = !context.parent;
                    var language = context.language;
                    var vocabulary = context.vocabulary;
                    // TODO: the "base" element may be used for HTML+RDFa 1.1
                    base = this.parseURI(removeHash(current.baseURI));
                    current.item = null;
                    // Sequence Step 2: set the default vocabulary
                    var vocabAtt = current.getAttributeNode("vocab");
                    if (vocabAtt) {
                        var value = this.trim(vocabAtt.value);
                        if (value.length > 0) {
                            vocabulary = value;
                            var baseSubject = base.spec;
                            // this.newSubject(current,baseSubject)
                            this.addTriple(current, baseSubject, "http://www.w3.org/ns/rdfa#usesVocabulary", {
                                type: RDFaProcessor.objectURI,
                                value: vocabulary
                            });
                        } else vocabulary = this.vocabulary;
                    }
                    // Sequence Step 3: IRI mappings
                    // handle xmlns attributes
                    for(var i = 0; i < current.attributes.length; i++){
                        var att = current.attributes[i];
                        // if (att.namespaceURI=="http://www.w3.org/2000/xmlns/") {
                        if (att.nodeName.charAt(0) === "x" && att.nodeName.indexOf("xmlns:") === 0) {
                            if (!prefixesCopied) {
                                prefixes = this.copyMappings(prefixes);
                                prefixesCopied = true;
                            }
                            var prefix = att.nodeName.substring(6);
                            // TODO: resolve relative?
                            var ref = RDFaProcessor.trim(att.value);
                            prefixes[prefix] = this.options.base ? $4Q80K.join(ref, this.options.base) : ref;
                        }
                    }
                    // Handle prefix mappings (@prefix)
                    var prefixAtt = current.getAttributeNode("prefix");
                    if (prefixAtt) {
                        if (!prefixesCopied) {
                            prefixes = this.copyMappings(prefixes);
                            prefixesCopied = true;
                        }
                        this.parsePrefixMappings(prefixAtt.value, prefixes);
                    }
                    // Sequence Step 4: language
                    var xmlLangAtt = null;
                    for(var _i3 = 0; !xmlLangAtt && _i3 < this.langAttributes.length; _i3++)xmlLangAtt = current.getAttributeNodeNS(this.langAttributes[_i3].namespaceURI, this.langAttributes[_i3].localName);
                    if (xmlLangAtt) {
                        var _value = RDFaProcessor.trim(xmlLangAtt.value);
                        if (_value.length > 0) language = _value;
                        else language = null;
                    }
                    var relAtt = current.getAttributeNode("rel");
                    var revAtt = current.getAttributeNode("rev");
                    var typeofAtt = current.getAttributeNode("typeof");
                    var propertyAtt = current.getAttributeNode("property");
                    var datatypeAtt = current.getAttributeNode("datatype");
                    var datetimeAtt = this.inHTMLMode ? current.getAttributeNode("datetime") : null;
                    var contentAtt = current.getAttributeNode("content");
                    var aboutAtt = current.getAttributeNode("about");
                    var srcAtt = current.getAttributeNode("src");
                    var resourceAtt = current.getAttributeNode("resource");
                    var hrefAtt = current.getAttributeNode("href");
                    var inlistAtt = current.getAttributeNode("inlist");
                    var relAttPredicates = [];
                    var predicate, values;
                    if (relAtt) {
                        values = this.tokenize(relAtt.value);
                        for(var _i4 = 0; _i4 < values.length; _i4++){
                            predicate = this.parsePredicate(values[_i4], vocabulary, context.terms, prefixes, base, this.inHTMLMode && propertyAtt !== null);
                            if (predicate) relAttPredicates.push(predicate);
                        }
                    }
                    var revAttPredicates = [];
                    if (revAtt) {
                        values = this.tokenize(revAtt.value);
                        for(var _i5 = 0; _i5 < values.length; _i5++){
                            predicate = this.parsePredicate(values[_i5], vocabulary, context.terms, prefixes, base, this.inHTMLMode && propertyAtt);
                            if (predicate) revAttPredicates.push(predicate);
                        }
                    }
                    // Section 3.1, bullet 7
                    if (this.inHTMLMode && (relAtt || revAtt) && propertyAtt) {
                        if (relAttPredicates.length === 0) relAtt = null;
                        if (revAttPredicates.length === 0) revAtt = null;
                    }
                    if (relAtt || revAtt) {
                        // Sequence Step 6: establish new subject and value
                        if (aboutAtt) newSubject = this.parseSafeCURIEOrCURIEOrURI(aboutAtt.value, prefixes, base);
                        if (typeofAtt) typedResource = newSubject;
                        if (!newSubject) {
                            if (current.parentNode.nodeType === $fec45f84912c236b$var$Node.DOCUMENT_NODE) newSubject = removeHash(current.baseURI);
                            else if (context.parentObject) // TODO: Verify: If the xml:base has been set and the parentObject is the baseURI of the parent, then the subject needs to be the new base URI
                            newSubject = removeHash(current.parentNode.baseURI) === context.parentObject ? removeHash(current.baseURI) : context.parentObject;
                        }
                        if (resourceAtt) currentObjectResource = this.parseSafeCURIEOrCURIEOrURI(resourceAtt.value, prefixes, base);
                        if (!currentObjectResource) {
                            if (hrefAtt) currentObjectResource = this.resolveAndNormalize(base, encodeURI(hrefAtt.value));
                            else if (srcAtt) currentObjectResource = this.resolveAndNormalize(base, encodeURI(srcAtt.value));
                            else if (typeofAtt && !aboutAtt && !(this.inXHTMLMode && (current.localName === "head" || current.localName === "body"))) currentObjectResource = this.newBlankNode();
                        }
                        if (typeofAtt && !aboutAtt && this.inXHTMLMode && (current.localName === "head" || current.localName === "body")) typedResource = newSubject;
                        else if (typeofAtt && !aboutAtt) typedResource = currentObjectResource;
                    } else if (propertyAtt && !contentAtt && !datatypeAtt) {
                        // Sequence Step 5.1: establish a new subject
                        if (aboutAtt) {
                            newSubject = this.parseSafeCURIEOrCURIEOrURI(aboutAtt.value, prefixes, base);
                            if (typeofAtt) typedResource = newSubject;
                        }
                        if (!newSubject && current.parentNode.nodeType === $fec45f84912c236b$var$Node.DOCUMENT_NODE) {
                            newSubject = removeHash(current.baseURI);
                            if (typeofAtt) typedResource = newSubject;
                        } else if (!newSubject && context.parentObject) // TODO: Verify: If the xml:base has been set and the parentObject is the baseURI of the parent, then the subject needs to be the new base URI
                        newSubject = removeHash(current.parentNode.baseURI) === context.parentObject ? removeHash(current.baseURI) : context.parentObject;
                        if (typeofAtt && !typedResource) {
                            if (resourceAtt) typedResource = this.parseSafeCURIEOrCURIEOrURI(resourceAtt.value, prefixes, base);
                            if (!typedResource && hrefAtt) typedResource = this.resolveAndNormalize(base, encodeURI(hrefAtt.value));
                            if (!typedResource && srcAtt) typedResource = this.resolveAndNormalize(base, encodeURI(srcAtt.value));
                            if (!typedResource && (this.inXHTMLMode || this.inHTMLMode) && (current.localName === "head" || current.localName === "body")) typedResource = newSubject;
                            if (!typedResource) typedResource = this.newBlankNode();
                            currentObjectResource = typedResource;
                        }
                    // console.log(current.localName+", newSubject="+newSubject+", typedResource="+typedResource+", currentObjectResource="+currentObjectResource)
                    } else {
                        // Sequence Step 5.2: establish a new subject
                        if (aboutAtt) newSubject = this.parseSafeCURIEOrCURIEOrURI(aboutAtt.value, prefixes, base);
                        if (!newSubject && resourceAtt) newSubject = this.parseSafeCURIEOrCURIEOrURI(resourceAtt.value, prefixes, base);
                        if (!newSubject && hrefAtt) newSubject = this.resolveAndNormalize(base, encodeURI(hrefAtt.value));
                        if (!newSubject && srcAtt) newSubject = this.resolveAndNormalize(base, encodeURI(srcAtt.value));
                        if (!newSubject) {
                            if (current.parentNode.nodeType === $fec45f84912c236b$var$Node.DOCUMENT_NODE) newSubject = removeHash(current.baseURI);
                            else if ((this.inXHTMLMode || this.inHTMLMode) && (current.localName === "head" || current.localName === "body")) newSubject = removeHash(current.parentNode.baseURI) === context.parentObject ? removeHash(current.baseURI) : context.parentObject;
                            else if (typeofAtt) newSubject = this.newBlankNode();
                            else if (context.parentObject) {
                                // TODO: Verify: If the xml:base has been set and the parentObject is the baseURI of the parent, then the subject needs to be the new base URI
                                newSubject = removeHash(current.parentNode.baseURI) === context.parentObject ? removeHash(current.baseURI) : context.parentObject;
                                if (!propertyAtt) skip = true;
                            }
                        }
                        if (typeofAtt) typedResource = newSubject;
                    }
                    // console.log(current.tagName+": newSubject="+newSubject+", currentObjectResource="+currentObjectResource+", typedResource="+typedResource+", skip="+skip)
                    // var rdfaData = null
                    if (newSubject) // this.newSubject(current,newSubject)
                    {
                        if (aboutAtt || resourceAtt || typedResource) {
                            var id = newSubject;
                            if (typeofAtt && !aboutAtt && !resourceAtt && currentObjectResource) id = currentObjectResource;
                            // console.log("Setting data attribute for "+current.localName+" for subject "+id)
                            this.newSubjectOrigin(current, id);
                        }
                    }
                    // Sequence Step 7: generate type triple
                    if (typedResource) {
                        values = this.tokenize(typeofAtt.value);
                        for(var _i6 = 0; _i6 < values.length; _i6++){
                            var object = this.parseTermOrCURIEOrAbsURI(values[_i6], vocabulary, context.terms, prefixes, base);
                            if (object) this.addTriple(current, typedResource, RDFaProcessor.typeURI, {
                                type: RDFaProcessor.objectURI,
                                value: object
                            });
                        }
                    }
                    // Sequence Step 8: new list mappings if there is a new subject
                    // console.log("Step 8: newSubject="+newSubject+", context.parentObject="+context.parentObject)
                    if (newSubject && newSubject !== context.parentObject) {
                        // console.log("Generating new list mapping for "+newSubject)
                        listMapping = {};
                        listMappingDifferent = true;
                    }
                    // Sequence Step 9: generate object triple
                    if (currentObjectResource) {
                        if (relAtt && inlistAtt) for(var _i7 = 0; _i7 < relAttPredicates.length; _i7++){
                            var _list = listMapping[relAttPredicates[_i7]];
                            if (!_list) {
                                _list = [];
                                listMapping[relAttPredicates[_i7]] = _list;
                            }
                            _list.push({
                                type: RDFaProcessor.objectURI,
                                value: currentObjectResource
                            });
                        }
                        else if (relAtt) for(var _i8 = 0; _i8 < relAttPredicates.length; _i8++)this.addTriple(current, newSubject, relAttPredicates[_i8], {
                            type: RDFaProcessor.objectURI,
                            value: currentObjectResource
                        });
                        if (revAtt) for(var _i9 = 0; _i9 < revAttPredicates.length; _i9++)this.addTriple(current, currentObjectResource, revAttPredicates[_i9], {
                            type: RDFaProcessor.objectURI,
                            value: newSubject
                        });
                    } else {
                        // Sequence Step 10: incomplete triples
                        if (newSubject && !currentObjectResource && (relAtt || revAtt)) currentObjectResource = this.newBlankNode();
                        if (relAtt && inlistAtt) for(var _i10 = 0; _i10 < relAttPredicates.length; _i10++){
                            var _list2 = listMapping[relAttPredicates[_i10]];
                            if (!_list2) {
                                _list2 = [];
                                listMapping[predicate] = _list2;
                            }
                            // console.log("Adding incomplete list for "+predicate)
                            incomplete.push({
                                predicate: relAttPredicates[_i10],
                                list: _list2
                            });
                        }
                        else if (relAtt) for(var _i11 = 0; _i11 < relAttPredicates.length; _i11++)incomplete.push({
                            predicate: relAttPredicates[_i11],
                            forward: true
                        });
                        if (revAtt) for(var _i12 = 0; _i12 < revAttPredicates.length; _i12++)incomplete.push({
                            predicate: revAttPredicates[_i12],
                            forward: false
                        });
                    }
                    // Step 11: Current property values
                    if (propertyAtt) {
                        var datatype = null;
                        var content = null;
                        if (datatypeAtt) {
                            datatype = datatypeAtt.value === "" ? RDFaProcessor.PlainLiteralURI : this.parseTermOrCURIEOrAbsURI(datatypeAtt.value, vocabulary, context.terms, prefixes, base);
                            if (datetimeAtt && !contentAtt) content = datetimeAtt.value;
                            else content = datatype === RDFaProcessor.XMLLiteralURI || datatype === RDFaProcessor.HTMLLiteralURI ? null : contentAtt ? contentAtt.value : current.textContent;
                        } else if (contentAtt) {
                            datatype = RDFaProcessor.PlainLiteralURI;
                            content = contentAtt.value;
                        } else if (datetimeAtt) {
                            content = datetimeAtt.value;
                            datatype = RDFaProcessor.deriveDateTimeType(content);
                            if (!datatype) datatype = RDFaProcessor.PlainLiteralURI;
                        } else if (!relAtt && !revAtt) {
                            if (resourceAtt) content = this.parseSafeCURIEOrCURIEOrURI(resourceAtt.value, prefixes, base);
                            if (!content && hrefAtt) content = this.resolveAndNormalize(base, encodeURI(hrefAtt.value));
                            else if (!content && srcAtt) content = this.resolveAndNormalize(base, encodeURI(srcAtt.value));
                            if (content) datatype = RDFaProcessor.objectURI;
                        }
                        if (!datatype) {
                            if (typeofAtt && !aboutAtt) {
                                datatype = RDFaProcessor.objectURI;
                                content = typedResource;
                            } else {
                                content = current.textContent;
                                if (this.inHTMLMode && current.localName === "time") datatype = RDFaProcessor.deriveDateTimeType(content);
                                if (!datatype) datatype = RDFaProcessor.PlainLiteralURI;
                            }
                        }
                        values = this.tokenize(propertyAtt.value);
                        for(var _i13 = 0; _i13 < values.length; _i13++){
                            var _predicate2 = this.parsePredicate(values[_i13], vocabulary, context.terms, prefixes, base);
                            if (_predicate2) {
                                if (inlistAtt) {
                                    var _list3 = listMapping[_predicate2];
                                    if (!_list3) {
                                        _list3 = [];
                                        listMapping[_predicate2] = _list3;
                                    }
                                    _list3.push(datatype === RDFaProcessor.XMLLiteralURI || datatype === RDFaProcessor.HTMLLiteralURI ? {
                                        type: datatype,
                                        value: current.childNodes
                                    } : {
                                        type: datatype || RDFaProcessor.PlainLiteralURI,
                                        value: content,
                                        language: language
                                    });
                                } else if (datatype === RDFaProcessor.XMLLiteralURI || datatype === RDFaProcessor.HTMLLiteralURI) this.addTriple(current, newSubject, _predicate2, {
                                    type: datatype,
                                    value: current.childNodes
                                });
                                else this.addTriple(current, newSubject, _predicate2, {
                                    type: datatype || RDFaProcessor.PlainLiteralURI,
                                    value: content,
                                    language: language
                                });
                            }
                        }
                    }
                    // Sequence Step 12: complete incomplete triples with new subject
                    if (newSubject && !skip) for(var _i14 = 0; _i14 < context.incomplete.length; _i14++){
                        if (context.incomplete[_i14].list) // console.log("Adding subject "+newSubject+" to list for "+context.incomplete[i].predicate)
                        // TODO: it is unclear what to do here
                        context.incomplete[_i14].list.push({
                            type: RDFaProcessor.objectURI,
                            value: newSubject
                        });
                        else if (context.incomplete[_i14].forward) // console.log(current.tagName+": completing forward triple "+context.incomplete[i].predicate+" with object="+newSubject)
                        this.addTriple(current, context.subject, context.incomplete[_i14].predicate, {
                            type: RDFaProcessor.objectURI,
                            value: newSubject
                        });
                        else // console.log(current.tagName+": completing reverse triple with object="+context.subject)
                        this.addTriple(current, newSubject, context.incomplete[_i14].predicate, {
                            type: RDFaProcessor.objectURI,
                            value: context.subject
                        });
                    }
                    var childContext = null;
                    var listSubject = newSubject;
                    if (skip) {
                        // TODO: should subject be null?
                        childContext = this.push(context, context.subject);
                        // TODO: should the entObject be passed along?  If not, then intermediary children will keep properties from being associated with incomplete triples.
                        // TODO: Verify: if the current baseURI has changed and the parentObject is the parent's base URI, then the baseURI should change
                        childContext.parentObject = removeHash(current.parentNode.baseURI) === context.parentObject ? removeHash(current.baseURI) : context.parentObject;
                        childContext.incomplete = context.incomplete;
                        childContext.language = language;
                        childContext.prefixes = prefixes;
                        childContext.vocabulary = vocabulary;
                    } else {
                        childContext = this.push(context, newSubject);
                        childContext.parentObject = currentObjectResource || newSubject || context.subject;
                        childContext.prefixes = prefixes;
                        childContext.incomplete = incomplete;
                        if (currentObjectResource) {
                            // console.log("Generating new list mapping for "+currentObjectResource)
                            listSubject = currentObjectResource;
                            listMapping = {};
                            listMappingDifferent = true;
                        }
                        childContext.listMapping = listMapping;
                        childContext.language = language;
                        childContext.vocabulary = vocabulary;
                    }
                    if (listMappingDifferent) // console.log("Pushing list parent "+current.localName)
                    queue.unshift({
                        parent: current,
                        context: context,
                        subject: listSubject,
                        listMapping: listMapping
                    });
                    for(var child = current.lastChild; child; child = child.previousSibling)if (child.nodeType === $fec45f84912c236b$var$Node.ELEMENT_NODE) // console.log("Pushing child "+child.localName)
                    // child.baseURI = current.baseURI
                    queue.unshift({
                        current: child,
                        context: childContext
                    });
                }
                if (this.inHTMLMode) this.copyProperties();
                for(var _i15 = 0; _i15 < this.finishedHandlers.length; _i15++)this.finishedHandlers[_i15](node);
            }
        },
        {
            key: "push",
            value: function push(parent, subject) {
                return {
                    parent: parent,
                    subject: subject || (parent ? parent.subject : null),
                    parentObject: null,
                    incomplete: [],
                    listMapping: parent ? parent.listMapping : {},
                    language: parent ? parent.language : this.language,
                    prefixes: parent ? parent.prefixes : this.target.graph.prefixes,
                    terms: parent ? parent.terms : this.target.graph.terms,
                    vocabulary: parent ? parent.vocabulary : this.vocabulary
                };
            }
        },
        {
            key: "resolveAndNormalize",
            value: function resolveAndNormalize(base, uri) {
                // console.log("Joining " + uri + " to " + base + " making " +  Uri.join(uri, base))
                return $4Q80K.join(uri, base); // @@ normalize?
            }
        },
        {
            key: "setContext",
            value: function setContext(node) {
                // We only recognized XHTML+RDFa 1.1 if the version is set propertyly
                if (node.localName === "html" && node.getAttribute("version") === "XHTML+RDFa 1.1") this.setXHTMLContext();
                else if (node.localName === "html" || node.namespaceURI === "http://www.w3.org/1999/xhtml") {
                    if (typeof document !== "undefined" && document.doctype) {
                        if (document.doctype.publicId === "-//W3C//DTD XHTML+RDFa 1.0//EN" && document.doctype.systemId === "http://www.w3.org/MarkUp/DTD/xhtml-rdfa-1.dtd") {
                            console.log("WARNING: RDF 1.0 is not supported.  Defaulting to HTML5 mode.");
                            this.setHTMLContext();
                        } else if (document.doctype.publicId === "-//W3C//DTD XHTML+RDFa 1.1//EN" && document.doctype.systemId === "http://www.w3.org/MarkUp/DTD/xhtml-rdfa-2.dtd") this.setXHTMLContext();
                        else this.setHTMLContext();
                    } else this.setHTMLContext();
                } else this.setXMLContext();
            }
        },
        {
            key: "setHTMLContext",
            value: function setHTMLContext() {
                this.setInitialContext();
                this.langAttributes = [
                    {
                        namespaceURI: "http://www.w3.org/XML/1998/namespace",
                        localName: "lang"
                    },
                    {
                        namespaceURI: null,
                        localName: "lang"
                    }
                ];
                this.inXHTMLMode = false;
                this.inHTMLMode = true;
            }
        },
        {
            key: "setInitialContext",
            value: function setInitialContext() {
                this.vocabulary = null;
                // By default, the prefixes are terms are loaded to the RDFa 1.1. standard within the graph constructor
                this.langAttributes = [
                    {
                        namespaceURI: "http://www.w3.org/XML/1998/namespace",
                        localName: "lang"
                    }
                ];
            }
        },
        {
            key: "setXHTMLContext",
            value: function setXHTMLContext() {
                this.setInitialContext();
                this.inXHTMLMode = true;
                this.inHTMLMode = false;
                this.langAttributes = [
                    {
                        namespaceURI: "http://www.w3.org/XML/1998/namespace",
                        localName: "lang"
                    },
                    {
                        namespaceURI: null,
                        localName: "lang"
                    }
                ];
                // From http://www.w3.org/2011/rdfa-context/xhtml-rdfa-1.1
                this.target.graph.terms["alternate"] = "http://www.w3.org/1999/xhtml/vocab#alternate";
                this.target.graph.terms["appendix"] = "http://www.w3.org/1999/xhtml/vocab#appendix";
                this.target.graph.terms["bookmark"] = "http://www.w3.org/1999/xhtml/vocab#bookmark";
                this.target.graph.terms["cite"] = "http://www.w3.org/1999/xhtml/vocab#cite";
                this.target.graph.terms["chapter"] = "http://www.w3.org/1999/xhtml/vocab#chapter";
                this.target.graph.terms["contents"] = "http://www.w3.org/1999/xhtml/vocab#contents";
                this.target.graph.terms["copyright"] = "http://www.w3.org/1999/xhtml/vocab#copyright";
                this.target.graph.terms["first"] = "http://www.w3.org/1999/xhtml/vocab#first";
                this.target.graph.terms["glossary"] = "http://www.w3.org/1999/xhtml/vocab#glossary";
                this.target.graph.terms["help"] = "http://www.w3.org/1999/xhtml/vocab#help";
                this.target.graph.terms["icon"] = "http://www.w3.org/1999/xhtml/vocab#icon";
                this.target.graph.terms["index"] = "http://www.w3.org/1999/xhtml/vocab#index";
                this.target.graph.terms["last"] = "http://www.w3.org/1999/xhtml/vocab#last";
                this.target.graph.terms["license"] = "http://www.w3.org/1999/xhtml/vocab#license";
                this.target.graph.terms["meta"] = "http://www.w3.org/1999/xhtml/vocab#meta";
                this.target.graph.terms["next"] = "http://www.w3.org/1999/xhtml/vocab#next";
                this.target.graph.terms["prev"] = "http://www.w3.org/1999/xhtml/vocab#prev";
                this.target.graph.terms["previous"] = "http://www.w3.org/1999/xhtml/vocab#previous";
                this.target.graph.terms["section"] = "http://www.w3.org/1999/xhtml/vocab#section";
                this.target.graph.terms["stylesheet"] = "http://www.w3.org/1999/xhtml/vocab#stylesheet";
                this.target.graph.terms["subsection"] = "http://www.w3.org/1999/xhtml/vocab#subsection";
                this.target.graph.terms["start"] = "http://www.w3.org/1999/xhtml/vocab#start";
                this.target.graph.terms["top"] = "http://www.w3.org/1999/xhtml/vocab#top";
                this.target.graph.terms["up"] = "http://www.w3.org/1999/xhtml/vocab#up";
                this.target.graph.terms["p3pv1"] = "http://www.w3.org/1999/xhtml/vocab#p3pv1";
                // other
                this.target.graph.terms["related"] = "http://www.w3.org/1999/xhtml/vocab#related";
                this.target.graph.terms["role"] = "http://www.w3.org/1999/xhtml/vocab#role";
                this.target.graph.terms["transformation"] = "http://www.w3.org/1999/xhtml/vocab#transformation";
            }
        },
        {
            key: "setXMLContext",
            value: function setXMLContext() {
                this.setInitialContext();
                this.inXHTMLMode = false;
                this.inHTMLMode = false;
            }
        },
        {
            key: "tokenize",
            value: function tokenize(str) {
                return this.trim(str).split(/\s+/);
            }
        },
        {
            key: "toRDFNodeObject",
            value: function toRDFNodeObject(x) {
                var _this = this;
                if (typeof x === "undefined") return undefined;
                if (typeof x === "string") {
                    if (x.substring(0, 2) === "_:") {
                        if (typeof this.blankNodes[x.substring(2)] === "undefined") this.blankNodes[x.substring(2)] = new (0, $d0a63e5194c4f691$export$2e2bcd8739ae039)(x.substring(2));
                        return this.blankNodes[x.substring(2)];
                    }
                    return (0, $158d84b4866fe33e$export$2e2bcd8739ae039).namedNode(x);
                }
                switch(x.type){
                    case RDFaProcessor.objectURI:
                        if (x.value.substring(0, 2) === "_:") {
                            if (typeof this.blankNodes[x.value.substring(2)] === "undefined") this.blankNodes[x.value.substring(2)] = new (0, $d0a63e5194c4f691$export$2e2bcd8739ae039)(x.value.substring(2));
                            return this.blankNodes[x.value.substring(2)];
                        }
                        return (0, $158d84b4866fe33e$export$2e2bcd8739ae039).namedNode(x.value);
                    case RDFaProcessor.PlainLiteralURI:
                        return new (0, $68c7b1d3a79e3436$export$2e2bcd8739ae039)(x.value, x.language || "");
                    case RDFaProcessor.XMLLiteralURI:
                    case RDFaProcessor.HTMLLiteralURI:
                        var string = "";
                        Object.keys(x.value).forEach(function(i) {
                            string += $23fob.domToString(x.value[i], _this.htmlOptions);
                        });
                        return new (0, $68c7b1d3a79e3436$export$2e2bcd8739ae039)(string, "", new (0, $99pVg.default)(x.type));
                    default:
                        return new (0, $68c7b1d3a79e3436$export$2e2bcd8739ae039)(x.value, "", new (0, $99pVg.default)(x.type));
                }
            }
        },
        {
            key: "trim",
            value: function trim(str) {
                return str.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
            }
        }
    ], [
        {
            key: "parseRDFaDOM",
            value: function parseRDFaDOM(dom, kb, base) {
                var p = new RDFaProcessor(kb, {
                    "base": base
                });
                //  Cannot assign to read only property 'baseURI' of object '#<XMLDocument>':
                if (!dom.baseURI) // Note this became a read-only attribute some time before 2018
                dom.baseURI = base; // oinly set if not already set
                p.process(dom, {
                    baseURI: base
                });
            }
        },
        {
            key: "tokenize",
            value: function tokenize(str) {
                return this.trim(str).split(/\s+/);
            }
        },
        {
            key: "trim",
            value: function trim(str) {
                return str.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
            }
        }
    ]);
    return RDFaProcessor;
}();
$fec45f84912c236b$export$2e2bcd8739ae039.XMLLiteralURI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#XMLLiteral";
$fec45f84912c236b$export$2e2bcd8739ae039.HTMLLiteralURI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#HTML";
$fec45f84912c236b$export$2e2bcd8739ae039.PlainLiteralURI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#PlainLiteral";
$fec45f84912c236b$export$2e2bcd8739ae039.objectURI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#object";
$fec45f84912c236b$export$2e2bcd8739ae039.typeURI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#type";
$fec45f84912c236b$export$2e2bcd8739ae039.nameChar = "[-A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u10000-\uEFFFF.0-9\xb7\u0300-\u036F\u203F-\u2040]";
$fec45f84912c236b$export$2e2bcd8739ae039.nameStartChar = "[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u0131\u0134-\u013E\u0141-\u0148\u014A-\u017E\u0180-\u01C3\u01CD-\u01F0\u01F4-\u01F5\u01FA-\u0217\u0250-\u02A8\u02BB-\u02C1\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03CE\u03D0-\u03D6\u03DA\u03DC\u03DE\u03E0\u03E2-\u03F3\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E-\u0481\u0490-\u04C4\u04C7-\u04C8\u04CB-\u04CC\u04D0-\u04EB\u04EE-\u04F5\u04F8-\u04F9\u0531-\u0556\u0559\u0561-\u0586\u05D0-\u05EA\u05F0-\u05F2\u0621-\u063A\u0641-\u064A\u0671-\u06B7\u06BA-\u06BE\u06C0-\u06CE\u06D0-\u06D3\u06D5\u06E5-\u06E6\u0905-\u0939\u093D\u0958-\u0961\u0985-\u098C\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09DC-\u09DD\u09DF-\u09E1\u09F0-\u09F1\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33\u0A35-\u0A36\u0A38-\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8B\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0AE0\u0B05-\u0B0C\u0B0F-\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B36-\u0B39\u0B3D\u0B5C-\u0B5D\u0B5F-\u0B61\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB5\u0BB7-\u0BB9\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C60-\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CDE\u0CE0-\u0CE1\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D28\u0D2A-\u0D39\u0D60-\u0D61\u0E01-\u0E2E\u0E30\u0E32-\u0E33\u0E40-\u0E45\u0E81-\u0E82\u0E84\u0E87-\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA-\u0EAB\u0EAD-\u0EAE\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0F40-\u0F47\u0F49-\u0F69\u10A0-\u10C5\u10D0-\u10F6\u1100\u1102-\u1103\u1105-\u1107\u1109\u110B-\u110C\u110E-\u1112\u113C\u113E\u1140\u114C\u114E\u1150\u1154-\u1155\u1159\u115F-\u1161\u1163\u1165\u1167\u1169\u116D-\u116E\u1172-\u1173\u1175\u119E\u11A8\u11AB\u11AE-\u11AF\u11B7-\u11B8\u11BA\u11BC-\u11C2\u11EB\u11F0\u11F9\u1E00-\u1E9B\u1EA0-\u1EF9\u1F00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2126\u212A-\u212B\u212E\u2180-\u2182\u3041-\u3094\u30A1-\u30FA\u3105-\u312C\uAC00-\uD7A3\u4E00-\u9FA5\u3007\u3021-\u3029_]";
$fec45f84912c236b$export$2e2bcd8739ae039.NCNAME = new RegExp("^" + $fec45f84912c236b$export$2e2bcd8739ae039.nameStartChar + $fec45f84912c236b$export$2e2bcd8739ae039.nameChar + "*$");
/*
RDFaProcessor.prototype.resolveAndNormalize = function(base,href) {
   var u = base.resolve(href)
   var parsed = this.parseURI(u)
   parsed.normalize()
   return parsed.spec
}
*/ $fec45f84912c236b$export$2e2bcd8739ae039.dateTimeTypes = [
    {
        pattern: /-?P(?:[0-9]+Y)?(?:[0-9]+M)?(?:[0-9]+D)?(?:T(?:[0-9]+H)?(?:[0-9]+M)?(?:[0-9]+(?:\.[0-9]+)?S)?)?/,
        type: "http://www.w3.org/2001/XMLSchema#duration"
    },
    {
        pattern: /-?(?:[1-9][0-9][0-9][0-9]|0[1-9][0-9][0-9]|00[1-9][0-9]|000[1-9])-[0-9][0-9]-[0-9][0-9]T(?:[0-1][0-9]|2[0-4]):[0-5][0-9]:[0-5][0-9](?:\.[0-9]+)?(?:Z|[+\-][0-9][0-9]:[0-9][0-9])?/,
        type: "http://www.w3.org/2001/XMLSchema#dateTime"
    },
    {
        pattern: /-?(?:[1-9][0-9][0-9][0-9]|0[1-9][0-9][0-9]|00[1-9][0-9]|000[1-9])-[0-9][0-9]-[0-9][0-9](?:Z|[+\-][0-9][0-9]:[0-9][0-9])?/,
        type: "http://www.w3.org/2001/XMLSchema#date"
    },
    {
        pattern: /(?:[0-1][0-9]|2[0-4]):[0-5][0-9]:[0-5][0-9](?:\.[0-9]+)?(?:Z|[+\-][0-9][0-9]:[0-9][0-9])?/,
        type: "http://www.w3.org/2001/XMLSchema#time"
    },
    {
        pattern: /-?(?:[1-9][0-9][0-9][0-9]|0[1-9][0-9][0-9]|00[1-9][0-9]|000[1-9])-[0-9][0-9]/,
        type: "http://www.w3.org/2001/XMLSchema#gYearMonth"
    },
    {
        pattern: /-?[1-9][0-9][0-9][0-9]|0[1-9][0-9][0-9]|00[1-9][0-9]|000[1-9]/,
        type: "http://www.w3.org/2001/XMLSchema#gYear"
    }
];
var $fec45f84912c236b$export$912cd33c0e79bc14 = $fec45f84912c236b$export$2e2bcd8739ae039.parseRDFaDOM;



var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $4Q80K = parcelRequire("4Q80K");
var $4fc73169c933142c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /*
   * @constructor
   * @param {RDFStore} store An RDFStore object
   */ function RDFParser(store) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, RDFParser);
        /** Our triple store reference @private */ this.store = store; /** Our identified blank nodes @private */ 
        this.bnodes = {}; /** A context for context-aware stores @private */ 
        this.why = null; /** Reification flag */ 
        this.reify = false;
    }
    /** Standard namespaces that we know how to handle @final
   *  @member RDFParser
   */ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(RDFParser, [
        {
            key: "frameFactory",
            value: /**
     * Frame class for namespace and base URI lookups
     * Base lookups will always resolve because the parser knows
     * the default base.
     *
     * @private
     */ function frameFactory(parser, parent, element) {
                return {
                    "NODE": 1,
                    "ARC": 2,
                    "parent": parent,
                    "parser": parser,
                    "store": parser.store,
                    "element": element,
                    "lastChild": 0,
                    "base": null,
                    "lang": null,
                    "node": null,
                    "nodeType": null,
                    "listIndex": 1,
                    "rdfid": null,
                    "datatype": null,
                    "collection": false,
                    /** Terminate the frame and notify the store that we're done */ "terminateFrame": function terminateFrame() {
                        if (this.collection) this.node.close();
                    },
                    /** Add a symbol of a certain type to the this frame */ "addSymbol": function addSymbol(type, uri) {
                        uri = $4Q80K.join(uri, this.base);
                        this.node = this.store.sym(uri);
                        this.nodeType = type;
                    },
                    /** Load any constructed triples into the store */ "loadTriple": function loadTriple() {
                        if (this.parent.parent.collection) this.parent.parent.node.append(this.node);
                        else this.store.add(this.parent.parent.node, this.parent.node, this.node, this.parser.why);
                        if (this.parent.rdfid != null) {
                            // reify
                            var triple = this.store.sym($4Q80K.join("#" + this.parent.rdfid, this.base));
                            this.store.add(triple, this.store.sym(RDFParser.ns.RDF + "type"), this.store.sym(RDFParser.ns.RDF + "Statement"), this.parser.why);
                            this.store.add(triple, this.store.sym(RDFParser.ns.RDF + "subject"), this.parent.parent.node, this.parser.why);
                            this.store.add(triple, this.store.sym(RDFParser.ns.RDF + "predicate"), this.parent.node, this.parser.why);
                            this.store.add(triple, this.store.sym(RDFParser.ns.RDF + "object"), this.node, this.parser.why);
                        }
                    },
                    /** Check if it's OK to load a triple */ "isTripleToLoad": function isTripleToLoad() {
                        return this.parent != null && this.parent.parent != null && this.nodeType === this.NODE && this.parent.nodeType === this.ARC && this.parent.parent.nodeType === this.NODE;
                    },
                    /** Add a symbolic node to this frame */ "addNode": function addNode(uri) {
                        this.addSymbol(this.NODE, uri);
                        if (this.isTripleToLoad()) this.loadTriple();
                    },
                    /** Add a collection node to this frame */ "addCollection": function addCollection() {
                        this.nodeType = this.NODE;
                        this.node = this.store.collection();
                        this.collection = true;
                        if (this.isTripleToLoad()) this.loadTriple();
                    },
                    /** Add a collection arc to this frame */ "addCollectionArc": function addCollectionArc() {
                        this.nodeType = this.ARC;
                    },
                    /** Add a bnode to this frame */ "addBNode": function addBNode(id) {
                        if (id != null) {
                            if (this.parser.bnodes[id] != null) this.node = this.parser.bnodes[id];
                            else this.node = this.parser.bnodes[id] = this.store.bnode();
                        } else this.node = this.store.bnode();
                        this.nodeType = this.NODE;
                        if (this.isTripleToLoad()) this.loadTriple();
                    },
                    /** Add an arc or property to this frame */ "addArc": function addArc(uri) {
                        if (uri === RDFParser.ns.RDF + "li") {
                            uri = RDFParser.ns.RDF + "_" + this.parent.listIndex;
                            this.parent.listIndex++;
                        }
                        this.addSymbol(this.ARC, uri);
                    },
                    /** Add a literal to this frame */ "addLiteral": function addLiteral(value) {
                        if (this.parent.datatype && this.parent.datatype !== RDFParser.ns.RDF + "langString") this.node = this.store.literal(value, this.store.sym(this.parent.datatype));
                        else this.node = this.store.literal(value, this.lang);
                        this.nodeType = this.NODE;
                        if (this.isTripleToLoad()) this.loadTriple();
                    }
                };
            }
        },
        {
            key: "getAttributeNodeNS",
            value: function getAttributeNodeNS(node, uri, name) {
                var attributeNode = null;
                if (node.getAttributeNodeNS) attributeNode = node.getAttributeNodeNS(uri, name);
                else {
                    var attributes = node.attributes;
                    var potentialNode, fullName;
                    for(var i = 0; i < attributes.length; ++i){
                        potentialNode = attributes[i];
                        if (potentialNode.namespaceURI === uri) {
                            fullName = potentialNode.prefix ? potentialNode.prefix + ":" + name : name;
                            if (fullName === potentialNode.nodeName) {
                                attributeNode = potentialNode;
                                break;
                            }
                        }
                    }
                }
                return attributeNode;
            }
        },
        {
            key: "parse",
            value: function parse(document, base, why) {
                var children = document.childNodes; // clean up for the next run
                this.cleanParser(); // figure out the root element
                var root;
                if (document.nodeType === RDFParser.nodeType.DOCUMENT) {
                    for(var c = 0; c < children.length; c++)if (children[c].nodeType === RDFParser.nodeType.ELEMENT) {
                        root = children[c];
                        break;
                    }
                } else if (document.nodeType === RDFParser.nodeType.ELEMENT) root = document;
                else throw new Error("RDFParser: can't find root in " + base + ". Halting. ");
                this.why = why; // our topmost frame
                var f = this.frameFactory(this);
                this.base = base;
                f.base = base;
                f.lang = null; // was '' but can't have langs like that 2015 (!)
                this.parseDOM(this.buildFrame(f, root));
                return true;
            }
        },
        {
            key: "parseDOM",
            value: function parseDOM(frame) {
                // a DOM utility function used in parsing
                var rdfid;
                var elementURI = (function(el) {
                    var result = "";
                    if (el.namespaceURI == null) throw new Error("RDF/XML syntax error: No namespace for " + el.localName + " in " + this.base);
                    if (el.namespaceURI) result = result + el.namespaceURI;
                    if (el.localName) result = result + el.localName;
                    else if (el.nodeName) {
                        if (el.nodeName.indexOf(":") >= 0) result = result + el.nodeName.split(":")[1];
                        else result = result + el.nodeName;
                    }
                    return result;
                }).bind(this);
                var dig = true; // if we'll dig down in the tree on the next iter
                while(frame.parent){
                    var dom = frame.element;
                    var attrs = dom.attributes;
                    if (dom.nodeType === RDFParser.nodeType.TEXT || dom.nodeType === RDFParser.nodeType.CDATA_SECTION) {
                        // we have a literal
                        if (frame.parent.nodeType === frame.NODE) {
                            // must have had attributes, store as rdf:value
                            frame.addArc(RDFParser.ns.RDF + "value");
                            frame = this.buildFrame(frame);
                        }
                        frame.addLiteral(dom.nodeValue);
                    } else if (elementURI(dom) !== RDFParser.ns.RDF + "RDF") {
                        // not root
                        if (frame.parent && frame.parent.collection) {
                            // we're a collection element
                            frame.addCollectionArc();
                            frame = this.buildFrame(frame, frame.element);
                            frame.parent.element = null;
                        }
                        if (!frame.parent || !frame.parent.nodeType || frame.parent.nodeType === frame.ARC) {
                            // we need a node
                            var about = this.getAttributeNodeNS(dom, RDFParser.ns.RDF, "about");
                            rdfid = this.getAttributeNodeNS(dom, RDFParser.ns.RDF, "ID");
                            if (about && rdfid) throw new Error("RDFParser: " + dom.nodeName + " has both rdf:id and rdf:about." + " Halting. Only one of these" + " properties may be specified on a" + " node.");
                            if (!about && rdfid) {
                                frame.addNode("#" + rdfid.nodeValue);
                                dom.removeAttributeNode(rdfid);
                            } else if (about == null && rdfid == null) {
                                var bnid = this.getAttributeNodeNS(dom, RDFParser.ns.RDF, "nodeID");
                                if (bnid) {
                                    frame.addBNode(bnid.nodeValue);
                                    dom.removeAttributeNode(bnid);
                                } else frame.addBNode();
                            } else {
                                frame.addNode(about.nodeValue);
                                dom.removeAttributeNode(about);
                            }
                            // Typed nodes
                            var rdftype = this.getAttributeNodeNS(dom, RDFParser.ns.RDF, "type");
                            if (RDFParser.ns.RDF + "Description" !== elementURI(dom)) rdftype = {
                                "nodeValue": elementURI(dom)
                            };
                            if (rdftype != null) {
                                this.store.add(frame.node, this.store.sym(RDFParser.ns.RDF + "type"), this.store.sym($4Q80K.join(rdftype.nodeValue, frame.base)), this.why);
                                if (rdftype.nodeName) dom.removeAttributeNode(rdftype);
                            }
                            // Property Attributes
                            for(var x = attrs.length - 1; x >= 0; x--)this.store.add(frame.node, this.store.sym(elementURI(attrs[x])), this.store.literal(attrs[x].nodeValue, frame.lang), this.why);
                        } else {
                            // we should add an arc (or implicit bnode+arc)
                            frame.addArc(elementURI(dom)); // save the arc's rdf:ID if it has one
                            if (this.reify) {
                                rdfid = this.getAttributeNodeNS(dom, RDFParser.ns.RDF, "ID");
                                if (rdfid) {
                                    frame.rdfid = rdfid.nodeValue;
                                    dom.removeAttributeNode(rdfid);
                                }
                            }
                            var parsetype = this.getAttributeNodeNS(dom, RDFParser.ns.RDF, "parseType");
                            var datatype = this.getAttributeNodeNS(dom, RDFParser.ns.RDF, "datatype");
                            if (datatype) {
                                frame.datatype = datatype.nodeValue;
                                dom.removeAttributeNode(datatype);
                            }
                            if (parsetype) {
                                var nv = parsetype.nodeValue;
                                if (nv === "Literal") {
                                    frame.datatype = RDFParser.ns.RDF + "XMLLiteral";
                                    frame = this.buildFrame(frame);
                                    // Don't include the literal node, only its children
                                    frame.addLiteral(dom.childNodes);
                                    dig = false;
                                } else if (nv === "Resource") {
                                    frame = this.buildFrame(frame, frame.element);
                                    frame.parent.element = null;
                                    frame.addBNode();
                                } else if (nv === "Collection") {
                                    frame = this.buildFrame(frame, frame.element);
                                    frame.parent.element = null;
                                    frame.addCollection();
                                }
                                dom.removeAttributeNode(parsetype);
                            }
                            if (attrs.length !== 0) {
                                var resource = this.getAttributeNodeNS(dom, RDFParser.ns.RDF, "resource");
                                var bnid2 = this.getAttributeNodeNS(dom, RDFParser.ns.RDF, "nodeID");
                                frame = this.buildFrame(frame);
                                if (resource) {
                                    frame.addNode(resource.nodeValue);
                                    dom.removeAttributeNode(resource);
                                } else if (bnid2) {
                                    frame.addBNode(bnid2.nodeValue);
                                    dom.removeAttributeNode(bnid2);
                                } else frame.addBNode();
                                for(var x1 = attrs.length - 1; x1 >= 0; x1--){
                                    var f = this.buildFrame(frame);
                                    f.addArc(elementURI(attrs[x1]));
                                    if (elementURI(attrs[x1]) === RDFParser.ns.RDF + "type") this.buildFrame(f).addNode(attrs[x1].nodeValue);
                                    else this.buildFrame(f).addLiteral(attrs[x1].nodeValue);
                                }
                            } else if (dom.childNodes.length === 0) this.buildFrame(frame).addLiteral("");
                        }
                    } // rdf:RDF
                    // dig dug
                    dom = frame.element;
                    while(frame.parent){
                        var pframe = frame;
                        while(dom == null){
                            frame = frame.parent;
                            dom = frame.element;
                        }
                        var candidate = dom.childNodes && dom.childNodes[frame.lastChild];
                        if (!candidate || !dig) {
                            frame.terminateFrame();
                            if (!(frame = frame.parent)) break;
                             // done
                            dom = frame.element;
                            dig = true;
                        } else if (candidate.nodeType !== RDFParser.nodeType.ELEMENT && candidate.nodeType !== RDFParser.nodeType.TEXT && candidate.nodeType !== RDFParser.nodeType.CDATA_SECTION || (candidate.nodeType === RDFParser.nodeType.TEXT || candidate.nodeType === RDFParser.nodeType.CDATA_SECTION) && dom.childNodes.length !== 1) frame.lastChild++;
                        else {
                            // not a leaf
                            frame.lastChild++;
                            frame = this.buildFrame(pframe, dom.childNodes[frame.lastChild - 1]);
                            break;
                        }
                    }
                } // while
            }
        },
        {
            key: "cleanParser",
            value: function cleanParser() {
                this.bnodes = {};
                this.why = null;
            }
        },
        {
            key: "buildFrame",
            value: function buildFrame(parent, element) {
                var frame = this.frameFactory(this, parent, element);
                if (parent) {
                    frame.base = parent.base;
                    frame.lang = parent.lang;
                }
                if (!element || element.nodeType === RDFParser.nodeType.TEXT || element.nodeType === RDFParser.nodeType.CDATA_SECTION) return frame;
                var attrs = element.attributes;
                var base = element.getAttributeNode("xml:base");
                if (base != null) {
                    frame.base = base.nodeValue;
                    element.removeAttribute("xml:base");
                }
                var lang = element.getAttributeNode("xml:lang");
                if (lang != null) {
                    frame.lang = lang.nodeValue;
                    element.removeAttribute("xml:lang");
                }
                // remove all extraneous xml and xmlns attributes
                for(var x = attrs.length - 1; x >= 0; x--)if (attrs[x].nodeName.substr(0, 3) === "xml") {
                    if (attrs[x].name.slice(0, 6) === "xmlns:") {
                        var uri = attrs[x].nodeValue; // alert('base for namespac attr:'+this.base)
                        if (this.base) uri = $4Q80K.join(uri, this.base);
                        this.store.setPrefixForURI(attrs[x].name.slice(6), uri);
                    }
                    //		alert('rdfparser: xml atribute: '+attrs[x].name) //@@
                    element.removeAttributeNode(attrs[x]);
                }
                return frame;
            }
        }
    ]);
    return RDFParser;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4fc73169c933142c$export$2e2bcd8739ae039, "ns", {
    "RDF": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    "RDFS": "http://www.w3.org/2000/01/rdf-schema#"
});
/** DOM Level 2 node type magic numbers @final
 *  @member RDFParser
 */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4fc73169c933142c$export$2e2bcd8739ae039, "nodeType", {
    "ELEMENT": 1,
    "ATTRIBUTE": 2,
    "TEXT": 3,
    "CDATA_SECTION": 4,
    "ENTITY_REFERENCE": 5,
    "ENTITY": 6,
    "PROCESSING_INSTRUCTION": 7,
    "COMMENT": 8,
    "DOCUMENT": 9,
    "DOCUMENT_TYPE": 10,
    "DOCUMENT_FRAGMENT": 11,
    "NOTATION": 12
});


// Parse a simple SPARL-Update subset syntax for patches.
//
//  This parses
//   WHERE {xxx} DELETE {yyy} INSERT DATA {zzz}
// (not necessarily in that order)
// as though it were the n3
//   <#query> patch:where {xxx}; patch:delete {yyy}; patch:insert {zzz}.


function $f5662a1810b2d5d2$export$2e2bcd8739ae039(str, kb, base) {
    var i, j, k;
    var keywords = [
        "INSERT",
        "DELETE",
        "WHERE"
    ];
    var SQNS = (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/ns/pim/patch#");
    var p = (0, $220f89846e1c7272$export$2e2bcd8739ae039)(kb, kb, base, base, null, null, "", null);
    var clauses = {};
    var badSyntax = function badSyntax(uri, lines, str, i, why) {
        return "Line " + (lines + 1) + " of <" + uri + ">: Bad syntax:\n   " + why + '\n   at: "' + str.slice(i, i + 30) + '"';
    };
    // var check = function (next, last, message) {
    //   if (next < 0) {
    //     throw badSyntax(p._thisDoc, p.lines, str, j, last, message)
    //   }
    //   return next
    // }
    i = 0;
    var query = kb.sym(base + "#query"); // Invent a URI for the query
    clauses["query"] = query; // A way of accessing it in its N3 model.
    while(true){
        // console.log("A Now at i = " + i)
        j = p.skipSpace(str, i);
        if (j < 0) return clauses;
        // console.log("B After space at j= " + j)
        if (str[j] === ";") {
            i = p.skipSpace(str, j + 1);
            if (i < 0) return clauses; // Allow end in a
            j = i;
        }
        var found = false;
        for(k = 0; k < keywords.length; k++){
            var key = keywords[k];
            if (str.slice(j, j + key.length) === key) {
                i = p.skipSpace(str, j + key.length);
                if (i < 0) throw badSyntax(p._thisDoc, p.lines, str, j + key.length, "found EOF, needed {...} after " + key);
                if ((key === "INSERT" || key === "DELETE") && str.slice(i, i + 4) === "DATA") {
                    // Some wanted 'DATA'. Whatever
                    j = p.skipSpace(str, i + 4);
                    if (j < 0) throw badSyntax(p._thisDoc, p.lines, str, i + 4, "needed {...} after INSERT DATA " + key);
                    i = j;
                }
                var res2 = [];
                j = p.node(str, i, res2); // Parse all the complexity of the clause
                if (j < 0) throw badSyntax(p._thisDoc, p.lines, str, i, "bad syntax or EOF in {...} after " + key);
                clauses[key.toLowerCase()] = res2[0];
                kb.add(query, SQNS(key.toLowerCase()), res2[0]); // , kb.sym(base)
                // key is the keyword and res2 has the contents
                found = true;
                i = j;
            }
        }
        if (!found && str.slice(j, j + 7) === "@prefix") {
            i = p.directive(str, j);
            if (i < 0) throw badSyntax(p._thisDoc, p.lines, str, i, "bad syntax or EOF after @prefix ");
            // console.log("P before dot i= " + i)
            i = p.checkDot(str, i);
            // console.log("Q after dot i= " + i)
            found = true;
        }
        if (!found) // console.log("Bad syntax " + j)
        throw badSyntax(p._thisDoc, p.lines, str, j, "Unknown syntax at start of statememt: '" + str.slice(j).slice(0, 20) + "'");
    } // while
// return clauses
}



var $23fob = parcelRequire("23fob");

var $8RKL2 = parcelRequire("8RKL2");
function $3e841386a4d5e0bd$export$2e2bcd8739ae039(str, kb, base) {
    var contentType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "text/turtle";
    var callback = arguments.length > 4 ? arguments[4] : undefined;
    contentType = contentType || (0, $8RKL2.TurtleContentType);
    contentType = contentType.split(";")[0];
    try {
        if (contentType === (0, $8RKL2.N3ContentType) || contentType === (0, $8RKL2.TurtleContentType)) {
            var p = (0, $220f89846e1c7272$export$2e2bcd8739ae039)(kb, kb, base, base, null, null, "", null);
            p.loadBuf(str);
            executeCallback();
        } else if (contentType === (0, $8RKL2.RDFXMLContentType)) {
            var parser = new (0, $4fc73169c933142c$export$2e2bcd8739ae039)(kb);
            parser.parse($23fob.parseXML(str), base, kb.sym(base));
            executeCallback();
        } else if (contentType === (0, $8RKL2.XHTMLContentType)) {
            (0, $fec45f84912c236b$export$912cd33c0e79bc14)($23fob.parseXML(str, {
                contentType: (0, $8RKL2.XHTMLContentType)
            }), kb, base);
            executeCallback();
        } else if (contentType === (0, $8RKL2.HTMLContentType)) {
            (0, $fec45f84912c236b$export$912cd33c0e79bc14)($23fob.parseXML(str, {
                contentType: (0, $8RKL2.HTMLContentType)
            }), kb, base);
            executeCallback();
        } else if (contentType === (0, $8RKL2.SPARQLUpdateContentType) || contentType === (0, $8RKL2.SPARQLUpdateSingleMatchContentType)) {
            // @@ we handle a subset
            (0, $f5662a1810b2d5d2$export$2e2bcd8739ae039)(str, kb, base);
            executeCallback();
        } else if (contentType === (0, $8RKL2.JSONLDContentType)) (0, $93c26633f06ced7c$export$2e2bcd8739ae039)(str, kb, base, executeCallback);
        else if (contentType === (0, $8RKL2.NQuadsContentType) || contentType === (0, $8RKL2.NQuadsAltContentType)) {
            var n3Parser = new (0, $c0715e6442e25456$export$2e2bcd8739ae039)({
                factory: (0, $2b3711697846728e$export$2e2bcd8739ae039)
            });
            nquadCallback(null, str);
        } else if (contentType === undefined) throw new Error("contentType is undefined");
        else throw new Error("Don't know how to parse " + contentType + " yet");
    } catch (e) {
        // @ts-ignore
        executeErrorCallback(e);
    }
    $3e841386a4d5e0bd$export$2e2bcd8739ae039.handled = {
        "text/n3": true,
        "text/turtle": true,
        "application/rdf+xml": true,
        "application/xhtml+xml": true,
        "text/html": true,
        "application/sparql-update": true,
        "application/sparql-update-single-match": true,
        "application/ld+json": true,
        "application/nquads": true,
        "application/n-quads": true
    };
    function executeCallback() {
        if (callback) callback(null, kb);
        else return;
    }
    function executeErrorCallback(e) {
        if (// TODO: Always true, what is the right behavior
        contentType !== (0, $8RKL2.JSONLDContentType) || // @ts-ignore always true?
        contentType !== (0, $8RKL2.NQuadsContentType) || // @ts-ignore always true?
        contentType !== (0, $8RKL2.NQuadsAltContentType)) {
            if (callback) callback(e, kb);
            else {
                var e2 = new Error("" + e + " while trying to parse <" + base + "> as " + contentType);
                //@ts-ignore .cause is not a default error property
                e2.cause = e;
                throw e2;
            }
        }
    }
    /*
    function setJsonLdBase (doc, base) {
      if (doc instanceof Array) {
        return
      }
      if (!('@context' in doc)) {
        doc['@context'] = {}
      }
      doc['@context']['@base'] = base
    }
  */ function nquadCallback(err, nquads) {
        if (err) callback(err, kb);
        try {
            n3Parser.parse(nquads, tripleCallback);
        } catch (err) {
            callback(err, kb);
        }
    }
    function tripleCallback(err, triple) {
        if (triple) kb.add(triple.subject, triple.predicate, triple.object, triple.graph);
        else callback(err, kb);
    }
}





var $4Q80K = parcelRequire("4Q80K");

var $gCJkd = parcelRequire("gCJkd");

var $23fob = parcelRequire("23fob");


var $R5nvG = parcelRequire("R5nvG");

var $8RKL2 = parcelRequire("8RKL2");

var $avzMW = parcelRequire("avzMW");

function $1d9128915acc42fc$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $1d9128915acc42fc$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $1d9128915acc42fc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1d9128915acc42fc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1d9128915acc42fc$var$_arrayLikeToArray(o, minLen);
}
function $1d9128915acc42fc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1d9128915acc42fc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1d9128915acc42fc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $1d9128915acc42fc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $1d9128915acc42fc$var$Parsable = {
    "text/n3": true,
    "text/turtle": true,
    "application/rdf+xml": true,
    "application/xhtml+xml": true,
    "text/html": true,
    "application/ld+json": true
};
// This is a minimal set to allow the use of damaged servers if necessary
var $1d9128915acc42fc$var$CONTENT_TYPE_BY_EXT = {
    "rdf": (0, $8RKL2.RDFXMLContentType),
    "owl": (0, $8RKL2.RDFXMLContentType),
    "n3": "text/n3",
    "ttl": "text/turtle",
    "nt": "text/n3",
    "acl": "text/n3",
    "html": "text/html",
    "xml": "text/xml"
};
// Convenience namespaces needed in this module.
// These are deliberately not exported as the user application should
// make its own list and not rely on the prefixes used here,
// and not be tempted to add to them, and them clash with those of another
// application.
var $1d9128915acc42fc$var$getNS = function getNS(factory) {
    return {
        link: (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/2007/ont/link#", factory),
        http: (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/2007/ont/http#", factory),
        httph: (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/2007/ont/httph#", factory),
        // headers
        rdf: (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/1999/02/22-rdf-syntax-ns#", factory),
        rdfs: (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/2000/01/rdf-schema#", factory),
        dc: (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://purl.org/dc/elements/1.1/", factory),
        ldp: (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/ns/ldp#", factory)
    };
};
var $1d9128915acc42fc$var$ns = $1d9128915acc42fc$var$getNS();
/** An extended interface of Response, since RDFlib.js adds some properties. */ /** tell typescript that a 'panes' child may exist on Window */ /** All valid inputs for initFetchOptions */ /** Initiated by initFetchOptions, which runs on load */ var $1d9128915acc42fc$var$Handler = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(function Handler(response, dom) {
    (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Handler);
    // TODO: Document, type
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "response", void 0);
    // TODO: Document, type
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "dom", void 0);
    this.response = response;
    // The type assertion operator here might need to be removed.
    this.dom = dom;
});
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($1d9128915acc42fc$var$Handler, "pattern", void 0);
var $1d9128915acc42fc$var$RDFXMLHandler = /*#__PURE__*/ function(_Handler) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(RDFXMLHandler, _Handler);
    var _super = $1d9128915acc42fc$var$_createSuper(RDFXMLHandler);
    function RDFXMLHandler() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, RDFXMLHandler);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(RDFXMLHandler, [
        {
            key: "parse",
            value: function parse(fetcher, /** An XML String */ responseText, /** Requires .original */ options) {
                var kb = fetcher.store;
                if (!this.dom) this.dom = $23fob.parseXML(responseText);
                var root = this.dom.documentElement;
                if (root.nodeName === "parsererror") // Mozilla only See issue/issue110
                // have to fail the request
                return fetcher.failFetch(options, "Badly formed XML in " + options.resource.value, "parse_error");
                var parser = new (0, $4fc73169c933142c$export$2e2bcd8739ae039)(kb);
                try {
                    parser.parse(this.dom, options.original.value, options.original);
                } catch (err) {
                    return fetcher.failFetch(options, "Syntax error parsing RDF/XML! " + err, "parse_error");
                }
                if (!options.noMeta) kb.add(options.original, $1d9128915acc42fc$var$ns.rdf("type"), $1d9128915acc42fc$var$ns.link("RDFDocument"), fetcher.appNode);
                return fetcher.doneFetch(options, this.response);
            }
        }
    ], [
        {
            key: "toString",
            value: function toString() {
                return "RDFXMLHandler";
            }
        },
        {
            key: "register",
            value: function register(fetcher) {
                fetcher.mediatypes[0, $8RKL2.RDFXMLContentType] = {
                    "q": 0.9
                };
            }
        }
    ]);
    return RDFXMLHandler;
}($1d9128915acc42fc$var$Handler);
$1d9128915acc42fc$var$RDFXMLHandler.pattern = new RegExp("application/rdf\\+xml");
var $1d9128915acc42fc$var$XHTMLHandler = /*#__PURE__*/ function(_Handler2) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(XHTMLHandler, _Handler2);
    var _super2 = $1d9128915acc42fc$var$_createSuper(XHTMLHandler);
    function XHTMLHandler() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, XHTMLHandler);
        return _super2.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(XHTMLHandler, [
        {
            key: "parse",
            value: function parse(fetcher, responseText, options) {
                var relation, reverse;
                if (!this.dom) this.dom = $23fob.parseXML(responseText);
                var kb = fetcher.store;
                // dc:title
                var title = this.dom.getElementsByTagName("title");
                if (title.length > 0) kb.add(options.resource, $1d9128915acc42fc$var$ns.dc("title"), kb.rdfFactory.literal(title[0].textContent), options.resource);
                // link rel
                var links = this.dom.getElementsByTagName("link");
                for(var x = links.length - 1; x >= 0; x--){
                    // @@ rev
                    relation = links[x].getAttribute("rel");
                    reverse = false;
                    if (!relation) {
                        relation = links[x].getAttribute("rev");
                        reverse = true;
                    }
                    if (relation) fetcher.linkData(options.original, relation, links[x].getAttribute("href"), options.resource, reverse);
                }
                // Data Islands
                var scripts = this.dom.getElementsByTagName("script");
                for(var i = 0; i < scripts.length; i++){
                    var contentType = scripts[i].getAttribute("type");
                    if ($1d9128915acc42fc$var$Parsable[contentType]) {
                        // @ts-ignore incompatibility between Store.add and Formula.add
                        (0, $3e841386a4d5e0bd$export$2e2bcd8739ae039)(scripts[i].textContent, kb, options.original.value, contentType);
                        // @ts-ignore incompatibility between Store.add and Formula.add
                        (0, $3e841386a4d5e0bd$export$2e2bcd8739ae039)(scripts[i].textContent, kb, options.original.value, contentType);
                    }
                }
                if (!options.noMeta) kb.add(options.resource, $1d9128915acc42fc$var$ns.rdf("type"), $1d9128915acc42fc$var$ns.link("WebPage"), fetcher.appNode);
                if (!options.noRDFa && (0, $fec45f84912c236b$export$912cd33c0e79bc14)) // enable by default
                try {
                    (0, $fec45f84912c236b$export$912cd33c0e79bc14)(this.dom, kb, options.original.value);
                } catch (err) {
                    // @ts-ignore
                    var msg = "Error trying to parse " + options.resource + " as RDFa:\n" + err + ":\n" + err.stack;
                    return fetcher.failFetch(options, msg, "parse_error");
                }
                return fetcher.doneFetch(options, this.response);
            }
        }
    ], [
        {
            key: "toString",
            value: function toString() {
                return "XHTMLHandler";
            }
        },
        {
            key: "register",
            value: function register(fetcher) {
                fetcher.mediatypes[0, $8RKL2.XHTMLContentType] = {};
            }
        }
    ]);
    return XHTMLHandler;
}($1d9128915acc42fc$var$Handler);
$1d9128915acc42fc$var$XHTMLHandler.pattern = new RegExp("application/xhtml");
var $1d9128915acc42fc$var$XMLHandler = /*#__PURE__*/ function(_Handler3) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(XMLHandler, _Handler3);
    var _super3 = $1d9128915acc42fc$var$_createSuper(XMLHandler);
    function XMLHandler() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, XMLHandler);
        return _super3.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(XMLHandler, [
        {
            key: "parse",
            value: function parse(fetcher, responseText, options) {
                var dom = $23fob.parseXML(responseText);
                // XML Semantics defined by root element namespace
                // figure out the root element
                for(var c = 0; c < dom.childNodes.length; c++){
                    var node = dom.childNodes[c];
                    // is this node an element?
                    if (XMLHandler.isElement(node)) {
                        // We've found the first element, it's the root
                        var _ns = node.namespaceURI;
                        // Is it RDF/XML?
                        if (_ns && _ns === _ns["rdf"]) {
                            fetcher.addStatus(options.req, "Has XML root element in the RDF namespace, so assume RDF/XML.");
                            var rdfHandler = new $1d9128915acc42fc$var$RDFXMLHandler(this.response, dom);
                            return rdfHandler.parse(fetcher, responseText, options);
                        }
                        break;
                    }
                }
                // Or it could be XHTML?
                // Maybe it has an XHTML DOCTYPE?
                if (dom.doctype) // log.info("We found a DOCTYPE in " + xhr.resource)
                {
                    if (dom.doctype.name === "html" && dom.doctype.publicId.match(/^-\/\/W3C\/\/DTD XHTML/) && dom.doctype.systemId.match(/http:\/\/www.w3.org\/TR\/xhtml/)) {
                        fetcher.addStatus(options.req, "Has XHTML DOCTYPE. Switching to XHTML Handler.\n");
                        var xhtmlHandler = new $1d9128915acc42fc$var$XHTMLHandler(this.response, dom);
                        return xhtmlHandler.parse(fetcher, responseText, options);
                    }
                }
                // Or what about an XHTML namespace?
                var html = dom.getElementsByTagName("html")[0];
                if (html) {
                    var xmlns = html.getAttribute("xmlns");
                    if (xmlns && xmlns.match(/^http:\/\/www.w3.org\/1999\/xhtml/)) {
                        fetcher.addStatus(options.req, "Has a default namespace for XHTML. Switching to XHTMLHandler.\n");
                        var _xhtmlHandler = new $1d9128915acc42fc$var$XHTMLHandler(this.response, dom);
                        return _xhtmlHandler.parse(fetcher, responseText, options);
                    }
                }
                // At this point we should check the namespace document (cache it!) and
                // look for a GRDDL transform
                // @@  Get namespace document <n>, parse it, look for  <n> grddl:namespaceTransform ?y
                // Apply ?y to   dom
                // We give up. What dialect is this?
                return fetcher.failFetch(options, "Unsupported dialect of XML: not RDF or XHTML namespace, etc.\n" + responseText.slice(0, 80), 901);
            }
        }
    ], [
        {
            key: "toString",
            value: function toString() {
                return "XMLHandler";
            }
        },
        {
            key: "register",
            value: function register(fetcher) {
                fetcher.mediatypes["text/xml"] = {
                    "q": 0.5
                };
                fetcher.mediatypes["application/xml"] = {
                    "q": 0.5
                };
            }
        },
        {
            key: "isElement",
            value: function isElement(node) {
                return node.nodeType === Node.ELEMENT_NODE;
            }
        }
    ]);
    return XMLHandler;
}($1d9128915acc42fc$var$Handler);
$1d9128915acc42fc$var$XMLHandler.pattern = new RegExp("(text|application)/(.*)xml");
var $1d9128915acc42fc$var$HTMLHandler = /*#__PURE__*/ function(_Handler4) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(HTMLHandler, _Handler4);
    var _super4 = $1d9128915acc42fc$var$_createSuper(HTMLHandler);
    function HTMLHandler() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, HTMLHandler);
        return _super4.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(HTMLHandler, [
        {
            key: "parse",
            value: function parse(fetcher, responseText, options) {
                var kb = fetcher.store;
                // We only handle XHTML so we have to figure out if this is XML
                // log.info("Sniffing HTML " + xhr.resource + " for XHTML.")
                if ($1d9128915acc42fc$var$isXML(responseText)) {
                    fetcher.addStatus(options.req, "Has an XML declaration. We'll assume it's XHTML as the content-type was text/html.\n");
                    var xhtmlHandler = new $1d9128915acc42fc$var$XHTMLHandler(this.response);
                    return xhtmlHandler.parse(fetcher, responseText, options);
                }
                // DOCTYPE html
                if ($1d9128915acc42fc$var$isXHTML(responseText)) {
                    fetcher.addStatus(options.req, "Has XHTML DOCTYPE. Switching to XHTMLHandler.\n");
                    var _xhtmlHandler2 = new $1d9128915acc42fc$var$XHTMLHandler(this.response);
                    return _xhtmlHandler2.parse(fetcher, responseText, options);
                }
                // xmlns
                if ($1d9128915acc42fc$var$isXMLNS(responseText)) {
                    fetcher.addStatus(options.req, "Has default namespace for XHTML, so switching to XHTMLHandler.\n");
                    var _xhtmlHandler3 = new $1d9128915acc42fc$var$XHTMLHandler(this.response);
                    return _xhtmlHandler3.parse(fetcher, responseText, options);
                }
                // dc:title
                // no need to escape '/' here
                var titleMatch = new RegExp("<title>([\\s\\S]+?)</title>", "im").exec(responseText);
                if (titleMatch) kb.add(options.resource, $1d9128915acc42fc$var$ns.dc("title"), kb.rdfFactory.literal(titleMatch[1]), options.resource); // think about xml:lang later
                kb.add(options.resource, $1d9128915acc42fc$var$ns.rdf("type"), $1d9128915acc42fc$var$ns.link("WebPage"), fetcher.appNode);
                fetcher.addStatus(options.req, "non-XML HTML document, not parsed for data.");
                return fetcher.doneFetch(options, this.response);
            }
        }
    ], [
        {
            key: "toString",
            value: function toString() {
                return "HTMLHandler";
            }
        },
        {
            key: "register",
            value: function register(fetcher) {
                fetcher.mediatypes["text/html"] = {
                    "q": 0.9
                };
            }
        }
    ]);
    return HTMLHandler;
}($1d9128915acc42fc$var$Handler);
$1d9128915acc42fc$var$HTMLHandler.pattern = new RegExp("text/html");
var $1d9128915acc42fc$var$JsonLdHandler = /*#__PURE__*/ function(_Handler5) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(JsonLdHandler, _Handler5);
    var _super5 = $1d9128915acc42fc$var$_createSuper(JsonLdHandler);
    function JsonLdHandler() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, JsonLdHandler);
        return _super5.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(JsonLdHandler, [
        {
            key: "parse",
            value: function parse(fetcher, responseText, options, response) {
                var kb = fetcher.store;
                return new Promise(function(resolve, reject) {
                    try {
                        (0, $93c26633f06ced7c$export$2e2bcd8739ae039)(responseText, kb, options.original.value, function() {
                            resolve(fetcher.doneFetch(options, response));
                        });
                    } catch (err) {
                        var msg = "Error trying to parse " + options.resource + " as JSON-LD:\n" + err; // not err.stack -- irrelevant
                        resolve(fetcher.failFetch(options, msg, "parse_error", response));
                    }
                });
            }
        }
    ], [
        {
            key: "toString",
            value: function toString() {
                return "JsonLdHandler";
            }
        },
        {
            key: "register",
            value: function register(fetcher) {
                fetcher.mediatypes["application/ld+json"] = {
                    "q": 0.9
                };
            }
        }
    ]);
    return JsonLdHandler;
}($1d9128915acc42fc$var$Handler);
$1d9128915acc42fc$var$JsonLdHandler.pattern = /application\/ld\+json/;
var $1d9128915acc42fc$var$TextHandler = /*#__PURE__*/ function(_Handler6) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(TextHandler, _Handler6);
    var _super6 = $1d9128915acc42fc$var$_createSuper(TextHandler);
    function TextHandler() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, TextHandler);
        return _super6.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(TextHandler, [
        {
            key: "parse",
            value: function parse(fetcher, responseText, options) {
                // We only speak dialects of XML right now. Is this XML?
                // Look for an XML declaration
                if ($1d9128915acc42fc$var$isXML(responseText)) {
                    fetcher.addStatus(options.req, "Warning: " + options.resource + " has an XML declaration. We'll assume " + "it's XML but its content-type wasn't XML.\n");
                    var xmlHandler = new $1d9128915acc42fc$var$XMLHandler(this.response);
                    return xmlHandler.parse(fetcher, responseText, options);
                }
                // Look for an XML declaration
                if (responseText.slice(0, 500).match(/xmlns:/)) {
                    fetcher.addStatus(options.req, "May have an XML namespace. We'll assume it's XML but its content-type wasn't XML.\n");
                    var _xmlHandler = new $1d9128915acc42fc$var$XMLHandler(this.response);
                    return _xmlHandler.parse(fetcher, responseText, options);
                }
                // We give up finding semantics - this is not an error, just no data
                fetcher.addStatus(options.req, "Plain text document, no known RDF semantics.");
                return fetcher.doneFetch(options, this.response);
            }
        }
    ], [
        {
            key: "toString",
            value: function toString() {
                return "TextHandler";
            }
        },
        {
            key: "register",
            value: function register(fetcher) {
                fetcher.mediatypes["text/plain"] = {
                    "q": 0.5
                };
            }
        }
    ]);
    return TextHandler;
}($1d9128915acc42fc$var$Handler);
$1d9128915acc42fc$var$TextHandler.pattern = new RegExp("text/plain");
var $1d9128915acc42fc$var$N3Handler = /*#__PURE__*/ function(_Handler7) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(N3Handler, _Handler7);
    var _super7 = $1d9128915acc42fc$var$_createSuper(N3Handler);
    function N3Handler() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, N3Handler);
        return _super7.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(N3Handler, [
        {
            key: "parse",
            value: function parse(fetcher, responseText, options, response) {
                // Parse the text of this N3 file
                var kb = fetcher.store;
                var p = (0, $220f89846e1c7272$export$2e2bcd8739ae039)(kb, kb, options.original.value, options.original.value, null, null, "", null);
                //                p.loadBuf(xhr.responseText)
                try {
                    p.loadBuf(responseText);
                } catch (err) {
                    var msg = "Error trying to parse " + options.resource + " as Notation3:\n" + err; // not err.stack -- irrelevant
                    return fetcher.failFetch(options, msg, "parse_error", response);
                }
                fetcher.addStatus(options.req, "N3 parsed: " + p.statementCount + " triples in " + p.lines + " lines.");
                fetcher.store.add(options.original, $1d9128915acc42fc$var$ns.rdf("type"), $1d9128915acc42fc$var$ns.link("RDFDocument"), fetcher.appNode);
                return fetcher.doneFetch(options, this.response);
            }
        }
    ], [
        {
            key: "toString",
            value: function toString() {
                return "N3Handler";
            }
        },
        {
            key: "register",
            value: function register(fetcher) {
                fetcher.mediatypes["text/n3"] = {
                    "q": "1.0"
                }; // as per 2008 spec
                /*
       fetcher.mediatypes['application/x-turtle'] = {
       'q': 1.0
       } // pre 2008
       */ fetcher.mediatypes["text/turtle"] = {
                    "q": 1.0
                }; // post 2008
            }
        }
    ]);
    return N3Handler;
}($1d9128915acc42fc$var$Handler);
$1d9128915acc42fc$var$N3Handler.pattern = new RegExp("(application|text)/(x-)?(rdf\\+)?(n3|turtle)");
var $1d9128915acc42fc$var$defaultHandlers = {
    RDFXMLHandler: $1d9128915acc42fc$var$RDFXMLHandler,
    XHTMLHandler: $1d9128915acc42fc$var$XHTMLHandler,
    XMLHandler: $1d9128915acc42fc$var$XMLHandler,
    HTMLHandler: $1d9128915acc42fc$var$HTMLHandler,
    TextHandler: $1d9128915acc42fc$var$TextHandler,
    N3Handler: $1d9128915acc42fc$var$N3Handler,
    JsonLdHandler: $1d9128915acc42fc$var$JsonLdHandler
};
function $1d9128915acc42fc$var$isXHTML(responseText) {
    var docTypeStart = responseText.indexOf("<!DOCTYPE html");
    var docTypeEnd = responseText.indexOf(">");
    if (docTypeStart === -1 || docTypeEnd === -1 || docTypeStart > docTypeEnd) return false;
    return responseText.substr(docTypeStart, docTypeEnd - docTypeStart).indexOf("XHTML") !== -1;
}
function $1d9128915acc42fc$var$isXML(responseText) {
    var match = responseText.match(/\s*<\?xml\s+version\s*=[^<>]+\?>/);
    return !!match;
}
function $1d9128915acc42fc$var$isXMLNS(responseText) {
    var match = responseText.match(/[^(<html)]*<html\s+[^<]*xmlns=['"]http:\/\/www.w3.org\/1999\/xhtml["'][^<]*>/);
    return !!match;
}
// Not sure about the shapes of this. Response? FetchError?
/** Differs from normal Fetch, has an extended Response type */ /** Fetcher
 *
 * The Fetcher object is a helper object for a quadstore
 * which turns it from an offline store to an online store.
 * The fetcher deals with loading data files rom the web,
  * figuring how to parse them.  It will also refresh, remove, the data
  * and put back the data to the web.
 */ var $1d9128915acc42fc$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher(store) {
        var _this = this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Fetcher);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "store", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "timeout", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_fetch", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "mediatypes", void 0);
        /** Denoting this session */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "appNode", void 0);
        /**
     * this.requested[uri] states:
     * undefined     no record of web access or records reset
     * true          has been requested, fetch in progress
     * 'done'        received, Ok
     * 401           Not logged in
     * 403           HTTP status unauthorized
     * 404           Resource does not exist. Can be created etc.
     * 'redirected'  In attempt to counter CORS problems retried.
     * 'parse_error' Parse error
     * 'unsupported_protocol'  URI is not a protocol Fetcher can deal with
     * other strings mean various other errors.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "requested", void 0);
        /** List of timeouts associated with a requested URL */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "timeouts", void 0);
        /** Redirected from *key uri* to *value uri* */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "redirectedTo", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "fetchQueue", void 0);
        /** fetchCallbacks[uri].push(callback) */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "fetchCallbacks", void 0);
        /** Keep track of explicit 404s -> we can overwrite etc */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "nonexistent", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "lookedUp", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "handlers", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "ns", void 0);
        /** Methods added by calling Util.callbackify in the constructor*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "fireCallbacks", void 0);
        this.store = store || new (0, $6f5c135260474402$export$2e2bcd8739ae039)();
        this.ns = $1d9128915acc42fc$var$getNS(this.store.rdfFactory);
        this.timeout = options.timeout || 30000;
        // solidFetcher is deprecated
        this._fetch = options.fetch || typeof $parcel$global !== "undefined" && ($parcel$global.solidFetcher || $parcel$global.solidFetch) || typeof window !== "undefined" && (window.solidFetcher || window.solidFetch) || (0, (/*@__PURE__*/$parcel$interopDefault($R5nvG)));
        if (!this._fetch) throw new Error("No _fetch function available for Fetcher");
        // This is the name of the graph we store all the HTTP metadata in
        this.appNode = this.store.sym("chrome://TheCurrentSession");
        // this.appNode = this.store.rdfFactory.blankNode() // Needs to have a URI in tests
        this.store.fetcher = this; // Bi-linked
        this.requested = {};
        this.timeouts = {};
        this.redirectedTo = {};
        this.fetchQueue = {};
        this.fetchCallbacks = {};
        this.nonexistent = {};
        this.lookedUp = {};
        this.handlers = [];
        this.mediatypes = {
            "image/*": {
                "q": 0.9
            },
            "*/*": {
                "q": 0.1
            } // Must allow access to random content
        };
        // Util.callbackify(this, ['request', 'recv', 'headers', 'load', 'fail',
        //   'refresh', 'retract', 'done'])
        // In switching to fetch(), 'recv', 'headers' and 'load' do not make sense
        $23fob.callbackify(this, [
            "request",
            "fail",
            "refresh",
            "retract",
            "done"
        ]);
        Object.keys(options.handlers || $1d9128915acc42fc$var$defaultHandlers).map(function(key) {
            return _this.addHandler($1d9128915acc42fc$var$defaultHandlers[key]);
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Fetcher, [
        {
            key: "load",
            value: /**
     * Promise-based load function
     *
     * Loads a web resource or resources into the store.
     *
     * A resource may be given as NamedNode object, or as a plain URI.
     * an array of resources will be given, in which they will be fetched in parallel.
     * By default, the HTTP headers are recorded also, in the same store, in a separate graph.
     * This allows code like editable() for example to test things about the resource.
     *
     * @param uri {Array<RDFlibNamedNode>|Array<string>|RDFlibNamedNode|string}
     *
     * @param [options={}] {Object}
     *
     * @param [options.fetch] {Function}
     *
     * @param [options.referringTerm] {RDFlibNamedNode} Referring term, the resource which
     *   referred to this (for tracking bad links)
     *
     * @param [options.contentType] {string} Provided content type (for writes)
     *
     * @param [options.forceContentType] {string} Override the incoming header to
     *   force the data to be treated as this content-type (for reads)
     *
     * @param [options.force] {boolean} Load the data even if loaded before.
     *   Also sets the `Cache-Control:` header to `no-cache`
     *
     * @param [options.baseURI=docuri] {Node|string} Original uri to preserve
     *   through proxying etc (`xhr.original`).
     *
     * @param [options.proxyUsed] {boolean} Whether this request is a retry via
     *   a proxy (generally done from an error handler)
     *
     * @param [options.withCredentials] {boolean} flag for XHR/CORS etc
     *
     * @param [options.clearPreviousData] {boolean} Before we parse new data,
     *   clear old, but only on status 200 responses
     *
     * @param [options.noMeta] {boolean} Prevents the addition of various metadata
     *   triples (about the fetch request) to the store
     *
     * @param [options.noRDFa] {boolean}
     *
     * @returns {Promise<Result>}
     */ function load(uri) {
                var _this2 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                options = Object.assign({}, options); // Take a copy as we add stuff to the options!!
                if (uri instanceof Array) return Promise.all(uri.map(function(x) {
                    return _this2.load(x, Object.assign({}, options));
                }));
                var uriIn = uri;
                var docuri = (0, $avzMW.termValue)(uriIn);
                docuri = docuri.split("#")[0];
                options = this.initFetchOptions(docuri, options);
                // if metadata flaged clear cache and removeDocument
                var meta = this.appNode;
                var kb = this.store;
                var requests = kb.statementsMatching(undefined, this.ns.link("requestedURI"), kb.sym(docuri), meta).map(function(st) {
                    return st.subject;
                });
                var _iterator = $1d9128915acc42fc$var$_createForOfIteratorHelper(requests), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var request = _step.value;
                        var _response = kb.any(request, this.ns.link("response"), null, meta);
                        if (_response != undefined) {
                            // ts
                            var quad = kb.statementsMatching(_response, this.ns.link("outOfDate"), true, meta);
                            kb.remove(quad);
                            options.force = true;
                            options.clearPreviousData = true;
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                var initialisedOptions = this.initFetchOptions(docuri, options);
                return this.pendingFetchPromise(docuri, initialisedOptions.baseURI, initialisedOptions);
            }
        },
        {
            key: "pendingFetchPromise",
            value: function() {
                var _pendingFetchPromise = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(uri, originalUri, options) {
                    var _this3 = this;
                    var pendingPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.t0 = !options.force;
                                if (!_context.t0) {
                                    _context.next = 5;
                                    break;
                                }
                                _context.next = 4;
                                return this.fetchQueue[originalUri];
                            case 4:
                                _context.t0 = _context.sent;
                            case 5:
                                if (!_context.t0) {
                                    _context.next = 9;
                                    break;
                                }
                                pendingPromise = this.fetchQueue[originalUri];
                                _context.next = 12;
                                break;
                            case 9:
                                pendingPromise = Promise.race([
                                    this.setRequestTimeout(uri, options),
                                    this.fetchUri(uri, options)
                                ]);
                                this.fetchQueue[originalUri] = pendingPromise;
                                // Clean up the queued promise after a time, if it's resolved
                                this.cleanupFetchRequest(originalUri, undefined, this.timeout);
                            case 12:
                                return _context.abrupt("return", pendingPromise.then(function(x) {
                                    if (uri in _this3.timeouts) {
                                        _this3.timeouts[uri].forEach(clearTimeout);
                                        delete _this3.timeouts[uri];
                                    }
                                    return x;
                                }));
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function pendingFetchPromise(_x, _x2, _x3) {
                    return _pendingFetchPromise.apply(this, arguments);
                }
                return pendingFetchPromise;
            }()
        },
        {
            key: "cleanupFetchRequest",
            value: function cleanupFetchRequest(originalUri, _options, timeout) {
                var _this4 = this;
                if (_options !== undefined) console.warn("_options is deprecated");
                this.timeouts[originalUri] = (this.timeouts[originalUri] || []).concat(setTimeout(function() {
                    if (!_this4.isPending(originalUri)) delete _this4.fetchQueue[originalUri];
                }, timeout));
            }
        },
        {
            key: "initFetchOptions",
            value: function initFetchOptions(uri, options) {
                var kb = this.store;
                var isGet = !options.method || options.method.toUpperCase() === "GET";
                if (!isGet) options.force = true;
                options.resource = kb.rdfFactory.namedNode(uri); // This might be proxified
                options.baseURI = options.baseURI || uri; // Preserve though proxying etc
                options.original = kb.rdfFactory.namedNode(options.baseURI);
                options.req = kb.bnode();
                options.headers = options.headers || new (0, $R5nvG.Headers)();
                if (options.contentType) // @ts-ignore
                options.headers["content-type"] = options.contentType;
                if (options.force) options.cache = "no-cache";
                var acceptString = this.acceptString();
                // @ts-ignore
                options.headers["accept"] = acceptString;
                var requestedURI = Fetcher.offlineOverride(uri);
                options.requestedURI = requestedURI;
                Fetcher.setCredentials(requestedURI, options);
                var actualProxyURI = Fetcher.proxyIfNecessary(requestedURI);
                if (requestedURI !== actualProxyURI) options.proxyUsed = true;
                options.actualProxyURI = actualProxyURI;
                return options;
            }
        },
        {
            key: "fetchUri",
            value: function fetchUri(docuri, options) {
                var _this5 = this;
                if (!docuri) return Promise.reject(new Error("Cannot fetch an empty uri"));
                if (Fetcher.unsupportedProtocol(docuri)) return this.failFetch(options, "fetcher: Unsupported protocol", "unsupported_protocol");
                var state = this.getState(docuri);
                if (!options.force) {
                    if (state === "fetched") // URI already fetched and added to store
                    return Promise.resolve(// @ts-ignore This is not a valid response object
                    this.doneFetch(options, {
                        status: 200,
                        ok: true,
                        statusText: "Already loaded into quadstore."
                    }));
                    if (state === "failed" && this.requested[docuri] === 404) {
                        // Remember nonexistence
                        var _message = "Previously failed: " + this.requested[docuri];
                        // @ts-ignore This is not a valid response object
                        var dummyResponse = {
                            url: docuri,
                            // This does not comply to Fetch spec, it can be a string value in rdflib
                            status: this.requested[docuri],
                            statusText: _message,
                            responseText: _message,
                            headers: new (0, $R5nvG.Headers)(),
                            // Headers() ???
                            ok: false,
                            body: null,
                            bodyUsed: false,
                            size: 0,
                            timeout: 0
                        };
                        return this.failFetch(options, _message, this.requested[docuri], dummyResponse);
                    }
                } else // options.force == true
                delete this.nonexistent[docuri];
                this.fireCallbacks("request", [
                    docuri
                ]);
                this.requested[docuri] = true; // mark this uri as 'requested'
                if (!options.noMeta) this.saveRequestMetadata(docuri, options);
                var actualProxyURI = options.actualProxyURI;
                // Map might get mistakenly added into headers
                // error TS2339: Property 'map' does not exist on type 'Headers'.
                /* let map
      if (options.headers && map in options.headers) {
        delete options.headers.map
      } */ return this._fetch(actualProxyURI, options).then(function(response) {
                    return _this5.handleResponse(response, docuri, options);
                }, function(error) {
                    // @@ handleError?
                    // @ts-ignore Invalid response object
                    var dummyResponse = {
                        url: actualProxyURI,
                        status: 999,
                        // @@ what number/string should fetch failures report?
                        statusText: (error.name || "network failure") + ": " + (error.errno || error.code || error.type),
                        responseText: error.message,
                        headers: new (0, $R5nvG.Headers)(),
                        // Headers() ???
                        ok: false,
                        body: null,
                        bodyUsed: false,
                        size: 0,
                        timeout: 0
                    };
                    // console.log('Fetcher: <' + actualProxyURI + '> Non-HTTP fetch exception: ' + error)
                    return _this5.handleError(dummyResponse, docuri, options); // possible credentials retry
                // return this.failFetch(options, 'fetch failed: ' + error, 999, dummyResponse) // Fake status code: fetch exception
                // handleError expects a response so we fake some important bits.
                /*
        this.handleError(, docuri, options)
        */ });
            }
        },
        {
            key: "nowOrWhenFetched",
            value: function nowOrWhenFetched(uriIn, p2, userCallback) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var uri = (0, $avzMW.termValue)(uriIn);
                if (typeof p2 === "function") // nowOrWhenFetched (uri, userCallback)
                userCallback = p2;
                else if (typeof p2 === "undefined") ;
                else if ((0, $gCJkd.isNamedNode)(p2)) // referringTerm = p2
                options.referringTerm = p2;
                else // nowOrWhenFetched (uri, options, userCallback)
                options = p2;
                this.load(uri, options).then(function(fetchResponse) {
                    if (userCallback) {
                        if (fetchResponse) {
                            if (fetchResponse.ok) userCallback(true, "OK", fetchResponse);
                            else {
                                var oops = "HTTP error: Status " + fetchResponse.status + " (" + fetchResponse.statusText + ")";
                                if (fetchResponse.responseText) oops += " " + fetchResponse.responseText; // not in 404, dns error, nock failure
                                userCallback(false, oops, fetchResponse);
                            }
                        } else {
                            var _oops = "@@ nowOrWhenFetched:  no response object!";
                            userCallback(false, _oops);
                        }
                    }
                }, function(err) {
                    var message = err.message || err.statusText;
                    message = "Failed to load  <" + uri + "> " + message;
                    if (err.response && err.response.status) message += " status: " + err.response.status;
                    userCallback(false, message, err.response);
                });
            }
        },
        {
            key: "addStatus",
            value: function addStatus(req, statusMessage) {
                // <Debug about="parsePerformance">
                var now = new Date();
                statusMessage = "[" + now.getHours() + ":" + now.getMinutes() + ":" + now.getSeconds() + "." + now.getMilliseconds() + "] " + statusMessage;
                // </Debug>
                var kb = this.store;
                var statusNode = kb.the(req, this.ns.link("status"));
                if ((0, $gCJkd.isCollection)(statusNode)) statusNode.append(kb.rdfFactory.literal(statusMessage));
                else (0, $kAE07.default).warn("web.js: No list to add to: " + statusNode + "," + statusMessage);
            }
        },
        {
            key: "failFetch",
            value: function failFetch(options, errorMessage, statusCode, response) {
                this.addStatus(options.req, errorMessage);
                if (!options.noMeta) this.store.add(options.original, this.ns.link("error"), this.store.rdfFactory.literal(errorMessage));
                var meth = (options.method || "GET").toUpperCase();
                var isGet = meth === "GET" || meth === "HEAD";
                if (isGet) {
                    // only cache the status code on GET or HEAD
                    options.resource.equals(options.original);
                    this.requested[$4Q80K.docpart(options.original.value)] = statusCode;
                    this.fireCallbacks("fail", [
                        options.original.value,
                        errorMessage
                    ]);
                }
                var err = new Error("Fetcher: " + errorMessage);
                // err.ok = false // Is taken as a response, will work too @@ phase out?
                err.status = statusCode;
                err.statusText = errorMessage;
                err.response = response;
                return Promise.reject(err);
            }
        },
        {
            key: "linkData",
            value: function linkData(originalUri, rel, uri, why, reverse) {
                if (!uri) return;
                var kb = this.store;
                var predicate;
                // See http://www.w3.org/TR/powder-dr/#httplink for describedby 2008-12-10
                var obj = kb.rdfFactory.namedNode($4Q80K.join(uri, originalUri.value));
                if (rel === "alternate" || rel === "seeAlso" || rel === "meta" || rel === "describedby") {
                    if (obj.value === originalUri.value) return;
                    predicate = this.ns.rdfs("seeAlso");
                } else if (rel === "type") predicate = kb.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type");
                else // See https://www.iana.org/assignments/link-relations/link-relations.xml
                // Alas not yet in RDF yet for each predicate
                // encode space in e.g. rel="shortcut icon"
                predicate = kb.rdfFactory.namedNode($4Q80K.join(encodeURIComponent(rel), "http://www.iana.org/assignments/link-relations/"));
                if (reverse) kb.add(obj, predicate, originalUri, why);
                else kb.add(originalUri, predicate, obj, why);
            }
        },
        {
            key: "parseLinkHeader",
            value: function parseLinkHeader(linkHeader, originalUri, reqNode) {
                if (!linkHeader) return;
                // const linkexp = /<[^>]*>\s*(\s*;\s*[^()<>@,;:"/[\]?={} \t]+=(([^()<>@,;:"/[]?={} \t]+)|("[^"]*")))*(,|$)/g
                // const paramexp = /[^()<>@,;:"/[]?={} \t]+=(([^()<>@,;:"/[]?={} \t]+)|("[^"]*"))/g
                // From https://www.dcode.fr/regular-expression-simplificator:
                // const linkexp = /<[^>]*>\s*(\s*;\s*[^()<>@,;:"/[\]?={} t]+=["]))*[,$]/g
                // const paramexp = /[^\\<>@,;:"\/\[\]?={} \t]+=["])/g
                // Original:
                var linkexp = /<[^>]*>\s*(\s*;\s*[^()<>@,;:"/[\]?={} \t]+=(([^\(\)<>@,;:"\/\[\]\?={} \t]+)|("[^"]*")))*(,|$)/g;
                var paramexp = /[^\(\)<>@,;:"\/\[\]\?={} \t]+=(([^\(\)<>@,;:"\/\[\]\?={} \t]+)|("[^"]*"))/g;
                var matches = linkHeader.match(linkexp);
                if (matches == null) return;
                for(var i = 0; i < matches.length; i++){
                    var split = matches[i].split(">");
                    var href = split[0].substring(1);
                    var ps = split[1];
                    var s = ps.match(paramexp);
                    if (s == null) return;
                    for(var j = 0; j < s.length; j++){
                        var p = s[j];
                        var paramsplit = p.split("=");
                        // var name = paramsplit[0]
                        var rel = paramsplit[1].replace(/["']/g, ""); // '"
                        this.linkData(originalUri, rel, href, reqNode);
                    }
                }
            }
        },
        {
            key: "doneFetch",
            value: function doneFetch(options, response) {
                this.addStatus(options.req, "Done.");
                this.requested[options.original.value] = "done";
                this.fireCallbacks("done", [
                    options.original.value
                ]);
                response.req = options.req; // Set the request meta blank node
                return response;
            }
        },
        {
            key: "nowKnownAs",
            value: function nowKnownAs(was, now) {
                if (this.lookedUp[was.value]) // Transfer userCallback
                {
                    if (!this.lookedUp[now.value]) this.lookUpThing(now, was);
                } else if (this.lookedUp[now.value]) {
                    if (!this.lookedUp[was.value]) this.lookUpThing(was, now);
                }
            }
        },
        {
            key: "putBack",
            value: function putBack(uri) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var uriSting = (0, $avzMW.termValue)(uri);
                var doc = new (0, $99pVg.default)(uriSting).doc(); // strip off #
                options.contentType = options["content-type"] || options["Content-Type"] || options.contentType || (0, $8RKL2.TurtleContentType);
                if (options.contentType === "application/ld+json") return new Promise(function(resolve, reject) {
                    (0, $957a454a8ab6ebde$export$2e2bcd8739ae039)(doc, _this6.store, doc.uri, options.contentType, function(err, jsonString) {
                        if (err) reject(err);
                        else {
                            // @ts-ignore
                            options.data = jsonString;
                            _this6.webOperation("PUT", uri, options).then(function(res) {
                                return resolve(res);
                            }).catch(function(error) {
                                return reject(error);
                            });
                        }
                    });
                });
                options.data = (0, $957a454a8ab6ebde$export$2e2bcd8739ae039)(doc, this.store, doc.value, options.contentType);
                return this.webOperation("PUT", uriSting, options);
            }
        },
        {
            key: "webCopy",
            value: function webCopy(here, there, contentType) {
                var _this7 = this;
                return this.webOperation("GET", here).then(function(result) {
                    return _this7.webOperation("PUT", // change to binary from text
                    there, {
                        data: result.responseText,
                        contentType: contentType
                    });
                });
            }
        },
        {
            key: "delete",
            value: function _delete(uri, options) {
                var _this8 = this;
                return this.webOperation("DELETE", uri, options).then(function(response) {
                    _this8.requested[uri] = 404;
                    _this8.nonexistent[uri] = true;
                    _this8.unload(_this8.store.rdfFactory.namedNode(uri));
                    return response;
                });
            }
        },
        {
            key: "createIfNotExists",
            value: function() {
                var _createIfNotExists = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee2(doc) {
                    var contentType, data, fetcher, response, _args2 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                contentType = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : (0, $8RKL2.TurtleContentType);
                                data = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : "";
                                fetcher = this;
                                _context2.prev = 3;
                                _context2.next = 6;
                                return fetcher.load(doc);
                            case 6:
                                response = _context2.sent;
                                _context2.next = 26;
                                break;
                            case 9:
                                _context2.prev = 9;
                                _context2.t0 = _context2["catch"](3);
                                if (!(_context2.t0.response.status === 404)) {
                                    _context2.next = 25;
                                    break;
                                }
                                _context2.prev = 12;
                                _context2.next = 15;
                                return fetcher.webOperation("PUT", doc.value, {
                                    data: data,
                                    contentType: contentType
                                });
                            case 15:
                                response = _context2.sent;
                                _context2.next = 21;
                                break;
                            case 18:
                                _context2.prev = 18;
                                _context2.t1 = _context2["catch"](12);
                                throw _context2.t1;
                            case 21:
                                delete fetcher.requested[doc.value]; // delete cached 404 error
                                // console.log('createIfNotExists doc created ok ' + doc)
                                return _context2.abrupt("return", response);
                            case 25:
                                throw _context2.t0;
                            case 26:
                                return _context2.abrupt("return", response);
                            case 27:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            3,
                            9
                        ],
                        [
                            12,
                            18
                        ]
                    ]);
                }));
                function createIfNotExists(_x4) {
                    return _createIfNotExists.apply(this, arguments);
                }
                return createIfNotExists;
            }()
        },
        {
            key: "createContainer",
            value: function createContainer(parentURI, folderName, data) {
                var headers = {
                    // Force the right mime type for containers
                    "content-type": (0, $8RKL2.TurtleContentType),
                    "link": this.ns.ldp("BasicContainer") + '; rel="type"'
                };
                if (folderName) headers["slug"] = folderName;
                // @ts-ignore These headers lack some of the required operators.
                var options = {
                    headers: headers
                };
                if (data) options.body = data;
                return this.webOperation("POST", parentURI, options);
            }
        },
        {
            key: "invalidateCache",
            value: function invalidateCache(iri) {
                var uri = (0, $avzMW.termValue)(iri);
                var fetcher = this;
                // @ts-ignore
                if (fetcher.fetchQueue && fetcher.fetchQueue[uri]) {
                    // console.log('Internal error - fetchQueue exists ' + uri)
                    var promise = fetcher.fetchQueue[uri];
                    if (promise["PromiseStatus"] === "resolved") delete fetcher.fetchQueue[uri];
                    else // pending
                    delete fetcher.fetchQueue[uri];
                }
                if (fetcher.requested[uri] && fetcher.requested[uri] !== "done" && fetcher.requested[uri] !== "failed" && fetcher.requested[uri] !== 404) {
                    var msg = "Rdflib: fetcher: Destructive operation on <".concat(fetcher.requested[uri], "> file being fetched! ") + uri;
                    console.error(msg);
                // alert(msg)
                } else {
                    delete fetcher.requested[uri]; // invalidate read cache -- @@ messes up logic if request in progress ??
                    delete fetcher.nonexistent[uri];
                }
            }
        },
        {
            key: "webOperation",
            value: function webOperation(method, uriIn) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var uri = (0, $avzMW.termValue)(uriIn);
                options.method = method;
                options.body = options.data || options.body;
                options.force = true;
                var fetcher = this;
                if (options.body && !options.contentType) throw new Error("Web operation sending data must have a defined contentType.");
                if (options.contentType) {
                    options.headers = options.headers || {};
                    options.headers["content-type"] = options.contentType;
                }
                Fetcher.setCredentials(uri, options);
                return new Promise(function(resolve, reject) {
                    fetcher._fetch(uri, options).then(function(response) {
                        if (response.ok) {
                            if (method === "PUT" || method === "PATCH" || method === "POST" || method === "DELETE") fetcher.invalidateCache(uri);
                             // response.body with Chrome can't be relied on
                            if (response.text) // Was: response.body https://github.com/linkeddata/rdflib.js/issues/506
                            response.text().then(function(data) {
                                response.responseText = data;
                                resolve(response);
                            });
                            else resolve(response);
                        } else {
                            var msg = "Web error: " + response.status;
                            if (response.statusText) msg += " (" + response.statusText + ")";
                            msg += " on " + method + " of <" + uri + ">";
                            if (response.responseText) msg += ": " + response.responseText;
                            var e2 = new Error(msg);
                            e2.response = response;
                            reject(e2);
                        }
                    }, function(err) {
                        var msg = "Fetch error for " + method + " of <" + uri + ">:" + err;
                        reject(new Error(msg));
                    });
                });
            }
        },
        {
            key: "lookUpThing",
            value: function lookUpThing(term, rterm) {
                var _this9 = this;
                var uris = this.store.uris(term); // Get all URIs
                uris = uris.map(function(u) {
                    return $4Q80K.docpart(u);
                }); // Drop hash fragments
                uris.forEach(function(u) {
                    _this9.lookedUp[u] = true;
                });
                // @ts-ignore Recursive type
                return this.load(uris, {
                    referringTerm: rterm
                });
            }
        },
        {
            key: "getHeader",
            value: function getHeader(doc, header) {
                var kb = this.store; // look for the URI (AS A STRING NOT A NODE) for a stored request
                var docuri = doc.value;
                var requests = kb.each(undefined, this.ns.link("requestedURI"), kb.rdfFactory.literal(docuri));
                for(var r = 0; r < requests.length; r++){
                    var request = requests[r];
                    if (request !== undefined) {
                        var _response2 = kb.any(request, this.ns.link("response"));
                        if (_response2 !== undefined && kb.anyValue(_response2, this.ns.http("status")) && kb.anyValue(_response2, this.ns.http("status")).startsWith("2")) {
                            // Only look at success returns - not 401 error messagess etc
                            var results = kb.each(_response2, this.ns.httph(header.toLowerCase()));
                            if (results.length) return results.map(function(v) {
                                return v.value;
                            });
                            return [];
                        }
                    }
                }
                return undefined;
            }
        },
        {
            key: "saveRequestMetadata",
            value: function saveRequestMetadata(docuri, options) {
                var req = options.req;
                var kb = this.store;
                var rterm = options.referringTerm;
                this.addStatus(options.req, "Accept: " + options.headers["accept"]);
                if ((0, $gCJkd.isNamedNode)(rterm)) kb.add(kb.rdfFactory.namedNode(docuri), this.ns.link("requestedBy"), rterm, this.appNode);
                if (options.original && options.original.value !== docuri) kb.add(req, this.ns.link("orginalURI"), kb.rdfFactory.literal(options.original.value), this.appNode);
                var now = new Date();
                var timeNow = "[" + now.getHours() + ":" + now.getMinutes() + ":" + now.getSeconds() + "] ";
                kb.add(req, this.ns.rdfs("label"), kb.rdfFactory.literal(timeNow + " Request for " + docuri), this.appNode);
                // We store the docuri as a string, not as a node,
                // see https://github.com/linkeddata/rdflib.js/pull/427#pullrequestreview-447910061
                kb.add(req, this.ns.link("requestedURI"), kb.rdfFactory.literal(docuri), this.appNode);
                kb.add(req, this.ns.link("status"), kb.collection(), this.appNode);
            }
        },
        {
            key: "saveResponseMetadata",
            value: function saveResponseMetadata(response, options) {
                var _this10 = this;
                var kb = this.store;
                var responseNode = kb.bnode();
                kb.add(options.req, this.ns.link("response"), responseNode, this.appNode);
                kb.add(responseNode, this.ns.http("status"), kb.rdfFactory.literal(response.status), this.appNode);
                kb.add(responseNode, this.ns.http("statusText"), kb.rdfFactory.literal(response.statusText), this.appNode);
                // Save the response headers
                response.headers.forEach(function(value, header) {
                    kb.add(responseNode, _this10.ns.httph(header), _this10.store.rdfFactory.literal(value), _this10.appNode);
                    if (header === "content-type") kb.add(options.resource, _this10.ns.rdf("type"), kb.rdfFactory.namedNode($23fob.mediaTypeClass(value).value), _this10.appNode // responseNode
                    );
                });
                return responseNode;
            }
        },
        {
            key: "objectRefresh",
            value: function objectRefresh(term) {
                var uris = this.store.uris(term); // Get all URIs
                if (typeof uris !== "undefined") for(var i = 0; i < uris.length; i++)this.refresh(this.store.rdfFactory.namedNode($4Q80K.docpart(uris[i])));
            }
        },
        {
            key: "refresh",
            value: function refresh(term, userCallback) {
                // sources_refresh
                this.fireCallbacks("refresh", arguments);
                this.nowOrWhenFetched(term, {
                    force: true,
                    clearPreviousData: true
                }, userCallback);
            }
        },
        {
            key: "refreshIfExpired",
            value: function refreshIfExpired(term, userCallback) {
                var exp = this.getHeader(term, "Expires");
                if (!exp || new Date(exp[0]).getTime() <= new Date().getTime()) this.refresh(term, userCallback);
                else userCallback(true, "Not expired", {});
            }
        },
        {
            key: "retract",
            value: function retract(term) {
                // sources_retract
                this.store.removeMany(undefined, undefined, undefined, term);
                if (term.value) delete this.requested[$4Q80K.docpart(term.value)];
                this.fireCallbacks("retract", arguments);
            }
        },
        {
            key: "getState",
            value: function getState(docuri) {
                if (typeof this.requested[docuri] === "undefined") return "unrequested";
                else if (this.requested[docuri] === true) return "requested";
                else if (this.requested[docuri] === "done") return "fetched";
                else if (this.requested[docuri] === "redirected") return this.getState(this.redirectedTo[docuri]);
                else // An non-200 HTTP error status
                return "failed";
            }
        },
        {
            key: "isPending",
            value: function isPending(docuri) {
                // sources_pending
                // doing anyStatementMatching is wasting time
                // if it's not pending: false -> flailed
                //   'done' -> done 'redirected' -> redirected
                return this.requested[docuri] === true;
            }
        },
        {
            key: "unload",
            value: function unload(term) {
                this.store.removeDocument(term);
                delete this.requested[term.value]; // So it can be load2ed again
            }
        },
        {
            key: "addHandler",
            value: function addHandler(handler) {
                this.handlers.push(handler);
                handler.register(this);
            }
        },
        {
            key: "retryNoCredentials",
            value: function retryNoCredentials(docuri, options) {
                // console.log('Fetcher: CORS: RETRYING with NO CREDENTIALS for ' + options.resource)
                options.retriedWithNoCredentials = true; // protect against being called twice
                delete this.requested[docuri]; // forget the original request happened
                delete this.fetchQueue[docuri];
                // Note: XHR property was withCredentials, but fetch property is just credentials
                var newOptions = Object.assign({}, options, {
                    credentials: "omit"
                });
                this.addStatus(options.req, "Abort: Will retry with credentials SUPPRESSED to see if that helps");
                return this.load(docuri, newOptions);
            }
        },
        {
            key: "isCrossSite",
            value: function isCrossSite(uri) {
                // Mashup situation, not node etc
                if (typeof document === "undefined" || !document.location) return false;
                var hostpart = $4Q80K.hostpart;
                var here = "" + document.location;
                return (hostpart(here) && hostpart(uri) && hostpart(here)) !== hostpart(uri);
            }
        },
        {
            key: "handleError",
            value: function handleError(response, docuri, options) {
                if (this.isCrossSite(docuri)) {
                    // Make sure we haven't retried already
                    if (options.credentials && options.credentials === "include" && !options.retriedWithNoCredentials) return this.retryNoCredentials(docuri, options);
                    // Now attempt retry via proxy
                    var proxyUri = Fetcher.crossSiteProxy(docuri);
                    if (proxyUri && !options.proxyUsed) // console.log('web: Direct failed so trying proxy ' + proxyUri)
                    return this.redirectToProxy(proxyUri, options);
                }
                var message;
                if (response instanceof Error) message = "Fetch error: " + response.message;
                else {
                    message = response.statusText;
                    if (response.responseText) message += " ".concat(response.responseText);
                }
                // This is either not a CORS error, or retries have been made
                return this.failFetch(options, message, response.status || 998, response);
            }
        },
        {
            key: "addType",
            value: function addType(rdfType, req, kb, locURI) {
                // add type to all redirected resources too
                var prev = req;
                if (locURI) {
                    var reqURI = kb.any(prev, this.ns.link("requestedURI"));
                    if (reqURI && reqURI.value !== locURI) kb.add(kb.rdfFactory.namedNode(locURI), this.ns.rdf("type"), rdfType, this.appNode);
                }
                for(;;){
                    var doc = kb.any(prev, this.ns.link("requestedURI"));
                    if (doc && doc.value) kb.add(kb.rdfFactory.namedNode(doc.value), this.ns.rdf("type"), rdfType, this.appNode);
                     // convert Literal
                    prev = kb.any(undefined, kb.rdfFactory.namedNode("http://www.w3.org/2007/ont/link#redirectedRequest"), prev);
                    if (!prev) break;
                    var response = kb.any(prev, kb.rdfFactory.namedNode("http://www.w3.org/2007/ont/link#response"));
                    if (!response) break;
                    var redirection = kb.any(response, kb.rdfFactory.namedNode("http://www.w3.org/2007/ont/http#status"));
                    if (!redirection) break;
                    // @ts-ignore always true?
                    if (redirection !== "301" && redirection !== "302") break;
                }
            }
        },
        {
            key: "handleResponse",
            value: function handleResponse(response, docuri, options) {
                var _this11 = this;
                var kb = this.store;
                var headers = response.headers;
                var reqNode = options.req;
                var responseNode = this.saveResponseMetadata(response, options);
                var contentType = this.normalizedContentType(options, headers) || "";
                var contentLocation = headers.get("content-location");
                // this.fireCallbacks('recv', xhr.args)
                // this.fireCallbacks('headers', [{uri: docuri, headers: xhr.headers}])
                // Check for masked errors (CORS, etc)
                if (response.status === 0) // console.log('Masked error - status 0 for ' + docuri)
                return this.handleError(response, docuri, options);
                if (response.status >= 400) {
                    if (response.status === 404) {
                        this.nonexistent[options.original.value] = true;
                        this.nonexistent[docuri] = true;
                    }
                    return this.saveErrorResponse(response, responseNode).then(function() {
                        var errorMessage = options.resource + " " + response.statusText;
                        return _this11.failFetch(options, errorMessage, response.status, response);
                    });
                }
                var diffLocation = null;
                var absContentLocation = null;
                if (contentLocation) {
                    absContentLocation = $4Q80K.join(contentLocation, docuri);
                    if (absContentLocation !== docuri) diffLocation = absContentLocation;
                }
                if (response.status === 200) {
                    this.addType(this.ns.link("Document"), reqNode, kb, docuri);
                    if (diffLocation) this.addType(this.ns.link("Document"), reqNode, kb, diffLocation);
                    // Before we parse new data clear old but only on 200
                    if (options.clearPreviousData) {
                        // kb.removeDocument(options.resource)
                        // only remove content, keep metatdata
                        var sts = kb.statementsMatching(undefined, undefined, undefined, options.resource).slice(); // Take a copy as this is the actual index
                        for(var i = 0; i < sts.length; i++)kb.removeStatement(sts[i]);
                    }
                    var isImage = contentType.includes("image/") || contentType.includes("application/pdf");
                    if (contentType && isImage) {
                        this.addType(kb.rdfFactory.namedNode("http://purl.org/dc/terms/Image"), reqNode, kb, docuri);
                        if (diffLocation) this.addType(kb.rdfFactory.namedNode("http://purl.org/dc/terms/Image"), reqNode, kb, diffLocation);
                    }
                }
                // If we have already got the thing at this location, abort
                if (contentLocation) {
                    if (!options.force && diffLocation && this.requested[absContentLocation] === "done") // we have already fetched this
                    // should we smush too?
                    // log.info("HTTP headers indicate we have already" + " retrieved " +
                    // xhr.resource + " as " + absContentLocation + ". Aborting.")
                    return this.doneFetch(options, response);
                    this.requested[absContentLocation] = true;
                }
                this.parseLinkHeader(headers.get("link"), options.original, reqNode);
                var handler = this.handlerForContentType(contentType, response);
                if (!handler) {
                    //  Not a problem, we just don't extract data
                    this.addStatus(reqNode, "Fetch over. No data handled.");
                    return this.doneFetch(options, response);
                }
                return response.text()// @ts-ignore Types seem right
                .then(function(responseText) {
                    response.responseText = responseText;
                    return handler.parse(_this11, responseText, options, response);
                });
            }
        },
        {
            key: "saveErrorResponse",
            value: function saveErrorResponse(response, responseNode) {
                var _this12 = this;
                var kb = this.store;
                return response.text().then(function(content) {
                    if (content.length > 10) kb.add(responseNode, _this12.ns.http("content"), kb.rdfFactory.literal(content), responseNode);
                });
            }
        },
        {
            key: "handlerForContentType",
            value: function handlerForContentType(contentType, response) {
                if (!contentType) return null;
                var Handler = this.handlers.find(function(handler) {
                    return contentType.match(handler.pattern);
                });
                // @ts-ignore in practice all Handlers have constructors.
                return Handler ? new Handler(response) : null;
            }
        },
        {
            key: "guessContentType",
            value: function guessContentType(uri) {
                return $1d9128915acc42fc$var$CONTENT_TYPE_BY_EXT[uri.split(".").pop()];
            }
        },
        {
            key: "normalizedContentType",
            value: function normalizedContentType(options, headers) {
                if (options.forceContentType) return options.forceContentType;
                var contentType = headers.get("content-type");
                if (!contentType || contentType.includes("application/octet-stream")) {
                    var guess = this.guessContentType(options.resource.value);
                    if (guess) return guess;
                }
                var protocol = $4Q80K.protocol(options.resource.value);
                if (!contentType && [
                    "file",
                    "chrome"
                ].includes(protocol)) return "text/xml";
                return contentType;
            }
        },
        {
            key: "redirectToProxy",
            value: function redirectToProxy(newURI, options) {
                var _this13 = this;
                this.addStatus(options.req, "BLOCKED -> Cross-site Proxy to <" + newURI + ">");
                options.proxyUsed = true;
                var kb = this.store;
                var oldReq = options.req; // request metadata blank node
                if (!options.noMeta) {
                    kb.add(oldReq, this.ns.link("redirectedTo"), kb.rdfFactory.namedNode(newURI), oldReq);
                    this.addStatus(oldReq, "redirected to new request"); // why
                }
                this.requested[options.resource.value] = "redirected";
                this.redirectedTo[options.resource.value] = newURI;
                var newOptions = Object.assign({}, options);
                newOptions.baseURI = options.resource.value;
                return this.fetchUri(newURI, newOptions).then(function(response) {
                    if (!newOptions.noMeta) kb.add(oldReq, _this13.ns.link("redirectedRequest"), newOptions.req, _this13.appNode);
                    return response;
                });
            }
        },
        {
            key: "setRequestTimeout",
            value: function setRequestTimeout(uri, options) {
                var _this14 = this;
                return new Promise(function(resolve) {
                    _this14.timeouts[uri] = (_this14.timeouts[uri] || []).concat(setTimeout(function() {
                        if (_this14.isPending(uri) && !options.retriedWithNoCredentials && !options.proxyUsed) resolve(_this14.failFetch(options, "Request to ".concat(uri, " timed out"), "timeout"));
                    }, _this14.timeout));
                });
            }
        },
        {
            key: "addFetchCallback",
            value: function addFetchCallback(uri, callback) {
                if (!this.fetchCallbacks[uri]) this.fetchCallbacks[uri] = [
                    callback
                ];
                else this.fetchCallbacks[uri].push(callback);
            }
        },
        {
            key: "acceptString",
            value: function acceptString() {
                var acceptstring = "";
                for(var mediaType in this.mediatypes){
                    if (acceptstring !== "") acceptstring += ", ";
                    acceptstring += mediaType;
                    for(var property in this.mediatypes[mediaType])acceptstring += ";" + property + "=" + this.mediatypes[mediaType][property];
                }
                return acceptstring;
            }
        }
    ], [
        {
            key: "crossSiteProxy",
            value: function crossSiteProxy(uri) {
                if (Fetcher.crossSiteProxyTemplate) return Fetcher.crossSiteProxyTemplate.replace("{uri}", encodeURIComponent(uri));
                else return undefined;
            }
        },
        {
            key: "offlineOverride",
            value: function offlineOverride(uri) {
                // Map the URI to a localhost proxy if we are running on localhost
                // This is used for working offline, e.g. on planes.
                // Is the script itself is running in localhost, then access all
                //   data in a localhost mirror.
                // Do not remove without checking with TimBL
                var requestedURI = uri;
                var UI;
                if (typeof window !== "undefined" && window.panes && (UI = window.panes.UI) && UI.preferences && UI.preferences.get("offlineModeUsingLocalhost")) {
                    if (requestedURI.slice(0, 7) === "http://" && requestedURI.slice(7, 17) !== "localhost/") {
                        requestedURI = "http://localhost/" + requestedURI.slice(7);
                        (0, $kAE07.default).warn("Localhost kludge for offline use: actually getting <" + requestedURI + ">");
                    }
                // log.warn("Localhost kludge NOT USED <" + requestedURI + ">")
                }
                return requestedURI;
            }
        },
        {
            key: "proxyIfNecessary",
            value: function proxyIfNecessary(uri) {
                var UI;
                if (typeof window !== "undefined" && window.panes && (UI = window.panes.UI) && UI.isExtension) return uri;
                 // Extension does not need proxy
                if (typeof $SolidTestEnvironment !== "undefined" && $SolidTestEnvironment.localSiteMap) {
                    // nested dictionaries of URI parts from origin down
                    var hostpath = uri.split("/").slice(2); // the bit after the //
                    var lookup = function lookup(parts, index) {
                        var z = index[parts.shift()];
                        if (!z) return null;
                        if (typeof z === "string") return z + parts.join("/");
                        if (!parts) return null;
                        return lookup(parts, z);
                    };
                    var y = lookup(hostpath, $SolidTestEnvironment.localSiteMap);
                    if (y) return y;
                }
                // browser does 2014 on as https browser script not trusted
                // If the web app origin is https: then the mixed content rules
                // prevent it loading insecure http: stuff so we need proxy.
                if (Fetcher.crossSiteProxyTemplate && typeof document !== "undefined" && document.location && ("" + document.location).slice(0, 6) === "https:" && // origin is secure
                uri.slice(0, 5) === "http:") // requested data is not
                return Fetcher.crossSiteProxyTemplate.replace("{uri}", encodeURIComponent(uri));
                return uri;
            }
        },
        {
            key: "unsupportedProtocol",
            value: function unsupportedProtocol(uri) {
                var pcol = $4Q80K.protocol(uri);
                return pcol === "tel" || pcol === "mailto" || pcol === "urn";
            }
        },
        {
            key: "setCredentials",
            value: function setCredentials(requestedURI) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                // 2014 CORS problem:
                // XMLHttpRequest cannot load http://www.w3.org/People/Berners-Lee/card.
                // A wildcard '*' cannot be used in the 'Access-Control-Allow-Origin'
                //   header when the credentials flag is true.
                // @ Many ontology files under http: and need CORS wildcard ->
                //   can't have credentials
                if (options.credentials === undefined) {
                    // Caller using new fetch convention
                    if (options.withCredentials !== undefined) // XHR style is what Fetcher specified before
                    options.credentials = options.withCredentials ? "include" : "omit";
                    else options.credentials = "include"; // default is to be logged on
                }
            }
        }
    ]);
    return Fetcher;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($1d9128915acc42fc$export$2e2bcd8739ae039, "HANDLERS", void 0);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($1d9128915acc42fc$export$2e2bcd8739ae039, "CONTENT_TYPE_BY_EXT", void 0);
// TODO: Document this
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($1d9128915acc42fc$export$2e2bcd8739ae039, "crossSiteProxyTemplate", void 0);
$1d9128915acc42fc$export$2e2bcd8739ae039.HANDLERS = $1d9128915acc42fc$var$defaultHandlers;
$1d9128915acc42fc$export$2e2bcd8739ae039.CONTENT_TYPE_BY_EXT = $1d9128915acc42fc$var$CONTENT_TYPE_BY_EXT;


















// Converting between SPARQL queries and the $rdf query API
/*

function SQuery () {
  this.terms = []
  return this
}

STerm.prototype.toString = STerm.val
SQuery.prototype.add = function (str) {this.terms.push()}*/ 
var $kAE07 = parcelRequire("kAE07");

function $0f0488a2fe711091$export$2e2bcd8739ae039(SPARQL, testMode, kb) {
    // AJAR_ClearTable()
    var variableHash = [];
    function makeVar(name) {
        if (variableHash[name]) return variableHash[name];
        var newVar = kb.variable(name);
        variableHash[name] = newVar;
        return newVar;
    }
    // term type functions
    function isRealText(term) {
        return typeof term === "string" && term.match(/[^ \n\t]/);
    }
    function isVar(term) {
        return typeof term === "string" && term.match(/^[\?\$]/);
    }
    function fixSymbolBrackets(term) {
        if (typeof term === "string") return term.replace(/^&lt;/, "<").replace(/&gt;$/, ">");
        else return term;
    }
    function isSymbol(term) {
        return typeof term === "string" && term.match(/^<[^>]*>$/);
    }
    function isBnode(term) {
        return typeof term === "string" && (term.match(/^_:/) || term.match(/^$/));
    }
    function isPrefix(term) {
        return typeof term === "string" && term.match(/:$/);
    }
    function isPrefixedSymbol(term) {
        return typeof term === "string" && term.match(/^:|^[^_][^:]*:/);
    }
    function getPrefix(term) {
        var a = term.split(":");
        return a[0];
    }
    function getSuffix(term) {
        var a = term.split(":");
        return a[1];
    }
    function removeBrackets(term) {
        if (isSymbol(term)) return term.slice(1, term.length - 1);
        else return term;
    }
    // takes a string and returns an array of strings and Literals in the place of literals
    function parseLiterals(str) {
        // var sin = (str.indexOf(/[ \n]\'/)==-1)?null:str.indexOf(/[ \n]\'/), doub = (str.indexOf(/[ \n]\"/)==-1)?null:str.indexOf(/[ \n]\"/)
        var sin = str.indexOf("'") === -1 ? null : str.indexOf("'");
        var doub = str.indexOf('"') === -1 ? null : str.indexOf('"');
        // alert("S: "+sin+" D: "+doub)
        if (!sin && !doub) {
            var a = new Array(1);
            a[0] = str;
            return a;
        }
        var res = new Array(2);
        var br;
        var ind;
        if (!sin || doub && doub < sin) {
            br = '"';
            ind = doub;
        } else if (!doub || sin && sin < doub) {
            br = "'";
            ind = sin;
        } else {
            (0, $kAE07.default).error("SQARQL QUERY OOPS!");
            return res;
        }
        res[0] = str.slice(0, ind);
        var end = str.slice(ind + 1).indexOf(br);
        if (end === -1) {
            (0, $kAE07.default).error("SPARQL parsing error: no matching parentheses in literal " + str);
            return str;
        }
        // alert(str.slice(end + ind + 2).match(/^\^\^/))
        var end2;
        if (str.slice(end + ind + 2).match(/^\^\^/)) {
            end2 = str.slice(end + ind + 2).indexOf(" ");
            // alert(end2)
            res[1] = kb.literal(str.slice(ind + 1, ind + 1 + end), kb.sym(removeBrackets(str.slice(ind + 4 + end, ind + 2 + end + end2))));
            // alert(res[1].datatype.uri)
            res = res.concat(parseLiterals(str.slice(end + ind + 3 + end2)));
        } else if (str.slice(end + ind + 2).match(/^@/)) {
            end2 = str.slice(end + ind + 2).indexOf(" ");
            // alert(end2)
            res[1] = kb.literal(str.slice(ind + 1, ind + 1 + end), str.slice(ind + 3 + end, ind + 2 + end + end2), null);
            // alert(res[1].datatype.uri)
            res = res.concat(parseLiterals(str.slice(end + ind + 2 + end2)));
        } else {
            res[1] = kb.literal(str.slice(ind + 1, ind + 1 + end));
            (0, $kAE07.default).info("Literal found: " + res[1]);
            res = res.concat(parseLiterals(str.slice(end + ind + 2))); // finds any other literals
        }
        return res;
    }
    function spaceDelimit(str) {
        str = str.replace(/\(/g, " ( ").replace(/\)/g, " ) ").replace(/</g, " <").replace(/>/g, "> ").replace(/{/g, " { ").replace(/}/g, " } ").replace(/[\t\n\r]/g, " ").replace(/; /g, " ; ").replace(/\. /g, " . ").replace(/, /g, " , ");
        (0, $kAE07.default).info("New str into spaceDelimit: \n" + str);
        var res = [];
        var br = str.split(" ");
        for(var x in br)if (isRealText(br[x])) res = res.concat(br[x]);
        return res;
    }
    function replaceKeywords(input) {
        var strarr = input;
        for(var x = 0; x < strarr.length; x++){
            if (strarr[x] === "a") strarr[x] = "<http://www.w3.org/1999/02/22-rdf-syntax-ns#type>";
            if (strarr[x] === "is" && strarr[x + 2] === "of") {
                strarr.splice(x, 1);
                strarr.splice(x + 1, 1);
                var s = strarr[x - 1];
                strarr[x - 1] = strarr[x + 1];
                strarr[x + 1] = s;
            }
        }
        return strarr;
    }
    function toTerms(input) {
        var res = [];
        for(var x = 0; x < input.length; x++){
            if (typeof input[x] !== "string") {
                res[x] = input[x];
                continue;
            }
            input[x] = fixSymbolBrackets(input[x]);
            if (isVar(input[x])) res[x] = makeVar(input[x].slice(1));
            else if (isBnode(input[x])) {
                (0, $kAE07.default).info(input[x] + " was identified as a bnode.");
                res[x] = kb.bnode();
            } else if (isSymbol(input[x])) {
                (0, $kAE07.default).info(input[x] + " was identified as a symbol.");
                res[x] = kb.sym(removeBrackets(input[x]));
            } else if (isPrefixedSymbol(input[x])) {
                (0, $kAE07.default).info(input[x] + " was identified as a prefixed symbol");
                if (prefixes[getPrefix(input[x])]) res[x] = kb.sym(input[x] = prefixes[getPrefix(input[x])] + getSuffix(input[x]));
                else {
                    (0, $kAE07.default).error("SPARQL error: " + input[x] + " with prefix " + getPrefix(input[x]) + " does not have a correct prefix entry.");
                    res[x] = input[x];
                }
            } else res[x] = input[x];
        }
        return res;
    }
    function tokenize(str) {
        var token1 = parseLiterals(str);
        var token2 = [];
        for(var x in token1)if (typeof token1[x] === "string") token2 = token2.concat(spaceDelimit(token1[x]));
        else token2 = token2.concat(token1[x]);
        token2 = replaceKeywords(token2);
        (0, $kAE07.default).info("SPARQL Tokens: " + token2);
        return token2;
    }
    // CASE-INSENSITIVE
    function arrayIndexOf(str, arr) {
        for(var i = 0; i < arr.length; i++){
            if (typeof arr[i] !== "string") continue;
            if (arr[i].toLowerCase() === str.toLowerCase()) return i;
        }
        // log.warn("No instance of "+str+" in array "+arr)
        return null;
    }
    // CASE-INSENSITIVE
    function arrayIndicesOf(str, arr) {
        var ind = [];
        for(var i = 0; i < arr.length; i++){
            if (typeof arr[i] !== "string") continue;
            if (arr[i].toLowerCase() === str.toLowerCase()) ind.push(i);
        }
        return ind;
    }
    function setVars(input, query) {
        (0, $kAE07.default).info("SPARQL vars: " + input);
        for(var x in input)if (isVar(input[x])) {
            (0, $kAE07.default).info("Added " + input[x] + " to query variables from SPARQL");
            var v = makeVar(input[x].slice(1));
            query.vars.push(v);
            v.label = input[x].slice(1);
        } else (0, $kAE07.default).warn("Incorrect SPARQL variable in SELECT: " + input[x]);
    }
    function getPrefixDeclarations(input) {
        var prefInd = arrayIndicesOf("PREFIX", input);
        var res = [];
        for(var i in prefInd){
            var a = input[prefInd[i] + 1];
            var b = input[prefInd[i] + 2];
            if (!isPrefix(a)) (0, $kAE07.default).error("Invalid SPARQL prefix: " + a);
            else if (!isSymbol(b)) (0, $kAE07.default).error("Invalid SPARQL symbol: " + b);
            else {
                (0, $kAE07.default).info("Prefix found: " + a + " -> " + b);
                var pref = getPrefix(a);
                var symbol = removeBrackets(b);
                res[pref] = symbol;
            }
        }
        return res;
    }
    function getMatchingBracket(arr, open, close) {
        (0, $kAE07.default).info("Looking for a close bracket of type " + close + " in " + arr);
        var index = 0;
        for(var i = 0; i < arr.length; i++){
            if (arr[i] === open) index++;
            if (arr[i] === close) index--;
            if (index < 0) return i;
        }
        (0, $kAE07.default).error("Statement had no close parenthesis in SPARQL query");
        return 0;
    }
    function constraintGreaterThan(value) {
        this.describe = function(varstr) {
            return varstr + " > " + value.toNT();
        };
        this.test = function(term) {
            if (term.value.match(/[0-9]+(\.[0-9]+)?([eE][+-]?[0-9]+)?/)) return parseFloat(term.value) > parseFloat(value);
            else return term.toNT() > value.toNT();
        };
        return this;
    }
    function constraintLessThan(value) {
        // this is not the recommended usage. Should only work on literal, numeric, dateTime
        this.describe = function(varstr) {
            return varstr + " < " + value.toNT();
        };
        this.test = function(term) {
            // this.describe = function (varstr) { return varstr + " < "+value }
            if (term.value.match(/[0-9]+(\.[0-9]+)?([eE][+-]?[0-9]+)?/)) return parseFloat(term.value) < parseFloat(value);
            else return term.toNT() < value.toNT();
        };
        return this;
    }
    // This should only work on literals but doesn't.
    function ConstraintEqualTo(value) {
        this.describe = function(varstr) {
            return varstr + " = " + value.toNT();
        };
        this.test = function(term) {
            return value.equals(term);
        };
        return this;
    }
    // value must be a literal
    function ConstraintRegexp(value) {
        this.describe = function(varstr) {
            return "REGEXP( '" + value + "' , " + varstr + " )";
        };
        this.test = function(term) {
            var str = value;
            // str = str.replace(/^//,"").replace(//$/,"")
            var rg = new RegExp(str);
            if (term.value) return rg.test(term.value);
            else return false;
        };
    }
    function setConstraint(input, pat) {
        if (input.length === 3 && input[0].termType === "Variable" && (input[2].termType === "NamedNode" || input[2].termType === "Literal")) {
            if (input[1] === "=") {
                (0, $kAE07.default).debug("Constraint added: " + input);
                pat.constraints[input[0]] = new ConstraintEqualTo(input[2]);
            } else if (input[1] === ">") {
                (0, $kAE07.default).debug("Constraint added: " + input);
                pat.constraints[input[0]] = new ConstraintEqualTo(input[2]);
            } else if (input[1] === "<") {
                (0, $kAE07.default).debug("Constraint added: " + input);
                pat.constraints[input[0]] = new ConstraintEqualTo(input[2]);
            } else (0, $kAE07.default).warn("I don't know how to handle the constraint: " + input);
        } else if (input.length === 6 && typeof input[0] === "string" && input[0].toLowerCase() === "regexp" && input[1] === "(" && input[5] === ")" && input[3] === "," && input[4].termType === "Variable" && input[2].termType === "Literal") {
            (0, $kAE07.default).debug("Constraint added: " + input);
            pat.constraints[input[4]] = new ConstraintRegexp(input[2].value);
        }
    // log.warn("I don't know how to handle the constraint: "+input)
    // alert("length: "+input.length+" input 0 type: "+input[0].termType+" input 1: "+input[1]+" input[2] type: "+input[2].termType)
    }
    function setOptional(terms, pat) {
        (0, $kAE07.default).debug("Optional query: " + terms + " not yet implemented.");
        var opt = kb.formula();
        setWhere(terms, opt);
        pat.optional.push(opt);
    }
    function setWhere(input, pat) {
        var terms = toTerms(input);
        var end;
        (0, $kAE07.default).debug("WHERE: " + terms);
        var opt;
        // var opt = arrayIndicesOf("OPTIONAL",terms)
        while(arrayIndexOf("OPTIONAL", terms)){
            opt = arrayIndexOf("OPTIONAL", terms);
            (0, $kAE07.default).debug("OPT: " + opt + " " + terms[opt] + " in " + terms);
            if (terms[opt + 1] !== "{") (0, $kAE07.default).warn("Bad optional opening bracket in word " + opt);
            end = getMatchingBracket(terms.slice(opt + 2), "{", "}");
            if (end === -1) (0, $kAE07.default).error("No matching bracket in word " + opt);
            else {
                setOptional(terms.slice(opt + 2, opt + 2 + end), pat);
                // alert(pat.statements[0].toNT())
                opt = arrayIndexOf("OPTIONAL", terms);
                end = getMatchingBracket(terms.slice(opt + 2), "{", "}");
                terms.splice(opt, end + 3);
            }
        }
        (0, $kAE07.default).debug("WHERE after optionals: " + terms);
        while(arrayIndexOf("FILTER", terms)){
            var filt = arrayIndexOf("FILTER", terms);
            if (terms[filt + 1] !== "(") (0, $kAE07.default).warn("Bad filter opening bracket in word " + filt);
            end = getMatchingBracket(terms.slice(filt + 2), "(", ")");
            if (end === -1) (0, $kAE07.default).error("No matching bracket in word " + filt);
            else {
                setConstraint(terms.slice(filt + 2, filt + 2 + end), pat);
                filt = arrayIndexOf("FILTER", terms);
                end = getMatchingBracket(terms.slice(filt + 2), "(", ")");
                terms.splice(filt, end + 3);
            }
        }
        (0, $kAE07.default).debug("WHERE after filters and optionals: " + terms);
        extractStatements(terms, pat);
    }
    function extractStatements(terms, formula) {
        var arrayZero = new Array(1);
        arrayZero[0] = -1; // this is just to add the beginning of the where to the periods index.
        var per = arrayZero.concat(arrayIndicesOf(".", terms));
        var stat = [];
        for(var x = 0; x < per.length - 1; x++)stat[x] = terms.slice(per[x] + 1, per[x + 1]);
        // Now it's in an array of statements
        for(x in stat){
            // THIS MUST BE CHANGED FOR COMMA, SEMICOLON
            (0, $kAE07.default).info("s+p+o " + x + " = " + stat[x]);
            var subj = stat[x][0];
            stat[x].splice(0, 1);
            var sem = arrayZero.concat(arrayIndicesOf(";", stat[x]));
            sem.push(stat[x].length);
            var stat2 = [];
            for(var y = 0; y < sem.length - 1; y++)stat2[y] = stat[x].slice(sem[y] + 1, sem[y + 1]);
            for(x in stat2){
                (0, $kAE07.default).info("p+o " + x + " = " + stat[x]);
                var pred = stat2[x][0];
                stat2[x].splice(0, 1);
                var com = arrayZero.concat(arrayIndicesOf(",", stat2[x]));
                com.push(stat2[x].length);
                var stat3 = [];
                for(y = 0; y < com.length - 1; y++)stat3[y] = stat2[x].slice(com[y] + 1, com[y + 1]);
                for(x in stat3){
                    var obj = stat3[x][0];
                    (0, $kAE07.default).info("Subj=" + subj + " Pred=" + pred + " Obj=" + obj);
                    formula.add(subj, pred, obj);
                }
            }
        }
    }
    // ******************************* Body of SPARQLToQuery ***************************//
    (0, $kAE07.default).info("SPARQL input: \n" + SPARQL);
    var q = new (0, $06f9ff3d33460d2e$export$62297b13309008b2)();
    var sp = tokenize(SPARQL); // first tokenize everything
    var prefixes = getPrefixDeclarations(sp);
    if (!prefixes.rdf) prefixes.rdf = "http://www.w3.org/1999/02/22-rdf-syntax-ns#";
    if (!prefixes.rdfs) prefixes.rdfs = "http://www.w3.org/2000/01/rdf-schema#";
    var selectLoc = arrayIndexOf("SELECT", sp);
    var whereLoc = arrayIndexOf("WHERE", sp);
    if (selectLoc < 0 || whereLoc < 0 || selectLoc > whereLoc) {
        (0, $kAE07.default).error("Invalid or nonexistent SELECT and WHERE tags in SPARQL query");
        return false;
    }
    setVars(sp.slice(selectLoc + 1, whereLoc), q);
    setWhere(sp.slice(whereLoc + 2, sp.length - 1), q.pat);
    if (testMode) return q;
    for(var x in q.pat.statements){
        var st = q.pat.statements[x];
        if (st.subject.termType === "NamedNode") {
            if (kb.fetcher) kb.fetcher.lookUpThing(st.subject, "sparql:" + st.subject);
        }
        if (st.object.termType === "NamedNode") {
            if (kb.fetcher) kb.fetcher.lookUpThing(st.object, "sparql:" + st.object);
        }
    }
    // alert(q.pat)
    return q;
// checkVars()
// *******************************************************************//
}





var $41YNz = parcelRequire("41YNz");


var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");



var $4Q80K = parcelRequire("4Q80K");




var $gCJkd = parcelRequire("gCJkd");

var $23fob = parcelRequire("23fob");

var $avzMW = parcelRequire("avzMW");
function $f8539385ca2d21cc$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $f8539385ca2d21cc$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $f8539385ca2d21cc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f8539385ca2d21cc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f8539385ca2d21cc$var$_arrayLikeToArray(o, minLen);
}
function $f8539385ca2d21cc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
* The UpdateManager is a helper object for a store.
* Just as a Fetcher provides the store with the ability to read and write,
* the Update Manager provides functionality for making small patches in real time,
* and also looking out for concurrent updates from other agents
*/ var $f8539385ca2d21cc$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  store - The quadstore to store data and metadata. Created if not passed.
  */ function UpdateManager(store) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UpdateManager);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "store", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "ifps", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "fps", void 0);
        /** Index of objects for coordinating incoming and outgoing patches */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "patchControl", void 0);
        /** Object of namespaces */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "ns", void 0);
        store = store || new (0, $6f5c135260474402$export$2e2bcd8739ae039)();
        if (store.updater) throw new Error("You can't have two UpdateManagers for the same store");
        if (!store.fetcher) store.fetcher = new (0, $1d9128915acc42fc$export$2e2bcd8739ae039)(store);
        this.store = store;
        store.updater = this;
        this.ifps = {};
        this.fps = {};
        this.ns = {};
        this.ns.link = (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/2007/ont/link#");
        this.ns.http = (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/2007/ont/http#");
        this.ns.httph = (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/2007/ont/httph#");
        this.ns.ldp = (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/ns/ldp#");
        this.ns.rdf = (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/1999/02/22-rdf-syntax-ns#");
        this.ns.rdfs = (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/2000/01/rdf-schema#");
        this.ns.rdf = (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/1999/02/22-rdf-syntax-ns#");
        this.ns.owl = (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/2002/07/owl#");
        this.patchControl = [];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UpdateManager, [
        {
            key: "patchControlFor",
            value: function patchControlFor(doc) {
                if (!this.patchControl[doc.value]) this.patchControl[doc.value] = [];
                return this.patchControl[doc.value];
            }
        },
        {
            key: "isHttpUri",
            value: function isHttpUri(uri) {
                return uri.slice(0, 4) === "http";
            }
        },
        {
            key: "flagAuthorizationMetadata",
            value: function flagAuthorizationMetadata(kb) {
                var _kb$fetcher;
                if (!kb) kb = this.store;
                var meta = (_kb$fetcher = kb.fetcher) === null || _kb$fetcher === void 0 ? void 0 : _kb$fetcher.appNode;
                var requests = kb.statementsMatching(undefined, this.ns.link("requestedURI"), undefined, meta).map(function(st) {
                    return st.subject;
                });
                var _iterator = $f8539385ca2d21cc$var$_createForOfIteratorHelper(requests), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var request = _step.value;
                        var _response = kb.any(request, this.ns.link("response"), null, meta);
                        if (_response != undefined) // ts
                        kb.add(_response, this.ns.link("outOfDate"), true, meta); // @@ Boolean is fine - fix types
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        },
        {
            key: "checkEditable",
            value: function() {
                var _checkEditable = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(uri, kb) {
                    var _kb$fetcher2;
                    var initial, final;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (uri) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return", false);
                            case 2:
                                if (!kb) kb = this.store;
                                initial = this.editable(uri, kb);
                                if (!(initial !== undefined)) {
                                    _context.next = 6;
                                    break;
                                }
                                return _context.abrupt("return", initial);
                            case 6:
                                _context.next = 8;
                                return (_kb$fetcher2 = kb.fetcher) === null || _kb$fetcher2 === void 0 ? void 0 : _kb$fetcher2.load(uri);
                            case 8:
                                final = this.editable(uri, kb); // console.log(`Loaded ${uri} just to check editable, result: ${final}.`)
                                return _context.abrupt("return", final);
                            case 10:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function checkEditable(_x, _x2) {
                    return _checkEditable.apply(this, arguments);
                }
                return checkEditable;
            }()
        },
        {
            key: "editable",
            value: function editable(uri, kb) {
                var _kb$fetcher3;
                if (!uri) return false; // Eg subject is bnode, no known doc to write to
                if (!kb) kb = this.store;
                uri = (0, $avzMW.termValue)(uri);
                if (!this.isHttpUri(uri)) {
                    if (kb.holds(kb.rdfFactory.namedNode(uri), kb.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"), kb.rdfFactory.namedNode("http://www.w3.org/2007/ont/link#MachineEditableDocument"))) return "LOCALFILE";
                }
                var request;
                var definitive = false;
                var meta = (_kb$fetcher3 = kb.fetcher) === null || _kb$fetcher3 === void 0 ? void 0 : _kb$fetcher3.appNode;
                // const kb = s
                // @ts-ignore passes a string to kb.each, which expects a term. Should this work?
                var requests = kb.each(undefined, this.ns.link("requestedURI"), (0, $4Q80K.docpart)(uri), meta);
                var method;
                for(var r = 0; r < requests.length; r++){
                    request = requests[r];
                    if (request !== undefined) {
                        var _response2 = kb.any(request, this.ns.link("response"), null, meta);
                        if (_response2 !== undefined) {
                            // ts
                            var outOfDate = kb.anyJS(_response2, this.ns.link("outOfDate"), null, meta);
                            if (outOfDate) continue;
                            var wacAllow = kb.anyValue(_response2, this.ns.httph("wac-allow"));
                            if (wacAllow) {
                                var _iterator2 = $f8539385ca2d21cc$var$_createForOfIteratorHelper(wacAllow.split(",")), _step2;
                                try {
                                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                        var bit = _step2.value;
                                        var lr = bit.split("=");
                                        if (lr[0].includes("user") && !lr[1].includes("write") && !lr[1].includes("append")) // console.log('    editable? excluded by WAC-Allow: ', wacAllow)
                                        return false;
                                    }
                                } catch (err) {
                                    _iterator2.e(err);
                                } finally{
                                    _iterator2.f();
                                }
                            }
                            var acceptPatch = kb.each(_response2, this.ns.httph("accept-patch"));
                            if (acceptPatch.length) for(var i = 0; i < acceptPatch.length; i++){
                                method = acceptPatch[i].value.trim();
                                if (method.indexOf("text/n3") >= 0) return "N3PATCH";
                                if (method.indexOf("application/sparql-update") >= 0) return "SPARQL";
                                if (method.indexOf("application/sparql-update-single-match") >= 0) return "SPARQL";
                            }
                            var authorVia = kb.each(_response2, this.ns.httph("ms-author-via"));
                            if (authorVia.length) for(var _i = 0; _i < authorVia.length; _i++){
                                method = authorVia[_i].value.trim();
                                if (method.indexOf("SPARQL") >= 0) return "SPARQL";
                                if (method.indexOf("DAV") >= 0) return "DAV";
                            }
                            if (!this.isHttpUri(uri)) {
                                if (!wacAllow) return false;
                                else return "LOCALFILE";
                            }
                            var status = kb.each(_response2, this.ns.http("status"));
                            if (status.length) {
                                for(var _i2 = 0; _i2 < status.length; _i2++)// @ts-ignore since statuses should be TFTerms, this should always be false
                                if (status[_i2] === 200 || status[_i2] === 404) definitive = true;
                            }
                        }
                    }
                }
                if (requests.length === 0) ;
                else {
                    if (definitive) return false; // We have got a request and it did NOT say editable => not editable
                }
                // console.log('UpdateManager.editable: inconclusive for ' + uri + '\n')
                return undefined; // We don't know (yet) as we haven't had a response (yet)
            }
        },
        {
            key: "anonymize",
            value: function anonymize(obj) {
                var anonymized = obj.toNT().substr(0, 2) === "_:" && this.mentioned(obj) ? "?" + obj.toNT().substr(2) : obj.toNT();
                return anonymized;
            }
        },
        {
            key: "anonymizeNT",
            value: function anonymizeNT(stmt) {
                return this.anonymize(stmt.subject) + " " + this.anonymize(stmt.predicate) + " " + this.anonymize(stmt.object) + " .";
            }
        },
        {
            key: "nTriples",
            value: function nTriples(stmt) {
                return "".concat(stmt.subject.toNT(), " ").concat(stmt.predicate.toNT(), " ").concat(stmt.object.toNT(), " .");
            }
        },
        {
            key: "statementBnodes",
            value: function statementBnodes(st) {
                return [
                    st.subject,
                    st.predicate,
                    st.object
                ].filter(function(x) {
                    return (0, $gCJkd.isBlankNode)(x);
                });
            }
        },
        {
            key: "statementArrayBnodes",
            value: function statementArrayBnodes(sts) {
                var bnodes = [];
                for(var i = 0; i < sts.length; i++)bnodes = bnodes.concat(this.statementBnodes(sts[i]));
                bnodes.sort(); // in place sort - result may have duplicates
                var bnodes2 = [];
                for(var j = 0; j < bnodes.length; j++)if (j === 0 || !bnodes[j].equals(bnodes[j - 1])) bnodes2.push(bnodes[j]);
                return bnodes2;
            }
        },
        {
            key: "cacheIfps",
            value: function cacheIfps() {
                this.ifps = {};
                var a = this.store.each(undefined, this.ns.rdf("type"), this.ns.owl("InverseFunctionalProperty"));
                for(var i = 0; i < a.length; i++)this.ifps[a[i].value] = true;
                this.fps = {};
                a = this.store.each(undefined, this.ns.rdf("type"), this.ns.owl("FunctionalProperty"));
                for(var _i3 = 0; _i3 < a.length; _i3++)this.fps[a[_i3].value] = true;
            }
        },
        {
            key: "bnodeContext2",
            value: function bnodeContext2(x, source, depth) {
                // Return a list of statements which indirectly identify a node
                //  Depth > 1 if try further indirection.
                //  Return array of statements (possibly empty), or null if failure
                var sts = this.store.statementsMatching(undefined, undefined, x, source); // incoming links
                var y;
                var res;
                for(var i = 0; i < sts.length; i++)if (this.fps[sts[i].predicate.value]) {
                    y = sts[i].subject;
                    if (!y.isBlank) return [
                        sts[i]
                    ];
                    if (depth) {
                        res = this.bnodeContext2(y, source, depth - 1);
                        if (res) return res.concat([
                            sts[i]
                        ]);
                    }
                }
                // outgoing links
                sts = this.store.statementsMatching(x, undefined, undefined, source);
                for(var _i4 = 0; _i4 < sts.length; _i4++)if (this.ifps[sts[_i4].predicate.value]) {
                    y = sts[_i4].object;
                    if (!y.isBlank) return [
                        sts[_i4]
                    ];
                    if (depth) {
                        res = this.bnodeContext2(y, source, depth - 1);
                        if (res) return res.concat([
                            sts[_i4]
                        ]);
                    }
                }
                return null; // Failure
            }
        },
        {
            key: "bnodeContext1",
            value: function bnodeContext1(x, source) {
                // Return a list of statements which indirectly identify a node
                //   Breadth-first
                for(var depth = 0; depth < 3; depth++){
                    // Try simple first
                    var con = this.bnodeContext2(x, source, depth);
                    if (con !== null) return con;
                }
                // If we can't guarantee unique with logic just send all info about node
                return this.store.connectedStatements(x, source); // was:
            // throw new Error('Unable to uniquely identify bnode: ' + x.toNT())
            }
        },
        {
            key: "mentioned",
            value: function mentioned(x) {
                return this.store.statementsMatching(x, null, null, null).length !== 0 || // Don't pin fresh bnodes
                this.store.statementsMatching(null, x).length !== 0 || this.store.statementsMatching(null, null, x).length !== 0;
            }
        },
        {
            key: "bnodeContext",
            value: function bnodeContext(bnodes, doc) {
                var context = [];
                if (bnodes.length) {
                    this.cacheIfps();
                    for(var i = 0; i < bnodes.length; i++){
                        // Does this occur in old graph?
                        var bnode = bnodes[i];
                        if (!this.mentioned(bnode)) continue;
                        context = context.concat(this.bnodeContext1(bnode, doc));
                    }
                }
                return context;
            }
        },
        {
            key: "statementContext",
            value: function statementContext(st) {
                var bnodes = this.statementBnodes(st);
                return this.bnodeContext(bnodes, st.graph);
            }
        },
        {
            key: "contextWhere",
            value: function contextWhere(context) {
                var updater = this;
                return !context || context.length === 0 ? "" : "WHERE { " + context.map(function(x) {
                    return updater.anonymizeNT(x);
                }).join("\n") + " }\n";
            }
        },
        {
            key: "fire",
            value: function fire(uri, query, callbackFunction) {
                var _this = this;
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                return Promise.resolve().then(function() {
                    if (!uri) throw new Error("No URI given for remote editing operation: " + query);
                    // console.log('UpdateManager: sending update to <' + uri + '>')
                    options.noMeta = true;
                    options.contentType = options.contentType || "application/sparql-update";
                    options.body = query;
                    return _this.store.fetcher.webOperation("PATCH", uri, options);
                }).then(function(response) {
                    if (!response.ok) {
                        var _message = "UpdateManager: update failed for <" + uri + "> status=" + response.status + ", " + response.statusText + "\n   for query: " + query;
                        // console.log(message)
                        throw new Error(_message);
                    }
                    // console.log('UpdateManager: update Ok for <' + uri + '>')
                    callbackFunction(uri, response.ok, response.responseText, response);
                }).catch(function(err) {
                    callbackFunction(uri, false, err.message, err);
                });
            }
        },
        {
            key: "update_statement",
            value: function update_statement(statement) {
                if (statement && !statement.graph) return;
                var updater = this;
                var context = this.statementContext(statement);
                return {
                    statement: statement ? [
                        statement.subject,
                        statement.predicate,
                        statement.object,
                        statement.graph
                    ] : undefined,
                    statementNT: statement ? this.anonymizeNT(statement) : undefined,
                    where: updater.contextWhere(context),
                    set_object: function set_object(obj, callbackFunction) {
                        var query = this.where;
                        query += "DELETE DATA { " + this.statementNT + " } ;\n";
                        query += "INSERT DATA { " + // @ts-ignore `this` might refer to the wrong scope. Does this work?
                        this.anonymize(this.statement[0]) + " " + // @ts-ignore
                        this.anonymize(this.statement[1]) + " " + // @ts-ignore
                        this.anonymize(obj) + " " + " . }\n";
                        updater.fire(this.statement[3].value, query, callbackFunction);
                    }
                };
            }
        },
        {
            key: "insert_statement",
            value: function insert_statement(st, callbackFunction) {
                var st0 = st instanceof Array ? st[0] : st;
                var query = this.contextWhere(this.statementContext(st0));
                if (st instanceof Array) {
                    var stText = "";
                    for(var i = 0; i < st.length; i++)stText += st[i] + "\n";
                    query += "INSERT DATA { " + stText + " }\n";
                } else query += "INSERT DATA { " + this.anonymize(st.subject) + " " + this.anonymize(st.predicate) + " " + this.anonymize(st.object) + " " + " . }\n";
                this.fire(st0.graph.value, query, callbackFunction);
            }
        },
        {
            key: "delete_statement",
            value: function delete_statement(st, callbackFunction) {
                var st0 = st instanceof Array ? st[0] : st;
                var query = this.contextWhere(this.statementContext(st0));
                if (st instanceof Array) {
                    var stText = "";
                    for(var i = 0; i < st.length; i++)stText += st[i] + "\n";
                    query += "DELETE DATA { " + stText + " }\n";
                } else query += "DELETE DATA { " + this.anonymize(st.subject) + " " + this.anonymize(st.predicate) + " " + this.anonymize(st.object) + " " + " . }\n";
                this.fire(st0.graph.value, query, callbackFunction);
            }
        },
        {
            key: "requestDownstreamAction",
            value: function requestDownstreamAction(doc, action) {
                var control = this.patchControlFor(doc);
                if (!control.pendingUpstream) action(doc);
                else if (control.downstreamAction) {
                    if ("" + control.downstreamAction !== "" + action) // Kludge compare
                    throw new Error("Can't wait for > 1 different downstream actions");
                } else control.downstreamAction = action;
            }
        },
        {
            key: "clearUpstreamCount",
            value: function clearUpstreamCount(doc) {
                var control = this.patchControlFor(doc);
                control.upstreamCount = 0;
            }
        },
        {
            key: "getUpdatesVia",
            value: function getUpdatesVia(doc) {
                var linkHeaders = this.store.fetcher.getHeader(doc, "updates-via");
                if (!linkHeaders || !linkHeaders.length) return null;
                return linkHeaders[0].trim();
            }
        },
        {
            key: "addDownstreamChangeListener",
            value: function addDownstreamChangeListener(doc, listener) {
                var _this2 = this;
                var control = this.patchControlFor(doc);
                if (!control.downstreamChangeListeners) control.downstreamChangeListeners = [];
                control.downstreamChangeListeners.push(listener);
                this.setRefreshHandler(doc, function(doc) {
                    _this2.reloadAndSync(doc);
                });
            }
        },
        {
            key: "reloadAndSync",
            value: function reloadAndSync(doc) {
                var control = this.patchControlFor(doc);
                var updater = this;
                if (control.reloading) {
                    // console.log('   Already reloading - note this load may be out of date')
                    control.outOfDate = true;
                    return; // once only needed @@ Not true, has changed again
                }
                control.reloading = true;
                var retryTimeout = 1000; // ms
                var tryReload = function tryReload() {
                    // console.log('try reload - timeout = ' + retryTimeout)
                    updater.reload(updater.store, doc, function(ok, message, response) {
                        if (ok) {
                            if (control.downstreamChangeListeners) for(var i = 0; i < control.downstreamChangeListeners.length; i++)// console.log('        Calling downstream listener ' + i)
                            control.downstreamChangeListeners[i]();
                            control.reloading = false;
                            if (control.outOfDate) {
                                // console.log('   Extra reload because of extra update.')
                                control.outOfDate = false;
                                tryReload();
                            }
                        } else {
                            control.reloading = false;
                            if (response && response.status === 0) {
                                // console.log('Network error refreshing the data. Retrying in ' +
                                // retryTimeout / 1000)
                                control.reloading = true;
                                retryTimeout = retryTimeout * 2;
                                setTimeout(tryReload, retryTimeout);
                            }
                        }
                    });
                };
                tryReload();
            }
        },
        {
            key: "setRefreshHandler",
            value: function setRefreshHandler(doc, handler) {
                var wssURI = this.getUpdatesVia(doc); // relative
                // var kb = this.store
                var theHandler = handler;
                var self = this;
                var updater = this;
                var retryTimeout = 1500; // *2 will be 3 Seconds, 6, 12, etc
                var retries = 0;
                if (!wssURI) // console.log('Server does not support live updates through Updates-Via :-(')
                return false;
                wssURI = (0, $4Q80K.join)(wssURI, doc.value);
                var validWssURI = wssURI.replace(/^http:/, "ws:").replace(/^https:/, "wss:");
                // console.log('Web socket URI ' + wssURI)
                var openWebsocket = function openWebsocket() {
                    // From https://github.com/solid/solid-spec#live-updates
                    var socket;
                    if (typeof WebSocket !== "undefined") socket = new WebSocket(validWssURI);
                    else if (typeof window !== "undefined" && window.WebSocket) socket = window.WebSocket(validWssURI);
                    else // console.log('Live update disabled, as WebSocket not supported by platform :-(')
                    return;
                    socket.onopen = function() {
                        // console.log('    websocket open')
                        retryTimeout = 1500; // reset timeout to fast on success
                        this.send("sub " + doc.value);
                        if (retries) // console.log('Web socket has been down, better check for any news.')
                        updater.requestDownstreamAction(doc, theHandler);
                    };
                    var control = self.patchControlFor(doc);
                    control.upstreamCount = 0;
                    socket.onerror = function onerror(err) {
                    // console.log('Error on Websocket:', err)
                    };
                    // https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent
                    //
                    // 1000  CLOSE_NORMAL  Normal closure; the connection successfully completed whatever purpose for which it was created.
                    // 1001  CLOSE_GOING_AWAY  The endpoint is going away, either
                    //                                  because of a server failure or because the browser is navigating away from the page that opened the connection.
                    // 1002  CLOSE_PROTOCOL_ERROR  The endpoint is terminating the connection due to a protocol error.
                    // 1003  CLOSE_UNSUPPORTED  The connection is being terminated because the endpoint
                    //                                  received data of a type it cannot accept (for example, a text-only endpoint received binary data).
                    // 1004                             Reserved. A meaning might be defined in the future.
                    // 1005  CLOSE_NO_STATUS  Reserved.  Indicates that no status code was provided even though one was expected.
                    // 1006  CLOSE_ABNORMAL  Reserved. Used to indicate that a connection was closed abnormally (
                    //
                    //
                    socket.onclose = function(event) {
                        // console.log('*** Websocket closed with code ' + event.code +
                        //   ", reason '" + event.reason + "' clean = " + event.wasClean)
                        retryTimeout *= 2;
                        retries += 1;
                        // console.log('Retrying in ' + retryTimeout + 'ms') // (ask user?)
                        setTimeout(function() {
                            // console.log('Trying websocket again')
                            openWebsocket();
                        }, retryTimeout);
                    };
                    socket.onmessage = function(msg) {
                        if (msg.data && msg.data.slice(0, 3) === "pub") {
                            if ("upstreamCount" in control) {
                                control.upstreamCount -= 1;
                                if (control.upstreamCount >= 0) // console.log('just an echo: ' + control.upstreamCount)
                                return; // Just an echo
                            }
                            // console.log('Assume a real downstream change: ' + control.upstreamCount + ' -> 0')
                            control.upstreamCount = 0;
                            self.requestDownstreamAction(doc, theHandler);
                        }
                    };
                }; // openWebsocket
                openWebsocket();
                return true;
            }
        },
        {
            key: "updateMany",
            value: function updateMany(deletions) {
                var insertions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var docs = deletions.concat(insertions).map(function(st) {
                    return st.why;
                });
                var thisUpdater = this;
                var uniqueDocs = [];
                docs.forEach(function(doc) {
                    if (!uniqueDocs.find(function(uniqueDoc) {
                        return uniqueDoc.equals(doc);
                    })) uniqueDocs.push(doc);
                });
                var updates = uniqueDocs.map(function(doc) {
                    return thisUpdater.update(deletions.filter(function(st) {
                        return st.why.equals(doc);
                    }), insertions.filter(function(st) {
                        return st.why.equals(doc);
                    }));
                });
                updates.length;
                return Promise.all(updates);
            }
        },
        {
            key: "constructSparqlUpdateQuery",
            value: function constructSparqlUpdateQuery(ds, is, bnodes_context) {
                var whereClause = this.contextWhere(bnodes_context);
                var query = "";
                if (whereClause.length) {
                    // Is there a WHERE clause?
                    if (ds.length) {
                        query += "DELETE { ";
                        for(var i = 0; i < ds.length; i++)query += this.anonymizeNT(ds[i]) + "\n";
                        query += " }\n";
                    }
                    if (is.length) {
                        query += "INSERT { ";
                        for(var _i5 = 0; _i5 < is.length; _i5++)query += this.anonymizeNT(is[_i5]) + "\n";
                        query += " }\n";
                    }
                    query += whereClause;
                } else {
                    // no where clause
                    if (ds.length) {
                        query += "DELETE DATA { ";
                        for(var _i6 = 0; _i6 < ds.length; _i6++)query += this.anonymizeNT(ds[_i6]) + "\n";
                        query += " } \n";
                    }
                    if (is.length) {
                        if (ds.length) query += " ; ";
                        query += "INSERT DATA { ";
                        for(var _i7 = 0; _i7 < is.length; _i7++)query += this.nTriples(is[_i7]) + "\n";
                        query += " }\n";
                    }
                }
                return query;
            }
        },
        {
            key: "constructN3PatchQuery",
            value: function constructN3PatchQuery(ds, is, bnodes_context) {
                var _this3 = this;
                var query = "\n@prefix solid: <http://www.w3.org/ns/solid/terms#>.\n@prefix ex: <http://www.example.org/terms#>.\n\n_:patch\n";
                // If bnode context is non trivial, express it as ?conditions formula.
                if (bnodes_context && bnodes_context.length > 0) query += "\n      solid:where {\n        ".concat(bnodes_context.map(function(x) {
                    return _this3.anonymizeNT(x);
                }).join("\n        "), "\n      };");
                if (ds.length > 0) query += "\n      solid:deletes {\n        ".concat(ds.map(function(x) {
                    return _this3.anonymizeNT(x);
                }).join("\n        "), "\n      };");
                if (is.length > 0) query += "\n      solid:inserts {\n        ".concat(is.map(function(x) {
                    return _this3.anonymizeNT(x);
                }).join("\n        "), "\n      };");
                query += "   a solid:InsertDeletePatch .\n";
                return query;
            }
        },
        {
            key: "update",
            value: function update(deletions, insertions, callback, secondTry) {
                var _this4 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                if (!callback) {
                    var thisUpdater = this;
                    return new Promise(function(resolve, reject) {
                        // Promise version
                        thisUpdater.update(deletions, insertions, function(uri, ok, errorBody) {
                            if (!ok) reject(new Error(errorBody));
                            else resolve();
                        }, secondTry, options); // callbackFunction
                    }); // promise
                } // if
                try {
                    var kb = this.store;
                    var ds = !deletions ? [] : (0, $gCJkd.isStore)(deletions) ? deletions.statements : deletions instanceof Array ? deletions : [
                        deletions
                    ];
                    var is = !insertions ? [] : (0, $gCJkd.isStore)(insertions) ? insertions.statements : insertions instanceof Array ? insertions : [
                        insertions
                    ];
                    if (!(ds instanceof Array)) throw new Error("Type Error " + (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ds) + ": " + ds);
                    if (!(is instanceof Array)) throw new Error("Type Error " + (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(is) + ": " + is);
                    if (ds.length === 0 && is.length === 0) return callback(null, true); // success -- nothing needed to be done.
                    var doc = ds.length ? ds[0].graph : is[0].graph;
                    if (!doc) {
                        var _message2 = "Error patching: statement does not specify which document to patch:" + ds[0] + ", " + is[0];
                        // console.log(message)
                        throw new Error(_message2);
                    }
                    if (doc.termType !== "NamedNode") {
                        var _message3 = "Error patching: document not a NamedNode:" + ds[0] + ", " + is[0];
                        // console.log(message)
                        throw new Error(_message3);
                    }
                    var control = this.patchControlFor(doc);
                    var startTime = Date.now();
                    var props = [
                        "subject",
                        "predicate",
                        "object",
                        "why"
                    ];
                    var verbs = [
                        "insert",
                        "delete"
                    ];
                    var clauses = {
                        "delete": ds,
                        "insert": is
                    };
                    verbs.map(function(verb) {
                        clauses[verb].map(function(st) {
                            if (!doc.equals(st.graph)) throw new Error("update: destination " + doc + " inconsistent with delete quad " + st.graph);
                            props.map(function(prop) {
                                if (typeof st[prop] === "undefined") throw new Error("update: undefined " + prop + " of statement.");
                            });
                        });
                    });
                    var protocol = this.editable(doc.value, kb);
                    if (protocol === false) throw new Error("Update: Can't make changes in uneditable " + doc);
                    if (protocol === undefined) {
                        // Not enough metadata
                        if (secondTry) throw new Error("Update: Loaded " + doc + "but still can't figure out what editing protocol it supports.");
                        // console.log(`Update: have not loaded ${doc} before: loading now...`);
                        this.store.fetcher.load(doc).then(function(response) {
                            _this4.update(deletions, insertions, callback, true, options);
                        }, function(err) {
                            if (err.response.status === 404) // nonexistent files are fine
                            _this4.update(deletions, insertions, callback, true, options);
                            else throw new Error("Update: Can't get updatability status ".concat(doc, " before patching: ").concat(err));
                        });
                        return;
                    } else if (protocol.indexOf("SPARQL") >= 0 || protocol.indexOf("N3PATCH") >= 0) {
                        var isSparql = protocol.indexOf("SPARQL") >= 0;
                        var bnodes = [];
                        // change ReadOnly type to Mutable type
                        if (ds.length) bnodes = this.statementArrayBnodes(ds);
                        if (is.length) bnodes = bnodes.concat(this.statementArrayBnodes(is));
                        var context = this.bnodeContext(bnodes, doc);
                        var query = isSparql ? this.constructSparqlUpdateQuery(ds, is, context) : this.constructN3PatchQuery(ds, is, context);
                        options.contentType = isSparql ? "application/sparql-update" : "text/n3";
                        // Track pending upstream patches until they have finished their callbackFunction
                        control.pendingUpstream = control.pendingUpstream ? control.pendingUpstream + 1 : 1;
                        if ("upstreamCount" in control) control.upstreamCount += 1; // count changes we originated ourselves
                        this.fire(doc.value, query, function(uri, success, body, response) {
                            response.elapsedTimeMs = Date.now() - startTime;
                            /* console.log('    UpdateManager: Return ' +
              (success ? 'success ' : 'FAILURE ') + (response as Response).status +
              ' elapsed ' + (response as any).elapsedTimeMs + 'ms')
              */ if (success) {
                                try {
                                    kb.remove(ds);
                                } catch (e) {
                                    success = false;
                                    body = "Remote Ok BUT error deleting " + ds.length + " from store!!! " + e;
                                } // Add in any case -- help recover from weirdness??
                                for(var i = 0; i < is.length; i++)kb.add(is[i].subject, is[i].predicate, is[i].object, doc);
                            }
                            callback(uri, success, body, response);
                            control.pendingUpstream -= 1;
                            // When upstream patches have been sent, reload state if downstream waiting
                            if (control.pendingUpstream === 0 && control.downstreamAction) {
                                var downstreamAction = control.downstreamAction;
                                delete control.downstreamAction;
                                // console.log('delayed downstream action:')
                                downstreamAction(doc);
                            }
                        }, options);
                    } else if (protocol.indexOf("DAV") >= 0) this.updateDav(doc, ds, is, callback, options);
                    else {
                        if (protocol.indexOf("LOCALFILE") >= 0) try {
                            this.updateLocalFile(doc, ds, is, callback, options);
                        } catch (e) {
                            callback(doc.value, false, "Exception trying to write back file <" + doc.value + ">\n");
                        }
                        else throw new Error("Unhandled edit method: '" + protocol + "' for " + doc);
                    }
                } catch (e) {
                    callback(undefined, false, "Exception in update: " + e + "\n" + $23fob.stackString(e));
                }
            }
        },
        {
            key: "updateDav",
            value: function updateDav(doc, ds, is, callbackFunction) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var kb = this.store;
                // The code below is derived from Kenny's UpdateCenter.js
                var request = kb.any(doc, this.ns.link("request"));
                if (!request) throw new Error("No record of our HTTP GET request for document: " + doc);
                 // should not happen
                var response = kb.any(request, this.ns.link("response"));
                if (!response) return null; // throw "No record HTTP GET response for document: "+doc
                var contentType = kb.the(response, this.ns.httph("content-type")).value;
                // prepare contents of revised document
                var newSts = kb.statementsMatching(undefined, undefined, undefined, doc).slice(); // copy!
                for(var i = 0; i < ds.length; i++)$23fob.RDFArrayRemove(newSts, ds[i]);
                for(var _i8 = 0; _i8 < is.length; _i8++)newSts.push(is[_i8]);
                var documentString = this.serialize(doc.value, newSts, contentType);
                // Write the new version back
                var candidateTarget = kb.the(response, this.ns.httph("content-location"));
                var targetURI;
                if (candidateTarget) targetURI = (0, $4Q80K.join)(candidateTarget.value, targetURI);
                options.contentType = contentType;
                options.noMeta = true;
                options.body = documentString;
                return kb.fetcher.webOperation("PUT", targetURI, options).then(function(response) {
                    if (!response.ok) throw new Error(response.error);
                    for(var _i9 = 0; _i9 < ds.length; _i9++)kb.remove(ds[_i9]);
                    for(var _i10 = 0; _i10 < is.length; _i10++)kb.add(is[_i10].subject, is[_i10].predicate, is[_i10].object, doc);
                    callbackFunction(doc.value, response.ok, response.responseText, response);
                }).catch(function(err) {
                    callbackFunction(doc.value, false, err.message, err);
                });
            }
        },
        {
            key: "updateLocalFile",
            value: function updateLocalFile(doc, ds, is, callbackFunction) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var kb = this.store;
                // console.log('Writing back to local file\n')
                // prepare contents of revised document
                var newSts = kb.statementsMatching(undefined, undefined, undefined, doc).slice(); // copy!
                for(var i = 0; i < ds.length; i++)$23fob.RDFArrayRemove(newSts, ds[i]);
                for(var _i11 = 0; _i11 < is.length; _i11++)newSts.push(is[_i11]);
                // serialize to the appropriate format
                var dot = doc.value.lastIndexOf(".");
                if (dot < 1) throw new Error("Rewriting file: No filename extension: " + doc.value);
                var ext = doc.value.slice(dot + 1);
                var contentType = (0, $1d9128915acc42fc$export$2e2bcd8739ae039).CONTENT_TYPE_BY_EXT[ext];
                if (!contentType) throw new Error("File extension ." + ext + " not supported for data write");
                options.body = this.serialize(doc.value, newSts, contentType);
                options.contentType = contentType;
                kb.fetcher.webOperation("PUT", doc.value, options).then(function(response) {
                    if (!response.ok) return callbackFunction(doc.value, false, response.error);
                    for(var _i12 = 0; _i12 < ds.length; _i12++)kb.remove(ds[_i12]);
                    for(var _i13 = 0; _i13 < is.length; _i13++)kb.add(is[_i13].subject, is[_i13].predicate, is[_i13].object, doc);
                    callbackFunction(doc.value, true, ""); // success!
                });
            }
        },
        {
            key: "serialize",
            value: function serialize(uri, data, contentType) {
                var kb = this.store;
                var documentString;
                if (typeof data === "string") return data;
                // serialize to the appropriate format
                var sz = (0, $f832e5387e149401$export$2e2bcd8739ae039)(kb);
                sz.suggestNamespaces(kb.namespaces);
                sz.setBase(uri);
                switch(contentType){
                    case "text/xml":
                    case "application/rdf+xml":
                        documentString = sz.statementsToXML(data);
                        break;
                    case "text/n3":
                    case "text/turtle":
                    case "application/x-turtle":
                    case "application/n3":
                        // Legacy
                        documentString = sz.statementsToN3(data);
                        break;
                    default:
                        throw new Error("Content-type " + contentType + " not supported for data serialization");
                }
                return documentString;
            }
        },
        {
            key: "put",
            value: function put(doc, data, contentType, callback) {
                var _this5 = this;
                var kb = this.store;
                var documentString;
                return Promise.resolve().then(function() {
                    documentString = _this5.serialize(doc.value, data, contentType);
                    return kb.fetcher.webOperation("PUT", doc.value, {
                        contentType: contentType,
                        body: documentString
                    });
                }).then(function(response) {
                    if (!response.ok) return callback(doc.value, response.ok, response.error, response);
                    delete kb.fetcher.nonexistent[doc.value];
                    delete kb.fetcher.requested[doc.value]; // @@ could this mess with the requested state machine? if a fetch is in progress
                    if (typeof data !== "string") data.map(function(st) {
                        kb.addStatement(st);
                    });
                    callback(doc.value, response.ok, "", response);
                }).catch(function(err) {
                    callback(doc.value, false, err.message);
                });
            }
        },
        {
            key: "reload",
            value: function reload(kb, doc, callbackFunction) {
                var startTime = Date.now();
                // force sets no-cache and
                var options = {
                    force: true,
                    noMeta: true,
                    clearPreviousData: true
                };
                kb.fetcher.nowOrWhenFetched(doc.value, options, function(ok, body, response) {
                    if (!ok) // console.log('    ERROR reloading data: ' + body)
                    callbackFunction(false, "Error reloading data: " + body, response);
                    else if (response.onErrorWasCalled || response.status !== 200) // console.log('    Non-HTTP error reloading data! onErrorWasCalled=' +
                    //@ts-ignore Where does onErrorWasCalled come from?
                    // response.onErrorWasCalled + ' status: ' + response.status)
                    callbackFunction(false, "Non-HTTP error reloading data: " + body, response);
                    else {
                        var elapsedTimeMs = Date.now() - startTime;
                        if (!doc.reloadTimeTotal) doc.reloadTimeTotal = 0;
                        if (!doc.reloadTimeCount) doc.reloadTimeCount = 0;
                        doc.reloadTimeTotal += elapsedTimeMs;
                        doc.reloadTimeCount += 1;
                        // console.log('    Fetch took ' + elapsedTimeMs + 'ms, av. of ' +
                        // doc.reloadTimeCount + ' = ' +
                        // (doc.reloadTimeTotal / doc.reloadTimeCount) + 'ms.')
                        callbackFunction(true);
                    }
                });
            }
        }
    ]);
    return UpdateManager;
}();







var $g5Zhu = parcelRequire("g5Zhu");



function $eb05007f91aa13a9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $eb05007f91aa13a9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $eb05007f91aa13a9$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $eb05007f91aa13a9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/** Full RDFLib.js Data Factory */ var $eb05007f91aa13a9$var$RDFlibDataFactory = $eb05007f91aa13a9$var$_objectSpread($eb05007f91aa13a9$var$_objectSpread({}, (0, $2b3711697846728e$export$2e2bcd8739ae039)), {}, {
    /**
   * Creates a new fetcher
   * @param store - The store to use
   * @param options - The options
   */ fetcher: function fetcher(store, options) {
        return new (0, $1d9128915acc42fc$export$2e2bcd8739ae039)(store, options);
    },
    /**
   * Creates a new graph (store)
   */ graph: function graph() {
        var features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
        return new (0, $6f5c135260474402$export$2e2bcd8739ae039)(features, opts || {
            rdfFactory: (0, $2b3711697846728e$export$2e2bcd8739ae039)
        });
    },
    /**
   * Creates a new literal node
   * @param val The lexical value
   * @param lang The language
   * @param dt The datatype
   */ lit: function lit(val, lang, dt) {
        return this.literal("" + val, lang || dt);
    },
    /**
   * Creates a new statement
   * @param subject The subject
   * @param predicate The predicate
   * @param object The object
   * @param graph The containing graph
   */ st: function st(subject, predicate, object, graph) {
        return this.quad(subject, predicate, object, graph);
    }
});
var $eb05007f91aa13a9$export$2e2bcd8739ae039 = $eb05007f91aa13a9$var$RDFlibDataFactory;


parcelRequire("gCJkd");

function $6f0137736d5eb798$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6f0137736d5eb798$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $6f0137736d5eb798$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
// Prepare bound versions of data factory methods for export
var $6f0137736d5eb798$var$boundDataFactory = {};
for(var $6f0137736d5eb798$var$name in 0, $eb05007f91aa13a9$export$2e2bcd8739ae039)if (typeof (0, $eb05007f91aa13a9$export$2e2bcd8739ae039)[$6f0137736d5eb798$var$name] === "function") $6f0137736d5eb798$var$boundDataFactory[$6f0137736d5eb798$var$name] = (0, $eb05007f91aa13a9$export$2e2bcd8739ae039)[$6f0137736d5eb798$var$name].bind((0, $eb05007f91aa13a9$export$2e2bcd8739ae039));
var $6f0137736d5eb798$export$47fdd40111eda34c = $6f0137736d5eb798$var$boundDataFactory.fetcher, $6f0137736d5eb798$export$3d344a3806285c2 = $6f0137736d5eb798$var$boundDataFactory.graph, $6f0137736d5eb798$export$f9c0624c04b6af9f = $6f0137736d5eb798$var$boundDataFactory.lit, $6f0137736d5eb798$export$8692ddd9f3fb5f5d = $6f0137736d5eb798$var$boundDataFactory.st, $6f0137736d5eb798$export$fe4bf738d66b6b12 = $6f0137736d5eb798$var$boundDataFactory.namedNode, $6f0137736d5eb798$export$3a9d57cefcd2c285 = $6f0137736d5eb798$var$boundDataFactory.variable, $6f0137736d5eb798$export$54639f27c75f330c = $6f0137736d5eb798$var$boundDataFactory.blankNode, $6f0137736d5eb798$export$d3dde9fdaf372e40 = $6f0137736d5eb798$var$boundDataFactory.defaultGraph, $6f0137736d5eb798$export$c8ec6e1ec9fefcb0 = $6f0137736d5eb798$var$boundDataFactory.literal, $6f0137736d5eb798$export$9fc5786234c4f1e = $6f0137736d5eb798$var$boundDataFactory.quad, $6f0137736d5eb798$export$515818ff8d37c07d = $6f0137736d5eb798$var$boundDataFactory.triple;
var $6f0137736d5eb798$var$formula = new (0, $31157af6e1e82257$export$2e2bcd8739ae039)();
var $6f0137736d5eb798$export$b66615c92119fc20 = function fromNT(str) {
    return $6f0137736d5eb798$var$formula.fromNT(str);
};
var $6f0137736d5eb798$export$be3eabeed0f5400e = (0, $e01338ed2499626a$export$2e2bcd8739ae039).fromValue;
// TODO: this export is broken;
// it exports the _current_ value of nextId, which is always 0
var $6f0137736d5eb798$export$ad5ce394e01d3081 = (0, $d0a63e5194c4f691$export$2e2bcd8739ae039).nextId;
var $6f0137736d5eb798$export$d778a5b158cf3099 = /*#__PURE__*/ function(_Store) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(ConnectedStore, _Store);
    var _super = $6f0137736d5eb798$var$_createSuper(ConnectedStore);
    function ConnectedStore(features) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ConnectedStore);
        _this = _super.call(this, features);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "fetcher", void 0);
        _this.fetcher = new (0, $1d9128915acc42fc$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), {});
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ConnectedStore);
}((0, $6f5c135260474402$export$2e2bcd8739ae039));
var $6f0137736d5eb798$export$385ff6920702c0f2 = /*#__PURE__*/ function(_ConnectedStore) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(LiveStore, _ConnectedStore);
    var _super2 = $6f0137736d5eb798$var$_createSuper(LiveStore);
    function LiveStore(features) {
        var _this2;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, LiveStore);
        _this2 = _super2.call(this, features);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this2), "updater", void 0);
        _this2.updater = new (0, $f8539385ca2d21cc$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this2));
        return _this2;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(LiveStore);
}($6f0137736d5eb798$export$d778a5b158cf3099);


var $gCJkd = parcelRequire("gCJkd");

let $38b80e3d89004393$export$ff9145aa8f5d08d8 = 10;
let $38b80e3d89004393$export$606d8b965266a4fd = 5000;
let $38b80e3d89004393$var$countConcurrentQueries = 0;
let $38b80e3d89004393$export$e69c944f813dd417 = 300;
let $38b80e3d89004393$export$ae866de19353582e = 1000;
let $38b80e3d89004393$export$774d0aa5c1bac3e7 = 0;
function $38b80e3d89004393$export$6cc6e25203630304() {
    return $38b80e3d89004393$var$countConcurrentQueries;
}
function $38b80e3d89004393$export$66826636ef5e1530(nb) {
    if (nb !== undefined && nb !== null && nb >= 0) $38b80e3d89004393$export$ff9145aa8f5d08d8 = nb;
    else throw new Error("The number of retries must be a positive integer");
}
function $38b80e3d89004393$export$f60a4bbf81e656d4(milliseconds) {
    if (milliseconds !== undefined && milliseconds !== null && milliseconds >= 0) $38b80e3d89004393$export$606d8b965266a4fd = milliseconds;
    else throw new Error("The number of milliseconds between retries must be a positive integer");
}
function $38b80e3d89004393$export$652c9b10c84c8691(max) {
    if (max !== undefined && max !== null && max >= 0) $38b80e3d89004393$export$e69c944f813dd417 = max;
    else throw new Error("The number of maximum concurrent queries must be a positive integer");
}
function $38b80e3d89004393$export$4ddac1eae8e1a9ec(milliseconds) {
    if (milliseconds !== undefined && milliseconds !== null && milliseconds >= 0) $38b80e3d89004393$export$ae866de19353582e = milliseconds;
    else throw new Error("The number of milliseconds between queries must be a positive integer");
}
function $38b80e3d89004393$export$72c04af63de9061a(filename) {
    let readFilePromise = null;
    if (filename.startsWith("http://") || filename.startsWith("https://")) readFilePromise = $38b80e3d89004393$export$a6e59c03a779ef88(filename);
    else throw new Error("Only http and https protocols are supported for now");
    return readFilePromise;
}
function $38b80e3d89004393$export$43afd36b730bac7c(args, promiseCreationFunction, delayMilliseconds = $38b80e3d89004393$export$774d0aa5c1bac3e7) {
    let argsCopy = args.map((arg)=>arg);
    if (argsCopy.length > 0) return promiseCreationFunction.apply(this, argsCopy[0]).then(()=>{
        argsCopy.shift();
        return $38b80e3d89004393$export$43afd36b730bac7c(argsCopy, promiseCreationFunction, delayMilliseconds);
    });
    return new Promise((resolve, reject)=>resolve());
}
function $38b80e3d89004393$export$7fc4ea9a72a632dc(url, header = {}, method = "GET", query = "", numTry = 0) {
    let myHeaders = {};
    // myHeaders["pragma"] = "no-cache";
    // myHeaders["cache-control"] = "no-cache";
    Object.keys(header).forEach((key)=>{
        myHeaders[key] = header[key];
    });
    let myInit = {
        method: method,
        headers: myHeaders,
        redirect: "follow"
    };
    if (method.localeCompare("POST") == 0) myInit.body = query;
    $38b80e3d89004393$var$countConcurrentQueries++;
    return fetch(url, myInit).then((response)=>{
        if (response.ok) return response.blob().then((blob)=>blob.text());
        else throw response;
    }).catch((error)=>{
        $5979e5393e457062$export$a3bc9b8ed74fc(error.type, error.message);
        $5979e5393e457062$export$a80b3bd66acc52ff("Try:", numTry, "Fetch ", method, url, query);
        if (numTry < $38b80e3d89004393$export$ff9145aa8f5d08d8) return $38b80e3d89004393$export$7fc4ea9a72a632dc(url, header, method, query, numTry + 1);
        else $5979e5393e457062$export$a3bc9b8ed74fc("Too many retries", error);
    }).finally(()=>{
        $38b80e3d89004393$var$countConcurrentQueries--;
        return;
    });
}
function $38b80e3d89004393$export$a6e59c03a779ef88(url, header = {}) {
    return $38b80e3d89004393$export$7fc4ea9a72a632dc(url, header);
}
function $38b80e3d89004393$export$3233bfa38a51357e(url, query = "", header = {}) {
    return $38b80e3d89004393$export$7fc4ea9a72a632dc(url, header, "POST", query);
}
function $38b80e3d89004393$export$230442c21b56ff1e(url, otherHeaders = {}) {
    let header = {};
    header["accept"] = "application/json";
    Object.keys(otherHeaders).forEach((key)=>{
        header[key] = otherHeaders[key];
    });
    return $38b80e3d89004393$export$a6e59c03a779ef88(url, header).then((response)=>{
        if (response == null || response == undefined || response == "") return {};
        else try {
            return JSON.parse(response);
        } catch (error) {
            $5979e5393e457062$export$a3bc9b8ed74fc(url, error, response);
            throw error;
        }
    });
}
function $38b80e3d89004393$export$a699a8b2615a99e(text) {
    return encodeURIComponent($38b80e3d89004393$export$f41cc328a6c393c3(text));
}
function $38b80e3d89004393$export$f41cc328a6c393c3(text) {
    return text.replace(/\\u[\dA-F]{4}/gi, function(match) {
        let unicodeMatch = String.fromCharCode(parseInt(match.replace(/\\u/g, ""), 16));
        let urlEncodedMatch = encodeURIComponent(unicodeMatch);
        return urlEncodedMatch;
    });
}



var $9043c565d33eb642$exports = {};
// queueMicrotask shim

var $6ZWSX = parcelRequire("6ZWSX");
var $9043c565d33eb642$require$Buffer = $6ZWSX.Buffer;
// not defined or not a function
if ("function" !== typeof queueMicrotask) {
    // create resolved promise
    let dp_resolve = Promise.resolve();
    // try to redefine
    try {
        // eslint-disable-next-line no-global-assign
        queueMicrotask = (fk)=>dp_resolve.then(fk).catch((e_callback)=>setTimeout(()=>{
                    throw e_callback;
                }, 0));
    } // oh well, at least we tried
    catch (e_define) {}
}
var $1a8051d506d618be$exports = {};
/** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */ (function(global, factory) {
    factory($1a8051d506d618be$exports);
})($1a8051d506d618be$exports, function(exports1) {
    "use strict";
    function merge() {
        for(var _len = arguments.length, sets = Array(_len), _key = 0; _key < _len; _key++)sets[_key] = arguments[_key];
        if (sets.length > 1) {
            sets[0] = sets[0].slice(0, -1);
            var xl = sets.length - 1;
            for(var x = 1; x < xl; ++x)sets[x] = sets[x].slice(1, -1);
            sets[xl] = sets[xl].slice(1);
            return sets.join("");
        } else return sets[0];
    }
    function subexp(str) {
        return "(?:" + str + ")";
    }
    function typeOf(o) {
        return o === undefined ? "undefined" : o === null ? "null" : Object.prototype.toString.call(o).split(" ").pop().split("]").shift().toLowerCase();
    }
    function toUpperCase(str) {
        return str.toUpperCase();
    }
    function toArray(obj) {
        return obj !== undefined && obj !== null ? obj instanceof Array ? obj : typeof obj.length !== "number" || obj.split || obj.setInterval || obj.call ? [
            obj
        ] : Array.prototype.slice.call(obj) : [];
    }
    function assign(target, source) {
        var obj = target;
        if (source) for(var key in source)obj[key] = source[key];
        return obj;
    }
    function buildExps(isIRI) {
        var ALPHA$$ = "[A-Za-z]", CR$ = "[\\x0D]", DIGIT$$ = "[0-9]", DQUOTE$$ = "[\\x22]", HEXDIG$$ = merge(DIGIT$$, "[A-Fa-f]"), //case-insensitive
        LF$$ = "[\\x0A]", SP$$ = "[\\x20]", PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)), //expanded
        GEN_DELIMS$$ = "[\\:\\/\\?\\#\\[\\]\\@]", SUB_DELIMS$$ = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", RESERVED$$ = merge(GEN_DELIMS$$, SUB_DELIMS$$), UCSCHAR$$ = isIRI ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]", //subset, excludes bidi control characters
        IPRIVATE$$ = isIRI ? "[\\uE000-\\uF8FF]" : "[]", //subset
        UNRESERVED$$ = merge(ALPHA$$, DIGIT$$, "[\\-\\.\\_\\~]", UCSCHAR$$), SCHEME$ = subexp(ALPHA$$ + merge(ALPHA$$, DIGIT$$, "[\\+\\-\\.]") + "*"), USERINFO$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]")) + "*"), DEC_OCTET$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("[1-9]" + DIGIT$$) + "|" + DIGIT$$), DEC_OCTET_RELAXED$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("0?[1-9]" + DIGIT$$) + "|0?0?" + DIGIT$$), //relaxed parsing rules
        IPV4ADDRESS$ = subexp(DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$), H16$ = subexp(HEXDIG$$ + "{1,4}"), LS32$ = subexp(subexp(H16$ + "\\:" + H16$) + "|" + IPV4ADDRESS$), IPV6ADDRESS1$ = subexp(subexp(H16$ + "\\:") + "{6}" + LS32$), //                           6( h16 ":" ) ls32
        IPV6ADDRESS2$ = subexp("\\:\\:" + subexp(H16$ + "\\:") + "{5}" + LS32$), //                      "::" 5( h16 ":" ) ls32
        IPV6ADDRESS3$ = subexp(subexp(H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{4}" + LS32$), //[               h16 ] "::" 4( h16 ":" ) ls32
        IPV6ADDRESS4$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,1}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{3}" + LS32$), //[ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
        IPV6ADDRESS5$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,2}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{2}" + LS32$), //[ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
        IPV6ADDRESS6$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,3}" + H16$) + "?\\:\\:" + H16$ + "\\:" + LS32$), //[ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
        IPV6ADDRESS7$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,4}" + H16$) + "?\\:\\:" + LS32$), //[ *4( h16 ":" ) h16 ] "::"              ls32
        IPV6ADDRESS8$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,5}" + H16$) + "?\\:\\:" + H16$), //[ *5( h16 ":" ) h16 ] "::"              h16
        IPV6ADDRESS9$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,6}" + H16$) + "?\\:\\:"), //[ *6( h16 ":" ) h16 ] "::"
        IPV6ADDRESS$ = subexp([
            IPV6ADDRESS1$,
            IPV6ADDRESS2$,
            IPV6ADDRESS3$,
            IPV6ADDRESS4$,
            IPV6ADDRESS5$,
            IPV6ADDRESS6$,
            IPV6ADDRESS7$,
            IPV6ADDRESS8$,
            IPV6ADDRESS9$
        ].join("|")), ZONEID$ = subexp(subexp(UNRESERVED$$ + "|" + PCT_ENCODED$) + "+"), //RFC 6874
        IPV6ADDRZ$ = subexp(IPV6ADDRESS$ + "\\%25" + ZONEID$), //RFC 6874
        IPV6ADDRZ_RELAXED$ = subexp(IPV6ADDRESS$ + subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + ZONEID$), //RFC 6874, with relaxed parsing rules
        IPVFUTURE$ = subexp("[vV]" + HEXDIG$$ + "+\\." + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]") + "+"), IP_LITERAL$ = subexp("\\[" + subexp(IPV6ADDRZ_RELAXED$ + "|" + IPV6ADDRESS$ + "|" + IPVFUTURE$) + "\\]"), //RFC 6874
        REG_NAME$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$)) + "*"), HOST$ = subexp(IP_LITERAL$ + "|" + IPV4ADDRESS$ + "(?!" + REG_NAME$ + ")" + "|" + REG_NAME$), PORT$ = subexp(DIGIT$$ + "*"), AUTHORITY$ = subexp(subexp(USERINFO$ + "@") + "?" + HOST$ + subexp("\\:" + PORT$) + "?"), PCHAR$ = subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@]")), SEGMENT$ = subexp(PCHAR$ + "*"), SEGMENT_NZ$ = subexp(PCHAR$ + "+"), SEGMENT_NZ_NC$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\@]")) + "+"), PATH_ABEMPTY$ = subexp(subexp("\\/" + SEGMENT$) + "*"), PATH_ABSOLUTE$ = subexp("\\/" + subexp(SEGMENT_NZ$ + PATH_ABEMPTY$) + "?"), //simplified
        PATH_NOSCHEME$ = subexp(SEGMENT_NZ_NC$ + PATH_ABEMPTY$), //simplified
        PATH_ROOTLESS$ = subexp(SEGMENT_NZ$ + PATH_ABEMPTY$), //simplified
        PATH_EMPTY$ = "(?!" + PCHAR$ + ")", PATH$ = subexp(PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), QUERY$ = subexp(subexp(PCHAR$ + "|" + merge("[\\/\\?]", IPRIVATE$$)) + "*"), FRAGMENT$ = subexp(subexp(PCHAR$ + "|[\\/\\?]") + "*"), HIER_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), RELATIVE_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$), RELATIVE$ = subexp(RELATIVE_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), URI_REFERENCE$ = subexp(URI$ + "|" + RELATIVE$), ABSOLUTE_URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?"), GENERIC_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", RELATIVE_REF$ = "^(){0}" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", ABSOLUTE_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?$", SAMEDOC_REF$ = "^" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", AUTHORITY_REF$ = "^" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?$";
        return {
            NOT_SCHEME: new RegExp(merge("[^]", ALPHA$$, DIGIT$$, "[\\+\\-\\.]"), "g"),
            NOT_USERINFO: new RegExp(merge("[^\\%\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_HOST: new RegExp(merge("[^\\%\\[\\]\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_PATH: new RegExp(merge("[^\\%\\/\\:\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_PATH_NOSCHEME: new RegExp(merge("[^\\%\\/\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_QUERY: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]", IPRIVATE$$), "g"),
            NOT_FRAGMENT: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]"), "g"),
            ESCAPE: new RegExp(merge("[^]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            UNRESERVED: new RegExp(UNRESERVED$$, "g"),
            OTHER_CHARS: new RegExp(merge("[^\\%]", UNRESERVED$$, RESERVED$$), "g"),
            PCT_ENCODED: new RegExp(PCT_ENCODED$, "g"),
            IPV4ADDRESS: new RegExp("^(" + IPV4ADDRESS$ + ")$"),
            IPV6ADDRESS: new RegExp("^\\[?(" + IPV6ADDRESS$ + ")" + subexp(subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + "(" + ZONEID$ + ")") + "?\\]?$") //RFC 6874, with relaxed parsing rules
        };
    }
    var URI_PROTOCOL = buildExps(false);
    var IRI_PROTOCOL = buildExps(true);
    var slicedToArray = function() {
        function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
                for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                    _arr.push(_s.value);
                    if (i && _arr.length === i) break;
                }
            } catch (err) {
                _d = true;
                _e = err;
            } finally{
                try {
                    if (!_n && _i["return"]) _i["return"]();
                } finally{
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
        return function(arr, i) {
            if (Array.isArray(arr)) return arr;
            else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
            else throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }();
    var toConsumableArray = function(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        } else return Array.from(arr);
    };
    /** Highest positive signed 32-bit float value */ var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
    /** Bootstring parameters */ var base = 36;
    var tMin = 1;
    var tMax = 26;
    var skew = 38;
    var damp = 700;
    var initialBias = 72;
    var initialN = 128; // 0x80
    var delimiter = "-"; // '\x2D'
    /** Regular expressions */ var regexPunycode = /^xn--/;
    var regexNonASCII = /[^\0-\x7E]/; // non-ASCII chars
    var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
    /** Error messages */ var errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    };
    /** Convenience shortcuts */ var baseMinusTMin = base - tMin;
    var floor = Math.floor;
    var stringFromCharCode = String.fromCharCode;
    /*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function error$1(type) {
        throw new RangeError(errors[type]);
    }
    /**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function map(array, fn) {
        var result = [];
        var length = array.length;
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function ucs2decode(string) {
        var output = [];
        var counter = 0;
        var length = string.length;
        while(counter < length){
            var value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // It's a high surrogate, and there is a next character.
                var extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) // Low surrogate.
                output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // It's an unmatched surrogate; only append this code unit, in case the
                    // next code unit is the high surrogate of a surrogate pair.
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ var ucs2encode = function ucs2encode(array) {
        return String.fromCodePoint.apply(String, toConsumableArray(array));
    };
    /**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ var basicToDigit = function basicToDigit(codePoint) {
        if (codePoint - 0x30 < 0x0A) return codePoint - 0x16;
        if (codePoint - 0x41 < 0x1A) return codePoint - 0x41;
        if (codePoint - 0x61 < 0x1A) return codePoint - 0x61;
        return base;
    };
    /**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ var digitToBasic = function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    };
    /**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ var adapt = function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    };
    /**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ var decode = function decode(input) {
        // Don't use UCS-2.
        var output = [];
        var inputLength = input.length;
        var i = 0;
        var n = initialN;
        var bias = initialBias;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        var basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(var j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error$1("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(var index = basic > 0 ? basic + 1 : 0; index < inputLength;)/* no final expression */ {
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            var oldi = i;
            for(var w = 1, k = base;; k += base){
                if (index >= inputLength) error$1("invalid-input");
                var digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error$1("overflow");
                i += digit * w;
                var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                var baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error$1("overflow");
                w *= baseMinusT;
            }
            var out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error$1("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output.
            output.splice(i++, 0, n);
        }
        return String.fromCodePoint.apply(String, output);
    };
    /**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ var encode = function encode(input) {
        var output = [];
        // Convert the input in UCS-2 to an array of Unicode code points.
        input = ucs2decode(input);
        // Cache the length.
        var inputLength = input.length;
        // Initialize the state.
        var n = initialN;
        var delta = 0;
        var bias = initialBias;
        // Handle the basic code points.
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _currentValue2 = _step.value;
                if (_currentValue2 < 0x80) output.push(stringFromCharCode(_currentValue2));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
        var basicLength = output.length;
        var handledCPCount = basicLength;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string with a delimiter unless it's empty.
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            var m = maxInt;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;
            try {
                for(var _iterator2 = input[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var currentValue = _step2.value;
                    if (currentValue >= n && currentValue < m) m = currentValue;
                }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow.
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                } finally{
                    if (_didIteratorError2) throw _iteratorError2;
                }
            }
            var handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error$1("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;
            try {
                for(var _iterator3 = input[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                    var _currentValue = _step3.value;
                    if (_currentValue < n && ++delta > maxInt) error$1("overflow");
                    if (_currentValue == n) {
                        // Represent delta as a generalized variable-length integer.
                        var q = delta;
                        for(var k = base;; k += base){
                            var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                            if (q < t) break;
                            var qMinusT = q - t;
                            var baseMinusT = base - t;
                            output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                            q = floor(qMinusT / baseMinusT);
                        }
                        output.push(stringFromCharCode(digitToBasic(q, 0)));
                        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                        delta = 0;
                        ++handledCPCount;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) _iterator3.return();
                } finally{
                    if (_didIteratorError3) throw _iteratorError3;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    };
    /**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ var toUnicode = function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    };
    /**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ var toASCII = function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    };
    /*--------------------------------------------------------------------------*/ /** Define the public API */ var punycode = {
        /**
  * A string representing the current Punycode.js version number.
  * @memberOf punycode
  * @type String
  */ "version": "2.1.0",
        /**
  * An object of methods to convert from JavaScript's internal character
  * representation (UCS-2) to Unicode code points, and back.
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode
  * @type Object
  */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /**
 * URI.js
 *
 * @fileoverview An RFC 3986 compliant, scheme extendable URI parsing/validating/resolving library for JavaScript.
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/uri-js
 */ /**
 * Copyright 2011 Gary Court. All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 *
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 *
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY GARY COURT ``AS IS'' AND ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL GARY COURT OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
 * ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * The views and conclusions contained in the software and documentation are those of the
 * authors and should not be interpreted as representing official policies, either expressed
 * or implied, of Gary Court.
 */ var SCHEMES = {};
    function pctEncChar(chr) {
        var c = chr.charCodeAt(0);
        var e = void 0;
        if (c < 16) e = "%0" + c.toString(16).toUpperCase();
        else if (c < 128) e = "%" + c.toString(16).toUpperCase();
        else if (c < 2048) e = "%" + (c >> 6 | 192).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        else e = "%" + (c >> 12 | 224).toString(16).toUpperCase() + "%" + (c >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        return e;
    }
    function pctDecChars(str) {
        var newStr = "";
        var i = 0;
        var il = str.length;
        while(i < il){
            var c = parseInt(str.substr(i + 1, 2), 16);
            if (c < 128) {
                newStr += String.fromCharCode(c);
                i += 3;
            } else if (c >= 194 && c < 224) {
                if (il - i >= 6) {
                    var c2 = parseInt(str.substr(i + 4, 2), 16);
                    newStr += String.fromCharCode((c & 31) << 6 | c2 & 63);
                } else newStr += str.substr(i, 6);
                i += 6;
            } else if (c >= 224) {
                if (il - i >= 9) {
                    var _c = parseInt(str.substr(i + 4, 2), 16);
                    var c3 = parseInt(str.substr(i + 7, 2), 16);
                    newStr += String.fromCharCode((c & 15) << 12 | (_c & 63) << 6 | c3 & 63);
                } else newStr += str.substr(i, 9);
                i += 9;
            } else {
                newStr += str.substr(i, 3);
                i += 3;
            }
        }
        return newStr;
    }
    function _normalizeComponentEncoding(components, protocol) {
        function decodeUnreserved(str) {
            var decStr = pctDecChars(str);
            return !decStr.match(protocol.UNRESERVED) ? str : decStr;
        }
        if (components.scheme) components.scheme = String(components.scheme).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_SCHEME, "");
        if (components.userinfo !== undefined) components.userinfo = String(components.userinfo).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_USERINFO, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.host !== undefined) components.host = String(components.host).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_HOST, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.path !== undefined) components.path = String(components.path).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(components.scheme ? protocol.NOT_PATH : protocol.NOT_PATH_NOSCHEME, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.query !== undefined) components.query = String(components.query).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_QUERY, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.fragment !== undefined) components.fragment = String(components.fragment).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_FRAGMENT, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        return components;
    }
    function _stripLeadingZeros(str) {
        return str.replace(/^0*(.*)/, "$1") || "0";
    }
    function _normalizeIPv4(host, protocol) {
        var matches = host.match(protocol.IPV4ADDRESS) || [];
        var _matches = slicedToArray(matches, 2), address = _matches[1];
        if (address) return address.split(".").map(_stripLeadingZeros).join(".");
        else return host;
    }
    function _normalizeIPv6(host, protocol) {
        var matches = host.match(protocol.IPV6ADDRESS) || [];
        var _matches2 = slicedToArray(matches, 3), address = _matches2[1], zone = _matches2[2];
        if (address) {
            var _address$toLowerCase$ = address.toLowerCase().split("::").reverse(), _address$toLowerCase$2 = slicedToArray(_address$toLowerCase$, 2), last = _address$toLowerCase$2[0], first = _address$toLowerCase$2[1];
            var firstFields = first ? first.split(":").map(_stripLeadingZeros) : [];
            var lastFields = last.split(":").map(_stripLeadingZeros);
            var isLastFieldIPv4Address = protocol.IPV4ADDRESS.test(lastFields[lastFields.length - 1]);
            var fieldCount = isLastFieldIPv4Address ? 7 : 8;
            var lastFieldsStart = lastFields.length - fieldCount;
            var fields = Array(fieldCount);
            for(var x = 0; x < fieldCount; ++x)fields[x] = firstFields[x] || lastFields[lastFieldsStart + x] || "";
            if (isLastFieldIPv4Address) fields[fieldCount - 1] = _normalizeIPv4(fields[fieldCount - 1], protocol);
            var allZeroFields = fields.reduce(function(acc, field, index) {
                if (!field || field === "0") {
                    var lastLongest = acc[acc.length - 1];
                    if (lastLongest && lastLongest.index + lastLongest.length === index) lastLongest.length++;
                    else acc.push({
                        index: index,
                        length: 1
                    });
                }
                return acc;
            }, []);
            var longestZeroFields = allZeroFields.sort(function(a, b) {
                return b.length - a.length;
            })[0];
            var newHost = void 0;
            if (longestZeroFields && longestZeroFields.length > 1) {
                var newFirst = fields.slice(0, longestZeroFields.index);
                var newLast = fields.slice(longestZeroFields.index + longestZeroFields.length);
                newHost = newFirst.join(":") + "::" + newLast.join(":");
            } else newHost = fields.join(":");
            if (zone) newHost += "%" + zone;
            return newHost;
        } else return host;
    }
    var URI_PARSE = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i;
    var NO_MATCH_IS_UNDEFINED = "".match(/(){0}/)[1] === undefined;
    function parse(uriString) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var components = {};
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        if (options.reference === "suffix") uriString = (options.scheme ? options.scheme + ":" : "") + "//" + uriString;
        var matches = uriString.match(URI_PARSE);
        if (matches) {
            if (NO_MATCH_IS_UNDEFINED) {
                //store each component
                components.scheme = matches[1];
                components.userinfo = matches[3];
                components.host = matches[4];
                components.port = parseInt(matches[5], 10);
                components.path = matches[6] || "";
                components.query = matches[7];
                components.fragment = matches[8];
                //fix port number
                if (isNaN(components.port)) components.port = matches[5];
            } else {
                //IE FIX for improper RegExp matching
                //store each component
                components.scheme = matches[1] || undefined;
                components.userinfo = uriString.indexOf("@") !== -1 ? matches[3] : undefined;
                components.host = uriString.indexOf("//") !== -1 ? matches[4] : undefined;
                components.port = parseInt(matches[5], 10);
                components.path = matches[6] || "";
                components.query = uriString.indexOf("?") !== -1 ? matches[7] : undefined;
                components.fragment = uriString.indexOf("#") !== -1 ? matches[8] : undefined;
                //fix port number
                if (isNaN(components.port)) components.port = uriString.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? matches[4] : undefined;
            }
            if (components.host) //normalize IP hosts
            components.host = _normalizeIPv6(_normalizeIPv4(components.host, protocol), protocol);
            //determine reference type
            if (components.scheme === undefined && components.userinfo === undefined && components.host === undefined && components.port === undefined && !components.path && components.query === undefined) components.reference = "same-document";
            else if (components.scheme === undefined) components.reference = "relative";
            else if (components.fragment === undefined) components.reference = "absolute";
            else components.reference = "uri";
            //check for reference errors
            if (options.reference && options.reference !== "suffix" && options.reference !== components.reference) components.error = components.error || "URI is not a " + options.reference + " reference.";
            //find scheme handler
            var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
            //check if scheme can't handle IRIs
            if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
                //if host component is a domain name
                if (components.host && (options.domainHost || schemeHandler && schemeHandler.domainHost)) //convert Unicode IDN -> ASCII IDN
                try {
                    components.host = punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase());
                } catch (e) {
                    components.error = components.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
                }
                //convert IRI -> URI
                _normalizeComponentEncoding(components, URI_PROTOCOL);
            } else //normalize encodings
            _normalizeComponentEncoding(components, protocol);
            //perform scheme specific parsing
            if (schemeHandler && schemeHandler.parse) schemeHandler.parse(components, options);
        } else components.error = components.error || "URI can not be parsed.";
        return components;
    }
    function _recomposeAuthority(components, options) {
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        if (components.userinfo !== undefined) {
            uriTokens.push(components.userinfo);
            uriTokens.push("@");
        }
        if (components.host !== undefined) //normalize IP hosts, add brackets and escape zone separator for IPv6
        uriTokens.push(_normalizeIPv6(_normalizeIPv4(String(components.host), protocol), protocol).replace(protocol.IPV6ADDRESS, function(_, $1, $2) {
            return "[" + $1 + ($2 ? "%25" + $2 : "") + "]";
        }));
        if (typeof components.port === "number" || typeof components.port === "string") {
            uriTokens.push(":");
            uriTokens.push(String(components.port));
        }
        return uriTokens.length ? uriTokens.join("") : undefined;
    }
    var RDS1 = /^\.\.?\//;
    var RDS2 = /^\/\.(\/|$)/;
    var RDS3 = /^\/\.\.(\/|$)/;
    var RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/;
    function removeDotSegments(input) {
        var output = [];
        while(input.length){
            if (input.match(RDS1)) input = input.replace(RDS1, "");
            else if (input.match(RDS2)) input = input.replace(RDS2, "/");
            else if (input.match(RDS3)) {
                input = input.replace(RDS3, "/");
                output.pop();
            } else if (input === "." || input === "..") input = "";
            else {
                var im = input.match(RDS5);
                if (im) {
                    var s = im[0];
                    input = input.slice(s.length);
                    output.push(s);
                } else throw new Error("Unexpected dot segment condition");
            }
        }
        return output.join("");
    }
    function serialize(components) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var protocol = options.iri ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        //find scheme handler
        var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
        //perform scheme specific serialization
        if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(components, options);
        if (components.host) {
            //if host component is an IPv6 address
            if (protocol.IPV6ADDRESS.test(components.host)) ;
            else if (options.domainHost || schemeHandler && schemeHandler.domainHost) //convert IDN via punycode
            try {
                components.host = !options.iri ? punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase()) : punycode.toUnicode(components.host);
            } catch (e) {
                components.error = components.error || "Host's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
            }
        }
        //normalize encoding
        _normalizeComponentEncoding(components, protocol);
        if (options.reference !== "suffix" && components.scheme) {
            uriTokens.push(components.scheme);
            uriTokens.push(":");
        }
        var authority = _recomposeAuthority(components, options);
        if (authority !== undefined) {
            if (options.reference !== "suffix") uriTokens.push("//");
            uriTokens.push(authority);
            if (components.path && components.path.charAt(0) !== "/") uriTokens.push("/");
        }
        if (components.path !== undefined) {
            var s = components.path;
            if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) s = removeDotSegments(s);
            if (authority === undefined) s = s.replace(/^\/\//, "/%2F"); //don't allow the path to start with "//"
            uriTokens.push(s);
        }
        if (components.query !== undefined) {
            uriTokens.push("?");
            uriTokens.push(components.query);
        }
        if (components.fragment !== undefined) {
            uriTokens.push("#");
            uriTokens.push(components.fragment);
        }
        return uriTokens.join(""); //merge tokens into a string
    }
    function resolveComponents(base, relative) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var skipNormalization = arguments[3];
        var target = {};
        if (!skipNormalization) {
            base = parse(serialize(base, options), options); //normalize base components
            relative = parse(serialize(relative, options), options); //normalize relative components
        }
        options = options || {};
        if (!options.tolerant && relative.scheme) {
            target.scheme = relative.scheme;
            //target.authority = relative.authority;
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = removeDotSegments(relative.path || "");
            target.query = relative.query;
        } else {
            if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
                //target.authority = relative.authority;
                target.userinfo = relative.userinfo;
                target.host = relative.host;
                target.port = relative.port;
                target.path = removeDotSegments(relative.path || "");
                target.query = relative.query;
            } else {
                if (!relative.path) {
                    target.path = base.path;
                    if (relative.query !== undefined) target.query = relative.query;
                    else target.query = base.query;
                } else {
                    if (relative.path.charAt(0) === "/") target.path = removeDotSegments(relative.path);
                    else {
                        if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) target.path = "/" + relative.path;
                        else if (!base.path) target.path = relative.path;
                        else target.path = base.path.slice(0, base.path.lastIndexOf("/") + 1) + relative.path;
                        target.path = removeDotSegments(target.path);
                    }
                    target.query = relative.query;
                }
                //target.authority = base.authority;
                target.userinfo = base.userinfo;
                target.host = base.host;
                target.port = base.port;
            }
            target.scheme = base.scheme;
        }
        target.fragment = relative.fragment;
        return target;
    }
    function resolve(baseURI, relativeURI, options) {
        var schemelessOptions = assign({
            scheme: "null"
        }, options);
        return serialize(resolveComponents(parse(baseURI, schemelessOptions), parse(relativeURI, schemelessOptions), schemelessOptions, true), schemelessOptions);
    }
    function normalize(uri, options) {
        if (typeof uri === "string") uri = serialize(parse(uri, options), options);
        else if (typeOf(uri) === "object") uri = parse(serialize(uri, options), options);
        return uri;
    }
    function equal(uriA, uriB, options) {
        if (typeof uriA === "string") uriA = serialize(parse(uriA, options), options);
        else if (typeOf(uriA) === "object") uriA = serialize(uriA, options);
        if (typeof uriB === "string") uriB = serialize(parse(uriB, options), options);
        else if (typeOf(uriB) === "object") uriB = serialize(uriB, options);
        return uriA === uriB;
    }
    function escapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.ESCAPE : IRI_PROTOCOL.ESCAPE, pctEncChar);
    }
    function unescapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.PCT_ENCODED : IRI_PROTOCOL.PCT_ENCODED, pctDecChars);
    }
    var handler = {
        scheme: "http",
        domainHost: true,
        parse: function parse(components, options) {
            //report missing host
            if (!components.host) components.error = components.error || "HTTP URIs must have a host.";
            return components;
        },
        serialize: function serialize(components, options) {
            var secure = String(components.scheme).toLowerCase() === "https";
            //normalize the default port
            if (components.port === (secure ? 443 : 80) || components.port === "") components.port = undefined;
            //normalize the empty path
            if (!components.path) components.path = "/";
            //NOTE: We do not parse query strings for HTTP URIs
            //as WWW Form Url Encoded query strings are part of the HTML4+ spec,
            //and not the HTTP spec.
            return components;
        }
    };
    var handler$1 = {
        scheme: "https",
        domainHost: handler.domainHost,
        parse: handler.parse,
        serialize: handler.serialize
    };
    function isSecure(wsComponents) {
        return typeof wsComponents.secure === "boolean" ? wsComponents.secure : String(wsComponents.scheme).toLowerCase() === "wss";
    }
    //RFC 6455
    var handler$2 = {
        scheme: "ws",
        domainHost: true,
        parse: function parse(components, options) {
            var wsComponents = components;
            //indicate if the secure flag is set
            wsComponents.secure = isSecure(wsComponents);
            //construct resouce name
            wsComponents.resourceName = (wsComponents.path || "/") + (wsComponents.query ? "?" + wsComponents.query : "");
            wsComponents.path = undefined;
            wsComponents.query = undefined;
            return wsComponents;
        },
        serialize: function serialize(wsComponents, options) {
            //normalize the default port
            if (wsComponents.port === (isSecure(wsComponents) ? 443 : 80) || wsComponents.port === "") wsComponents.port = undefined;
            //ensure scheme matches secure flag
            if (typeof wsComponents.secure === "boolean") {
                wsComponents.scheme = wsComponents.secure ? "wss" : "ws";
                wsComponents.secure = undefined;
            }
            //reconstruct path from resource name
            if (wsComponents.resourceName) {
                var _wsComponents$resourc = wsComponents.resourceName.split("?"), _wsComponents$resourc2 = slicedToArray(_wsComponents$resourc, 2), path = _wsComponents$resourc2[0], query = _wsComponents$resourc2[1];
                wsComponents.path = path && path !== "/" ? path : undefined;
                wsComponents.query = query;
                wsComponents.resourceName = undefined;
            }
            //forbid fragment component
            wsComponents.fragment = undefined;
            return wsComponents;
        }
    };
    var handler$3 = {
        scheme: "wss",
        domainHost: handler$2.domainHost,
        parse: handler$2.parse,
        serialize: handler$2.serialize
    };
    var O = {};
    var isIRI = true;
    //RFC 3986
    var UNRESERVED$$ = "[A-Za-z0-9\\-\\.\\_\\~" + (isIRI ? "\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF" : "") + "]";
    var HEXDIG$$ = "[0-9A-Fa-f]"; //case-insensitive
    var PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)); //expanded
    //RFC 5322, except these symbols as per RFC 6068: @ : / ? # [ ] & ; =
    //const ATEXT$$ = "[A-Za-z0-9\\!\\#\\$\\%\\&\\'\\*\\+\\-\\/\\=\\?\\^\\_\\`\\{\\|\\}\\~]";
    //const WSP$$ = "[\\x20\\x09]";
    //const OBS_QTEXT$$ = "[\\x01-\\x08\\x0B\\x0C\\x0E-\\x1F\\x7F]";  //(%d1-8 / %d11-12 / %d14-31 / %d127)
    //const QTEXT$$ = merge("[\\x21\\x23-\\x5B\\x5D-\\x7E]", OBS_QTEXT$$);  //%d33 / %d35-91 / %d93-126 / obs-qtext
    //const VCHAR$$ = "[\\x21-\\x7E]";
    //const WSP$$ = "[\\x20\\x09]";
    //const OBS_QP$ = subexp("\\\\" + merge("[\\x00\\x0D\\x0A]", OBS_QTEXT$$));  //%d0 / CR / LF / obs-qtext
    //const FWS$ = subexp(subexp(WSP$$ + "*" + "\\x0D\\x0A") + "?" + WSP$$ + "+");
    //const QUOTED_PAIR$ = subexp(subexp("\\\\" + subexp(VCHAR$$ + "|" + WSP$$)) + "|" + OBS_QP$);
    //const QUOTED_STRING$ = subexp('\\"' + subexp(FWS$ + "?" + QCONTENT$) + "*" + FWS$ + "?" + '\\"');
    var ATEXT$$ = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]";
    var QTEXT$$ = "[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]";
    var VCHAR$$ = merge(QTEXT$$, '[\\"\\\\]');
    var SOME_DELIMS$$ = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]";
    var UNRESERVED = new RegExp(UNRESERVED$$, "g");
    var PCT_ENCODED = new RegExp(PCT_ENCODED$, "g");
    var NOT_LOCAL_PART = new RegExp(merge("[^]", ATEXT$$, "[\\.]", '[\\"]', VCHAR$$), "g");
    var NOT_HFNAME = new RegExp(merge("[^]", UNRESERVED$$, SOME_DELIMS$$), "g");
    var NOT_HFVALUE = NOT_HFNAME;
    function decodeUnreserved(str) {
        var decStr = pctDecChars(str);
        return !decStr.match(UNRESERVED) ? str : decStr;
    }
    var handler$4 = {
        scheme: "mailto",
        parse: function parse$$1(components, options) {
            var mailtoComponents = components;
            var to = mailtoComponents.to = mailtoComponents.path ? mailtoComponents.path.split(",") : [];
            mailtoComponents.path = undefined;
            if (mailtoComponents.query) {
                var unknownHeaders = false;
                var headers = {};
                var hfields = mailtoComponents.query.split("&");
                for(var x = 0, xl = hfields.length; x < xl; ++x){
                    var hfield = hfields[x].split("=");
                    switch(hfield[0]){
                        case "to":
                            var toAddrs = hfield[1].split(",");
                            for(var _x = 0, _xl = toAddrs.length; _x < _xl; ++_x)to.push(toAddrs[_x]);
                            break;
                        case "subject":
                            mailtoComponents.subject = unescapeComponent(hfield[1], options);
                            break;
                        case "body":
                            mailtoComponents.body = unescapeComponent(hfield[1], options);
                            break;
                        default:
                            unknownHeaders = true;
                            headers[unescapeComponent(hfield[0], options)] = unescapeComponent(hfield[1], options);
                            break;
                    }
                }
                if (unknownHeaders) mailtoComponents.headers = headers;
            }
            mailtoComponents.query = undefined;
            for(var _x2 = 0, _xl2 = to.length; _x2 < _xl2; ++_x2){
                var addr = to[_x2].split("@");
                addr[0] = unescapeComponent(addr[0]);
                if (!options.unicodeSupport) //convert Unicode IDN -> ASCII IDN
                try {
                    addr[1] = punycode.toASCII(unescapeComponent(addr[1], options).toLowerCase());
                } catch (e) {
                    mailtoComponents.error = mailtoComponents.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
                }
                else addr[1] = unescapeComponent(addr[1], options).toLowerCase();
                to[_x2] = addr.join("@");
            }
            return mailtoComponents;
        },
        serialize: function serialize$$1(mailtoComponents, options) {
            var components = mailtoComponents;
            var to = toArray(mailtoComponents.to);
            if (to) {
                for(var x = 0, xl = to.length; x < xl; ++x){
                    var toAddr = String(to[x]);
                    var atIdx = toAddr.lastIndexOf("@");
                    var localPart = toAddr.slice(0, atIdx).replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_LOCAL_PART, pctEncChar);
                    var domain = toAddr.slice(atIdx + 1);
                    //convert IDN via punycode
                    try {
                        domain = !options.iri ? punycode.toASCII(unescapeComponent(domain, options).toLowerCase()) : punycode.toUnicode(domain);
                    } catch (e) {
                        components.error = components.error || "Email address's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                    }
                    to[x] = localPart + "@" + domain;
                }
                components.path = to.join(",");
            }
            var headers = mailtoComponents.headers = mailtoComponents.headers || {};
            if (mailtoComponents.subject) headers["subject"] = mailtoComponents.subject;
            if (mailtoComponents.body) headers["body"] = mailtoComponents.body;
            var fields = [];
            for(var name in headers)if (headers[name] !== O[name]) fields.push(name.replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFNAME, pctEncChar) + "=" + headers[name].replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFVALUE, pctEncChar));
            if (fields.length) components.query = fields.join("&");
            return components;
        }
    };
    var URN_PARSE = /^([^\:]+)\:(.*)/;
    //RFC 2141
    var handler$5 = {
        scheme: "urn",
        parse: function parse$$1(components, options) {
            var matches = components.path && components.path.match(URN_PARSE);
            var urnComponents = components;
            if (matches) {
                var scheme = options.scheme || urnComponents.scheme || "urn";
                var nid = matches[1].toLowerCase();
                var nss = matches[2];
                var urnScheme = scheme + ":" + (options.nid || nid);
                var schemeHandler = SCHEMES[urnScheme];
                urnComponents.nid = nid;
                urnComponents.nss = nss;
                urnComponents.path = undefined;
                if (schemeHandler) urnComponents = schemeHandler.parse(urnComponents, options);
            } else urnComponents.error = urnComponents.error || "URN can not be parsed.";
            return urnComponents;
        },
        serialize: function serialize$$1(urnComponents, options) {
            var scheme = options.scheme || urnComponents.scheme || "urn";
            var nid = urnComponents.nid;
            var urnScheme = scheme + ":" + (options.nid || nid);
            var schemeHandler = SCHEMES[urnScheme];
            if (schemeHandler) urnComponents = schemeHandler.serialize(urnComponents, options);
            var uriComponents = urnComponents;
            var nss = urnComponents.nss;
            uriComponents.path = (nid || options.nid) + ":" + nss;
            return uriComponents;
        }
    };
    var UUID = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/;
    //RFC 4122
    var handler$6 = {
        scheme: "urn:uuid",
        parse: function parse(urnComponents, options) {
            var uuidComponents = urnComponents;
            uuidComponents.uuid = uuidComponents.nss;
            uuidComponents.nss = undefined;
            if (!options.tolerant && (!uuidComponents.uuid || !uuidComponents.uuid.match(UUID))) uuidComponents.error = uuidComponents.error || "UUID is not valid.";
            return uuidComponents;
        },
        serialize: function serialize(uuidComponents, options) {
            var urnComponents = uuidComponents;
            //normalize UUID
            urnComponents.nss = (uuidComponents.uuid || "").toLowerCase();
            return urnComponents;
        }
    };
    SCHEMES[handler.scheme] = handler;
    SCHEMES[handler$1.scheme] = handler$1;
    SCHEMES[handler$2.scheme] = handler$2;
    SCHEMES[handler$3.scheme] = handler$3;
    SCHEMES[handler$4.scheme] = handler$4;
    SCHEMES[handler$5.scheme] = handler$5;
    SCHEMES[handler$6.scheme] = handler$6;
    exports1.SCHEMES = SCHEMES;
    exports1.pctEncChar = pctEncChar;
    exports1.pctDecChars = pctDecChars;
    exports1.parse = parse;
    exports1.removeDotSegments = removeDotSegments;
    exports1.serialize = serialize;
    exports1.resolveComponents = resolveComponents;
    exports1.resolve = resolve;
    exports1.normalize = normalize;
    exports1.equal = equal;
    exports1.escapeComponent = escapeComponent;
    exports1.unescapeComponent = unescapeComponent;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});



var $eNRCS = parcelRequire("eNRCS");
var $141f1697ab3cba12$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $141f1697ab3cba12$require$Buffer = $6ZWSX.Buffer;

var $hPtJY = parcelRequire("hPtJY");

var $hGlpy = parcelRequire("hGlpy");
class $141f1697ab3cba12$var$Readable extends $hGlpy.Readable {
    constructor(gc_readable = {}){
        super(gc_readable);
        // use iterator
        if (gc_readable.iterator) throw new Error("readable stream iterator shortcut not yet implemented");
    }
    until(s_event, b_return_stream) {
        return new Promise((fk_until, fe_until)=>{
            // convert error to rejected promise
            this.on("error", (e_stream)=>{
                fe_until(e_stream);
            });
            // special cases returns `this`
            if (b_return_stream) this.once(s_event, (...a_args)=>{
                fk_until(this, ...a_args);
            });
            else this.once(s_event, fk_until);
        });
    }
    bucket(s_encoding = "utf8") {
        let g_readable = this._readableState;
        // object mode
        if (g_readable.objectMode) // async operation
        return new Promise((fk_bucket, fe_bucket)=>{
            let a_data = [];
            // pipe to writable
            this.pipe(new $hGlpy.Writable({
                write (w_event, s_write_encoding, fk_write) {
                    a_data.push(w_event);
                    fk_write();
                },
                writev (a_chunks, fk_writev) {
                    a_data.push(...a_chunks);
                    fk_writev();
                }
            }))// error
            .on("error", (e_stream)=>{
                fe_bucket(e_stream);
            })// wait for it to finish
            .on("finish", ()=>{
                fk_bucket(a_data);
            });
        });
        else if ("utf8" === s_encoding || "utf-8" === s_encoding) // async operation
        return new Promise((fk_bucket, fe_bucket)=>{
            let s_data = "";
            // set encoding
            this.setEncoding(s_encoding);
            // pipe to writable
            this.pipe(new $hGlpy.Writable({
                decodeStrings: false,
                write (s_chunk, s_write_encoding, fk_write) {
                    s_data += s_chunk;
                    fk_write();
                },
                writev (a_chunks, fk_writev) {
                    s_data += a_chunks.join("");
                    fk_writev();
                }
            }))// error
            .on("error", (e_stream)=>{
                fe_bucket(e_stream);
            })// wait for it to finish
            .on("finish", ()=>{
                fk_bucket(s_data);
            });
        });
        else if ("buffer" === s_encoding) // async operation
        return new Promise((fk_bucket, fe_bucket)=>{
            let ab_data = $141f1697ab3cba12$require$Buffer.from([]);
            // pipe to writable
            this.pipe(new $hGlpy.Writable({
                decodeStrings: true,
                write (ab_chunk, s_write_encoding, fk_write) {
                    ab_data = $141f1697ab3cba12$require$Buffer.concat([
                        ab_data,
                        ab_chunk
                    ], ab_data.length + ab_chunk.length);
                    fk_write();
                }
            }))// error
            .on("error", (e_stream)=>{
                fe_bucket(e_stream);
            })// wait for it to finish
            .on("finish", ()=>{
                fk_bucket(ab_data);
            });
        });
    }
}
class $141f1697ab3cba12$var$Writable extends $hGlpy.Writable {
    until(s_event, b_return_stream) {
        return new Promise((fk_until, fe_until)=>{
            // convert error to rejected promise
            this.on("error", (e_stream)=>{
                fe_until(e_stream);
            });
            // special cases returns `this`
            if (b_return_stream) this.once(s_event, (...a_args)=>{
                fk_until(this, ...a_args);
            });
            else this.once(s_event, fk_until);
        });
    }
    // rdfjs impl
    import(ds_source) {
        ds_source.on("data", (w_chunk)=>this.write(w_chunk)).on("end", ()=>this.end()).on("error", (e_read)=>this.emit("error", e_read));
        return this;
    }
}
class $141f1697ab3cba12$var$Duplex extends $hGlpy.Duplex {
    until(s_event, b_return_stream) {
        return new Promise((fk_until, fe_until)=>{
            // convert error to rejected promise
            this.on("error", (e_stream)=>{
                fe_until(e_stream);
            });
            // special cases returns `this`
            if (b_return_stream) this.once(s_event, (...a_args)=>{
                fk_until(this, ...a_args);
            });
            else this.once(s_event, fk_until);
        });
    }
    bucket(s_encoding = "utf8") {
        let g_readable = this._readableState;
        // object mode
        if (g_readable.objectMode) // async operation
        return new Promise((fk_bucket, fe_bucket)=>{
            let a_data = [];
            // pipe to writable
            this.pipe(new $hGlpy.Writable({
                write (w_event, s_write_encoding, fk_write) {
                    a_data.push(w_event);
                    fk_write();
                },
                writev (a_chunks, fk_writev) {
                    a_data.push(...a_chunks);
                    fk_writev();
                }
            }))// error
            .on("error", (e_stream)=>{
                fe_bucket(e_stream);
            })// wait for it to finish
            .on("finish", ()=>{
                fk_bucket(a_data);
            });
        });
        else if ("utf8" === s_encoding || "utf-8" === s_encoding) // async operation
        return new Promise((fk_bucket, fe_bucket)=>{
            let s_data = "";
            // set encoding
            this.setEncoding(s_encoding);
            // pipe to writable
            this.pipe(new $hGlpy.Writable({
                decodeStrings: false,
                write (s_chunk, s_write_encoding, fk_write) {
                    s_data += s_chunk;
                    fk_write();
                },
                writev (a_chunks, fk_writev) {
                    s_data += a_chunks.join("");
                    fk_writev();
                }
            }))// error
            .on("error", (e_stream)=>{
                fe_bucket(e_stream);
            })// wait for it to finish
            .on("finish", ()=>{
                fk_bucket(s_data);
            });
        });
        else if ("buffer" === s_encoding) // async operation
        return new Promise((fk_bucket, fe_bucket)=>{
            let ab_data = $141f1697ab3cba12$require$Buffer.from([]);
            // pipe to writable
            this.pipe(new $hGlpy.Writable({
                decodeStrings: true,
                write (ab_chunk, s_write_encoding, fk_write) {
                    ab_data = $141f1697ab3cba12$require$Buffer.concat([
                        ab_data,
                        ab_chunk
                    ], ab_data.length + ab_chunk.length);
                    fk_write();
                }
            }))// error
            .on("error", (e_stream)=>{
                fe_bucket(e_stream);
            })// wait for it to finish
            .on("finish", ()=>{
                fk_bucket(ab_data);
            });
        });
    }
}
class $141f1697ab3cba12$var$Transform extends $hGlpy.Transform {
    until(s_event, b_return_stream) {
        return new Promise((fk_until, fe_until)=>{
            // convert error to rejected promise
            this.on("error", (e_stream)=>{
                fe_until(e_stream);
            });
            // special cases returns `this`
            if (b_return_stream) this.once(s_event, (...a_args)=>{
                fk_until(this, ...a_args);
            });
            else this.once(s_event, fk_until);
        });
    }
    bucket(s_encoding = "utf8") {
        let g_readable = this._readableState;
        // object mode
        if (g_readable.objectMode) // async operation
        return new Promise((fk_bucket, fe_bucket)=>{
            let a_data = [];
            // pipe to writable
            this.pipe(new $hGlpy.Writable({
                write (w_event, s_write_encoding, fk_write) {
                    a_data.push(w_event);
                    fk_write();
                },
                writev (a_chunks, fk_writev) {
                    a_data.push(...a_chunks);
                    fk_writev();
                }
            }))// error
            .on("error", (e_stream)=>{
                fe_bucket(e_stream);
            })// wait for it to finish
            .on("finish", ()=>{
                fk_bucket(a_data);
            });
        });
        else if ("utf8" === s_encoding || "utf-8" === s_encoding) // async operation
        return new Promise((fk_bucket, fe_bucket)=>{
            let s_data = "";
            // set encoding
            this.setEncoding(s_encoding);
            // pipe to writable
            this.pipe(new $hGlpy.Writable({
                decodeStrings: false,
                write (s_chunk, s_write_encoding, fk_write) {
                    s_data += s_chunk;
                    fk_write();
                },
                writev (a_chunks, fk_writev) {
                    s_data += a_chunks.join("");
                    fk_writev();
                }
            }))// error
            .on("error", (e_stream)=>{
                fe_bucket(e_stream);
            })// wait for it to finish
            .on("finish", ()=>{
                fk_bucket(s_data);
            });
        });
        else if ("buffer" === s_encoding) // async operation
        return new Promise((fk_bucket, fe_bucket)=>{
            let ab_data = $141f1697ab3cba12$require$Buffer.from([]);
            // pipe to writable
            this.pipe(new $hGlpy.Writable({
                decodeStrings: true,
                write (ab_chunk, s_write_encoding, fk_write) {
                    ab_data = $141f1697ab3cba12$require$Buffer.concat([
                        ab_data,
                        ab_chunk
                    ], ab_data.length + ab_chunk.length);
                    fk_write();
                }
            }))// error
            .on("error", (e_stream)=>{
                fe_bucket(e_stream);
            })// wait for it to finish
            .on("finish", ()=>{
                fk_bucket(ab_data);
            });
        });
    }
    // rdfjs impl
    import(ds_source) {
        ds_source.on("data", (w_chunk)=>this.write(w_chunk)).on("end", ()=>this.end()).on("error", (e_read)=>this.emit("error", e_read));
        return this;
    }
    demolish(e_destroy) {
        // do not allow to push
        this.push = (z_chunk)=>{
            // ignore eof signals from node core
            if (null === z_chunk) return;
            // anything else is bad
            throw new Error(`[ERR_STREAM_DESTROYED]: Cannot push after stream was destroyed`);
        };
        // do not allow to emit 'end'
        this.emit = function(s_event, ...a_args) {
            if ("end" === s_event) return;
            Object.getPrototypeOf(this).emit.apply(this, [
                s_event,
                ...a_args
            ]);
        };
        // an error was given, destroy the stream as well
        if (e_destroy) return $hGlpy.Transform.prototype.destroy.call(this, e_destroy);
    }
}
// eslint-disable-next-line no-new-func
const $141f1697ab3cba12$var$b_is_node = new Function(/* syntax: js */ `try {return this===global;}catch(e){return false;}`)();
// deduce the runtime environment
const [$141f1697ab3cba12$var$B_BROWSER, $141f1697ab3cba12$var$B_BROWSERIFY] = (()=>"undefined" === typeof $hPtJY ? [
        true,
        false
    ] : [
        true,
        true
    ])();
// node.js or browserify; patch for node < v10
if ($141f1697ab3cba12$var$B_BROWSERIFY || $141f1697ab3cba12$var$b_is_node && +/^v(\d+)/.exec($hPtJY.version)[1] < 10) {
    // override destroy methods
    $141f1697ab3cba12$var$Transform.prototype.destroy = $141f1697ab3cba12$var$Duplex.prototype.destroy = function(e_destroy, fke_destroy) {
        this._readableState.destroyed = true;
        this._writableState.destroyed = true;
        let f_emit_close = ()=>{
            if (!this._writableState.emitClose) return;
            if (!this._readableState.emitClose) return;
            this.emit("close");
        };
        this._destroy(e_destroy || null, (e_destroy_re)=>{
            if (!fke_destroy && e_destroy_re) {
                $hPtJY.nextTick(()=>{
                    this.emit("error", e_destroy_re);
                    f_emit_close();
                });
                this._writableState.errorEmitted = true;
            } else {
                $hPtJY.nextTick(f_emit_close);
                if (fke_destroy) fke_destroy(e_destroy_re);
            }
        });
        return this;
    };
    // override default _destroy implementations
    $141f1697ab3cba12$var$Transform.prototype._destroy = $141f1697ab3cba12$var$Duplex.prototype._destroy = (e_destroy, fke_destroy)=>fke_destroy(e_destroy);
}
class $141f1697ab3cba12$var$QuadsToOther extends $141f1697ab3cba12$var$Transform {
    constructor(gc_transform = {}){
        super({
            ...gc_transform,
            writableObjectMode: true,
            readableObjectMode: true
        });
        this._as_inputs = new Set();
        // forward prefix and comment events
        this.on("pipe", (ds_src)=>{
            this._as_inputs.add(ds_src);
            ds_src.on("prefix", (...a_args)=>{
                this.emit("prefix", ...a_args);
            }).on("comment", (...a_args)=>{
                this.emit("comment", ...a_args);
            });
        });
        this.on("unpipe", (ds_src)=>{
            this._as_inputs.delete(ds_src);
        });
    }
    _destroy() {
        for (let ds_input of this._as_inputs)ds_input.destroy();
    }
}
class $141f1697ab3cba12$var$Quads_To_JSON_Transform extends $141f1697ab3cba12$var$QuadsToOther {
    // serializse json
    _transform(g_quad, s_encoding, fk_transform) {
        fk_transform(null, JSON.stringify(g_quad.isolate()) + "\n");
    }
}
class $141f1697ab3cba12$var$Quads_To_Writable extends $141f1697ab3cba12$var$QuadsToOther {
    _transform(g_quad, s_encoding, fk_transform) {
        fk_transform(null, {
            type: "quad",
            value: g_quad
        });
    }
}
$141f1697ab3cba12$var$Transform.QuadsToOther = $141f1697ab3cba12$var$QuadsToOther;
$141f1697ab3cba12$exports = {
    ...$hGlpy,
    Readable: $141f1697ab3cba12$var$Readable,
    Writable: $141f1697ab3cba12$var$Writable,
    Duplex: $141f1697ab3cba12$var$Duplex,
    Transform: $141f1697ab3cba12$var$Transform,
    QuadsToOther: $141f1697ab3cba12$var$QuadsToOther,
    // create a transform from quad objects into JSON strings for trivial serialization
    quads_to_json () {
        return new $141f1697ab3cba12$var$Quads_To_JSON_Transform();
    },
    // create a transform from quad objects into writable data events
    quads_to_writable () {
        return new $141f1697ab3cba12$var$Quads_To_Writable();
    },
    // create a simple, single-event readable stream
    source (w_push, s_encoding = null) {
        // encoding not explicit, string given; assume utf8
        if (!s_encoding && "string" === typeof w_push) s_encoding = "utf8";
        // readable
        return new $141f1697ab3cba12$var$Readable({
            objectMode: !s_encoding && "string" !== typeof w_push && !$141f1697ab3cba12$require$Buffer.isBuffer(w_push),
            read () {
                this.push(w_push, s_encoding);
                this.push(null);
            }
        });
    }
};


var $266825253b7f24dc$exports = {};
var $44edd02a6be448cd$export$5f828d93ff035aa8;
var $44edd02a6be448cd$export$cd94982b18c6332c;
var $44edd02a6be448cd$export$1d518568e4f529b0;
var $44edd02a6be448cd$export$5285b6d41c912b41;
var $44edd02a6be448cd$export$2fb37efbf6ae0c0e;
var $44edd02a6be448cd$export$ab85ecd77ce6a5cd;
var $44edd02a6be448cd$export$da39cf97e1eb7c91;
var $44edd02a6be448cd$export$52a9039d7177394f;
var $44edd02a6be448cd$export$f7201db400317331;
var $44edd02a6be448cd$export$448fa22aedc9dbca;
var $44edd02a6be448cd$export$b80c7ba289c8fa56;
var $44edd02a6be448cd$export$26e5786e8ac8e530;
var $44edd02a6be448cd$export$bdd223f16383713e;
var $44edd02a6be448cd$export$20533d26f07f1ee0;
var $44edd02a6be448cd$export$2f64596b8cbf08b4;
var $44edd02a6be448cd$export$2ce6d8d0e8b04e1a;
var $44edd02a6be448cd$export$12ada9414fbc594c;
var $44edd02a6be448cd$export$f5e7e39d57cd9700;
var $44edd02a6be448cd$export$36b6d6ef312eab39;
var $44edd02a6be448cd$export$58a258485f1e49f6;
var $44edd02a6be448cd$export$dedd8dc3dc62b370;
var $44edd02a6be448cd$export$971862a2fcb1bb40;
var $44edd02a6be448cd$export$c6ff6a88acbeaf40;
var $44edd02a6be448cd$export$fdc27893e98845cc;
var $44edd02a6be448cd$export$6671fb9a1323bed;
var $44edd02a6be448cd$export$d74daf141a551db;
var $44edd02a6be448cd$export$45df7cae684751af;
var $44edd02a6be448cd$export$1db683ad541682f6;
var $44edd02a6be448cd$export$6f65485f87568e37;
var $44edd02a6be448cd$export$91a8e56769aeb334;
var $44edd02a6be448cd$export$2d4117e99c2179e4;
var $44edd02a6be448cd$export$512823e338ddb1b7;
var $44edd02a6be448cd$export$9d0e0c0c4a8d30f3;
var $44edd02a6be448cd$export$b9d55ff329113abd;
var $44edd02a6be448cd$export$7efb24e2fddf99b9;
var $44edd02a6be448cd$export$bb1abf2ce84fc7e8;
var $44edd02a6be448cd$export$2f7171e78e524d5e;
var $44edd02a6be448cd$export$e1d879b482f37d98;
var $44edd02a6be448cd$export$1a988e7317c65621;
"use strict";

$44edd02a6be448cd$export$5f828d93ff035aa8 = $44edd02a6be448cd$export$cd94982b18c6332c = $44edd02a6be448cd$export$1d518568e4f529b0 = $44edd02a6be448cd$export$5285b6d41c912b41 = (parcelRequire("hkN9y"));

$44edd02a6be448cd$export$2fb37efbf6ae0c0e = $44edd02a6be448cd$export$ab85ecd77ce6a5cd = (parcelRequire("1R2J7"));

$44edd02a6be448cd$export$da39cf97e1eb7c91 = $44edd02a6be448cd$export$52a9039d7177394f = (parcelRequire("1iL1D"));
var $aaef572789dc684d$exports = {};
"use strict";

$aaef572789dc684d$exports = (parcelRequire("6swAi"));


var $44edd02a6be448cd$var$algoKeys = Object.keys($aaef572789dc684d$exports);
var $44edd02a6be448cd$var$hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat($44edd02a6be448cd$var$algoKeys);
$44edd02a6be448cd$export$f7201db400317331 = function() {
    return $44edd02a6be448cd$var$hashes;
};

var $lORrZ = parcelRequire("lORrZ");
$44edd02a6be448cd$export$448fa22aedc9dbca = $lORrZ.pbkdf2;
$44edd02a6be448cd$export$b80c7ba289c8fa56 = $lORrZ.pbkdf2Sync;
var $a97f913e2ff95e3b$export$bdd223f16383713e;
var $a97f913e2ff95e3b$export$26e5786e8ac8e530;
var $a97f913e2ff95e3b$export$2f64596b8cbf08b4;
var $a97f913e2ff95e3b$export$20533d26f07f1ee0;
var $a97f913e2ff95e3b$export$12ada9414fbc594c;
var $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a;
var $a97f913e2ff95e3b$export$36b6d6ef312eab39;
var $a97f913e2ff95e3b$export$f5e7e39d57cd9700;
var $a97f913e2ff95e3b$export$dedd8dc3dc62b370;
var $a97f913e2ff95e3b$export$58a258485f1e49f6;
var $f85287bc79724838$exports = {};

var $26nOC = parcelRequire("26nOC");
var $675eb908dbde2e68$export$eab97d15b1788b8d;
var $675eb908dbde2e68$export$26e5786e8ac8e530;
var $675eb908dbde2e68$export$cc8859615686b300;
var $675eb908dbde2e68$export$8ad3f227af08fcc5;
var $675eb908dbde2e68$export$947646e34766044f;
"use strict";

$675eb908dbde2e68$export$eab97d15b1788b8d = (parcelRequire("dyok1"));

$675eb908dbde2e68$export$26e5786e8ac8e530 = (parcelRequire("enfpo"));

$675eb908dbde2e68$export$cc8859615686b300 = (parcelRequire("dB8Kv"));

$675eb908dbde2e68$export$8ad3f227af08fcc5 = (parcelRequire("eiYbc"));

$675eb908dbde2e68$export$947646e34766044f = (parcelRequire("5ye6K"));



var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $f85287bc79724838$require$Buffer = $1U9GM.Buffer;
var $f85287bc79724838$var$modes = {
    "des-ede3-cbc": $675eb908dbde2e68$export$8ad3f227af08fcc5.instantiate($675eb908dbde2e68$export$947646e34766044f),
    "des-ede3": $675eb908dbde2e68$export$947646e34766044f,
    "des-ede-cbc": $675eb908dbde2e68$export$8ad3f227af08fcc5.instantiate($675eb908dbde2e68$export$947646e34766044f),
    "des-ede": $675eb908dbde2e68$export$947646e34766044f,
    "des-cbc": $675eb908dbde2e68$export$8ad3f227af08fcc5.instantiate($675eb908dbde2e68$export$cc8859615686b300),
    "des-ecb": $675eb908dbde2e68$export$cc8859615686b300
};
$f85287bc79724838$var$modes.des = $f85287bc79724838$var$modes["des-cbc"];
$f85287bc79724838$var$modes.des3 = $f85287bc79724838$var$modes["des-ede3-cbc"];
$f85287bc79724838$exports = $f85287bc79724838$var$DES;
$dlqwk($f85287bc79724838$var$DES, $26nOC);
function $f85287bc79724838$var$DES(opts) {
    $26nOC.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $f85287bc79724838$var$modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!$f85287bc79724838$require$Buffer.isBuffer(key)) key = $f85287bc79724838$require$Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = $f85287bc79724838$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$f85287bc79724838$require$Buffer.isBuffer(iv)) iv = $f85287bc79724838$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$f85287bc79724838$var$DES.prototype._update = function(data) {
    return $f85287bc79724838$require$Buffer.from(this._des.update(data));
};
$f85287bc79724838$var$DES.prototype._final = function() {
    return $f85287bc79724838$require$Buffer.from(this._des.final());
};



var $7Zu82 = parcelRequire("7Zu82");

var $5Su5u = parcelRequire("5Su5u");
var $0649907c0434f982$exports = {};

$parcel$export($0649907c0434f982$exports, "des-ecb", () => $0649907c0434f982$export$116f8a5cee447347, (v) => $0649907c0434f982$export$116f8a5cee447347 = v);
$parcel$export($0649907c0434f982$exports, "des-cbc", () => $0649907c0434f982$export$7483c4066bfb7ae9, (v) => $0649907c0434f982$export$7483c4066bfb7ae9 = v);
$parcel$export($0649907c0434f982$exports, "des", () => $0649907c0434f982$export$e7a565d2e588bb06, (v) => $0649907c0434f982$export$e7a565d2e588bb06 = v);
$parcel$export($0649907c0434f982$exports, "des-ede3-cbc", () => $0649907c0434f982$export$aaa2f54a426f3eb8, (v) => $0649907c0434f982$export$aaa2f54a426f3eb8 = v);
$parcel$export($0649907c0434f982$exports, "des3", () => $0649907c0434f982$export$eba20568dde4ada, (v) => $0649907c0434f982$export$eba20568dde4ada = v);
$parcel$export($0649907c0434f982$exports, "des-ede3", () => $0649907c0434f982$export$d3b5e5996938f5ae, (v) => $0649907c0434f982$export$d3b5e5996938f5ae = v);
$parcel$export($0649907c0434f982$exports, "des-ede-cbc", () => $0649907c0434f982$export$57c08356130bc99b, (v) => $0649907c0434f982$export$57c08356130bc99b = v);
$parcel$export($0649907c0434f982$exports, "des-ede", () => $0649907c0434f982$export$c7169791d5c1e65d, (v) => $0649907c0434f982$export$c7169791d5c1e65d = v);
var $0649907c0434f982$export$116f8a5cee447347;
var $0649907c0434f982$export$7483c4066bfb7ae9;
var $0649907c0434f982$export$e7a565d2e588bb06;
var $0649907c0434f982$export$aaa2f54a426f3eb8;
var $0649907c0434f982$export$eba20568dde4ada;
var $0649907c0434f982$export$d3b5e5996938f5ae;
var $0649907c0434f982$export$57c08356130bc99b;
var $0649907c0434f982$export$c7169791d5c1e65d;
$0649907c0434f982$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$0649907c0434f982$export$7483c4066bfb7ae9 = $0649907c0434f982$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$0649907c0434f982$export$aaa2f54a426f3eb8 = $0649907c0434f982$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$0649907c0434f982$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$0649907c0434f982$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$0649907c0434f982$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};



var $bSYjd = parcelRequire("bSYjd");
function $a97f913e2ff95e3b$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($0649907c0434f982$exports[suite]) {
        keyLen = $0649907c0434f982$exports[suite].key * 8;
        ivLen = $0649907c0434f982$exports[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createCipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($0649907c0434f982$exports[suite]) {
        keyLen = $0649907c0434f982$exports[suite].key * 8;
        ivLen = $0649907c0434f982$exports[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createCipheriv(suite, key, iv);
    if ($0649907c0434f982$exports[suite]) return new $f85287bc79724838$exports({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function $a97f913e2ff95e3b$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createDecipheriv(suite, key, iv);
    if ($0649907c0434f982$exports[suite]) return new $f85287bc79724838$exports({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function $a97f913e2ff95e3b$var$getCiphers() {
    return Object.keys($0649907c0434f982$exports).concat($7Zu82.getCiphers());
}
$a97f913e2ff95e3b$export$bdd223f16383713e = $a97f913e2ff95e3b$export$26e5786e8ac8e530 = $a97f913e2ff95e3b$var$createCipher;
$a97f913e2ff95e3b$export$2f64596b8cbf08b4 = $a97f913e2ff95e3b$export$20533d26f07f1ee0 = $a97f913e2ff95e3b$var$createCipheriv;
$a97f913e2ff95e3b$export$12ada9414fbc594c = $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a = $a97f913e2ff95e3b$var$createDecipher;
$a97f913e2ff95e3b$export$36b6d6ef312eab39 = $a97f913e2ff95e3b$export$f5e7e39d57cd9700 = $a97f913e2ff95e3b$var$createDecipheriv;
$a97f913e2ff95e3b$export$dedd8dc3dc62b370 = $a97f913e2ff95e3b$export$58a258485f1e49f6 = $a97f913e2ff95e3b$var$getCiphers;


$44edd02a6be448cd$export$26e5786e8ac8e530 = $a97f913e2ff95e3b$export$26e5786e8ac8e530;
$44edd02a6be448cd$export$bdd223f16383713e = $a97f913e2ff95e3b$export$bdd223f16383713e;
$44edd02a6be448cd$export$20533d26f07f1ee0 = $a97f913e2ff95e3b$export$20533d26f07f1ee0;
$44edd02a6be448cd$export$2f64596b8cbf08b4 = $a97f913e2ff95e3b$export$2f64596b8cbf08b4;
$44edd02a6be448cd$export$2ce6d8d0e8b04e1a = $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a;
$44edd02a6be448cd$export$12ada9414fbc594c = $a97f913e2ff95e3b$export$12ada9414fbc594c;
$44edd02a6be448cd$export$f5e7e39d57cd9700 = $a97f913e2ff95e3b$export$f5e7e39d57cd9700;
$44edd02a6be448cd$export$36b6d6ef312eab39 = $a97f913e2ff95e3b$export$36b6d6ef312eab39;
$44edd02a6be448cd$export$58a258485f1e49f6 = $a97f913e2ff95e3b$export$58a258485f1e49f6;
$44edd02a6be448cd$export$dedd8dc3dc62b370 = $a97f913e2ff95e3b$export$dedd8dc3dc62b370;
var $4387b1fafb8a1868$export$971862a2fcb1bb40;
var $4387b1fafb8a1868$export$c6ff6a88acbeaf40;
var $4387b1fafb8a1868$export$fdc27893e98845cc;
var $4387b1fafb8a1868$export$6671fb9a1323bed;
var $4387b1fafb8a1868$export$d74daf141a551db;

var $6ZWSX = parcelRequire("6ZWSX");
var $4387b1fafb8a1868$require$Buffer = $6ZWSX.Buffer;
var $7f34ba2fa9025258$exports = {};

var $hkN9y = parcelRequire("hkN9y");
$7f34ba2fa9025258$exports = $7f34ba2fa9025258$var$findPrime;
$7f34ba2fa9025258$var$findPrime.simpleSieve = $7f34ba2fa9025258$var$simpleSieve;
$7f34ba2fa9025258$var$findPrime.fermatTest = $7f34ba2fa9025258$var$fermatTest;

var $5vmVB = parcelRequire("5vmVB");
var $7f34ba2fa9025258$var$TWENTYFOUR = new $5vmVB(24);
var $bac5f004a90de4c6$exports = {};

var $7Zvov = parcelRequire("7Zvov");

var $7JHF0 = parcelRequire("7JHF0");
function $bac5f004a90de4c6$var$MillerRabin(rand) {
    this.rand = rand || new $7JHF0.Rand();
}
$bac5f004a90de4c6$exports = $bac5f004a90de4c6$var$MillerRabin;
$bac5f004a90de4c6$var$MillerRabin.create = function create(rand) {
    return new $bac5f004a90de4c6$var$MillerRabin(rand);
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $7Zvov(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$bac5f004a90de4c6$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$bac5f004a90de4c6$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};


var $7f34ba2fa9025258$var$millerRabin = new $bac5f004a90de4c6$exports();
var $7f34ba2fa9025258$var$ONE = new $5vmVB(1);
var $7f34ba2fa9025258$var$TWO = new $5vmVB(2);
var $7f34ba2fa9025258$var$FIVE = new $5vmVB(5);
var $7f34ba2fa9025258$var$SIXTEEN = new $5vmVB(16);
var $7f34ba2fa9025258$var$EIGHT = new $5vmVB(8);
var $7f34ba2fa9025258$var$TEN = new $5vmVB(10);
var $7f34ba2fa9025258$var$THREE = new $5vmVB(3);
var $7f34ba2fa9025258$var$SEVEN = new $5vmVB(7);
var $7f34ba2fa9025258$var$ELEVEN = new $5vmVB(11);
var $7f34ba2fa9025258$var$FOUR = new $5vmVB(4);
var $7f34ba2fa9025258$var$TWELVE = new $5vmVB(12);
var $7f34ba2fa9025258$var$primes = null;
function $7f34ba2fa9025258$var$_getPrimes() {
    if ($7f34ba2fa9025258$var$primes !== null) return $7f34ba2fa9025258$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $7f34ba2fa9025258$var$primes = res;
    return res;
}
function $7f34ba2fa9025258$var$simpleSieve(p) {
    var primes = $7f34ba2fa9025258$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $7f34ba2fa9025258$var$fermatTest(p) {
    var red = $5vmVB.mont(p);
    return $7f34ba2fa9025258$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $7f34ba2fa9025258$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $5vmVB([
            0x8c,
            0x7b
        ]);
        else return new $5vmVB([
            0x8c,
            0x27
        ]);
    }
    gen = new $5vmVB(gen);
    var num, n2;
    while(true){
        num = new $5vmVB($hkN9y(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($7f34ba2fa9025258$var$ONE);
        if (!num.testn(1)) num.iadd($7f34ba2fa9025258$var$TWO);
        if (!gen.cmp($7f34ba2fa9025258$var$TWO)) while(num.mod($7f34ba2fa9025258$var$TWENTYFOUR).cmp($7f34ba2fa9025258$var$ELEVEN))num.iadd($7f34ba2fa9025258$var$FOUR);
        else if (!gen.cmp($7f34ba2fa9025258$var$FIVE)) while(num.mod($7f34ba2fa9025258$var$TEN).cmp($7f34ba2fa9025258$var$THREE))num.iadd($7f34ba2fa9025258$var$FOUR);
        n2 = num.shrn(1);
        if ($7f34ba2fa9025258$var$simpleSieve(n2) && $7f34ba2fa9025258$var$simpleSieve(num) && $7f34ba2fa9025258$var$fermatTest(n2) && $7f34ba2fa9025258$var$fermatTest(num) && $7f34ba2fa9025258$var$millerRabin.test(n2) && $7f34ba2fa9025258$var$millerRabin.test(num)) return num;
    }
}


var $f0f71b0d846b32d7$exports = {};
$f0f71b0d846b32d7$exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');


var $8911d62d5514749e$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $8911d62d5514749e$require$Buffer = $6ZWSX.Buffer;

var $5vmVB = parcelRequire("5vmVB");

var $8911d62d5514749e$var$millerRabin = new $bac5f004a90de4c6$exports();
var $8911d62d5514749e$var$TWENTYFOUR = new $5vmVB(24);
var $8911d62d5514749e$var$ELEVEN = new $5vmVB(11);
var $8911d62d5514749e$var$TEN = new $5vmVB(10);
var $8911d62d5514749e$var$THREE = new $5vmVB(3);
var $8911d62d5514749e$var$SEVEN = new $5vmVB(7);


var $hkN9y = parcelRequire("hkN9y");
$8911d62d5514749e$exports = $8911d62d5514749e$var$DH;
function $8911d62d5514749e$var$setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(pub)) pub = new $8911d62d5514749e$require$Buffer(pub, enc);
    this._pub = new $5vmVB(pub);
    return this;
}
function $8911d62d5514749e$var$setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(priv)) priv = new $8911d62d5514749e$require$Buffer(priv, enc);
    this._priv = new $5vmVB(priv);
    return this;
}
var $8911d62d5514749e$var$primeCache = {};
function $8911d62d5514749e$var$checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in $8911d62d5514749e$var$primeCache) return $8911d62d5514749e$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$7f34ba2fa9025258$exports.simpleSieve || !$7f34ba2fa9025258$exports.fermatTest(prime) || !$8911d62d5514749e$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $8911d62d5514749e$var$primeCache[hex] = error;
        return error;
    }
    if (!$8911d62d5514749e$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod($8911d62d5514749e$var$TWENTYFOUR).cmp($8911d62d5514749e$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod($8911d62d5514749e$var$TEN);
            if (rem.cmp($8911d62d5514749e$var$THREE) && rem.cmp($8911d62d5514749e$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $8911d62d5514749e$var$primeCache[hex] = error;
    return error;
}
function $8911d62d5514749e$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $5vmVB(prime);
    this._prime = $5vmVB.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $8911d62d5514749e$var$setPublicKey;
        this.setPrivateKey = $8911d62d5514749e$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($8911d62d5514749e$var$DH.prototype, "verifyError", {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== "number") this._primeCode = $8911d62d5514749e$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$8911d62d5514749e$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $5vmVB($hkN9y(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$8911d62d5514749e$var$DH.prototype.computeSecret = function(other) {
    other = new $5vmVB(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $8911d62d5514749e$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $8911d62d5514749e$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $8911d62d5514749e$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$8911d62d5514749e$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._pub, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._priv, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrime = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this.__prime, enc);
};
$8911d62d5514749e$var$DH.prototype.getGenerator = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._gen, enc);
};
$8911d62d5514749e$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(gen)) gen = new $8911d62d5514749e$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $5vmVB(gen);
    return this;
};
function $8911d62d5514749e$var$formatReturnValue(bn, enc) {
    var buf = new $8911d62d5514749e$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}


function $4387b1fafb8a1868$var$getDiffieHellman(mod) {
    var prime = new $4387b1fafb8a1868$require$Buffer($f0f71b0d846b32d7$exports[mod].prime, "hex");
    var gen = new $4387b1fafb8a1868$require$Buffer($f0f71b0d846b32d7$exports[mod].gen, "hex");
    return new $8911d62d5514749e$exports(prime, gen);
}
var $4387b1fafb8a1868$var$ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function $4387b1fafb8a1868$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($4387b1fafb8a1868$require$Buffer.isBuffer(enc) || $4387b1fafb8a1868$var$ENCODINGS[enc] === undefined) return $4387b1fafb8a1868$var$createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new $4387b1fafb8a1868$require$Buffer([
        2
    ]);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(generator)) generator = new $4387b1fafb8a1868$require$Buffer(generator, genc);
    if (typeof prime === "number") return new $8911d62d5514749e$exports($7f34ba2fa9025258$exports(prime, generator), generator, true);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(prime)) prime = new $4387b1fafb8a1868$require$Buffer(prime, enc);
    return new $8911d62d5514749e$exports(prime, generator, true);
}
$4387b1fafb8a1868$export$971862a2fcb1bb40 = $4387b1fafb8a1868$export$c6ff6a88acbeaf40 = $4387b1fafb8a1868$export$fdc27893e98845cc = $4387b1fafb8a1868$var$getDiffieHellman;
$4387b1fafb8a1868$export$6671fb9a1323bed = $4387b1fafb8a1868$export$d74daf141a551db = $4387b1fafb8a1868$var$createDiffieHellman;


$44edd02a6be448cd$export$971862a2fcb1bb40 = $4387b1fafb8a1868$export$971862a2fcb1bb40;
$44edd02a6be448cd$export$c6ff6a88acbeaf40 = $4387b1fafb8a1868$export$c6ff6a88acbeaf40;
$44edd02a6be448cd$export$fdc27893e98845cc = $4387b1fafb8a1868$export$fdc27893e98845cc;
$44edd02a6be448cd$export$6671fb9a1323bed = $4387b1fafb8a1868$export$6671fb9a1323bed;
$44edd02a6be448cd$export$d74daf141a551db = $4387b1fafb8a1868$export$d74daf141a551db;
var $3550302076d9e62e$exports = {};
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $3550302076d9e62e$require$Buffer = $1U9GM.Buffer;

var $1R2J7 = parcelRequire("1R2J7");

var $b6RFW = parcelRequire("b6RFW");

var $dlqwk = parcelRequire("dlqwk");
var $4d6db7c28d99f640$exports = {};
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $4d6db7c28d99f640$require$Buffer = $1U9GM.Buffer;

var $1iL1D = parcelRequire("1iL1D");

var $3Sg1O = parcelRequire("3Sg1O");

var $1zUcV = parcelRequire("1zUcV");
var $4d6db7c28d99f640$require$EC = $1zUcV.ec;

var $dEXSZ = parcelRequire("dEXSZ");

var $aNeDF = parcelRequire("aNeDF");
var $7fcf61ce5a538063$exports = {};
$7fcf61ce5a538063$exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');


var $4d6db7c28d99f640$var$RSA_PKCS1_PADDING = 1;
function $4d6db7c28d99f640$var$sign(hash, key, hashType, signType, tag) {
    var priv = $aNeDF(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return $4d6db7c28d99f640$var$ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return $4d6db7c28d99f640$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    if (key.padding !== undefined && key.padding !== $4d6db7c28d99f640$var$RSA_PKCS1_PADDING) throw new Error("illegal or unsupported padding mode");
    hash = $4d6db7c28d99f640$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $3Sg1O(pad, priv);
    return out;
}
function $4d6db7c28d99f640$var$ecSign(hash, priv) {
    var curveId = $7fcf61ce5a538063$exports[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new $4d6db7c28d99f640$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $4d6db7c28d99f640$require$Buffer.from(out.toDER());
}
function $4d6db7c28d99f640$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $dEXSZ(0);
    var k;
    var H = $4d6db7c28d99f640$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $4d6db7c28d99f640$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $4d6db7c28d99f640$var$makeKey(q, kv, algo);
        r = $4d6db7c28d99f640$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $dEXSZ(0);
        }
    }
    return $4d6db7c28d99f640$var$toDER(r, s);
}
function $4d6db7c28d99f640$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $4d6db7c28d99f640$require$Buffer.from(res);
}
function $4d6db7c28d99f640$var$getKey(x, q, hash, algo) {
    x = $4d6db7c28d99f640$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - x.length);
        x = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $4d6db7c28d99f640$var$bits2octets(hash, q);
    var v = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $4d6db7c28d99f640$var$bits2int(obits, q) {
    var bits = new $dEXSZ(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $4d6db7c28d99f640$var$bits2octets(bits, q) {
    bits = $4d6db7c28d99f640$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $4d6db7c28d99f640$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - out.length);
        out = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $4d6db7c28d99f640$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $4d6db7c28d99f640$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
            t = $4d6db7c28d99f640$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $4d6db7c28d99f640$var$bits2int(t, q);
        kv.k = $1iL1D(algo, kv.k).update(kv.v).update($4d6db7c28d99f640$require$Buffer.from([
            0
        ])).digest();
        kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $4d6db7c28d99f640$var$makeR(g, k, p, q) {
    return g.toRed($dEXSZ.mont(p)).redPow(k).fromRed().mod(q);
}
$4d6db7c28d99f640$exports = $4d6db7c28d99f640$var$sign;
$4d6db7c28d99f640$exports.getKey = $4d6db7c28d99f640$var$getKey;
$4d6db7c28d99f640$exports.makeKey = $4d6db7c28d99f640$var$makeKey;


var $b885ed4272d45f84$exports = {};
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $b885ed4272d45f84$require$Buffer = $1U9GM.Buffer;

var $dEXSZ = parcelRequire("dEXSZ");

var $1zUcV = parcelRequire("1zUcV");
var $b885ed4272d45f84$require$EC = $1zUcV.ec;

var $aNeDF = parcelRequire("aNeDF");

function $b885ed4272d45f84$var$verify(sig, hash, key, signType, tag) {
    var pub = $aNeDF(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return $b885ed4272d45f84$var$ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return $b885ed4272d45f84$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    hash = $b885ed4272d45f84$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $b885ed4272d45f84$require$Buffer.from(pad);
    var red = $dEXSZ.mont(pub.modulus);
    sig = new $dEXSZ(sig).toRed(red);
    sig = sig.redPow(new $dEXSZ(pub.publicExponent));
    sig = $b885ed4272d45f84$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $b885ed4272d45f84$var$ecVerify(sig, hash, pub) {
    var curveId = $7fcf61ce5a538063$exports[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new $b885ed4272d45f84$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $b885ed4272d45f84$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $aNeDF.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    $b885ed4272d45f84$var$checkValue(s, q);
    $b885ed4272d45f84$var$checkValue(r, q);
    var montp = $dEXSZ.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $dEXSZ(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $b885ed4272d45f84$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= 0) throw new Error("invalid sig");
}
$b885ed4272d45f84$exports = $b885ed4272d45f84$var$verify;



var $6swAi = parcelRequire("6swAi");
Object.keys($6swAi).forEach(function(key) {
    $6swAi[key].id = $3550302076d9e62e$require$Buffer.from($6swAi[key].id, "hex");
    $6swAi[key.toLowerCase()] = $6swAi[key];
});
function $3550302076d9e62e$var$Sign(algorithm) {
    $b6RFW.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Sign, $b6RFW.Writable);
$3550302076d9e62e$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $4d6db7c28d99f640$exports(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $3550302076d9e62e$var$Verify(algorithm) {
    $b6RFW.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Verify, $b6RFW.Writable);
$3550302076d9e62e$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === "string" ? $3550302076d9e62e$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $b885ed4272d45f84$exports(sigBuffer, hash, key, this._signType, this._tag);
};
function $3550302076d9e62e$var$createSign(algorithm) {
    return new $3550302076d9e62e$var$Sign(algorithm);
}
function $3550302076d9e62e$var$createVerify(algorithm) {
    return new $3550302076d9e62e$var$Verify(algorithm);
}
$3550302076d9e62e$exports = {
    Sign: $3550302076d9e62e$var$createSign,
    Verify: $3550302076d9e62e$var$createVerify,
    createSign: $3550302076d9e62e$var$createSign,
    createVerify: $3550302076d9e62e$var$createVerify
};


$44edd02a6be448cd$export$45df7cae684751af = $3550302076d9e62e$exports.createSign;
$44edd02a6be448cd$export$1db683ad541682f6 = $3550302076d9e62e$exports.Sign;
$44edd02a6be448cd$export$6f65485f87568e37 = $3550302076d9e62e$exports.createVerify;
$44edd02a6be448cd$export$91a8e56769aeb334 = $3550302076d9e62e$exports.Verify;

$44edd02a6be448cd$export$2d4117e99c2179e4 = (parcelRequire("fd3gh"));
var $b7e0a6843ffae451$export$512823e338ddb1b7;
var $b7e0a6843ffae451$export$7efb24e2fddf99b9;
var $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3;
var $b7e0a6843ffae451$export$b9d55ff329113abd;

$b7e0a6843ffae451$export$512823e338ddb1b7 = (parcelRequire("98aLY"));

$b7e0a6843ffae451$export$7efb24e2fddf99b9 = (parcelRequire("jU8t7"));
$b7e0a6843ffae451$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $b7e0a6843ffae451$export$512823e338ddb1b7(key, buf, true);
};
$b7e0a6843ffae451$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $b7e0a6843ffae451$export$7efb24e2fddf99b9(key, buf, true);
};


$44edd02a6be448cd$export$512823e338ddb1b7 = $b7e0a6843ffae451$export$512823e338ddb1b7;
$44edd02a6be448cd$export$9d0e0c0c4a8d30f3 = $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3;
$44edd02a6be448cd$export$b9d55ff329113abd = $b7e0a6843ffae451$export$b9d55ff329113abd;
$44edd02a6be448cd$export$7efb24e2fddf99b9 = $b7e0a6843ffae451$export$7efb24e2fddf99b9;
var $8c5943302864e9a5$export$bb1abf2ce84fc7e8;
var $8c5943302864e9a5$export$2f7171e78e524d5e;

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $8c5943302864e9a5$var$oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}

var $1U9GM = parcelRequire("1U9GM");

var $hkN9y = parcelRequire("hkN9y");
var $8c5943302864e9a5$var$Buffer = $1U9GM.Buffer;
var $8c5943302864e9a5$var$kBufferMaxLength = $1U9GM.kMaxLength;
var $8c5943302864e9a5$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $8c5943302864e9a5$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $8c5943302864e9a5$var$assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > $8c5943302864e9a5$var$kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > $8c5943302864e9a5$var$kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function $8c5943302864e9a5$var$assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > $8c5943302864e9a5$var$kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > $8c5943302864e9a5$var$kBufferMaxLength) throw new RangeError("buffer too small");
}
if ($8c5943302864e9a5$var$crypto && $8c5943302864e9a5$var$crypto.getRandomValues || false) {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$randomFill;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$randomFillSync;
} else {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$oldBrowser;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$oldBrowser;
}
function $8c5943302864e9a5$var$randomFill(buf, offset, size, cb) {
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size, cb);
}
function $8c5943302864e9a5$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $8c5943302864e9a5$var$crypto.getRandomValues(uint);
    if (cb) {
        $hPtJY.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $hkN9y(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $hkN9y(size);
    bytes.copy(buf, offset);
    return buf;
}
function $8c5943302864e9a5$var$randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size);
}


$44edd02a6be448cd$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$export$bb1abf2ce84fc7e8;
$44edd02a6be448cd$export$2f7171e78e524d5e = $8c5943302864e9a5$export$2f7171e78e524d5e;
$44edd02a6be448cd$export$e1d879b482f37d98 = function() {
    throw new Error([
        "sorry, createCredentials is not implemented yet",
        "we accept pull requests",
        "https://github.com/crypto-browserify/crypto-browserify"
    ].join("\n"));
};
$44edd02a6be448cd$export$1a988e7317c65621 = {
    "DH_CHECK_P_NOT_SAFE_PRIME": 2,
    "DH_CHECK_P_NOT_PRIME": 1,
    "DH_UNABLE_TO_CHECK_GENERATOR": 4,
    "DH_NOT_SUITABLE_GENERATOR": 8,
    "NPN_ENABLED": 1,
    "ALPN_ENABLED": 1,
    "RSA_PKCS1_PADDING": 1,
    "RSA_SSLV23_PADDING": 2,
    "RSA_NO_PADDING": 3,
    "RSA_PKCS1_OAEP_PADDING": 4,
    "RSA_X931_PADDING": 5,
    "RSA_PKCS1_PSS_PADDING": 6,
    "POINT_CONVERSION_COMPRESSED": 2,
    "POINT_CONVERSION_UNCOMPRESSED": 4,
    "POINT_CONVERSION_HYBRID": 6
};


const $266825253b7f24dc$var$R_INVALID_IRIREF = /([\x00-\x20<>"{}|^`\\]|%(?![0-9A-F][0-9A-F]))/g;
const $266825253b7f24dc$var$F_REPLACE_INVALID_IRIREF = (s_, s_v)=>{
    let s_code = s_v.codePointAt(0).toString(16) + "";
    return s_code.length > 4 ? "\\U" + s_code.padStart(8, "0") : "\\u" + s_code.padStart(4, "0");
};
const $266825253b7f24dc$var$clean_iri = (p_iri_dirty)=>p_iri_dirty.replace($266825253b7f24dc$var$R_INVALID_IRIREF, $266825253b7f24dc$var$F_REPLACE_INVALID_IRIREF);
// eslint-disable-next-line no-misleading-character-class
const $266825253b7f24dc$var$RT_AVOID_PNAME_NS = /^(?:[\u0000-@[-`{-\u00bf\u00d7\u00f7\u0300-\u306f\u037e\u2000-\u200b\u200e-\u206f\u2190-\u2bff\u2ff0-\u3000\ud800-\uf8ff\ufdd0-\ufddf\ufffe\uffff].+|(?:.+?[\u0000-,\/:-@[-^`{-\u00b6\u00b8-\u00bf\u00d7\u00f7\u037e\u2000-\u200b\u200e-\u203e\u2041-\u206f\u2190-\u2bff\u2ff0-\u3000\ud800-\uf8ff\ufdd0-\ufddf\ufffe\uffff].*)|.+\.)$/;
// eslint-disable-next-line no-misleading-character-class
const $266825253b7f24dc$var$RT_AVOID_PNAME_LOCAL = /^(?:\\|[\u0000-\/;-@[-^`{-\u00bf\u00d7\u00f7\u0300-\u306f\u037e\u2000-\u200b\u200e-\u206f\u2190-\u2bff\u2ff0-\u3000\ud800-\uf8ff\ufdd0-\ufddf\ufffe\uffff].+|(?:.+?(?:\\|[\u0000-,\/;-@[-^`{-\u00b6\u00b8-\u00bf\u00d7\u00f7\u037e\u2000-\u200b\u200e-\u203e\u2041-\u206f\u2190-\u2bff\u2ff0-\u3000\ud800-\uf8ff\ufdd0-\ufddf\ufffe\uffff]).+)|(?:.+?(?:\\|[\u0000-,.\/;-@[-^`{-\u00b6\u00b8-\u00bf\u00d7\u00f7\u037e\u2000-\u200b\u200e-\u203e\u2041-\u206f\u2190-\u2bff\u2ff0-\u3000\ud800-\uf8ff\ufdd0-\ufddf\ufffe\uffff])))$/;
const $266825253b7f24dc$var$RT_BOOLEAN_TRUE = /^([Tt](rue)?|TRUE)$/;
const $266825253b7f24dc$var$RT_BOOLEAN_FALSE = /^([Ff](alse)?|FALSE)$/;
const $266825253b7f24dc$var$S_UUID_V4 = "xxxxxxxx_xxxx_4xxx_yxxx_xxxxxxxxxxxx";
const $266825253b7f24dc$var$R_UUID_V4 = /[xy]/g;
const $266825253b7f24dc$var$uuid_v4 = ()=>{
    let dt_now = Date.now();
    if ("undefined" !== typeof performance) dt_now += performance.now();
    return $266825253b7f24dc$var$S_UUID_V4.replace($266825253b7f24dc$var$R_UUID_V4, (s)=>{
        let x_r = (dt_now + Math.random() * 16) % 16 | 0;
        dt_now = Math.floor(dt_now / 16);
        return ("x" === s ? x_r : x_r & 0x3 | 0x8).toString(16);
    });
};
// symbol to access cache on a prefix mapping
const $266825253b7f24dc$var$$_PREFIX_CACHE = Symbol("prefix-cache");
// escape characters for compiling regexes
const $266825253b7f24dc$var$R_REGEX_ESCAPE = /[$^*()+[\\{}|.?]/g;
// valid locals of prefixed names
const $266825253b7f24dc$var$SR_PN_LOCAL = "((?:[A-Za-z\\xc0-\\xd6\\xd8-\\xf6\\xf8-\\u{02ff}\\u{0370}-\\u{037d}\\u{037f}-\\u{1fff}\\u{200c}-\\u{200d}\\u{2070}-\\u{218f}\\u{2c00}-\\u{2fef}\\u{3001}-\\u{d7ff}\\u{f900}-\\u{fdcf}\\u{fdf0}-\\u{fffd}\\u{10000}-\\u{effff}_:0-9]|%[A-Fa-f0-9]{2}|\\\\[_~.\\-!$&'()*+,;=/?#@%])(?:(?:[A-Za-z\\xc0-\\xd6\\xd8-\\xf6\\xf8-\\u{02ff}\\u{0370}-\\u{037d}\\u{037f}-\\u{1fff}\\u{200c}-\\u{200d}\\u{2070}-\\u{218f}\\u{2c00}-\\u{2fef}\\u{3001}-\\u{d7ff}\\u{f900}-\\u{fdcf}\\u{fdf0}-\\u{fffd}\\u{10000}-\\u{effff}_\\-0-9\\xb7\\u{0300}-\\u{036f}\\u{203f}-\\u{2040}.:]|%[A-Fa-f0-9]{2}|\\\\[_~.\\-!$&'()*+,;=/?#@%])*(?:[A-Za-z\\xc0-\\xd6\\xd8-\\xf6\\xf8-\\u{02ff}\\u{0370}-\\u{037d}\\u{037f}-\\u{1fff}\\u{200c}-\\u{200d}\\u{2070}-\\u{218f}\\u{2c00}-\\u{2fef}\\u{3001}-\\u{d7ff}\\u{f900}-\\u{fdcf}\\u{fdf0}-\\u{fffd}\\u{10000}-\\u{effff}_\\-0-9\\xb7\\u{0300}-\\u{036f}\\u{203f}-\\u{2040}:]|%[A-Fa-f0-9]{2}|\\\\[_~.\\-!$&'()*+,;=/?#@%]))?)$";
// create a cache on a prefix mapping
function $266825253b7f24dc$var$cache_prefixes(h_prefixes, b_terse = false) {
    // regex cache string building
    let a_cache = [];
    // inverse mappings
    let h_inverse = {};
    // each prefix/iri pair
    for(let si_prefix in h_prefixes){
        let p_iri = h_prefixes[si_prefix];
        // prefix would make an invalid namespace; skip
        if (b_terse && $266825253b7f24dc$var$RT_AVOID_PNAME_NS.test(si_prefix)) continue;
        // save inverse mapping
        h_inverse[p_iri] = si_prefix;
        // push iri
        a_cache.push(p_iri.replace($266825253b7f24dc$var$R_REGEX_ESCAPE, "\\$&"));
    }
    // no prefixes; forgo cache
    if (!a_cache.length) return h_prefixes;
    // save cache object
    h_prefixes[$266825253b7f24dc$var$$_PREFIX_CACHE] = {
        _r_iris: new RegExp(`^(${a_cache.join("|")})${$266825253b7f24dc$var$SR_PN_LOCAL}`, "u"),
        _h_inverse: h_inverse
    };
    // freeze object
    return Object.freeze(h_prefixes);
}
// attempt to turn an iri into a terse prefixed name
const $266825253b7f24dc$var$terse = (p_iri, h_prefixes)=>{
    // ref cache
    let g_cache = h_prefixes[$266825253b7f24dc$var$$_PREFIX_CACHE];
    // cache exists
    if (g_cache) {
        // iri matching
        let m_iri = g_cache._r_iris.exec(p_iri);
        // prefix mapped; compress
        if (m_iri) return g_cache._h_inverse[m_iri[1]] + ":" + m_iri[2];
    } else {
        // best prefix id
        let si_best_prefix = "";
        let s_best_suffix = "";
        // length of longest matching iri
        let nl_best_prefix_iri = -1;
        // each prefix in hash
        for(let si_prefix in h_prefixes){
            let p_prefix_iri = h_prefixes[si_prefix];
            // target iri starts with prefix iri and its longer than the current best
            if (0 === p_iri.indexOf(p_prefix_iri) && p_prefix_iri.length > nl_best_prefix_iri && !$266825253b7f24dc$var$RT_AVOID_PNAME_NS.test(si_prefix)) {
                // compute suffix
                let s_suffix = p_iri.slice(p_prefix_iri.length);
                // suffix is okay to use
                if (!$266825253b7f24dc$var$RT_AVOID_PNAME_LOCAL.test(s_suffix)) {
                    s_best_suffix = s_suffix;
                    // save prefix id as best
                    si_best_prefix = si_prefix;
                    // update best iri length
                    nl_best_prefix_iri = p_prefix_iri.length;
                }
            }
        }
        // found a prefix
        if (-1 !== nl_best_prefix_iri) // use terse prefixed name
        return si_best_prefix + ":" + s_best_suffix;
    }
    // fallback
    return "<" + p_iri + ">";
};
// attempt to turn an iri into a concise prefixed name
const $266825253b7f24dc$var$concise = (p_iri, h_prefixes = {})=>{
    // ref cache
    let g_cache = h_prefixes[$266825253b7f24dc$var$$_PREFIX_CACHE];
    // cache exists
    if (g_cache) {
        // iri matching
        let m_iri = g_cache._r_iris.exec(p_iri);
        // prefix mapped; compress
        if (m_iri) return g_cache._h_inverse[m_iri[1]] + ":" + m_iri[2];
    } else {
        // best prefix id
        let s_best_prefix_id = "";
        // length of longest matching iri
        let nl_best_prefix_iri = -1;
        // each prefix in hash
        for(let s_prefix_id in h_prefixes){
            let p_prefix_iri = h_prefixes[s_prefix_id];
            // target iri starts with prefix iri and its longer than the current best
            if (p_iri.startsWith(p_prefix_iri) && p_prefix_iri.length > nl_best_prefix_iri) {
                // save prefix id as best
                s_best_prefix_id = s_prefix_id;
                // update best iri length
                nl_best_prefix_iri = p_prefix_iri.length;
            }
        }
        // found a prefix
        if (-1 !== nl_best_prefix_iri) return s_best_prefix_id + ":" + p_iri.slice(nl_best_prefix_iri);
    }
    // no prefix found; default to full iri
    return ">" + p_iri;
};
const $266825253b7f24dc$var$R_C1N_DECONSTRUCT = /^([^:]*):(.*)$/;
function $266825253b7f24dc$var$c1_to_nt(sc1_in, h_prefixes = {}, b_verbose = false) {
    switch(sc1_in[0]){
        // absolute iri
        case ">":
            return "<" + sc1_in.slice(1) + ">";
        // blank node
        case "_":
            // ephemeral hint
            if (sc1_in.length <= 2 || "#" === sc1_in[2]) return new $266825253b7f24dc$var$EphemeralBlankNode()[b_verbose ? "verbose" : "terse"]();
            else return sc1_in;
        // simple literal
        case '"':
            return JSON.stringify(sc1_in.slice(1));
        // languaged literal
        case "@":
            {
                let i_contents = sc1_in.indexOf('"');
                return JSON.stringify(sc1_in.slice(i_contents + 1)) + sc1_in.slice(0, i_contents);
            }
        // datatyped literal
        case "^":
            {
                let i_contents = sc1_in.indexOf('"');
                return JSON.stringify(sc1_in.slice(i_contents + 1)) + "^^" + $266825253b7f24dc$var$c1_to_nt(sc1_in.slice(1, i_contents), h_prefixes, b_verbose);
            }
        // default graph
        case "*":
            return "";
        // directive / node explicit
        case "<":
        case "`":
            return $266825253b7f24dc$var$factory.c1(sc1_in).terse(h_prefixes);
        // otherwise
        default:
            {
                // rdf:type alis
                if ("a" === sc1_in) return b_verbose ? "<http://www.w3.org/1999/02/22-rdf-syntax-ns#type>" : "a";
                // deconstruct prefixed name
                let [, si_prefix, s_suffix] = $266825253b7f24dc$var$R_C1N_DECONSTRUCT.exec(sc1_in);
                // avoid illegal prefixed name parts
                if (b_verbose || $266825253b7f24dc$var$RT_AVOID_PNAME_LOCAL.test(s_suffix) || $266825253b7f24dc$var$RT_AVOID_PNAME_NS.test(si_prefix)) return "<" + h_prefixes[si_prefix] + s_suffix + ">";
                // good as-is
                return sc1_in;
            }
    }
}
class $266825253b7f24dc$var$GenericTerm {
    valueOf() {
        return this.concise();
    }
    toString() {
        return this.concise();
    }
    equals(z_other) {
        return z_other ? this === z_other || z_other.termType === this.termType && z_other.value === this.value : false;
    }
}
Object.assign($266825253b7f24dc$var$GenericTerm.prototype, {
    isGraphyTerm: true
});
class $266825253b7f24dc$var$NamedNode extends $266825253b7f24dc$var$GenericTerm {
    constructor(s_iri){
        super();
        this.value = s_iri;
    }
    concise(h_prefixes = {}) {
        return $266825253b7f24dc$var$concise(this.value, h_prefixes);
    }
    terse(h_prefixes = {}, b_opt = false) {
        return $266825253b7f24dc$var$terse($266825253b7f24dc$var$clean_iri(this.value), h_prefixes, b_opt);
    }
    verbose() {
        return "<" + $266825253b7f24dc$var$clean_iri(this.value) + ">";
    }
    isolate() {
        return {
            termType: "NamedNode",
            value: this.value
        };
    }
}
Object.assign($266825253b7f24dc$var$NamedNode.prototype, {
    termType: "NamedNode",
    isNamedNode: true
});
const $266825253b7f24dc$var$KT_RDF_TYPE = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type");
$266825253b7f24dc$var$KT_RDF_TYPE.isRdfTypeAlias = true; // for serialization
const $266825253b7f24dc$var$KT_RDF_LANG_STRING = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#langString");
const $266825253b7f24dc$var$G_ISOLATE_RDF_LANG_STRING = $266825253b7f24dc$var$KT_RDF_LANG_STRING.isolate();
const $266825253b7f24dc$var$KT_RDF_FIRST = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#first");
const $266825253b7f24dc$var$KT_RDF_REST = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#rest");
const $266825253b7f24dc$var$KT_RDF_NIL = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#nil");
const $266825253b7f24dc$var$KT_XSD_DATE = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/2001/XMLSchema#date");
const $266825253b7f24dc$var$KT_XSD_DATETIME = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/2001/XMLSchema#dateTime");
const $266825253b7f24dc$var$KT_XSD_STRING = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/2001/XMLSchema#string");
class $266825253b7f24dc$var$GenericLiteral extends $266825253b7f24dc$var$GenericTerm {
    equals(z_other) {
        return z_other ? this === z_other || "Literal" === z_other.termType && z_other.value === this.value && this.datatype.equals(z_other.datatype) && z_other.language === this.language : false;
    }
    verbose() {
        return JSON.stringify(this.value) + (this.language ? "@" + this.language : "^^" + this.datatype.verbose());
    }
    concise(h_prefixes) {
        if (this.language) return "@" + this.language + '"' + this.value;
        else return "^" + $266825253b7f24dc$var$concise(this.datatype.value, h_prefixes) + '"' + this.value;
    }
    terse(h_prefixes = {}) {
        // turn into terse
        let st_datatype = this.datatype.terse(h_prefixes);
        // stringify literal
        return JSON.stringify(this.value) + (this.language ? "@" + this.language : "^^" + st_datatype);
    }
    isolate() {
        return {
            termType: "Literal",
            value: this.value,
            language: this.language,
            datatype: this.datatype.isolate()
        };
    }
}
Object.assign($266825253b7f24dc$var$GenericLiteral.prototype, {
    datatype: $266825253b7f24dc$var$KT_XSD_STRING,
    language: "",
    termType: "Literal",
    isLiteral: true,
    isSimple: false
});
class $266825253b7f24dc$var$LanguagedLiteral extends $266825253b7f24dc$var$GenericLiteral {
    constructor(s_value, s_lang){
        super();
        this.value = s_value;
        // remove optional '@' character from beginning
        this.language = ("@" === s_lang[0] ? s_lang.slice(1) : s_lang).toLowerCase();
    }
    verbose() {
        return JSON.stringify(this.value) + "@" + this.language;
    }
    concise() {
        return "@" + this.language + '"' + this.value;
    }
    terse() {
        // stringify literal
        return JSON.stringify(this.value) + "@" + this.language;
    }
    isolate() {
        return {
            termType: "Literal",
            value: this.value,
            language: this.language,
            datatype: $266825253b7f24dc$var$G_ISOLATE_RDF_LANG_STRING
        };
    }
}
Object.assign($266825253b7f24dc$var$LanguagedLiteral.prototype, {
    datatype: $266825253b7f24dc$var$KT_RDF_LANG_STRING,
    isLanguaged: true
});
class $266825253b7f24dc$var$DatatypedLiteral extends $266825253b7f24dc$var$GenericLiteral {
    verbose() {
        return JSON.stringify(this.value) + "^^" + this.datatype.verbose();
    }
    concise(h_prefixes) {
        return "^" + $266825253b7f24dc$var$concise(this.datatype.value, h_prefixes) + '"' + this.value;
    }
    terse(h_prefixes = {}) {
        // turn into terse
        let st_datatype = this.datatype.terse(h_prefixes);
        // stringify literal
        return JSON.stringify(this.value) + "^^" + st_datatype;
    }
    isolate() {
        return {
            termType: "Literal",
            value: this.value,
            language: this.language,
            datatype: this.datatype.isolate()
        };
    }
}
Object.assign($266825253b7f24dc$var$DatatypedLiteral.prototype, {
    isDatatyped: true
});
class $266825253b7f24dc$var$ExplicitlyDatatypedLiteral extends $266825253b7f24dc$var$DatatypedLiteral {
    constructor(s_value, kt_datatype){
        super();
        this.value = s_value;
        this.datatype = kt_datatype;
    }
}
class $266825253b7f24dc$var$RawLiteral extends $266825253b7f24dc$var$GenericTerm {
    constructor(s_value){
        super();
        this.value = s_value;
    }
    get isSimple() {
        return !this.language && !this.datatype.equals($266825253b7f24dc$var$KT_XSD_STRING);
    }
    get isLanguaged() {
        return !!this.language;
    }
    get isDatatyped() {
        return $266825253b7f24dc$var$KT_XSD_STRING.equals(this.datatype);
    }
    equals(z_other) {
        return z_other ? this === z_other || "Literal" === z_other.termType && z_other.value === this.value && this.datatype.equals(z_other.datatype) && z_other.language === this.language : false;
    }
    verbose() {
        return JSON.stringify(this.value) + (this.language ? "@" + this.language : "^^" + this.datatype.verbose());
    }
    concise(h_prefixes) {
        if (this.language) return "@" + this.language + '"' + this.value;
        else return "^" + $266825253b7f24dc$var$concise(this.datatype.value, h_prefixes) + '"' + this.value;
    }
    terse(h_prefixes = {}) {
        // turn into terse
        let st_datatype = this.datatype.terse(h_prefixes);
        // stringify literal
        return JSON.stringify(this.value) + (this.language ? "@" + this.language : "^^" + st_datatype);
    }
    isolate() {
        return {
            termType: "Literal",
            value: this.value,
            language: this.language,
            datatype: this.datatype.isolate()
        };
    }
}
Object.assign($266825253b7f24dc$var$RawLiteral.prototype, {
    datatype: $266825253b7f24dc$var$KT_XSD_STRING,
    language: "",
    termType: "Literal",
    isLiteral: true
});
class $266825253b7f24dc$var$SimpleLiteral extends $266825253b7f24dc$var$GenericLiteral {
    constructor(s_value){
        super();
        this.value = s_value;
    }
    verbose() {
        return JSON.stringify(this.value);
    }
    concise() {
        return '"' + this.value;
    }
    terse() {
        return JSON.stringify(this.value);
    }
}
Object.assign($266825253b7f24dc$var$SimpleLiteral.prototype, {
    isSimple: true
});
const $266825253b7f24dc$var$KT_XSD_INTEGER = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/2001/XMLSchema#integer");
class $266825253b7f24dc$var$Literal_Integer extends $266825253b7f24dc$var$DatatypedLiteral {
    static from(s_literal) {
        let kt = new $266825253b7f24dc$var$Literal_Integer(+s_literal);
        kt.value = s_literal;
        return kt;
    }
    constructor(x_value){
        super();
        this.value = x_value + "";
        this.number = x_value;
    }
    concise(h_prefixes = {}) {
        return "^" + $266825253b7f24dc$var$KT_XSD_INTEGER.concise(h_prefixes) + '"' + this.value;
    }
    terse() {
        return this.value.includes("e") ? `"${this.value}"^^<http://www.w3.org/2001/XMLSchema#integer>` : this.value;
    }
}
Object.assign($266825253b7f24dc$var$Literal_Integer.prototype, {
    datatype: $266825253b7f24dc$var$KT_XSD_INTEGER,
    isNumeric: true,
    isInteger: true
});
const $266825253b7f24dc$var$KT_XSD_DOUBLE = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/2001/XMLSchema#double");
class $266825253b7f24dc$var$Literal_Double extends $266825253b7f24dc$var$DatatypedLiteral {
    static from(s_literal) {
        let kt = new $266825253b7f24dc$var$Literal_Double(+s_literal);
        kt.value = s_literal;
        return kt;
    }
    constructor(x_value){
        super();
        this.value = x_value + "";
        this.number = x_value;
    }
    concise(h_prefixes = {}) {
        return "^" + $266825253b7f24dc$var$KT_XSD_DOUBLE.concise(h_prefixes) + '"' + this.value;
    }
    terse() {
        return this.number.toExponential();
    }
}
Object.assign($266825253b7f24dc$var$Literal_Double.prototype, {
    datatype: $266825253b7f24dc$var$KT_XSD_DOUBLE,
    isNumeric: true,
    isDouble: true
});
const $266825253b7f24dc$var$KT_XSD_DECIMAL = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/2001/XMLSchema#decimal");
class $266825253b7f24dc$var$Literal_Decimal extends $266825253b7f24dc$var$DatatypedLiteral {
    static from(s_literal) {
        let kt = new $266825253b7f24dc$var$Literal_Decimal(+s_literal);
        kt.value = s_literal;
        return kt;
    }
    constructor(x_value){
        super();
        this.value = x_value + "";
        this.number = x_value;
    }
    concise(h_prefixes = {}) {
        return "^" + $266825253b7f24dc$var$KT_XSD_DECIMAL.concise(h_prefixes) + '"' + this.value;
    }
    terse() {
        return this.value.includes("e") ? `"${this.value}"^^<http://www.w3.org/2001/XMLSchema#decimal>` : this.value + (this.value.includes(".") ? "" : ".0");
    }
}
Object.assign($266825253b7f24dc$var$Literal_Decimal.prototype, {
    datatype: $266825253b7f24dc$var$KT_XSD_DECIMAL,
    isNumeric: true,
    isDecimal: true
});
const $266825253b7f24dc$var$KT_XSD_BOOLEAN = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/2001/XMLSchema#boolean");
class $266825253b7f24dc$var$Literal_Boolean extends $266825253b7f24dc$var$DatatypedLiteral {
    static from(s_literal) {
        let kt = new $266825253b7f24dc$var$Literal_Boolean(+s_literal);
        kt.value = s_literal;
        return kt;
    }
    constructor(b_value){
        super();
        this.value = b_value + "";
        this.boolean = b_value;
    }
    concise(h_prefixes = {}) {
        return "^" + $266825253b7f24dc$var$KT_XSD_BOOLEAN.concise(h_prefixes) + '"' + this.value;
    }
    terse() {
        return this.value + "";
    }
}
Object.assign($266825253b7f24dc$var$Literal_Boolean.prototype, {
    datatype: $266825253b7f24dc$var$KT_XSD_BOOLEAN,
    isBoolean: true
});
class $266825253b7f24dc$var$Literal_PositiveInfinity extends $266825253b7f24dc$var$Literal_Double {
    constructor(){
        super(Infinity);
        this.value = "INF";
    }
    terse(h_prefixes) {
        return '"INF"^^' + $266825253b7f24dc$var$KT_XSD_DOUBLE.terse(h_prefixes);
    }
}
Object.assign($266825253b7f24dc$var$Literal_PositiveInfinity.prototype, {
    isInfinite: true
});
class $266825253b7f24dc$var$Literal_NegativeInfinity extends $266825253b7f24dc$var$Literal_Double {
    constructor(){
        super(-Infinity);
        this.value = "-INF";
    }
    terse(h_prefixes) {
        return '"-INF"^^' + $266825253b7f24dc$var$KT_XSD_DOUBLE.terse(h_prefixes);
    }
}
Object.assign($266825253b7f24dc$var$Literal_NegativeInfinity.prototype, {
    isInfinite: true
});
class $266825253b7f24dc$var$Literal_NaN extends $266825253b7f24dc$var$Literal_Double {
    constructor(){
        super(NaN);
        this.value = "NaN";
    }
    terse(h_prefixes) {
        return '"NaN"^^' + $266825253b7f24dc$var$KT_XSD_DOUBLE.terse(h_prefixes);
    }
}
Object.assign($266825253b7f24dc$var$Literal_NaN.prototype, {
    isNaN: true
});
function $266825253b7f24dc$var$BlankNode(s_value, b_anonymous = false) {
    this.value = s_value;
    this.isAnonymous = b_anonymous;
}
$266825253b7f24dc$var$BlankNode.prototype = Object.assign(Object.create($266825253b7f24dc$var$GenericTerm.prototype), {
    termType: "BlankNode",
    isBlankNode: true,
    concise () {
        return "_:" + this.value;
    },
    terse () {
        return "_:" + this.value;
    },
    verbose () {
        return "_:" + this.value;
    },
    isolate () {
        return {
            termType: "BlankNode",
            value: this.value
        };
    }
});
function $266825253b7f24dc$var$EphemeralBlankNode() {}
$266825253b7f24dc$var$EphemeralBlankNode.prototype = Object.assign(Object.create($266825253b7f24dc$var$BlankNode.prototype), {
    isAnonymous: true,
    isEphemeral: true,
    concise () {
        return "_:#" + this.value;
    },
    terse () {
        return "[]";
    },
    verbose () {
        return "_:" + this.value;
    },
    isolate () {
        return {
            termType: "BlankNode",
            value: this.value
        };
    },
    equals () {
        return false;
    }
});
Object.defineProperty($266825253b7f24dc$var$EphemeralBlankNode.prototype, "value", {
    get () {
        return "_" + $266825253b7f24dc$var$uuid_v4();
    }
});
class $266825253b7f24dc$var$Variable extends $266825253b7f24dc$var$GenericTerm {
    constructor(s_label){
        super();
        this.value = s_label;
    }
    concise() {
        return "?" + this.value;
    }
    terse() {
        throw new Error(`Cannot call .terse() on 'Variable' term type`);
    }
    verbose() {
        throw new Error(`Cannot call .verbose() on 'Variable' term type`);
    }
    isolate() {
        return {
            termType: "Variable",
            value: this.value
        };
    }
}
Object.assign($266825253b7f24dc$var$Variable.prototype, {
    termType: "Variable",
    isVariable: true
});
function $266825253b7f24dc$var$DefaultGraph() {}
$266825253b7f24dc$var$DefaultGraph.prototype = Object.assign(Object.create($266825253b7f24dc$var$GenericTerm.prototype), {
    value: "",
    termType: "DefaultGraph",
    isDefaultGraph: true,
    concise () {
        return "*";
    },
    terse () {
        return "";
    },
    verbose () {
        return "";
    },
    isolate () {
        return {
            termType: "DefaultGraph",
            value: ""
        };
    }
});
function $266825253b7f24dc$var$NoGraph() {}
$266825253b7f24dc$var$NoGraph.prototype = Object.assign(Object.create($266825253b7f24dc$var$GenericTerm.prototype), {
    value: "",
    termType: "NoGraph",
    concise () {
        return "";
    },
    terse () {
        return "";
    },
    verbose () {
        return "";
    },
    isolate () {
        return {
            termType: "NoGraph",
            value: ""
        };
    }
});
const $266825253b7f24dc$var$KT_DEFAULT_GRAPH = new $266825253b7f24dc$var$DefaultGraph();
function $266825253b7f24dc$var$Quad(h_subject, h_predicate, h_object, h_graph = $266825253b7f24dc$var$KT_DEFAULT_GRAPH) {
    this.subject = h_subject;
    this.predicate = h_predicate;
    this.object = h_object;
    this.graph = h_graph;
}
Object.assign($266825253b7f24dc$var$Quad.prototype, {
    isGraphyQuad: true,
    equals (z_other) {
        return z_other ? this === z_other || this.object.equals(z_other.object) && this.subject.equals(z_other.subject) && this.predicate.equals(z_other.predicate) && this.graph.equals(z_other.graph) : false;
    },
    valueOf () {
        return this.verbose();
    },
    concise (h_prefixes = {}) {
        return [
            this.subject.concise(h_prefixes),
            this.predicate.concise(h_prefixes),
            this.object.concise(h_prefixes),
            this.graph.concise(h_prefixes)
        ];
    },
    terse (h_prefixes) {
        let b_default_graph = this.graph.isDefaultGraph;
        return (b_default_graph ? "" : this.graph.terse(h_prefixes) + " { ") + this.subject.terse(h_prefixes) + " " + this.predicate.terse(h_prefixes) + " " + this.object.terse(h_prefixes) + " ." + (b_default_graph ? "" : " }");
    },
    verbose () {
        return this.subject.verbose() + " " + this.predicate.verbose() + " " + this.object.verbose() + " " + (this.graph.isDefaultGraph ? "" : this.graph.verbose() + " ") + ".";
    },
    isolate () {
        return {
            subject: this.subject.isolate(),
            predicate: this.predicate.isolate(),
            object: this.object.isolate(),
            graph: this.graph.isolate()
        };
    }
});
let $266825253b7f24dc$var$g_raw = {
    namedNode (p_iri) {
        return new $266825253b7f24dc$var$NamedNode(p_iri);
    },
    blankNode (s_label, b_anonymous) {
        return new $266825253b7f24dc$var$BlankNode(s_label, b_anonymous);
    },
    literal (s_value) {
        return new $266825253b7f24dc$var$RawLiteral(s_value);
    },
    defaultGraph () {
        return new $266825253b7f24dc$var$DefaultGraph();
    },
    quad (kt_subject, kt_predicate, kt_object, kt_graph) {
        return new $266825253b7f24dc$var$Quad(kt_subject, kt_predicate, kt_object, kt_graph || $266825253b7f24dc$var$KT_DEFAULT_GRAPH);
    },
    integer (w) {
        return $266825253b7f24dc$var$Literal_Integer.from(w);
    },
    double (w) {
        return $266825253b7f24dc$var$Literal_Double.from(w);
    },
    decimal (w) {
        return $266825253b7f24dc$var$Literal_Decimal.from(w);
    },
    boolean (w) {
        return new $266825253b7f24dc$var$Literal_Boolean(w);
    }
};
const $266825253b7f24dc$var$factory = $266825253b7f24dc$exports = {
    concise: $266825253b7f24dc$var$concise,
    adopt (dc_factory) {
        let dc_extend = Object.create(dc_factory);
        let b_use_extend = false;
        if ("function" !== typeof dc_factory.boolean) {
            let kt_xsd_boolean = dc_factory.namedNode("http://www.w3.org/2001/XMLSchema#boolean");
            dc_extend.boolean = (b_value)=>dc_factory.literal(b_value + "", kt_xsd_boolean);
            b_use_extend = true;
        }
        if ("function" !== typeof dc_factory.double) {
            let kt_xsd_double = dc_factory.namedNode("http://www.w3.org/2001/XMLSchema#double");
            dc_extend.double = (s_value)=>dc_factory.literal(s_value + "", kt_xsd_double);
            b_use_extend = true;
        }
        if ("function" !== typeof dc_factory.decimal) {
            let kt_xsd_decimal = dc_factory.namedNode("http://www.w3.org/2001/XMLSchema#decimal");
            dc_extend.decimal = (s_value)=>dc_factory.literal(s_value + "", kt_xsd_decimal);
            b_use_extend = true;
        }
        if ("function" !== typeof dc_factory.integer) {
            let kt_xsd_integer = dc_factory.namedNode("http://www.w3.org/2001/XMLSchema#integer");
            dc_extend.integer = (s_value)=>dc_factory.literal(s_value + "", kt_xsd_integer);
            b_use_extend = true;
        }
        if ("function" !== typeof dc_factory.simpleLiteral) {
            dc_extend.simpleLiteral = (s_value)=>dc_factory.literal(s_value);
            b_use_extend = true;
        }
        if ("function" !== typeof dc_factory.languagedLiteral) {
            dc_extend.languagedLiteral = (s_value, s_lang)=>dc_factory.literal(s_value, s_lang);
            b_use_extend = true;
        }
        if ("function" !== typeof dc_factory.datatypedLiteral) {
            dc_extend.datatypedLiteral = (s_value, kt_datatype)=>dc_factory.literal(s_value, kt_datatype);
            b_use_extend = true;
        }
        if (b_use_extend) return dc_extend;
        else return dc_factory;
    },
    raw: $266825253b7f24dc$var$g_raw,
    unfiltered: {
        ...$266825253b7f24dc$var$g_raw,
        literal (s_value, z_datatype_or_lang) {
            if (!z_datatype_or_lang || $266825253b7f24dc$var$KT_XSD_STRING.equals(z_datatype_or_lang)) return new $266825253b7f24dc$var$SimpleLiteral(s_value);
            else if ("string" === typeof z_datatype_or_lang) return new $266825253b7f24dc$var$LanguagedLiteral(s_value, z_datatype_or_lang);
            else if ($266825253b7f24dc$var$KT_XSD_STRING.equals(z_datatype_or_lang)) return new $266825253b7f24dc$var$SimpleLiteral(s_value);
            else return new $266825253b7f24dc$var$ExplicitlyDatatypedLiteral(s_value, z_datatype_or_lang);
        },
        simpleLiteral (s_value) {
            return new $266825253b7f24dc$var$SimpleLiteral(s_value);
        },
        languagedLiteral (s_value, s_language) {
            return new $266825253b7f24dc$var$LanguagedLiteral(s_value, s_language);
        },
        datatypedLiteral (s_value, kt_datatype) {
            if ($266825253b7f24dc$var$KT_XSD_STRING.equals(kt_datatype)) return new $266825253b7f24dc$var$SimpleLiteral(s_value);
            else return new $266825253b7f24dc$var$ExplicitlyDatatypedLiteral(s_value, kt_datatype);
        }
    },
    number (x) {
        // not finite or not a number
        if ("number" === typeof x && (!Number.isFinite(x) || Number.isNaN(x))) return $266825253b7f24dc$var$factory.double(x);
        else if (Number.isInteger(x) || "bigint" === typeof x) return $266825253b7f24dc$var$factory.integer(x);
        else return $266825253b7f24dc$var$factory.decimal(x);
    },
    date (dt) {
        return $266825253b7f24dc$var$factory.literal(dt.toISOString().replace(/T.+$/, "Z"), $266825253b7f24dc$var$KT_XSD_DATE);
    },
    dateTime (dt) {
        return $266825253b7f24dc$var$factory.literal(dt.toISOString(), $266825253b7f24dc$var$KT_XSD_DATETIME);
    },
    namedNode (p_iri) {
        return new $266825253b7f24dc$var$NamedNode(p_iri);
    },
    ephemeral () {
        return new $266825253b7f24dc$var$EphemeralBlankNode();
    },
    // @deprecated
    anonymous () {
        return new $266825253b7f24dc$var$EphemeralBlankNode();
    },
    blankNode (z_label) {
        // no label given, generate a UUID
        if (!z_label) // eslint-disable-next-line no-undef
        return new $266825253b7f24dc$var$BlankNode("_" + $266825253b7f24dc$var$uuid_v4(), true);
        else if ("string" === typeof z_label) return new $266825253b7f24dc$var$BlankNode(z_label);
        throw new TypeError(`factory.blankNode(label) expects 'label' parameter to be falsy or a string; instead found: ${z_label}`);
    },
    literal (s_value, z_datatype_or_lang) {
        if (!z_datatype_or_lang || $266825253b7f24dc$var$KT_XSD_STRING.equals(z_datatype_or_lang)) return new $266825253b7f24dc$var$SimpleLiteral(s_value);
        else if ("string" === typeof z_datatype_or_lang) return new $266825253b7f24dc$var$LanguagedLiteral(s_value, z_datatype_or_lang);
        else return new $266825253b7f24dc$var$ExplicitlyDatatypedLiteral(s_value, z_datatype_or_lang);
    },
    integer (w_value) {
        let s_type = typeof w_value;
        // a number was given
        if ("number" === s_type) {
            // not a finite number
            if (!Number.isFinite(w_value)) {
                // NaN
                if (Number.isNaN(w_value)) throw new Error("XSD integer cannot encode NaN. Try using double");
                throw new Error("XSD integer cannot encode +/-infinity. Try using double");
            } else if (!Number.isInteger(w_value)) throw new Error("Number is not an integer: " + w_value);
            return new $266825253b7f24dc$var$Literal_Integer(w_value);
        } else if ("string" === s_type) {
            // empty string
            if ("" === w_value) throw new Error("Refusing to serialize empty string as xsd:integer");
            // parse to number
            let x_value = +w_value;
            // failed to parse or not an integer
            if (Number.isNaN(x_value) || !Number.isInteger(x_value)) throw new Error("Invalid integer string: " + w_value);
            return new $266825253b7f24dc$var$Literal_Integer(x_value);
        } else if ("undefined" === s_type) throw new Error("Refusing to serialize undefined value as xsd:integer");
        else {
            // null
            if (null === w_value) throw new Error("Refusing to serialize null value as xsd:integer");
            // invalid
            throw new Error("XSD integer expects a number type or integer string");
        }
    },
    double (w_value) {
        let s_type = typeof w_value;
        // a number was given
        if ("number" === s_type) {
            // not a finite number
            if (!Number.isFinite(w_value)) {
                // NaN
                if (Number.isNaN(w_value)) return new $266825253b7f24dc$var$Literal_NaN();
                return w_value > 0 ? new $266825253b7f24dc$var$Literal_PositiveInfinity() : new $266825253b7f24dc$var$Literal_NegativeInfinity();
            }
            return new $266825253b7f24dc$var$Literal_Double(w_value);
        } else if ("string" === s_type) {
            // empty string
            if ("" === w_value) throw new Error("Refusing to serialize empty string as xsd:double");
            // parse to number
            let x_value = +w_value;
            // failed to parse
            if (Number.isNaN(x_value)) throw new Error("Invalid decimal string: " + w_value);
            return new $266825253b7f24dc$var$Literal_Double(x_value);
        } else if ("undefined" === s_type) throw new Error("Refusing to serialize undefined value as xsd:double");
        else {
            // null
            if (null === w_value) throw new Error("Refusing to serialize null value as xsd:double");
            // invalid
            throw new Error("XSD double expects a number type or double string");
        }
    },
    decimal (w_value) {
        let s_type = typeof w_value;
        // a number was given
        if ("number" === s_type) {
            // not a finite number
            if (!Number.isFinite(w_value)) {
                // NaN
                if (Number.isNaN(w_value)) throw new Error("XSD decimal cannot encode NaN. Try using double");
                throw new Error("XSD decimal cannot encode +/-infinity. Try using double");
            }
            return new $266825253b7f24dc$var$Literal_Decimal(w_value);
        } else if ("string" === s_type) {
            // empty string
            if ("" === w_value) throw new Error("Refusing to serialize empty string as xsd:decimal");
            // parse to number
            let x_value = +w_value;
            // failed to parse
            if (Number.isNaN(x_value)) throw new Error("Invalid decimal string: " + w_value);
            return new $266825253b7f24dc$var$Literal_Decimal(x_value);
        } else if ("undefined" === s_type) throw new Error("Refusing to serialize undefined value as xsd:decimal");
        else {
            // null
            if (null === w_value) throw new Error("Refusing to serialize null value as xsd:decimal");
            // invalid
            throw new Error("XSD decimal expects a number type or decimal string");
        }
    },
    boolean (w_value) {
        let s_type = typeof w_value;
        // boolean
        if ("boolean" === s_type) return new $266825253b7f24dc$var$Literal_Boolean(w_value);
        else if ("number" === s_type) {
            // 1
            if (1 === w_value) return new $266825253b7f24dc$var$Literal_Boolean(true);
            else if (0 === w_value) return new $266825253b7f24dc$var$Literal_Boolean(false);
            // invalid
            throw new Error(`Boolean value 'w_value' must be either a '1' or '0' if using numbers`);
        } else if ("string" === s_type) {
            // truthy value
            if ($266825253b7f24dc$var$RT_BOOLEAN_TRUE.test(w_value)) return new $266825253b7f24dc$var$Literal_Boolean(true);
            else if ($266825253b7f24dc$var$RT_BOOLEAN_FALSE.test(w_value)) return new $266825253b7f24dc$var$Literal_Boolean(false);
            // empty string
            if ("" === w_value) throw new Error("Refusing to serialize empty string as xsd:boolean");
            // failed to parse
            throw new Error("Invalid boolean string: " + w_value);
        } else if ("undefined" === s_type) throw new Error("Refusing to serialize undefined value as xsd:boolean");
        else {
            // null
            if (null === w_value) throw new Error("Refusing to serialize null value as xsd:boolean");
            // invalid
            throw new Error("XSD boolean expects a boolean type or boolean string");
        }
    },
    defaultGraph () {
        return new $266825253b7f24dc$var$DefaultGraph();
    },
    variable (s_label) {
        return new $266825253b7f24dc$var$Variable(s_label);
    },
    // warn
    triple (h_subject, h_predicate, h_object) {
        let e_stack = new Error("It is strongly encouraged to use .quad() instead of .triple()");
        console.warn(e_stack.stack.replace(/^(\s*)Error:/, "$1Warning:"));
        return new $266825253b7f24dc$var$Quad(h_subject, h_predicate, h_object);
    },
    quad (h_subject, h_predicate, h_object, h_graph) {
        return new $266825253b7f24dc$var$Quad(h_subject, h_predicate, h_object, h_graph || $266825253b7f24dc$var$KT_DEFAULT_GRAPH);
    },
    term (z_term, w_prefixes) {
        // concise term
        if ("string" === typeof z_term) return $266825253b7f24dc$var$factory.c1(z_term, w_prefixes);
        else return $266825253b7f24dc$var$factory.from.rdfjs_term(z_term);
    },
    /**
	 * construct a term object from a concise term string
	 * @param  {c1_string} sc1_term - a representation of the term object to create
	 * @param  {Object} h_prefixes - mappings for prefixes
	 * @return {Term} - an RDFJS-compatible term object
	 */ c1 (sc1_term, h_prefixes = {}) {
        // deduce term type
        switch(sc1_term[0]){
            // datatyped literal
            case "^":
                {
                    // find literal's contents delimiter
                    let i_contents = sc1_term.indexOf('"');
                    // no delimiter
                    if (-1 === i_contents) throw new Error(`Invalid concise-term string, no content literal delimiter found: '${sc1_term}'`);
                    // extract datatype
                    let s_datatype = sc1_term.slice(1, i_contents);
                    // make term
                    return $266825253b7f24dc$var$factory.literal(sc1_term.slice(i_contents + 1), $266825253b7f24dc$var$factory.c1_node_explicit(s_datatype, h_prefixes));
                }
            // languaged literal
            case "@":
                {
                    // find literal's contents delimiter
                    let i_contents = sc1_term.indexOf('"');
                    // no delimiter
                    if (-1 === i_contents) throw new Error(`Invalid concise-term string, no content literal delimiter found: '${sc1_term}'`);
                    // extract language
                    let s_language = sc1_term.slice(1, i_contents);
                    // make term
                    return $266825253b7f24dc$var$factory.literal(sc1_term.slice(i_contents + 1), s_language);
                }
            // simple literal
            case '"':
                // make term
                return $266825253b7f24dc$var$factory.literal(sc1_term.slice(1));
            // prefixed name
            default:
                return $266825253b7f24dc$var$factory.c1_node(sc1_term, h_prefixes);
        }
    },
    // construct a term object from a concise term string for nodes
    c1_node (sc1_node, h_prefixes = {}) {
        // rdf:type shortcut
        if ("a" === sc1_node) return $266825253b7f24dc$var$KT_RDF_TYPE;
        // default graph
        if ("*" === sc1_node) return $266825253b7f24dc$var$factory.defaultGraph();
        // blank node
        if ("_" === sc1_node[0]) {
            if (":" !== sc1_node[1]) throw new Error(`Invliad concise-term string, prefixes are not allowed to start with an underscore: '${sc1_node}'`);
            // interpret ephemeral hint
            if ("#" === sc1_node[2] || 2 === sc1_node.length) return $266825253b7f24dc$var$factory.ephemeral();
            // create blank node
            return $266825253b7f24dc$var$factory.blankNode(sc1_node.slice(2));
        }
        // other
        return $266825253b7f24dc$var$factory.c1_node_explicit(sc1_node, h_prefixes);
    },
    // construct a named node
    c1_named_node (sc1_node, h_prefixes = {}) {
        // rdf:type shortcut
        if ("a" === sc1_node) return $266825253b7f24dc$var$KT_RDF_TYPE;
        // other
        return $266825253b7f24dc$var$factory.c1_node_explicit(sc1_node, h_prefixes);
    },
    // construct a term object from a concise term string for nodes (no shortcuts)
    c1_node_explicit (sc1_node, h_prefixes = {}) {
        // deduce term type
        switch(sc1_node[0]){
            // iri
            case ">":
                return $266825253b7f24dc$var$factory.namedNode(sc1_node.slice(1));
            // invalid concise-term string
            case "<":
                throw new Error(`Whoops! It looks like this concise-term string starts with a '<' character. Remember to use '>' if you are trying to make an absolute IRI reference.\nInvalid concise-term string '${sc1_node}'`);
            case "`":
                throw new Error(`The backtick character '\`' is reserved for concise-struct key directives and should not be used in the object position.\nInvalid concise-term string '${sc1_node}'`);
            // prefixed name
            default:
                return this.c1_prefixed_node(sc1_node, h_prefixes);
        }
    },
    // construct a term object from a concise term string for prefixed nodes
    c1_prefixed_node (sc1_node, h_prefixes = {}) {
        // find prefix delimiter
        let i_colon = sc1_node.indexOf(":");
        // no delimter; invalid concise-term string for node
        if (-1 === i_colon) throw new Error(`A relative or prefixed node must include a ':' character. \nInvalid concise-term string for node: '${sc1_node}'`);
        // prefix id
        let s_prefix_id = sc1_node.slice(0, i_colon);
        // suffix
        let s_suffix = sc1_node.slice(i_colon + 1);
        // find prefix in hash
        if (s_prefix_id in h_prefixes) return $266825253b7f24dc$var$factory.namedNode(h_prefixes[s_prefix_id] + s_suffix);
        else throw new Error(`Prefix not defined: '${s_prefix_id}'`);
    },
    c1_to_nt: $266825253b7f24dc$var$c1_to_nt,
    *quads (hc4_quads, h_prefixes = {}) {
        for(let sc1_graph in hc4_quads)yield* $266825253b7f24dc$var$factory.triples(hc4_quads[sc1_graph], h_prefixes, sc1_graph);
    },
    *triples (hc3_triples, h_prefixes = {}, sc1_graph = "*") {
        let k_graph = $266825253b7f24dc$var$factory.c1(sc1_graph, h_prefixes);
        for(let sc1_subject in hc3_triples){
            let k_subject = $266825253b7f24dc$var$factory.c1(sc1_subject, h_prefixes);
            let hc2_pairs = hc3_triples[sc1_subject];
            yield* $266825253b7f24dc$var$factory.pairs(k_graph, k_subject, hc2_pairs, h_prefixes);
        }
    },
    *pairs (k_graph, k_subject, hc2_pairs, h_prefixes = {}) {
        for(let sc1_predicate in hc2_pairs){
            let k_predicate = $266825253b7f24dc$var$factory.c1(sc1_predicate, h_prefixes);
            let z_objects = hc2_pairs[sc1_predicate];
            yield* $266825253b7f24dc$var$factory.objects(k_graph, k_subject, k_predicate, z_objects, h_prefixes);
        }
    },
    *collection (k_graph, k_subject, a_objects, h_prefixes = {}) {
        // first item
        yield* $266825253b7f24dc$var$factory.objects(k_graph, k_subject, $266825253b7f24dc$var$KT_RDF_FIRST, a_objects[0], h_prefixes);
        // rest of items
        let a_rest = a_objects.slice(1);
        // no more
        if (!a_rest.length) yield new $266825253b7f24dc$var$Quad(k_subject, $266825253b7f24dc$var$KT_RDF_REST, $266825253b7f24dc$var$KT_RDF_NIL, k_graph);
        else {
            // auto blank node
            let k_hop = $266825253b7f24dc$var$factory.blankNode();
            // incoming triple
            yield new $266825253b7f24dc$var$Quad(k_subject, $266825253b7f24dc$var$KT_RDF_REST, k_hop, k_graph);
            // outgoing triples
            yield* $266825253b7f24dc$var$factory.collection(k_graph, k_hop, a_rest, h_prefixes);
        }
    },
    *objects (k_graph, k_subject, k_predicate, z_objects, h_prefixes, b_nested = false) {
        // value type
        let s_type = typeof z_objects;
        switch(s_type){
            // c1-string
            case "string":
                yield new $266825253b7f24dc$var$Quad(k_subject, k_predicate, $266825253b7f24dc$var$factory.c1(z_objects, h_prefixes), k_graph);
                break;
            // number
            case "number":
                yield new $266825253b7f24dc$var$Quad(k_subject, k_predicate, $266825253b7f24dc$var$factory.number(z_objects), k_graph);
                break;
            // object
            case "object":
                // array
                if (Array.isArray(z_objects)) {
                    // RDF collection
                    if (b_nested) {
                        // auto blank node
                        let k_hop = $266825253b7f24dc$var$factory.blankNode();
                        // incoming triple
                        yield new $266825253b7f24dc$var$Quad(k_subject, k_predicate, k_hop, k_graph);
                        // outgoing triple
                        yield* $266825253b7f24dc$var$factory.collection(k_graph, k_hop, z_objects, h_prefixes);
                    } else for (let z_item of z_objects)yield* $266825253b7f24dc$var$factory.objects(k_graph, k_subject, k_predicate, z_item, h_prefixes, true);
                } else {
                    // auto blank node
                    let k_hop = $266825253b7f24dc$var$factory.blankNode();
                    // incoming triple
                    yield new $266825253b7f24dc$var$Quad(k_subject, k_predicate, k_hop, k_graph);
                    // outgoing triples
                    yield* $266825253b7f24dc$var$factory.pairs(k_graph, k_hop, z_objects, h_prefixes);
                }
                break;
            // other
            default:
                throw new Error(`invalid object type: ${typeof z_objects}`);
        }
    },
    from: {
        term (z_term) {
            if (null === z_term) return z_term;
            if (z_term.isGraphyTerm) return z_term;
            return $266825253b7f24dc$var$factory.from.rdfjs_term(z_term);
        },
        quad (g_quad) {
            if (null === g_quad) return g_quad;
            if (g_quad.isGraphyQuad) return g_quad;
            let g_from = $266825253b7f24dc$var$factory.from;
            return new $266825253b7f24dc$var$Quad(g_from.rdfjs_term(g_quad.subject), g_from.rdfjs_term(g_quad.predicate), g_from.rdfjs_term(g_quad.object), g_quad.graph ? g_from.rdfjs_term(g_quad.graph) : $266825253b7f24dc$var$KT_DEFAULT_GRAPH);
        },
        rdfjs_term (g_term) {
            switch(g_term.termType){
                case "NamedNode":
                    return new $266825253b7f24dc$var$NamedNode(g_term.value);
                case "BlankNode":
                    return new $266825253b7f24dc$var$BlankNode(g_term.value);
                case "Literal":
                    return $266825253b7f24dc$var$factory.literal(g_term.value, g_term.language ? g_term.language : g_term.datatype ? new $266825253b7f24dc$var$NamedNode(g_term.datatype.value) : null);
                case "DefaultGraph":
                    return new $266825253b7f24dc$var$DefaultGraph();
                default:
                    throw new TypeError(`invalid termType: ${g_term.termType}`);
            }
        },
        sparql_result (g_term) {
            switch(g_term.type){
                case "uri":
                    return new $266825253b7f24dc$var$NamedNode(g_term.value);
                case "literal":
                case "typed-literal":
                    if ("xml:lang" in g_term) return new $266825253b7f24dc$var$LanguagedLiteral(g_term.value, g_term["xml:lang"]);
                    else if ("datatype" in g_term && "http://www.w3.org/2001/XMLSchema#string" !== g_term.datatype) return new $266825253b7f24dc$var$ExplicitlyDatatypedLiteral(g_term.value, new $266825253b7f24dc$var$NamedNode(g_term.datatype));
                    else return new $266825253b7f24dc$var$SimpleLiteral(g_term.value);
                case "bnode":
                    return new $266825253b7f24dc$var$BlankNode(g_term.value);
                default:
                    throw new Error(`unexpected SPARQL Result JSON Format Term type: ${g_term.type}`);
            }
        }
    },
    to: {
        boolean: (s_boolean)=>$266825253b7f24dc$var$Literal_Boolean.from(s_boolean),
        integer: (s_integer)=>$266825253b7f24dc$var$Literal_Integer.from(s_integer),
        decimal: (s_decimal)=>$266825253b7f24dc$var$Literal_Decimal.from(s_decimal),
        double: (s_double)=>$266825253b7f24dc$var$Literal_Double.from(s_double)
    },
    /**
	 * @param  {Object} gc_comment -
	 * @return {string} a `concise-term string` directive to be used as a key in `concise-term structs`
	 * 	in order to write a comment to the document (only works with supporting serializers)
	 */ comment (gc_comment = {}) {
        return `\`[${$266825253b7f24dc$var$uuid_v4()}]${JSON.stringify({
            ...gc_comment,
            type: "comment"
        })}`;
    },
    /**
	 * @param  {integer} [line_count=1] - number of newlines to insert
	 * @return {string} a `concise-term string` directive to be used as a key in `concise-term structs`
	 * 	in order to write the given number of newlines to the document (only works with supporting serializers)
	 */ newlines () {
        // if(!Number.isInteger(n_line_count)) throw new TypeError('graphy/core.data.factory#newlines() expects `line_count` argument to be an integer');
        return `\`[${$266825253b7f24dc$var$uuid_v4()}]{"type":"newlines"}`;
    },
    /**
	 * @param {string} s_key - key that identifies which aspect to configure. e.g., 'lists'
	 * @return {string} a `concise-term string` directive to be used as a key in `concise-term structs`
	 * 	in order to write the given number of newlines to the document (only works with supporting serializers)
	 */ config (s_key) {
        if ("string" !== typeof s_key) throw new TypeError(`Expected 'key' argument to be a string, instead found ${typeof s_key}`);
        return `\`[${$266825253b7f24dc$var$uuid_v4()}]{"type":"config","value":${JSON.stringify(s_key)}}`;
    },
    /**
	 * @param {AnyQuad} g_quad - quad to hash
	 * @return {string} a sha256 hash of the quad
	 */ hash (g_quad) {
        // normalize quad
        let k_quad = $266825253b7f24dc$var$factory.from.quad(g_quad);
        // create hash
        let d_hash = $44edd02a6be448cd$export$2fb37efbf6ae0c0e("sha256");
        // verbose quad
        d_hash.update(k_quad.verbose());
        // return hash string
        return d_hash.digest("hex");
    },
    cache_prefixes: $266825253b7f24dc$var$cache_prefixes,
    cachePrefixes: $266825253b7f24dc$var$cache_prefixes,
    terse: $266825253b7f24dc$var$terse,
    clean_iri: $266825253b7f24dc$var$clean_iri,
    cleanIri: $266825253b7f24dc$var$clean_iri,
    $_PREFIX_CACHE: $266825253b7f24dc$var$$_PREFIX_CACHE
};
Object.assign($266825253b7f24dc$var$factory, {
    c3: $266825253b7f24dc$var$factory.triples,
    c4: $266825253b7f24dc$var$factory.quads,
    fromTerm: $266825253b7f24dc$var$factory.from.term,
    fromQuad: $266825253b7f24dc$var$factory.from.quad
});


const $9043c565d33eb642$var$quad = (k)=>$266825253b7f24dc$exports.quad(k._kt_subject, k._kt_predicate, k._kt_object, k._kt_graph);
// eslint-disable-next-line no-misleading-character-class
const $9043c565d33eb642$var$RT_PREFIXED_NAME_NAMESPACE_VALID = /^([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}]([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}.]*[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}])?)?$/u;
// eslint-disable-next-line no-misleading-character-class
const $9043c565d33eb642$var$RT_PREFIXED_NAME_LOCAL_NAME_VALID = /^([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_:0-9]|%[A-Fa-f0-9]{2}|\\[_~.\-!$&'()*+,;=/?#@%])(([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}.:]|%[A-Fa-f0-9]{2}|\\[_~.\-!$&'()*+,;=/?#@%])*([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}:]|%[A-Fa-f0-9]{2}|\\[_~.\-!$&'()*+,;=/?#@%]))?$/u;
// eslint-disable-next-line no-misleading-character-class
const $9043c565d33eb642$var$RT_BLANK_NODE_VALID = /^[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_0-9]([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}.]*[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}])?$/u;
const $9043c565d33eb642$var$RT_NAMED_NODE_VALID = /^([^\0-\x20<>"{}|^`\\]|\\u[A-Fa-f0-9]{4}|\\U[A-Fa-f0-9]{8})*$/;
const $9043c565d33eb642$var$RT_NAMED_NODE_ESCAPELESS_VALID = /^([^\0-\x20<>"{}|^`])*$/;
const $9043c565d33eb642$var$RT_LITERAL_CONTENTS_VALID = /^(?:[^\\]|\\[tbnrf"'\\]|\\u[A-Fa-f0-9]{4}|\\U[A-Fa-f0-9]{8})*$/;
const $9043c565d33eb642$var$R_UNICODE_ANY = /\\u([0-9A-Fa-f]{4})|\\U([0-9A-Fa-f]{8})/g;
const $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY = (s_, s_4, s_8)=>String.fromCodePoint(parseInt(s_4 || s_8, 16));
const $9043c565d33eb642$var$OPHOP = Object.prototype.hasOwnProperty;
const $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK = /([A-Za-z][A-Za-z0-9_-]*)?:([A-Za-z_0-9:][A-Za-z0-9_:-]*)(?:\s+|(?=\.?[<[("';,)\]#]|\.[\s\0]))/y;
const $9043c565d33eb642$var$R_PREFIXED_NAME_ESCAPELESS = /([^\s#@<[("':_][^\s#@<[("':]*)?:((?:[^\s#@<[("'.;,)\]\\](?:[^\s#@<[("';,)\]\\]*[^\s#@<[("'.;,)\]\\])?)?)(?:\s+|(?=\.?[<[("';,)\]#]|\.[\s\0]))/y;
const $9043c565d33eb642$var$R_PREFIXED_NAME = /([^\s#@<[("':_][^\s#@<[("':]*)?:((?:(?:[^\s#@<[("'.;,)\]\\]|\\(?:%[0-9A-Fa-f][0-9A-Fa-f]|[^\s"]))(?:(?:[^\s#@<[("';,)\]\\]|\\(?:%[0-9A-Fa-f][0-9A-Fa-f]|[^\s"]))*(?:[^\s#@<[("'.;,)\]\\]|\\(?:%[0-9A-Fa-f][0-9A-Fa-f]|[^\s"])))?)?)(?:\s+|(?=\.?[<[("';,)\]#]|\.[\s\0]))/y;
const $9043c565d33eb642$var$R_PN_LOCAL_ESCAPES = /\\(.)/g;
const $9043c565d33eb642$var$R_BLANK_NODE_LABEL = /_:(.(?:[^\s:<;,)\]#]*[^\s:<.;,)\]#])?)(?:\s+|(?=[<:,;\])#]))/y;
const $9043c565d33eb642$var$R_BLANK_NODE_LABEL_TERMINAL = /_:(.(?:[^\s:<;,)\]#]*[^\s:<.;,)\]#])?)(?:\s+|(?=\.?[<:,;\])#])|(?=\.[\s@#<({[}]))/y;
const $9043c565d33eb642$var$R_IRIREF_ESCAPELESS = /<([^\\>]*)>\s*/y;
const $9043c565d33eb642$var$R_IRIREF = /<([^>]*)>\s*/y;
const $9043c565d33eb642$var$R_NUMERIC_LITERAL = /([+-]?(?:[0-9]+(\.[0-9]+)?|(\.[0-9]+))(\.?[eE][+-]?[0-9]+)?)(?:\s+|(?=\.[^eE0-9]|[;,)\]]))/y;
const $9043c565d33eb642$var$R_BOOLEAN_LITERAL = /(?:(true|TRUE)|false|FALSE)\s*/y;
const $9043c565d33eb642$var$R_A = /a(?:\s+|(?=[[("'<#]))/y;
const $9043c565d33eb642$var$R_DOUBLE_CARET = /\^\^/y;
const $9043c565d33eb642$var$R_WS = /\s*/y;
const $9043c565d33eb642$var$R_LANGTAG = /@([A-Za-z]+(?:-[A-Za-z0-9-]+)*)(?:\s+|(?=[.,;\])#]))/y;
const $9043c565d33eb642$var$R_PREFIX_KEYWORD = /(?:(@prefix)|[pP][rR][eE][fF][iI][xX])\s*/y;
const $9043c565d33eb642$var$R_PREFIX_ID = /([^#:]*):\s*/iy;
const $9043c565d33eb642$var$R_BASE_KEYWORD = /(?:(@base)|[bB][aA][sS][eE])\s*/y;
const $9043c565d33eb642$var$R_COMMENT = /(#[^\n]*\n\s*)+/y;
const $9043c565d33eb642$var$RT_IRI_ABSOLUTE = /^[A-Za-z][A-Za-z0-9.\-+]*:/;
const $9043c565d33eb642$var$R_RELATIVE_URI = /^(\/[^?#]+)([?#].*)?$/;
const $9043c565d33eb642$var$R_BASE_IRI = /^((([A-Za-z0-9.\-+]*:\/)?\/[^/>]*)?(\/(?:[^/>]*\/)*)?[^>]*)$/;
const $9043c565d33eb642$var$R_ANONYMOUS_BLANK_NODE = /\[\s*\]\s*/y;
const $9043c565d33eb642$var$R_CHAR_BLANK_NODE = /\[(?:\s+|(?=[^\]]))/y;
const $9043c565d33eb642$var$R_CHAR_COLLECTION = /\(\s*/y;
const $9043c565d33eb642$var$R_CHAR_KET = /\]\s*/y;
const $9043c565d33eb642$var$R_CHAR_STOP = /\.\s*/y;
const $9043c565d33eb642$var$R_STRLIT_SHORT_DOUBLE_BREAK = /[\\"\r\n]/g;
const $9043c565d33eb642$var$R_STRLIT_SHORT_SINGLE_BREAK = /[\\'\r\n]/g;
const $9043c565d33eb642$var$R_STRLIT_LONG_DOUBLE_UNFINISHED_TERM = /"{1,2}$/g;
const $9043c565d33eb642$var$R_STRLIT_LONG_SINGLE_UNFINISHED_TERM = /'{1,2}$/g;
const $9043c565d33eb642$var$R_STRLIT_LONG_DOUBLE_BREAK = /(\\|""")/g;
const $9043c565d33eb642$var$R_STRLIT_LONG_SINGLE_BREAK = /(\\|''')/g;
const $9043c565d33eb642$var$F_REPLACE_STRLIT_CONTENTS = (s_, s_whitespace, s_auto, s_4, s_8, s_invalid)=>{
    if (s_whitespace) switch(s_whitespace){
        case "t":
            return "	";
        case "n":
            return "\n";
        case "r":
            return "\r";
        case "f":
            return "\f";
        case "b":
            return "\b";
        default:
            console.assert(`bad regex escape char mapping: '${s_whitespace}'`);
    }
    else if (s_auto) return s_auto;
    else if (s_4) return String.fromCodePoint(parseInt(s_4, 16));
    else if (s_8) return String.fromCodePoint(parseInt(s_8, 16));
    else if (s_invalid) {
        // pointless escape
        if ("\\" === s_invalid[0]) // // relaxed
        // return s_invalid[1];
        // if relaxed then return s_invalid, otherwise throw:
        throw new Error(`expected string_literal but invalid escape sequence within contents: '${s_invalid}'. failed to parse a valid token`);
        else throw new Error(`expected string_literal but invalid whitespace character within contents: ${JSON.stringify(s_invalid)}. failed to parse a valid token`);
    } else console.assert(`unexpected no match branch in escape sequence replace callback`);
};
const $9043c565d33eb642$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_HARD = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|([\r\n]|\\.))/g;
const $9043c565d33eb642$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|([\r\n]|\\[^uU]|\\u[^]{4}|\\U[^]{8}))/g;
const $9043c565d33eb642$var$unescape_literal_short_hard = (s_literal)=>s_literal.replace($9043c565d33eb642$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_HARD, $9043c565d33eb642$var$F_REPLACE_STRLIT_CONTENTS);
const $9043c565d33eb642$var$unescape_literal_short_soft = (s_literal)=>{
    let m_incomplete = $9043c565d33eb642$var$R_STRLIT_ESCAPE_INCOMPLETE.exec(s_literal);
    // incomplete escape
    if (m_incomplete) {
        let i_safe = m_incomplete.index;
        // rewind
        return [
            s_literal.slice(0, i_safe).replace($9043c565d33eb642$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT, $9043c565d33eb642$var$F_REPLACE_STRLIT_CONTENTS),
            s_literal.slice(i_safe)
        ];
    } else return [
        s_literal.replace($9043c565d33eb642$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT, $9043c565d33eb642$var$F_REPLACE_STRLIT_CONTENTS),
        ""
    ];
};
const $9043c565d33eb642$var$R_STRLIT_LONG_CONTENTS_ESCAPES_HARD = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|(\\.))/g;
const $9043c565d33eb642$var$R_STRLIT_LONG_CONTENTS_ESCAPES_SOFT = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|(\\[^uU]|\\u[^]{4}|\\U[^]{8}))/g;
const $9043c565d33eb642$var$unescape_literal_long_hard = (s_literal)=>s_literal.replace($9043c565d33eb642$var$R_STRLIT_LONG_CONTENTS_ESCAPES_HARD, $9043c565d33eb642$var$F_REPLACE_STRLIT_CONTENTS);
const $9043c565d33eb642$var$unescape_literal_long_soft = (s_literal)=>{
    let m_incomplete = $9043c565d33eb642$var$R_STRLIT_ESCAPE_INCOMPLETE.exec(s_literal);
    // incomplete escape
    if (m_incomplete) {
        let i_safe = m_incomplete.index;
        // rewind
        return [
            s_literal.slice(0, i_safe).replace($9043c565d33eb642$var$R_STRLIT_LONG_CONTENTS_ESCAPES_SOFT, $9043c565d33eb642$var$F_REPLACE_STRLIT_CONTENTS),
            s_literal.slice(i_safe)
        ];
    } else return [
        s_literal.replace($9043c565d33eb642$var$R_STRLIT_LONG_CONTENTS_ESCAPES_SOFT, $9043c565d33eb642$var$F_REPLACE_STRLIT_CONTENTS),
        ""
    ];
};
// lookbehind regexes
const [$9043c565d33eb642$var$R_STRLIT_ESCAPE_INCOMPLETE, $9043c565d33eb642$var$R_STRLIT_SHORT_DOUBLE_TERM, $9043c565d33eb642$var$R_STRLIT_SHORT_SINGLE_TERM, $9043c565d33eb642$var$R_STRLIT_LONG_DOUBLE_TERM, $9043c565d33eb642$var$R_STRLIT_LONG_SINGLE_TERM] = (()=>{
    function RegExp_$lookbehind_polyfill(s_input) {
        let m_match = RegExp.prototype.exec.call(this, s_input);
        if (m_match) {
            let i_start = m_match[0].length - m_match[1].length;
            m_match.index += i_start;
            m_match[0] = m_match[0].slice(i_start);
        }
        return m_match;
    }
    let mk_lookbehind_regex = (()=>{
        try {
            new RegExp("(?<!h)i"); // eslint-disable-line no-new
        } catch (e_compile) {
            return (f_lookbehind, r_polyfill, f_polyfill)=>{
                r_polyfill.exec = f_polyfill;
                return r_polyfill;
            };
        }
        return (f_lookbehind)=>f_lookbehind();
    })();
    return [
        // R_STRLIT_ESCAPE_INCOMPLETE
        mk_lookbehind_regex(()=>new RegExp("(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)\\\\(|u[0-9A-Fa-f]{0,3}|U[0-9A-Fa-f]{0,7})$"), /^(?:(?:[^\\]|\\.)*)(\\(?:|u[0-9A-Fa-f]{0,3}|U[0-9A-Fa-f]{0,7}))$/, function RegExp_$lookbehind_polyfill_n(s_input) {
            let m_match = RegExp.prototype.exec.call(this, s_input);
            if (m_match) m_match.index += m_match[0].length - m_match[1].length;
            return m_match;
        }),
        // R_STRLIT_SHORT_DOUBLE_TERM
        mk_lookbehind_regex(()=>new RegExp('(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)"\\s*', "g"), /(?:[^\\"]|\\.)*("\s*)/y, RegExp_$lookbehind_polyfill),
        // R_STRLIT_SHORT_SINGLE_TERM
        mk_lookbehind_regex(()=>new RegExp("(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)'\\s*", "g"), /(?:[^\\']|\\.)*('\s*)/y, RegExp_$lookbehind_polyfill),
        // R_STRLIT_LONG_DOUBLE_TERM
        mk_lookbehind_regex(()=>new RegExp('(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)"""\\s*', "g"), /(?:[^\\"]|\\.|""?(?!"))*("""\s*)/y, RegExp_$lookbehind_polyfill),
        // R_STRLIT_LONG_SINGLE_TERM
        mk_lookbehind_regex(()=>new RegExp("(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)'''\\s*", "g"), /(?:[^\\']|\\.|''?(?!'))*('''\s*)/y, RegExp_$lookbehind_polyfill)
    ];
})();
const $9043c565d33eb642$var$match_prefixed_name_quick = (s, i)=>{
    $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.lastIndex = i;
    return [
        $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.exec(s),
        $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.lastIndex
    ];
};
const $9043c565d33eb642$var$match_prefixed_name_escapeless = (s, i)=>{
    $9043c565d33eb642$var$R_PREFIXED_NAME_ESCAPELESS.lastIndex = i;
    return [
        $9043c565d33eb642$var$R_PREFIXED_NAME_ESCAPELESS.exec(s),
        $9043c565d33eb642$var$R_PREFIXED_NAME_ESCAPELESS.lastIndex
    ];
};
const $9043c565d33eb642$var$match_prefixed_name = (s, i)=>{
    $9043c565d33eb642$var$R_PREFIXED_NAME.lastIndex = i;
    return [
        $9043c565d33eb642$var$R_PREFIXED_NAME.exec(s),
        $9043c565d33eb642$var$R_PREFIXED_NAME.lastIndex
    ];
};
function $9043c565d33eb642$var$Reader$syntax_error(k_self, i, si_state, s_info) {
    let i_off = Math.min(i, Math.abs(i - 15));
    let s = k_self.s;
    return k_self.error(`\n\`${s.substr(i_off, i_off + 90).replace(/[\n\t]/g, " ")}\`\n` + ` ${" ".repeat(i - i_off)}^\n` + `expected ${si_state} ${s_info || ""}.  failed to parse a valid token starting at ${s[i] ? '"' + s[i] + '"' : "<<EOF>>"}`);
}
class $9043c565d33eb642$var$Turtle_Reader extends $141f1697ab3cba12$exports.Transform {
    constructor(g_impls){
        super({
            // do not decode strings into buffers
            decodeStrings: false,
            // accept strings as input on writable side
            writableObjectMode: false,
            // output quad objects on readable side
            readableObjectMode: true,
            // implementations
            flush: g_impls.flush,
            transform: g_impls.transform
        });
    }
    // intercept pipe
    pipe(ds_out) {
        let ds_dst = ds_out;
        // non-object mode
        if (!ds_dst._writableState.objectMode) // transform to JSON
        ds_out = $141f1697ab3cba12$exports.quads_to_json();
        else if (ds_out.isGraphyWritable) // transform to writable data events
        ds_out = $141f1697ab3cba12$exports.quads_to_writable();
        // interim stream created
        if (ds_out !== ds_dst) {
            // forward output to super
            super.pipe(ds_out);
            // pipe outpu to destination
            return ds_out.pipe(ds_dst);
        } else return super.pipe(ds_dst);
    }
}
class $9043c565d33eb642$var$Reader {
    constructor(g_config = {}){
        // impl-specific configs
        let { // input medium
        input: g_input = null, // a state to inherit
        state: g_state = {} } = g_config;
        // inherit state from creator
        let { // index for anonymous blank node labels
        blank_node_index: i_anon = 0, // prefix map
        prefixes: h_prefixes = {}, // blank node label map
        labels: h_labels = {} } = g_state;
        let dc_factory = $266825253b7f24dc$exports.adopt(g_config.dataFactory || g_config.data_factory || $266825253b7f24dc$exports.unfiltered);
        let kt_default_graph = dc_factory.defaultGraph();
        // if data factory is not graphy, it might be returning the same object on each call to .defaultGraph()
        if (dc_factory !== $266825253b7f24dc$exports.unfiltered) // do not trust it, create a new object
        kt_default_graph = Object.create(kt_default_graph);
        let kt_rdf_first = dc_factory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#first");
        let blankNode = dc_factory.blankNode;
        let namedNode = dc_factory.namedNode;
        this.emit_data = $266825253b7f24dc$exports.unfiltered === dc_factory ? function() {
            ds_transform.push($9043c565d33eb642$var$quad(this));
        } : function() {
            let g_quad = dc_factory.quad(this._kt_subject, this._kt_predicate, this._kt_object, this._kt_graph);
            ds_transform.push(g_quad);
        };
        // fields
        Object.assign(this, {
            // read index
            i: 0,
            // string buffer
            s: "",
            // string buffer length
            n: 0,
            // left-over string from previous data chunk
            pre: g_config.prepend || "",
            // debug state
            _b_debug: g_config.debug || false,
            // relax
            _b_relax: g_config.relax || false,
            // factory
            _dc_factory: dc_factory,
            // current reader state
            _f_state: this.statement,
            // map of current prefix ids => iris
            _h_prefixes: h_prefixes,
            // reader was destroyed by an error
            _b_destroyed: false,
            // current @base url
            _s_base_url: "",
            _s_base_url_scheme: "",
            _s_base_url_root: "",
            _s_base_url_path: "",
            // current data
            _kt_subject: null,
            _kt_predicate: kt_rdf_first,
            _kt_object: null,
            _kt_graph: kt_default_graph,
            _s_literal: "",
            // static terms
            _kt_rdf_type: dc_factory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"),
            _kt_rdf_first: kt_rdf_first,
            _kt_rdf_rest: dc_factory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#rest"),
            _kt_rdf_nil: dc_factory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"),
            _kt_default_graph: kt_default_graph,
            // queue of nested subject, predicate, state for blanknodes and collections
            _a_nested: [],
            // hash to keep track of all blank node labels in use
            _h_labels: h_labels,
            // event routing
            event: this.emit,
            data: this.emit_data,
            // for restoring the original event callback when resuming paused stream
            restore_data: this.emit_data,
            // keep a queue of data events to hold onto until stream resumes (only happens in rare conditions)
            _a_queue_event: [],
            // helper states
            _b_expecting_full_stop: false,
            _s_temp_prefix_id: null,
            _b_trim_start: true,
            anonymous_blank_node: (s_label)=>blankNode(s_label, true),
            // finds the next non-conflicting blank node label
            next_label () {
                let s_label = "";
                do s_label = "g" + i_anon++;
                while (this._h_labels[s_label]);
                // claim this label, and remember that we invented it
                this._h_labels[s_label] = 2;
                // return the label
                return s_label;
            },
            // what to do when reach eos
            eos: null,
            // which state to go to after end of statement
            after_end_of_statement: this.post_object,
            // maximum length of a token: defaults to 2048 => http://stackoverflow.com/a/417184/1641160
            _n_max_token_length: g_config.max_token_length || g_config.maxTokenLength || 2048,
            // maximum length of a string (overrides max_token_length): defaults to Infinity
            _n_max_string_length: g_config.max_string_length || g_config.maxStringLength || Infinity,
            // byte tracking
            _b_byte_tracking: g_config.byte_tracking || g_config.byteTracking || false,
            _nb_seen: 0,
            _nb_last: 0,
            _nb_curr: 0
        });
        if (g_config.relaxed) console.warn(new Error(`no such option 'relaxed'; did you mean 'relax' ?`).stack.replace(/^Error:/, "Warning:"));
        if ("validate" in g_config) console.warn(new Error(`option 'validate' has been deprecated. Validation is now enabled by default. Use the 'relax' option if you wish to disable validation.`).stack.replace(/^Error:/, "Warning:"));
        // term constructors
        Object.assign(this, !g_config.relax ? {
            blank_node (s_label) {
                // test valid blank node label
                if (!$9043c565d33eb642$var$RT_BLANK_NODE_VALID.test(s_label)) return this.error(`invalid blank node label: "${s_label}"`);
                // not first time use of label
                let z_label_state = this._h_labels[s_label];
                if (z_label_state) {
                    // label was used previously by document and has no conflict
                    if (1 === z_label_state) ; // eslint-disable-line no-empty
                    else if (2 === z_label_state) // so create a redirect mapping for this actual label & use it instead
                    s_label = this._h_labels[s_label] = this.next_label();
                    else // use redirected label
                    s_label = this._h_labels[s_label];
                } else // store label in hash so we avoid future collisions
                this._h_labels[s_label] = 1;
                // make term
                return blankNode(s_label);
            },
            check_named_node (p_iri) {
                if (!$9043c565d33eb642$var$RT_NAMED_NODE_VALID.test(p_iri)) return this.error(`invalid IRI: "${p_iri}"`);
                return namedNode(p_iri);
            },
            check_named_node_escapeless (p_iri) {
                if (!$9043c565d33eb642$var$RT_NAMED_NODE_ESCAPELESS_VALID.test(p_iri)) return this.error(`invalid IRI: "${p_iri}"`);
                return namedNode(p_iri);
            },
            match_prefixed_name_quick (s, i) {
                $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.lastIndex = i;
                return [
                    $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.exec(s),
                    $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.lastIndex
                ];
            },
            match_prefixed_name_escapeless (s, i) {
                let [m_prefixed_name_e, im_prefixed_name_e] = $9043c565d33eb642$var$match_prefixed_name_escapeless(s, i);
                if (m_prefixed_name_e) // invalid local name
                {
                    if (!$9043c565d33eb642$var$RT_PREFIXED_NAME_LOCAL_NAME_VALID.test(m_prefixed_name_e[2]) && m_prefixed_name_e[2]) {
                        this.error(`invalid prefixed name local name: "${m_prefixed_name_e[2]}:"`);
                        return;
                    }
                }
                return [
                    m_prefixed_name_e,
                    im_prefixed_name_e
                ];
            },
            match_prefixed_name (s, i) {
                let [m_prefixed_name, im_prefixed_name] = $9043c565d33eb642$var$match_prefixed_name(s, i);
                if (m_prefixed_name) // invalid local name
                {
                    if (!$9043c565d33eb642$var$RT_PREFIXED_NAME_LOCAL_NAME_VALID.test(m_prefixed_name[2])) {
                        this.error(`invalid prefixed name local name: "${m_prefixed_name[2]}:"`);
                        return;
                    }
                }
                return [
                    m_prefixed_name,
                    im_prefixed_name
                ];
            }
        } : {
            // term constructors
            blank_node (s_label) {
                // not first time use of label
                let z_label_state = this._h_labels[s_label];
                if (z_label_state) {
                    // label was used previously by document and has no conflict
                    if (1 === z_label_state) ; // eslint-disable-line no-empty
                    else if (2 === z_label_state) // so create a redirect mapping for this actual label & use it instead
                    s_label = this._h_labels[s_label] = this.next_label();
                    else // use redirected label
                    s_label = this._h_labels[s_label];
                } else // store label in hash so we avoid future collisions
                this._h_labels[s_label] = 1;
                // make term
                return blankNode(s_label);
            },
            check_named_node: namedNode,
            check_named_node_escapeless: namedNode,
            match_prefixed_name_escapeless: $9043c565d33eb642$var$match_prefixed_name_escapeless,
            match_prefixed_name: $9043c565d33eb642$var$match_prefixed_name
        });
        this.named_node = namedNode;
        this.prefixed_name = function(si_prefix, s_suffix) {
            return namedNode(h_prefixes[si_prefix] + s_suffix);
        };
        // oops -- user passed string into `base`
        if ("string" === typeof g_config.base) throw new TypeError(`invalid type 'string' was given for 'base' event listener: '${g_config.base}'\n` + `did you mean to use the 'base_uri' key instead?`);
        // base uri
        let p_set_base_uri = g_config.base_uri || g_config.baseUri || g_config.baseURI || g_config.base_iri || g_config.baseIri || g_config.baseIRI;
        if (p_set_base_uri) {
            let m_base_iri = $9043c565d33eb642$var$R_BASE_IRI.exec(p_set_base_uri);
            this._s_base_url = m_base_iri[1];
            this._s_base_url_root = m_base_iri[2] || "";
            this._s_base_url_scheme = m_base_iri[3] || "";
            this._s_base_url_path = m_base_iri[4] || "";
        } else if (g_config.base_url || g_config.baseUrl || g_config.baseURL) throw new Error(`invalid option: .base${g_config.base_url ? "_url" : g_config.baseUrl ? "Url" : g_config.baseURL ? "URL" : ""}; use the '.base_uri' key instead`);
        // transform stream
        let ds_transform = this.transform = new $9043c565d33eb642$var$Turtle_Reader({
            // on data event
            transform: (s_chunk, s_encoding, fke_chunk)=>{
                // concatenate current chunk to previous chunk
                let s = this.s = this.pre + s_chunk;
                // cache chunk length
                this.n = s.length;
                // eat whitespace before token and reset index
                if (this._b_trim_start) {
                    // consume whitespace (and incidentally reset index)
                    $9043c565d33eb642$var$R_WS.lastIndex = 0;
                    $9043c565d33eb642$var$R_WS.exec(s);
                    this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                } else this.i = 0;
                // resume parsing; no errors
                if (this.safe_parse(true)) {
                    // emit progress event updates
                    ds_transform.emit("progress", s_chunk.length);
                    // done transforming this chunk
                    fke_chunk();
                }
            },
            // once there's no more data to consume, invoke eof
            flush: (fke_flush)=>{
                // now that input stream has ended, clean up remainder
                try {
                    this.eof(1);
                } // read error occurred
                catch (e_eof) {
                    // destroy self and stream
                    this.destroy(e_eof);
                    // exit gracefully
                    return;
                }
                // no errors. done flushing, close read stream
                fke_flush();
            }
        });
        // when the writable side is piped into
        ds_transform.on("pipe", (ds_input)=>{
            this._ds_input = ds_input;
            let b_byte_tracking = this._b_byte_tracking;
            // byte-tracking is disable & input stream has encoding option; ensure stream encoding is utf8
            if (!b_byte_tracking && "function" === typeof ds_input.setEncoding) ds_input.setEncoding("utf8");
            else {
                let f_write = ds_transform.write;
                let d_decoder = new $eNRCS.StringDecoder("utf8");
                let f_write_track = (s_chunk, s_encoding, fk_write)=>{
                    // TODO: optimize by testing for multibyte chars and using string length instead?
                    let nb_chunk = $9043c565d33eb642$require$Buffer.from(s_chunk, "utf8").length;
                    this._nb_seen += nb_chunk;
                    this._nb_last = nb_chunk;
                    return f_write.call(ds_transform, s_chunk, s_encoding, fk_write);
                };
                let f_decode_write_track = (ab_chunk, s_encoding, fk_write)=>{
                    let nb_chunk = this._nb_last = ab_chunk.length;
                    this._nb_seen += nb_chunk;
                    return f_write.call(ds_transform, d_decoder.write(ab_chunk), s_encoding, fk_write);
                };
                let f_decode_write = (ab_chunk, s_encoding, fk_write)=>f_write.call(ds_transform, d_decoder.write(ab_chunk), s_encoding, fk_write);
                ds_transform.write = function(z_chunk, s_encoding, fk_write) {
                    // not null
                    if (null !== z_chunk) {
                        // chunk is string; adapt by resetting method to original
                        if ("string" === typeof z_chunk) ds_transform.write = b_byte_tracking ? f_write_track : f_write;
                        else ds_transform.write = b_byte_tracking ? f_decode_write_track : f_decode_write;
                        // use set method
                        return ds_transform.write(z_chunk, s_encoding, fk_write);
                    }
                    // null, use parent
                    return f_write.call(ds_transform, z_chunk, s_encoding, fk_write);
                };
                // byte tracking is enabled
                if (b_byte_tracking) // overwrite emit_data method
                this.emit_data = this.data = this.restore_data = function() {
                    let g_quad = this._dc_factory.quad(this._kt_subject, this._kt_predicate, this._kt_object, this._kt_graph);
                    let nb_post = $9043c565d33eb642$require$Buffer.from(this.s.slice(this.i)).length;
                    let ib_post = this._nb_seen - nb_post;
                    g_quad.byteRange = [
                        this._nb_curr,
                        ib_post
                    ];
                    this._nb_curr = ib_post;
                    this.transform.push(g_quad);
                };
            }
        });
        // new listener added
        ds_transform.on("newListener", (s_event)=>{
            // comment
            if ("comment" === s_event) this.emit_comments = (s_captured)=>{
                let a_comments = s_captured.slice(1).replace(/\n\s+$/, "").split(/\n+\s*#/g);
                for (let s_comment of a_comments)ds_transform.emit("comment", s_comment);
            };
        });
        // destroy
        ds_transform._destroy = (...a_args)=>{
            this.destroy(...a_args);
        };
        // bind events to transform stream
        this.bind(g_config);
        // input given
        if (g_input) {
            // input is stream
            if (g_input.stream) {
                let ds_input = g_input.stream;
                // go async so caller has chance to bind event listeners
                queueMicrotask(()=>{
                    ds_input.pipe(ds_transform);
                });
            } else if ("string" === typeof g_input.string) {
                let s_input = g_input.string;
                // go async so caller has chance to bind event listeners
                queueMicrotask(()=>{
                    ds_transform.end(s_input, "utf8");
                });
            } else throw new TypeError(`Invalid argument for input parameter: ${"object" === typeof g_input ? JSON.stringify(g_input) : g_input}`);
        }
    }
    // begin parsing, keep applying until no more stack bail-outs
    safe_parse() {
        try {
            let f_sync = this._f_state();
            while("function" === typeof f_sync)f_sync = f_sync.apply(this);
        } // read error occurred
        catch (e_read) {
            // destroy self and stream
            this.destroy(e_read);
            // failure
            return false;
        }
        // okay
        return true;
    }
    emit(s_event, ...a_args) {
        this.transform.emit(s_event, ...a_args);
    }
    queue(s_event, ...a_args) {
        this._a_queue_event.push({
            event: s_event,
            args: a_args
        });
    }
    error(s_message) {
        // bail out
        throw new Error(s_message);
    }
    // parse_error (not meant to be an event callback)
    parse_error(s_expected, b_eof = false) {
        let i = this.i;
        let i_off = Math.min(i, Math.abs(i - 15));
        let s = this.s;
        return this.error(`\n\`${s.substr(i_off, i_off + 90).replace(/[\n\t]/g, " ")}\`\n` + ` ${" ".repeat(i - i_off)}^\n` + `expected ${s_expected} ${b_eof ? "but encountered <<EOF>>" : ""}.  failed to parse a valid token starting at ${s[i] ? '"' + s[i] + '"' : "<<EOF>>"}`);
    }
    info_error(s_message) {
        let i = this.i;
        let i_off = Math.min(i, Math.abs(i - 15));
        let s = this.s;
        this.error(`\n\`${s.substr(i_off, i_off + 90).replace(/[\n\t]/g, " ")}\`\n` + ` ${" ".repeat(i - i_off)}^\n` + s_message);
    }
    // end of file
    eof() {
        // there are events queued
        if (this._a_queue_event.length) {
            let a_queue = this._a_queue_event;
            // drain event queue
            while(a_queue.length){
                // remove event from front of queue
                let h_event = a_queue.shift();
                // make event callback
                this[h_event.event](h_event.data);
            }
        }
        // invalid parsing state
        if (this.statement !== this._f_state) {
            // append EOF char
            this.s += "\0";
            // exit "flowing" mode
            this.n = this.s.length;
            // resume parsing; no errors
            if (this.safe_parse()) {
                // eof has occurred under safe parse
                if (null === this.s) return;
                // still invalid parsing state
                if (this.statement !== this._f_state) return this.parse_error(this._f_state.name, true);
            }
        }
        // there are still unparsed characters
        if (this.i < this.n) {
            // consume whitespace and comments
            let s = this.s;
            let i = this.i;
            // consume whitespace (and incidentally reset index)
            $9043c565d33eb642$var$R_WS.lastIndex = i;
            $9043c565d33eb642$var$R_WS.exec(s);
            i = $9043c565d33eb642$var$R_WS.lastIndex;
            $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
            let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
            // advance beyond comment
            if ($9043c565d33eb642$var$R_COMMENT.lastIndex > i) {
                this.i = i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                if (this.emit_comments) this.emit_comments(m_comment[0]);
            }
            // still unparsed characters
            if (i < this.n) {
                // not EOF
                if (!(i === this.n - 1 && "\0" === s[i])) // bad input; parse error
                return this.parse_error(this._f_state.name);
            }
        }
        // make buffer's alloc eligible for gc
        this.s = null;
        // transform stream
        let ds_transform = this.transform;
        // final progress update: no additional bytes were read
        ds_transform.emit("progress", 0);
        // call end event listener
        ds_transform.emit("eof", this._h_prefixes);
        // close write stream (EOF-signaling)
        ds_transform.push(null);
    }
    // bind event listeners to transform stream
    bind(g_config) {
        let ds_transform = this.transform;
        if (g_config.base) ds_transform.on("base", g_config.base);
        if (g_config.prefix) ds_transform.on("prefix", g_config.prefix);
        if (g_config.comment) ds_transform.on("comment", g_config.comment);
        if (g_config.error) ds_transform.on("error", g_config.error);
        if (g_config.read) ds_transform.once("read", g_config.read);
        if (g_config.progress) ds_transform.on("progress", g_config.progress);
        if (g_config.eof) ds_transform.once("eof", g_config.eof);
        if (g_config.end) ds_transform.once("end", g_config.end);
        if (g_config.finish) ds_transform.once("finish", g_config.finish);
        if (g_config.data) ds_transform.on("data", g_config.data);
    }
    // after a blank node subject (either property-list or colleciton)
    post_blank_subject() {
        let { s: s, i: i } = this;
        if ("." === s[i]) {
            // consume whitespace (and incidentally reset index)
            $9043c565d33eb642$var$R_WS.lastIndex = i + 1;
            $9043c565d33eb642$var$R_WS.exec(s);
            this.i = $9043c565d33eb642$var$R_WS.lastIndex;
            return this.statement();
        }
        return this.pairs();
    }
    // parse state for statement
    statement() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // prefixed name quick
            // prepare sticky regex index
            $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.lastIndex = i;
            // execute regex
            let m_pnq_subject = $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.exec(s);
            // regex was a match
            if (m_pnq_subject) {
                // advance index
                this.i = $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.lastIndex;
                // check valid prefix
                let s_prefix_id = m_pnq_subject[1] || "";
                // invalid prefix
                if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                // commit subject iri from resolve prefixed name
                this._kt_subject = this.prefixed_name(s_prefix_id, m_pnq_subject[2]);
                // predicate-object pairs state
                return this.pairs();
            // iriref
            } else {
                // prepare sticky regex index
                $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex = i;
                // execute regex
                let m_iriref_e_subject = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.exec(s);
                // regex was a match
                if (m_iriref_e_subject) {
                    // advance index
                    this.i = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex;
                    // ref iri
                    let s_iri = m_iriref_e_subject[1];
                    // absolute iri
                    if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set subject
                    this._kt_subject = this.check_named_node_escapeless(s_iri);
                    else this._kt_subject = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                    // predicate-object pairs state
                    return this.pairs();
                // prefixed name
                } else {
                    // try match
                    let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                    // stack bail out
                    if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                    let [m_prefixed_named_e_subject, im_prefixed_named_e_subject] = aw_valid_this_match_prefixed_name_escapeless;
                    if (m_prefixed_named_e_subject) {
                        // advance index
                        this.i = im_prefixed_named_e_subject;
                        // check valid prefix
                        let s_prefix_id = m_prefixed_named_e_subject[1] || "";
                        // invalid prefix
                        if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                        // make subject key
                        this._kt_subject = this.prefixed_name(s_prefix_id, m_prefixed_named_e_subject[2]);
                        // predicate-object pairs state
                        return this.pairs();
                    // blank node label
                    } else {
                        // prepare sticky regex index
                        $9043c565d33eb642$var$R_BLANK_NODE_LABEL.lastIndex = i;
                        // execute regex
                        let m_blank_node_label_subject = $9043c565d33eb642$var$R_BLANK_NODE_LABEL.exec(s);
                        // regex was a match
                        if (m_blank_node_label_subject) {
                            // advance index
                            this.i = $9043c565d33eb642$var$R_BLANK_NODE_LABEL.lastIndex;
                            // extract label
                            let s_label = m_blank_node_label_subject[1];
                            // make subject key
                            this._kt_subject = this.blank_node(s_label);
                            // predicate-object pairs state
                            return this.pairs();
                        // anonymous blank node subject
                        } else {
                            // prepare sticky regex index
                            $9043c565d33eb642$var$R_ANONYMOUS_BLANK_NODE.lastIndex = i;
                            if ($9043c565d33eb642$var$R_ANONYMOUS_BLANK_NODE.exec(s)) {
                                // advance index
                                this.i = $9043c565d33eb642$var$R_ANONYMOUS_BLANK_NODE.lastIndex;
                                // set new blank node as subject
                                this._kt_subject = this.anonymous_blank_node(this.next_label());
                                // goto pairs state for inside property list
                                return this.pairs();
                            // anonymous blank node property list subject
                            } else {
                                // prepare sticky regex index
                                $9043c565d33eb642$var$R_CHAR_BLANK_NODE.lastIndex = i;
                                if ($9043c565d33eb642$var$R_CHAR_BLANK_NODE.exec(s)) {
                                    // advance index
                                    this.i = $9043c565d33eb642$var$R_CHAR_BLANK_NODE.lastIndex;
                                    // enter blank node
                                    this._kt_subject = this.anonymous_blank_node(this.next_label());
                                    // how to resume when we pop state
                                    this._a_nested.push([
                                        this._kt_subject,
                                        this._kt_predicate,
                                        "post_blank_subject"
                                    ]);
                                    // goto pairs state for inside property list
                                    return this.pairs();
                                // rdf collection
                                } else {
                                    // prepare sticky regex index
                                    $9043c565d33eb642$var$R_CHAR_COLLECTION.lastIndex = i;
                                    if ($9043c565d33eb642$var$R_CHAR_COLLECTION.exec(s)) {
                                        // advance index
                                        this.i = $9043c565d33eb642$var$R_CHAR_COLLECTION.lastIndex;
                                        // indicate that collection subject should emit an initial statement
                                        this._kt_subject = null;
                                        // (don't push state, we don't have a subject yet)
                                        // goto collection-subject state
                                        return this.collection_subject();
                                    // prefix with interupt (e.g., a comment)
                                    } else {
                                        // prepare sticky regex index
                                        $9043c565d33eb642$var$R_PREFIX_KEYWORD.lastIndex = i;
                                        // execute regex
                                        let m_prefix_keyword = $9043c565d33eb642$var$R_PREFIX_KEYWORD.exec(s);
                                        // regex was a match
                                        if (m_prefix_keyword) {
                                            // advance index
                                            this.i = $9043c565d33eb642$var$R_PREFIX_KEYWORD.lastIndex;
                                            // save whether or not to expect a full stop
                                            this._b_expecting_full_stop = !!m_prefix_keyword[1];
                                            // goto prefix state
                                            return this.prefix_id();
                                        // base with interupt (e.g., a comment)
                                        } else {
                                            // prepare sticky regex index
                                            $9043c565d33eb642$var$R_BASE_KEYWORD.lastIndex = i;
                                            // execute regex
                                            let m_base_keyword = $9043c565d33eb642$var$R_BASE_KEYWORD.exec(s);
                                            // regex was a match
                                            if (m_base_keyword) {
                                                // advance index
                                                this.i = $9043c565d33eb642$var$R_BASE_KEYWORD.lastIndex;
                                                // save whether or not to expect a full stop
                                                this._b_expecting_full_stop = !!m_base_keyword[1];
                                                // goto base state
                                                return this.base_iri();
                                            // iriref
                                            } else {
                                                // prepare sticky regex index
                                                $9043c565d33eb642$var$R_IRIREF.lastIndex = i;
                                                // execute regex
                                                let m_iriref_subject = $9043c565d33eb642$var$R_IRIREF.exec(s);
                                                // regex was a match
                                                if (m_iriref_subject) {
                                                    // advance index
                                                    this.i = $9043c565d33eb642$var$R_IRIREF.lastIndex;
                                                    // ref iri
                                                    let s_iri = m_iriref_subject[1].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY);
                                                    // absolute iri
                                                    if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set subject
                                                    this._kt_subject = this.check_named_node(s_iri);
                                                    else this._kt_subject = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                                    // predicate-object pairs state
                                                    return this.pairs();
                                                // prefixed name
                                                } else {
                                                    // try match
                                                    let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                                    // stack bail out
                                                    if (!aw_valid_this_match_prefixed_name) return true;
                                                    let [m_prefixed_named_subject, im_prefixed_named_subject] = aw_valid_this_match_prefixed_name;
                                                    if (m_prefixed_named_subject) {
                                                        // advance index
                                                        this.i = im_prefixed_named_subject;
                                                        // check valid prefix
                                                        let s_prefix_id = m_prefixed_named_subject[1] || "";
                                                        // invalid prefix
                                                        if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                                        // escape local escapes
                                                        let s_suffix = m_prefixed_named_subject[2].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY).replace($9043c565d33eb642$var$R_PN_LOCAL_ESCAPES, "$1");
                                                        // make subject key
                                                        this._kt_subject = this.prefixed_name(s_prefix_id, s_suffix);
                                                        // predicate-object pairs state
                                                        return this.pairs();
                                                    // comment
                                                    } else {
                                                        // prepare sticky regex index
                                                        $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                                                        // execute regex
                                                        let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                                                        // regex was a match
                                                        if (m_comment) {
                                                            // advance index
                                                            i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                                                            if (this.emit_comments) this.emit_comments(m_comment[0]);
                                                            continue;
                                                        // not iriref, not prefixed name, not blank node label, not prefix id, not base
                                                        // match counter: 11
                                                        } else break;
                                                    } // brace #11
                                                } // brace #10
                                            } // brace #9
                                        } // brace #8
                                    } // brace #7
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("statement");
            }
        }
        // save state before pausing
        this._f_state = this.statement;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for pairs
    pairs() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // benchmarks indicate: regex for end of blank node property list faster than ch
            // iriref
            // prepare sticky regex index
            $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_iriref_e_predicate = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.exec(s);
            // regex was a match
            if (m_iriref_e_predicate) {
                // advance index
                this.i = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex;
                // ref iri
                let s_iri = m_iriref_e_predicate[1];
                // absolute iri
                if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set predicate
                this._kt_predicate = this.check_named_node_escapeless(s_iri);
                else this._kt_predicate = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                // object-list state
                return this.object_list();
            // prefixed name
            } else {
                // try match
                let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                // stack bail out
                if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                let [m_prefixed_named_e_predicate, im_prefixed_named_e_predicate] = aw_valid_this_match_prefixed_name_escapeless;
                if (m_prefixed_named_e_predicate) {
                    // advance index
                    this.i = im_prefixed_named_e_predicate;
                    // check valid prefix
                    let s_prefix_id = m_prefixed_named_e_predicate[1] || "";
                    // invalid prefix
                    if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                    // make predicate key
                    this._kt_predicate = this.prefixed_name(s_prefix_id, m_prefixed_named_e_predicate[2]);
                    // object-list state
                    return this.object_list();
                // 'a'
                } else {
                    // prepare sticky regex index
                    $9043c565d33eb642$var$R_A.lastIndex = i;
                    if ($9043c565d33eb642$var$R_A.exec(s)) {
                        // advance index
                        this.i = $9043c565d33eb642$var$R_A.lastIndex;
                        // make predicate key
                        this._kt_predicate = this._kt_rdf_type;
                        // object-list state
                        return this.object_list();
                    // ']' end of blank node property list
                    } else {
                        // prepare sticky regex index
                        $9043c565d33eb642$var$R_CHAR_KET.lastIndex = i;
                        if ($9043c565d33eb642$var$R_CHAR_KET.exec(s)) {
                            // advance index
                            this.i = $9043c565d33eb642$var$R_CHAR_KET.lastIndex;
                            let s_resume_state;
                            [this._kt_subject, this._kt_predicate, s_resume_state] = this._a_nested.pop();
                            return this[s_resume_state]();
                        // iriref
                        } else {
                            // prepare sticky regex index
                            $9043c565d33eb642$var$R_IRIREF.lastIndex = i;
                            // execute regex
                            let m_iriref_predicate = $9043c565d33eb642$var$R_IRIREF.exec(s);
                            // regex was a match
                            if (m_iriref_predicate) {
                                // advance index
                                this.i = $9043c565d33eb642$var$R_IRIREF.lastIndex;
                                // ref iri
                                let s_iri = m_iriref_predicate[1].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY);
                                // absolute iri
                                if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set predicate
                                this._kt_predicate = this.check_named_node(s_iri);
                                else this._kt_predicate = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                // object-list state
                                return this.object_list();
                            // prefixed name
                            } else {
                                // try match
                                let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                // stack bail out
                                if (!aw_valid_this_match_prefixed_name) return true;
                                let [m_prefixed_named_predicate, im_prefixed_named_predicate] = aw_valid_this_match_prefixed_name;
                                if (m_prefixed_named_predicate) {
                                    // advance index
                                    this.i = im_prefixed_named_predicate;
                                    // check valid prefix
                                    let s_prefix_id = m_prefixed_named_predicate[1] || "";
                                    // invalid prefix
                                    if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                    // escape local escapes
                                    let s_suffix = m_prefixed_named_predicate[2].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY).replace($9043c565d33eb642$var$R_PN_LOCAL_ESCAPES, "$1");
                                    // make predicate key
                                    this._kt_predicate = this.prefixed_name(s_prefix_id, s_suffix);
                                    // object-list state
                                    return this.object_list();
                                } else {
                                    // prepare sticky regex index
                                    $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                                    // execute regex
                                    let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                                    // regex was a match
                                    if (m_comment) {
                                        // advance index
                                        i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                                        if (this.emit_comments) this.emit_comments(m_comment[0]);
                                        continue;
                                    // not iriref, not prefixed name, not 'a'
                                    // match counter: 6
                                    } else break;
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("pairs");
            }
        }
        // save state before pausing
        this._f_state = this.pairs;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for object_list
    object_list() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // ref char
            let x = s[i];
            // string literal * double
            if ('"' === x) {
                // enough chars to deduce type
                if (i + 2 < n) {
                    // long type
                    if ('"' === s[i + 1] && '"' === s[i + 2]) {
                        // advance index beyond token
                        this.i = i + 3;
                        // read contents
                        return this.string_literal_long_double();
                    } else {
                        // advance index beyond token
                        this.i = i + 1;
                        // read contents
                        return this.string_literal_short_double();
                    }
                } else if (i + 1 < n && '"' !== s[i + 1]) {
                    // advance index beyond token
                    this.i = i + 1;
                    // read contents
                    return this.string_literal_short_double();
                } else break;
            // prefixed name quick
            } else {
                // prepare sticky regex index
                $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.lastIndex = i;
                // execute regex
                let m_pnq_object = $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.exec(s);
                // regex was a match
                if (m_pnq_object) {
                    // advance index
                    this.i = $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.lastIndex;
                    // check valid prefix
                    let s_prefix_id = m_pnq_object[1] || "";
                    // invalid prefix
                    if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                    // commit object iri from resolve prefixed name
                    this._kt_object = this.prefixed_name(s_prefix_id, m_pnq_object[2]);
                // iriref
                } else {
                    // prepare sticky regex index
                    $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex = i;
                    // execute regex
                    let m_iriref_e_object = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.exec(s);
                    // regex was a match
                    if (m_iriref_e_object) {
                        // advance index
                        this.i = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex;
                        // ref iri
                        let s_iri = m_iriref_e_object[1];
                        // absolute iri
                        if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                        this._kt_object = this.check_named_node_escapeless(s_iri);
                        else this._kt_object = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                    // prefixed name
                    } else {
                        // try match
                        let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                        // stack bail out
                        if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                        let [m_prefixed_named_e_object, im_prefixed_named_e_object] = aw_valid_this_match_prefixed_name_escapeless;
                        if (m_prefixed_named_e_object) {
                            // advance index
                            this.i = im_prefixed_named_e_object;
                            // check valid prefix
                            let s_prefix_id = m_prefixed_named_e_object[1] || "";
                            // invalid prefix
                            if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                            // commit object iri from resolve prefixed name
                            this._kt_object = this.prefixed_name(s_prefix_id, m_prefixed_named_e_object[2]);
                        // string literal * single
                        } else if ("'" === x) {
                            // enough chars to deduce type
                            if (i + 2 < n) {
                                // long type
                                if ("'" === s[i + 1] && "'" === s[i + 2]) {
                                    // advance index beyond token
                                    this.i = i + 3;
                                    // read contents
                                    return this.string_literal_long_single();
                                } else {
                                    // advance index beyond token
                                    this.i = i + 1;
                                    // read contents
                                    return this.string_literal_short_single();
                                }
                            } else if (i + 1 < n && "'" !== s[i + 1]) {
                                // advance index beyond token
                                this.i = i + 1;
                                // read contents
                                return this.string_literal_short_single();
                            } else break;
                        // numeric literal
                        } else {
                            // prepare sticky regex index
                            $9043c565d33eb642$var$R_NUMERIC_LITERAL.lastIndex = i;
                            // execute regex
                            let m_numeric_literal = $9043c565d33eb642$var$R_NUMERIC_LITERAL.exec(s);
                            // regex was a match
                            if (m_numeric_literal) {
                                // advance index
                                this.i = $9043c565d33eb642$var$R_NUMERIC_LITERAL.lastIndex;
                                // it has exponent term, xsd:double
                                if (m_numeric_literal[4]) this._kt_object = this._dc_factory.double(m_numeric_literal[1]);
                                else if (m_numeric_literal[2] || m_numeric_literal[3]) this._kt_object = this._dc_factory.decimal(m_numeric_literal[1]);
                                else this._kt_object = this._dc_factory.integer(m_numeric_literal[1]);
                            // boolean literal
                            } else {
                                // prepare sticky regex index
                                $9043c565d33eb642$var$R_BOOLEAN_LITERAL.lastIndex = i;
                                // execute regex
                                let m_boolean_literal = $9043c565d33eb642$var$R_BOOLEAN_LITERAL.exec(s);
                                // regex was a match
                                if (m_boolean_literal) {
                                    // advance index
                                    this.i = $9043c565d33eb642$var$R_BOOLEAN_LITERAL.lastIndex;
                                    // make literal
                                    this._kt_object = this._dc_factory.boolean(!!m_boolean_literal[1]);
                                // blank node property list
                                } else if ("[" === x) {
                                    // advance index to next token
                                    // consume whitespace (and incidentally reset index)
                                    $9043c565d33eb642$var$R_WS.lastIndex = i + 1;
                                    $9043c565d33eb642$var$R_WS.exec(s);
                                    this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                                    // make object
                                    let kt_blank_node = this._kt_object = this.anonymous_blank_node(this.next_label());
                                    // emit statement event
                                    this.data();
                                    // push state to stack
                                    this._a_nested.push([
                                        this._kt_subject,
                                        this._kt_predicate,
                                        "post_object"
                                    ]);
                                    // set new subject
                                    this._kt_subject = kt_blank_node;
                                    // goto parsing pairs state
                                    return this.pairs();
                                // labeled blank node
                                } else {
                                    // prepare sticky regex index
                                    $9043c565d33eb642$var$R_BLANK_NODE_LABEL_TERMINAL.lastIndex = i;
                                    // execute regex
                                    let m_blank_node_label_object = $9043c565d33eb642$var$R_BLANK_NODE_LABEL_TERMINAL.exec(s);
                                    // regex was a match
                                    if (m_blank_node_label_object) {
                                        // advance index
                                        this.i = $9043c565d33eb642$var$R_BLANK_NODE_LABEL_TERMINAL.lastIndex;
                                        // ref blank node label
                                        let s_label = m_blank_node_label_object[1];
                                        // make object
                                        this._kt_object = this.blank_node(s_label);
                                    // collection
                                    } else if ("(" === x) {
                                        // advance index to next token
                                        // consume whitespace (and incidentally reset index)
                                        $9043c565d33eb642$var$R_WS.lastIndex = i + 1;
                                        $9043c565d33eb642$var$R_WS.exec(s);
                                        this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                                        // state to resume after collection ends
                                        this._a_nested.push([
                                            this._kt_subject,
                                            this._kt_predicate,
                                            "post_object"
                                        ]);
                                        // goto collection-object state
                                        return this.collection_object();
                                    // iriref
                                    } else {
                                        // prepare sticky regex index
                                        $9043c565d33eb642$var$R_IRIREF.lastIndex = i;
                                        // execute regex
                                        let m_iriref_object = $9043c565d33eb642$var$R_IRIREF.exec(s);
                                        // regex was a match
                                        if (m_iriref_object) {
                                            // advance index
                                            this.i = $9043c565d33eb642$var$R_IRIREF.lastIndex;
                                            // ref iri
                                            let s_iri = m_iriref_object[1].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY);
                                            // absolute iri
                                            if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                                            this._kt_object = this.check_named_node(s_iri);
                                            else this._kt_object = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                        // prefixed name
                                        } else {
                                            // try match
                                            let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                            // stack bail out
                                            if (!aw_valid_this_match_prefixed_name) return true;
                                            let [m_prefixed_named_object, im_prefixed_named_object] = aw_valid_this_match_prefixed_name;
                                            if (m_prefixed_named_object) {
                                                // advance index
                                                this.i = im_prefixed_named_object;
                                                // check valid prefix
                                                let s_prefix_id = m_prefixed_named_object[1] || "";
                                                // invalid prefix
                                                if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                                // escape local escapes
                                                let s_suffix = m_prefixed_named_object[2].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY).replace($9043c565d33eb642$var$R_PN_LOCAL_ESCAPES, "$1");
                                                // commit object iri from resolve prefixed name
                                                this._kt_object = this.prefixed_name(s_prefix_id, s_suffix);
                                            } else {
                                                // prepare sticky regex index
                                                $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                                                // execute regex
                                                let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                                                // regex was a match
                                                if (m_comment) {
                                                    // advance index
                                                    i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                                                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                                                    continue;
                                                // not iriref, not prefixed name, not string literal, not numeric literal, not boolean literal, not blank node property list, not collection
                                                // match counter: 9
                                                } else break;
                                            } // brace #9
                                        } // brace #8
                                    } // brace #7
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
            // fall through for cases that did not change state on their own
            // at this point, a new statement has been parsed
            this.data();
            // goto next parsing state; bail out of stack
            return this.after_end_of_statement;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("object_list");
            }
        }
        // save state before pausing
        this._f_state = this.object_list;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for string_literal_short_double
    string_literal_short_double() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        string_literal_short_double: while(i < n){
            // something breaks string in this chunk
            // prepare sticky regex index
            $9043c565d33eb642$var$R_STRLIT_SHORT_DOUBLE_BREAK.lastIndex = i;
            // execute regex
            let m_break = $9043c565d33eb642$var$R_STRLIT_SHORT_DOUBLE_BREAK.exec(s);
            // regex was a match
            if (m_break) {
                // advance index
                this.i = $9043c565d33eb642$var$R_STRLIT_SHORT_DOUBLE_BREAK.lastIndex;
                // index of break
                let i_break = m_break.index;
                // add to contents
                this._s_literal += s.slice(i, i_break);
                // depending on char
                switch(s[i_break]){
                    // terminator
                    case '"':
                        // advance index to next token beyond delimiter
                        // consume whitespace (and incidentally reset index)
                        $9043c565d33eb642$var$R_WS.lastIndex = i_break + 1;
                        $9043c565d33eb642$var$R_WS.exec(s);
                        this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                        // resume eating whitespace at start of next chunk
                        this._b_trim_start = true;
                        // consume rest
                        return this.datatype_or_langtag();
                    // escape
                    case "\\":
                        {
                            // try to find end
                            $9043c565d33eb642$var$R_STRLIT_SHORT_DOUBLE_TERM.lastIndex = i_break;
                            let m_term = $9043c565d33eb642$var$R_STRLIT_SHORT_DOUBLE_TERM.exec(s);
                            // end is in this chunk
                            if (m_term) {
                                // index of terminator
                                let i_term = m_term.index;
                                // extract dirty potion
                                let s_dirty = s.slice(i_break, i_term);
                                // clean and save
                                this._s_literal += $9043c565d33eb642$var$unescape_literal_short_hard(s_dirty);
                                // advance index beyond terminator
                                this.i = i_term + m_term[0].length;
                                // resume eating whitespace at start of next chunk
                                this._b_trim_start = true;
                                // consume rest
                                return this.datatype_or_langtag();
                            } else {
                                // extract whole portion
                                let s_dirty = s.slice(i_break);
                                // unescape to clean part
                                let [s_clean, s_incomplete] = $9043c565d33eb642$var$unescape_literal_short_soft(s_dirty);
                                // save
                                this._s_literal += s_clean;
                                // set unparsed index
                                i = n - s_incomplete.length;
                                break string_literal_short_double;
                            }
                        }
                    // invalid '\n'
                    case "\n":
                        return this.info_error(`expected string_literal_short_double but invalid line feed character '\\n' (newline) within contents. failed to parse a valid token`);
                    // invalid '\r'
                    case "\r":
                        return this.info_error(`expected string_literal_short_double but invalid form feed character '\\r' (carriage return) within contents. failed to parse a valid token`);
                    // invalid
                    default:
                        console.assert(`Unhandle invalid character ${JSON.stringify(s[i_break])} case for string_literal_short_double`);
                }
            // no terminator and nothing to escape
            // match counter: 0
            } else {
                // save
                this._s_literal += i ? s.slice(i) : s;
                // set unparsed index
                i = n;
                break;
            }
        }
        // do not eat whitespace at start of next chunk
        this._b_trim_start = false;
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("string_literal_short_double");
            }
        }
        // save state before pausing
        this._f_state = this.string_literal_short_double;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for string_literal_short_single
    string_literal_short_single() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        string_literal_short_single: while(i < n){
            // something breaks string in this chunk
            // prepare sticky regex index
            $9043c565d33eb642$var$R_STRLIT_SHORT_SINGLE_BREAK.lastIndex = i;
            // execute regex
            let m_break = $9043c565d33eb642$var$R_STRLIT_SHORT_SINGLE_BREAK.exec(s);
            // regex was a match
            if (m_break) {
                // advance index
                this.i = $9043c565d33eb642$var$R_STRLIT_SHORT_SINGLE_BREAK.lastIndex;
                // index of break
                let i_break = m_break.index;
                // add to contents
                this._s_literal += s.slice(i, i_break);
                // depending on char
                switch(s[i_break]){
                    // terminator
                    case "'":
                        // advance index to next token beyond delimiter
                        // consume whitespace (and incidentally reset index)
                        $9043c565d33eb642$var$R_WS.lastIndex = i_break + 1;
                        $9043c565d33eb642$var$R_WS.exec(s);
                        this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                        // resume eating whitespace at start of next chunk
                        this._b_trim_start = true;
                        // consume rest
                        return this.datatype_or_langtag();
                    // escape
                    case "\\":
                        {
                            // try to find end
                            $9043c565d33eb642$var$R_STRLIT_SHORT_SINGLE_TERM.lastIndex = i_break;
                            let m_term = $9043c565d33eb642$var$R_STRLIT_SHORT_SINGLE_TERM.exec(s);
                            // end is in this chunk
                            if (m_term) {
                                // index of terminator
                                let i_term = m_term.index;
                                // extract dirty potion
                                let s_dirty = s.slice(i_break, i_term);
                                // clean and save
                                this._s_literal += $9043c565d33eb642$var$unescape_literal_short_hard(s_dirty);
                                // advance index beyond terminator
                                this.i = i_term + m_term[0].length;
                                // resume eating whitespace at start of next chunk
                                this._b_trim_start = true;
                                // consume rest
                                return this.datatype_or_langtag();
                            } else {
                                // extract whole portion
                                let s_dirty = s.slice(i_break);
                                // unescape to clean part
                                let [s_clean, s_incomplete] = $9043c565d33eb642$var$unescape_literal_short_soft(s_dirty);
                                // save
                                this._s_literal += s_clean;
                                // set unparsed index
                                i = n - s_incomplete.length;
                                break string_literal_short_single;
                            }
                        }
                    // invalid '\n'
                    case "\n":
                        return this.info_error(`expected string_literal_short_single but invalid line feed character '\\n' (newline) within contents. failed to parse a valid token`);
                    // invalid '\r'
                    case "\r":
                        return this.info_error(`expected string_literal_short_single but invalid form feed character '\\r' (carriage return) within contents. failed to parse a valid token`);
                    // invalid
                    default:
                        console.assert(`Unhandle invalid character ${JSON.stringify(s[i_break])} case for string_literal_short_single`);
                }
            // no terminator and nothing to escape
            // match counter: 0
            } else {
                // save
                this._s_literal += i ? s.slice(i) : s;
                // set unparsed index
                i = n;
                break;
            }
        }
        // do not eat whitespace at start of next chunk
        this._b_trim_start = false;
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("string_literal_short_single");
            }
        }
        // save state before pausing
        this._f_state = this.string_literal_short_single;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for string_literal_long_double
    string_literal_long_double() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        string_literal_long_double: while(i < n){
            // something breaks string in this chunk
            // prepare sticky regex index
            $9043c565d33eb642$var$R_STRLIT_LONG_DOUBLE_BREAK.lastIndex = i;
            // execute regex
            let m_break = $9043c565d33eb642$var$R_STRLIT_LONG_DOUBLE_BREAK.exec(s);
            // regex was a match
            if (m_break) {
                // advance index
                this.i = $9043c565d33eb642$var$R_STRLIT_LONG_DOUBLE_BREAK.lastIndex;
                // index of break
                let i_break = m_break.index;
                // add to contents
                this._s_literal += s.slice(i, i_break);
                // depending on char
                switch(s[i_break]){
                    // terminator
                    case '"':
                        // advance index to next token beyond delimiter
                        // consume whitespace (and incidentally reset index)
                        $9043c565d33eb642$var$R_WS.lastIndex = i_break + 3;
                        $9043c565d33eb642$var$R_WS.exec(s);
                        this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                        // resume eating whitespace at start of next chunk
                        this._b_trim_start = true;
                        // consume rest
                        return this.datatype_or_langtag();
                    // escape
                    case "\\":
                        {
                            // try to find end
                            $9043c565d33eb642$var$R_STRLIT_LONG_DOUBLE_TERM.lastIndex = i_break;
                            let m_term = $9043c565d33eb642$var$R_STRLIT_LONG_DOUBLE_TERM.exec(s);
                            // end is in this chunk
                            if (m_term) {
                                // index of terminator
                                let i_term = m_term.index;
                                // extract dirty potion
                                let s_dirty = s.slice(i_break, i_term);
                                // clean and save
                                this._s_literal += $9043c565d33eb642$var$unescape_literal_long_hard(s_dirty);
                                // advance index beyond terminator
                                this.i = i_term + m_term[0].length;
                                // resume eating whitespace at start of next chunk
                                this._b_trim_start = true;
                                // consume rest
                                return this.datatype_or_langtag();
                            } else {
                                // extract whole portion
                                let s_dirty = s.slice(i_break);
                                // unescape to clean part
                                let [s_clean, s_incomplete] = $9043c565d33eb642$var$unescape_literal_long_soft(s_dirty);
                                // save
                                this._s_literal += s_clean;
                                // set unparsed index
                                i = n - s_incomplete.length;
                                break string_literal_long_double;
                            }
                        }
                    // invalid
                    default:
                        console.assert(`Unhandle invalid character ${JSON.stringify(s[i_break])} case for string_literal_long_double`);
                }
            // no terminator and nothing to escape
            // match counter: 0
            } else {
                // could be unfinished terminator
                $9043c565d33eb642$var$R_STRLIT_LONG_DOUBLE_UNFINISHED_TERM.lastIndex = i;
                let m_unfinished = $9043c565d33eb642$var$R_STRLIT_LONG_DOUBLE_UNFINISHED_TERM.exec(s);
                // unfinished terminator
                if (m_unfinished) {
                    // save valid portion
                    this._s_literal += s.slice(i, m_unfinished.index);
                    // set unparsed index
                    i = m_unfinished.index;
                } else {
                    // save
                    this._s_literal += i ? s.slice(i) : s;
                    // set unparsed index
                    i = n;
                }
                break;
            }
        }
        // do not eat whitespace at start of next chunk
        this._b_trim_start = false;
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("string_literal_long_double");
            }
        }
        // save state before pausing
        this._f_state = this.string_literal_long_double;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for string_literal_long_single
    string_literal_long_single() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        string_literal_long_single: while(i < n){
            // something breaks string in this chunk
            // prepare sticky regex index
            $9043c565d33eb642$var$R_STRLIT_LONG_SINGLE_BREAK.lastIndex = i;
            // execute regex
            let m_break = $9043c565d33eb642$var$R_STRLIT_LONG_SINGLE_BREAK.exec(s);
            // regex was a match
            if (m_break) {
                // advance index
                this.i = $9043c565d33eb642$var$R_STRLIT_LONG_SINGLE_BREAK.lastIndex;
                // index of break
                let i_break = m_break.index;
                // add to contents
                this._s_literal += s.slice(i, i_break);
                // depending on char
                switch(s[i_break]){
                    // terminator
                    case "'":
                        // advance index to next token beyond delimiter
                        // consume whitespace (and incidentally reset index)
                        $9043c565d33eb642$var$R_WS.lastIndex = i_break + 3;
                        $9043c565d33eb642$var$R_WS.exec(s);
                        this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                        // resume eating whitespace at start of next chunk
                        this._b_trim_start = true;
                        // consume rest
                        return this.datatype_or_langtag();
                    // escape
                    case "\\":
                        {
                            // try to find end
                            $9043c565d33eb642$var$R_STRLIT_LONG_SINGLE_TERM.lastIndex = i_break;
                            let m_term = $9043c565d33eb642$var$R_STRLIT_LONG_SINGLE_TERM.exec(s);
                            // end is in this chunk
                            if (m_term) {
                                // index of terminator
                                let i_term = m_term.index;
                                // extract dirty potion
                                let s_dirty = s.slice(i_break, i_term);
                                // clean and save
                                this._s_literal += $9043c565d33eb642$var$unescape_literal_long_hard(s_dirty);
                                // advance index beyond terminator
                                this.i = i_term + m_term[0].length;
                                // resume eating whitespace at start of next chunk
                                this._b_trim_start = true;
                                // consume rest
                                return this.datatype_or_langtag();
                            } else {
                                // extract whole portion
                                let s_dirty = s.slice(i_break);
                                // unescape to clean part
                                let [s_clean, s_incomplete] = $9043c565d33eb642$var$unescape_literal_long_soft(s_dirty);
                                // save
                                this._s_literal += s_clean;
                                // set unparsed index
                                i = n - s_incomplete.length;
                                break string_literal_long_single;
                            }
                        }
                    // invalid
                    default:
                        console.assert(`Unhandle invalid character ${JSON.stringify(s[i_break])} case for string_literal_long_single`);
                }
            // no terminator and nothing to escape
            // match counter: 0
            } else {
                // could be unfinished terminator
                $9043c565d33eb642$var$R_STRLIT_LONG_SINGLE_UNFINISHED_TERM.lastIndex = i;
                let m_unfinished = $9043c565d33eb642$var$R_STRLIT_LONG_SINGLE_UNFINISHED_TERM.exec(s);
                // unfinished terminator
                if (m_unfinished) {
                    // save valid portion
                    this._s_literal += s.slice(i, m_unfinished.index);
                    // set unparsed index
                    i = m_unfinished.index;
                } else {
                    // save
                    this._s_literal += i ? s.slice(i) : s;
                    // set unparsed index
                    i = n;
                }
                break;
            }
        }
        // do not eat whitespace at start of next chunk
        this._b_trim_start = false;
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("string_literal_long_single");
            }
        }
        // save state before pausing
        this._f_state = this.string_literal_long_single;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for string_literal
    string_literal() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // ref character
            let x = s[i];
            // string literal * double
            if ('"' === x) {
                // enough chars to deduce type
                if (i + 2 < n) {
                    // long type
                    if ('"' === s[i + 1] && '"' === s[i + 2]) {
                        // advance index beyond token
                        this.i = i + 3;
                        // read contents
                        return this.string_literal_long_double();
                    } else {
                        // advance index beyond token
                        this.i = i + 1;
                        // read contents
                        return this.string_literal_short_double();
                    }
                } else if (i + 1 < n && '"' !== s[i + 1]) {
                    // advance index beyond token
                    this.i = i + 1;
                    // read contents
                    return this.string_literal_short_double();
                } else break;
            // string literal * single
            } else if ("'" === x) {
                // enough chars to deduce type
                if (i + 2 < n) {
                    // long type
                    if ("'" === s[i + 1] && "'" === s[i + 2]) {
                        // advance index beyond token
                        this.i = i + 3;
                        // read contents
                        return this.string_literal_long_single();
                    } else {
                        // advance index beyond token
                        this.i = i + 1;
                        // read contents
                        return this.string_literal_short_single();
                    }
                } else if (i + 1 < n && "'" !== s[i + 1]) {
                    // advance index beyond token
                    this.i = i + 1;
                    // read contents
                    return this.string_literal_short_single();
                } else break;
            // not string literal long single quote, not string literal single quote
            // match counter: 0
            } else break;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_string_length) return this.parse_error("string_literal");
            }
        }
        // save state before pausing
        this._f_state = this.string_literal;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for datatype_or_langtag
    datatype_or_langtag() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // ref character
            let x = s[i];
            // next token indicates datatype or langtag
            if ("^" === x || "@" === x) {
                // '^^' datatype
                // prepare sticky regex index
                $9043c565d33eb642$var$R_DOUBLE_CARET.lastIndex = i;
                if ($9043c565d33eb642$var$R_DOUBLE_CARET.exec(s)) {
                    // advance index
                    this.i = $9043c565d33eb642$var$R_DOUBLE_CARET.lastIndex;
                    return this.datatype();
                // '@' language tag
                } else {
                    // prepare sticky regex index
                    $9043c565d33eb642$var$R_LANGTAG.lastIndex = i;
                    // execute regex
                    let m_langtag = $9043c565d33eb642$var$R_LANGTAG.exec(s);
                    // regex was a match
                    if (m_langtag) {
                        // advance index
                        this.i = $9043c565d33eb642$var$R_LANGTAG.lastIndex;
                        this._kt_object = this._dc_factory.languagedLiteral(this._s_literal, m_langtag[1]);
                        // reset literal
                        this._s_literal = "";
                    // next token definitely datatype or langtag, we are just being interrupted by eos
                    // match counter: 1
                    } else break;
                } // brace #1
            } else {
                // prepare sticky regex index
                $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // match counter: 1
                } else {
                    this._kt_object = this._dc_factory.simpleLiteral(this._s_literal);
                    // reset literal
                    this._s_literal = "";
                // not datatype, not language tag => that's okay! those are optional
                }
            } // brace #1
            // goto end of statement state
            // at this point, a new statement has been parsed
            this.data();
            // goto next parsing state; bail out of stack
            return this.after_end_of_statement;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("datatype_or_langtag");
            }
        }
        // save state before pausing
        this._f_state = this.datatype_or_langtag;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for datatype
    datatype() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            let kt_datatype = null;
            // prefixed name quick
            // prepare sticky regex index
            $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.lastIndex = i;
            // execute regex
            let m_pnq_datatype = $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.exec(s);
            // regex was a match
            if (m_pnq_datatype) {
                // advance index
                this.i = $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.lastIndex;
                // check valid prefix
                let s_prefix_id = m_pnq_datatype[1] || "";
                // invalid prefix
                if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                // commit object iri from resolve prefixed name
                kt_datatype = this.prefixed_name(s_prefix_id, m_pnq_datatype[2]);
            // iriref
            } else {
                // prepare sticky regex index
                $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex = i;
                // execute regex
                let m_iriref_e_datatype = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.exec(s);
                // regex was a match
                if (m_iriref_e_datatype) {
                    // advance index
                    this.i = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex;
                    let p_datatype;
                    // ref iri
                    let s_iri = m_iriref_e_datatype[1];
                    // absolute iri
                    if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set p_datatype
                    p_datatype = s_iri;
                    else p_datatype = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                    kt_datatype = this.check_named_node_escapeless(p_datatype);
                // prefixed name
                } else {
                    // try match
                    let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                    // stack bail out
                    if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                    let [m_prefixed_named_e_datatype, im_prefixed_named_e_datatype] = aw_valid_this_match_prefixed_name_escapeless;
                    if (m_prefixed_named_e_datatype) {
                        // advance index
                        this.i = im_prefixed_named_e_datatype;
                        // check valid prefix
                        let s_prefix_id = m_prefixed_named_e_datatype[1] || "";
                        // invalid prefix
                        if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                        kt_datatype = this.prefixed_name(s_prefix_id, m_prefixed_named_e_datatype[2]);
                    // iriref
                    } else {
                        // prepare sticky regex index
                        $9043c565d33eb642$var$R_IRIREF.lastIndex = i;
                        // execute regex
                        let m_iriref_datatype = $9043c565d33eb642$var$R_IRIREF.exec(s);
                        // regex was a match
                        if (m_iriref_datatype) {
                            // advance index
                            this.i = $9043c565d33eb642$var$R_IRIREF.lastIndex;
                            let p_datatype;
                            // ref iri
                            let s_iri = m_iriref_e_datatype[1].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY);
                            // absolute iri
                            if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set p_datatype
                            p_datatype = s_iri;
                            else p_datatype = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                            kt_datatype = this.check_named_node(p_datatype);
                        // prefixed name
                        } else {
                            // try match
                            let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                            // stack bail out
                            if (!aw_valid_this_match_prefixed_name) return true;
                            let [m_prefixed_named_datatype, im_prefixed_named_datatype] = aw_valid_this_match_prefixed_name;
                            if (m_prefixed_named_datatype) {
                                // advance index
                                this.i = im_prefixed_named_datatype;
                                // check valid prefix
                                let s_prefix_id = m_prefixed_named_datatype[1] || "";
                                // invalid prefix
                                if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                // escape local escapes
                                let s_suffix = m_prefixed_named_datatype[2].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY).replace($9043c565d33eb642$var$R_PN_LOCAL_ESCAPES, "$1");
                                // set literal datatype
                                kt_datatype = this.prefixed_name(s_prefix_id, s_suffix);
                            // not iriref, not prefixed name
                            // match counter: 4
                            } else break;
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
            this._kt_object = this._dc_factory.datatypedLiteral(this._s_literal, kt_datatype);
            // reset literal
            this._s_literal = "";
            // goto end of statement state
            // at this point, a new statement has been parsed
            this.data();
            // goto next parsing state; bail out of stack
            return this.after_end_of_statement;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("datatype");
            }
        }
        // save state before pausing
        this._f_state = this.datatype;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for post_object
    post_object() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            let i_reset = i;
            // benchmarks confirm: character ref faster than regexes in this context
            let x = s[i];
            // advance index to next token beyond delimiter
            // consume whitespace (and incidentally reset index)
            $9043c565d33eb642$var$R_WS.lastIndex = i + 1;
            $9043c565d33eb642$var$R_WS.exec(s);
            this.i = $9043c565d33eb642$var$R_WS.lastIndex;
            // ',' more objects
            if ("," === x) return this.object_list();
            else if (";" === x) {
                for(;;){
                    // next token is end of outer section
                    let s_peek = s[this.i];
                    if ("." === s_peek || "]" === s_peek || ";" === s_peek) // goto post_object state
                    return this.post_object();
                    else if ("#" === s_peek) {
                        // comment
                        i = this.i;
                        // prepare sticky regex index
                        $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                        // execute regex
                        let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                        // regex was a match
                        if (m_comment) {
                            // advance index
                            this.i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                            if (this.emit_comments) this.emit_comments(m_comment[0]);
                            continue;
                        } else break;
                    } else if (this.i === n) break;
                    else return this.pairs();
                }
                // rather than pushing a dedicated state, just try again next chunk
                i = i_reset;
                break;
            // '.' end of statement
            } else if ("." === x) {
                // assert not nested
                if (this._a_nested.length) {
                    // reset index to that character
                    this.i = i;
                    // emit parse error
                    return this.parse_error("end_of_property_list");
                }
                return this.statement();
            // ']' end of property-object pairs
            } else if ("]" === x) {
                let s_resume_state;
                [this._kt_subject, this._kt_predicate, s_resume_state] = this._a_nested.pop();
                return this[s_resume_state]();
            // ')' end of collection
            } else if (")" === x) // should not be here
            return $9043c565d33eb642$var$Reader$syntax_error(this, i, "post_object", "but encountered end of collection");
            else {
                // prepare sticky regex index
                $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // comment interrupted by eos?
                // match counter: 1
                } else break;
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("post_object");
            }
        }
        // save state before pausing
        this._f_state = this.post_object;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for base_iri
    base_iri() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // prefix id
            // prepare sticky regex index
            $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_iriref_e_base = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.exec(s);
            // regex was a match
            if (m_iriref_e_base) {
                // advance index
                this.i = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex;
                // ref iri
                let s_iri = m_iriref_e_base[1];
                // absolute iri
                if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set base_url
                this._s_base_url = s_iri;
                else this._s_base_url = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                let m_base_iri = $9043c565d33eb642$var$R_BASE_IRI.exec(this._s_base_url);
                this._s_base_url = m_base_iri[1];
                this._s_base_url_root = m_base_iri[2] || "";
                this._s_base_url_scheme = m_base_iri[3] || "";
                this._s_base_url_path = m_base_iri[4] || "";
                // emit base event
                this.emit("base", this._s_base_url);
                if (this._b_expecting_full_stop) // change state
                return this.full_stop();
                // goto prefix iri state
                return this.statement();
            // prefix id
            } else {
                // prepare sticky regex index
                $9043c565d33eb642$var$R_IRIREF.lastIndex = i;
                // execute regex
                let m_iriref_base = $9043c565d33eb642$var$R_IRIREF.exec(s);
                // regex was a match
                if (m_iriref_base) {
                    // advance index
                    this.i = $9043c565d33eb642$var$R_IRIREF.lastIndex;
                    // ref iri
                    let s_iri = m_iriref_base[1].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY);
                    // absolute iri
                    if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set base_url
                    this._s_base_url = s_iri;
                    else this._s_base_url = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                    let m_base_iri = $9043c565d33eb642$var$R_BASE_IRI.exec(this._s_base_url);
                    this._s_base_url = m_base_iri[1];
                    this._s_base_url_root = m_base_iri[2] || "";
                    this._s_base_url_scheme = m_base_iri[3] || "";
                    this._s_base_url_path = m_base_iri[4] || "";
                    // emit base event
                    this.emit("base", this._s_base_url);
                    if (this._b_expecting_full_stop) // change state
                    return this.full_stop();
                    // goto prefix iri state
                    return this.statement();
                // for poorly-placed comments
                } else {
                    // prepare sticky regex index
                    $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                    // execute regex
                    let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                    // regex was a match
                    if (m_comment) {
                        // advance index
                        i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                        if (this.emit_comments) this.emit_comments(m_comment[0]);
                        continue;
                    // match counter: 2
                    } else break;
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("base_iri");
            }
        }
        // save state before pausing
        this._f_state = this.base_iri;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for prefix_id
    prefix_id() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // prefix id
            // prepare sticky regex index
            $9043c565d33eb642$var$R_PREFIX_ID.lastIndex = i;
            // execute regex
            let m_prefix_id = $9043c565d33eb642$var$R_PREFIX_ID.exec(s);
            // regex was a match
            if (m_prefix_id) {
                // advance index
                this.i = $9043c565d33eb642$var$R_PREFIX_ID.lastIndex;
                // set temp prefix id
                this._s_temp_prefix_id = m_prefix_id[1];
                // goto prefix iri state
                return this.prefix_iri();
            // for poorly-placed comments
            } else {
                // prepare sticky regex index
                $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // match counter: 1
                } else break;
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("prefix_id");
            }
        }
        // save state before pausing
        this._f_state = this.prefix_id;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for prefix_iri
    prefix_iri() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            let h_prefixes = this._h_prefixes;
            let s_prefix_id = this._s_temp_prefix_id;
            let p_prefix_iri;
            // prefix iri
            // prepare sticky regex index
            $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_iriref_e_prefix = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.exec(s);
            // regex was a match
            if (m_iriref_e_prefix) {
                // advance index
                this.i = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex;
                // ref iri
                let s_iri = m_iriref_e_prefix[1];
                // absolute iri
                if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set p_prefix_iri
                p_prefix_iri = s_iri;
                else p_prefix_iri = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                let b_relax = this._b_relax;
                // existing mapping
                if (s_prefix_id in h_prefixes) // doesn't match existing
                {
                    if (p_prefix_iri !== h_prefixes[s_prefix_id]) {
                        // emit change event
                        if (this.prefix_change) this.prefix_change(s_prefix_id, h_prefixes[s_prefix_id], p_prefix_iri);
                        // update prefix
                        h_prefixes[s_prefix_id] = p_prefix_iri;
                    }
                } else {
                    // check namespace, invalid
                    if (!b_relax && !$9043c565d33eb642$var$RT_PREFIXED_NAME_NAMESPACE_VALID.test(s_prefix_id)) return this.error(`Invalid namespace for prefixed name: "${s_prefix_id}:"`);
                    // set prefix
                    h_prefixes[s_prefix_id] = p_prefix_iri;
                }
                // check iri, invalid
                if (!b_relax && !$9043c565d33eb642$var$RT_NAMED_NODE_VALID.test(p_prefix_iri)) return this.error(`Invalid IRI found in prefix delcaration: "${s_iri}"`);
                // emit prefix event
                this.event("prefix", s_prefix_id, p_prefix_iri);
                if (this._b_expecting_full_stop) // change state
                return this.full_stop();
                // goto statement state
                return this.statement();
            // prefix iri
            } else {
                // prepare sticky regex index
                $9043c565d33eb642$var$R_IRIREF.lastIndex = i;
                // execute regex
                let m_iriref_prefix = $9043c565d33eb642$var$R_IRIREF.exec(s);
                // regex was a match
                if (m_iriref_prefix) {
                    // advance index
                    this.i = $9043c565d33eb642$var$R_IRIREF.lastIndex;
                    // ref iri
                    let s_iri = m_iriref_prefix[1].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY);
                    // absolute iri
                    if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set p_prefix_iri
                    p_prefix_iri = s_iri;
                    else p_prefix_iri = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                    let b_relax = this._b_relax;
                    // existing mapping
                    if (s_prefix_id in h_prefixes) // doesn't match existing
                    {
                        if (p_prefix_iri !== h_prefixes[s_prefix_id]) {
                            // emit change event
                            if (this.prefix_change) this.prefix_change(s_prefix_id, h_prefixes[s_prefix_id], p_prefix_iri);
                            // update prefix
                            h_prefixes[s_prefix_id] = p_prefix_iri;
                        }
                    } else {
                        // check namespace, invalid
                        if (!b_relax && !$9043c565d33eb642$var$RT_PREFIXED_NAME_NAMESPACE_VALID.test(s_prefix_id)) return this.error(`Invalid namespace for prefixed name: "${s_prefix_id}:"`);
                        // set prefix
                        h_prefixes[s_prefix_id] = p_prefix_iri;
                    }
                    // check iri, invalid
                    if (!b_relax && !$9043c565d33eb642$var$RT_NAMED_NODE_VALID.test(p_prefix_iri)) return this.error(`Invalid IRI found in prefix delcaration: "${s_iri}"`);
                    // emit prefix event
                    this.event("prefix", s_prefix_id, p_prefix_iri);
                    if (this._b_expecting_full_stop) // change state
                    return this.full_stop();
                    // goto statement state
                    return this.statement();
                // for poorly-placed comments
                } else {
                    // prepare sticky regex index
                    $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                    // execute regex
                    let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                    // regex was a match
                    if (m_comment) {
                        // advance index
                        i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                        if (this.emit_comments) this.emit_comments(m_comment[0]);
                        continue;
                    // match counter: 2
                    } else break;
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("prefix_iri");
            }
        }
        // save state before pausing
        this._f_state = this.prefix_iri;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // in case eos happens twice during prefix / base (extremely unlikely)
    // parse state for full_stop
    full_stop() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // prepare sticky regex index
            $9043c565d33eb642$var$R_CHAR_STOP.lastIndex = i;
            if ($9043c565d33eb642$var$R_CHAR_STOP.exec(s)) {
                // advance index
                this.i = $9043c565d33eb642$var$R_CHAR_STOP.lastIndex;
                // resume statement
                return this.statement();
            // poorly-placed comment
            } else {
                // prepare sticky regex index
                $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // possibly interrupted by eos
                // match counter: 1
                } else break;
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("full_stop");
            }
        }
        // save state before pausing
        this._f_state = this.full_stop;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for collection_subject
    collection_subject() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // ref char
            let x = s[i];
            // end of collection
            if (")" === x) {
                // consume whitespace (and incidentally reset index)
                $9043c565d33eb642$var$R_WS.lastIndex = i + 1;
                $9043c565d33eb642$var$R_WS.exec(s);
                this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                // no items in collection subject
                if (null === this._kt_subject) {
                    // prepare subject
                    this._kt_subject = this._kt_rdf_nil;
                    // state was never pushed to stack, jump to post_subject state
                    return this.post_blank_subject();
                }
                // otherwise, there must be items in collection
                // commit collection end
                this._kt_object = this._kt_rdf_nil;
                this.data();
                // restore state from stack
                let s_resume_state;
                [this._kt_subject, this._kt_predicate, s_resume_state] = this._a_nested.pop();
                return this[s_resume_state]();
            }
            // otherwise, pre-emptively secure the next blank node label
            let s_pointer_label;
            // very first collection object
            let b_pushed = false;
            if (null === this._kt_subject) {
                // set quasi subject (really for resume state)
                s_pointer_label = this.next_label();
                this._kt_subject = this.anonymous_blank_node(s_pointer_label);
                this._a_nested.push([
                    this._kt_subject,
                    this._kt_predicate,
                    "pairs"
                ]);
                // reset subject for later conditional branch
                this._kt_subject = null;
                b_pushed = true;
            }
            // iriref
            // prepare sticky regex index
            $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_iriref_e_object = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.exec(s);
            // regex was a match
            if (m_iriref_e_object) {
                // advance index
                i = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex;
                // ref iri
                let s_iri = m_iriref_e_object[1];
                // absolute iri
                if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                this._kt_object = this.check_named_node_escapeless(s_iri);
                else this._kt_object = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
            // prefixed name
            } else {
                // try match
                let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                // stack bail out
                if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                let [m_prefixed_named_e_object, im_prefixed_named_e_object] = aw_valid_this_match_prefixed_name_escapeless;
                if (m_prefixed_named_e_object) {
                    // advance index
                    i = im_prefixed_named_e_object;
                    // check valid prefix
                    let s_prefix_id = m_prefixed_named_e_object[1] || "";
                    // invalid prefix
                    if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                    // commit object iri from resolve prefixed name
                    this._kt_object = this.prefixed_name(s_prefix_id, m_prefixed_named_e_object[2]);
                // string literal
                } else if ('"' === x || "'" === x) {
                    // first item in list
                    if (null === this._kt_subject) {
                        s_pointer_label = this.next_label();
                        this._kt_subject = this.anonymous_blank_node(s_pointer_label);
                        this._kt_predicate = this._kt_rdf_first;
                    } else {
                        // make nest list item
                        s_pointer_label = this.next_label();
                        let kt_blank_node = this._kt_object = this.anonymous_blank_node(s_pointer_label);
                        this.data();
                        // setup for object literal
                        this._kt_subject = kt_blank_node;
                        this._kt_predicate = this._kt_rdf_first;
                    }
                    // how to resume collection subject state after object literal
                    this.after_end_of_statement = function() {
                        this._kt_predicate = this._kt_rdf_rest;
                        this.after_end_of_statement = this.post_object;
                        return this.collection_subject();
                    };
                    return this.string_literal();
                // numeric literal
                } else {
                    // prepare sticky regex index
                    $9043c565d33eb642$var$R_NUMERIC_LITERAL.lastIndex = i;
                    // execute regex
                    let m_numeric_literal = $9043c565d33eb642$var$R_NUMERIC_LITERAL.exec(s);
                    // regex was a match
                    if (m_numeric_literal) {
                        // advance index
                        i = $9043c565d33eb642$var$R_NUMERIC_LITERAL.lastIndex;
                        // it has exponent term, xsd:double
                        if (m_numeric_literal[4]) this._kt_object = this._dc_factory.double(m_numeric_literal[1]);
                        else if (m_numeric_literal[2] || m_numeric_literal[3]) this._kt_object = this._dc_factory.decimal(m_numeric_literal[1]);
                        else this._kt_object = this._dc_factory.integer(m_numeric_literal[1]);
                    // boolean literal
                    } else {
                        // prepare sticky regex index
                        $9043c565d33eb642$var$R_BOOLEAN_LITERAL.lastIndex = i;
                        // execute regex
                        let m_boolean_literal = $9043c565d33eb642$var$R_BOOLEAN_LITERAL.exec(s);
                        // regex was a match
                        if (m_boolean_literal) {
                            // advance index
                            i = $9043c565d33eb642$var$R_BOOLEAN_LITERAL.lastIndex;
                            // make literal
                            this._kt_object = this._dc_factory.boolean(!!m_boolean_literal[1]);
                        // blank node property list
                        } else if ("[" === x) {
                            // advance index to next token
                            // consume whitespace (and incidentally reset index)
                            $9043c565d33eb642$var$R_WS.lastIndex = i + 1;
                            $9043c565d33eb642$var$R_WS.exec(s);
                            this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                            // this blank node is just the next item in the list
                            s_pointer_label = this.next_label();
                            let kt_blank_node;
                            if (null !== this._kt_subject) {
                                kt_blank_node = this._kt_object = this.anonymous_blank_node(s_pointer_label);
                                this.data();
                            }
                            // subject needs to be set
                            this._kt_subject = kt_blank_node || this.anonymous_blank_node(s_pointer_label);
                            this._kt_predicate = this._kt_rdf_first;
                            let s_label = this.next_label();
                            kt_blank_node = this._kt_object = this.anonymous_blank_node(s_label);
                            this.data();
                            // when resume
                            this._kt_predicate = this._kt_rdf_rest;
                            // push state
                            this._a_nested.push([
                                this._kt_subject,
                                this._kt_predicate,
                                "collection_subject"
                            ]);
                            // prepare next triple
                            this._kt_subject = kt_blank_node;
                            // goto parsing pairs state
                            return this.pairs();
                        // new collection
                        } else if ("(" === x) {
                            // consume whitespace (and incidentally reset index)
                            $9043c565d33eb642$var$R_WS.lastIndex = i + 1;
                            $9043c565d33eb642$var$R_WS.exec(s);
                            i = $9043c565d33eb642$var$R_WS.lastIndex;
                            // empty collection
                            if (")" === s[i]) {
                                this.i = i;
                                this._kt_subject = this._a_nested[this._a_nested.length - 1][0];
                                this._kt_predicate = this._kt_rdf_first;
                                this._a_nested.push([
                                    this._kt_subject,
                                    this._kt_rdf_rest,
                                    "collection_subject"
                                ]);
                                return this.collection_object();
                            }
                            // commit list item pointer
                            s_pointer_label = this.next_label();
                            let kt_blank_node = this._kt_object = this.anonymous_blank_node(s_pointer_label);
                            this.data();
                            // add this list as an item to the outer list
                            this._kt_subject = kt_blank_node;
                            this._kt_predicate = this._kt_rdf_rest;
                            this._a_nested.push([
                                this._kt_subject,
                                this._kt_predicate,
                                "collection_object"
                            ]);
                            // prepare next triple
                            this._kt_predicate = this._kt_rdf_first;
                            continue;
                        // labeled blank node
                        } else {
                            // prepare sticky regex index
                            $9043c565d33eb642$var$R_BLANK_NODE_LABEL.lastIndex = i;
                            // execute regex
                            let m_blank_node_label_object = $9043c565d33eb642$var$R_BLANK_NODE_LABEL.exec(s);
                            // regex was a match
                            if (m_blank_node_label_object) {
                                // advance index
                                i = $9043c565d33eb642$var$R_BLANK_NODE_LABEL.lastIndex;
                                // ref blank node label
                                let s_label = m_blank_node_label_object[1];
                                // make object
                                this._kt_object = this.blank_node(s_label);
                            // iriref
                            } else {
                                // prepare sticky regex index
                                $9043c565d33eb642$var$R_IRIREF.lastIndex = i;
                                // execute regex
                                let m_iriref_object = $9043c565d33eb642$var$R_IRIREF.exec(s);
                                // regex was a match
                                if (m_iriref_object) {
                                    // advance index
                                    i = $9043c565d33eb642$var$R_IRIREF.lastIndex;
                                    // ref iri
                                    let s_iri = m_iriref_object[1].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY);
                                    // absolute iri
                                    if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                                    this._kt_object = this.check_named_node(s_iri);
                                    else this._kt_object = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                // prefixed name
                                } else {
                                    // try match
                                    let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                    // stack bail out
                                    if (!aw_valid_this_match_prefixed_name) return true;
                                    let [m_prefixed_named_object, im_prefixed_named_object] = aw_valid_this_match_prefixed_name;
                                    if (m_prefixed_named_object) {
                                        // advance index
                                        i = im_prefixed_named_object;
                                        // check valid prefix
                                        let s_prefix_id = m_prefixed_named_object[1] || "";
                                        // invalid prefix
                                        if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                        // escape local escapes
                                        let s_suffix = m_prefixed_named_object[2].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY).replace($9043c565d33eb642$var$R_PN_LOCAL_ESCAPES, "$1");
                                        // commit object iri from resolve prefixed name
                                        this._kt_object = this.prefixed_name(s_prefix_id, s_suffix);
                                    } else {
                                        // prepare sticky regex index
                                        $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                                        // execute regex
                                        let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                                        // regex was a match
                                        if (m_comment) {
                                            // advance index
                                            i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                                            if (this.emit_comments) this.emit_comments(m_comment[0]);
                                            continue;
                                        // not iriref, not prefixed name, not string literal, not numeric literal, not boolean literal, not blank node property list, not collection
                                        // match counter: 7
                                        } else {
                                            // ran out of characters after pushing state, pop it
                                            if (b_pushed) this._a_nested.pop();
                                            break;
                                        }
                                    } // brace #7
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
            let kt_blank_node_outer;
            if (!s_pointer_label) s_pointer_label = this.next_label();
            // not the very first item of collection subject
            if (this._kt_subject !== null) {
                // ref object
                let w_object = this._kt_object;
                // create blanknode to embed list
                kt_blank_node_outer = this._kt_object = this.anonymous_blank_node(s_pointer_label);
                // emit statement that functions as collection's head "pointer"
                this.data();
                // swap back object
                this._kt_object = w_object;
            }
            // emit statement that is item
            this._kt_subject = kt_blank_node_outer || this.anonymous_blank_node(s_pointer_label);
            this._kt_predicate = this._kt_rdf_first;
            this.data();
            // prepare next predicate
            this._kt_predicate = this._kt_rdf_rest;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("collection_subject");
            }
        }
        // save state before pausing
        this._f_state = this.collection_subject;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for collection_object
    collection_object() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // ref char
            let x = s[i];
            // end of collection
            if (")" === x) {
                // consume whitespace (and incidentally reset index)
                $9043c565d33eb642$var$R_WS.lastIndex = i + 1;
                $9043c565d33eb642$var$R_WS.exec(s);
                this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                // make & emit collection's tail "pointer"
                this._kt_object = this._kt_rdf_nil;
                this.data();
                // restore previous state
                let s_resume_state;
                [this._kt_subject, this._kt_predicate, s_resume_state] = this._a_nested.pop();
                return this[s_resume_state]();
            }
            // otherwise, pre-emptively secure the next blank node label
            let s_pointer_label;
            // iriref
            // prepare sticky regex index
            $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_iriref_e_object = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.exec(s);
            // regex was a match
            if (m_iriref_e_object) {
                // advance index
                i = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex;
                // commit object iri as is
                // ref iri
                let s_iri = m_iriref_e_object[1];
                // absolute iri
                if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                this._kt_object = this.check_named_node_escapeless(s_iri);
                else this._kt_object = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
            // prefixed name
            } else {
                // try match
                let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                // stack bail out
                if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                let [m_prefixed_named_e_object, im_prefixed_named_e_object] = aw_valid_this_match_prefixed_name_escapeless;
                if (m_prefixed_named_e_object) {
                    // advance index
                    i = im_prefixed_named_e_object;
                    // check valid prefix
                    let s_prefix_id = m_prefixed_named_e_object[1] || "";
                    // invalid prefix
                    if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                    // commit object iri from resolve prefixed name
                    this._kt_object = this.prefixed_name(s_prefix_id, m_prefixed_named_e_object[2]);
                // string literal
                } else if ('"' === x || "'" === x) {
                    // update index before changing states
                    this.i = i;
                    // create blanknode to embed list
                    let kt_blank_node = this._kt_object = this.anonymous_blank_node(this.next_label());
                    // emit statement that functions as collection's head "pointer"
                    this.data();
                    // prepare statement that is item
                    this._kt_subject = kt_blank_node;
                    this._kt_predicate = this._kt_rdf_first;
                    this.after_end_of_statement = function() {
                        this._kt_predicate = this._kt_rdf_rest;
                        this.after_end_of_statement = this.post_object;
                        return this.collection_object();
                    };
                    return this.string_literal();
                // numeric literal
                } else {
                    // prepare sticky regex index
                    $9043c565d33eb642$var$R_NUMERIC_LITERAL.lastIndex = i;
                    // execute regex
                    let m_numeric_literal = $9043c565d33eb642$var$R_NUMERIC_LITERAL.exec(s);
                    // regex was a match
                    if (m_numeric_literal) {
                        // advance index
                        i = $9043c565d33eb642$var$R_NUMERIC_LITERAL.lastIndex;
                        // it has exponent term, xsd:double
                        if (m_numeric_literal[4]) this._kt_object = this._dc_factory.double(m_numeric_literal[1]);
                        else if (m_numeric_literal[2] || m_numeric_literal[3]) this._kt_object = this._dc_factory.decimal(m_numeric_literal[1]);
                        else this._kt_object = this._dc_factory.integer(m_numeric_literal[1]);
                    // boolean literal
                    } else {
                        // prepare sticky regex index
                        $9043c565d33eb642$var$R_BOOLEAN_LITERAL.lastIndex = i;
                        // execute regex
                        let m_boolean_literal = $9043c565d33eb642$var$R_BOOLEAN_LITERAL.exec(s);
                        // regex was a match
                        if (m_boolean_literal) {
                            // advance index
                            i = $9043c565d33eb642$var$R_BOOLEAN_LITERAL.lastIndex;
                            // make literal
                            this._kt_object = this._dc_factory.boolean(!!m_boolean_literal[1]);
                        // blank node property list
                        } else if ("[" === x) {
                            // advance index to next token
                            // consume whitespace (and incidentally reset index)
                            $9043c565d33eb642$var$R_WS.lastIndex = i + 1;
                            $9043c565d33eb642$var$R_WS.exec(s);
                            this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                            // commit head of list pointer
                            let kt_blank_node = this._kt_object = this.anonymous_blank_node(this.next_label());
                            this.data();
                            // setup state to resume and push
                            this._kt_subject = kt_blank_node;
                            this._kt_predicate = this._kt_rdf_rest;
                            this._a_nested.push([
                                this._kt_subject,
                                this._kt_predicate,
                                "collection_object"
                            ]);
                            // enter blank node
                            this._kt_predicate = this._kt_rdf_first;
                            kt_blank_node = this._kt_object = this.anonymous_blank_node(this.next_label());
                            this.data();
                            // prepare next triple
                            this._kt_subject = kt_blank_node;
                            this._kt_predicate = this._kt_rdf_first;
                            // goto parsing pairs state
                            return this.pairs();
                        // new collection
                        } else if ("(" === x) {
                            // consume whitespace (and incidentally reset index)
                            $9043c565d33eb642$var$R_WS.lastIndex = i + 1;
                            $9043c565d33eb642$var$R_WS.exec(s);
                            i = $9043c565d33eb642$var$R_WS.lastIndex;
                            // commit list item pointer
                            s_pointer_label = this.next_label();
                            let kt_blank_node = this._kt_object = this.anonymous_blank_node(s_pointer_label);
                            if (null === this._kt_subject) {
                                let a_recent = this._a_nested[this._a_nested.length - 1];
                                this._kt_subject = a_recent[0];
                                this._kt_predicate = a_recent[1];
                            }
                            this.data();
                            // add this list as an item to the outer list
                            this._kt_subject = kt_blank_node;
                            this._kt_predicate = this._kt_rdf_rest;
                            this._a_nested.push([
                                this._kt_subject,
                                this._kt_predicate,
                                "collection_object"
                            ]);
                            // prepare next triple
                            this._kt_predicate = this._kt_rdf_first;
                            continue;
                        // labeled blank node
                        } else {
                            // prepare sticky regex index
                            $9043c565d33eb642$var$R_BLANK_NODE_LABEL.lastIndex = i;
                            // execute regex
                            let m_blank_node_label_object = $9043c565d33eb642$var$R_BLANK_NODE_LABEL.exec(s);
                            // regex was a match
                            if (m_blank_node_label_object) {
                                // advance index
                                i = $9043c565d33eb642$var$R_BLANK_NODE_LABEL.lastIndex;
                                // ref blank node label
                                let s_label = m_blank_node_label_object[1];
                                // make collection pointer label first
                                s_pointer_label = this.next_label();
                                // make object
                                this._kt_object = this.blank_node(s_label);
                            // iriref
                            } else {
                                // prepare sticky regex index
                                $9043c565d33eb642$var$R_IRIREF.lastIndex = i;
                                // execute regex
                                let m_iriref_object = $9043c565d33eb642$var$R_IRIREF.exec(s);
                                // regex was a match
                                if (m_iriref_object) {
                                    // advance index
                                    i = $9043c565d33eb642$var$R_IRIREF.lastIndex;
                                    // commit object iri as is
                                    // ref iri
                                    let s_iri = m_iriref_object[1].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY);
                                    // absolute iri
                                    if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                                    this._kt_object = this.check_named_node(s_iri);
                                    else this._kt_object = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                // prefixed name
                                } else {
                                    // try match
                                    let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                    // stack bail out
                                    if (!aw_valid_this_match_prefixed_name) return true;
                                    let [m_prefixed_named_object, im_prefixed_named_object] = aw_valid_this_match_prefixed_name;
                                    if (m_prefixed_named_object) {
                                        // advance index
                                        i = im_prefixed_named_object;
                                        // check valid prefix
                                        let s_prefix_id = m_prefixed_named_object[1] || "";
                                        // invalid prefix
                                        if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                        // escape local escapes
                                        let s_suffix = m_prefixed_named_object[2].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY).replace($9043c565d33eb642$var$R_PN_LOCAL_ESCAPES, "$1");
                                        // commit object iri from resolve prefixed name
                                        this._kt_object = this.prefixed_name(s_prefix_id, s_suffix);
                                    } else {
                                        // prepare sticky regex index
                                        $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                                        // execute regex
                                        let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                                        // regex was a match
                                        if (m_comment) {
                                            // advance index
                                            i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                                            if (this.emit_comments) this.emit_comments(m_comment[0]);
                                            continue;
                                        // not iriref, not prefixed name, not string literal, not numeric literal, not boolean literal, not blank node property list, not collection
                                        // match counter: 7
                                        } else break;
                                    } // brace #7
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
            // ref object
            let w_object = this._kt_object;
            // create blanknode to embed list
            if (!s_pointer_label) s_pointer_label = this.next_label();
            let kt_blank_node_outer = this._kt_object = this.anonymous_blank_node(s_pointer_label);
            // emit statement that functions as collection's head "pointer"
            this.data();
            // emit statement that is item
            this._kt_subject = kt_blank_node_outer;
            this._kt_predicate = this._kt_rdf_first;
            this._kt_object = w_object;
            this.data();
            // prepare next predicate
            this._kt_predicate = this._kt_rdf_rest;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("collection_object");
            }
        }
        // save state before pausing
        this._f_state = this.collection_object;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    destroy(e_destroy) {
        this.post_blank_subject = ()=>{};
        this.statement = ()=>{};
        this.pairs = ()=>{};
        this.object_list = ()=>{};
        this.string_literal_short_double = ()=>{};
        this.string_literal_short_single = ()=>{};
        this.string_literal_long_double = ()=>{};
        this.string_literal_long_single = ()=>{};
        this.string_literal = ()=>{};
        this.datatype_or_langtag = ()=>{};
        this.datatype = ()=>{};
        this.post_object = ()=>{};
        this.base_iri = ()=>{};
        this.prefix_id = ()=>{};
        this.prefix_iri = ()=>{};
        this.full_stop = ()=>{};
        this.collection_subject = ()=>{};
        this.collection_object = ()=>{};
        this.eof = ()=>{
            this.s = null;
        };
        this._b_destroyed = true;
        // propagate input destroy
        if (!e_destroy && this._ds_input) this._ds_input.destroy(e_destroy);
        this.transform.demolish(e_destroy);
    }
}
$9043c565d33eb642$exports = function(...a_args) {
    let g_config = {};
    // at least one argument
    if (a_args.length) {
        let z_arg_0 = a_args[0];
        // input given unspecified
        if (z_arg_0 && z_arg_0.input && "undefined" === typeof z_arg_0.input.string && !z_arg_0.input.stream) z_arg_0 = z_arg_0.input;
        // string
        if ("string" === typeof z_arg_0) g_config.input = {
            string: z_arg_0
        };
        else if (null === z_arg_0) g_config.input = null;
        else if ("function" === typeof z_arg_0.setEncoding) g_config.input = {
            stream: z_arg_0
        };
        else if ("function" === typeof z_arg_0.pipeTo) throw new TypeError(`Sorry, WHATWG streams are currently not supported :(`);
        else if (z_arg_0 && "object" === typeof z_arg_0 && "[object Object]" === Object.prototype.toString.call(z_arg_0)) {
            g_config = z_arg_0;
            // more args; invalid
            if (a_args.length > 1) throw new TypeError(`unexpected argument(s) after config struct: ${a_args.slice(1)}`);
        } else throw new TypeError(`unexpected input type: ${z_arg_0}`);
        // more args
        if (a_args.length > 1) {
            // copy onto struct
            Object.assign(g_config, a_args[1]);
            // more args
            if (a_args.length > 2) throw new TypeError(`unexpected argument(s) after input and config struct: ${a_args.slice(2)}`);
        }
    }
    // create reader, return transform stream
    return new $9043c565d33eb642$var$Reader(g_config).transform;
};


var $7d44226cc0f38078$exports = {};
// queueMicrotask shim
// not defined or not a function
if ("function" !== typeof queueMicrotask) {
    // create resolved promise
    let dp_resolve = Promise.resolve();
    // try to redefine
    try {
        // eslint-disable-next-line no-global-assign
        queueMicrotask = (fk)=>dp_resolve.then(fk).catch((e_callback)=>setTimeout(()=>{
                    throw e_callback;
                }, 0));
    } // oh well, at least we tried
    catch (e_define) {}
}


const $7d44226cc0f38078$var$RT_ABSOLUTE_IRI_VALID = /^[a-z][a-z0-9+\-.]*:(?:[^\0-\x20<>"{}|^`\\]|\\u[A-Fa-f0-9]{4}|\\U[A-Fa-f0-9]{8})*$/;
const $7d44226cc0f38078$var$RT_ABSOLUTE_IRI_ESCAPELESS_VALID = /^[a-z][a-z0-9+\-.]*:[^\0-\x20<>"{}|^`]*$/;
const $7d44226cc0f38078$var$RT_NAMED_NODE_VALID = /^([^\0-\x20<>"{}|^`\\]|\\u[A-Fa-f0-9]{4}|\\U[A-Fa-f0-9]{8})*$/;
const $7d44226cc0f38078$var$RT_NAMED_NODE_ESCAPELESS_VALID = /^([^\0-\x20<>"{}|^`])*$/;
const $7d44226cc0f38078$var$R_UNICODE_ANY = /\\u([0-9A-Fa-f]{4})|\\U([0-9A-Fa-f]{8})/g;
const $7d44226cc0f38078$var$F_REPLACE_UNICODE_ANY = (s_, s_4, s_8)=>String.fromCodePoint(parseInt(s_4 || s_8, 16));
const $7d44226cc0f38078$var$R_CLEAN = /\s*(?:#[^\n]*\n\s*)*\s*/y;
const $7d44226cc0f38078$var$R_CLEAN_COMMENTS = /\s*(#[^\n]*\n\s*)*\s*/y;
const $7d44226cc0f38078$var$RT_HAS_ESCAPES = /[\\]/;
const $7d44226cc0f38078$var$R_EOL = /[^\n]+\n/y;
// eslint-disable-next-line no-misleading-character-class
const $7d44226cc0f38078$var$RT_BLANK_NODE_LABEL_VALID = /^(?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_0-9])(?:(?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}.])*[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}])?$/u;
const $7d44226cc0f38078$var$RT_LANGUAGE_VALID = /^[a-z]+(-[a-z0-9]+)*$/;
const $7d44226cc0f38078$var$R_WS = /\s*/y;
const $7d44226cc0f38078$var$R_HWS = /[ \t]*/y;
const $7d44226cc0f38078$var$R_LANGTAG = /@([A-Za-z]+(?:-[A-Za-z0-9-]+)*)(?:\s+|(?=[.,;\])#]))/y;
const $7d44226cc0f38078$var$R_IRIREF = /<([^>]*)>\s*/y;
const $7d44226cc0f38078$var$F_REPLACE_STRLIT_CONTENTS = (s_, s_whitespace, s_auto, s_4, s_8, s_invalid)=>{
    if (s_whitespace) switch(s_whitespace){
        case "t":
            return "	";
        case "n":
            return "\n";
        case "r":
            return "\r";
        case "f":
            return "\f";
        case "b":
            return "\b";
        default:
            console.assert(`bad regex escape char mapping: '${s_whitespace}'`);
    }
    else if (s_auto) return s_auto;
    else if (s_4) return String.fromCodePoint(parseInt(s_4, 16));
    else if (s_8) return String.fromCodePoint(parseInt(s_8, 16));
    else if (s_invalid) {
        // pointless escape
        if ("\\" === s_invalid[0]) // // relaxed
        // return s_invalid[1];
        // if relaxed then return s_invalid, otherwise throw:
        throw new Error(`expected string_literal but invalid escape sequence within contents: '${s_invalid}'. failed to parse a valid token`);
        else throw new Error(`expected string_literal but invalid whitespace character within contents: ${JSON.stringify(s_invalid)}. failed to parse a valid token`);
    } else console.assert(`unexpected no match branch in escape sequence replace callback`);
};
const $7d44226cc0f38078$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_HARD = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|([\r\n]|\\.))/g;
const $7d44226cc0f38078$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|([\r\n]|\\[^uU]|\\u[^]{4}|\\U[^]{8}))/g;
const $7d44226cc0f38078$var$unescape_literal_short_hard = (s_literal)=>s_literal.replace($7d44226cc0f38078$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_HARD, $7d44226cc0f38078$var$F_REPLACE_STRLIT_CONTENTS);
const $7d44226cc0f38078$var$unescape_literal_short_soft = (s_literal)=>{
    let m_incomplete = $7d44226cc0f38078$var$R_STRLIT_ESCAPE_INCOMPLETE.exec(s_literal);
    // incomplete escape
    if (m_incomplete) {
        let i_safe = m_incomplete.index;
        // rewind
        return [
            s_literal.slice(0, i_safe).replace($7d44226cc0f38078$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT, $7d44226cc0f38078$var$F_REPLACE_STRLIT_CONTENTS),
            s_literal.slice(i_safe)
        ];
    } else return [
        s_literal.replace($7d44226cc0f38078$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT, $7d44226cc0f38078$var$F_REPLACE_STRLIT_CONTENTS),
        ""
    ];
};
// lookbehind regexes
const [$7d44226cc0f38078$var$R_STRLIT_ESCAPE_INCOMPLETE, $7d44226cc0f38078$var$R_STRLIT_SHORT_DOUBLE_TERM] = (()=>{
    function RegExp_$lookbehind_polyfill(s_input) {
        let m_match = RegExp.prototype.exec.call(this, s_input);
        if (m_match) {
            let i_start = m_match[0].length - m_match[1].length;
            m_match.index += i_start;
            m_match[0] = m_match[0].slice(i_start);
        }
        return m_match;
    }
    let mk_lookbehind_regex = (()=>{
        try {
            new RegExp("(?<!h)i"); // eslint-disable-line no-new
        } catch (e_compile) {
            return (f_lookbehind, r_polyfill, f_polyfill)=>{
                r_polyfill.exec = f_polyfill;
                return r_polyfill;
            };
        }
        return (f_lookbehind)=>f_lookbehind();
    })();
    return [
        // R_STRLIT_ESCAPE_INCOMPLETE
        mk_lookbehind_regex(()=>new RegExp("(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)\\\\(|u[0-9A-Fa-f]{0,3}|U[0-9A-Fa-f]{0,7})$"), /^(?:(?:[^\\]|\\.)*)(\\(?:|u[0-9A-Fa-f]{0,3}|U[0-9A-Fa-f]{0,7}))$/, function RegExp_$lookbehind_polyfill_n(s_input) {
            let m_match = RegExp.prototype.exec.call(this, s_input);
            if (m_match) m_match.index += m_match[0].length - m_match[1].length;
            return m_match;
        }),
        // R_STRLIT_SHORT_DOUBLE_TERM
        mk_lookbehind_regex(()=>new RegExp('(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)"\\s*', "g"), /(?:[^\\"]|\\.)*("\s*)/y, RegExp_$lookbehind_polyfill)
    ];
})();
const $7d44226cc0f38078$var$R_TRIPLE_ESCAPELESS_SP = /(?:<([^\\>]*)>|_:([^\x20\t<]+))[\x20\t]*<([^\\>]*)>[\x20\t]*(?:(?:(<[^\\>]*)>|_:([^\x20\t<]+))[\x20\t]*\.\s*(#[^\n]*\n\s*|\n\s*)+|"([^"\\]*)(?:(")(?:\^\^<([^\\>]*)>|@([^\x20\t.]+)|)[\x20\t]*\.\s*(#[^\n]*\n\s*|\n\s*)+)?)/y;
const $7d44226cc0f38078$var$R_TRIPLE = /(?:<([^>]*)>|_:([^\x20\t<]+))[\x20\t]*<([^>]*)>[\x20\t]*(?:(?:(<[^>]*)>|_:([^\x20\t<]+))[\x20\t]*\.\s*(#[^\n]*\n\s*|\n\s*)+|"((?:[^"\\]|\\.)*)(?:(")(?:\^\^<([^>]*)>|@([^\x20\t.]+)|)[\x20\t]*\.\s*(#[^\n]*\n\s*|\n\s*)+)?)/y;
class $7d44226cc0f38078$var$NTriples_Reader extends $141f1697ab3cba12$exports.Transform {
    constructor(g_impls){
        super({
            // do not decode strings into buffers
            decodeStrings: false,
            // accept strings as input on writable side
            writableObjectMode: false,
            // output quad objects on readable side
            readableObjectMode: true,
            // implementations
            flush: g_impls.flush,
            transform: g_impls.transform
        });
        // when the writable side is piped into
        this.on("pipe", (ds_input)=>{
            this._ds_input = ds_input;
            // input stream has encoding option; ensure stream encoding is utf8
            if ("function" === typeof ds_input.setEncoding) ds_input.setEncoding("utf8");
        });
    }
    // intercept pipe
    pipe(ds_out) {
        let ds_dst = ds_out;
        // non-object mode
        if (!ds_dst._writableState.objectMode) // transform to JSON
        ds_out = $141f1697ab3cba12$exports.quads_to_json();
        else if (ds_out.isGraphyWritable) // transform to quad-stream
        ds_out = $141f1697ab3cba12$exports.quads_to_writable();
        // interim stream created
        if (ds_out !== ds_dst) {
            // forward output to super
            super.pipe(ds_out);
            // pipe outpu to destination
            return ds_out.pipe(ds_dst);
        } else return super.pipe(ds_dst);
    }
}
class $7d44226cc0f38078$var$Reader {
    constructor(g_config){
        let { // input medium
        input: g_input = null, // relax validation
        relax: b_relax = false, // debug
        debug: b_debug = false } = g_config;
        // allow relative iris flag
        let b_allow_relative_iris = g_config.allow_relative_iris || g_config.allowRelativeIRIs || g_config.allowRelativeIris || false;
        // adopt factory
        let dc_factory = this._dc_factory = $266825253b7f24dc$exports.adopt(g_config.dataFactory || g_config.data_factory || $266825253b7f24dc$exports.unfiltered);
        let f_quad = this._f_quad = dc_factory.quad;
        // fields
        Object.assign(this, {
            // string buffer, accept left-over string from previous data chunk
            s: g_config.prepend || "",
            // string buffer length
            n: 0,
            _b_debug: b_debug,
            _b_relax: b_relax,
            _b_destroyed: false,
            _b_trim_start: true,
            _f_state: this.statement,
            _kt_subject: null,
            _kt_predicate: null,
            _s_literal: ""
        });
        this._kt_default_graph = dc_factory.defaultGraph();
        this._kt_rdfs_lang_string = dc_factory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#langString");
        // clean regex
        let r_clean = this._r_clean = $7d44226cc0f38078$var$R_CLEAN;
        if (g_config.relaxed) console.warn(new Error(`no such option 'relaxed'; did you mean 'relax' ?`).stack.replace(/^Error:/, "Warning:"));
        if ("validate" in g_config) console.warn(new Error(`option 'validate' has been removed and validation is now on by default. Use 'relax' option if you wish to disable validation.`).stack.replace(/^Error:/, "Warning:"));
        let namedNode = dc_factory.namedNode;
        let blankNode = dc_factory.blankNode;
        let languagedLiteral = dc_factory.languagedLiteral;
        // test for valid named node
        let rt_named_node_valid = b_allow_relative_iris ? $7d44226cc0f38078$var$RT_NAMED_NODE_VALID : $7d44226cc0f38078$var$RT_ABSOLUTE_IRI_VALID;
        // test for valid named node escapeless
        let rt_named_node_valid_escapeless = b_allow_relative_iris ? $7d44226cc0f38078$var$RT_NAMED_NODE_ESCAPELESS_VALID : $7d44226cc0f38078$var$RT_ABSOLUTE_IRI_ESCAPELESS_VALID;
        // validation
        let k_self = this;
        Object.assign(this, !b_relax ? {
            create_named_node (p_iri) {
                if (!rt_named_node_valid.test(p_iri)) return k_self._error(`invalid IRI: "${p_iri}"`);
                return namedNode(p_iri);
            },
            create_named_node_escapeless (p_iri) {
                if (!rt_named_node_valid_escapeless.test(p_iri)) return k_self._error(`invalid IRI: "${p_iri}"`);
                return namedNode(p_iri);
            },
            create_blank_node (s_label) {
                if (!$7d44226cc0f38078$var$RT_BLANK_NODE_LABEL_VALID.test(s_label)) return k_self._error(`Invalid blank node label: "${s_label}"`);
                return blankNode(s_label);
            },
            create_languaged_literal (s_contents, s_language) {
                if (!$7d44226cc0f38078$var$RT_LANGUAGE_VALID.test(s_language)) return k_self._error(`Invalid literal language tag: ${s_language}`);
                return languagedLiteral(s_contents, s_language);
            }
        } : {
            create_named_node: namedNode,
            create_named_node_escapeless: namedNode,
            create_blank_node: blankNode,
            create_languaged_literal: languagedLiteral
        });
        // transform stream
        let ds_transform;
        // whether or not data has been received before
        let b_init = false;
        // create transform
        ds_transform = this.transform = new $7d44226cc0f38078$var$NTriples_Reader({
            // on data event
            transform: (s_chunk, s_encoding, fk_chunk)=>{
                // first transform
                if (!b_init) {
                    // notify that data will begin
                    ds_transform.emit("ready");
                    // do not emit 'ready' event again
                    b_init = false;
                }
                // concatenate current chunk to previous chunk
                let s = this.s += s_chunk;
                // remove whitespace & comments from beginning
                if (this._b_trim_start) {
                    r_clean.lastIndex = 0;
                    let m_clean = r_clean.exec(s);
                    if (this.emit_comments) this.emit_comments(m_clean[1]);
                    // update index and prepare to match statement
                    this.i = r_clean.lastIndex;
                } else this.i = 0;
                // cache chunk length
                this.n = s.length;
                // resume parsing
                try {
                    this.parse(true);
                } // read error occurred; emit and destroy stream
                catch (e_read) {
                    return ds_transform.destroy(e_read);
                }
                // emit progress event updates
                ds_transform.emit("progress", s_chunk.length);
                // done transforming this chunk
                fk_chunk();
            },
            // once there's no more data to consume, invoke eof
            flush: (fk_flush)=>{
                // there is still unparsed data
                if (this.s.length) {
                    // append newline to end so we can match token
                    this.s += "\n";
                    // remove whitespace & comments from beginning
                    if (this._b_trim_start) {
                        r_clean.lastIndex = 0;
                        let m_clean = r_clean.exec(this.s);
                        if (this.emit_comments) this.emit_comments(m_clean[1]);
                        // update index and prepare to match statement
                        this.i = r_clean.lastIndex;
                    } else this.i = 0;
                    // parse
                    try {
                        this.parse();
                    } // read error occurred; pass to flush errback and exit method
                    catch (e_read) {
                        // destroying during flush means overriding push
                        return ds_transform.demolish(e_read);
                    }
                    // still unparsed characters; pass to flush errback and exit method
                    if (this.s.length) return ds_transform.demolish(new Error(`parsing error occurred in state: statement\n  ${this.s.substr(0, 50)}\n  ^ starting here`));
                }
                // invalid state
                if (this._f_state !== this.statement) return ds_transform.demolish(new Error(`parsing error occurred in state: ${this._f_state.name}\n  ${this.s.substr(0, 50)}\n  ^ starting here`));
                // make buffer's alloc eligible for gc
                this.s = null;
                // final progress update: no additional bytes were read
                ds_transform.emit("progress", 0);
                // call end event listener
                ds_transform.emit("eof");
                // done flushing, close read stream
                fk_flush();
            }
        });
        // destroy
        ds_transform._destroy = (...a_args)=>{
            this.destroy(...a_args);
        };
        // data quad
        this._f_data_quad = (kt_subject, kt_predicate, kt_object, kt_graph)=>ds_transform.push(f_quad(kt_subject, kt_predicate, kt_object, kt_graph));
        // new listener added
        ds_transform.on("newListener", (s_event)=>{
            // comment
            if ("comment" === s_event) {
                r_clean = $7d44226cc0f38078$var$R_CLEAN_COMMENTS;
                this.emit_comments = (s_captured)=>{
                    if (!s_captured) return;
                    let a_comments = s_captured.slice(1).replace(/\n\s+$/, "").split(/\n+\s*#/g);
                    for (let s_comment of a_comments)ds_transform.emit("comment", s_comment);
                };
            }
        });
        // bind events to transform stream
        this.bind(g_config);
        // input given
        if (g_input) {
            // input is stream
            if (g_input.stream) {
                let ds_input = g_input.stream;
                // go async so caller has chance to bind event listeners
                queueMicrotask(()=>{
                    ds_input.pipe(ds_transform);
                });
            } else if ("string" === typeof g_input.string) {
                let s_input = g_input.string;
                // go async so caller has chance to bind event listeners
                queueMicrotask(()=>{
                    ds_transform.end(s_input, "utf8");
                });
            } else throw new TypeError(`Invalid argument for input parameter: ${"object" === typeof g_input ? JSON.stringify(g_input) : g_input}`);
        }
        ds_transform._graphy_reader = this;
    }
    _error(s_message) {
        this._b_destroyed = true;
        throw new Error(s_message);
    }
    bind(g_config) {
        let ds_transform = this.transform;
        if (g_config.error) ds_transform.on("error", g_config.error);
        if (g_config.comment) ds_transform.on("comment", g_config.comment);
        if (g_config.read) ds_transform.once("read", g_config.read);
        if (g_config.progress) ds_transform.on("progress", g_config.progress);
        if (g_config.eof) ds_transform.once("eof", g_config.eof);
        if (g_config.end) ds_transform.once("end", g_config.end);
        if (g_config.finish) ds_transform.once("finish", g_config.finish);
        if (g_config.data) ds_transform.on("data", g_config.data);
    }
    // begin parsing, keep applying until no more stack bail-outs
    parse() {
        let f_sync = this._f_state();
        while("function" === typeof f_sync)f_sync = f_sync.apply(this);
    }
    statement() {
        let s = this.s;
        let n = this.n;
        let i = this.i;
        let f_data_quad = this._f_data_quad;
        let create_named_node = this.create_named_node;
        let create_named_node_escapeless = this.create_named_node_escapeless;
        let create_languaged_literal = this.create_languaged_literal;
        let create_blank_node = this.create_blank_node;
        let simpleLiteral = this._dc_factory.simpleLiteral;
        let datatypedLiteral = this._dc_factory.datatypedLiteral;
        let kt_default_graph = this._kt_default_graph;
        // match triples/quads
        for(;;){
            // prepare sticky regex index
            $7d44226cc0f38078$var$R_TRIPLE_ESCAPELESS_SP.lastIndex = i;
            // execute regex
            let m_statement_e_sp = $7d44226cc0f38078$var$R_TRIPLE_ESCAPELESS_SP.exec(s);
            // regex was a match
            if (m_statement_e_sp) {
                // advance index
                i = $7d44226cc0f38078$var$R_TRIPLE_ESCAPELESS_SP.lastIndex;
                // prep object term
                let kt_object;
                // object term type is named node
                if (m_statement_e_sp[4]) {
                    let p_object = m_statement_e_sp[4].slice(1);
                    kt_object = create_named_node_escapeless(p_object);
                } else if (m_statement_e_sp[5]) kt_object = create_blank_node(m_statement_e_sp[5]);
                else {
                    // contents
                    let s_contents = m_statement_e_sp[7];
                    // string terminator
                    if (m_statement_e_sp[8]) {
                        // datatype is present
                        if (m_statement_e_sp[9]) {
                            // create datatype term
                            let kt_datatype = this.create_named_node_escapeless(m_statement_e_sp[9]);
                            // create object term
                            kt_object = datatypedLiteral(s_contents, kt_datatype);
                        } else if (m_statement_e_sp[10]) {
                            // normalize language
                            let s_language = m_statement_e_sp[10].toLowerCase();
                            // create object term
                            kt_object = create_languaged_literal(s_contents, s_language);
                        } else kt_object = simpleLiteral(s_contents);
                    } else {
                        // save contents
                        this._s_literal = s_contents;
                        // update index
                        this.i = i;
                        // save subject
                        {
                            let s_subject = m_statement_e_sp[1];
                            // named node
                            if (s_subject || "string" === typeof s_subject) this._kt_subject = create_named_node_escapeless(s_subject);
                            else this._kt_subject = create_blank_node(m_statement_e_sp[2]);
                        }
                        // save predicate
                        this._kt_predicate = create_named_node_escapeless(m_statement_e_sp[3]);
                        // parse contents
                        let z_bail = this.strlit_contents();
                        // bail out of stack
                        if (z_bail && this.statement !== z_bail) return z_bail;
                        else {
                            // clean
                            let r_clean = this._r_clean;
                            r_clean.lastIndex = this.i;
                            let m_clean = r_clean.exec(s);
                            if (this.emit_comments) this.emit_comments(m_clean[1]);
                            // update local index and prepare to match next statement
                            i = r_clean.lastIndex;
                            continue;
                        }
                    }
                }
                let kt_subject;
                {
                    let s_subject = m_statement_e_sp[1];
                    // named node
                    if (s_subject || "string" === typeof s_subject) kt_subject = create_named_node_escapeless(s_subject);
                    else kt_subject = create_blank_node(m_statement_e_sp[2]);
                }
                let s_predicate = m_statement_e_sp[3];
                // emit data event
                f_data_quad(kt_subject, create_named_node_escapeless(s_predicate), kt_object, kt_default_graph);
                // comments
                if (this.emit_comments) this.emit_comments(m_statement_e_sp[6] || m_statement_e_sp[11]);
            } else {
                // prepare sticky regex index
                $7d44226cc0f38078$var$R_TRIPLE.lastIndex = i;
                // execute regex
                let m_statement = $7d44226cc0f38078$var$R_TRIPLE.exec(s);
                // regex was a match
                if (m_statement) {
                    // advance index
                    i = $7d44226cc0f38078$var$R_TRIPLE.lastIndex;
                    // prep object term
                    let kt_object;
                    // object term type is named node
                    if (m_statement[4]) {
                        let p_object = m_statement[4].slice(1);
                        kt_object = create_named_node($7d44226cc0f38078$var$RT_HAS_ESCAPES.test(p_object) ? p_object.replace($7d44226cc0f38078$var$R_UNICODE_ANY, $7d44226cc0f38078$var$F_REPLACE_UNICODE_ANY) : p_object);
                    } else if (m_statement[5]) kt_object = create_blank_node($7d44226cc0f38078$var$RT_HAS_ESCAPES.test(m_statement[5]) ? m_statement[5].replace($7d44226cc0f38078$var$R_UNICODE_ANY, $7d44226cc0f38078$var$F_REPLACE_UNICODE_ANY) : m_statement[5]);
                    else {
                        // contents
                        let s_contents = m_statement[7];
                        // string terminator
                        if (m_statement[8]) {
                            // unescape contents
                            s_contents = $7d44226cc0f38078$var$unescape_literal_short_hard(s_contents);
                            // datatype is present
                            if (m_statement[9]) {
                                // create datatype term
                                let kt_datatype = this.create_named_node(m_statement[9]);
                                // create object term
                                kt_object = datatypedLiteral(s_contents, kt_datatype);
                            } else if (m_statement[10]) {
                                // normalize language
                                let s_language = m_statement[10].toLowerCase();
                                // create object term
                                kt_object = create_languaged_literal(s_contents, s_language);
                            } else kt_object = simpleLiteral(s_contents);
                        } else {
                            // save contents
                            this._s_literal = s_contents;
                            // update index
                            this.i = i;
                            // save subject
                            {
                                let s_subject = m_statement[1];
                                // named node
                                if (s_subject || "string" === typeof s_subject) this._kt_subject = create_named_node($7d44226cc0f38078$var$RT_HAS_ESCAPES.test(s_subject) ? s_subject.replace($7d44226cc0f38078$var$R_UNICODE_ANY, $7d44226cc0f38078$var$F_REPLACE_UNICODE_ANY) : s_subject);
                                else this._kt_subject = create_blank_node(m_statement[2]);
                            }
                            // save predicate
                            this._kt_predicate = create_named_node($7d44226cc0f38078$var$RT_HAS_ESCAPES.test(m_statement[3]) ? m_statement[3].replace($7d44226cc0f38078$var$R_UNICODE_ANY, $7d44226cc0f38078$var$F_REPLACE_UNICODE_ANY) : m_statement[3]);
                            // parse contents
                            let z_bail = this.strlit_contents();
                            // bail out of stack
                            if (z_bail && this.statement !== z_bail) return z_bail;
                            else {
                                // clean
                                let r_clean = this._r_clean;
                                r_clean.lastIndex = this.i;
                                let m_clean = r_clean.exec(s);
                                if (this.emit_comments) this.emit_comments(m_clean[1]);
                                // update local index and prepare to match next statement
                                i = r_clean.lastIndex;
                                continue;
                            }
                        }
                    }
                    let kt_subject;
                    {
                        let s_subject = m_statement[1];
                        // named node
                        if (s_subject || "string" === typeof s_subject) kt_subject = create_named_node($7d44226cc0f38078$var$RT_HAS_ESCAPES.test(s_subject) ? s_subject.replace($7d44226cc0f38078$var$R_UNICODE_ANY, $7d44226cc0f38078$var$F_REPLACE_UNICODE_ANY) : s_subject);
                        else kt_subject = create_blank_node(m_statement[2]);
                    }
                    let s_predicate = m_statement[3];
                    // emit data event
                    f_data_quad(kt_subject, create_named_node($7d44226cc0f38078$var$RT_HAS_ESCAPES.test(s_predicate) ? s_predicate.replace($7d44226cc0f38078$var$R_UNICODE_ANY, $7d44226cc0f38078$var$F_REPLACE_UNICODE_ANY) : s_predicate), kt_object, kt_default_graph);
                    // comments
                    if (this.emit_comments) this.emit_comments(m_statement[6] || m_statement[11]);
                } else {
                    // prepare sticky regex index
                    $7d44226cc0f38078$var$R_EOL.lastIndex = i;
                    if ($7d44226cc0f38078$var$R_EOL.exec(s)) {
                        // advance index
                        i = $7d44226cc0f38078$var$R_EOL.lastIndex;
                        this._error(`Failed to read statement:\n\`${s.substr(i, 80).replace(/\n/g, "\u23CE")} [...]\`\n ^ starting here`);
                    // match counter: 2
                    } else break;
                } // brace #2
            } // brace #1
        } // end of while
        // update unparsed data string
        this.s = s.substr(i);
        // resume here
        this._f_state = this.statement;
        // exit
        return 1;
    }
    strlit_contents() {
        let { s: s, n: n, i: i } = this;
        // try to find end
        $7d44226cc0f38078$var$R_STRLIT_SHORT_DOUBLE_TERM.lastIndex = i;
        let m_term = $7d44226cc0f38078$var$R_STRLIT_SHORT_DOUBLE_TERM.exec(s);
        // end is in this chunk
        if (m_term) {
            // index of terminator
            let i_term = m_term.index;
            // extract dirty potion
            let s_dirty = s.slice(i, i_term);
            // clean and save
            this._s_literal += $7d44226cc0f38078$var$unescape_literal_short_hard(s_dirty);
            // advance index beyond terminator
            this.i = i_term + m_term[0].length;
            // resume eating whitespace at start of next chunk
            this._b_trim_start = true;
            // proceed with datatype_or_lang, then bail out of stack or resume parsing
            return this.datatype_or_langtag() || this.statement;
        } else {
            // extract whole portion
            let s_dirty = s.slice(i);
            // unescape to clean part
            let [s_clean, s_incomplete] = $7d44226cc0f38078$var$unescape_literal_short_soft(s_dirty);
            // save
            this._s_literal += s_clean;
            // set unparsed index
            this.i = i = n - s_incomplete.length;
            // do not eat whitespace at start of next chunk
            this._b_trim_start = false;
        }
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("strlit_contents");
            }
        }
        // resume here
        this._f_state = this.strlit_contents;
        // store what is unparsed
        this.s = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return 1;
    }
    // parse state for datatype_or_langtag
    datatype_or_langtag() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // ref character
        let x = s[i];
        while(i < n){
            // datatype
            if ("^" === x) {
                // enough to speculate datatype
                if (i + 2 < n) {
                    // correct token
                    if ("^" === s[i + 1]) {
                        // advance index beyond token
                        $7d44226cc0f38078$var$R_IRIREF.lastIndex = i + 2;
                        // execute regex
                        let m_iriref = $7d44226cc0f38078$var$R_IRIREF.exec(s);
                        // regex was a match
                        if (m_iriref) {
                            // advance index
                            this.i = $7d44226cc0f38078$var$R_IRIREF.lastIndex;
                            // prepare iri
                            let p_datatype = m_iriref[1].replace($7d44226cc0f38078$var$R_UNICODE_ANY, $7d44226cc0f38078$var$F_REPLACE_UNICODE_ANY);
                            // create datatype term
                            let kt_datatype = this.create_named_node(p_datatype);
                            // create object term
                            let kt_object = this._dc_factory.datatypedLiteral(this._s_literal, kt_datatype);
                            // free literal string
                            this._s_literal = "";
                            // emit data event
                            this._f_data_quad(this._kt_subject, this._kt_predicate, kt_object, this._kt_default_graph);
                            // complete with statement_term
                            return this.statement_term();
                        } else break;
                    } else this._error(`Failed to read token after literal:\n\`${s.substr(i + 1, 80).replace(/\n/g, "\u23CE")} [...]\`\n ^ starting here`);
                } else break;
            } else if ("@" === x) {
                // prepare sticky regex index
                $7d44226cc0f38078$var$R_LANGTAG.lastIndex = i;
                // execute regex
                let m_langtag = $7d44226cc0f38078$var$R_LANGTAG.exec(s);
                // regex was a match
                if (m_langtag) {
                    // advance index
                    this.i = $7d44226cc0f38078$var$R_LANGTAG.lastIndex;
                    // use direct factory method since regex is validation
                    let kt_object = this._dc_factory.languagedLiteral(this._s_literal, m_langtag[1]);
                    // free literal string
                    this._s_literal = "";
                    // emit data event
                    this._f_data_quad(this._kt_subject, this._kt_predicate, kt_object, this._kt_default_graph);
                    // complete with statement_term
                    return this.statement_term();
                } else break;
            } else if ("." === x) {
                // save simple literal
                let kt_object = this._dc_factory.simpleLiteral(this._s_literal);
                // free literal string
                this._s_literal = "";
                // advance index beyond terminator
                this.i = i + 1;
                // emit data event
                this._f_data_quad(this._kt_subject, this._kt_predicate, kt_object, this._kt_default_graph);
                // reset state
                return this.statement;
            // // consume whitespace (and incidentally reset index)
            // R_WS.lastIndex = i + 1;
            // R_WS.exec(s);
            // this.i = R_WS.lastIndex;
            // // done
            // return;
            } else break;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("datatype_or_langtag");
            }
        }
        // resume here
        this._f_state = this.datatype_or_langtag;
        // store what is unparsed
        this.s = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return 1;
    }
    statement_term() {
        let { s: s, n: n, i: i } = this;
        // find full stop
        let i_stop = s.indexOf(".", i);
        // found
        if (i_stop > -1) {
            // consume whitespace again
            this._b_trim_start = true;
            // advance beyond token
            this.i = i_stop + 1;
            // reset state
            return this.statement;
        } else if (!/^\s*$/.test(s.slice(i))) this.parse_error("statement_term");
        // do not consume whitespace
        this._b_trim_start = false;
        // resume here
        this._f_state = this.statement_term;
        // store what is unparsed
        this.s = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return 1;
    }
    parse_error(s_state) {
        return this._error(`Failed to read ${s_state}:\n\`${this.s.substr(this.i, 80).replace(/\n/g, "\u23CE")} [...]\`\n ^ starting here`);
    }
    destroy(e_destroy) {
        this._f_data_quad = ()=>{};
        if (!e_destroy && this._ds_input) this._ds_input.destroy(e_destroy);
        this.transform.demolish(e_destroy);
    }
}
$7d44226cc0f38078$exports = function(...a_args) {
    let g_config = {};
    // at least one argument
    if (a_args.length) {
        let z_arg_0 = a_args[0];
        // input given unspecified
        if (z_arg_0 && z_arg_0.input && "undefined" === typeof z_arg_0.input.string && !z_arg_0.input.stream) z_arg_0 = z_arg_0.input;
        // string
        if ("string" === typeof z_arg_0) g_config.input = {
            string: z_arg_0
        };
        else if (null === z_arg_0) g_config.input = null;
        else if ("function" === typeof z_arg_0.setEncoding) g_config.input = {
            stream: z_arg_0
        };
        else if ("function" === typeof z_arg_0.pipeTo) throw new TypeError(`Sorry, WHATWG streams are currently not supported :(`);
        else if (z_arg_0 && "object" === typeof z_arg_0 && "[object Object]" === Object.prototype.toString.call(z_arg_0)) {
            g_config = z_arg_0;
            // more args; invalid
            if (a_args.length > 1) throw new TypeError(`unexpected argument(s) after config struct: ${a_args.slice(1)}`);
        } else throw new TypeError(`unexpected input type: ${z_arg_0}`);
        // more args
        if (a_args.length > 1) {
            // copy onto struct
            Object.assign(g_config, a_args[1]);
            // more args
            if (a_args.length > 2) throw new TypeError(`unexpected argument(s) after input and config struct: ${a_args.slice(2)}`);
        }
    }
    // create reader, return transform stream
    return new $7d44226cc0f38078$var$Reader(g_config).transform;
};


var $0a4e3e68448dada6$exports = {};
// queueMicrotask shim
// not defined or not a function
if ("function" !== typeof queueMicrotask) {
    // create resolved promise
    let dp_resolve = Promise.resolve();
    // try to redefine
    try {
        // eslint-disable-next-line no-global-assign
        queueMicrotask = (fk)=>dp_resolve.then(fk).catch((e_callback)=>setTimeout(()=>{
                    throw e_callback;
                }, 0));
    } // oh well, at least we tried
    catch (e_define) {}
}


const $0a4e3e68448dada6$var$RT_ABSOLUTE_IRI_VALID = /^[a-z][a-z0-9+\-.]*:(?:[^\0-\x20<>"{}|^`\\]|\\u[A-Fa-f0-9]{4}|\\U[A-Fa-f0-9]{8})*$/;
const $0a4e3e68448dada6$var$RT_ABSOLUTE_IRI_ESCAPELESS_VALID = /^[a-z][a-z0-9+\-.]*:[^\0-\x20<>"{}|^`]*$/;
const $0a4e3e68448dada6$var$RT_NAMED_NODE_VALID = /^([^\0-\x20<>"{}|^`\\]|\\u[A-Fa-f0-9]{4}|\\U[A-Fa-f0-9]{8})*$/;
const $0a4e3e68448dada6$var$RT_NAMED_NODE_ESCAPELESS_VALID = /^([^\0-\x20<>"{}|^`])*$/;
const $0a4e3e68448dada6$var$R_UNICODE_ANY = /\\u([0-9A-Fa-f]{4})|\\U([0-9A-Fa-f]{8})/g;
const $0a4e3e68448dada6$var$F_REPLACE_UNICODE_ANY = (s_, s_4, s_8)=>String.fromCodePoint(parseInt(s_4 || s_8, 16));
const $0a4e3e68448dada6$var$R_CLEAN = /\s*(?:#[^\n]*\n\s*)*\s*/y;
const $0a4e3e68448dada6$var$R_CLEAN_COMMENTS = /\s*(#[^\n]*\n\s*)*\s*/y;
const $0a4e3e68448dada6$var$RT_HAS_ESCAPES = /[\\]/;
const $0a4e3e68448dada6$var$R_EOL = /[^\n]+\n/y;
// eslint-disable-next-line no-misleading-character-class
const $0a4e3e68448dada6$var$RT_BLANK_NODE_LABEL_VALID = /^(?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_0-9])(?:(?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}.])*[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}])?$/u;
const $0a4e3e68448dada6$var$RT_LANGUAGE_VALID = /^[a-z]+(-[a-z0-9]+)*$/;
const $0a4e3e68448dada6$var$R_WS = /\s*/y;
const $0a4e3e68448dada6$var$R_HWS = /[ \t]*/y;
const $0a4e3e68448dada6$var$R_LANGTAG = /@([A-Za-z]+(?:-[A-Za-z0-9-]+)*)(?:\s+|(?=[.,;\])#]))/y;
const $0a4e3e68448dada6$var$R_IRIREF = /<([^>]*)>\s*/y;
const $0a4e3e68448dada6$var$F_REPLACE_STRLIT_CONTENTS = (s_, s_whitespace, s_auto, s_4, s_8, s_invalid)=>{
    if (s_whitespace) switch(s_whitespace){
        case "t":
            return "	";
        case "n":
            return "\n";
        case "r":
            return "\r";
        case "f":
            return "\f";
        case "b":
            return "\b";
        default:
            console.assert(`bad regex escape char mapping: '${s_whitespace}'`);
    }
    else if (s_auto) return s_auto;
    else if (s_4) return String.fromCodePoint(parseInt(s_4, 16));
    else if (s_8) return String.fromCodePoint(parseInt(s_8, 16));
    else if (s_invalid) {
        // pointless escape
        if ("\\" === s_invalid[0]) // // relaxed
        // return s_invalid[1];
        // if relaxed then return s_invalid, otherwise throw:
        throw new Error(`expected string_literal but invalid escape sequence within contents: '${s_invalid}'. failed to parse a valid token`);
        else throw new Error(`expected string_literal but invalid whitespace character within contents: ${JSON.stringify(s_invalid)}. failed to parse a valid token`);
    } else console.assert(`unexpected no match branch in escape sequence replace callback`);
};
const $0a4e3e68448dada6$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_HARD = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|([\r\n]|\\.))/g;
const $0a4e3e68448dada6$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|([\r\n]|\\[^uU]|\\u[^]{4}|\\U[^]{8}))/g;
const $0a4e3e68448dada6$var$unescape_literal_short_hard = (s_literal)=>s_literal.replace($0a4e3e68448dada6$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_HARD, $0a4e3e68448dada6$var$F_REPLACE_STRLIT_CONTENTS);
const $0a4e3e68448dada6$var$unescape_literal_short_soft = (s_literal)=>{
    let m_incomplete = $0a4e3e68448dada6$var$R_STRLIT_ESCAPE_INCOMPLETE.exec(s_literal);
    // incomplete escape
    if (m_incomplete) {
        let i_safe = m_incomplete.index;
        // rewind
        return [
            s_literal.slice(0, i_safe).replace($0a4e3e68448dada6$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT, $0a4e3e68448dada6$var$F_REPLACE_STRLIT_CONTENTS),
            s_literal.slice(i_safe)
        ];
    } else return [
        s_literal.replace($0a4e3e68448dada6$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT, $0a4e3e68448dada6$var$F_REPLACE_STRLIT_CONTENTS),
        ""
    ];
};
// lookbehind regexes
const [$0a4e3e68448dada6$var$R_STRLIT_ESCAPE_INCOMPLETE, $0a4e3e68448dada6$var$R_STRLIT_SHORT_DOUBLE_TERM] = (()=>{
    function RegExp_$lookbehind_polyfill(s_input) {
        let m_match = RegExp.prototype.exec.call(this, s_input);
        if (m_match) {
            let i_start = m_match[0].length - m_match[1].length;
            m_match.index += i_start;
            m_match[0] = m_match[0].slice(i_start);
        }
        return m_match;
    }
    let mk_lookbehind_regex = (()=>{
        try {
            new RegExp("(?<!h)i"); // eslint-disable-line no-new
        } catch (e_compile) {
            return (f_lookbehind, r_polyfill, f_polyfill)=>{
                r_polyfill.exec = f_polyfill;
                return r_polyfill;
            };
        }
        return (f_lookbehind)=>f_lookbehind();
    })();
    return [
        // R_STRLIT_ESCAPE_INCOMPLETE
        mk_lookbehind_regex(()=>new RegExp("(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)\\\\(|u[0-9A-Fa-f]{0,3}|U[0-9A-Fa-f]{0,7})$"), /^(?:(?:[^\\]|\\.)*)(\\(?:|u[0-9A-Fa-f]{0,3}|U[0-9A-Fa-f]{0,7}))$/, function RegExp_$lookbehind_polyfill_n(s_input) {
            let m_match = RegExp.prototype.exec.call(this, s_input);
            if (m_match) m_match.index += m_match[0].length - m_match[1].length;
            return m_match;
        }),
        // R_STRLIT_SHORT_DOUBLE_TERM
        mk_lookbehind_regex(()=>new RegExp('(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)"\\s*', "g"), /(?:[^\\"]|\\.)*("\s*)/y, RegExp_$lookbehind_polyfill)
    ];
})();
const $0a4e3e68448dada6$var$R_QUAD_ESCAPELESS_SP = /(?:<([^\\>]*)>|_:([^\x20\t<]+))[\x20\t]*<([^\\>]*)>[\x20\t]*(?:(?:(<[^\\>]*)>|_:([^\x20\t<]+))[\x20\t]*(?:<([^\\>]*)>|_:([^\x20\t<]+)|)[\x20\t]*\.\s*(#[^\n]*\n\s*|\n\s*)+|"([^"\\]*)(?:(")(?:\^\^<([^\\>]*)>|@([^\x20\t.]+)|)[\x20\t]*(?:<([^\\>]*)>|_:([^\x20\t<]+)|)[\x20\t]*\.\s*(#[^\n]*\n\s*|\n\s*)+)?)/y;
const $0a4e3e68448dada6$var$R_QUAD = /(?:<([^>]*)>|_:([^\x20\t<]+))[\x20\t]*<([^>]*)>[\x20\t]*(?:(?:(<[^>]*)>|_:([^\x20\t<]+))[\x20\t]*(?:<([^>]*)>|_:([^\x20\t<]+)|)[\x20\t]*\.\s*(#[^\n]*\n\s*|\n\s*)+|"((?:[^"\\]|\\.)*)(?:(")(?:\^\^<([^>]*)>|@([^\x20\t.]+)|)[\x20\t]*(?:<([^>]*)>|_:([^\x20\t<]+)|)[\x20\t]*\.\s*(#[^\n]*\n\s*|\n\s*)+)?)/y;
const $0a4e3e68448dada6$var$R_BLANK_NODE = /_:([^\x20\t<]+)/y;
class $0a4e3e68448dada6$var$NQuads_Reader extends $141f1697ab3cba12$exports.Transform {
    constructor(g_impls){
        super({
            // do not decode strings into buffers
            decodeStrings: false,
            // accept strings as input on writable side
            writableObjectMode: false,
            // output quad objects on readable side
            readableObjectMode: true,
            // implementations
            flush: g_impls.flush,
            transform: g_impls.transform
        });
        // when the writable side is piped into
        this.on("pipe", (ds_input)=>{
            this._ds_input = ds_input;
            // input stream has encoding option; ensure stream encoding is utf8
            if ("function" === typeof ds_input.setEncoding) ds_input.setEncoding("utf8");
        });
    }
    // intercept pipe
    pipe(ds_out) {
        let ds_dst = ds_out;
        // non-object mode
        if (!ds_dst._writableState.objectMode) // transform to JSON
        ds_out = $141f1697ab3cba12$exports.quads_to_json();
        else if (ds_out.isGraphyWritable) // transform to quad-stream
        ds_out = $141f1697ab3cba12$exports.quads_to_writable();
        // interim stream created
        if (ds_out !== ds_dst) {
            // forward output to super
            super.pipe(ds_out);
            // pipe outpu to destination
            return ds_out.pipe(ds_dst);
        } else return super.pipe(ds_dst);
    }
}
class $0a4e3e68448dada6$var$Reader {
    constructor(g_config){
        let { // input medium
        input: g_input = null, // relax validation
        relax: b_relax = false, // debug
        debug: b_debug = false } = g_config;
        // allow relative iris flag
        let b_allow_relative_iris = g_config.allow_relative_iris || g_config.allowRelativeIRIs || g_config.allowRelativeIris || false;
        // adopt factory
        let dc_factory = this._dc_factory = $266825253b7f24dc$exports.adopt(g_config.dataFactory || g_config.data_factory || $266825253b7f24dc$exports.unfiltered);
        let f_quad = this._f_quad = dc_factory.quad;
        // fields
        Object.assign(this, {
            // string buffer, accept left-over string from previous data chunk
            s: g_config.prepend || "",
            // string buffer length
            n: 0,
            _b_debug: b_debug,
            _b_relax: b_relax,
            _b_destroyed: false,
            _b_trim_start: true,
            _f_state: this.statement,
            _kt_subject: null,
            _kt_predicate: null,
            _kt_object: null,
            _s_literal: ""
        });
        this._kt_default_graph = dc_factory.defaultGraph();
        this._kt_rdfs_lang_string = dc_factory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#langString");
        // clean regex
        let r_clean = this._r_clean = $0a4e3e68448dada6$var$R_CLEAN;
        if (g_config.relaxed) console.warn(new Error(`no such option 'relaxed'; did you mean 'relax' ?`).stack.replace(/^Error:/, "Warning:"));
        if ("validate" in g_config) console.warn(new Error(`option 'validate' has been removed and validation is now on by default. Use 'relax' option if you wish to disable validation.`).stack.replace(/^Error:/, "Warning:"));
        let namedNode = dc_factory.namedNode;
        let blankNode = dc_factory.blankNode;
        let languagedLiteral = dc_factory.languagedLiteral;
        // test for valid named node
        let rt_named_node_valid = b_allow_relative_iris ? $0a4e3e68448dada6$var$RT_NAMED_NODE_VALID : $0a4e3e68448dada6$var$RT_ABSOLUTE_IRI_VALID;
        // test for valid named node escapeless
        let rt_named_node_valid_escapeless = b_allow_relative_iris ? $0a4e3e68448dada6$var$RT_NAMED_NODE_ESCAPELESS_VALID : $0a4e3e68448dada6$var$RT_ABSOLUTE_IRI_ESCAPELESS_VALID;
        // validation
        let k_self = this;
        Object.assign(this, !b_relax ? {
            create_named_node (p_iri) {
                if (!rt_named_node_valid.test(p_iri)) return k_self._error(`invalid IRI: "${p_iri}"`);
                return namedNode(p_iri);
            },
            create_named_node_escapeless (p_iri) {
                if (!rt_named_node_valid_escapeless.test(p_iri)) return k_self._error(`invalid IRI: "${p_iri}"`);
                return namedNode(p_iri);
            },
            create_blank_node (s_label) {
                if (!$0a4e3e68448dada6$var$RT_BLANK_NODE_LABEL_VALID.test(s_label)) return k_self._error(`Invalid blank node label: "${s_label}"`);
                return blankNode(s_label);
            },
            create_languaged_literal (s_contents, s_language) {
                if (!$0a4e3e68448dada6$var$RT_LANGUAGE_VALID.test(s_language)) return k_self._error(`Invalid literal language tag: ${s_language}`);
                return languagedLiteral(s_contents, s_language);
            }
        } : {
            create_named_node: namedNode,
            create_named_node_escapeless: namedNode,
            create_blank_node: blankNode,
            create_languaged_literal: languagedLiteral
        });
        // transform stream
        let ds_transform;
        // whether or not data has been received before
        let b_init = false;
        // create transform
        ds_transform = this.transform = new $0a4e3e68448dada6$var$NQuads_Reader({
            // on data event
            transform: (s_chunk, s_encoding, fk_chunk)=>{
                // first transform
                if (!b_init) {
                    // notify that data will begin
                    ds_transform.emit("ready");
                    // do not emit 'ready' event again
                    b_init = false;
                }
                // concatenate current chunk to previous chunk
                let s = this.s += s_chunk;
                // remove whitespace & comments from beginning
                if (this._b_trim_start) {
                    r_clean.lastIndex = 0;
                    let m_clean = r_clean.exec(s);
                    if (this.emit_comments) this.emit_comments(m_clean[1]);
                    // update index and prepare to match statement
                    this.i = r_clean.lastIndex;
                } else this.i = 0;
                // cache chunk length
                this.n = s.length;
                // resume parsing
                try {
                    this.parse(true);
                } // read error occurred; emit and destroy stream
                catch (e_read) {
                    return ds_transform.destroy(e_read);
                }
                // emit progress event updates
                ds_transform.emit("progress", s_chunk.length);
                // done transforming this chunk
                fk_chunk();
            },
            // once there's no more data to consume, invoke eof
            flush: (fk_flush)=>{
                // there is still unparsed data
                if (this.s.length) {
                    // append newline to end so we can match token
                    this.s += "\n";
                    // remove whitespace & comments from beginning
                    if (this._b_trim_start) {
                        r_clean.lastIndex = 0;
                        let m_clean = r_clean.exec(this.s);
                        if (this.emit_comments) this.emit_comments(m_clean[1]);
                        // update index and prepare to match statement
                        this.i = r_clean.lastIndex;
                    } else this.i = 0;
                    // parse
                    try {
                        this.parse();
                    } // read error occurred; pass to flush errback and exit method
                    catch (e_read) {
                        // destroying during flush means overriding push
                        return ds_transform.demolish(e_read);
                    }
                    // still unparsed characters; pass to flush errback and exit method
                    if (this.s.length) return ds_transform.demolish(new Error(`parsing error occurred in state: statement\n  ${this.s.substr(0, 50)}\n  ^ starting here`));
                }
                // invalid state
                if (this._f_state !== this.statement) return ds_transform.demolish(new Error(`parsing error occurred in state: ${this._f_state.name}\n  ${this.s.substr(0, 50)}\n  ^ starting here`));
                // make buffer's alloc eligible for gc
                this.s = null;
                // final progress update: no additional bytes were read
                ds_transform.emit("progress", 0);
                // call end event listener
                ds_transform.emit("eof");
                // done flushing, close read stream
                fk_flush();
            }
        });
        // destroy
        ds_transform._destroy = (...a_args)=>{
            this.destroy(...a_args);
        };
        // data quad
        this._f_data_quad = (kt_subject, kt_predicate, kt_object, kt_graph)=>ds_transform.push(f_quad(kt_subject, kt_predicate, kt_object, kt_graph));
        // new listener added
        ds_transform.on("newListener", (s_event)=>{
            // comment
            if ("comment" === s_event) {
                r_clean = $0a4e3e68448dada6$var$R_CLEAN_COMMENTS;
                this.emit_comments = (s_captured)=>{
                    if (!s_captured) return;
                    let a_comments = s_captured.slice(1).replace(/\n\s+$/, "").split(/\n+\s*#/g);
                    for (let s_comment of a_comments)ds_transform.emit("comment", s_comment);
                };
            }
        });
        // bind events to transform stream
        this.bind(g_config);
        // input given
        if (g_input) {
            // input is stream
            if (g_input.stream) {
                let ds_input = g_input.stream;
                // go async so caller has chance to bind event listeners
                queueMicrotask(()=>{
                    ds_input.pipe(ds_transform);
                });
            } else if ("string" === typeof g_input.string) {
                let s_input = g_input.string;
                // go async so caller has chance to bind event listeners
                queueMicrotask(()=>{
                    ds_transform.end(s_input, "utf8");
                });
            } else throw new TypeError(`Invalid argument for input parameter: ${"object" === typeof g_input ? JSON.stringify(g_input) : g_input}`);
        }
        ds_transform._graphy_reader = this;
    }
    _error(s_message) {
        this._b_destroyed = true;
        throw new Error(s_message);
    }
    bind(g_config) {
        let ds_transform = this.transform;
        if (g_config.error) ds_transform.on("error", g_config.error);
        if (g_config.comment) ds_transform.on("comment", g_config.comment);
        if (g_config.read) ds_transform.once("read", g_config.read);
        if (g_config.progress) ds_transform.on("progress", g_config.progress);
        if (g_config.eof) ds_transform.once("eof", g_config.eof);
        if (g_config.end) ds_transform.once("end", g_config.end);
        if (g_config.finish) ds_transform.once("finish", g_config.finish);
        if (g_config.data) ds_transform.on("data", g_config.data);
    }
    // begin parsing, keep applying until no more stack bail-outs
    parse() {
        let f_sync = this._f_state();
        while("function" === typeof f_sync)f_sync = f_sync.apply(this);
    }
    statement() {
        let s = this.s;
        let n = this.n;
        let i = this.i;
        let f_data_quad = this._f_data_quad;
        let create_named_node = this.create_named_node;
        let create_named_node_escapeless = this.create_named_node_escapeless;
        let create_languaged_literal = this.create_languaged_literal;
        let create_blank_node = this.create_blank_node;
        let simpleLiteral = this._dc_factory.simpleLiteral;
        let datatypedLiteral = this._dc_factory.datatypedLiteral;
        let kt_default_graph = this._kt_default_graph;
        // match triples/quads
        for(;;){
            // prepare sticky regex index
            $0a4e3e68448dada6$var$R_QUAD_ESCAPELESS_SP.lastIndex = i;
            // execute regex
            let m_statement_e_sp = $0a4e3e68448dada6$var$R_QUAD_ESCAPELESS_SP.exec(s);
            // regex was a match
            if (m_statement_e_sp) {
                // advance index
                i = $0a4e3e68448dada6$var$R_QUAD_ESCAPELESS_SP.lastIndex;
                // prep object term
                let kt_object;
                // where to find the graph component
                let b_graph_late = false;
                // object term type is named node
                if (m_statement_e_sp[4]) {
                    let p_object = m_statement_e_sp[4].slice(1);
                    kt_object = create_named_node_escapeless(p_object);
                } else if (m_statement_e_sp[5]) kt_object = create_blank_node(m_statement_e_sp[5]);
                else {
                    // graph is in late capture group
                    b_graph_late = true;
                    // contents
                    let s_contents = m_statement_e_sp[9];
                    // string terminator
                    if (m_statement_e_sp[10]) {
                        // datatype is present
                        if (m_statement_e_sp[11]) {
                            // create datatype term
                            let kt_datatype = this.create_named_node_escapeless(m_statement_e_sp[11]);
                            // create object term
                            kt_object = datatypedLiteral(s_contents, kt_datatype);
                        } else if (m_statement_e_sp[12]) {
                            // normalize language
                            let s_language = m_statement_e_sp[12].toLowerCase();
                            // create object term
                            kt_object = create_languaged_literal(s_contents, s_language);
                        } else kt_object = simpleLiteral(s_contents);
                    } else {
                        // save contents
                        this._s_literal = s_contents;
                        // update index
                        this.i = i;
                        // save subject
                        {
                            let s_subject = m_statement_e_sp[1];
                            // named node
                            if (s_subject || "string" === typeof s_subject) this._kt_subject = create_named_node_escapeless(s_subject);
                            else this._kt_subject = create_blank_node(m_statement_e_sp[2]);
                        }
                        // save predicate
                        this._kt_predicate = create_named_node_escapeless(m_statement_e_sp[3]);
                        // parse contents
                        let z_bail = this.strlit_contents();
                        // bail out of stack
                        if (z_bail && this.statement !== z_bail) return z_bail;
                        else {
                            // clean
                            let r_clean = this._r_clean;
                            r_clean.lastIndex = this.i;
                            let m_clean = r_clean.exec(s);
                            if (this.emit_comments) this.emit_comments(m_clean[1]);
                            // update local index and prepare to match next statement
                            i = r_clean.lastIndex;
                            continue;
                        }
                    }
                }
                let kt_graph = kt_default_graph;
                // graph after literal
                if (b_graph_late) {
                    // ref capture group
                    let s_graph = m_statement_e_sp[13];
                    // named node
                    if (s_graph || "string" === typeof s_graph) kt_graph = create_named_node_escapeless(s_graph);
                    else if (m_statement_e_sp[14]) kt_graph = create_blank_node(m_statement_e_sp[14]);
                } else {
                    // ref capture group
                    let s_graph = m_statement_e_sp[6];
                    // named node
                    if (s_graph || "string" === typeof s_graph) kt_graph = create_named_node_escapeless(s_graph);
                    else if (m_statement_e_sp[7]) kt_graph = create_blank_node(m_statement_e_sp[7]);
                }
                let kt_subject;
                {
                    let s_subject = m_statement_e_sp[1];
                    // named node
                    if (s_subject || "string" === typeof s_subject) kt_subject = create_named_node_escapeless(s_subject);
                    else kt_subject = create_blank_node(m_statement_e_sp[2]);
                }
                let s_predicate = m_statement_e_sp[3];
                // emit data event
                f_data_quad(kt_subject, create_named_node_escapeless(s_predicate), kt_object, kt_graph);
                // comments
                if (this.emit_comments) this.emit_comments(m_statement_e_sp[8] || m_statement_e_sp[15]);
            } else {
                // prepare sticky regex index
                $0a4e3e68448dada6$var$R_QUAD.lastIndex = i;
                // execute regex
                let m_statement = $0a4e3e68448dada6$var$R_QUAD.exec(s);
                // regex was a match
                if (m_statement) {
                    // advance index
                    i = $0a4e3e68448dada6$var$R_QUAD.lastIndex;
                    // prep object term
                    let kt_object;
                    // where to find the graph component
                    let b_graph_late = false;
                    // object term type is named node
                    if (m_statement[4]) {
                        let p_object = m_statement[4].slice(1);
                        kt_object = create_named_node($0a4e3e68448dada6$var$RT_HAS_ESCAPES.test(p_object) ? p_object.replace($0a4e3e68448dada6$var$R_UNICODE_ANY, $0a4e3e68448dada6$var$F_REPLACE_UNICODE_ANY) : p_object);
                    } else if (m_statement[5]) kt_object = create_blank_node($0a4e3e68448dada6$var$RT_HAS_ESCAPES.test(m_statement[5]) ? m_statement[5].replace($0a4e3e68448dada6$var$R_UNICODE_ANY, $0a4e3e68448dada6$var$F_REPLACE_UNICODE_ANY) : m_statement[5]);
                    else {
                        // graph is in late capture group
                        b_graph_late = true;
                        // contents
                        let s_contents = m_statement[9];
                        // string terminator
                        if (m_statement[10]) {
                            // unescape contents
                            s_contents = $0a4e3e68448dada6$var$unescape_literal_short_hard(s_contents);
                            // datatype is present
                            if (m_statement[11]) {
                                // create datatype term
                                let kt_datatype = this.create_named_node(m_statement[11]);
                                // create object term
                                kt_object = datatypedLiteral(s_contents, kt_datatype);
                            } else if (m_statement[12]) {
                                // normalize language
                                let s_language = m_statement[12].toLowerCase();
                                // create object term
                                kt_object = create_languaged_literal(s_contents, s_language);
                            } else kt_object = simpleLiteral(s_contents);
                        } else {
                            // save contents
                            this._s_literal = s_contents;
                            // update index
                            this.i = i;
                            // save subject
                            {
                                let s_subject = m_statement[1];
                                // named node
                                if (s_subject || "string" === typeof s_subject) this._kt_subject = create_named_node($0a4e3e68448dada6$var$RT_HAS_ESCAPES.test(s_subject) ? s_subject.replace($0a4e3e68448dada6$var$R_UNICODE_ANY, $0a4e3e68448dada6$var$F_REPLACE_UNICODE_ANY) : s_subject);
                                else this._kt_subject = create_blank_node(m_statement[2]);
                            }
                            // save predicate
                            this._kt_predicate = create_named_node($0a4e3e68448dada6$var$RT_HAS_ESCAPES.test(m_statement[3]) ? m_statement[3].replace($0a4e3e68448dada6$var$R_UNICODE_ANY, $0a4e3e68448dada6$var$F_REPLACE_UNICODE_ANY) : m_statement[3]);
                            // parse contents
                            let z_bail = this.strlit_contents();
                            // bail out of stack
                            if (z_bail && this.statement !== z_bail) return z_bail;
                            else {
                                // clean
                                let r_clean = this._r_clean;
                                r_clean.lastIndex = this.i;
                                let m_clean = r_clean.exec(s);
                                if (this.emit_comments) this.emit_comments(m_clean[1]);
                                // update local index and prepare to match next statement
                                i = r_clean.lastIndex;
                                continue;
                            }
                        }
                    }
                    let kt_graph = kt_default_graph;
                    // graph after literal
                    if (b_graph_late) {
                        // ref capture group
                        let s_graph = m_statement[13];
                        // named node
                        if (s_graph || "string" === typeof s_graph) kt_graph = create_named_node($0a4e3e68448dada6$var$RT_HAS_ESCAPES.test(s_graph) ? s_graph.replace($0a4e3e68448dada6$var$R_UNICODE_ANY, $0a4e3e68448dada6$var$F_REPLACE_UNICODE_ANY) : s_graph);
                        else if (m_statement[14]) kt_graph = create_blank_node(m_statement[14]);
                    } else {
                        // ref capture group
                        let s_graph = m_statement[6];
                        // named node
                        if (s_graph || "string" === typeof s_graph) kt_graph = create_named_node($0a4e3e68448dada6$var$RT_HAS_ESCAPES.test(s_graph) ? s_graph.replace($0a4e3e68448dada6$var$R_UNICODE_ANY, $0a4e3e68448dada6$var$F_REPLACE_UNICODE_ANY) : s_graph);
                        else if (m_statement[7]) kt_graph = create_blank_node(m_statement[7]);
                    }
                    let kt_subject;
                    {
                        let s_subject = m_statement[1];
                        // named node
                        if (s_subject || "string" === typeof s_subject) kt_subject = create_named_node($0a4e3e68448dada6$var$RT_HAS_ESCAPES.test(s_subject) ? s_subject.replace($0a4e3e68448dada6$var$R_UNICODE_ANY, $0a4e3e68448dada6$var$F_REPLACE_UNICODE_ANY) : s_subject);
                        else kt_subject = create_blank_node(m_statement[2]);
                    }
                    let s_predicate = m_statement[3];
                    // emit data event
                    f_data_quad(kt_subject, create_named_node($0a4e3e68448dada6$var$RT_HAS_ESCAPES.test(s_predicate) ? s_predicate.replace($0a4e3e68448dada6$var$R_UNICODE_ANY, $0a4e3e68448dada6$var$F_REPLACE_UNICODE_ANY) : s_predicate), kt_object, kt_graph);
                    // comments
                    if (this.emit_comments) this.emit_comments(m_statement[8] || m_statement[15]);
                } else {
                    // prepare sticky regex index
                    $0a4e3e68448dada6$var$R_EOL.lastIndex = i;
                    if ($0a4e3e68448dada6$var$R_EOL.exec(s)) {
                        // advance index
                        i = $0a4e3e68448dada6$var$R_EOL.lastIndex;
                        this._error(`Failed to read statement:\n\`${s.substr(i, 80).replace(/\n/g, "\u23CE")} [...]\`\n ^ starting here`);
                    // match counter: 2
                    } else break;
                } // brace #2
            } // brace #1
        } // end of while
        // update unparsed data string
        this.s = s.substr(i);
        // resume here
        this._f_state = this.statement;
        // exit
        return 1;
    }
    strlit_contents() {
        let { s: s, n: n, i: i } = this;
        // try to find end
        $0a4e3e68448dada6$var$R_STRLIT_SHORT_DOUBLE_TERM.lastIndex = i;
        let m_term = $0a4e3e68448dada6$var$R_STRLIT_SHORT_DOUBLE_TERM.exec(s);
        // end is in this chunk
        if (m_term) {
            // index of terminator
            let i_term = m_term.index;
            // extract dirty potion
            let s_dirty = s.slice(i, i_term);
            // clean and save
            this._s_literal += $0a4e3e68448dada6$var$unescape_literal_short_hard(s_dirty);
            // advance index beyond terminator
            this.i = i_term + m_term[0].length;
            // resume eating whitespace at start of next chunk
            this._b_trim_start = true;
            // proceed with datatype_or_lang, then bail out of stack or resume parsing
            return this.datatype_or_langtag() || this.statement;
        } else {
            // extract whole portion
            let s_dirty = s.slice(i);
            // unescape to clean part
            let [s_clean, s_incomplete] = $0a4e3e68448dada6$var$unescape_literal_short_soft(s_dirty);
            // save
            this._s_literal += s_clean;
            // set unparsed index
            this.i = i = n - s_incomplete.length;
            // do not eat whitespace at start of next chunk
            this._b_trim_start = false;
        }
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("strlit_contents");
            }
        }
        // resume here
        this._f_state = this.strlit_contents;
        // store what is unparsed
        this.s = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return 1;
    }
    // parse state for datatype_or_langtag
    datatype_or_langtag() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // ref character
        let x = s[i];
        while(i < n){
            // datatype
            if ("^" === x) {
                // enough to speculate datatype
                if (i + 2 < n) {
                    // correct token
                    if ("^" === s[i + 1]) {
                        // advance index beyond token
                        $0a4e3e68448dada6$var$R_IRIREF.lastIndex = i + 2;
                        // execute regex
                        let m_iriref = $0a4e3e68448dada6$var$R_IRIREF.exec(s);
                        // regex was a match
                        if (m_iriref) {
                            // advance index
                            this.i = $0a4e3e68448dada6$var$R_IRIREF.lastIndex;
                            // prepare iri
                            let p_datatype = m_iriref[1].replace($0a4e3e68448dada6$var$R_UNICODE_ANY, $0a4e3e68448dada6$var$F_REPLACE_UNICODE_ANY);
                            // create datatype term
                            let kt_datatype = this.create_named_node(p_datatype);
                            // create object term
                            this._kt_object = this._dc_factory.datatypedLiteral(this._s_literal, kt_datatype);
                            // free literal string
                            this._s_literal = "";
                            // graph state
                            return this.post_object();
                        } else break;
                    } else this._error(`Failed to read token after literal:\n\`${s.substr(i + 1, 80).replace(/\n/g, "\u23CE")} [...]\`\n ^ starting here`);
                } else break;
            } else if ("@" === x) {
                // prepare sticky regex index
                $0a4e3e68448dada6$var$R_LANGTAG.lastIndex = i;
                // execute regex
                let m_langtag = $0a4e3e68448dada6$var$R_LANGTAG.exec(s);
                // regex was a match
                if (m_langtag) {
                    // advance index
                    this.i = $0a4e3e68448dada6$var$R_LANGTAG.lastIndex;
                    // use direct factory method since regex is validation
                    this._kt_object = this._dc_factory.languagedLiteral(this._s_literal, m_langtag[1]);
                    // free literal string
                    this._s_literal = "";
                    // graph state
                    return this.post_object();
                } else break;
            } else if ("<" === x || "_" === x) {
                // save simple literal
                this._kt_object = this._dc_factory.simpleLiteral(this._s_literal);
                // free literal string
                this._s_literal = "";
                // continue parsing graph component
                return this.graph();
            } else if ("." === x) {
                // save simple literal
                let kt_object = this._dc_factory.simpleLiteral(this._s_literal);
                // free literal string
                this._s_literal = "";
                // advance index beyond terminator
                this.i = i + 1;
                // emit data event
                this._f_data_quad(this._kt_subject, this._kt_predicate, kt_object, this._kt_default_graph);
                // reset state
                return this.statement;
            // // consume whitespace (and incidentally reset index)
            // R_WS.lastIndex = i + 1;
            // R_WS.exec(s);
            // this.i = R_WS.lastIndex;
            // // done
            // return;
            } else break;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("datatype_or_langtag");
            }
        }
        // resume here
        this._f_state = this.datatype_or_langtag;
        // store what is unparsed
        this.s = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return 1;
    }
    statement_term() {
        let { s: s, n: n, i: i } = this;
        // find full stop
        let i_stop = s.indexOf(".", i);
        // found
        if (i_stop > -1) {
            // consume whitespace again
            this._b_trim_start = true;
            // advance beyond token
            this.i = i_stop + 1;
            // reset state
            return this.statement;
        } else if (!/^\s*$/.test(s.slice(i))) this.parse_error("statement_term");
        // do not consume whitespace
        this._b_trim_start = false;
        // resume here
        this._f_state = this.statement_term;
        // store what is unparsed
        this.s = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return 1;
    }
    post_object() {
        let { s: s, n: n, i: i } = this;
        // eat horizontal whitespace
        $0a4e3e68448dada6$var$R_HWS.lastIndex = i;
        $0a4e3e68448dada6$var$R_HWS.exec(s);
        i = $0a4e3e68448dada6$var$R_HWS.lastIndex;
        // ran out of characters
        if (i >= n) {
            // resume here
            this._f_state = this.post_object;
            // store what is unparsed
            this.s = s.slice(i);
            // if we're not parsing a stream, then this is an error
            if (this.eos) this.eos();
            return 1;
        }
        // depending on char
        switch(s[i]){
            // statement term
            case ".":
                // advance index beyond terminator
                this.i = i + 1;
                // emit data event
                this._f_data_quad(this._kt_subject, this._kt_predicate, this._kt_object, this._kt_default_graph);
                // reset state
                return this.statement;
            // graph
            case "<":
            case "_":
                // save index
                this.i = i;
                // consume graph component
                return this.graph();
            // invalid
            default:
                // save index
                this.i = i;
                // emit parsing error
                this.parse_error("post_object");
        }
    }
    graph() {
        let { s: s, n: n, i: i } = this;
        // prepare sticky regex index
        $0a4e3e68448dada6$var$R_IRIREF.lastIndex = i;
        // execute regex
        let m_iriref = $0a4e3e68448dada6$var$R_IRIREF.exec(s);
        // regex was a match
        if (m_iriref) {
            // advance index
            this.i = $0a4e3e68448dada6$var$R_IRIREF.lastIndex;
            // create graph term
            let kt_graph = this.create_named_node(m_iriref[1]);
            // emit data event
            this._f_data_quad(this._kt_subject, this._kt_predicate, this._kt_object, kt_graph);
            // complete with statement_term
            return this.statement_term();
        } else {
            // prepare sticky regex index
            $0a4e3e68448dada6$var$R_BLANK_NODE.lastIndex = i;
            // execute regex
            let m_blank = $0a4e3e68448dada6$var$R_BLANK_NODE.exec(s);
            // regex was a match
            if (m_blank) {
                // advance index
                this.i = $0a4e3e68448dada6$var$R_BLANK_NODE.lastIndex;
                // create graph term
                let kt_graph = this._dc_factory.blankNode(m_blank[1]);
                // emit data event
                this._f_data_quad(this._kt_subject, this._kt_predicate, this._kt_object, kt_graph);
                // complete with statement_term
                return this.statement_term();
            }
        } // brace #1
        // resume here
        this._f_state = this.graph;
        // store what is unparsed
        this.s = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return 1;
    }
    parse_error(s_state) {
        return this._error(`Failed to read ${s_state}:\n\`${this.s.substr(this.i, 80).replace(/\n/g, "\u23CE")} [...]\`\n ^ starting here`);
    }
    destroy(e_destroy) {
        this._f_data_quad = ()=>{};
        if (!e_destroy && this._ds_input) this._ds_input.destroy(e_destroy);
        this.transform.demolish(e_destroy);
    }
}
$0a4e3e68448dada6$exports = function(...a_args) {
    let g_config = {};
    // at least one argument
    if (a_args.length) {
        let z_arg_0 = a_args[0];
        // input given unspecified
        if (z_arg_0 && z_arg_0.input && "undefined" === typeof z_arg_0.input.string && !z_arg_0.input.stream) z_arg_0 = z_arg_0.input;
        // string
        if ("string" === typeof z_arg_0) g_config.input = {
            string: z_arg_0
        };
        else if (null === z_arg_0) g_config.input = null;
        else if ("function" === typeof z_arg_0.setEncoding) g_config.input = {
            stream: z_arg_0
        };
        else if ("function" === typeof z_arg_0.pipeTo) throw new TypeError(`Sorry, WHATWG streams are currently not supported :(`);
        else if (z_arg_0 && "object" === typeof z_arg_0 && "[object Object]" === Object.prototype.toString.call(z_arg_0)) {
            g_config = z_arg_0;
            // more args; invalid
            if (a_args.length > 1) throw new TypeError(`unexpected argument(s) after config struct: ${a_args.slice(1)}`);
        } else throw new TypeError(`unexpected input type: ${z_arg_0}`);
        // more args
        if (a_args.length > 1) {
            // copy onto struct
            Object.assign(g_config, a_args[1]);
            // more args
            if (a_args.length > 2) throw new TypeError(`unexpected argument(s) after input and config struct: ${a_args.slice(2)}`);
        }
    }
    // create reader, return transform stream
    return new $0a4e3e68448dada6$var$Reader(g_config).transform;
};


var $50d4a76629506683$exports = {};
// queueMicrotask shim

var $6ZWSX = parcelRequire("6ZWSX");
var $50d4a76629506683$require$Buffer = $6ZWSX.Buffer;
// not defined or not a function
if ("function" !== typeof queueMicrotask) {
    // create resolved promise
    let dp_resolve = Promise.resolve();
    // try to redefine
    try {
        // eslint-disable-next-line no-global-assign
        queueMicrotask = (fk)=>dp_resolve.then(fk).catch((e_callback)=>setTimeout(()=>{
                    throw e_callback;
                }, 0));
    } // oh well, at least we tried
    catch (e_define) {}
}


var $eNRCS = parcelRequire("eNRCS");


const $50d4a76629506683$var$quad = (k)=>$266825253b7f24dc$exports.quad(k._kt_subject, k._kt_predicate, k._kt_object, k._kt_graph);
// eslint-disable-next-line no-misleading-character-class
const $50d4a76629506683$var$RT_PREFIXED_NAME_NAMESPACE_VALID = /^([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}]([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}.]*[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}])?)?$/u;
// eslint-disable-next-line no-misleading-character-class
const $50d4a76629506683$var$RT_PREFIXED_NAME_LOCAL_NAME_VALID = /^([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_:0-9]|%[A-Fa-f0-9]{2}|\\[_~.\-!$&'()*+,;=/?#@%])(([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}.:]|%[A-Fa-f0-9]{2}|\\[_~.\-!$&'()*+,;=/?#@%])*([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}:]|%[A-Fa-f0-9]{2}|\\[_~.\-!$&'()*+,;=/?#@%]))?$/u;
// eslint-disable-next-line no-misleading-character-class
const $50d4a76629506683$var$RT_BLANK_NODE_VALID = /^[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_0-9]([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}.]*[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}])?$/u;
const $50d4a76629506683$var$RT_NAMED_NODE_VALID = /^([^\0-\x20<>"{}|^`\\]|\\u[A-Fa-f0-9]{4}|\\U[A-Fa-f0-9]{8})*$/;
const $50d4a76629506683$var$RT_NAMED_NODE_ESCAPELESS_VALID = /^([^\0-\x20<>"{}|^`])*$/;
const $50d4a76629506683$var$RT_LITERAL_CONTENTS_VALID = /^(?:[^\\]|\\[tbnrf"'\\]|\\u[A-Fa-f0-9]{4}|\\U[A-Fa-f0-9]{8})*$/;
const $50d4a76629506683$var$R_UNICODE_ANY = /\\u([0-9A-Fa-f]{4})|\\U([0-9A-Fa-f]{8})/g;
const $50d4a76629506683$var$F_REPLACE_UNICODE_ANY = (s_, s_4, s_8)=>String.fromCodePoint(parseInt(s_4 || s_8, 16));
const $50d4a76629506683$var$OPHOP = Object.prototype.hasOwnProperty;
const $50d4a76629506683$var$R_PREFIXED_NAME_QUICK = /([A-Za-z][A-Za-z0-9_-]*)?:([A-Za-z_0-9:][A-Za-z0-9_:-]*)(?:\s+|(?=\.?[<[("';,)\]#{}]|\.[\s\0]))/y;
const $50d4a76629506683$var$R_PREFIXED_NAME_ESCAPELESS = /([^\s#@<[("':_{}][^\s#@<[("':{}]*)?:((?:[^\s#@<[("'.;,{})\]\\](?:[^\s#@<[("';,{})\]\\]*[^\s#@<[("'.;,{})\]\\])?)?)(?:\s+|(?=\.?[<[("';,)\]#{}]|\.[\s\0]))/y;
const $50d4a76629506683$var$R_PREFIXED_NAME = /([^\s#@<[("':_{}][^\s#@<[("':{}]*)?:((?:(?:[^\s#@<[("'.;,{})\]\\]|\\(?:%[0-9A-Fa-f][0-9A-Fa-f]|[^\s"]))(?:(?:[^\s#@<[("';,{})\]\\]|\\(?:%[0-9A-Fa-f][0-9A-Fa-f]|[^\s"]))*(?:[^\s#@<[("'.;,{})\]\\]|\\(?:%[0-9A-Fa-f][0-9A-Fa-f]|[^\s"])))?)?)(?:\s+|(?=\.?[<[("';,)\]#{}]|\.[\s\0]))/y;
const $50d4a76629506683$var$R_PN_LOCAL_ESCAPES = /\\(.)/g;
const $50d4a76629506683$var$R_BLANK_NODE_LABEL = /_:(.(?:[^\s:<;,)\]#}]*[^\s:<.;,)\]#}])?)(?:\s+|(?=[<:{,;\])#]))/y;
const $50d4a76629506683$var$R_BLANK_NODE_LABEL_TERMINAL = /_:(.(?:[^\s:<;,)\]#}]*[^\s:<.;,)\]#}])?)(?:\s+|(?=\.?[<:{,;\])#])|(?=\.[\s@#<({[}]))/y;
const $50d4a76629506683$var$R_IRIREF_ESCAPELESS = /<([^\\>]*)>\s*/y;
const $50d4a76629506683$var$R_IRIREF = /<([^>]*)>\s*/y;
const $50d4a76629506683$var$R_NUMERIC_LITERAL = /([+-]?(?:[0-9]+(\.[0-9]+)?|(\.[0-9]+))(\.?[eE][+-]?[0-9]+)?)(?:\s+|(?=\.[^eE0-9]|[;,)\]]))/y;
const $50d4a76629506683$var$R_BOOLEAN_LITERAL = /(?:(true|TRUE)|false|FALSE)\s*/y;
const $50d4a76629506683$var$R_A = /a(?:\s+|(?=[[("'<#]))/y;
const $50d4a76629506683$var$R_DOUBLE_CARET = /\^\^/y;
const $50d4a76629506683$var$R_WS = /\s*/y;
const $50d4a76629506683$var$R_LANGTAG = /@([A-Za-z]+(?:-[A-Za-z0-9-]+)*)(?:\s+|(?=[.},;\])#]))/y;
const $50d4a76629506683$var$R_PREFIX_KEYWORD = /(?:(@prefix)|[pP][rR][eE][fF][iI][xX])\s*/y;
const $50d4a76629506683$var$R_PREFIX_ID = /([^#:]*):\s*/iy;
const $50d4a76629506683$var$R_BASE_KEYWORD = /(?:(@base)|[bB][aA][sS][eE])\s*/y;
const $50d4a76629506683$var$R_GRAPH_IRI_ESCAPELESS = /(?:graph)?\s*<([^\\>]*)>\s*\{\s*/iy;
const $50d4a76629506683$var$R_GRAPH_PREFIXED_NAME = /(?:graph)?\s*([^\s#@<[("':_{}][^\s#@<[("':{}]*)?:((?:(?:[^\s#@<[("'.;,{})\]\\]|\\(?:%[0-9A-Fa-f][0-9A-Fa-f]|[^\s"]))(?:(?:[^\s#@<[("';,{})\]\\]|\\(?:%[0-9A-Fa-f][0-9A-Fa-f]|[^\s"]))*(?:[^\s#@<[("'.;,{})\]\\]|\\(?:%[0-9A-Fa-f][0-9A-Fa-f]|[^\s"])))?)?)\s*\{\s*/iy;
const $50d4a76629506683$var$R_GRAPH_LABELED_BLANK_NODE = /(?:graph)?\s*_:(.(?:[^\s:<;,)\]#}]*[^\s:<.;,)\]#}])?)\s*\{\s*/iy;
const $50d4a76629506683$var$R_GRAPH_ANONYMOUS_BLANK_NODE = /(?:graph)?\s*\[\s*\]\s*\{\s*/iy;
const $50d4a76629506683$var$R_GRAPH_IRI = /(?:graph)?\s*<([^>]*)>\s*\{\s*/iy;
const $50d4a76629506683$var$R_GRAPH = /graph(?:\s+|(?=[#<[{]))/iy;
const $50d4a76629506683$var$R_COMMENT = /(#[^\n]*\n\s*)+/y;
const $50d4a76629506683$var$RT_IRI_ABSOLUTE = /^[A-Za-z][A-Za-z0-9.\-+]*:/;
const $50d4a76629506683$var$R_RELATIVE_URI = /^(\/[^?#]+)([?#].*)?$/;
const $50d4a76629506683$var$R_BASE_IRI = /^((([A-Za-z0-9.\-+]*:\/)?\/[^/>]*)?(\/(?:[^/>]*\/)*)?[^>]*)$/;
const $50d4a76629506683$var$R_ANONYMOUS_BLANK_NODE = /\[\s*\]\s*/y;
const $50d4a76629506683$var$R_CHAR_BLANK_NODE = /\[(?:\s+|(?=[^\]]))/y;
const $50d4a76629506683$var$R_CHAR_COLLECTION = /\(\s*/y;
const $50d4a76629506683$var$R_CHAR_KET = /\]\s*/y;
const $50d4a76629506683$var$R_CHAR_OPEN = /\{\s*/y;
const $50d4a76629506683$var$R_CHAR_CLOSE = /\}\s*/y;
const $50d4a76629506683$var$R_CHAR_STOP = /\.\s*/y;
const $50d4a76629506683$var$R_STRLIT_SHORT_DOUBLE_BREAK = /[\\"\r\n]/g;
const $50d4a76629506683$var$R_STRLIT_SHORT_SINGLE_BREAK = /[\\'\r\n]/g;
const $50d4a76629506683$var$R_STRLIT_LONG_DOUBLE_UNFINISHED_TERM = /"{1,2}$/g;
const $50d4a76629506683$var$R_STRLIT_LONG_SINGLE_UNFINISHED_TERM = /'{1,2}$/g;
const $50d4a76629506683$var$R_STRLIT_LONG_DOUBLE_BREAK = /(\\|""")/g;
const $50d4a76629506683$var$R_STRLIT_LONG_SINGLE_BREAK = /(\\|''')/g;
const $50d4a76629506683$var$F_REPLACE_STRLIT_CONTENTS = (s_, s_whitespace, s_auto, s_4, s_8, s_invalid)=>{
    if (s_whitespace) switch(s_whitespace){
        case "t":
            return "	";
        case "n":
            return "\n";
        case "r":
            return "\r";
        case "f":
            return "\f";
        case "b":
            return "\b";
        default:
            console.assert(`bad regex escape char mapping: '${s_whitespace}'`);
    }
    else if (s_auto) return s_auto;
    else if (s_4) return String.fromCodePoint(parseInt(s_4, 16));
    else if (s_8) return String.fromCodePoint(parseInt(s_8, 16));
    else if (s_invalid) {
        // pointless escape
        if ("\\" === s_invalid[0]) // // relaxed
        // return s_invalid[1];
        // if relaxed then return s_invalid, otherwise throw:
        throw new Error(`expected string_literal but invalid escape sequence within contents: '${s_invalid}'. failed to parse a valid token`);
        else throw new Error(`expected string_literal but invalid whitespace character within contents: ${JSON.stringify(s_invalid)}. failed to parse a valid token`);
    } else console.assert(`unexpected no match branch in escape sequence replace callback`);
};
const $50d4a76629506683$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_HARD = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|([\r\n]|\\.))/g;
const $50d4a76629506683$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|([\r\n]|\\[^uU]|\\u[^]{4}|\\U[^]{8}))/g;
const $50d4a76629506683$var$unescape_literal_short_hard = (s_literal)=>s_literal.replace($50d4a76629506683$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_HARD, $50d4a76629506683$var$F_REPLACE_STRLIT_CONTENTS);
const $50d4a76629506683$var$unescape_literal_short_soft = (s_literal)=>{
    let m_incomplete = $50d4a76629506683$var$R_STRLIT_ESCAPE_INCOMPLETE.exec(s_literal);
    // incomplete escape
    if (m_incomplete) {
        let i_safe = m_incomplete.index;
        // rewind
        return [
            s_literal.slice(0, i_safe).replace($50d4a76629506683$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT, $50d4a76629506683$var$F_REPLACE_STRLIT_CONTENTS),
            s_literal.slice(i_safe)
        ];
    } else return [
        s_literal.replace($50d4a76629506683$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT, $50d4a76629506683$var$F_REPLACE_STRLIT_CONTENTS),
        ""
    ];
};
const $50d4a76629506683$var$R_STRLIT_LONG_CONTENTS_ESCAPES_HARD = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|(\\.))/g;
const $50d4a76629506683$var$R_STRLIT_LONG_CONTENTS_ESCAPES_SOFT = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|(\\[^uU]|\\u[^]{4}|\\U[^]{8}))/g;
const $50d4a76629506683$var$unescape_literal_long_hard = (s_literal)=>s_literal.replace($50d4a76629506683$var$R_STRLIT_LONG_CONTENTS_ESCAPES_HARD, $50d4a76629506683$var$F_REPLACE_STRLIT_CONTENTS);
const $50d4a76629506683$var$unescape_literal_long_soft = (s_literal)=>{
    let m_incomplete = $50d4a76629506683$var$R_STRLIT_ESCAPE_INCOMPLETE.exec(s_literal);
    // incomplete escape
    if (m_incomplete) {
        let i_safe = m_incomplete.index;
        // rewind
        return [
            s_literal.slice(0, i_safe).replace($50d4a76629506683$var$R_STRLIT_LONG_CONTENTS_ESCAPES_SOFT, $50d4a76629506683$var$F_REPLACE_STRLIT_CONTENTS),
            s_literal.slice(i_safe)
        ];
    } else return [
        s_literal.replace($50d4a76629506683$var$R_STRLIT_LONG_CONTENTS_ESCAPES_SOFT, $50d4a76629506683$var$F_REPLACE_STRLIT_CONTENTS),
        ""
    ];
};
// lookbehind regexes
const [$50d4a76629506683$var$R_STRLIT_ESCAPE_INCOMPLETE, $50d4a76629506683$var$R_STRLIT_SHORT_DOUBLE_TERM, $50d4a76629506683$var$R_STRLIT_SHORT_SINGLE_TERM, $50d4a76629506683$var$R_STRLIT_LONG_DOUBLE_TERM, $50d4a76629506683$var$R_STRLIT_LONG_SINGLE_TERM] = (()=>{
    function RegExp_$lookbehind_polyfill(s_input) {
        let m_match = RegExp.prototype.exec.call(this, s_input);
        if (m_match) {
            let i_start = m_match[0].length - m_match[1].length;
            m_match.index += i_start;
            m_match[0] = m_match[0].slice(i_start);
        }
        return m_match;
    }
    let mk_lookbehind_regex = (()=>{
        try {
            new RegExp("(?<!h)i"); // eslint-disable-line no-new
        } catch (e_compile) {
            return (f_lookbehind, r_polyfill, f_polyfill)=>{
                r_polyfill.exec = f_polyfill;
                return r_polyfill;
            };
        }
        return (f_lookbehind)=>f_lookbehind();
    })();
    return [
        // R_STRLIT_ESCAPE_INCOMPLETE
        mk_lookbehind_regex(()=>new RegExp("(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)\\\\(|u[0-9A-Fa-f]{0,3}|U[0-9A-Fa-f]{0,7})$"), /^(?:(?:[^\\]|\\.)*)(\\(?:|u[0-9A-Fa-f]{0,3}|U[0-9A-Fa-f]{0,7}))$/, function RegExp_$lookbehind_polyfill_n(s_input) {
            let m_match = RegExp.prototype.exec.call(this, s_input);
            if (m_match) m_match.index += m_match[0].length - m_match[1].length;
            return m_match;
        }),
        // R_STRLIT_SHORT_DOUBLE_TERM
        mk_lookbehind_regex(()=>new RegExp('(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)"\\s*', "g"), /(?:[^\\"]|\\.)*("\s*)/y, RegExp_$lookbehind_polyfill),
        // R_STRLIT_SHORT_SINGLE_TERM
        mk_lookbehind_regex(()=>new RegExp("(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)'\\s*", "g"), /(?:[^\\']|\\.)*('\s*)/y, RegExp_$lookbehind_polyfill),
        // R_STRLIT_LONG_DOUBLE_TERM
        mk_lookbehind_regex(()=>new RegExp('(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)"""\\s*', "g"), /(?:[^\\"]|\\.|""?(?!"))*("""\s*)/y, RegExp_$lookbehind_polyfill),
        // R_STRLIT_LONG_SINGLE_TERM
        mk_lookbehind_regex(()=>new RegExp("(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)'''\\s*", "g"), /(?:[^\\']|\\.|''?(?!'))*('''\s*)/y, RegExp_$lookbehind_polyfill)
    ];
})();
const $50d4a76629506683$var$match_prefixed_name_quick = (s, i)=>{
    $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.lastIndex = i;
    return [
        $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.exec(s),
        $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.lastIndex
    ];
};
const $50d4a76629506683$var$match_prefixed_name_escapeless = (s, i)=>{
    $50d4a76629506683$var$R_PREFIXED_NAME_ESCAPELESS.lastIndex = i;
    return [
        $50d4a76629506683$var$R_PREFIXED_NAME_ESCAPELESS.exec(s),
        $50d4a76629506683$var$R_PREFIXED_NAME_ESCAPELESS.lastIndex
    ];
};
const $50d4a76629506683$var$match_prefixed_name = (s, i)=>{
    $50d4a76629506683$var$R_PREFIXED_NAME.lastIndex = i;
    return [
        $50d4a76629506683$var$R_PREFIXED_NAME.exec(s),
        $50d4a76629506683$var$R_PREFIXED_NAME.lastIndex
    ];
};
function $50d4a76629506683$var$Reader$syntax_error(k_self, i, si_state, s_info) {
    let i_off = Math.min(i, Math.abs(i - 15));
    let s = k_self.s;
    return k_self.error(`\n\`${s.substr(i_off, i_off + 90).replace(/[\n\t]/g, " ")}\`\n` + ` ${" ".repeat(i - i_off)}^\n` + `expected ${si_state} ${s_info || ""}.  failed to parse a valid token starting at ${s[i] ? '"' + s[i] + '"' : "<<EOF>>"}`);
}
class $50d4a76629506683$var$TriG_Reader extends $141f1697ab3cba12$exports.Transform {
    constructor(g_impls){
        super({
            // do not decode strings into buffers
            decodeStrings: false,
            // accept strings as input on writable side
            writableObjectMode: false,
            // output quad objects on readable side
            readableObjectMode: true,
            // implementations
            flush: g_impls.flush,
            transform: g_impls.transform
        });
    }
    // intercept pipe
    pipe(ds_out) {
        let ds_dst = ds_out;
        // non-object mode
        if (!ds_dst._writableState.objectMode) // transform to JSON
        ds_out = $141f1697ab3cba12$exports.quads_to_json();
        else if (ds_out.isGraphyWritable) // transform to writable data events
        ds_out = $141f1697ab3cba12$exports.quads_to_writable();
        // interim stream created
        if (ds_out !== ds_dst) {
            // forward output to super
            super.pipe(ds_out);
            // pipe outpu to destination
            return ds_out.pipe(ds_dst);
        } else return super.pipe(ds_dst);
    }
}
class $50d4a76629506683$var$Reader {
    constructor(g_config = {}){
        // impl-specific configs
        let { // input medium
        input: g_input = null, // a state to inherit
        state: g_state = {} } = g_config;
        // inherit state from creator
        let { // index for anonymous blank node labels
        blank_node_index: i_anon = 0, // prefix map
        prefixes: h_prefixes = {}, // blank node label map
        labels: h_labels = {} } = g_state;
        let dc_factory = $266825253b7f24dc$exports.adopt(g_config.dataFactory || g_config.data_factory || $266825253b7f24dc$exports.unfiltered);
        let kt_default_graph = dc_factory.defaultGraph();
        // if data factory is not graphy, it might be returning the same object on each call to .defaultGraph()
        if (dc_factory !== $266825253b7f24dc$exports.unfiltered) // do not trust it, create a new object
        kt_default_graph = Object.create(kt_default_graph);
        let kt_rdf_first = dc_factory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#first");
        let blankNode = dc_factory.blankNode;
        let namedNode = dc_factory.namedNode;
        this.emit_data = $266825253b7f24dc$exports.unfiltered === dc_factory ? function() {
            ds_transform.push($50d4a76629506683$var$quad(this));
        } : function() {
            let g_quad = dc_factory.quad(this._kt_subject, this._kt_predicate, this._kt_object, this._kt_graph);
            ds_transform.push(g_quad);
        };
        // fields
        Object.assign(this, {
            // read index
            i: 0,
            // string buffer
            s: "",
            // string buffer length
            n: 0,
            // left-over string from previous data chunk
            pre: g_config.prepend || "",
            // debug state
            _b_debug: g_config.debug || false,
            // relax
            _b_relax: g_config.relax || false,
            // factory
            _dc_factory: dc_factory,
            // current reader state
            _f_state: this.block,
            // map of current prefix ids => iris
            _h_prefixes: h_prefixes,
            // reader was destroyed by an error
            _b_destroyed: false,
            // current @base url
            _s_base_url: "",
            _s_base_url_scheme: "",
            _s_base_url_root: "",
            _s_base_url_path: "",
            // current data
            _kt_subject: null,
            _kt_predicate: kt_rdf_first,
            _kt_object: null,
            _kt_graph: kt_default_graph,
            _s_literal: "",
            // static terms
            _kt_rdf_type: dc_factory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"),
            _kt_rdf_first: kt_rdf_first,
            _kt_rdf_rest: dc_factory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#rest"),
            _kt_rdf_nil: dc_factory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"),
            _kt_default_graph: kt_default_graph,
            // queue of nested subject, predicate, state for blanknodes and collections
            _a_nested: [],
            // hash to keep track of all blank node labels in use
            _h_labels: h_labels,
            // event routing
            event: this.emit,
            data: this.emit_data,
            // for restoring the original event callback when resuming paused stream
            restore_data: this.emit_data,
            // keep a queue of data events to hold onto until stream resumes (only happens in rare conditions)
            _a_queue_event: [],
            // helper states
            _b_expecting_full_stop: false,
            _s_temp_prefix_id: null,
            _b_trim_start: true,
            anonymous_blank_node: (s_label)=>blankNode(s_label, true),
            // finds the next non-conflicting blank node label
            next_label () {
                let s_label = "";
                do s_label = "g" + i_anon++;
                while (this._h_labels[s_label]);
                // claim this label, and remember that we invented it
                this._h_labels[s_label] = 2;
                // return the label
                return s_label;
            },
            // what to do when reach eos
            eos: null,
            // which state to go to after end of statement
            after_end_of_statement: this.post_object,
            // maximum length of a token: defaults to 2048 => http://stackoverflow.com/a/417184/1641160
            _n_max_token_length: g_config.max_token_length || g_config.maxTokenLength || 2048,
            // maximum length of a string (overrides max_token_length): defaults to Infinity
            _n_max_string_length: g_config.max_string_length || g_config.maxStringLength || Infinity,
            // byte tracking
            _b_byte_tracking: g_config.byte_tracking || g_config.byteTracking || false,
            _nb_seen: 0,
            _nb_last: 0,
            _nb_curr: 0
        });
        if (g_config.relaxed) console.warn(new Error(`no such option 'relaxed'; did you mean 'relax' ?`).stack.replace(/^Error:/, "Warning:"));
        if ("validate" in g_config) console.warn(new Error(`option 'validate' has been deprecated. Validation is now enabled by default. Use the 'relax' option if you wish to disable validation.`).stack.replace(/^Error:/, "Warning:"));
        // term constructors
        Object.assign(this, !g_config.relax ? {
            blank_node (s_label) {
                // test valid blank node label
                if (!$50d4a76629506683$var$RT_BLANK_NODE_VALID.test(s_label)) return this.error(`invalid blank node label: "${s_label}"`);
                // not first time use of label
                let z_label_state = this._h_labels[s_label];
                if (z_label_state) {
                    // label was used previously by document and has no conflict
                    if (1 === z_label_state) ; // eslint-disable-line no-empty
                    else if (2 === z_label_state) // so create a redirect mapping for this actual label & use it instead
                    s_label = this._h_labels[s_label] = this.next_label();
                    else // use redirected label
                    s_label = this._h_labels[s_label];
                } else // store label in hash so we avoid future collisions
                this._h_labels[s_label] = 1;
                // make term
                return blankNode(s_label);
            },
            check_named_node (p_iri) {
                if (!$50d4a76629506683$var$RT_NAMED_NODE_VALID.test(p_iri)) return this.error(`invalid IRI: "${p_iri}"`);
                return namedNode(p_iri);
            },
            check_named_node_escapeless (p_iri) {
                if (!$50d4a76629506683$var$RT_NAMED_NODE_ESCAPELESS_VALID.test(p_iri)) return this.error(`invalid IRI: "${p_iri}"`);
                return namedNode(p_iri);
            },
            match_prefixed_name_quick (s, i) {
                $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.lastIndex = i;
                return [
                    $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.exec(s),
                    $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.lastIndex
                ];
            },
            match_prefixed_name_escapeless (s, i) {
                let [m_prefixed_name_e, im_prefixed_name_e] = $50d4a76629506683$var$match_prefixed_name_escapeless(s, i);
                if (m_prefixed_name_e) // invalid local name
                {
                    if (!$50d4a76629506683$var$RT_PREFIXED_NAME_LOCAL_NAME_VALID.test(m_prefixed_name_e[2]) && m_prefixed_name_e[2]) {
                        this.error(`invalid prefixed name local name: "${m_prefixed_name_e[2]}:"`);
                        return;
                    }
                }
                return [
                    m_prefixed_name_e,
                    im_prefixed_name_e
                ];
            },
            match_prefixed_name (s, i) {
                let [m_prefixed_name, im_prefixed_name] = $50d4a76629506683$var$match_prefixed_name(s, i);
                if (m_prefixed_name) // invalid local name
                {
                    if (!$50d4a76629506683$var$RT_PREFIXED_NAME_LOCAL_NAME_VALID.test(m_prefixed_name[2])) {
                        this.error(`invalid prefixed name local name: "${m_prefixed_name[2]}:"`);
                        return;
                    }
                }
                return [
                    m_prefixed_name,
                    im_prefixed_name
                ];
            }
        } : {
            // term constructors
            blank_node (s_label) {
                // not first time use of label
                let z_label_state = this._h_labels[s_label];
                if (z_label_state) {
                    // label was used previously by document and has no conflict
                    if (1 === z_label_state) ; // eslint-disable-line no-empty
                    else if (2 === z_label_state) // so create a redirect mapping for this actual label & use it instead
                    s_label = this._h_labels[s_label] = this.next_label();
                    else // use redirected label
                    s_label = this._h_labels[s_label];
                } else // store label in hash so we avoid future collisions
                this._h_labels[s_label] = 1;
                // make term
                return blankNode(s_label);
            },
            check_named_node: namedNode,
            check_named_node_escapeless: namedNode,
            match_prefixed_name_escapeless: $50d4a76629506683$var$match_prefixed_name_escapeless,
            match_prefixed_name: $50d4a76629506683$var$match_prefixed_name
        });
        this.named_node = namedNode;
        this.prefixed_name = function(si_prefix, s_suffix) {
            return namedNode(h_prefixes[si_prefix] + s_suffix);
        };
        // oops -- user passed string into `base`
        if ("string" === typeof g_config.base) throw new TypeError(`invalid type 'string' was given for 'base' event listener: '${g_config.base}'\n` + `did you mean to use the 'base_uri' key instead?`);
        // base uri
        let p_set_base_uri = g_config.base_uri || g_config.baseUri || g_config.baseURI || g_config.base_iri || g_config.baseIri || g_config.baseIRI;
        if (p_set_base_uri) {
            let m_base_iri = $50d4a76629506683$var$R_BASE_IRI.exec(p_set_base_uri);
            this._s_base_url = m_base_iri[1];
            this._s_base_url_root = m_base_iri[2] || "";
            this._s_base_url_scheme = m_base_iri[3] || "";
            this._s_base_url_path = m_base_iri[4] || "";
        } else if (g_config.base_url || g_config.baseUrl || g_config.baseURL) throw new Error(`invalid option: .base${g_config.base_url ? "_url" : g_config.baseUrl ? "Url" : g_config.baseURL ? "URL" : ""}; use the '.base_uri' key instead`);
        // transform stream
        let ds_transform = this.transform = new $50d4a76629506683$var$TriG_Reader({
            // on data event
            transform: (s_chunk, s_encoding, fke_chunk)=>{
                // concatenate current chunk to previous chunk
                let s = this.s = this.pre + s_chunk;
                // cache chunk length
                this.n = s.length;
                // eat whitespace before token and reset index
                if (this._b_trim_start) {
                    // consume whitespace (and incidentally reset index)
                    $50d4a76629506683$var$R_WS.lastIndex = 0;
                    $50d4a76629506683$var$R_WS.exec(s);
                    this.i = $50d4a76629506683$var$R_WS.lastIndex;
                } else this.i = 0;
                // resume parsing; no errors
                if (this.safe_parse(true)) {
                    // emit progress event updates
                    ds_transform.emit("progress", s_chunk.length);
                    // done transforming this chunk
                    fke_chunk();
                }
            },
            // once there's no more data to consume, invoke eof
            flush: (fke_flush)=>{
                // now that input stream has ended, clean up remainder
                try {
                    this.eof(1);
                } // read error occurred
                catch (e_eof) {
                    // destroy self and stream
                    this.destroy(e_eof);
                    // exit gracefully
                    return;
                }
                // no errors. done flushing, close read stream
                fke_flush();
            }
        });
        // when the writable side is piped into
        ds_transform.on("pipe", (ds_input)=>{
            this._ds_input = ds_input;
            let b_byte_tracking = this._b_byte_tracking;
            // byte-tracking is disable & input stream has encoding option; ensure stream encoding is utf8
            if (!b_byte_tracking && "function" === typeof ds_input.setEncoding) ds_input.setEncoding("utf8");
            else {
                let f_write = ds_transform.write;
                let d_decoder = new $eNRCS.StringDecoder("utf8");
                let f_write_track = (s_chunk, s_encoding, fk_write)=>{
                    // TODO: optimize by testing for multibyte chars and using string length instead?
                    let nb_chunk = $50d4a76629506683$require$Buffer.from(s_chunk, "utf8").length;
                    this._nb_seen += nb_chunk;
                    this._nb_last = nb_chunk;
                    return f_write.call(ds_transform, s_chunk, s_encoding, fk_write);
                };
                let f_decode_write_track = (ab_chunk, s_encoding, fk_write)=>{
                    let nb_chunk = this._nb_last = ab_chunk.length;
                    this._nb_seen += nb_chunk;
                    return f_write.call(ds_transform, d_decoder.write(ab_chunk), s_encoding, fk_write);
                };
                let f_decode_write = (ab_chunk, s_encoding, fk_write)=>f_write.call(ds_transform, d_decoder.write(ab_chunk), s_encoding, fk_write);
                ds_transform.write = function(z_chunk, s_encoding, fk_write) {
                    // not null
                    if (null !== z_chunk) {
                        // chunk is string; adapt by resetting method to original
                        if ("string" === typeof z_chunk) ds_transform.write = b_byte_tracking ? f_write_track : f_write;
                        else ds_transform.write = b_byte_tracking ? f_decode_write_track : f_decode_write;
                        // use set method
                        return ds_transform.write(z_chunk, s_encoding, fk_write);
                    }
                    // null, use parent
                    return f_write.call(ds_transform, z_chunk, s_encoding, fk_write);
                };
                // byte tracking is enabled
                if (b_byte_tracking) // overwrite emit_data method
                this.emit_data = this.data = this.restore_data = function() {
                    let g_quad = this._dc_factory.quad(this._kt_subject, this._kt_predicate, this._kt_object, this._kt_graph);
                    let nb_post = $50d4a76629506683$require$Buffer.from(this.s.slice(this.i)).length;
                    let ib_post = this._nb_seen - nb_post;
                    g_quad.byteRange = [
                        this._nb_curr,
                        ib_post
                    ];
                    this._nb_curr = ib_post;
                    this.transform.push(g_quad);
                };
            }
        });
        // new listener added
        ds_transform.on("newListener", (s_event)=>{
            // comment
            if ("comment" === s_event) this.emit_comments = (s_captured)=>{
                let a_comments = s_captured.slice(1).replace(/\n\s+$/, "").split(/\n+\s*#/g);
                for (let s_comment of a_comments)ds_transform.emit("comment", s_comment);
            };
        });
        // destroy
        ds_transform._destroy = (...a_args)=>{
            this.destroy(...a_args);
        };
        // bind events to transform stream
        this.bind(g_config);
        // input given
        if (g_input) {
            // input is stream
            if (g_input.stream) {
                let ds_input = g_input.stream;
                // go async so caller has chance to bind event listeners
                queueMicrotask(()=>{
                    ds_input.pipe(ds_transform);
                });
            } else if ("string" === typeof g_input.string) {
                let s_input = g_input.string;
                // go async so caller has chance to bind event listeners
                queueMicrotask(()=>{
                    ds_transform.end(s_input, "utf8");
                });
            } else throw new TypeError(`Invalid argument for input parameter: ${"object" === typeof g_input ? JSON.stringify(g_input) : g_input}`);
        }
    }
    // begin parsing, keep applying until no more stack bail-outs
    safe_parse() {
        try {
            let f_sync = this._f_state();
            while("function" === typeof f_sync)f_sync = f_sync.apply(this);
        } // read error occurred
        catch (e_read) {
            // destroy self and stream
            this.destroy(e_read);
            // failure
            return false;
        }
        // okay
        return true;
    }
    emit(s_event, ...a_args) {
        this.transform.emit(s_event, ...a_args);
    }
    queue(s_event, ...a_args) {
        this._a_queue_event.push({
            event: s_event,
            args: a_args
        });
    }
    error(s_message) {
        // bail out
        throw new Error(s_message);
    }
    // parse_error (not meant to be an event callback)
    parse_error(s_expected, b_eof = false) {
        let i = this.i;
        let i_off = Math.min(i, Math.abs(i - 15));
        let s = this.s;
        return this.error(`\n\`${s.substr(i_off, i_off + 90).replace(/[\n\t]/g, " ")}\`\n` + ` ${" ".repeat(i - i_off)}^\n` + `expected ${s_expected} ${b_eof ? "but encountered <<EOF>>" : ""}.  failed to parse a valid token starting at ${s[i] ? '"' + s[i] + '"' : "<<EOF>>"}`);
    }
    info_error(s_message) {
        let i = this.i;
        let i_off = Math.min(i, Math.abs(i - 15));
        let s = this.s;
        this.error(`\n\`${s.substr(i_off, i_off + 90).replace(/[\n\t]/g, " ")}\`\n` + ` ${" ".repeat(i - i_off)}^\n` + s_message);
    }
    // end of file
    eof() {
        // there are events queued
        if (this._a_queue_event.length) {
            let a_queue = this._a_queue_event;
            // drain event queue
            while(a_queue.length){
                // remove event from front of queue
                let h_event = a_queue.shift();
                // make event callback
                this[h_event.event](h_event.data);
            }
        }
        // invalid parsing state
        if (this.block !== this._f_state) {
            // append EOF char
            this.s += "\0";
            // exit "flowing" mode
            this.n = this.s.length;
            // resume parsing; no errors
            if (this.safe_parse()) {
                // eof has occurred under safe parse
                if (null === this.s) return;
                // still invalid parsing state
                if (this.block !== this._f_state) return this.parse_error(this._f_state.name, true);
            }
        }
        // there are still unparsed characters
        if (this.i < this.n) {
            // consume whitespace and comments
            let s = this.s;
            let i = this.i;
            // consume whitespace (and incidentally reset index)
            $50d4a76629506683$var$R_WS.lastIndex = i;
            $50d4a76629506683$var$R_WS.exec(s);
            i = $50d4a76629506683$var$R_WS.lastIndex;
            $50d4a76629506683$var$R_COMMENT.lastIndex = i;
            let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
            // advance beyond comment
            if ($50d4a76629506683$var$R_COMMENT.lastIndex > i) {
                this.i = i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                if (this.emit_comments) this.emit_comments(m_comment[0]);
            }
            // still unparsed characters
            if (i < this.n) {
                // not EOF
                if (!(i === this.n - 1 && "\0" === s[i])) // bad input; parse error
                return this.parse_error(this._f_state.name);
            }
        }
        // make buffer's alloc eligible for gc
        this.s = null;
        // transform stream
        let ds_transform = this.transform;
        // final progress update: no additional bytes were read
        ds_transform.emit("progress", 0);
        // call end event listener
        ds_transform.emit("eof", this._h_prefixes);
        // close write stream (EOF-signaling)
        ds_transform.push(null);
    }
    // bind event listeners to transform stream
    bind(g_config) {
        let ds_transform = this.transform;
        if (g_config.base) ds_transform.on("base", g_config.base);
        if (g_config.prefix) ds_transform.on("prefix", g_config.prefix);
        if (g_config.enter) ds_transform.on("enter", g_config.enter);
        if (g_config.exit) ds_transform.on("exit", g_config.exit);
        if (g_config.comment) ds_transform.on("comment", g_config.comment);
        if (g_config.error) ds_transform.on("error", g_config.error);
        if (g_config.read) ds_transform.once("read", g_config.read);
        if (g_config.progress) ds_transform.on("progress", g_config.progress);
        if (g_config.eof) ds_transform.once("eof", g_config.eof);
        if (g_config.end) ds_transform.once("end", g_config.end);
        if (g_config.finish) ds_transform.once("finish", g_config.finish);
        if (g_config.data) ds_transform.on("data", g_config.data);
    }
    // after a blank node subject (either property-list or colleciton)
    post_blank_subject() {
        let { s: s, i: i } = this;
        if ("." === s[i]) {
            // consume whitespace (and incidentally reset index)
            $50d4a76629506683$var$R_WS.lastIndex = i + 1;
            $50d4a76629506683$var$R_WS.exec(s);
            this.i = $50d4a76629506683$var$R_WS.lastIndex;
            // not inside block
            if (this._kt_default_graph === this._kt_graph) return this.block();
            else return this.statement();
        } else {
            // prepare sticky regex index
            $50d4a76629506683$var$R_CHAR_CLOSE.lastIndex = i;
            if ($50d4a76629506683$var$R_CHAR_CLOSE.exec(s)) {
                // advance index
                this.i = $50d4a76629506683$var$R_CHAR_CLOSE.lastIndex;
                // empty collection
                if (this._kt_rdf_nil.equals(this._kt_subject)) return this.error("empty collection");
                // emit graph_close event
                this.emit("exit", this._kt_graph);
                // reset graph
                this._kt_graph = this._kt_default_graph;
                // goto block state
                return this.block();
            }
        } // brace #1
        return this.pairs();
    }
    // parse state for statement
    statement() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // prefixed name quick
            // prepare sticky regex index
            $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.lastIndex = i;
            // execute regex
            let m_pnq_subject = $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.exec(s);
            // regex was a match
            if (m_pnq_subject) {
                // advance index
                this.i = $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.lastIndex;
                // check valid prefix
                let s_prefix_id = m_pnq_subject[1] || "";
                // invalid prefix
                if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                // commit subject iri from resolve prefixed name
                this._kt_subject = this.prefixed_name(s_prefix_id, m_pnq_subject[2]);
                // predicate-object pairs state
                return this.pairs();
            // iriref
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex = i;
                // execute regex
                let m_iriref_e_subject = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.exec(s);
                // regex was a match
                if (m_iriref_e_subject) {
                    // advance index
                    this.i = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex;
                    // ref iri
                    let s_iri = m_iriref_e_subject[1];
                    // absolute iri
                    if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set subject
                    this._kt_subject = this.check_named_node_escapeless(s_iri);
                    else this._kt_subject = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                    // predicate-object pairs state
                    return this.pairs();
                // prefixed name
                } else {
                    // try match
                    let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                    // stack bail out
                    if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                    let [m_prefixed_named_e_subject, im_prefixed_named_e_subject] = aw_valid_this_match_prefixed_name_escapeless;
                    if (m_prefixed_named_e_subject) {
                        // advance index
                        this.i = im_prefixed_named_e_subject;
                        // check valid prefix
                        let s_prefix_id = m_prefixed_named_e_subject[1] || "";
                        // invalid prefix
                        if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                        // make subject key
                        this._kt_subject = this.prefixed_name(s_prefix_id, m_prefixed_named_e_subject[2]);
                        // predicate-object pairs state
                        return this.pairs();
                    // blank node label
                    } else {
                        // prepare sticky regex index
                        $50d4a76629506683$var$R_BLANK_NODE_LABEL.lastIndex = i;
                        // execute regex
                        let m_blank_node_label_subject = $50d4a76629506683$var$R_BLANK_NODE_LABEL.exec(s);
                        // regex was a match
                        if (m_blank_node_label_subject) {
                            // advance index
                            this.i = $50d4a76629506683$var$R_BLANK_NODE_LABEL.lastIndex;
                            // extract label
                            let s_label = m_blank_node_label_subject[1];
                            // make subject key
                            this._kt_subject = this.blank_node(s_label);
                            // predicate-object pairs state
                            return this.pairs();
                        // anonymous blank node subject
                        } else {
                            // prepare sticky regex index
                            $50d4a76629506683$var$R_ANONYMOUS_BLANK_NODE.lastIndex = i;
                            if ($50d4a76629506683$var$R_ANONYMOUS_BLANK_NODE.exec(s)) {
                                // advance index
                                this.i = $50d4a76629506683$var$R_ANONYMOUS_BLANK_NODE.lastIndex;
                                // set new blank node as subject
                                this._kt_subject = this.anonymous_blank_node(this.next_label());
                                // goto pairs state for inside property list
                                return this.pairs();
                            // anonymous blank node property list subject
                            } else {
                                // prepare sticky regex index
                                $50d4a76629506683$var$R_CHAR_BLANK_NODE.lastIndex = i;
                                if ($50d4a76629506683$var$R_CHAR_BLANK_NODE.exec(s)) {
                                    // advance index
                                    this.i = $50d4a76629506683$var$R_CHAR_BLANK_NODE.lastIndex;
                                    // enter blank node
                                    this._kt_subject = this.anonymous_blank_node(this.next_label());
                                    // how to resume when we pop state
                                    this._a_nested.push([
                                        this._kt_subject,
                                        this._kt_predicate,
                                        "post_blank_subject"
                                    ]);
                                    // goto pairs state for inside property list
                                    return this.pairs();
                                // rdf collection
                                } else {
                                    // prepare sticky regex index
                                    $50d4a76629506683$var$R_CHAR_COLLECTION.lastIndex = i;
                                    if ($50d4a76629506683$var$R_CHAR_COLLECTION.exec(s)) {
                                        // advance index
                                        this.i = $50d4a76629506683$var$R_CHAR_COLLECTION.lastIndex;
                                        // indicate that collection subject should emit an initial statement
                                        this._kt_subject = null;
                                        // (don't push state, we don't have a subject yet)
                                        // goto collection-subject state
                                        return this.collection_subject();
                                    // closing graph '}'
                                    } else {
                                        // prepare sticky regex index
                                        $50d4a76629506683$var$R_CHAR_CLOSE.lastIndex = i;
                                        if ($50d4a76629506683$var$R_CHAR_CLOSE.exec(s)) {
                                            // advance index
                                            this.i = $50d4a76629506683$var$R_CHAR_CLOSE.lastIndex;
                                            // emit graph_close event
                                            this.emit("exit", this._kt_graph);
                                            // reset graph
                                            this._kt_graph = this._kt_default_graph;
                                            // goto block state
                                            return this.block();
                                        // iriref
                                        } else {
                                            // prepare sticky regex index
                                            $50d4a76629506683$var$R_IRIREF.lastIndex = i;
                                            // execute regex
                                            let m_iriref_subject = $50d4a76629506683$var$R_IRIREF.exec(s);
                                            // regex was a match
                                            if (m_iriref_subject) {
                                                // advance index
                                                this.i = $50d4a76629506683$var$R_IRIREF.lastIndex;
                                                // ref iri
                                                let s_iri = m_iriref_subject[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                                                // absolute iri
                                                if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set subject
                                                this._kt_subject = this.check_named_node(s_iri);
                                                else this._kt_subject = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                                // predicate-object pairs state
                                                return this.pairs();
                                            // prefixed name
                                            } else {
                                                // try match
                                                let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                                // stack bail out
                                                if (!aw_valid_this_match_prefixed_name) return true;
                                                let [m_prefixed_named_subject, im_prefixed_named_subject] = aw_valid_this_match_prefixed_name;
                                                if (m_prefixed_named_subject) {
                                                    // advance index
                                                    this.i = im_prefixed_named_subject;
                                                    // check valid prefix
                                                    let s_prefix_id = m_prefixed_named_subject[1] || "";
                                                    // invalid prefix
                                                    if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                                    // escape local escapes
                                                    let s_suffix = m_prefixed_named_subject[2].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY).replace($50d4a76629506683$var$R_PN_LOCAL_ESCAPES, "$1");
                                                    // make subject key
                                                    this._kt_subject = this.prefixed_name(s_prefix_id, s_suffix);
                                                    // predicate-object pairs state
                                                    return this.pairs();
                                                // comment
                                                } else {
                                                    // prepare sticky regex index
                                                    $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                                                    // execute regex
                                                    let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                                                    // regex was a match
                                                    if (m_comment) {
                                                        // advance index
                                                        i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                                                        if (this.emit_comments) this.emit_comments(m_comment[0]);
                                                        continue;
                                                    // not iriref, not prefixed name, not blank node label, not prefix id, not base
                                                    // match counter: 10
                                                    } else break;
                                                } // brace #10
                                            } // brace #9
                                        } // brace #8
                                    } // brace #7
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("statement");
            }
        }
        // save state before pausing
        this._f_state = this.statement;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for block
    block() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // prepare sticky regex index
            $50d4a76629506683$var$R_GRAPH_IRI_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_graph_iriref_e_graph = $50d4a76629506683$var$R_GRAPH_IRI_ESCAPELESS.exec(s);
            // regex was a match
            if (m_graph_iriref_e_graph) {
                // advance index
                this.i = $50d4a76629506683$var$R_GRAPH_IRI_ESCAPELESS.lastIndex;
                // ref iri
                let s_iri = m_graph_iriref_e_graph[1];
                // absolute iri
                if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set graph
                this._kt_graph = this.check_named_node_escapeless(s_iri);
                else this._kt_graph = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                this.emit("enter", this._kt_graph);
                // statement state
                return this.statement();
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_GRAPH_PREFIXED_NAME.lastIndex = i;
                // execute regex
                let m_graph_prefixed_name = $50d4a76629506683$var$R_GRAPH_PREFIXED_NAME.exec(s);
                // regex was a match
                if (m_graph_prefixed_name) {
                    // advance index
                    this.i = $50d4a76629506683$var$R_GRAPH_PREFIXED_NAME.lastIndex;
                    // check valid prefix
                    let s_prefix_id = m_graph_prefixed_name[1] || "";
                    // invalid prefix
                    if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                    // make subject key
                    this._kt_graph = this.prefixed_name(s_prefix_id, m_graph_prefixed_name[2]);
                    this.emit("enter", this._kt_graph);
                    // statement state
                    return this.statement();
                } else {
                    // prepare sticky regex index
                    $50d4a76629506683$var$R_CHAR_OPEN.lastIndex = i;
                    if ($50d4a76629506683$var$R_CHAR_OPEN.exec(s)) {
                        // advance index
                        this.i = $50d4a76629506683$var$R_CHAR_OPEN.lastIndex;
                        // make new default graph
                        this._kt_graph = this._dc_factory.defaultGraph();
                        this.emit("enter", this._kt_graph);
                        // goto statement state
                        return this.statement();
                    } else {
                        // prepare sticky regex index
                        $50d4a76629506683$var$R_GRAPH_ANONYMOUS_BLANK_NODE.lastIndex = i;
                        // execute regex
                        let m_graph_anonymous_blank_node = $50d4a76629506683$var$R_GRAPH_ANONYMOUS_BLANK_NODE.exec(s);
                        // regex was a match
                        if (m_graph_anonymous_blank_node) {
                            // advance index
                            this.i = $50d4a76629506683$var$R_GRAPH_ANONYMOUS_BLANK_NODE.lastIndex;
                            // make new label & set graph to blank node
                            this._kt_graph = this.anonymous_blank_node(this.next_label());
                            this.emit("enter", this._kt_graph);
                            // statement state
                            return this.statement();
                        } else {
                            // prepare sticky regex index
                            $50d4a76629506683$var$R_GRAPH_LABELED_BLANK_NODE.lastIndex = i;
                            // execute regex
                            let m_graph_labeled_blank_node = $50d4a76629506683$var$R_GRAPH_LABELED_BLANK_NODE.exec(s);
                            // regex was a match
                            if (m_graph_labeled_blank_node) {
                                // advance index
                                this.i = $50d4a76629506683$var$R_GRAPH_LABELED_BLANK_NODE.lastIndex;
                                let s_label = m_graph_labeled_blank_node[1];
                                this._kt_graph = this.blank_node(s_label);
                                this.emit("enter", this._kt_graph);
                                // statement state
                                return this.statement();
                            // iriref
                            } else {
                                // prepare sticky regex index
                                $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex = i;
                                // execute regex
                                let m_iriref_e_graph_subject = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.exec(s);
                                // regex was a match
                                if (m_iriref_e_graph_subject) {
                                    // advance index
                                    this.i = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex;
                                    // ref iri
                                    let s_iri = m_iriref_e_graph_subject[1];
                                    // absolute iri
                                    if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set subject
                                    this._kt_subject = this.check_named_node_escapeless(s_iri);
                                    else this._kt_subject = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                    // graph or subject
                                    return this.graph_or_subject();
                                // prefixed name
                                } else {
                                    // try match
                                    let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                                    // stack bail out
                                    if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                                    let [m_prefixed_named_e_subject, im_prefixed_named_e_subject] = aw_valid_this_match_prefixed_name_escapeless;
                                    if (m_prefixed_named_e_subject) {
                                        // advance index
                                        this.i = im_prefixed_named_e_subject;
                                        // check valid prefix
                                        let s_prefix_id = m_prefixed_named_e_subject[1] || "";
                                        // invalid prefix
                                        if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                        // make subject key
                                        this._kt_subject = this.prefixed_name(s_prefix_id, m_prefixed_named_e_subject[2]);
                                        // predicate-object pairs state
                                        return this.graph_or_subject();
                                    // blank node label
                                    } else {
                                        // prepare sticky regex index
                                        $50d4a76629506683$var$R_BLANK_NODE_LABEL.lastIndex = i;
                                        // execute regex
                                        let m_blank_node_label_subject = $50d4a76629506683$var$R_BLANK_NODE_LABEL.exec(s);
                                        // regex was a match
                                        if (m_blank_node_label_subject) {
                                            // advance index
                                            this.i = $50d4a76629506683$var$R_BLANK_NODE_LABEL.lastIndex;
                                            // extract label
                                            let s_label = m_blank_node_label_subject[1];
                                            // make subject key
                                            this._kt_subject = this.blank_node(s_label);
                                            // predicate-object pairs state
                                            return this.graph_or_subject();
                                        // anonymous blank node subject
                                        } else {
                                            // prepare sticky regex index
                                            $50d4a76629506683$var$R_ANONYMOUS_BLANK_NODE.lastIndex = i;
                                            if ($50d4a76629506683$var$R_ANONYMOUS_BLANK_NODE.exec(s)) {
                                                // advance index
                                                this.i = $50d4a76629506683$var$R_ANONYMOUS_BLANK_NODE.lastIndex;
                                                // set new blank node as subject
                                                this._kt_subject = this.anonymous_blank_node(this.next_label());
                                                // goto pairs state for inside property list
                                                return this.graph_or_subject();
                                            // anonymous blank node property list subject
                                            } else {
                                                // prepare sticky regex index
                                                $50d4a76629506683$var$R_CHAR_BLANK_NODE.lastIndex = i;
                                                if ($50d4a76629506683$var$R_CHAR_BLANK_NODE.exec(s)) {
                                                    // advance index
                                                    this.i = $50d4a76629506683$var$R_CHAR_BLANK_NODE.lastIndex;
                                                    // enter blank node
                                                    this._kt_subject = this.anonymous_blank_node(this.next_label());
                                                    // how to resume when we pop state
                                                    this._a_nested.push([
                                                        this._kt_subject,
                                                        this._kt_predicate,
                                                        "post_blank_subject"
                                                    ]);
                                                    // goto pairs state for inside property list
                                                    return this.graph_or_subject_property_list();
                                                // rdf collection
                                                } else {
                                                    // prepare sticky regex index
                                                    $50d4a76629506683$var$R_CHAR_COLLECTION.lastIndex = i;
                                                    if ($50d4a76629506683$var$R_CHAR_COLLECTION.exec(s)) {
                                                        // advance index
                                                        this.i = $50d4a76629506683$var$R_CHAR_COLLECTION.lastIndex;
                                                        // indicate that collection subject should emit an initial statement
                                                        this._kt_subject = null;
                                                        // (don't push state, we don't have a subject yet)
                                                        // goto collection-subject state
                                                        return this.collection_subject();
                                                    // prefix with interupt (e.g., a comment)
                                                    } else {
                                                        // prepare sticky regex index
                                                        $50d4a76629506683$var$R_PREFIX_KEYWORD.lastIndex = i;
                                                        // execute regex
                                                        let m_prefix_keyword = $50d4a76629506683$var$R_PREFIX_KEYWORD.exec(s);
                                                        // regex was a match
                                                        if (m_prefix_keyword) {
                                                            // advance index
                                                            this.i = $50d4a76629506683$var$R_PREFIX_KEYWORD.lastIndex;
                                                            // save whether or not to expect a full stop
                                                            this._b_expecting_full_stop = !!m_prefix_keyword[1];
                                                            // goto prefix state
                                                            return this.prefix_id();
                                                        // base with interupt (e.g., a comment)
                                                        } else {
                                                            // prepare sticky regex index
                                                            $50d4a76629506683$var$R_BASE_KEYWORD.lastIndex = i;
                                                            // execute regex
                                                            let m_base_keyword = $50d4a76629506683$var$R_BASE_KEYWORD.exec(s);
                                                            // regex was a match
                                                            if (m_base_keyword) {
                                                                // advance index
                                                                this.i = $50d4a76629506683$var$R_BASE_KEYWORD.lastIndex;
                                                                // save whether or not to expect a full stop
                                                                this._b_expecting_full_stop = !!m_base_keyword[1];
                                                                // goto base state
                                                                return this.base_iri();
                                                            // iriref
                                                            } else {
                                                                // prepare sticky regex index
                                                                $50d4a76629506683$var$R_IRIREF.lastIndex = i;
                                                                // execute regex
                                                                let m_iriref_subject = $50d4a76629506683$var$R_IRIREF.exec(s);
                                                                // regex was a match
                                                                if (m_iriref_subject) {
                                                                    // advance index
                                                                    this.i = $50d4a76629506683$var$R_IRIREF.lastIndex;
                                                                    // ref iri
                                                                    let s_iri = m_iriref_subject[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                                                                    // absolute iri
                                                                    if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set subject
                                                                    this._kt_subject = this.check_named_node(s_iri);
                                                                    else this._kt_subject = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                                                    // predicate-object pairs state
                                                                    return this.graph_or_subject();
                                                                // prefixed name
                                                                } else {
                                                                    // try match
                                                                    let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                                                    // stack bail out
                                                                    if (!aw_valid_this_match_prefixed_name) return true;
                                                                    let [m_prefixed_named_subject, im_prefixed_named_subject] = aw_valid_this_match_prefixed_name;
                                                                    if (m_prefixed_named_subject) {
                                                                        // advance index
                                                                        this.i = im_prefixed_named_subject;
                                                                        // check valid prefix
                                                                        let s_prefix_id = m_prefixed_named_subject[1] || "";
                                                                        // invalid prefix
                                                                        if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                                                        // escape local escapes
                                                                        let s_suffix = m_prefixed_named_subject[2].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY).replace($50d4a76629506683$var$R_PN_LOCAL_ESCAPES, "$1");
                                                                        // make subject key
                                                                        this._kt_subject = this.prefixed_name(s_prefix_id, s_suffix);
                                                                        // predicate-object pairs state
                                                                        return this.graph_or_subject();
                                                                    } else {
                                                                        // prepare sticky regex index
                                                                        $50d4a76629506683$var$R_GRAPH_IRI.lastIndex = i;
                                                                        // execute regex
                                                                        let m_graph_iriref_graph = $50d4a76629506683$var$R_GRAPH_IRI.exec(s);
                                                                        // regex was a match
                                                                        if (m_graph_iriref_graph) {
                                                                            // advance index
                                                                            this.i = $50d4a76629506683$var$R_GRAPH_IRI.lastIndex;
                                                                            // ref iri
                                                                            let s_iri = m_graph_iriref_graph[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                                                                            // absolute iri
                                                                            if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set graph
                                                                            this._kt_graph = this.check_named_node(s_iri);
                                                                            else this._kt_graph = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                                                            this.emit("enter", this._kt_graph);
                                                                            // statement state
                                                                            return this.statement();
                                                                        // comment
                                                                        } else {
                                                                            // prepare sticky regex index
                                                                            $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                                                                            // execute regex
                                                                            let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                                                                            // regex was a match
                                                                            if (m_comment) {
                                                                                // advance index
                                                                                i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                                                                                if (this.emit_comments) this.emit_comments(m_comment[0]);
                                                                                continue;
                                                                            } else {
                                                                                // prepare sticky regex index
                                                                                $50d4a76629506683$var$R_GRAPH.lastIndex = i;
                                                                                if ($50d4a76629506683$var$R_GRAPH.exec(s)) {
                                                                                    // advance index
                                                                                    this.i = $50d4a76629506683$var$R_GRAPH.lastIndex;
                                                                                    return this.graph_keyword();
                                                                                // not iriref, not prefixed name, not blank node label, not prefix id, not base
                                                                                // match counter: 17
                                                                                } else break;
                                                                            } // brace #17
                                                                        } // brace #16
                                                                    } // brace #15
                                                                } // brace #14
                                                            } // brace #13
                                                        } // brace #12
                                                    } // brace #11
                                                } // brace #10
                                            } // brace #9
                                        } // brace #8
                                    } // brace #7
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("block");
            }
        }
        // save state before pausing
        this._f_state = this.block;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for graph_or_subject
    graph_or_subject() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            let x = s[i];
            if ("{" === x) {
                // consume whitespace (and incidentally reset index)
                $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                $50d4a76629506683$var$R_WS.exec(s);
                this.i = $50d4a76629506683$var$R_WS.lastIndex;
                // shift placeholder subject
                this._kt_graph = this._kt_subject;
                this.emit("enter", this._kt_graph);
                // reset subject in case of collections
                this._kt_subject = null;
                // statement state
                return this.statement();
            // non-comment
            } else if ("#" !== x) return this.pairs();
            else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // match counter: 1
                } else break;
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("graph_or_subject");
            }
        }
        // save state before pausing
        this._f_state = this.graph_or_subject;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for graph_or_subject_property_list
    graph_or_subject_property_list() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            let x = s[i];
            if ("]" === x) {
                // consume whitespace (and incidentally reset index)
                $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                $50d4a76629506683$var$R_WS.exec(s);
                this.i = $50d4a76629506683$var$R_WS.lastIndex;
                // next state
                return this.graph_or_subject_anon();
            // non-comment
            } else if ("#" !== x) return this.pairs();
            else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // match counter: 1
                } else break;
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("graph_or_subject_property_list");
            }
        }
        // save state before pausing
        this._f_state = this.graph_or_subject_property_list;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for graph_or_subject_anon
    graph_or_subject_anon() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            let x = s[i];
            if ("{" === x) {
                // consume whitespace (and incidentally reset index)
                $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                $50d4a76629506683$var$R_WS.exec(s);
                this.i = $50d4a76629506683$var$R_WS.lastIndex;
                // shift placeholder subject
                this._kt_graph = this._kt_subject;
                this.emit("enter", this._kt_graph);
                // reset subject in case of collections
                this._kt_subject = null;
                // pop dummy state
                this._a_nested.pop();
                // statement state
                return this.statement();
            // non-comment
            } else if ("#" !== x) return this.pairs();
            else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // match counter: 1
                } else break;
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("graph_or_subject_anon");
            }
        }
        // save state before pausing
        this._f_state = this.graph_or_subject_anon;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for graph_keyword
    graph_keyword() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // prefixed name
            // try match
            let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
            // stack bail out
            if (!aw_valid_this_match_prefixed_name_escapeless) return true;
            let [m_prefixed_named_e_graph, im_prefixed_named_e_graph] = aw_valid_this_match_prefixed_name_escapeless;
            if (m_prefixed_named_e_graph) {
                // advance index
                this.i = im_prefixed_named_e_graph;
                // check valid prefix
                let s_prefix_id = m_prefixed_named_e_graph[1] || "";
                // invalid prefix
                if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                // make subject key
                this._kt_graph = this.prefixed_name(s_prefix_id, m_prefixed_named_e_graph[2]);
                // predicate-object pairs state
                return this.graph_post_name();
            // iriref
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex = i;
                // execute regex
                let m_iriref_e_graph = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.exec(s);
                // regex was a match
                if (m_iriref_e_graph) {
                    // advance index
                    this.i = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex;
                    // ref iri
                    let s_iri = m_iriref_e_graph[1];
                    // absolute iri
                    if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set graph
                    this._kt_graph = this.check_named_node_escapeless(s_iri);
                    else this._kt_graph = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                    // graph
                    return this.graph_post_name();
                // blank node label
                } else {
                    // prepare sticky regex index
                    $50d4a76629506683$var$R_BLANK_NODE_LABEL.lastIndex = i;
                    // execute regex
                    let m_blank_node_label_graph = $50d4a76629506683$var$R_BLANK_NODE_LABEL.exec(s);
                    // regex was a match
                    if (m_blank_node_label_graph) {
                        // advance index
                        this.i = $50d4a76629506683$var$R_BLANK_NODE_LABEL.lastIndex;
                        // extract label
                        let s_label = m_blank_node_label_graph[1];
                        // make graph key
                        this._kt_graph = this.blank_node(s_label);
                        // predicate-object pairs state
                        return this.graph_post_name();
                    // anonymous blank node graph
                    } else {
                        // prepare sticky regex index
                        $50d4a76629506683$var$R_ANONYMOUS_BLANK_NODE.lastIndex = i;
                        if ($50d4a76629506683$var$R_ANONYMOUS_BLANK_NODE.exec(s)) {
                            // advance index
                            this.i = $50d4a76629506683$var$R_ANONYMOUS_BLANK_NODE.lastIndex;
                            // set new blank node as graph
                            this._kt_graph = this.anonymous_blank_node(this.next_label());
                            // goto pairs state for inside property list
                            return this.graph_post_name();
                        // iriref
                        } else {
                            // prepare sticky regex index
                            $50d4a76629506683$var$R_IRIREF.lastIndex = i;
                            // execute regex
                            let m_iriref_graph = $50d4a76629506683$var$R_IRIREF.exec(s);
                            // regex was a match
                            if (m_iriref_graph) {
                                // advance index
                                this.i = $50d4a76629506683$var$R_IRIREF.lastIndex;
                                // ref iri
                                let s_iri = m_iriref_graph[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                                // absolute iri
                                if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set graph
                                this._kt_graph = this.check_named_node(s_iri);
                                else this._kt_graph = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                // predicate-object pairs state
                                return this.graph_post_name();
                            // prefixed name
                            } else {
                                // try match
                                let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                // stack bail out
                                if (!aw_valid_this_match_prefixed_name) return true;
                                let [m_prefixed_named_graph, im_prefixed_named_graph] = aw_valid_this_match_prefixed_name;
                                if (m_prefixed_named_graph) {
                                    // advance index
                                    this.i = im_prefixed_named_graph;
                                    // check valid prefix
                                    let s_prefix_id = m_prefixed_named_graph[1] || "";
                                    // invalid prefix
                                    if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                    // escape local escapes
                                    let s_suffix = m_prefixed_named_graph[2].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY).replace($50d4a76629506683$var$R_PN_LOCAL_ESCAPES, "$1");
                                    // make subject key
                                    this._kt_graph = this.prefixed_name(s_prefix_id, s_suffix);
                                    // predicate-object pairs state
                                    return this.graph_post_name();
                                // comment
                                } else {
                                    // prepare sticky regex index
                                    $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                                    // execute regex
                                    let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                                    // regex was a match
                                    if (m_comment) {
                                        // advance index
                                        i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                                        if (this.emit_comments) this.emit_comments(m_comment[0]);
                                        continue;
                                    // not iriref, not prefixed name, not blank node label, not prefix id, not base
                                    // match counter: 6
                                    } else break;
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("graph_keyword");
            }
        }
        // save state before pausing
        this._f_state = this.graph_keyword;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for graph_post_name
    graph_post_name() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            let x = s[i];
            if ("{" === x) {
                // consume whitespace (and incidentally reset index)
                $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                $50d4a76629506683$var$R_WS.exec(s);
                this.i = $50d4a76629506683$var$R_WS.lastIndex;
                this.emit("enter", this._kt_graph);
                // statement state
                return this.statement();
            // comment
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // match counter: 1
                } else break;
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("graph_post_name");
            }
        }
        // save state before pausing
        this._f_state = this.graph_post_name;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for pairs
    pairs() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // benchmarks indicate: regex for end of blank node property list faster than ch
            // iriref
            // prepare sticky regex index
            $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_iriref_e_predicate = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.exec(s);
            // regex was a match
            if (m_iriref_e_predicate) {
                // advance index
                this.i = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex;
                // ref iri
                let s_iri = m_iriref_e_predicate[1];
                // absolute iri
                if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set predicate
                this._kt_predicate = this.check_named_node_escapeless(s_iri);
                else this._kt_predicate = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                // object-list state
                return this.object_list();
            // prefixed name
            } else {
                // try match
                let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                // stack bail out
                if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                let [m_prefixed_named_e_predicate, im_prefixed_named_e_predicate] = aw_valid_this_match_prefixed_name_escapeless;
                if (m_prefixed_named_e_predicate) {
                    // advance index
                    this.i = im_prefixed_named_e_predicate;
                    // check valid prefix
                    let s_prefix_id = m_prefixed_named_e_predicate[1] || "";
                    // invalid prefix
                    if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                    // make predicate key
                    this._kt_predicate = this.prefixed_name(s_prefix_id, m_prefixed_named_e_predicate[2]);
                    // object-list state
                    return this.object_list();
                // 'a'
                } else {
                    // prepare sticky regex index
                    $50d4a76629506683$var$R_A.lastIndex = i;
                    if ($50d4a76629506683$var$R_A.exec(s)) {
                        // advance index
                        this.i = $50d4a76629506683$var$R_A.lastIndex;
                        // make predicate key
                        this._kt_predicate = this._kt_rdf_type;
                        // object-list state
                        return this.object_list();
                    // ']' end of blank node property list
                    } else {
                        // prepare sticky regex index
                        $50d4a76629506683$var$R_CHAR_KET.lastIndex = i;
                        if ($50d4a76629506683$var$R_CHAR_KET.exec(s)) {
                            // advance index
                            this.i = $50d4a76629506683$var$R_CHAR_KET.lastIndex;
                            let s_resume_state;
                            [this._kt_subject, this._kt_predicate, s_resume_state] = this._a_nested.pop();
                            return this[s_resume_state]();
                        // iriref
                        } else {
                            // prepare sticky regex index
                            $50d4a76629506683$var$R_IRIREF.lastIndex = i;
                            // execute regex
                            let m_iriref_predicate = $50d4a76629506683$var$R_IRIREF.exec(s);
                            // regex was a match
                            if (m_iriref_predicate) {
                                // advance index
                                this.i = $50d4a76629506683$var$R_IRIREF.lastIndex;
                                // ref iri
                                let s_iri = m_iriref_predicate[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                                // absolute iri
                                if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set predicate
                                this._kt_predicate = this.check_named_node(s_iri);
                                else this._kt_predicate = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                // object-list state
                                return this.object_list();
                            // prefixed name
                            } else {
                                // try match
                                let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                // stack bail out
                                if (!aw_valid_this_match_prefixed_name) return true;
                                let [m_prefixed_named_predicate, im_prefixed_named_predicate] = aw_valid_this_match_prefixed_name;
                                if (m_prefixed_named_predicate) {
                                    // advance index
                                    this.i = im_prefixed_named_predicate;
                                    // check valid prefix
                                    let s_prefix_id = m_prefixed_named_predicate[1] || "";
                                    // invalid prefix
                                    if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                    // escape local escapes
                                    let s_suffix = m_prefixed_named_predicate[2].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY).replace($50d4a76629506683$var$R_PN_LOCAL_ESCAPES, "$1");
                                    // make predicate key
                                    this._kt_predicate = this.prefixed_name(s_prefix_id, s_suffix);
                                    // object-list state
                                    return this.object_list();
                                } else {
                                    // prepare sticky regex index
                                    $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                                    // execute regex
                                    let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                                    // regex was a match
                                    if (m_comment) {
                                        // advance index
                                        i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                                        if (this.emit_comments) this.emit_comments(m_comment[0]);
                                        continue;
                                    // not iriref, not prefixed name, not 'a'
                                    // match counter: 6
                                    } else break;
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("pairs");
            }
        }
        // save state before pausing
        this._f_state = this.pairs;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for object_list
    object_list() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // ref char
            let x = s[i];
            // string literal * double
            if ('"' === x) {
                // enough chars to deduce type
                if (i + 2 < n) {
                    // long type
                    if ('"' === s[i + 1] && '"' === s[i + 2]) {
                        // advance index beyond token
                        this.i = i + 3;
                        // read contents
                        return this.string_literal_long_double();
                    } else {
                        // advance index beyond token
                        this.i = i + 1;
                        // read contents
                        return this.string_literal_short_double();
                    }
                } else if (i + 1 < n && '"' !== s[i + 1]) {
                    // advance index beyond token
                    this.i = i + 1;
                    // read contents
                    return this.string_literal_short_double();
                } else break;
            // prefixed name quick
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.lastIndex = i;
                // execute regex
                let m_pnq_object = $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.exec(s);
                // regex was a match
                if (m_pnq_object) {
                    // advance index
                    this.i = $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.lastIndex;
                    // check valid prefix
                    let s_prefix_id = m_pnq_object[1] || "";
                    // invalid prefix
                    if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                    // commit object iri from resolve prefixed name
                    this._kt_object = this.prefixed_name(s_prefix_id, m_pnq_object[2]);
                // iriref
                } else {
                    // prepare sticky regex index
                    $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex = i;
                    // execute regex
                    let m_iriref_e_object = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.exec(s);
                    // regex was a match
                    if (m_iriref_e_object) {
                        // advance index
                        this.i = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex;
                        // ref iri
                        let s_iri = m_iriref_e_object[1];
                        // absolute iri
                        if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                        this._kt_object = this.check_named_node_escapeless(s_iri);
                        else this._kt_object = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                    // prefixed name
                    } else {
                        // try match
                        let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                        // stack bail out
                        if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                        let [m_prefixed_named_e_object, im_prefixed_named_e_object] = aw_valid_this_match_prefixed_name_escapeless;
                        if (m_prefixed_named_e_object) {
                            // advance index
                            this.i = im_prefixed_named_e_object;
                            // check valid prefix
                            let s_prefix_id = m_prefixed_named_e_object[1] || "";
                            // invalid prefix
                            if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                            // commit object iri from resolve prefixed name
                            this._kt_object = this.prefixed_name(s_prefix_id, m_prefixed_named_e_object[2]);
                        // string literal * single
                        } else if ("'" === x) {
                            // enough chars to deduce type
                            if (i + 2 < n) {
                                // long type
                                if ("'" === s[i + 1] && "'" === s[i + 2]) {
                                    // advance index beyond token
                                    this.i = i + 3;
                                    // read contents
                                    return this.string_literal_long_single();
                                } else {
                                    // advance index beyond token
                                    this.i = i + 1;
                                    // read contents
                                    return this.string_literal_short_single();
                                }
                            } else if (i + 1 < n && "'" !== s[i + 1]) {
                                // advance index beyond token
                                this.i = i + 1;
                                // read contents
                                return this.string_literal_short_single();
                            } else break;
                        // numeric literal
                        } else {
                            // prepare sticky regex index
                            $50d4a76629506683$var$R_NUMERIC_LITERAL.lastIndex = i;
                            // execute regex
                            let m_numeric_literal = $50d4a76629506683$var$R_NUMERIC_LITERAL.exec(s);
                            // regex was a match
                            if (m_numeric_literal) {
                                // advance index
                                this.i = $50d4a76629506683$var$R_NUMERIC_LITERAL.lastIndex;
                                // it has exponent term, xsd:double
                                if (m_numeric_literal[4]) this._kt_object = this._dc_factory.double(m_numeric_literal[1]);
                                else if (m_numeric_literal[2] || m_numeric_literal[3]) this._kt_object = this._dc_factory.decimal(m_numeric_literal[1]);
                                else this._kt_object = this._dc_factory.integer(m_numeric_literal[1]);
                            // boolean literal
                            } else {
                                // prepare sticky regex index
                                $50d4a76629506683$var$R_BOOLEAN_LITERAL.lastIndex = i;
                                // execute regex
                                let m_boolean_literal = $50d4a76629506683$var$R_BOOLEAN_LITERAL.exec(s);
                                // regex was a match
                                if (m_boolean_literal) {
                                    // advance index
                                    this.i = $50d4a76629506683$var$R_BOOLEAN_LITERAL.lastIndex;
                                    // make literal
                                    this._kt_object = this._dc_factory.boolean(!!m_boolean_literal[1]);
                                // blank node property list
                                } else if ("[" === x) {
                                    // advance index to next token
                                    // consume whitespace (and incidentally reset index)
                                    $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                                    $50d4a76629506683$var$R_WS.exec(s);
                                    this.i = $50d4a76629506683$var$R_WS.lastIndex;
                                    // make object
                                    let kt_blank_node = this._kt_object = this.anonymous_blank_node(this.next_label());
                                    // emit statement event
                                    this.data();
                                    // push state to stack
                                    this._a_nested.push([
                                        this._kt_subject,
                                        this._kt_predicate,
                                        "post_object"
                                    ]);
                                    // set new subject
                                    this._kt_subject = kt_blank_node;
                                    // goto parsing pairs state
                                    return this.pairs();
                                // labeled blank node
                                } else {
                                    // prepare sticky regex index
                                    $50d4a76629506683$var$R_BLANK_NODE_LABEL_TERMINAL.lastIndex = i;
                                    // execute regex
                                    let m_blank_node_label_object = $50d4a76629506683$var$R_BLANK_NODE_LABEL_TERMINAL.exec(s);
                                    // regex was a match
                                    if (m_blank_node_label_object) {
                                        // advance index
                                        this.i = $50d4a76629506683$var$R_BLANK_NODE_LABEL_TERMINAL.lastIndex;
                                        // ref blank node label
                                        let s_label = m_blank_node_label_object[1];
                                        // make object
                                        this._kt_object = this.blank_node(s_label);
                                    // collection
                                    } else if ("(" === x) {
                                        // advance index to next token
                                        // consume whitespace (and incidentally reset index)
                                        $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                                        $50d4a76629506683$var$R_WS.exec(s);
                                        this.i = $50d4a76629506683$var$R_WS.lastIndex;
                                        // state to resume after collection ends
                                        this._a_nested.push([
                                            this._kt_subject,
                                            this._kt_predicate,
                                            "post_object"
                                        ]);
                                        // goto collection-object state
                                        return this.collection_object();
                                    // iriref
                                    } else {
                                        // prepare sticky regex index
                                        $50d4a76629506683$var$R_IRIREF.lastIndex = i;
                                        // execute regex
                                        let m_iriref_object = $50d4a76629506683$var$R_IRIREF.exec(s);
                                        // regex was a match
                                        if (m_iriref_object) {
                                            // advance index
                                            this.i = $50d4a76629506683$var$R_IRIREF.lastIndex;
                                            // ref iri
                                            let s_iri = m_iriref_object[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                                            // absolute iri
                                            if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                                            this._kt_object = this.check_named_node(s_iri);
                                            else this._kt_object = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                        // prefixed name
                                        } else {
                                            // try match
                                            let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                            // stack bail out
                                            if (!aw_valid_this_match_prefixed_name) return true;
                                            let [m_prefixed_named_object, im_prefixed_named_object] = aw_valid_this_match_prefixed_name;
                                            if (m_prefixed_named_object) {
                                                // advance index
                                                this.i = im_prefixed_named_object;
                                                // check valid prefix
                                                let s_prefix_id = m_prefixed_named_object[1] || "";
                                                // invalid prefix
                                                if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                                // escape local escapes
                                                let s_suffix = m_prefixed_named_object[2].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY).replace($50d4a76629506683$var$R_PN_LOCAL_ESCAPES, "$1");
                                                // commit object iri from resolve prefixed name
                                                this._kt_object = this.prefixed_name(s_prefix_id, s_suffix);
                                            } else {
                                                // prepare sticky regex index
                                                $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                                                // execute regex
                                                let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                                                // regex was a match
                                                if (m_comment) {
                                                    // advance index
                                                    i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                                                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                                                    continue;
                                                // not iriref, not prefixed name, not string literal, not numeric literal, not boolean literal, not blank node property list, not collection
                                                // match counter: 9
                                                } else break;
                                            } // brace #9
                                        } // brace #8
                                    } // brace #7
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
            // fall through for cases that did not change state on their own
            // at this point, a new statement has been parsed
            this.data();
            // goto next parsing state; bail out of stack
            return this.after_end_of_statement;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("object_list");
            }
        }
        // save state before pausing
        this._f_state = this.object_list;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for string_literal_short_double
    string_literal_short_double() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        string_literal_short_double: while(i < n){
            // something breaks string in this chunk
            // prepare sticky regex index
            $50d4a76629506683$var$R_STRLIT_SHORT_DOUBLE_BREAK.lastIndex = i;
            // execute regex
            let m_break = $50d4a76629506683$var$R_STRLIT_SHORT_DOUBLE_BREAK.exec(s);
            // regex was a match
            if (m_break) {
                // advance index
                this.i = $50d4a76629506683$var$R_STRLIT_SHORT_DOUBLE_BREAK.lastIndex;
                // index of break
                let i_break = m_break.index;
                // add to contents
                this._s_literal += s.slice(i, i_break);
                // depending on char
                switch(s[i_break]){
                    // terminator
                    case '"':
                        // advance index to next token beyond delimiter
                        // consume whitespace (and incidentally reset index)
                        $50d4a76629506683$var$R_WS.lastIndex = i_break + 1;
                        $50d4a76629506683$var$R_WS.exec(s);
                        this.i = $50d4a76629506683$var$R_WS.lastIndex;
                        // resume eating whitespace at start of next chunk
                        this._b_trim_start = true;
                        // consume rest
                        return this.datatype_or_langtag();
                    // escape
                    case "\\":
                        {
                            // try to find end
                            $50d4a76629506683$var$R_STRLIT_SHORT_DOUBLE_TERM.lastIndex = i_break;
                            let m_term = $50d4a76629506683$var$R_STRLIT_SHORT_DOUBLE_TERM.exec(s);
                            // end is in this chunk
                            if (m_term) {
                                // index of terminator
                                let i_term = m_term.index;
                                // extract dirty potion
                                let s_dirty = s.slice(i_break, i_term);
                                // clean and save
                                this._s_literal += $50d4a76629506683$var$unescape_literal_short_hard(s_dirty);
                                // advance index beyond terminator
                                this.i = i_term + m_term[0].length;
                                // resume eating whitespace at start of next chunk
                                this._b_trim_start = true;
                                // consume rest
                                return this.datatype_or_langtag();
                            } else {
                                // extract whole portion
                                let s_dirty = s.slice(i_break);
                                // unescape to clean part
                                let [s_clean, s_incomplete] = $50d4a76629506683$var$unescape_literal_short_soft(s_dirty);
                                // save
                                this._s_literal += s_clean;
                                // set unparsed index
                                i = n - s_incomplete.length;
                                break string_literal_short_double;
                            }
                        }
                    // invalid '\n'
                    case "\n":
                        return this.info_error(`expected string_literal_short_double but invalid line feed character '\\n' (newline) within contents. failed to parse a valid token`);
                    // invalid '\r'
                    case "\r":
                        return this.info_error(`expected string_literal_short_double but invalid form feed character '\\r' (carriage return) within contents. failed to parse a valid token`);
                    // invalid
                    default:
                        console.assert(`Unhandle invalid character ${JSON.stringify(s[i_break])} case for string_literal_short_double`);
                }
            // no terminator and nothing to escape
            // match counter: 0
            } else {
                // save
                this._s_literal += i ? s.slice(i) : s;
                // set unparsed index
                i = n;
                break;
            }
        }
        // do not eat whitespace at start of next chunk
        this._b_trim_start = false;
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("string_literal_short_double");
            }
        }
        // save state before pausing
        this._f_state = this.string_literal_short_double;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for string_literal_short_single
    string_literal_short_single() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        string_literal_short_single: while(i < n){
            // something breaks string in this chunk
            // prepare sticky regex index
            $50d4a76629506683$var$R_STRLIT_SHORT_SINGLE_BREAK.lastIndex = i;
            // execute regex
            let m_break = $50d4a76629506683$var$R_STRLIT_SHORT_SINGLE_BREAK.exec(s);
            // regex was a match
            if (m_break) {
                // advance index
                this.i = $50d4a76629506683$var$R_STRLIT_SHORT_SINGLE_BREAK.lastIndex;
                // index of break
                let i_break = m_break.index;
                // add to contents
                this._s_literal += s.slice(i, i_break);
                // depending on char
                switch(s[i_break]){
                    // terminator
                    case "'":
                        // advance index to next token beyond delimiter
                        // consume whitespace (and incidentally reset index)
                        $50d4a76629506683$var$R_WS.lastIndex = i_break + 1;
                        $50d4a76629506683$var$R_WS.exec(s);
                        this.i = $50d4a76629506683$var$R_WS.lastIndex;
                        // resume eating whitespace at start of next chunk
                        this._b_trim_start = true;
                        // consume rest
                        return this.datatype_or_langtag();
                    // escape
                    case "\\":
                        {
                            // try to find end
                            $50d4a76629506683$var$R_STRLIT_SHORT_SINGLE_TERM.lastIndex = i_break;
                            let m_term = $50d4a76629506683$var$R_STRLIT_SHORT_SINGLE_TERM.exec(s);
                            // end is in this chunk
                            if (m_term) {
                                // index of terminator
                                let i_term = m_term.index;
                                // extract dirty potion
                                let s_dirty = s.slice(i_break, i_term);
                                // clean and save
                                this._s_literal += $50d4a76629506683$var$unescape_literal_short_hard(s_dirty);
                                // advance index beyond terminator
                                this.i = i_term + m_term[0].length;
                                // resume eating whitespace at start of next chunk
                                this._b_trim_start = true;
                                // consume rest
                                return this.datatype_or_langtag();
                            } else {
                                // extract whole portion
                                let s_dirty = s.slice(i_break);
                                // unescape to clean part
                                let [s_clean, s_incomplete] = $50d4a76629506683$var$unescape_literal_short_soft(s_dirty);
                                // save
                                this._s_literal += s_clean;
                                // set unparsed index
                                i = n - s_incomplete.length;
                                break string_literal_short_single;
                            }
                        }
                    // invalid '\n'
                    case "\n":
                        return this.info_error(`expected string_literal_short_single but invalid line feed character '\\n' (newline) within contents. failed to parse a valid token`);
                    // invalid '\r'
                    case "\r":
                        return this.info_error(`expected string_literal_short_single but invalid form feed character '\\r' (carriage return) within contents. failed to parse a valid token`);
                    // invalid
                    default:
                        console.assert(`Unhandle invalid character ${JSON.stringify(s[i_break])} case for string_literal_short_single`);
                }
            // no terminator and nothing to escape
            // match counter: 0
            } else {
                // save
                this._s_literal += i ? s.slice(i) : s;
                // set unparsed index
                i = n;
                break;
            }
        }
        // do not eat whitespace at start of next chunk
        this._b_trim_start = false;
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("string_literal_short_single");
            }
        }
        // save state before pausing
        this._f_state = this.string_literal_short_single;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for string_literal_long_double
    string_literal_long_double() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        string_literal_long_double: while(i < n){
            // something breaks string in this chunk
            // prepare sticky regex index
            $50d4a76629506683$var$R_STRLIT_LONG_DOUBLE_BREAK.lastIndex = i;
            // execute regex
            let m_break = $50d4a76629506683$var$R_STRLIT_LONG_DOUBLE_BREAK.exec(s);
            // regex was a match
            if (m_break) {
                // advance index
                this.i = $50d4a76629506683$var$R_STRLIT_LONG_DOUBLE_BREAK.lastIndex;
                // index of break
                let i_break = m_break.index;
                // add to contents
                this._s_literal += s.slice(i, i_break);
                // depending on char
                switch(s[i_break]){
                    // terminator
                    case '"':
                        // advance index to next token beyond delimiter
                        // consume whitespace (and incidentally reset index)
                        $50d4a76629506683$var$R_WS.lastIndex = i_break + 3;
                        $50d4a76629506683$var$R_WS.exec(s);
                        this.i = $50d4a76629506683$var$R_WS.lastIndex;
                        // resume eating whitespace at start of next chunk
                        this._b_trim_start = true;
                        // consume rest
                        return this.datatype_or_langtag();
                    // escape
                    case "\\":
                        {
                            // try to find end
                            $50d4a76629506683$var$R_STRLIT_LONG_DOUBLE_TERM.lastIndex = i_break;
                            let m_term = $50d4a76629506683$var$R_STRLIT_LONG_DOUBLE_TERM.exec(s);
                            // end is in this chunk
                            if (m_term) {
                                // index of terminator
                                let i_term = m_term.index;
                                // extract dirty potion
                                let s_dirty = s.slice(i_break, i_term);
                                // clean and save
                                this._s_literal += $50d4a76629506683$var$unescape_literal_long_hard(s_dirty);
                                // advance index beyond terminator
                                this.i = i_term + m_term[0].length;
                                // resume eating whitespace at start of next chunk
                                this._b_trim_start = true;
                                // consume rest
                                return this.datatype_or_langtag();
                            } else {
                                // extract whole portion
                                let s_dirty = s.slice(i_break);
                                // unescape to clean part
                                let [s_clean, s_incomplete] = $50d4a76629506683$var$unescape_literal_long_soft(s_dirty);
                                // save
                                this._s_literal += s_clean;
                                // set unparsed index
                                i = n - s_incomplete.length;
                                break string_literal_long_double;
                            }
                        }
                    // invalid
                    default:
                        console.assert(`Unhandle invalid character ${JSON.stringify(s[i_break])} case for string_literal_long_double`);
                }
            // no terminator and nothing to escape
            // match counter: 0
            } else {
                // could be unfinished terminator
                $50d4a76629506683$var$R_STRLIT_LONG_DOUBLE_UNFINISHED_TERM.lastIndex = i;
                let m_unfinished = $50d4a76629506683$var$R_STRLIT_LONG_DOUBLE_UNFINISHED_TERM.exec(s);
                // unfinished terminator
                if (m_unfinished) {
                    // save valid portion
                    this._s_literal += s.slice(i, m_unfinished.index);
                    // set unparsed index
                    i = m_unfinished.index;
                } else {
                    // save
                    this._s_literal += i ? s.slice(i) : s;
                    // set unparsed index
                    i = n;
                }
                break;
            }
        }
        // do not eat whitespace at start of next chunk
        this._b_trim_start = false;
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("string_literal_long_double");
            }
        }
        // save state before pausing
        this._f_state = this.string_literal_long_double;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for string_literal_long_single
    string_literal_long_single() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        string_literal_long_single: while(i < n){
            // something breaks string in this chunk
            // prepare sticky regex index
            $50d4a76629506683$var$R_STRLIT_LONG_SINGLE_BREAK.lastIndex = i;
            // execute regex
            let m_break = $50d4a76629506683$var$R_STRLIT_LONG_SINGLE_BREAK.exec(s);
            // regex was a match
            if (m_break) {
                // advance index
                this.i = $50d4a76629506683$var$R_STRLIT_LONG_SINGLE_BREAK.lastIndex;
                // index of break
                let i_break = m_break.index;
                // add to contents
                this._s_literal += s.slice(i, i_break);
                // depending on char
                switch(s[i_break]){
                    // terminator
                    case "'":
                        // advance index to next token beyond delimiter
                        // consume whitespace (and incidentally reset index)
                        $50d4a76629506683$var$R_WS.lastIndex = i_break + 3;
                        $50d4a76629506683$var$R_WS.exec(s);
                        this.i = $50d4a76629506683$var$R_WS.lastIndex;
                        // resume eating whitespace at start of next chunk
                        this._b_trim_start = true;
                        // consume rest
                        return this.datatype_or_langtag();
                    // escape
                    case "\\":
                        {
                            // try to find end
                            $50d4a76629506683$var$R_STRLIT_LONG_SINGLE_TERM.lastIndex = i_break;
                            let m_term = $50d4a76629506683$var$R_STRLIT_LONG_SINGLE_TERM.exec(s);
                            // end is in this chunk
                            if (m_term) {
                                // index of terminator
                                let i_term = m_term.index;
                                // extract dirty potion
                                let s_dirty = s.slice(i_break, i_term);
                                // clean and save
                                this._s_literal += $50d4a76629506683$var$unescape_literal_long_hard(s_dirty);
                                // advance index beyond terminator
                                this.i = i_term + m_term[0].length;
                                // resume eating whitespace at start of next chunk
                                this._b_trim_start = true;
                                // consume rest
                                return this.datatype_or_langtag();
                            } else {
                                // extract whole portion
                                let s_dirty = s.slice(i_break);
                                // unescape to clean part
                                let [s_clean, s_incomplete] = $50d4a76629506683$var$unescape_literal_long_soft(s_dirty);
                                // save
                                this._s_literal += s_clean;
                                // set unparsed index
                                i = n - s_incomplete.length;
                                break string_literal_long_single;
                            }
                        }
                    // invalid
                    default:
                        console.assert(`Unhandle invalid character ${JSON.stringify(s[i_break])} case for string_literal_long_single`);
                }
            // no terminator and nothing to escape
            // match counter: 0
            } else {
                // could be unfinished terminator
                $50d4a76629506683$var$R_STRLIT_LONG_SINGLE_UNFINISHED_TERM.lastIndex = i;
                let m_unfinished = $50d4a76629506683$var$R_STRLIT_LONG_SINGLE_UNFINISHED_TERM.exec(s);
                // unfinished terminator
                if (m_unfinished) {
                    // save valid portion
                    this._s_literal += s.slice(i, m_unfinished.index);
                    // set unparsed index
                    i = m_unfinished.index;
                } else {
                    // save
                    this._s_literal += i ? s.slice(i) : s;
                    // set unparsed index
                    i = n;
                }
                break;
            }
        }
        // do not eat whitespace at start of next chunk
        this._b_trim_start = false;
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("string_literal_long_single");
            }
        }
        // save state before pausing
        this._f_state = this.string_literal_long_single;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for string_literal
    string_literal() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // ref character
            let x = s[i];
            // string literal * double
            if ('"' === x) {
                // enough chars to deduce type
                if (i + 2 < n) {
                    // long type
                    if ('"' === s[i + 1] && '"' === s[i + 2]) {
                        // advance index beyond token
                        this.i = i + 3;
                        // read contents
                        return this.string_literal_long_double();
                    } else {
                        // advance index beyond token
                        this.i = i + 1;
                        // read contents
                        return this.string_literal_short_double();
                    }
                } else if (i + 1 < n && '"' !== s[i + 1]) {
                    // advance index beyond token
                    this.i = i + 1;
                    // read contents
                    return this.string_literal_short_double();
                } else break;
            // string literal * single
            } else if ("'" === x) {
                // enough chars to deduce type
                if (i + 2 < n) {
                    // long type
                    if ("'" === s[i + 1] && "'" === s[i + 2]) {
                        // advance index beyond token
                        this.i = i + 3;
                        // read contents
                        return this.string_literal_long_single();
                    } else {
                        // advance index beyond token
                        this.i = i + 1;
                        // read contents
                        return this.string_literal_short_single();
                    }
                } else if (i + 1 < n && "'" !== s[i + 1]) {
                    // advance index beyond token
                    this.i = i + 1;
                    // read contents
                    return this.string_literal_short_single();
                } else break;
            // not string literal long single quote, not string literal single quote
            // match counter: 0
            } else break;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_string_length) return this.parse_error("string_literal");
            }
        }
        // save state before pausing
        this._f_state = this.string_literal;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for datatype_or_langtag
    datatype_or_langtag() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // ref character
            let x = s[i];
            // next token indicates datatype or langtag
            if ("^" === x || "@" === x) {
                // '^^' datatype
                // prepare sticky regex index
                $50d4a76629506683$var$R_DOUBLE_CARET.lastIndex = i;
                if ($50d4a76629506683$var$R_DOUBLE_CARET.exec(s)) {
                    // advance index
                    this.i = $50d4a76629506683$var$R_DOUBLE_CARET.lastIndex;
                    return this.datatype();
                // '@' language tag
                } else {
                    // prepare sticky regex index
                    $50d4a76629506683$var$R_LANGTAG.lastIndex = i;
                    // execute regex
                    let m_langtag = $50d4a76629506683$var$R_LANGTAG.exec(s);
                    // regex was a match
                    if (m_langtag) {
                        // advance index
                        this.i = $50d4a76629506683$var$R_LANGTAG.lastIndex;
                        this._kt_object = this._dc_factory.languagedLiteral(this._s_literal, m_langtag[1]);
                        // reset literal
                        this._s_literal = "";
                    // next token definitely datatype or langtag, we are just being interrupted by eos
                    // match counter: 1
                    } else break;
                } // brace #1
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // match counter: 1
                } else {
                    this._kt_object = this._dc_factory.simpleLiteral(this._s_literal);
                    // reset literal
                    this._s_literal = "";
                // not datatype, not language tag => that's okay! those are optional
                }
            } // brace #1
            // goto end of statement state
            // at this point, a new statement has been parsed
            this.data();
            // goto next parsing state; bail out of stack
            return this.after_end_of_statement;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("datatype_or_langtag");
            }
        }
        // save state before pausing
        this._f_state = this.datatype_or_langtag;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for datatype
    datatype() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            let kt_datatype = null;
            // prefixed name quick
            // prepare sticky regex index
            $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.lastIndex = i;
            // execute regex
            let m_pnq_datatype = $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.exec(s);
            // regex was a match
            if (m_pnq_datatype) {
                // advance index
                this.i = $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.lastIndex;
                // check valid prefix
                let s_prefix_id = m_pnq_datatype[1] || "";
                // invalid prefix
                if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                // commit object iri from resolve prefixed name
                kt_datatype = this.prefixed_name(s_prefix_id, m_pnq_datatype[2]);
            // iriref
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex = i;
                // execute regex
                let m_iriref_e_datatype = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.exec(s);
                // regex was a match
                if (m_iriref_e_datatype) {
                    // advance index
                    this.i = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex;
                    let p_datatype;
                    // ref iri
                    let s_iri = m_iriref_e_datatype[1];
                    // absolute iri
                    if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set p_datatype
                    p_datatype = s_iri;
                    else p_datatype = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                    kt_datatype = this.check_named_node_escapeless(p_datatype);
                // prefixed name
                } else {
                    // try match
                    let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                    // stack bail out
                    if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                    let [m_prefixed_named_e_datatype, im_prefixed_named_e_datatype] = aw_valid_this_match_prefixed_name_escapeless;
                    if (m_prefixed_named_e_datatype) {
                        // advance index
                        this.i = im_prefixed_named_e_datatype;
                        // check valid prefix
                        let s_prefix_id = m_prefixed_named_e_datatype[1] || "";
                        // invalid prefix
                        if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                        kt_datatype = this.prefixed_name(s_prefix_id, m_prefixed_named_e_datatype[2]);
                    // iriref
                    } else {
                        // prepare sticky regex index
                        $50d4a76629506683$var$R_IRIREF.lastIndex = i;
                        // execute regex
                        let m_iriref_datatype = $50d4a76629506683$var$R_IRIREF.exec(s);
                        // regex was a match
                        if (m_iriref_datatype) {
                            // advance index
                            this.i = $50d4a76629506683$var$R_IRIREF.lastIndex;
                            let p_datatype;
                            // ref iri
                            let s_iri = m_iriref_e_datatype[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                            // absolute iri
                            if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set p_datatype
                            p_datatype = s_iri;
                            else p_datatype = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                            kt_datatype = this.check_named_node(p_datatype);
                        // prefixed name
                        } else {
                            // try match
                            let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                            // stack bail out
                            if (!aw_valid_this_match_prefixed_name) return true;
                            let [m_prefixed_named_datatype, im_prefixed_named_datatype] = aw_valid_this_match_prefixed_name;
                            if (m_prefixed_named_datatype) {
                                // advance index
                                this.i = im_prefixed_named_datatype;
                                // check valid prefix
                                let s_prefix_id = m_prefixed_named_datatype[1] || "";
                                // invalid prefix
                                if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                // escape local escapes
                                let s_suffix = m_prefixed_named_datatype[2].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY).replace($50d4a76629506683$var$R_PN_LOCAL_ESCAPES, "$1");
                                // set literal datatype
                                kt_datatype = this.prefixed_name(s_prefix_id, s_suffix);
                            // not iriref, not prefixed name
                            // match counter: 4
                            } else break;
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
            this._kt_object = this._dc_factory.datatypedLiteral(this._s_literal, kt_datatype);
            // reset literal
            this._s_literal = "";
            // goto end of statement state
            // at this point, a new statement has been parsed
            this.data();
            // goto next parsing state; bail out of stack
            return this.after_end_of_statement;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("datatype");
            }
        }
        // save state before pausing
        this._f_state = this.datatype;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for post_object
    post_object() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            let i_reset = i;
            // benchmarks confirm: character ref faster than regexes in this context
            let x = s[i];
            // advance index to next token beyond delimiter
            // consume whitespace (and incidentally reset index)
            $50d4a76629506683$var$R_WS.lastIndex = i + 1;
            $50d4a76629506683$var$R_WS.exec(s);
            this.i = $50d4a76629506683$var$R_WS.lastIndex;
            // ',' more objects
            if ("," === x) return this.object_list();
            else if (";" === x) {
                for(;;){
                    // next token is end of outer section
                    let s_peek = s[this.i];
                    if ("." === s_peek || "]" === s_peek || ";" === s_peek || "}" === s_peek) // goto post_object state
                    return this.post_object();
                    else if ("#" === s_peek) {
                        // comment
                        i = this.i;
                        // prepare sticky regex index
                        $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                        // execute regex
                        let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                        // regex was a match
                        if (m_comment) {
                            // advance index
                            this.i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                            if (this.emit_comments) this.emit_comments(m_comment[0]);
                            continue;
                        } else break;
                    } else if (this.i === n) break;
                    else return this.pairs();
                }
                // rather than pushing a dedicated state, just try again next chunk
                i = i_reset;
                break;
            // '.' end of statement
            } else if ("." === x) {
                // assert not nested
                if (this._a_nested.length) {
                    // reset index to that character
                    this.i = i;
                    // emit parse error
                    return this.parse_error("end_of_property_list");
                }
                return this._kt_default_graph === this._kt_graph ? this.block() : this.statement();
            // ']' end of property-object pairs
            } else if ("]" === x) {
                let s_resume_state;
                [this._kt_subject, this._kt_predicate, s_resume_state] = this._a_nested.pop();
                return this[s_resume_state]();
            // ')' end of collection
            } else if (")" === x) // should not be here
            return $50d4a76629506683$var$Reader$syntax_error(this, i, "post_object", "but encountered end of collection");
            else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_CHAR_CLOSE.lastIndex = i;
                if ($50d4a76629506683$var$R_CHAR_CLOSE.exec(s)) {
                    // advance index
                    this.i = $50d4a76629506683$var$R_CHAR_CLOSE.lastIndex;
                    // emit graph_close event
                    this.emit("exit", this._kt_graph);
                    // reset graph
                    this._kt_graph = this._kt_default_graph;
                    return this.block();
                // comment
                } else {
                    // prepare sticky regex index
                    $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                    // execute regex
                    let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                    // regex was a match
                    if (m_comment) {
                        // advance index
                        i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                        if (this.emit_comments) this.emit_comments(m_comment[0]);
                        continue;
                    // comment interrupted by eos?
                    // match counter: 2
                    } else break;
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("post_object");
            }
        }
        // save state before pausing
        this._f_state = this.post_object;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for base_iri
    base_iri() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // prefix id
            // prepare sticky regex index
            $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_iriref_e_base = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.exec(s);
            // regex was a match
            if (m_iriref_e_base) {
                // advance index
                this.i = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex;
                // ref iri
                let s_iri = m_iriref_e_base[1];
                // absolute iri
                if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set base_url
                this._s_base_url = s_iri;
                else this._s_base_url = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                let m_base_iri = $50d4a76629506683$var$R_BASE_IRI.exec(this._s_base_url);
                this._s_base_url = m_base_iri[1];
                this._s_base_url_root = m_base_iri[2] || "";
                this._s_base_url_scheme = m_base_iri[3] || "";
                this._s_base_url_path = m_base_iri[4] || "";
                // emit base event
                this.emit("base", this._s_base_url);
                if (this._b_expecting_full_stop) // change state
                return this.full_stop();
                // goto prefix iri state
                return this.block();
            // prefix id
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_IRIREF.lastIndex = i;
                // execute regex
                let m_iriref_base = $50d4a76629506683$var$R_IRIREF.exec(s);
                // regex was a match
                if (m_iriref_base) {
                    // advance index
                    this.i = $50d4a76629506683$var$R_IRIREF.lastIndex;
                    // ref iri
                    let s_iri = m_iriref_base[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                    // absolute iri
                    if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set base_url
                    this._s_base_url = s_iri;
                    else this._s_base_url = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                    let m_base_iri = $50d4a76629506683$var$R_BASE_IRI.exec(this._s_base_url);
                    this._s_base_url = m_base_iri[1];
                    this._s_base_url_root = m_base_iri[2] || "";
                    this._s_base_url_scheme = m_base_iri[3] || "";
                    this._s_base_url_path = m_base_iri[4] || "";
                    // emit base event
                    this.emit("base", this._s_base_url);
                    if (this._b_expecting_full_stop) // change state
                    return this.full_stop();
                    // goto prefix iri state
                    return this.block();
                // for poorly-placed comments
                } else {
                    // prepare sticky regex index
                    $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                    // execute regex
                    let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                    // regex was a match
                    if (m_comment) {
                        // advance index
                        i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                        if (this.emit_comments) this.emit_comments(m_comment[0]);
                        continue;
                    // match counter: 2
                    } else break;
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("base_iri");
            }
        }
        // save state before pausing
        this._f_state = this.base_iri;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for prefix_id
    prefix_id() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // prefix id
            // prepare sticky regex index
            $50d4a76629506683$var$R_PREFIX_ID.lastIndex = i;
            // execute regex
            let m_prefix_id = $50d4a76629506683$var$R_PREFIX_ID.exec(s);
            // regex was a match
            if (m_prefix_id) {
                // advance index
                this.i = $50d4a76629506683$var$R_PREFIX_ID.lastIndex;
                // set temp prefix id
                this._s_temp_prefix_id = m_prefix_id[1];
                // goto prefix iri state
                return this.prefix_iri();
            // for poorly-placed comments
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // match counter: 1
                } else break;
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("prefix_id");
            }
        }
        // save state before pausing
        this._f_state = this.prefix_id;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for prefix_iri
    prefix_iri() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            let h_prefixes = this._h_prefixes;
            let s_prefix_id = this._s_temp_prefix_id;
            let p_prefix_iri;
            // prefix iri
            // prepare sticky regex index
            $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_iriref_e_prefix = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.exec(s);
            // regex was a match
            if (m_iriref_e_prefix) {
                // advance index
                this.i = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex;
                // ref iri
                let s_iri = m_iriref_e_prefix[1];
                // absolute iri
                if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set p_prefix_iri
                p_prefix_iri = s_iri;
                else p_prefix_iri = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                let b_relax = this._b_relax;
                // existing mapping
                if (s_prefix_id in h_prefixes) // doesn't match existing
                {
                    if (p_prefix_iri !== h_prefixes[s_prefix_id]) {
                        // emit change event
                        if (this.prefix_change) this.prefix_change(s_prefix_id, h_prefixes[s_prefix_id], p_prefix_iri);
                        // update prefix
                        h_prefixes[s_prefix_id] = p_prefix_iri;
                    }
                } else {
                    // check namespace, invalid
                    if (!b_relax && !$50d4a76629506683$var$RT_PREFIXED_NAME_NAMESPACE_VALID.test(s_prefix_id)) return this.error(`Invalid namespace for prefixed name: "${s_prefix_id}:"`);
                    // set prefix
                    h_prefixes[s_prefix_id] = p_prefix_iri;
                }
                // check iri, invalid
                if (!b_relax && !$50d4a76629506683$var$RT_NAMED_NODE_VALID.test(p_prefix_iri)) return this.error(`Invalid IRI found in prefix delcaration: "${s_iri}"`);
                // emit prefix event
                this.event("prefix", s_prefix_id, p_prefix_iri);
                if (this._b_expecting_full_stop) // change state
                return this.full_stop();
                // goto statement state
                return this.block();
            // prefix iri
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_IRIREF.lastIndex = i;
                // execute regex
                let m_iriref_prefix = $50d4a76629506683$var$R_IRIREF.exec(s);
                // regex was a match
                if (m_iriref_prefix) {
                    // advance index
                    this.i = $50d4a76629506683$var$R_IRIREF.lastIndex;
                    // ref iri
                    let s_iri = m_iriref_prefix[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                    // absolute iri
                    if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set p_prefix_iri
                    p_prefix_iri = s_iri;
                    else p_prefix_iri = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                    let b_relax = this._b_relax;
                    // existing mapping
                    if (s_prefix_id in h_prefixes) // doesn't match existing
                    {
                        if (p_prefix_iri !== h_prefixes[s_prefix_id]) {
                            // emit change event
                            if (this.prefix_change) this.prefix_change(s_prefix_id, h_prefixes[s_prefix_id], p_prefix_iri);
                            // update prefix
                            h_prefixes[s_prefix_id] = p_prefix_iri;
                        }
                    } else {
                        // check namespace, invalid
                        if (!b_relax && !$50d4a76629506683$var$RT_PREFIXED_NAME_NAMESPACE_VALID.test(s_prefix_id)) return this.error(`Invalid namespace for prefixed name: "${s_prefix_id}:"`);
                        // set prefix
                        h_prefixes[s_prefix_id] = p_prefix_iri;
                    }
                    // check iri, invalid
                    if (!b_relax && !$50d4a76629506683$var$RT_NAMED_NODE_VALID.test(p_prefix_iri)) return this.error(`Invalid IRI found in prefix delcaration: "${s_iri}"`);
                    // emit prefix event
                    this.event("prefix", s_prefix_id, p_prefix_iri);
                    if (this._b_expecting_full_stop) // change state
                    return this.full_stop();
                    // goto statement state
                    return this.block();
                // for poorly-placed comments
                } else {
                    // prepare sticky regex index
                    $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                    // execute regex
                    let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                    // regex was a match
                    if (m_comment) {
                        // advance index
                        i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                        if (this.emit_comments) this.emit_comments(m_comment[0]);
                        continue;
                    // match counter: 2
                    } else break;
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("prefix_iri");
            }
        }
        // save state before pausing
        this._f_state = this.prefix_iri;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // in case eos happens twice during prefix / base (extremely unlikely)
    // parse state for full_stop
    full_stop() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // prepare sticky regex index
            $50d4a76629506683$var$R_CHAR_STOP.lastIndex = i;
            if ($50d4a76629506683$var$R_CHAR_STOP.exec(s)) {
                // advance index
                this.i = $50d4a76629506683$var$R_CHAR_STOP.lastIndex;
                // resume statement
                return this.block();
            // poorly-placed comment
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // possibly interrupted by eos
                // match counter: 1
                } else break;
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("full_stop");
            }
        }
        // save state before pausing
        this._f_state = this.full_stop;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for collection_subject
    collection_subject() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // ref char
            let x = s[i];
            // end of collection
            if (")" === x) {
                // consume whitespace (and incidentally reset index)
                $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                $50d4a76629506683$var$R_WS.exec(s);
                this.i = $50d4a76629506683$var$R_WS.lastIndex;
                // no items in collection subject
                if (null === this._kt_subject) {
                    // prepare subject
                    this._kt_subject = this._kt_rdf_nil;
                    // state was never pushed to stack, jump to post_subject state
                    return this.post_blank_subject();
                }
                // otherwise, there must be items in collection
                // commit collection end
                this._kt_object = this._kt_rdf_nil;
                this.data();
                // restore state from stack
                let s_resume_state;
                [this._kt_subject, this._kt_predicate, s_resume_state] = this._a_nested.pop();
                return this[s_resume_state]();
            }
            // otherwise, pre-emptively secure the next blank node label
            let s_pointer_label;
            // very first collection object
            let b_pushed = false;
            if (null === this._kt_subject) {
                // set quasi subject (really for resume state)
                s_pointer_label = this.next_label();
                this._kt_subject = this.anonymous_blank_node(s_pointer_label);
                this._a_nested.push([
                    this._kt_subject,
                    this._kt_predicate,
                    "pairs"
                ]);
                // reset subject for later conditional branch
                this._kt_subject = null;
                b_pushed = true;
            }
            // iriref
            // prepare sticky regex index
            $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_iriref_e_object = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.exec(s);
            // regex was a match
            if (m_iriref_e_object) {
                // advance index
                i = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex;
                // ref iri
                let s_iri = m_iriref_e_object[1];
                // absolute iri
                if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                this._kt_object = this.check_named_node_escapeless(s_iri);
                else this._kt_object = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
            // prefixed name
            } else {
                // try match
                let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                // stack bail out
                if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                let [m_prefixed_named_e_object, im_prefixed_named_e_object] = aw_valid_this_match_prefixed_name_escapeless;
                if (m_prefixed_named_e_object) {
                    // advance index
                    i = im_prefixed_named_e_object;
                    // check valid prefix
                    let s_prefix_id = m_prefixed_named_e_object[1] || "";
                    // invalid prefix
                    if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                    // commit object iri from resolve prefixed name
                    this._kt_object = this.prefixed_name(s_prefix_id, m_prefixed_named_e_object[2]);
                // string literal
                } else if ('"' === x || "'" === x) {
                    // first item in list
                    if (null === this._kt_subject) {
                        s_pointer_label = this.next_label();
                        this._kt_subject = this.anonymous_blank_node(s_pointer_label);
                        this._kt_predicate = this._kt_rdf_first;
                    } else {
                        // make nest list item
                        s_pointer_label = this.next_label();
                        let kt_blank_node = this._kt_object = this.anonymous_blank_node(s_pointer_label);
                        this.data();
                        // setup for object literal
                        this._kt_subject = kt_blank_node;
                        this._kt_predicate = this._kt_rdf_first;
                    }
                    // how to resume collection subject state after object literal
                    this.after_end_of_statement = function() {
                        this._kt_predicate = this._kt_rdf_rest;
                        this.after_end_of_statement = this.post_object;
                        return this.collection_subject();
                    };
                    return this.string_literal();
                // numeric literal
                } else {
                    // prepare sticky regex index
                    $50d4a76629506683$var$R_NUMERIC_LITERAL.lastIndex = i;
                    // execute regex
                    let m_numeric_literal = $50d4a76629506683$var$R_NUMERIC_LITERAL.exec(s);
                    // regex was a match
                    if (m_numeric_literal) {
                        // advance index
                        i = $50d4a76629506683$var$R_NUMERIC_LITERAL.lastIndex;
                        // it has exponent term, xsd:double
                        if (m_numeric_literal[4]) this._kt_object = this._dc_factory.double(m_numeric_literal[1]);
                        else if (m_numeric_literal[2] || m_numeric_literal[3]) this._kt_object = this._dc_factory.decimal(m_numeric_literal[1]);
                        else this._kt_object = this._dc_factory.integer(m_numeric_literal[1]);
                    // boolean literal
                    } else {
                        // prepare sticky regex index
                        $50d4a76629506683$var$R_BOOLEAN_LITERAL.lastIndex = i;
                        // execute regex
                        let m_boolean_literal = $50d4a76629506683$var$R_BOOLEAN_LITERAL.exec(s);
                        // regex was a match
                        if (m_boolean_literal) {
                            // advance index
                            i = $50d4a76629506683$var$R_BOOLEAN_LITERAL.lastIndex;
                            // make literal
                            this._kt_object = this._dc_factory.boolean(!!m_boolean_literal[1]);
                        // blank node property list
                        } else if ("[" === x) {
                            // advance index to next token
                            // consume whitespace (and incidentally reset index)
                            $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                            $50d4a76629506683$var$R_WS.exec(s);
                            this.i = $50d4a76629506683$var$R_WS.lastIndex;
                            // this blank node is just the next item in the list
                            s_pointer_label = this.next_label();
                            let kt_blank_node;
                            if (null !== this._kt_subject) {
                                kt_blank_node = this._kt_object = this.anonymous_blank_node(s_pointer_label);
                                this.data();
                            }
                            // subject needs to be set
                            this._kt_subject = kt_blank_node || this.anonymous_blank_node(s_pointer_label);
                            this._kt_predicate = this._kt_rdf_first;
                            let s_label = this.next_label();
                            kt_blank_node = this._kt_object = this.anonymous_blank_node(s_label);
                            this.data();
                            // when resume
                            this._kt_predicate = this._kt_rdf_rest;
                            // push state
                            this._a_nested.push([
                                this._kt_subject,
                                this._kt_predicate,
                                "collection_subject"
                            ]);
                            // prepare next triple
                            this._kt_subject = kt_blank_node;
                            // goto parsing pairs state
                            return this.pairs();
                        // new collection
                        } else if ("(" === x) {
                            // consume whitespace (and incidentally reset index)
                            $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                            $50d4a76629506683$var$R_WS.exec(s);
                            i = $50d4a76629506683$var$R_WS.lastIndex;
                            // empty collection
                            if (")" === s[i]) {
                                this.i = i;
                                this._kt_subject = this._a_nested[this._a_nested.length - 1][0];
                                this._kt_predicate = this._kt_rdf_first;
                                this._a_nested.push([
                                    this._kt_subject,
                                    this._kt_rdf_rest,
                                    "collection_subject"
                                ]);
                                return this.collection_object();
                            }
                            // commit list item pointer
                            s_pointer_label = this.next_label();
                            let kt_blank_node = this._kt_object = this.anonymous_blank_node(s_pointer_label);
                            this.data();
                            // add this list as an item to the outer list
                            this._kt_subject = kt_blank_node;
                            this._kt_predicate = this._kt_rdf_rest;
                            this._a_nested.push([
                                this._kt_subject,
                                this._kt_predicate,
                                "collection_object"
                            ]);
                            // prepare next triple
                            this._kt_predicate = this._kt_rdf_first;
                            continue;
                        // labeled blank node
                        } else {
                            // prepare sticky regex index
                            $50d4a76629506683$var$R_BLANK_NODE_LABEL.lastIndex = i;
                            // execute regex
                            let m_blank_node_label_object = $50d4a76629506683$var$R_BLANK_NODE_LABEL.exec(s);
                            // regex was a match
                            if (m_blank_node_label_object) {
                                // advance index
                                i = $50d4a76629506683$var$R_BLANK_NODE_LABEL.lastIndex;
                                // ref blank node label
                                let s_label = m_blank_node_label_object[1];
                                // make object
                                this._kt_object = this.blank_node(s_label);
                            // iriref
                            } else {
                                // prepare sticky regex index
                                $50d4a76629506683$var$R_IRIREF.lastIndex = i;
                                // execute regex
                                let m_iriref_object = $50d4a76629506683$var$R_IRIREF.exec(s);
                                // regex was a match
                                if (m_iriref_object) {
                                    // advance index
                                    i = $50d4a76629506683$var$R_IRIREF.lastIndex;
                                    // ref iri
                                    let s_iri = m_iriref_object[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                                    // absolute iri
                                    if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                                    this._kt_object = this.check_named_node(s_iri);
                                    else this._kt_object = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                // prefixed name
                                } else {
                                    // try match
                                    let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                    // stack bail out
                                    if (!aw_valid_this_match_prefixed_name) return true;
                                    let [m_prefixed_named_object, im_prefixed_named_object] = aw_valid_this_match_prefixed_name;
                                    if (m_prefixed_named_object) {
                                        // advance index
                                        i = im_prefixed_named_object;
                                        // check valid prefix
                                        let s_prefix_id = m_prefixed_named_object[1] || "";
                                        // invalid prefix
                                        if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                        // escape local escapes
                                        let s_suffix = m_prefixed_named_object[2].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY).replace($50d4a76629506683$var$R_PN_LOCAL_ESCAPES, "$1");
                                        // commit object iri from resolve prefixed name
                                        this._kt_object = this.prefixed_name(s_prefix_id, s_suffix);
                                    } else {
                                        // prepare sticky regex index
                                        $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                                        // execute regex
                                        let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                                        // regex was a match
                                        if (m_comment) {
                                            // advance index
                                            i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                                            if (this.emit_comments) this.emit_comments(m_comment[0]);
                                            continue;
                                        // not iriref, not prefixed name, not string literal, not numeric literal, not boolean literal, not blank node property list, not collection
                                        // match counter: 7
                                        } else {
                                            // ran out of characters after pushing state, pop it
                                            if (b_pushed) this._a_nested.pop();
                                            break;
                                        }
                                    } // brace #7
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
            let kt_blank_node_outer;
            if (!s_pointer_label) s_pointer_label = this.next_label();
            // not the very first item of collection subject
            if (this._kt_subject !== null) {
                // ref object
                let w_object = this._kt_object;
                // create blanknode to embed list
                kt_blank_node_outer = this._kt_object = this.anonymous_blank_node(s_pointer_label);
                // emit statement that functions as collection's head "pointer"
                this.data();
                // swap back object
                this._kt_object = w_object;
            }
            // emit statement that is item
            this._kt_subject = kt_blank_node_outer || this.anonymous_blank_node(s_pointer_label);
            this._kt_predicate = this._kt_rdf_first;
            this.data();
            // prepare next predicate
            this._kt_predicate = this._kt_rdf_rest;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("collection_subject");
            }
        }
        // save state before pausing
        this._f_state = this.collection_subject;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for collection_object
    collection_object() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // ref char
            let x = s[i];
            // end of collection
            if (")" === x) {
                // consume whitespace (and incidentally reset index)
                $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                $50d4a76629506683$var$R_WS.exec(s);
                this.i = $50d4a76629506683$var$R_WS.lastIndex;
                // make & emit collection's tail "pointer"
                this._kt_object = this._kt_rdf_nil;
                this.data();
                // restore previous state
                let s_resume_state;
                [this._kt_subject, this._kt_predicate, s_resume_state] = this._a_nested.pop();
                return this[s_resume_state]();
            }
            // otherwise, pre-emptively secure the next blank node label
            let s_pointer_label;
            // iriref
            // prepare sticky regex index
            $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_iriref_e_object = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.exec(s);
            // regex was a match
            if (m_iriref_e_object) {
                // advance index
                i = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex;
                // commit object iri as is
                // ref iri
                let s_iri = m_iriref_e_object[1];
                // absolute iri
                if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                this._kt_object = this.check_named_node_escapeless(s_iri);
                else this._kt_object = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
            // prefixed name
            } else {
                // try match
                let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                // stack bail out
                if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                let [m_prefixed_named_e_object, im_prefixed_named_e_object] = aw_valid_this_match_prefixed_name_escapeless;
                if (m_prefixed_named_e_object) {
                    // advance index
                    i = im_prefixed_named_e_object;
                    // check valid prefix
                    let s_prefix_id = m_prefixed_named_e_object[1] || "";
                    // invalid prefix
                    if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                    // commit object iri from resolve prefixed name
                    this._kt_object = this.prefixed_name(s_prefix_id, m_prefixed_named_e_object[2]);
                // string literal
                } else if ('"' === x || "'" === x) {
                    // update index before changing states
                    this.i = i;
                    // create blanknode to embed list
                    let kt_blank_node = this._kt_object = this.anonymous_blank_node(this.next_label());
                    // emit statement that functions as collection's head "pointer"
                    this.data();
                    // prepare statement that is item
                    this._kt_subject = kt_blank_node;
                    this._kt_predicate = this._kt_rdf_first;
                    this.after_end_of_statement = function() {
                        this._kt_predicate = this._kt_rdf_rest;
                        this.after_end_of_statement = this.post_object;
                        return this.collection_object();
                    };
                    return this.string_literal();
                // numeric literal
                } else {
                    // prepare sticky regex index
                    $50d4a76629506683$var$R_NUMERIC_LITERAL.lastIndex = i;
                    // execute regex
                    let m_numeric_literal = $50d4a76629506683$var$R_NUMERIC_LITERAL.exec(s);
                    // regex was a match
                    if (m_numeric_literal) {
                        // advance index
                        i = $50d4a76629506683$var$R_NUMERIC_LITERAL.lastIndex;
                        // it has exponent term, xsd:double
                        if (m_numeric_literal[4]) this._kt_object = this._dc_factory.double(m_numeric_literal[1]);
                        else if (m_numeric_literal[2] || m_numeric_literal[3]) this._kt_object = this._dc_factory.decimal(m_numeric_literal[1]);
                        else this._kt_object = this._dc_factory.integer(m_numeric_literal[1]);
                    // boolean literal
                    } else {
                        // prepare sticky regex index
                        $50d4a76629506683$var$R_BOOLEAN_LITERAL.lastIndex = i;
                        // execute regex
                        let m_boolean_literal = $50d4a76629506683$var$R_BOOLEAN_LITERAL.exec(s);
                        // regex was a match
                        if (m_boolean_literal) {
                            // advance index
                            i = $50d4a76629506683$var$R_BOOLEAN_LITERAL.lastIndex;
                            // make literal
                            this._kt_object = this._dc_factory.boolean(!!m_boolean_literal[1]);
                        // blank node property list
                        } else if ("[" === x) {
                            // advance index to next token
                            // consume whitespace (and incidentally reset index)
                            $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                            $50d4a76629506683$var$R_WS.exec(s);
                            this.i = $50d4a76629506683$var$R_WS.lastIndex;
                            // commit head of list pointer
                            let kt_blank_node = this._kt_object = this.anonymous_blank_node(this.next_label());
                            this.data();
                            // setup state to resume and push
                            this._kt_subject = kt_blank_node;
                            this._kt_predicate = this._kt_rdf_rest;
                            this._a_nested.push([
                                this._kt_subject,
                                this._kt_predicate,
                                "collection_object"
                            ]);
                            // enter blank node
                            this._kt_predicate = this._kt_rdf_first;
                            kt_blank_node = this._kt_object = this.anonymous_blank_node(this.next_label());
                            this.data();
                            // prepare next triple
                            this._kt_subject = kt_blank_node;
                            this._kt_predicate = this._kt_rdf_first;
                            // goto parsing pairs state
                            return this.pairs();
                        // new collection
                        } else if ("(" === x) {
                            // consume whitespace (and incidentally reset index)
                            $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                            $50d4a76629506683$var$R_WS.exec(s);
                            i = $50d4a76629506683$var$R_WS.lastIndex;
                            // commit list item pointer
                            s_pointer_label = this.next_label();
                            let kt_blank_node = this._kt_object = this.anonymous_blank_node(s_pointer_label);
                            if (null === this._kt_subject) {
                                let a_recent = this._a_nested[this._a_nested.length - 1];
                                this._kt_subject = a_recent[0];
                                this._kt_predicate = a_recent[1];
                            }
                            this.data();
                            // add this list as an item to the outer list
                            this._kt_subject = kt_blank_node;
                            this._kt_predicate = this._kt_rdf_rest;
                            this._a_nested.push([
                                this._kt_subject,
                                this._kt_predicate,
                                "collection_object"
                            ]);
                            // prepare next triple
                            this._kt_predicate = this._kt_rdf_first;
                            continue;
                        // labeled blank node
                        } else {
                            // prepare sticky regex index
                            $50d4a76629506683$var$R_BLANK_NODE_LABEL.lastIndex = i;
                            // execute regex
                            let m_blank_node_label_object = $50d4a76629506683$var$R_BLANK_NODE_LABEL.exec(s);
                            // regex was a match
                            if (m_blank_node_label_object) {
                                // advance index
                                i = $50d4a76629506683$var$R_BLANK_NODE_LABEL.lastIndex;
                                // ref blank node label
                                let s_label = m_blank_node_label_object[1];
                                // make collection pointer label first
                                s_pointer_label = this.next_label();
                                // make object
                                this._kt_object = this.blank_node(s_label);
                            // iriref
                            } else {
                                // prepare sticky regex index
                                $50d4a76629506683$var$R_IRIREF.lastIndex = i;
                                // execute regex
                                let m_iriref_object = $50d4a76629506683$var$R_IRIREF.exec(s);
                                // regex was a match
                                if (m_iriref_object) {
                                    // advance index
                                    i = $50d4a76629506683$var$R_IRIREF.lastIndex;
                                    // commit object iri as is
                                    // ref iri
                                    let s_iri = m_iriref_object[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                                    // absolute iri
                                    if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                                    this._kt_object = this.check_named_node(s_iri);
                                    else this._kt_object = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                // prefixed name
                                } else {
                                    // try match
                                    let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                    // stack bail out
                                    if (!aw_valid_this_match_prefixed_name) return true;
                                    let [m_prefixed_named_object, im_prefixed_named_object] = aw_valid_this_match_prefixed_name;
                                    if (m_prefixed_named_object) {
                                        // advance index
                                        i = im_prefixed_named_object;
                                        // check valid prefix
                                        let s_prefix_id = m_prefixed_named_object[1] || "";
                                        // invalid prefix
                                        if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                        // escape local escapes
                                        let s_suffix = m_prefixed_named_object[2].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY).replace($50d4a76629506683$var$R_PN_LOCAL_ESCAPES, "$1");
                                        // commit object iri from resolve prefixed name
                                        this._kt_object = this.prefixed_name(s_prefix_id, s_suffix);
                                    } else {
                                        // prepare sticky regex index
                                        $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                                        // execute regex
                                        let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                                        // regex was a match
                                        if (m_comment) {
                                            // advance index
                                            i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                                            if (this.emit_comments) this.emit_comments(m_comment[0]);
                                            continue;
                                        // not iriref, not prefixed name, not string literal, not numeric literal, not boolean literal, not blank node property list, not collection
                                        // match counter: 7
                                        } else break;
                                    } // brace #7
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
            // ref object
            let w_object = this._kt_object;
            // create blanknode to embed list
            if (!s_pointer_label) s_pointer_label = this.next_label();
            let kt_blank_node_outer = this._kt_object = this.anonymous_blank_node(s_pointer_label);
            // emit statement that functions as collection's head "pointer"
            this.data();
            // emit statement that is item
            this._kt_subject = kt_blank_node_outer;
            this._kt_predicate = this._kt_rdf_first;
            this._kt_object = w_object;
            this.data();
            // prepare next predicate
            this._kt_predicate = this._kt_rdf_rest;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("collection_object");
            }
        }
        // save state before pausing
        this._f_state = this.collection_object;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    destroy(e_destroy) {
        this.post_blank_subject = ()=>{};
        this.statement = ()=>{};
        this.block = ()=>{};
        this.graph_or_subject = ()=>{};
        this.graph_or_subject_property_list = ()=>{};
        this.graph_or_subject_anon = ()=>{};
        this.graph_keyword = ()=>{};
        this.graph_post_name = ()=>{};
        this.pairs = ()=>{};
        this.object_list = ()=>{};
        this.string_literal_short_double = ()=>{};
        this.string_literal_short_single = ()=>{};
        this.string_literal_long_double = ()=>{};
        this.string_literal_long_single = ()=>{};
        this.string_literal = ()=>{};
        this.datatype_or_langtag = ()=>{};
        this.datatype = ()=>{};
        this.post_object = ()=>{};
        this.base_iri = ()=>{};
        this.prefix_id = ()=>{};
        this.prefix_iri = ()=>{};
        this.full_stop = ()=>{};
        this.collection_subject = ()=>{};
        this.collection_object = ()=>{};
        this.eof = ()=>{
            this.s = null;
        };
        this._b_destroyed = true;
        // propagate input destroy
        if (!e_destroy && this._ds_input) this._ds_input.destroy(e_destroy);
        this.transform.demolish(e_destroy);
    }
}
$50d4a76629506683$exports = function(...a_args) {
    let g_config = {};
    // at least one argument
    if (a_args.length) {
        let z_arg_0 = a_args[0];
        // input given unspecified
        if (z_arg_0 && z_arg_0.input && "undefined" === typeof z_arg_0.input.string && !z_arg_0.input.stream) z_arg_0 = z_arg_0.input;
        // string
        if ("string" === typeof z_arg_0) g_config.input = {
            string: z_arg_0
        };
        else if (null === z_arg_0) g_config.input = null;
        else if ("function" === typeof z_arg_0.setEncoding) g_config.input = {
            stream: z_arg_0
        };
        else if ("function" === typeof z_arg_0.pipeTo) throw new TypeError(`Sorry, WHATWG streams are currently not supported :(`);
        else if (z_arg_0 && "object" === typeof z_arg_0 && "[object Object]" === Object.prototype.toString.call(z_arg_0)) {
            g_config = z_arg_0;
            // more args; invalid
            if (a_args.length > 1) throw new TypeError(`unexpected argument(s) after config struct: ${a_args.slice(1)}`);
        } else throw new TypeError(`unexpected input type: ${z_arg_0}`);
        // more args
        if (a_args.length > 1) {
            // copy onto struct
            Object.assign(g_config, a_args[1]);
            // more args
            if (a_args.length > 2) throw new TypeError(`unexpected argument(s) after input and config struct: ${a_args.slice(2)}`);
        }
    }
    // create reader, return transform stream
    return new $50d4a76629506683$var$Reader(g_config).transform;
};



var $biuEp = parcelRequire("biuEp");
const $5605c1058d66d37f$export$1cd1943b3a73bbe8 = $5b5611d501681341$export$2e2bcd8739ae039("http://rdfs.org/ns/void#");
const $5605c1058d66d37f$export$65dca9476b1ea120 = $5b5611d501681341$export$2e2bcd8739ae039("http://www.w3.org/2001/XMLSchema#");
const $5605c1058d66d37f$export$7be7716cc4115fc5 = $5b5611d501681341$export$2e2bcd8739ae039("http://www.w3.org/ns/dcat#");
const $5605c1058d66d37f$export$afb74c410165642c = $5b5611d501681341$export$2e2bcd8739ae039("http://www.w3.org/ns/prov#");
const $5605c1058d66d37f$export$5b088def975a652b = $5b5611d501681341$export$2e2bcd8739ae039("http://www.w3.org/ns/sparql-service-description#");
const $5605c1058d66d37f$export$969f4e5258613036 = $5b5611d501681341$export$2e2bcd8739ae039("http://purl.org/dc/terms/");
const $5605c1058d66d37f$export$65000094e116eac3 = $5b5611d501681341$export$2e2bcd8739ae039("http://purl.org/pav/");
const $5605c1058d66d37f$export$fd985e82eeb3038 = $5b5611d501681341$export$2e2bcd8739ae039("http://www.w3.org/1999/02/22-rdf-syntax-ns#");
const $5605c1058d66d37f$export$ed40fb79445e6c3f = $5b5611d501681341$export$2e2bcd8739ae039("http://www.w3.org/2000/01/rdf-schema#");
const $5605c1058d66d37f$export$f4d442bee9f13350 = $5b5611d501681341$export$2e2bcd8739ae039("http://www.w3.org/2002/07/owl#");
const $5605c1058d66d37f$export$2399ee13db66b01b = $5b5611d501681341$export$2e2bcd8739ae039("http://xmlns.com/foaf/0.1/");
const $5605c1058d66d37f$export$166a3e0dcf6b0f25 = $5b5611d501681341$export$2e2bcd8739ae039("http://schema.org/");
const $5605c1058d66d37f$export$31263f9522fbe61c = $5b5611d501681341$export$2e2bcd8739ae039("http://purl.org/dc/elements/1.1/");
const $5605c1058d66d37f$export$b613353551a25804 = $5b5611d501681341$export$2e2bcd8739ae039("http://www.w3.org/2004/02/skos/core#");
const $5605c1058d66d37f$export$4c64c06afd02bfd3 = $5b5611d501681341$export$2e2bcd8739ae039("https://w3id.org/mod#");
const $5605c1058d66d37f$export$d3b38a047f2b40c9 = $5b5611d501681341$export$2e2bcd8739ae039("http://www.w3.org/ns/earl#");
const $5605c1058d66d37f$export$d02421b6d5283efe = $5b5611d501681341$export$2e2bcd8739ae039("http://www.w3.org/2001/sw/DataAccess/tests/test-manifest#");
const $5605c1058d66d37f$export$7da59e8c4251b58c = $5b5611d501681341$export$2e2bcd8739ae039("http://ns.inria.fr/kg/index#");
const $5605c1058d66d37f$export$b205ee610c4a7a73 = $5b5611d501681341$export$2e2bcd8739ae039("https://dblp.org/rdf/schema#");
const $5605c1058d66d37f$export$3dea16473ae9857a = $5b5611d501681341$export$2e2bcd8739ae039("http://data.archives-ouvertes.fr/schema/>");
const $5605c1058d66d37f$export$6b64c61e92e05834 = $5605c1058d66d37f$export$fd985e82eeb3038("type");
function $5605c1058d66d37f$export$8fc05e03d96f502e(url) {
    let baseURI = url.replace(new RegExp("/^(?:.*/)*([^/\r\n]+?|)(?=(?:.[^/\r\n..]*.)?$)/gm"), "");
    baseURI = baseURI.substring(0, baseURI.lastIndexOf("/") + 1);
    return baseURI;
}
function $5605c1058d66d37f$export$666a71f41531be3f(url) {
    var regex = new RegExp("^(?:[a-z+]+:)?//", "i");
    return regex.test(url);
}
function $5605c1058d66d37f$export$300bd6d67c49dbfc(url, baseURI, filename) {
    let result = url;
    if (url.localeCompare("") == 0) result = filename;
    if (!$5605c1058d66d37f$export$666a71f41531be3f(result)) {
        if (filename != null && filename != undefined && filename != "") result = (0, $biuEp.resolve)(filename, result);
        else result = (0, $biuEp.resolve)(baseURI, result);
    }
    if (!(result.startsWith("http://") || result.startsWith("https://") || result.startsWith("file://"))) result = "file://" + result;
    return result;
}
function $5605c1058d66d37f$export$e42ce4998cf68d98(ttlString) {
    const regexBnB = /([ \n])(b[0-9]+) /g;
    const regexNodeB = /([ \n])(node[0-9]+) /g;
    let result = ttlString;
    result = result.replaceAll("nodeID://", "_:"); // Dirty hack to fix nodeID:// from Virtuoso servers for turtle
    result = result.replaceAll("genid-", "_:"); // Dirty hack to fix blank nodes with genid- prefix
    result = result.replaceAll(regexBnB, "$1_:$2 "); // Dirty hack to fix blank nodes with b prefix
    result = result.replaceAll(regexNodeB, "$1_:$2 "); // Dirty hack to fix blank nodes with node prefix
    result = $38b80e3d89004393$export$f41cc328a6c393c3(result);
    return result;
}
function $5605c1058d66d37f$export$f51a9068ac82ea43() {
    let store = $6f0137736d5eb798$export$3d344a3806285c2();
    store.setPrefixForURI("cc", "http://creativecommons.org/ns#");
    store.setPrefixForURI("culturefr", "https://www.culture.gouv.fr/");
    store.setPrefixForURI("dbfr", "http://fr.dbpedia.org/");
    store.setPrefixForURI("dbfrg", "http://fr.dbpedia.org/graph/");
    store.setPrefixForURI("dbfrp", "http://fr.dbpedia.org/property/");
    store.setPrefixForURI("dbo", "http://dbpedia.org/ontology/");
    store.setPrefixForURI("dbspr", "http://dbpedia.org/schema/property_rules#");
    store.setPrefixForURI("dcat", "http://www.w3.org/ns/dcat#");
    store.setPrefixForURI("dce", "http://purl.org/dc/elements/1.1/");
    store.setPrefixForURI("dcmitype", "http://purl.org/dc/dcmitype/");
    store.setPrefixForURI("eclass", "http://www.ebusiness-unibw.org/ontologies/eclass/5.1.4/#");
    store.setPrefixForURI("ex", "https://e.g/#");
    store.setPrefixForURI("georss", "http://www.georss.org/georss/");
    store.setPrefixForURI("goodrel", "http://purl.org/goodrelations/v1#");
    store.setPrefixForURI("inria", "https://www.inria.fr/");
    store.setPrefixForURI("kgi", "http://ns.inria.fr/kg/index#");
    store.setPrefixForURI("localdav", "http://localhost:8890/DAV/");
    store.setPrefixForURI("mod", "https://w3id.org/mod#");
    store.setPrefixForURI("oa", "http://www.w3.org/ns/oa#");
    store.setPrefixForURI("openvoc", "http://open.vocab.org/terms/");
    store.setPrefixForURI("pav", "http://purl.org/pav/");
    store.setPrefixForURI("powders", "http://www.w3.org/2007/05/powder-s#");
    store.setPrefixForURI("schema", "http://schema.org/");
    store.setPrefixForURI("sd", "http://www.w3.org/ns/sparql-service-description#");
    store.setPrefixForURI("skos", "http://www.w3.org/2004/02/skos/core#");
    store.setPrefixForURI("vann", "http://purl.org/vocab/vann/");
    store.setPrefixForURI("voaf", "http://purl.org/vocommons/voaf#");
    store.setPrefixForURI("wdentity", "http://www.wikidata.org/entity/");
    store.setPrefixForURI("wimmics", "https://team.inria.fr/wimmics/");
    return store;
}
function $5605c1058d66d37f$var$getGraphyReadingFunction(contentType) {
    switch(contentType){
        case $5605c1058d66d37f$export$72c700663a6da118:
            return 0, (/*@__PURE__*/$parcel$interopDefault($0a4e3e68448dada6$exports));
        case $5605c1058d66d37f$export$1c7d73fda2689091:
            return 0, (/*@__PURE__*/$parcel$interopDefault($7d44226cc0f38078$exports));
        case $5605c1058d66d37f$export$b0cb396944dacc84:
            return 0, (/*@__PURE__*/$parcel$interopDefault($50d4a76629506683$exports));
        default:
        case $5605c1058d66d37f$export$9be2284ddc122481:
            return 0, (/*@__PURE__*/$parcel$interopDefault($9043c565d33eb642$exports));
    }
}
function $5605c1058d66d37f$var$graphyQuadLoadingToStore(store, y_quad, baseURI, filename = $5605c1058d66d37f$export$7da59e8c4251b58c("").value) {
    function createValidBlankNode(node, baseURI) {
        if (node.termType === "BlankNode") return $6f0137736d5eb798$export$fe4bf738d66b6b12(baseURI + "#" + node.value);
        else throw new Error("Invalid node" + node + " expecting blank node");
    }
    try {
        let s = undefined;
        if (y_quad.subject.termType === "NamedNode") s = $6f0137736d5eb798$export$fe4bf738d66b6b12($5605c1058d66d37f$export$300bd6d67c49dbfc(y_quad.subject.value, baseURI, filename));
        else if (y_quad.subject.termType === "Literal") {
            if (y_quad.subject.language != null && y_quad.subject.language != undefined && y_quad.subject.language != "") s = $6f0137736d5eb798$export$f9c0624c04b6af9f(y_quad.subject.value, y_quad.subject.language);
            else if (y_quad.subject.datatype != null && y_quad.subject.datatype != undefined && y_quad.subject.datatype != "") s = $6f0137736d5eb798$export$f9c0624c04b6af9f(y_quad.subject.value, undefined, $6f0137736d5eb798$export$fe4bf738d66b6b12(y_quad.subject.datatype));
            else s = $6f0137736d5eb798$export$f9c0624c04b6af9f(y_quad.subject.value);
        } else s = createValidBlankNode(y_quad.subject, baseURI);
        const p = $6f0137736d5eb798$export$fe4bf738d66b6b12(y_quad.predicate.value);
        let o = undefined;
        if (y_quad.object.termType === "NamedNode") o = $6f0137736d5eb798$export$fe4bf738d66b6b12($5605c1058d66d37f$export$300bd6d67c49dbfc(y_quad.object.value, baseURI, filename));
        else if (y_quad.object.termType === "Literal") {
            if (y_quad.object.language != null && y_quad.object.language != undefined && y_quad.object.language != "") o = $6f0137736d5eb798$export$f9c0624c04b6af9f(y_quad.object.value, y_quad.object.language);
            else if (y_quad.object.datatype != null && y_quad.object.datatype != undefined && y_quad.object.datatype != "") o = $6f0137736d5eb798$export$f9c0624c04b6af9f(y_quad.object.value, undefined, $6f0137736d5eb798$export$fe4bf738d66b6b12(y_quad.object.datatype));
            else o = $6f0137736d5eb798$export$f9c0624c04b6af9f(y_quad.object.value);
        } else o = createValidBlankNode(y_quad.object, baseURI);
        if (!$gCJkd.isLiteral(s)) {
            if (y_quad.graph.value === "") store.add(s, p, o);
            else {
                const g = $6f0137736d5eb798$export$fe4bf738d66b6b12(y_quad.graph);
                store.add(s, p, o, g);
            }
        }
    } catch (error) {
        $5979e5393e457062$export$a3bc9b8ed74fc("Error while loading quad", y_quad, "error", error);
    }
}
function $5605c1058d66d37f$export$d17f379544103d74(file, store, baseURI) {
    return $5605c1058d66d37f$export$f7e34cb4c320986e([
        file
    ], store, baseURI);
}
function $5605c1058d66d37f$export$f7e34cb4c320986e(files, store, generalBaseUri) {
    try {
        const promiseArray = files.map((filename)=>{
            let baseURI = $5605c1058d66d37f$export$8fc05e03d96f502e(filename);
            if (generalBaseUri != null && generalBaseUri != undefined) baseURI = generalBaseUri;
            const contentType = $5605c1058d66d37f$export$660184b15845db27(filename);
            let readingFunction = (0, (/*@__PURE__*/$parcel$interopDefault($9043c565d33eb642$exports)));
            if (contentType != undefined) readingFunction = $5605c1058d66d37f$var$getGraphyReadingFunction(contentType);
            else throw new Error("Unsupported content type for " + filename + ", only .ttl, .nq and .nt supported.");
            return new Promise((resolve, reject)=>{
                try {
                    if (filename.startsWith("http")) filename = filename.replace("http://", "https://");
                    $38b80e3d89004393$export$72c04af63de9061a(filename).then((content)=>{
                        readingFunction(content, {
                            data (y_quad) {
                                $5605c1058d66d37f$var$graphyQuadLoadingToStore(store, y_quad, baseURI, filename);
                            },
                            eof (h_prefixes) {
                                resolve();
                            },
                            error (error) {
                                $5979e5393e457062$export$a3bc9b8ed74fc("Error while reading RDF file", filename, " using graphy reading function, error", error);
                                reject(error);
                            }
                        });
                    }).catch((error)=>{
                        $5979e5393e457062$export$a3bc9b8ed74fc("Error while reading RDF file", filename, "error", error);
                        reject(error);
                    });
                } catch (error) {
                    $5979e5393e457062$export$a3bc9b8ed74fc("Error while loading RDF files", files, "error", error);
                    reject(error);
                }
            }).catch((error)=>{
                $5979e5393e457062$export$a3bc9b8ed74fc("Error while loading RDF files", files, "error", error);
                return Promise.reject(error);
            });
        });
        return Promise.allSettled(promiseArray).then((results)=>Promise.resolve());
    } catch (error) {
        $5979e5393e457062$export$a3bc9b8ed74fc("Error while loading RDF files", files, "error", error);
        return Promise.reject(error);
    }
}
function $5605c1058d66d37f$export$147c92fc1e54141d(store, baseURI) {
    return new Promise((accept, reject)=>{
        try {
            $957a454a8ab6ebde$export$2e2bcd8739ae039(null, store, baseURI, "text/turtle", function(err, str) {
                if (err != null) reject(err);
                // str = Global.unicodeToUrlendcode(str)
                accept(str);
            }, {
                namespaces: store.namespaces
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $5605c1058d66d37f$export$4128d08d4610f65f(store, baseURI) {
    return new Promise((accept, reject)=>{
        try {
            $957a454a8ab6ebde$export$2e2bcd8739ae039(null, store, baseURI, "application/n-triples", function(err, str) {
                if (err != null) reject(err);
                // str = Global.unicodeToUrlendcode(str)
                accept(str);
            }, {
                // flags: 'deinprstux', // r: Flag to escape /u unicode characters, t: flag to replace rdf:type by "a", d: flag to use the default namespace for unqualified terms with prefix ":"
                namespaces: store.namespaces
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $5605c1058d66d37f$export$b37a8f1ff56a0ace(store, baseURI) {
    return new Promise((accept, reject)=>{
        try {
            $957a454a8ab6ebde$export$2e2bcd8739ae039(null, store, baseURI, "application/trig", function(err, str) {
                if (err != null) reject(err);
                // str = Global.unicodeToUrlendcode(str)
                accept(str);
            }, {
                namespaces: store.namespaces
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $5605c1058d66d37f$export$53d6b4153e4d31a3(store, baseURI) {
    return new Promise((accept, reject)=>{
        try {
            $957a454a8ab6ebde$export$2e2bcd8739ae039(null, store, baseURI, "application/nquads", function(err, str) {
                if (err != null) reject(err);
                // str = Global.unicodeToUrlendcode(str)
                accept(str);
            }, {
                namespaces: store.namespaces
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $5605c1058d66d37f$export$3f751611e1c07e11(content, store, baseURI) {
    return new Promise((accept, reject)=>{
        try {
            // content = Global.unicodeToUrlendcode(content)
            $3e841386a4d5e0bd$export$2e2bcd8739ae039(content, store, baseURI, "application/n-triples", (err, kb)=>{
                if (err != null) reject(err);
                accept(kb);
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $5605c1058d66d37f$export$c5a866906ae935ba(content, store, baseURI) {
    return new Promise((accept, reject)=>{
        try {
            // content = Global.unicodeToUrlendcode(content)
            $3e841386a4d5e0bd$export$2e2bcd8739ae039(content, store, baseURI, "text/n3", (err, kb)=>{
                if (err != null) reject(err);
                accept(kb);
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $5605c1058d66d37f$export$968deea481412d5d(content, store, baseURI) {
    return new Promise((accept, reject)=>{
        try {
            content = $5605c1058d66d37f$export$e42ce4998cf68d98(content);
            (0, (/*@__PURE__*/$parcel$interopDefault($9043c565d33eb642$exports)))(content, {
                baseIRI: baseURI,
                data (y_quad) {
                    $5605c1058d66d37f$var$graphyQuadLoadingToStore(store, y_quad, baseURI, "");
                },
                eof (h_prefixes) {
                    accept(store);
                },
                error (error) {
                    $5979e5393e457062$export$a3bc9b8ed74fc("Error while reading RDF Turtle content using graphy reading function, error", error);
                    reject(error);
                }
            });
        } catch (error) {
            $5979e5393e457062$export$a3bc9b8ed74fc("Error while parsing turtle content", content, "error", error);
            reject(error);
        }
    });
}
function $5605c1058d66d37f$export$ef9657044009dbea(content, store, baseURI) {
    return new Promise((accept, reject)=>{
        try {
            $3e841386a4d5e0bd$export$2e2bcd8739ae039(content, store, baseURI, "text/html", (err, kb)=>{
                if (err != null) reject(err);
                accept(kb);
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $5605c1058d66d37f$export$6725074973fc00d(content, store, baseURI) {
    return new Promise((accept, reject)=>{
        try {
            // content = Global.unicodeToUrlendcode(content)
            $3e841386a4d5e0bd$export$2e2bcd8739ae039(content, store, baseURI, "application/ld+json", (err, kb)=>{
                if (err != null) reject(err);
                accept(kb);
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $5605c1058d66d37f$export$1843c9c1bbbb33a(content, store, baseURI) {
    return new Promise((accept, reject)=>{
        try {
            $3e841386a4d5e0bd$export$2e2bcd8739ae039(content, store, baseURI, "application/nquads", (err, kb)=>{
                if (err != null) reject(err);
                accept(kb);
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $5605c1058d66d37f$export$4e369e5d821beb3f(content, store, baseURI) {
    return new Promise((accept, reject)=>{
        try {
            $3e841386a4d5e0bd$export$2e2bcd8739ae039(content, store, baseURI, "application/rdf+xml", (err, kb)=>{
                if (err != null) reject(err);
                accept(kb);
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $5605c1058d66d37f$export$548d67cf2ef0f340(store, query) {
    return new Promise((resolve, reject)=>{
        try {
            let parsedQuery = $0f0488a2fe711091$export$2e2bcd8739ae039(query, false, store);
            if (parsedQuery) {
                parsedQuery;
                store.query(parsedQuery, (results)=>{
                    resolve(results);
                });
            } else reject("Query is not a valid SPARQL query" + query);
        } catch (error) {
            reject(error);
        }
    });
}
function $5605c1058d66d37f$export$177a7908c10ca9b0(collection, store) {
    let result = [];
    store.statementsMatching(collection, $5605c1058d66d37f$export$fd985e82eeb3038("first")).forEach((statement)=>{
        if (!statement.object.equals($5605c1058d66d37f$export$fd985e82eeb3038("nil"))) result.push(statement.object);
    });
    store.statementsMatching(collection, $5605c1058d66d37f$export$fd985e82eeb3038("rest")).forEach((statement)=>{
        if (!statement.object.equals($5605c1058d66d37f$export$fd985e82eeb3038("nil"))) {
            if ($gCJkd.isNamedNode(statement.object)) result = result.concat($5605c1058d66d37f$export$177a7908c10ca9b0(statement.object, store));
            else if ($gCJkd.isBlankNode(statement.object)) result = result.concat($5605c1058d66d37f$export$177a7908c10ca9b0(statement.object, store));
        }
    });
    return [
        ...new Set(result)
    ];
}
const $5605c1058d66d37f$export$1c7d73fda2689091 = "application/n-triples";
const $5605c1058d66d37f$export$72c700663a6da118 = "application/nquads";
const $5605c1058d66d37f$export$9be2284ddc122481 = "text/turtle";
const $5605c1058d66d37f$export$b0cb396944dacc84 = "application/trig";
function $5605c1058d66d37f$export$660184b15845db27(filename) {
    filename = filename.trim();
    if (filename.endsWith(".ttl")) return $5605c1058d66d37f$export$9be2284ddc122481;
    else if (filename.endsWith(".nt")) return $5605c1058d66d37f$export$1c7d73fda2689091;
    else if (filename.endsWith(".nq")) return $5605c1058d66d37f$export$72c700663a6da118;
    else if (filename.endsWith(".trig")) return $5605c1058d66d37f$export$b0cb396944dacc84;
    else return undefined;
}



// Main parser class
var $acb166200129f66e$exports = {};

$parcel$export($acb166200129f66e$exports, "isString", () => $acb166200129f66e$export$844ec244b1367d54);
$parcel$export($acb166200129f66e$exports, "has", () => $acb166200129f66e$export$a4f4bb6b1453fff5);
$parcel$export($acb166200129f66e$exports, "assign", () => $acb166200129f66e$export$e6e34fd1f2686227);
$parcel$export($acb166200129f66e$exports, "arrayReplaceAt", () => $acb166200129f66e$export$f78478f71955b6bc);
$parcel$export($acb166200129f66e$exports, "isValidEntityCode", () => $acb166200129f66e$export$644a8f5b13b2a36d);
$parcel$export($acb166200129f66e$exports, "fromCodePoint", () => $acb166200129f66e$export$73bfc63873071f74);
$parcel$export($acb166200129f66e$exports, "unescapeMd", () => $acb166200129f66e$export$5ccde1ea0c14bb03);
$parcel$export($acb166200129f66e$exports, "unescapeAll", () => $acb166200129f66e$export$db8a17c6655f7e2c);
$parcel$export($acb166200129f66e$exports, "escapeHtml", () => $acb166200129f66e$export$4cf11838cdc2a8a8);
$parcel$export($acb166200129f66e$exports, "escapeRE", () => $acb166200129f66e$export$bc616c8f7dc20d5d);
$parcel$export($acb166200129f66e$exports, "isSpace", () => $acb166200129f66e$export$1d5ccafae59b4926);
$parcel$export($acb166200129f66e$exports, "isWhiteSpace", () => $acb166200129f66e$export$3c52dd84024ae72c);
$parcel$export($acb166200129f66e$exports, "isPunctChar", () => $acb166200129f66e$export$4888a643af800fc1);
$parcel$export($acb166200129f66e$exports, "isMdAsciiPunct", () => $acb166200129f66e$export$829a0d33ae4e744);
$parcel$export($acb166200129f66e$exports, "normalizeReference", () => $acb166200129f66e$export$20ef46802c8744b);
$parcel$export($acb166200129f66e$exports, "lib", () => $acb166200129f66e$export$16c08b91f883959a);
// Utilities
//
var $cfe8e16a3976eb73$exports = {};

$parcel$export($cfe8e16a3976eb73$exports, "decode", () => $0d34e69e6f2a0359$export$2e2bcd8739ae039);
$parcel$export($cfe8e16a3976eb73$exports, "encode", () => $a16db32880174ee4$export$2e2bcd8739ae039);
$parcel$export($cfe8e16a3976eb73$exports, "format", () => $555640cbd60e2fdc$export$2e2bcd8739ae039);
$parcel$export($cfe8e16a3976eb73$exports, "parse", () => $544ec39afc7ce01f$export$2e2bcd8739ae039);
/* eslint-disable no-bitwise */ const $0d34e69e6f2a0359$var$decodeCache = {};
function $0d34e69e6f2a0359$var$getDecodeCache(exclude) {
    let cache = $0d34e69e6f2a0359$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $0d34e69e6f2a0359$var$decodeCache[exclude] = [];
    for(let i = 0; i < 128; i++){
        const ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(let i = 0; i < exclude.length; i++){
        const ch = exclude.charCodeAt(i);
        cache[ch] = "%" + ("0" + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $0d34e69e6f2a0359$var$decode(string, exclude) {
    if (typeof exclude !== "string") exclude = $0d34e69e6f2a0359$var$decode.defaultChars;
    const cache = $0d34e69e6f2a0359$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        let result = "";
        for(let i = 0, l = seq.length; i < l; i += 3){
            const b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    const chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += "\uFFFD\uFFFD";
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    const chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += "\uFFFD\uFFFD\uFFFD";
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                const b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    let chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += "\uFFFD\uFFFD\uFFFD\uFFFD";
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += "\uFFFD";
        }
        return result;
    });
}
$0d34e69e6f2a0359$var$decode.defaultChars = ";/?:@&=+$,#";
$0d34e69e6f2a0359$var$decode.componentChars = "";
var $0d34e69e6f2a0359$export$2e2bcd8739ae039 = $0d34e69e6f2a0359$var$decode;


const $a16db32880174ee4$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $a16db32880174ee4$var$getEncodeCache(exclude) {
    let cache = $a16db32880174ee4$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $a16db32880174ee4$var$encodeCache[exclude] = [];
    for(let i = 0; i < 128; i++){
        const ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push("%" + ("0" + i.toString(16).toUpperCase()).slice(-2));
    }
    for(let i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $a16db32880174ee4$var$encode(string, exclude, keepEscaped) {
    if (typeof exclude !== "string") {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $a16db32880174ee4$var$encode.defaultChars;
    }
    if (typeof keepEscaped === "undefined") keepEscaped = true;
    const cache = $a16db32880174ee4$var$getEncodeCache(exclude);
    let result = "";
    for(let i = 0, l = string.length; i < l; i++){
        const code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                const nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += "%EF%BF%BD";
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$a16db32880174ee4$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$a16db32880174ee4$var$encode.componentChars = "-_.!~*'()";
var $a16db32880174ee4$export$2e2bcd8739ae039 = $a16db32880174ee4$var$encode;


function $555640cbd60e2fdc$export$2e2bcd8739ae039(url) {
    let result = "";
    result += url.protocol || "";
    result += url.slashes ? "//" : "";
    result += url.auth ? url.auth + "@" : "";
    if (url.hostname && url.hostname.indexOf(":") !== -1) // ipv6 address
    result += "[" + url.hostname + "]";
    else result += url.hostname || "";
    result += url.port ? ":" + url.port : "";
    result += url.pathname || "";
    result += url.search || "";
    result += url.hash || "";
    return result;
}


// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $544ec39afc7ce01f$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
const $544ec39afc7ce01f$var$protocolPattern = /^([a-z0-9.+-]+:)/i;
const $544ec39afc7ce01f$var$portPattern = /:[0-9]*$/;
// Special case for a simple path URL
/* eslint-disable-next-line no-useless-escape */ const $544ec39afc7ce01f$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/;
// RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
const $544ec39afc7ce01f$var$delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
];
// RFC 2396: characters not allowed for various reasons.
const $544ec39afc7ce01f$var$unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat($544ec39afc7ce01f$var$delims);
// Allowed by RFCs, but cause of XSS attacks.  Always escape these.
const $544ec39afc7ce01f$var$autoEscape = [
    "'"
].concat($544ec39afc7ce01f$var$unwise);
// Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
const $544ec39afc7ce01f$var$nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat($544ec39afc7ce01f$var$autoEscape);
const $544ec39afc7ce01f$var$hostEndingChars = [
    "/",
    "?",
    "#"
];
const $544ec39afc7ce01f$var$hostnameMaxLen = 255;
const $544ec39afc7ce01f$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/;
const $544ec39afc7ce01f$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/;
// protocols that can allow "unsafe" and "unwise" chars.
// protocols that never have a hostname.
const $544ec39afc7ce01f$var$hostlessProtocol = {
    javascript: true,
    "javascript:": true
};
// protocols that always contain a // bit.
const $544ec39afc7ce01f$var$slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};
function $544ec39afc7ce01f$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $544ec39afc7ce01f$var$Url) return url;
    const u = new $544ec39afc7ce01f$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$544ec39afc7ce01f$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    let lowerProto, hec, slashes;
    let rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        const simplePath = $544ec39afc7ce01f$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    let proto = $544ec39afc7ce01f$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    /* eslint-disable-next-line no-useless-escape */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && $544ec39afc7ce01f$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$544ec39afc7ce01f$var$hostlessProtocol[proto] && (slashes || proto && !$544ec39afc7ce01f$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        let hostEnd = -1;
        for(let i = 0; i < $544ec39afc7ce01f$var$hostEndingChars.length; i++){
            hec = rest.indexOf($544ec39afc7ce01f$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        let auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf("@", hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(let i = 0; i < $544ec39afc7ce01f$var$nonHostChars.length; i++){
            hec = rest.indexOf($544ec39afc7ce01f$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ":") hostEnd--;
        const host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || "";
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        const ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            const hostparts = this.hostname.split(/\./);
            for(let i = 0, l = hostparts.length; i < l; i++){
                const part = hostparts[i];
                if (!part) continue;
                if (!part.match($544ec39afc7ce01f$var$hostnamePartPattern)) {
                    let newpart = "";
                    for(let j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($544ec39afc7ce01f$var$hostnamePartPattern)) {
                        const validParts = hostparts.slice(0, i);
                        const notHost = hostparts.slice(i + 1);
                        const bit = part.match($544ec39afc7ce01f$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $544ec39afc7ce01f$var$hostnameMaxLen) this.hostname = "";
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    const hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    const qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($544ec39afc7ce01f$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "";
    return this;
};
$544ec39afc7ce01f$var$Url.prototype.parseHost = function(host) {
    let port = $544ec39afc7ce01f$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
var $544ec39afc7ce01f$export$2e2bcd8739ae039 = $544ec39afc7ce01f$var$urlParse;




var $d55a0620136dd6aa$exports = {};

$parcel$export($d55a0620136dd6aa$exports, "Any", () => $cbc832af4f488565$export$2e2bcd8739ae039);
$parcel$export($d55a0620136dd6aa$exports, "Cc", () => $c23f5f283a1bf321$export$2e2bcd8739ae039);
$parcel$export($d55a0620136dd6aa$exports, "Cf", () => $8b025739c405fffe$export$2e2bcd8739ae039);
$parcel$export($d55a0620136dd6aa$exports, "P", () => $e24366eb89af439c$export$2e2bcd8739ae039);
$parcel$export($d55a0620136dd6aa$exports, "S", () => $add59bdd531def5c$export$2e2bcd8739ae039);
$parcel$export($d55a0620136dd6aa$exports, "Z", () => $df20dc3bfc54166a$export$2e2bcd8739ae039);
var $cbc832af4f488565$export$2e2bcd8739ae039 = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;


var $c23f5f283a1bf321$export$2e2bcd8739ae039 = /[\0-\x1F\x7F-\x9F]/;


var $8b025739c405fffe$export$2e2bcd8739ae039 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;


var $e24366eb89af439c$export$2e2bcd8739ae039 = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;


var $add59bdd531def5c$export$2e2bcd8739ae039 = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/;


var $df20dc3bfc54166a$export$2e2bcd8739ae039 = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;




// Generated using scripts/write-decode-map.ts
var $955886d6453f1f75$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
'\u1D41<\xd5\u0131\u028A\u049D\u057B\u05D0\u0675\u06DE\u07A2\u07D6\u080F\u0A4A\u0A91\u0DA1\u0E6D\u0F09\u0F26\u10CA\u1228\u12E1\u1415\u149D\u14C3\u14DF\u1525\0\0\0\0\0\0\u156B\u16CD\u198D\u1C12\u1DDD\u1F7E\u2060\u21B0\u228D\u23C0\u23FB\u2442\u2824\u2912\u2D08\u2E48\u2FCE\u3016\u32BA\u3639\u37AC\u38FE\u3A28\u3A71\u3AE0\u3B2E\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803B\xc6\u40C6P\u803B&\u4026cute\u803B\xc1\u40C1reve;\u4102\u0100iyx}rc\u803B\xc2\u40C2;\u4410r;\uC000\ud835\udd04rave\u803B\xc0\u40C0pha;\u4391acr;\u4100d;\u6A53\u0100gp\x9d\xa1on;\u4104f;\uC000\ud835\udd38plyFunction;\u6061ing\u803B\xc5\u40C5\u0100cs\xbe\xc3r;\uC000\ud835\udc9cign;\u6254ilde\u803B\xc3\u40C3ml\u803B\xc4\u40C4\u0400aceforsu\xe5\xfb\xfe\u0117\u011C\u0122\u0127\u012A\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6AE7ed;\u6306y;\u4411\u0180crt\u0105\u010B\u0114ause;\u6235noullis;\u612Ca;\u4392r;\uC000\ud835\udd05pf;\uC000\ud835\udd39eve;\u42D8c\xf2\u0113mpeq;\u624E\u0700HOacdefhilorsu\u014D\u0151\u0156\u0180\u019E\u01A2\u01B5\u01B7\u01BA\u01DC\u0215\u0273\u0278\u027Ecy;\u4427PY\u803B\xa9\u40A9\u0180cpy\u015D\u0162\u017Aute;\u4106\u0100;i\u0167\u0168\u62D2talDifferentialD;\u6145leys;\u612D\u0200aeio\u0189\u018E\u0194\u0198ron;\u410Cdil\u803B\xc7\u40C7rc;\u4108nint;\u6230ot;\u410A\u0100dn\u01A7\u01ADilla;\u40B8terDot;\u40B7\xf2\u017Fi;\u43A7rcle\u0200DMPT\u01C7\u01CB\u01D1\u01D6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01E2\u01F8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020FoubleQuote;\u601Duote;\u6019\u0200lnpu\u021E\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6A74\u0180git\u022F\u0236\u023Aruent;\u6261nt;\u622FourIntegral;\u622E\u0100fr\u024C\u024E;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6A2Fcr;\uC000\ud835\udc9ep\u0100;C\u0284\u0285\u62D3ap;\u624D\u0580DJSZacefios\u02A0\u02AC\u02B0\u02B4\u02B8\u02CB\u02D7\u02E1\u02E6\u0333\u048D\u0100;o\u0179\u02A5trahd;\u6911cy;\u4402cy;\u4405cy;\u440F\u0180grs\u02BF\u02C4\u02C7ger;\u6021r;\u61A1hv;\u6AE4\u0100ay\u02D0\u02D5ron;\u410E;\u4414l\u0100;t\u02DD\u02DE\u6207a;\u4394r;\uC000\ud835\udd07\u0100af\u02EB\u0327\u0100cm\u02F0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031Ccute;\u40B4o\u0174\u030B\u030D;\u42D9bleAcute;\u42DDrave;\u4060ilde;\u42DCond;\u62C4ferentialD;\u6146\u0470\u033D\0\0\0\u0342\u0354\0\u0405f;\uC000\ud835\udd3b\u0180;DE\u0348\u0349\u034D\u40A8ot;\u60DCqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03CF\u03E2\u03F8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037B\xbb\u0349nArrow;\u61D3\u0100eo\u0387\u03A4ft\u0180ART\u0390\u0396\u03A1rrow;\u61D0ightArrow;\u61D4e\xe5\u02CAng\u0100LR\u03AB\u03C4eft\u0100AR\u03B3\u03B9rrow;\u67F8ightArrow;\u67FAightArrow;\u67F9ight\u0100AT\u03D8\u03DErrow;\u61D2ee;\u62A8p\u0241\u03E9\0\0\u03EFrrow;\u61D1ownArrow;\u61D5erticalBar;\u6225n\u0300ABLRTa\u0412\u042A\u0430\u045E\u047F\u037Crrow\u0180;BU\u041D\u041E\u0422\u6193ar;\u6913pArrow;\u61F5reve;\u4311eft\u02D2\u043A\0\u0446\0\u0450ightVector;\u6950eeVector;\u695Eector\u0100;B\u0459\u045A\u61BDar;\u6956ight\u01D4\u0467\0\u0471eeVector;\u695Fector\u0100;B\u047A\u047B\u61C1ar;\u6957ee\u0100;A\u0486\u0487\u62A4rrow;\u61A7\u0100ct\u0492\u0497r;\uC000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04BD\u04C0\u04C4\u04CB\u04DE\u04E2\u04E7\u04EE\u04F5\u0521\u052F\u0536\u0552\u055D\u0560\u0565G;\u414AH\u803B\xd0\u40D0cute\u803B\xc9\u40C9\u0180aiy\u04D2\u04D7\u04DCron;\u411Arc\u803B\xca\u40CA;\u442Dot;\u4116r;\uC000\ud835\udd08rave\u803B\xc8\u40C8ement;\u6208\u0100ap\u04FA\u04FEcr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65FBerySmallSquare;\u65AB\u0100gp\u0526\u052Aon;\u4118f;\uC000\ud835\udd3csilon;\u4395u\u0100ai\u053C\u0549l\u0100;T\u0542\u0543\u6A75ilde;\u6242librium;\u61CC\u0100ci\u0557\u055Ar;\u6130m;\u6A73a;\u4397ml\u803B\xcb\u40CB\u0100ip\u056A\u056Fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058D\u05B2\u05CCy;\u4424r;\uC000\ud835\udd09lled\u0253\u0597\0\0\u05A3mallSquare;\u65FCerySmallSquare;\u65AA\u0370\u05BA\0\u05BF\0\0\u05C4f;\uC000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05CB\u0600JTabcdfgorst\u05E8\u05EC\u05EF\u05FA\u0600\u0612\u0616\u061B\u061D\u0623\u066C\u0672cy;\u4403\u803B>\u403Emma\u0100;d\u05F7\u05F8\u4393;\u43DCreve;\u411E\u0180eiy\u0607\u060C\u0610dil;\u4122rc;\u411C;\u4413ot;\u4120r;\uC000\ud835\udd0a;\u62D9pf;\uC000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064E\u0656\u065B\u0666qual\u0100;L\u063E\u063F\u6265ess;\u62DBullEqual;\u6267reater;\u6AA2ess;\u6277lantEqual;\u6A7Eilde;\u6273cr;\uC000\ud835\udca2;\u626B\u0400Aacfiosu\u0685\u068B\u0696\u069B\u069E\u06AA\u06BE\u06CARDcy;\u442A\u0100ct\u0690\u0694ek;\u42C7;\u405Eirc;\u4124r;\u610ClbertSpace;\u610B\u01F0\u06AF\0\u06B2f;\u610DizontalLine;\u6500\u0100ct\u06C3\u06C5\xf2\u06A9rok;\u4126mp\u0144\u06D0\u06D8ownHum\xf0\u012Fqual;\u624F\u0700EJOacdfgmnostu\u06FA\u06FE\u0703\u0707\u070E\u071A\u071E\u0721\u0728\u0744\u0778\u078B\u078F\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803B\xcd\u40CD\u0100iy\u0713\u0718rc\u803B\xce\u40CE;\u4418ot;\u4130r;\u6111rave\u803B\xcc\u40CC\u0180;ap\u0720\u072F\u073F\u0100cg\u0734\u0737r;\u412AinaryI;\u6148lie\xf3\u03DD\u01F4\u0749\0\u0762\u0100;e\u074D\u074E\u622C\u0100gr\u0753\u0758ral;\u622Bsection;\u62C2isible\u0100CT\u076C\u0772omma;\u6063imes;\u6062\u0180gpt\u077F\u0783\u0788on;\u412Ef;\uC000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01EB\u079A\0\u079Ecy;\u4406l\u803B\xcf\u40CF\u0280cfosu\u07AC\u07B7\u07BC\u07C2\u07D0\u0100iy\u07B1\u07B5rc;\u4134;\u4419r;\uC000\ud835\udd0dpf;\uC000\ud835\udd41\u01E3\u07C7\0\u07CCr;\uC000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07E4\u07E8\u07EC\u07F1\u07FD\u0802\u0808cy;\u4425cy;\u440Cppa;\u439A\u0100ey\u07F6\u07FBdil;\u4136;\u441Ar;\uC000\ud835\udd0epf;\uC000\ud835\udd42cr;\uC000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082C\u0850\u0863\u09B3\u09B8\u09C7\u09CD\u0A37\u0A47cy;\u4409\u803B<\u403C\u0280cmnpr\u0837\u083C\u0841\u0844\u084Dute;\u4139bda;\u439Bg;\u67EAlacetrf;\u6112r;\u619E\u0180aey\u0857\u085C\u0861ron;\u413Ddil;\u413B;\u441B\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087E\u08A9\u08B1\u08E0\u08E6\u08FC\u092F\u095B\u0390\u096A\u0100nr\u0883\u088FgleBracket;\u67E8row\u0180;BR\u0899\u089A\u089E\u6190ar;\u61E4ightArrow;\u61C6eiling;\u6308o\u01F5\u08B7\0\u08C3bleBracket;\u67E6n\u01D4\u08C8\0\u08D2eeVector;\u6961ector\u0100;B\u08DB\u08DC\u61C3ar;\u6959loor;\u630Aight\u0100AV\u08EF\u08F5rrow;\u6194ector;\u694E\u0100er\u0901\u0917e\u0180;AV\u0909\u090A\u0910\u62A3rrow;\u61A4ector;\u695Aiangle\u0180;BE\u0924\u0925\u0929\u62B2ar;\u69CFqual;\u62B4p\u0180DTV\u0937\u0942\u094CownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61BFar;\u6958ector\u0100;B\u0965\u0966\u61BCar;\u6952ight\xe1\u039Cs\u0300EFGLST\u097E\u098B\u0995\u099D\u09A2\u09ADqualGreater;\u62DAullEqual;\u6266reater;\u6276ess;\u6AA1lantEqual;\u6A7Dilde;\u6272r;\uC000\ud835\udd0f\u0100;e\u09BD\u09BE\u62D8ftarrow;\u61DAidot;\u413F\u0180npw\u09D4\u0A16\u0A1Bg\u0200LRlr\u09DE\u09F7\u0A02\u0A10eft\u0100AR\u09E6\u09ECrrow;\u67F5ightArrow;\u67F7ightArrow;\u67F6eft\u0100ar\u03B3\u0A0Aight\xe1\u03BFight\xe1\u03CAf;\uC000\ud835\udd43er\u0100LR\u0A22\u0A2CeftArrow;\u6199ightArrow;\u6198\u0180cht\u0A3E\u0A40\u0A42\xf2\u084C;\u61B0rok;\u4141;\u626A\u0400acefiosu\u0A5A\u0A5D\u0A60\u0A77\u0A7C\u0A85\u0A8B\u0A8Ep;\u6905y;\u441C\u0100dl\u0A65\u0A6FiumSpace;\u605Flintrf;\u6133r;\uC000\ud835\udd10nusPlus;\u6213pf;\uC000\ud835\udd44c\xf2\u0A76;\u439C\u0480Jacefostu\u0AA3\u0AA7\u0AAD\u0AC0\u0B14\u0B19\u0D91\u0D97\u0D9Ecy;\u440Acute;\u4143\u0180aey\u0AB4\u0AB9\u0ABEron;\u4147dil;\u4145;\u441D\u0180gsw\u0AC7\u0AF0\u0B0Eative\u0180MTV\u0AD3\u0ADF\u0AE8ediumSpace;\u600Bhi\u0100cn\u0AE6\u0AD8\xeb\u0AD9eryThi\xee\u0AD9ted\u0100GL\u0AF8\u0B06reaterGreate\xf2\u0673essLes\xf3\u0A48Line;\u400Ar;\uC000\ud835\udd11\u0200Bnpt\u0B22\u0B28\u0B37\u0B3Areak;\u6060BreakingSpace;\u40A0f;\u6115\u0680;CDEGHLNPRSTV\u0B55\u0B56\u0B6A\u0B7C\u0BA1\u0BEB\u0C04\u0C5E\u0C84\u0CA6\u0CD8\u0D61\u0D85\u6AEC\u0100ou\u0B5B\u0B64ngruent;\u6262pCap;\u626DoubleVerticalBar;\u6226\u0180lqx\u0B83\u0B8A\u0B9Bement;\u6209ual\u0100;T\u0B92\u0B93\u6260ilde;\uC000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0BB6\u0BB7\u0BBD\u0BC9\u0BD3\u0BD8\u0BE5\u626Fqual;\u6271ullEqual;\uC000\u2267\u0338reater;\uC000\u226B\u0338ess;\u6279lantEqual;\uC000\u2A7E\u0338ilde;\u6275ump\u0144\u0BF2\u0BFDownHump;\uC000\u224E\u0338qual;\uC000\u224F\u0338e\u0100fs\u0C0A\u0C27tTriangle\u0180;BE\u0C1A\u0C1B\u0C21\u62EAar;\uC000\u29CF\u0338qual;\u62ECs\u0300;EGLST\u0C35\u0C36\u0C3C\u0C44\u0C4B\u0C58\u626Equal;\u6270reater;\u6278ess;\uC000\u226A\u0338lantEqual;\uC000\u2A7D\u0338ilde;\u6274ested\u0100GL\u0C68\u0C79reaterGreater;\uC000\u2AA2\u0338essLess;\uC000\u2AA1\u0338recedes\u0180;ES\u0C92\u0C93\u0C9B\u6280qual;\uC000\u2AAF\u0338lantEqual;\u62E0\u0100ei\u0CAB\u0CB9verseElement;\u620CghtTriangle\u0180;BE\u0CCB\u0CCC\u0CD2\u62EBar;\uC000\u29D0\u0338qual;\u62ED\u0100qu\u0CDD\u0D0CuareSu\u0100bp\u0CE8\u0CF9set\u0100;E\u0CF0\u0CF3\uC000\u228F\u0338qual;\u62E2erset\u0100;E\u0D03\u0D06\uC000\u2290\u0338qual;\u62E3\u0180bcp\u0D13\u0D24\u0D4Eset\u0100;E\u0D1B\u0D1E\uC000\u2282\u20D2qual;\u6288ceeds\u0200;EST\u0D32\u0D33\u0D3B\u0D46\u6281qual;\uC000\u2AB0\u0338lantEqual;\u62E1ilde;\uC000\u227F\u0338erset\u0100;E\u0D58\u0D5B\uC000\u2283\u20D2qual;\u6289ilde\u0200;EFT\u0D6E\u0D6F\u0D75\u0D7F\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uC000\ud835\udca9ilde\u803B\xd1\u40D1;\u439D\u0700Eacdfgmoprstuv\u0DBD\u0DC2\u0DC9\u0DD5\u0DDB\u0DE0\u0DE7\u0DFC\u0E02\u0E20\u0E22\u0E32\u0E3F\u0E44lig;\u4152cute\u803B\xd3\u40D3\u0100iy\u0DCE\u0DD3rc\u803B\xd4\u40D4;\u441Eblac;\u4150r;\uC000\ud835\udd12rave\u803B\xd2\u40D2\u0180aei\u0DEE\u0DF2\u0DF6cr;\u414Cga;\u43A9cron;\u439Fpf;\uC000\ud835\udd46enCurly\u0100DQ\u0E0E\u0E1AoubleQuote;\u601Cuote;\u6018;\u6A54\u0100cl\u0E27\u0E2Cr;\uC000\ud835\udcaaash\u803B\xd8\u40D8i\u016C\u0E37\u0E3Cde\u803B\xd5\u40D5es;\u6A37ml\u803B\xd6\u40D6er\u0100BP\u0E4B\u0E60\u0100ar\u0E50\u0E53r;\u603Eac\u0100ek\u0E5A\u0E5C;\u63DEet;\u63B4arenthesis;\u63DC\u0480acfhilors\u0E7F\u0E87\u0E8A\u0E8F\u0E92\u0E94\u0E9D\u0EB0\u0EFCrtialD;\u6202y;\u441Fr;\uC000\ud835\udd13i;\u43A6;\u43A0usMinus;\u40B1\u0100ip\u0EA2\u0EADncareplan\xe5\u069Df;\u6119\u0200;eio\u0EB9\u0EBA\u0EE0\u0EE4\u6ABBcedes\u0200;EST\u0EC8\u0EC9\u0ECF\u0EDA\u627Aqual;\u6AAFlantEqual;\u627Cilde;\u627Eme;\u6033\u0100dp\u0EE9\u0EEEuct;\u620Fortion\u0100;a\u0225\u0EF9l;\u621D\u0100ci\u0F01\u0F06r;\uC000\ud835\udcab;\u43A8\u0200Ufos\u0F11\u0F16\u0F1B\u0F1FOT\u803B"\u4022r;\uC000\ud835\udd14pf;\u611Acr;\uC000\ud835\udcac\u0600BEacefhiorsu\u0F3E\u0F43\u0F47\u0F60\u0F73\u0FA7\u0FAA\u0FAD\u1096\u10A9\u10B4\u10BEarr;\u6910G\u803B\xae\u40AE\u0180cnr\u0F4E\u0F53\u0F56ute;\u4154g;\u67EBr\u0100;t\u0F5C\u0F5D\u61A0l;\u6916\u0180aey\u0F67\u0F6C\u0F71ron;\u4158dil;\u4156;\u4420\u0100;v\u0F78\u0F79\u611Cerse\u0100EU\u0F82\u0F99\u0100lq\u0F87\u0F8Eement;\u620Builibrium;\u61CBpEquilibrium;\u696Fr\xbb\u0F79o;\u43A1ght\u0400ACDFTUVa\u0FC1\u0FEB\u0FF3\u1022\u1028\u105B\u1087\u03D8\u0100nr\u0FC6\u0FD2gleBracket;\u67E9row\u0180;BL\u0FDC\u0FDD\u0FE1\u6192ar;\u61E5eftArrow;\u61C4eiling;\u6309o\u01F5\u0FF9\0\u1005bleBracket;\u67E7n\u01D4\u100A\0\u1014eeVector;\u695Dector\u0100;B\u101D\u101E\u61C2ar;\u6955loor;\u630B\u0100er\u102D\u1043e\u0180;AV\u1035\u1036\u103C\u62A2rrow;\u61A6ector;\u695Biangle\u0180;BE\u1050\u1051\u1055\u62B3ar;\u69D0qual;\u62B5p\u0180DTV\u1063\u106E\u1078ownVector;\u694FeeVector;\u695Cector\u0100;B\u1082\u1083\u61BEar;\u6954ector\u0100;B\u1091\u1092\u61C0ar;\u6953\u0100pu\u109B\u109Ef;\u611DndImplies;\u6970ightarrow;\u61DB\u0100ch\u10B9\u10BCr;\u611B;\u61B1leDelayed;\u69F4\u0680HOacfhimoqstu\u10E4\u10F1\u10F7\u10FD\u1119\u111E\u1151\u1156\u1161\u1167\u11B5\u11BB\u11BF\u0100Cc\u10E9\u10EEHcy;\u4429y;\u4428FTcy;\u442Ccute;\u415A\u0280;aeiy\u1108\u1109\u110E\u1113\u1117\u6ABCron;\u4160dil;\u415Erc;\u415C;\u4421r;\uC000\ud835\udd16ort\u0200DLRU\u112A\u1134\u113E\u1149ownArrow\xbb\u041EeftArrow\xbb\u089AightArrow\xbb\u0FDDpArrow;\u6191gma;\u43A3allCircle;\u6218pf;\uC000\ud835\udd4a\u0272\u116D\0\0\u1170t;\u621Aare\u0200;ISU\u117B\u117C\u1189\u11AF\u65A1ntersection;\u6293u\u0100bp\u118F\u119Eset\u0100;E\u1197\u1198\u628Fqual;\u6291erset\u0100;E\u11A8\u11A9\u6290qual;\u6292nion;\u6294cr;\uC000\ud835\udcaear;\u62C6\u0200bcmp\u11C8\u11DB\u1209\u120B\u0100;s\u11CD\u11CE\u62D0et\u0100;E\u11CD\u11D5qual;\u6286\u0100ch\u11E0\u1205eeds\u0200;EST\u11ED\u11EE\u11F4\u11FF\u627Bqual;\u6AB0lantEqual;\u627Dilde;\u627FTh\xe1\u0F8C;\u6211\u0180;es\u1212\u1213\u1223\u62D1rset\u0100;E\u121C\u121D\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123E\u1244\u1249\u1255\u125E\u1271\u1276\u129F\u12C2\u12C8\u12D1ORN\u803B\xde\u40DEADE;\u6122\u0100Hc\u124E\u1252cy;\u440By;\u4426\u0100bu\u125A\u125C;\u4009;\u43A4\u0180aey\u1265\u126A\u126Fron;\u4164dil;\u4162;\u4422r;\uC000\ud835\udd17\u0100ei\u127B\u1289\u01F2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128E\u1298kSpace;\uC000\u205F\u200ASpace;\u6009lde\u0200;EFT\u12AB\u12AC\u12B2\u12BC\u623Cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uC000\ud835\udd4bipleDot;\u60DB\u0100ct\u12D6\u12DBr;\uC000\ud835\udcafrok;\u4166\u0AE1\u12F7\u130E\u131A\u1326\0\u132C\u1331\0\0\0\0\0\u1338\u133D\u1377\u1385\0\u13FF\u1404\u140A\u1410\u0100cr\u12FB\u1301ute\u803B\xda\u40DAr\u0100;o\u1307\u1308\u619Fcir;\u6949r\u01E3\u1313\0\u1316y;\u440Eve;\u416C\u0100iy\u131E\u1323rc\u803B\xdb\u40DB;\u4423blac;\u4170r;\uC000\ud835\udd18rave\u803B\xd9\u40D9acr;\u416A\u0100di\u1341\u1369er\u0100BP\u1348\u135D\u0100ar\u134D\u1350r;\u405Fac\u0100ek\u1357\u1359;\u63DFet;\u63B5arenthesis;\u63DDon\u0100;P\u1370\u1371\u62C3lus;\u628E\u0100gp\u137B\u137Fon;\u4172f;\uC000\ud835\udd4c\u0400ADETadps\u1395\u13AE\u13B8\u13C4\u03E8\u13D2\u13D7\u13F3rrow\u0180;BD\u1150\u13A0\u13A4ar;\u6912ownArrow;\u61C5ownArrow;\u6195quilibrium;\u696Eee\u0100;A\u13CB\u13CC\u62A5rrow;\u61A5own\xe1\u03F3er\u0100LR\u13DE\u13E8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13F9\u13FA\u43D2on;\u43A5ing;\u416Ecr;\uC000\ud835\udcb0ilde;\u4168ml\u803B\xdc\u40DC\u0480Dbcdefosv\u1427\u142C\u1430\u1433\u143E\u1485\u148A\u1490\u1496ash;\u62ABar;\u6AEBy;\u4412ash\u0100;l\u143B\u143C\u62A9;\u6AE6\u0100er\u1443\u1445;\u62C1\u0180bty\u144C\u1450\u147Aar;\u6016\u0100;i\u144F\u1455cal\u0200BLST\u1461\u1465\u146A\u1474ar;\u6223ine;\u407Ceparator;\u6758ilde;\u6240ThinSpace;\u600Ar;\uC000\ud835\udd19pf;\uC000\ud835\udd4dcr;\uC000\ud835\udcb1dash;\u62AA\u0280cefos\u14A7\u14AC\u14B1\u14B6\u14BCirc;\u4174dge;\u62C0r;\uC000\ud835\udd1apf;\uC000\ud835\udd4ecr;\uC000\ud835\udcb2\u0200fios\u14CB\u14D0\u14D2\u14D8r;\uC000\ud835\udd1b;\u439Epf;\uC000\ud835\udd4fcr;\uC000\ud835\udcb3\u0480AIUacfosu\u14F1\u14F5\u14F9\u14FD\u1504\u150F\u1514\u151A\u1520cy;\u442Fcy;\u4407cy;\u442Ecute\u803B\xdd\u40DD\u0100iy\u1509\u150Drc;\u4176;\u442Br;\uC000\ud835\udd1cpf;\uC000\ud835\udd50cr;\uC000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153F\u154B\u154F\u155D\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417D;\u4417ot;\u417B\u01F2\u1554\0\u155BoWidt\xe8\u0AD9a;\u4396r;\u6128pf;\u6124cr;\uC000\ud835\udcb5\u0BE1\u1583\u158A\u1590\0\u15B0\u15B6\u15BF\0\0\0\0\u15C6\u15DB\u15EB\u165F\u166D\0\u1695\u169B\u16B2\u16B9\0\u16BEcute\u803B\xe1\u40E1reve;\u4103\u0300;Ediuy\u159C\u159D\u15A1\u15A3\u15A8\u15AD\u623E;\uC000\u223E\u0333;\u623Frc\u803B\xe2\u40E2te\u80BB\xb4\u0306;\u4430lig\u803B\xe6\u40E6\u0100;r\xb2\u15BA;\uC000\ud835\udd1erave\u803B\xe0\u40E0\u0100ep\u15CA\u15D6\u0100fp\u15CF\u15D4sym;\u6135\xe8\u15D3ha;\u43B1\u0100ap\u15DFc\u0100cl\u15E4\u15E7r;\u4101g;\u6A3F\u0264\u15F0\0\0\u160A\u0280;adsv\u15FA\u15FB\u15FF\u1601\u1607\u6227nd;\u6A55;\u6A5Clope;\u6A58;\u6A5A\u0380;elmrsz\u1618\u1619\u161B\u161E\u163F\u164F\u1659\u6220;\u69A4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163A\u163C\u163E;\u69A8;\u69A9;\u69AA;\u69AB;\u69AC;\u69AD;\u69AE;\u69AFt\u0100;v\u1645\u1646\u621Fb\u0100;d\u164C\u164D\u62BE;\u699D\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637C\u0100gp\u1663\u1667on;\u4105f;\uC000\ud835\udd52\u0380;Eaeiop\u12C1\u167B\u167D\u1682\u1684\u1687\u168A;\u6A70cir;\u6A6F;\u624Ad;\u624Bs;\u4027rox\u0100;e\u12C1\u1692\xf1\u1683ing\u803B\xe5\u40E5\u0180cty\u16A1\u16A6\u16A8r;\uC000\ud835\udcb6;\u402Amp\u0100;e\u12C1\u16AF\xf1\u0288ilde\u803B\xe3\u40E3ml\u803B\xe4\u40E4\u0100ci\u16C2\u16C8onin\xf4\u0272nt;\u6A11\u0800Nabcdefiklnoprsu\u16ED\u16F1\u1730\u173C\u1743\u1748\u1778\u177D\u17E0\u17E6\u1839\u1850\u170D\u193D\u1948\u1970ot;\u6AED\u0100cr\u16F6\u171Ek\u0200ceps\u1700\u1705\u170D\u1713ong;\u624Cpsilon;\u43F6rime;\u6035im\u0100;e\u171A\u171B\u623Dq;\u62CD\u0176\u1722\u1726ee;\u62BDed\u0100;g\u172C\u172D\u6305e\xbb\u172Drk\u0100;t\u135C\u1737brk;\u63B6\u0100oy\u1701\u1741;\u4431quo;\u601E\u0280cmprt\u1753\u175B\u1761\u1764\u1768aus\u0100;e\u010A\u0109ptyv;\u69B0s\xe9\u170Cno\xf5\u0113\u0180ahw\u176F\u1771\u1773;\u43B2;\u6136een;\u626Cr;\uC000\ud835\udd1fg\u0380costuvw\u178D\u179D\u17B3\u17C1\u17D5\u17DB\u17DE\u0180aiu\u1794\u1796\u179A\xf0\u0760rc;\u65EFp\xbb\u1371\u0180dpt\u17A4\u17A8\u17ADot;\u6A00lus;\u6A01imes;\u6A02\u0271\u17B9\0\0\u17BEcup;\u6A06ar;\u6605riangle\u0100du\u17CD\u17D2own;\u65BDp;\u65B3plus;\u6A04e\xe5\u1444\xe5\u14ADarow;\u690D\u0180ako\u17ED\u1826\u1835\u0100cn\u17F2\u1823k\u0180lst\u17FA\u05AB\u1802ozenge;\u69EBriangle\u0200;dlr\u1812\u1813\u1818\u181D\u65B4own;\u65BEeft;\u65C2ight;\u65B8k;\u6423\u01B1\u182B\0\u1833\u01B2\u182F\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183E\u184D\u0100;q\u1843\u1846\uC000=\u20E5uiv;\uC000\u2261\u20E5t;\u6310\u0200ptwx\u1859\u185E\u1867\u186Cf;\uC000\ud835\udd53\u0100;t\u13CB\u1863om\xbb\u13CCtie;\u62C8\u0600DHUVbdhmptuv\u1885\u1896\u18AA\u18BB\u18D7\u18DB\u18EC\u18FF\u1905\u190A\u1910\u1921\u0200LRlr\u188E\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18A1\u18A2\u18A4\u18A6\u18A8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18B3\u18B5\u18B7\u18B9;\u655D;\u655A;\u655C;\u6559\u0380;HLRhlr\u18CA\u18CB\u18CD\u18CF\u18D1\u18D3\u18D5\u6551;\u656C;\u6563;\u6560;\u656B;\u6562;\u655Fox;\u69C9\u0200LRlr\u18E4\u18E6\u18E8\u18EA;\u6555;\u6552;\u6510;\u650C\u0280;DUdu\u06BD\u18F7\u18F9\u18FB\u18FD;\u6565;\u6568;\u652C;\u6534inus;\u629Flus;\u629Eimes;\u62A0\u0200LRlr\u1919\u191B\u191D\u191F;\u655B;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193B\u6502;\u656A;\u6561;\u655E;\u653C;\u6524;\u651C\u0100ev\u0123\u1942bar\u803B\xa6\u40A6\u0200ceio\u1951\u1956\u195A\u1960r;\uC000\ud835\udcb7mi;\u604Fm\u0100;e\u171A\u171Cl\u0180;bh\u1968\u1969\u196B\u405C;\u69C5sub;\u67C8\u016C\u1974\u197El\u0100;e\u1979\u197A\u6022t\xbb\u197Ap\u0180;Ee\u012F\u1985\u1987;\u6AAE\u0100;q\u06DC\u06DB\u0CE1\u19A7\0\u19E8\u1A11\u1A15\u1A32\0\u1A37\u1A50\0\0\u1AB4\0\0\u1AC1\0\0\u1B21\u1B2E\u1B4D\u1B52\0\u1BFD\0\u1C0C\u0180cpr\u19AD\u19B2\u19DDute;\u4107\u0300;abcds\u19BF\u19C0\u19C4\u19CA\u19D5\u19D9\u6229nd;\u6A44rcup;\u6A49\u0100au\u19CF\u19D2p;\u6A4Bp;\u6A47ot;\u6A40;\uC000\u2229\uFE00\u0100eo\u19E2\u19E5t;\u6041\xee\u0693\u0200aeiu\u19F0\u19FB\u1A01\u1A05\u01F0\u19F5\0\u19F8s;\u6A4Don;\u410Ddil\u803B\xe7\u40E7rc;\u4109ps\u0100;s\u1A0C\u1A0D\u6A4Cm;\u6A50ot;\u410B\u0180dmn\u1A1B\u1A20\u1A26il\u80BB\xb8\u01ADptyv;\u69B2t\u8100\xa2;e\u1A2D\u1A2E\u40A2r\xe4\u01B2r;\uC000\ud835\udd20\u0180cei\u1A3D\u1A40\u1A4Dy;\u4447ck\u0100;m\u1A47\u1A48\u6713ark\xbb\u1A48;\u43C7r\u0380;Ecefms\u1A5F\u1A60\u1A62\u1A6B\u1AA4\u1AAA\u1AAE\u65CB;\u69C3\u0180;el\u1A69\u1A6A\u1A6D\u42C6q;\u6257e\u0261\u1A74\0\0\u1A88rrow\u0100lr\u1A7C\u1A81eft;\u61BAight;\u61BB\u0280RSacd\u1A92\u1A94\u1A96\u1A9A\u1A9F\xbb\u0F47;\u64C8st;\u629Birc;\u629Aash;\u629Dnint;\u6A10id;\u6AEFcir;\u69C2ubs\u0100;u\u1ABB\u1ABC\u6663it\xbb\u1ABC\u02EC\u1AC7\u1AD4\u1AFA\0\u1B0Aon\u0100;e\u1ACD\u1ACE\u403A\u0100;q\xc7\xc6\u026D\u1AD9\0\0\u1AE2a\u0100;t\u1ADE\u1ADF\u402C;\u4040\u0180;fl\u1AE8\u1AE9\u1AEB\u6201\xee\u1160e\u0100mx\u1AF1\u1AF6ent\xbb\u1AE9e\xf3\u024D\u01E7\u1AFE\0\u1B07\u0100;d\u12BB\u1B02ot;\u6A6Dn\xf4\u0246\u0180fry\u1B10\u1B14\u1B17;\uC000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1B1Dr;\u6117\u0100ao\u1B25\u1B29rr;\u61B5ss;\u6717\u0100cu\u1B32\u1B37r;\uC000\ud835\udcb8\u0100bp\u1B3C\u1B44\u0100;e\u1B41\u1B42\u6ACF;\u6AD1\u0100;e\u1B49\u1B4A\u6AD0;\u6AD2dot;\u62EF\u0380delprvw\u1B60\u1B6C\u1B77\u1B82\u1BAC\u1BD4\u1BF9arr\u0100lr\u1B68\u1B6A;\u6938;\u6935\u0270\u1B72\0\0\u1B75r;\u62DEc;\u62DFarr\u0100;p\u1B7F\u1B80\u61B6;\u693D\u0300;bcdos\u1B8F\u1B90\u1B96\u1BA1\u1BA5\u1BA8\u622Arcap;\u6A48\u0100au\u1B9B\u1B9Ep;\u6A46p;\u6A4Aot;\u628Dr;\u6A45;\uC000\u222A\uFE00\u0200alrv\u1BB5\u1BBF\u1BDE\u1BE3rr\u0100;m\u1BBC\u1BBD\u61B7;\u693Cy\u0180evw\u1BC7\u1BD4\u1BD8q\u0270\u1BCE\0\0\u1BD2re\xe3\u1B73u\xe3\u1B75ee;\u62CEedge;\u62CFen\u803B\xa4\u40A4earrow\u0100lr\u1BEE\u1BF3eft\xbb\u1B80ight\xbb\u1BBDe\xe4\u1BDD\u0100ci\u1C01\u1C07onin\xf4\u01F7nt;\u6231lcty;\u632D\u0980AHabcdefhijlorstuwz\u1C38\u1C3B\u1C3F\u1C5D\u1C69\u1C75\u1C8A\u1C9E\u1CAC\u1CB7\u1CFB\u1CFF\u1D0D\u1D7B\u1D91\u1DAB\u1DBB\u1DC6\u1DCDr\xf2\u0381ar;\u6965\u0200glrs\u1C48\u1C4D\u1C52\u1C54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1C5A\u1C5B\u6010\xbb\u090A\u016B\u1C61\u1C67arow;\u690Fa\xe3\u0315\u0100ay\u1C6E\u1C73ron;\u410F;\u4434\u0180;ao\u0332\u1C7C\u1C84\u0100gr\u02BF\u1C81r;\u61CAtseq;\u6A77\u0180glm\u1C91\u1C94\u1C98\u803B\xb0\u40B0ta;\u43B4ptyv;\u69B1\u0100ir\u1CA3\u1CA8sht;\u697F;\uC000\ud835\udd21ar\u0100lr\u1CB3\u1CB5\xbb\u08DC\xbb\u101E\u0280aegsv\u1CC2\u0378\u1CD6\u1CDC\u1CE0m\u0180;os\u0326\u1CCA\u1CD4nd\u0100;s\u0326\u1CD1uit;\u6666amma;\u43DDin;\u62F2\u0180;io\u1CE7\u1CE8\u1CF8\u40F7de\u8100\xf7;o\u1CE7\u1CF0ntimes;\u62C7n\xf8\u1CF7cy;\u4452c\u026F\u1D06\0\0\u1D0Arn;\u631Eop;\u630D\u0280lptuw\u1D18\u1D1D\u1D22\u1D49\u1D55lar;\u4024f;\uC000\ud835\udd55\u0280;emps\u030B\u1D2D\u1D37\u1D3D\u1D42q\u0100;d\u0352\u1D33ot;\u6251inus;\u6238lus;\u6214quare;\u62A1blebarwedg\xe5\xfan\u0180adh\u112E\u1D5D\u1D67ownarrow\xf3\u1C83arpoon\u0100lr\u1D72\u1D76ef\xf4\u1CB4igh\xf4\u1CB6\u0162\u1D7F\u1D85karo\xf7\u0F42\u026F\u1D8A\0\0\u1D8Ern;\u631Fop;\u630C\u0180cot\u1D98\u1DA3\u1DA6\u0100ry\u1D9D\u1DA1;\uC000\ud835\udcb9;\u4455l;\u69F6rok;\u4111\u0100dr\u1DB0\u1DB4ot;\u62F1i\u0100;f\u1DBA\u1816\u65BF\u0100ah\u1DC0\u1DC3r\xf2\u0429a\xf2\u0FA6angle;\u69A6\u0100ci\u1DD2\u1DD5y;\u445Fgrarr;\u67FF\u0900Dacdefglmnopqrstux\u1E01\u1E09\u1E19\u1E38\u0578\u1E3C\u1E49\u1E61\u1E7E\u1EA5\u1EAF\u1EBD\u1EE1\u1F2A\u1F37\u1F44\u1F4E\u1F5A\u0100Do\u1E06\u1D34o\xf4\u1C89\u0100cs\u1E0E\u1E14ute\u803B\xe9\u40E9ter;\u6A6E\u0200aioy\u1E22\u1E27\u1E31\u1E36ron;\u411Br\u0100;c\u1E2D\u1E2E\u6256\u803B\xea\u40EAlon;\u6255;\u444Dot;\u4117\u0100Dr\u1E41\u1E45ot;\u6252;\uC000\ud835\udd22\u0180;rs\u1E50\u1E51\u1E57\u6A9Aave\u803B\xe8\u40E8\u0100;d\u1E5C\u1E5D\u6A96ot;\u6A98\u0200;ils\u1E6A\u1E6B\u1E72\u1E74\u6A99nters;\u63E7;\u6113\u0100;d\u1E79\u1E7A\u6A95ot;\u6A97\u0180aps\u1E85\u1E89\u1E97cr;\u4113ty\u0180;sv\u1E92\u1E93\u1E95\u6205et\xbb\u1E93p\u01001;\u1E9D\u1EA4\u0133\u1EA1\u1EA3;\u6004;\u6005\u6003\u0100gs\u1EAA\u1EAC;\u414Bp;\u6002\u0100gp\u1EB4\u1EB8on;\u4119f;\uC000\ud835\udd56\u0180als\u1EC4\u1ECE\u1ED2r\u0100;s\u1ECA\u1ECB\u62D5l;\u69E3us;\u6A71i\u0180;lv\u1EDA\u1EDB\u1EDF\u43B5on\xbb\u1EDB;\u43F5\u0200csuv\u1EEA\u1EF3\u1F0B\u1F23\u0100io\u1EEF\u1E31rc\xbb\u1E2E\u0269\u1EF9\0\0\u1EFB\xed\u0548ant\u0100gl\u1F02\u1F06tr\xbb\u1E5Dess\xbb\u1E7A\u0180aei\u1F12\u1F16\u1F1Als;\u403Dst;\u625Fv\u0100;D\u0235\u1F20D;\u6A78parsl;\u69E5\u0100Da\u1F2F\u1F33ot;\u6253rr;\u6971\u0180cdi\u1F3E\u1F41\u1EF8r;\u612Fo\xf4\u0352\u0100ah\u1F49\u1F4B;\u43B7\u803B\xf0\u40F0\u0100mr\u1F53\u1F57l\u803B\xeb\u40EBo;\u60AC\u0180cip\u1F61\u1F64\u1F67l;\u4021s\xf4\u056E\u0100eo\u1F6C\u1F74ctatio\xee\u0559nential\xe5\u0579\u09E1\u1F92\0\u1F9E\0\u1FA1\u1FA7\0\0\u1FC6\u1FCC\0\u1FD3\0\u1FE6\u1FEA\u2000\0\u2008\u205Allingdotse\xf1\u1E44y;\u4444male;\u6640\u0180ilr\u1FAD\u1FB3\u1FC1lig;\u8000\uFB03\u0269\u1FB9\0\0\u1FBDg;\u8000\uFB00ig;\u8000\uFB04;\uC000\ud835\udd23lig;\u8000\uFB01lig;\uC000fj\u0180alt\u1FD9\u1FDC\u1FE1t;\u666Dig;\u8000\uFB02ns;\u65B1of;\u4192\u01F0\u1FEE\0\u1FF3f;\uC000\ud835\udd57\u0100ak\u05BF\u1FF7\u0100;v\u1FFC\u1FFD\u62D4;\u6AD9artint;\u6A0D\u0100ao\u200C\u2055\u0100cs\u2011\u2052\u03B1\u201A\u2030\u2038\u2045\u2048\0\u2050\u03B2\u2022\u2025\u2027\u202A\u202C\0\u202E\u803B\xbd\u40BD;\u6153\u803B\xbc\u40BC;\u6155;\u6159;\u615B\u01B3\u2034\0\u2036;\u6154;\u6156\u02B4\u203E\u2041\0\0\u2043\u803B\xbe\u40BE;\u6157;\u615C5;\u6158\u01B6\u204C\0\u204E;\u615A;\u615D8;\u615El;\u6044wn;\u6322cr;\uC000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209F\u20A5\u20B0\u20B4\u20F0\u20F5\u20FA\u20FF\u2103\u2112\u2138\u0317\u213E\u2152\u219E\u0100;l\u064D\u2087;\u6A8C\u0180cmp\u2090\u2095\u209Dute;\u41F5ma\u0100;d\u209C\u1CDA\u43B3;\u6A86reve;\u411F\u0100iy\u20AA\u20AErc;\u411D;\u4433ot;\u4121\u0200;lqs\u063E\u0642\u20BD\u20C9\u0180;qs\u063E\u064C\u20C4lan\xf4\u0665\u0200;cdl\u0665\u20D2\u20D5\u20E5c;\u6AA9ot\u0100;o\u20DC\u20DD\u6A80\u0100;l\u20E2\u20E3\u6A82;\u6A84\u0100;e\u20EA\u20ED\uC000\u22DB\uFE00s;\u6A94r;\uC000\ud835\udd24\u0100;g\u0673\u061Bmel;\u6137cy;\u4453\u0200;Eaj\u065A\u210C\u210E\u2110;\u6A92;\u6AA5;\u6AA4\u0200Eaes\u211B\u211D\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6A8Arox\xbb\u2124\u0100;q\u212E\u212F\u6A88\u0100;q\u212E\u211Bim;\u62E7pf;\uC000\ud835\udd58\u0100ci\u2143\u2146r;\u610Am\u0180;el\u066B\u214E\u2150;\u6A8E;\u6A90\u8300>;cdlqr\u05EE\u2160\u216A\u216E\u2173\u2179\u0100ci\u2165\u2167;\u6AA7r;\u6A7Aot;\u62D7Par;\u6995uest;\u6A7C\u0280adels\u2184\u216A\u2190\u0656\u219B\u01F0\u2189\0\u218Epro\xf8\u209Er;\u6978q\u0100lq\u063F\u2196les\xf3\u2088i\xed\u066B\u0100en\u21A3\u21ADrtneqq;\uC000\u2269\uFE00\xc5\u21AA\u0500Aabcefkosy\u21C4\u21C7\u21F1\u21F5\u21FA\u2218\u221D\u222F\u2268\u227Dr\xf2\u03A0\u0200ilmr\u21D0\u21D4\u21D7\u21DBrs\xf0\u1484f\xbb\u2024il\xf4\u06A9\u0100dr\u21E0\u21E4cy;\u444A\u0180;cw\u08F4\u21EB\u21EFir;\u6948;\u61ADar;\u610Firc;\u4125\u0180alr\u2201\u220E\u2213rts\u0100;u\u2209\u220A\u6665it\xbb\u220Alip;\u6026con;\u62B9r;\uC000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223A\u223E\u2243\u225E\u2263rr;\u61FFtht;\u623Bk\u0100lr\u2249\u2253eftarrow;\u61A9ightarrow;\u61AAf;\uC000\ud835\udd59bar;\u6015\u0180clt\u226F\u2274\u2278r;\uC000\ud835\udcbdas\xe8\u21F4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1C5B\u0AE1\u22A3\0\u22AA\0\u22B8\u22C5\u22CE\0\u22D5\u22F3\0\0\u22F8\u2322\u2367\u2362\u237F\0\u2386\u23AA\u23B4cute\u803B\xed\u40ED\u0180;iy\u0771\u22B0\u22B5rc\u803B\xee\u40EE;\u4438\u0100cx\u22BC\u22BFy;\u4435cl\u803B\xa1\u40A1\u0100fr\u039F\u22C9;\uC000\ud835\udd26rave\u803B\xec\u40EC\u0200;ino\u073E\u22DD\u22E9\u22EE\u0100in\u22E2\u22E6nt;\u6A0Ct;\u622Dfin;\u69DCta;\u6129lig;\u4133\u0180aop\u22FE\u231A\u231D\u0180cgt\u2305\u2308\u2317r;\u412B\u0180elp\u071F\u230F\u2313in\xe5\u078Ear\xf4\u0720h;\u4131f;\u62B7ed;\u41B5\u0280;cfot\u04F4\u232C\u2331\u233D\u2341are;\u6105in\u0100;t\u2338\u2339\u621Eie;\u69DDdo\xf4\u2319\u0280;celp\u0757\u234C\u2350\u235B\u2361al;\u62BA\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234Darhk;\u6A17rod;\u6A3C\u0200cgpt\u236F\u2372\u2376\u237By;\u4451on;\u412Ff;\uC000\ud835\udd5aa;\u43B9uest\u803B\xbf\u40BF\u0100ci\u238A\u238Fr;\uC000\ud835\udcben\u0280;Edsv\u04F4\u239B\u239D\u23A1\u04F3;\u62F9ot;\u62F5\u0100;v\u23A6\u23A7\u62F4;\u62F3\u0100;i\u0777\u23AElde;\u4129\u01EB\u23B8\0\u23BCcy;\u4456l\u803B\xef\u40EF\u0300cfmosu\u23CC\u23D7\u23DC\u23E1\u23E7\u23F5\u0100iy\u23D1\u23D5rc;\u4135;\u4439r;\uC000\ud835\udd27ath;\u4237pf;\uC000\ud835\udd5b\u01E3\u23EC\0\u23F1r;\uC000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240B\u2416\u2422\u2427\u242D\u2431\u2435\u243Bppa\u0100;v\u2413\u2414\u43BA;\u43F0\u0100ey\u241B\u2420dil;\u4137;\u443Ar;\uC000\ud835\udd28reen;\u4138cy;\u4445cy;\u445Cpf;\uC000\ud835\udd5ccr;\uC000\ud835\udcc0\u0B80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248D\u2491\u250E\u253D\u255A\u2580\u264E\u265E\u2665\u2679\u267D\u269A\u26B2\u26D8\u275D\u2768\u278B\u27C0\u2801\u2812\u0180art\u2477\u247A\u247Cr\xf2\u09C6\xf2\u0395ail;\u691Barr;\u690E\u0100;g\u0994\u248B;\u6A8Bar;\u6962\u0963\u24A5\0\u24AA\0\u24B1\0\0\0\0\0\u24B5\u24BA\0\u24C6\u24C8\u24CD\0\u24F9ute;\u413Amptyv;\u69B4ra\xee\u084Cbda;\u43BBg\u0180;dl\u088E\u24C1\u24C3;\u6991\xe5\u088E;\u6A85uo\u803B\xab\u40ABr\u0400;bfhlpst\u0899\u24DE\u24E6\u24E9\u24EB\u24EE\u24F1\u24F5\u0100;f\u089D\u24E3s;\u691Fs;\u691D\xeb\u2252p;\u61ABl;\u6939im;\u6973l;\u61A2\u0180;ae\u24FF\u2500\u2504\u6AABil;\u6919\u0100;s\u2509\u250A\u6AAD;\uC000\u2AAD\uFE00\u0180abr\u2515\u2519\u251Drr;\u690Crk;\u6772\u0100ak\u2522\u252Cc\u0100ek\u2528\u252A;\u407B;\u405B\u0100es\u2531\u2533;\u698Bl\u0100du\u2539\u253B;\u698F;\u698D\u0200aeuy\u2546\u254B\u2556\u2558ron;\u413E\u0100di\u2550\u2554il;\u413C\xec\u08B0\xe2\u2529;\u443B\u0200cqrs\u2563\u2566\u256D\u257Da;\u6936uo\u0100;r\u0E19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694Bh;\u61B2\u0280;fgqs\u258B\u258C\u0989\u25F3\u25FF\u6264t\u0280ahlrt\u2598\u25A4\u25B7\u25C2\u25E8rrow\u0100;t\u0899\u25A1a\xe9\u24F6arpoon\u0100du\u25AF\u25B4own\xbb\u045Ap\xbb\u0966eftarrows;\u61C7ight\u0180ahs\u25CD\u25D6\u25DErrow\u0100;s\u08F4\u08A7arpoon\xf3\u0F98quigarro\xf7\u21F0hreetimes;\u62CB\u0180;qs\u258B\u0993\u25FAlan\xf4\u09AC\u0280;cdgs\u09AC\u260A\u260D\u261D\u2628c;\u6AA8ot\u0100;o\u2614\u2615\u6A7F\u0100;r\u261A\u261B\u6A81;\u6A83\u0100;e\u2622\u2625\uC000\u22DA\uFE00s;\u6A93\u0280adegs\u2633\u2639\u263D\u2649\u264Bppro\xf8\u24C6ot;\u62D6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248C\xf4\u099Bi\xed\u09B2\u0180ilr\u2655\u08E1\u265Asht;\u697C;\uC000\ud835\udd29\u0100;E\u099C\u2663;\u6A91\u0161\u2669\u2676r\u0100du\u25B2\u266E\u0100;l\u0965\u2673;\u696Alk;\u6584cy;\u4459\u0280;acht\u0A48\u2688\u268B\u2691\u2696r\xf2\u25C1orne\xf2\u1D08ard;\u696Bri;\u65FA\u0100io\u269F\u26A4dot;\u4140ust\u0100;a\u26AC\u26AD\u63B0che\xbb\u26AD\u0200Eaes\u26BB\u26BD\u26C9\u26D4;\u6268p\u0100;p\u26C3\u26C4\u6A89rox\xbb\u26C4\u0100;q\u26CE\u26CF\u6A87\u0100;q\u26CE\u26BBim;\u62E6\u0400abnoptwz\u26E9\u26F4\u26F7\u271A\u272F\u2741\u2747\u2750\u0100nr\u26EE\u26F1g;\u67ECr;\u61FDr\xeb\u08C1g\u0180lmr\u26FF\u270D\u2714eft\u0100ar\u09E6\u2707ight\xe1\u09F2apsto;\u67FCight\xe1\u09FDparrow\u0100lr\u2725\u2729ef\xf4\u24EDight;\u61AC\u0180afl\u2736\u2739\u273Dr;\u6985;\uC000\ud835\udd5dus;\u6A2Dimes;\u6A34\u0161\u274B\u274Fst;\u6217\xe1\u134E\u0180;ef\u2757\u2758\u1800\u65CAnge\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277C\u2785\u2787r\xf2\u08A8orne\xf2\u1D8Car\u0100;d\u0F98\u2783;\u696D;\u600Eri;\u62BF\u0300achiqt\u2798\u279D\u0A40\u27A2\u27AE\u27BBquo;\u6039r;\uC000\ud835\udcc1m\u0180;eg\u09B2\u27AA\u27AC;\u6A8D;\u6A8F\u0100bu\u252A\u27B3o\u0100;r\u0E1F\u27B9;\u601Arok;\u4142\u8400<;cdhilqr\u082B\u27D2\u2639\u27DC\u27E0\u27E5\u27EA\u27F0\u0100ci\u27D7\u27D9;\u6AA6r;\u6A79re\xe5\u25F2mes;\u62C9arr;\u6976uest;\u6A7B\u0100Pi\u27F5\u27F9ar;\u6996\u0180;ef\u2800\u092D\u181B\u65C3r\u0100du\u2807\u280Dshar;\u694Ahar;\u6966\u0100en\u2817\u2821rtneqq;\uC000\u2268\uFE00\xc5\u281E\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288E\u2893\u28A0\u28A5\u28A8\u28DA\u28E2\u28E4\u0A83\u28F3\u2902Dot;\u623A\u0200clpr\u284E\u2852\u2863\u287Dr\u803B\xaf\u40AF\u0100et\u2857\u2859;\u6642\u0100;e\u285E\u285F\u6720se\xbb\u285F\u0100;s\u103B\u2868to\u0200;dlu\u103B\u2873\u2877\u287Bow\xee\u048Cef\xf4\u090F\xf0\u13D1ker;\u65AE\u0100oy\u2887\u288Cmma;\u6A29;\u443Cash;\u6014asuredangle\xbb\u1626r;\uC000\ud835\udd2ao;\u6127\u0180cdn\u28AF\u28B4\u28C9ro\u803B\xb5\u40B5\u0200;acd\u1464\u28BD\u28C0\u28C4s\xf4\u16A7ir;\u6AF0ot\u80BB\xb7\u01B5us\u0180;bd\u28D2\u1903\u28D3\u6212\u0100;u\u1D3C\u28D8;\u6A2A\u0163\u28DE\u28E1p;\u6ADB\xf2\u2212\xf0\u0A81\u0100dp\u28E9\u28EEels;\u62A7f;\uC000\ud835\udd5e\u0100ct\u28F8\u28FDr;\uC000\ud835\udcc2pos\xbb\u159D\u0180;lm\u2909\u290A\u290D\u43BCtimap;\u62B8\u0C00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297E\u2989\u2998\u29DA\u29E9\u2A15\u2A1A\u2A58\u2A5D\u2A83\u2A95\u2AA4\u2AA8\u2B04\u2B07\u2B44\u2B7F\u2BAE\u2C34\u2C67\u2C7C\u2CE9\u0100gt\u2947\u294B;\uC000\u22D9\u0338\u0100;v\u2950\u0BCF\uC000\u226B\u20D2\u0180elt\u295A\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61CDightarrow;\u61CE;\uC000\u22D8\u0338\u0100;v\u297B\u0C47\uC000\u226A\u20D2ightarrow;\u61CF\u0100Dd\u298E\u2993ash;\u62AFash;\u62AE\u0280bcnpt\u29A3\u29A7\u29AC\u29B1\u29CCla\xbb\u02DEute;\u4144g;\uC000\u2220\u20D2\u0280;Eiop\u0D84\u29BC\u29C0\u29C5\u29C8;\uC000\u2A70\u0338d;\uC000\u224B\u0338s;\u4149ro\xf8\u0D84ur\u0100;a\u29D3\u29D4\u666El\u0100;s\u29D3\u0B38\u01F3\u29DF\0\u29E3p\u80BB\xa0\u0B37mp\u0100;e\u0BF9\u0C00\u0280aeouy\u29F4\u29FE\u2A03\u2A10\u2A13\u01F0\u29F9\0\u29FB;\u6A43on;\u4148dil;\u4146ng\u0100;d\u0D7E\u2A0Aot;\uC000\u2A6D\u0338p;\u6A42;\u443Dash;\u6013\u0380;Aadqsx\u0B92\u2A29\u2A2D\u2A3B\u2A41\u2A45\u2A50rr;\u61D7r\u0100hr\u2A33\u2A36k;\u6924\u0100;o\u13F2\u13F0ot;\uC000\u2250\u0338ui\xf6\u0B63\u0100ei\u2A4A\u2A4Ear;\u6928\xed\u0B98ist\u0100;s\u0BA0\u0B9Fr;\uC000\ud835\udd2b\u0200Eest\u0BC5\u2A66\u2A79\u2A7C\u0180;qs\u0BBC\u2A6D\u0BE1\u0180;qs\u0BBC\u0BC5\u2A74lan\xf4\u0BE2i\xed\u0BEA\u0100;r\u0BB6\u2A81\xbb\u0BB7\u0180Aap\u2A8A\u2A8D\u2A91r\xf2\u2971rr;\u61AEar;\u6AF2\u0180;sv\u0F8D\u2A9C\u0F8C\u0100;d\u2AA1\u2AA2\u62FC;\u62FAcy;\u445A\u0380AEadest\u2AB7\u2ABA\u2ABE\u2AC2\u2AC5\u2AF6\u2AF9r\xf2\u2966;\uC000\u2266\u0338rr;\u619Ar;\u6025\u0200;fqs\u0C3B\u2ACE\u2AE3\u2AEFt\u0100ar\u2AD4\u2AD9rro\xf7\u2AC1ightarro\xf7\u2A90\u0180;qs\u0C3B\u2ABA\u2AEAlan\xf4\u0C55\u0100;s\u0C55\u2AF4\xbb\u0C36i\xed\u0C5D\u0100;r\u0C35\u2AFEi\u0100;e\u0C1A\u0C25i\xe4\u0D90\u0100pt\u2B0C\u2B11f;\uC000\ud835\udd5f\u8180\xac;in\u2B19\u2B1A\u2B36\u40ACn\u0200;Edv\u0B89\u2B24\u2B28\u2B2E;\uC000\u22F9\u0338ot;\uC000\u22F5\u0338\u01E1\u0B89\u2B33\u2B35;\u62F7;\u62F6i\u0100;v\u0CB8\u2B3C\u01E1\u0CB8\u2B41\u2B43;\u62FE;\u62FD\u0180aor\u2B4B\u2B63\u2B69r\u0200;ast\u0B7B\u2B55\u2B5A\u2B5Flle\xec\u0B7Bl;\uC000\u2AFD\u20E5;\uC000\u2202\u0338lint;\u6A14\u0180;ce\u0C92\u2B70\u2B73u\xe5\u0CA5\u0100;c\u0C98\u2B78\u0100;e\u0C92\u2B7D\xf1\u0C98\u0200Aait\u2B88\u2B8B\u2B9D\u2BA7r\xf2\u2988rr\u0180;cw\u2B94\u2B95\u2B99\u619B;\uC000\u2933\u0338;\uC000\u219D\u0338ghtarrow\xbb\u2B95ri\u0100;e\u0CCB\u0CD6\u0380chimpqu\u2BBD\u2BCD\u2BD9\u2B04\u0B78\u2BE4\u2BEF\u0200;cer\u0D32\u2BC6\u0D37\u2BC9u\xe5\u0D45;\uC000\ud835\udcc3ort\u026D\u2B05\0\0\u2BD6ar\xe1\u2B56m\u0100;e\u0D6E\u2BDF\u0100;q\u0D74\u0D73su\u0100bp\u2BEB\u2BED\xe5\u0CF8\xe5\u0D0B\u0180bcp\u2BF6\u2C11\u2C19\u0200;Ees\u2BFF\u2C00\u0D22\u2C04\u6284;\uC000\u2AC5\u0338et\u0100;e\u0D1B\u2C0Bq\u0100;q\u0D23\u2C00c\u0100;e\u0D32\u2C17\xf1\u0D38\u0200;Ees\u2C22\u2C23\u0D5F\u2C27\u6285;\uC000\u2AC6\u0338et\u0100;e\u0D58\u2C2Eq\u0100;q\u0D60\u2C23\u0200gilr\u2C3D\u2C3F\u2C45\u2C47\xec\u0BD7lde\u803B\xf1\u40F1\xe7\u0C43iangle\u0100lr\u2C52\u2C5Ceft\u0100;e\u0C1A\u2C5A\xf1\u0C26ight\u0100;e\u0CCB\u2C65\xf1\u0CD7\u0100;m\u2C6C\u2C6D\u43BD\u0180;es\u2C74\u2C75\u2C79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2C8F\u2C94\u2C99\u2C9E\u2CA3\u2CB0\u2CB6\u2CD3\u2CE3ash;\u62ADarr;\u6904p;\uC000\u224D\u20D2ash;\u62AC\u0100et\u2CA8\u2CAC;\uC000\u2265\u20D2;\uC000>\u20D2nfin;\u69DE\u0180Aet\u2CBD\u2CC1\u2CC5rr;\u6902;\uC000\u2264\u20D2\u0100;r\u2CCA\u2CCD\uC000<\u20D2ie;\uC000\u22B4\u20D2\u0100At\u2CD8\u2CDCrr;\u6903rie;\uC000\u22B5\u20D2im;\uC000\u223C\u20D2\u0180Aan\u2CF0\u2CF4\u2D02rr;\u61D6r\u0100hr\u2CFA\u2CFDk;\u6923\u0100;o\u13E7\u13E5ear;\u6927\u1253\u1A95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2D2D\0\u2D38\u2D48\u2D60\u2D65\u2D72\u2D84\u1B07\0\0\u2D8D\u2DAB\0\u2DC8\u2DCE\0\u2DDC\u2E19\u2E2B\u2E3E\u2E43\u0100cs\u2D31\u1A97ute\u803B\xf3\u40F3\u0100iy\u2D3C\u2D45r\u0100;c\u1A9E\u2D42\u803B\xf4\u40F4;\u443E\u0280abios\u1AA0\u2D52\u2D57\u01C8\u2D5Alac;\u4151v;\u6A38old;\u69BClig;\u4153\u0100cr\u2D69\u2D6Dir;\u69BF;\uC000\ud835\udd2c\u036F\u2D79\0\0\u2D7C\0\u2D82n;\u42DBave\u803B\xf2\u40F2;\u69C1\u0100bm\u2D88\u0DF4ar;\u69B5\u0200acit\u2D95\u2D98\u2DA5\u2DA8r\xf2\u1A80\u0100ir\u2D9D\u2DA0r;\u69BEoss;\u69BBn\xe5\u0E52;\u69C0\u0180aei\u2DB1\u2DB5\u2DB9cr;\u414Dga;\u43C9\u0180cdn\u2DC0\u2DC5\u01CDron;\u43BF;\u69B6pf;\uC000\ud835\udd60\u0180ael\u2DD4\u2DD7\u01D2r;\u69B7rp;\u69B9\u0380;adiosv\u2DEA\u2DEB\u2DEE\u2E08\u2E0D\u2E10\u2E16\u6228r\xf2\u1A86\u0200;efm\u2DF7\u2DF8\u2E02\u2E05\u6A5Dr\u0100;o\u2DFE\u2DFF\u6134f\xbb\u2DFF\u803B\xaa\u40AA\u803B\xba\u40BAgof;\u62B6r;\u6A56lope;\u6A57;\u6A5B\u0180clo\u2E1F\u2E21\u2E27\xf2\u2E01ash\u803B\xf8\u40F8l;\u6298i\u016C\u2E2F\u2E34de\u803B\xf5\u40F5es\u0100;a\u01DB\u2E3As;\u6A36ml\u803B\xf6\u40F6bar;\u633D\u0AE1\u2E5E\0\u2E7D\0\u2E80\u2E9D\0\u2EA2\u2EB9\0\0\u2ECB\u0E9C\0\u2F13\0\0\u2F2B\u2FBC\0\u2FC8r\u0200;ast\u0403\u2E67\u2E72\u0E85\u8100\xb6;l\u2E6D\u2E6E\u40B6le\xec\u0403\u0269\u2E78\0\0\u2E7Bm;\u6AF3;\u6AFDy;\u443Fr\u0280cimpt\u2E8B\u2E8F\u2E93\u1865\u2E97nt;\u4025od;\u402Eil;\u6030enk;\u6031r;\uC000\ud835\udd2d\u0180imo\u2EA8\u2EB0\u2EB4\u0100;v\u2EAD\u2EAE\u43C6;\u43D5ma\xf4\u0A76ne;\u660E\u0180;tv\u2EBF\u2EC0\u2EC8\u43C0chfork\xbb\u1FFD;\u43D6\u0100au\u2ECF\u2EDFn\u0100ck\u2ED5\u2EDDk\u0100;h\u21F4\u2EDB;\u610E\xf6\u21F4s\u0480;abcdemst\u2EF3\u2EF4\u1908\u2EF9\u2EFD\u2F04\u2F06\u2F0A\u2F0E\u402Bcir;\u6A23ir;\u6A22\u0100ou\u1D40\u2F02;\u6A25;\u6A72n\u80BB\xb1\u0E9Dim;\u6A26wo;\u6A27\u0180ipu\u2F19\u2F20\u2F25ntint;\u6A15f;\uC000\ud835\udd61nd\u803B\xa3\u40A3\u0500;Eaceinosu\u0EC8\u2F3F\u2F41\u2F44\u2F47\u2F81\u2F89\u2F92\u2F7E\u2FB6;\u6AB3p;\u6AB7u\xe5\u0ED9\u0100;c\u0ECE\u2F4C\u0300;acens\u0EC8\u2F59\u2F5F\u2F66\u2F68\u2F7Eppro\xf8\u2F43urlye\xf1\u0ED9\xf1\u0ECE\u0180aes\u2F6F\u2F76\u2F7Approx;\u6AB9qq;\u6AB5im;\u62E8i\xed\u0EDFme\u0100;s\u2F88\u0EAE\u6032\u0180Eas\u2F78\u2F90\u2F7A\xf0\u2F75\u0180dfp\u0EEC\u2F99\u2FAF\u0180als\u2FA0\u2FA5\u2FAAlar;\u632Eine;\u6312urf;\u6313\u0100;t\u0EFB\u2FB4\xef\u0EFBrel;\u62B0\u0100ci\u2FC0\u2FC5r;\uC000\ud835\udcc5;\u43C8ncsp;\u6008\u0300fiopsu\u2FDA\u22E2\u2FDF\u2FE5\u2FEB\u2FF1r;\uC000\ud835\udd2epf;\uC000\ud835\udd62rime;\u6057cr;\uC000\ud835\udcc6\u0180aeo\u2FF8\u3009\u3013t\u0100ei\u2FFE\u3005rnion\xf3\u06B0nt;\u6A16st\u0100;e\u3010\u3011\u403F\xf1\u1F19\xf4\u0F14\u0A80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30E0\u310E\u312B\u3147\u3162\u3172\u318E\u3206\u3215\u3224\u3229\u3258\u326E\u3272\u3290\u32B0\u32B7\u0180art\u3047\u304A\u304Cr\xf2\u10B3\xf2\u03DDail;\u691Car\xf2\u1C65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307F\u308F\u3094\u30CC\u0100eu\u306D\u3071;\uC000\u223D\u0331te;\u4155i\xe3\u116Emptyv;\u69B3g\u0200;del\u0FD1\u3089\u308B\u308D;\u6992;\u69A5\xe5\u0FD1uo\u803B\xbb\u40BBr\u0580;abcfhlpstw\u0FDC\u30AC\u30AF\u30B7\u30B9\u30BC\u30BE\u30C0\u30C3\u30C7\u30CAp;\u6975\u0100;f\u0FE0\u30B4s;\u6920;\u6933s;\u691E\xeb\u225D\xf0\u272El;\u6945im;\u6974l;\u61A3;\u619D\u0100ai\u30D1\u30D5il;\u691Ao\u0100;n\u30DB\u30DC\u6236al\xf3\u0F1E\u0180abr\u30E7\u30EA\u30EEr\xf2\u17E5rk;\u6773\u0100ak\u30F3\u30FDc\u0100ek\u30F9\u30FB;\u407D;\u405D\u0100es\u3102\u3104;\u698Cl\u0100du\u310A\u310C;\u698E;\u6990\u0200aeuy\u3117\u311C\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0FF2\xe2\u30FA;\u4440\u0200clqs\u3134\u3137\u313D\u3144a;\u6937dhar;\u6969uo\u0100;r\u020E\u020Dh;\u61B3\u0180acg\u314E\u315F\u0F44l\u0200;ips\u0F78\u3158\u315B\u109Cn\xe5\u10BBar\xf4\u0FA9t;\u65AD\u0180ilr\u3169\u1023\u316Esht;\u697D;\uC000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317D\u317F\xbb\u047B\u0100;l\u1091\u3184;\u696C\u0100;v\u318B\u318C\u43C1;\u43F1\u0180gns\u3195\u31F9\u31FCht\u0300ahlrst\u31A4\u31B0\u31C2\u31D8\u31E4\u31EErrow\u0100;t\u0FDC\u31ADa\xe9\u30C8arpoon\u0100du\u31BB\u31BFow\xee\u317Ep\xbb\u1092eft\u0100ah\u31CA\u31D0rrow\xf3\u0FEAarpoon\xf3\u0551ightarrows;\u61C9quigarro\xf7\u30CBhreetimes;\u62CCg;\u42DAingdotse\xf1\u1F32\u0180ahm\u320D\u3210\u3213r\xf2\u0FEAa\xf2\u0551;\u600Foust\u0100;a\u321E\u321F\u63B1che\xbb\u321Fmid;\u6AEE\u0200abpt\u3232\u323D\u3240\u3252\u0100nr\u3237\u323Ag;\u67EDr;\u61FEr\xeb\u1003\u0180afl\u3247\u324A\u324Er;\u6986;\uC000\ud835\udd63us;\u6A2Eimes;\u6A35\u0100ap\u325D\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6A12ar\xf2\u31E3\u0200achq\u327B\u3280\u10BC\u3285quo;\u603Ar;\uC000\ud835\udcc7\u0100bu\u30FB\u328Ao\u0100;r\u0214\u0213\u0180hir\u3297\u329B\u32A0re\xe5\u31F8mes;\u62CAi\u0200;efl\u32AA\u1059\u1821\u32AB\u65B9tri;\u69CEluhar;\u6968;\u611E\u0D61\u32D5\u32DB\u32DF\u332C\u3338\u3371\0\u337A\u33A4\0\0\u33EC\u33F0\0\u3428\u3448\u345A\u34AD\u34B1\u34CA\u34F1\0\u3616\0\0\u3633cute;\u415Bqu\xef\u27BA\u0500;Eaceinpsy\u11ED\u32F3\u32F5\u32FF\u3302\u330B\u330F\u331F\u3326\u3329;\u6AB4\u01F0\u32FA\0\u32FC;\u6AB8on;\u4161u\xe5\u11FE\u0100;d\u11F3\u3307il;\u415Frc;\u415D\u0180Eas\u3316\u3318\u331B;\u6AB6p;\u6ABAim;\u62E9olint;\u6A13i\xed\u1204;\u4441ot\u0180;be\u3334\u1D47\u3335\u62C5;\u6A66\u0380Aacmstx\u3346\u334A\u3357\u335B\u335E\u3363\u336Drr;\u61D8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0A36\u0A34t\u803B\xa7\u40A7i;\u403Bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uC000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33A0rp;\u666F\u0100hy\u338B\u338Fcy;\u4449;\u4448rt\u026D\u3399\0\0\u339Ci\xe4\u1464ara\xec\u2E6F\u803B\xad\u40AD\u0100gm\u33A8\u33B4ma\u0180;fv\u33B1\u33B2\u33B2\u43C3;\u43C2\u0400;deglnpr\u12AB\u33C5\u33C9\u33CE\u33D6\u33DE\u33E1\u33E6ot;\u6A6A\u0100;q\u12B1\u12B0\u0100;E\u33D3\u33D4\u6A9E;\u6AA0\u0100;E\u33DB\u33DC\u6A9D;\u6A9Fe;\u6246lus;\u6A24arr;\u6972ar\xf2\u113D\u0200aeit\u33F8\u3408\u340F\u3417\u0100ls\u33FD\u3404lsetm\xe9\u336Ahp;\u6A33parsl;\u69E4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341C\u341D\u6AAA\u0100;s\u3422\u3423\u6AAC;\uC000\u2AAC\uFE00\u0180flp\u342E\u3433\u3442tcy;\u444C\u0100;b\u3438\u3439\u402F\u0100;a\u343E\u343F\u69C4r;\u633Ff;\uC000\ud835\udd64a\u0100dr\u344D\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349F\u0100au\u3465\u346Fp\u0100;s\u1188\u346B;\uC000\u2293\uFE00p\u0100;s\u11B4\u3475;\uC000\u2294\uFE00u\u0100bp\u347F\u348F\u0180;es\u1197\u119C\u3486et\u0100;e\u1197\u348D\xf1\u119D\u0180;es\u11A8\u11AD\u3496et\u0100;e\u11A8\u349D\xf1\u11AE\u0180;af\u117B\u34A6\u05B0r\u0165\u34AB\u05B1\xbb\u117Car\xf2\u1148\u0200cemt\u34B9\u34BE\u34C2\u34C5r;\uC000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11BE\u0100ar\u34CE\u34D5r\u0100;f\u34D4\u17BF\u6606\u0100an\u34DA\u34EDight\u0100ep\u34E3\u34EApsilo\xee\u1EE0h\xe9\u2EAFs\xbb\u2852\u0280bcmnp\u34FB\u355E\u1209\u358B\u358E\u0480;Edemnprs\u350E\u350F\u3511\u3515\u351E\u3523\u352C\u3531\u3536\u6282;\u6AC5ot;\u6ABD\u0100;d\u11DA\u351Aot;\u6AC3ult;\u6AC1\u0100Ee\u3528\u352A;\u6ACB;\u628Alus;\u6ABFarr;\u6979\u0180eiu\u353D\u3552\u3555t\u0180;en\u350E\u3545\u354Bq\u0100;q\u11DA\u350Feq\u0100;q\u352B\u3528m;\u6AC7\u0100bp\u355A\u355C;\u6AD5;\u6AD3c\u0300;acens\u11ED\u356C\u3572\u3579\u357B\u3326ppro\xf8\u32FAurlye\xf1\u11FE\xf1\u11F3\u0180aes\u3582\u3588\u331Bppro\xf8\u331Aq\xf1\u3317g;\u666A\u0680123;Edehlmnps\u35A9\u35AC\u35AF\u121C\u35B2\u35B4\u35C0\u35C9\u35D5\u35DA\u35DF\u35E8\u35ED\u803B\xb9\u40B9\u803B\xb2\u40B2\u803B\xb3\u40B3;\u6AC6\u0100os\u35B9\u35BCt;\u6ABEub;\u6AD8\u0100;d\u1222\u35C5ot;\u6AC4s\u0100ou\u35CF\u35D2l;\u67C9b;\u6AD7arr;\u697Bult;\u6AC2\u0100Ee\u35E4\u35E6;\u6ACC;\u628Blus;\u6AC0\u0180eiu\u35F4\u3609\u360Ct\u0180;en\u121C\u35FC\u3602q\u0100;q\u1222\u35B2eq\u0100;q\u35E7\u35E4m;\u6AC8\u0100bp\u3611\u3613;\u6AD4;\u6AD6\u0180Aan\u361C\u3620\u362Drr;\u61D9r\u0100hr\u3626\u3628\xeb\u222E\u0100;o\u0A2B\u0A29war;\u692Alig\u803B\xdf\u40DF\u0BE1\u3651\u365D\u3660\u12CE\u3673\u3679\0\u367E\u36C2\0\0\0\0\0\u36DB\u3703\0\u3709\u376C\0\0\0\u3787\u0272\u3656\0\0\u365Bget;\u6316;\u43C4r\xeb\u0E5F\u0180aey\u3666\u366B\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uC000\ud835\udd31\u0200eiko\u3686\u369D\u36B5\u36BC\u01F2\u368B\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369B\u43B8ym;\u43D1\u0100cn\u36A2\u36B2k\u0100as\u36A8\u36AEppro\xf8\u12C1im\xbb\u12ACs\xf0\u129E\u0100as\u36BA\u36AE\xf0\u12C1rn\u803B\xfe\u40FE\u01EC\u031F\u36C6\u22E7es\u8180\xd7;bd\u36CF\u36D0\u36D8\u40D7\u0100;a\u190F\u36D5r;\u6A31;\u6A30\u0180eps\u36E1\u36E3\u3700\xe1\u2A4D\u0200;bcf\u0486\u36EC\u36F0\u36F4ot;\u6336ir;\u6AF1\u0100;o\u36F9\u36FC\uC000\ud835\udd65rk;\u6ADA\xe1\u3362rime;\u6034\u0180aip\u370F\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374D\u3740\u3751\u3757\u375C\u375Fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65B5own\xbb\u1DBBeft\u0100;e\u2800\u373E\xf1\u092E;\u625Cight\u0100;e\u32AA\u374B\xf1\u105Aot;\u65ECinus;\u6A3Alus;\u6A39b;\u69CDime;\u6A3Bezium;\u63E2\u0180cht\u3772\u377D\u3781\u0100ry\u3777\u377B;\uC000\ud835\udcc9;\u4446cy;\u445Brok;\u4167\u0100io\u378B\u378Ex\xf4\u1777head\u0100lr\u3797\u37A0eftarro\xf7\u084Fightarrow\xbb\u0F5D\u0900AHabcdfghlmoprstuw\u37D0\u37D3\u37D7\u37E4\u37F0\u37FC\u380E\u381C\u3823\u3834\u3851\u385D\u386B\u38A9\u38CC\u38D2\u38EA\u38F6r\xf2\u03EDar;\u6963\u0100cr\u37DC\u37E2ute\u803B\xfa\u40FA\xf2\u1150r\u01E3\u37EA\0\u37EDy;\u445Eve;\u416D\u0100iy\u37F5\u37FArc\u803B\xfb\u40FB;\u4443\u0180abh\u3803\u3806\u380Br\xf2\u13ADlac;\u4171a\xf2\u13C3\u0100ir\u3813\u3818sht;\u697E;\uC000\ud835\udd32rave\u803B\xf9\u40F9\u0161\u3827\u3831r\u0100lr\u382C\u382E\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384D\u026F\u383F\0\0\u384Arn\u0100;e\u3845\u3846\u631Cr\xbb\u3846op;\u630Fri;\u65F8\u0100al\u3856\u385Acr;\u416B\u80BB\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uC000\ud835\udd66\u0300adhlsu\u114B\u3878\u387D\u1372\u3891\u38A0own\xe1\u13B3arpoon\u0100lr\u3888\u388Cef\xf4\u382Digh\xf4\u382Fi\u0180;hl\u3899\u389A\u389C\u43C5\xbb\u13FAon\xbb\u389Aparrows;\u61C8\u0180cit\u38B0\u38C4\u38C8\u026F\u38B6\0\0\u38C1rn\u0100;e\u38BC\u38BD\u631Dr\xbb\u38BDop;\u630Eng;\u416Fri;\u65F9cr;\uC000\ud835\udcca\u0180dir\u38D9\u38DD\u38E2ot;\u62F0lde;\u4169i\u0100;f\u3730\u38E8\xbb\u1813\u0100am\u38EF\u38F2r\xf2\u38A8l\u803B\xfc\u40FCangle;\u69A7\u0780ABDacdeflnoprsz\u391C\u391F\u3929\u392D\u39B5\u39B8\u39BD\u39DF\u39E4\u39E8\u39F3\u39F9\u39FD\u3A01\u3A20r\xf2\u03F7ar\u0100;v\u3926\u3927\u6AE8;\u6AE9as\xe8\u03E1\u0100nr\u3932\u3937grt;\u699C\u0380eknprst\u34E3\u3946\u394B\u3952\u395D\u3964\u3996app\xe1\u2415othin\xe7\u1E96\u0180hir\u34EB\u2EC8\u3959op\xf4\u2FB5\u0100;h\u13B7\u3962\xef\u318D\u0100iu\u3969\u396Dgm\xe1\u33B3\u0100bp\u3972\u3984setneq\u0100;q\u397D\u3980\uC000\u228A\uFE00;\uC000\u2ACB\uFE00setneq\u0100;q\u398F\u3992\uC000\u228B\uFE00;\uC000\u2ACC\uFE00\u0100hr\u399B\u399Fet\xe1\u369Ciangle\u0100lr\u39AA\u39AFeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39C4\u39D2\u39D7\u0180;be\u2DEA\u39CB\u39CFar;\u62BBq;\u625Alip;\u62EE\u0100bt\u39DC\u1468a\xf2\u1469r;\uC000\ud835\udd33tr\xe9\u39AEsu\u0100bp\u39EF\u39F1\xbb\u0D1C\xbb\u0D59pf;\uC000\ud835\udd67ro\xf0\u0EFBtr\xe9\u39B4\u0100cu\u3A06\u3A0Br;\uC000\ud835\udccb\u0100bp\u3A10\u3A18n\u0100Ee\u3980\u3A16\xbb\u397En\u0100Ee\u3992\u3A1E\xbb\u3990igzag;\u699A\u0380cefoprs\u3A36\u3A3B\u3A56\u3A5B\u3A54\u3A61\u3A6Airc;\u4175\u0100di\u3A40\u3A51\u0100bg\u3A45\u3A49ar;\u6A5Fe\u0100;q\u15FA\u3A4F;\u6259erp;\u6118r;\uC000\ud835\udd34pf;\uC000\ud835\udd68\u0100;e\u1479\u3A66at\xe8\u1479cr;\uC000\ud835\udccc\u0AE3\u178E\u3A87\0\u3A8B\0\u3A90\u3A9B\0\0\u3A9D\u3AA8\u3AAB\u3AAF\0\0\u3AC3\u3ACE\0\u3AD8\u17DC\u17DFtr\xe9\u17D1r;\uC000\ud835\udd35\u0100Aa\u3A94\u3A97r\xf2\u03C3r\xf2\u09F6;\u43BE\u0100Aa\u3AA1\u3AA4r\xf2\u03B8r\xf2\u09EBa\xf0\u2713is;\u62FB\u0180dpt\u17A4\u3AB5\u3ABE\u0100fl\u3ABA\u17A9;\uC000\ud835\udd69im\xe5\u17B2\u0100Aa\u3AC7\u3ACAr\xf2\u03CEr\xf2\u0A01\u0100cq\u3AD2\u17B8r;\uC000\ud835\udccd\u0100pt\u17D6\u3ADCr\xe9\u17D4\u0400acefiosu\u3AF0\u3AFD\u3B08\u3B0C\u3B11\u3B15\u3B1B\u3B21c\u0100uy\u3AF6\u3AFBte\u803B\xfd\u40FD;\u444F\u0100iy\u3B02\u3B06rc;\u4177;\u444Bn\u803B\xa5\u40A5r;\uC000\ud835\udd36cy;\u4457pf;\uC000\ud835\udd6acr;\uC000\ud835\udcce\u0100cm\u3B26\u3B29y;\u444El\u803B\xff\u40FF\u0500acdefhiosw\u3B42\u3B48\u3B54\u3B58\u3B64\u3B69\u3B6D\u3B74\u3B7A\u3B80cute;\u417A\u0100ay\u3B4D\u3B52ron;\u417E;\u4437ot;\u417C\u0100et\u3B5D\u3B61tr\xe6\u155Fa;\u43B6r;\uC000\ud835\udd37cy;\u4436grarr;\u61DDpf;\uC000\ud835\udd6bcr;\uC000\ud835\udccf\u0100jn\u3B85\u3B87;\u600Dj;\u600C'.split("").map((c)=>c.charCodeAt(0)));


// Generated using scripts/write-decode-map.ts
var $79538e6bbdd097a4$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u0200aglq	\x15\x18\x1b\u026D\x0f\0\0\x12p;\u4026os;\u4027t;\u403Et;\u403Cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));


// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $10632aaf914d6bd1$var$_a;
const $10632aaf914d6bd1$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
const $10632aaf914d6bd1$export$73bfc63873071f74 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($10632aaf914d6bd1$var$_a = String.fromCodePoint) !== null && $10632aaf914d6bd1$var$_a !== void 0 ? $10632aaf914d6bd1$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $10632aaf914d6bd1$export$b978ab756102108a(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $10632aaf914d6bd1$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function $10632aaf914d6bd1$export$2e2bcd8739ae039(codePoint) {
    return $10632aaf914d6bd1$export$73bfc63873071f74($10632aaf914d6bd1$export$b978ab756102108a(codePoint));
}


var $21b54aeefac41b63$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($21b54aeefac41b63$var$CharCodes || ($21b54aeefac41b63$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $21b54aeefac41b63$var$TO_LOWER_BIT = 32;
var $21b54aeefac41b63$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($21b54aeefac41b63$export$6a4325c613e0faec || ($21b54aeefac41b63$export$6a4325c613e0faec = {}));
function $21b54aeefac41b63$var$isNumber(code) {
    return code >= $21b54aeefac41b63$var$CharCodes.ZERO && code <= $21b54aeefac41b63$var$CharCodes.NINE;
}
function $21b54aeefac41b63$var$isHexadecimalCharacter(code) {
    return code >= $21b54aeefac41b63$var$CharCodes.UPPER_A && code <= $21b54aeefac41b63$var$CharCodes.UPPER_F || code >= $21b54aeefac41b63$var$CharCodes.LOWER_A && code <= $21b54aeefac41b63$var$CharCodes.LOWER_F;
}
function $21b54aeefac41b63$var$isAsciiAlphaNumeric(code) {
    return code >= $21b54aeefac41b63$var$CharCodes.UPPER_A && code <= $21b54aeefac41b63$var$CharCodes.UPPER_Z || code >= $21b54aeefac41b63$var$CharCodes.LOWER_A && code <= $21b54aeefac41b63$var$CharCodes.LOWER_Z || $21b54aeefac41b63$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $21b54aeefac41b63$var$isEntityInAttributeInvalidEnd(code) {
    return code === $21b54aeefac41b63$var$CharCodes.EQUALS || $21b54aeefac41b63$var$isAsciiAlphaNumeric(code);
}
var $21b54aeefac41b63$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($21b54aeefac41b63$var$EntityDecoderState || ($21b54aeefac41b63$var$EntityDecoderState = {}));
var $21b54aeefac41b63$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($21b54aeefac41b63$export$8c8f129ce60f53c || ($21b54aeefac41b63$export$8c8f129ce60f53c = {}));
class $21b54aeefac41b63$export$15263a93ff7ec8ba {
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $21b54aeefac41b63$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $21b54aeefac41b63$export$8c8f129ce60f53c.Strict;
    }
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $21b54aeefac41b63$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(str, offset) {
        switch(this.state){
            case $21b54aeefac41b63$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $21b54aeefac41b63$var$CharCodes.NUM) {
                    this.state = $21b54aeefac41b63$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $21b54aeefac41b63$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $21b54aeefac41b63$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $21b54aeefac41b63$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $21b54aeefac41b63$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $21b54aeefac41b63$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $21b54aeefac41b63$var$TO_LOWER_BIT) === $21b54aeefac41b63$var$CharCodes.LOWER_X) {
            this.state = $21b54aeefac41b63$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $21b54aeefac41b63$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    }
    addToNumericResult(str, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($21b54aeefac41b63$var$isNumber(char) || $21b54aeefac41b63$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($21b54aeefac41b63$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $21b54aeefac41b63$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $21b54aeefac41b63$export$8c8f129ce60f53c.Strict) return 0;
        this.emitCodePoint((0, $10632aaf914d6bd1$export$b978ab756102108a)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $21b54aeefac41b63$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(str, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $21b54aeefac41b63$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            const char = str.charCodeAt(offset);
            this.treeIndex = $21b54aeefac41b63$export$44c08d99945e6276(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $21b54aeefac41b63$export$8c8f129ce60f53c.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $21b54aeefac41b63$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $21b54aeefac41b63$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $21b54aeefac41b63$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $21b54aeefac41b63$export$8c8f129ce60f53c.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $21b54aeefac41b63$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$21b54aeefac41b63$export$6a4325c613e0faec.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $21b54aeefac41b63$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $21b54aeefac41b63$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $21b54aeefac41b63$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $21b54aeefac41b63$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $21b54aeefac41b63$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $21b54aeefac41b63$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $21b54aeefac41b63$var$getDecoder(decodeTree) {
    let ret = "";
    const decoder = new $21b54aeefac41b63$export$15263a93ff7ec8ba(decodeTree, (str)=>ret += (0, $10632aaf914d6bd1$export$73bfc63873071f74)(str));
    return function decodeWithTrie(str, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
function $21b54aeefac41b63$export$44c08d99945e6276(decodeTree, current, nodeIdx, char) {
    const branchCount = (current & $21b54aeefac41b63$export$6a4325c613e0faec.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $21b54aeefac41b63$export$6a4325c613e0faec.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIdx;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $21b54aeefac41b63$var$htmlDecoder = $21b54aeefac41b63$var$getDecoder((0, $955886d6453f1f75$export$2e2bcd8739ae039));
const $21b54aeefac41b63$var$xmlDecoder = $21b54aeefac41b63$var$getDecoder((0, $79538e6bbdd097a4$export$2e2bcd8739ae039));
function $21b54aeefac41b63$export$f045cb747ce77a19(str, mode = $21b54aeefac41b63$export$8c8f129ce60f53c.Legacy) {
    return $21b54aeefac41b63$var$htmlDecoder(str, mode);
}
function $21b54aeefac41b63$export$49f5e8089adb006a(str) {
    return $21b54aeefac41b63$var$htmlDecoder(str, $21b54aeefac41b63$export$8c8f129ce60f53c.Attribute);
}
function $21b54aeefac41b63$export$da52f4371b3f37de(str) {
    return $21b54aeefac41b63$var$htmlDecoder(str, $21b54aeefac41b63$export$8c8f129ce60f53c.Strict);
}
function $21b54aeefac41b63$export$88e3b9643a8bd06e(str) {
    return $21b54aeefac41b63$var$xmlDecoder(str, $21b54aeefac41b63$export$8c8f129ce60f53c.Strict);
}


// Generated using scripts/write-encode-map.ts
function $70fecd720f63c751$var$restoreDiff(arr) {
    for(let i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
var // prettier-ignore
$70fecd720f63c751$export$2e2bcd8739ae039 = new Map(/* #__PURE__ */ $70fecd720f63c751$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $70fecd720f63c751$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $70fecd720f63c751$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $70fecd720f63c751$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));


const $e72123220ae6606b$export$5699810ce3244ab8 = /["&'<>$\x80-\uFFFF]/g;
const $e72123220ae6606b$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
const $e72123220ae6606b$export$e02688b8085d016b = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? (str, index)=>str.codePointAt(index) : (c, index)=>(c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
function $e72123220ae6606b$export$18855ec5be97da16(str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = $e72123220ae6606b$export$5699810ce3244ab8.exec(str)) !== null){
        const i = match.index;
        const char = str.charCodeAt(i);
        const next = $e72123220ae6606b$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += `${str.substring(lastIdx, i)}&#x${$e72123220ae6606b$export$e02688b8085d016b(str, i).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = $e72123220ae6606b$export$5699810ce3244ab8.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
const $e72123220ae6606b$export$4e7f196112fea3c5 = $e72123220ae6606b$export$18855ec5be97da16;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $e72123220ae6606b$var$getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIdx = 0;
        let result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
const $e72123220ae6606b$export$9e081872deefdcb0 = $e72123220ae6606b$var$getEscaper(/[&<>'"]/g, $e72123220ae6606b$var$xmlCodeMap);
const $e72123220ae6606b$export$30330f3d5eb70e11 = $e72123220ae6606b$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
const $e72123220ae6606b$export$96e6fc3a139b2555 = $e72123220ae6606b$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));


const $428a7e43bc21742b$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function $428a7e43bc21742b$export$f9d6449b9af28dc1(data) {
    return $428a7e43bc21742b$var$encodeHTMLTrieRe($428a7e43bc21742b$var$htmlReplacer, data);
}
function $428a7e43bc21742b$export$e6e86c76506f1190(data) {
    return $428a7e43bc21742b$var$encodeHTMLTrieRe((0, $e72123220ae6606b$export$5699810ce3244ab8), data);
}
function $428a7e43bc21742b$var$encodeHTMLTrieRe(regExp, str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = regExp.exec(str)) !== null){
        const i = match.index;
        ret += str.substring(lastIdx, i);
        const char = str.charCodeAt(i);
        let next = (0, $70fecd720f63c751$export$2e2bcd8739ae039).get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                const nextChar = str.charCodeAt(i + 1);
                const value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            const cp = (0, $e72123220ae6606b$export$e02688b8085d016b)(str, i);
            ret += `&#x${cp.toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}



var $19c65afdc12482fd$export$b8c86583d9718b50;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($19c65afdc12482fd$export$b8c86583d9718b50 || ($19c65afdc12482fd$export$b8c86583d9718b50 = {}));
var $19c65afdc12482fd$export$1851b20d614eb756;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($19c65afdc12482fd$export$1851b20d614eb756 || ($19c65afdc12482fd$export$1851b20d614eb756 = {}));
function $19c65afdc12482fd$export$2f872c0f2117be69(data, options = $19c65afdc12482fd$export$b8c86583d9718b50.XML) {
    const level = typeof options === "number" ? options : options.level;
    if (level === $19c65afdc12482fd$export$b8c86583d9718b50.HTML) {
        const mode = typeof options === "object" ? options.mode : undefined;
        return (0, $21b54aeefac41b63$export$f045cb747ce77a19)(data, mode);
    }
    return (0, $21b54aeefac41b63$export$88e3b9643a8bd06e)(data);
}
function $19c65afdc12482fd$export$c94669f4c7d36be4(data, options = $19c65afdc12482fd$export$b8c86583d9718b50.XML) {
    var _a;
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = (0, $21b54aeefac41b63$export$8c8f129ce60f53c).Strict;
    return $19c65afdc12482fd$export$2f872c0f2117be69(data, opts);
}
function $19c65afdc12482fd$export$c564cdbbe6da493(data, options = $19c65afdc12482fd$export$b8c86583d9718b50.XML) {
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $19c65afdc12482fd$export$1851b20d614eb756.UTF8) return (0, $e72123220ae6606b$export$9e081872deefdcb0)(data);
    if (opts.mode === $19c65afdc12482fd$export$1851b20d614eb756.Attribute) return (0, $e72123220ae6606b$export$30330f3d5eb70e11)(data);
    if (opts.mode === $19c65afdc12482fd$export$1851b20d614eb756.Text) return (0, $e72123220ae6606b$export$96e6fc3a139b2555)(data);
    if (opts.level === $19c65afdc12482fd$export$b8c86583d9718b50.HTML) {
        if (opts.mode === $19c65afdc12482fd$export$1851b20d614eb756.ASCII) return (0, $428a7e43bc21742b$export$e6e86c76506f1190)(data);
        return (0, $428a7e43bc21742b$export$f9d6449b9af28dc1)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $e72123220ae6606b$export$18855ec5be97da16)(data);
}


function $acb166200129f66e$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $acb166200129f66e$export$844ec244b1367d54(obj) {
    return $acb166200129f66e$var$_class(obj) === "[object String]";
}
const $acb166200129f66e$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $acb166200129f66e$export$a4f4bb6b1453fff5(object, key) {
    return $acb166200129f66e$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $acb166200129f66e$export$e6e34fd1f2686227(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== "object") throw new TypeError(source + "must be object");
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $acb166200129f66e$export$f78478f71955b6bc(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
function $acb166200129f66e$export$644a8f5b13b2a36d(c) {
    /* eslint no-bitwise:0 */ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $acb166200129f66e$export$73bfc63873071f74(c) {
    /* eslint no-bitwise:0 */ if (c > 0xffff) {
        c -= 0x10000;
        const surrogate1 = 0xd800 + (c >> 10);
        const surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
const $acb166200129f66e$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g;
const $acb166200129f66e$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
const $acb166200129f66e$var$UNESCAPE_ALL_RE = new RegExp($acb166200129f66e$var$UNESCAPE_MD_RE.source + "|" + $acb166200129f66e$var$ENTITY_RE.source, "gi");
const $acb166200129f66e$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function $acb166200129f66e$var$replaceEntityPattern(match, name) {
    if (name.charCodeAt(0) === 0x23 /* # */  && $acb166200129f66e$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        const code = name[1].toLowerCase() === "x" ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($acb166200129f66e$export$644a8f5b13b2a36d(code)) return $acb166200129f66e$export$73bfc63873071f74(code);
        return match;
    }
    const decoded = (0, $21b54aeefac41b63$export$f045cb747ce77a19)(match);
    if (decoded !== match) return decoded;
    return match;
}
/* function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
} */ function $acb166200129f66e$export$5ccde1ea0c14bb03(str) {
    if (str.indexOf("\\") < 0) return str;
    return str.replace($acb166200129f66e$var$UNESCAPE_MD_RE, "$1");
}
function $acb166200129f66e$export$db8a17c6655f7e2c(str) {
    if (str.indexOf("\\") < 0 && str.indexOf("&") < 0) return str;
    return str.replace($acb166200129f66e$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $acb166200129f66e$var$replaceEntityPattern(match, entity);
    });
}
const $acb166200129f66e$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
const $acb166200129f66e$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
const $acb166200129f66e$var$HTML_REPLACEMENTS = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;"
};
function $acb166200129f66e$var$replaceUnsafeChar(ch) {
    return $acb166200129f66e$var$HTML_REPLACEMENTS[ch];
}
function $acb166200129f66e$export$4cf11838cdc2a8a8(str) {
    if ($acb166200129f66e$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($acb166200129f66e$var$HTML_ESCAPE_REPLACE_RE, $acb166200129f66e$var$replaceUnsafeChar);
    return str;
}
const $acb166200129f66e$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $acb166200129f66e$export$bc616c8f7dc20d5d(str) {
    return str.replace($acb166200129f66e$var$REGEXP_ESCAPE_RE, "\\$&");
}
function $acb166200129f66e$export$1d5ccafae59b4926(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $acb166200129f66e$export$3c52dd84024ae72c(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}
/* eslint-disable max-len */ // Currently without astral characters support.
function $acb166200129f66e$export$4888a643af800fc1(ch) {
    return $e24366eb89af439c$export$2e2bcd8739ae039.test(ch) || $add59bdd531def5c$export$2e2bcd8739ae039.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $acb166200129f66e$export$829a0d33ae4e744(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $acb166200129f66e$export$20ef46802c8744b(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, " ");
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
const $acb166200129f66e$export$16c08b91f883959a = {
    mdurl: $cfe8e16a3976eb73$exports,
    ucmicro: $d55a0620136dd6aa$exports
};


var $99119f957fdc25f6$exports = {};

$parcel$export($99119f957fdc25f6$exports, "parseLinkLabel", () => $abd2f48303995751$export$2e2bcd8739ae039);
$parcel$export($99119f957fdc25f6$exports, "parseLinkDestination", () => $edde6865825d92e7$export$2e2bcd8739ae039);
$parcel$export($99119f957fdc25f6$exports, "parseLinkTitle", () => $f1d3017a5ae96057$export$2e2bcd8739ae039);
// Just a shortcut for bulk export
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
function $abd2f48303995751$export$2e2bcd8739ae039(state, start, disableNested) {
    let level, found, marker, prevPos;
    const max = state.posMax;
    const oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    let labelEnd = -1;
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
}


// Parse link destination
//

function $edde6865825d92e7$export$2e2bcd8739ae039(str, start, max) {
    let code;
    let pos = start;
    const result = {
        ok: false,
        pos: 0,
        str: ""
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = (0, $acb166200129f66e$export$db8a17c6655f7e2c)(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    let level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = (0, $acb166200129f66e$export$db8a17c6655f7e2c)(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
}


// Parse link title
//

function $f1d3017a5ae96057$export$2e2bcd8739ae039(str, start, max, prev_state) {
    let code;
    let pos = start;
    const state = {
        // if `true`, this is a valid link title
        ok: false,
        // if `true`, this link can be continued on the next line
        can_continue: false,
        // if `ok`, it's the position of the first character after the closing marker
        pos: 0,
        // if `ok`, it's the unescaped title
        str: "",
        // expected closing marker character code
        marker: 0
    };
    if (prev_state) {
        // this is a continuation of a previous parseLinkTitle call on the next line,
        // used in reference links only
        state.str = prev_state.str;
        state.marker = prev_state.marker;
    } else {
        if (pos >= max) return state;
        let marker = str.charCodeAt(pos);
        if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return state;
        start++;
        pos++;
        // if opening marker is "(", switch it to closing marker ")"
        if (marker === 0x28) marker = 0x29;
        state.marker = marker;
    }
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === state.marker) {
            state.pos = pos + 1;
            state.str += (0, $acb166200129f66e$export$db8a17c6655f7e2c)(str.slice(start, pos));
            state.ok = true;
            return state;
        } else if (code === 0x28 /* ( */  && state.marker === 0x29 /* ) */ ) return state;
        else if (code === 0x5C /* \ */  && pos + 1 < max) pos++;
        pos++;
    }
    // no closing marker found, but this link title may continue on the next line (for references)
    state.can_continue = true;
    state.str += (0, $acb166200129f66e$export$db8a17c6655f7e2c)(str.slice(start, pos));
    return state;
}




/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 
const $1aad198f750e42d7$var$default_rules = {};
$1aad198f750e42d7$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return "<code" + slf.renderAttrs(token) + ">" + (0, $acb166200129f66e$export$4cf11838cdc2a8a8)(token.content) + "</code>";
};
$1aad198f750e42d7$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return "<pre" + slf.renderAttrs(token) + "><code>" + (0, $acb166200129f66e$export$4cf11838cdc2a8a8)(tokens[idx].content) + "</code></pre>\n";
};
$1aad198f750e42d7$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    const info = token.info ? (0, $acb166200129f66e$export$db8a17c6655f7e2c)(token.info).trim() : "";
    let langName = "";
    let langAttrs = "";
    if (info) {
        const arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join("");
    }
    let highlighted;
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || (0, $acb166200129f66e$export$4cf11838cdc2a8a8)(token.content);
    else highlighted = (0, $acb166200129f66e$export$4cf11838cdc2a8a8)(token.content);
    if (highlighted.indexOf("<pre") === 0) return highlighted + "\n";
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        const i = token.attrIndex("class");
        const tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            "class",
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += " " + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        const tmpToken = {
            attrs: tmpAttrs
        };
        return `<pre><code${slf.renderAttrs(tmpToken)}>${highlighted}</code></pre>\n`;
    }
    return `<pre><code${slf.renderAttrs(token)}>${highlighted}</code></pre>\n`;
};
$1aad198f750e42d7$var$default_rules.image = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex("alt")][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$1aad198f750e42d7$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? "<br />\n" : "<br>\n";
};
$1aad198f750e42d7$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? "<br />\n" : "<br>\n" : "\n";
};
$1aad198f750e42d7$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return (0, $acb166200129f66e$export$4cf11838cdc2a8a8)(tokens[idx].content);
};
$1aad198f750e42d7$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$1aad198f750e42d7$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $1aad198f750e42d7$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs)
   * for more details and examples.
   **/ this.rules = (0, $acb166200129f66e$export$e6e34fd1f2686227)({}, $1aad198f750e42d7$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $1aad198f750e42d7$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    let i, l, result;
    if (!token.attrs) return "";
    result = "";
    for(i = 0, l = token.attrs.length; i < l; i++)result += " " + (0, $acb166200129f66e$export$4cf11838cdc2a8a8)(token.attrs[i][0]) + '="' + (0, $acb166200129f66e$export$4cf11838cdc2a8a8)(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $1aad198f750e42d7$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    const token = tokens[idx];
    let result = "";
    // Tight list paragraphs
    if (token.hidden) return "";
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += "\n";
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? "</" : "<") + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += " /";
    // Check if we need to add a newline after this tag
    let needLf = false;
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                const nextToken = tokens[idx + 1];
                if (nextToken.type === "inline" || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? ">\n" : ">";
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $1aad198f750e42d7$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    let result = "";
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (typeof rules[type] !== "undefined") result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $1aad198f750e42d7$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    let result = "";
    for(let i = 0, len = tokens.length; i < len; i++)switch(tokens[i].type){
        case "text":
            result += tokens[i].content;
            break;
        case "image":
            result += this.renderInlineAsText(tokens[i].children, options, env);
            break;
        case "html_inline":
        case "html_block":
            result += tokens[i].content;
            break;
        case "softbreak":
        case "hardbreak":
            result += "\n";
            break;
        default:
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $1aad198f750e42d7$var$Renderer.prototype.render = function(tokens, options, env) {
    let result = "";
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (type === "inline") result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== "undefined") result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
var $1aad198f750e42d7$export$2e2bcd8739ae039 = $1aad198f750e42d7$var$Renderer;


/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ /**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ /**
 * new Ruler()
 **/ function $41ea3ea6c70806b8$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
// Helper methods, should not be used directly
// Find rule index by name
//
$41ea3ea6c70806b8$var$Ruler.prototype.__find__ = function(name) {
    for(let i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$41ea3ea6c70806b8$var$Ruler.prototype.__compile__ = function() {
    const self = this;
    const chains = [
        ""
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.at = function(name, fn, options) {
    const index = this.__find__(name);
    const opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    const index = this.__find__(beforeName);
    const opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    const index = this.__find__(afterName);
    const opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.push = function(ruleName, fn, options) {
    const opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and enable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error("Rules manager: invalid rule name " + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and disable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error("Rules manager: invalid rule name " + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
var $41ea3ea6c70806b8$export$2e2bcd8739ae039 = $41ea3ea6c70806b8$var$Ruler;


// Core state object
//
// Token class
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $59ac17e6d91b036a$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = "";
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = "";
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = "";
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $59ac17e6d91b036a$var$Token.prototype.attrIndex = function attrIndex(name) {
    if (!this.attrs) return -1;
    const attrs = this.attrs;
    for(let i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $59ac17e6d91b036a$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $59ac17e6d91b036a$var$Token.prototype.attrSet = function attrSet(name, value) {
    const idx = this.attrIndex(name);
    const attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $59ac17e6d91b036a$var$Token.prototype.attrGet = function attrGet(name) {
    const idx = this.attrIndex(name);
    let value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $59ac17e6d91b036a$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    const idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + " " + value;
};
var $59ac17e6d91b036a$export$2e2bcd8739ae039 = $59ac17e6d91b036a$var$Token;


function $8993a444d7ae3c83$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md // link to parser instance
    ;
}
// re-export Token class to use in core rules
$8993a444d7ae3c83$var$StateCore.prototype.Token = (0, $59ac17e6d91b036a$export$2e2bcd8739ae039);
var $8993a444d7ae3c83$export$2e2bcd8739ae039 = $8993a444d7ae3c83$var$StateCore;


// Normalize input string
// https://spec.commonmark.org/0.29/#line-ending
const $5203c6838a32c344$var$NEWLINES_RE = /\r\n?|\n/g;
const $5203c6838a32c344$var$NULL_RE = /\0/g;
function $5203c6838a32c344$export$2e2bcd8739ae039(state) {
    let str;
    // Normalize newlines
    str = state.src.replace($5203c6838a32c344$var$NEWLINES_RE, "\n");
    // Replace NULL characters
    str = str.replace($5203c6838a32c344$var$NULL_RE, "\uFFFD");
    state.src = str;
}


function $cd7698881deefc7d$export$2e2bcd8739ae039(state) {
    let token;
    if (state.inlineMode) {
        token = new state.Token("inline", "", 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
}


function $196eb58ba8a882c3$export$2e2bcd8739ae039(state) {
    const tokens = state.tokens;
    // Parse inlines
    for(let i = 0, l = tokens.length; i < l; i++){
        const tok = tokens[i];
        if (tok.type === "inline") state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
}


// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//

function $e017aabd93d74ca7$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $e017aabd93d74ca7$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $e017aabd93d74ca7$export$2e2bcd8739ae039(state) {
    const blockTokens = state.tokens;
    if (!state.md.options.linkify) return;
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== "inline" || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === "link_close") {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== "link_open")i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === "html_inline") {
                if ($e017aabd93d74ca7$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($e017aabd93d74ca7$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === "text" && state.md.linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = state.md.linkify.match(text);
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === "text_special") links = links.slice(1);
                for(let ln = 0; ln < links.length; ln++){
                    const url = links[ln].url;
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText("http://" + urlText).replace(/^http:\/\//, "");
                    else if (links[ln].schema === "mailto:" && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText("mailto:" + urlText).replace(/^mailto:/, "");
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token("text", "", 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    const token_o = new state.Token("link_open", "a", 1);
                    token_o.attrs = [
                        [
                            "href",
                            fullUrl
                        ]
                    ];
                    token_o.level = level++;
                    token_o.markup = "linkify";
                    token_o.info = "auto";
                    nodes.push(token_o);
                    const token_t = new state.Token("text", "", 0);
                    token_t.content = urlText;
                    token_t.level = level;
                    nodes.push(token_t);
                    const token_c = new state.Token("link_close", "a", -1);
                    token_c.level = --level;
                    token_c.markup = "linkify";
                    token_c.info = "auto";
                    nodes.push(token_c);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token("text", "", 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = (0, $acb166200129f66e$export$f78478f71955b6bc)(tokens, i, nodes);
            }
        }
    }
}


// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
const $71faf318b045012d$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
const $71faf318b045012d$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
const $71faf318b045012d$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
const $71faf318b045012d$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $71faf318b045012d$var$replaceFn(match, name) {
    return $71faf318b045012d$var$SCOPED_ABBR[name.toLowerCase()];
}
function $71faf318b045012d$var$replace_scoped(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === "text" && !inside_autolink) token.content = token.content.replace($71faf318b045012d$var$SCOPED_ABBR_RE, $71faf318b045012d$var$replaceFn);
        if (token.type === "link_open" && token.info === "auto") inside_autolink--;
        if (token.type === "link_close" && token.info === "auto") inside_autolink++;
    }
}
function $71faf318b045012d$var$replace_rare(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === "text" && !inside_autolink) {
            if ($71faf318b045012d$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",")// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, "$1\u2014")// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, "$1\u2013").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1\u2013");
        }
        if (token.type === "link_open" && token.info === "auto") inside_autolink--;
        if (token.type === "link_close" && token.info === "auto") inside_autolink++;
    }
}
function $71faf318b045012d$export$2e2bcd8739ae039(state) {
    let blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline") continue;
        if ($71faf318b045012d$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $71faf318b045012d$var$replace_scoped(state.tokens[blkIdx].children);
        if ($71faf318b045012d$var$RARE_RE.test(state.tokens[blkIdx].content)) $71faf318b045012d$var$replace_rare(state.tokens[blkIdx].children);
    }
}


// Convert straight quotation marks to typographic ones
//

const $18c84f826c38cf40$var$QUOTE_TEST_RE = /['"]/;
const $18c84f826c38cf40$var$QUOTE_RE = /['"]/g;
const $18c84f826c38cf40$var$APOSTROPHE = "\u2019" /* ’ */ ;
function $18c84f826c38cf40$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $18c84f826c38cf40$var$process_inlines(tokens, state) {
    let j;
    const stack = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        const thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== "text") continue;
        let text = token.content;
        let pos = 0;
        let max = text.length;
        /* eslint no-labels:0,block-scoped-var:0 */ OUTER: while(pos < max){
            $18c84f826c38cf40$var$QUOTE_RE.lastIndex = pos;
            const t = $18c84f826c38cf40$var$QUOTE_RE.exec(text);
            if (!t) break;
            let canOpen = true;
            let canClose = true;
            pos = t.index + 1;
            const isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            let lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            let nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            const isLastPunctChar = (0, $acb166200129f66e$export$829a0d33ae4e744)(lastChar) || (0, $acb166200129f66e$export$4888a643af800fc1)(String.fromCharCode(lastChar));
            const isNextPunctChar = (0, $acb166200129f66e$export$829a0d33ae4e744)(nextChar) || (0, $acb166200129f66e$export$4888a643af800fc1)(String.fromCharCode(nextChar));
            const isLastWhiteSpace = (0, $acb166200129f66e$export$3c52dd84024ae72c)(lastChar);
            const isNextWhiteSpace = (0, $acb166200129f66e$export$3c52dd84024ae72c)(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $18c84f826c38cf40$var$replaceAt(token.content, t.index, $18c84f826c38cf40$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                let item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    let openQuote;
                    let closeQuote;
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $18c84f826c38cf40$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $18c84f826c38cf40$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $18c84f826c38cf40$var$replaceAt(token.content, t.index, $18c84f826c38cf40$var$APOSTROPHE);
        }
    }
}
function $18c84f826c38cf40$export$2e2bcd8739ae039(state) {
    /* eslint max-depth:0 */ if (!state.md.options.typographer) return;
    for(let blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline" || !$18c84f826c38cf40$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $18c84f826c38cf40$var$process_inlines(state.tokens[blkIdx].children, state);
    }
}


// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
function $7a6cf0d0aa696419$export$2e2bcd8739ae039(state) {
    let curr, last;
    const blockTokens = state.tokens;
    const l = blockTokens.length;
    for(let j = 0; j < l; j++){
        if (blockTokens[j].type !== "inline") continue;
        const tokens = blockTokens[j].children;
        const max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === "text_special") tokens[curr].type = "text";
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === "text" && curr + 1 < max && tokens[curr + 1].type === "text") // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
}


const $1dbd8732bf2ea1e5$var$_rules = [
    [
        "normalize",
        (0, $5203c6838a32c344$export$2e2bcd8739ae039)
    ],
    [
        "block",
        (0, $cd7698881deefc7d$export$2e2bcd8739ae039)
    ],
    [
        "inline",
        (0, $196eb58ba8a882c3$export$2e2bcd8739ae039)
    ],
    [
        "linkify",
        (0, $e017aabd93d74ca7$export$2e2bcd8739ae039)
    ],
    [
        "replacements",
        (0, $71faf318b045012d$export$2e2bcd8739ae039)
    ],
    [
        "smartquotes",
        (0, $18c84f826c38cf40$export$2e2bcd8739ae039)
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        "text_join",
        (0, $7a6cf0d0aa696419$export$2e2bcd8739ae039)
    ]
];
/**
 * new Core()
 **/ function $1dbd8732bf2ea1e5$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new (0, $41ea3ea6c70806b8$export$2e2bcd8739ae039)();
    for(let i = 0; i < $1dbd8732bf2ea1e5$var$_rules.length; i++)this.ruler.push($1dbd8732bf2ea1e5$var$_rules[i][0], $1dbd8732bf2ea1e5$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $1dbd8732bf2ea1e5$var$Core.prototype.process = function(state) {
    const rules = this.ruler.getRules("");
    for(let i = 0, l = rules.length; i < l; i++)rules[i](state);
};
$1dbd8732bf2ea1e5$var$Core.prototype.State = (0, $8993a444d7ae3c83$export$2e2bcd8739ae039);
var $1dbd8732bf2ea1e5$export$2e2bcd8739ae039 = $1dbd8732bf2ea1e5$var$Core;


/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 
// Parser state class


function $ad2420667aa7c8e8$var$StateBlock(src, md, env, tokens) {
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = [] // line begin offsets for fast jumps
    ;
    this.eMarks = [] // line end offsets for fast jumps
    ;
    this.tShift = [] // offsets of the first non-space characters (tabs not expanded)
    ;
    this.sCount = [] // indents for each line (tabs expanded)
    ;
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.blkIndent = 0;
    this.line = 0 // line index in src
    ;
    this.lineMax = 0 // lines count
    ;
    this.tight = false // loose/tight mode for lists
    ;
    this.ddIndent = -1 // indent of the current dd block (-1 if there isn't any)
    ;
    this.listIndent = -1 // indent of the current list block (-1 if there isn't any)
    ;
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = "root";
    this.level = 0;
    // Create caches
    // Generate markers.
    const s = this.src;
    for(let start = 0, pos = 0, indent = 0, offset = 0, len = s.length, indent_found = false; pos < len; pos++){
        const ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ((0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1 // don't count last fake line
    ;
}
// Push new token to "stream".
//
$ad2420667aa7c8e8$var$StateBlock.prototype.push = function(type, tag, nesting) {
    const token = new (0, $59ac17e6d91b036a$export$2e2bcd8739ae039)(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level-- // closing tag
    ;
    token.level = this.level;
    if (nesting > 0) this.level++ // opening tag
    ;
    this.tokens.push(token);
    return token;
};
$ad2420667aa7c8e8$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$ad2420667aa7c8e8$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(let max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$ad2420667aa7c8e8$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    for(let max = this.src.length; pos < max; pos++){
        const ch = this.src.charCodeAt(pos);
        if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$ad2420667aa7c8e8$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$ad2420667aa7c8e8$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(let max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$ad2420667aa7c8e8$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$ad2420667aa7c8e8$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    if (begin >= end) return "";
    const queue = new Array(end - begin);
    for(let i = 0, line = begin; line < end; line++, i++){
        let lineIndent = 0;
        const lineStart = this.bMarks[line];
        let first = lineStart;
        let last;
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            const ch = this.src.charCodeAt(first);
            if ((0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(" ") + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join("");
};
// re-export Token class to use in block rules
$ad2420667aa7c8e8$var$StateBlock.prototype.Token = (0, $59ac17e6d91b036a$export$2e2bcd8739ae039);
var $ad2420667aa7c8e8$export$2e2bcd8739ae039 = $ad2420667aa7c8e8$var$StateBlock;


// GFM table, https://github.github.com/gfm/#tables-extension-

// Limit the amount of empty autocompleted cells in a table,
// see https://github.com/markdown-it/markdown-it/issues/1000,
//
// Both pulldown-cmark and commonmark-hs limit the number of cells this way to ~200k.
// We set it to 65k, which can expand user input by a factor of x370
// (256x256 square is 1.8kB expanded into 650kB).
const $2ef92aecf350006a$var$MAX_AUTOCOMPLETED_CELLS = 0x10000;
function $2ef92aecf350006a$var$getLine(state, line) {
    const pos = state.bMarks[line] + state.tShift[line];
    const max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $2ef92aecf350006a$var$escapedSplit(str) {
    const result = [];
    const max = str.length;
    let pos = 0;
    let ch = str.charCodeAt(pos);
    let isEscaped = false;
    let lastPos = 0;
    let current = "";
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = "";
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
function $2ef92aecf350006a$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    let nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    let pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    const firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    const secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !(0, $acb166200129f66e$export$1d5ccafae59b4926)(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && (0, $acb166200129f66e$export$1d5ccafae59b4926)(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        const ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !(0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) return false;
        pos++;
    }
    let lineText = $2ef92aecf350006a$var$getLine(state, startLine + 1);
    let columns = lineText.split("|");
    const aligns = [];
    for(let i = 0; i < columns.length; i++){
        const t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? "center" : "right");
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push("left");
        else aligns.push("");
    }
    lineText = $2ef92aecf350006a$var$getLine(state, startLine).trim();
    if (lineText.indexOf("|") === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $2ef92aecf350006a$var$escapedSplit(lineText);
    if (columns.length && columns[0] === "") columns.shift();
    if (columns.length && columns[columns.length - 1] === "") columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    const columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    const oldParentType = state.parentType;
    state.parentType = "table";
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    const terminatorRules = state.md.block.ruler.getRules("blockquote");
    const token_to = state.push("table_open", "table", 1);
    const tableLines = [
        startLine,
        0
    ];
    token_to.map = tableLines;
    const token_tho = state.push("thead_open", "thead", 1);
    token_tho.map = [
        startLine,
        startLine + 1
    ];
    const token_htro = state.push("tr_open", "tr", 1);
    token_htro.map = [
        startLine,
        startLine + 1
    ];
    for(let i = 0; i < columns.length; i++){
        const token_ho = state.push("th_open", "th", 1);
        if (aligns[i]) token_ho.attrs = [
            [
                "style",
                "text-align:" + aligns[i]
            ]
        ];
        const token_il = state.push("inline", "", 0);
        token_il.content = columns[i].trim();
        token_il.children = [];
        state.push("th_close", "th", -1);
    }
    state.push("tr_close", "tr", -1);
    state.push("thead_close", "thead", -1);
    let tbodyLines;
    let autocompletedCells = 0;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $2ef92aecf350006a$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $2ef92aecf350006a$var$escapedSplit(lineText);
        if (columns.length && columns[0] === "") columns.shift();
        if (columns.length && columns[columns.length - 1] === "") columns.pop();
        // note: autocomplete count can be negative if user specifies more columns than header,
        // but that does not affect intended use (which is limiting expansion)
        autocompletedCells += columnCount - columns.length;
        if (autocompletedCells > $2ef92aecf350006a$var$MAX_AUTOCOMPLETED_CELLS) break;
        if (nextLine === startLine + 2) {
            const token_tbo = state.push("tbody_open", "tbody", 1);
            token_tbo.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        const token_tro = state.push("tr_open", "tr", 1);
        token_tro.map = [
            nextLine,
            nextLine + 1
        ];
        for(let i = 0; i < columnCount; i++){
            const token_tdo = state.push("td_open", "td", 1);
            if (aligns[i]) token_tdo.attrs = [
                [
                    "style",
                    "text-align:" + aligns[i]
                ]
            ];
            const token_il = state.push("inline", "", 0);
            token_il.content = columns[i] ? columns[i].trim() : "";
            token_il.children = [];
            state.push("td_close", "td", -1);
        }
        state.push("tr_close", "tr", -1);
    }
    if (tbodyLines) {
        state.push("tbody_close", "tbody", -1);
        tbodyLines[1] = nextLine;
    }
    state.push("table_close", "table", -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
}


// Code block (4 spaces padded)
function $319716b5135e5657$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    let nextLine = startLine + 1;
    let last = nextLine;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    const token = state.push("code_block", "code", 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + "\n";
    token.map = [
        startLine,
        state.line
    ];
    return true;
}


// fences (``` lang, ~~~ lang)
function $96fff8032daf3c7b$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    const marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    let mem = pos;
    pos = state.skipChars(pos, marker);
    let len = pos - mem;
    if (len < 3) return false;
    const markup = state.src.slice(mem, pos);
    const params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    let nextLine = startLine;
    let haveEndMarker = false;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    const token = state.push("fence", "code", 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
}


// Block quotes

function $56f381d401e94dfa$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    const oldLineMax = state.lineMax;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    const oldBMarks = [];
    const oldBSCount = [];
    const oldSCount = [];
    const oldTShift = [];
    const terminatorRules = state.md.block.ruler.getRules("blockquote");
    const oldParentType = state.parentType;
    state.parentType = "blockquote";
    let lastLineEmpty = false;
    let nextLine;
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        const isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            let initial = state.sCount[nextLine] + 1;
            let spaceAfterMarker;
            let adjustTab;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            let offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                const ch = state.src.charCodeAt(pos);
                if ((0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    const oldIndent = state.blkIndent;
    state.blkIndent = 0;
    const token_o = state.push("blockquote_open", "blockquote", 1);
    token_o.markup = ">";
    const lines = [
        startLine,
        0
    ];
    token_o.map = lines;
    state.md.block.tokenize(state, startLine, nextLine);
    const token_c = state.push("blockquote_close", "blockquote", -1);
    token_c.markup = ">";
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(let i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
}


// Horizontal rule

function $bd654477b14b4267$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    const max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    let cnt = 1;
    while(pos < max){
        const ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !(0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    const token = state.push("hr", "hr", 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
}


// Lists

// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $3b7cbf7838646e8a$var$skipBulletListMarker(state, startLine) {
    const max = state.eMarks[startLine];
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        const ch = state.src.charCodeAt(pos);
        if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $3b7cbf7838646e8a$var$skipOrderedListMarker(state, startLine) {
    const start = state.bMarks[startLine] + state.tShift[startLine];
    const max = state.eMarks[startLine];
    let pos = start;
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    let ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $3b7cbf7838646e8a$var$markTightParagraphs(state, idx) {
    const level = state.level + 2;
    for(let i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === "paragraph_open") {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
function $3b7cbf7838646e8a$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let max, pos, start, token;
    let nextLine = startLine;
    let tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    let isTerminatingParagraph = false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === "paragraph") // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    let isOrdered;
    let markerValue;
    let posAfterMarker;
    if ((posAfterMarker = $3b7cbf7838646e8a$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $3b7cbf7838646e8a$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    const markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    const listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push("ordered_list_open", "ol", 1);
        if (markerValue !== 1) token.attrs = [
            [
                "start",
                markerValue
            ]
        ];
    } else token = state.push("bullet_list_open", "ul", 1);
    const listLines = [
        nextLine,
        0
    ];
    token.map = listLines;
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    let prevEmptyEnd = false;
    const terminatorRules = state.md.block.ruler.getRules("list");
    const oldParentType = state.parentType;
    state.parentType = "list";
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        const initial = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        let offset = initial;
        while(pos < max){
            const ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        const contentStart = pos;
        let indentAfterMarker;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        const indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push("list_item_open", "li", 1);
        token.markup = String.fromCharCode(markerCharCode);
        const itemLines = [
            nextLine,
            0
        ];
        token.map = itemLines;
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        const oldTight = state.tight;
        const oldTShift = state.tShift[nextLine];
        const oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        const oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push("list_item_close", "li", -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $3b7cbf7838646e8a$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $3b7cbf7838646e8a$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push("ordered_list_close", "ol", -1);
    else token = state.push("bullet_list_close", "ul", -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $3b7cbf7838646e8a$var$markTightParagraphs(state, listTokIdx);
    return true;
}



function $dc5cd5db6853c1d8$export$2e2bcd8739ae039(state, startLine, _endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    let nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    function getNextLine(nextLine) {
        const endLine = state.lineMax;
        if (nextLine >= endLine || state.isEmpty(nextLine)) // empty line or end of input
        return null;
        let isContinuation = false;
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) isContinuation = true;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) isContinuation = true;
        if (!isContinuation) {
            const terminatorRules = state.md.block.ruler.getRules("reference");
            const oldParentType = state.parentType;
            state.parentType = "reference";
            // Some tags can terminate paragraph without empty line.
            let terminate = false;
            for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
                terminate = true;
                break;
            }
            state.parentType = oldParentType;
            if (terminate) // terminated by another block
            return null;
        }
        const pos = state.bMarks[nextLine] + state.tShift[nextLine];
        const max = state.eMarks[nextLine];
        // max + 1 explicitly includes the newline
        return state.src.slice(pos, max + 1);
    }
    let str = state.src.slice(pos, max + 1);
    max = str.length;
    let labelEnd = -1;
    for(pos = 1; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) {
                const lineContent = getNextLine(nextLine);
                if (lineContent !== null) {
                    str += lineContent;
                    max = str.length;
                    nextLine++;
                }
            }
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    const destRes = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!destRes.ok) return false;
    const href = state.md.normalizeLink(destRes.str);
    if (!state.md.validateLink(href)) return false;
    pos = destRes.pos;
    // save cursor state, we could require to rollback later
    const destEndPos = pos;
    const destEndLineNo = nextLine;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    const start = pos;
    for(; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    let titleRes = state.md.helpers.parseLinkTitle(str, pos, max);
    while(titleRes.can_continue){
        const lineContent = getNextLine(nextLine);
        if (lineContent === null) break;
        str += lineContent;
        pos = max;
        max = str.length;
        nextLine++;
        titleRes = state.md.helpers.parseLinkTitle(str, pos, max, titleRes);
    }
    let title;
    if (pos < max && start !== pos && titleRes.ok) {
        title = titleRes.str;
        pos = titleRes.pos;
    } else {
        title = "";
        pos = destEndPos;
        nextLine = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        const ch = str.charCodeAt(pos);
        if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = "";
            pos = destEndPos;
            nextLine = destEndLineNo;
            while(pos < max){
                const ch = str.charCodeAt(pos);
                if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    const label = (0, $acb166200129f66e$export$20ef46802c8744b)(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /* istanbul ignore if */ if (silent) return true;
    if (typeof state.env.references === "undefined") state.env.references = {};
    if (typeof state.env.references[label] === "undefined") state.env.references[label] = {
        title: title,
        href: href
    };
    state.line = nextLine;
    return true;
}


// HTML block
// List of valid html blocks names, according to commonmark spec
// https://spec.commonmark.org/0.30/#html-blocks
var $8955e68447e3f9db$export$2e2bcd8739ae039 = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "search",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];


// Regexps to match html elements
const $08e6c33d10f51cc6$var$attr_name = "[a-zA-Z_:][a-zA-Z0-9:._-]*";
const $08e6c33d10f51cc6$var$unquoted = "[^\"'=<>`\\x00-\\x20]+";
const $08e6c33d10f51cc6$var$single_quoted = "'[^']*'";
const $08e6c33d10f51cc6$var$double_quoted = '"[^"]*"';
const $08e6c33d10f51cc6$var$attr_value = "(?:" + $08e6c33d10f51cc6$var$unquoted + "|" + $08e6c33d10f51cc6$var$single_quoted + "|" + $08e6c33d10f51cc6$var$double_quoted + ")";
const $08e6c33d10f51cc6$var$attribute = "(?:\\s+" + $08e6c33d10f51cc6$var$attr_name + "(?:\\s*=\\s*" + $08e6c33d10f51cc6$var$attr_value + ")?)";
const $08e6c33d10f51cc6$var$open_tag = "<[A-Za-z][A-Za-z0-9\\-]*" + $08e6c33d10f51cc6$var$attribute + "*\\s*\\/?>";
const $08e6c33d10f51cc6$var$close_tag = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>";
const $08e6c33d10f51cc6$var$comment = "<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->";
const $08e6c33d10f51cc6$var$processing = "<[?][\\s\\S]*?[?]>";
const $08e6c33d10f51cc6$var$declaration = "<![A-Za-z][^>]*>";
const $08e6c33d10f51cc6$var$cdata = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>";
const $08e6c33d10f51cc6$export$6db61d2c3a16e419 = new RegExp("^(?:" + $08e6c33d10f51cc6$var$open_tag + "|" + $08e6c33d10f51cc6$var$close_tag + "|" + $08e6c33d10f51cc6$var$comment + "|" + $08e6c33d10f51cc6$var$processing + "|" + $08e6c33d10f51cc6$var$declaration + "|" + $08e6c33d10f51cc6$var$cdata + ")");
const $08e6c33d10f51cc6$export$cd48660d06f74639 = new RegExp("^(?:" + $08e6c33d10f51cc6$var$open_tag + "|" + $08e6c33d10f51cc6$var$close_tag + ")");


// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
const $d9386c6e85fc1b48$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp("^</?(" + (0, $8955e68447e3f9db$export$2e2bcd8739ae039).join("|") + ")(?=(\\s|/?>|$))", "i"),
        /^$/,
        true
    ],
    [
        new RegExp((0, $08e6c33d10f51cc6$export$cd48660d06f74639).source + "\\s*$"),
        /^$/,
        false
    ]
];
function $d9386c6e85fc1b48$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    let lineText = state.src.slice(pos, max);
    let i = 0;
    for(; i < $d9386c6e85fc1b48$var$HTML_SEQUENCES.length; i++){
        if ($d9386c6e85fc1b48$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $d9386c6e85fc1b48$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $d9386c6e85fc1b48$var$HTML_SEQUENCES[i][2];
    let nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$d9386c6e85fc1b48$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($d9386c6e85fc1b48$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    const token = state.push("html_block", "", 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
}


// heading (#, ##, ...)

function $dd7f552fbefa4306$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    let level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !(0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    const tmp = state.skipCharsBack(max, 0x23, pos) // #
    ;
    if (tmp > pos && (0, $acb166200129f66e$export$1d5ccafae59b4926)(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    const token_o = state.push("heading_open", "h" + String(level), 1);
    token_o.markup = "########".slice(0, level);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push("inline", "", 0);
    token_i.content = state.src.slice(pos, max).trim();
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    const token_c = state.push("heading_close", "h" + String(level), -1);
    token_c.markup = "########".slice(0, level);
    return true;
}


// lheading (---, ===)
function $acb81d8044351f9f$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    const terminatorRules = state.md.block.ruler.getRules("paragraph");
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    const oldParentType = state.parentType;
    state.parentType = "paragraph" // use paragraph to match terminatorRules
    ;
    // jump line-by-line until empty one or EOF
    let level = 0;
    let marker;
    let nextLine = startLine + 1;
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            let pos = state.bMarks[nextLine] + state.tShift[nextLine];
            const max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    const token_o = state.push("heading_open", "h" + String(level), 1);
    token_o.markup = String.fromCharCode(marker);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push("inline", "", 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line - 1
    ];
    token_i.children = [];
    const token_c = state.push("heading_close", "h" + String(level), -1);
    token_c.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
}


// Paragraph
function $d374391f851a68ad$export$2e2bcd8739ae039(state, startLine, endLine) {
    const terminatorRules = state.md.block.ruler.getRules("paragraph");
    const oldParentType = state.parentType;
    let nextLine = startLine + 1;
    state.parentType = "paragraph";
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    const token_o = state.push("paragraph_open", "p", 1);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push("inline", "", 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    state.push("paragraph_close", "p", -1);
    state.parentType = oldParentType;
    return true;
}


const $3349c57a2e9a47a9$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        "table",
        (0, $2ef92aecf350006a$export$2e2bcd8739ae039),
        [
            "paragraph",
            "reference"
        ]
    ],
    [
        "code",
        (0, $319716b5135e5657$export$2e2bcd8739ae039)
    ],
    [
        "fence",
        (0, $96fff8032daf3c7b$export$2e2bcd8739ae039),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "blockquote",
        (0, $56f381d401e94dfa$export$2e2bcd8739ae039),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "hr",
        (0, $bd654477b14b4267$export$2e2bcd8739ae039),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "list",
        (0, $3b7cbf7838646e8a$export$2e2bcd8739ae039),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "reference",
        (0, $dc5cd5db6853c1d8$export$2e2bcd8739ae039)
    ],
    [
        "html_block",
        (0, $d9386c6e85fc1b48$export$2e2bcd8739ae039),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "heading",
        (0, $dd7f552fbefa4306$export$2e2bcd8739ae039),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "lheading",
        (0, $acb81d8044351f9f$export$2e2bcd8739ae039)
    ],
    [
        "paragraph",
        (0, $d374391f851a68ad$export$2e2bcd8739ae039)
    ]
];
/**
 * new ParserBlock()
 **/ function $3349c57a2e9a47a9$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new (0, $41ea3ea6c70806b8$export$2e2bcd8739ae039)();
    for(let i = 0; i < $3349c57a2e9a47a9$var$_rules.length; i++)this.ruler.push($3349c57a2e9a47a9$var$_rules[i][0], $3349c57a2e9a47a9$var$_rules[i][1], {
        alt: ($3349c57a2e9a47a9$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$3349c57a2e9a47a9$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    const rules = this.ruler.getRules("");
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    let line = startLine;
    let hasEmptyLines = false;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        const prevLine = state.line;
        let ok = false;
        for(let i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error("none of the block rules matched");
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $3349c57a2e9a47a9$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    if (!src) return;
    const state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};
$3349c57a2e9a47a9$var$ParserBlock.prototype.State = (0, $ad2420667aa7c8e8$export$2e2bcd8739ae039);
var $3349c57a2e9a47a9$export$2e2bcd8739ae039 = $3349c57a2e9a47a9$var$ParserBlock;


/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 
// Inline parser state


function $78766ebe20d230e1$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = "";
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$78766ebe20d230e1$var$StateInline.prototype.pushPending = function() {
    const token = new (0, $59ac17e6d91b036a$export$2e2bcd8739ae039)("text", "", 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = "";
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$78766ebe20d230e1$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    const token = new (0, $59ac17e6d91b036a$export$2e2bcd8739ae039)(type, tag, nesting);
    let token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$78766ebe20d230e1$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    const max = this.posMax;
    const marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    const lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    let pos = start;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    const count = pos - start;
    // treat end of the line as a whitespace
    const nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    const isLastPunctChar = (0, $acb166200129f66e$export$829a0d33ae4e744)(lastChar) || (0, $acb166200129f66e$export$4888a643af800fc1)(String.fromCharCode(lastChar));
    const isNextPunctChar = (0, $acb166200129f66e$export$829a0d33ae4e744)(nextChar) || (0, $acb166200129f66e$export$4888a643af800fc1)(String.fromCharCode(nextChar));
    const isLastWhiteSpace = (0, $acb166200129f66e$export$3c52dd84024ae72c)(lastChar);
    const isNextWhiteSpace = (0, $acb166200129f66e$export$3c52dd84024ae72c)(nextChar);
    const left_flanking = !isNextWhiteSpace && (!isNextPunctChar || isLastWhiteSpace || isLastPunctChar);
    const right_flanking = !isLastWhiteSpace && (!isLastPunctChar || isNextWhiteSpace || isNextPunctChar);
    const can_open = left_flanking && (canSplitWord || !right_flanking || isLastPunctChar);
    const can_close = right_flanking && (canSplitWord || !left_flanking || isNextPunctChar);
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$78766ebe20d230e1$var$StateInline.prototype.Token = (0, $59ac17e6d91b036a$export$2e2bcd8739ae039);
var $78766ebe20d230e1$export$2e2bcd8739ae039 = $78766ebe20d230e1$var$StateInline;


// Skip text characters for text token, place those to pending buffer
// and increment current pos
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $52dad52dbdb68874$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
function $52dad52dbdb68874$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    while(pos < state.posMax && !$52dad52dbdb68874$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
} // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParserInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
}; */ 


// Process links like https://example.org/
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
const $d922190b2670a68c$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function $d922190b2670a68c$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    const pos = state.pos;
    const max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    const match = state.pending.match($d922190b2670a68c$var$SCHEME_RE);
    if (!match) return false;
    const proto = match[1];
    const link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    let url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, "");
    const fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        const token_o = state.push("link_open", "a", 1);
        token_o.attrs = [
            [
                "href",
                fullUrl
            ]
        ];
        token_o.markup = "linkify";
        token_o.info = "auto";
        const token_t = state.push("text", "", 0);
        token_t.content = state.md.normalizeLinkText(url);
        const token_c = state.push("link_close", "a", -1);
        token_c.markup = "linkify";
        token_c.info = "auto";
    }
    state.pos += url.length - proto.length;
    return true;
}


// Proceess '\n'

function $4da0439b0e5b89ea$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    const max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                let ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push("hardbreak", "br", 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push("softbreak", "br", 0);
            }
        } else state.push("softbreak", "br", 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && (0, $acb166200129f66e$export$1d5ccafae59b4926)(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
}


// Process escaped chars and hardbreaks

const $b91dce80827c08a1$var$ESCAPED = [];
for(let i = 0; i < 256; i++)$b91dce80827c08a1$var$ESCAPED.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(ch) {
    $b91dce80827c08a1$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
function $b91dce80827c08a1$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    let ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push("hardbreak", "br", 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    let escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        const ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    const origStr = "\\" + escapedStr;
    if (!silent) {
        const token = state.push("text_special", "", 0);
        if (ch1 < 256 && $b91dce80827c08a1$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = "escape";
    }
    state.pos = pos + 1;
    return true;
}


// Parse backticks
function $b39c44d4094d07d3$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    const start = pos;
    pos++;
    const max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    const marker = state.src.slice(start, pos);
    const openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    let matchEnd = pos;
    let matchStart;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf("`", matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        const closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                const token = state.push("code_inline", "code", 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
}


// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $c4e44d3b61071958$var$strikethrough_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    const scanned = state.scanDelims(state.pos, true);
    let len = scanned.length;
    const ch = String.fromCharCode(marker);
    if (len < 2) return false;
    let token;
    if (len % 2) {
        token = state.push("text", "", 0);
        token.content = ch;
        len--;
    }
    for(let i = 0; i < len; i += 2){
        token = state.push("text", "", 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $c4e44d3b61071958$var$postProcess(state, delimiters) {
    let token;
    const loneMarkers = [];
    const max = delimiters.length;
    for(let i = 0; i < max; i++){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = "s_open";
        token.tag = "s";
        token.nesting = 1;
        token.markup = "~~";
        token.content = "";
        token = state.tokens[endDelim.token];
        token.type = "s_close";
        token.tag = "s";
        token.nesting = -1;
        token.markup = "~~";
        token.content = "";
        if (state.tokens[endDelim.token - 1].type === "text" && state.tokens[endDelim.token - 1].content === "~") loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        const i = loneMarkers.pop();
        let j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === "s_close")j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $c4e44d3b61071958$var$strikethrough_postProcess(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $c4e44d3b61071958$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $c4e44d3b61071958$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $c4e44d3b61071958$export$2e2bcd8739ae039 = {
    tokenize: $c4e44d3b61071958$var$strikethrough_tokenize,
    postProcess: $c4e44d3b61071958$var$strikethrough_postProcess
};


// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $354922e1ef651ea3$var$emphasis_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    const scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(let i = 0; i < scanned.length; i++){
        const token = state.push("text", "", 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            marker: // Char code of the starting marker (number).
            //
            marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $354922e1ef651ea3$var$postProcess(state, delimiters) {
    const max = delimiters.length;
    for(let i = max - 1; i >= 0; i--){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        const isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        const ch = String.fromCharCode(startDelim.marker);
        const token_o = state.tokens[startDelim.token];
        token_o.type = isStrong ? "strong_open" : "em_open";
        token_o.tag = isStrong ? "strong" : "em";
        token_o.nesting = 1;
        token_o.markup = isStrong ? ch + ch : ch;
        token_o.content = "";
        const token_c = state.tokens[endDelim.token];
        token_c.type = isStrong ? "strong_close" : "em_close";
        token_c.tag = isStrong ? "strong" : "em";
        token_c.nesting = -1;
        token_c.markup = isStrong ? ch + ch : ch;
        token_c.content = "";
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = "";
            state.tokens[delimiters[startDelim.end + 1].token].content = "";
            i--;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $354922e1ef651ea3$var$emphasis_post_process(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $354922e1ef651ea3$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $354922e1ef651ea3$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $354922e1ef651ea3$export$2e2bcd8739ae039 = {
    tokenize: $354922e1ef651ea3$var$emphasis_tokenize,
    postProcess: $354922e1ef651ea3$var$emphasis_post_process
};


// Process [link](<to> "stuff")

function $019ddf5760813e0c$export$2e2bcd8739ae039(state, silent) {
    let code, label, res, ref;
    let href = "";
    let title = "";
    let start = state.pos;
    let parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    const oldPos = state.pos;
    const max = state.posMax;
    const labelStart = state.pos + 1;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    let pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = "";
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === "undefined") return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $acb166200129f66e$export$20ef46802c8744b)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        const token_o = state.push("link_open", "a", 1);
        const attrs = [
            [
                "href",
                href
            ]
        ];
        token_o.attrs = attrs;
        if (title) attrs.push([
            "title",
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        state.push("link_close", "a", -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}


// Process ![image](<src> "title")

function $f2e767ae90fa58fa$export$2e2bcd8739ae039(state, silent) {
    let code, content, label, pos, ref, res, title, start;
    let href = "";
    const oldPos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    const labelStart = state.pos + 2;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = "";
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(code) && code !== 0x0A) break;
            }
        } else title = "";
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === "undefined") return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $acb166200129f66e$export$20ef46802c8744b)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        const tokens = [];
        state.md.inline.parse(content, state.md, state.env, tokens);
        const token = state.push("image", "img", 0);
        const attrs = [
            [
                "src",
                href
            ],
            [
                "alt",
                ""
            ]
        ];
        token.attrs = attrs;
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            "title",
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}


// Process autolinks '<protocol:...>'
/* eslint max-len:0 */ const $38fe1de13dbca06b$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
/* eslint-disable-next-line no-control-regex */ const $38fe1de13dbca06b$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function $38fe1de13dbca06b$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    const start = state.pos;
    const max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        const ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    const url = state.src.slice(start + 1, pos);
    if ($38fe1de13dbca06b$var$AUTOLINK_RE.test(url)) {
        const fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push("link_open", "a", 1);
            token_o.attrs = [
                [
                    "href",
                    fullUrl
                ]
            ];
            token_o.markup = "autolink";
            token_o.info = "auto";
            const token_t = state.push("text", "", 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push("link_close", "a", -1);
            token_c.markup = "autolink";
            token_c.info = "auto";
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($38fe1de13dbca06b$var$EMAIL_RE.test(url)) {
        const fullUrl = state.md.normalizeLink("mailto:" + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push("link_open", "a", 1);
            token_o.attrs = [
                [
                    "href",
                    fullUrl
                ]
            ];
            token_o.markup = "autolink";
            token_o.info = "auto";
            const token_t = state.push("text", "", 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push("link_close", "a", -1);
            token_c.markup = "autolink";
            token_c.info = "auto";
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
}


// Process html tags

function $c398d6df9e0474f7$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $c398d6df9e0474f7$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $c398d6df9e0474f7$var$isLetter(ch) {
    /* eslint no-bitwise:0 */ const lc = ch | 0x20 // to lower case
    ;
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
function $c398d6df9e0474f7$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.html) return false;
    // Check start
    const max = state.posMax;
    const pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    const ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$c398d6df9e0474f7$var$isLetter(ch)) return false;
    const match = state.src.slice(pos).match((0, $08e6c33d10f51cc6$export$6db61d2c3a16e419));
    if (!match) return false;
    if (!silent) {
        const token = state.push("html_inline", "", 0);
        token.content = match[0];
        if ($c398d6df9e0474f7$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($c398d6df9e0474f7$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
}


// Process html entity - &#123;, &#xAF;, &quot;, ...


const $2605af2f776ac07c$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
const $2605af2f776ac07c$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
function $2605af2f776ac07c$export$2e2bcd8739ae039(state, silent) {
    const pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    const ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        const match = state.src.slice(pos).match($2605af2f776ac07c$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                const code = match[1][0].toLowerCase() === "x" ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                const token = state.push("text_special", "", 0);
                token.content = (0, $acb166200129f66e$export$644a8f5b13b2a36d)(code) ? (0, $acb166200129f66e$export$73bfc63873071f74)(code) : (0, $acb166200129f66e$export$73bfc63873071f74)(0xFFFD);
                token.markup = match[0];
                token.info = "entity";
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        const match = state.src.slice(pos).match($2605af2f776ac07c$var$NAMED_RE);
        if (match) {
            const decoded = (0, $21b54aeefac41b63$export$f045cb747ce77a19)(match[0]);
            if (decoded !== match[0]) {
                if (!silent) {
                    const token = state.push("text_special", "", 0);
                    token.content = decoded;
                    token.markup = match[0];
                    token.info = "entity";
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
}


// For each opening emphasis-like marker find a matching closing one
//
function $86b620d722e5f8d3$var$processDelimiters(delimiters) {
    const openersBottom = {};
    const max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    let headerIdx = 0;
    let lastTokenIdx = -2 // needs any value lower than -1
    ;
    const jumps = [];
    for(let closerIdx = 0; closerIdx < max; closerIdx++){
        const closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        /* eslint-disable-next-line no-prototype-builtins */ if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        const minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        let openerIdx = headerIdx - jumps[headerIdx] - 1;
        let newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            const opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                let isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    const lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
function $86b620d722e5f8d3$export$2e2bcd8739ae039(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $86b620d722e5f8d3$var$processDelimiters(state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $86b620d722e5f8d3$var$processDelimiters(tokens_meta[curr].delimiters);
}


// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
function $657f3da74a75df34$export$2e2bcd8739ae039(state) {
    let curr, last;
    let level = 0;
    const tokens = state.tokens;
    const max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level-- // closing tag
        ;
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++ // opening tag
        ;
        if (tokens[curr].type === "text" && curr + 1 < max && tokens[curr + 1].type === "text") // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
}


// Parser rules
const $086c870d02d0d269$var$_rules = [
    [
        "text",
        (0, $52dad52dbdb68874$export$2e2bcd8739ae039)
    ],
    [
        "linkify",
        (0, $d922190b2670a68c$export$2e2bcd8739ae039)
    ],
    [
        "newline",
        (0, $4da0439b0e5b89ea$export$2e2bcd8739ae039)
    ],
    [
        "escape",
        (0, $b91dce80827c08a1$export$2e2bcd8739ae039)
    ],
    [
        "backticks",
        (0, $b39c44d4094d07d3$export$2e2bcd8739ae039)
    ],
    [
        "strikethrough",
        (0, $c4e44d3b61071958$export$2e2bcd8739ae039).tokenize
    ],
    [
        "emphasis",
        (0, $354922e1ef651ea3$export$2e2bcd8739ae039).tokenize
    ],
    [
        "link",
        (0, $019ddf5760813e0c$export$2e2bcd8739ae039)
    ],
    [
        "image",
        (0, $f2e767ae90fa58fa$export$2e2bcd8739ae039)
    ],
    [
        "autolink",
        (0, $38fe1de13dbca06b$export$2e2bcd8739ae039)
    ],
    [
        "html_inline",
        (0, $c398d6df9e0474f7$export$2e2bcd8739ae039)
    ],
    [
        "entity",
        (0, $2605af2f776ac07c$export$2e2bcd8739ae039)
    ]
];
// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
const $086c870d02d0d269$var$_rules2 = [
    [
        "balance_pairs",
        (0, $86b620d722e5f8d3$export$2e2bcd8739ae039)
    ],
    [
        "strikethrough",
        (0, $c4e44d3b61071958$export$2e2bcd8739ae039).postProcess
    ],
    [
        "emphasis",
        (0, $354922e1ef651ea3$export$2e2bcd8739ae039).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        "fragments_join",
        (0, $657f3da74a75df34$export$2e2bcd8739ae039)
    ]
];
/**
 * new ParserInline()
 **/ function $086c870d02d0d269$var$ParserInline() {
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new (0, $41ea3ea6c70806b8$export$2e2bcd8739ae039)();
    for(let i = 0; i < $086c870d02d0d269$var$_rules.length; i++)this.ruler.push($086c870d02d0d269$var$_rules[i][0], $086c870d02d0d269$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new (0, $41ea3ea6c70806b8$export$2e2bcd8739ae039)();
    for(let i = 0; i < $086c870d02d0d269$var$_rules2.length; i++)this.ruler2.push($086c870d02d0d269$var$_rules2[i][0], $086c870d02d0d269$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$086c870d02d0d269$var$ParserInline.prototype.skipToken = function(state) {
    const pos = state.pos;
    const rules = this.ruler.getRules("");
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    const cache = state.cache;
    if (typeof cache[pos] !== "undefined") {
        state.pos = cache[pos];
        return;
    }
    let ok = false;
    if (state.level < maxNesting) for(let i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$086c870d02d0d269$var$ParserInline.prototype.tokenize = function(state) {
    const rules = this.ruler.getRules("");
    const len = rules.length;
    const end = state.posMax;
    const maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        const prevPos = state.pos;
        let ok = false;
        if (state.level < maxNesting) for(let i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $086c870d02d0d269$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    const state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    const rules = this.ruler2.getRules("");
    const len = rules.length;
    for(let i = 0; i < len; i++)rules[i](state);
};
$086c870d02d0d269$var$ParserInline.prototype.State = (0, $78766ebe20d230e1$export$2e2bcd8739ae039);
var $086c870d02d0d269$export$2e2bcd8739ae039 = $086c870d02d0d269$var$ParserInline;



function $8395954499c294bc$export$2e2bcd8739ae039(opts) {
    const re = {};
    opts = opts || {};
    re.src_Any = (0, $cbc832af4f488565$export$2e2bcd8739ae039).source;
    re.src_Cc = (0, $c23f5f283a1bf321$export$2e2bcd8739ae039).source;
    re.src_Z = (0, $df20dc3bfc54166a$export$2e2bcd8739ae039).source;
    re.src_P = (0, $e24366eb89af439c$export$2e2bcd8739ae039).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join("|");
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join("|");
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    const text_separators = "[><\uFF5C]";
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = "(?:(?!" + text_separators + "|" + re.src_ZPCc + ")" + re.src_Any + ")";
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    re.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = "(?:(?:(?!" + re.src_ZCc + "|[@/\\[\\]()]).)+@)?";
    re.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?";
    re.src_host_terminator = "(?=$|" + text_separators + "|" + re.src_ZPCc + ")" + "(?!" + (opts["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + re.src_ZPCc + "))";
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + "|" + text_separators + "|[()[\\]{}.,\"'?!\\-;]).|" + "\\[(?:(?!" + re.src_ZCc + "|\\]).)*\\]|" + "\\((?:(?!" + re.src_ZCc + "|[)]).)*\\)|" + "\\{(?:(?!" + re.src_ZCc + "|[}]).)*\\}|" + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + // allow `I'm_king` if no pair found
    "\\'(?=" + re.src_pseudo_letter + "|[-])|" + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    "\\.{2,}[a-zA-Z0-9%/&]|" + "\\.(?!" + re.src_ZCc + "|[.]|$)|" + (opts["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" // `---` => long dash, terminate
     : "\\-+|") + // allow `,,,` in paths
    ",(?!" + re.src_ZCc + "|$)|" + // allow `;` if not followed by space-like char
    ";(?!" + re.src_ZCc + "|$)|" + // allow `!!!` in paths, but not at the end
    "\\!+(?!" + re.src_ZCc + "|[!]|$)|" + "\\?(?!" + re.src_ZCc + "|[?]|$)" + ")+" + "|\\/" + ")?";
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = "xn--[a-z0-9\\-]{1,59}";
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    "(?:" + re.src_xn + "|" + re.src_pseudo_letter + "{1,63}" + ")";
    re.src_domain = "(?:" + re.src_xn + "|" + "(?:" + re.src_pseudo_letter + ")" + "|" + "(?:" + re.src_pseudo_letter + "(?:-|" + re.src_pseudo_letter + "){0,61}" + re.src_pseudo_letter + ")" + ")";
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ")\\.)*" + re.src_domain /* _root */  + ")" + ")";
    re.tpl_host_fuzzy = "(?:" + re.src_ip4 + "|" + "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))" + ")";
    re.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))";
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    //
    // Main rules
    //
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + re.src_ZPCc + "|>|$))";
    re.tpl_email_fuzzy = "(^|" + text_separators + '|"|\\(|' + re.src_ZCc + ")" + "(" + re.src_email_name + "@" + re.tpl_host_fuzzy_strict + ")";
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_fuzzy_strict + re.src_path + ")";
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ")";
    return re;
}


//
// Helpers
//
// Merge objects
//
function $fdfb0b45a2ba540e$var$assign(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $fdfb0b45a2ba540e$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $fdfb0b45a2ba540e$var$isString(obj) {
    return $fdfb0b45a2ba540e$var$_class(obj) === "[object String]";
}
function $fdfb0b45a2ba540e$var$isObject(obj) {
    return $fdfb0b45a2ba540e$var$_class(obj) === "[object Object]";
}
function $fdfb0b45a2ba540e$var$isRegExp(obj) {
    return $fdfb0b45a2ba540e$var$_class(obj) === "[object RegExp]";
}
function $fdfb0b45a2ba540e$var$isFunction(obj) {
    return $fdfb0b45a2ba540e$var$_class(obj) === "[object Function]";
}
function $fdfb0b45a2ba540e$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
//
const $fdfb0b45a2ba540e$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $fdfb0b45a2ba540e$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        /* eslint-disable-next-line no-prototype-builtins */ return acc || $fdfb0b45a2ba540e$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
const $fdfb0b45a2ba540e$var$defaultSchemas = {
    "http:": {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp("^\\/\\/" + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, "i");
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    "https:": "http:",
    "ftp:": "http:",
    "//": {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp("^" + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            "(?:localhost|(?:(?:" + self.re.src_domain + ")\\.)+" + self.re.src_domain_root + ")" + self.re.src_port + self.re.src_host_terminator + self.re.src_path, "i");
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ":") return 0;
                if (pos >= 3 && text[pos - 3] === "/") return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    "mailto:": {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp("^" + self.re.src_email_name + "@" + self.re.src_host_strict, "i");
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
/* eslint-disable-next-line max-len */ const $fdfb0b45a2ba540e$var$tlds_2ch_src_re = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]";
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
const $fdfb0b45a2ba540e$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split("|");
function $fdfb0b45a2ba540e$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = "";
}
function $fdfb0b45a2ba540e$var$createValidator(re) {
    return function(text, pos) {
        const tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $fdfb0b45a2ba540e$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}
// Schemas compiler. Build regexps.
//
function $fdfb0b45a2ba540e$var$compile(self) {
    // Load & clone RE patterns.
    const re = self.re = (0, $8395954499c294bc$export$2e2bcd8739ae039)(self.__opts__);
    // Define dynamic patterns
    const tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($fdfb0b45a2ba540e$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join("|");
    function untpl(tpl) {
        return tpl.replace("%TLDS%", re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), "i");
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), "i");
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), "i");
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), "i");
    //
    // Compile each schema
    //
    const aliases = [];
    self.__compiled__ = {} // Reset compiled data
    ;
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        const val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        const compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($fdfb0b45a2ba540e$var$isObject(val)) {
            if ($fdfb0b45a2ba540e$var$isRegExp(val.validate)) compiled.validate = $fdfb0b45a2ba540e$var$createValidator(val.validate);
            else if ($fdfb0b45a2ba540e$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($fdfb0b45a2ba540e$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $fdfb0b45a2ba540e$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($fdfb0b45a2ba540e$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[""] = {
        validate: null,
        normalize: $fdfb0b45a2ba540e$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    const slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($fdfb0b45a2ba540e$var$escapeRE).join("|");
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "i");
    self.re.schema_search = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "ig");
    self.re.schema_at_start = RegExp("^" + self.re.schema_search.source, "i");
    self.re.pretest = RegExp("(" + self.re.schema_test.source + ")|(" + self.re.host_fuzzy_test.source + ")|@", "i");
    //
    // Cleanup
    //
    $fdfb0b45a2ba540e$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $fdfb0b45a2ba540e$var$Match(self, shift) {
    const start = self.__index__;
    const end = self.__last_index__;
    const text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $fdfb0b45a2ba540e$var$createMatch(self, shift) {
    const match = new $fdfb0b45a2ba540e$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $fdfb0b45a2ba540e$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $fdfb0b45a2ba540e$var$LinkifyIt)) return new $fdfb0b45a2ba540e$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($fdfb0b45a2ba540e$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $fdfb0b45a2ba540e$var$assign({}, $fdfb0b45a2ba540e$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1 // Next scan position
    ;
    this.__schema__ = "";
    this.__text_cache__ = "";
    this.__schemas__ = $fdfb0b45a2ba540e$var$assign({}, $fdfb0b45a2ba540e$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $fdfb0b45a2ba540e$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $fdfb0b45a2ba540e$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $fdfb0b45a2ba540e$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $fdfb0b45a2ba540e$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    let m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__["http:"]) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = "";
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__["mailto:"]) {
        // guess schemaless emails
        at_pos = text.indexOf("@");
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = "mailto:";
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.match = function match(text) {
    const result = [];
    let shift = 0;
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($fdfb0b45a2ba540e$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    let tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($fdfb0b45a2ba540e$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    const m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    const len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $fdfb0b45a2ba540e$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $fdfb0b45a2ba540e$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $fdfb0b45a2ba540e$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = "http://" + match.url;
    if (match.schema === "mailto:" && !/^mailto:/i.test(match.url)) match.url = "mailto:" + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.onCompile = function onCompile() {};
var $fdfb0b45a2ba540e$export$2e2bcd8739ae039 = $fdfb0b45a2ba540e$var$LinkifyIt;



"use strict";
/** Highest positive signed 32-bit float value */ const $cc1c99c5745bccf3$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $cc1c99c5745bccf3$var$base = 36;
const $cc1c99c5745bccf3$var$tMin = 1;
const $cc1c99c5745bccf3$var$tMax = 26;
const $cc1c99c5745bccf3$var$skew = 38;
const $cc1c99c5745bccf3$var$damp = 700;
const $cc1c99c5745bccf3$var$initialBias = 72;
const $cc1c99c5745bccf3$var$initialN = 128; // 0x80
const $cc1c99c5745bccf3$var$delimiter = "-"; // '\x2D'
/** Regular expressions */ const $cc1c99c5745bccf3$var$regexPunycode = /^xn--/;
const $cc1c99c5745bccf3$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $cc1c99c5745bccf3$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $cc1c99c5745bccf3$var$errors = {
    "overflow": "Overflow: input needs wider integers to process",
    "not-basic": "Illegal input >= 0x80 (not a basic code point)",
    "invalid-input": "Invalid input"
};
/** Convenience shortcuts */ const $cc1c99c5745bccf3$var$baseMinusTMin = $cc1c99c5745bccf3$var$base - $cc1c99c5745bccf3$var$tMin;
const $cc1c99c5745bccf3$var$floor = Math.floor;
const $cc1c99c5745bccf3$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $cc1c99c5745bccf3$var$error(type) {
    throw new RangeError($cc1c99c5745bccf3$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $cc1c99c5745bccf3$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $cc1c99c5745bccf3$var$mapDomain(domain, callback) {
    const parts = domain.split("@");
    let result = "";
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + "@";
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($cc1c99c5745bccf3$var$regexSeparators, ".");
    const labels = domain.split(".");
    const encoded = $cc1c99c5745bccf3$var$map(labels, callback).join(".");
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $cc1c99c5745bccf3$export$c1700176c90f250f(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $cc1c99c5745bccf3$export$f999239d9b149395 = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $cc1c99c5745bccf3$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $cc1c99c5745bccf3$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $cc1c99c5745bccf3$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $cc1c99c5745bccf3$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $cc1c99c5745bccf3$var$floor(delta / $cc1c99c5745bccf3$var$damp) : delta >> 1;
    delta += $cc1c99c5745bccf3$var$floor(delta / numPoints);
    for(; delta > $cc1c99c5745bccf3$var$baseMinusTMin * $cc1c99c5745bccf3$var$tMax >> 1; k += $cc1c99c5745bccf3$var$base)delta = $cc1c99c5745bccf3$var$floor(delta / $cc1c99c5745bccf3$var$baseMinusTMin);
    return $cc1c99c5745bccf3$var$floor(k + ($cc1c99c5745bccf3$var$baseMinusTMin + 1) * delta / (delta + $cc1c99c5745bccf3$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $cc1c99c5745bccf3$export$2f872c0f2117be69 = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $cc1c99c5745bccf3$var$initialN;
    let bias = $cc1c99c5745bccf3$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($cc1c99c5745bccf3$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $cc1c99c5745bccf3$var$error("not-basic");
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $cc1c99c5745bccf3$var$base;; k += $cc1c99c5745bccf3$var$base){
            if (index >= inputLength) $cc1c99c5745bccf3$var$error("invalid-input");
            const digit = $cc1c99c5745bccf3$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $cc1c99c5745bccf3$var$base) $cc1c99c5745bccf3$var$error("invalid-input");
            if (digit > $cc1c99c5745bccf3$var$floor(($cc1c99c5745bccf3$var$maxInt - i) / w)) $cc1c99c5745bccf3$var$error("overflow");
            i += digit * w;
            const t = k <= bias ? $cc1c99c5745bccf3$var$tMin : k >= bias + $cc1c99c5745bccf3$var$tMax ? $cc1c99c5745bccf3$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $cc1c99c5745bccf3$var$base - t;
            if (w > $cc1c99c5745bccf3$var$floor($cc1c99c5745bccf3$var$maxInt / baseMinusT)) $cc1c99c5745bccf3$var$error("overflow");
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $cc1c99c5745bccf3$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($cc1c99c5745bccf3$var$floor(i / out) > $cc1c99c5745bccf3$var$maxInt - n) $cc1c99c5745bccf3$var$error("overflow");
        n += $cc1c99c5745bccf3$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $cc1c99c5745bccf3$export$c564cdbbe6da493 = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $cc1c99c5745bccf3$export$c1700176c90f250f(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $cc1c99c5745bccf3$var$initialN;
    let delta = 0;
    let bias = $cc1c99c5745bccf3$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($cc1c99c5745bccf3$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($cc1c99c5745bccf3$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $cc1c99c5745bccf3$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $cc1c99c5745bccf3$var$floor(($cc1c99c5745bccf3$var$maxInt - delta) / handledCPCountPlusOne)) $cc1c99c5745bccf3$var$error("overflow");
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $cc1c99c5745bccf3$var$maxInt) $cc1c99c5745bccf3$var$error("overflow");
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $cc1c99c5745bccf3$var$base;; k += $cc1c99c5745bccf3$var$base){
                    const t = k <= bias ? $cc1c99c5745bccf3$var$tMin : k >= bias + $cc1c99c5745bccf3$var$tMax ? $cc1c99c5745bccf3$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $cc1c99c5745bccf3$var$base - t;
                    output.push($cc1c99c5745bccf3$var$stringFromCharCode($cc1c99c5745bccf3$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $cc1c99c5745bccf3$var$floor(qMinusT / baseMinusT);
                }
                output.push($cc1c99c5745bccf3$var$stringFromCharCode($cc1c99c5745bccf3$var$digitToBasic(q, 0)));
                bias = $cc1c99c5745bccf3$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join("");
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $cc1c99c5745bccf3$export$110c810e8727e62b = function(input) {
    return $cc1c99c5745bccf3$var$mapDomain(input, function(string) {
        return $cc1c99c5745bccf3$var$regexPunycode.test(string) ? $cc1c99c5745bccf3$export$2f872c0f2117be69(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $cc1c99c5745bccf3$export$69111c4ea6e0c4a0 = function(input) {
    return $cc1c99c5745bccf3$var$mapDomain(input, function(string) {
        return $cc1c99c5745bccf3$var$regexNonASCII.test(string) ? "xn--" + $cc1c99c5745bccf3$export$c564cdbbe6da493(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $cc1c99c5745bccf3$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ "version": "2.3.1",
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ "ucs2": {
        "decode": $cc1c99c5745bccf3$export$c1700176c90f250f,
        "encode": $cc1c99c5745bccf3$export$f999239d9b149395
    },
    "decode": $cc1c99c5745bccf3$export$2f872c0f2117be69,
    "encode": $cc1c99c5745bccf3$export$c564cdbbe6da493,
    "toASCII": $cc1c99c5745bccf3$export$69111c4ea6e0c4a0,
    "toUnicode": $cc1c99c5745bccf3$export$110c810e8727e62b
};
var $cc1c99c5745bccf3$export$2e2bcd8739ae039 = $cc1c99c5745bccf3$var$punycode;


// markdown-it default options
var $3fe4a7f778f0f36e$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: "language-",
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 100
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};


// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
var $d8eecf2af6991231$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: "language-",
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline",
                "text_join"
            ]
        },
        block: {
            rules: [
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "text"
            ],
            rules2: [
                "balance_pairs",
                "fragments_join"
            ]
        }
    }
};


// Commonmark default options
var $b06235d334be6c3f$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: true,
        // Use '/' to close single tags (<br />)
        xhtmlOut: true,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: "language-",
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline",
                "text_join"
            ]
        },
        block: {
            rules: [
                "blockquote",
                "code",
                "fence",
                "heading",
                "hr",
                "html_block",
                "lheading",
                "list",
                "reference",
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "autolink",
                "backticks",
                "emphasis",
                "entity",
                "escape",
                "html_inline",
                "image",
                "link",
                "newline",
                "text"
            ],
            rules2: [
                "balance_pairs",
                "emphasis",
                "fragments_join"
            ]
        }
    }
};


const $0d15360f132ce1e2$var$config = {
    default: (0, $3fe4a7f778f0f36e$export$2e2bcd8739ae039),
    zero: (0, $d8eecf2af6991231$export$2e2bcd8739ae039),
    commonmark: (0, $b06235d334be6c3f$export$2e2bcd8739ae039)
};
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
const $0d15360f132ce1e2$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
const $0d15360f132ce1e2$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $0d15360f132ce1e2$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    const str = url.trim().toLowerCase();
    return $0d15360f132ce1e2$var$BAD_PROTO_RE.test(str) ? $0d15360f132ce1e2$var$GOOD_DATA_RE.test(str) : true;
}
const $0d15360f132ce1e2$var$RECODE_HOSTNAME_FOR = [
    "http:",
    "https:",
    "mailto:"
];
function $0d15360f132ce1e2$var$normalizeLink(url) {
    const parsed = $544ec39afc7ce01f$export$2e2bcd8739ae039(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $0d15360f132ce1e2$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $cc1c99c5745bccf3$export$2e2bcd8739ae039).toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $a16db32880174ee4$export$2e2bcd8739ae039($555640cbd60e2fdc$export$2e2bcd8739ae039(parsed));
}
function $0d15360f132ce1e2$var$normalizeLinkText(url) {
    const parsed = $544ec39afc7ce01f$export$2e2bcd8739ae039(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $0d15360f132ce1e2$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $cc1c99c5745bccf3$export$2e2bcd8739ae039).toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $0d34e69e6f2a0359$export$2e2bcd8739ae039($555640cbd60e2fdc$export$2e2bcd8739ae039(parsed), $0d34e69e6f2a0359$export$2e2bcd8739ae039.defaultChars + "%");
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.mjs) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.mjs) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.mjs) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.mjs) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>` or `<code>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre><code class="hljs">' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre><code class="hljs">' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $0d15360f132ce1e2$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $0d15360f132ce1e2$var$MarkdownIt)) return new $0d15360f132ce1e2$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$acb166200129f66e$exports.isString(presetName)) {
            options = presetName || {};
            presetName = "default";
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new (0, $086c870d02d0d269$export$2e2bcd8739ae039)();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new (0, $3349c57a2e9a47a9$export$2e2bcd8739ae039)();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new (0, $1dbd8732bf2ea1e5$export$2e2bcd8739ae039)();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs).
   **/ this.renderer = new (0, $1aad198f750e42d7$export$2e2bcd8739ae039)();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.mjs)
   * rule.
   **/ this.linkify = new (0, $fdfb0b45a2ba540e$export$2e2bcd8739ae039)();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $0d15360f132ce1e2$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $0d15360f132ce1e2$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $0d15360f132ce1e2$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.mjs).
   **/ this.utils = $acb166200129f66e$exports;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $acb166200129f66e$exports.assign({}, $99119f957fdc25f6$exports);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.set = function(options) {
    $acb166200129f66e$exports.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.configure = function(presets) {
    const self = this;
    if ($acb166200129f66e$exports.isString(presets)) {
        const presetName = presets;
        presets = $0d15360f132ce1e2$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error("Wrong `markdown-it` preset, can't be empty");
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        "core",
        "block",
        "inline"
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        "core",
        "block",
        "inline"
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    const args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== "string") throw new Error("Input data should be a String");
    const state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.parseInline = function(src, env) {
    const state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
var $0d15360f132ce1e2$export$2e2bcd8739ae039 = $0d15360f132ce1e2$var$MarkdownIt;




let $1dd5f29d6665a182$var$md = new (0, $0d15360f132ce1e2$export$2e2bcd8739ae039)({
    html: true,
    xhtmlOut: true,
    breaks: true,
    langPrefix: "language-",
    linkify: true
});
class $1dd5f29d6665a182$export$5cf80f451b772330 {
    constructor(name, configKey, configObject, appendTargetId = "#mainContentCol"){
        this.name = name;
        this.configKey = configKey;
        this.config = configObject[configKey];
        this.appendTargetId = appendTargetId;
    }
    render() {
        let title = `## ${this.name}

`;
        this.content().then((content)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this.appendTargetId).append($1dd5f29d6665a182$var$md.render(title).concat(content));
        });
    }
    content() {
        throw new Error("Method not implemented.");
    }
}


var $03b19053b9503b86$exports = {};
var $26e61ff341e03f4b$exports = {};
/* parser generated by jison 0.4.18 */ /*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/ 
var $26e61ff341e03f4b$var$SparqlParser = function() {
    var o = function(k, v, o, l) {
        for(o = o || {}, l = k.length; l--; o[k[l]] = v);
        return o;
    }, $V0 = [
        6,
        12,
        13,
        15,
        16,
        24,
        32,
        36,
        41,
        45,
        100,
        110,
        113,
        115,
        116,
        123,
        126,
        131,
        197,
        224,
        229,
        308,
        329,
        330,
        331,
        332,
        333
    ], $V1 = [
        2,
        247
    ], $V2 = [
        100,
        110,
        113,
        115,
        116,
        123,
        126,
        131,
        329,
        330,
        331,
        332,
        333
    ], $V3 = [
        2,
        409
    ], $V4 = [
        1,
        18
    ], $V5 = [
        1,
        27
    ], $V6 = [
        13,
        16,
        45,
        197,
        224,
        229,
        308
    ], $V7 = [
        28,
        29,
        53
    ], $V8 = [
        28,
        53
    ], $V9 = [
        1,
        42
    ], $Va = [
        1,
        45
    ], $Vb = [
        1,
        41
    ], $Vc = [
        1,
        44
    ], $Vd = [
        123,
        126
    ], $Ve = [
        1,
        67
    ], $Vf = [
        39,
        45,
        87
    ], $Vg = [
        13,
        16,
        45,
        197,
        224,
        308
    ], $Vh = [
        1,
        87
    ], $Vi = [
        2,
        281
    ], $Vj = [
        1,
        86
    ], $Vk = [
        13,
        16,
        45,
        82,
        87,
        89,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312
    ], $Vl = [
        6,
        28,
        29,
        53,
        63,
        70,
        73,
        81,
        83,
        85
    ], $Vm = [
        6,
        13,
        16,
        28,
        29,
        53,
        63,
        70,
        73,
        81,
        83,
        85,
        87,
        308
    ], $Vn = [
        6,
        13,
        16,
        28,
        29,
        45,
        53,
        63,
        70,
        73,
        81,
        82,
        83,
        85,
        87,
        89,
        197,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        314
    ], $Vo = [
        6,
        13,
        16,
        28,
        29,
        31,
        39,
        45,
        47,
        48,
        53,
        63,
        70,
        73,
        81,
        82,
        83,
        85,
        87,
        89,
        109,
        112,
        121,
        123,
        126,
        128,
        159,
        160,
        161,
        163,
        164,
        174,
        193,
        197,
        224,
        229,
        231,
        232,
        242,
        246,
        250,
        263,
        265,
        272,
        290,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        314,
        317,
        318,
        335,
        337,
        338,
        340,
        341,
        342,
        343,
        344,
        345,
        346
    ], $Vp = [
        13,
        16,
        308
    ], $Vq = [
        112,
        132,
        327,
        334
    ], $Vr = [
        13,
        16,
        112,
        132,
        308
    ], $Vs = [
        1,
        111
    ], $Vt = [
        1,
        117
    ], $Vu = [
        112,
        132,
        327,
        328,
        334
    ], $Vv = [
        13,
        16,
        112,
        132,
        308,
        328
    ], $Vw = [
        28,
        29,
        45,
        53,
        87
    ], $Vx = [
        1,
        138
    ], $Vy = [
        1,
        151
    ], $Vz = [
        1,
        128
    ], $VA = [
        1,
        127
    ], $VB = [
        1,
        129
    ], $VC = [
        1,
        140
    ], $VD = [
        1,
        141
    ], $VE = [
        1,
        142
    ], $VF = [
        1,
        143
    ], $VG = [
        1,
        144
    ], $VH = [
        1,
        145
    ], $VI = [
        1,
        147
    ], $VJ = [
        1,
        148
    ], $VK = [
        2,
        457
    ], $VL = [
        1,
        158
    ], $VM = [
        1,
        159
    ], $VN = [
        1,
        160
    ], $VO = [
        1,
        152
    ], $VP = [
        1,
        153
    ], $VQ = [
        1,
        156
    ], $VR = [
        1,
        171
    ], $VS = [
        1,
        172
    ], $VT = [
        1,
        173
    ], $VU = [
        1,
        174
    ], $VV = [
        1,
        175
    ], $VW = [
        1,
        176
    ], $VX = [
        1,
        167
    ], $VY = [
        1,
        168
    ], $VZ = [
        1,
        169
    ], $V_ = [
        1,
        170
    ], $V$ = [
        1,
        157
    ], $V01 = [
        1,
        166
    ], $V11 = [
        1,
        161
    ], $V21 = [
        1,
        162
    ], $V31 = [
        1,
        163
    ], $V41 = [
        1,
        164
    ], $V51 = [
        1,
        165
    ], $V61 = [
        6,
        13,
        16,
        29,
        31,
        45,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        335
    ], $V71 = [
        1,
        195
    ], $V81 = [
        6,
        31,
        73,
        81,
        83,
        85
    ], $V91 = [
        2,
        285
    ], $Va1 = [
        1,
        199
    ], $Vb1 = [
        1,
        201
    ], $Vc1 = [
        6,
        31,
        70,
        73,
        81,
        83,
        85
    ], $Vd1 = [
        2,
        283
    ], $Ve1 = [
        1,
        207
    ], $Vf1 = [
        1,
        218
    ], $Vg1 = [
        1,
        223
    ], $Vh1 = [
        1,
        219
    ], $Vi1 = [
        1,
        225
    ], $Vj1 = [
        1,
        226
    ], $Vk1 = [
        1,
        224
    ], $Vl1 = [
        6,
        63,
        70,
        73,
        81,
        83,
        85
    ], $Vm1 = [
        1,
        236
    ], $Vn1 = [
        2,
        334
    ], $Vo1 = [
        1,
        243
    ], $Vp1 = [
        1,
        241
    ], $Vq1 = [
        6,
        193
    ], $Vr1 = [
        2,
        349
    ], $Vs1 = [
        2,
        339
    ], $Vt1 = [
        28,
        128
    ], $Vu1 = [
        47,
        48,
        193,
        272
    ], $Vv1 = [
        47,
        48,
        193,
        242,
        272
    ], $Vw1 = [
        47,
        48,
        193,
        242,
        246,
        272
    ], $Vx1 = [
        47,
        48,
        193,
        242,
        246,
        250,
        263,
        265,
        272,
        290,
        297,
        298,
        299,
        300,
        301,
        302,
        341,
        342,
        343,
        344,
        345,
        346
    ], $Vy1 = [
        39,
        47,
        48,
        193,
        242,
        246,
        250,
        263,
        265,
        272,
        290,
        297,
        298,
        299,
        300,
        301,
        302,
        338,
        341,
        342,
        343,
        344,
        345,
        346
    ], $Vz1 = [
        1,
        271
    ], $VA1 = [
        1,
        270
    ], $VB1 = [
        6,
        13,
        16,
        29,
        31,
        39,
        45,
        47,
        48,
        70,
        73,
        76,
        78,
        81,
        82,
        83,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        231,
        242,
        246,
        250,
        263,
        265,
        268,
        269,
        270,
        271,
        272,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        290,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        335,
        338,
        341,
        342,
        343,
        344,
        345,
        346,
        347,
        348,
        349,
        350,
        351
    ], $VC1 = [
        1,
        281
    ], $VD1 = [
        1,
        280
    ], $VE1 = [
        13,
        16,
        29,
        31,
        39,
        45,
        47,
        48,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        174,
        193,
        197,
        224,
        229,
        231,
        232,
        242,
        246,
        250,
        263,
        265,
        272,
        290,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        314,
        317,
        318,
        335,
        338,
        341,
        342,
        343,
        344,
        345,
        346
    ], $VF1 = [
        45,
        89
    ], $VG1 = [
        13,
        16,
        29,
        31,
        39,
        45,
        47,
        48,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        174,
        193,
        197,
        224,
        229,
        231,
        232,
        242,
        246,
        250,
        263,
        265,
        272,
        290,
        292,
        293,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        314,
        317,
        318,
        335,
        338,
        341,
        342,
        343,
        344,
        345,
        346
    ], $VH1 = [
        13,
        16,
        31,
        82,
        174,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        312
    ], $VI1 = [
        31,
        89
    ], $VJ1 = [
        48,
        87
    ], $VK1 = [
        6,
        13,
        16,
        45,
        48,
        82,
        87,
        89,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        337,
        338
    ], $VL1 = [
        6,
        13,
        16,
        39,
        45,
        48,
        82,
        87,
        89,
        231,
        263,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        337,
        338,
        340
    ], $VM1 = [
        1,
        313
    ], $VN1 = [
        6,
        85
    ], $VO1 = [
        6,
        31,
        81,
        83,
        85
    ], $VP1 = [
        2,
        361
    ], $VQ1 = [
        2,
        353
    ], $VR1 = [
        1,
        343
    ], $VS1 = [
        31,
        112,
        335
    ], $VT1 = [
        13,
        16,
        29,
        31,
        45,
        48,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        197,
        224,
        229,
        231,
        232,
        272,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        317,
        318,
        335
    ], $VU1 = [
        13,
        16,
        29,
        31,
        45,
        48,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        197,
        224,
        229,
        231,
        232,
        272,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        314,
        317,
        318,
        335
    ], $VV1 = [
        6,
        109,
        193
    ], $VW1 = [
        31,
        112
    ], $VX1 = [
        13,
        16,
        45,
        82,
        87,
        224,
        263,
        265,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        312,
        346,
        347,
        348,
        349,
        350,
        351
    ], $VY1 = [
        1,
        390
    ], $VZ1 = [
        1,
        391
    ], $V_1 = [
        13,
        16,
        87,
        197,
        308,
        314
    ], $V$1 = [
        13,
        16,
        39,
        45,
        82,
        87,
        224,
        263,
        265,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        312,
        346,
        347,
        348,
        349,
        350,
        351
    ], $V02 = [
        1,
        417
    ], $V12 = [
        1,
        418
    ], $V22 = [
        13,
        16,
        48,
        197,
        229,
        308
    ], $V32 = [
        6,
        31,
        85
    ], $V42 = [
        6,
        13,
        16,
        31,
        45,
        73,
        81,
        83,
        85,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        308,
        346,
        347,
        348,
        349,
        350,
        351
    ], $V52 = [
        6,
        13,
        16,
        29,
        31,
        45,
        73,
        76,
        78,
        81,
        82,
        83,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        231,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        335,
        346,
        347,
        348,
        349,
        350,
        351
    ], $V62 = [
        29,
        31,
        85,
        112,
        159,
        160,
        161,
        163,
        164
    ], $V72 = [
        1,
        443
    ], $V82 = [
        1,
        444
    ], $V92 = [
        1,
        449
    ], $Va2 = [
        31,
        112,
        193,
        232,
        318,
        335
    ], $Vb2 = [
        13,
        16,
        45,
        48,
        82,
        87,
        89,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312
    ], $Vc2 = [
        13,
        16,
        31,
        45,
        48,
        82,
        87,
        89,
        112,
        193,
        231,
        232,
        272,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        317,
        318,
        335
    ], $Vd2 = [
        13,
        16,
        29,
        31,
        45,
        48,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        231,
        232,
        272,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        317,
        318,
        335
    ], $Ve2 = [
        13,
        16,
        31,
        48,
        82,
        174,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        312
    ], $Vf2 = [
        31,
        45
    ], $Vg2 = [
        1,
        507
    ], $Vh2 = [
        1,
        508
    ], $Vi2 = [
        6,
        13,
        16,
        29,
        31,
        39,
        45,
        47,
        48,
        63,
        70,
        73,
        76,
        78,
        81,
        82,
        83,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        231,
        242,
        246,
        250,
        263,
        265,
        268,
        269,
        270,
        271,
        272,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        290,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        335,
        336,
        338,
        341,
        342,
        343,
        344,
        345,
        346,
        347,
        348,
        349,
        350,
        351
    ], $Vj2 = [
        29,
        31,
        85,
        112,
        159,
        160,
        161,
        163,
        164,
        335
    ], $Vk2 = [
        6,
        13,
        16,
        31,
        45,
        70,
        73,
        81,
        83,
        85,
        87,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        308,
        346,
        347,
        348,
        349,
        350,
        351
    ], $Vl2 = [
        13,
        16,
        31,
        45,
        48,
        82,
        87,
        89,
        112,
        193,
        197,
        231,
        232,
        272,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        317,
        318,
        335
    ], $Vm2 = [
        2,
        352
    ], $Vn2 = [
        13,
        16,
        197,
        308,
        314
    ], $Vo2 = [
        1,
        565
    ], $Vp2 = [
        6,
        13,
        16,
        31,
        45,
        76,
        78,
        81,
        83,
        85,
        87,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        308,
        346,
        347,
        348,
        349,
        350,
        351
    ], $Vq2 = [
        13,
        16,
        29,
        31,
        45,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312
    ], $Vr2 = [
        13,
        16,
        29,
        31,
        45,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        335
    ], $Vs2 = [
        13,
        16,
        87,
        308
    ], $Vt2 = [
        2,
        364
    ], $Vu2 = [
        29,
        31,
        85,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        232,
        318,
        335
    ], $Vv2 = [
        31,
        112,
        193,
        232,
        272,
        318,
        335
    ], $Vw2 = [
        2,
        359
    ], $Vx2 = [
        13,
        16,
        48,
        82,
        174,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        312
    ], $Vy2 = [
        29,
        31,
        85,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        232,
        272,
        318,
        335
    ], $Vz2 = [
        13,
        16,
        31,
        45,
        82,
        87,
        89,
        112,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312
    ], $VA2 = [
        2,
        347
    ];
    var parser = {
        trace: function trace() {},
        yy: {},
        symbols_: {
            "error": 2,
            "QueryOrUpdate": 3,
            "Prologue": 4,
            "QueryOrUpdate_group0": 5,
            "EOF": 6,
            "Query": 7,
            "Qry": 8,
            "Query_option0": 9,
            "Prologue_repetition0": 10,
            "BaseDecl": 11,
            "BASE": 12,
            "IRIREF": 13,
            "PrefixDecl": 14,
            "PREFIX": 15,
            "PNAME_NS": 16,
            "SelectClauseWildcard": 17,
            "Qry_repetition0": 18,
            "WhereClause": 19,
            "SolutionModifierNoGroup": 20,
            "SelectClauseVars": 21,
            "Qry_repetition1": 22,
            "SolutionModifier": 23,
            "CONSTRUCT": 24,
            "ConstructTemplate": 25,
            "Qry_repetition2": 26,
            "Qry_repetition3": 27,
            "WHERE": 28,
            "{": 29,
            "Qry_option0": 30,
            "}": 31,
            "DESCRIBE": 32,
            "Qry_group0": 33,
            "Qry_repetition4": 34,
            "Qry_option1": 35,
            "ASK": 36,
            "Qry_repetition5": 37,
            "SelectClauseBase": 38,
            "*": 39,
            "SelectClauseVars_repetition_plus0": 40,
            "SELECT": 41,
            "SelectClauseBase_option0": 42,
            "SelectClauseItem": 43,
            "Var": 44,
            "(": 45,
            "Expression": 46,
            "AS": 47,
            ")": 48,
            "SubSelect": 49,
            "SubSelect_option0": 50,
            "SubSelect_option1": 51,
            "DatasetClause": 52,
            "FROM": 53,
            "DatasetClause_option0": 54,
            "iri": 55,
            "WhereClause_option0": 56,
            "GroupGraphPattern": 57,
            "SolutionModifier_option0": 58,
            "SolutionModifierNoGroup_option0": 59,
            "SolutionModifierNoGroup_option1": 60,
            "SolutionModifierNoGroup_option2": 61,
            "GroupClause": 62,
            "GROUP": 63,
            "BY": 64,
            "GroupClause_repetition_plus0": 65,
            "GroupCondition": 66,
            "BuiltInCall": 67,
            "FunctionCall": 68,
            "HavingClause": 69,
            "HAVING": 70,
            "HavingClause_repetition_plus0": 71,
            "OrderClause": 72,
            "ORDER": 73,
            "OrderClause_repetition_plus0": 74,
            "OrderCondition": 75,
            "ASC": 76,
            "BrackettedExpression": 77,
            "DESC": 78,
            "Constraint": 79,
            "LimitOffsetClauses": 80,
            "LIMIT": 81,
            "INTEGER": 82,
            "OFFSET": 83,
            "ValuesClause": 84,
            "VALUES": 85,
            "InlineData": 86,
            "VAR": 87,
            "InlineData_repetition0": 88,
            "NIL": 89,
            "InlineData_repetition1": 90,
            "InlineData_repetition_plus2": 91,
            "InlineData_repetition3": 92,
            "DataBlock": 93,
            "DataBlockValueList": 94,
            "DataBlockValueList_repetition_plus0": 95,
            "Update": 96,
            "Update_repetition0": 97,
            "Update1": 98,
            "Update_option0": 99,
            "LOAD": 100,
            "Update1_option0": 101,
            "Update1_option1": 102,
            "Update1_group0": 103,
            "Update1_option2": 104,
            "GraphRefAll": 105,
            "Update1_group1": 106,
            "Update1_option3": 107,
            "GraphOrDefault": 108,
            "TO": 109,
            "CREATE": 110,
            "Update1_option4": 111,
            "GRAPH": 112,
            "INSERTDATA": 113,
            "QuadPattern": 114,
            "DELETEDATA": 115,
            "DELETEWHERE": 116,
            "Update1_option5": 117,
            "InsertDeleteClause": 118,
            "Update1_repetition0": 119,
            "IntoGraphClause": 120,
            "INTO": 121,
            "GraphRef": 122,
            "DELETE": 123,
            "InsertDeleteClause_option0": 124,
            "InsertClause": 125,
            "INSERT": 126,
            "UsingClause": 127,
            "USING": 128,
            "UsingClause_option0": 129,
            "WithClause": 130,
            "WITH": 131,
            "DEFAULT": 132,
            "GraphOrDefault_option0": 133,
            "GraphRefAll_group0": 134,
            "Quads": 135,
            "Quads_option0": 136,
            "Quads_repetition0": 137,
            "QuadsNotTriples": 138,
            "VarOrIri": 139,
            "QuadsNotTriples_option0": 140,
            "QuadsNotTriples_option1": 141,
            "QuadsNotTriples_option2": 142,
            "TriplesTemplate": 143,
            "TriplesTemplate_repetition0": 144,
            "TriplesSameSubject": 145,
            "TriplesTemplate_option0": 146,
            "GroupGraphPatternSub": 147,
            "GroupGraphPatternSub_option0": 148,
            "GroupGraphPatternSub_repetition0": 149,
            "GroupGraphPatternSubTail": 150,
            "GraphPatternNotTriples": 151,
            "GroupGraphPatternSubTail_option0": 152,
            "GroupGraphPatternSubTail_option1": 153,
            "TriplesBlock": 154,
            "TriplesBlock_repetition0": 155,
            "TriplesSameSubjectPath": 156,
            "TriplesBlock_option0": 157,
            "GroupOrUnionGraphPattern": 158,
            "OPTIONAL": 159,
            "MINUS": 160,
            "SERVICE": 161,
            "GraphPatternNotTriples_option0": 162,
            "FILTER": 163,
            "BIND": 164,
            "InlineDataOneVar": 165,
            "InlineDataFull": 166,
            "InlineDataOneVar_repetition0": 167,
            "InlineDataFull_repetition0": 168,
            "InlineDataFull_repetition_plus1": 169,
            "InlineDataFull_repetition2": 170,
            "DataBlockValue": 171,
            "Literal": 172,
            "QuotedTriple": 173,
            "UNDEF": 174,
            "GroupOrUnionGraphPattern_repetition0": 175,
            "ArgList": 176,
            "ArgList_option0": 177,
            "ArgList_repetition0": 178,
            "ExpressionList": 179,
            "ExpressionList_repetition0": 180,
            "ConstructTemplate_option0": 181,
            "ConstructTriples": 182,
            "ConstructTriples_repetition0": 183,
            "ConstructTriples_option0": 184,
            "VarOrTermOrQuotedTP": 185,
            "PropertyListNotEmpty": 186,
            "TriplesNode": 187,
            "PropertyList": 188,
            "PropertyList_option0": 189,
            "VerbObjectList": 190,
            "PropertyListNotEmpty_repetition0": 191,
            "SemiOptionalVerbObjectList": 192,
            ";": 193,
            "SemiOptionalVerbObjectList_option0": 194,
            "Verb": 195,
            "ObjectList": 196,
            "a": 197,
            "ObjectList_repetition0": 198,
            "Object": 199,
            "GraphNode": 200,
            "Object_option0": 201,
            "PropertyListPathNotEmpty": 202,
            "TriplesNodePath": 203,
            "TriplesSameSubjectPath_option0": 204,
            "O": 205,
            "PropertyListPathNotEmpty_repetition0": 206,
            "PropertyListPathNotEmptyTail": 207,
            "O_group0": 208,
            "ObjectListPath": 209,
            "ObjectListPath_repetition0": 210,
            "ObjectPath": 211,
            "GraphNodePath": 212,
            "ObjectPath_option0": 213,
            "Path": 214,
            "Path_repetition0": 215,
            "PathSequence": 216,
            "PathSequence_repetition0": 217,
            "PathEltOrInverse": 218,
            "PathElt": 219,
            "PathPrimary": 220,
            "PathElt_option0": 221,
            "PathEltOrInverse_option0": 222,
            "IriOrA": 223,
            "!": 224,
            "PathNegatedPropertySet": 225,
            "PathOneInPropertySet": 226,
            "PathNegatedPropertySet_repetition0": 227,
            "PathNegatedPropertySet_option0": 228,
            "^": 229,
            "TriplesNode_repetition_plus0": 230,
            "[": 231,
            "]": 232,
            "TriplesNodePath_repetition_plus0": 233,
            "VarOrTermOrQuotedTPExpr": 234,
            "VarOrTerm": 235,
            "GraphTerm": 236,
            "BlankNode": 237,
            "ConditionalOrExpression": 238,
            "ConditionalAndExpression": 239,
            "ConditionalOrExpression_repetition0": 240,
            "ConditionalOrExpressionTail": 241,
            "||": 242,
            "RelationalExpression": 243,
            "ConditionalAndExpression_repetition0": 244,
            "ConditionalAndExpressionTail": 245,
            "&&": 246,
            "NumericExpression": 247,
            "RelationalExpression_group0": 248,
            "RelationalExpression_option0": 249,
            "IN": 250,
            "MultiplicativeExpression": 251,
            "NumericExpression_repetition0": 252,
            "AdditiveExpressionTail": 253,
            "AdditiveExpressionTail_group0": 254,
            "NumericLiteralPositive": 255,
            "AdditiveExpressionTail_repetition0": 256,
            "NumericLiteralNegative": 257,
            "AdditiveExpressionTail_repetition1": 258,
            "UnaryExpression": 259,
            "MultiplicativeExpression_repetition0": 260,
            "MultiplicativeExpressionTail": 261,
            "MultiplicativeExpressionTail_group0": 262,
            "+": 263,
            "PrimaryExpression": 264,
            "-": 265,
            "ExprQuotedTP": 266,
            "Aggregate": 267,
            "FUNC_ARITY0": 268,
            "FUNC_ARITY1": 269,
            "FUNC_ARITY1_SPARQL_STAR": 270,
            "FUNC_ARITY2": 271,
            ",": 272,
            "FUNC_ARITY3": 273,
            "FUNC_ARITY3_SPARQL_STAR": 274,
            "BuiltInCall_group0": 275,
            "BOUND": 276,
            "BNODE": 277,
            "BuiltInCall_option0": 278,
            "EXISTS": 279,
            "COUNT": 280,
            "Aggregate_option0": 281,
            "Aggregate_group0": 282,
            "FUNC_AGGREGATE": 283,
            "Aggregate_option1": 284,
            "GROUP_CONCAT": 285,
            "Aggregate_option2": 286,
            "Aggregate_option3": 287,
            "GroupConcatSeparator": 288,
            "SEPARATOR": 289,
            "=": 290,
            "String": 291,
            "LANGTAG": 292,
            "^^": 293,
            "DECIMAL": 294,
            "DOUBLE": 295,
            "BOOLEAN": 296,
            "INTEGER_POSITIVE": 297,
            "DECIMAL_POSITIVE": 298,
            "DOUBLE_POSITIVE": 299,
            "INTEGER_NEGATIVE": 300,
            "DECIMAL_NEGATIVE": 301,
            "DOUBLE_NEGATIVE": 302,
            "STRING_LITERAL1": 303,
            "STRING_LITERAL2": 304,
            "STRING_LITERAL_LONG1": 305,
            "STRING_LITERAL_LONG2": 306,
            "PrefixedName": 307,
            "PNAME_LN": 308,
            "BLANK_NODE_LABEL": 309,
            "ANON": 310,
            "QuotedTP": 311,
            "<<": 312,
            "qtSubjectOrObject": 313,
            ">>": 314,
            "DataValueTerm": 315,
            "AnnotationPattern": 316,
            "{|": 317,
            "|}": 318,
            "AnnotationPatternPath": 319,
            "ExprVarOrTerm": 320,
            "QueryOrUpdate_group0_option0": 321,
            "Prologue_repetition0_group0": 322,
            "Qry_group0_repetition_plus0": 323,
            "SelectClauseBase_option0_group0": 324,
            "DISTINCT": 325,
            "REDUCED": 326,
            "NAMED": 327,
            "SILENT": 328,
            "CLEAR": 329,
            "DROP": 330,
            "ADD": 331,
            "MOVE": 332,
            "COPY": 333,
            "ALL": 334,
            ".": 335,
            "UNION": 336,
            "|": 337,
            "/": 338,
            "PathElt_option0_group0": 339,
            "?": 340,
            "!=": 341,
            "<": 342,
            ">": 343,
            "<=": 344,
            ">=": 345,
            "NOT": 346,
            "CONCAT": 347,
            "COALESCE": 348,
            "SUBSTR": 349,
            "REGEX": 350,
            "REPLACE": 351,
            "$accept": 0,
            "$end": 1
        },
        terminals_: {
            2: "error",
            6: "EOF",
            12: "BASE",
            13: "IRIREF",
            15: "PREFIX",
            16: "PNAME_NS",
            24: "CONSTRUCT",
            28: "WHERE",
            29: "{",
            31: "}",
            32: "DESCRIBE",
            36: "ASK",
            39: "*",
            41: "SELECT",
            45: "(",
            47: "AS",
            48: ")",
            53: "FROM",
            63: "GROUP",
            64: "BY",
            70: "HAVING",
            73: "ORDER",
            76: "ASC",
            78: "DESC",
            81: "LIMIT",
            82: "INTEGER",
            83: "OFFSET",
            85: "VALUES",
            87: "VAR",
            89: "NIL",
            100: "LOAD",
            109: "TO",
            110: "CREATE",
            112: "GRAPH",
            113: "INSERTDATA",
            115: "DELETEDATA",
            116: "DELETEWHERE",
            121: "INTO",
            123: "DELETE",
            126: "INSERT",
            128: "USING",
            131: "WITH",
            132: "DEFAULT",
            159: "OPTIONAL",
            160: "MINUS",
            161: "SERVICE",
            163: "FILTER",
            164: "BIND",
            174: "UNDEF",
            193: ";",
            197: "a",
            224: "!",
            229: "^",
            231: "[",
            232: "]",
            242: "||",
            246: "&&",
            250: "IN",
            263: "+",
            265: "-",
            268: "FUNC_ARITY0",
            269: "FUNC_ARITY1",
            270: "FUNC_ARITY1_SPARQL_STAR",
            271: "FUNC_ARITY2",
            272: ",",
            273: "FUNC_ARITY3",
            274: "FUNC_ARITY3_SPARQL_STAR",
            276: "BOUND",
            277: "BNODE",
            279: "EXISTS",
            280: "COUNT",
            283: "FUNC_AGGREGATE",
            285: "GROUP_CONCAT",
            289: "SEPARATOR",
            290: "=",
            292: "LANGTAG",
            293: "^^",
            294: "DECIMAL",
            295: "DOUBLE",
            296: "BOOLEAN",
            297: "INTEGER_POSITIVE",
            298: "DECIMAL_POSITIVE",
            299: "DOUBLE_POSITIVE",
            300: "INTEGER_NEGATIVE",
            301: "DECIMAL_NEGATIVE",
            302: "DOUBLE_NEGATIVE",
            303: "STRING_LITERAL1",
            304: "STRING_LITERAL2",
            305: "STRING_LITERAL_LONG1",
            306: "STRING_LITERAL_LONG2",
            308: "PNAME_LN",
            309: "BLANK_NODE_LABEL",
            310: "ANON",
            312: "<<",
            314: ">>",
            317: "{|",
            318: "|}",
            325: "DISTINCT",
            326: "REDUCED",
            327: "NAMED",
            328: "SILENT",
            329: "CLEAR",
            330: "DROP",
            331: "ADD",
            332: "MOVE",
            333: "COPY",
            334: "ALL",
            335: ".",
            336: "UNION",
            337: "|",
            338: "/",
            340: "?",
            341: "!=",
            342: "<",
            343: ">",
            344: "<=",
            345: ">=",
            346: "NOT",
            347: "CONCAT",
            348: "COALESCE",
            349: "SUBSTR",
            350: "REGEX",
            351: "REPLACE"
        },
        productions_: [
            0,
            [
                3,
                3
            ],
            [
                7,
                2
            ],
            [
                4,
                1
            ],
            [
                11,
                2
            ],
            [
                14,
                3
            ],
            [
                8,
                4
            ],
            [
                8,
                4
            ],
            [
                8,
                5
            ],
            [
                8,
                7
            ],
            [
                8,
                5
            ],
            [
                8,
                4
            ],
            [
                17,
                2
            ],
            [
                21,
                2
            ],
            [
                38,
                2
            ],
            [
                43,
                1
            ],
            [
                43,
                5
            ],
            [
                49,
                4
            ],
            [
                49,
                4
            ],
            [
                52,
                3
            ],
            [
                19,
                2
            ],
            [
                23,
                2
            ],
            [
                20,
                3
            ],
            [
                62,
                3
            ],
            [
                66,
                1
            ],
            [
                66,
                1
            ],
            [
                66,
                3
            ],
            [
                66,
                5
            ],
            [
                66,
                1
            ],
            [
                69,
                2
            ],
            [
                72,
                3
            ],
            [
                75,
                2
            ],
            [
                75,
                2
            ],
            [
                75,
                1
            ],
            [
                75,
                1
            ],
            [
                80,
                2
            ],
            [
                80,
                2
            ],
            [
                80,
                4
            ],
            [
                80,
                4
            ],
            [
                84,
                2
            ],
            [
                86,
                4
            ],
            [
                86,
                4
            ],
            [
                86,
                6
            ],
            [
                86,
                2
            ],
            [
                94,
                3
            ],
            [
                96,
                3
            ],
            [
                98,
                4
            ],
            [
                98,
                3
            ],
            [
                98,
                5
            ],
            [
                98,
                4
            ],
            [
                98,
                2
            ],
            [
                98,
                2
            ],
            [
                98,
                2
            ],
            [
                98,
                5
            ],
            [
                120,
                2
            ],
            [
                118,
                3
            ],
            [
                118,
                1
            ],
            [
                125,
                2
            ],
            [
                127,
                3
            ],
            [
                130,
                2
            ],
            [
                108,
                1
            ],
            [
                108,
                2
            ],
            [
                122,
                2
            ],
            [
                105,
                1
            ],
            [
                105,
                1
            ],
            [
                114,
                3
            ],
            [
                135,
                2
            ],
            [
                138,
                7
            ],
            [
                143,
                3
            ],
            [
                57,
                3
            ],
            [
                57,
                3
            ],
            [
                147,
                2
            ],
            [
                150,
                3
            ],
            [
                154,
                3
            ],
            [
                151,
                1
            ],
            [
                151,
                2
            ],
            [
                151,
                2
            ],
            [
                151,
                3
            ],
            [
                151,
                4
            ],
            [
                151,
                2
            ],
            [
                151,
                6
            ],
            [
                151,
                1
            ],
            [
                93,
                1
            ],
            [
                93,
                1
            ],
            [
                165,
                4
            ],
            [
                166,
                4
            ],
            [
                166,
                6
            ],
            [
                171,
                1
            ],
            [
                171,
                1
            ],
            [
                171,
                1
            ],
            [
                171,
                1
            ],
            [
                158,
                2
            ],
            [
                79,
                1
            ],
            [
                79,
                1
            ],
            [
                79,
                1
            ],
            [
                68,
                2
            ],
            [
                176,
                1
            ],
            [
                176,
                5
            ],
            [
                179,
                1
            ],
            [
                179,
                4
            ],
            [
                25,
                3
            ],
            [
                182,
                3
            ],
            [
                145,
                2
            ],
            [
                145,
                2
            ],
            [
                188,
                1
            ],
            [
                186,
                2
            ],
            [
                192,
                2
            ],
            [
                190,
                2
            ],
            [
                195,
                1
            ],
            [
                195,
                1
            ],
            [
                196,
                2
            ],
            [
                199,
                2
            ],
            [
                156,
                2
            ],
            [
                156,
                2
            ],
            [
                202,
                2
            ],
            [
                207,
                1
            ],
            [
                207,
                2
            ],
            [
                205,
                2
            ],
            [
                209,
                2
            ],
            [
                211,
                2
            ],
            [
                214,
                2
            ],
            [
                216,
                2
            ],
            [
                219,
                2
            ],
            [
                218,
                2
            ],
            [
                220,
                1
            ],
            [
                220,
                2
            ],
            [
                220,
                3
            ],
            [
                225,
                1
            ],
            [
                225,
                1
            ],
            [
                225,
                4
            ],
            [
                226,
                1
            ],
            [
                226,
                2
            ],
            [
                187,
                3
            ],
            [
                187,
                3
            ],
            [
                203,
                3
            ],
            [
                203,
                3
            ],
            [
                200,
                1
            ],
            [
                200,
                1
            ],
            [
                212,
                1
            ],
            [
                212,
                1
            ],
            [
                234,
                1
            ],
            [
                235,
                1
            ],
            [
                235,
                1
            ],
            [
                139,
                1
            ],
            [
                139,
                1
            ],
            [
                44,
                1
            ],
            [
                236,
                1
            ],
            [
                236,
                1
            ],
            [
                236,
                1
            ],
            [
                236,
                1
            ],
            [
                46,
                1
            ],
            [
                238,
                2
            ],
            [
                241,
                2
            ],
            [
                239,
                2
            ],
            [
                245,
                2
            ],
            [
                243,
                1
            ],
            [
                243,
                3
            ],
            [
                243,
                4
            ],
            [
                247,
                2
            ],
            [
                253,
                2
            ],
            [
                253,
                2
            ],
            [
                253,
                2
            ],
            [
                251,
                2
            ],
            [
                261,
                2
            ],
            [
                259,
                2
            ],
            [
                259,
                2
            ],
            [
                259,
                2
            ],
            [
                259,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                77,
                3
            ],
            [
                67,
                1
            ],
            [
                67,
                2
            ],
            [
                67,
                4
            ],
            [
                67,
                4
            ],
            [
                67,
                6
            ],
            [
                67,
                8
            ],
            [
                67,
                8
            ],
            [
                67,
                2
            ],
            [
                67,
                4
            ],
            [
                67,
                2
            ],
            [
                67,
                4
            ],
            [
                67,
                3
            ],
            [
                267,
                5
            ],
            [
                267,
                5
            ],
            [
                267,
                6
            ],
            [
                288,
                4
            ],
            [
                172,
                1
            ],
            [
                172,
                2
            ],
            [
                172,
                3
            ],
            [
                172,
                1
            ],
            [
                172,
                1
            ],
            [
                172,
                1
            ],
            [
                172,
                1
            ],
            [
                172,
                1
            ],
            [
                172,
                1
            ],
            [
                255,
                1
            ],
            [
                255,
                1
            ],
            [
                255,
                1
            ],
            [
                257,
                1
            ],
            [
                257,
                1
            ],
            [
                257,
                1
            ],
            [
                291,
                1
            ],
            [
                291,
                1
            ],
            [
                291,
                1
            ],
            [
                291,
                1
            ],
            [
                55,
                1
            ],
            [
                55,
                1
            ],
            [
                307,
                1
            ],
            [
                307,
                1
            ],
            [
                237,
                1
            ],
            [
                237,
                1
            ],
            [
                311,
                5
            ],
            [
                173,
                5
            ],
            [
                313,
                1
            ],
            [
                313,
                1
            ],
            [
                313,
                1
            ],
            [
                313,
                1
            ],
            [
                313,
                1
            ],
            [
                315,
                1
            ],
            [
                315,
                1
            ],
            [
                315,
                1
            ],
            [
                185,
                1
            ],
            [
                185,
                1
            ],
            [
                185,
                1
            ],
            [
                316,
                3
            ],
            [
                319,
                3
            ],
            [
                266,
                5
            ],
            [
                320,
                1
            ],
            [
                320,
                1
            ],
            [
                320,
                1
            ],
            [
                223,
                1
            ],
            [
                223,
                1
            ],
            [
                321,
                0
            ],
            [
                321,
                1
            ],
            [
                5,
                1
            ],
            [
                5,
                1
            ],
            [
                5,
                1
            ],
            [
                9,
                0
            ],
            [
                9,
                1
            ],
            [
                322,
                1
            ],
            [
                322,
                1
            ],
            [
                10,
                0
            ],
            [
                10,
                2
            ],
            [
                18,
                0
            ],
            [
                18,
                2
            ],
            [
                22,
                0
            ],
            [
                22,
                2
            ],
            [
                26,
                0
            ],
            [
                26,
                2
            ],
            [
                27,
                0
            ],
            [
                27,
                2
            ],
            [
                30,
                0
            ],
            [
                30,
                1
            ],
            [
                323,
                1
            ],
            [
                323,
                2
            ],
            [
                33,
                1
            ],
            [
                33,
                1
            ],
            [
                34,
                0
            ],
            [
                34,
                2
            ],
            [
                35,
                0
            ],
            [
                35,
                1
            ],
            [
                37,
                0
            ],
            [
                37,
                2
            ],
            [
                40,
                1
            ],
            [
                40,
                2
            ],
            [
                324,
                1
            ],
            [
                324,
                1
            ],
            [
                42,
                0
            ],
            [
                42,
                1
            ],
            [
                50,
                0
            ],
            [
                50,
                1
            ],
            [
                51,
                0
            ],
            [
                51,
                1
            ],
            [
                54,
                0
            ],
            [
                54,
                1
            ],
            [
                56,
                0
            ],
            [
                56,
                1
            ],
            [
                58,
                0
            ],
            [
                58,
                1
            ],
            [
                59,
                0
            ],
            [
                59,
                1
            ],
            [
                60,
                0
            ],
            [
                60,
                1
            ],
            [
                61,
                0
            ],
            [
                61,
                1
            ],
            [
                65,
                1
            ],
            [
                65,
                2
            ],
            [
                71,
                1
            ],
            [
                71,
                2
            ],
            [
                74,
                1
            ],
            [
                74,
                2
            ],
            [
                88,
                0
            ],
            [
                88,
                2
            ],
            [
                90,
                0
            ],
            [
                90,
                2
            ],
            [
                91,
                1
            ],
            [
                91,
                2
            ],
            [
                92,
                0
            ],
            [
                92,
                2
            ],
            [
                95,
                1
            ],
            [
                95,
                2
            ],
            [
                97,
                0
            ],
            [
                97,
                4
            ],
            [
                99,
                0
            ],
            [
                99,
                2
            ],
            [
                101,
                0
            ],
            [
                101,
                1
            ],
            [
                102,
                0
            ],
            [
                102,
                1
            ],
            [
                103,
                1
            ],
            [
                103,
                1
            ],
            [
                104,
                0
            ],
            [
                104,
                1
            ],
            [
                106,
                1
            ],
            [
                106,
                1
            ],
            [
                106,
                1
            ],
            [
                107,
                0
            ],
            [
                107,
                1
            ],
            [
                111,
                0
            ],
            [
                111,
                1
            ],
            [
                117,
                0
            ],
            [
                117,
                1
            ],
            [
                119,
                0
            ],
            [
                119,
                2
            ],
            [
                124,
                0
            ],
            [
                124,
                1
            ],
            [
                129,
                0
            ],
            [
                129,
                1
            ],
            [
                133,
                0
            ],
            [
                133,
                1
            ],
            [
                134,
                1
            ],
            [
                134,
                1
            ],
            [
                134,
                1
            ],
            [
                136,
                0
            ],
            [
                136,
                1
            ],
            [
                137,
                0
            ],
            [
                137,
                2
            ],
            [
                140,
                0
            ],
            [
                140,
                1
            ],
            [
                141,
                0
            ],
            [
                141,
                1
            ],
            [
                142,
                0
            ],
            [
                142,
                1
            ],
            [
                144,
                0
            ],
            [
                144,
                3
            ],
            [
                146,
                0
            ],
            [
                146,
                1
            ],
            [
                148,
                0
            ],
            [
                148,
                1
            ],
            [
                149,
                0
            ],
            [
                149,
                2
            ],
            [
                152,
                0
            ],
            [
                152,
                1
            ],
            [
                153,
                0
            ],
            [
                153,
                1
            ],
            [
                155,
                0
            ],
            [
                155,
                3
            ],
            [
                157,
                0
            ],
            [
                157,
                1
            ],
            [
                162,
                0
            ],
            [
                162,
                1
            ],
            [
                167,
                0
            ],
            [
                167,
                2
            ],
            [
                168,
                0
            ],
            [
                168,
                2
            ],
            [
                169,
                1
            ],
            [
                169,
                2
            ],
            [
                170,
                0
            ],
            [
                170,
                2
            ],
            [
                175,
                0
            ],
            [
                175,
                3
            ],
            [
                177,
                0
            ],
            [
                177,
                1
            ],
            [
                178,
                0
            ],
            [
                178,
                3
            ],
            [
                180,
                0
            ],
            [
                180,
                3
            ],
            [
                181,
                0
            ],
            [
                181,
                1
            ],
            [
                183,
                0
            ],
            [
                183,
                3
            ],
            [
                184,
                0
            ],
            [
                184,
                1
            ],
            [
                189,
                0
            ],
            [
                189,
                1
            ],
            [
                191,
                0
            ],
            [
                191,
                2
            ],
            [
                194,
                0
            ],
            [
                194,
                1
            ],
            [
                198,
                0
            ],
            [
                198,
                3
            ],
            [
                201,
                0
            ],
            [
                201,
                1
            ],
            [
                204,
                0
            ],
            [
                204,
                1
            ],
            [
                206,
                0
            ],
            [
                206,
                2
            ],
            [
                208,
                1
            ],
            [
                208,
                1
            ],
            [
                210,
                0
            ],
            [
                210,
                3
            ],
            [
                213,
                0
            ],
            [
                213,
                1
            ],
            [
                215,
                0
            ],
            [
                215,
                3
            ],
            [
                217,
                0
            ],
            [
                217,
                3
            ],
            [
                339,
                1
            ],
            [
                339,
                1
            ],
            [
                339,
                1
            ],
            [
                221,
                0
            ],
            [
                221,
                1
            ],
            [
                222,
                0
            ],
            [
                222,
                1
            ],
            [
                227,
                0
            ],
            [
                227,
                3
            ],
            [
                228,
                0
            ],
            [
                228,
                1
            ],
            [
                230,
                1
            ],
            [
                230,
                2
            ],
            [
                233,
                1
            ],
            [
                233,
                2
            ],
            [
                240,
                0
            ],
            [
                240,
                2
            ],
            [
                244,
                0
            ],
            [
                244,
                2
            ],
            [
                248,
                1
            ],
            [
                248,
                1
            ],
            [
                248,
                1
            ],
            [
                248,
                1
            ],
            [
                248,
                1
            ],
            [
                248,
                1
            ],
            [
                249,
                0
            ],
            [
                249,
                1
            ],
            [
                252,
                0
            ],
            [
                252,
                2
            ],
            [
                254,
                1
            ],
            [
                254,
                1
            ],
            [
                256,
                0
            ],
            [
                256,
                2
            ],
            [
                258,
                0
            ],
            [
                258,
                2
            ],
            [
                260,
                0
            ],
            [
                260,
                2
            ],
            [
                262,
                1
            ],
            [
                262,
                1
            ],
            [
                275,
                1
            ],
            [
                275,
                1
            ],
            [
                275,
                1
            ],
            [
                275,
                1
            ],
            [
                275,
                1
            ],
            [
                278,
                0
            ],
            [
                278,
                1
            ],
            [
                281,
                0
            ],
            [
                281,
                1
            ],
            [
                282,
                1
            ],
            [
                282,
                1
            ],
            [
                284,
                0
            ],
            [
                284,
                1
            ],
            [
                286,
                0
            ],
            [
                286,
                1
            ],
            [
                287,
                0
            ],
            [
                287,
                1
            ]
        ],
        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */ , $$ /* vstack */ , _$ /* lstack */ ) {
            /* this == yyval */ var $0 = $$.length - 1;
            switch(yystate){
                case 1:
                    // Set parser options
                    $$[$0 - 1] = $$[$0 - 1] || {};
                    if (Parser.base) $$[$0 - 1].base = Parser.base;
                    Parser.base = "";
                    $$[$0 - 1].prefixes = Parser.prefixes;
                    Parser.prefixes = null;
                    if (Parser.pathOnly) {
                        if ($$[$0 - 1].type === "path" || "termType" in $$[$0 - 1]) return $$[$0 - 1];
                        throw new Error("Received full SPARQL query in path only mode");
                    } else if ($$[$0 - 1].type === "path" || "termType" in $$[$0 - 1]) throw new Error("Received only path in full SPARQL mode");
                    // Ensure that blank nodes are not used across INSERT DATA clauses
                    if ($$[$0 - 1].type === "update") {
                        const insertBnodesAll = {};
                        for (const update of $$[$0 - 1].updates)if (update.updateType === "insert") {
                            // Collect bnodes for current insert clause
                            const insertBnodes = {};
                            for (const operation of update.insert){
                                if (operation.type === "bgp" || operation.type === "graph") for (const triple of operation.triples){
                                    if (triple.subject.termType === "BlankNode") insertBnodes[triple.subject.value] = true;
                                    if (triple.predicate.termType === "BlankNode") insertBnodes[triple.predicate.value] = true;
                                    if (triple.object.termType === "BlankNode") insertBnodes[triple.object.value] = true;
                                }
                            }
                            // Check if the inserting bnodes don't clash with bnodes from a previous insert clause
                            for (const bnode of Object.keys(insertBnodes)){
                                if (insertBnodesAll[bnode]) throw new Error("Detected reuse blank node across different INSERT DATA clauses");
                                insertBnodesAll[bnode] = true;
                            }
                        }
                    }
                    return $$[$0 - 1];
                case 2:
                    this.$ = {
                        ...$$[$0 - 1],
                        ...$$[$0],
                        type: "query"
                    };
                    break;
                case 4:
                    Parser.base = resolveIRI($$[$0]);
                    break;
                case 5:
                    if (!Parser.prefixes) Parser.prefixes = {};
                    $$[$0 - 1] = $$[$0 - 1].substr(0, $$[$0 - 1].length - 1);
                    $$[$0] = resolveIRI($$[$0]);
                    Parser.prefixes[$$[$0 - 1]] = $$[$0];
                    break;
                case 6:
                    this.$ = {
                        ...$$[$0 - 3],
                        ...groupDatasets($$[$0 - 2]),
                        ...$$[$0 - 1],
                        ...$$[$0]
                    };
                    break;
                case 7:
                    // Check for projection of ungrouped variable
                    if (!Parser.skipValidation) {
                        const counts = flatten($$[$0 - 3].variables.map((vars)=>getAggregatesOfExpression(vars.expression))).some((agg)=>agg.aggregation === "count" && !(agg.expression instanceof Wildcard));
                        if (counts || $$[$0].group) for (const selectVar of $$[$0 - 3].variables){
                            if (selectVar.termType === "Variable") {
                                if (!$$[$0].group || !$$[$0].group.map((groupVar)=>getExpressionId(groupVar)).includes(getExpressionId(selectVar))) throw Error("Projection of ungrouped variable (?" + getExpressionId(selectVar) + ")");
                            } else if (getAggregatesOfExpression(selectVar.expression).length === 0) {
                                const usedVars = getVariablesFromExpression(selectVar.expression);
                                for (const usedVar of usedVars){
                                    if (!$$[$0].group || !$$[$0].group.map || !$$[$0].group.map((groupVar)=>getExpressionId(groupVar)).includes(getExpressionId(usedVar))) throw Error("Use of ungrouped variable in projection of operation (?" + getExpressionId(usedVar) + ")");
                                }
                            }
                        }
                    }
                    // Check if id of each AS-selected column is not yet bound by subquery
                    const subqueries = $$[$0 - 1].where.filter((w)=>w.type === "query");
                    if (subqueries.length > 0) {
                        const selectedVarIds = $$[$0 - 3].variables.filter((v)=>v.variable && v.variable.value).map((v)=>v.variable.value);
                        const subqueryIds = flatten(subqueries.map((sub)=>sub.variables)).map((v)=>v.value || v.variable.value);
                        for (const selectedVarId of selectedVarIds){
                            if (subqueryIds.indexOf(selectedVarId) >= 0) throw Error("Target id of 'AS' (?" + selectedVarId + ") already used in subquery");
                        }
                    }
                    this.$ = extend($$[$0 - 3], groupDatasets($$[$0 - 2]), $$[$0 - 1], $$[$0]);
                    break;
                case 8:
                    this.$ = extend({
                        queryType: "CONSTRUCT",
                        template: $$[$0 - 3]
                    }, groupDatasets($$[$0 - 2]), $$[$0 - 1], $$[$0]);
                    break;
                case 9:
                    this.$ = extend({
                        queryType: "CONSTRUCT",
                        template: $$[$0 - 2] = $$[$0 - 2] ? $$[$0 - 2].triples : []
                    }, groupDatasets($$[$0 - 5]), {
                        where: [
                            {
                                type: "bgp",
                                triples: appendAllTo([], $$[$0 - 2])
                            }
                        ]
                    }, $$[$0]);
                    break;
                case 10:
                    this.$ = extend({
                        queryType: "DESCRIBE",
                        variables: $$[$0 - 3] === "*" ? [
                            new Wildcard()
                        ] : $$[$0 - 3]
                    }, groupDatasets($$[$0 - 2]), $$[$0 - 1], $$[$0]);
                    break;
                case 11:
                    this.$ = extend({
                        queryType: "ASK"
                    }, groupDatasets($$[$0 - 2]), $$[$0 - 1], $$[$0]);
                    break;
                case 12:
                    this.$ = extend($$[$0 - 1], {
                        variables: [
                            new Wildcard()
                        ]
                    });
                    break;
                case 13:
                    // Check if id of each selected column is different
                    const selectedVarIds = $$[$0].map((v)=>v.value || v.variable.value);
                    const duplicates = getDuplicatesInArray(selectedVarIds);
                    if (duplicates.length > 0) throw Error("Two or more of the resulting columns have the same name (?" + duplicates[0] + ")");
                    this.$ = extend($$[$0 - 1], {
                        variables: $$[$0]
                    });
                    break;
                case 14:
                    this.$ = extend({
                        queryType: "SELECT"
                    }, $$[$0] && ($$[$0 - 1] = lowercase($$[$0]), $$[$0] = {}, $$[$0][$$[$0 - 1]] = true, $$[$0]));
                    break;
                case 16:
                case 27:
                    this.$ = expression($$[$0 - 3], {
                        variable: $$[$0 - 1]
                    });
                    break;
                case 17:
                case 18:
                    this.$ = extend($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], {
                        type: "query"
                    });
                    break;
                case 19:
                case 58:
                    this.$ = {
                        iri: $$[$0],
                        named: !!$$[$0 - 1]
                    };
                    break;
                case 20:
                    this.$ = {
                        where: $$[$0].patterns
                    };
                    break;
                case 21:
                    this.$ = extend($$[$0 - 1], $$[$0]);
                    break;
                case 22:
                    this.$ = extend($$[$0 - 2], $$[$0 - 1], $$[$0]);
                    break;
                case 23:
                    this.$ = {
                        group: $$[$0]
                    };
                    break;
                case 24:
                case 25:
                case 28:
                case 31:
                case 33:
                case 34:
                    this.$ = expression($$[$0]);
                    break;
                case 26:
                    this.$ = expression($$[$0 - 1]);
                    break;
                case 29:
                    this.$ = {
                        having: $$[$0]
                    };
                    break;
                case 30:
                    this.$ = {
                        order: $$[$0]
                    };
                    break;
                case 32:
                    this.$ = expression($$[$0], {
                        descending: true
                    });
                    break;
                case 35:
                    this.$ = {
                        limit: toInt($$[$0])
                    };
                    break;
                case 36:
                    this.$ = {
                        offset: toInt($$[$0])
                    };
                    break;
                case 37:
                    this.$ = {
                        limit: toInt($$[$0 - 2]),
                        offset: toInt($$[$0])
                    };
                    break;
                case 38:
                    this.$ = {
                        limit: toInt($$[$0]),
                        offset: toInt($$[$0 - 2])
                    };
                    break;
                case 39:
                case 43:
                    this.$ = {
                        type: "values",
                        values: $$[$0]
                    };
                    break;
                case 40:
                case 84:
                    this.$ = $$[$0 - 1].map((v)=>({
                            [$$[$0 - 3]]: v
                        }));
                    break;
                case 41:
                case 85:
                    this.$ = $$[$0 - 1].map(()=>({}));
                    break;
                case 42:
                case 86:
                    var length = $$[$0 - 4].length;
                    $$[$0 - 4] = $$[$0 - 4].map(toVar);
                    this.$ = $$[$0 - 1].map(function(values) {
                        if (values.length !== length) throw Error("Inconsistent VALUES length");
                        var valuesObject = {};
                        for(var i = 0; i < length; i++)valuesObject["?" + $$[$0 - 4][i].value] = values[i];
                        return valuesObject;
                    });
                    break;
                case 44:
                case 65:
                case 100:
                case 126:
                case 175:
                    this.$ = $$[$0 - 1];
                    break;
                case 45:
                    this.$ = {
                        type: "update",
                        updates: appendTo($$[$0 - 2], $$[$0 - 1])
                    };
                    break;
                case 46:
                    this.$ = extend({
                        type: "load",
                        silent: !!$$[$0 - 2],
                        source: $$[$0 - 1]
                    }, $$[$0] && {
                        destination: $$[$0]
                    });
                    break;
                case 47:
                    this.$ = {
                        type: lowercase($$[$0 - 2]),
                        silent: !!$$[$0 - 1],
                        graph: $$[$0]
                    };
                    break;
                case 48:
                    this.$ = {
                        type: lowercase($$[$0 - 4]),
                        silent: !!$$[$0 - 3],
                        source: $$[$0 - 2],
                        destination: $$[$0]
                    };
                    break;
                case 49:
                    this.$ = {
                        type: "create",
                        silent: !!$$[$0 - 2],
                        graph: {
                            type: "graph",
                            name: $$[$0]
                        }
                    };
                    break;
                case 50:
                    this.$ = {
                        updateType: "insert",
                        insert: ensureNoVariables($$[$0])
                    };
                    break;
                case 51:
                    this.$ = {
                        updateType: "delete",
                        delete: ensureNoBnodes(ensureNoVariables($$[$0]))
                    };
                    break;
                case 52:
                    this.$ = {
                        updateType: "deletewhere",
                        delete: ensureNoBnodes($$[$0])
                    };
                    break;
                case 53:
                    this.$ = {
                        updateType: "insertdelete",
                        ...$$[$0 - 4],
                        ...$$[$0 - 3],
                        ...groupDatasets($$[$0 - 2], "using"),
                        where: $$[$0].patterns
                    };
                    break;
                case 54:
                case 57:
                case 62:
                case 167:
                case 191:
                case 236:
                    this.$ = $$[$0];
                    break;
                case 55:
                    this.$ = {
                        delete: ensureNoBnodes($$[$0 - 1]),
                        insert: $$[$0] || []
                    };
                    break;
                case 56:
                    this.$ = {
                        delete: [],
                        insert: $$[$0]
                    };
                    break;
                case 59:
                    this.$ = {
                        graph: $$[$0]
                    };
                    break;
                case 60:
                    this.$ = {
                        type: "graph",
                        default: true
                    };
                    break;
                case 61:
                case 63:
                    this.$ = {
                        type: "graph",
                        name: $$[$0]
                    };
                    break;
                case 64:
                    this.$ = {
                        [lowercase($$[$0])]: true
                    };
                    break;
                case 66:
                    this.$ = $$[$0 - 1] ? unionAll($$[$0], [
                        $$[$0 - 1]
                    ]) : unionAll($$[$0]);
                    break;
                case 67:
                    var graph = extend($$[$0 - 3] || {
                        triples: []
                    }, {
                        type: "graph",
                        name: $$[$0 - 5]
                    });
                    this.$ = $$[$0] ? [
                        graph,
                        $$[$0]
                    ] : [
                        graph
                    ];
                    break;
                case 68:
                case 73:
                    this.$ = {
                        type: "bgp",
                        triples: unionAll($$[$0 - 2], [
                            $$[$0 - 1]
                        ])
                    };
                    break;
                case 69:
                    this.$ = {
                        type: "group",
                        patterns: [
                            $$[$0 - 1]
                        ]
                    };
                    break;
                case 70:
                    // For every binding
                    for (const binding of $$[$0 - 1].filter((el)=>el.type === "bind")){
                        const index = $$[$0 - 1].indexOf(binding);
                        const boundVars = new Set();
                        //Collect all bounded variables before the binding
                        for (const el of $$[$0 - 1].slice(0, index))if (el.type === "group" || el.type === "bgp") getBoundVarsFromGroupGraphPattern(el).forEach((boundVar)=>boundVars.add(boundVar));
                        // If binding with a non-free variable, throw error
                        if (boundVars.has(binding.variable.value)) throw Error("Variable used to bind is already bound (?" + binding.variable.value + ")");
                    }
                    this.$ = {
                        type: "group",
                        patterns: $$[$0 - 1]
                    };
                    break;
                case 71:
                    this.$ = $$[$0 - 1] ? unionAll([
                        $$[$0 - 1]
                    ], $$[$0]) : unionAll($$[$0]);
                    break;
                case 72:
                    this.$ = $$[$0] ? [
                        $$[$0 - 2],
                        $$[$0]
                    ] : $$[$0 - 2];
                    break;
                case 75:
                    this.$ = extend($$[$0], {
                        type: "optional"
                    });
                    break;
                case 76:
                    this.$ = extend($$[$0], {
                        type: "minus"
                    });
                    break;
                case 77:
                    this.$ = extend($$[$0], {
                        type: "graph",
                        name: $$[$0 - 1]
                    });
                    break;
                case 78:
                    this.$ = extend($$[$0], {
                        type: "service",
                        name: $$[$0 - 1],
                        silent: !!$$[$0 - 2]
                    });
                    break;
                case 79:
                    this.$ = {
                        type: "filter",
                        expression: $$[$0]
                    };
                    break;
                case 80:
                    this.$ = {
                        type: "bind",
                        variable: $$[$0 - 1],
                        expression: $$[$0 - 3]
                    };
                    break;
                case 89:
                    this.$ = ensureSparqlStar($$[$0]);
                    break;
                case 90:
                    this.$ = undefined;
                    break;
                case 91:
                    this.$ = $$[$0 - 1].length ? {
                        type: "union",
                        patterns: unionAll($$[$0 - 1].map(degroupSingle), [
                            degroupSingle($$[$0])
                        ])
                    } : $$[$0];
                    break;
                case 95:
                    this.$ = {
                        ...$$[$0],
                        function: $$[$0 - 1]
                    };
                    break;
                case 96:
                    this.$ = {
                        type: "functionCall",
                        args: []
                    };
                    break;
                case 97:
                    this.$ = {
                        type: "functionCall",
                        args: appendTo($$[$0 - 2], $$[$0 - 1]),
                        distinct: !!$$[$0 - 3]
                    };
                    break;
                case 98:
                case 115:
                case 128:
                case 247:
                case 249:
                case 251:
                case 253:
                case 255:
                case 263:
                case 267:
                case 297:
                case 299:
                case 303:
                case 307:
                case 328:
                case 341:
                case 349:
                case 355:
                case 361:
                case 367:
                case 369:
                case 373:
                case 375:
                case 379:
                case 381:
                case 385:
                case 391:
                case 395:
                case 401:
                case 405:
                case 409:
                case 411:
                case 420:
                case 428:
                case 430:
                case 440:
                case 444:
                case 446:
                case 448:
                    this.$ = [];
                    break;
                case 99:
                    this.$ = appendTo($$[$0 - 2], $$[$0 - 1]);
                    break;
                case 101:
                    this.$ = unionAll($$[$0 - 2], [
                        $$[$0 - 1]
                    ]);
                    break;
                case 102:
                case 112:
                    this.$ = applyAnnotations($$[$0].map((t)=>extend(triple($$[$0 - 1]), t)));
                    break;
                case 103:
                    this.$ = applyAnnotations(appendAllTo($$[$0].map((t)=>extend(triple($$[$0 - 1].entity), t)), $$[$0 - 1].triples)) /* the subject is a blank node, possibly with more triples */ ;
                    break;
                case 105:
                    this.$ = unionAll([
                        $$[$0 - 1]
                    ], $$[$0]);
                    break;
                case 106:
                    this.$ = unionAll($$[$0]);
                    break;
                case 107:
                    this.$ = objectListToTriples($$[$0 - 1], $$[$0]);
                    break;
                case 109:
                case 237:
                    this.$ = Parser.factory.namedNode(RDF_TYPE);
                    break;
                case 110:
                case 118:
                    this.$ = appendTo($$[$0 - 1], $$[$0]);
                    break;
                case 111:
                    this.$ = $$[$0] ? {
                        annotation: $$[$0],
                        object: $$[$0 - 1]
                    } : $$[$0 - 1];
                    break;
                case 113:
                    this.$ = !$$[$0] ? $$[$0 - 1].triples : applyAnnotations(appendAllTo($$[$0].map((t)=>extend(triple($$[$0 - 1].entity), t)), $$[$0 - 1].triples)) /* the subject is a blank node, possibly with more triples */ ;
                    break;
                case 114:
                    this.$ = objectListToTriples(...$$[$0 - 1], $$[$0]);
                    break;
                case 116:
                    this.$ = objectListToTriples(...$$[$0]);
                    break;
                case 117:
                case 159:
                case 163:
                    this.$ = [
                        $$[$0 - 1],
                        $$[$0]
                    ];
                    break;
                case 119:
                    this.$ = $$[$0] ? {
                        object: $$[$0 - 1],
                        annotation: $$[$0]
                    } : $$[$0 - 1];
                    break;
                case 120:
                    this.$ = $$[$0 - 1].length ? path("|", appendTo($$[$0 - 1], $$[$0])) : $$[$0];
                    break;
                case 121:
                    this.$ = $$[$0 - 1].length ? path("/", appendTo($$[$0 - 1], $$[$0])) : $$[$0];
                    break;
                case 122:
                    this.$ = $$[$0] ? path($$[$0], [
                        $$[$0 - 1]
                    ]) : $$[$0 - 1];
                    break;
                case 123:
                    this.$ = $$[$0 - 1] ? path($$[$0 - 1], [
                        $$[$0]
                    ]) : $$[$0];
                    break;
                case 125:
                case 131:
                    this.$ = path($$[$0 - 1], [
                        $$[$0]
                    ]);
                    break;
                case 129:
                    this.$ = path("|", appendTo($$[$0 - 2], $$[$0 - 1]));
                    break;
                case 132:
                case 134:
                    this.$ = createList($$[$0 - 1]);
                    break;
                case 133:
                case 135:
                    this.$ = createAnonymousObject($$[$0 - 1]);
                    break;
                case 140:
                    this.$ = {
                        entity: $$[$0],
                        triples: []
                    };
                    break;
                case 145:
                    this.$ = toVar($$[$0]);
                    break;
                case 149:
                    this.$ = Parser.factory.namedNode(RDF_NIL);
                    break;
                case 151:
                case 153:
                case 158:
                case 162:
                    this.$ = createOperationTree($$[$0 - 1], $$[$0]);
                    break;
                case 152:
                    this.$ = [
                        "||",
                        $$[$0]
                    ];
                    break;
                case 154:
                    this.$ = [
                        "&&",
                        $$[$0]
                    ];
                    break;
                case 156:
                    this.$ = operation($$[$0 - 1], [
                        $$[$0 - 2],
                        $$[$0]
                    ]);
                    break;
                case 157:
                    this.$ = operation($$[$0 - 2] ? "notin" : "in", [
                        $$[$0 - 3],
                        $$[$0]
                    ]);
                    break;
                case 160:
                    this.$ = [
                        "+",
                        createOperationTree($$[$0 - 1], $$[$0])
                    ];
                    break;
                case 161:
                    var negatedLiteral = createTypedLiteral($$[$0 - 1].value.replace("-", ""), $$[$0 - 1].datatype);
                    this.$ = [
                        "-",
                        createOperationTree(negatedLiteral, $$[$0])
                    ];
                    break;
                case 164:
                    this.$ = operation("UPLUS", [
                        $$[$0]
                    ]);
                    break;
                case 165:
                    this.$ = operation($$[$0 - 1], [
                        $$[$0]
                    ]);
                    break;
                case 166:
                    this.$ = operation("UMINUS", [
                        $$[$0]
                    ]);
                    break;
                case 177:
                    this.$ = operation(lowercase($$[$0 - 1]));
                    break;
                case 178:
                    this.$ = operation(lowercase($$[$0 - 3]), [
                        $$[$0 - 1]
                    ]);
                    break;
                case 179:
                    this.$ = ensureSparqlStar(operation(lowercase($$[$0 - 3]), [
                        $$[$0 - 1]
                    ]));
                    break;
                case 180:
                    this.$ = operation(lowercase($$[$0 - 5]), [
                        $$[$0 - 3],
                        $$[$0 - 1]
                    ]);
                    break;
                case 181:
                    this.$ = operation(lowercase($$[$0 - 7]), [
                        $$[$0 - 5],
                        $$[$0 - 3],
                        $$[$0 - 1]
                    ]);
                    break;
                case 182:
                    this.$ = ensureSparqlStar(operation(lowercase($$[$0 - 7]), [
                        $$[$0 - 5],
                        $$[$0 - 3],
                        $$[$0 - 1]
                    ]));
                    break;
                case 183:
                    this.$ = operation(lowercase($$[$0 - 1]), $$[$0]);
                    break;
                case 184:
                    this.$ = operation("bound", [
                        toVar($$[$0 - 1])
                    ]);
                    break;
                case 185:
                    this.$ = operation($$[$0 - 1], []);
                    break;
                case 186:
                    this.$ = operation($$[$0 - 3], [
                        $$[$0 - 1]
                    ]);
                    break;
                case 187:
                    this.$ = operation($$[$0 - 2] ? "notexists" : "exists", [
                        degroupSingle($$[$0])
                    ]);
                    break;
                case 188:
                case 189:
                    this.$ = expression($$[$0 - 1], {
                        type: "aggregate",
                        aggregation: lowercase($$[$0 - 4]),
                        distinct: !!$$[$0 - 2]
                    });
                    break;
                case 190:
                    this.$ = expression($$[$0 - 2], {
                        type: "aggregate",
                        aggregation: lowercase($$[$0 - 5]),
                        distinct: !!$$[$0 - 3],
                        separator: typeof $$[$0 - 1] === "string" ? $$[$0 - 1] : " "
                    });
                    break;
                case 192:
                    this.$ = createTypedLiteral($$[$0]);
                    break;
                case 193:
                    this.$ = createLangLiteral($$[$0 - 1], lowercase($$[$0].substr(1)));
                    break;
                case 194:
                    this.$ = createTypedLiteral($$[$0 - 2], $$[$0]);
                    break;
                case 195:
                case 204:
                    this.$ = createTypedLiteral($$[$0], XSD_INTEGER);
                    break;
                case 196:
                case 205:
                    this.$ = createTypedLiteral($$[$0], XSD_DECIMAL);
                    break;
                case 197:
                case 206:
                    this.$ = createTypedLiteral(lowercase($$[$0]), XSD_DOUBLE);
                    break;
                case 200:
                    this.$ = createTypedLiteral($$[$0].toLowerCase(), XSD_BOOLEAN);
                    break;
                case 201:
                    this.$ = createTypedLiteral($$[$0].substr(1), XSD_INTEGER);
                    break;
                case 202:
                    this.$ = createTypedLiteral($$[$0].substr(1), XSD_DECIMAL);
                    break;
                case 203:
                    this.$ = createTypedLiteral($$[$0].substr(1).toLowerCase(), XSD_DOUBLE);
                    break;
                case 207:
                case 208:
                    this.$ = unescapeString($$[$0], 1);
                    break;
                case 209:
                case 210:
                    this.$ = unescapeString($$[$0], 3);
                    break;
                case 211:
                    this.$ = Parser.factory.namedNode(resolveIRI($$[$0]));
                    break;
                case 213:
                    var namePos = $$[$0].indexOf(":"), prefix = $$[$0].substr(0, namePos), expansion = Parser.prefixes[prefix];
                    if (!expansion) throw new Error("Unknown prefix: " + prefix);
                    var uriString = resolveIRI(expansion + $$[$0].substr(namePos + 1));
                    this.$ = Parser.factory.namedNode(uriString);
                    break;
                case 214:
                    $$[$0] = $$[$0].substr(0, $$[$0].length - 1);
                    if (!($$[$0] in Parser.prefixes)) throw new Error("Unknown prefix: " + $$[$0]);
                    var uriString = resolveIRI(Parser.prefixes[$$[$0]]);
                    this.$ = Parser.factory.namedNode(uriString);
                    break;
                case 215:
                    this.$ = blank($$[$0].replace(/^(_:)/, ""));
                    break;
                case 216:
                    this.$ = blank();
                    break;
                case 217:
                case 218:
                case 232:
                    this.$ = ensureSparqlStar(nestedTriple($$[$0 - 3], $$[$0 - 2], $$[$0 - 1]));
                    break;
                case 230:
                case 231:
                    this.$ = ensureSparqlStar($$[$0 - 1]);
                    break;
                case 248:
                case 250:
                case 252:
                case 254:
                case 256:
                case 260:
                case 264:
                case 268:
                case 270:
                case 292:
                case 294:
                case 296:
                case 298:
                case 300:
                case 302:
                case 304:
                case 306:
                case 329:
                case 342:
                case 356:
                case 368:
                case 370:
                case 372:
                case 374:
                case 392:
                case 402:
                case 425:
                case 427:
                case 429:
                case 431:
                case 441:
                case 445:
                case 447:
                case 449:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 259:
                case 269:
                case 291:
                case 293:
                case 295:
                case 301:
                case 305:
                case 371:
                case 424:
                case 426:
                    this.$ = [
                        $$[$0]
                    ];
                    break;
                case 308:
                    $$[$0 - 3].push($$[$0 - 2]);
                    break;
                case 350:
                case 362:
                case 376:
                case 380:
                case 382:
                case 386:
                case 396:
                case 406:
                case 410:
                case 412:
                case 421:
                    $$[$0 - 2].push($$[$0 - 1]);
                    break;
            }
        },
        table: [
            o($V0, $V1, {
                3: 1,
                4: 2,
                10: 3
            }),
            {
                1: [
                    3
                ]
            },
            o($V2, [
                2,
                307
            ], {
                5: 4,
                7: 5,
                321: 6,
                214: 7,
                8: 8,
                96: 9,
                215: 10,
                17: 11,
                21: 12,
                97: 16,
                38: 17,
                6: [
                    2,
                    238
                ],
                13: $V3,
                16: $V3,
                45: $V3,
                197: $V3,
                224: $V3,
                229: $V3,
                308: $V3,
                24: [
                    1,
                    13
                ],
                32: [
                    1,
                    14
                ],
                36: [
                    1,
                    15
                ],
                41: $V4
            }),
            o([
                6,
                13,
                16,
                24,
                32,
                36,
                41,
                45,
                100,
                110,
                113,
                115,
                116,
                123,
                126,
                131,
                197,
                224,
                229,
                308,
                329,
                330,
                331,
                332,
                333
            ], [
                2,
                3
            ], {
                322: 19,
                11: 20,
                14: 21,
                12: [
                    1,
                    22
                ],
                15: [
                    1,
                    23
                ]
            }),
            {
                6: [
                    1,
                    24
                ]
            },
            {
                6: [
                    2,
                    240
                ]
            },
            {
                6: [
                    2,
                    241
                ]
            },
            {
                6: [
                    2,
                    242
                ]
            },
            {
                6: [
                    2,
                    243
                ],
                9: 25,
                84: 26,
                85: $V5
            },
            {
                6: [
                    2,
                    239
                ]
            },
            o($V6, [
                2,
                411
            ], {
                216: 28,
                217: 29
            }),
            o($V7, [
                2,
                249
            ], {
                18: 30
            }),
            o($V7, [
                2,
                251
            ], {
                22: 31
            }),
            o($V8, [
                2,
                255
            ], {
                25: 32,
                27: 33,
                29: [
                    1,
                    34
                ]
            }),
            {
                13: $V9,
                16: $Va,
                33: 35,
                39: [
                    1,
                    37
                ],
                44: 39,
                55: 40,
                87: $Vb,
                139: 38,
                307: 43,
                308: $Vc,
                323: 36
            },
            o($V7, [
                2,
                267
            ], {
                37: 46
            }),
            o($Vd, [
                2,
                326
            ], {
                98: 47,
                103: 49,
                106: 50,
                117: 55,
                130: 61,
                100: [
                    1,
                    48
                ],
                110: [
                    1,
                    51
                ],
                113: [
                    1,
                    52
                ],
                115: [
                    1,
                    53
                ],
                116: [
                    1,
                    54
                ],
                131: [
                    1,
                    62
                ],
                329: [
                    1,
                    56
                ],
                330: [
                    1,
                    57
                ],
                331: [
                    1,
                    58
                ],
                332: [
                    1,
                    59
                ],
                333: [
                    1,
                    60
                ]
            }),
            {
                39: [
                    1,
                    63
                ],
                40: 64,
                43: 65,
                44: 66,
                45: $Ve,
                87: $Vb
            },
            o($Vf, [
                2,
                273
            ], {
                42: 68,
                324: 69,
                325: [
                    1,
                    70
                ],
                326: [
                    1,
                    71
                ]
            }),
            o($V0, [
                2,
                248
            ]),
            o($V0, [
                2,
                245
            ]),
            o($V0, [
                2,
                246
            ]),
            {
                13: [
                    1,
                    72
                ]
            },
            {
                16: [
                    1,
                    73
                ]
            },
            {
                1: [
                    2,
                    1
                ]
            },
            {
                6: [
                    2,
                    2
                ]
            },
            {
                6: [
                    2,
                    244
                ]
            },
            {
                45: [
                    1,
                    77
                ],
                85: [
                    1,
                    78
                ],
                86: 74,
                87: [
                    1,
                    75
                ],
                89: [
                    1,
                    76
                ]
            },
            o([
                6,
                13,
                16,
                45,
                48,
                82,
                87,
                89,
                231,
                294,
                295,
                296,
                297,
                298,
                299,
                300,
                301,
                302,
                303,
                304,
                305,
                306,
                308,
                309,
                310,
                312
            ], [
                2,
                120
            ], {
                337: [
                    1,
                    79
                ]
            }),
            o($Vg, [
                2,
                418
            ], {
                218: 80,
                222: 81,
                229: [
                    1,
                    82
                ]
            }),
            {
                19: 83,
                28: $Vh,
                29: $Vi,
                52: 84,
                53: $Vj,
                56: 85
            },
            {
                19: 88,
                28: $Vh,
                29: $Vi,
                52: 89,
                53: $Vj,
                56: 85
            },
            o($V7, [
                2,
                253
            ], {
                26: 90
            }),
            {
                28: [
                    1,
                    91
                ],
                52: 92,
                53: $Vj
            },
            o($Vk, [
                2,
                385
            ], {
                181: 93,
                182: 94,
                183: 95,
                31: [
                    2,
                    383
                ]
            }),
            o($Vl, [
                2,
                263
            ], {
                34: 96
            }),
            o($Vl, [
                2,
                261
            ], {
                44: 39,
                55: 40,
                307: 43,
                139: 97,
                13: $V9,
                16: $Va,
                87: $Vb,
                308: $Vc
            }),
            o($Vl, [
                2,
                262
            ]),
            o($Vm, [
                2,
                259
            ]),
            o($Vn, [
                2,
                143
            ]),
            o($Vn, [
                2,
                144
            ]),
            o([
                6,
                13,
                16,
                28,
                29,
                31,
                39,
                45,
                47,
                48,
                53,
                63,
                70,
                73,
                76,
                78,
                81,
                82,
                83,
                85,
                87,
                89,
                112,
                159,
                160,
                161,
                163,
                164,
                193,
                197,
                224,
                229,
                231,
                232,
                242,
                246,
                250,
                263,
                265,
                268,
                269,
                270,
                271,
                272,
                273,
                274,
                276,
                277,
                279,
                280,
                283,
                285,
                290,
                294,
                295,
                296,
                297,
                298,
                299,
                300,
                301,
                302,
                303,
                304,
                305,
                306,
                308,
                309,
                310,
                312,
                314,
                317,
                318,
                335,
                338,
                341,
                342,
                343,
                344,
                345,
                346,
                347,
                348,
                349,
                350,
                351
            ], [
                2,
                145
            ]),
            o($Vo, [
                2,
                211
            ]),
            o($Vo, [
                2,
                212
            ]),
            o($Vo, [
                2,
                213
            ]),
            o($Vo, [
                2,
                214
            ]),
            {
                19: 98,
                28: $Vh,
                29: $Vi,
                52: 99,
                53: $Vj,
                56: 85
            },
            {
                6: [
                    2,
                    309
                ],
                99: 100,
                193: [
                    1,
                    101
                ]
            },
            o($Vp, [
                2,
                311
            ], {
                101: 102,
                328: [
                    1,
                    103
                ]
            }),
            o($Vq, [
                2,
                317
            ], {
                104: 104,
                328: [
                    1,
                    105
                ]
            }),
            o($Vr, [
                2,
                322
            ], {
                107: 106,
                328: [
                    1,
                    107
                ]
            }),
            {
                111: 108,
                112: [
                    2,
                    324
                ],
                328: [
                    1,
                    109
                ]
            },
            {
                29: $Vs,
                114: 110
            },
            {
                29: $Vs,
                114: 112
            },
            {
                29: $Vs,
                114: 113
            },
            {
                118: 114,
                123: [
                    1,
                    115
                ],
                125: 116,
                126: $Vt
            },
            o($Vu, [
                2,
                315
            ]),
            o($Vu, [
                2,
                316
            ]),
            o($Vv, [
                2,
                319
            ]),
            o($Vv, [
                2,
                320
            ]),
            o($Vv, [
                2,
                321
            ]),
            o($Vd, [
                2,
                327
            ]),
            {
                13: $V9,
                16: $Va,
                55: 118,
                307: 43,
                308: $Vc
            },
            o($V7, [
                2,
                12
            ]),
            o($V7, [
                2,
                13
            ], {
                44: 66,
                43: 119,
                45: $Ve,
                87: $Vb
            }),
            o($Vw, [
                2,
                269
            ]),
            o($Vw, [
                2,
                15
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 120,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vf, [
                2,
                14
            ]),
            o($Vf, [
                2,
                274
            ]),
            o($Vf, [
                2,
                271
            ]),
            o($Vf, [
                2,
                272
            ]),
            o($V0, [
                2,
                4
            ]),
            {
                13: [
                    1,
                    177
                ]
            },
            o($V61, [
                2,
                39
            ]),
            {
                29: [
                    1,
                    178
                ]
            },
            {
                29: [
                    1,
                    179
                ]
            },
            {
                87: [
                    1,
                    181
                ],
                91: 180
            },
            {
                45: [
                    1,
                    187
                ],
                87: [
                    1,
                    185
                ],
                89: [
                    1,
                    186
                ],
                93: 182,
                165: 183,
                166: 184
            },
            o($V6, [
                2,
                410
            ]),
            o([
                6,
                13,
                16,
                45,
                48,
                82,
                87,
                89,
                231,
                294,
                295,
                296,
                297,
                298,
                299,
                300,
                301,
                302,
                303,
                304,
                305,
                306,
                308,
                309,
                310,
                312,
                337
            ], [
                2,
                121
            ], {
                338: [
                    1,
                    188
                ]
            }),
            {
                13: $V9,
                16: $Va,
                45: [
                    1,
                    193
                ],
                55: 194,
                197: $V71,
                219: 189,
                220: 190,
                223: 191,
                224: [
                    1,
                    192
                ],
                307: 43,
                308: $Vc
            },
            o($Vg, [
                2,
                419
            ]),
            o($V81, $V91, {
                20: 196,
                59: 197,
                69: 198,
                70: $Va1
            }),
            o($V7, [
                2,
                250
            ]),
            {
                29: $Vb1,
                57: 200
            },
            o($Vp, [
                2,
                279
            ], {
                54: 202,
                327: [
                    1,
                    203
                ]
            }),
            {
                29: [
                    2,
                    282
                ]
            },
            o($Vc1, $Vd1, {
                23: 204,
                58: 205,
                62: 206,
                63: $Ve1
            }),
            o($V7, [
                2,
                252
            ]),
            {
                19: 208,
                28: $Vh,
                29: $Vi,
                52: 209,
                53: $Vj,
                56: 85
            },
            {
                29: [
                    1,
                    210
                ]
            },
            o($V8, [
                2,
                256
            ]),
            {
                31: [
                    1,
                    211
                ]
            },
            {
                31: [
                    2,
                    384
                ]
            },
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $Vf1,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                145: 212,
                172: 221,
                185: 213,
                187: 214,
                231: $Vh1,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($Vl1, [
                2,
                265
            ], {
                56: 85,
                35: 227,
                52: 228,
                19: 229,
                28: $Vh,
                29: $Vi,
                53: $Vj
            }),
            o($Vm, [
                2,
                260
            ]),
            o($Vc1, $Vd1, {
                58: 205,
                62: 206,
                23: 230,
                63: $Ve1
            }),
            o($V7, [
                2,
                268
            ]),
            {
                6: [
                    2,
                    45
                ]
            },
            o($V0, $V1, {
                10: 3,
                4: 231
            }),
            {
                13: $V9,
                16: $Va,
                55: 232,
                307: 43,
                308: $Vc
            },
            o($Vp, [
                2,
                312
            ]),
            {
                105: 233,
                112: $Vm1,
                122: 234,
                132: [
                    1,
                    237
                ],
                134: 235,
                327: [
                    1,
                    238
                ],
                334: [
                    1,
                    239
                ]
            },
            o($Vq, [
                2,
                318
            ]),
            o($Vp, $Vn1, {
                108: 240,
                133: 242,
                112: $Vo1,
                132: $Vp1
            }),
            o($Vr, [
                2,
                323
            ]),
            {
                112: [
                    1,
                    244
                ]
            },
            {
                112: [
                    2,
                    325
                ]
            },
            o($Vq1, [
                2,
                50
            ]),
            o($Vk, $Vr1, {
                135: 245,
                136: 246,
                143: 247,
                144: 248,
                31: $Vs1,
                112: $Vs1
            }),
            o($Vq1, [
                2,
                51
            ]),
            o($Vq1, [
                2,
                52
            ]),
            o($Vt1, [
                2,
                328
            ], {
                119: 249
            }),
            {
                29: $Vs,
                114: 250
            },
            o($Vt1, [
                2,
                56
            ]),
            {
                29: $Vs,
                114: 251
            },
            o($Vd, [
                2,
                59
            ]),
            o($Vw, [
                2,
                270
            ]),
            {
                47: [
                    1,
                    252
                ]
            },
            o($Vu1, [
                2,
                150
            ]),
            o($Vv1, [
                2,
                428
            ], {
                240: 253
            }),
            o($Vw1, [
                2,
                430
            ], {
                244: 254
            }),
            o($Vw1, [
                2,
                155
            ], {
                248: 255,
                249: 256,
                250: [
                    2,
                    438
                ],
                290: [
                    1,
                    257
                ],
                341: [
                    1,
                    258
                ],
                342: [
                    1,
                    259
                ],
                343: [
                    1,
                    260
                ],
                344: [
                    1,
                    261
                ],
                345: [
                    1,
                    262
                ],
                346: [
                    1,
                    263
                ]
            }),
            o($Vx1, [
                2,
                440
            ], {
                252: 264
            }),
            o($Vy1, [
                2,
                448
            ], {
                260: 265
            }),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                255: 154,
                257: 155,
                264: 266,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                255: 154,
                257: 155,
                264: 267,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                255: 154,
                257: 155,
                264: 268,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vy1, [
                2,
                167
            ]),
            o($Vy1, [
                2,
                168
            ]),
            o($Vy1, [
                2,
                169
            ]),
            o($Vy1, [
                2,
                170
            ], {
                176: 269,
                45: $Vz1,
                89: $VA1
            }),
            o($Vy1, [
                2,
                171
            ]),
            o($Vy1, [
                2,
                172
            ]),
            o($Vy1, [
                2,
                173
            ]),
            o($Vy1, [
                2,
                174
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 272,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VB1, [
                2,
                176
            ]),
            {
                89: [
                    1,
                    273
                ]
            },
            {
                45: [
                    1,
                    274
                ]
            },
            {
                45: [
                    1,
                    275
                ]
            },
            {
                45: [
                    1,
                    276
                ]
            },
            {
                45: [
                    1,
                    277
                ]
            },
            {
                45: [
                    1,
                    278
                ]
            },
            {
                45: $VC1,
                89: $VD1,
                179: 279
            },
            {
                45: [
                    1,
                    282
                ]
            },
            {
                45: [
                    1,
                    284
                ],
                89: [
                    1,
                    283
                ]
            },
            {
                279: [
                    1,
                    285
                ]
            },
            o($VE1, [
                2,
                192
            ], {
                292: [
                    1,
                    286
                ],
                293: [
                    1,
                    287
                ]
            }),
            o($VE1, [
                2,
                195
            ]),
            o($VE1, [
                2,
                196
            ]),
            o($VE1, [
                2,
                197
            ]),
            o($VE1, [
                2,
                198
            ]),
            o($VE1, [
                2,
                199
            ]),
            o($VE1, [
                2,
                200
            ]),
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                82: $Vy,
                87: $Vb,
                139: 289,
                172: 291,
                255: 154,
                257: 155,
                266: 290,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                320: 288
            },
            {
                45: [
                    1,
                    292
                ]
            },
            {
                45: [
                    1,
                    293
                ]
            },
            {
                45: [
                    1,
                    294
                ]
            },
            o($VF1, [
                2,
                452
            ]),
            o($VF1, [
                2,
                453
            ]),
            o($VF1, [
                2,
                454
            ]),
            o($VF1, [
                2,
                455
            ]),
            o($VF1, [
                2,
                456
            ]),
            {
                279: [
                    2,
                    458
                ]
            },
            o($VG1, [
                2,
                207
            ]),
            o($VG1, [
                2,
                208
            ]),
            o($VG1, [
                2,
                209
            ]),
            o($VG1, [
                2,
                210
            ]),
            o($VE1, [
                2,
                201
            ]),
            o($VE1, [
                2,
                202
            ]),
            o($VE1, [
                2,
                203
            ]),
            o($VE1, [
                2,
                204
            ]),
            o($VE1, [
                2,
                205
            ]),
            o($VE1, [
                2,
                206
            ]),
            o($V0, [
                2,
                5
            ]),
            o($VH1, [
                2,
                297
            ], {
                88: 295
            }),
            o($VI1, [
                2,
                299
            ], {
                90: 296
            }),
            {
                48: [
                    1,
                    297
                ],
                87: [
                    1,
                    298
                ]
            },
            o($VJ1, [
                2,
                301
            ]),
            o($V61, [
                2,
                43
            ]),
            o($V61, [
                2,
                82
            ]),
            o($V61, [
                2,
                83
            ]),
            {
                29: [
                    1,
                    299
                ]
            },
            {
                29: [
                    1,
                    300
                ]
            },
            {
                87: [
                    1,
                    302
                ],
                169: 301
            },
            o($V6, [
                2,
                412
            ]),
            o($VK1, [
                2,
                123
            ]),
            o($VK1, [
                2,
                416
            ], {
                221: 303,
                339: 304,
                39: [
                    1,
                    306
                ],
                263: [
                    1,
                    307
                ],
                340: [
                    1,
                    305
                ]
            }),
            o($VL1, [
                2,
                124
            ]),
            {
                13: $V9,
                16: $Va,
                45: [
                    1,
                    311
                ],
                55: 194,
                89: [
                    1,
                    310
                ],
                197: $V71,
                223: 312,
                225: 308,
                226: 309,
                229: $VM1,
                307: 43,
                308: $Vc
            },
            o($V6, $V3, {
                215: 10,
                214: 314
            }),
            o($VL1, [
                2,
                236
            ]),
            o($VL1, [
                2,
                237
            ]),
            o($VN1, [
                2,
                6
            ]),
            o($VO1, [
                2,
                287
            ], {
                60: 315,
                72: 316,
                73: [
                    1,
                    317
                ]
            }),
            o($V81, [
                2,
                286
            ]),
            {
                13: $V9,
                16: $Va,
                45: $Vx,
                55: 323,
                67: 321,
                68: 322,
                71: 318,
                77: 320,
                79: 319,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                307: 43,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o([
                6,
                31,
                63,
                70,
                73,
                81,
                83,
                85
            ], [
                2,
                20
            ]),
            o($Vk, $VP1, {
                38: 17,
                49: 324,
                147: 325,
                17: 326,
                21: 327,
                148: 328,
                154: 329,
                155: 330,
                29: $VQ1,
                31: $VQ1,
                85: $VQ1,
                112: $VQ1,
                159: $VQ1,
                160: $VQ1,
                161: $VQ1,
                163: $VQ1,
                164: $VQ1,
                41: $V4
            }),
            {
                13: $V9,
                16: $Va,
                55: 331,
                307: 43,
                308: $Vc
            },
            o($Vp, [
                2,
                280
            ]),
            o($VN1, [
                2,
                7
            ]),
            o($V81, $V91, {
                59: 197,
                69: 198,
                20: 332,
                70: $Va1
            }),
            o($Vc1, [
                2,
                284
            ]),
            {
                64: [
                    1,
                    333
                ]
            },
            o($Vc1, $Vd1, {
                58: 205,
                62: 206,
                23: 334,
                63: $Ve1
            }),
            o($V7, [
                2,
                254
            ]),
            o($Vk, $Vr1, {
                144: 248,
                30: 335,
                143: 336,
                31: [
                    2,
                    257
                ]
            }),
            o($V7, [
                2,
                100
            ]),
            {
                31: [
                    2,
                    387
                ],
                184: 337,
                335: [
                    1,
                    338
                ]
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 342,
                186: 339,
                190: 340,
                195: 341,
                197: $VR1,
                307: 43,
                308: $Vc
            },
            o($VS1, [
                2,
                389
            ], {
                44: 39,
                55: 40,
                307: 43,
                190: 340,
                195: 341,
                139: 342,
                188: 344,
                189: 345,
                186: 346,
                13: $V9,
                16: $Va,
                87: $Vb,
                197: $VR1,
                308: $Vc
            }),
            o($VT1, [
                2,
                227
            ]),
            o($VT1, [
                2,
                228
            ]),
            o($VT1, [
                2,
                229
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $Vf1,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                187: 350,
                200: 348,
                230: 347,
                231: $Vh1,
                234: 349,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 342,
                186: 352,
                190: 340,
                195: 341,
                197: $VR1,
                307: 43,
                308: $Vc
            },
            o($VT1, [
                2,
                146
            ]),
            o($VT1, [
                2,
                147
            ]),
            o($VT1, [
                2,
                148
            ]),
            o($VT1, [
                2,
                149
            ]),
            {
                13: $V9,
                16: $Va,
                44: 354,
                55: 355,
                82: $Vy,
                87: $Vb,
                172: 357,
                237: 356,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 358,
                312: $Vk1,
                313: 353
            },
            o($VU1, [
                2,
                215
            ]),
            o($VU1, [
                2,
                216
            ]),
            o($Vc1, $Vd1, {
                58: 205,
                62: 206,
                23: 359,
                63: $Ve1
            }),
            o($Vl, [
                2,
                264
            ]),
            o($Vl1, [
                2,
                266
            ]),
            o($VN1, [
                2,
                11
            ]),
            o($V2, [
                2,
                308
            ], {
                6: [
                    2,
                    310
                ]
            }),
            o($Vq1, [
                2,
                313
            ], {
                102: 360,
                120: 361,
                121: [
                    1,
                    362
                ]
            }),
            o($Vq1, [
                2,
                47
            ]),
            o($Vq1, [
                2,
                63
            ]),
            o($Vq1, [
                2,
                64
            ]),
            {
                13: $V9,
                16: $Va,
                55: 363,
                307: 43,
                308: $Vc
            },
            o($Vq1, [
                2,
                336
            ]),
            o($Vq1, [
                2,
                337
            ]),
            o($Vq1, [
                2,
                338
            ]),
            {
                109: [
                    1,
                    364
                ]
            },
            o($VV1, [
                2,
                60
            ]),
            {
                13: $V9,
                16: $Va,
                55: 365,
                307: 43,
                308: $Vc
            },
            o($Vp, [
                2,
                335
            ]),
            {
                13: $V9,
                16: $Va,
                55: 366,
                307: 43,
                308: $Vc
            },
            {
                31: [
                    1,
                    367
                ]
            },
            o($VW1, [
                2,
                341
            ], {
                137: 368
            }),
            o($VW1, [
                2,
                340
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $Vf1,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                145: 369,
                172: 221,
                185: 213,
                187: 214,
                231: $Vh1,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            {
                28: [
                    1,
                    370
                ],
                127: 371,
                128: [
                    1,
                    372
                ]
            },
            o($Vt1, [
                2,
                330
            ], {
                124: 373,
                125: 374,
                126: $Vt
            }),
            o($Vt1, [
                2,
                57
            ]),
            {
                44: 375,
                87: $Vb
            },
            o($Vu1, [
                2,
                151
            ], {
                241: 376,
                242: [
                    1,
                    377
                ]
            }),
            o($Vv1, [
                2,
                153
            ], {
                245: 378,
                246: [
                    1,
                    379
                ]
            }),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                247: 380,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                250: [
                    1,
                    381
                ]
            },
            o($VX1, [
                2,
                432
            ]),
            o($VX1, [
                2,
                433
            ]),
            o($VX1, [
                2,
                434
            ]),
            o($VX1, [
                2,
                435
            ]),
            o($VX1, [
                2,
                436
            ]),
            o($VX1, [
                2,
                437
            ]),
            {
                250: [
                    2,
                    439
                ]
            },
            o([
                47,
                48,
                193,
                242,
                246,
                250,
                272,
                290,
                341,
                342,
                343,
                344,
                345,
                346
            ], [
                2,
                158
            ], {
                253: 382,
                254: 383,
                255: 384,
                257: 385,
                263: [
                    1,
                    386
                ],
                265: [
                    1,
                    387
                ],
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW
            }),
            o($Vx1, [
                2,
                162
            ], {
                261: 388,
                262: 389,
                39: $VY1,
                338: $VZ1
            }),
            o($Vy1, [
                2,
                164
            ]),
            o($Vy1, [
                2,
                165
            ]),
            o($Vy1, [
                2,
                166
            ]),
            o($VB1, [
                2,
                95
            ]),
            o($VB1, [
                2,
                96
            ]),
            o($VX1, [
                2,
                377
            ], {
                177: 392,
                325: [
                    1,
                    393
                ]
            }),
            {
                48: [
                    1,
                    394
                ]
            },
            o($VB1, [
                2,
                177
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 395,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 396,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 397,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 398,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 399,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VB1, [
                2,
                183
            ]),
            o($VB1, [
                2,
                98
            ]),
            o($VX1, [
                2,
                381
            ], {
                180: 400
            }),
            {
                87: [
                    1,
                    401
                ]
            },
            o($VB1, [
                2,
                185
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 402,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                29: $Vb1,
                57: 403
            },
            o($VE1, [
                2,
                193
            ]),
            {
                13: $V9,
                16: $Va,
                55: 404,
                307: 43,
                308: $Vc
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 342,
                195: 405,
                197: $VR1,
                307: 43,
                308: $Vc
            },
            o($V_1, [
                2,
                233
            ]),
            o($V_1, [
                2,
                234
            ]),
            o($V_1, [
                2,
                235
            ]),
            o($V$1, [
                2,
                459
            ], {
                281: 406,
                325: [
                    1,
                    407
                ]
            }),
            o($VX1, [
                2,
                463
            ], {
                284: 408,
                325: [
                    1,
                    409
                ]
            }),
            o($VX1, [
                2,
                465
            ], {
                286: 410,
                325: [
                    1,
                    411
                ]
            }),
            {
                13: $V9,
                16: $Va,
                31: [
                    1,
                    412
                ],
                55: 414,
                82: $Vy,
                171: 413,
                172: 415,
                173: 416,
                174: $V02,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V12
            },
            {
                31: [
                    1,
                    419
                ],
                89: [
                    1,
                    420
                ]
            },
            {
                29: [
                    1,
                    421
                ]
            },
            o($VJ1, [
                2,
                302
            ]),
            o($VH1, [
                2,
                367
            ], {
                167: 422
            }),
            o($VI1, [
                2,
                369
            ], {
                168: 423
            }),
            {
                48: [
                    1,
                    424
                ],
                87: [
                    1,
                    425
                ]
            },
            o($VJ1, [
                2,
                371
            ]),
            o($VK1, [
                2,
                122
            ]),
            o($VK1, [
                2,
                417
            ]),
            o($VK1, [
                2,
                413
            ]),
            o($VK1, [
                2,
                414
            ]),
            o($VK1, [
                2,
                415
            ]),
            o($VL1, [
                2,
                125
            ]),
            o($VL1, [
                2,
                127
            ]),
            o($VL1, [
                2,
                128
            ]),
            o($V22, [
                2,
                420
            ], {
                227: 426
            }),
            o($VL1, [
                2,
                130
            ]),
            {
                13: $V9,
                16: $Va,
                55: 194,
                197: $V71,
                223: 427,
                307: 43,
                308: $Vc
            },
            {
                48: [
                    1,
                    428
                ]
            },
            o($V32, [
                2,
                289
            ], {
                61: 429,
                80: 430,
                81: [
                    1,
                    431
                ],
                83: [
                    1,
                    432
                ]
            }),
            o($VO1, [
                2,
                288
            ]),
            {
                64: [
                    1,
                    433
                ]
            },
            o($V81, [
                2,
                29
            ], {
                307: 43,
                267: 139,
                275: 146,
                278: 149,
                77: 320,
                67: 321,
                68: 322,
                55: 323,
                79: 434,
                13: $V9,
                16: $Va,
                45: $Vx,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                276: $VI,
                277: $VJ,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            }),
            o($V42, [
                2,
                293
            ]),
            o($V52, [
                2,
                92
            ]),
            o($V52, [
                2,
                93
            ]),
            o($V52, [
                2,
                94
            ]),
            {
                45: $Vz1,
                89: $VA1,
                176: 269
            },
            {
                31: [
                    1,
                    435
                ]
            },
            {
                31: [
                    1,
                    436
                ]
            },
            {
                19: 437,
                28: $Vh,
                29: $Vi,
                56: 85
            },
            {
                19: 438,
                28: $Vh,
                29: $Vi,
                56: 85
            },
            o($V62, [
                2,
                355
            ], {
                149: 439
            }),
            o($V62, [
                2,
                354
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $V72,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                156: 440,
                172: 221,
                185: 441,
                203: 442,
                231: $V82,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($Vl, [
                2,
                19
            ]),
            o($V32, [
                2,
                21
            ]),
            {
                13: $V9,
                16: $Va,
                44: 450,
                45: $V92,
                55: 323,
                65: 445,
                66: 446,
                67: 447,
                68: 448,
                87: $Vb,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                307: 43,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VN1, [
                2,
                8
            ]),
            {
                31: [
                    1,
                    451
                ]
            },
            {
                31: [
                    2,
                    258
                ]
            },
            {
                31: [
                    2,
                    101
                ]
            },
            o($Vk, [
                2,
                386
            ], {
                31: [
                    2,
                    388
                ]
            }),
            o($VS1, [
                2,
                102
            ]),
            o($Va2, [
                2,
                391
            ], {
                191: 452
            }),
            o($Vk, [
                2,
                395
            ], {
                196: 453,
                198: 454
            }),
            o($Vk, [
                2,
                108
            ]),
            o($Vk, [
                2,
                109
            ]),
            o($VS1, [
                2,
                103
            ]),
            o($VS1, [
                2,
                104
            ]),
            o($VS1, [
                2,
                390
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $Vf1,
                48: [
                    1,
                    455
                ],
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                187: 350,
                200: 456,
                231: $Vh1,
                234: 349,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($Vb2, [
                2,
                424
            ]),
            o($Vc2, [
                2,
                136
            ]),
            o($Vc2, [
                2,
                137
            ]),
            o($Vd2, [
                2,
                140
            ]),
            {
                232: [
                    1,
                    457
                ]
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 342,
                195: 458,
                197: $VR1,
                307: 43,
                308: $Vc
            },
            o($V_1, [
                2,
                219
            ]),
            o($V_1, [
                2,
                220
            ]),
            o($V_1, [
                2,
                221
            ]),
            o($V_1, [
                2,
                222
            ]),
            o($V_1, [
                2,
                223
            ]),
            o($VN1, [
                2,
                10
            ]),
            o($Vq1, [
                2,
                46
            ]),
            o($Vq1, [
                2,
                314
            ]),
            {
                112: $Vm1,
                122: 459
            },
            o($Vq1, [
                2,
                62
            ]),
            o($Vp, $Vn1, {
                133: 242,
                108: 460,
                112: $Vo1,
                132: $Vp1
            }),
            o($VV1, [
                2,
                61
            ]),
            o($Vq1, [
                2,
                49
            ]),
            o([
                6,
                28,
                126,
                128,
                193
            ], [
                2,
                65
            ]),
            {
                31: [
                    2,
                    66
                ],
                112: [
                    1,
                    462
                ],
                138: 461
            },
            o($VW1, [
                2,
                351
            ], {
                146: 463,
                335: [
                    1,
                    464
                ]
            }),
            {
                29: $Vb1,
                57: 465
            },
            o($Vt1, [
                2,
                329
            ]),
            o($Vp, [
                2,
                332
            ], {
                129: 466,
                327: [
                    1,
                    467
                ]
            }),
            o($Vt1, [
                2,
                55
            ]),
            o($Vt1, [
                2,
                331
            ]),
            {
                48: [
                    1,
                    468
                ]
            },
            o($Vv1, [
                2,
                429
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                239: 469,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vw1, [
                2,
                431
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                243: 470,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vw1, [
                2,
                156
            ]),
            {
                45: $VC1,
                89: $VD1,
                179: 471
            },
            o($Vx1, [
                2,
                441
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                251: 472,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vy1, [
                2,
                444
            ], {
                256: 473
            }),
            o($Vy1, [
                2,
                446
            ], {
                258: 474
            }),
            o($VX1, [
                2,
                442
            ]),
            o($VX1, [
                2,
                443
            ]),
            o($Vy1, [
                2,
                449
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                255: 154,
                257: 155,
                259: 475,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VX1, [
                2,
                450
            ]),
            o($VX1, [
                2,
                451
            ]),
            o($VX1, [
                2,
                379
            ], {
                178: 476
            }),
            o($VX1, [
                2,
                378
            ]),
            o([
                6,
                13,
                16,
                29,
                31,
                39,
                45,
                47,
                48,
                73,
                76,
                78,
                81,
                82,
                83,
                85,
                87,
                89,
                112,
                159,
                160,
                161,
                163,
                164,
                193,
                231,
                242,
                246,
                250,
                263,
                265,
                268,
                269,
                270,
                271,
                272,
                273,
                274,
                276,
                277,
                279,
                280,
                283,
                285,
                290,
                294,
                295,
                296,
                297,
                298,
                299,
                300,
                301,
                302,
                303,
                304,
                305,
                306,
                308,
                309,
                310,
                312,
                335,
                338,
                341,
                342,
                343,
                344,
                345,
                346,
                347,
                348,
                349,
                350,
                351
            ], [
                2,
                175
            ]),
            {
                48: [
                    1,
                    477
                ]
            },
            {
                48: [
                    1,
                    478
                ]
            },
            {
                272: [
                    1,
                    479
                ]
            },
            {
                272: [
                    1,
                    480
                ]
            },
            {
                272: [
                    1,
                    481
                ]
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 482,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                48: [
                    1,
                    483
                ]
            },
            {
                48: [
                    1,
                    484
                ]
            },
            o($VB1, [
                2,
                187
            ]),
            o($VE1, [
                2,
                194
            ]),
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                82: $Vy,
                87: $Vb,
                139: 289,
                172: 291,
                255: 154,
                257: 155,
                266: 290,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                320: 485
            },
            {
                13: $V9,
                16: $Va,
                39: [
                    1,
                    487
                ],
                44: 136,
                45: $Vx,
                46: 488,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                282: 486,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($V$1, [
                2,
                460
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 489,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VX1, [
                2,
                464
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 490,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VX1, [
                2,
                466
            ]),
            o($V61, [
                2,
                40
            ]),
            o($VH1, [
                2,
                298
            ]),
            o($Ve2, [
                2,
                87
            ]),
            o($Ve2, [
                2,
                88
            ]),
            o($Ve2, [
                2,
                89
            ]),
            o($Ve2, [
                2,
                90
            ]),
            {
                13: $V9,
                16: $Va,
                55: 492,
                82: $Vy,
                172: 493,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                311: 494,
                312: $Vk1,
                315: 491
            },
            o($V61, [
                2,
                41
            ]),
            o($VI1, [
                2,
                300
            ]),
            o($Vf2, [
                2,
                303
            ], {
                92: 495
            }),
            {
                13: $V9,
                16: $Va,
                31: [
                    1,
                    496
                ],
                55: 414,
                82: $Vy,
                171: 497,
                172: 415,
                173: 416,
                174: $V02,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V12
            },
            {
                31: [
                    1,
                    498
                ],
                89: [
                    1,
                    499
                ]
            },
            {
                29: [
                    1,
                    500
                ]
            },
            o($VJ1, [
                2,
                372
            ]),
            {
                13: $V9,
                16: $Va,
                48: [
                    2,
                    422
                ],
                55: 194,
                197: $V71,
                223: 312,
                226: 502,
                228: 501,
                229: $VM1,
                307: 43,
                308: $Vc
            },
            o($VL1, [
                2,
                131
            ]),
            o($VL1, [
                2,
                126
            ]),
            o($V32, [
                2,
                22
            ]),
            o($V32, [
                2,
                290
            ]),
            {
                82: [
                    1,
                    503
                ]
            },
            {
                82: [
                    1,
                    504
                ]
            },
            {
                13: $V9,
                16: $Va,
                44: 510,
                45: $Vx,
                55: 323,
                67: 321,
                68: 322,
                74: 505,
                75: 506,
                76: $Vg2,
                77: 320,
                78: $Vh2,
                79: 509,
                87: $Vb,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                307: 43,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($V42, [
                2,
                294
            ]),
            o($Vi2, [
                2,
                69
            ]),
            o($Vi2, [
                2,
                70
            ]),
            o($V81, $V91, {
                59: 197,
                69: 198,
                20: 511,
                70: $Va1
            }),
            o($Vc1, $Vd1, {
                58: 205,
                62: 206,
                23: 512,
                63: $Ve1
            }),
            {
                29: [
                    2,
                    375
                ],
                31: [
                    2,
                    71
                ],
                84: 522,
                85: $V5,
                112: [
                    1,
                    518
                ],
                150: 513,
                151: 514,
                158: 515,
                159: [
                    1,
                    516
                ],
                160: [
                    1,
                    517
                ],
                161: [
                    1,
                    519
                ],
                163: [
                    1,
                    520
                ],
                164: [
                    1,
                    521
                ],
                175: 523
            },
            o($V62, [
                2,
                363
            ], {
                157: 524,
                335: [
                    1,
                    525
                ]
            }),
            o($V6, $V3, {
                215: 10,
                202: 526,
                205: 527,
                208: 528,
                214: 529,
                44: 530,
                87: $Vb
            }),
            o($Vj2, [
                2,
                399
            ], {
                215: 10,
                205: 527,
                208: 528,
                214: 529,
                44: 530,
                204: 531,
                202: 532,
                13: $V3,
                16: $V3,
                45: $V3,
                197: $V3,
                224: $V3,
                229: $V3,
                308: $V3,
                87: $Vb
            }),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $V72,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                203: 536,
                212: 534,
                231: $V82,
                233: 533,
                234: 535,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($V6, $V3, {
                215: 10,
                205: 527,
                208: 528,
                214: 529,
                44: 530,
                202: 537,
                87: $Vb
            }),
            o($Vc1, [
                2,
                23
            ], {
                307: 43,
                267: 139,
                275: 146,
                278: 149,
                55: 323,
                67: 447,
                68: 448,
                44: 450,
                66: 538,
                13: $V9,
                16: $Va,
                45: $V92,
                87: $Vb,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                276: $VI,
                277: $VJ,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            }),
            o($Vk2, [
                2,
                291
            ]),
            o($Vk2, [
                2,
                24
            ]),
            o($Vk2, [
                2,
                25
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 539,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vk2, [
                2,
                28
            ]),
            o($Vc1, $Vd1, {
                58: 205,
                62: 206,
                23: 540,
                63: $Ve1
            }),
            o([
                31,
                112,
                232,
                318,
                335
            ], [
                2,
                105
            ], {
                192: 541,
                193: [
                    1,
                    542
                ]
            }),
            o($Va2, [
                2,
                107
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $Vf1,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                187: 350,
                199: 543,
                200: 544,
                231: $Vh1,
                234: 349,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($Vl2, [
                2,
                132
            ]),
            o($Vb2, [
                2,
                425
            ]),
            o($Vl2, [
                2,
                133
            ]),
            {
                13: $V9,
                16: $Va,
                44: 354,
                55: 355,
                82: $Vy,
                87: $Vb,
                172: 357,
                237: 356,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 358,
                312: $Vk1,
                313: 545
            },
            o($Vq1, [
                2,
                54
            ]),
            o($Vq1, [
                2,
                48
            ]),
            o($VW1, [
                2,
                342
            ]),
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 546,
                307: 43,
                308: $Vc
            },
            o($VW1, [
                2,
                68
            ]),
            o($Vk, [
                2,
                350
            ], {
                31: $Vm2,
                112: $Vm2
            }),
            o($Vq1, [
                2,
                53
            ]),
            {
                13: $V9,
                16: $Va,
                55: 547,
                307: 43,
                308: $Vc
            },
            o($Vp, [
                2,
                333
            ]),
            o($Vw, [
                2,
                16
            ]),
            o($Vv1, [
                2,
                152
            ]),
            o($Vw1, [
                2,
                154
            ]),
            o($Vw1, [
                2,
                157
            ]),
            o($Vx1, [
                2,
                159
            ]),
            o($Vx1, [
                2,
                160
            ], {
                262: 389,
                261: 548,
                39: $VY1,
                338: $VZ1
            }),
            o($Vx1, [
                2,
                161
            ], {
                262: 389,
                261: 549,
                39: $VY1,
                338: $VZ1
            }),
            o($Vy1, [
                2,
                163
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 550,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VB1, [
                2,
                178
            ]),
            o($VB1, [
                2,
                179
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 551,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 552,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 553,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                48: [
                    1,
                    554
                ],
                272: [
                    1,
                    555
                ]
            },
            o($VB1, [
                2,
                184
            ]),
            o($VB1, [
                2,
                186
            ]),
            {
                314: [
                    1,
                    556
                ]
            },
            {
                48: [
                    1,
                    557
                ]
            },
            {
                48: [
                    2,
                    461
                ]
            },
            {
                48: [
                    2,
                    462
                ]
            },
            {
                48: [
                    1,
                    558
                ]
            },
            {
                48: [
                    2,
                    467
                ],
                193: [
                    1,
                    561
                ],
                287: 559,
                288: 560
            },
            {
                13: $V9,
                16: $Va,
                55: 194,
                197: $V71,
                223: 562,
                307: 43,
                308: $Vc
            },
            o($Vn2, [
                2,
                224
            ]),
            o($Vn2, [
                2,
                225
            ]),
            o($Vn2, [
                2,
                226
            ]),
            {
                31: [
                    1,
                    563
                ],
                45: $Vo2,
                94: 564
            },
            o($V61, [
                2,
                84
            ]),
            o($VH1, [
                2,
                368
            ]),
            o($V61, [
                2,
                85
            ]),
            o($VI1, [
                2,
                370
            ]),
            o($Vf2, [
                2,
                373
            ], {
                170: 566
            }),
            {
                48: [
                    1,
                    567
                ]
            },
            {
                48: [
                    2,
                    423
                ],
                337: [
                    1,
                    568
                ]
            },
            o($V32, [
                2,
                35
            ], {
                83: [
                    1,
                    569
                ]
            }),
            o($V32, [
                2,
                36
            ], {
                81: [
                    1,
                    570
                ]
            }),
            o($VO1, [
                2,
                30
            ], {
                307: 43,
                267: 139,
                275: 146,
                278: 149,
                77: 320,
                67: 321,
                68: 322,
                55: 323,
                79: 509,
                44: 510,
                75: 571,
                13: $V9,
                16: $Va,
                45: $Vx,
                76: $Vg2,
                78: $Vh2,
                87: $Vb,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                276: $VI,
                277: $VJ,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            }),
            o($Vp2, [
                2,
                295
            ]),
            {
                45: $Vx,
                77: 572
            },
            {
                45: $Vx,
                77: 573
            },
            o($Vp2, [
                2,
                33
            ]),
            o($Vp2, [
                2,
                34
            ]),
            {
                31: [
                    2,
                    275
                ],
                50: 574,
                84: 575,
                85: $V5
            },
            {
                31: [
                    2,
                    277
                ],
                51: 576,
                84: 577,
                85: $V5
            },
            o($V62, [
                2,
                356
            ]),
            o($Vq2, [
                2,
                357
            ], {
                152: 578,
                335: [
                    1,
                    579
                ]
            }),
            o($Vr2, [
                2,
                74
            ]),
            {
                29: $Vb1,
                57: 580
            },
            {
                29: $Vb1,
                57: 581
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 582,
                307: 43,
                308: $Vc
            },
            o($Vs2, [
                2,
                365
            ], {
                162: 583,
                328: [
                    1,
                    584
                ]
            }),
            {
                13: $V9,
                16: $Va,
                45: $Vx,
                55: 323,
                67: 321,
                68: 322,
                77: 320,
                79: 585,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                307: 43,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                45: [
                    1,
                    586
                ]
            },
            o($Vr2, [
                2,
                81
            ]),
            {
                29: $Vb1,
                57: 587
            },
            o($V62, [
                2,
                73
            ]),
            o($Vk, [
                2,
                362
            ], {
                29: $Vt2,
                31: $Vt2,
                85: $Vt2,
                112: $Vt2,
                159: $Vt2,
                160: $Vt2,
                161: $Vt2,
                163: $Vt2,
                164: $Vt2
            }),
            o($Vj2, [
                2,
                112
            ]),
            o($Vu2, [
                2,
                401
            ], {
                206: 588
            }),
            o($Vk, [
                2,
                405
            ], {
                209: 589,
                210: 590
            }),
            o($Vk, [
                2,
                403
            ]),
            o($Vk, [
                2,
                404
            ]),
            o($Vj2, [
                2,
                113
            ]),
            o($Vj2, [
                2,
                400
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $V72,
                48: [
                    1,
                    591
                ],
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                203: 536,
                212: 592,
                231: $V82,
                234: 535,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($Vb2, [
                2,
                426
            ]),
            o($Vd2, [
                2,
                138
            ]),
            o($Vd2, [
                2,
                139
            ]),
            {
                232: [
                    1,
                    593
                ]
            },
            o($Vk2, [
                2,
                292
            ]),
            {
                47: [
                    1,
                    595
                ],
                48: [
                    1,
                    594
                ]
            },
            o($VN1, [
                2,
                9
            ]),
            o($Va2, [
                2,
                392
            ]),
            o($Va2, [
                2,
                393
            ], {
                44: 39,
                55: 40,
                307: 43,
                195: 341,
                139: 342,
                194: 596,
                190: 597,
                13: $V9,
                16: $Va,
                87: $Vb,
                197: $VR1,
                308: $Vc
            }),
            o($Va2, [
                2,
                110
            ], {
                272: [
                    1,
                    598
                ]
            }),
            o($Vv2, [
                2,
                397
            ], {
                201: 599,
                316: 600,
                317: [
                    1,
                    601
                ]
            }),
            {
                314: [
                    1,
                    602
                ]
            },
            {
                29: [
                    1,
                    603
                ]
            },
            o($Vt1, [
                2,
                58
            ]),
            o($Vy1, [
                2,
                445
            ]),
            o($Vy1, [
                2,
                447
            ]),
            {
                48: [
                    1,
                    604
                ],
                272: [
                    1,
                    605
                ]
            },
            {
                48: [
                    1,
                    606
                ]
            },
            {
                272: [
                    1,
                    607
                ]
            },
            {
                272: [
                    1,
                    608
                ]
            },
            o($VB1, [
                2,
                99
            ]),
            o($VX1, [
                2,
                382
            ]),
            o([
                13,
                16,
                39,
                47,
                48,
                87,
                193,
                197,
                242,
                246,
                250,
                263,
                265,
                272,
                290,
                297,
                298,
                299,
                300,
                301,
                302,
                308,
                314,
                338,
                341,
                342,
                343,
                344,
                345,
                346
            ], [
                2,
                232
            ]),
            o($VB1, [
                2,
                188
            ]),
            o($VB1, [
                2,
                189
            ]),
            {
                48: [
                    1,
                    609
                ]
            },
            {
                48: [
                    2,
                    468
                ]
            },
            {
                289: [
                    1,
                    610
                ]
            },
            {
                13: $V9,
                16: $Va,
                55: 492,
                82: $Vy,
                172: 493,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                311: 494,
                312: $Vk1,
                315: 611
            },
            o($V61, [
                2,
                42
            ]),
            o($Vf2, [
                2,
                304
            ]),
            {
                13: $V9,
                16: $Va,
                55: 414,
                82: $Vy,
                95: 612,
                171: 613,
                172: 415,
                173: 416,
                174: $V02,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V12
            },
            {
                31: [
                    1,
                    614
                ],
                45: $Vo2,
                94: 615
            },
            o($VL1, [
                2,
                129
            ]),
            o($V22, [
                2,
                421
            ]),
            {
                82: [
                    1,
                    616
                ]
            },
            {
                82: [
                    1,
                    617
                ]
            },
            o($Vp2, [
                2,
                296
            ]),
            o($Vp2, [
                2,
                31
            ]),
            o($Vp2, [
                2,
                32
            ]),
            {
                31: [
                    2,
                    17
                ]
            },
            {
                31: [
                    2,
                    276
                ]
            },
            {
                31: [
                    2,
                    18
                ]
            },
            {
                31: [
                    2,
                    278
                ]
            },
            o($Vk, $VP1, {
                155: 330,
                153: 618,
                154: 619,
                29: $Vw2,
                31: $Vw2,
                85: $Vw2,
                112: $Vw2,
                159: $Vw2,
                160: $Vw2,
                161: $Vw2,
                163: $Vw2,
                164: $Vw2
            }),
            o($Vq2, [
                2,
                358
            ]),
            o($Vr2, [
                2,
                75
            ]),
            o($Vr2, [
                2,
                76
            ]),
            {
                29: $Vb1,
                57: 620
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 621,
                307: 43,
                308: $Vc
            },
            o($Vs2, [
                2,
                366
            ]),
            o($Vr2, [
                2,
                79
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 622,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vr2, [
                2,
                91
            ], {
                336: [
                    1,
                    623
                ]
            }),
            o([
                29,
                31,
                85,
                112,
                159,
                160,
                161,
                163,
                164,
                232,
                318,
                335
            ], [
                2,
                114
            ], {
                207: 624,
                193: [
                    1,
                    625
                ]
            }),
            o($Vu2, [
                2,
                117
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $V72,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                203: 536,
                211: 626,
                212: 627,
                231: $V82,
                234: 535,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($VT1, [
                2,
                134
            ]),
            o($Vb2, [
                2,
                427
            ]),
            o($VT1, [
                2,
                135
            ]),
            o($Vk2, [
                2,
                26
            ]),
            {
                44: 628,
                87: $Vb
            },
            o($Va2, [
                2,
                106
            ]),
            o($Va2, [
                2,
                394
            ]),
            o($Vk, [
                2,
                396
            ]),
            o($Vv2, [
                2,
                111
            ]),
            o($Vv2, [
                2,
                398
            ]),
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 342,
                186: 629,
                190: 340,
                195: 341,
                197: $VR1,
                307: 43,
                308: $Vc
            },
            o($VU1, [
                2,
                217
            ]),
            o($Vk, $Vr1, {
                144: 248,
                140: 630,
                143: 631,
                31: [
                    2,
                    343
                ]
            }),
            o($VB1, [
                2,
                97
            ]),
            o($VX1, [
                2,
                380
            ]),
            o($VB1, [
                2,
                180
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 632,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 633,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VB1, [
                2,
                190
            ]),
            {
                290: [
                    1,
                    634
                ]
            },
            {
                314: [
                    1,
                    635
                ]
            },
            {
                13: $V9,
                16: $Va,
                48: [
                    1,
                    636
                ],
                55: 414,
                82: $Vy,
                171: 637,
                172: 415,
                173: 416,
                174: $V02,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V12
            },
            o($Vx2, [
                2,
                305
            ]),
            o($V61, [
                2,
                86
            ]),
            o($Vf2, [
                2,
                374
            ]),
            o($V32, [
                2,
                37
            ]),
            o($V32, [
                2,
                38
            ]),
            o($V62, [
                2,
                72
            ]),
            o($V62, [
                2,
                360
            ]),
            o($Vr2, [
                2,
                77
            ]),
            {
                29: $Vb1,
                57: 638
            },
            {
                47: [
                    1,
                    639
                ]
            },
            {
                29: [
                    2,
                    376
                ]
            },
            o($Vu2, [
                2,
                402
            ]),
            o($Vu2, [
                2,
                115
            ], {
                215: 10,
                208: 528,
                214: 529,
                44: 530,
                205: 640,
                13: $V3,
                16: $V3,
                45: $V3,
                197: $V3,
                224: $V3,
                229: $V3,
                308: $V3,
                87: $Vb
            }),
            o($Vu2, [
                2,
                118
            ], {
                272: [
                    1,
                    641
                ]
            }),
            o($Vy2, [
                2,
                407
            ], {
                213: 642,
                319: 643,
                317: [
                    1,
                    644
                ]
            }),
            {
                48: [
                    1,
                    645
                ]
            },
            {
                318: [
                    1,
                    646
                ]
            },
            {
                31: [
                    1,
                    647
                ]
            },
            {
                31: [
                    2,
                    344
                ]
            },
            {
                48: [
                    1,
                    648
                ]
            },
            {
                48: [
                    1,
                    649
                ]
            },
            {
                291: 650,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_
            },
            o($Ve2, [
                2,
                218
            ]),
            o($Vf2, [
                2,
                44
            ]),
            o($Vx2, [
                2,
                306
            ]),
            o($Vr2, [
                2,
                78
            ]),
            {
                44: 651,
                87: $Vb
            },
            o($Vu2, [
                2,
                116
            ]),
            o($Vk, [
                2,
                406
            ]),
            o($Vy2, [
                2,
                119
            ]),
            o($Vy2, [
                2,
                408
            ]),
            o($V6, $V3, {
                215: 10,
                205: 527,
                208: 528,
                214: 529,
                44: 530,
                202: 652,
                87: $Vb
            }),
            o($Vk2, [
                2,
                27
            ]),
            o($Vv2, [
                2,
                230
            ]),
            o($Vz2, [
                2,
                345
            ], {
                141: 653,
                335: [
                    1,
                    654
                ]
            }),
            o($VB1, [
                2,
                181
            ]),
            o($VB1, [
                2,
                182
            ]),
            {
                48: [
                    2,
                    191
                ]
            },
            {
                48: [
                    1,
                    655
                ]
            },
            {
                318: [
                    1,
                    656
                ]
            },
            o($Vk, $Vr1, {
                144: 248,
                142: 657,
                143: 658,
                31: $VA2,
                112: $VA2
            }),
            o($Vz2, [
                2,
                346
            ]),
            o($Vr2, [
                2,
                80
            ]),
            o($Vy2, [
                2,
                231
            ]),
            o($VW1, [
                2,
                67
            ]),
            o($VW1, [
                2,
                348
            ])
        ],
        defaultActions: {
            5: [
                2,
                240
            ],
            6: [
                2,
                241
            ],
            7: [
                2,
                242
            ],
            9: [
                2,
                239
            ],
            24: [
                2,
                1
            ],
            25: [
                2,
                2
            ],
            26: [
                2,
                244
            ],
            87: [
                2,
                282
            ],
            94: [
                2,
                384
            ],
            100: [
                2,
                45
            ],
            109: [
                2,
                325
            ],
            166: [
                2,
                458
            ],
            263: [
                2,
                439
            ],
            336: [
                2,
                258
            ],
            337: [
                2,
                101
            ],
            487: [
                2,
                461
            ],
            488: [
                2,
                462
            ],
            560: [
                2,
                468
            ],
            574: [
                2,
                17
            ],
            575: [
                2,
                276
            ],
            576: [
                2,
                18
            ],
            577: [
                2,
                278
            ],
            623: [
                2,
                376
            ],
            631: [
                2,
                344
            ],
            650: [
                2,
                191
            ]
        },
        parseError: function parseError(str, hash) {
            if (hash.recoverable) this.trace(str);
            else {
                var error = new Error(str);
                error.hash = hash;
                throw error;
            }
        },
        parse: function parse(input) {
            var self = this, stack = [
                0
            ], tstack = [], vstack = [
                null
            ], lstack = [], table = this.table, yytext = "", yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
            var args = lstack.slice.call(arguments, 1);
            var lexer = Object.create(this.lexer);
            var sharedState = {
                yy: {}
            };
            for(var k in this.yy)if (Object.prototype.hasOwnProperty.call(this.yy, k)) sharedState.yy[k] = this.yy[k];
            lexer.setInput(input, sharedState.yy);
            sharedState.yy.lexer = lexer;
            sharedState.yy.parser = this;
            if (typeof lexer.yylloc == "undefined") lexer.yylloc = {};
            var yyloc = lexer.yylloc;
            lstack.push(yyloc);
            var ranges = lexer.options && lexer.options.ranges;
            if (typeof sharedState.yy.parseError === "function") this.parseError = sharedState.yy.parseError;
            else this.parseError = Object.getPrototypeOf(this).parseError;
            function popStack(n) {
                stack.length = stack.length - 2 * n;
                vstack.length = vstack.length - n;
                lstack.length = lstack.length - n;
            }
            _token_stack: var lex = function() {
                var token;
                token = lexer.lex() || EOF;
                if (typeof token !== "number") token = self.symbols_[token] || token;
                return token;
            };
            var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
            while(true){
                state = stack[stack.length - 1];
                if (this.defaultActions[state]) action = this.defaultActions[state];
                else {
                    if (symbol === null || typeof symbol == "undefined") symbol = lex();
                    action = table[state] && table[state][symbol];
                }
                if (typeof action === "undefined" || !action.length || !action[0]) {
                    var errStr = "";
                    expected = [];
                    for(p in table[state])if (this.terminals_[p] && p > TERROR) expected.push("'" + this.terminals_[p] + "'");
                    if (lexer.showPosition) errStr = "Parse error on line " + (yylineno + 1) + ":\n" + lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
                    else errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == EOF ? "end of input" : "'" + (this.terminals_[symbol] || symbol) + "'");
                    this.parseError(errStr, {
                        text: lexer.match,
                        token: this.terminals_[symbol] || symbol,
                        line: lexer.yylineno,
                        loc: yyloc,
                        expected: expected
                    });
                }
                if (action[0] instanceof Array && action.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
                switch(action[0]){
                    case 1:
                        stack.push(symbol);
                        vstack.push(lexer.yytext);
                        lstack.push(lexer.yylloc);
                        stack.push(action[1]);
                        symbol = null;
                        if (!preErrorSymbol) {
                            yyleng = lexer.yyleng;
                            yytext = lexer.yytext;
                            yylineno = lexer.yylineno;
                            yyloc = lexer.yylloc;
                            if (recovering > 0) recovering--;
                        } else {
                            symbol = preErrorSymbol;
                            preErrorSymbol = null;
                        }
                        break;
                    case 2:
                        len = this.productions_[action[1]][1];
                        yyval.$ = vstack[vstack.length - len];
                        yyval._$ = {
                            first_line: lstack[lstack.length - (len || 1)].first_line,
                            last_line: lstack[lstack.length - 1].last_line,
                            first_column: lstack[lstack.length - (len || 1)].first_column,
                            last_column: lstack[lstack.length - 1].last_column
                        };
                        if (ranges) yyval._$.range = [
                            lstack[lstack.length - (len || 1)].range[0],
                            lstack[lstack.length - 1].range[1]
                        ];
                        r = this.performAction.apply(yyval, [
                            yytext,
                            yyleng,
                            yylineno,
                            sharedState.yy,
                            action[1],
                            vstack,
                            lstack
                        ].concat(args));
                        if (typeof r !== "undefined") return r;
                        if (len) {
                            stack = stack.slice(0, -1 * len * 2);
                            vstack = vstack.slice(0, -1 * len);
                            lstack = lstack.slice(0, -1 * len);
                        }
                        stack.push(this.productions_[action[1]][0]);
                        vstack.push(yyval.$);
                        lstack.push(yyval._$);
                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
                        stack.push(newState);
                        break;
                    case 3:
                        return true;
                }
            }
            return true;
        }
    };
    /*
    SPARQL parser in the Jison parser generator format.
  */ var Wildcard = (parcelRequire("jUw11")).Wildcard;
    // Common namespaces and entities
    var RDF = "http://www.w3.org/1999/02/22-rdf-syntax-ns#", RDF_TYPE = RDF + "type", RDF_FIRST = RDF + "first", RDF_REST = RDF + "rest", RDF_NIL = RDF + "nil", XSD = "http://www.w3.org/2001/XMLSchema#", XSD_INTEGER = XSD + "integer", XSD_DECIMAL = XSD + "decimal", XSD_DOUBLE = XSD + "double", XSD_BOOLEAN = XSD + "boolean";
    var base = "", basePath = "", baseRoot = "";
    // Returns a lowercase version of the given string
    function lowercase(string) {
        return string.toLowerCase();
    }
    // Appends the item to the array and returns the array
    function appendTo(array, item) {
        return array.push(item), array;
    }
    // Appends the items to the array and returns the array
    function appendAllTo(array, items) {
        return array.push.apply(array, items), array;
    }
    // Extends a base object with properties of other objects
    function extend(base) {
        if (!base) base = {};
        for(var i = 1, l = arguments.length, arg; i < l && (arg = arguments[i] || {}); i++)for(var name in arg)base[name] = arg[name];
        return base;
    }
    // Creates an array that contains all items of the given arrays
    function unionAll() {
        var union = [];
        for(var i = 0, l = arguments.length; i < l; i++)union = union.concat.apply(union, arguments[i]);
        return union;
    }
    // Resolves an IRI against a base path
    function resolveIRI(iri) {
        // Strip off possible angular brackets
        if (iri[0] === "<") iri = iri.substring(1, iri.length - 1);
        // Return absolute IRIs unmodified
        if (/^[a-z]+:/i.test(iri)) return iri;
        if (!Parser.base) throw new Error("Cannot resolve relative IRI " + iri + " because no base IRI was set.");
        if (base !== Parser.base) {
            base = Parser.base;
            basePath = base.replace(/[^\/:]*$/, "");
            baseRoot = base.match(/^(?:[a-z]+:\/*)?[^\/]*/)[0];
        }
        switch(iri[0]){
            // An empty relative IRI indicates the base IRI
            case undefined:
                return base;
            // Resolve relative fragment IRIs against the base IRI
            case "#":
                return base + iri;
            // Resolve relative query string IRIs by replacing the query string
            case "?":
                return base.replace(/(?:\?.*)?$/, iri);
            // Resolve root relative IRIs at the root of the base IRI
            case "/":
                return baseRoot + iri;
            // Resolve all other IRIs at the base IRI's path
            default:
                return basePath + iri;
        }
    }
    // If the item is a variable, ensures it starts with a question mark
    function toVar(variable) {
        if (variable) {
            var first = variable[0];
            if (first === "?" || first === "$") return Parser.factory.variable(variable.substr(1));
        }
        return variable;
    }
    // Creates an operation with the given name and arguments
    function operation(operatorName, args) {
        return {
            type: "operation",
            operator: operatorName,
            args: args || []
        };
    }
    // Creates an expression with the given type and attributes
    function expression(expr, attr) {
        var expression = {
            expression: expr === "*" ? new Wildcard() : expr
        };
        if (attr) for(var a in attr)expression[a] = attr[a];
        return expression;
    }
    // Creates a path with the given type and items
    function path(type, items) {
        return {
            type: "path",
            pathType: type,
            items: items
        };
    }
    // Transforms a list of operations types and arguments into a tree of operations
    function createOperationTree(initialExpression, operationList) {
        for(var i = 0, l = operationList.length, item; i < l && (item = operationList[i]); i++)initialExpression = operation(item[0], [
            initialExpression,
            item[1]
        ]);
        return initialExpression;
    }
    // Group datasets by default and named
    function groupDatasets(fromClauses, groupName) {
        var defaults = [], named = [], l = fromClauses.length, fromClause, group = {};
        if (!l) return null;
        for(var i = 0; i < l && (fromClause = fromClauses[i]); i++)(fromClause.named ? named : defaults).push(fromClause.iri);
        group[groupName || "from"] = {
            default: defaults,
            named: named
        };
        return group;
    }
    // Converts the string to a number
    function toInt(string) {
        return parseInt(string, 10);
    }
    // Transforms a possibly single group into its patterns
    function degroupSingle(group) {
        return group.type === "group" && group.patterns.length === 1 ? group.patterns[0] : group;
    }
    // Creates a literal with the given value and type
    function createTypedLiteral(value, type) {
        if (type && type.termType !== "NamedNode") type = Parser.factory.namedNode(type);
        return Parser.factory.literal(value, type);
    }
    // Creates a literal with the given value and language
    function createLangLiteral(value, lang) {
        return Parser.factory.literal(value, lang);
    }
    function nestedTriple(subject, predicate, object) {
        // TODO: Remove this when it is caught by the grammar
        if (!("termType" in predicate)) throw new Error("Nested triples cannot contain paths");
        return Parser.factory.quad(subject, predicate, object);
    }
    // Creates a triple with the given subject, predicate, and object
    function triple(subject, predicate, object, annotations) {
        var triple = {};
        if (subject != null) triple.subject = subject;
        if (predicate != null) triple.predicate = predicate;
        if (object != null) triple.object = object;
        if (annotations != null) triple.annotations = annotations;
        return triple;
    }
    // Creates a new blank node
    function blank(name) {
        if (typeof name === "string") {
            if (name.startsWith("e_")) return Parser.factory.blankNode(name);
            return Parser.factory.blankNode("e_" + name);
        }
        return Parser.factory.blankNode("g_" + blankId++);
    }
    var blankId = 0;
    Parser._resetBlanks = function() {
        blankId = 0;
    };
    // Regular expression and replacement strings to escape strings
    var escapeSequence = /\\u([a-fA-F0-9]{4})|\\U([a-fA-F0-9]{8})|\\(.)/g, escapeReplacements = {
        "\\": "\\",
        "'": "'",
        '"': '"',
        "t": "	",
        "b": "\b",
        "n": "\n",
        "r": "\r",
        "f": "\f"
    }, partialSurrogatesWithoutEndpoint = /[\uD800-\uDBFF]([^\uDC00-\uDFFF]|$)/, fromCharCode = String.fromCharCode;
    // Translates escape codes in the string into their textual equivalent
    function unescapeString(string, trimLength) {
        string = string.substring(trimLength, string.length - trimLength);
        try {
            string = string.replace(escapeSequence, function(sequence, unicode4, unicode8, escapedChar) {
                var charCode;
                if (unicode4) {
                    charCode = parseInt(unicode4, 16);
                    if (isNaN(charCode)) throw new Error(); // can never happen (regex), but helps performance
                    return fromCharCode(charCode);
                } else if (unicode8) {
                    charCode = parseInt(unicode8, 16);
                    if (isNaN(charCode)) throw new Error(); // can never happen (regex), but helps performance
                    if (charCode < 0xFFFF) return fromCharCode(charCode);
                    return fromCharCode(0xD800 + ((charCode -= 0x10000) >> 10), 0xDC00 + (charCode & 0x3FF));
                } else {
                    var replacement = escapeReplacements[escapedChar];
                    if (!replacement) throw new Error();
                    return replacement;
                }
            });
        } catch (error) {
            return "";
        }
        // Test for invalid unicode surrogate pairs
        if (partialSurrogatesWithoutEndpoint.exec(string)) throw new Error("Invalid unicode codepoint of surrogate pair without corresponding codepoint in " + string);
        return string;
    }
    // Creates a list, collecting its (possibly blank) items and triples associated with those items
    function createList(objects) {
        var list = blank(), head = list, listItems = [], listTriples, triples = [];
        objects.forEach(function(o) {
            listItems.push(o.entity);
            appendAllTo(triples, o.triples);
        });
        // Build an RDF list out of the items
        for(var i = 0, j = 0, l = listItems.length, listTriples = Array(l * 2); i < l;)listTriples[j++] = triple(head, Parser.factory.namedNode(RDF_FIRST), listItems[i]), listTriples[j++] = triple(head, Parser.factory.namedNode(RDF_REST), head = ++i < l ? blank() : Parser.factory.namedNode(RDF_NIL));
        // Return the list's identifier, its triples, and the triples associated with its items
        return {
            entity: list,
            triples: appendAllTo(listTriples, triples)
        };
    }
    // Creates a blank node identifier, collecting triples with that blank node as subject
    function createAnonymousObject(propertyList) {
        var entity = blank();
        return {
            entity: entity,
            triples: propertyList.map(function(t) {
                return extend(triple(entity), t);
            })
        };
    }
    // Collects all (possibly blank) objects, and triples that have them as subject
    function objectListToTriples(predicate, objectList, otherTriples) {
        var objects = [], triples = [];
        objectList.forEach(function(l) {
            let annotation = null;
            if (l.annotation) {
                annotation = l.annotation;
                l = l.object;
            }
            objects.push(triple(null, predicate, l.entity, annotation));
            appendAllTo(triples, l.triples);
        });
        return unionAll(objects, otherTriples || [], triples);
    }
    // Simplifies groups by merging adjacent BGPs
    function mergeAdjacentBGPs(groups) {
        var merged = [], currentBgp;
        for(var i = 0, group; group = groups[i]; i++)switch(group.type){
            // Add a BGP's triples to the current BGP
            case "bgp":
                if (group.triples.length) {
                    if (!currentBgp) appendTo(merged, currentBgp = group);
                    else appendAllTo(currentBgp.triples, group.triples);
                }
                break;
            // All other groups break up a BGP
            default:
                // Only add the group if its pattern is non-empty
                if (!group.patterns || group.patterns.length > 0) {
                    appendTo(merged, group);
                    currentBgp = null;
                }
        }
        return merged;
    }
    // Return the id of an expression
    function getExpressionId(expression) {
        return expression.variable ? expression.variable.value : expression.value || expression.expression.value;
    }
    // Get all "aggregate"'s from an expression
    function getAggregatesOfExpression(expression) {
        if (!expression) return [];
        if (expression.type === "aggregate") return [
            expression
        ];
        else if (expression.type === "operation") {
            const aggregates = [];
            for (const arg of expression.args)aggregates.push(...getAggregatesOfExpression(arg));
            return aggregates;
        }
        return [];
    }
    // Get all variables used in an expression
    function getVariablesFromExpression(expression) {
        const variables = new Set();
        const visitExpression = function(expr) {
            if (!expr) return;
            if (expr.termType === "Variable") variables.add(expr);
            else if (expr.type === "operation") expr.args.forEach(visitExpression);
        };
        visitExpression(expression);
        return variables;
    }
    // Helper function to flatten arrays
    function flatten(input, depth = 1, stack = []) {
        for (const item of input)if (depth > 0 && item instanceof Array) flatten(item, depth - 1, stack);
        else stack.push(item);
        return stack;
    }
    function isVariable(term) {
        return term.termType === "Variable";
    }
    function getBoundVarsFromGroupGraphPattern(pattern) {
        if (pattern.triples) {
            const boundVars = [];
            for (const triple of pattern.triples){
                if (isVariable(triple.subject)) boundVars.push(triple.subject.value);
                if (isVariable(triple.predicate)) boundVars.push(triple.predicate.value);
                if (isVariable(triple.object)) boundVars.push(triple.object.value);
            }
            return boundVars;
        } else if (pattern.patterns) {
            const boundVars = [];
            for (const pat of pattern.patterns)boundVars.push(...getBoundVarsFromGroupGraphPattern(pat));
            return boundVars;
        }
        return [];
    }
    // Helper function to find duplicates in array
    function getDuplicatesInArray(array) {
        const sortedArray = array.slice().sort();
        const duplicates = [];
        for(let i = 0; i < sortedArray.length - 1; i++)if (sortedArray[i + 1] == sortedArray[i]) duplicates.push(sortedArray[i]);
        return duplicates;
    }
    function ensureSparqlStar(value) {
        if (!Parser.sparqlStar) throw new Error("SPARQL-star support is not enabled");
        return value;
    }
    function _applyAnnotations(subject, annotations, arr) {
        for (const annotation of annotations){
            const t = triple(// If the annotation already has a subject then just push the
            // annotation to the upper scope as it is a blank node introduced
            // from a pattern like :s :p :o {| :p1 [ :p2 :o2; :p3 :o3 ] |}
            "subject" in annotation ? annotation.subject : subject, annotation.predicate, annotation.object);
            arr.push(t);
            if (annotation.annotations) _applyAnnotations(nestedTriple(subject, annotation.predicate, annotation.object), annotation.annotations, arr);
        }
    }
    function applyAnnotations(triples) {
        if (Parser.sparqlStar) {
            const newTriples = [];
            triples.forEach((t)=>{
                const s = triple(t.subject, t.predicate, t.object);
                newTriples.push(s);
                if (t.annotations) _applyAnnotations(nestedTriple(t.subject, t.predicate, t.object), t.annotations, newTriples);
            });
            return newTriples;
        }
        return triples;
    }
    function ensureSparqlStarNestedQuads(value) {
        if (!Parser.sparqlStarNestedQuads) throw new Error("Lenient SPARQL-star support with nested quads is not enabled");
        return value;
    }
    function ensureNoVariables(operations) {
        for (const operation of operations){
            if (operation.type === "graph" && operation.name.termType === "Variable") throw new Error("Detected illegal variable in GRAPH");
            if (operation.type === "bgp" || operation.type === "graph") for (const triple of operation.triples){
                if (triple.subject.termType === "Variable" || triple.predicate.termType === "Variable" || triple.object.termType === "Variable") throw new Error("Detected illegal variable in BGP");
            }
        }
        return operations;
    }
    function ensureNoBnodes(operations) {
        for (const operation of operations){
            if (operation.type === "bgp") for (const triple of operation.triples){
                if (triple.subject.termType === "BlankNode" || triple.predicate.termType === "BlankNode" || triple.object.termType === "BlankNode") throw new Error("Detected illegal blank node in BGP");
            }
        }
        return operations;
    }
    /* generated by jison-lex 0.3.4 */ var lexer = function() {
        var lexer = {
            EOF: 1,
            parseError: function parseError(str, hash) {
                if (this.yy.parser) this.yy.parser.parseError(str, hash);
                else throw new Error(str);
            },
            // resets the lexer, sets new input
            setInput: function(input, yy) {
                this.yy = yy || this.yy || {};
                this._input = input;
                this._more = this._backtrack = this.done = false;
                this.yylineno = this.yyleng = 0;
                this.yytext = this.matched = this.match = "";
                this.conditionStack = [
                    "INITIAL"
                ];
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0
                };
                if (this.options.ranges) this.yylloc.range = [
                    0,
                    0
                ];
                this.offset = 0;
                return this;
            },
            // consumes and returns one char from the input
            input: function() {
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                var lines = ch.match(/(?:\r\n?|\n).*/g);
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                } else this.yylloc.last_column++;
                if (this.options.ranges) this.yylloc.range[1]++;
                this._input = this._input.slice(1);
                return ch;
            },
            // unshifts one char (or a string) into the input
            unput: function(ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len);
                //this.yyleng -= len;
                this.offset -= len;
                var oldLines = this.match.split(/(?:\r\n?|\n)/g);
                this.match = this.match.substr(0, this.match.length - 1);
                this.matched = this.matched.substr(0, this.matched.length - 1);
                if (lines.length - 1) this.yylineno -= lines.length - 1;
                var r = this.yylloc.range;
                this.yylloc = {
                    first_line: this.yylloc.first_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.first_column,
                    last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
                };
                if (this.options.ranges) this.yylloc.range = [
                    r[0],
                    r[0] + this.yyleng - len
                ];
                this.yyleng = this.yytext.length;
                return this;
            },
            // When called from action, caches matched text and appends it on next action
            more: function() {
                this._more = true;
                return this;
            },
            // When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
            reject: function() {
                if (this.options.backtrack_lexer) this._backtrack = true;
                else return this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                });
                return this;
            },
            // retain first n characters of the match
            less: function(n) {
                this.unput(this.match.slice(n));
            },
            // displays already matched input, i.e. for error messages
            pastInput: function() {
                var past = this.matched.substr(0, this.matched.length - this.match.length);
                return (past.length > 20 ? "..." : "") + past.substr(-20).replace(/\n/g, "");
            },
            // displays upcoming input, i.e. for error messages
            upcomingInput: function() {
                var next = this.match;
                if (next.length < 20) next += this._input.substr(0, 20 - next.length);
                return (next.substr(0, 20) + (next.length > 20 ? "..." : "")).replace(/\n/g, "");
            },
            // displays the character position where the lexing error occurred, i.e. for error messages
            showPosition: function() {
                var pre = this.pastInput();
                var c = new Array(pre.length + 1).join("-");
                return pre + this.upcomingInput() + "\n" + c + "^";
            },
            // test the lexed token: return FALSE when not a match, otherwise return token
            test_match: function(match, indexed_rule) {
                var token, lines, backup;
                if (this.options.backtrack_lexer) {
                    // save context
                    backup = {
                        yylineno: this.yylineno,
                        yylloc: {
                            first_line: this.yylloc.first_line,
                            last_line: this.last_line,
                            first_column: this.yylloc.first_column,
                            last_column: this.yylloc.last_column
                        },
                        yytext: this.yytext,
                        match: this.match,
                        matches: this.matches,
                        matched: this.matched,
                        yyleng: this.yyleng,
                        offset: this.offset,
                        _more: this._more,
                        _input: this._input,
                        yy: this.yy,
                        conditionStack: this.conditionStack.slice(0),
                        done: this.done
                    };
                    if (this.options.ranges) backup.yylloc.range = this.yylloc.range.slice(0);
                }
                lines = match[0].match(/(?:\r\n?|\n).*/g);
                if (lines) this.yylineno += lines.length;
                this.yylloc = {
                    first_line: this.yylloc.last_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.last_column,
                    last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length
                };
                this.yytext += match[0];
                this.match += match[0];
                this.matches = match;
                this.yyleng = this.yytext.length;
                if (this.options.ranges) this.yylloc.range = [
                    this.offset,
                    this.offset += this.yyleng
                ];
                this._more = false;
                this._backtrack = false;
                this._input = this._input.slice(match[0].length);
                this.matched += match[0];
                token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
                if (this.done && this._input) this.done = false;
                if (token) return token;
                else if (this._backtrack) {
                    // recover context
                    for(var k in backup)this[k] = backup[k];
                    return false; // rule action called reject() implying the next rule should be tested instead.
                }
                return false;
            },
            // return next match in input
            next: function() {
                if (this.done) return this.EOF;
                if (!this._input) this.done = true;
                var token, match, tempMatch, index;
                if (!this._more) {
                    this.yytext = "";
                    this.match = "";
                }
                var rules = this._currentRules();
                for(var i = 0; i < rules.length; i++){
                    tempMatch = this._input.match(this.rules[rules[i]]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (this.options.backtrack_lexer) {
                            token = this.test_match(tempMatch, rules[i]);
                            if (token !== false) return token;
                            else if (this._backtrack) {
                                match = false;
                                continue; // rule action called reject() implying a rule MISmatch.
                            } else // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                            return false;
                        } else if (!this.options.flex) break;
                    }
                }
                if (match) {
                    token = this.test_match(match, rules[index]);
                    if (token !== false) return token;
                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                    return false;
                }
                if (this._input === "") return this.EOF;
                else return this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                });
            },
            // return next match that has a token
            lex: function lex() {
                var r = this.next();
                if (r) return r;
                else return this.lex();
            },
            // activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
            begin: function begin(condition) {
                this.conditionStack.push(condition);
            },
            // pop the previously active lexer condition state off the condition stack
            popState: function popState() {
                var n = this.conditionStack.length - 1;
                if (n > 0) return this.conditionStack.pop();
                else return this.conditionStack[0];
            },
            // produce the lexer rule set which is active for the currently active lexer condition state
            _currentRules: function _currentRules() {
                if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
                else return this.conditions["INITIAL"].rules;
            },
            // return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
            topState: function topState(n) {
                n = this.conditionStack.length - 1 - Math.abs(n || 0);
                if (n >= 0) return this.conditionStack[n];
                else return "INITIAL";
            },
            // alias for begin(condition)
            pushState: function pushState(condition) {
                this.begin(condition);
            },
            // return the number of states currently on the stack
            stateStackSize: function stateStackSize() {
                return this.conditionStack.length;
            },
            options: {
                "flex": true,
                "case-insensitive": true
            },
            performAction: function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
                var YYSTATE = YY_START;
                switch($avoiding_name_collisions){
                    case 0:
                        break;
                    case 1:
                        return 12;
                    case 2:
                        return 15;
                    case 3:
                        return 41;
                    case 4:
                        return 325;
                    case 5:
                        return 326;
                    case 6:
                        return 45;
                    case 7:
                        return 47;
                    case 8:
                        return 48;
                    case 9:
                        return 39;
                    case 10:
                        return 24;
                    case 11:
                        return 28;
                    case 12:
                        return 29;
                    case 13:
                        return 31;
                    case 14:
                        return 32;
                    case 15:
                        return 36;
                    case 16:
                        return 53;
                    case 17:
                        return 327;
                    case 18:
                        return 63;
                    case 19:
                        return 64;
                    case 20:
                        return 70;
                    case 21:
                        return 73;
                    case 22:
                        return 76;
                    case 23:
                        return 78;
                    case 24:
                        return 81;
                    case 25:
                        return 83;
                    case 26:
                        return 85;
                    case 27:
                        return 193;
                    case 28:
                        return 100;
                    case 29:
                        return 328;
                    case 30:
                        return 121;
                    case 31:
                        return 329;
                    case 32:
                        return 330;
                    case 33:
                        return 110;
                    case 34:
                        return 331;
                    case 35:
                        return 109;
                    case 36:
                        return 332;
                    case 37:
                        return 333;
                    case 38:
                        return 113;
                    case 39:
                        return 115;
                    case 40:
                        return 116;
                    case 41:
                        return 131;
                    case 42:
                        return 123;
                    case 43:
                        return 126;
                    case 44:
                        return 128;
                    case 45:
                        return 132;
                    case 46:
                        return 112;
                    case 47:
                        return 334;
                    case 48:
                        return 335;
                    case 49:
                        return 159;
                    case 50:
                        return 161;
                    case 51:
                        return 164;
                    case 52:
                        return 174;
                    case 53:
                        return 160;
                    case 54:
                        return 336;
                    case 55:
                        return 163;
                    case 56:
                        return 312;
                    case 57:
                        return 314;
                    case 58:
                        return 317;
                    case 59:
                        return 318;
                    case 60:
                        return 272;
                    case 61:
                        return 197;
                    case 62:
                        return 337;
                    case 63:
                        return 338;
                    case 64:
                        return 229;
                    case 65:
                        return 340;
                    case 66:
                        return 263;
                    case 67:
                        return 224;
                    case 68:
                        return 231;
                    case 69:
                        return 232;
                    case 70:
                        return 242;
                    case 71:
                        return 246;
                    case 72:
                        return 290;
                    case 73:
                        return 341;
                    case 74:
                        return 342;
                    case 75:
                        return 343;
                    case 76:
                        return 344;
                    case 77:
                        return 345;
                    case 78:
                        return 250;
                    case 79:
                        return 346;
                    case 80:
                        return 265;
                    case 81:
                        return 276;
                    case 82:
                        return 277;
                    case 83:
                        return 268;
                    case 84:
                        return 269;
                    case 85:
                        return 270;
                    case 86:
                        return 271;
                    case 87:
                        return 347;
                    case 88:
                        return 348;
                    case 89:
                        return 273;
                    case 90:
                        return 274;
                    case 91:
                        return 350;
                    case 92:
                        return 349;
                    case 93:
                        return 351;
                    case 94:
                        return 279;
                    case 95:
                        return 280;
                    case 96:
                        return 283;
                    case 97:
                        return 285;
                    case 98:
                        return 289;
                    case 99:
                        return 293;
                    case 100:
                        return 296;
                    case 101:
                        return 13;
                    case 102:
                        return 16;
                    case 103:
                        return 308;
                    case 104:
                        return 309;
                    case 105:
                        return 87;
                    case 106:
                        return 292;
                    case 107:
                        return 82;
                    case 108:
                        return 294;
                    case 109:
                        return 295;
                    case 110:
                        return 297;
                    case 111:
                        return 298;
                    case 112:
                        return 299;
                    case 113:
                        return 300;
                    case 114:
                        return 301;
                    case 115:
                        return 302;
                    case 116:
                        return "EXPONENT";
                    case 117:
                        return 303;
                    case 118:
                        return 304;
                    case 119:
                        return 305;
                    case 120:
                        return 306;
                    case 121:
                        return 89;
                    case 122:
                        return 310;
                    case 123:
                        return 6;
                    case 124:
                        return "INVALID";
                    case 125:
                        console.log(yy_.yytext);
                        break;
                }
            },
            rules: [
                /^(?:\s+|(#[^\n\r]*))/i,
                /^(?:BASE)/i,
                /^(?:PREFIX)/i,
                /^(?:SELECT)/i,
                /^(?:DISTINCT)/i,
                /^(?:REDUCED)/i,
                /^(?:\()/i,
                /^(?:AS)/i,
                /^(?:\))/i,
                /^(?:\*)/i,
                /^(?:CONSTRUCT)/i,
                /^(?:WHERE)/i,
                /^(?:\{)/i,
                /^(?:\})/i,
                /^(?:DESCRIBE)/i,
                /^(?:ASK)/i,
                /^(?:FROM)/i,
                /^(?:NAMED)/i,
                /^(?:GROUP)/i,
                /^(?:BY)/i,
                /^(?:HAVING)/i,
                /^(?:ORDER)/i,
                /^(?:ASC)/i,
                /^(?:DESC)/i,
                /^(?:LIMIT)/i,
                /^(?:OFFSET)/i,
                /^(?:VALUES)/i,
                /^(?:;)/i,
                /^(?:LOAD)/i,
                /^(?:SILENT)/i,
                /^(?:INTO)/i,
                /^(?:CLEAR)/i,
                /^(?:DROP)/i,
                /^(?:CREATE)/i,
                /^(?:ADD)/i,
                /^(?:TO)/i,
                /^(?:MOVE)/i,
                /^(?:COPY)/i,
                /^(?:INSERT((\s+|(#[^\n\r]*)\n\r?)+)DATA)/i,
                /^(?:DELETE((\s+|(#[^\n\r]*)\n\r?)+)DATA)/i,
                /^(?:DELETE((\s+|(#[^\n\r]*)\n\r?)+)WHERE)/i,
                /^(?:WITH)/i,
                /^(?:DELETE)/i,
                /^(?:INSERT)/i,
                /^(?:USING)/i,
                /^(?:DEFAULT)/i,
                /^(?:GRAPH)/i,
                /^(?:ALL)/i,
                /^(?:\.)/i,
                /^(?:OPTIONAL)/i,
                /^(?:SERVICE)/i,
                /^(?:BIND)/i,
                /^(?:UNDEF)/i,
                /^(?:MINUS)/i,
                /^(?:UNION)/i,
                /^(?:FILTER)/i,
                /^(?:<<)/i,
                /^(?:>>)/i,
                /^(?:\{\|)/i,
                /^(?:\|\})/i,
                /^(?:,)/i,
                /^(?:a)/i,
                /^(?:\|)/i,
                /^(?:\/)/i,
                /^(?:\^)/i,
                /^(?:\?)/i,
                /^(?:\+)/i,
                /^(?:!)/i,
                /^(?:\[)/i,
                /^(?:\])/i,
                /^(?:\|\|)/i,
                /^(?:&&)/i,
                /^(?:=)/i,
                /^(?:!=)/i,
                /^(?:<)/i,
                /^(?:>)/i,
                /^(?:<=)/i,
                /^(?:>=)/i,
                /^(?:IN)/i,
                /^(?:NOT)/i,
                /^(?:-)/i,
                /^(?:BOUND)/i,
                /^(?:BNODE)/i,
                /^(?:(RAND|NOW|UUID|STRUUID))/i,
                /^(?:(LANG|DATATYPE|IRI|URI|ABS|CEIL|FLOOR|ROUND|STRLEN|STR|UCASE|LCASE|ENCODE_FOR_URI|YEAR|MONTH|DAY|HOURS|MINUTES|SECONDS|TIMEZONE|TZ|MD5|SHA1|SHA256|SHA384|SHA512|isIRI|isURI|isBLANK|isLITERAL|isNUMERIC))/i,
                /^(?:(SUBJECT|PREDICATE|OBJECT|isTRIPLE))/i,
                /^(?:(LANGMATCHES|CONTAINS|STRSTARTS|STRENDS|STRBEFORE|STRAFTER|STRLANG|STRDT|sameTerm))/i,
                /^(?:CONCAT)/i,
                /^(?:COALESCE)/i,
                /^(?:IF)/i,
                /^(?:TRIPLE)/i,
                /^(?:REGEX)/i,
                /^(?:SUBSTR)/i,
                /^(?:REPLACE)/i,
                /^(?:EXISTS)/i,
                /^(?:COUNT)/i,
                /^(?:SUM|MIN|MAX|AVG|SAMPLE)/i,
                /^(?:GROUP_CONCAT)/i,
                /^(?:SEPARATOR)/i,
                /^(?:\^\^)/i,
                /^(?:true|false)/i,
                /^(?:(<(?:[^<>\"\{\}\|\^`\\\u0000-\u0020])*>))/i,
                /^(?:((([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])(?:(?:(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])|\.)*(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040]))?)?:))/i,
                /^(?:(((([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])(?:(?:(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])|\.)*(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040]))?)?:)((?:((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|:|[0-9]|((%([0-9A-Fa-f])([0-9A-Fa-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%))))(?:(?:(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])|\.|:|((%([0-9A-Fa-f])([0-9A-Fa-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%))))*(?:(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])|:|((%([0-9A-Fa-f])([0-9A-Fa-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%)))))?)))/i,
                /^(?:(_:(?:((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|[0-9])(?:(?:(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])|\.)*(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040]))?))/i,
                /^(?:([\?\$]((?:((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|[0-9])(?:((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])*)))/i,
                /^(?:(@[a-zA-Z]+(?:-[a-zA-Z0-9]+)*))/i,
                /^(?:([0-9]+))/i,
                /^(?:([0-9]*\.[0-9]+))/i,
                /^(?:([0-9]+\.[0-9]*([eE][+-]?[0-9]+)|\.([0-9])+([eE][+-]?[0-9]+)|([0-9])+([eE][+-]?[0-9]+)))/i,
                /^(?:(\+([0-9]+)))/i,
                /^(?:(\+([0-9]*\.[0-9]+)))/i,
                /^(?:(\+([0-9]+\.[0-9]*([eE][+-]?[0-9]+)|\.([0-9])+([eE][+-]?[0-9]+)|([0-9])+([eE][+-]?[0-9]+))))/i,
                /^(?:(-([0-9]+)))/i,
                /^(?:(-([0-9]*\.[0-9]+)))/i,
                /^(?:(-([0-9]+\.[0-9]*([eE][+-]?[0-9]+)|\.([0-9])+([eE][+-]?[0-9]+)|([0-9])+([eE][+-]?[0-9]+))))/i,
                /^(?:([eE][+-]?[0-9]+))/i,
                /^(?:('(?:(?:[^\u0027\u005C\u000A\u000D])|(\\[tbnrf\\\"']|\\u([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])|\\U([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])))*'))/i,
                /^(?:("(?:(?:[^\u0022\u005C\u000A\u000D])|(\\[tbnrf\\\"']|\\u([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])|\\U([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])))*"))/i,
                /^(?:('''(?:(?:'|'')?(?:[^'\\]|(\\[tbnrf\\\"']|\\u([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])|\\U([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f]))))*'''))/i,
                /^(?:("""(?:(?:"|"")?(?:[^\"\\]|(\\[tbnrf\\\"']|\\u([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])|\\U([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f]))))*"""))/i,
                /^(?:(\((\u0020|\u0009|\u000D|\u000A)*\)))/i,
                /^(?:(\[(\u0020|\u0009|\u000D|\u000A)*\]))/i,
                /^(?:$)/i,
                /^(?:.)/i,
                /^(?:.)/i
            ],
            conditions: {
                "INITIAL": {
                    "rules": [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28,
                        29,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39,
                        40,
                        41,
                        42,
                        43,
                        44,
                        45,
                        46,
                        47,
                        48,
                        49,
                        50,
                        51,
                        52,
                        53,
                        54,
                        55,
                        56,
                        57,
                        58,
                        59,
                        60,
                        61,
                        62,
                        63,
                        64,
                        65,
                        66,
                        67,
                        68,
                        69,
                        70,
                        71,
                        72,
                        73,
                        74,
                        75,
                        76,
                        77,
                        78,
                        79,
                        80,
                        81,
                        82,
                        83,
                        84,
                        85,
                        86,
                        87,
                        88,
                        89,
                        90,
                        91,
                        92,
                        93,
                        94,
                        95,
                        96,
                        97,
                        98,
                        99,
                        100,
                        101,
                        102,
                        103,
                        104,
                        105,
                        106,
                        107,
                        108,
                        109,
                        110,
                        111,
                        112,
                        113,
                        114,
                        115,
                        116,
                        117,
                        118,
                        119,
                        120,
                        121,
                        122,
                        123,
                        124,
                        125
                    ],
                    "inclusive": true
                }
            }
        };
        return lexer;
    }();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser;
}();
$26e61ff341e03f4b$exports = $26e61ff341e03f4b$var$SparqlParser;


var $03b19053b9503b86$require$Parser = $26e61ff341e03f4b$exports.Parser;
var $af61b920292f76e6$exports = {};
var $af61b920292f76e6$var$XSD_INTEGER = "http://www.w3.org/2001/XMLSchema#integer";
var $af61b920292f76e6$var$XSD_STRING = "http://www.w3.org/2001/XMLSchema#string";
function $af61b920292f76e6$var$Generator(options) {
    this._options = options = options || {};
    var prefixes = options.prefixes || {};
    this._prefixByIri = {};
    var prefixIris = [];
    for(var prefix in prefixes){
        var iri = prefixes[prefix];
        if ($af61b920292f76e6$var$isString(iri)) {
            this._prefixByIri[iri] = prefix;
            prefixIris.push(iri);
        }
    }
    var iriList = prefixIris.join("|").replace(/[\]\/\(\)\*\+\?\.\\\$]/g, "\\$&");
    this._prefixRegex = new RegExp("^(" + iriList + ")([a-zA-Z][\\-_a-zA-Z0-9]*)$");
    this._usedPrefixes = {};
    this._sparqlStar = options.sparqlStar;
    this._indent = $af61b920292f76e6$var$isString(options.indent) ? options.indent : "  ";
    this._newline = $af61b920292f76e6$var$isString(options.newline) ? options.newline : "\n";
    this._explicitDatatype = Boolean(options.explicitDatatype);
}
// Converts the parsed query object into a SPARQL query
$af61b920292f76e6$var$Generator.prototype.toQuery = function(q) {
    var query = "";
    if (q.queryType) query += q.queryType.toUpperCase() + " ";
    if (q.reduced) query += "REDUCED ";
    if (q.distinct) query += "DISTINCT ";
    if (q.variables) query += $af61b920292f76e6$var$mapJoin(q.variables, undefined, function(variable) {
        return $af61b920292f76e6$var$isTerm(variable) ? this.toEntity(variable) : "(" + this.toExpression(variable.expression) + " AS " + $af61b920292f76e6$var$variableToString(variable.variable) + ")";
    }, this) + " ";
    else if (q.template) query += this.group(q.template, true) + this._newline;
    if (q.from) query += this.graphs("FROM ", q.from.default) + this.graphs("FROM NAMED ", q.from.named);
    if (q.where) query += "WHERE " + this.group(q.where, true) + this._newline;
    if (q.updates) query += $af61b920292f76e6$var$mapJoin(q.updates, ";" + this._newline, this.toUpdate, this);
    if (q.group) query += "GROUP BY " + $af61b920292f76e6$var$mapJoin(q.group, undefined, function(it) {
        var result = $af61b920292f76e6$var$isTerm(it.expression) ? this.toEntity(it.expression) : "(" + this.toExpression(it.expression) + ")";
        return it.variable ? "(" + result + " AS " + $af61b920292f76e6$var$variableToString(it.variable) + ")" : result;
    }, this) + this._newline;
    if (q.having) query += "HAVING (" + $af61b920292f76e6$var$mapJoin(q.having, undefined, this.toExpression, this) + ")" + this._newline;
    if (q.order) query += "ORDER BY " + $af61b920292f76e6$var$mapJoin(q.order, undefined, function(it) {
        var expr = "(" + this.toExpression(it.expression) + ")";
        return !it.descending ? expr : "DESC " + expr;
    }, this) + this._newline;
    if (q.offset) query += "OFFSET " + q.offset + this._newline;
    if (q.limit) query += "LIMIT " + q.limit + this._newline;
    if (q.values) query += this.values(q);
    // stringify prefixes at the end to mark used ones
    query = this.baseAndPrefixes(q) + query;
    return query.trim();
};
$af61b920292f76e6$var$Generator.prototype.baseAndPrefixes = function(q) {
    var base = q.base ? "BASE <" + q.base + ">" + this._newline : "";
    var prefixes = "";
    for(var key in q.prefixes)if (this._options.allPrefixes || this._usedPrefixes[key]) prefixes += "PREFIX " + key + ": <" + q.prefixes[key] + ">" + this._newline;
    return base + prefixes;
};
// Converts the parsed SPARQL pattern into a SPARQL pattern
$af61b920292f76e6$var$Generator.prototype.toPattern = function(pattern) {
    var type = pattern.type || pattern instanceof Array && "array" || (pattern.subject && pattern.predicate && pattern.object ? "triple" : "");
    if (!(type in this)) throw new Error("Unknown entry type: " + type);
    return this[type](pattern);
};
$af61b920292f76e6$var$Generator.prototype.triple = function(t) {
    return this.toEntity(t.subject) + " " + this.toEntity(t.predicate) + " " + this.toEntity(t.object) + ".";
};
$af61b920292f76e6$var$Generator.prototype.array = function(items) {
    return $af61b920292f76e6$var$mapJoin(items, this._newline, this.toPattern, this);
};
$af61b920292f76e6$var$Generator.prototype.bgp = function(bgp) {
    return this.encodeTriples(bgp.triples);
};
$af61b920292f76e6$var$Generator.prototype.encodeTriples = function(triples) {
    if (!triples.length) return "";
    var parts = [], subject = undefined, predicate = undefined;
    for(var i = 0; i < triples.length; i++){
        var triple = triples[i];
        // Triple with different subject
        if (!$af61b920292f76e6$var$equalTerms(triple.subject, subject)) {
            // Terminate previous triple
            if (subject) parts.push("." + this._newline);
            subject = triple.subject;
            predicate = triple.predicate;
            parts.push(this.toEntity(subject), " ", this.toEntity(predicate));
        } else if (!$af61b920292f76e6$var$equalTerms(triple.predicate, predicate)) {
            predicate = triple.predicate;
            parts.push(";" + this._newline, this._indent, this.toEntity(predicate));
        } else parts.push(",");
        parts.push(" ", this.toEntity(triple.object));
    }
    parts.push(".");
    return parts.join("");
};
$af61b920292f76e6$var$Generator.prototype.graph = function(graph) {
    return "GRAPH " + this.toEntity(graph.name) + " " + this.group(graph);
};
$af61b920292f76e6$var$Generator.prototype.graphs = function(keyword, graphs) {
    return !graphs || graphs.length === 0 ? "" : $af61b920292f76e6$var$mapJoin(graphs, "", function(g) {
        return keyword + this.toEntity(g) + this._newline;
    }, this);
};
$af61b920292f76e6$var$Generator.prototype.group = function(group, inline) {
    group = inline !== true ? this.array(group.patterns || group.triples) : this.toPattern(group.type !== "group" ? group : group.patterns);
    return group.indexOf(this._newline) === -1 ? "{ " + group + " }" : "{" + this._newline + this.indent(group) + this._newline + "}";
};
$af61b920292f76e6$var$Generator.prototype.query = function(query) {
    return this.toQuery(query);
};
$af61b920292f76e6$var$Generator.prototype.filter = function(filter) {
    return "FILTER(" + this.toExpression(filter.expression) + ")";
};
$af61b920292f76e6$var$Generator.prototype.bind = function(bind) {
    return "BIND(" + this.toExpression(bind.expression) + " AS " + $af61b920292f76e6$var$variableToString(bind.variable) + ")";
};
$af61b920292f76e6$var$Generator.prototype.optional = function(optional) {
    return "OPTIONAL " + this.group(optional);
};
$af61b920292f76e6$var$Generator.prototype.union = function(union) {
    return $af61b920292f76e6$var$mapJoin(union.patterns, this._newline + "UNION" + this._newline, function(p) {
        return this.group(p, true);
    }, this);
};
$af61b920292f76e6$var$Generator.prototype.minus = function(minus) {
    return "MINUS " + this.group(minus);
};
$af61b920292f76e6$var$Generator.prototype.values = function(valuesList) {
    // Gather unique keys
    var keys = Object.keys(valuesList.values.reduce(function(keyHash, values) {
        for(var key in values)keyHash[key] = true;
        return keyHash;
    }, {}));
    // Check whether simple syntax can be used
    var lparen, rparen;
    if (keys.length === 1) lparen = rparen = "";
    else {
        lparen = "(";
        rparen = ")";
    }
    // Create value rows
    return "VALUES " + lparen + keys.join(" ") + rparen + " {" + this._newline + $af61b920292f76e6$var$mapJoin(valuesList.values, this._newline, function(values) {
        return "  " + lparen + $af61b920292f76e6$var$mapJoin(keys, undefined, function(key) {
            return values[key] ? this.toEntity(values[key]) : "UNDEF";
        }, this) + rparen;
    }, this) + this._newline + "}";
};
$af61b920292f76e6$var$Generator.prototype.service = function(service) {
    return "SERVICE " + (service.silent ? "SILENT " : "") + this.toEntity(service.name) + " " + this.group(service);
};
// Converts the parsed expression object into a SPARQL expression
$af61b920292f76e6$var$Generator.prototype.toExpression = function(expr) {
    if ($af61b920292f76e6$var$isTerm(expr)) return this.toEntity(expr);
    switch(expr.type.toLowerCase()){
        case "aggregate":
            return expr.aggregation.toUpperCase() + "(" + (expr.distinct ? "DISTINCT " : "") + this.toExpression(expr.expression) + (typeof expr.separator === "string" ? '; SEPARATOR = "' + expr.separator.replace($af61b920292f76e6$var$escape, $af61b920292f76e6$var$escapeReplacer) + '"' : "") + ")";
        case "functioncall":
            return this.toEntity(expr.function) + "(" + $af61b920292f76e6$var$mapJoin(expr.args, ", ", this.toExpression, this) + ")";
        case "operation":
            var operator = expr.operator.toUpperCase(), args = expr.args || [];
            switch(expr.operator.toLowerCase()){
                // Infix operators
                case "<":
                case ">":
                case ">=":
                case "<=":
                case "&&":
                case "||":
                case "=":
                case "!=":
                case "+":
                case "-":
                case "*":
                case "/":
                    return ($af61b920292f76e6$var$isTerm(args[0]) ? this.toEntity(args[0]) : "(" + this.toExpression(args[0]) + ")") + " " + operator + " " + ($af61b920292f76e6$var$isTerm(args[1]) ? this.toEntity(args[1]) : "(" + this.toExpression(args[1]) + ")");
                // Unary operators
                case "!":
                    return "!(" + this.toExpression(args[0]) + ")";
                case "uplus":
                    return "+(" + this.toExpression(args[0]) + ")";
                case "uminus":
                    return "-(" + this.toExpression(args[0]) + ")";
                // IN and NOT IN
                case "notin":
                    operator = "NOT IN";
                case "in":
                    return this.toExpression(args[0]) + " " + operator + "(" + ($af61b920292f76e6$var$isString(args[1]) ? args[1] : $af61b920292f76e6$var$mapJoin(args[1], ", ", this.toExpression, this)) + ")";
                // EXISTS and NOT EXISTS
                case "notexists":
                    operator = "NOT EXISTS";
                case "exists":
                    return operator + " " + this.group(args[0], true);
                // Other expressions
                default:
                    return operator + "(" + $af61b920292f76e6$var$mapJoin(args, ", ", this.toExpression, this) + ")";
            }
        default:
            throw new Error("Unknown expression type: " + expr.type);
    }
};
// Converts the parsed entity (or property path) into a SPARQL entity
$af61b920292f76e6$var$Generator.prototype.toEntity = function(value) {
    if ($af61b920292f76e6$var$isTerm(value)) switch(value.termType){
        // variable, * selector, or blank node
        case "Wildcard":
            return "*";
        case "Variable":
            return $af61b920292f76e6$var$variableToString(value);
        case "BlankNode":
            return "_:" + value.value;
        // literal
        case "Literal":
            var lexical = value.value || "", language = value.language || "", datatype = value.datatype;
            value = '"' + lexical.replace($af61b920292f76e6$var$escape, $af61b920292f76e6$var$escapeReplacer) + '"';
            if (language) value += "@" + language;
            else if (datatype) {
                // Abbreviate literals when possible
                if (!this._explicitDatatype) switch(datatype.value){
                    case $af61b920292f76e6$var$XSD_STRING:
                        return value;
                    case $af61b920292f76e6$var$XSD_INTEGER:
                        if (/^\d+$/.test(lexical)) // Add space to avoid confusion with decimals in broken parsers
                        return lexical + " ";
                }
                value += "^^" + this.encodeIRI(datatype.value);
            }
            return value;
        case "Quad":
            if (!this._sparqlStar) throw new Error("SPARQL* support is not enabled");
            if (value.graph && value.graph.termType !== "DefaultGraph") return "<< GRAPH " + this.toEntity(value.graph) + " { " + this.toEntity(value.subject) + " " + this.toEntity(value.predicate) + " " + this.toEntity(value.object) + " } " + " >>";
            else return "<< " + this.toEntity(value.subject) + " " + this.toEntity(value.predicate) + " " + this.toEntity(value.object) + " >>";
        // IRI
        default:
            return this.encodeIRI(value.value);
    }
    else {
        var items = value.items.map(this.toEntity, this), path = value.pathType;
        switch(path){
            // prefix operator
            case "^":
            case "!":
                return path + items[0];
            // postfix operator
            case "*":
            case "+":
            case "?":
                return "(" + items[0] + path + ")";
            // infix operator
            default:
                return "(" + items.join(path) + ")";
        }
    }
};
var $af61b920292f76e6$var$escape = /["\\\t\n\r\b\f]/g, $af61b920292f76e6$var$escapeReplacer = function(c) {
    return $af61b920292f76e6$var$escapeReplacements[c];
}, $af61b920292f76e6$var$escapeReplacements = {
    "\\": "\\\\",
    '"': '\\"',
    "	": "\\t",
    "\n": "\\n",
    "\r": "\\r",
    "\b": "\\b",
    "\f": "\\f"
};
// Represent the IRI, as a prefixed name when possible
$af61b920292f76e6$var$Generator.prototype.encodeIRI = function(iri) {
    var prefixMatch = this._prefixRegex.exec(iri);
    if (prefixMatch) {
        var prefix = this._prefixByIri[prefixMatch[1]];
        this._usedPrefixes[prefix] = true;
        return prefix + ":" + prefixMatch[2];
    }
    return "<" + iri + ">";
};
// Converts the parsed update object into a SPARQL update clause
$af61b920292f76e6$var$Generator.prototype.toUpdate = function(update) {
    switch(update.type || update.updateType){
        case "load":
            return "LOAD" + (update.source ? " " + this.toEntity(update.source) : "") + (update.destination ? " INTO GRAPH " + this.toEntity(update.destination) : "");
        case "insert":
            return "INSERT DATA " + this.group(update.insert, true);
        case "delete":
            return "DELETE DATA " + this.group(update.delete, true);
        case "deletewhere":
            return "DELETE WHERE " + this.group(update.delete, true);
        case "insertdelete":
            return (update.graph ? "WITH " + this.toEntity(update.graph) + this._newline : "") + (update.delete.length ? "DELETE " + this.group(update.delete, true) + this._newline : "") + (update.insert.length ? "INSERT " + this.group(update.insert, true) + this._newline : "") + (update.using ? this.graphs("USING ", update.using.default) : "") + (update.using ? this.graphs("USING NAMED ", update.using.named) : "") + "WHERE " + this.group(update.where, true);
        case "add":
        case "copy":
        case "move":
            return update.type.toUpperCase() + " " + (update.silent ? "SILENT " : "") + (update.source.default ? "DEFAULT" : this.toEntity(update.source.name)) + " TO " + this.toEntity(update.destination.name);
        case "create":
        case "clear":
        case "drop":
            return update.type.toUpperCase() + (update.silent ? " SILENT " : " ") + (update.graph.default ? "DEFAULT" : update.graph.named ? "NAMED" : update.graph.all ? "ALL" : "GRAPH " + this.toEntity(update.graph.name));
        default:
            throw new Error("Unknown update query type: " + update.type);
    }
};
// Indents each line of the string
$af61b920292f76e6$var$Generator.prototype.indent = function(text) {
    return text.replace(/^/gm, this._indent);
};
function $af61b920292f76e6$var$variableToString(variable) {
    return "?" + variable.value;
}
// Checks whether the object is a string
function $af61b920292f76e6$var$isString(object) {
    return typeof object === "string";
}
// Checks whether the object is a Term
function $af61b920292f76e6$var$isTerm(object) {
    return typeof object.termType === "string";
}
// Checks whether term1 and term2 are equivalent without `.equals()` prototype method
function $af61b920292f76e6$var$equalTerms(term1, term2) {
    if (!term1 || !$af61b920292f76e6$var$isTerm(term1)) return false;
    if (!term2 || !$af61b920292f76e6$var$isTerm(term2)) return false;
    if (term1.termType !== term2.termType) return false;
    switch(term1.termType){
        case "Literal":
            return term1.value === term2.value && term1.language === term2.language && $af61b920292f76e6$var$equalTerms(term1.datatype, term2.datatype);
        case "Quad":
            return $af61b920292f76e6$var$equalTerms(term1.subject, term2.subject) && $af61b920292f76e6$var$equalTerms(term1.predicate, term2.predicate) && $af61b920292f76e6$var$equalTerms(term1.object, term2.object) && $af61b920292f76e6$var$equalTerms(term1.graph, term2.graph);
        default:
            return term1.value === term2.value;
    }
}
// Maps the array with the given function, and joins the results using the separator
function $af61b920292f76e6$var$mapJoin(array, sep, func, self) {
    return array.map(func, self).join($af61b920292f76e6$var$isString(sep) ? sep : " ");
}
/**
 * @param options {
 *   allPrefixes: boolean,
 *   indentation: string,
 *   newline: string
 * }
 */ $af61b920292f76e6$exports = function SparqlGenerator(options = {}) {
    return {
        stringify: function(query) {
            var currentOptions = Object.create(options);
            currentOptions.prefixes = query.prefixes;
            return new $af61b920292f76e6$var$Generator(currentOptions).toQuery(query);
        },
        createGenerator: function() {
            return new $af61b920292f76e6$var$Generator(options);
        }
    };
};



var $jUw11 = parcelRequire("jUw11");
var $03b19053b9503b86$require$Wildcard = $jUw11.Wildcard;
var $fbdcb90cff43807c$exports = {};
"use strict";
var $fbdcb90cff43807c$var$__createBinding = $fbdcb90cff43807c$exports && $fbdcb90cff43807c$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fbdcb90cff43807c$var$__exportStar = $fbdcb90cff43807c$exports && $fbdcb90cff43807c$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fbdcb90cff43807c$var$__createBinding(exports1, m, p);
};
Object.defineProperty($fbdcb90cff43807c$exports, "__esModule", {
    value: true
});

$fbdcb90cff43807c$var$__exportStar((parcelRequire("dUwlf")), $fbdcb90cff43807c$exports);

$fbdcb90cff43807c$var$__exportStar((parcelRequire("3wL3n")), $fbdcb90cff43807c$exports);

$fbdcb90cff43807c$var$__exportStar((parcelRequire("0UUif")), $fbdcb90cff43807c$exports);

$fbdcb90cff43807c$var$__exportStar((parcelRequire("8RsDA")), $fbdcb90cff43807c$exports);

$fbdcb90cff43807c$var$__exportStar((parcelRequire("7KJsK")), $fbdcb90cff43807c$exports);

$fbdcb90cff43807c$var$__exportStar((parcelRequire("1k2AX")), $fbdcb90cff43807c$exports);

$fbdcb90cff43807c$var$__exportStar((parcelRequire("kNA9K")), $fbdcb90cff43807c$exports);


var $03b19053b9503b86$require$DataFactory = $fbdcb90cff43807c$exports.DataFactory;
$03b19053b9503b86$exports = {
    /**
   * Creates a SPARQL parser with the given pre-defined prefixes and base IRI
   * @param options {
   *   prefixes?: { [prefix: string]: string },
   *   baseIRI?: string,
   *   factory?: import('rdf-js').DataFactory,
   *   sparqlStar?: boolean,
   *   skipValidation?: boolean,
   *   skipUngroupedVariableCheck?: boolean
   * }
   */ Parser: function({ prefixes: prefixes, baseIRI: baseIRI, factory: factory, sparqlStar: sparqlStar, skipValidation: skipValidation, skipUngroupedVariableCheck: skipUngroupedVariableCheck, pathOnly: pathOnly } = {}) {
        // Create a copy of the prefixes
        var prefixesCopy = {};
        for(var prefix in prefixes || {})prefixesCopy[prefix] = prefixes[prefix];
        // Create a new parser with the given prefixes
        // (Workaround for https://github.com/zaach/jison/issues/241)
        var parser = new $03b19053b9503b86$require$Parser();
        parser.parse = function() {
            $03b19053b9503b86$require$Parser.base = baseIRI || "";
            $03b19053b9503b86$require$Parser.prefixes = Object.create(prefixesCopy);
            $03b19053b9503b86$require$Parser.factory = factory || new $03b19053b9503b86$require$DataFactory();
            $03b19053b9503b86$require$Parser.sparqlStar = Boolean(sparqlStar);
            $03b19053b9503b86$require$Parser.pathOnly = Boolean(pathOnly);
            // We keep skipUngroupedVariableCheck for compatibility reasons.
            $03b19053b9503b86$require$Parser.skipValidation = Boolean(skipValidation) || Boolean(skipUngroupedVariableCheck);
            return $03b19053b9503b86$require$Parser.prototype.parse.apply(parser, arguments);
        };
        parser._resetBlanks = $03b19053b9503b86$require$Parser._resetBlanks;
        return parser;
    },
    Generator: $af61b920292f76e6$exports,
    Wildcard: $03b19053b9503b86$require$Wildcard
};



const $35459c07cd7570af$var$defaultQueryPaginationSize = 250;
let $35459c07cd7570af$export$91240bce4e364bef = 60000;
function $35459c07cd7570af$export$7fc4ea9a72a632dc(url, header = {}, method = "GET", query = "", numTry = 0) {
    let myHeaders = {};
    myHeaders["pragma"] = "no-cache";
    myHeaders["cache-control"] = "no-cache";
    Object.keys(header).forEach((key)=>{
        myHeaders[key] = header[key];
    });
    let myInit = {
        method: method,
        headers: myHeaders,
        redirect: "follow"
    };
    if (method.localeCompare("POST") == 0) myInit.body = query;
    return fetch(url, myInit).then((response)=>{
        if (response.ok) return response.blob().then((blob)=>blob.text());
        else throw response;
    }).catch((error)=>{
        console.error("Error during fetch", error);
    });
}
function $35459c07cd7570af$export$a6e59c03a779ef88(url, header = {}) {
    return new Promise((resolve, reject)=>{
        let request = new XMLHttpRequest();
        request.open("GET", url);
        let myHeaders = {};
        // myHeaders["pragma"] = "no-cache";
        // myHeaders["cache-control"] = "no-cache";
        Object.keys(header).forEach((key)=>{
            myHeaders[key] = header[key];
        });
        Object.keys(myHeaders).forEach((key)=>{
            request.setRequestHeader(key, myHeaders[key]);
        });
        request.onreadystatechange = ()=>{
            if (request.readyState == 4) {
                if (request.status == 200) resolve(request.responseText);
                else reject(request.status);
            }
        };
        request.send();
    });
}
function $35459c07cd7570af$export$3233bfa38a51357e(url, query = "", header = {}) {
    return $35459c07cd7570af$export$7fc4ea9a72a632dc(url, header, "POST", query);
}
function $35459c07cd7570af$export$230442c21b56ff1e(url, otherHeaders = {}) {
    let header = {};
    header["accept"] = "application/json";
    Object.keys(otherHeaders).forEach((key)=>{
        header[key] = otherHeaders[key];
    });
    return $35459c07cd7570af$export$a6e59c03a779ef88(url, header).then((response)=>{
        if (response == null || response == undefined || response == "") return {};
        else try {
            return JSON.parse(response);
        } catch (error) {
            console.error(url, error, response);
            throw error;
        }
    });
}
function $35459c07cd7570af$export$d37bf5547347f960(endpoint, query, timeout = $35459c07cd7570af$export$91240bce4e364bef) {
    let jsonHeaders = {};
    jsonHeaders["Accept"] = "application/sparql-results+json";
    if ($35459c07cd7570af$export$3cdb12c099e58bd1(query)) return $35459c07cd7570af$export$230442c21b56ff1e(endpoint + "?query=" + encodeURIComponent(query) + "&format=json&timeout=" + timeout, jsonHeaders).catch((error)=>{
        console.error(endpoint, query, error);
        throw error;
    });
    else if ($35459c07cd7570af$export$6fc7ccfd73d62d6(query)) return $35459c07cd7570af$export$230442c21b56ff1e(endpoint + "?query=" + encodeURIComponent(query) + "&format=json&timeout=" + timeout, jsonHeaders).catch(()=>{
        return {
            boolean: false
        };
    });
    else if ($35459c07cd7570af$export$8b54a6cc6363eda0(query) || $35459c07cd7570af$export$e96226776349d85c(query)) return $35459c07cd7570af$export$a6e59c03a779ef88(endpoint + "?query=" + encodeURIComponent(query) + "&format=turtle&timeout=" + timeout).then((result)=>{
        let resultStore = $5605c1058d66d37f$export$f51a9068ac82ea43();
        result = $5605c1058d66d37f$export$e42ce4998cf68d98(result);
        return $5605c1058d66d37f$export$968deea481412d5d(result, resultStore, endpoint).catch((error)=>{
            console.error(endpoint, query, error, result);
            return;
        });
    }).catch((error)=>{
        console.error(endpoint, query, error);
        throw error;
    });
    else {
        console.error(new Error("Unexpected query type"));
        return Promise.reject(new Error("Unexpected query type"));
    }
}
function $35459c07cd7570af$export$2ffe62e6fe70d843(queryString, queryType) {
    let parser = new (0, (/*@__PURE__*/$parcel$interopDefault($03b19053b9503b86$exports))).Parser();
    try {
        const parsedQuery = parser.parse(queryString);
        if (parsedQuery.queryType != undefined) return parsedQuery.queryType.localeCompare(queryType) == 0;
        else if (parsedQuery.type != undefined) return parsedQuery.type.localeCompare(queryType) == 0;
        else throw new Error("No expected query type property : " + JSON.stringify(parsedQuery));
    } catch (error) {
        console.error(queryString, error);
        return false;
    }
}
function $35459c07cd7570af$export$8b54a6cc6363eda0(queryString) {
    return $35459c07cd7570af$export$2ffe62e6fe70d843(queryString, "CONSTRUCT");
}
function $35459c07cd7570af$export$3cdb12c099e58bd1(queryString) {
    return $35459c07cd7570af$export$2ffe62e6fe70d843(queryString, "SELECT");
}
function $35459c07cd7570af$export$6fc7ccfd73d62d6(queryString) {
    return $35459c07cd7570af$export$2ffe62e6fe70d843(queryString, "ASK");
}
function $35459c07cd7570af$export$e96226776349d85c(queryString) {
    return $35459c07cd7570af$export$2ffe62e6fe70d843(queryString, "DESCRIBE");
}
function $35459c07cd7570af$export$25d0fe831c5dfff3(queryString) {
    return $35459c07cd7570af$export$2ffe62e6fe70d843(queryString, "update");
}
function $35459c07cd7570af$export$47ed34a15a70bfcf(query) {
    return query.queryType !== undefined && query.queryType === "SELECT";
}
function $35459c07cd7570af$export$b8aa98064b7724c5(query) {
    return query.queryType !== undefined && query.queryType === "ASK";
}
function $35459c07cd7570af$export$f9883ba9a52b1c20(query) {
    return query.queryType !== undefined && query.queryType === "CONSTRUCT";
}
function $35459c07cd7570af$export$d8400edf95116ba7(query) {
    return query.queryType !== undefined && query.queryType === "DESCRIBE";
}
function $35459c07cd7570af$export$90b40f9476038ea6(query) {
    return query.type !== undefined && query.type === "update";
}
function $35459c07cd7570af$export$39dfa61b343cea87(endpointUrl, query, pageSize = $35459c07cd7570af$var$defaultQueryPaginationSize, iteration = 0, timeout = $35459c07cd7570af$export$91240bce4e364bef, finalResult) {
    let generator = new (0, (/*@__PURE__*/$parcel$interopDefault($03b19053b9503b86$exports))).Generator();
    let parser = new (0, (/*@__PURE__*/$parcel$interopDefault($03b19053b9503b86$exports))).Parser();
    let queryObject = parser.parse(query);
    if (finalResult === undefined) {
        if ($35459c07cd7570af$export$3cdb12c099e58bd1(query)) finalResult = [];
        else if ($35459c07cd7570af$export$8b54a6cc6363eda0(query)) finalResult = $5605c1058d66d37f$export$f51a9068ac82ea43();
        else throw new Error("Unexpected query type during pagination");
    }
    if ($35459c07cd7570af$export$47ed34a15a70bfcf(queryObject)) {
        // We add the OFFSET and LIMIT to the query
        queryObject.offset = iteration * pageSize;
        queryObject.limit = pageSize;
    }
    let generatedQuery = generator.stringify(queryObject);
    // We send the paginated CONSTRUCT query
    return $35459c07cd7570af$export$d37bf5547347f960(endpointUrl, generatedQuery, timeout).then((generatedQueryResult)=>{
        if (generatedQueryResult !== undefined) {
            if ($35459c07cd7570af$export$3cdb12c099e58bd1(query)) try {
                let parsedSelectQueryResult = generatedQueryResult;
                finalResult = finalResult.concat(parsedSelectQueryResult["results"].bindings);
                if (parsedSelectQueryResult["results"].bindings.length > 0) return $35459c07cd7570af$export$39dfa61b343cea87(endpointUrl, query, pageSize, iteration + 1, timeout, finalResult);
                else return finalResult;
            } catch (error) {
                console.error("Error while parsing the query result as SELECT result: ", error, generatedQueryResult);
                throw error;
            }
            else if ($35459c07cd7570af$export$8b54a6cc6363eda0(query)) {
                finalResult.addAll(generatedQueryResult.statements);
                if (generatedQueryResult.statements.length > 0) return $35459c07cd7570af$export$39dfa61b343cea87(endpointUrl, query, pageSize, iteration + 1, timeout, finalResult);
                else {
                    if (finalResult !== undefined) return finalResult;
                    else throw new Error("No final result defined");
                }
            } else {
                if (finalResult !== undefined) return finalResult;
                else throw new Error("No final result defined");
            }
        } else {
            if (finalResult !== undefined) return finalResult;
            else throw new Error("No final result defined");
        }
    }).catch((error)=>{
        console.error("Error while paginating the query: ", error);
        throw error;
    }).finally(()=>{
        if (finalResult !== undefined) return finalResult;
        else throw new Error("No final result defined");
    });
}
function $35459c07cd7570af$export$4282b215e95fd9cb(settledPromisesResult) {
    return settledPromisesResult.map((promiseResult)=>{
        if (promiseResult.status === "fulfilled") return promiseResult.value;
        else return undefined;
    });
}



let $522a0f63ac74d0e8$var$md = new (0, $0d15360f132ce1e2$export$2e2bcd8739ae039)({
    html: true,
    xhtmlOut: true,
    breaks: true,
    langPrefix: "language-",
    linkify: true
});
class $522a0f63ac74d0e8$export$5eed707d4f2a2569 extends (0, $1dd5f29d6665a182$export$5cf80f451b772330) {
    constructor(configObject, appendTargetId = "#titleHeader"){
        super("", "person", configObject, appendTargetId);
    }
    content() {
        let personName = this.config["name"];
        return Promise.resolve($522a0f63ac74d0e8$var$md.render(`# ${personName}`));
    }
}
class $522a0f63ac74d0e8$export$79e3a3d3e861b76d extends (0, $1dd5f29d6665a182$export$5cf80f451b772330) {
    constructor(configObject, appendTargetId = "#socialInfo"){
        super("", "social", configObject, appendTargetId);
    }
    content() {
        let content = "";
        if (this.config.website !== undefined && this.config.website !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/globe.svg" alt="Website logo" class="icon-image"> Website](${this.config.website}) `);
        if (this.config.blog !== undefined && this.config.blog !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/journal-text.svg" alt="Blog logo" class="icon-image"> Blog](${this.config.blog}) `);
        if (this.config.email !== undefined && this.config.email !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/envelope-fill.svg" alt="Email logo" class="icon-image"> Email](mailto:${this.config.email}) `);
        if (this.config.twitter !== undefined && this.config.twitter !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/twitter-x.svg" alt="X logo" class="icon-image"> X](https://twitter.com/${this.config.twitter}) `);
        if (this.config.github !== undefined && this.config.github !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/github.svg" alt="Github logo" class="icon-image"> GitHub](https://github.com/${this.config.github}) `);
        if (this.config.mastodon !== undefined && this.config.mastodon !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/mastodon.svg" alt="Mastodon logo" class="icon-image"> Mastodon](${this.config.mastodon}) `);
        if (this.config.linkedin !== undefined && this.config.linkedin !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/linkedin.svg" alt="LinkedIn logo" class="icon-image"> LinkedIn](https://www.linkedin.com/in/${this.config.linkedin}) `);
        if (this.config.orcid !== undefined && this.config.orcid !== "") content = content.concat(`[<img src="https://info.orcid.org/wp-content/uploads/2020/12/orcid_16x16.gif" alt="ORCID logo" class="icon-image"> ORCiD](https://orcid.org/${this.config.orcid}) `);
        if (this.config.dblp !== undefined && this.config.dblp !== "") content = content.concat(`[<img src="https://dblp.org/img/dblp.icon.192x192.png" alt="DBLP logo" class="icon-image"> DBLP](https://dblp.org/pid/${this.config.dblp}) `);
        if (this.config.hal !== undefined && this.config.hal !== "") content = content.concat(`[<img src="https://raw.githubusercontent.com/MaillPierre/personal-page/refs/heads/main/img/hal-logo-header.png" alt="HAL Id logo" class="icon-image"> HAL](https://cv.hal.science/${this.config.hal}) `);
        if (this.config.gscholar !== undefined && this.config.gscholar !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/google.svg" alt="Google Scholar logo" class="icon-image"> Google Scholar](https://scholar.google.com/citations?user=${this.config.gscholar}) `);
        if (this.config.instagram !== undefined && this.config.instagram !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/instagram.svg" alt="Instagram logo" class="icon-image"> Instagram](https://www.instagram.com/${this.config.instagram}) `);
        if (this.config.facebook !== undefined && this.config.facebook !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/facebook.svg" alt="Facebook logo" class="icon-image"> Facebook](${this.config.facebook}) `);
        if (this.config.youtube !== undefined && this.config.youtube !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/youtube.svg" alt="YouTube logo" class="icon-image"> YouTube](${this.config.youtube}) `);
        if (this.config.twitch !== undefined && this.config.twitch !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/twitch.svg" alt="Twitch logo" class="icon-image"> Twitch](${this.config.twitch}) `);
        if (this.config.patreon !== undefined && this.config.patreon !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/patreon.svg" alt="Patreon logo" class="icon-image"> Patreon](https://patreon.com/${this.config.patreon}) `);
        if (this.config.paypal !== undefined && this.config.paypal !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/paypal.svg" alt="PayPal logo" class="icon-image"> PayPal](${this.config.paypal}) `);
        if (this.config.bitcoin !== undefined && this.config.bitcoin !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/bitcoin.svg" alt="Bitcoin logo" class="icon-image"> Bitcoin](${this.config.bitcoin}) `);
        if (this.config.ethereum !== undefined && this.config.ethereum !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/ethereum.svg" alt="Ethereum logo" class="icon-image"> Ethereum](${this.config.ethereum}) `);
        if (this.config.monero !== undefined && this.config.monero !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/monero.svg" alt="Monero logo" class="icon-image"> Monero](${this.config.monero}) `);
        if (this.config.flattr !== undefined && this.config.flattr !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/flattr.svg" alt="Flattr logo" class="icon-image"> Flattr](${this.config.flattr}) `);
        if (this.config.liberapay !== undefined && this.config.liberapay !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/liberapay.svg" alt="Liberapay logo" class="icon-image"> Liberapay](${this.config.liberapay}) `);
        if (this.config.buymeacoffee !== undefined && this.config.buymeacoffee !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/buymeacoffee.svg" alt="Buy me a coffee logo" class="icon-image"> Buy me a coffee](${this.config.buymeacoffee}) `);
        if (this.config.open_collective !== undefined && this.config.open_collective !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/open-collective.svg" alt="Open Collective logo" class="icon-image"> Open Collective](${this.config.open_collective}) `);
        if (this.config.ko_fi !== undefined && this.config.ko_fi !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/ko-fi.svg" alt="Ko-fi logo" class="icon-image"> Ko-fi](${this.config.ko_fi}) `);
        if (this.config.reddit !== undefined && this.config.reddit !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/reddit.svg" alt="Reddit logo" class="icon-image"> Reddit](https://www.reddit.com/${this.config.reddit}) `);
        if (this.config.whatsapp !== undefined && this.config.whatsapp !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/whatsapp.svg" alt="WhatsApp logo" class="icon-image"> WhatsApp](${this.config.whatsapp}) `);
        if (this.config.telegram !== undefined && this.config.telegram !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/telegram.svg" alt="Telegram logo" class="icon-image"> Telegram](${this.config.telegram}) `);
        if (this.config.discord !== undefined && this.config.discord !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/discord.svg" alt="Discord logo" class="icon-image"> Discord](${this.config.discord}) `);
        if (this.config.bluesky !== undefined && this.config.bluesky !== "") content = content.concat(`[<img src="https://raw.githubusercontent.com/MaillPierre/personal-page/6dea702d7df909f2b962e1fa924aefa79bf93c29/img/butterfly.svg" alt="BlueSky logo" class="icon-image"> BlueSky](${this.config.bluesky}) `);
        if (this.config.slack !== undefined && this.config.slack !== "") content = content.concat(`[<img src="https://icons.getbootstrap.com/assets/icons/slack.svg" alt="Slack logo" class="icon-image"> Slack](${this.config.slack}) `);
        if (this.config.affiliation !== undefined && this.config.affiliation !== "") content = content.concat(`
Affiliation: ${this.config.affiliation} `);
        return Promise.resolve($522a0f63ac74d0e8$var$md.render(content));
    }
}
class $522a0f63ac74d0e8$export$588bdae3d57c90cb extends (0, $1dd5f29d6665a182$export$5cf80f451b772330) {
    constructor(configObject, appendTargetId = "#publications"){
        super("Publications", "dblp", configObject, appendTargetId);
        this.idDBLP = configObject.publications.dblp;
        this.dblpData = $5605c1058d66d37f$export$f51a9068ac82ea43();
        this.dblpDataLoadingPromise = $35459c07cd7570af$export$a6e59c03a779ef88(`https://raw.githubusercontent.com/MaillPierre/personal-page/deploy/data/dblp_person.ttl`).then((dataString)=>{
            $5605c1058d66d37f$export$968deea481412d5d(dataString, this.dblpData, `https://dblp.org/pid/${this.idDBLP}.ttl`);
        }).catch((error)=>{
            $5979e5393e457062$export$bef1f36f5486a6a3("error", "Error loading HAL data: " + error);
        });
    }
    generateData() {
        let authorOrcidMap = new Map();
        let biblioObject = {
            journalArticle: [],
            conferenceArticle: [],
            informalArticle: []
        };
        return this.dblpDataLoadingPromise.then(()=>{
            return $35459c07cd7570af$export$a6e59c03a779ef88(`https://raw.githubusercontent.com/MaillPierre/personal-page/deploy/data/dblp_articles.ttl`).then((articleDataString)=>{
                return $5605c1058d66d37f$export$968deea481412d5d(articleDataString, this.dblpData, `https://dblp.org/pid/${this.idDBLP}.ttl`);
            });
        }).then(()=>{
            function extractArticleArray(articleType, dblpData) {
                let typedArticlesNodes = dblpData.statementsMatching(undefined, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$b205ee610c4a7a73(articleType)).map((statement)=>{
                    return statement.subject;
                });
                return typedArticlesNodes.map((articleNode)=>{
                    let articleObject = {
                        types: [],
                        title: "",
                        authors: [],
                        year: "",
                        month: "",
                        venue: "",
                        doi: ""
                    };
                    dblpData.statementsMatching(articleNode, $5605c1058d66d37f$export$fd985e82eeb3038("type"), undefined).forEach((statement)=>{
                        articleObject.types.push(statement.object);
                    });
                    dblpData.statementsMatching(articleNode, $5605c1058d66d37f$export$b205ee610c4a7a73("title"), undefined).forEach((statement)=>{
                        articleObject.title = decodeURIComponent(statement.object.value);
                    });
                    dblpData.statementsMatching(articleNode, $5605c1058d66d37f$export$b205ee610c4a7a73("doi"), undefined).forEach((statement)=>{
                        articleObject.doi = statement.object.value;
                    });
                    dblpData.statementsMatching(articleNode, $5605c1058d66d37f$export$b205ee610c4a7a73("publishedIn"), undefined).forEach((statement)=>{
                        articleObject.venue = decodeURIComponent(statement.object.value);
                    });
                    dblpData.statementsMatching(articleNode, $5605c1058d66d37f$export$b205ee610c4a7a73("yearOfPublication"), undefined).forEach((statement)=>{
                        articleObject.year = statement.object.value;
                    });
                    dblpData.statementsMatching(articleNode, $5605c1058d66d37f$export$b205ee610c4a7a73("monthOfPublication"), undefined).forEach((statement)=>{
                        articleObject.month = statement.object.value;
                    });
                    dblpData.statementsMatching(articleNode, $5605c1058d66d37f$export$b205ee610c4a7a73("hasSignature"), undefined).forEach((statement)=>{
                        let signatureNode = statement.object;
                        let authorObject = {
                            name: "",
                            orcid: "",
                            order: 0
                        };
                        dblpData.statementsMatching(signatureNode, $5605c1058d66d37f$export$b205ee610c4a7a73("signatureDblpName"), undefined).forEach((statement)=>{
                            authorObject.name = decodeURIComponent(statement.object.value);
                        });
                        dblpData.statementsMatching(signatureNode, $5605c1058d66d37f$export$b205ee610c4a7a73("signatureOrcid"), undefined).forEach((statement)=>{
                            authorOrcidMap.set(authorObject.name, statement.object.value);
                        });
                        dblpData.statementsMatching(signatureNode, $5605c1058d66d37f$export$b205ee610c4a7a73("signatureOrdinal"), undefined).forEach((statement)=>{
                            authorObject.order = parseInt(statement.object.value);
                        });
                        articleObject.authors.push(authorObject);
                    });
                    articleObject.authors.sort((a, b)=>{
                        return a.order - b.order;
                    });
                    return articleObject;
                });
            }
            biblioObject.journalArticle = extractArticleArray("Article", this.dblpData).sort((a, b)=>{
                return parseInt(b.year) - parseInt(a.year);
            });
            biblioObject.conferenceArticle = extractArticleArray("Inproceedings", this.dblpData).sort((a, b)=>{
                return parseInt(b.year) - parseInt(a.year);
            });
            biblioObject.informalArticle = extractArticleArray("Informal", this.dblpData).sort((a, b)=>{
                return parseInt(b.year) - parseInt(a.year);
            });
            return biblioObject;
        }).then((biblioObject)=>{
            function articleListToString(articleList) {
                return articleList.map((articleObject)=>{
                    let authors = articleObject.authors.map((author)=>{
                        if (authorOrcidMap.get(author.name) !== "" && authorOrcidMap.get(author.name) !== undefined) return `[${author.name}](${authorOrcidMap.get(author.name)})`;
                        else return author.name;
                    }).join(", ");
                    return `* [**${articleObject.title}**](${articleObject.doi}), ${authors}. ${articleObject.venue}, ${articleObject.month} ${articleObject.year}`;
                }).join("\n");
            }
            return `### Journal articles\n\n${articleListToString(biblioObject.journalArticle)}\n\n### Conference articles\n\n ${articleListToString(biblioObject.conferenceArticle)}\n\n### Informal articles\n\n${articleListToString(biblioObject.informalArticle)}`;
        }).then((result)=>{
            let doiList = this.dblpData.statementsMatching(undefined, $5605c1058d66d37f$export$b205ee610c4a7a73("doi"), undefined).map((statement)=>{
                return statement.object.value;
            });
            doiList = doiList.filter((doi, index)=>{
                return doi.startsWith("https://doi.org/");
            });
            let keywordMap = new Map();
            return Promise.allSettled(doiList.map((doi)=>{
                return $35459c07cd7570af$export$230442c21b56ff1e(`https://api.openalex.org/works/${doi}`).then((data)=>{
                    if (data["concepts"] != undefined) {
                        let concepts = [];
                        data["concepts"].forEach((concept)=>{
                            if (concept["score"] > 0) concepts.push(concept["display_name"]);
                        });
                        keywordMap.set(doi, concepts);
                    }
                });
            })).then(()=>{
                let keywordSet = new Set();
                let keywordCountMap = new Map();
                keywordMap.forEach((keywords, doi)=>{
                    keywords.forEach((keyword)=>{
                        if (keywordCountMap.has(keyword)) keywordCountMap.set(keyword, keywordCountMap.get(keyword) + 1);
                        else keywordCountMap.set(keyword, 1);
                        keywordSet.add(keyword);
                    });
                });
                let keywordArray = Array.from(keywordSet).sort((a, b)=>{
                    return keywordCountMap.get(b) - keywordCountMap.get(a);
                });
                let keywordString = keywordArray.filter((keyword)=>keywordCountMap.get(keyword) > 1).join("; ");
                result = result.concat(`\n\n### Keywords\n\n${keywordString}`);
                return result;
            });
        });
    }
    content() {
        return this.generateData().then((content)=>{
            return $522a0f63ac74d0e8$var$md.render(content);
        });
    }
}
class $522a0f63ac74d0e8$export$d400d7f0d4711da5 extends (0, $1dd5f29d6665a182$export$5cf80f451b772330) {
    constructor(configObject, appendTargetId = "#projects"){
        super("Projects", "projects", configObject, appendTargetId);
        // https://api.github.com/users/MaillPierre/repos
        this.contentPromise = Promise.resolve("");
    }
    content() {
        return this.contentPromise;
    }
}
class $522a0f63ac74d0e8$export$43fccbb6b02b9005 extends (0, $1dd5f29d6665a182$export$5cf80f451b772330) {
    constructor(configObject, markdownFile, appendTargetId){
        super("", "", configObject, appendTargetId);
        this.contentPromise = $35459c07cd7570af$export$a6e59c03a779ef88(markdownFile).then((data)=>{
            return $522a0f63ac74d0e8$var$md.render(data);
        });
    }
    content() {
        return this.contentPromise;
    }
}


var $816bdfa2c16d98cd$exports = {};
$816bdfa2c16d98cd$exports = JSON.parse('{"person":{"name":"Pierre MAILLOT"},"social":{"website":"https://w3id.org/people/pierremaillot","blog":"","orcid":"0000-0002-9814-439X","hal":"pierre-maillot","affiliation":"Open to relocate","email":"pierre.maillot.pro@pm.me","github":"MaillPierre","mastodon":"https://mastodon.social/@LePierreMaillot","twitter":"LePierreMaillot","bluesky":"https://bsky.app/profile/lepierremaillot.bsky.social","instagram":"","facebook":"","linkedin":"pierre-maillot-266b1a63","dblp":"143/6275","youtube":"","twitch":"","patreon":"","paypal":"","bitcoin":"","ethereum":"","monero":"","flattr":"","buymeacoffee":"","liberapay":"","open_collective":"","keybase":"","reddit":"","hackernews":"","lobsters":"","telegram":"","whatsapp":"","signal":"","discord":"","slack":"","matrix":"","xmpp":"","gscholar":"Svt8d0IAAAAJ"},"publications":{"dblp":"143/6275","openalex":"A5045550951"},"projects":{"github":"MaillPierre"}}');


(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(()=>{
    let modules = [
        new $522a0f63ac74d0e8$export$5eed707d4f2a2569($816bdfa2c16d98cd$exports),
        new $522a0f63ac74d0e8$export$79e3a3d3e861b76d($816bdfa2c16d98cd$exports),
        new $522a0f63ac74d0e8$export$43fccbb6b02b9005($816bdfa2c16d98cd$exports, "https://raw.githubusercontent.com/MaillPierre/personal-page/main/data/Previous_position.md", "#positions"),
        new $522a0f63ac74d0e8$export$588bdae3d57c90cb($816bdfa2c16d98cd$exports),
        new $522a0f63ac74d0e8$export$43fccbb6b02b9005($816bdfa2c16d98cd$exports, "https://raw.githubusercontent.com/MaillPierre/personal-page/main/data/Skills.md", "#skills")
    ];
    modules.forEach((module)=>{
        module.render();
    });
});


//# sourceMappingURL=index.af20b558.js.map
